/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(94);


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule invariant
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule warning
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(9);
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = emptyFunction;
	
	if (false) {
	  warning = function (condition, format) {
	    for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	      args[_key - 2] = arguments[_key];
	    }
	
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	
	    if (format.indexOf('Failed Composite propType: ') === 0) {
	      return; // Ignore CompositeComponent proptype check.
	    }
	
	    if (!condition) {
	      var argIndex = 0;
	      var message = 'Warning: ' + format.replace(/%s/g, function () {
	        return args[argIndex++];
	      });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // --- Welcome to debugging React ---
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch (x) {}
	    }
	  };
	}
	
	module.exports = warning;

/***/ }),
/* 3 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule Object.assign
	 */
	
	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-object.assign
	
	'use strict';
	
	function assign(target, sources) {
	  if (target == null) {
	    throw new TypeError('Object.assign target cannot be null or undefined');
	  }
	
	  var to = Object(target);
	  var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	  for (var nextIndex = 1; nextIndex < arguments.length; nextIndex++) {
	    var nextSource = arguments[nextIndex];
	    if (nextSource == null) {
	      continue;
	    }
	
	    var from = Object(nextSource);
	
	    // We don't currently support accessors nor proxies. Therefore this
	    // copy cannot throw. If we ever supported this then we must handle
	    // exceptions and side-effects. We don't support symbols so they won't
	    // be transferred.
	
	    for (var key in from) {
	      if (hasOwnProperty.call(from, key)) {
	        to[key] = from[key];
	      }
	    }
	  }
	
	  return to;
	}
	
	module.exports = assign;

/***/ }),
/* 4 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ExecutionEnvironment
	 */
	
	'use strict';
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	/**
	 * Simple, lightweight module assisting with the detection and context of
	 * Worker. Helps avoid circular dependencies and allows code to reason about
	 * whether or not they are in a Worker, even if they never include the main
	 * `ReactWorker` dependency.
	 */
	var ExecutionEnvironment = {
	
	  canUseDOM: canUseDOM,
	
	  canUseWorkers: typeof Worker !== 'undefined',
	
	  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
	
	  canUseViewport: canUseDOM && !!window.screen,
	
	  isInWorker: !canUseDOM // For now, this is true - might change in the future.
	
	};
	
	module.exports = ExecutionEnvironment;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactMount
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(18);
	var ReactBrowserEventEmitter = __webpack_require__(26);
	var ReactCurrentOwner = __webpack_require__(12);
	var ReactDOMFeatureFlags = __webpack_require__(70);
	var ReactElement = __webpack_require__(6);
	var ReactEmptyComponentRegistry = __webpack_require__(77);
	var ReactInstanceHandles = __webpack_require__(19);
	var ReactInstanceMap = __webpack_require__(23);
	var ReactMarkupChecksum = __webpack_require__(80);
	var ReactPerf = __webpack_require__(7);
	var ReactReconciler = __webpack_require__(15);
	var ReactUpdateQueue = __webpack_require__(41);
	var ReactUpdates = __webpack_require__(8);
	
	var assign = __webpack_require__(3);
	var emptyObject = __webpack_require__(20);
	var containsNode = __webpack_require__(55);
	var instantiateReactComponent = __webpack_require__(48);
	var invariant = __webpack_require__(1);
	var setInnerHTML = __webpack_require__(33);
	var shouldUpdateReactComponent = __webpack_require__(51);
	var validateDOMNesting = __webpack_require__(53);
	var warning = __webpack_require__(2);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var nodeCache = {};
	
	var ELEMENT_NODE_TYPE = 1;
	var DOC_NODE_TYPE = 9;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	var ownerDocumentContextKey = '__ReactMount_ownerDocument$' + Math.random().toString(36).slice(2);
	
	/** Mapping from reactRootID to React component instance. */
	var instancesByReactRootID = {};
	
	/** Mapping from reactRootID to `container` nodes. */
	var containersByReactRootID = {};
	
	if (false) {
	  /** __DEV__-only mapping from reactRootID to root elements. */
	  var rootElementsByReactRootID = {};
	}
	
	// Used to store breadth-first search state in findComponentRoot.
	var findComponentRootReusableArray = [];
	
	/**
	 * Finds the index of the first character
	 * that's not common between the two given strings.
	 *
	 * @return {number} the index of the character where the strings diverge
	 */
	function firstDifferenceIndex(string1, string2) {
	  var minLen = Math.min(string1.length, string2.length);
	  for (var i = 0; i < minLen; i++) {
	    if (string1.charAt(i) !== string2.charAt(i)) {
	      return i;
	    }
	  }
	  return string1.length === string2.length ? -1 : minLen;
	}
	
	/**
	 * @param {DOMElement|DOMDocument} container DOM element that may contain
	 * a React component
	 * @return {?*} DOM element that may have the reactRoot ID, or null.
	 */
	function getReactRootElementInContainer(container) {
	  if (!container) {
	    return null;
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    return container.documentElement;
	  } else {
	    return container.firstChild;
	  }
	}
	
	/**
	 * @param {DOMElement} container DOM element that may contain a React component.
	 * @return {?string} A "reactRoot" ID, if a React component is rendered.
	 */
	function getReactRootID(container) {
	  var rootElement = getReactRootElementInContainer(container);
	  return rootElement && ReactMount.getID(rootElement);
	}
	
	/**
	 * Accessing node[ATTR_NAME] or calling getAttribute(ATTR_NAME) on a form
	 * element can return its control whose name or ID equals ATTR_NAME. All
	 * DOM nodes support `getAttributeNode` but this can also get called on
	 * other objects so just return '' if we're given something other than a
	 * DOM node (such as window).
	 *
	 * @param {?DOMElement|DOMWindow|DOMDocument|DOMTextNode} node DOM node.
	 * @return {string} ID of the supplied `domNode`.
	 */
	function getID(node) {
	  var id = internalGetID(node);
	  if (id) {
	    if (nodeCache.hasOwnProperty(id)) {
	      var cached = nodeCache[id];
	      if (cached !== node) {
	        !!isValid(cached, id) ?  false ? invariant(false, 'ReactMount: Two valid but unequal nodes with the same `%s`: %s', ATTR_NAME, id) : invariant(false) : undefined;
	
	        nodeCache[id] = node;
	      }
	    } else {
	      nodeCache[id] = node;
	    }
	  }
	
	  return id;
	}
	
	function internalGetID(node) {
	  // If node is something like a window, document, or text node, none of
	  // which support attributes or a .getAttribute method, gracefully return
	  // the empty string, as if the attribute were missing.
	  return node && node.getAttribute && node.getAttribute(ATTR_NAME) || '';
	}
	
	/**
	 * Sets the React-specific ID of the given node.
	 *
	 * @param {DOMElement} node The DOM node whose ID will be set.
	 * @param {string} id The value of the ID attribute.
	 */
	function setID(node, id) {
	  var oldID = internalGetID(node);
	  if (oldID !== id) {
	    delete nodeCache[oldID];
	  }
	  node.setAttribute(ATTR_NAME, id);
	  nodeCache[id] = node;
	}
	
	/**
	 * Finds the node with the supplied React-generated DOM ID.
	 *
	 * @param {string} id A React-generated DOM ID.
	 * @return {DOMElement} DOM node with the suppled `id`.
	 * @internal
	 */
	function getNode(id) {
	  if (!nodeCache.hasOwnProperty(id) || !isValid(nodeCache[id], id)) {
	    nodeCache[id] = ReactMount.findReactNodeByID(id);
	  }
	  return nodeCache[id];
	}
	
	/**
	 * Finds the node with the supplied public React instance.
	 *
	 * @param {*} instance A public React instance.
	 * @return {?DOMElement} DOM node with the suppled `id`.
	 * @internal
	 */
	function getNodeFromInstance(instance) {
	  var id = ReactInstanceMap.get(instance)._rootNodeID;
	  if (ReactEmptyComponentRegistry.isNullComponentID(id)) {
	    return null;
	  }
	  if (!nodeCache.hasOwnProperty(id) || !isValid(nodeCache[id], id)) {
	    nodeCache[id] = ReactMount.findReactNodeByID(id);
	  }
	  return nodeCache[id];
	}
	
	/**
	 * A node is "valid" if it is contained by a currently mounted container.
	 *
	 * This means that the node does not have to be contained by a document in
	 * order to be considered valid.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @param {string} id The expected ID of the node.
	 * @return {boolean} Whether the node is contained by a mounted container.
	 */
	function isValid(node, id) {
	  if (node) {
	    !(internalGetID(node) === id) ?  false ? invariant(false, 'ReactMount: Unexpected modification of `%s`', ATTR_NAME) : invariant(false) : undefined;
	
	    var container = ReactMount.findReactContainerForID(id);
	    if (container && containsNode(container, node)) {
	      return true;
	    }
	  }
	
	  return false;
	}
	
	/**
	 * Causes the cache to forget about one React-specific ID.
	 *
	 * @param {string} id The ID to forget.
	 */
	function purgeID(id) {
	  delete nodeCache[id];
	}
	
	var deepestNodeSoFar = null;
	function findDeepestCachedAncestorImpl(ancestorID) {
	  var ancestor = nodeCache[ancestorID];
	  if (ancestor && isValid(ancestor, ancestorID)) {
	    deepestNodeSoFar = ancestor;
	  } else {
	    // This node isn't populated in the cache, so presumably none of its
	    // descendants are. Break out of the loop.
	    return false;
	  }
	}
	
	/**
	 * Return the deepest cached node whose ID is a prefix of `targetID`.
	 */
	function findDeepestCachedAncestor(targetID) {
	  deepestNodeSoFar = null;
	  ReactInstanceHandles.traverseAncestors(targetID, findDeepestCachedAncestorImpl);
	
	  var foundNode = deepestNodeSoFar;
	  deepestNodeSoFar = null;
	  return foundNode;
	}
	
	/**
	 * Mounts this component and inserts it into the DOM.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {string} rootID DOM ID of the root node.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {ReactReconcileTransaction} transaction
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function mountComponentIntoNode(componentInstance, rootID, container, transaction, shouldReuseMarkup, context) {
	  if (ReactDOMFeatureFlags.useCreateElement) {
	    context = assign({}, context);
	    if (container.nodeType === DOC_NODE_TYPE) {
	      context[ownerDocumentContextKey] = container;
	    } else {
	      context[ownerDocumentContextKey] = container.ownerDocument;
	    }
	  }
	  if (false) {
	    if (context === emptyObject) {
	      context = {};
	    }
	    var tag = container.nodeName.toLowerCase();
	    context[validateDOMNesting.ancestorInfoContextKey] = validateDOMNesting.updatedAncestorInfo(null, tag, null);
	  }
	  var markup = ReactReconciler.mountComponent(componentInstance, rootID, transaction, context);
	  componentInstance._renderedComponent._topLevelWrapper = componentInstance;
	  ReactMount._mountImageIntoNode(markup, container, shouldReuseMarkup, transaction);
	}
	
	/**
	 * Batched mount.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {string} rootID DOM ID of the root node.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function batchedMountComponentIntoNode(componentInstance, rootID, container, shouldReuseMarkup, context) {
	  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* forceHTML */shouldReuseMarkup);
	  transaction.perform(mountComponentIntoNode, null, componentInstance, rootID, container, transaction, shouldReuseMarkup, context);
	  ReactUpdates.ReactReconcileTransaction.release(transaction);
	}
	
	/**
	 * Unmounts a component and removes it from the DOM.
	 *
	 * @param {ReactComponent} instance React component instance.
	 * @param {DOMElement} container DOM element to unmount from.
	 * @final
	 * @internal
	 * @see {ReactMount.unmountComponentAtNode}
	 */
	function unmountComponentFromNode(instance, container) {
	  ReactReconciler.unmountComponent(instance);
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    container = container.documentElement;
	  }
	
	  // http://jsperf.com/emptying-a-node
	  while (container.lastChild) {
	    container.removeChild(container.lastChild);
	  }
	}
	
	/**
	 * True if the supplied DOM node has a direct React-rendered child that is
	 * not a React root element. Useful for warning in `render`,
	 * `unmountComponentAtNode`, etc.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM element contains a direct child that was
	 * rendered by React but is not a root element.
	 * @internal
	 */
	function hasNonRootReactChild(node) {
	  var reactRootID = getReactRootID(node);
	  return reactRootID ? reactRootID !== ReactInstanceHandles.getReactRootIDFromNodeID(reactRootID) : false;
	}
	
	/**
	 * Returns the first (deepest) ancestor of a node which is rendered by this copy
	 * of React.
	 */
	function findFirstReactDOMImpl(node) {
	  // This node might be from another React instance, so we make sure not to
	  // examine the node cache here
	  for (; node && node.parentNode !== node; node = node.parentNode) {
	    if (node.nodeType !== 1) {
	      // Not a DOMElement, therefore not a React component
	      continue;
	    }
	    var nodeID = internalGetID(node);
	    if (!nodeID) {
	      continue;
	    }
	    var reactRootID = ReactInstanceHandles.getReactRootIDFromNodeID(nodeID);
	
	    // If containersByReactRootID contains the container we find by crawling up
	    // the tree, we know that this instance of React rendered the node.
	    // nb. isValid's strategy (with containsNode) does not work because render
	    // trees may be nested and we don't want a false positive in that case.
	    var current = node;
	    var lastID;
	    do {
	      lastID = internalGetID(current);
	      current = current.parentNode;
	      if (current == null) {
	        // The passed-in node has been detached from the container it was
	        // originally rendered into.
	        return null;
	      }
	    } while (lastID !== reactRootID);
	
	    if (current === containersByReactRootID[reactRootID]) {
	      return node;
	    }
	  }
	  return null;
	}
	
	/**
	 * Temporary (?) hack so that we can store all top-level pending updates on
	 * composites instead of having to worry about different types of components
	 * here.
	 */
	var TopLevelWrapper = function () {};
	TopLevelWrapper.prototype.isReactComponent = {};
	if (false) {
	  TopLevelWrapper.displayName = 'TopLevelWrapper';
	}
	TopLevelWrapper.prototype.render = function () {
	  // this.props is actually a ReactElement
	  return this.props;
	};
	
	/**
	 * Mounting is the process of initializing a React component by creating its
	 * representative DOM elements and inserting them into a supplied `container`.
	 * Any prior content inside `container` is destroyed in the process.
	 *
	 *   ReactMount.render(
	 *     component,
	 *     document.getElementById('container')
	 *   );
	 *
	 *   <div id="container">                   <-- Supplied `container`.
	 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
	 *       // ...                                 component.
	 *     </div>
	 *   </div>
	 *
	 * Inside of `container`, the first element rendered is the "reactRoot".
	 */
	var ReactMount = {
	
	  TopLevelWrapper: TopLevelWrapper,
	
	  /** Exposed for debugging purposes **/
	  _instancesByReactRootID: instancesByReactRootID,
	
	  /**
	   * This is a hook provided to support rendering React components while
	   * ensuring that the apparent scroll position of its `container` does not
	   * change.
	   *
	   * @param {DOMElement} container The `container` being rendered into.
	   * @param {function} renderCallback This must be called once to do the render.
	   */
	  scrollMonitor: function (container, renderCallback) {
	    renderCallback();
	  },
	
	  /**
	   * Take a component that's already mounted into the DOM and replace its props
	   * @param {ReactComponent} prevComponent component instance already in the DOM
	   * @param {ReactElement} nextElement component instance to render
	   * @param {DOMElement} container container to render into
	   * @param {?function} callback function triggered on completion
	   */
	  _updateRootComponent: function (prevComponent, nextElement, container, callback) {
	    ReactMount.scrollMonitor(container, function () {
	      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement);
	      if (callback) {
	        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
	      }
	    });
	
	    if (false) {
	      // Record the root element in case it later gets transplanted.
	      rootElementsByReactRootID[getReactRootID(container)] = getReactRootElementInContainer(container);
	    }
	
	    return prevComponent;
	  },
	
	  /**
	   * Register a component into the instance map and starts scroll value
	   * monitoring
	   * @param {ReactComponent} nextComponent component instance to render
	   * @param {DOMElement} container container to render into
	   * @return {string} reactRoot ID prefix
	   */
	  _registerComponent: function (nextComponent, container) {
	    !(container && (container.nodeType === ELEMENT_NODE_TYPE || container.nodeType === DOC_NODE_TYPE || container.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE)) ?  false ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : invariant(false) : undefined;
	
	    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
	
	    var reactRootID = ReactMount.registerContainer(container);
	    instancesByReactRootID[reactRootID] = nextComponent;
	    return reactRootID;
	  },
	
	  /**
	   * Render a new component into the DOM.
	   * @param {ReactElement} nextElement element to render
	   * @param {DOMElement} container container to render into
	   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
	   * @return {ReactComponent} nextComponent
	   */
	  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case.
	     false ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : undefined;
	
	    var componentInstance = instantiateReactComponent(nextElement, null);
	    var reactRootID = ReactMount._registerComponent(componentInstance, container);
	
	    // The initial render is synchronous but any updates that happen during
	    // rendering, in componentWillMount or componentDidMount, will be batched
	    // according to the current batching strategy.
	
	    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, reactRootID, container, shouldReuseMarkup, context);
	
	    if (false) {
	      // Record the root element in case it later gets transplanted.
	      rootElementsByReactRootID[reactRootID] = getReactRootElementInContainer(container);
	    }
	
	    return componentInstance;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    !(parentComponent != null && parentComponent._reactInternalInstance != null) ?  false ? invariant(false, 'parentComponent must be a valid React Component') : invariant(false) : undefined;
	    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
	  },
	
	  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    !ReactElement.isValidElement(nextElement) ?  false ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? ' Instead of passing an element string, make sure to instantiate ' + 'it by passing it to React.createElement.' : typeof nextElement === 'function' ? ' Instead of passing a component class, make sure to instantiate ' + 'it by passing it to React.createElement.' :
	    // Check if it quacks like an element
	    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : invariant(false) : undefined;
	
	     false ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : undefined;
	
	    var nextWrappedElement = new ReactElement(TopLevelWrapper, null, null, null, null, null, nextElement);
	
	    var prevComponent = instancesByReactRootID[getReactRootID(container)];
	
	    if (prevComponent) {
	      var prevWrappedElement = prevComponent._currentElement;
	      var prevElement = prevWrappedElement.props;
	      if (shouldUpdateReactComponent(prevElement, nextElement)) {
	        var publicInst = prevComponent._renderedComponent.getPublicInstance();
	        var updatedCallback = callback && function () {
	          callback.call(publicInst);
	        };
	        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, container, updatedCallback);
	        return publicInst;
	      } else {
	        ReactMount.unmountComponentAtNode(container);
	      }
	    }
	
	    var reactRootElement = getReactRootElementInContainer(container);
	    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
	    var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : undefined;
	
	      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
	        var rootElementSibling = reactRootElement;
	        while (rootElementSibling) {
	          if (internalGetID(rootElementSibling)) {
	            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : undefined;
	            break;
	          }
	          rootElementSibling = rootElementSibling.nextSibling;
	        }
	      }
	    }
	
	    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
	    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, parentComponent != null ? parentComponent._reactInternalInstance._processChildContext(parentComponent._reactInternalInstance._context) : emptyObject)._renderedComponent.getPublicInstance();
	    if (callback) {
	      callback.call(component);
	    }
	    return component;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  render: function (nextElement, container, callback) {
	    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
	  },
	
	  /**
	   * Registers a container node into which React components will be rendered.
	   * This also creates the "reactRoot" ID that will be assigned to the element
	   * rendered within.
	   *
	   * @param {DOMElement} container DOM element to register as a container.
	   * @return {string} The "reactRoot" ID of elements rendered within.
	   */
	  registerContainer: function (container) {
	    var reactRootID = getReactRootID(container);
	    if (reactRootID) {
	      // If one exists, make sure it is a valid "reactRoot" ID.
	      reactRootID = ReactInstanceHandles.getReactRootIDFromNodeID(reactRootID);
	    }
	    if (!reactRootID) {
	      // No valid "reactRoot" ID found, create one.
	      reactRootID = ReactInstanceHandles.createReactRootID();
	    }
	    containersByReactRootID[reactRootID] = container;
	    return reactRootID;
	  },
	
	  /**
	   * Unmounts and destroys the React component rendered in the `container`.
	   *
	   * @param {DOMElement} container DOM element containing a React component.
	   * @return {boolean} True if a component was found in and unmounted from
	   *                   `container`
	   */
	  unmountComponentAtNode: function (container) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case. (Strictly speaking, unmounting won't cause a
	    // render but we still don't expect to be in a render call here.)
	     false ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : undefined;
	
	    !(container && (container.nodeType === ELEMENT_NODE_TYPE || container.nodeType === DOC_NODE_TYPE || container.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE)) ?  false ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : invariant(false) : undefined;
	
	    var reactRootID = getReactRootID(container);
	    var component = instancesByReactRootID[reactRootID];
	    if (!component) {
	      // Check if the node being unmounted was rendered by React, but isn't a
	      // root node.
	      var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	      // Check if the container itself is a React root node.
	      var containerID = internalGetID(container);
	      var isContainerReactRoot = containerID && containerID === ReactInstanceHandles.getReactRootIDFromNodeID(containerID);
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'unmountComponentAtNode(): The node you\'re attempting to unmount ' + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : undefined;
	      }
	
	      return false;
	    }
	    ReactUpdates.batchedUpdates(unmountComponentFromNode, component, container);
	    delete instancesByReactRootID[reactRootID];
	    delete containersByReactRootID[reactRootID];
	    if (false) {
	      delete rootElementsByReactRootID[reactRootID];
	    }
	    return true;
	  },
	
	  /**
	   * Finds the container DOM element that contains React component to which the
	   * supplied DOM `id` belongs.
	   *
	   * @param {string} id The ID of an element rendered by a React component.
	   * @return {?DOMElement} DOM element that contains the `id`.
	   */
	  findReactContainerForID: function (id) {
	    var reactRootID = ReactInstanceHandles.getReactRootIDFromNodeID(id);
	    var container = containersByReactRootID[reactRootID];
	
	    if (false) {
	      var rootElement = rootElementsByReactRootID[reactRootID];
	      if (rootElement && rootElement.parentNode !== container) {
	        process.env.NODE_ENV !== 'production' ? warning(
	        // Call internalGetID here because getID calls isValid which calls
	        // findReactContainerForID (this function).
	        internalGetID(rootElement) === reactRootID, 'ReactMount: Root element ID differed from reactRootID.') : undefined;
	        var containerChild = container.firstChild;
	        if (containerChild && reactRootID === internalGetID(containerChild)) {
	          // If the container has a new child with the same ID as the old
	          // root element, then rootElementsByReactRootID[reactRootID] is
	          // just stale and needs to be updated. The case that deserves a
	          // warning is when the container is empty.
	          rootElementsByReactRootID[reactRootID] = containerChild;
	        } else {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'ReactMount: Root element has been removed from its original ' + 'container. New container: %s', rootElement.parentNode) : undefined;
	        }
	      }
	    }
	
	    return container;
	  },
	
	  /**
	   * Finds an element rendered by React with the supplied ID.
	   *
	   * @param {string} id ID of a DOM node in the React component.
	   * @return {DOMElement} Root DOM node of the React component.
	   */
	  findReactNodeByID: function (id) {
	    var reactRoot = ReactMount.findReactContainerForID(id);
	    return ReactMount.findComponentRoot(reactRoot, id);
	  },
	
	  /**
	   * Traverses up the ancestors of the supplied node to find a node that is a
	   * DOM representation of a React component rendered by this copy of React.
	   *
	   * @param {*} node
	   * @return {?DOMEventTarget}
	   * @internal
	   */
	  getFirstReactDOM: function (node) {
	    return findFirstReactDOMImpl(node);
	  },
	
	  /**
	   * Finds a node with the supplied `targetID` inside of the supplied
	   * `ancestorNode`.  Exploits the ID naming scheme to perform the search
	   * quickly.
	   *
	   * @param {DOMEventTarget} ancestorNode Search from this root.
	   * @pararm {string} targetID ID of the DOM representation of the component.
	   * @return {DOMEventTarget} DOM node with the supplied `targetID`.
	   * @internal
	   */
	  findComponentRoot: function (ancestorNode, targetID) {
	    var firstChildren = findComponentRootReusableArray;
	    var childIndex = 0;
	
	    var deepestAncestor = findDeepestCachedAncestor(targetID) || ancestorNode;
	
	    if (false) {
	      // This will throw on the next line; give an early warning
	      process.env.NODE_ENV !== 'production' ? warning(deepestAncestor != null, 'React can\'t find the root component node for data-reactid value ' + '`%s`. If you\'re seeing this message, it probably means that ' + 'you\'ve loaded two copies of React on the page. At this time, only ' + 'a single copy of React can be loaded at a time.', targetID) : undefined;
	    }
	
	    firstChildren[0] = deepestAncestor.firstChild;
	    firstChildren.length = 1;
	
	    while (childIndex < firstChildren.length) {
	      var child = firstChildren[childIndex++];
	      var targetChild;
	
	      while (child) {
	        var childID = ReactMount.getID(child);
	        if (childID) {
	          // Even if we find the node we're looking for, we finish looping
	          // through its siblings to ensure they're cached so that we don't have
	          // to revisit this node again. Otherwise, we make n^2 calls to getID
	          // when visiting the many children of a single node in order.
	
	          if (targetID === childID) {
	            targetChild = child;
	          } else if (ReactInstanceHandles.isAncestorIDOf(childID, targetID)) {
	            // If we find a child whose ID is an ancestor of the given ID,
	            // then we can be sure that we only want to search the subtree
	            // rooted at this child, so we can throw out the rest of the
	            // search state.
	            firstChildren.length = childIndex = 0;
	            firstChildren.push(child.firstChild);
	          }
	        } else {
	          // If this child had no ID, then there's a chance that it was
	          // injected automatically by the browser, as when a `<table>`
	          // element sprouts an extra `<tbody>` child as a side effect of
	          // `.innerHTML` parsing. Optimistically continue down this
	          // branch, but not before examining the other siblings.
	          firstChildren.push(child.firstChild);
	        }
	
	        child = child.nextSibling;
	      }
	
	      if (targetChild) {
	        // Emptying firstChildren/findComponentRootReusableArray is
	        // not necessary for correctness, but it helps the GC reclaim
	        // any nodes that were left at the end of the search.
	        firstChildren.length = 0;
	
	        return targetChild;
	      }
	    }
	
	    firstChildren.length = 0;
	
	     true ?  false ? invariant(false, 'findComponentRoot(..., %s): Unable to find element. This probably ' + 'means the DOM was unexpectedly mutated (e.g., by the browser), ' + 'usually due to forgetting a <tbody> when using tables, nesting tags ' + 'like <form>, <p>, or <a>, or using non-SVG elements in an <svg> ' + 'parent. ' + 'Try inspecting the child nodes of the element with React ID `%s`.', targetID, ReactMount.getID(ancestorNode)) : invariant(false) : undefined;
	  },
	
	  _mountImageIntoNode: function (markup, container, shouldReuseMarkup, transaction) {
	    !(container && (container.nodeType === ELEMENT_NODE_TYPE || container.nodeType === DOC_NODE_TYPE || container.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE)) ?  false ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : invariant(false) : undefined;
	
	    if (shouldReuseMarkup) {
	      var rootElement = getReactRootElementInContainer(container);
	      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
	        return;
	      } else {
	        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	
	        var rootMarkup = rootElement.outerHTML;
	        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);
	
	        var normalizedMarkup = markup;
	        if (false) {
	          // because rootMarkup is retrieved from the DOM, various normalizations
	          // will have occurred which will not be present in `markup`. Here,
	          // insert markup into a <div> or <iframe> depending on the container
	          // type to perform the same normalizations before comparing.
	          var normalizer;
	          if (container.nodeType === ELEMENT_NODE_TYPE) {
	            normalizer = document.createElement('div');
	            normalizer.innerHTML = markup;
	            normalizedMarkup = normalizer.innerHTML;
	          } else {
	            normalizer = document.createElement('iframe');
	            document.body.appendChild(normalizer);
	            normalizer.contentDocument.write(markup);
	            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
	            document.body.removeChild(normalizer);
	          }
	        }
	
	        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
	        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);
	
	        !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document using ' + 'server rendering but the checksum was invalid. This usually ' + 'means you rendered a different component type or props on ' + 'the client from the one on the server, or your render() ' + 'methods are impure. React cannot handle this case due to ' + 'cross-browser quirks by rendering at the document root. You ' + 'should look for environment dependent code in your components ' + 'and ensure the props are the same client and server side:\n%s', difference) : invariant(false) : undefined;
	
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : undefined;
	        }
	      }
	    }
	
	    !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document but ' + 'you didn\'t use server rendering. We can\'t do this ' + 'without using server rendering due to cross-browser quirks. ' + 'See ReactDOMServer.renderToString() for server rendering.') : invariant(false) : undefined;
	
	    if (transaction.useCreateElement) {
	      while (container.lastChild) {
	        container.removeChild(container.lastChild);
	      }
	      container.appendChild(markup);
	    } else {
	      setInnerHTML(container, markup);
	    }
	  },
	
	  ownerDocumentContextKey: ownerDocumentContextKey,
	
	  /**
	   * React ID utilities.
	   */
	
	  getReactRootID: getReactRootID,
	
	  getID: getID,
	
	  setID: setID,
	
	  getNode: getNode,
	
	  getNodeFromInstance: getNodeFromInstance,
	
	  isValid: isValid,
	
	  purgeID: purgeID
	};
	
	ReactPerf.measureMethods(ReactMount, 'ReactMount', {
	  _renderNewRootComponent: '_renderNewRootComponent',
	  _mountImageIntoNode: '_mountImageIntoNode'
	});
	
	module.exports = ReactMount;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactElement
	 */
	
	'use strict';
	
	var ReactCurrentOwner = __webpack_require__(12);
	
	var assign = __webpack_require__(3);
	var canDefineProperty = __webpack_require__(31);
	
	// The Symbol used to tag the ReactElement type. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;
	
	var RESERVED_PROPS = {
	  key: true,
	  ref: true,
	  __self: true,
	  __source: true
	};
	
	/**
	 * Base constructor for all React elements. This is only used to make this
	 * work with a dynamic instanceof check. Nothing should live on this prototype.
	 *
	 * @param {*} type
	 * @param {*} key
	 * @param {string|object} ref
	 * @param {*} self A *temporary* helper to detect places where `this` is
	 * different from the `owner` when React.createElement is called, so that we
	 * can warn. We want to get rid of owner and replace string `ref`s with arrow
	 * functions, and as long as `this` and owner are the same, there will be no
	 * change in behavior.
	 * @param {*} source An annotation object (added by a transpiler or otherwise)
	 * indicating filename, line number, and/or other information.
	 * @param {*} owner
	 * @param {*} props
	 * @internal
	 */
	var ReactElement = function (type, key, ref, self, source, owner, props) {
	  var element = {
	    // This tag allow us to uniquely identify this as a React Element
	    $$typeof: REACT_ELEMENT_TYPE,
	
	    // Built-in properties that belong on the element
	    type: type,
	    key: key,
	    ref: ref,
	    props: props,
	
	    // Record the component responsible for creating this element.
	    _owner: owner
	  };
	
	  if (false) {
	    // The validation flag is currently mutative. We put it on
	    // an external backing store so that we can freeze the whole object.
	    // This can be replaced with a WeakMap once they are implemented in
	    // commonly used development environments.
	    element._store = {};
	
	    // To make comparing ReactElements easier for testing purposes, we make
	    // the validation flag non-enumerable (where possible, which should
	    // include every environment we run tests in), so the test framework
	    // ignores it.
	    if (canDefineProperty) {
	      Object.defineProperty(element._store, 'validated', {
	        configurable: false,
	        enumerable: false,
	        writable: true,
	        value: false
	      });
	      // self and source are DEV only properties.
	      Object.defineProperty(element, '_self', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: self
	      });
	      // Two elements created in two different places should be considered
	      // equal for testing purposes and therefore we hide it from enumeration.
	      Object.defineProperty(element, '_source', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: source
	      });
	    } else {
	      element._store.validated = false;
	      element._self = self;
	      element._source = source;
	    }
	    Object.freeze(element.props);
	    Object.freeze(element);
	  }
	
	  return element;
	};
	
	ReactElement.createElement = function (type, config, children) {
	  var propName;
	
	  // Reserved names are extracted
	  var props = {};
	
	  var key = null;
	  var ref = null;
	  var self = null;
	  var source = null;
	
	  if (config != null) {
	    ref = config.ref === undefined ? null : config.ref;
	    key = config.key === undefined ? null : '' + config.key;
	    self = config.__self === undefined ? null : config.__self;
	    source = config.__source === undefined ? null : config.__source;
	    // Remaining properties are added to a new props object
	    for (propName in config) {
	      if (config.hasOwnProperty(propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        props[propName] = config[propName];
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  // Resolve default props
	  if (type && type.defaultProps) {
	    var defaultProps = type.defaultProps;
	    for (propName in defaultProps) {
	      if (typeof props[propName] === 'undefined') {
	        props[propName] = defaultProps[propName];
	      }
	    }
	  }
	
	  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
	};
	
	ReactElement.createFactory = function (type) {
	  var factory = ReactElement.createElement.bind(null, type);
	  // Expose the type on the factory and the prototype so that it can be
	  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
	  // This should not be named `constructor` since this may not be the function
	  // that created the element, and it may not even be a constructor.
	  // Legacy hook TODO: Warn if this is accessed
	  factory.type = type;
	  return factory;
	};
	
	ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
	  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
	
	  return newElement;
	};
	
	ReactElement.cloneAndReplaceProps = function (oldElement, newProps) {
	  var newElement = ReactElement(oldElement.type, oldElement.key, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, newProps);
	
	  if (false) {
	    // If the key on the original is valid, then the clone is valid
	    newElement._store.validated = oldElement._store.validated;
	  }
	
	  return newElement;
	};
	
	ReactElement.cloneElement = function (element, config, children) {
	  var propName;
	
	  // Original props are copied
	  var props = assign({}, element.props);
	
	  // Reserved names are extracted
	  var key = element.key;
	  var ref = element.ref;
	  // Self is preserved since the owner is preserved.
	  var self = element._self;
	  // Source is preserved since cloneElement is unlikely to be targeted by a
	  // transpiler, and the original source is probably a better indicator of the
	  // true owner.
	  var source = element._source;
	
	  // Owner will be preserved, unless ref is overridden
	  var owner = element._owner;
	
	  if (config != null) {
	    if (config.ref !== undefined) {
	      // Silently steal the ref from the parent.
	      ref = config.ref;
	      owner = ReactCurrentOwner.current;
	    }
	    if (config.key !== undefined) {
	      key = '' + config.key;
	    }
	    // Remaining properties override existing props
	    for (propName in config) {
	      if (config.hasOwnProperty(propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        props[propName] = config[propName];
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  return ReactElement(element.type, key, ref, self, source, owner, props);
	};
	
	/**
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid component.
	 * @final
	 */
	ReactElement.isValidElement = function (object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	};
	
	module.exports = ReactElement;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactPerf
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * ReactPerf is a general AOP system designed to measure performance. This
	 * module only has the hooks: see ReactDefaultPerf for the analysis tool.
	 */
	var ReactPerf = {
	  /**
	   * Boolean to enable/disable measurement. Set to false by default to prevent
	   * accidental logging and perf loss.
	   */
	  enableMeasure: false,
	
	  /**
	   * Holds onto the measure function in use. By default, don't measure
	   * anything, but we'll override this if we inject a measure function.
	   */
	  storedMeasure: _noMeasure,
	
	  /**
	   * @param {object} object
	   * @param {string} objectName
	   * @param {object<string>} methodNames
	   */
	  measureMethods: function (object, objectName, methodNames) {
	    if (false) {
	      for (var key in methodNames) {
	        if (!methodNames.hasOwnProperty(key)) {
	          continue;
	        }
	        object[key] = ReactPerf.measure(objectName, methodNames[key], object[key]);
	      }
	    }
	  },
	
	  /**
	   * Use this to wrap methods you want to measure. Zero overhead in production.
	   *
	   * @param {string} objName
	   * @param {string} fnName
	   * @param {function} func
	   * @return {function}
	   */
	  measure: function (objName, fnName, func) {
	    if (false) {
	      var measuredFunc = null;
	      var wrapper = function () {
	        if (ReactPerf.enableMeasure) {
	          if (!measuredFunc) {
	            measuredFunc = ReactPerf.storedMeasure(objName, fnName, func);
	          }
	          return measuredFunc.apply(this, arguments);
	        }
	        return func.apply(this, arguments);
	      };
	      wrapper.displayName = objName + '_' + fnName;
	      return wrapper;
	    }
	    return func;
	  },
	
	  injection: {
	    /**
	     * @param {function} measure
	     */
	    injectMeasure: function (measure) {
	      ReactPerf.storedMeasure = measure;
	    }
	  }
	};
	
	/**
	 * Simply passes through the measured function, without measuring it.
	 *
	 * @param {string} objName
	 * @param {string} fnName
	 * @param {function} func
	 * @return {function}
	 */
	function _noMeasure(objName, fnName, func) {
	  return func;
	}
	
	module.exports = ReactPerf;

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactUpdates
	 */
	
	'use strict';
	
	var CallbackQueue = __webpack_require__(35);
	var PooledClass = __webpack_require__(14);
	var ReactPerf = __webpack_require__(7);
	var ReactReconciler = __webpack_require__(15);
	var Transaction = __webpack_require__(30);
	
	var assign = __webpack_require__(3);
	var invariant = __webpack_require__(1);
	
	var dirtyComponents = [];
	var asapCallbackQueue = CallbackQueue.getPooled();
	var asapEnqueued = false;
	
	var batchingStrategy = null;
	
	function ensureInjected() {
	  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ?  false ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching ' + 'strategy') : invariant(false) : undefined;
	}
	
	var NESTED_UPDATES = {
	  initialize: function () {
	    this.dirtyComponentsLength = dirtyComponents.length;
	  },
	  close: function () {
	    if (this.dirtyComponentsLength !== dirtyComponents.length) {
	      // Additional updates were enqueued by componentDidUpdate handlers or
	      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
	      // these new updates so that if A's componentDidUpdate calls setState on
	      // B, B will update before the callback A's updater provided when calling
	      // setState.
	      dirtyComponents.splice(0, this.dirtyComponentsLength);
	      flushBatchedUpdates();
	    } else {
	      dirtyComponents.length = 0;
	    }
	  }
	};
	
	var UPDATE_QUEUEING = {
	  initialize: function () {
	    this.callbackQueue.reset();
	  },
	  close: function () {
	    this.callbackQueue.notifyAll();
	  }
	};
	
	var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];
	
	function ReactUpdatesFlushTransaction() {
	  this.reinitializeTransaction();
	  this.dirtyComponentsLength = null;
	  this.callbackQueue = CallbackQueue.getPooled();
	  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled( /* forceHTML */false);
	}
	
	assign(ReactUpdatesFlushTransaction.prototype, Transaction.Mixin, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  destructor: function () {
	    this.dirtyComponentsLength = null;
	    CallbackQueue.release(this.callbackQueue);
	    this.callbackQueue = null;
	    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
	    this.reconcileTransaction = null;
	  },
	
	  perform: function (method, scope, a) {
	    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
	    // with this transaction's wrappers around it.
	    return Transaction.Mixin.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
	  }
	});
	
	PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);
	
	function batchedUpdates(callback, a, b, c, d, e) {
	  ensureInjected();
	  batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
	}
	
	/**
	 * Array comparator for ReactComponents by mount ordering.
	 *
	 * @param {ReactComponent} c1 first component you're comparing
	 * @param {ReactComponent} c2 second component you're comparing
	 * @return {number} Return value usable by Array.prototype.sort().
	 */
	function mountOrderComparator(c1, c2) {
	  return c1._mountOrder - c2._mountOrder;
	}
	
	function runBatchedUpdates(transaction) {
	  var len = transaction.dirtyComponentsLength;
	  !(len === dirtyComponents.length) ?  false ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to ' + 'match dirty-components array length (%s).', len, dirtyComponents.length) : invariant(false) : undefined;
	
	  // Since reconciling a component higher in the owner hierarchy usually (not
	  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
	  // them before their children by sorting the array.
	  dirtyComponents.sort(mountOrderComparator);
	
	  for (var i = 0; i < len; i++) {
	    // If a component is unmounted before pending changes apply, it will still
	    // be here, but we assume that it has cleared its _pendingCallbacks and
	    // that performUpdateIfNecessary is a noop.
	    var component = dirtyComponents[i];
	
	    // If performUpdateIfNecessary happens to enqueue any new updates, we
	    // shouldn't execute the callbacks until the next render happens, so
	    // stash the callbacks first
	    var callbacks = component._pendingCallbacks;
	    component._pendingCallbacks = null;
	
	    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction);
	
	    if (callbacks) {
	      for (var j = 0; j < callbacks.length; j++) {
	        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
	      }
	    }
	  }
	}
	
	var flushBatchedUpdates = function () {
	  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
	  // array and perform any updates enqueued by mount-ready handlers (i.e.,
	  // componentDidUpdate) but we need to check here too in order to catch
	  // updates enqueued by setState callbacks and asap calls.
	  while (dirtyComponents.length || asapEnqueued) {
	    if (dirtyComponents.length) {
	      var transaction = ReactUpdatesFlushTransaction.getPooled();
	      transaction.perform(runBatchedUpdates, null, transaction);
	      ReactUpdatesFlushTransaction.release(transaction);
	    }
	
	    if (asapEnqueued) {
	      asapEnqueued = false;
	      var queue = asapCallbackQueue;
	      asapCallbackQueue = CallbackQueue.getPooled();
	      queue.notifyAll();
	      CallbackQueue.release(queue);
	    }
	  }
	};
	flushBatchedUpdates = ReactPerf.measure('ReactUpdates', 'flushBatchedUpdates', flushBatchedUpdates);
	
	/**
	 * Mark a component as needing a rerender, adding an optional callback to a
	 * list of functions which will be executed once the rerender occurs.
	 */
	function enqueueUpdate(component) {
	  ensureInjected();
	
	  // Various parts of our code (such as ReactCompositeComponent's
	  // _renderValidatedComponent) assume that calls to render aren't nested;
	  // verify that that's the case. (This is called by each top-level update
	  // function, like setProps, setState, forceUpdate, etc.; creation and
	  // destruction of top-level components is guarded in ReactMount.)
	
	  if (!batchingStrategy.isBatchingUpdates) {
	    batchingStrategy.batchedUpdates(enqueueUpdate, component);
	    return;
	  }
	
	  dirtyComponents.push(component);
	}
	
	/**
	 * Enqueue a callback to be run at the end of the current batching cycle. Throws
	 * if no updates are currently being performed.
	 */
	function asap(callback, context) {
	  !batchingStrategy.isBatchingUpdates ?  false ? invariant(false, 'ReactUpdates.asap: Can\'t enqueue an asap callback in a context where' + 'updates are not being batched.') : invariant(false) : undefined;
	  asapCallbackQueue.enqueue(callback, context);
	  asapEnqueued = true;
	}
	
	var ReactUpdatesInjection = {
	  injectReconcileTransaction: function (ReconcileTransaction) {
	    !ReconcileTransaction ?  false ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : invariant(false) : undefined;
	    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
	  },
	
	  injectBatchingStrategy: function (_batchingStrategy) {
	    !_batchingStrategy ?  false ? invariant(false, 'ReactUpdates: must provide a batching strategy') : invariant(false) : undefined;
	    !(typeof _batchingStrategy.batchedUpdates === 'function') ?  false ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : invariant(false) : undefined;
	    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ?  false ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : invariant(false) : undefined;
	    batchingStrategy = _batchingStrategy;
	  }
	};
	
	var ReactUpdates = {
	  /**
	   * React references `ReactReconcileTransaction` using this property in order
	   * to allow dependency injection.
	   *
	   * @internal
	   */
	  ReactReconcileTransaction: null,
	
	  batchedUpdates: batchedUpdates,
	  enqueueUpdate: enqueueUpdate,
	  flushBatchedUpdates: flushBatchedUpdates,
	  injection: ReactUpdatesInjection,
	  asap: asap
	};
	
	module.exports = ReactUpdates;

/***/ }),
/* 9 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule emptyFunction
	 */
	
	"use strict";
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	function emptyFunction() {}
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x3, _x4, _x5) { var _again = true; _function: while (_again) { var object = _x3, property = _x4, receiver = _x5; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x3 = parent; _x4 = property; _x5 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(17);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(62);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _propTypes = __webpack_require__(34);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _baseStyles = __webpack_require__(116);
	
	var _baseStyles2 = _interopRequireDefault(_baseStyles);
	
	var _BurgerIcon = __webpack_require__(113);
	
	var _BurgerIcon2 = _interopRequireDefault(_BurgerIcon);
	
	var _CrossIcon = __webpack_require__(115);
	
	var _CrossIcon2 = _interopRequireDefault(_CrossIcon);
	
	exports['default'] = function (styles) {
	  var Menu = (function (_Component) {
	    _inherits(Menu, _Component);
	
	    function Menu(props) {
	      _classCallCheck(this, Menu);
	
	      _get(Object.getPrototypeOf(Menu.prototype), 'constructor', this).call(this, props);
	      this.state = {
	        isOpen: false
	      };
	    }
	
	    _createClass(Menu, [{
	      key: 'toggleMenu',
	      value: function toggleMenu() {
	        var _this = this;
	
	        var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	        var isOpen = options.isOpen;
	        var noStateChange = options.noStateChange;
	
	        var newState = {
	          isOpen: typeof isOpen !== 'undefined' ? isOpen : !this.state.isOpen
	        };
	
	        this.applyWrapperStyles();
	
	        this.setState(newState, function () {
	          !noStateChange && _this.props.onStateChange(newState);
	
	          // Timeout ensures wrappers are cleared after animation finishes.
	          _this.timeoutId && clearTimeout(_this.timeoutId);
	          _this.timeoutId = setTimeout(function () {
	            _this.timeoutId = null;
	            if (!newState.isOpen) {
	              _this.applyWrapperStyles(false);
	            }
	          }, 500);
	        });
	      }
	
	      // Applies component-specific styles to external wrapper elements.
	    }, {
	      key: 'applyWrapperStyles',
	      value: function applyWrapperStyles() {
	        var set = arguments.length <= 0 || arguments[0] === undefined ? true : arguments[0];
	
	        if (this.props.bodyClassName) {
	          var body = document.querySelector('body');
	          body.classList[set ? 'add' : 'remove'](this.props.bodyClassName);
	        }
	
	        if (styles.pageWrap && this.props.pageWrapId) {
	          this.handleExternalWrapper(this.props.pageWrapId, styles.pageWrap, set);
	        }
	
	        if (styles.outerContainer && this.props.outerContainerId) {
	          this.handleExternalWrapper(this.props.outerContainerId, styles.outerContainer, set);
	        }
	      }
	
	      // Sets or unsets styles on DOM elements outside the menu component.
	      // This is necessary for correct page interaction with some of the menus.
	      // Throws and returns if the required external elements don't exist,
	      // which means any external page animations won't be applied.
	    }, {
	      key: 'handleExternalWrapper',
	      value: function handleExternalWrapper(id, wrapperStyles, set) {
	        var html = document.querySelector('html');
	        var body = document.querySelector('body');
	        var wrapper = document.getElementById(id);
	
	        if (!wrapper) {
	          console.error("Element with ID '" + id + "' not found");
	          return;
	        }
	
	        var builtStyles = this.getStyle(wrapperStyles);
	
	        for (var prop in builtStyles) {
	          if (builtStyles.hasOwnProperty(prop)) {
	            wrapper.style[prop] = set ? builtStyles[prop] : '';
	          }
	        }
	
	        // Prevent any horizontal scroll.
	        [html, body].forEach(function (element) {
	          element.style['overflow-x'] = set ? 'hidden' : '';
	        });
	      }
	
	      // Builds styles incrementally for a given element.
	    }, {
	      key: 'getStyles',
	      value: function getStyles(el, index, inline) {
	        var propName = 'bm' + el.replace(el.charAt(0), el.charAt(0).toUpperCase());
	
	        // Set base styles.
	        var output = _baseStyles2['default'][el] ? this.getStyle(_baseStyles2['default'][el]) : {};
	
	        // Add animation-specific styles.
	        if (styles[el]) {
	          output = _extends({}, output, this.getStyle(styles[el], index + 1));
	        }
	
	        // Add custom styles.
	        if (this.props.styles[propName]) {
	          output = _extends({}, output, this.props.styles[propName]);
	        }
	
	        // Add element inline styles.
	        if (inline) {
	          output = _extends({}, output, inline);
	        }
	
	        return output;
	      }
	    }, {
	      key: 'getStyle',
	      value: function getStyle(style, index) {
	        var width = this.props.width;
	
	        var formattedWidth = typeof width !== 'string' ? width + 'px' : width;
	        return style(this.state.isOpen, formattedWidth, this.props.right, index);
	      }
	    }, {
	      key: 'listenForClose',
	      value: function listenForClose(e) {
	        e = e || window.event;
	
	        if (this.state.isOpen && (e.key === 'Escape' || e.keyCode === 27)) {
	          this.toggleMenu();
	        }
	      }
	    }, {
	      key: 'shouldDisableOverlayClick',
	      value: function shouldDisableOverlayClick() {
	        if (typeof this.props.disableOverlayClick === 'function') {
	          return this.props.disableOverlayClick();
	        } else {
	          return this.props.disableOverlayClick;
	        }
	      }
	    }, {
	      key: 'componentWillMount',
	      value: function componentWillMount() {
	        if (!styles) {
	          throw new Error('No styles supplied');
	        }
	      }
	    }, {
	      key: 'componentDidMount',
	      value: function componentDidMount() {
	        // Bind ESC key handler (unless disabled or custom function supplied).
	        if (this.props.customOnKeyDown) {
	          window.onkeydown = this.props.customOnKeyDown;
	        } else if (!this.props.disableCloseOnEsc) {
	          window.onkeydown = this.listenForClose.bind(this);
	        }
	
	        // Allow initial open state to be set by props.
	        if (this.props.isOpen) {
	          this.toggleMenu({ isOpen: true, noStateChange: true });
	        }
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        window.onkeydown = null;
	
	        this.applyWrapperStyles(false);
	      }
	    }, {
	      key: 'componentDidUpdate',
	      value: function componentDidUpdate() {
	        var _this2 = this;
	
	        if (styles.svg) {
	          (function () {
	            var morphShape = _reactDom2['default'].findDOMNode(_this2, 'bm-morph-shape');
	            var path = styles.svg.lib(morphShape).select('path');
	
	            if (_this2.state.isOpen) {
	              // Animate SVG path.
	              styles.svg.animate(path);
	            } else {
	              // Reset path (timeout ensures animation happens off screen).
	              setTimeout(function () {
	                path.attr('d', styles.svg.pathInitial);
	              }, 300);
	            }
	          })();
	        }
	      }
	    }, {
	      key: 'componentWillReceiveProps',
	      value: function componentWillReceiveProps(nextProps) {
	        if (typeof nextProps.isOpen !== 'undefined' && nextProps.isOpen !== this.state.isOpen) {
	          this.toggleMenu();
	        }
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _this3 = this;
	
	        return _react2['default'].createElement(
	          'div',
	          null,
	          !this.props.noOverlay && _react2['default'].createElement('div', {
	            className: ('bm-overlay ' + this.props.overlayClassName).trim(),
	            onClick: function () {
	              return !_this3.shouldDisableOverlayClick() && _this3.toggleMenu();
	            },
	            style: this.getStyles('overlay')
	          }),
	          _react2['default'].createElement(
	            'div',
	            {
	              id: this.props.id,
	              className: ('bm-menu-wrap ' + this.props.className).trim(),
	              style: this.getStyles('menuWrap')
	            },
	            styles.svg && _react2['default'].createElement(
	              'div',
	              {
	                className: ('bm-morph-shape ' + this.props.morphShapeClassName).trim(),
	                style: this.getStyles('morphShape')
	              },
	              _react2['default'].createElement(
	                'svg',
	                {
	                  width: '100%',
	                  height: '100%',
	                  viewBox: '0 0 100 800',
	                  preserveAspectRatio: 'none'
	                },
	                _react2['default'].createElement('path', { d: styles.svg.pathInitial })
	              )
	            ),
	            _react2['default'].createElement(
	              'div',
	              {
	                className: ('bm-menu ' + this.props.menuClassName).trim(),
	                style: this.getStyles('menu')
	              },
	              _react2['default'].createElement(
	                'nav',
	                {
	                  className: ('bm-item-list ' + this.props.itemListClassName).trim(),
	                  style: this.getStyles('itemList')
	                },
	                _react2['default'].Children.map(this.props.children, function (item, index) {
	                  if (item) {
	                    var classList = ['bm-item', _this3.props.itemClassName, item.props.className].filter(function (className) {
	                      return !!className;
	                    }).join(' ');
	                    var extraProps = {
	                      key: index,
	                      className: classList,
	                      style: _this3.getStyles('item', index, item.props.style)
	                    };
	                    return _react2['default'].cloneElement(item, extraProps);
	                  }
	                })
	              )
	            ),
	            this.props.customCrossIcon !== false && _react2['default'].createElement(
	              'div',
	              { style: this.getStyles('closeButton') },
	              _react2['default'].createElement(_CrossIcon2['default'], {
	                onClick: function () {
	                  return _this3.toggleMenu();
	                },
	                styles: this.props.styles,
	                customIcon: this.props.customCrossIcon,
	                className: this.props.crossButtonClassName,
	                crossClassName: this.props.crossClassName
	              })
	            )
	          ),
	          this.props.customBurgerIcon !== false && _react2['default'].createElement(
	            'div',
	            { style: this.getStyles('burgerIcon') },
	            _react2['default'].createElement(_BurgerIcon2['default'], {
	              onClick: function () {
	                return _this3.toggleMenu();
	              },
	              styles: this.props.styles,
	              customIcon: this.props.customBurgerIcon,
	              className: this.props.burgerButtonClassName,
	              barClassName: this.props.burgerBarClassName
	            })
	          )
	        );
	      }
	    }]);
	
	    return Menu;
	  })(_react.Component);
	
	  Menu.propTypes = {
	    bodyClassName: _propTypes2['default'].string,
	    burgerBarClassName: _propTypes2['default'].string,
	    burgerButtonClassName: _propTypes2['default'].string,
	    crossButtonClassName: _propTypes2['default'].string,
	    crossClassName: _propTypes2['default'].string,
	    customBurgerIcon: _propTypes2['default'].oneOfType([_propTypes2['default'].element, _propTypes2['default'].oneOf([false])]),
	    customCrossIcon: _propTypes2['default'].oneOfType([_propTypes2['default'].element, _propTypes2['default'].oneOf([false])]),
	    customOnKeyDown: _propTypes2['default'].func,
	    disableCloseOnEsc: _propTypes2['default'].bool,
	    disableOverlayClick: _propTypes2['default'].oneOfType([_propTypes2['default'].bool, _propTypes2['default'].func]),
	    id: _propTypes2['default'].string,
	    isOpen: _propTypes2['default'].bool,
	    itemClassName: _propTypes2['default'].string,
	    itemListClassName: _propTypes2['default'].string,
	    menuClassName: _propTypes2['default'].string,
	    morphShapeClassName: _propTypes2['default'].string,
	    noOverlay: _propTypes2['default'].bool,
	    onStateChange: _propTypes2['default'].func,
	    outerContainerId: styles && styles.outerContainer ? _propTypes2['default'].string.isRequired : _propTypes2['default'].string,
	    overlayClassName: _propTypes2['default'].string,
	    pageWrapId: styles && styles.pageWrap ? _propTypes2['default'].string.isRequired : _propTypes2['default'].string,
	    right: _propTypes2['default'].bool,
	    styles: _propTypes2['default'].object,
	    width: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].string])
	  };
	
	  Menu.defaultProps = {
	    bodyClassName: '',
	    burgerBarClassName: '',
	    burgerButtonClassName: '',
	    className: '',
	    crossButtonClassName: '',
	    crossClassName: '',
	    disableCloseOnEsc: false,
	    id: '',
	    itemClassName: '',
	    itemListClassName: '',
	    menuClassName: '',
	    morphShapeClassName: '',
	    noOverlay: false,
	    onStateChange: function onStateChange() {},
	    outerContainerId: '',
	    overlayClassName: '',
	    pageWrapId: '',
	    styles: {},
	    width: 300
	  };
	
	  return Menu;
	};
	
	module.exports = exports['default'];

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventConstants
	 */
	
	'use strict';
	
	var keyMirror = __webpack_require__(25);
	
	var PropagationPhases = keyMirror({ bubbled: null, captured: null });
	
	/**
	 * Types of raw signals from the browser caught at the top level.
	 */
	var topLevelTypes = keyMirror({
	  topAbort: null,
	  topBlur: null,
	  topCanPlay: null,
	  topCanPlayThrough: null,
	  topChange: null,
	  topClick: null,
	  topCompositionEnd: null,
	  topCompositionStart: null,
	  topCompositionUpdate: null,
	  topContextMenu: null,
	  topCopy: null,
	  topCut: null,
	  topDoubleClick: null,
	  topDrag: null,
	  topDragEnd: null,
	  topDragEnter: null,
	  topDragExit: null,
	  topDragLeave: null,
	  topDragOver: null,
	  topDragStart: null,
	  topDrop: null,
	  topDurationChange: null,
	  topEmptied: null,
	  topEncrypted: null,
	  topEnded: null,
	  topError: null,
	  topFocus: null,
	  topInput: null,
	  topKeyDown: null,
	  topKeyPress: null,
	  topKeyUp: null,
	  topLoad: null,
	  topLoadedData: null,
	  topLoadedMetadata: null,
	  topLoadStart: null,
	  topMouseDown: null,
	  topMouseMove: null,
	  topMouseOut: null,
	  topMouseOver: null,
	  topMouseUp: null,
	  topPaste: null,
	  topPause: null,
	  topPlay: null,
	  topPlaying: null,
	  topProgress: null,
	  topRateChange: null,
	  topReset: null,
	  topScroll: null,
	  topSeeked: null,
	  topSeeking: null,
	  topSelectionChange: null,
	  topStalled: null,
	  topSubmit: null,
	  topSuspend: null,
	  topTextInput: null,
	  topTimeUpdate: null,
	  topTouchCancel: null,
	  topTouchEnd: null,
	  topTouchMove: null,
	  topTouchStart: null,
	  topVolumeChange: null,
	  topWaiting: null,
	  topWheel: null
	});
	
	var EventConstants = {
	  topLevelTypes: topLevelTypes,
	  PropagationPhases: PropagationPhases
	};
	
	module.exports = EventConstants;

/***/ }),
/* 12 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactCurrentOwner
	 */
	
	'use strict';
	
	/**
	 * Keeps track of the current owner.
	 *
	 * The current owner is the component who should own any components that are
	 * currently being constructed.
	 */
	var ReactCurrentOwner = {
	
	  /**
	   * @internal
	   * @type {ReactComponent}
	   */
	  current: null
	
	};
	
	module.exports = ReactCurrentOwner;

/***/ }),
/* 13 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule keyOf
	 */
	
	/**
	 * Allows extraction of a minified key. Let's the build system minify keys
	 * without losing the ability to dynamically use key strings as values
	 * themselves. Pass in an object with a single key/val pair and it will return
	 * you the string key of that single record. Suppose you want to grab the
	 * value for a key 'className' inside of an object. Key/val minification may
	 * have aliased that key to be 'xa12'. keyOf({className: null}) will return
	 * 'xa12' in that case. Resolve keys you want to use once at startup time, then
	 * reuse those resolutions.
	 */
	"use strict";
	
	var keyOf = function (oneKeyObj) {
	  var key;
	  for (key in oneKeyObj) {
	    if (!oneKeyObj.hasOwnProperty(key)) {
	      continue;
	    }
	    return key;
	  }
	  return null;
	};
	
	module.exports = keyOf;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule PooledClass
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(1);
	
	/**
	 * Static poolers. Several custom versions for each potential number of
	 * arguments. A completely generic pooler is easy to implement, but would
	 * require accessing the `arguments` object. In each of these, `this` refers to
	 * the Class itself, not an instance. If any others are needed, simply add them
	 * here, or in their own files.
	 */
	var oneArgumentPooler = function (copyFieldsFrom) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, copyFieldsFrom);
	    return instance;
	  } else {
	    return new Klass(copyFieldsFrom);
	  }
	};
	
	var twoArgumentPooler = function (a1, a2) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2);
	    return instance;
	  } else {
	    return new Klass(a1, a2);
	  }
	};
	
	var threeArgumentPooler = function (a1, a2, a3) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3);
	  }
	};
	
	var fourArgumentPooler = function (a1, a2, a3, a4) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4);
	  }
	};
	
	var fiveArgumentPooler = function (a1, a2, a3, a4, a5) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4, a5);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4, a5);
	  }
	};
	
	var standardReleaser = function (instance) {
	  var Klass = this;
	  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : invariant(false) : undefined;
	  instance.destructor();
	  if (Klass.instancePool.length < Klass.poolSize) {
	    Klass.instancePool.push(instance);
	  }
	};
	
	var DEFAULT_POOL_SIZE = 10;
	var DEFAULT_POOLER = oneArgumentPooler;
	
	/**
	 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
	 * itself (statically) not adding any prototypical fields. Any CopyConstructor
	 * you give this may have a `poolSize` property, and will look for a
	 * prototypical `destructor` on instances (optional).
	 *
	 * @param {Function} CopyConstructor Constructor that can be used to reset.
	 * @param {Function} pooler Customizable pooler.
	 */
	var addPoolingTo = function (CopyConstructor, pooler) {
	  var NewKlass = CopyConstructor;
	  NewKlass.instancePool = [];
	  NewKlass.getPooled = pooler || DEFAULT_POOLER;
	  if (!NewKlass.poolSize) {
	    NewKlass.poolSize = DEFAULT_POOL_SIZE;
	  }
	  NewKlass.release = standardReleaser;
	  return NewKlass;
	};
	
	var PooledClass = {
	  addPoolingTo: addPoolingTo,
	  oneArgumentPooler: oneArgumentPooler,
	  twoArgumentPooler: twoArgumentPooler,
	  threeArgumentPooler: threeArgumentPooler,
	  fourArgumentPooler: fourArgumentPooler,
	  fiveArgumentPooler: fiveArgumentPooler
	};
	
	module.exports = PooledClass;

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactReconciler
	 */
	
	'use strict';
	
	var ReactRef = __webpack_require__(157);
	
	/**
	 * Helper to call ReactRef.attachRefs with this composite component, split out
	 * to avoid allocations in the transaction mount-ready queue.
	 */
	function attachRefs() {
	  ReactRef.attachRefs(this, this._currentElement);
	}
	
	var ReactReconciler = {
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {string} rootID DOM ID of the root node.
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (internalInstance, rootID, transaction, context) {
	    var markup = internalInstance.mountComponent(rootID, transaction, context);
	    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	    return markup;
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (internalInstance) {
	    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
	    internalInstance.unmountComponent();
	  },
	
	  /**
	   * Update a component using a new element.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @internal
	   */
	  receiveComponent: function (internalInstance, nextElement, transaction, context) {
	    var prevElement = internalInstance._currentElement;
	
	    if (nextElement === prevElement && context === internalInstance._context) {
	      // Since elements are immutable after the owner is rendered,
	      // we can do a cheap identity compare here to determine if this is a
	      // superfluous reconcile. It's possible for state to be mutable but such
	      // change should trigger an update of the owner which would recreate
	      // the element. We explicitly check for the existence of an owner since
	      // it's possible for an element created outside a composite to be
	      // deeply mutated and reused.
	
	      // TODO: Bailing out early is just a perf optimization right?
	      // TODO: Removing the return statement should affect correctness?
	      return;
	    }
	
	    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);
	
	    if (refsChanged) {
	      ReactRef.detachRefs(internalInstance, prevElement);
	    }
	
	    internalInstance.receiveComponent(nextElement, transaction, context);
	
	    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	  },
	
	  /**
	   * Flush any dirty changes in a component.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (internalInstance, transaction) {
	    internalInstance.performUpdateIfNecessary(transaction);
	  }
	
	};
	
	module.exports = ReactReconciler;

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(14);
	
	var assign = __webpack_require__(3);
	var emptyFunction = __webpack_require__(9);
	var warning = __webpack_require__(2);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var EventInterface = {
	  type: null,
	  target: null,
	  // currentTarget is set when dispatching; no use in copying it here
	  currentTarget: emptyFunction.thatReturnsNull,
	  eventPhase: null,
	  bubbles: null,
	  cancelable: null,
	  timeStamp: function (event) {
	    return event.timeStamp || Date.now();
	  },
	  defaultPrevented: null,
	  isTrusted: null
	};
	
	/**
	 * Synthetic events are dispatched by event plugins, typically in response to a
	 * top-level event delegation handler.
	 *
	 * These systems should generally use pooling to reduce the frequency of garbage
	 * collection. The system should check `isPersistent` to determine whether the
	 * event should be released into the pool after being dispatched. Users that
	 * need a persisted event should invoke `persist`.
	 *
	 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
	 * normalizing browser quirks. Subclasses do not necessarily have to implement a
	 * DOM interface; custom application-specific events can also subclass this.
	 *
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 */
	function SyntheticEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  this.dispatchConfig = dispatchConfig;
	  this.dispatchMarker = dispatchMarker;
	  this.nativeEvent = nativeEvent;
	
	  var Interface = this.constructor.Interface;
	  for (var propName in Interface) {
	    if (!Interface.hasOwnProperty(propName)) {
	      continue;
	    }
	    var normalize = Interface[propName];
	    if (normalize) {
	      this[propName] = normalize(nativeEvent);
	    } else {
	      if (propName === 'target') {
	        this.target = nativeEventTarget;
	      } else {
	        this[propName] = nativeEvent[propName];
	      }
	    }
	  }
	
	  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
	  if (defaultPrevented) {
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  } else {
	    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
	  }
	  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
	}
	
	assign(SyntheticEvent.prototype, {
	
	  preventDefault: function () {
	    this.defaultPrevented = true;
	    var event = this.nativeEvent;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(event, 'This synthetic event is reused for performance reasons. If you\'re ' + 'seeing this, you\'re calling `preventDefault` on a ' + 'released/nullified synthetic event. This is a no-op. See ' + 'https://fb.me/react-event-pooling for more information.') : undefined;
	    }
	    if (!event) {
	      return;
	    }
	
	    if (event.preventDefault) {
	      event.preventDefault();
	    } else {
	      event.returnValue = false;
	    }
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  },
	
	  stopPropagation: function () {
	    var event = this.nativeEvent;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(event, 'This synthetic event is reused for performance reasons. If you\'re ' + 'seeing this, you\'re calling `stopPropagation` on a ' + 'released/nullified synthetic event. This is a no-op. See ' + 'https://fb.me/react-event-pooling for more information.') : undefined;
	    }
	    if (!event) {
	      return;
	    }
	
	    if (event.stopPropagation) {
	      event.stopPropagation();
	    } else {
	      event.cancelBubble = true;
	    }
	    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * We release all dispatched `SyntheticEvent`s after each event loop, adding
	   * them back into the pool. This allows a way to hold onto a reference that
	   * won't be added back into the pool.
	   */
	  persist: function () {
	    this.isPersistent = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * Checks if this event should be released back into the pool.
	   *
	   * @return {boolean} True if this should not be released, false otherwise.
	   */
	  isPersistent: emptyFunction.thatReturnsFalse,
	
	  /**
	   * `PooledClass` looks for `destructor` on each instance it releases.
	   */
	  destructor: function () {
	    var Interface = this.constructor.Interface;
	    for (var propName in Interface) {
	      this[propName] = null;
	    }
	    this.dispatchConfig = null;
	    this.dispatchMarker = null;
	    this.nativeEvent = null;
	  }
	
	});
	
	SyntheticEvent.Interface = EventInterface;
	
	/**
	 * Helper to reduce boilerplate when creating subclasses.
	 *
	 * @param {function} Class
	 * @param {?object} Interface
	 */
	SyntheticEvent.augmentClass = function (Class, Interface) {
	  var Super = this;
	
	  var prototype = Object.create(Super.prototype);
	  assign(prototype, Class.prototype);
	  Class.prototype = prototype;
	  Class.prototype.constructor = Class;
	
	  Class.Interface = assign({}, Super.Interface, Interface);
	  Class.augmentClass = Super.augmentClass;
	
	  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
	};
	
	PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);
	
	module.exports = SyntheticEvent;

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(138);


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DOMProperty
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(1);
	
	function checkMask(value, bitmask) {
	  return (value & bitmask) === bitmask;
	}
	
	var DOMPropertyInjection = {
	  /**
	   * Mapping from normalized, camelcased property names to a configuration that
	   * specifies how the associated DOM property should be accessed or rendered.
	   */
	  MUST_USE_ATTRIBUTE: 0x1,
	  MUST_USE_PROPERTY: 0x2,
	  HAS_SIDE_EFFECTS: 0x4,
	  HAS_BOOLEAN_VALUE: 0x8,
	  HAS_NUMERIC_VALUE: 0x10,
	  HAS_POSITIVE_NUMERIC_VALUE: 0x20 | 0x10,
	  HAS_OVERLOADED_BOOLEAN_VALUE: 0x40,
	
	  /**
	   * Inject some specialized knowledge about the DOM. This takes a config object
	   * with the following properties:
	   *
	   * isCustomAttribute: function that given an attribute name will return true
	   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
	   * attributes where it's impossible to enumerate all of the possible
	   * attribute names,
	   *
	   * Properties: object mapping DOM property name to one of the
	   * DOMPropertyInjection constants or null. If your attribute isn't in here,
	   * it won't get written to the DOM.
	   *
	   * DOMAttributeNames: object mapping React attribute name to the DOM
	   * attribute name. Attribute names not specified use the **lowercase**
	   * normalized name.
	   *
	   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
	   * attribute namespace URL. (Attribute names not specified use no namespace.)
	   *
	   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
	   * Property names not specified use the normalized name.
	   *
	   * DOMMutationMethods: Properties that require special mutation methods. If
	   * `value` is undefined, the mutation method should unset the property.
	   *
	   * @param {object} domPropertyConfig the config as described above.
	   */
	  injectDOMPropertyConfig: function (domPropertyConfig) {
	    var Injection = DOMPropertyInjection;
	    var Properties = domPropertyConfig.Properties || {};
	    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
	    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
	    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
	    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};
	
	    if (domPropertyConfig.isCustomAttribute) {
	      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
	    }
	
	    for (var propName in Properties) {
	      !!DOMProperty.properties.hasOwnProperty(propName) ?  false ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property ' + '\'%s\' which has already been injected. You may be accidentally ' + 'injecting the same DOM property config twice, or you may be ' + 'injecting two configs that have conflicting property names.', propName) : invariant(false) : undefined;
	
	      var lowerCased = propName.toLowerCase();
	      var propConfig = Properties[propName];
	
	      var propertyInfo = {
	        attributeName: lowerCased,
	        attributeNamespace: null,
	        propertyName: propName,
	        mutationMethod: null,
	
	        mustUseAttribute: checkMask(propConfig, Injection.MUST_USE_ATTRIBUTE),
	        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
	        hasSideEffects: checkMask(propConfig, Injection.HAS_SIDE_EFFECTS),
	        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
	        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
	        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
	        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
	      };
	
	      !(!propertyInfo.mustUseAttribute || !propertyInfo.mustUseProperty) ?  false ? invariant(false, 'DOMProperty: Cannot require using both attribute and property: %s', propName) : invariant(false) : undefined;
	      !(propertyInfo.mustUseProperty || !propertyInfo.hasSideEffects) ?  false ? invariant(false, 'DOMProperty: Properties that have side effects must use property: %s', propName) : invariant(false) : undefined;
	      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  false ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or ' + 'numeric value, but not a combination: %s', propName) : invariant(false) : undefined;
	
	      if (false) {
	        DOMProperty.getPossibleStandardName[lowerCased] = propName;
	      }
	
	      if (DOMAttributeNames.hasOwnProperty(propName)) {
	        var attributeName = DOMAttributeNames[propName];
	        propertyInfo.attributeName = attributeName;
	        if (false) {
	          DOMProperty.getPossibleStandardName[attributeName] = propName;
	        }
	      }
	
	      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
	        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
	      }
	
	      if (DOMPropertyNames.hasOwnProperty(propName)) {
	        propertyInfo.propertyName = DOMPropertyNames[propName];
	      }
	
	      if (DOMMutationMethods.hasOwnProperty(propName)) {
	        propertyInfo.mutationMethod = DOMMutationMethods[propName];
	      }
	
	      DOMProperty.properties[propName] = propertyInfo;
	    }
	  }
	};
	var defaultValueCache = {};
	
	/**
	 * DOMProperty exports lookup objects that can be used like functions:
	 *
	 *   > DOMProperty.isValid['id']
	 *   true
	 *   > DOMProperty.isValid['foobar']
	 *   undefined
	 *
	 * Although this may be confusing, it performs better in general.
	 *
	 * @see http://jsperf.com/key-exists
	 * @see http://jsperf.com/key-missing
	 */
	var DOMProperty = {
	
	  ID_ATTRIBUTE_NAME: 'data-reactid',
	
	  /**
	   * Map from property "standard name" to an object with info about how to set
	   * the property in the DOM. Each object contains:
	   *
	   * attributeName:
	   *   Used when rendering markup or with `*Attribute()`.
	   * attributeNamespace
	   * propertyName:
	   *   Used on DOM node instances. (This includes properties that mutate due to
	   *   external factors.)
	   * mutationMethod:
	   *   If non-null, used instead of the property or `setAttribute()` after
	   *   initial render.
	   * mustUseAttribute:
	   *   Whether the property must be accessed and mutated using `*Attribute()`.
	   *   (This includes anything that fails `<propName> in <element>`.)
	   * mustUseProperty:
	   *   Whether the property must be accessed and mutated as an object property.
	   * hasSideEffects:
	   *   Whether or not setting a value causes side effects such as triggering
	   *   resources to be loaded or text selection changes. If true, we read from
	   *   the DOM before updating to ensure that the value is only set if it has
	   *   changed.
	   * hasBooleanValue:
	   *   Whether the property should be removed when set to a falsey value.
	   * hasNumericValue:
	   *   Whether the property must be numeric or parse as a numeric and should be
	   *   removed when set to a falsey value.
	   * hasPositiveNumericValue:
	   *   Whether the property must be positive numeric or parse as a positive
	   *   numeric and should be removed when set to a falsey value.
	   * hasOverloadedBooleanValue:
	   *   Whether the property can be used as a flag as well as with a value.
	   *   Removed when strictly equal to false; present without a value when
	   *   strictly equal to true; present with a value otherwise.
	   */
	  properties: {},
	
	  /**
	   * Mapping from lowercase property names to the properly cased version, used
	   * to warn in the case of missing properties. Available only in __DEV__.
	   * @type {Object}
	   */
	  getPossibleStandardName:  false ? {} : null,
	
	  /**
	   * All of the isCustomAttribute() functions that have been injected.
	   */
	  _isCustomAttributeFunctions: [],
	
	  /**
	   * Checks whether a property name is a custom attribute.
	   * @method
	   */
	  isCustomAttribute: function (attributeName) {
	    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
	      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
	      if (isCustomAttributeFn(attributeName)) {
	        return true;
	      }
	    }
	    return false;
	  },
	
	  /**
	   * Returns the default property value for a DOM property (i.e., not an
	   * attribute). Most default values are '' or false, but not all. Worse yet,
	   * some (in particular, `type`) vary depending on the type of element.
	   *
	   * TODO: Is it better to grab all the possible properties when creating an
	   * element to avoid having to create the same element twice?
	   */
	  getDefaultValueForProperty: function (nodeName, prop) {
	    var nodeDefaults = defaultValueCache[nodeName];
	    var testElement;
	    if (!nodeDefaults) {
	      defaultValueCache[nodeName] = nodeDefaults = {};
	    }
	    if (!(prop in nodeDefaults)) {
	      testElement = document.createElement(nodeName);
	      nodeDefaults[prop] = testElement[prop];
	    }
	    return nodeDefaults[prop];
	  },
	
	  injection: DOMPropertyInjection
	};
	
	module.exports = DOMProperty;

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactInstanceHandles
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var ReactRootIndex = __webpack_require__(85);
	
	var invariant = __webpack_require__(1);
	
	var SEPARATOR = '.';
	var SEPARATOR_LENGTH = SEPARATOR.length;
	
	/**
	 * Maximum depth of traversals before we consider the possibility of a bad ID.
	 */
	var MAX_TREE_DEPTH = 10000;
	
	/**
	 * Creates a DOM ID prefix to use when mounting React components.
	 *
	 * @param {number} index A unique integer
	 * @return {string} React root ID.
	 * @internal
	 */
	function getReactRootIDString(index) {
	  return SEPARATOR + index.toString(36);
	}
	
	/**
	 * Checks if a character in the supplied ID is a separator or the end.
	 *
	 * @param {string} id A React DOM ID.
	 * @param {number} index Index of the character to check.
	 * @return {boolean} True if the character is a separator or end of the ID.
	 * @private
	 */
	function isBoundary(id, index) {
	  return id.charAt(index) === SEPARATOR || index === id.length;
	}
	
	/**
	 * Checks if the supplied string is a valid React DOM ID.
	 *
	 * @param {string} id A React DOM ID, maybe.
	 * @return {boolean} True if the string is a valid React DOM ID.
	 * @private
	 */
	function isValidID(id) {
	  return id === '' || id.charAt(0) === SEPARATOR && id.charAt(id.length - 1) !== SEPARATOR;
	}
	
	/**
	 * Checks if the first ID is an ancestor of or equal to the second ID.
	 *
	 * @param {string} ancestorID
	 * @param {string} descendantID
	 * @return {boolean} True if `ancestorID` is an ancestor of `descendantID`.
	 * @internal
	 */
	function isAncestorIDOf(ancestorID, descendantID) {
	  return descendantID.indexOf(ancestorID) === 0 && isBoundary(descendantID, ancestorID.length);
	}
	
	/**
	 * Gets the parent ID of the supplied React DOM ID, `id`.
	 *
	 * @param {string} id ID of a component.
	 * @return {string} ID of the parent, or an empty string.
	 * @private
	 */
	function getParentID(id) {
	  return id ? id.substr(0, id.lastIndexOf(SEPARATOR)) : '';
	}
	
	/**
	 * Gets the next DOM ID on the tree path from the supplied `ancestorID` to the
	 * supplied `destinationID`. If they are equal, the ID is returned.
	 *
	 * @param {string} ancestorID ID of an ancestor node of `destinationID`.
	 * @param {string} destinationID ID of the destination node.
	 * @return {string} Next ID on the path from `ancestorID` to `destinationID`.
	 * @private
	 */
	function getNextDescendantID(ancestorID, destinationID) {
	  !(isValidID(ancestorID) && isValidID(destinationID)) ?  false ? invariant(false, 'getNextDescendantID(%s, %s): Received an invalid React DOM ID.', ancestorID, destinationID) : invariant(false) : undefined;
	  !isAncestorIDOf(ancestorID, destinationID) ?  false ? invariant(false, 'getNextDescendantID(...): React has made an invalid assumption about ' + 'the DOM hierarchy. Expected `%s` to be an ancestor of `%s`.', ancestorID, destinationID) : invariant(false) : undefined;
	  if (ancestorID === destinationID) {
	    return ancestorID;
	  }
	  // Skip over the ancestor and the immediate separator. Traverse until we hit
	  // another separator or we reach the end of `destinationID`.
	  var start = ancestorID.length + SEPARATOR_LENGTH;
	  var i;
	  for (i = start; i < destinationID.length; i++) {
	    if (isBoundary(destinationID, i)) {
	      break;
	    }
	  }
	  return destinationID.substr(0, i);
	}
	
	/**
	 * Gets the nearest common ancestor ID of two IDs.
	 *
	 * Using this ID scheme, the nearest common ancestor ID is the longest common
	 * prefix of the two IDs that immediately preceded a "marker" in both strings.
	 *
	 * @param {string} oneID
	 * @param {string} twoID
	 * @return {string} Nearest common ancestor ID, or the empty string if none.
	 * @private
	 */
	function getFirstCommonAncestorID(oneID, twoID) {
	  var minLength = Math.min(oneID.length, twoID.length);
	  if (minLength === 0) {
	    return '';
	  }
	  var lastCommonMarkerIndex = 0;
	  // Use `<=` to traverse until the "EOL" of the shorter string.
	  for (var i = 0; i <= minLength; i++) {
	    if (isBoundary(oneID, i) && isBoundary(twoID, i)) {
	      lastCommonMarkerIndex = i;
	    } else if (oneID.charAt(i) !== twoID.charAt(i)) {
	      break;
	    }
	  }
	  var longestCommonID = oneID.substr(0, lastCommonMarkerIndex);
	  !isValidID(longestCommonID) ?  false ? invariant(false, 'getFirstCommonAncestorID(%s, %s): Expected a valid React DOM ID: %s', oneID, twoID, longestCommonID) : invariant(false) : undefined;
	  return longestCommonID;
	}
	
	/**
	 * Traverses the parent path between two IDs (either up or down). The IDs must
	 * not be the same, and there must exist a parent path between them. If the
	 * callback returns `false`, traversal is stopped.
	 *
	 * @param {?string} start ID at which to start traversal.
	 * @param {?string} stop ID at which to end traversal.
	 * @param {function} cb Callback to invoke each ID with.
	 * @param {*} arg Argument to invoke the callback with.
	 * @param {?boolean} skipFirst Whether or not to skip the first node.
	 * @param {?boolean} skipLast Whether or not to skip the last node.
	 * @private
	 */
	function traverseParentPath(start, stop, cb, arg, skipFirst, skipLast) {
	  start = start || '';
	  stop = stop || '';
	  !(start !== stop) ?  false ? invariant(false, 'traverseParentPath(...): Cannot traverse from and to the same ID, `%s`.', start) : invariant(false) : undefined;
	  var traverseUp = isAncestorIDOf(stop, start);
	  !(traverseUp || isAncestorIDOf(start, stop)) ?  false ? invariant(false, 'traverseParentPath(%s, %s, ...): Cannot traverse from two IDs that do ' + 'not have a parent path.', start, stop) : invariant(false) : undefined;
	  // Traverse from `start` to `stop` one depth at a time.
	  var depth = 0;
	  var traverse = traverseUp ? getParentID : getNextDescendantID;
	  for (var id = start;; /* until break */id = traverse(id, stop)) {
	    var ret;
	    if ((!skipFirst || id !== start) && (!skipLast || id !== stop)) {
	      ret = cb(id, traverseUp, arg);
	    }
	    if (ret === false || id === stop) {
	      // Only break //after// visiting `stop`.
	      break;
	    }
	    !(depth++ < MAX_TREE_DEPTH) ?  false ? invariant(false, 'traverseParentPath(%s, %s, ...): Detected an infinite loop while ' + 'traversing the React DOM ID tree. This may be due to malformed IDs: %s', start, stop, id) : invariant(false) : undefined;
	  }
	}
	
	/**
	 * Manages the IDs assigned to DOM representations of React components. This
	 * uses a specific scheme in order to traverse the DOM efficiently (e.g. in
	 * order to simulate events).
	 *
	 * @internal
	 */
	var ReactInstanceHandles = {
	
	  /**
	   * Constructs a React root ID
	   * @return {string} A React root ID.
	   */
	  createReactRootID: function () {
	    return getReactRootIDString(ReactRootIndex.createReactRootIndex());
	  },
	
	  /**
	   * Constructs a React ID by joining a root ID with a name.
	   *
	   * @param {string} rootID Root ID of a parent component.
	   * @param {string} name A component's name (as flattened children).
	   * @return {string} A React ID.
	   * @internal
	   */
	  createReactID: function (rootID, name) {
	    return rootID + name;
	  },
	
	  /**
	   * Gets the DOM ID of the React component that is the root of the tree that
	   * contains the React component with the supplied DOM ID.
	   *
	   * @param {string} id DOM ID of a React component.
	   * @return {?string} DOM ID of the React component that is the root.
	   * @internal
	   */
	  getReactRootIDFromNodeID: function (id) {
	    if (id && id.charAt(0) === SEPARATOR && id.length > 1) {
	      var index = id.indexOf(SEPARATOR, 1);
	      return index > -1 ? id.substr(0, index) : id;
	    }
	    return null;
	  },
	
	  /**
	   * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
	   * should would receive a `mouseEnter` or `mouseLeave` event.
	   *
	   * NOTE: Does not invoke the callback on the nearest common ancestor because
	   * nothing "entered" or "left" that element.
	   *
	   * @param {string} leaveID ID being left.
	   * @param {string} enterID ID being entered.
	   * @param {function} cb Callback to invoke on each entered/left ID.
	   * @param {*} upArg Argument to invoke the callback with on left IDs.
	   * @param {*} downArg Argument to invoke the callback with on entered IDs.
	   * @internal
	   */
	  traverseEnterLeave: function (leaveID, enterID, cb, upArg, downArg) {
	    var ancestorID = getFirstCommonAncestorID(leaveID, enterID);
	    if (ancestorID !== leaveID) {
	      traverseParentPath(leaveID, ancestorID, cb, upArg, false, true);
	    }
	    if (ancestorID !== enterID) {
	      traverseParentPath(ancestorID, enterID, cb, downArg, true, false);
	    }
	  },
	
	  /**
	   * Simulates the traversal of a two-phase, capture/bubble event dispatch.
	   *
	   * NOTE: This traversal happens on IDs without touching the DOM.
	   *
	   * @param {string} targetID ID of the target node.
	   * @param {function} cb Callback to invoke.
	   * @param {*} arg Argument to invoke the callback with.
	   * @internal
	   */
	  traverseTwoPhase: function (targetID, cb, arg) {
	    if (targetID) {
	      traverseParentPath('', targetID, cb, arg, true, false);
	      traverseParentPath(targetID, '', cb, arg, false, true);
	    }
	  },
	
	  /**
	   * Same as `traverseTwoPhase` but skips the `targetID`.
	   */
	  traverseTwoPhaseSkipTarget: function (targetID, cb, arg) {
	    if (targetID) {
	      traverseParentPath('', targetID, cb, arg, true, true);
	      traverseParentPath(targetID, '', cb, arg, true, true);
	    }
	  },
	
	  /**
	   * Traverse a node ID, calling the supplied `cb` for each ancestor ID. For
	   * example, passing `.0.$row-0.1` would result in `cb` getting called
	   * with `.0`, `.0.$row-0`, and `.0.$row-0.1`.
	   *
	   * NOTE: This traversal happens on IDs without touching the DOM.
	   *
	   * @param {string} targetID ID of the target node.
	   * @param {function} cb Callback to invoke.
	   * @param {*} arg Argument to invoke the callback with.
	   * @internal
	   */
	  traverseAncestors: function (targetID, cb, arg) {
	    traverseParentPath('', targetID, cb, arg, true, false);
	  },
	
	  getFirstCommonAncestorID: getFirstCommonAncestorID,
	
	  /**
	   * Exposed for unit testing.
	   * @private
	   */
	  _getNextDescendantID: getNextDescendantID,
	
	  isAncestorIDOf: isAncestorIDOf,
	
	  SEPARATOR: SEPARATOR
	
	};
	
	module.exports = ReactInstanceHandles;

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule emptyObject
	 */
	
	'use strict';
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	module.exports = emptyObject;

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventPluginHub
	 */
	
	'use strict';
	
	var EventPluginRegistry = __webpack_require__(65);
	var EventPluginUtils = __webpack_require__(135);
	var ReactErrorUtils = __webpack_require__(78);
	
	var accumulateInto = __webpack_require__(87);
	var forEachAccumulated = __webpack_require__(88);
	var invariant = __webpack_require__(1);
	var warning = __webpack_require__(2);
	
	/**
	 * Internal store for event listeners
	 */
	var listenerBank = {};
	
	/**
	 * Internal queue of events that have accumulated their dispatches and are
	 * waiting to have their dispatches executed.
	 */
	var eventQueue = null;
	
	/**
	 * Dispatches an event and releases it back into the pool, unless persistent.
	 *
	 * @param {?object} event Synthetic event to be dispatched.
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @private
	 */
	var executeDispatchesAndRelease = function (event, simulated) {
	  if (event) {
	    EventPluginUtils.executeDispatchesInOrder(event, simulated);
	
	    if (!event.isPersistent()) {
	      event.constructor.release(event);
	    }
	  }
	};
	var executeDispatchesAndReleaseSimulated = function (e) {
	  return executeDispatchesAndRelease(e, true);
	};
	var executeDispatchesAndReleaseTopLevel = function (e) {
	  return executeDispatchesAndRelease(e, false);
	};
	
	/**
	 * - `InstanceHandle`: [required] Module that performs logical traversals of DOM
	 *   hierarchy given ids of the logical DOM elements involved.
	 */
	var InstanceHandle = null;
	
	function validateInstanceHandle() {
	  var valid = InstanceHandle && InstanceHandle.traverseTwoPhase && InstanceHandle.traverseEnterLeave;
	   false ? warning(valid, 'InstanceHandle not injected before use!') : undefined;
	}
	
	/**
	 * This is a unified interface for event plugins to be installed and configured.
	 *
	 * Event plugins can implement the following properties:
	 *
	 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
	 *     Required. When a top-level event is fired, this method is expected to
	 *     extract synthetic events that will in turn be queued and dispatched.
	 *
	 *   `eventTypes` {object}
	 *     Optional, plugins that fire events must publish a mapping of registration
	 *     names that are used to register listeners. Values of this mapping must
	 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
	 *
	 *   `executeDispatch` {function(object, function, string)}
	 *     Optional, allows plugins to override how an event gets dispatched. By
	 *     default, the listener is simply invoked.
	 *
	 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
	 *
	 * @public
	 */
	var EventPluginHub = {
	
	  /**
	   * Methods for injecting dependencies.
	   */
	  injection: {
	
	    /**
	     * @param {object} InjectedMount
	     * @public
	     */
	    injectMount: EventPluginUtils.injection.injectMount,
	
	    /**
	     * @param {object} InjectedInstanceHandle
	     * @public
	     */
	    injectInstanceHandle: function (InjectedInstanceHandle) {
	      InstanceHandle = InjectedInstanceHandle;
	      if (false) {
	        validateInstanceHandle();
	      }
	    },
	
	    getInstanceHandle: function () {
	      if (false) {
	        validateInstanceHandle();
	      }
	      return InstanceHandle;
	    },
	
	    /**
	     * @param {array} InjectedEventPluginOrder
	     * @public
	     */
	    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,
	
	    /**
	     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	     */
	    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName
	
	  },
	
	  eventNameDispatchConfigs: EventPluginRegistry.eventNameDispatchConfigs,
	
	  registrationNameModules: EventPluginRegistry.registrationNameModules,
	
	  /**
	   * Stores `listener` at `listenerBank[registrationName][id]`. Is idempotent.
	   *
	   * @param {string} id ID of the DOM element.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {?function} listener The callback to store.
	   */
	  putListener: function (id, registrationName, listener) {
	    !(typeof listener === 'function') ?  false ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : invariant(false) : undefined;
	
	    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
	    bankForRegistrationName[id] = listener;
	
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.didPutListener) {
	      PluginModule.didPutListener(id, registrationName, listener);
	    }
	  },
	
	  /**
	   * @param {string} id ID of the DOM element.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @return {?function} The stored callback.
	   */
	  getListener: function (id, registrationName) {
	    var bankForRegistrationName = listenerBank[registrationName];
	    return bankForRegistrationName && bankForRegistrationName[id];
	  },
	
	  /**
	   * Deletes a listener from the registration bank.
	   *
	   * @param {string} id ID of the DOM element.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   */
	  deleteListener: function (id, registrationName) {
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.willDeleteListener) {
	      PluginModule.willDeleteListener(id, registrationName);
	    }
	
	    var bankForRegistrationName = listenerBank[registrationName];
	    // TODO: This should never be null -- when is it?
	    if (bankForRegistrationName) {
	      delete bankForRegistrationName[id];
	    }
	  },
	
	  /**
	   * Deletes all listeners for the DOM element with the supplied ID.
	   *
	   * @param {string} id ID of the DOM element.
	   */
	  deleteAllListeners: function (id) {
	    for (var registrationName in listenerBank) {
	      if (!listenerBank[registrationName][id]) {
	        continue;
	      }
	
	      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	      if (PluginModule && PluginModule.willDeleteListener) {
	        PluginModule.willDeleteListener(id, registrationName);
	      }
	
	      delete listenerBank[registrationName][id];
	    }
	  },
	
	  /**
	   * Allows registered plugins an opportunity to extract events from top-level
	   * native browser events.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {DOMEventTarget} topLevelTarget The listening component root node.
	   * @param {string} topLevelTargetID ID of `topLevelTarget`.
	   * @param {object} nativeEvent Native browser event.
	   * @return {*} An accumulation of synthetic events.
	   * @internal
	   */
	  extractEvents: function (topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget) {
	    var events;
	    var plugins = EventPluginRegistry.plugins;
	    for (var i = 0; i < plugins.length; i++) {
	      // Not every plugin in the ordering may be loaded at runtime.
	      var possiblePlugin = plugins[i];
	      if (possiblePlugin) {
	        var extractedEvents = possiblePlugin.extractEvents(topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget);
	        if (extractedEvents) {
	          events = accumulateInto(events, extractedEvents);
	        }
	      }
	    }
	    return events;
	  },
	
	  /**
	   * Enqueues a synthetic event that should be dispatched when
	   * `processEventQueue` is invoked.
	   *
	   * @param {*} events An accumulation of synthetic events.
	   * @internal
	   */
	  enqueueEvents: function (events) {
	    if (events) {
	      eventQueue = accumulateInto(eventQueue, events);
	    }
	  },
	
	  /**
	   * Dispatches all synthetic events on the event queue.
	   *
	   * @internal
	   */
	  processEventQueue: function (simulated) {
	    // Set `eventQueue` to null before processing it so that we can tell if more
	    // events get enqueued while processing.
	    var processingEventQueue = eventQueue;
	    eventQueue = null;
	    if (simulated) {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
	    } else {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
	    }
	    !!eventQueue ?  false ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing ' + 'an event queue. Support for this has not yet been implemented.') : invariant(false) : undefined;
	    // This would be a good time to rethrow if any of the event handlers threw.
	    ReactErrorUtils.rethrowCaughtError();
	  },
	
	  /**
	   * These are needed for tests only. Do not use!
	   */
	  __purge: function () {
	    listenerBank = {};
	  },
	
	  __getListenerBank: function () {
	    return listenerBank;
	  }
	
	};
	
	module.exports = EventPluginHub;

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventPropagators
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(11);
	var EventPluginHub = __webpack_require__(21);
	
	var warning = __webpack_require__(2);
	
	var accumulateInto = __webpack_require__(87);
	var forEachAccumulated = __webpack_require__(88);
	
	var PropagationPhases = EventConstants.PropagationPhases;
	var getListener = EventPluginHub.getListener;
	
	/**
	 * Some event types have a notion of different registration names for different
	 * "phases" of propagation. This finds listeners by a given phase.
	 */
	function listenerAtPhase(id, event, propagationPhase) {
	  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
	  return getListener(id, registrationName);
	}
	
	/**
	 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
	 * here, allows us to not have to bind or create functions for each event.
	 * Mutating the event's members allows us to not have to create a wrapping
	 * "dispatch" object that pairs the event with the listener.
	 */
	function accumulateDirectionalDispatches(domID, upwards, event) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(domID, 'Dispatching id must not be null') : undefined;
	  }
	  var phase = upwards ? PropagationPhases.bubbled : PropagationPhases.captured;
	  var listener = listenerAtPhase(domID, event, phase);
	  if (listener) {
	    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	    event._dispatchIDs = accumulateInto(event._dispatchIDs, domID);
	  }
	}
	
	/**
	 * Collect dispatches (must be entirely collected before dispatching - see unit
	 * tests). Lazily allocate the array to conserve memory.  We must loop through
	 * each event and perform the traversal for each one. We cannot perform a
	 * single traversal for the entire collection of events because each event may
	 * have a different target.
	 */
	function accumulateTwoPhaseDispatchesSingle(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    EventPluginHub.injection.getInstanceHandle().traverseTwoPhase(event.dispatchMarker, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
	 */
	function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    EventPluginHub.injection.getInstanceHandle().traverseTwoPhaseSkipTarget(event.dispatchMarker, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Accumulates without regard to direction, does not look for phased
	 * registration names. Same as `accumulateDirectDispatchesSingle` but without
	 * requiring that the `dispatchMarker` be the same as the dispatched ID.
	 */
	function accumulateDispatches(id, ignoredDirection, event) {
	  if (event && event.dispatchConfig.registrationName) {
	    var registrationName = event.dispatchConfig.registrationName;
	    var listener = getListener(id, registrationName);
	    if (listener) {
	      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	      event._dispatchIDs = accumulateInto(event._dispatchIDs, id);
	    }
	  }
	}
	
	/**
	 * Accumulates dispatches on an `SyntheticEvent`, but only for the
	 * `dispatchMarker`.
	 * @param {SyntheticEvent} event
	 */
	function accumulateDirectDispatchesSingle(event) {
	  if (event && event.dispatchConfig.registrationName) {
	    accumulateDispatches(event.dispatchMarker, null, event);
	  }
	}
	
	function accumulateTwoPhaseDispatches(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
	}
	
	function accumulateTwoPhaseDispatchesSkipTarget(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
	}
	
	function accumulateEnterLeaveDispatches(leave, enter, fromID, toID) {
	  EventPluginHub.injection.getInstanceHandle().traverseEnterLeave(fromID, toID, accumulateDispatches, leave, enter);
	}
	
	function accumulateDirectDispatches(events) {
	  forEachAccumulated(events, accumulateDirectDispatchesSingle);
	}
	
	/**
	 * A small set of propagation patterns, each of which will accept a small amount
	 * of information, and generate a set of "dispatch ready event objects" - which
	 * are sets of events that have already been annotated with a set of dispatched
	 * listener functions/ids. The API is designed this way to discourage these
	 * propagation strategies from actually executing the dispatches, since we
	 * always want to collect the entire set of dispatches before executing event a
	 * single one.
	 *
	 * @constructor EventPropagators
	 */
	var EventPropagators = {
	  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
	  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
	  accumulateDirectDispatches: accumulateDirectDispatches,
	  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
	};
	
	module.exports = EventPropagators;

/***/ }),
/* 23 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactInstanceMap
	 */
	
	'use strict';
	
	/**
	 * `ReactInstanceMap` maintains a mapping from a public facing stateful
	 * instance (key) and the internal representation (value). This allows public
	 * methods to accept the user facing instance as an argument and map them back
	 * to internal methods.
	 */
	
	// TODO: Replace this with ES6: var ReactInstanceMap = new Map();
	var ReactInstanceMap = {
	
	  /**
	   * This API should be called `delete` but we'd have to make sure to always
	   * transform these to strings for IE support. When this transform is fully
	   * supported we can rename it.
	   */
	  remove: function (key) {
	    key._reactInternalInstance = undefined;
	  },
	
	  get: function (key) {
	    return key._reactInternalInstance;
	  },
	
	  has: function (key) {
	    return key._reactInternalInstance !== undefined;
	  },
	
	  set: function (key, value) {
	    key._reactInternalInstance = value;
	  }
	
	};
	
	module.exports = ReactInstanceMap;

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticUIEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(16);
	
	var getEventTarget = __webpack_require__(46);
	
	/**
	 * @interface UIEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var UIEventInterface = {
	  view: function (event) {
	    if (event.view) {
	      return event.view;
	    }
	
	    var target = getEventTarget(event);
	    if (target != null && target.window === target) {
	      // target is a window object
	      return target;
	    }
	
	    var doc = target.ownerDocument;
	    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	    if (doc) {
	      return doc.defaultView || doc.parentWindow;
	    } else {
	      return window;
	    }
	  },
	  detail: function (event) {
	    return event.detail || 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);
	
	module.exports = SyntheticUIEvent;

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule keyMirror
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(1);
	
	/**
	 * Constructs an enumeration with keys equal to their value.
	 *
	 * For example:
	 *
	 *   var COLORS = keyMirror({blue: null, red: null});
	 *   var myColor = COLORS.blue;
	 *   var isColorValid = !!COLORS[myColor];
	 *
	 * The last line could not be performed if the values of the generated enum were
	 * not equal to their keys.
	 *
	 *   Input:  {key1: val1, key2: val2}
	 *   Output: {key1: key1, key2: key2}
	 *
	 * @param {object} obj
	 * @return {object}
	 */
	var keyMirror = function (obj) {
	  var ret = {};
	  var key;
	  !(obj instanceof Object && !Array.isArray(obj)) ?  false ? invariant(false, 'keyMirror(...): Argument must be an object.') : invariant(false) : undefined;
	  for (key in obj) {
	    if (!obj.hasOwnProperty(key)) {
	      continue;
	    }
	    ret[key] = key;
	  }
	  return ret;
	};
	
	module.exports = keyMirror;

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactBrowserEventEmitter
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(11);
	var EventPluginHub = __webpack_require__(21);
	var EventPluginRegistry = __webpack_require__(65);
	var ReactEventEmitterMixin = __webpack_require__(150);
	var ReactPerf = __webpack_require__(7);
	var ViewportMetrics = __webpack_require__(86);
	
	var assign = __webpack_require__(3);
	var isEventSupported = __webpack_require__(49);
	
	/**
	 * Summary of `ReactBrowserEventEmitter` event handling:
	 *
	 *  - Top-level delegation is used to trap most native browser events. This
	 *    may only occur in the main thread and is the responsibility of
	 *    ReactEventListener, which is injected and can therefore support pluggable
	 *    event sources. This is the only work that occurs in the main thread.
	 *
	 *  - We normalize and de-duplicate events to account for browser quirks. This
	 *    may be done in the worker thread.
	 *
	 *  - Forward these native events (with the associated top-level type used to
	 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
	 *    to extract any synthetic events.
	 *
	 *  - The `EventPluginHub` will then process each event by annotating them with
	 *    "dispatches", a sequence of listeners and IDs that care about that event.
	 *
	 *  - The `EventPluginHub` then dispatches the events.
	 *
	 * Overview of React and the event system:
	 *
	 * +------------+    .
	 * |    DOM     |    .
	 * +------------+    .
	 *       |           .
	 *       v           .
	 * +------------+    .
	 * | ReactEvent |    .
	 * |  Listener  |    .
	 * +------------+    .                         +-----------+
	 *       |           .               +--------+|SimpleEvent|
	 *       |           .               |         |Plugin     |
	 * +-----|------+    .               v         +-----------+
	 * |     |      |    .    +--------------+                    +------------+
	 * |     +-----------.--->|EventPluginHub|                    |    Event   |
	 * |            |    .    |              |     +-----------+  | Propagators|
	 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
	 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
	 * |            |    .    |              |     +-----------+  |  utilities |
	 * |     +-----------.--->|              |                    +------------+
	 * |     |      |    .    +--------------+
	 * +-----|------+    .                ^        +-----------+
	 *       |           .                |        |Enter/Leave|
	 *       +           .                +-------+|Plugin     |
	 * +-------------+   .                         +-----------+
	 * | application |   .
	 * |-------------|   .
	 * |             |   .
	 * |             |   .
	 * +-------------+   .
	 *                   .
	 *    React Core     .  General Purpose Event Plugin System
	 */
	
	var alreadyListeningTo = {};
	var isMonitoringScrollValue = false;
	var reactTopListenersCounter = 0;
	
	// For events like 'submit' which don't consistently bubble (which we trap at a
	// lower node than `document`), binding at `document` would cause duplicate
	// events so we don't include them here
	var topEventMapping = {
	  topAbort: 'abort',
	  topBlur: 'blur',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topChange: 'change',
	  topClick: 'click',
	  topCompositionEnd: 'compositionend',
	  topCompositionStart: 'compositionstart',
	  topCompositionUpdate: 'compositionupdate',
	  topContextMenu: 'contextmenu',
	  topCopy: 'copy',
	  topCut: 'cut',
	  topDoubleClick: 'dblclick',
	  topDrag: 'drag',
	  topDragEnd: 'dragend',
	  topDragEnter: 'dragenter',
	  topDragExit: 'dragexit',
	  topDragLeave: 'dragleave',
	  topDragOver: 'dragover',
	  topDragStart: 'dragstart',
	  topDrop: 'drop',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topFocus: 'focus',
	  topInput: 'input',
	  topKeyDown: 'keydown',
	  topKeyPress: 'keypress',
	  topKeyUp: 'keyup',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topMouseDown: 'mousedown',
	  topMouseMove: 'mousemove',
	  topMouseOut: 'mouseout',
	  topMouseOver: 'mouseover',
	  topMouseUp: 'mouseup',
	  topPaste: 'paste',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topScroll: 'scroll',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topSelectionChange: 'selectionchange',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTextInput: 'textInput',
	  topTimeUpdate: 'timeupdate',
	  topTouchCancel: 'touchcancel',
	  topTouchEnd: 'touchend',
	  topTouchMove: 'touchmove',
	  topTouchStart: 'touchstart',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting',
	  topWheel: 'wheel'
	};
	
	/**
	 * To ensure no conflicts with other potential React instances on the page
	 */
	var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);
	
	function getListeningForDocument(mountAt) {
	  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
	  // directly.
	  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
	    mountAt[topListenersIDKey] = reactTopListenersCounter++;
	    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
	  }
	  return alreadyListeningTo[mountAt[topListenersIDKey]];
	}
	
	/**
	 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
	 * example:
	 *
	 *   ReactBrowserEventEmitter.putListener('myID', 'onClick', myFunction);
	 *
	 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
	 *
	 * @internal
	 */
	var ReactBrowserEventEmitter = assign({}, ReactEventEmitterMixin, {
	
	  /**
	   * Injectable event backend
	   */
	  ReactEventListener: null,
	
	  injection: {
	    /**
	     * @param {object} ReactEventListener
	     */
	    injectReactEventListener: function (ReactEventListener) {
	      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
	      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
	    }
	  },
	
	  /**
	   * Sets whether or not any created callbacks should be enabled.
	   *
	   * @param {boolean} enabled True if callbacks should be enabled.
	   */
	  setEnabled: function (enabled) {
	    if (ReactBrowserEventEmitter.ReactEventListener) {
	      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
	    }
	  },
	
	  /**
	   * @return {boolean} True if callbacks are enabled.
	   */
	  isEnabled: function () {
	    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
	  },
	
	  /**
	   * We listen for bubbled touch events on the document object.
	   *
	   * Firefox v8.01 (and possibly others) exhibited strange behavior when
	   * mounting `onmousemove` events at some node that was not the document
	   * element. The symptoms were that if your mouse is not moving over something
	   * contained within that mount point (for example on the background) the
	   * top-level listeners for `onmousemove` won't be called. However, if you
	   * register the `mousemove` on the document object, then it will of course
	   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
	   * top-level listeners to the document object only, at least for these
	   * movement types of events and possibly all events.
	   *
	   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	   *
	   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
	   * they bubble to document.
	   *
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {object} contentDocumentHandle Document which owns the container
	   */
	  listenTo: function (registrationName, contentDocumentHandle) {
	    var mountAt = contentDocumentHandle;
	    var isListening = getListeningForDocument(mountAt);
	    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];
	
	    var topLevelTypes = EventConstants.topLevelTypes;
	    for (var i = 0; i < dependencies.length; i++) {
	      var dependency = dependencies[i];
	      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
	        if (dependency === topLevelTypes.topWheel) {
	          if (isEventSupported('wheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topWheel, 'wheel', mountAt);
	          } else if (isEventSupported('mousewheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topWheel, 'mousewheel', mountAt);
	          } else {
	            // Firefox needs to capture a different mouse scroll event.
	            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topWheel, 'DOMMouseScroll', mountAt);
	          }
	        } else if (dependency === topLevelTypes.topScroll) {
	
	          if (isEventSupported('scroll', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelTypes.topScroll, 'scroll', mountAt);
	          } else {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topScroll, 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
	          }
	        } else if (dependency === topLevelTypes.topFocus || dependency === topLevelTypes.topBlur) {
	
	          if (isEventSupported('focus', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelTypes.topFocus, 'focus', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelTypes.topBlur, 'blur', mountAt);
	          } else if (isEventSupported('focusin')) {
	            // IE has `focusin` and `focusout` events which bubble.
	            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topFocus, 'focusin', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topBlur, 'focusout', mountAt);
	          }
	
	          // to make sure blur and focus event listeners are only attached once
	          isListening[topLevelTypes.topBlur] = true;
	          isListening[topLevelTypes.topFocus] = true;
	        } else if (topEventMapping.hasOwnProperty(dependency)) {
	          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
	        }
	
	        isListening[dependency] = true;
	      }
	    }
	  },
	
	  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  /**
	   * Listens to window scroll and resize events. We cache scroll values so that
	   * application code can access them without triggering reflows.
	   *
	   * NOTE: Scroll events do not bubble.
	   *
	   * @see http://www.quirksmode.org/dom/events/scroll.html
	   */
	  ensureScrollValueMonitoring: function () {
	    if (!isMonitoringScrollValue) {
	      var refresh = ViewportMetrics.refreshScrollValues;
	      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
	      isMonitoringScrollValue = true;
	    }
	  },
	
	  eventNameDispatchConfigs: EventPluginHub.eventNameDispatchConfigs,
	
	  registrationNameModules: EventPluginHub.registrationNameModules,
	
	  putListener: EventPluginHub.putListener,
	
	  getListener: EventPluginHub.getListener,
	
	  deleteListener: EventPluginHub.deleteListener,
	
	  deleteAllListeners: EventPluginHub.deleteAllListeners
	
	});
	
	ReactPerf.measureMethods(ReactBrowserEventEmitter, 'ReactBrowserEventEmitter', {
	  putListener: 'putListener',
	  deleteListener: 'deleteListener'
	});
	
	module.exports = ReactBrowserEventEmitter;

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactPropTypeLocationNames
	 */
	
	'use strict';
	
	var ReactPropTypeLocationNames = {};
	
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	}
	
	module.exports = ReactPropTypeLocationNames;

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactPropTypeLocations
	 */
	
	'use strict';
	
	var keyMirror = __webpack_require__(25);
	
	var ReactPropTypeLocations = keyMirror({
	  prop: null,
	  context: null,
	  childContext: null
	});
	
	module.exports = ReactPropTypeLocations;

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticMouseEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(24);
	var ViewportMetrics = __webpack_require__(86);
	
	var getEventModifierState = __webpack_require__(45);
	
	/**
	 * @interface MouseEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var MouseEventInterface = {
	  screenX: null,
	  screenY: null,
	  clientX: null,
	  clientY: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  getModifierState: getEventModifierState,
	  button: function (event) {
	    // Webkit, Firefox, IE9+
	    // which:  1 2 3
	    // button: 0 1 2 (standard)
	    var button = event.button;
	    if ('which' in event) {
	      return button;
	    }
	    // IE<9
	    // which:  undefined
	    // button: 0 0 0
	    // button: 1 4 2 (onmouseup)
	    return button === 2 ? 2 : button === 4 ? 1 : 0;
	  },
	  buttons: null,
	  relatedTarget: function (event) {
	    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
	  },
	  // "Proprietary" Interface.
	  pageX: function (event) {
	    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
	  },
	  pageY: function (event) {
	    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);
	
	module.exports = SyntheticMouseEvent;

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule Transaction
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(1);
	
	/**
	 * `Transaction` creates a black box that is able to wrap any method such that
	 * certain invariants are maintained before and after the method is invoked
	 * (Even if an exception is thrown while invoking the wrapped method). Whoever
	 * instantiates a transaction can provide enforcers of the invariants at
	 * creation time. The `Transaction` class itself will supply one additional
	 * automatic invariant for you - the invariant that any transaction instance
	 * should not be run while it is already being run. You would typically create a
	 * single instance of a `Transaction` for reuse multiple times, that potentially
	 * is used to wrap several different methods. Wrappers are extremely simple -
	 * they only require implementing two methods.
	 *
	 * <pre>
	 *                       wrappers (injected at creation time)
	 *                                      +        +
	 *                                      |        |
	 *                    +-----------------|--------|--------------+
	 *                    |                 v        |              |
	 *                    |      +---------------+   |              |
	 *                    |   +--|    wrapper1   |---|----+         |
	 *                    |   |  +---------------+   v    |         |
	 *                    |   |          +-------------+  |         |
	 *                    |   |     +----|   wrapper2  |--------+   |
	 *                    |   |     |    +-------------+  |     |   |
	 *                    |   |     |                     |     |   |
	 *                    |   v     v                     v     v   | wrapper
	 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
	 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
	 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | +---+ +---+   +---------+   +---+ +---+ |
	 *                    |  initialize                    close    |
	 *                    +-----------------------------------------+
	 * </pre>
	 *
	 * Use cases:
	 * - Preserving the input selection ranges before/after reconciliation.
	 *   Restoring selection even in the event of an unexpected error.
	 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
	 *   while guaranteeing that afterwards, the event system is reactivated.
	 * - Flushing a queue of collected DOM mutations to the main UI thread after a
	 *   reconciliation takes place in a worker thread.
	 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
	 *   content.
	 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
	 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
	 * - (Future use case): Layout calculations before and after DOM updates.
	 *
	 * Transactional plugin API:
	 * - A module that has an `initialize` method that returns any precomputation.
	 * - and a `close` method that accepts the precomputation. `close` is invoked
	 *   when the wrapped process is completed, or has failed.
	 *
	 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
	 * that implement `initialize` and `close`.
	 * @return {Transaction} Single transaction for reuse in thread.
	 *
	 * @class Transaction
	 */
	var Mixin = {
	  /**
	   * Sets up this instance so that it is prepared for collecting metrics. Does
	   * so such that this setup method may be used on an instance that is already
	   * initialized, in a way that does not consume additional memory upon reuse.
	   * That can be useful if you decide to make your subclass of this mixin a
	   * "PooledClass".
	   */
	  reinitializeTransaction: function () {
	    this.transactionWrappers = this.getTransactionWrappers();
	    if (this.wrapperInitData) {
	      this.wrapperInitData.length = 0;
	    } else {
	      this.wrapperInitData = [];
	    }
	    this._isInTransaction = false;
	  },
	
	  _isInTransaction: false,
	
	  /**
	   * @abstract
	   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
	   */
	  getTransactionWrappers: null,
	
	  isInTransaction: function () {
	    return !!this._isInTransaction;
	  },
	
	  /**
	   * Executes the function within a safety window. Use this for the top level
	   * methods that result in large amounts of computation/mutations that would
	   * need to be safety checked. The optional arguments helps prevent the need
	   * to bind in many cases.
	   *
	   * @param {function} method Member of scope to call.
	   * @param {Object} scope Scope to invoke from.
	   * @param {Object?=} a Argument to pass to the method.
	   * @param {Object?=} b Argument to pass to the method.
	   * @param {Object?=} c Argument to pass to the method.
	   * @param {Object?=} d Argument to pass to the method.
	   * @param {Object?=} e Argument to pass to the method.
	   * @param {Object?=} f Argument to pass to the method.
	   *
	   * @return {*} Return value from `method`.
	   */
	  perform: function (method, scope, a, b, c, d, e, f) {
	    !!this.isInTransaction() ?  false ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there ' + 'is already an outstanding transaction.') : invariant(false) : undefined;
	    var errorThrown;
	    var ret;
	    try {
	      this._isInTransaction = true;
	      // Catching errors makes debugging more difficult, so we start with
	      // errorThrown set to true before setting it to false after calling
	      // close -- if it's still set to true in the finally block, it means
	      // one of these calls threw.
	      errorThrown = true;
	      this.initializeAll(0);
	      ret = method.call(scope, a, b, c, d, e, f);
	      errorThrown = false;
	    } finally {
	      try {
	        if (errorThrown) {
	          // If `method` throws, prefer to show that stack trace over any thrown
	          // by invoking `closeAll`.
	          try {
	            this.closeAll(0);
	          } catch (err) {}
	        } else {
	          // Since `method` didn't throw, we don't want to silence the exception
	          // here.
	          this.closeAll(0);
	        }
	      } finally {
	        this._isInTransaction = false;
	      }
	    }
	    return ret;
	  },
	
	  initializeAll: function (startIndex) {
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      try {
	        // Catching errors makes debugging more difficult, so we start with the
	        // OBSERVED_ERROR state before overwriting it with the real return value
	        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
	        // block, it means wrapper.initialize threw.
	        this.wrapperInitData[i] = Transaction.OBSERVED_ERROR;
	        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
	      } finally {
	        if (this.wrapperInitData[i] === Transaction.OBSERVED_ERROR) {
	          // The initializer for wrapper i threw an error; initialize the
	          // remaining wrappers but silence any exceptions from them to ensure
	          // that the first error is the one to bubble up.
	          try {
	            this.initializeAll(i + 1);
	          } catch (err) {}
	        }
	      }
	    }
	  },
	
	  /**
	   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
	   * them the respective return values of `this.transactionWrappers.init[i]`
	   * (`close`rs that correspond to initializers that failed will not be
	   * invoked).
	   */
	  closeAll: function (startIndex) {
	    !this.isInTransaction() ?  false ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : invariant(false) : undefined;
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      var initData = this.wrapperInitData[i];
	      var errorThrown;
	      try {
	        // Catching errors makes debugging more difficult, so we start with
	        // errorThrown set to true before setting it to false after calling
	        // close -- if it's still set to true in the finally block, it means
	        // wrapper.close threw.
	        errorThrown = true;
	        if (initData !== Transaction.OBSERVED_ERROR && wrapper.close) {
	          wrapper.close.call(this, initData);
	        }
	        errorThrown = false;
	      } finally {
	        if (errorThrown) {
	          // The closer for wrapper i threw an error; close the remaining
	          // wrappers but silence any exceptions from them to ensure that the
	          // first error is the one to bubble up.
	          try {
	            this.closeAll(i + 1);
	          } catch (e) {}
	        }
	      }
	    }
	    this.wrapperInitData.length = 0;
	  }
	};
	
	var Transaction = {
	
	  Mixin: Mixin,
	
	  /**
	   * Token to look for to determine if an error occurred.
	   */
	  OBSERVED_ERROR: {}
	
	};
	
	module.exports = Transaction;

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule canDefineProperty
	 */
	
	'use strict';
	
	var canDefineProperty = false;
	if (false) {
	  try {
	    Object.defineProperty({}, 'x', { get: function () {} });
	    canDefineProperty = true;
	  } catch (x) {
	    // IE will fail on defineProperty
	  }
	}
	
	module.exports = canDefineProperty;

/***/ }),
/* 32 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule escapeTextContentForBrowser
	 */
	
	'use strict';
	
	var ESCAPE_LOOKUP = {
	  '&': '&amp;',
	  '>': '&gt;',
	  '<': '&lt;',
	  '"': '&quot;',
	  '\'': '&#x27;'
	};
	
	var ESCAPE_REGEX = /[&><"']/g;
	
	function escaper(match) {
	  return ESCAPE_LOOKUP[match];
	}
	
	/**
	 * Escapes text to prevent scripting attacks.
	 *
	 * @param {*} text Text value to escape.
	 * @return {string} An escaped string.
	 */
	function escapeTextContentForBrowser(text) {
	  return ('' + text).replace(ESCAPE_REGEX, escaper);
	}
	
	module.exports = escapeTextContentForBrowser;

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule setInnerHTML
	 */
	
	/* globals MSApp */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(4);
	
	var WHITESPACE_TEST = /^[ \r\n\t\f]/;
	var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;
	
	/**
	 * Set the innerHTML property of a node, ensuring that whitespace is preserved
	 * even in IE8.
	 *
	 * @param {DOMElement} node
	 * @param {string} html
	 * @internal
	 */
	var setInnerHTML = function (node, html) {
	  node.innerHTML = html;
	};
	
	// Win8 apps: Allow all html to be inserted
	if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
	  setInnerHTML = function (node, html) {
	    MSApp.execUnsafeLocalFunction(function () {
	      node.innerHTML = html;
	    });
	  };
	}
	
	if (ExecutionEnvironment.canUseDOM) {
	  // IE8: When updating a just created node with innerHTML only leading
	  // whitespace is removed. When updating an existing node with innerHTML
	  // whitespace in root TextNodes is also collapsed.
	  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html
	
	  // Feature detection; only IE8 is known to behave improperly like this.
	  var testElement = document.createElement('div');
	  testElement.innerHTML = ' ';
	  if (testElement.innerHTML === '') {
	    setInnerHTML = function (node, html) {
	      // Magic theory: IE8 supposedly differentiates between added and updated
	      // nodes when processing innerHTML, innerHTML on updated nodes suffers
	      // from worse whitespace behavior. Re-adding a node like this triggers
	      // the initial and more favorable whitespace behavior.
	      // TODO: What to do on a detached node?
	      if (node.parentNode) {
	        node.parentNode.replaceChild(node, node);
	      }
	
	      // We also implement a workaround for non-visible tags disappearing into
	      // thin air on IE8, this only happens if there is no visible text
	      // in-front of the non-visible tags. Piggyback on the whitespace fix
	      // and simply check if any non-visible tags appear in the source.
	      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
	        // Recover leading whitespace by temporarily prepending any character.
	        // \uFEFF has the potential advantage of being zero-width/invisible.
	        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
	        // in hopes that this is preserved even if "\uFEFF" is transformed to
	        // the actual Unicode character (by Babel, for example).
	        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
	        node.innerHTML = String.fromCharCode(0xFEFF) + html;
	
	        // deleteData leaves an empty `TextNode` which offsets the index of all
	        // children. Definitely want to avoid this.
	        var textNode = node.firstChild;
	        if (textNode.data.length === 1) {
	          node.removeChild(textNode);
	        } else {
	          textNode.deleteData(0, 1);
	        }
	      } else {
	        node.innerHTML = html;
	      }
	    };
	  }
	}
	
	module.exports = setInnerHTML;

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (false) {
	  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
	    Symbol.for &&
	    Symbol.for('react.element')) ||
	    0xeac7;
	
	  var isValidElement = function(object) {
	    return typeof object === 'object' &&
	      object !== null &&
	      object.$$typeof === REACT_ELEMENT_TYPE;
	  };
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(111)();
	}


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule CallbackQueue
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(14);
	
	var assign = __webpack_require__(3);
	var invariant = __webpack_require__(1);
	
	/**
	 * A specialized pseudo-event module to help keep track of components waiting to
	 * be notified when their DOM representations are available for use.
	 *
	 * This implements `PooledClass`, so you should never need to instantiate this.
	 * Instead, use `CallbackQueue.getPooled()`.
	 *
	 * @class ReactMountReady
	 * @implements PooledClass
	 * @internal
	 */
	function CallbackQueue() {
	  this._callbacks = null;
	  this._contexts = null;
	}
	
	assign(CallbackQueue.prototype, {
	
	  /**
	   * Enqueues a callback to be invoked when `notifyAll` is invoked.
	   *
	   * @param {function} callback Invoked when `notifyAll` is invoked.
	   * @param {?object} context Context to call `callback` with.
	   * @internal
	   */
	  enqueue: function (callback, context) {
	    this._callbacks = this._callbacks || [];
	    this._contexts = this._contexts || [];
	    this._callbacks.push(callback);
	    this._contexts.push(context);
	  },
	
	  /**
	   * Invokes all enqueued callbacks and clears the queue. This is invoked after
	   * the DOM representation of a component has been created or updated.
	   *
	   * @internal
	   */
	  notifyAll: function () {
	    var callbacks = this._callbacks;
	    var contexts = this._contexts;
	    if (callbacks) {
	      !(callbacks.length === contexts.length) ?  false ? invariant(false, 'Mismatched list of contexts in callback queue') : invariant(false) : undefined;
	      this._callbacks = null;
	      this._contexts = null;
	      for (var i = 0; i < callbacks.length; i++) {
	        callbacks[i].call(contexts[i]);
	      }
	      callbacks.length = 0;
	      contexts.length = 0;
	    }
	  },
	
	  /**
	   * Resets the internal queue.
	   *
	   * @internal
	   */
	  reset: function () {
	    this._callbacks = null;
	    this._contexts = null;
	  },
	
	  /**
	   * `PooledClass` looks for this.
	   */
	  destructor: function () {
	    this.reset();
	  }
	
	});
	
	PooledClass.addPoolingTo(CallbackQueue);
	
	module.exports = CallbackQueue;

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DOMPropertyOperations
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(18);
	var ReactPerf = __webpack_require__(7);
	
	var quoteAttributeValueForBrowser = __webpack_require__(180);
	var warning = __webpack_require__(2);
	
	// Simplified subset
	var VALID_ATTRIBUTE_NAME_REGEX = /^[a-zA-Z_][\w\.\-]*$/;
	var illegalAttributeNameCache = {};
	var validatedAttributeNameCache = {};
	
	function isAttributeNameSafe(attributeName) {
	  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
	    return true;
	  }
	  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
	    return false;
	  }
	  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
	    validatedAttributeNameCache[attributeName] = true;
	    return true;
	  }
	  illegalAttributeNameCache[attributeName] = true;
	   false ? warning(false, 'Invalid attribute name: `%s`', attributeName) : undefined;
	  return false;
	}
	
	function shouldIgnoreValue(propertyInfo, value) {
	  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
	}
	
	if (false) {
	  var reactProps = {
	    children: true,
	    dangerouslySetInnerHTML: true,
	    key: true,
	    ref: true
	  };
	  var warnedProperties = {};
	
	  var warnUnknownProperty = function (name) {
	    if (reactProps.hasOwnProperty(name) && reactProps[name] || warnedProperties.hasOwnProperty(name) && warnedProperties[name]) {
	      return;
	    }
	
	    warnedProperties[name] = true;
	    var lowerCasedName = name.toLowerCase();
	
	    // data-* attributes should be lowercase; suggest the lowercase version
	    var standardName = DOMProperty.isCustomAttribute(lowerCasedName) ? lowerCasedName : DOMProperty.getPossibleStandardName.hasOwnProperty(lowerCasedName) ? DOMProperty.getPossibleStandardName[lowerCasedName] : null;
	
	    // For now, only warn when we have a suggested correction. This prevents
	    // logging too much when using transferPropsTo.
	    process.env.NODE_ENV !== 'production' ? warning(standardName == null, 'Unknown DOM property %s. Did you mean %s?', name, standardName) : undefined;
	  };
	}
	
	/**
	 * Operations for dealing with DOM properties.
	 */
	var DOMPropertyOperations = {
	
	  /**
	   * Creates markup for the ID property.
	   *
	   * @param {string} id Unescaped ID.
	   * @return {string} Markup string.
	   */
	  createMarkupForID: function (id) {
	    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
	  },
	
	  setAttributeForID: function (node, id) {
	    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
	  },
	
	  /**
	   * Creates markup for a property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {?string} Markup string, or null if the property was invalid.
	   */
	  createMarkupForProperty: function (name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      if (shouldIgnoreValue(propertyInfo, value)) {
	        return '';
	      }
	      var attributeName = propertyInfo.attributeName;
	      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	        return attributeName + '=""';
	      }
	      return attributeName + '=' + quoteAttributeValueForBrowser(value);
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      if (value == null) {
	        return '';
	      }
	      return name + '=' + quoteAttributeValueForBrowser(value);
	    } else if (false) {
	      warnUnknownProperty(name);
	    }
	    return null;
	  },
	
	  /**
	   * Creates markup for a custom property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {string} Markup string, or empty string if the property was invalid.
	   */
	  createMarkupForCustomAttribute: function (name, value) {
	    if (!isAttributeNameSafe(name) || value == null) {
	      return '';
	    }
	    return name + '=' + quoteAttributeValueForBrowser(value);
	  },
	
	  /**
	   * Sets the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   * @param {*} value
	   */
	  setValueForProperty: function (node, name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, value);
	      } else if (shouldIgnoreValue(propertyInfo, value)) {
	        this.deleteValueForProperty(node, name);
	      } else if (propertyInfo.mustUseAttribute) {
	        var attributeName = propertyInfo.attributeName;
	        var namespace = propertyInfo.attributeNamespace;
	        // `setAttribute` with objects becomes only `[object]` in IE8/9,
	        // ('' + value) makes it output the correct toString()-value.
	        if (namespace) {
	          node.setAttributeNS(namespace, attributeName, '' + value);
	        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	          node.setAttribute(attributeName, '');
	        } else {
	          node.setAttribute(attributeName, '' + value);
	        }
	      } else {
	        var propName = propertyInfo.propertyName;
	        // Must explicitly cast values for HAS_SIDE_EFFECTS-properties to the
	        // property type before comparing; only `value` does and is string.
	        if (!propertyInfo.hasSideEffects || '' + node[propName] !== '' + value) {
	          // Contrary to `setAttribute`, object properties are properly
	          // `toString`ed by IE8/9.
	          node[propName] = value;
	        }
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      DOMPropertyOperations.setValueForAttribute(node, name, value);
	    } else if (false) {
	      warnUnknownProperty(name);
	    }
	  },
	
	  setValueForAttribute: function (node, name, value) {
	    if (!isAttributeNameSafe(name)) {
	      return;
	    }
	    if (value == null) {
	      node.removeAttribute(name);
	    } else {
	      node.setAttribute(name, '' + value);
	    }
	  },
	
	  /**
	   * Deletes the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForProperty: function (node, name) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, undefined);
	      } else if (propertyInfo.mustUseAttribute) {
	        node.removeAttribute(propertyInfo.attributeName);
	      } else {
	        var propName = propertyInfo.propertyName;
	        var defaultValue = DOMProperty.getDefaultValueForProperty(node.nodeName, propName);
	        if (!propertyInfo.hasSideEffects || '' + node[propName] !== defaultValue) {
	          node[propName] = defaultValue;
	        }
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      node.removeAttribute(name);
	    } else if (false) {
	      warnUnknownProperty(name);
	    }
	  }
	
	};
	
	ReactPerf.measureMethods(DOMPropertyOperations, 'DOMPropertyOperations', {
	  setValueForProperty: 'setValueForProperty',
	  setValueForAttribute: 'setValueForAttribute',
	  deleteValueForProperty: 'deleteValueForProperty'
	});
	
	module.exports = DOMPropertyOperations;

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule LinkedValueUtils
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var ReactPropTypes = __webpack_require__(84);
	var ReactPropTypeLocations = __webpack_require__(28);
	
	var invariant = __webpack_require__(1);
	var warning = __webpack_require__(2);
	
	var hasReadOnlyValue = {
	  'button': true,
	  'checkbox': true,
	  'image': true,
	  'hidden': true,
	  'radio': true,
	  'reset': true,
	  'submit': true
	};
	
	function _assertSingleLink(inputProps) {
	  !(inputProps.checkedLink == null || inputProps.valueLink == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use ' + 'checkedLink, you probably don\'t want to use valueLink and vice versa.') : invariant(false) : undefined;
	}
	function _assertValueLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.value == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want ' + 'to use value or onChange, you probably don\'t want to use valueLink.') : invariant(false) : undefined;
	}
	
	function _assertCheckedLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.checked == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. ' + 'If you want to use checked or onChange, you probably don\'t want to ' + 'use checkedLink') : invariant(false) : undefined;
	}
	
	var propTypes = {
	  value: function (props, propName, componentName) {
	    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  checked: function (props, propName, componentName) {
	    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  onChange: ReactPropTypes.func
	};
	
	var loggedTypeFailures = {};
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Provide a linked `value` attribute for controlled forms. You should not use
	 * this outside of the ReactDOM controlled form components.
	 */
	var LinkedValueUtils = {
	  checkPropTypes: function (tagName, props, owner) {
	    for (var propName in propTypes) {
	      if (propTypes.hasOwnProperty(propName)) {
	        var error = propTypes[propName](props, propName, tagName, ReactPropTypeLocations.prop, null, 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED');
	      }
	      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	        // Only monitor this failure once because there tends to be a lot of the
	        // same error.
	        loggedTypeFailures[error.message] = true;
	
	        var addendum = getDeclarationErrorAddendum(owner);
	         false ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : undefined;
	      }
	    }
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current value of the input either from value prop or link.
	   */
	  getValue: function (inputProps) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.value;
	    }
	    return inputProps.value;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current checked status of the input either from checked prop
	   *             or link.
	   */
	  getChecked: function (inputProps) {
	    if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.value;
	    }
	    return inputProps.checked;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @param {SyntheticEvent} event change event to handle
	   */
	  executeOnChange: function (inputProps, event) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.requestChange(event.target.value);
	    } else if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.requestChange(event.target.checked);
	    } else if (inputProps.onChange) {
	      return inputProps.onChange.call(undefined, event);
	    }
	  }
	};
	
	module.exports = LinkedValueUtils;

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactComponentBrowserEnvironment
	 */
	
	'use strict';
	
	var ReactDOMIDOperations = __webpack_require__(40);
	var ReactMount = __webpack_require__(5);
	
	/**
	 * Abstracts away all functionality of the reconciler that requires knowledge of
	 * the browser context. TODO: These callers should be refactored to avoid the
	 * need for this injection.
	 */
	var ReactComponentBrowserEnvironment = {
	
	  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,
	
	  replaceNodeWithMarkupByID: ReactDOMIDOperations.dangerouslyReplaceNodeWithMarkupByID,
	
	  /**
	   * If a particular environment requires that some resources be cleaned up,
	   * specify this in the injected Mixin. In the DOM, we would likely want to
	   * purge any cached node ID lookups.
	   *
	   * @private
	   */
	  unmountIDFromEnvironment: function (rootNodeID) {
	    ReactMount.purgeID(rootNodeID);
	  }
	
	};
	
	module.exports = ReactComponentBrowserEnvironment;

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactComponentEnvironment
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(1);
	
	var injected = false;
	
	var ReactComponentEnvironment = {
	
	  /**
	   * Optionally injectable environment dependent cleanup hook. (server vs.
	   * browser etc). Example: A browser system caches DOM nodes based on component
	   * ID and must remove that cache entry when this instance is unmounted.
	   */
	  unmountIDFromEnvironment: null,
	
	  /**
	   * Optionally injectable hook for swapping out mount images in the middle of
	   * the tree.
	   */
	  replaceNodeWithMarkupByID: null,
	
	  /**
	   * Optionally injectable hook for processing a queue of child updates. Will
	   * later move into MultiChildComponents.
	   */
	  processChildrenUpdates: null,
	
	  injection: {
	    injectEnvironment: function (environment) {
	      !!injected ?  false ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : invariant(false) : undefined;
	      ReactComponentEnvironment.unmountIDFromEnvironment = environment.unmountIDFromEnvironment;
	      ReactComponentEnvironment.replaceNodeWithMarkupByID = environment.replaceNodeWithMarkupByID;
	      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
	      injected = true;
	    }
	  }
	
	};
	
	module.exports = ReactComponentEnvironment;

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMIDOperations
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(64);
	var DOMPropertyOperations = __webpack_require__(36);
	var ReactMount = __webpack_require__(5);
	var ReactPerf = __webpack_require__(7);
	
	var invariant = __webpack_require__(1);
	
	/**
	 * Errors for properties that should not be updated with `updatePropertyByID()`.
	 *
	 * @type {object}
	 * @private
	 */
	var INVALID_PROPERTY_ERRORS = {
	  dangerouslySetInnerHTML: '`dangerouslySetInnerHTML` must be set using `updateInnerHTMLByID()`.',
	  style: '`style` must be set using `updateStylesByID()`.'
	};
	
	/**
	 * Operations used to process updates to DOM nodes.
	 */
	var ReactDOMIDOperations = {
	
	  /**
	   * Updates a DOM node with new property values. This should only be used to
	   * update DOM properties in `DOMProperty`.
	   *
	   * @param {string} id ID of the node to update.
	   * @param {string} name A valid property name, see `DOMProperty`.
	   * @param {*} value New value of the property.
	   * @internal
	   */
	  updatePropertyByID: function (id, name, value) {
	    var node = ReactMount.getNode(id);
	    !!INVALID_PROPERTY_ERRORS.hasOwnProperty(name) ?  false ? invariant(false, 'updatePropertyByID(...): %s', INVALID_PROPERTY_ERRORS[name]) : invariant(false) : undefined;
	
	    // If we're updating to null or undefined, we should remove the property
	    // from the DOM node instead of inadvertantly setting to a string. This
	    // brings us in line with the same behavior we have on initial render.
	    if (value != null) {
	      DOMPropertyOperations.setValueForProperty(node, name, value);
	    } else {
	      DOMPropertyOperations.deleteValueForProperty(node, name);
	    }
	  },
	
	  /**
	   * Replaces a DOM node that exists in the document with markup.
	   *
	   * @param {string} id ID of child to be replaced.
	   * @param {string} markup Dangerous markup to inject in place of child.
	   * @internal
	   * @see {Danger.dangerouslyReplaceNodeWithMarkup}
	   */
	  dangerouslyReplaceNodeWithMarkupByID: function (id, markup) {
	    var node = ReactMount.getNode(id);
	    DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup(node, markup);
	  },
	
	  /**
	   * Updates a component's children by processing a series of updates.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @param {array<string>} markup List of markup strings.
	   * @internal
	   */
	  dangerouslyProcessChildrenUpdates: function (updates, markup) {
	    for (var i = 0; i < updates.length; i++) {
	      updates[i].parentNode = ReactMount.getNode(updates[i].parentID);
	    }
	    DOMChildrenOperations.processUpdates(updates, markup);
	  }
	};
	
	ReactPerf.measureMethods(ReactDOMIDOperations, 'ReactDOMIDOperations', {
	  dangerouslyReplaceNodeWithMarkupByID: 'dangerouslyReplaceNodeWithMarkupByID',
	  dangerouslyProcessChildrenUpdates: 'dangerouslyProcessChildrenUpdates'
	});
	
	module.exports = ReactDOMIDOperations;

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactUpdateQueue
	 */
	
	'use strict';
	
	var ReactCurrentOwner = __webpack_require__(12);
	var ReactElement = __webpack_require__(6);
	var ReactInstanceMap = __webpack_require__(23);
	var ReactUpdates = __webpack_require__(8);
	
	var assign = __webpack_require__(3);
	var invariant = __webpack_require__(1);
	var warning = __webpack_require__(2);
	
	function enqueueUpdate(internalInstance) {
	  ReactUpdates.enqueueUpdate(internalInstance);
	}
	
	function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
	  var internalInstance = ReactInstanceMap.get(publicInstance);
	  if (!internalInstance) {
	    if (false) {
	      // Only warn when we have a callerName. Otherwise we should be silent.
	      // We're probably calling from enqueueCallback. We don't want to warn
	      // there because we already warned for the corresponding lifecycle method.
	      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, publicInstance.constructor.displayName) : undefined;
	    }
	    return null;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition ' + '(such as within `render`). Render methods should be a pure function ' + 'of props and state.', callerName) : undefined;
	  }
	
	  return internalInstance;
	}
	
	/**
	 * ReactUpdateQueue allows for state updates to be scheduled into a later
	 * reconciliation step.
	 */
	var ReactUpdateQueue = {
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    if (false) {
	      var owner = ReactCurrentOwner.current;
	      if (owner !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : undefined;
	        owner._warnedAboutRefsInRender = true;
	      }
	    }
	    var internalInstance = ReactInstanceMap.get(publicInstance);
	    if (internalInstance) {
	      // During componentWillMount and render this will still be null but after
	      // that will always render to something. At least for now. So we can use
	      // this hack.
	      return !!internalInstance._renderedComponent;
	    } else {
	      return false;
	    }
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback) {
	    !(typeof callback === 'function') ?  false ? invariant(false, 'enqueueCallback(...): You called `setProps`, `replaceProps`, ' + '`setState`, `replaceState`, or `forceUpdate` with a callback that ' + 'isn\'t callable.') : invariant(false) : undefined;
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);
	
	    // Previously we would throw an error if we didn't have an internal
	    // instance. Since we want to make it a no-op instead, we mirror the same
	    // behavior we have in other enqueue* methods.
	    // We also need to ignore callbacks in componentWillMount. See
	    // enqueueUpdates.
	    if (!internalInstance) {
	      return null;
	    }
	
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    // TODO: The callback here is ignored when setState is called from
	    // componentWillMount. Either fix it or disallow doing so completely in
	    // favor of getInitialState. Alternatively, we can disallow
	    // componentWillMount during server-side rendering.
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueCallbackInternal: function (internalInstance, callback) {
	    !(typeof callback === 'function') ?  false ? invariant(false, 'enqueueCallback(...): You called `setProps`, `replaceProps`, ' + '`setState`, `replaceState`, or `forceUpdate` with a callback that ' + 'isn\'t callable.') : invariant(false) : undefined;
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingForceUpdate = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingStateQueue = [completeState];
	    internalInstance._pendingReplaceState = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
	    queue.push(partialState);
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Sets a subset of the props.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialProps Subset of the next props.
	   * @internal
	   */
	  enqueueSetProps: function (publicInstance, partialProps) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setProps');
	    if (!internalInstance) {
	      return;
	    }
	    ReactUpdateQueue.enqueueSetPropsInternal(internalInstance, partialProps);
	  },
	
	  enqueueSetPropsInternal: function (internalInstance, partialProps) {
	    var topLevelWrapper = internalInstance._topLevelWrapper;
	    !topLevelWrapper ?  false ? invariant(false, 'setProps(...): You called `setProps` on a ' + 'component with a parent. This is an anti-pattern since props will ' + 'get reactively updated when rendered. Instead, change the owner\'s ' + '`render` method to pass the correct value as props to the component ' + 'where it is created.') : invariant(false) : undefined;
	
	    // Merge with the pending element if it exists, otherwise with existing
	    // element props.
	    var wrapElement = topLevelWrapper._pendingElement || topLevelWrapper._currentElement;
	    var element = wrapElement.props;
	    var props = assign({}, element.props, partialProps);
	    topLevelWrapper._pendingElement = ReactElement.cloneAndReplaceProps(wrapElement, ReactElement.cloneAndReplaceProps(element, props));
	
	    enqueueUpdate(topLevelWrapper);
	  },
	
	  /**
	   * Replaces all of the props.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} props New props.
	   * @internal
	   */
	  enqueueReplaceProps: function (publicInstance, props) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceProps');
	    if (!internalInstance) {
	      return;
	    }
	    ReactUpdateQueue.enqueueReplacePropsInternal(internalInstance, props);
	  },
	
	  enqueueReplacePropsInternal: function (internalInstance, props) {
	    var topLevelWrapper = internalInstance._topLevelWrapper;
	    !topLevelWrapper ?  false ? invariant(false, 'replaceProps(...): You called `replaceProps` on a ' + 'component with a parent. This is an anti-pattern since props will ' + 'get reactively updated when rendered. Instead, change the owner\'s ' + '`render` method to pass the correct value as props to the component ' + 'where it is created.') : invariant(false) : undefined;
	
	    // Merge with the pending element if it exists, otherwise with existing
	    // element props.
	    var wrapElement = topLevelWrapper._pendingElement || topLevelWrapper._currentElement;
	    var element = wrapElement.props;
	    topLevelWrapper._pendingElement = ReactElement.cloneAndReplaceProps(wrapElement, ReactElement.cloneAndReplaceProps(element, props));
	
	    enqueueUpdate(topLevelWrapper);
	  },
	
	  enqueueElementInternal: function (internalInstance, newElement) {
	    internalInstance._pendingElement = newElement;
	    enqueueUpdate(internalInstance);
	  }
	
	};
	
	module.exports = ReactUpdateQueue;

/***/ }),
/* 42 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactVersion
	 */
	
	'use strict';
	
	module.exports = '0.14.9';

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule findDOMNode
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var ReactCurrentOwner = __webpack_require__(12);
	var ReactInstanceMap = __webpack_require__(23);
	var ReactMount = __webpack_require__(5);
	
	var invariant = __webpack_require__(1);
	var warning = __webpack_require__(2);
	
	/**
	 * Returns the DOM node rendered by this element.
	 *
	 * @param {ReactComponent|DOMElement} componentOrElement
	 * @return {?DOMElement} The root node of this element.
	 */
	function findDOMNode(componentOrElement) {
	  if (false) {
	    var owner = ReactCurrentOwner.current;
	    if (owner !== null) {
	      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing getDOMNode or findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : undefined;
	      owner._warnedAboutRefsInRender = true;
	    }
	  }
	  if (componentOrElement == null) {
	    return null;
	  }
	  if (componentOrElement.nodeType === 1) {
	    return componentOrElement;
	  }
	  if (ReactInstanceMap.has(componentOrElement)) {
	    return ReactMount.getNodeFromInstance(componentOrElement);
	  }
	  !(componentOrElement.render == null || typeof componentOrElement.render !== 'function') ?  false ? invariant(false, 'findDOMNode was called on an unmounted component.') : invariant(false) : undefined;
	   true ?  false ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : invariant(false) : undefined;
	}
	
	module.exports = findDOMNode;

/***/ }),
/* 44 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getEventCharCode
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * `charCode` represents the actual "character code" and is safe to use with
	 * `String.fromCharCode`. As such, only keys that correspond to printable
	 * characters produce a valid `charCode`, the only exception to this is Enter.
	 * The Tab-key is considered non-printable and does not have a `charCode`,
	 * presumably because it does not produce a tab-character in browsers.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {number} Normalized `charCode` property.
	 */
	function getEventCharCode(nativeEvent) {
	  var charCode;
	  var keyCode = nativeEvent.keyCode;
	
	  if ('charCode' in nativeEvent) {
	    charCode = nativeEvent.charCode;
	
	    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
	    if (charCode === 0 && keyCode === 13) {
	      charCode = 13;
	    }
	  } else {
	    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
	    charCode = keyCode;
	  }
	
	  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
	  // Must not discard the (non-)printable Enter-key.
	  if (charCode >= 32 || charCode === 13) {
	    return charCode;
	  }
	
	  return 0;
	}
	
	module.exports = getEventCharCode;

/***/ }),
/* 45 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getEventModifierState
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Translation from modifier key to the associated property in the event.
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
	 */
	
	var modifierKeyToProp = {
	  'Alt': 'altKey',
	  'Control': 'ctrlKey',
	  'Meta': 'metaKey',
	  'Shift': 'shiftKey'
	};
	
	// IE8 does not implement getModifierState so we simply map it to the only
	// modifier keys exposed by the event itself, does not support Lock-keys.
	// Currently, all major browsers except Chrome seems to support Lock-keys.
	function modifierStateGetter(keyArg) {
	  var syntheticEvent = this;
	  var nativeEvent = syntheticEvent.nativeEvent;
	  if (nativeEvent.getModifierState) {
	    return nativeEvent.getModifierState(keyArg);
	  }
	  var keyProp = modifierKeyToProp[keyArg];
	  return keyProp ? !!nativeEvent[keyProp] : false;
	}
	
	function getEventModifierState(nativeEvent) {
	  return modifierStateGetter;
	}
	
	module.exports = getEventModifierState;

/***/ }),
/* 46 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getEventTarget
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Gets the target node from a native browser event by accounting for
	 * inconsistencies in browser DOM APIs.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {DOMEventTarget} Target node.
	 */
	function getEventTarget(nativeEvent) {
	  var target = nativeEvent.target || nativeEvent.srcElement || window;
	  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
	  // @see http://www.quirksmode.org/js/events_properties.html
	  return target.nodeType === 3 ? target.parentNode : target;
	}
	
	module.exports = getEventTarget;

/***/ }),
/* 47 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getIteratorFn
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/* global Symbol */
	var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	/**
	 * Returns the iterator method function contained on the iterable object.
	 *
	 * Be sure to invoke the function with the iterable as context:
	 *
	 *     var iteratorFn = getIteratorFn(myIterable);
	 *     if (iteratorFn) {
	 *       var iterator = iteratorFn.call(myIterable);
	 *       ...
	 *     }
	 *
	 * @param {?object} maybeIterable
	 * @return {?function}
	 */
	function getIteratorFn(maybeIterable) {
	  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	  if (typeof iteratorFn === 'function') {
	    return iteratorFn;
	  }
	}
	
	module.exports = getIteratorFn;

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule instantiateReactComponent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var ReactCompositeComponent = __webpack_require__(141);
	var ReactEmptyComponent = __webpack_require__(76);
	var ReactNativeComponent = __webpack_require__(82);
	
	var assign = __webpack_require__(3);
	var invariant = __webpack_require__(1);
	var warning = __webpack_require__(2);
	
	// To avoid a cyclic dependency, we create the final class in this module
	var ReactCompositeComponentWrapper = function () {};
	assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent.Mixin, {
	  _instantiateReactComponent: instantiateReactComponent
	});
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Check if the type reference is a known internal type. I.e. not a user
	 * provided composite type.
	 *
	 * @param {function} type
	 * @return {boolean} Returns true if this is a valid internal type.
	 */
	function isInternalComponentType(type) {
	  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
	}
	
	/**
	 * Given a ReactNode, create an instance that will actually be mounted.
	 *
	 * @param {ReactNode} node
	 * @return {object} A new instance of the element's constructor.
	 * @protected
	 */
	function instantiateReactComponent(node) {
	  var instance;
	
	  if (node === null || node === false) {
	    instance = new ReactEmptyComponent(instantiateReactComponent);
	  } else if (typeof node === 'object') {
	    var element = node;
	    !(element && (typeof element.type === 'function' || typeof element.type === 'string')) ?  false ? invariant(false, 'Element type is invalid: expected a string (for built-in components) ' + 'or a class/function (for composite components) but got: %s.%s', element.type == null ? element.type : typeof element.type, getDeclarationErrorAddendum(element._owner)) : invariant(false) : undefined;
	
	    // Special case string values
	    if (typeof element.type === 'string') {
	      instance = ReactNativeComponent.createInternalComponent(element);
	    } else if (isInternalComponentType(element.type)) {
	      // This is temporarily available for custom components that are not string
	      // representations. I.e. ART. Once those are updated to use the string
	      // representation, we can drop this code path.
	      instance = new element.type(element);
	    } else {
	      instance = new ReactCompositeComponentWrapper();
	    }
	  } else if (typeof node === 'string' || typeof node === 'number') {
	    instance = ReactNativeComponent.createInstanceForText(node);
	  } else {
	     true ?  false ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : invariant(false) : undefined;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(typeof instance.construct === 'function' && typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : undefined;
	  }
	
	  // Sets up the instance. This can probably just move into the constructor now.
	  instance.construct(node);
	
	  // These two fields are used by the DOM and ART diffing algorithms
	  // respectively. Instead of using expandos on components, we should be
	  // storing the state needed by the diffing algorithms elsewhere.
	  instance._mountIndex = 0;
	  instance._mountImage = null;
	
	  if (false) {
	    instance._isOwnerNecessary = false;
	    instance._warnedAboutRefsInRender = false;
	  }
	
	  // Internal instances should fully constructed at this point, so they should
	  // not get any new fields added to them at this point.
	  if (false) {
	    if (Object.preventExtensions) {
	      Object.preventExtensions(instance);
	    }
	  }
	
	  return instance;
	}
	
	module.exports = instantiateReactComponent;

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule isEventSupported
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(4);
	
	var useHasFeature;
	if (ExecutionEnvironment.canUseDOM) {
	  useHasFeature = document.implementation && document.implementation.hasFeature &&
	  // always returns true in newer browsers as per the standard.
	  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
	  document.implementation.hasFeature('', '') !== true;
	}
	
	/**
	 * Checks if an event is supported in the current execution environment.
	 *
	 * NOTE: This will not work correctly for non-generic events such as `change`,
	 * `reset`, `load`, `error`, and `select`.
	 *
	 * Borrows from Modernizr.
	 *
	 * @param {string} eventNameSuffix Event name, e.g. "click".
	 * @param {?boolean} capture Check if the capture phase is supported.
	 * @return {boolean} True if the event is supported.
	 * @internal
	 * @license Modernizr 3.0.0pre (Custom Build) | MIT
	 */
	function isEventSupported(eventNameSuffix, capture) {
	  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
	    return false;
	  }
	
	  var eventName = 'on' + eventNameSuffix;
	  var isSupported = (eventName in document);
	
	  if (!isSupported) {
	    var element = document.createElement('div');
	    element.setAttribute(eventName, 'return;');
	    isSupported = typeof element[eventName] === 'function';
	  }
	
	  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
	    // This is the only way to test support for the `wheel` event in IE9+.
	    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
	  }
	
	  return isSupported;
	}
	
	module.exports = isEventSupported;

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule setTextContent
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(4);
	var escapeTextContentForBrowser = __webpack_require__(32);
	var setInnerHTML = __webpack_require__(33);
	
	/**
	 * Set the textContent property of a node, ensuring that whitespace is preserved
	 * even in IE8. innerText is a poor substitute for textContent and, among many
	 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
	 * as it should.
	 *
	 * @param {DOMElement} node
	 * @param {string} text
	 * @internal
	 */
	var setTextContent = function (node, text) {
	  node.textContent = text;
	};
	
	if (ExecutionEnvironment.canUseDOM) {
	  if (!('textContent' in document.documentElement)) {
	    setTextContent = function (node, text) {
	      setInnerHTML(node, escapeTextContentForBrowser(text));
	    };
	  }
	}
	
	module.exports = setTextContent;

/***/ }),
/* 51 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule shouldUpdateReactComponent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Given a `prevElement` and `nextElement`, determines if the existing
	 * instance should be updated as opposed to being destroyed or replaced by a new
	 * instance. Both arguments are elements. This ensures that this logic can
	 * operate on stateless trees without any backing instance.
	 *
	 * @param {?object} prevElement
	 * @param {?object} nextElement
	 * @return {boolean} True if the existing instance should be updated.
	 * @protected
	 */
	function shouldUpdateReactComponent(prevElement, nextElement) {
	  var prevEmpty = prevElement === null || prevElement === false;
	  var nextEmpty = nextElement === null || nextElement === false;
	  if (prevEmpty || nextEmpty) {
	    return prevEmpty === nextEmpty;
	  }
	
	  var prevType = typeof prevElement;
	  var nextType = typeof nextElement;
	  if (prevType === 'string' || prevType === 'number') {
	    return nextType === 'string' || nextType === 'number';
	  } else {
	    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
	  }
	  return false;
	}
	
	module.exports = shouldUpdateReactComponent;

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule traverseAllChildren
	 */
	
	'use strict';
	
	var ReactCurrentOwner = __webpack_require__(12);
	var ReactElement = __webpack_require__(6);
	var ReactInstanceHandles = __webpack_require__(19);
	
	var getIteratorFn = __webpack_require__(47);
	var invariant = __webpack_require__(1);
	var warning = __webpack_require__(2);
	
	var SEPARATOR = ReactInstanceHandles.SEPARATOR;
	var SUBSEPARATOR = ':';
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var userProvidedKeyEscaperLookup = {
	  '=': '=0',
	  '.': '=1',
	  ':': '=2'
	};
	
	var userProvidedKeyEscapeRegex = /[=.:]/g;
	
	var didWarnAboutMaps = false;
	
	function userProvidedKeyEscaper(match) {
	  return userProvidedKeyEscaperLookup[match];
	}
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  if (component && component.key != null) {
	    // Explicit key
	    return wrapUserProvidedKey(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * Escape a component key so that it is safe to use in a reactid.
	 *
	 * @param {*} text Component key to be escaped.
	 * @return {string} An escaped string.
	 */
	function escapeUserProvidedKey(text) {
	  return ('' + text).replace(userProvidedKeyEscapeRegex, userProvidedKeyEscaper);
	}
	
	/**
	 * Wrap a `key` value explicitly provided by the user to distinguish it from
	 * implicitly-generated keys generated by a component's index in its parent.
	 *
	 * @param {string} key Value of a user-provided `key` attribute
	 * @return {string}
	 */
	function wrapUserProvidedKey(key) {
	  return '$' + escapeUserProvidedKey(key);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' || ReactElement.isValidElement(children)) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.') : undefined;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + wrapUserProvidedKey(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = ' It looks like you\'re using an element created by a different ' + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : invariant(false) : undefined;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule validateDOMNesting
	 */
	
	'use strict';
	
	var assign = __webpack_require__(3);
	var emptyFunction = __webpack_require__(9);
	var warning = __webpack_require__(2);
	
	var validateDOMNesting = emptyFunction;
	
	if (false) {
	  // This validation code was written based on the HTML5 parsing spec:
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  //
	  // Note: this does not catch all invalid nesting, nor does it try to (as it's
	  // not clear what practical benefit doing so provides); instead, we warn only
	  // for cases where the parser will give a parse tree differing from what React
	  // intended. For example, <b><div></div></b> is invalid but we don't warn
	  // because it still parses correctly; we do warn for other cases like nested
	  // <p> tags where the beginning of the second element implicitly closes the
	  // first, causing a confusing mess.
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#special
	  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
	  // TODO: Distinguish by namespace here -- for <title>, including it here
	  // errs on the side of fewer warnings
	  'foreignObject', 'desc', 'title'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
	  var buttonScopeTags = inScopeTags.concat(['button']);
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
	  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];
	
	  var emptyAncestorInfo = {
	    parentTag: null,
	
	    formTag: null,
	    aTagInScope: null,
	    buttonTagInScope: null,
	    nobrTagInScope: null,
	    pTagInButtonScope: null,
	
	    listItemTagAutoclosing: null,
	    dlItemTagAutoclosing: null
	  };
	
	  var updatedAncestorInfo = function (oldInfo, tag, instance) {
	    var ancestorInfo = assign({}, oldInfo || emptyAncestorInfo);
	    var info = { tag: tag, instance: instance };
	
	    if (inScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.aTagInScope = null;
	      ancestorInfo.buttonTagInScope = null;
	      ancestorInfo.nobrTagInScope = null;
	    }
	    if (buttonScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.pTagInButtonScope = null;
	    }
	
	    // See rules for 'li', 'dd', 'dt' start tags in
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
	      ancestorInfo.listItemTagAutoclosing = null;
	      ancestorInfo.dlItemTagAutoclosing = null;
	    }
	
	    ancestorInfo.parentTag = info;
	
	    if (tag === 'form') {
	      ancestorInfo.formTag = info;
	    }
	    if (tag === 'a') {
	      ancestorInfo.aTagInScope = info;
	    }
	    if (tag === 'button') {
	      ancestorInfo.buttonTagInScope = info;
	    }
	    if (tag === 'nobr') {
	      ancestorInfo.nobrTagInScope = info;
	    }
	    if (tag === 'p') {
	      ancestorInfo.pTagInButtonScope = info;
	    }
	    if (tag === 'li') {
	      ancestorInfo.listItemTagAutoclosing = info;
	    }
	    if (tag === 'dd' || tag === 'dt') {
	      ancestorInfo.dlItemTagAutoclosing = info;
	    }
	
	    return ancestorInfo;
	  };
	
	  /**
	   * Returns whether
	   */
	  var isTagValidWithParent = function (tag, parentTag) {
	    // First, let's check if we're in an unusual parsing mode...
	    switch (parentTag) {
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
	      case 'select':
	        return tag === 'option' || tag === 'optgroup' || tag === '#text';
	      case 'optgroup':
	        return tag === 'option' || tag === '#text';
	      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
	      // but
	      case 'option':
	        return tag === '#text';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
	      // No special behavior since these rules fall back to "in body" mode for
	      // all except special table nodes which cause bad parsing behavior anyway.
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
	      case 'tr':
	        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
	      case 'tbody':
	      case 'thead':
	      case 'tfoot':
	        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
	      case 'colgroup':
	        return tag === 'col' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
	      case 'table':
	        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
	      case 'head':
	        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
	      case 'html':
	        return tag === 'head' || tag === 'body';
	    }
	
	    // Probably in the "in body" parsing mode, so we outlaw only tag combos
	    // where the parsing rules cause implicit opens or closes to be added.
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    switch (tag) {
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';
	
	      case 'rp':
	      case 'rt':
	        return impliedEndTags.indexOf(parentTag) === -1;
	
	      case 'caption':
	      case 'col':
	      case 'colgroup':
	      case 'frame':
	      case 'head':
	      case 'tbody':
	      case 'td':
	      case 'tfoot':
	      case 'th':
	      case 'thead':
	      case 'tr':
	        // These tags are only valid with a few parents that have special child
	        // parsing rules -- if we're down here, then none of those matched and
	        // so we allow it only if we don't know what the parent is, as all other
	        // cases are invalid.
	        return parentTag == null;
	    }
	
	    return true;
	  };
	
	  /**
	   * Returns whether
	   */
	  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
	    switch (tag) {
	      case 'address':
	      case 'article':
	      case 'aside':
	      case 'blockquote':
	      case 'center':
	      case 'details':
	      case 'dialog':
	      case 'dir':
	      case 'div':
	      case 'dl':
	      case 'fieldset':
	      case 'figcaption':
	      case 'figure':
	      case 'footer':
	      case 'header':
	      case 'hgroup':
	      case 'main':
	      case 'menu':
	      case 'nav':
	      case 'ol':
	      case 'p':
	      case 'section':
	      case 'summary':
	      case 'ul':
	
	      case 'pre':
	      case 'listing':
	
	      case 'table':
	
	      case 'hr':
	
	      case 'xmp':
	
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return ancestorInfo.pTagInButtonScope;
	
	      case 'form':
	        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;
	
	      case 'li':
	        return ancestorInfo.listItemTagAutoclosing;
	
	      case 'dd':
	      case 'dt':
	        return ancestorInfo.dlItemTagAutoclosing;
	
	      case 'button':
	        return ancestorInfo.buttonTagInScope;
	
	      case 'a':
	        // Spec says something about storing a list of markers, but it sounds
	        // equivalent to this check.
	        return ancestorInfo.aTagInScope;
	
	      case 'nobr':
	        return ancestorInfo.nobrTagInScope;
	    }
	
	    return null;
	  };
	
	  /**
	   * Given a ReactCompositeComponent instance, return a list of its recursive
	   * owners, starting at the root and ending with the instance itself.
	   */
	  var findOwnerStack = function (instance) {
	    if (!instance) {
	      return [];
	    }
	
	    var stack = [];
	    /*eslint-disable space-after-keywords */
	    do {
	      /*eslint-enable space-after-keywords */
	      stack.push(instance);
	    } while (instance = instance._currentElement._owner);
	    stack.reverse();
	    return stack;
	  };
	
	  var didWarn = {};
	
	  validateDOMNesting = function (childTag, childInstance, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.parentTag;
	    var parentTag = parentInfo && parentInfo.tag;
	
	    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
	    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
	    var problematic = invalidParent || invalidAncestor;
	
	    if (problematic) {
	      var ancestorTag = problematic.tag;
	      var ancestorInstance = problematic.instance;
	
	      var childOwner = childInstance && childInstance._currentElement._owner;
	      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;
	
	      var childOwners = findOwnerStack(childOwner);
	      var ancestorOwners = findOwnerStack(ancestorOwner);
	
	      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
	      var i;
	
	      var deepestCommon = -1;
	      for (i = 0; i < minStackLen; i++) {
	        if (childOwners[i] === ancestorOwners[i]) {
	          deepestCommon = i;
	        } else {
	          break;
	        }
	      }
	
	      var UNKNOWN = '(unknown)';
	      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ownerInfo = [].concat(
	      // If the parent and child instances have a common owner ancestor, start
	      // with that -- otherwise we just start with the parent's owners.
	      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
	      // If we're warning about an invalid (non-parent) ancestry, add '...'
	      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');
	
	      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
	      if (didWarn[warnKey]) {
	        return;
	      }
	      didWarn[warnKey] = true;
	
	      if (invalidParent) {
	        var info = '';
	        if (ancestorTag === 'table' && childTag === 'tr') {
	          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
	        }
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): <%s> cannot appear as a child of <%s>. ' + 'See %s.%s', childTag, ancestorTag, ownerInfo, info) : undefined;
	      } else {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): <%s> cannot appear as a descendant of ' + '<%s>. See %s.', childTag, ancestorTag, ownerInfo) : undefined;
	      }
	    }
	  };
	
	  validateDOMNesting.ancestorInfoContextKey = '__validateDOMNesting_ancestorInfo$' + Math.random().toString(36).slice(2);
	
	  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;
	
	  // For testing
	  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.parentTag;
	    var parentTag = parentInfo && parentInfo.tag;
	    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
	  };
	}
	
	module.exports = validateDOMNesting;

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule EventListener
	 * @typechecks
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(9);
	
	/**
	 * Upstream version of event listener. Does not take into account specific
	 * nature of platform.
	 */
	var EventListener = {
	  /**
	   * Listen to DOM events during the bubble phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  listen: function (target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, false);
	      return {
	        remove: function () {
	          target.removeEventListener(eventType, callback, false);
	        }
	      };
	    } else if (target.attachEvent) {
	      target.attachEvent('on' + eventType, callback);
	      return {
	        remove: function () {
	          target.detachEvent('on' + eventType, callback);
	        }
	      };
	    }
	  },
	
	  /**
	   * Listen to DOM events during the capture phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  capture: function (target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, true);
	      return {
	        remove: function () {
	          target.removeEventListener(eventType, callback, true);
	        }
	      };
	    } else {
	      if (false) {
	        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
	      }
	      return {
	        remove: emptyFunction
	      };
	    }
	  },
	
	  registerDefault: function () {}
	};
	
	module.exports = EventListener;

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule containsNode
	 * @typechecks
	 */
	
	'use strict';
	
	var isTextNode = __webpack_require__(106);
	
	/*eslint-disable no-bitwise */
	
	/**
	 * Checks if a given DOM node contains or is another DOM node.
	 *
	 * @param {?DOMNode} outerNode Outer DOM node.
	 * @param {?DOMNode} innerNode Inner DOM node.
	 * @return {boolean} True if `outerNode` contains or is `innerNode`.
	 */
	function containsNode(_x, _x2) {
	  var _again = true;
	
	  _function: while (_again) {
	    var outerNode = _x,
	        innerNode = _x2;
	    _again = false;
	
	    if (!outerNode || !innerNode) {
	      return false;
	    } else if (outerNode === innerNode) {
	      return true;
	    } else if (isTextNode(outerNode)) {
	      return false;
	    } else if (isTextNode(innerNode)) {
	      _x = outerNode;
	      _x2 = innerNode.parentNode;
	      _again = true;
	      continue _function;
	    } else if (outerNode.contains) {
	      return outerNode.contains(innerNode);
	    } else if (outerNode.compareDocumentPosition) {
	      return !!(outerNode.compareDocumentPosition(innerNode) & 16);
	    } else {
	      return false;
	    }
	  }
	}
	
	module.exports = containsNode;

/***/ }),
/* 56 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule focusNode
	 */
	
	'use strict';
	
	/**
	 * @param {DOMElement} node input/textarea to focus
	 */
	function focusNode(node) {
	  // IE8 can throw "Can't move focus to the control because it is invisible,
	  // not enabled, or of a type that does not accept the focus." for all kinds of
	  // reasons that are too expensive and fragile to test.
	  try {
	    node.focus();
	  } catch (e) {}
	}
	
	module.exports = focusNode;

/***/ }),
/* 57 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getActiveElement
	 * @typechecks
	 */
	
	/* eslint-disable fb-www/typeof-undefined */
	
	/**
	 * Same as document.activeElement but wraps in a try-catch block. In IE it is
	 * not safe to call document.activeElement if there is nothing focused.
	 *
	 * The activeElement will be null only if the document or document body is not
	 * yet defined.
	 */
	'use strict';
	
	function getActiveElement() /*?DOMElement*/{
	  if (typeof document === 'undefined') {
	    return null;
	  }
	  try {
	    return document.activeElement || document.body;
	  } catch (e) {
	    return document.body;
	  }
	}
	
	module.exports = getActiveElement;

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getMarkupWrap
	 */
	
	/*eslint-disable fb-www/unsafe-html */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(4);
	
	var invariant = __webpack_require__(1);
	
	/**
	 * Dummy container used to detect which wraps are necessary.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Some browsers cannot use `innerHTML` to render certain elements standalone,
	 * so we wrap them, render the wrapped nodes, then extract the desired node.
	 *
	 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
	 */
	
	var shouldWrap = {};
	
	var selectWrap = [1, '<select multiple="true">', '</select>'];
	var tableWrap = [1, '<table>', '</table>'];
	var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];
	
	var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];
	
	var markupWrap = {
	  '*': [1, '?<div>', '</div>'],
	
	  'area': [1, '<map>', '</map>'],
	  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
	  'legend': [1, '<fieldset>', '</fieldset>'],
	  'param': [1, '<object>', '</object>'],
	  'tr': [2, '<table><tbody>', '</tbody></table>'],
	
	  'optgroup': selectWrap,
	  'option': selectWrap,
	
	  'caption': tableWrap,
	  'colgroup': tableWrap,
	  'tbody': tableWrap,
	  'tfoot': tableWrap,
	  'thead': tableWrap,
	
	  'td': trWrap,
	  'th': trWrap
	};
	
	// Initialize the SVG elements since we know they'll always need to be wrapped
	// consistently. If they are created inside a <div> they will be initialized in
	// the wrong namespace (and will not display).
	var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
	svgElements.forEach(function (nodeName) {
	  markupWrap[nodeName] = svgWrap;
	  shouldWrap[nodeName] = true;
	});
	
	/**
	 * Gets the markup wrap configuration for the supplied `nodeName`.
	 *
	 * NOTE: This lazily detects which wraps are necessary for the current browser.
	 *
	 * @param {string} nodeName Lowercase `nodeName`.
	 * @return {?array} Markup wrap configuration, if applicable.
	 */
	function getMarkupWrap(nodeName) {
	  !!!dummyNode ?  false ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : undefined;
	  if (!markupWrap.hasOwnProperty(nodeName)) {
	    nodeName = '*';
	  }
	  if (!shouldWrap.hasOwnProperty(nodeName)) {
	    if (nodeName === '*') {
	      dummyNode.innerHTML = '<link />';
	    } else {
	      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
	    }
	    shouldWrap[nodeName] = !dummyNode.firstChild;
	  }
	  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
	}
	
	module.exports = getMarkupWrap;

/***/ }),
/* 59 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule shallowEqual
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * Performs equality by iterating through keys on an object and returning false
	 * when any key has values which are not strictly equal between the arguments.
	 * Returns true when the values of all keys are strictly equal.
	 */
	function shallowEqual(objA, objB) {
	  if (objA === objB) {
	    return true;
	  }
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  var bHasOwnProperty = hasOwnProperty.bind(objB);
	  for (var i = 0; i < keysA.length; i++) {
	    if (!bHasOwnProperty(keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = shallowEqual;

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "f4769f9bdb7466be65088239c12046d1.eot";

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	exports['default'] = function () {
	  var Snap = undefined;
	  try {
	    Snap = __webpack_require__(182);
	  } finally {
	    return Snap;
	  }
	};
	
	module.exports = exports['default'];

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(69);


/***/ }),
/* 63 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule CSSProperty
	 */
	
	'use strict';
	
	/**
	 * CSS properties which accept numbers but are not in units of "px".
	 */
	var isUnitlessNumber = {
	  animationIterationCount: true,
	  boxFlex: true,
	  boxFlexGroup: true,
	  boxOrdinalGroup: true,
	  columnCount: true,
	  flex: true,
	  flexGrow: true,
	  flexPositive: true,
	  flexShrink: true,
	  flexNegative: true,
	  flexOrder: true,
	  fontWeight: true,
	  lineClamp: true,
	  lineHeight: true,
	  opacity: true,
	  order: true,
	  orphans: true,
	  tabSize: true,
	  widows: true,
	  zIndex: true,
	  zoom: true,
	
	  // SVG-related properties
	  fillOpacity: true,
	  stopOpacity: true,
	  strokeDashoffset: true,
	  strokeOpacity: true,
	  strokeWidth: true
	};
	
	/**
	 * @param {string} prefix vendor-specific prefix, eg: Webkit
	 * @param {string} key style name, eg: transitionDuration
	 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
	 * WebkitTransitionDuration
	 */
	function prefixKey(prefix, key) {
	  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
	}
	
	/**
	 * Support style names that may come passed in prefixed by adding permutations
	 * of vendor prefixes.
	 */
	var prefixes = ['Webkit', 'ms', 'Moz', 'O'];
	
	// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
	// infinite loop, because it iterates over the newly added props too.
	Object.keys(isUnitlessNumber).forEach(function (prop) {
	  prefixes.forEach(function (prefix) {
	    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
	  });
	});
	
	/**
	 * Most style properties can be unset by doing .style[prop] = '' but IE8
	 * doesn't like doing that with shorthand properties so for the properties that
	 * IE8 breaks on, which are listed here, we instead unset each of the
	 * individual properties. See http://bugs.jquery.com/ticket/12385.
	 * The 4-value 'clock' properties like margin, padding, border-width seem to
	 * behave without any problems. Curiously, list-style works too without any
	 * special prodding.
	 */
	var shorthandPropertyExpansions = {
	  background: {
	    backgroundAttachment: true,
	    backgroundColor: true,
	    backgroundImage: true,
	    backgroundPositionX: true,
	    backgroundPositionY: true,
	    backgroundRepeat: true
	  },
	  backgroundPosition: {
	    backgroundPositionX: true,
	    backgroundPositionY: true
	  },
	  border: {
	    borderWidth: true,
	    borderStyle: true,
	    borderColor: true
	  },
	  borderBottom: {
	    borderBottomWidth: true,
	    borderBottomStyle: true,
	    borderBottomColor: true
	  },
	  borderLeft: {
	    borderLeftWidth: true,
	    borderLeftStyle: true,
	    borderLeftColor: true
	  },
	  borderRight: {
	    borderRightWidth: true,
	    borderRightStyle: true,
	    borderRightColor: true
	  },
	  borderTop: {
	    borderTopWidth: true,
	    borderTopStyle: true,
	    borderTopColor: true
	  },
	  font: {
	    fontStyle: true,
	    fontVariant: true,
	    fontWeight: true,
	    fontSize: true,
	    lineHeight: true,
	    fontFamily: true
	  },
	  outline: {
	    outlineWidth: true,
	    outlineStyle: true,
	    outlineColor: true
	  }
	};
	
	var CSSProperty = {
	  isUnitlessNumber: isUnitlessNumber,
	  shorthandPropertyExpansions: shorthandPropertyExpansions
	};
	
	module.exports = CSSProperty;

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DOMChildrenOperations
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var Danger = __webpack_require__(132);
	var ReactMultiChildUpdateTypes = __webpack_require__(81);
	var ReactPerf = __webpack_require__(7);
	
	var setInnerHTML = __webpack_require__(33);
	var setTextContent = __webpack_require__(50);
	var invariant = __webpack_require__(1);
	
	/**
	 * Inserts `childNode` as a child of `parentNode` at the `index`.
	 *
	 * @param {DOMElement} parentNode Parent node in which to insert.
	 * @param {DOMElement} childNode Child node to insert.
	 * @param {number} index Index at which to insert the child.
	 * @internal
	 */
	function insertChildAt(parentNode, childNode, index) {
	  // By exploiting arrays returning `undefined` for an undefined index, we can
	  // rely exclusively on `insertBefore(node, null)` instead of also using
	  // `appendChild(node)`. However, using `undefined` is not allowed by all
	  // browsers so we must replace it with `null`.
	
	  // fix render order error in safari
	  // IE8 will throw error when index out of list size.
	  var beforeChild = index >= parentNode.childNodes.length ? null : parentNode.childNodes.item(index);
	
	  parentNode.insertBefore(childNode, beforeChild);
	}
	
	/**
	 * Operations for updating with DOM children.
	 */
	var DOMChildrenOperations = {
	
	  dangerouslyReplaceNodeWithMarkup: Danger.dangerouslyReplaceNodeWithMarkup,
	
	  updateTextContent: setTextContent,
	
	  /**
	   * Updates a component's children by processing a series of updates. The
	   * update configurations are each expected to have a `parentNode` property.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @param {array<string>} markupList List of markup strings.
	   * @internal
	   */
	  processUpdates: function (updates, markupList) {
	    var update;
	    // Mapping from parent IDs to initial child orderings.
	    var initialChildren = null;
	    // List of children that will be moved or removed.
	    var updatedChildren = null;
	
	    for (var i = 0; i < updates.length; i++) {
	      update = updates[i];
	      if (update.type === ReactMultiChildUpdateTypes.MOVE_EXISTING || update.type === ReactMultiChildUpdateTypes.REMOVE_NODE) {
	        var updatedIndex = update.fromIndex;
	        var updatedChild = update.parentNode.childNodes[updatedIndex];
	        var parentID = update.parentID;
	
	        !updatedChild ?  false ? invariant(false, 'processUpdates(): Unable to find child %s of element. This ' + 'probably means the DOM was unexpectedly mutated (e.g., by the ' + 'browser), usually due to forgetting a <tbody> when using tables, ' + 'nesting tags like <form>, <p>, or <a>, or using non-SVG elements ' + 'in an <svg> parent. Try inspecting the child nodes of the element ' + 'with React ID `%s`.', updatedIndex, parentID) : invariant(false) : undefined;
	
	        initialChildren = initialChildren || {};
	        initialChildren[parentID] = initialChildren[parentID] || [];
	        initialChildren[parentID][updatedIndex] = updatedChild;
	
	        updatedChildren = updatedChildren || [];
	        updatedChildren.push(updatedChild);
	      }
	    }
	
	    var renderedMarkup;
	    // markupList is either a list of markup or just a list of elements
	    if (markupList.length && typeof markupList[0] === 'string') {
	      renderedMarkup = Danger.dangerouslyRenderMarkup(markupList);
	    } else {
	      renderedMarkup = markupList;
	    }
	
	    // Remove updated children first so that `toIndex` is consistent.
	    if (updatedChildren) {
	      for (var j = 0; j < updatedChildren.length; j++) {
	        updatedChildren[j].parentNode.removeChild(updatedChildren[j]);
	      }
	    }
	
	    for (var k = 0; k < updates.length; k++) {
	      update = updates[k];
	      switch (update.type) {
	        case ReactMultiChildUpdateTypes.INSERT_MARKUP:
	          insertChildAt(update.parentNode, renderedMarkup[update.markupIndex], update.toIndex);
	          break;
	        case ReactMultiChildUpdateTypes.MOVE_EXISTING:
	          insertChildAt(update.parentNode, initialChildren[update.parentID][update.fromIndex], update.toIndex);
	          break;
	        case ReactMultiChildUpdateTypes.SET_MARKUP:
	          setInnerHTML(update.parentNode, update.content);
	          break;
	        case ReactMultiChildUpdateTypes.TEXT_CONTENT:
	          setTextContent(update.parentNode, update.content);
	          break;
	        case ReactMultiChildUpdateTypes.REMOVE_NODE:
	          // Already removed by the for-loop above.
	          break;
	      }
	    }
	  }
	
	};
	
	ReactPerf.measureMethods(DOMChildrenOperations, 'DOMChildrenOperations', {
	  updateTextContent: 'updateTextContent'
	});
	
	module.exports = DOMChildrenOperations;

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventPluginRegistry
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(1);
	
	/**
	 * Injectable ordering of event plugins.
	 */
	var EventPluginOrder = null;
	
	/**
	 * Injectable mapping from names to event plugin modules.
	 */
	var namesToPlugins = {};
	
	/**
	 * Recomputes the plugin list using the injected plugins and plugin ordering.
	 *
	 * @private
	 */
	function recomputePluginOrdering() {
	  if (!EventPluginOrder) {
	    // Wait until an `EventPluginOrder` is injected.
	    return;
	  }
	  for (var pluginName in namesToPlugins) {
	    var PluginModule = namesToPlugins[pluginName];
	    var pluginIndex = EventPluginOrder.indexOf(pluginName);
	    !(pluginIndex > -1) ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in ' + 'the plugin ordering, `%s`.', pluginName) : invariant(false) : undefined;
	    if (EventPluginRegistry.plugins[pluginIndex]) {
	      continue;
	    }
	    !PluginModule.extractEvents ?  false ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` ' + 'method, but `%s` does not.', pluginName) : invariant(false) : undefined;
	    EventPluginRegistry.plugins[pluginIndex] = PluginModule;
	    var publishedEvents = PluginModule.eventTypes;
	    for (var eventName in publishedEvents) {
	      !publishEventForPlugin(publishedEvents[eventName], PluginModule, eventName) ?  false ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : invariant(false) : undefined;
	    }
	  }
	}
	
	/**
	 * Publishes an event so that it can be dispatched by the supplied plugin.
	 *
	 * @param {object} dispatchConfig Dispatch configuration for the event.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @return {boolean} True if the event was successfully published.
	 * @private
	 */
	function publishEventForPlugin(dispatchConfig, PluginModule, eventName) {
	  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same ' + 'event name, `%s`.', eventName) : invariant(false) : undefined;
	  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;
	
	  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	  if (phasedRegistrationNames) {
	    for (var phaseName in phasedRegistrationNames) {
	      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
	        var phasedRegistrationName = phasedRegistrationNames[phaseName];
	        publishRegistrationName(phasedRegistrationName, PluginModule, eventName);
	      }
	    }
	    return true;
	  } else if (dispatchConfig.registrationName) {
	    publishRegistrationName(dispatchConfig.registrationName, PluginModule, eventName);
	    return true;
	  }
	  return false;
	}
	
	/**
	 * Publishes a registration name that is used to identify dispatched events and
	 * can be used with `EventPluginHub.putListener` to register listeners.
	 *
	 * @param {string} registrationName Registration name to add.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @private
	 */
	function publishRegistrationName(registrationName, PluginModule, eventName) {
	  !!EventPluginRegistry.registrationNameModules[registrationName] ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same ' + 'registration name, `%s`.', registrationName) : invariant(false) : undefined;
	  EventPluginRegistry.registrationNameModules[registrationName] = PluginModule;
	  EventPluginRegistry.registrationNameDependencies[registrationName] = PluginModule.eventTypes[eventName].dependencies;
	}
	
	/**
	 * Registers plugins so that they can extract and dispatch events.
	 *
	 * @see {EventPluginHub}
	 */
	var EventPluginRegistry = {
	
	  /**
	   * Ordered list of injected plugins.
	   */
	  plugins: [],
	
	  /**
	   * Mapping from event name to dispatch config
	   */
	  eventNameDispatchConfigs: {},
	
	  /**
	   * Mapping from registration name to plugin module
	   */
	  registrationNameModules: {},
	
	  /**
	   * Mapping from registration name to event name
	   */
	  registrationNameDependencies: {},
	
	  /**
	   * Injects an ordering of plugins (by plugin name). This allows the ordering
	   * to be decoupled from injection of the actual plugins so that ordering is
	   * always deterministic regardless of packaging, on-the-fly injection, etc.
	   *
	   * @param {array} InjectedEventPluginOrder
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginOrder}
	   */
	  injectEventPluginOrder: function (InjectedEventPluginOrder) {
	    !!EventPluginOrder ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than ' + 'once. You are likely trying to load more than one copy of React.') : invariant(false) : undefined;
	    // Clone the ordering so it cannot be dynamically mutated.
	    EventPluginOrder = Array.prototype.slice.call(InjectedEventPluginOrder);
	    recomputePluginOrdering();
	  },
	
	  /**
	   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
	   * in the ordering injected by `injectEventPluginOrder`.
	   *
	   * Plugins can be injected as part of page initialization or on-the-fly.
	   *
	   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginsByName}
	   */
	  injectEventPluginsByName: function (injectedNamesToPlugins) {
	    var isOrderingDirty = false;
	    for (var pluginName in injectedNamesToPlugins) {
	      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
	        continue;
	      }
	      var PluginModule = injectedNamesToPlugins[pluginName];
	      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== PluginModule) {
	        !!namesToPlugins[pluginName] ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins ' + 'using the same name, `%s`.', pluginName) : invariant(false) : undefined;
	        namesToPlugins[pluginName] = PluginModule;
	        isOrderingDirty = true;
	      }
	    }
	    if (isOrderingDirty) {
	      recomputePluginOrdering();
	    }
	  },
	
	  /**
	   * Looks up the plugin for the supplied event.
	   *
	   * @param {object} event A synthetic event.
	   * @return {?object} The plugin that created the supplied event.
	   * @internal
	   */
	  getPluginModuleForEvent: function (event) {
	    var dispatchConfig = event.dispatchConfig;
	    if (dispatchConfig.registrationName) {
	      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
	    }
	    for (var phase in dispatchConfig.phasedRegistrationNames) {
	      if (!dispatchConfig.phasedRegistrationNames.hasOwnProperty(phase)) {
	        continue;
	      }
	      var PluginModule = EventPluginRegistry.registrationNameModules[dispatchConfig.phasedRegistrationNames[phase]];
	      if (PluginModule) {
	        return PluginModule;
	      }
	    }
	    return null;
	  },
	
	  /**
	   * Exposed for unit testing.
	   * @private
	   */
	  _resetEventPlugins: function () {
	    EventPluginOrder = null;
	    for (var pluginName in namesToPlugins) {
	      if (namesToPlugins.hasOwnProperty(pluginName)) {
	        delete namesToPlugins[pluginName];
	      }
	    }
	    EventPluginRegistry.plugins.length = 0;
	
	    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
	    for (var eventName in eventNameDispatchConfigs) {
	      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
	        delete eventNameDispatchConfigs[eventName];
	      }
	    }
	
	    var registrationNameModules = EventPluginRegistry.registrationNameModules;
	    for (var registrationName in registrationNameModules) {
	      if (registrationNameModules.hasOwnProperty(registrationName)) {
	        delete registrationNameModules[registrationName];
	      }
	    }
	  }
	
	};
	
	module.exports = EventPluginRegistry;

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactChildren
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(14);
	var ReactElement = __webpack_require__(6);
	
	var emptyFunction = __webpack_require__(9);
	var traverseAllChildren = __webpack_require__(52);
	
	var twoArgumentPooler = PooledClass.twoArgumentPooler;
	var fourArgumentPooler = PooledClass.fourArgumentPooler;
	
	var userProvidedKeyEscapeRegex = /\/(?!\/)/g;
	function escapeUserProvidedKey(text) {
	  return ('' + text).replace(userProvidedKeyEscapeRegex, '//');
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * traversal. Allows avoiding binding callbacks.
	 *
	 * @constructor ForEachBookKeeping
	 * @param {!function} forEachFunction Function to perform traversal with.
	 * @param {?*} forEachContext Context to perform context with.
	 */
	function ForEachBookKeeping(forEachFunction, forEachContext) {
	  this.func = forEachFunction;
	  this.context = forEachContext;
	  this.count = 0;
	}
	ForEachBookKeeping.prototype.destructor = function () {
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);
	
	function forEachSingleChild(bookKeeping, child, name) {
	  var func = bookKeeping.func;
	  var context = bookKeeping.context;
	
	  func.call(context, child, bookKeeping.count++);
	}
	
	/**
	 * Iterates through children that are typically specified as `props.children`.
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} forEachFunc
	 * @param {*} forEachContext Context for forEachContext.
	 */
	function forEachChildren(children, forEachFunc, forEachContext) {
	  if (children == null) {
	    return children;
	  }
	  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
	  traverseAllChildren(children, forEachSingleChild, traverseContext);
	  ForEachBookKeeping.release(traverseContext);
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * mapping. Allows avoiding binding callbacks.
	 *
	 * @constructor MapBookKeeping
	 * @param {!*} mapResult Object containing the ordered map of results.
	 * @param {!function} mapFunction Function to perform mapping with.
	 * @param {?*} mapContext Context to perform mapping with.
	 */
	function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
	  this.result = mapResult;
	  this.keyPrefix = keyPrefix;
	  this.func = mapFunction;
	  this.context = mapContext;
	  this.count = 0;
	}
	MapBookKeeping.prototype.destructor = function () {
	  this.result = null;
	  this.keyPrefix = null;
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);
	
	function mapSingleChildIntoContext(bookKeeping, child, childKey) {
	  var result = bookKeeping.result;
	  var keyPrefix = bookKeeping.keyPrefix;
	  var func = bookKeeping.func;
	  var context = bookKeeping.context;
	
	  var mappedChild = func.call(context, child, bookKeeping.count++);
	  if (Array.isArray(mappedChild)) {
	    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
	  } else if (mappedChild != null) {
	    if (ReactElement.isValidElement(mappedChild)) {
	      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
	      // Keep both the (mapped) and old keys if they differ, just as
	      // traverseAllChildren used to do for objects as children
	      keyPrefix + (mappedChild !== child ? escapeUserProvidedKey(mappedChild.key || '') + '/' : '') + childKey);
	    }
	    result.push(mappedChild);
	  }
	}
	
	function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
	  var escapedPrefix = '';
	  if (prefix != null) {
	    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
	  }
	  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
	  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
	  MapBookKeeping.release(traverseContext);
	}
	
	/**
	 * Maps children that are typically specified as `props.children`.
	 *
	 * The provided mapFunction(child, key, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func The map function.
	 * @param {*} context Context for mapFunction.
	 * @return {object} Object containing the ordered map of results.
	 */
	function mapChildren(children, func, context) {
	  if (children == null) {
	    return children;
	  }
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
	  return result;
	}
	
	function forEachSingleChildDummy(traverseContext, child, name) {
	  return null;
	}
	
	/**
	 * Count the number of children that are typically specified as
	 * `props.children`.
	 *
	 * @param {?*} children Children tree container.
	 * @return {number} The number of children.
	 */
	function countChildren(children, context) {
	  return traverseAllChildren(children, forEachSingleChildDummy, null);
	}
	
	/**
	 * Flatten a children object (typically specified as `props.children`) and
	 * return an array with appropriately re-keyed children.
	 */
	function toArray(children) {
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
	  return result;
	}
	
	var ReactChildren = {
	  forEach: forEachChildren,
	  map: mapChildren,
	  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
	  count: countChildren,
	  toArray: toArray
	};
	
	module.exports = ReactChildren;

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactClass
	 */
	
	'use strict';
	
	var ReactComponent = __webpack_require__(68);
	var ReactElement = __webpack_require__(6);
	var ReactPropTypeLocations = __webpack_require__(28);
	var ReactPropTypeLocationNames = __webpack_require__(27);
	var ReactNoopUpdateQueue = __webpack_require__(83);
	
	var assign = __webpack_require__(3);
	var emptyObject = __webpack_require__(20);
	var invariant = __webpack_require__(1);
	var keyMirror = __webpack_require__(25);
	var keyOf = __webpack_require__(13);
	var warning = __webpack_require__(2);
	
	var MIXINS_KEY = keyOf({ mixins: null });
	
	/**
	 * Policies that describe methods in `ReactClassInterface`.
	 */
	var SpecPolicy = keyMirror({
	  /**
	   * These methods may be defined only once by the class specification or mixin.
	   */
	  DEFINE_ONCE: null,
	  /**
	   * These methods may be defined by both the class specification and mixins.
	   * Subsequent definitions will be chained. These methods must return void.
	   */
	  DEFINE_MANY: null,
	  /**
	   * These methods are overriding the base class.
	   */
	  OVERRIDE_BASE: null,
	  /**
	   * These methods are similar to DEFINE_MANY, except we assume they return
	   * objects. We try to merge the keys of the return values of all the mixed in
	   * functions. If there is a key conflict we throw.
	   */
	  DEFINE_MANY_MERGED: null
	});
	
	var injectedMixins = [];
	
	var warnedSetProps = false;
	function warnSetProps() {
	  if (!warnedSetProps) {
	    warnedSetProps = true;
	     false ? warning(false, 'setProps(...) and replaceProps(...) are deprecated. ' + 'Instead, call render again at the top level.') : undefined;
	  }
	}
	
	/**
	 * Composite components are higher-level components that compose other composite
	 * or native components.
	 *
	 * To create a new type of `ReactClass`, pass a specification of
	 * your new class to `React.createClass`. The only requirement of your class
	 * specification is that you implement a `render` method.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return <div>Hello World</div>;
	 *     }
	 *   });
	 *
	 * The class specification supports a specific protocol of methods that have
	 * special meaning (e.g. `render`). See `ReactClassInterface` for
	 * more the comprehensive protocol. Any other properties and methods in the
	 * class specification will be available on the prototype.
	 *
	 * @interface ReactClassInterface
	 * @internal
	 */
	var ReactClassInterface = {
	
	  /**
	   * An array of Mixin objects to include when defining your component.
	   *
	   * @type {array}
	   * @optional
	   */
	  mixins: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * An object containing properties and methods that should be defined on
	   * the component's constructor instead of its prototype (static methods).
	   *
	   * @type {object}
	   * @optional
	   */
	  statics: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Definition of prop types for this component.
	   *
	   * @type {object}
	   * @optional
	   */
	  propTypes: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Definition of context types for this component.
	   *
	   * @type {object}
	   * @optional
	   */
	  contextTypes: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Definition of context types this component sets for its children.
	   *
	   * @type {object}
	   * @optional
	   */
	  childContextTypes: SpecPolicy.DEFINE_MANY,
	
	  // ==== Definition methods ====
	
	  /**
	   * Invoked when the component is mounted. Values in the mapping will be set on
	   * `this.props` if that prop is not specified (i.e. using an `in` check).
	   *
	   * This method is invoked before `getInitialState` and therefore cannot rely
	   * on `this.state` or use `this.setState`.
	   *
	   * @return {object}
	   * @optional
	   */
	  getDefaultProps: SpecPolicy.DEFINE_MANY_MERGED,
	
	  /**
	   * Invoked once before the component is mounted. The return value will be used
	   * as the initial value of `this.state`.
	   *
	   *   getInitialState: function() {
	   *     return {
	   *       isOn: false,
	   *       fooBaz: new BazFoo()
	   *     }
	   *   }
	   *
	   * @return {object}
	   * @optional
	   */
	  getInitialState: SpecPolicy.DEFINE_MANY_MERGED,
	
	  /**
	   * @return {object}
	   * @optional
	   */
	  getChildContext: SpecPolicy.DEFINE_MANY_MERGED,
	
	  /**
	   * Uses props from `this.props` and state from `this.state` to render the
	   * structure of the component.
	   *
	   * No guarantees are made about when or how often this method is invoked, so
	   * it must not have side effects.
	   *
	   *   render: function() {
	   *     var name = this.props.name;
	   *     return <div>Hello, {name}!</div>;
	   *   }
	   *
	   * @return {ReactComponent}
	   * @nosideeffects
	   * @required
	   */
	  render: SpecPolicy.DEFINE_ONCE,
	
	  // ==== Delegate methods ====
	
	  /**
	   * Invoked when the component is initially created and about to be mounted.
	   * This may have side effects, but any external subscriptions or data created
	   * by this method must be cleaned up in `componentWillUnmount`.
	   *
	   * @optional
	   */
	  componentWillMount: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked when the component has been mounted and has a DOM representation.
	   * However, there is no guarantee that the DOM node is in the document.
	   *
	   * Use this as an opportunity to operate on the DOM when the component has
	   * been mounted (initialized and rendered) for the first time.
	   *
	   * @param {DOMElement} rootNode DOM element representing the component.
	   * @optional
	   */
	  componentDidMount: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked before the component receives new props.
	   *
	   * Use this as an opportunity to react to a prop transition by updating the
	   * state using `this.setState`. Current props are accessed via `this.props`.
	   *
	   *   componentWillReceiveProps: function(nextProps, nextContext) {
	   *     this.setState({
	   *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	   *     });
	   *   }
	   *
	   * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	   * transition may cause a state change, but the opposite is not true. If you
	   * need it, you are probably looking for `componentWillUpdate`.
	   *
	   * @param {object} nextProps
	   * @optional
	   */
	  componentWillReceiveProps: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked while deciding if the component should be updated as a result of
	   * receiving new props, state and/or context.
	   *
	   * Use this as an opportunity to `return false` when you're certain that the
	   * transition to the new props/state/context will not require a component
	   * update.
	   *
	   *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	   *     return !equal(nextProps, this.props) ||
	   *       !equal(nextState, this.state) ||
	   *       !equal(nextContext, this.context);
	   *   }
	   *
	   * @param {object} nextProps
	   * @param {?object} nextState
	   * @param {?object} nextContext
	   * @return {boolean} True if the component should update.
	   * @optional
	   */
	  shouldComponentUpdate: SpecPolicy.DEFINE_ONCE,
	
	  /**
	   * Invoked when the component is about to update due to a transition from
	   * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	   * and `nextContext`.
	   *
	   * Use this as an opportunity to perform preparation before an update occurs.
	   *
	   * NOTE: You **cannot** use `this.setState()` in this method.
	   *
	   * @param {object} nextProps
	   * @param {?object} nextState
	   * @param {?object} nextContext
	   * @param {ReactReconcileTransaction} transaction
	   * @optional
	   */
	  componentWillUpdate: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked when the component's DOM representation has been updated.
	   *
	   * Use this as an opportunity to operate on the DOM when the component has
	   * been updated.
	   *
	   * @param {object} prevProps
	   * @param {?object} prevState
	   * @param {?object} prevContext
	   * @param {DOMElement} rootNode DOM element representing the component.
	   * @optional
	   */
	  componentDidUpdate: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked when the component is about to be removed from its parent and have
	   * its DOM representation destroyed.
	   *
	   * Use this as an opportunity to deallocate any external resources.
	   *
	   * NOTE: There is no `componentDidUnmount` since your component will have been
	   * destroyed by that point.
	   *
	   * @optional
	   */
	  componentWillUnmount: SpecPolicy.DEFINE_MANY,
	
	  // ==== Advanced methods ====
	
	  /**
	   * Updates the component's currently mounted DOM representation.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   * @overridable
	   */
	  updateComponent: SpecPolicy.OVERRIDE_BASE
	
	};
	
	/**
	 * Mapping from class specification keys to special processing functions.
	 *
	 * Although these are declared like instance properties in the specification
	 * when defining classes using `React.createClass`, they are actually static
	 * and are accessible on the constructor instead of the prototype. Despite
	 * being static, they must be defined outside of the "statics" key under
	 * which all other static methods are defined.
	 */
	var RESERVED_SPEC_KEYS = {
	  displayName: function (Constructor, displayName) {
	    Constructor.displayName = displayName;
	  },
	  mixins: function (Constructor, mixins) {
	    if (mixins) {
	      for (var i = 0; i < mixins.length; i++) {
	        mixSpecIntoComponent(Constructor, mixins[i]);
	      }
	    }
	  },
	  childContextTypes: function (Constructor, childContextTypes) {
	    if (false) {
	      validateTypeDef(Constructor, childContextTypes, ReactPropTypeLocations.childContext);
	    }
	    Constructor.childContextTypes = assign({}, Constructor.childContextTypes, childContextTypes);
	  },
	  contextTypes: function (Constructor, contextTypes) {
	    if (false) {
	      validateTypeDef(Constructor, contextTypes, ReactPropTypeLocations.context);
	    }
	    Constructor.contextTypes = assign({}, Constructor.contextTypes, contextTypes);
	  },
	  /**
	   * Special case getDefaultProps which should move into statics but requires
	   * automatic merging.
	   */
	  getDefaultProps: function (Constructor, getDefaultProps) {
	    if (Constructor.getDefaultProps) {
	      Constructor.getDefaultProps = createMergedResultFunction(Constructor.getDefaultProps, getDefaultProps);
	    } else {
	      Constructor.getDefaultProps = getDefaultProps;
	    }
	  },
	  propTypes: function (Constructor, propTypes) {
	    if (false) {
	      validateTypeDef(Constructor, propTypes, ReactPropTypeLocations.prop);
	    }
	    Constructor.propTypes = assign({}, Constructor.propTypes, propTypes);
	  },
	  statics: function (Constructor, statics) {
	    mixStaticSpecIntoComponent(Constructor, statics);
	  },
	  autobind: function () {} };
	
	// noop
	function validateTypeDef(Constructor, typeDef, location) {
	  for (var propName in typeDef) {
	    if (typeDef.hasOwnProperty(propName)) {
	      // use a warning instead of an invariant so components
	      // don't show up in prod but not in __DEV__
	       false ? warning(typeof typeDef[propName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', Constructor.displayName || 'ReactClass', ReactPropTypeLocationNames[location], propName) : undefined;
	    }
	  }
	}
	
	function validateMethodOverride(proto, name) {
	  var specPolicy = ReactClassInterface.hasOwnProperty(name) ? ReactClassInterface[name] : null;
	
	  // Disallow overriding of base class methods unless explicitly allowed.
	  if (ReactClassMixin.hasOwnProperty(name)) {
	    !(specPolicy === SpecPolicy.OVERRIDE_BASE) ?  false ? invariant(false, 'ReactClassInterface: You are attempting to override ' + '`%s` from your class specification. Ensure that your method names ' + 'do not overlap with React methods.', name) : invariant(false) : undefined;
	  }
	
	  // Disallow defining methods more than once unless explicitly allowed.
	  if (proto.hasOwnProperty(name)) {
	    !(specPolicy === SpecPolicy.DEFINE_MANY || specPolicy === SpecPolicy.DEFINE_MANY_MERGED) ?  false ? invariant(false, 'ReactClassInterface: You are attempting to define ' + '`%s` on your component more than once. This conflict may be due ' + 'to a mixin.', name) : invariant(false) : undefined;
	  }
	}
	
	/**
	 * Mixin helper which handles policy validation and reserved
	 * specification keys when building React classses.
	 */
	function mixSpecIntoComponent(Constructor, spec) {
	  if (!spec) {
	    return;
	  }
	
	  !(typeof spec !== 'function') ?  false ? invariant(false, 'ReactClass: You\'re attempting to ' + 'use a component class as a mixin. Instead, just use a regular object.') : invariant(false) : undefined;
	  !!ReactElement.isValidElement(spec) ?  false ? invariant(false, 'ReactClass: You\'re attempting to ' + 'use a component as a mixin. Instead, just use a regular object.') : invariant(false) : undefined;
	
	  var proto = Constructor.prototype;
	
	  // By handling mixins before any other properties, we ensure the same
	  // chaining order is applied to methods with DEFINE_MANY policy, whether
	  // mixins are listed before or after these methods in the spec.
	  if (spec.hasOwnProperty(MIXINS_KEY)) {
	    RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	  }
	
	  for (var name in spec) {
	    if (!spec.hasOwnProperty(name)) {
	      continue;
	    }
	
	    if (name === MIXINS_KEY) {
	      // We have already handled mixins in a special case above.
	      continue;
	    }
	
	    var property = spec[name];
	    validateMethodOverride(proto, name);
	
	    if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	      RESERVED_SPEC_KEYS[name](Constructor, property);
	    } else {
	      // Setup methods on prototype:
	      // The following member methods should not be automatically bound:
	      // 1. Expected ReactClass methods (in the "interface").
	      // 2. Overridden methods (that were mixed in).
	      var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	      var isAlreadyDefined = proto.hasOwnProperty(name);
	      var isFunction = typeof property === 'function';
	      var shouldAutoBind = isFunction && !isReactClassMethod && !isAlreadyDefined && spec.autobind !== false;
	
	      if (shouldAutoBind) {
	        if (!proto.__reactAutoBindMap) {
	          proto.__reactAutoBindMap = {};
	        }
	        proto.__reactAutoBindMap[name] = property;
	        proto[name] = property;
	      } else {
	        if (isAlreadyDefined) {
	          var specPolicy = ReactClassInterface[name];
	
	          // These cases should already be caught by validateMethodOverride.
	          !(isReactClassMethod && (specPolicy === SpecPolicy.DEFINE_MANY_MERGED || specPolicy === SpecPolicy.DEFINE_MANY)) ?  false ? invariant(false, 'ReactClass: Unexpected spec policy %s for key %s ' + 'when mixing in component specs.', specPolicy, name) : invariant(false) : undefined;
	
	          // For methods which are defined more than once, call the existing
	          // methods before calling the new property, merging if appropriate.
	          if (specPolicy === SpecPolicy.DEFINE_MANY_MERGED) {
	            proto[name] = createMergedResultFunction(proto[name], property);
	          } else if (specPolicy === SpecPolicy.DEFINE_MANY) {
	            proto[name] = createChainedFunction(proto[name], property);
	          }
	        } else {
	          proto[name] = property;
	          if (false) {
	            // Add verbose displayName to the function, which helps when looking
	            // at profiling tools.
	            if (typeof property === 'function' && spec.displayName) {
	              proto[name].displayName = spec.displayName + '_' + name;
	            }
	          }
	        }
	      }
	    }
	  }
	}
	
	function mixStaticSpecIntoComponent(Constructor, statics) {
	  if (!statics) {
	    return;
	  }
	  for (var name in statics) {
	    var property = statics[name];
	    if (!statics.hasOwnProperty(name)) {
	      continue;
	    }
	
	    var isReserved = (name in RESERVED_SPEC_KEYS);
	    !!isReserved ?  false ? invariant(false, 'ReactClass: You are attempting to define a reserved ' + 'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' + 'as an instance property instead; it will still be accessible on the ' + 'constructor.', name) : invariant(false) : undefined;
	
	    var isInherited = (name in Constructor);
	    !!isInherited ?  false ? invariant(false, 'ReactClass: You are attempting to define ' + '`%s` on your component more than once. This conflict may be ' + 'due to a mixin.', name) : invariant(false) : undefined;
	    Constructor[name] = property;
	  }
	}
	
	/**
	 * Merge two objects, but throw if both contain the same key.
	 *
	 * @param {object} one The first object, which is mutated.
	 * @param {object} two The second object
	 * @return {object} one after it has been mutated to contain everything in two.
	 */
	function mergeIntoWithNoDuplicateKeys(one, two) {
	  !(one && two && typeof one === 'object' && typeof two === 'object') ?  false ? invariant(false, 'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.') : invariant(false) : undefined;
	
	  for (var key in two) {
	    if (two.hasOwnProperty(key)) {
	      !(one[key] === undefined) ?  false ? invariant(false, 'mergeIntoWithNoDuplicateKeys(): ' + 'Tried to merge two objects with the same key: `%s`. This conflict ' + 'may be due to a mixin; in particular, this may be caused by two ' + 'getInitialState() or getDefaultProps() methods returning objects ' + 'with clashing keys.', key) : invariant(false) : undefined;
	      one[key] = two[key];
	    }
	  }
	  return one;
	}
	
	/**
	 * Creates a function that invokes two functions and merges their return values.
	 *
	 * @param {function} one Function to invoke first.
	 * @param {function} two Function to invoke second.
	 * @return {function} Function that invokes the two argument functions.
	 * @private
	 */
	function createMergedResultFunction(one, two) {
	  return function mergedResult() {
	    var a = one.apply(this, arguments);
	    var b = two.apply(this, arguments);
	    if (a == null) {
	      return b;
	    } else if (b == null) {
	      return a;
	    }
	    var c = {};
	    mergeIntoWithNoDuplicateKeys(c, a);
	    mergeIntoWithNoDuplicateKeys(c, b);
	    return c;
	  };
	}
	
	/**
	 * Creates a function that invokes two functions and ignores their return vales.
	 *
	 * @param {function} one Function to invoke first.
	 * @param {function} two Function to invoke second.
	 * @return {function} Function that invokes the two argument functions.
	 * @private
	 */
	function createChainedFunction(one, two) {
	  return function chainedFunction() {
	    one.apply(this, arguments);
	    two.apply(this, arguments);
	  };
	}
	
	/**
	 * Binds a method to the component.
	 *
	 * @param {object} component Component whose method is going to be bound.
	 * @param {function} method Method to be bound.
	 * @return {function} The bound method.
	 */
	function bindAutoBindMethod(component, method) {
	  var boundMethod = method.bind(component);
	  if (false) {
	    boundMethod.__reactBoundContext = component;
	    boundMethod.__reactBoundMethod = method;
	    boundMethod.__reactBoundArguments = null;
	    var componentName = component.constructor.displayName;
	    var _bind = boundMethod.bind;
	    /* eslint-disable block-scoped-var, no-undef */
	    boundMethod.bind = function (newThis) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      // User is trying to bind() an autobound method; we effectively will
	      // ignore the value of "this" that the user is trying to use, so
	      // let's warn.
	      if (newThis !== component && newThis !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): React component methods may only be bound to the ' + 'component instance. See %s', componentName) : undefined;
	      } else if (!args.length) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): You are binding a component method to the component. ' + 'React does this for you automatically in a high-performance ' + 'way, so you can safely remove this call. See %s', componentName) : undefined;
	        return boundMethod;
	      }
	      var reboundMethod = _bind.apply(boundMethod, arguments);
	      reboundMethod.__reactBoundContext = component;
	      reboundMethod.__reactBoundMethod = method;
	      reboundMethod.__reactBoundArguments = args;
	      return reboundMethod;
	      /* eslint-enable */
	    };
	  }
	  return boundMethod;
	}
	
	/**
	 * Binds all auto-bound methods in a component.
	 *
	 * @param {object} component Component whose method is going to be bound.
	 */
	function bindAutoBindMethods(component) {
	  for (var autoBindKey in component.__reactAutoBindMap) {
	    if (component.__reactAutoBindMap.hasOwnProperty(autoBindKey)) {
	      var method = component.__reactAutoBindMap[autoBindKey];
	      component[autoBindKey] = bindAutoBindMethod(component, method);
	    }
	  }
	}
	
	/**
	 * Add more to the ReactClass base class. These are all legacy features and
	 * therefore not already part of the modern ReactComponent.
	 */
	var ReactClassMixin = {
	
	  /**
	   * TODO: This will be deprecated because state should always keep a consistent
	   * type signature and the only use case for this, is to avoid that.
	   */
	  replaceState: function (newState, callback) {
	    this.updater.enqueueReplaceState(this, newState);
	    if (callback) {
	      this.updater.enqueueCallback(this, callback);
	    }
	  },
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function () {
	    return this.updater.isMounted(this);
	  },
	
	  /**
	   * Sets a subset of the props.
	   *
	   * @param {object} partialProps Subset of the next props.
	   * @param {?function} callback Called after props are updated.
	   * @final
	   * @public
	   * @deprecated
	   */
	  setProps: function (partialProps, callback) {
	    if (false) {
	      warnSetProps();
	    }
	    this.updater.enqueueSetProps(this, partialProps);
	    if (callback) {
	      this.updater.enqueueCallback(this, callback);
	    }
	  },
	
	  /**
	   * Replace all the props.
	   *
	   * @param {object} newProps Subset of the next props.
	   * @param {?function} callback Called after props are updated.
	   * @final
	   * @public
	   * @deprecated
	   */
	  replaceProps: function (newProps, callback) {
	    if (false) {
	      warnSetProps();
	    }
	    this.updater.enqueueReplaceProps(this, newProps);
	    if (callback) {
	      this.updater.enqueueCallback(this, callback);
	    }
	  }
	};
	
	var ReactClassComponent = function () {};
	assign(ReactClassComponent.prototype, ReactComponent.prototype, ReactClassMixin);
	
	/**
	 * Module for creating composite components.
	 *
	 * @class ReactClass
	 */
	var ReactClass = {
	
	  /**
	   * Creates a composite component class given a class specification.
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  createClass: function (spec) {
	    var Constructor = function (props, context, updater) {
	      // This constructor is overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(this instanceof Constructor, 'Something is calling a React component directly. Use a factory or ' + 'JSX instead. See: https://fb.me/react-legacyfactory') : undefined;
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindMap) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (typeof initialState === 'undefined' && this.getInitialState._isMockFunction) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.getInitialState(): must return an object or null', Constructor.displayName || 'ReactCompositeComponent') : invariant(false) : undefined;
	
	      this.state = initialState;
	    };
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, spec);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    !Constructor.prototype.render ?  false ? invariant(false, 'createClass(...): Class specification must implement a `render` method.') : invariant(false) : undefined;
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentShouldUpdate, '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', spec.displayName || 'A component') : undefined;
	      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentWillRecieveProps, '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', spec.displayName || 'A component') : undefined;
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  },
	
	  injection: {
	    injectMixin: function (mixin) {
	      injectedMixins.push(mixin);
	    }
	  }
	
	};
	
	module.exports = ReactClass;

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactComponent
	 */
	
	'use strict';
	
	var ReactNoopUpdateQueue = __webpack_require__(83);
	
	var canDefineProperty = __webpack_require__(31);
	var emptyObject = __webpack_require__(20);
	var invariant = __webpack_require__(1);
	var warning = __webpack_require__(2);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactComponent(props, context, updater) {
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	ReactComponent.prototype.isReactComponent = {};
	
	/**
	 * Sets a subset of the state. Always use this to mutate
	 * state. You should treat `this.state` as immutable.
	 *
	 * There is no guarantee that `this.state` will be immediately updated, so
	 * accessing `this.state` after calling this method may return the old value.
	 *
	 * There is no guarantee that calls to `setState` will run synchronously,
	 * as they may eventually be batched together.  You can provide an optional
	 * callback that will be executed when the call to setState is actually
	 * completed.
	 *
	 * When a function is provided to setState, it will be called at some point in
	 * the future (not synchronously). It will be called with the up to date
	 * component arguments (state, props, context). These values can be different
	 * from this.* because your function may be called after receiveProps but before
	 * shouldComponentUpdate, and this new state, props, and context will not yet be
	 * assigned to this.
	 *
	 * @param {object|function} partialState Next partial state or function to
	 *        produce next partial state to be merged with current state.
	 * @param {?function} callback Called after state is updated.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.setState = function (partialState, callback) {
	  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a ' + 'function which returns an object of state variables.') : invariant(false) : undefined;
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : undefined;
	  }
	  this.updater.enqueueSetState(this, partialState);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback);
	  }
	};
	
	/**
	 * Forces an update. This should only be invoked when it is known with
	 * certainty that we are **not** in a DOM transaction.
	 *
	 * You may want to call this when you know that some deeper aspect of the
	 * component's state has changed but `setState` was not called.
	 *
	 * This will not invoke `shouldComponentUpdate`, but it will invoke
	 * `componentWillUpdate` and `componentDidUpdate`.
	 *
	 * @param {?function} callback Called after update is complete.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.forceUpdate = function (callback) {
	  this.updater.enqueueForceUpdate(this);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback);
	  }
	};
	
	/**
	 * Deprecated APIs. These APIs used to exist on classic React classes but since
	 * we would like to deprecate them, we're not going to move them over to this
	 * modern base class. Instead, we define a getter that warns if it's accessed.
	 */
	if (false) {
	  var deprecatedAPIs = {
	    getDOMNode: ['getDOMNode', 'Use ReactDOM.findDOMNode(component) instead.'],
	    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
	    replaceProps: ['replaceProps', 'Instead, call render again at the top level.'],
	    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).'],
	    setProps: ['setProps', 'Instead, call render again at the top level.']
	  };
	  var defineDeprecationWarning = function (methodName, info) {
	    if (canDefineProperty) {
	      Object.defineProperty(ReactComponent.prototype, methodName, {
	        get: function () {
	          process.env.NODE_ENV !== 'production' ? warning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]) : undefined;
	          return undefined;
	        }
	      });
	    }
	  };
	  for (var fnName in deprecatedAPIs) {
	    if (deprecatedAPIs.hasOwnProperty(fnName)) {
	      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
	    }
	  }
	}
	
	module.exports = ReactComponent;

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOM
	 */
	
	/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/
	
	'use strict';
	
	var ReactCurrentOwner = __webpack_require__(12);
	var ReactDOMTextComponent = __webpack_require__(72);
	var ReactDefaultInjection = __webpack_require__(74);
	var ReactInstanceHandles = __webpack_require__(19);
	var ReactMount = __webpack_require__(5);
	var ReactPerf = __webpack_require__(7);
	var ReactReconciler = __webpack_require__(15);
	var ReactUpdates = __webpack_require__(8);
	var ReactVersion = __webpack_require__(42);
	
	var findDOMNode = __webpack_require__(43);
	var renderSubtreeIntoContainer = __webpack_require__(181);
	var warning = __webpack_require__(2);
	
	ReactDefaultInjection.inject();
	
	var render = ReactPerf.measure('React', 'render', ReactMount.render);
	
	var React = {
	  findDOMNode: findDOMNode,
	  render: render,
	  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
	  version: ReactVersion,
	
	  /* eslint-disable camelcase */
	  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
	  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
	};
	
	// Inject the runtime into a devtools global hook regardless of browser.
	// Allows for debugging when the hook is injected on the page.
	/* eslint-enable camelcase */
	if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
	  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
	    CurrentOwner: ReactCurrentOwner,
	    InstanceHandles: ReactInstanceHandles,
	    Mount: ReactMount,
	    Reconciler: ReactReconciler,
	    TextComponent: ReactDOMTextComponent
	  });
	}
	
	if (false) {
	  var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
	  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {
	
	    // First check if devtools is not installed
	    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
	      // If we're in Chrome or Firefox, provide a download link if not installed.
	      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
	        console.debug('Download the React DevTools for a better development experience: ' + 'https://fb.me/react-devtools');
	      }
	    }
	
	    // If we're in IE8, check to see if we are in compatibility mode and provide
	    // information on preventing compatibility mode
	    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;
	
	    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : undefined;
	
	    var expectedFeatures = [
	    // shims
	    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.split, String.prototype.trim,
	
	    // shams
	    Object.create, Object.freeze];
	
	    for (var i = 0; i < expectedFeatures.length; i++) {
	      if (!expectedFeatures[i]) {
	        console.error('One or more ES5 shim/shams expected by React are not available: ' + 'https://fb.me/react-warning-polyfills');
	        break;
	      }
	    }
	  }
	}
	
	module.exports = React;

/***/ }),
/* 70 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMFeatureFlags
	 */
	
	'use strict';
	
	var ReactDOMFeatureFlags = {
	  useCreateElement: false
	};
	
	module.exports = ReactDOMFeatureFlags;

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMSelect
	 */
	
	'use strict';
	
	var LinkedValueUtils = __webpack_require__(37);
	var ReactMount = __webpack_require__(5);
	var ReactUpdates = __webpack_require__(8);
	
	var assign = __webpack_require__(3);
	var warning = __webpack_require__(2);
	
	var valueContextKey = '__ReactDOMSelect_value$' + Math.random().toString(36).slice(2);
	
	function updateOptionsIfPendingUpdateAndMounted() {
	  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
	    this._wrapperState.pendingUpdate = false;
	
	    var props = this._currentElement.props;
	    var value = LinkedValueUtils.getValue(props);
	
	    if (value != null) {
	      updateOptions(this, Boolean(props.multiple), value);
	    }
	  }
	}
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	var valuePropNames = ['value', 'defaultValue'];
	
	/**
	 * Validation function for `value` and `defaultValue`.
	 * @private
	 */
	function checkSelectPropTypes(inst, props) {
	  var owner = inst._currentElement._owner;
	  LinkedValueUtils.checkPropTypes('select', props, owner);
	
	  for (var i = 0; i < valuePropNames.length; i++) {
	    var propName = valuePropNames[i];
	    if (props[propName] == null) {
	      continue;
	    }
	    if (props.multiple) {
	       false ? warning(Array.isArray(props[propName]), 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : undefined;
	    } else {
	       false ? warning(!Array.isArray(props[propName]), 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : undefined;
	    }
	  }
	}
	
	/**
	 * @param {ReactDOMComponent} inst
	 * @param {boolean} multiple
	 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
	 * @private
	 */
	function updateOptions(inst, multiple, propValue) {
	  var selectedValue, i;
	  var options = ReactMount.getNode(inst._rootNodeID).options;
	
	  if (multiple) {
	    selectedValue = {};
	    for (i = 0; i < propValue.length; i++) {
	      selectedValue['' + propValue[i]] = true;
	    }
	    for (i = 0; i < options.length; i++) {
	      var selected = selectedValue.hasOwnProperty(options[i].value);
	      if (options[i].selected !== selected) {
	        options[i].selected = selected;
	      }
	    }
	  } else {
	    // Do not set `select.value` as exact behavior isn't consistent across all
	    // browsers for all cases.
	    selectedValue = '' + propValue;
	    for (i = 0; i < options.length; i++) {
	      if (options[i].value === selectedValue) {
	        options[i].selected = true;
	        return;
	      }
	    }
	    if (options.length) {
	      options[0].selected = true;
	    }
	  }
	}
	
	/**
	 * Implements a <select> native component that allows optionally setting the
	 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
	 * stringable. If `multiple` is true, the prop must be an array of stringables.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that change the
	 * selected option will trigger updates to the rendered options.
	 *
	 * If it is supplied (and not null/undefined), the rendered options will not
	 * update in response to user actions. Instead, the `value` prop must change in
	 * order for the rendered options to update.
	 *
	 * If `defaultValue` is provided, any options with the supplied values will be
	 * selected.
	 */
	var ReactDOMSelect = {
	  valueContextKey: valueContextKey,
	
	  getNativeProps: function (inst, props, context) {
	    return assign({}, props, {
	      onChange: inst._wrapperState.onChange,
	      value: undefined
	    });
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      checkSelectPropTypes(inst, props);
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    inst._wrapperState = {
	      pendingUpdate: false,
	      initialValue: value != null ? value : props.defaultValue,
	      onChange: _handleChange.bind(inst),
	      wasMultiple: Boolean(props.multiple)
	    };
	  },
	
	  processChildContext: function (inst, props, context) {
	    // Pass down initial value so initial generated markup has correct
	    // `selected` attributes
	    var childContext = assign({}, context);
	    childContext[valueContextKey] = inst._wrapperState.initialValue;
	    return childContext;
	  },
	
	  postUpdateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // After the initial mount, we control selected-ness manually so don't pass
	    // the context value down
	    inst._wrapperState.initialValue = undefined;
	
	    var wasMultiple = inst._wrapperState.wasMultiple;
	    inst._wrapperState.wasMultiple = Boolean(props.multiple);
	
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      inst._wrapperState.pendingUpdate = false;
	      updateOptions(inst, Boolean(props.multiple), value);
	    } else if (wasMultiple !== Boolean(props.multiple)) {
	      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
	      if (props.defaultValue != null) {
	        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
	      } else {
	        // Revert the select back to its default unselected state.
	        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
	      }
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  this._wrapperState.pendingUpdate = true;
	  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMSelect;

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMTextComponent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(64);
	var DOMPropertyOperations = __webpack_require__(36);
	var ReactComponentBrowserEnvironment = __webpack_require__(38);
	var ReactMount = __webpack_require__(5);
	
	var assign = __webpack_require__(3);
	var escapeTextContentForBrowser = __webpack_require__(32);
	var setTextContent = __webpack_require__(50);
	var validateDOMNesting = __webpack_require__(53);
	
	/**
	 * Text nodes violate a couple assumptions that React makes about components:
	 *
	 *  - When mounting text into the DOM, adjacent text nodes are merged.
	 *  - Text nodes cannot be assigned a React root ID.
	 *
	 * This component is used to wrap strings in elements so that they can undergo
	 * the same reconciliation that is applied to elements.
	 *
	 * TODO: Investigate representing React components in the DOM with text nodes.
	 *
	 * @class ReactDOMTextComponent
	 * @extends ReactComponent
	 * @internal
	 */
	var ReactDOMTextComponent = function (props) {
	  // This constructor and its argument is currently used by mocks.
	};
	
	assign(ReactDOMTextComponent.prototype, {
	
	  /**
	   * @param {ReactText} text
	   * @internal
	   */
	  construct: function (text) {
	    // TODO: This is really a ReactText (ReactNode), not a ReactElement
	    this._currentElement = text;
	    this._stringText = '' + text;
	
	    // Properties
	    this._rootNodeID = null;
	    this._mountIndex = 0;
	  },
	
	  /**
	   * Creates the markup for this text node. This node is not intended to have
	   * any features besides containing text content.
	   *
	   * @param {string} rootID DOM ID of the root node.
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {string} Markup for this text node.
	   * @internal
	   */
	  mountComponent: function (rootID, transaction, context) {
	    if (false) {
	      if (context[validateDOMNesting.ancestorInfoContextKey]) {
	        validateDOMNesting('span', null, context[validateDOMNesting.ancestorInfoContextKey]);
	      }
	    }
	
	    this._rootNodeID = rootID;
	    if (transaction.useCreateElement) {
	      var ownerDocument = context[ReactMount.ownerDocumentContextKey];
	      var el = ownerDocument.createElement('span');
	      DOMPropertyOperations.setAttributeForID(el, rootID);
	      // Populate node cache
	      ReactMount.getID(el);
	      setTextContent(el, this._stringText);
	      return el;
	    } else {
	      var escapedText = escapeTextContentForBrowser(this._stringText);
	
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd wrap this in a `span` for the reasons stated above, but
	        // since this is a situation where React won't take over (static pages),
	        // we can simply return the text as it is.
	        return escapedText;
	      }
	
	      return '<span ' + DOMPropertyOperations.createMarkupForID(rootID) + '>' + escapedText + '</span>';
	    }
	  },
	
	  /**
	   * Updates this component by updating the text content.
	   *
	   * @param {ReactText} nextText The next text content
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  receiveComponent: function (nextText, transaction) {
	    if (nextText !== this._currentElement) {
	      this._currentElement = nextText;
	      var nextStringText = '' + nextText;
	      if (nextStringText !== this._stringText) {
	        // TODO: Save this as pending props and use performUpdateIfNecessary
	        // and/or updateComponent to do the actual update for consistency with
	        // other component types?
	        this._stringText = nextStringText;
	        var node = ReactMount.getNode(this._rootNodeID);
	        DOMChildrenOperations.updateTextContent(node, nextStringText);
	      }
	    }
	  },
	
	  unmountComponent: function () {
	    ReactComponentBrowserEnvironment.unmountIDFromEnvironment(this._rootNodeID);
	  }
	
	});
	
	module.exports = ReactDOMTextComponent;

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDefaultBatchingStrategy
	 */
	
	'use strict';
	
	var ReactUpdates = __webpack_require__(8);
	var Transaction = __webpack_require__(30);
	
	var assign = __webpack_require__(3);
	var emptyFunction = __webpack_require__(9);
	
	var RESET_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: function () {
	    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
	  }
	};
	
	var FLUSH_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
	};
	
	var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];
	
	function ReactDefaultBatchingStrategyTransaction() {
	  this.reinitializeTransaction();
	}
	
	assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction.Mixin, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  }
	});
	
	var transaction = new ReactDefaultBatchingStrategyTransaction();
	
	var ReactDefaultBatchingStrategy = {
	  isBatchingUpdates: false,
	
	  /**
	   * Call the provided function in a context within which calls to `setState`
	   * and friends are batched such that components aren't updated unnecessarily.
	   */
	  batchedUpdates: function (callback, a, b, c, d, e) {
	    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;
	
	    ReactDefaultBatchingStrategy.isBatchingUpdates = true;
	
	    // The code is written this way to avoid extra allocations
	    if (alreadyBatchingUpdates) {
	      callback(a, b, c, d, e);
	    } else {
	      transaction.perform(callback, null, a, b, c, d, e);
	    }
	  }
	};
	
	module.exports = ReactDefaultBatchingStrategy;

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDefaultInjection
	 */
	
	'use strict';
	
	var BeforeInputEventPlugin = __webpack_require__(128);
	var ChangeEventPlugin = __webpack_require__(130);
	var ClientReactRootIndex = __webpack_require__(131);
	var DefaultEventPluginOrder = __webpack_require__(133);
	var EnterLeaveEventPlugin = __webpack_require__(134);
	var ExecutionEnvironment = __webpack_require__(4);
	var HTMLDOMPropertyConfig = __webpack_require__(137);
	var ReactBrowserComponentMixin = __webpack_require__(139);
	var ReactComponentBrowserEnvironment = __webpack_require__(38);
	var ReactDefaultBatchingStrategy = __webpack_require__(73);
	var ReactDOMComponent = __webpack_require__(143);
	var ReactDOMTextComponent = __webpack_require__(72);
	var ReactEventListener = __webpack_require__(151);
	var ReactInjection = __webpack_require__(152);
	var ReactInstanceHandles = __webpack_require__(19);
	var ReactMount = __webpack_require__(5);
	var ReactReconcileTransaction = __webpack_require__(156);
	var SelectEventPlugin = __webpack_require__(162);
	var ServerReactRootIndex = __webpack_require__(163);
	var SimpleEventPlugin = __webpack_require__(164);
	var SVGDOMPropertyConfig = __webpack_require__(161);
	
	var alreadyInjected = false;
	
	function inject() {
	  if (alreadyInjected) {
	    // TODO: This is currently true because these injections are shared between
	    // the client and the server package. They should be built independently
	    // and not share any injection state. Then this problem will be solved.
	    return;
	  }
	  alreadyInjected = true;
	
	  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);
	
	  /**
	   * Inject modules for resolving DOM hierarchy and plugin ordering.
	   */
	  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
	  ReactInjection.EventPluginHub.injectInstanceHandle(ReactInstanceHandles);
	  ReactInjection.EventPluginHub.injectMount(ReactMount);
	
	  /**
	   * Some important event plugins included by default (without having to require
	   * them).
	   */
	  ReactInjection.EventPluginHub.injectEventPluginsByName({
	    SimpleEventPlugin: SimpleEventPlugin,
	    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
	    ChangeEventPlugin: ChangeEventPlugin,
	    SelectEventPlugin: SelectEventPlugin,
	    BeforeInputEventPlugin: BeforeInputEventPlugin
	  });
	
	  ReactInjection.NativeComponent.injectGenericComponentClass(ReactDOMComponent);
	
	  ReactInjection.NativeComponent.injectTextComponentClass(ReactDOMTextComponent);
	
	  ReactInjection.Class.injectMixin(ReactBrowserComponentMixin);
	
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);
	
	  ReactInjection.EmptyComponent.injectEmptyComponent('noscript');
	
	  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
	  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	
	  ReactInjection.RootIndex.injectCreateReactRootIndex(ExecutionEnvironment.canUseDOM ? ClientReactRootIndex.createReactRootIndex : ServerReactRootIndex.createReactRootIndex);
	
	  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
	
	  if (false) {
	    var url = ExecutionEnvironment.canUseDOM && window.location.href || '';
	    if (/[?&]react_perf\b/.test(url)) {
	      var ReactDefaultPerf = require('./ReactDefaultPerf');
	      ReactDefaultPerf.start();
	    }
	  }
	}
	
	module.exports = {
	  inject: inject
	};

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactElementValidator
	 */
	
	/**
	 * ReactElementValidator provides a wrapper around a element factory
	 * which validates the props passed to the element. This is intended to be
	 * used only in DEV and could be replaced by a static type checker for languages
	 * that support it.
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(6);
	var ReactPropTypeLocations = __webpack_require__(28);
	var ReactPropTypeLocationNames = __webpack_require__(27);
	var ReactCurrentOwner = __webpack_require__(12);
	
	var canDefineProperty = __webpack_require__(31);
	var getIteratorFn = __webpack_require__(47);
	var invariant = __webpack_require__(1);
	var warning = __webpack_require__(2);
	
	function getDeclarationErrorAddendum() {
	  if (ReactCurrentOwner.current) {
	    var name = ReactCurrentOwner.current.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Warn if there's no key explicitly set on dynamic arrays of children or
	 * object keys are not valid. This allows us to keep track of children between
	 * updates.
	 */
	var ownerHasKeyUseWarning = {};
	
	var loggedTypeFailures = {};
	
	/**
	 * Warn if the element doesn't have an explicit key assigned to it.
	 * This element is in an array. The array could grow and shrink or be
	 * reordered. All children that haven't already been validated are required to
	 * have a "key" property assigned to it.
	 *
	 * @internal
	 * @param {ReactElement} element Element that requires a key.
	 * @param {*} parentType element's parent's type.
	 */
	function validateExplicitKey(element, parentType) {
	  if (!element._store || element._store.validated || element.key != null) {
	    return;
	  }
	  element._store.validated = true;
	
	  var addenda = getAddendaForKeyUse('uniqueKey', element, parentType);
	  if (addenda === null) {
	    // we already showed the warning
	    return;
	  }
	   false ? warning(false, 'Each child in an array or iterator should have a unique "key" prop.' + '%s%s%s', addenda.parentOrOwner || '', addenda.childOwner || '', addenda.url || '') : undefined;
	}
	
	/**
	 * Shared warning and monitoring code for the key warnings.
	 *
	 * @internal
	 * @param {string} messageType A key used for de-duping warnings.
	 * @param {ReactElement} element Component that requires a key.
	 * @param {*} parentType element's parent's type.
	 * @returns {?object} A set of addenda to use in the warning message, or null
	 * if the warning has already been shown before (and shouldn't be shown again).
	 */
	function getAddendaForKeyUse(messageType, element, parentType) {
	  var addendum = getDeclarationErrorAddendum();
	  if (!addendum) {
	    var parentName = typeof parentType === 'string' ? parentType : parentType.displayName || parentType.name;
	    if (parentName) {
	      addendum = ' Check the top-level render call using <' + parentName + '>.';
	    }
	  }
	
	  var memoizer = ownerHasKeyUseWarning[messageType] || (ownerHasKeyUseWarning[messageType] = {});
	  if (memoizer[addendum]) {
	    return null;
	  }
	  memoizer[addendum] = true;
	
	  var addenda = {
	    parentOrOwner: addendum,
	    url: ' See https://fb.me/react-warning-keys for more information.',
	    childOwner: null
	  };
	
	  // Usually the current owner is the offender, but if it accepts children as a
	  // property, it may be the creator of the child that's responsible for
	  // assigning it a key.
	  if (element && element._owner && element._owner !== ReactCurrentOwner.current) {
	    // Give the component that originally created this child.
	    addenda.childOwner = ' It was passed a child from ' + element._owner.getName() + '.';
	  }
	
	  return addenda;
	}
	
	/**
	 * Ensure that every element either is passed in a static location, in an
	 * array with an explicit keys property defined, or in an object literal
	 * with valid key property.
	 *
	 * @internal
	 * @param {ReactNode} node Statically passed child of any type.
	 * @param {*} parentType node's parent's type.
	 */
	function validateChildKeys(node, parentType) {
	  if (typeof node !== 'object') {
	    return;
	  }
	  if (Array.isArray(node)) {
	    for (var i = 0; i < node.length; i++) {
	      var child = node[i];
	      if (ReactElement.isValidElement(child)) {
	        validateExplicitKey(child, parentType);
	      }
	    }
	  } else if (ReactElement.isValidElement(node)) {
	    // This element was passed in a valid location.
	    if (node._store) {
	      node._store.validated = true;
	    }
	  } else if (node) {
	    var iteratorFn = getIteratorFn(node);
	    // Entry iterators provide implicit keys.
	    if (iteratorFn) {
	      if (iteratorFn !== node.entries) {
	        var iterator = iteratorFn.call(node);
	        var step;
	        while (!(step = iterator.next()).done) {
	          if (ReactElement.isValidElement(step.value)) {
	            validateExplicitKey(step.value, parentType);
	          }
	        }
	      }
	    }
	  }
	}
	
	/**
	 * Assert that the props are valid
	 *
	 * @param {string} componentName Name of the component for error messages.
	 * @param {object} propTypes Map of prop name to a ReactPropType
	 * @param {object} props
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @private
	 */
	function checkPropTypes(componentName, propTypes, props, location) {
	  for (var propName in propTypes) {
	    if (propTypes.hasOwnProperty(propName)) {
	      var error;
	      // Prop type validation may throw. In case they do, we don't want to
	      // fail the render phase where it didn't fail before. So we log it.
	      // After these have been cleaned up, we'll let them throw.
	      try {
	        // This is intentionally an invariant that gets caught. It's the same
	        // behavior as without this statement except with a better message.
	        !(typeof propTypes[propName] === 'function') ?  false ? invariant(false, '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', componentName || 'React class', ReactPropTypeLocationNames[location], propName) : invariant(false) : undefined;
	        error = propTypes[propName](props, propName, componentName, location, null, 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED');
	      } catch (ex) {
	        error = ex;
	      }
	       false ? warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', ReactPropTypeLocationNames[location], propName, typeof error) : undefined;
	      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	        // Only monitor this failure once because there tends to be a lot of the
	        // same error.
	        loggedTypeFailures[error.message] = true;
	
	        var addendum = getDeclarationErrorAddendum();
	         false ? warning(false, 'Failed propType: %s%s', error.message, addendum) : undefined;
	      }
	    }
	  }
	}
	
	/**
	 * Given an element, validate that its props follow the propTypes definition,
	 * provided by the type.
	 *
	 * @param {ReactElement} element
	 */
	function validatePropTypes(element) {
	  var componentClass = element.type;
	  if (typeof componentClass !== 'function') {
	    return;
	  }
	  var name = componentClass.displayName || componentClass.name;
	  if (componentClass.propTypes) {
	    checkPropTypes(name, componentClass.propTypes, element.props, ReactPropTypeLocations.prop);
	  }
	  if (typeof componentClass.getDefaultProps === 'function') {
	     false ? warning(componentClass.getDefaultProps.isReactClassApproved, 'getDefaultProps is only used on classic React.createClass ' + 'definitions. Use a static property named `defaultProps` instead.') : undefined;
	  }
	}
	
	var ReactElementValidator = {
	
	  createElement: function (type, props, children) {
	    var validType = typeof type === 'string' || typeof type === 'function';
	    // We warn in this case but don't throw. We expect the element creation to
	    // succeed and there will likely be errors in render.
	     false ? warning(validType, 'React.createElement: type should not be null, undefined, boolean, or ' + 'number. It should be a string (for DOM elements) or a ReactClass ' + '(for composite components).%s', getDeclarationErrorAddendum()) : undefined;
	
	    var element = ReactElement.createElement.apply(this, arguments);
	
	    // The result can be nullish if a mock or a custom function is used.
	    // TODO: Drop this when these are no longer allowed as the type argument.
	    if (element == null) {
	      return element;
	    }
	
	    // Skip key warning if the type isn't valid since our key validation logic
	    // doesn't expect a non-string/function type and can throw confusing errors.
	    // We don't want exception behavior to differ between dev and prod.
	    // (Rendering will throw with a helpful message and as soon as the type is
	    // fixed, the key warnings will appear.)
	    if (validType) {
	      for (var i = 2; i < arguments.length; i++) {
	        validateChildKeys(arguments[i], type);
	      }
	    }
	
	    validatePropTypes(element);
	
	    return element;
	  },
	
	  createFactory: function (type) {
	    var validatedFactory = ReactElementValidator.createElement.bind(null, type);
	    // Legacy hook TODO: Warn if this is accessed
	    validatedFactory.type = type;
	
	    if (false) {
	      if (canDefineProperty) {
	        Object.defineProperty(validatedFactory, 'type', {
	          enumerable: false,
	          get: function () {
	            process.env.NODE_ENV !== 'production' ? warning(false, 'Factory.type is deprecated. Access the class directly ' + 'before passing it to createFactory.') : undefined;
	            Object.defineProperty(this, 'type', {
	              value: type
	            });
	            return type;
	          }
	        });
	      }
	    }
	
	    return validatedFactory;
	  },
	
	  cloneElement: function (element, props, children) {
	    var newElement = ReactElement.cloneElement.apply(this, arguments);
	    for (var i = 2; i < arguments.length; i++) {
	      validateChildKeys(arguments[i], newElement.type);
	    }
	    validatePropTypes(newElement);
	    return newElement;
	  }
	
	};
	
	module.exports = ReactElementValidator;

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactEmptyComponent
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(6);
	var ReactEmptyComponentRegistry = __webpack_require__(77);
	var ReactReconciler = __webpack_require__(15);
	
	var assign = __webpack_require__(3);
	
	var placeholderElement;
	
	var ReactEmptyComponentInjection = {
	  injectEmptyComponent: function (component) {
	    placeholderElement = ReactElement.createElement(component);
	  }
	};
	
	function registerNullComponentID() {
	  ReactEmptyComponentRegistry.registerNullComponentID(this._rootNodeID);
	}
	
	var ReactEmptyComponent = function (instantiate) {
	  this._currentElement = null;
	  this._rootNodeID = null;
	  this._renderedComponent = instantiate(placeholderElement);
	};
	assign(ReactEmptyComponent.prototype, {
	  construct: function (element) {},
	  mountComponent: function (rootID, transaction, context) {
	    transaction.getReactMountReady().enqueue(registerNullComponentID, this);
	    this._rootNodeID = rootID;
	    return ReactReconciler.mountComponent(this._renderedComponent, rootID, transaction, context);
	  },
	  receiveComponent: function () {},
	  unmountComponent: function (rootID, transaction, context) {
	    ReactReconciler.unmountComponent(this._renderedComponent);
	    ReactEmptyComponentRegistry.deregisterNullComponentID(this._rootNodeID);
	    this._rootNodeID = null;
	    this._renderedComponent = null;
	  }
	});
	
	ReactEmptyComponent.injection = ReactEmptyComponentInjection;
	
	module.exports = ReactEmptyComponent;

/***/ }),
/* 77 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactEmptyComponentRegistry
	 */
	
	'use strict';
	
	// This registry keeps track of the React IDs of the components that rendered to
	// `null` (in reality a placeholder such as `noscript`)
	var nullComponentIDsRegistry = {};
	
	/**
	 * @param {string} id Component's `_rootNodeID`.
	 * @return {boolean} True if the component is rendered to null.
	 */
	function isNullComponentID(id) {
	  return !!nullComponentIDsRegistry[id];
	}
	
	/**
	 * Mark the component as having rendered to null.
	 * @param {string} id Component's `_rootNodeID`.
	 */
	function registerNullComponentID(id) {
	  nullComponentIDsRegistry[id] = true;
	}
	
	/**
	 * Unmark the component as having rendered to null: it renders to something now.
	 * @param {string} id Component's `_rootNodeID`.
	 */
	function deregisterNullComponentID(id) {
	  delete nullComponentIDsRegistry[id];
	}
	
	var ReactEmptyComponentRegistry = {
	  isNullComponentID: isNullComponentID,
	  registerNullComponentID: registerNullComponentID,
	  deregisterNullComponentID: deregisterNullComponentID
	};
	
	module.exports = ReactEmptyComponentRegistry;

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactErrorUtils
	 * @typechecks
	 */
	
	'use strict';
	
	var caughtError = null;
	
	/**
	 * Call a function while guarding against errors that happens within it.
	 *
	 * @param {?String} name of the guard to use for logging or debugging
	 * @param {Function} func The function to invoke
	 * @param {*} a First argument
	 * @param {*} b Second argument
	 */
	function invokeGuardedCallback(name, func, a, b) {
	  try {
	    return func(a, b);
	  } catch (x) {
	    if (caughtError === null) {
	      caughtError = x;
	    }
	    return undefined;
	  }
	}
	
	var ReactErrorUtils = {
	  invokeGuardedCallback: invokeGuardedCallback,
	
	  /**
	   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
	   * handler are sure to be rethrown by rethrowCaughtError.
	   */
	  invokeGuardedCallbackWithCatch: invokeGuardedCallback,
	
	  /**
	   * During execution of guarded functions we will capture the first error which
	   * we will rethrow to be handled by the top level error handler.
	   */
	  rethrowCaughtError: function () {
	    if (caughtError) {
	      var error = caughtError;
	      caughtError = null;
	      throw error;
	    }
	  }
	};
	
	if (false) {
	  /**
	   * To help development we can get better devtools integration by simulating a
	   * real browser event.
	   */
	  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
	    var fakeNode = document.createElement('react');
	    ReactErrorUtils.invokeGuardedCallback = function (name, func, a, b) {
	      var boundFunc = func.bind(null, a, b);
	      var evtType = 'react-' + name;
	      fakeNode.addEventListener(evtType, boundFunc, false);
	      var evt = document.createEvent('Event');
	      evt.initEvent(evtType, false, false);
	      fakeNode.dispatchEvent(evt);
	      fakeNode.removeEventListener(evtType, boundFunc, false);
	    };
	  }
	}
	
	module.exports = ReactErrorUtils;

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactInputSelection
	 */
	
	'use strict';
	
	var ReactDOMSelection = __webpack_require__(147);
	
	var containsNode = __webpack_require__(55);
	var focusNode = __webpack_require__(56);
	var getActiveElement = __webpack_require__(57);
	
	function isInDocument(node) {
	  return containsNode(document.documentElement, node);
	}
	
	/**
	 * @ReactInputSelection: React input selection module. Based on Selection.js,
	 * but modified to be suitable for react and has a couple of bug fixes (doesn't
	 * assume buttons have range selections allowed).
	 * Input selection module for React.
	 */
	var ReactInputSelection = {
	
	  hasSelectionCapabilities: function (elem) {
	    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
	  },
	
	  getSelectionInformation: function () {
	    var focusedElem = getActiveElement();
	    return {
	      focusedElem: focusedElem,
	      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
	    };
	  },
	
	  /**
	   * @restoreSelection: If any selection information was potentially lost,
	   * restore it. This is useful when performing operations that could remove dom
	   * nodes and place them back in, resulting in focus being lost.
	   */
	  restoreSelection: function (priorSelectionInformation) {
	    var curFocusedElem = getActiveElement();
	    var priorFocusedElem = priorSelectionInformation.focusedElem;
	    var priorSelectionRange = priorSelectionInformation.selectionRange;
	    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
	      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
	        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
	      }
	      focusNode(priorFocusedElem);
	    }
	  },
	
	  /**
	   * @getSelection: Gets the selection bounds of a focused textarea, input or
	   * contentEditable node.
	   * -@input: Look up selection bounds of this input
	   * -@return {start: selectionStart, end: selectionEnd}
	   */
	  getSelection: function (input) {
	    var selection;
	
	    if ('selectionStart' in input) {
	      // Modern browser with input or textarea.
	      selection = {
	        start: input.selectionStart,
	        end: input.selectionEnd
	      };
	    } else if (document.selection && (input.nodeName && input.nodeName.toLowerCase() === 'input')) {
	      // IE8 input.
	      var range = document.selection.createRange();
	      // There can only be one selection per document in IE, so it must
	      // be in our element.
	      if (range.parentElement() === input) {
	        selection = {
	          start: -range.moveStart('character', -input.value.length),
	          end: -range.moveEnd('character', -input.value.length)
	        };
	      }
	    } else {
	      // Content editable or old IE textarea.
	      selection = ReactDOMSelection.getOffsets(input);
	    }
	
	    return selection || { start: 0, end: 0 };
	  },
	
	  /**
	   * @setSelection: Sets the selection bounds of a textarea or input and focuses
	   * the input.
	   * -@input     Set selection bounds of this input or textarea
	   * -@offsets   Object of same form that is returned from get*
	   */
	  setSelection: function (input, offsets) {
	    var start = offsets.start;
	    var end = offsets.end;
	    if (typeof end === 'undefined') {
	      end = start;
	    }
	
	    if ('selectionStart' in input) {
	      input.selectionStart = start;
	      input.selectionEnd = Math.min(end, input.value.length);
	    } else if (document.selection && (input.nodeName && input.nodeName.toLowerCase() === 'input')) {
	      var range = input.createTextRange();
	      range.collapse(true);
	      range.moveStart('character', start);
	      range.moveEnd('character', end - start);
	      range.select();
	    } else {
	      ReactDOMSelection.setOffsets(input, offsets);
	    }
	  }
	};
	
	module.exports = ReactInputSelection;

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactMarkupChecksum
	 */
	
	'use strict';
	
	var adler32 = __webpack_require__(173);
	
	var TAG_END = /\/?>/;
	
	var ReactMarkupChecksum = {
	  CHECKSUM_ATTR_NAME: 'data-react-checksum',
	
	  /**
	   * @param {string} markup Markup string
	   * @return {string} Markup string with checksum attribute attached
	   */
	  addChecksumToMarkup: function (markup) {
	    var checksum = adler32(markup);
	
	    // Add checksum (handle both parent tags and self-closing tags)
	    return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
	  },
	
	  /**
	   * @param {string} markup to use
	   * @param {DOMElement} element root React element
	   * @returns {boolean} whether or not the markup is the same
	   */
	  canReuseMarkup: function (markup, element) {
	    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
	    var markupChecksum = adler32(markup);
	    return markupChecksum === existingChecksum;
	  }
	};
	
	module.exports = ReactMarkupChecksum;

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactMultiChildUpdateTypes
	 */
	
	'use strict';
	
	var keyMirror = __webpack_require__(25);
	
	/**
	 * When a component's children are updated, a series of update configuration
	 * objects are created in order to batch and serialize the required changes.
	 *
	 * Enumerates all the possible types of update configurations.
	 *
	 * @internal
	 */
	var ReactMultiChildUpdateTypes = keyMirror({
	  INSERT_MARKUP: null,
	  MOVE_EXISTING: null,
	  REMOVE_NODE: null,
	  SET_MARKUP: null,
	  TEXT_CONTENT: null
	});
	
	module.exports = ReactMultiChildUpdateTypes;

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactNativeComponent
	 */
	
	'use strict';
	
	var assign = __webpack_require__(3);
	var invariant = __webpack_require__(1);
	
	var autoGenerateWrapperClass = null;
	var genericComponentClass = null;
	// This registry keeps track of wrapper classes around native tags.
	var tagToComponentClass = {};
	var textComponentClass = null;
	
	var ReactNativeComponentInjection = {
	  // This accepts a class that receives the tag string. This is a catch all
	  // that can render any kind of tag.
	  injectGenericComponentClass: function (componentClass) {
	    genericComponentClass = componentClass;
	  },
	  // This accepts a text component class that takes the text string to be
	  // rendered as props.
	  injectTextComponentClass: function (componentClass) {
	    textComponentClass = componentClass;
	  },
	  // This accepts a keyed object with classes as values. Each key represents a
	  // tag. That particular tag will use this class instead of the generic one.
	  injectComponentClasses: function (componentClasses) {
	    assign(tagToComponentClass, componentClasses);
	  }
	};
	
	/**
	 * Get a composite component wrapper class for a specific tag.
	 *
	 * @param {ReactElement} element The tag for which to get the class.
	 * @return {function} The React class constructor function.
	 */
	function getComponentClassForElement(element) {
	  if (typeof element.type === 'function') {
	    return element.type;
	  }
	  var tag = element.type;
	  var componentClass = tagToComponentClass[tag];
	  if (componentClass == null) {
	    tagToComponentClass[tag] = componentClass = autoGenerateWrapperClass(tag);
	  }
	  return componentClass;
	}
	
	/**
	 * Get a native internal component class for a specific tag.
	 *
	 * @param {ReactElement} element The element to create.
	 * @return {function} The internal class constructor function.
	 */
	function createInternalComponent(element) {
	  !genericComponentClass ?  false ? invariant(false, 'There is no registered component for the tag %s', element.type) : invariant(false) : undefined;
	  return new genericComponentClass(element.type, element.props);
	}
	
	/**
	 * @param {ReactText} text
	 * @return {ReactComponent}
	 */
	function createInstanceForText(text) {
	  return new textComponentClass(text);
	}
	
	/**
	 * @param {ReactComponent} component
	 * @return {boolean}
	 */
	function isTextComponent(component) {
	  return component instanceof textComponentClass;
	}
	
	var ReactNativeComponent = {
	  getComponentClassForElement: getComponentClassForElement,
	  createInternalComponent: createInternalComponent,
	  createInstanceForText: createInstanceForText,
	  isTextComponent: isTextComponent,
	  injection: ReactNativeComponentInjection
	};
	
	module.exports = ReactNativeComponent;

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactNoopUpdateQueue
	 */
	
	'use strict';
	
	var warning = __webpack_require__(2);
	
	function warnTDZ(publicInstance, callerName) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, publicInstance.constructor && publicInstance.constructor.displayName || '') : undefined;
	  }
	}
	
	/**
	 * This is the abstract API for an update queue.
	 */
	var ReactNoopUpdateQueue = {
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    return false;
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback) {},
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    warnTDZ(publicInstance, 'forceUpdate');
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    warnTDZ(publicInstance, 'replaceState');
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    warnTDZ(publicInstance, 'setState');
	  },
	
	  /**
	   * Sets a subset of the props.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialProps Subset of the next props.
	   * @internal
	   */
	  enqueueSetProps: function (publicInstance, partialProps) {
	    warnTDZ(publicInstance, 'setProps');
	  },
	
	  /**
	   * Replaces all of the props.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} props New props.
	   * @internal
	   */
	  enqueueReplaceProps: function (publicInstance, props) {
	    warnTDZ(publicInstance, 'replaceProps');
	  }
	
	};
	
	module.exports = ReactNoopUpdateQueue;

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactPropTypes
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(6);
	var ReactPropTypeLocationNames = __webpack_require__(27);
	
	var emptyFunction = __webpack_require__(9);
	var getIteratorFn = __webpack_require__(47);
	
	/**
	 * Collection of methods that allow declaration and validation of props that are
	 * supplied to React components. Example usage:
	 *
	 *   var Props = require('ReactPropTypes');
	 *   var MyArticle = React.createClass({
	 *     propTypes: {
	 *       // An optional string prop named "description".
	 *       description: Props.string,
	 *
	 *       // A required enum prop named "category".
	 *       category: Props.oneOf(['News','Photos']).isRequired,
	 *
	 *       // A prop named "dialog" that requires an instance of Dialog.
	 *       dialog: Props.instanceOf(Dialog).isRequired
	 *     },
	 *     render: function() { ... }
	 *   });
	 *
	 * A more formal specification of how these methods are used:
	 *
	 *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	 *   decl := ReactPropTypes.{type}(.isRequired)?
	 *
	 * Each and every declaration produces a function with the same signature. This
	 * allows the creation of custom validation functions. For example:
	 *
	 *  var MyLink = React.createClass({
	 *    propTypes: {
	 *      // An optional string or URI prop named "href".
	 *      href: function(props, propName, componentName) {
	 *        var propValue = props[propName];
	 *        if (propValue != null && typeof propValue !== 'string' &&
	 *            !(propValue instanceof URI)) {
	 *          return new Error(
	 *            'Expected a string or an URI for ' + propName + ' in ' +
	 *            componentName
	 *          );
	 *        }
	 *      }
	 *    },
	 *    render: function() {...}
	 *  });
	 *
	 * @internal
	 */
	
	var ANONYMOUS = '<<anonymous>>';
	
	var ReactPropTypes = {
	  array: createPrimitiveTypeChecker('array'),
	  bool: createPrimitiveTypeChecker('boolean'),
	  func: createPrimitiveTypeChecker('function'),
	  number: createPrimitiveTypeChecker('number'),
	  object: createPrimitiveTypeChecker('object'),
	  string: createPrimitiveTypeChecker('string'),
	
	  any: createAnyTypeChecker(),
	  arrayOf: createArrayOfTypeChecker,
	  element: createElementTypeChecker(),
	  instanceOf: createInstanceTypeChecker,
	  node: createNodeChecker(),
	  objectOf: createObjectOfTypeChecker,
	  oneOf: createEnumTypeChecker,
	  oneOfType: createUnionTypeChecker,
	  shape: createShapeTypeChecker
	};
	
	function createChainableTypeChecker(validate) {
	  function checkType(isRequired, props, propName, componentName, location, propFullName) {
	    componentName = componentName || ANONYMOUS;
	    propFullName = propFullName || propName;
	    if (props[propName] == null) {
	      var locationName = ReactPropTypeLocationNames[location];
	      if (isRequired) {
	        return new Error('Required ' + locationName + ' `' + propFullName + '` was not specified in ' + ('`' + componentName + '`.'));
	      }
	      return null;
	    } else {
	      return validate(props, propName, componentName, location, propFullName);
	    }
	  }
	
	  var chainedCheckType = checkType.bind(null, false);
	  chainedCheckType.isRequired = checkType.bind(null, true);
	
	  return chainedCheckType;
	}
	
	function createPrimitiveTypeChecker(expectedType) {
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    var propType = getPropType(propValue);
	    if (propType !== expectedType) {
	      var locationName = ReactPropTypeLocationNames[location];
	      // `propValue` being instance of, say, date/regexp, pass the 'object'
	      // check, but we can offer a more precise error message here rather than
	      // 'of type `object`'.
	      var preciseType = getPreciseType(propValue);
	
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createAnyTypeChecker() {
	  return createChainableTypeChecker(emptyFunction.thatReturns(null));
	}
	
	function createArrayOfTypeChecker(typeChecker) {
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    if (!Array.isArray(propValue)) {
	      var locationName = ReactPropTypeLocationNames[location];
	      var propType = getPropType(propValue);
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	    }
	    for (var i = 0; i < propValue.length; i++) {
	      var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED');
	      if (error instanceof Error) {
	        return error;
	      }
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createElementTypeChecker() {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (!ReactElement.isValidElement(props[propName])) {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a single ReactElement.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createInstanceTypeChecker(expectedClass) {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (!(props[propName] instanceof expectedClass)) {
	      var locationName = ReactPropTypeLocationNames[location];
	      var expectedClassName = expectedClass.name || ANONYMOUS;
	      var actualClassName = getClassName(props[propName]);
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createEnumTypeChecker(expectedValues) {
	  if (!Array.isArray(expectedValues)) {
	    return createChainableTypeChecker(function () {
	      return new Error('Invalid argument supplied to oneOf, expected an instance of array.');
	    });
	  }
	
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    for (var i = 0; i < expectedValues.length; i++) {
	      if (propValue === expectedValues[i]) {
	        return null;
	      }
	    }
	
	    var locationName = ReactPropTypeLocationNames[location];
	    var valuesString = JSON.stringify(expectedValues);
	    return new Error('Invalid ' + locationName + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createObjectOfTypeChecker(typeChecker) {
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    var propType = getPropType(propValue);
	    if (propType !== 'object') {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	    }
	    for (var key in propValue) {
	      if (propValue.hasOwnProperty(key)) {
	        var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED');
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createUnionTypeChecker(arrayOfTypeCheckers) {
	  if (!Array.isArray(arrayOfTypeCheckers)) {
	    return createChainableTypeChecker(function () {
	      return new Error('Invalid argument supplied to oneOfType, expected an instance of array.');
	    });
	  }
	
	  function validate(props, propName, componentName, location, propFullName) {
	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (checker(props, propName, componentName, location, propFullName, 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED') == null) {
	        return null;
	      }
	    }
	
	    var locationName = ReactPropTypeLocationNames[location];
	    return new Error('Invalid ' + locationName + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createNodeChecker() {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (!isNode(props[propName])) {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createShapeTypeChecker(shapeTypes) {
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    var propType = getPropType(propValue);
	    if (propType !== 'object') {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	    }
	    for (var key in shapeTypes) {
	      var checker = shapeTypes[key];
	      if (!checker) {
	        continue;
	      }
	      var error = checker(propValue, key, componentName, location, propFullName + '.' + key, 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED');
	      if (error) {
	        return error;
	      }
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function isNode(propValue) {
	  switch (typeof propValue) {
	    case 'number':
	    case 'string':
	    case 'undefined':
	      return true;
	    case 'boolean':
	      return !propValue;
	    case 'object':
	      if (Array.isArray(propValue)) {
	        return propValue.every(isNode);
	      }
	      if (propValue === null || ReactElement.isValidElement(propValue)) {
	        return true;
	      }
	
	      var iteratorFn = getIteratorFn(propValue);
	      if (iteratorFn) {
	        var iterator = iteratorFn.call(propValue);
	        var step;
	        if (iteratorFn !== propValue.entries) {
	          while (!(step = iterator.next()).done) {
	            if (!isNode(step.value)) {
	              return false;
	            }
	          }
	        } else {
	          // Iterator will provide entry [k,v] tuples rather than values.
	          while (!(step = iterator.next()).done) {
	            var entry = step.value;
	            if (entry) {
	              if (!isNode(entry[1])) {
	                return false;
	              }
	            }
	          }
	        }
	      } else {
	        return false;
	      }
	
	      return true;
	    default:
	      return false;
	  }
	}
	
	// Equivalent of `typeof` but with special handling for array and regexp.
	function getPropType(propValue) {
	  var propType = typeof propValue;
	  if (Array.isArray(propValue)) {
	    return 'array';
	  }
	  if (propValue instanceof RegExp) {
	    // Old webkits (at least until Android 4.0) return 'function' rather than
	    // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	    // passes PropTypes.object.
	    return 'object';
	  }
	  return propType;
	}
	
	// This handles more types than `getPropType`. Only used for error messages.
	// See `createPrimitiveTypeChecker`.
	function getPreciseType(propValue) {
	  var propType = getPropType(propValue);
	  if (propType === 'object') {
	    if (propValue instanceof Date) {
	      return 'date';
	    } else if (propValue instanceof RegExp) {
	      return 'regexp';
	    }
	  }
	  return propType;
	}
	
	// Returns class name of the object, if any.
	function getClassName(propValue) {
	  if (!propValue.constructor || !propValue.constructor.name) {
	    return '<<anonymous>>';
	  }
	  return propValue.constructor.name;
	}
	
	module.exports = ReactPropTypes;

/***/ }),
/* 85 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactRootIndex
	 * @typechecks
	 */
	
	'use strict';
	
	var ReactRootIndexInjection = {
	  /**
	   * @param {function} _createReactRootIndex
	   */
	  injectCreateReactRootIndex: function (_createReactRootIndex) {
	    ReactRootIndex.createReactRootIndex = _createReactRootIndex;
	  }
	};
	
	var ReactRootIndex = {
	  createReactRootIndex: null,
	  injection: ReactRootIndexInjection
	};
	
	module.exports = ReactRootIndex;

/***/ }),
/* 86 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ViewportMetrics
	 */
	
	'use strict';
	
	var ViewportMetrics = {
	
	  currentScrollLeft: 0,
	
	  currentScrollTop: 0,
	
	  refreshScrollValues: function (scrollPosition) {
	    ViewportMetrics.currentScrollLeft = scrollPosition.x;
	    ViewportMetrics.currentScrollTop = scrollPosition.y;
	  }
	
	};
	
	module.exports = ViewportMetrics;

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule accumulateInto
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(1);
	
	/**
	 *
	 * Accumulates items that must not be null or undefined into the first one. This
	 * is used to conserve memory by avoiding array allocations, and thus sacrifices
	 * API cleanness. Since `current` can be null before being passed in and not
	 * null after this function, make sure to assign it back to `current`:
	 *
	 * `a = accumulateInto(a, b);`
	 *
	 * This API should be sparingly used. Try `accumulate` for something cleaner.
	 *
	 * @return {*|array<*>} An accumulation of items.
	 */
	
	function accumulateInto(current, next) {
	  !(next != null) ?  false ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : invariant(false) : undefined;
	  if (current == null) {
	    return next;
	  }
	
	  // Both are not empty. Warning: Never call x.concat(y) when you are not
	  // certain that x is an Array (x could be a string with concat method).
	  var currentIsArray = Array.isArray(current);
	  var nextIsArray = Array.isArray(next);
	
	  if (currentIsArray && nextIsArray) {
	    current.push.apply(current, next);
	    return current;
	  }
	
	  if (currentIsArray) {
	    current.push(next);
	    return current;
	  }
	
	  if (nextIsArray) {
	    // A bit too dangerous to mutate `next`.
	    return [current].concat(next);
	  }
	
	  return [current, next];
	}
	
	module.exports = accumulateInto;

/***/ }),
/* 88 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule forEachAccumulated
	 */
	
	'use strict';
	
	/**
	 * @param {array} arr an "accumulation" of items which is either an Array or
	 * a single item. Useful when paired with the `accumulate` module. This is a
	 * simple utility that allows us to reason about a collection of items, but
	 * handling the case when there is exactly one item (and we do not need to
	 * allocate an array).
	 */
	var forEachAccumulated = function (arr, cb, scope) {
	  if (Array.isArray(arr)) {
	    arr.forEach(cb, scope);
	  } else if (arr) {
	    cb.call(scope, arr);
	  }
	};
	
	module.exports = forEachAccumulated;

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getTextContentAccessor
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(4);
	
	var contentKey = null;
	
	/**
	 * Gets the key used to access text content on a DOM node.
	 *
	 * @return {?string} Key used to access text content.
	 * @internal
	 */
	function getTextContentAccessor() {
	  if (!contentKey && ExecutionEnvironment.canUseDOM) {
	    // Prefer textContent to innerText because many browsers support both but
	    // SVG <text> elements don't support innerText even when <div> does.
	    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
	  }
	  return contentKey;
	}
	
	module.exports = getTextContentAccessor;

/***/ }),
/* 90 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule isTextInputElement
	 */
	
	'use strict';
	
	/**
	 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
	 */
	var supportedInputTypes = {
	  'color': true,
	  'date': true,
	  'datetime': true,
	  'datetime-local': true,
	  'email': true,
	  'month': true,
	  'number': true,
	  'password': true,
	  'range': true,
	  'search': true,
	  'tel': true,
	  'text': true,
	  'time': true,
	  'url': true,
	  'week': true
	};
	
	function isTextInputElement(elem) {
	  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	  return nodeName && (nodeName === 'input' && supportedInputTypes[elem.type] || nodeName === 'textarea');
	}
	
	module.exports = isTextInputElement;

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(17);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _WhiteboardsViewer = __webpack_require__(93);
	
	var _WhiteboardsViewer2 = _interopRequireDefault(_WhiteboardsViewer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var App = _react2.default.createClass({
	  displayName: 'App',
	  getInitialState: function getInitialState() {
	    return {
	      whiteboardsData: null
	    };
	  },
	  componentDidMount: function componentDidMount() {
	    var _this = this;
	
	    var request = new XMLHttpRequest();
	    request.onreadystatechange = function () {
	      if (request.readyState == 4 && request.status == 200) {
	        _this.setState({ whiteboardsData: JSON.parse(request.responseText) });
	      }
	    };
	    request.open('GET', 'data/whiteboards.json', true);
	    request.send(null);
	  },
	  render: function render() {
	    var whiteboardsData = this.state.whiteboardsData;
	
	
	    if (whiteboardsData) {
	      return _react2.default.createElement(_WhiteboardsViewer2.default, { whiteboards: whiteboardsData });
	    } else {
	      return _react2.default.createElement(
	        'div',
	        null,
	        'Loading...'
	      );
	    }
	  }
	});
	
	exports.default = App;

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(17);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _openseadragon = __webpack_require__(110);
	
	var _openseadragon2 = _interopRequireDefault(_openseadragon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var OpenSeadragonViewer = _react2.default.createClass({
	  displayName: 'OpenSeadragonViewer',
	  render: function render() {
	    var _props = this.props,
	        tileSources = _props.tileSources,
	        controlPosition = _props.controlPosition,
	        sequenceMode = _props.sequenceMode,
	        otherProps = _objectWithoutProperties(_props, ['tileSources', 'controlPosition', 'sequenceMode']);
	
	    return _react2.default.createElement('div', _extends({ ref: 'div' }, otherProps));
	  },
	  componentDidMount: function componentDidMount() {
	    var _props2 = this.props,
	        tileSources = _props2.tileSources,
	        controlPosition = _props2.controlPosition,
	        sequenceMode = _props2.sequenceMode;
	
	
	    var navigationControlAnchor = _openseadragon2.default.ControlAnchor[controlPosition || 'TOP_LEFT'];
	
	    this.viewer = (0, _openseadragon2.default)({
	      element: this.refs.div,
	      prefixUrl: "nav-images/",
	      tileSources: tileSources,
	      sequenceMode: sequenceMode,
	      showNavigator: true,
	      navigationControlAnchor: navigationControlAnchor,
	      sequenceControlAnchor: navigationControlAnchor,
	      preserveViewport: true,
	      visibilityRatio: 1.0
	    });
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    this.viewer.destroy();
	  }
	});
	
	exports.default = OpenSeadragonViewer;

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(17);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _underscore = __webpack_require__(185);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _reactBurgerMenu = __webpack_require__(114);
	
	var _reactBurgerMenu2 = _interopRequireDefault(_reactBurgerMenu);
	
	var _OpenSeadragonViewer = __webpack_require__(92);
	
	var _OpenSeadragonViewer2 = _interopRequireDefault(_OpenSeadragonViewer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Menu = _reactBurgerMenu2.default.slide;
	
	var menuStyles = {
	  bmBurgerButton: {
	    position: 'fixed',
	    width: '36px',
	    height: '30px',
	    left: '36px',
	    top: '36px'
	  },
	  bmBurgerBars: {
	    background: '#bdc3c7' //'#373a47'
	  },
	  bmCrossButton: {
	    height: '24px',
	    width: '24px'
	  },
	  bmCross: {
	    background: '#666666'
	  },
	  bmMenu: {
	    background: '#dddddd',
	    padding: '2.5em 1em 0 0.5em',
	    fontSize: '1.15em'
	  },
	  bmMorphShape: {
	    fill: '#373a47'
	  },
	  bmItemList: {
	    color: '#666666',
	    padding: '0.8em'
	  },
	  bmOverlay: {
	    background: 'rgba(255, 255, 255, 0.1)'
	  }
	};
	
	var WhiteboardsViewer = _react2.default.createClass({
	  displayName: 'WhiteboardsViewer',
	  getInitialState: function getInitialState() {
	    var whiteboards = this.props.whiteboards;
	
	
	    var displayedWhiteboard = _underscore2.default.keys(whiteboards)[0];
	    var displayedStitching = whiteboards[displayedWhiteboard][0];
	
	    return { displayedWhiteboard: displayedWhiteboard, displayedStitching: displayedStitching };
	  },
	  setDisplayed: function setDisplayed(displayedWhiteboard, displayedStitching) {
	    this.setState({ displayedWhiteboard: displayedWhiteboard, displayedStitching: displayedStitching });
	  },
	  render: function render() {
	    var _this = this;
	
	    var whiteboards = this.props.whiteboards;
	    var _state = this.state,
	        displayedWhiteboard = _state.displayedWhiteboard,
	        displayedStitching = _state.displayedStitching;
	
	
	    var dataRoot = 'data/' + displayedWhiteboard + '/' + displayedStitching + '/';
	    var tileSources = [dataRoot + 'stitched/image.dzi', dataRoot + 'homographies/image.dzi', dataRoot + 'masks/image.dzi'];
	
	    var whiteboardsInOrder = _underscore2.default.sortBy(_underscore2.default.pairs(whiteboards), 0);
	
	    return _react2.default.createElement(
	      'div',
	      { style: { background: '#444444' } },
	      _react2.default.createElement(
	        Menu,
	        { styles: menuStyles },
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { style: { height: '100%', overflow: 'scroll' } },
	            whiteboardsInOrder.map(function (_ref) {
	              var _ref2 = _slicedToArray(_ref, 2),
	                  whiteboardName = _ref2[0],
	                  stitchings = _ref2[1];
	
	              return _react2.default.createElement(
	                'div',
	                { key: whiteboardName, style: { paddingLeft: 20, textIndent: -20, paddingBottom: 20 } },
	                stitchings.length == 1 ? _react2.default.createElement(
	                  'a',
	                  { href: '#', onClick: function onClick() {
	                      return _this.setDisplayed(whiteboardName, stitchings[0]);
	                    } },
	                  whiteboardName
	                ) : _react2.default.createElement(
	                  'span',
	                  null,
	                  whiteboardName,
	                  stitchings.map(function (stitchingName, i) {
	                    return _react2.default.createElement(
	                      'a',
	                      { href: '#', onClick: function onClick() {
	                          return _this.setDisplayed(whiteboardName, stitchingName);
	                        } },
	                      ' ',
	                      '[',
	                      i + 1,
	                      ']'
	                    );
	                  })
	                )
	              );
	            }),
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'div',
	                { style: { marginTop: 50 } },
	                _react2.default.createElement(
	                  'i',
	                  null,
	                  'Use the left- and right-arrows to switch between the stitched view, the image boundaries view, and the compositing-mask view.'
	                )
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(_OpenSeadragonViewer2.default, {
	        key: displayedWhiteboard + '/' + displayedStitching,
	        tileSources: tileSources,
	        sequenceMode: true,
	        controlPosition: 'BOTTOM_LEFT',
	        style: { width: '100%', height: '100%' } })
	    );
	  }
	});
	
	exports.default = WhiteboardsViewer;

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(17);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(62);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	__webpack_require__(184);
	
	var _App = __webpack_require__(91);
	
	var _App2 = _interopRequireDefault(_App);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_reactDom2.default.render(_react2.default.createElement(_App2.default, null), document.getElementById('root'));

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(96)();
	// imports
	
	
	// module
	exports.push([module.id, "/*!\n * Bootstrap v3.3.7 (http://getbootstrap.com)\n * Copyright 2011-2016 Twitter, Inc.\n * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)\n *//*! normalize.css v3.0.3 | MIT License | github.com/necolas/normalize.css */html{font-family:sans-serif;-webkit-text-size-adjust:100%;-ms-text-size-adjust:100%}body{margin:0}article,aside,details,figcaption,figure,footer,header,hgroup,main,menu,nav,section,summary{display:block}audio,canvas,progress,video{display:inline-block;vertical-align:baseline}audio:not([controls]){display:none;height:0}[hidden],template{display:none}a{background-color:transparent}a:active,a:hover{outline:0}abbr[title]{border-bottom:1px dotted}b,strong{font-weight:700}dfn{font-style:italic}h1{margin:.67em 0;font-size:2em}mark{color:#000;background:#ff0}small{font-size:80%}sub,sup{position:relative;font-size:75%;line-height:0;vertical-align:baseline}sup{top:-.5em}sub{bottom:-.25em}img{border:0}svg:not(:root){overflow:hidden}figure{margin:1em 40px}hr{height:0;box-sizing:content-box}pre{overflow:auto}code,kbd,pre,samp{font-family:monospace,monospace;font-size:1em}button,input,optgroup,select,textarea{margin:0;font:inherit;color:inherit}button{overflow:visible}button,select{text-transform:none}button,html input[type=button],input[type=reset],input[type=submit]{-webkit-appearance:button;cursor:pointer}button[disabled],html input[disabled]{cursor:default}button::-moz-focus-inner,input::-moz-focus-inner{padding:0;border:0}input{line-height:normal}input[type=checkbox],input[type=radio]{box-sizing:border-box;padding:0}input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{height:auto}input[type=search]{box-sizing:content-box;-webkit-appearance:textfield}input[type=search]::-webkit-search-cancel-button,input[type=search]::-webkit-search-decoration{-webkit-appearance:none}fieldset{padding:.35em .625em .75em;margin:0 2px;border:1px solid silver}textarea{overflow:auto}optgroup{font-weight:700}table{border-spacing:0;border-collapse:collapse}td,th{padding:0}/*! Source: https://github.com/h5bp/html5-boilerplate/blob/master/src/css/main.css */@media print{*,:after,:before{color:#000!important;text-shadow:none!important;background:0 0!important;box-shadow:none!important}a,a:visited{text-decoration:underline}a[href]:after{content:\" (\" attr(href) \")\"}abbr[title]:after{content:\" (\" attr(title) \")\"}a[href^=\"#\"]:after,a[href^=\"javascript:\"]:after{content:\"\"}blockquote,pre{border:1px solid #999;page-break-inside:avoid}thead{display:table-header-group}img,tr{page-break-inside:avoid}img{max-width:100%!important}h2,h3,p{orphans:3;widows:3}h2,h3{page-break-after:avoid}.navbar{display:none}.btn>.caret,.dropup>.btn>.caret{border-top-color:#000!important}.label{border:1px solid #000}.table{border-collapse:collapse!important}.table td,.table th{background-color:#fff!important}.table-bordered td,.table-bordered th{border:1px solid #ddd!important}}@font-face{font-family:Glyphicons Halflings;src:url(" + __webpack_require__(60) + ");src:url(" + __webpack_require__(60) + "?#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__(187) + ") format(\"woff2\"),url(" + __webpack_require__(186) + ") format(\"woff\"),url(" + __webpack_require__(188) + ") format(\"truetype\"),url(" + __webpack_require__(189) + "#glyphicons_halflingsregular) format(\"svg\")}.glyphicon{position:relative;top:1px;display:inline-block;font-family:Glyphicons Halflings;font-style:normal;font-weight:400;line-height:1;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.glyphicon-asterisk:before{content:\"*\"}.glyphicon-plus:before{content:\"+\"}.glyphicon-eur:before,.glyphicon-euro:before{content:\"\\20AC\"}.glyphicon-minus:before{content:\"\\2212\"}.glyphicon-cloud:before{content:\"\\2601\"}.glyphicon-envelope:before{content:\"\\2709\"}.glyphicon-pencil:before{content:\"\\270F\"}.glyphicon-glass:before{content:\"\\E001\"}.glyphicon-music:before{content:\"\\E002\"}.glyphicon-search:before{content:\"\\E003\"}.glyphicon-heart:before{content:\"\\E005\"}.glyphicon-star:before{content:\"\\E006\"}.glyphicon-star-empty:before{content:\"\\E007\"}.glyphicon-user:before{content:\"\\E008\"}.glyphicon-film:before{content:\"\\E009\"}.glyphicon-th-large:before{content:\"\\E010\"}.glyphicon-th:before{content:\"\\E011\"}.glyphicon-th-list:before{content:\"\\E012\"}.glyphicon-ok:before{content:\"\\E013\"}.glyphicon-remove:before{content:\"\\E014\"}.glyphicon-zoom-in:before{content:\"\\E015\"}.glyphicon-zoom-out:before{content:\"\\E016\"}.glyphicon-off:before{content:\"\\E017\"}.glyphicon-signal:before{content:\"\\E018\"}.glyphicon-cog:before{content:\"\\E019\"}.glyphicon-trash:before{content:\"\\E020\"}.glyphicon-home:before{content:\"\\E021\"}.glyphicon-file:before{content:\"\\E022\"}.glyphicon-time:before{content:\"\\E023\"}.glyphicon-road:before{content:\"\\E024\"}.glyphicon-download-alt:before{content:\"\\E025\"}.glyphicon-download:before{content:\"\\E026\"}.glyphicon-upload:before{content:\"\\E027\"}.glyphicon-inbox:before{content:\"\\E028\"}.glyphicon-play-circle:before{content:\"\\E029\"}.glyphicon-repeat:before{content:\"\\E030\"}.glyphicon-refresh:before{content:\"\\E031\"}.glyphicon-list-alt:before{content:\"\\E032\"}.glyphicon-lock:before{content:\"\\E033\"}.glyphicon-flag:before{content:\"\\E034\"}.glyphicon-headphones:before{content:\"\\E035\"}.glyphicon-volume-off:before{content:\"\\E036\"}.glyphicon-volume-down:before{content:\"\\E037\"}.glyphicon-volume-up:before{content:\"\\E038\"}.glyphicon-qrcode:before{content:\"\\E039\"}.glyphicon-barcode:before{content:\"\\E040\"}.glyphicon-tag:before{content:\"\\E041\"}.glyphicon-tags:before{content:\"\\E042\"}.glyphicon-book:before{content:\"\\E043\"}.glyphicon-bookmark:before{content:\"\\E044\"}.glyphicon-print:before{content:\"\\E045\"}.glyphicon-camera:before{content:\"\\E046\"}.glyphicon-font:before{content:\"\\E047\"}.glyphicon-bold:before{content:\"\\E048\"}.glyphicon-italic:before{content:\"\\E049\"}.glyphicon-text-height:before{content:\"\\E050\"}.glyphicon-text-width:before{content:\"\\E051\"}.glyphicon-align-left:before{content:\"\\E052\"}.glyphicon-align-center:before{content:\"\\E053\"}.glyphicon-align-right:before{content:\"\\E054\"}.glyphicon-align-justify:before{content:\"\\E055\"}.glyphicon-list:before{content:\"\\E056\"}.glyphicon-indent-left:before{content:\"\\E057\"}.glyphicon-indent-right:before{content:\"\\E058\"}.glyphicon-facetime-video:before{content:\"\\E059\"}.glyphicon-picture:before{content:\"\\E060\"}.glyphicon-map-marker:before{content:\"\\E062\"}.glyphicon-adjust:before{content:\"\\E063\"}.glyphicon-tint:before{content:\"\\E064\"}.glyphicon-edit:before{content:\"\\E065\"}.glyphicon-share:before{content:\"\\E066\"}.glyphicon-check:before{content:\"\\E067\"}.glyphicon-move:before{content:\"\\E068\"}.glyphicon-step-backward:before{content:\"\\E069\"}.glyphicon-fast-backward:before{content:\"\\E070\"}.glyphicon-backward:before{content:\"\\E071\"}.glyphicon-play:before{content:\"\\E072\"}.glyphicon-pause:before{content:\"\\E073\"}.glyphicon-stop:before{content:\"\\E074\"}.glyphicon-forward:before{content:\"\\E075\"}.glyphicon-fast-forward:before{content:\"\\E076\"}.glyphicon-step-forward:before{content:\"\\E077\"}.glyphicon-eject:before{content:\"\\E078\"}.glyphicon-chevron-left:before{content:\"\\E079\"}.glyphicon-chevron-right:before{content:\"\\E080\"}.glyphicon-plus-sign:before{content:\"\\E081\"}.glyphicon-minus-sign:before{content:\"\\E082\"}.glyphicon-remove-sign:before{content:\"\\E083\"}.glyphicon-ok-sign:before{content:\"\\E084\"}.glyphicon-question-sign:before{content:\"\\E085\"}.glyphicon-info-sign:before{content:\"\\E086\"}.glyphicon-screenshot:before{content:\"\\E087\"}.glyphicon-remove-circle:before{content:\"\\E088\"}.glyphicon-ok-circle:before{content:\"\\E089\"}.glyphicon-ban-circle:before{content:\"\\E090\"}.glyphicon-arrow-left:before{content:\"\\E091\"}.glyphicon-arrow-right:before{content:\"\\E092\"}.glyphicon-arrow-up:before{content:\"\\E093\"}.glyphicon-arrow-down:before{content:\"\\E094\"}.glyphicon-share-alt:before{content:\"\\E095\"}.glyphicon-resize-full:before{content:\"\\E096\"}.glyphicon-resize-small:before{content:\"\\E097\"}.glyphicon-exclamation-sign:before{content:\"\\E101\"}.glyphicon-gift:before{content:\"\\E102\"}.glyphicon-leaf:before{content:\"\\E103\"}.glyphicon-fire:before{content:\"\\E104\"}.glyphicon-eye-open:before{content:\"\\E105\"}.glyphicon-eye-close:before{content:\"\\E106\"}.glyphicon-warning-sign:before{content:\"\\E107\"}.glyphicon-plane:before{content:\"\\E108\"}.glyphicon-calendar:before{content:\"\\E109\"}.glyphicon-random:before{content:\"\\E110\"}.glyphicon-comment:before{content:\"\\E111\"}.glyphicon-magnet:before{content:\"\\E112\"}.glyphicon-chevron-up:before{content:\"\\E113\"}.glyphicon-chevron-down:before{content:\"\\E114\"}.glyphicon-retweet:before{content:\"\\E115\"}.glyphicon-shopping-cart:before{content:\"\\E116\"}.glyphicon-folder-close:before{content:\"\\E117\"}.glyphicon-folder-open:before{content:\"\\E118\"}.glyphicon-resize-vertical:before{content:\"\\E119\"}.glyphicon-resize-horizontal:before{content:\"\\E120\"}.glyphicon-hdd:before{content:\"\\E121\"}.glyphicon-bullhorn:before{content:\"\\E122\"}.glyphicon-bell:before{content:\"\\E123\"}.glyphicon-certificate:before{content:\"\\E124\"}.glyphicon-thumbs-up:before{content:\"\\E125\"}.glyphicon-thumbs-down:before{content:\"\\E126\"}.glyphicon-hand-right:before{content:\"\\E127\"}.glyphicon-hand-left:before{content:\"\\E128\"}.glyphicon-hand-up:before{content:\"\\E129\"}.glyphicon-hand-down:before{content:\"\\E130\"}.glyphicon-circle-arrow-right:before{content:\"\\E131\"}.glyphicon-circle-arrow-left:before{content:\"\\E132\"}.glyphicon-circle-arrow-up:before{content:\"\\E133\"}.glyphicon-circle-arrow-down:before{content:\"\\E134\"}.glyphicon-globe:before{content:\"\\E135\"}.glyphicon-wrench:before{content:\"\\E136\"}.glyphicon-tasks:before{content:\"\\E137\"}.glyphicon-filter:before{content:\"\\E138\"}.glyphicon-briefcase:before{content:\"\\E139\"}.glyphicon-fullscreen:before{content:\"\\E140\"}.glyphicon-dashboard:before{content:\"\\E141\"}.glyphicon-paperclip:before{content:\"\\E142\"}.glyphicon-heart-empty:before{content:\"\\E143\"}.glyphicon-link:before{content:\"\\E144\"}.glyphicon-phone:before{content:\"\\E145\"}.glyphicon-pushpin:before{content:\"\\E146\"}.glyphicon-usd:before{content:\"\\E148\"}.glyphicon-gbp:before{content:\"\\E149\"}.glyphicon-sort:before{content:\"\\E150\"}.glyphicon-sort-by-alphabet:before{content:\"\\E151\"}.glyphicon-sort-by-alphabet-alt:before{content:\"\\E152\"}.glyphicon-sort-by-order:before{content:\"\\E153\"}.glyphicon-sort-by-order-alt:before{content:\"\\E154\"}.glyphicon-sort-by-attributes:before{content:\"\\E155\"}.glyphicon-sort-by-attributes-alt:before{content:\"\\E156\"}.glyphicon-unchecked:before{content:\"\\E157\"}.glyphicon-expand:before{content:\"\\E158\"}.glyphicon-collapse-down:before{content:\"\\E159\"}.glyphicon-collapse-up:before{content:\"\\E160\"}.glyphicon-log-in:before{content:\"\\E161\"}.glyphicon-flash:before{content:\"\\E162\"}.glyphicon-log-out:before{content:\"\\E163\"}.glyphicon-new-window:before{content:\"\\E164\"}.glyphicon-record:before{content:\"\\E165\"}.glyphicon-save:before{content:\"\\E166\"}.glyphicon-open:before{content:\"\\E167\"}.glyphicon-saved:before{content:\"\\E168\"}.glyphicon-import:before{content:\"\\E169\"}.glyphicon-export:before{content:\"\\E170\"}.glyphicon-send:before{content:\"\\E171\"}.glyphicon-floppy-disk:before{content:\"\\E172\"}.glyphicon-floppy-saved:before{content:\"\\E173\"}.glyphicon-floppy-remove:before{content:\"\\E174\"}.glyphicon-floppy-save:before{content:\"\\E175\"}.glyphicon-floppy-open:before{content:\"\\E176\"}.glyphicon-credit-card:before{content:\"\\E177\"}.glyphicon-transfer:before{content:\"\\E178\"}.glyphicon-cutlery:before{content:\"\\E179\"}.glyphicon-header:before{content:\"\\E180\"}.glyphicon-compressed:before{content:\"\\E181\"}.glyphicon-earphone:before{content:\"\\E182\"}.glyphicon-phone-alt:before{content:\"\\E183\"}.glyphicon-tower:before{content:\"\\E184\"}.glyphicon-stats:before{content:\"\\E185\"}.glyphicon-sd-video:before{content:\"\\E186\"}.glyphicon-hd-video:before{content:\"\\E187\"}.glyphicon-subtitles:before{content:\"\\E188\"}.glyphicon-sound-stereo:before{content:\"\\E189\"}.glyphicon-sound-dolby:before{content:\"\\E190\"}.glyphicon-sound-5-1:before{content:\"\\E191\"}.glyphicon-sound-6-1:before{content:\"\\E192\"}.glyphicon-sound-7-1:before{content:\"\\E193\"}.glyphicon-copyright-mark:before{content:\"\\E194\"}.glyphicon-registration-mark:before{content:\"\\E195\"}.glyphicon-cloud-download:before{content:\"\\E197\"}.glyphicon-cloud-upload:before{content:\"\\E198\"}.glyphicon-tree-conifer:before{content:\"\\E199\"}.glyphicon-tree-deciduous:before{content:\"\\E200\"}.glyphicon-cd:before{content:\"\\E201\"}.glyphicon-save-file:before{content:\"\\E202\"}.glyphicon-open-file:before{content:\"\\E203\"}.glyphicon-level-up:before{content:\"\\E204\"}.glyphicon-copy:before{content:\"\\E205\"}.glyphicon-paste:before{content:\"\\E206\"}.glyphicon-alert:before{content:\"\\E209\"}.glyphicon-equalizer:before{content:\"\\E210\"}.glyphicon-king:before{content:\"\\E211\"}.glyphicon-queen:before{content:\"\\E212\"}.glyphicon-pawn:before{content:\"\\E213\"}.glyphicon-bishop:before{content:\"\\E214\"}.glyphicon-knight:before{content:\"\\E215\"}.glyphicon-baby-formula:before{content:\"\\E216\"}.glyphicon-tent:before{content:\"\\26FA\"}.glyphicon-blackboard:before{content:\"\\E218\"}.glyphicon-bed:before{content:\"\\E219\"}.glyphicon-apple:before{content:\"\\F8FF\"}.glyphicon-erase:before{content:\"\\E221\"}.glyphicon-hourglass:before{content:\"\\231B\"}.glyphicon-lamp:before{content:\"\\E223\"}.glyphicon-duplicate:before{content:\"\\E224\"}.glyphicon-piggy-bank:before{content:\"\\E225\"}.glyphicon-scissors:before{content:\"\\E226\"}.glyphicon-bitcoin:before,.glyphicon-btc:before,.glyphicon-xbt:before{content:\"\\E227\"}.glyphicon-jpy:before,.glyphicon-yen:before{content:\"\\A5\"}.glyphicon-rub:before,.glyphicon-ruble:before{content:\"\\20BD\"}.glyphicon-scale:before{content:\"\\E230\"}.glyphicon-ice-lolly:before{content:\"\\E231\"}.glyphicon-ice-lolly-tasted:before{content:\"\\E232\"}.glyphicon-education:before{content:\"\\E233\"}.glyphicon-option-horizontal:before{content:\"\\E234\"}.glyphicon-option-vertical:before{content:\"\\E235\"}.glyphicon-menu-hamburger:before{content:\"\\E236\"}.glyphicon-modal-window:before{content:\"\\E237\"}.glyphicon-oil:before{content:\"\\E238\"}.glyphicon-grain:before{content:\"\\E239\"}.glyphicon-sunglasses:before{content:\"\\E240\"}.glyphicon-text-size:before{content:\"\\E241\"}.glyphicon-text-color:before{content:\"\\E242\"}.glyphicon-text-background:before{content:\"\\E243\"}.glyphicon-object-align-top:before{content:\"\\E244\"}.glyphicon-object-align-bottom:before{content:\"\\E245\"}.glyphicon-object-align-horizontal:before{content:\"\\E246\"}.glyphicon-object-align-left:before{content:\"\\E247\"}.glyphicon-object-align-vertical:before{content:\"\\E248\"}.glyphicon-object-align-right:before{content:\"\\E249\"}.glyphicon-triangle-right:before{content:\"\\E250\"}.glyphicon-triangle-left:before{content:\"\\E251\"}.glyphicon-triangle-bottom:before{content:\"\\E252\"}.glyphicon-triangle-top:before{content:\"\\E253\"}.glyphicon-console:before{content:\"\\E254\"}.glyphicon-superscript:before{content:\"\\E255\"}.glyphicon-subscript:before{content:\"\\E256\"}.glyphicon-menu-left:before{content:\"\\E257\"}.glyphicon-menu-right:before{content:\"\\E258\"}.glyphicon-menu-down:before{content:\"\\E259\"}.glyphicon-menu-up:before{content:\"\\E260\"}*,:after,:before{box-sizing:border-box}html{font-size:10px;-webkit-tap-highlight-color:rgba(0,0,0,0)}body{font-family:Helvetica Neue,Helvetica,Arial,sans-serif;font-size:14px;line-height:1.42857143;color:#333;background-color:#fff}button,input,select,textarea{font-family:inherit;font-size:inherit;line-height:inherit}a{color:#337ab7;text-decoration:none}a:focus,a:hover{color:#23527c;text-decoration:underline}a:focus{outline:5px auto -webkit-focus-ring-color;outline-offset:-2px}figure{margin:0}img{vertical-align:middle}.carousel-inner>.item>a>img,.carousel-inner>.item>img,.img-responsive,.thumbnail>img,.thumbnail a>img{display:block;max-width:100%;height:auto}.img-rounded{border-radius:6px}.img-thumbnail{display:inline-block;max-width:100%;height:auto;padding:4px;line-height:1.42857143;background-color:#fff;border:1px solid #ddd;border-radius:4px;transition:all .2s ease-in-out}.img-circle{border-radius:50%}hr{margin-top:20px;margin-bottom:20px;border:0;border-top:1px solid #eee}.sr-only{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);border:0}.sr-only-focusable:active,.sr-only-focusable:focus{position:static;width:auto;height:auto;margin:0;overflow:visible;clip:auto}[role=button]{cursor:pointer}.h1,.h2,.h3,.h4,.h5,.h6,h1,h2,h3,h4,h5,h6{font-family:inherit;font-weight:500;line-height:1.1;color:inherit}.h1 .small,.h1 small,.h2 .small,.h2 small,.h3 .small,.h3 small,.h4 .small,.h4 small,.h5 .small,.h5 small,.h6 .small,.h6 small,h1 .small,h1 small,h2 .small,h2 small,h3 .small,h3 small,h4 .small,h4 small,h5 .small,h5 small,h6 .small,h6 small{font-weight:400;line-height:1;color:#777}.h1,.h2,.h3,h1,h2,h3{margin-top:20px;margin-bottom:10px}.h1 .small,.h1 small,.h2 .small,.h2 small,.h3 .small,.h3 small,h1 .small,h1 small,h2 .small,h2 small,h3 .small,h3 small{font-size:65%}.h4,.h5,.h6,h4,h5,h6{margin-top:10px;margin-bottom:10px}.h4 .small,.h4 small,.h5 .small,.h5 small,.h6 .small,.h6 small,h4 .small,h4 small,h5 .small,h5 small,h6 .small,h6 small{font-size:75%}.h1,h1{font-size:36px}.h2,h2{font-size:30px}.h3,h3{font-size:24px}.h4,h4{font-size:18px}.h5,h5{font-size:14px}.h6,h6{font-size:12px}p{margin:0 0 10px}.lead{margin-bottom:20px;font-size:16px;font-weight:300;line-height:1.4}@media (min-width:768px){.lead{font-size:21px}}.small,small{font-size:85%}.mark,mark{padding:.2em;background-color:#fcf8e3}.text-left{text-align:left}.text-right{text-align:right}.text-center{text-align:center}.text-justify{text-align:justify}.text-nowrap{white-space:nowrap}.text-lowercase{text-transform:lowercase}.text-uppercase{text-transform:uppercase}.text-capitalize{text-transform:capitalize}.text-muted{color:#777}.text-primary{color:#337ab7}a.text-primary:focus,a.text-primary:hover{color:#286090}.text-success{color:#3c763d}a.text-success:focus,a.text-success:hover{color:#2b542c}.text-info{color:#31708f}a.text-info:focus,a.text-info:hover{color:#245269}.text-warning{color:#8a6d3b}a.text-warning:focus,a.text-warning:hover{color:#66512c}.text-danger{color:#a94442}a.text-danger:focus,a.text-danger:hover{color:#843534}.bg-primary{color:#fff;background-color:#337ab7}a.bg-primary:focus,a.bg-primary:hover{background-color:#286090}.bg-success{background-color:#dff0d8}a.bg-success:focus,a.bg-success:hover{background-color:#c1e2b3}.bg-info{background-color:#d9edf7}a.bg-info:focus,a.bg-info:hover{background-color:#afd9ee}.bg-warning{background-color:#fcf8e3}a.bg-warning:focus,a.bg-warning:hover{background-color:#f7ecb5}.bg-danger{background-color:#f2dede}a.bg-danger:focus,a.bg-danger:hover{background-color:#e4b9b9}.page-header{padding-bottom:9px;margin:40px 0 20px;border-bottom:1px solid #eee}ol,ul{margin-top:0;margin-bottom:10px}ol ol,ol ul,ul ol,ul ul{margin-bottom:0}.list-inline,.list-unstyled{padding-left:0;list-style:none}.list-inline{margin-left:-5px}.list-inline>li{display:inline-block;padding-right:5px;padding-left:5px}dl{margin-top:0;margin-bottom:20px}dd,dt{line-height:1.42857143}dt{font-weight:700}dd{margin-left:0}@media (min-width:768px){.dl-horizontal dt{float:left;width:160px;overflow:hidden;clear:left;text-align:right;text-overflow:ellipsis;white-space:nowrap}.dl-horizontal dd{margin-left:180px}}abbr[data-original-title],abbr[title]{cursor:help;border-bottom:1px dotted #777}.initialism{font-size:90%;text-transform:uppercase}blockquote{padding:10px 20px;margin:0 0 20px;font-size:17.5px;border-left:5px solid #eee}blockquote ol:last-child,blockquote p:last-child,blockquote ul:last-child{margin-bottom:0}blockquote .small,blockquote footer,blockquote small{display:block;font-size:80%;line-height:1.42857143;color:#777}blockquote .small:before,blockquote footer:before,blockquote small:before{content:\"\\2014   \\A0\"}.blockquote-reverse,blockquote.pull-right{padding-right:15px;padding-left:0;text-align:right;border-right:5px solid #eee;border-left:0}.blockquote-reverse .small:before,.blockquote-reverse footer:before,.blockquote-reverse small:before,blockquote.pull-right .small:before,blockquote.pull-right footer:before,blockquote.pull-right small:before{content:\"\"}.blockquote-reverse .small:after,.blockquote-reverse footer:after,.blockquote-reverse small:after,blockquote.pull-right .small:after,blockquote.pull-right footer:after,blockquote.pull-right small:after{content:\"\\A0   \\2014\"}address{margin-bottom:20px;font-style:normal;line-height:1.42857143}code,kbd,pre,samp{font-family:Menlo,Monaco,Consolas,Courier New,monospace}code{color:#c7254e;background-color:#f9f2f4;border-radius:4px}code,kbd{padding:2px 4px;font-size:90%}kbd{color:#fff;background-color:#333;border-radius:3px;box-shadow:inset 0 -1px 0 rgba(0,0,0,.25)}kbd kbd{padding:0;font-size:100%;font-weight:700;box-shadow:none}pre{display:block;padding:9.5px;margin:0 0 10px;font-size:13px;line-height:1.42857143;color:#333;word-break:break-all;word-wrap:break-word;background-color:#f5f5f5;border:1px solid #ccc;border-radius:4px}pre code{padding:0;font-size:inherit;color:inherit;white-space:pre-wrap;background-color:transparent;border-radius:0}.pre-scrollable{max-height:340px;overflow-y:scroll}.container{padding-right:15px;padding-left:15px;margin-right:auto;margin-left:auto}@media (min-width:768px){.container{width:750px}}@media (min-width:992px){.container{width:970px}}@media (min-width:1200px){.container{width:1170px}}.container-fluid{padding-right:15px;padding-left:15px;margin-right:auto;margin-left:auto}.row{margin-right:-15px;margin-left:-15px}.col-lg-1,.col-lg-2,.col-lg-3,.col-lg-4,.col-lg-5,.col-lg-6,.col-lg-7,.col-lg-8,.col-lg-9,.col-lg-10,.col-lg-11,.col-lg-12,.col-md-1,.col-md-2,.col-md-3,.col-md-4,.col-md-5,.col-md-6,.col-md-7,.col-md-8,.col-md-9,.col-md-10,.col-md-11,.col-md-12,.col-sm-1,.col-sm-2,.col-sm-3,.col-sm-4,.col-sm-5,.col-sm-6,.col-sm-7,.col-sm-8,.col-sm-9,.col-sm-10,.col-sm-11,.col-sm-12,.col-xs-1,.col-xs-2,.col-xs-3,.col-xs-4,.col-xs-5,.col-xs-6,.col-xs-7,.col-xs-8,.col-xs-9,.col-xs-10,.col-xs-11,.col-xs-12{position:relative;min-height:1px;padding-right:15px;padding-left:15px}.col-xs-1,.col-xs-2,.col-xs-3,.col-xs-4,.col-xs-5,.col-xs-6,.col-xs-7,.col-xs-8,.col-xs-9,.col-xs-10,.col-xs-11,.col-xs-12{float:left}.col-xs-12{width:100%}.col-xs-11{width:91.66666667%}.col-xs-10{width:83.33333333%}.col-xs-9{width:75%}.col-xs-8{width:66.66666667%}.col-xs-7{width:58.33333333%}.col-xs-6{width:50%}.col-xs-5{width:41.66666667%}.col-xs-4{width:33.33333333%}.col-xs-3{width:25%}.col-xs-2{width:16.66666667%}.col-xs-1{width:8.33333333%}.col-xs-pull-12{right:100%}.col-xs-pull-11{right:91.66666667%}.col-xs-pull-10{right:83.33333333%}.col-xs-pull-9{right:75%}.col-xs-pull-8{right:66.66666667%}.col-xs-pull-7{right:58.33333333%}.col-xs-pull-6{right:50%}.col-xs-pull-5{right:41.66666667%}.col-xs-pull-4{right:33.33333333%}.col-xs-pull-3{right:25%}.col-xs-pull-2{right:16.66666667%}.col-xs-pull-1{right:8.33333333%}.col-xs-pull-0{right:auto}.col-xs-push-12{left:100%}.col-xs-push-11{left:91.66666667%}.col-xs-push-10{left:83.33333333%}.col-xs-push-9{left:75%}.col-xs-push-8{left:66.66666667%}.col-xs-push-7{left:58.33333333%}.col-xs-push-6{left:50%}.col-xs-push-5{left:41.66666667%}.col-xs-push-4{left:33.33333333%}.col-xs-push-3{left:25%}.col-xs-push-2{left:16.66666667%}.col-xs-push-1{left:8.33333333%}.col-xs-push-0{left:auto}.col-xs-offset-12{margin-left:100%}.col-xs-offset-11{margin-left:91.66666667%}.col-xs-offset-10{margin-left:83.33333333%}.col-xs-offset-9{margin-left:75%}.col-xs-offset-8{margin-left:66.66666667%}.col-xs-offset-7{margin-left:58.33333333%}.col-xs-offset-6{margin-left:50%}.col-xs-offset-5{margin-left:41.66666667%}.col-xs-offset-4{margin-left:33.33333333%}.col-xs-offset-3{margin-left:25%}.col-xs-offset-2{margin-left:16.66666667%}.col-xs-offset-1{margin-left:8.33333333%}.col-xs-offset-0{margin-left:0}@media (min-width:768px){.col-sm-1,.col-sm-2,.col-sm-3,.col-sm-4,.col-sm-5,.col-sm-6,.col-sm-7,.col-sm-8,.col-sm-9,.col-sm-10,.col-sm-11,.col-sm-12{float:left}.col-sm-12{width:100%}.col-sm-11{width:91.66666667%}.col-sm-10{width:83.33333333%}.col-sm-9{width:75%}.col-sm-8{width:66.66666667%}.col-sm-7{width:58.33333333%}.col-sm-6{width:50%}.col-sm-5{width:41.66666667%}.col-sm-4{width:33.33333333%}.col-sm-3{width:25%}.col-sm-2{width:16.66666667%}.col-sm-1{width:8.33333333%}.col-sm-pull-12{right:100%}.col-sm-pull-11{right:91.66666667%}.col-sm-pull-10{right:83.33333333%}.col-sm-pull-9{right:75%}.col-sm-pull-8{right:66.66666667%}.col-sm-pull-7{right:58.33333333%}.col-sm-pull-6{right:50%}.col-sm-pull-5{right:41.66666667%}.col-sm-pull-4{right:33.33333333%}.col-sm-pull-3{right:25%}.col-sm-pull-2{right:16.66666667%}.col-sm-pull-1{right:8.33333333%}.col-sm-pull-0{right:auto}.col-sm-push-12{left:100%}.col-sm-push-11{left:91.66666667%}.col-sm-push-10{left:83.33333333%}.col-sm-push-9{left:75%}.col-sm-push-8{left:66.66666667%}.col-sm-push-7{left:58.33333333%}.col-sm-push-6{left:50%}.col-sm-push-5{left:41.66666667%}.col-sm-push-4{left:33.33333333%}.col-sm-push-3{left:25%}.col-sm-push-2{left:16.66666667%}.col-sm-push-1{left:8.33333333%}.col-sm-push-0{left:auto}.col-sm-offset-12{margin-left:100%}.col-sm-offset-11{margin-left:91.66666667%}.col-sm-offset-10{margin-left:83.33333333%}.col-sm-offset-9{margin-left:75%}.col-sm-offset-8{margin-left:66.66666667%}.col-sm-offset-7{margin-left:58.33333333%}.col-sm-offset-6{margin-left:50%}.col-sm-offset-5{margin-left:41.66666667%}.col-sm-offset-4{margin-left:33.33333333%}.col-sm-offset-3{margin-left:25%}.col-sm-offset-2{margin-left:16.66666667%}.col-sm-offset-1{margin-left:8.33333333%}.col-sm-offset-0{margin-left:0}}@media (min-width:992px){.col-md-1,.col-md-2,.col-md-3,.col-md-4,.col-md-5,.col-md-6,.col-md-7,.col-md-8,.col-md-9,.col-md-10,.col-md-11,.col-md-12{float:left}.col-md-12{width:100%}.col-md-11{width:91.66666667%}.col-md-10{width:83.33333333%}.col-md-9{width:75%}.col-md-8{width:66.66666667%}.col-md-7{width:58.33333333%}.col-md-6{width:50%}.col-md-5{width:41.66666667%}.col-md-4{width:33.33333333%}.col-md-3{width:25%}.col-md-2{width:16.66666667%}.col-md-1{width:8.33333333%}.col-md-pull-12{right:100%}.col-md-pull-11{right:91.66666667%}.col-md-pull-10{right:83.33333333%}.col-md-pull-9{right:75%}.col-md-pull-8{right:66.66666667%}.col-md-pull-7{right:58.33333333%}.col-md-pull-6{right:50%}.col-md-pull-5{right:41.66666667%}.col-md-pull-4{right:33.33333333%}.col-md-pull-3{right:25%}.col-md-pull-2{right:16.66666667%}.col-md-pull-1{right:8.33333333%}.col-md-pull-0{right:auto}.col-md-push-12{left:100%}.col-md-push-11{left:91.66666667%}.col-md-push-10{left:83.33333333%}.col-md-push-9{left:75%}.col-md-push-8{left:66.66666667%}.col-md-push-7{left:58.33333333%}.col-md-push-6{left:50%}.col-md-push-5{left:41.66666667%}.col-md-push-4{left:33.33333333%}.col-md-push-3{left:25%}.col-md-push-2{left:16.66666667%}.col-md-push-1{left:8.33333333%}.col-md-push-0{left:auto}.col-md-offset-12{margin-left:100%}.col-md-offset-11{margin-left:91.66666667%}.col-md-offset-10{margin-left:83.33333333%}.col-md-offset-9{margin-left:75%}.col-md-offset-8{margin-left:66.66666667%}.col-md-offset-7{margin-left:58.33333333%}.col-md-offset-6{margin-left:50%}.col-md-offset-5{margin-left:41.66666667%}.col-md-offset-4{margin-left:33.33333333%}.col-md-offset-3{margin-left:25%}.col-md-offset-2{margin-left:16.66666667%}.col-md-offset-1{margin-left:8.33333333%}.col-md-offset-0{margin-left:0}}@media (min-width:1200px){.col-lg-1,.col-lg-2,.col-lg-3,.col-lg-4,.col-lg-5,.col-lg-6,.col-lg-7,.col-lg-8,.col-lg-9,.col-lg-10,.col-lg-11,.col-lg-12{float:left}.col-lg-12{width:100%}.col-lg-11{width:91.66666667%}.col-lg-10{width:83.33333333%}.col-lg-9{width:75%}.col-lg-8{width:66.66666667%}.col-lg-7{width:58.33333333%}.col-lg-6{width:50%}.col-lg-5{width:41.66666667%}.col-lg-4{width:33.33333333%}.col-lg-3{width:25%}.col-lg-2{width:16.66666667%}.col-lg-1{width:8.33333333%}.col-lg-pull-12{right:100%}.col-lg-pull-11{right:91.66666667%}.col-lg-pull-10{right:83.33333333%}.col-lg-pull-9{right:75%}.col-lg-pull-8{right:66.66666667%}.col-lg-pull-7{right:58.33333333%}.col-lg-pull-6{right:50%}.col-lg-pull-5{right:41.66666667%}.col-lg-pull-4{right:33.33333333%}.col-lg-pull-3{right:25%}.col-lg-pull-2{right:16.66666667%}.col-lg-pull-1{right:8.33333333%}.col-lg-pull-0{right:auto}.col-lg-push-12{left:100%}.col-lg-push-11{left:91.66666667%}.col-lg-push-10{left:83.33333333%}.col-lg-push-9{left:75%}.col-lg-push-8{left:66.66666667%}.col-lg-push-7{left:58.33333333%}.col-lg-push-6{left:50%}.col-lg-push-5{left:41.66666667%}.col-lg-push-4{left:33.33333333%}.col-lg-push-3{left:25%}.col-lg-push-2{left:16.66666667%}.col-lg-push-1{left:8.33333333%}.col-lg-push-0{left:auto}.col-lg-offset-12{margin-left:100%}.col-lg-offset-11{margin-left:91.66666667%}.col-lg-offset-10{margin-left:83.33333333%}.col-lg-offset-9{margin-left:75%}.col-lg-offset-8{margin-left:66.66666667%}.col-lg-offset-7{margin-left:58.33333333%}.col-lg-offset-6{margin-left:50%}.col-lg-offset-5{margin-left:41.66666667%}.col-lg-offset-4{margin-left:33.33333333%}.col-lg-offset-3{margin-left:25%}.col-lg-offset-2{margin-left:16.66666667%}.col-lg-offset-1{margin-left:8.33333333%}.col-lg-offset-0{margin-left:0}}table{background-color:transparent}caption{padding-top:8px;padding-bottom:8px;color:#777}caption,th{text-align:left}.table{width:100%;max-width:100%;margin-bottom:20px}.table>tbody>tr>td,.table>tbody>tr>th,.table>tfoot>tr>td,.table>tfoot>tr>th,.table>thead>tr>td,.table>thead>tr>th{padding:8px;line-height:1.42857143;vertical-align:top;border-top:1px solid #ddd}.table>thead>tr>th{vertical-align:bottom;border-bottom:2px solid #ddd}.table>caption+thead>tr:first-child>td,.table>caption+thead>tr:first-child>th,.table>colgroup+thead>tr:first-child>td,.table>colgroup+thead>tr:first-child>th,.table>thead:first-child>tr:first-child>td,.table>thead:first-child>tr:first-child>th{border-top:0}.table>tbody+tbody{border-top:2px solid #ddd}.table .table{background-color:#fff}.table-condensed>tbody>tr>td,.table-condensed>tbody>tr>th,.table-condensed>tfoot>tr>td,.table-condensed>tfoot>tr>th,.table-condensed>thead>tr>td,.table-condensed>thead>tr>th{padding:5px}.table-bordered,.table-bordered>tbody>tr>td,.table-bordered>tbody>tr>th,.table-bordered>tfoot>tr>td,.table-bordered>tfoot>tr>th,.table-bordered>thead>tr>td,.table-bordered>thead>tr>th{border:1px solid #ddd}.table-bordered>thead>tr>td,.table-bordered>thead>tr>th{border-bottom-width:2px}.table-striped>tbody>tr:nth-of-type(odd){background-color:#f9f9f9}.table-hover>tbody>tr:hover{background-color:#f5f5f5}table col[class*=col-]{position:static;display:table-column;float:none}table td[class*=col-],table th[class*=col-]{position:static;display:table-cell;float:none}.table>tbody>tr.active>td,.table>tbody>tr.active>th,.table>tbody>tr>td.active,.table>tbody>tr>th.active,.table>tfoot>tr.active>td,.table>tfoot>tr.active>th,.table>tfoot>tr>td.active,.table>tfoot>tr>th.active,.table>thead>tr.active>td,.table>thead>tr.active>th,.table>thead>tr>td.active,.table>thead>tr>th.active{background-color:#f5f5f5}.table-hover>tbody>tr.active:hover>td,.table-hover>tbody>tr.active:hover>th,.table-hover>tbody>tr:hover>.active,.table-hover>tbody>tr>td.active:hover,.table-hover>tbody>tr>th.active:hover{background-color:#e8e8e8}.table>tbody>tr.success>td,.table>tbody>tr.success>th,.table>tbody>tr>td.success,.table>tbody>tr>th.success,.table>tfoot>tr.success>td,.table>tfoot>tr.success>th,.table>tfoot>tr>td.success,.table>tfoot>tr>th.success,.table>thead>tr.success>td,.table>thead>tr.success>th,.table>thead>tr>td.success,.table>thead>tr>th.success{background-color:#dff0d8}.table-hover>tbody>tr.success:hover>td,.table-hover>tbody>tr.success:hover>th,.table-hover>tbody>tr:hover>.success,.table-hover>tbody>tr>td.success:hover,.table-hover>tbody>tr>th.success:hover{background-color:#d0e9c6}.table>tbody>tr.info>td,.table>tbody>tr.info>th,.table>tbody>tr>td.info,.table>tbody>tr>th.info,.table>tfoot>tr.info>td,.table>tfoot>tr.info>th,.table>tfoot>tr>td.info,.table>tfoot>tr>th.info,.table>thead>tr.info>td,.table>thead>tr.info>th,.table>thead>tr>td.info,.table>thead>tr>th.info{background-color:#d9edf7}.table-hover>tbody>tr.info:hover>td,.table-hover>tbody>tr.info:hover>th,.table-hover>tbody>tr:hover>.info,.table-hover>tbody>tr>td.info:hover,.table-hover>tbody>tr>th.info:hover{background-color:#c4e3f3}.table>tbody>tr.warning>td,.table>tbody>tr.warning>th,.table>tbody>tr>td.warning,.table>tbody>tr>th.warning,.table>tfoot>tr.warning>td,.table>tfoot>tr.warning>th,.table>tfoot>tr>td.warning,.table>tfoot>tr>th.warning,.table>thead>tr.warning>td,.table>thead>tr.warning>th,.table>thead>tr>td.warning,.table>thead>tr>th.warning{background-color:#fcf8e3}.table-hover>tbody>tr.warning:hover>td,.table-hover>tbody>tr.warning:hover>th,.table-hover>tbody>tr:hover>.warning,.table-hover>tbody>tr>td.warning:hover,.table-hover>tbody>tr>th.warning:hover{background-color:#faf2cc}.table>tbody>tr.danger>td,.table>tbody>tr.danger>th,.table>tbody>tr>td.danger,.table>tbody>tr>th.danger,.table>tfoot>tr.danger>td,.table>tfoot>tr.danger>th,.table>tfoot>tr>td.danger,.table>tfoot>tr>th.danger,.table>thead>tr.danger>td,.table>thead>tr.danger>th,.table>thead>tr>td.danger,.table>thead>tr>th.danger{background-color:#f2dede}.table-hover>tbody>tr.danger:hover>td,.table-hover>tbody>tr.danger:hover>th,.table-hover>tbody>tr:hover>.danger,.table-hover>tbody>tr>td.danger:hover,.table-hover>tbody>tr>th.danger:hover{background-color:#ebcccc}.table-responsive{min-height:.01%;overflow-x:auto}@media screen and (max-width:767px){.table-responsive{width:100%;margin-bottom:15px;overflow-y:hidden;-ms-overflow-style:-ms-autohiding-scrollbar;border:1px solid #ddd}.table-responsive>.table{margin-bottom:0}.table-responsive>.table>tbody>tr>td,.table-responsive>.table>tbody>tr>th,.table-responsive>.table>tfoot>tr>td,.table-responsive>.table>tfoot>tr>th,.table-responsive>.table>thead>tr>td,.table-responsive>.table>thead>tr>th{white-space:nowrap}.table-responsive>.table-bordered{border:0}.table-responsive>.table-bordered>tbody>tr>td:first-child,.table-responsive>.table-bordered>tbody>tr>th:first-child,.table-responsive>.table-bordered>tfoot>tr>td:first-child,.table-responsive>.table-bordered>tfoot>tr>th:first-child,.table-responsive>.table-bordered>thead>tr>td:first-child,.table-responsive>.table-bordered>thead>tr>th:first-child{border-left:0}.table-responsive>.table-bordered>tbody>tr>td:last-child,.table-responsive>.table-bordered>tbody>tr>th:last-child,.table-responsive>.table-bordered>tfoot>tr>td:last-child,.table-responsive>.table-bordered>tfoot>tr>th:last-child,.table-responsive>.table-bordered>thead>tr>td:last-child,.table-responsive>.table-bordered>thead>tr>th:last-child{border-right:0}.table-responsive>.table-bordered>tbody>tr:last-child>td,.table-responsive>.table-bordered>tbody>tr:last-child>th,.table-responsive>.table-bordered>tfoot>tr:last-child>td,.table-responsive>.table-bordered>tfoot>tr:last-child>th{border-bottom:0}}fieldset{min-width:0;margin:0}fieldset,legend{padding:0;border:0}legend{display:block;width:100%;margin-bottom:20px;font-size:21px;line-height:inherit;color:#333;border-bottom:1px solid #e5e5e5}label{display:inline-block;max-width:100%;margin-bottom:5px;font-weight:700}input[type=search]{box-sizing:border-box}input[type=checkbox],input[type=radio]{margin:4px 0 0;margin-top:1px\\9;line-height:normal}input[type=file]{display:block}input[type=range]{display:block;width:100%}select[multiple],select[size]{height:auto}input[type=checkbox]:focus,input[type=file]:focus,input[type=radio]:focus{outline:5px auto -webkit-focus-ring-color;outline-offset:-2px}output{padding-top:7px}.form-control,output{display:block;font-size:14px;line-height:1.42857143;color:#555}.form-control{width:100%;height:34px;padding:6px 12px;background-color:#fff;background-image:none;border:1px solid #ccc;border-radius:4px;box-shadow:inset 0 1px 1px rgba(0,0,0,.075);transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out}.form-control:focus{border-color:#66afe9;outline:0;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(102,175,233,.6)}.form-control::-moz-placeholder{color:#999;opacity:1}.form-control:-ms-input-placeholder{color:#999}.form-control::-webkit-input-placeholder{color:#999}.form-control::-ms-expand{background-color:transparent;border:0}.form-control[disabled],.form-control[readonly],fieldset[disabled] .form-control{background-color:#eee;opacity:1}.form-control[disabled],fieldset[disabled] .form-control{cursor:not-allowed}textarea.form-control{height:auto}input[type=search]{-webkit-appearance:none}@media screen and (-webkit-min-device-pixel-ratio:0){input[type=date].form-control,input[type=datetime-local].form-control,input[type=month].form-control,input[type=time].form-control{line-height:34px}.input-group-sm input[type=date],.input-group-sm input[type=datetime-local],.input-group-sm input[type=month],.input-group-sm input[type=time],input[type=date].input-sm,input[type=datetime-local].input-sm,input[type=month].input-sm,input[type=time].input-sm{line-height:30px}.input-group-lg input[type=date],.input-group-lg input[type=datetime-local],.input-group-lg input[type=month],.input-group-lg input[type=time],input[type=date].input-lg,input[type=datetime-local].input-lg,input[type=month].input-lg,input[type=time].input-lg{line-height:46px}}.form-group{margin-bottom:15px}.checkbox,.radio{position:relative;display:block;margin-top:10px;margin-bottom:10px}.checkbox label,.radio label{min-height:20px;padding-left:20px;margin-bottom:0;font-weight:400;cursor:pointer}.checkbox-inline input[type=checkbox],.checkbox input[type=checkbox],.radio-inline input[type=radio],.radio input[type=radio]{position:absolute;margin-top:4px\\9;margin-left:-20px}.checkbox+.checkbox,.radio+.radio{margin-top:-5px}.checkbox-inline,.radio-inline{position:relative;display:inline-block;padding-left:20px;margin-bottom:0;font-weight:400;vertical-align:middle;cursor:pointer}.checkbox-inline+.checkbox-inline,.radio-inline+.radio-inline{margin-top:0;margin-left:10px}.checkbox-inline.disabled,.checkbox.disabled label,.radio-inline.disabled,.radio.disabled label,fieldset[disabled] .checkbox-inline,fieldset[disabled] .checkbox label,fieldset[disabled] .radio-inline,fieldset[disabled] .radio label,fieldset[disabled] input[type=checkbox],fieldset[disabled] input[type=radio],input[type=checkbox].disabled,input[type=checkbox][disabled],input[type=radio].disabled,input[type=radio][disabled]{cursor:not-allowed}.form-control-static{min-height:34px;padding-top:7px;padding-bottom:7px;margin-bottom:0}.form-control-static.input-lg,.form-control-static.input-sm{padding-right:0;padding-left:0}.input-sm{height:30px;padding:5px 10px;font-size:12px;line-height:1.5;border-radius:3px}select.input-sm{height:30px;line-height:30px}select[multiple].input-sm,textarea.input-sm{height:auto}.form-group-sm .form-control{height:30px;padding:5px 10px;font-size:12px;line-height:1.5;border-radius:3px}.form-group-sm select.form-control{height:30px;line-height:30px}.form-group-sm select[multiple].form-control,.form-group-sm textarea.form-control{height:auto}.form-group-sm .form-control-static{height:30px;min-height:32px;padding:6px 10px;font-size:12px;line-height:1.5}.input-lg{height:46px;padding:10px 16px;font-size:18px;line-height:1.3333333;border-radius:6px}select.input-lg{height:46px;line-height:46px}select[multiple].input-lg,textarea.input-lg{height:auto}.form-group-lg .form-control{height:46px;padding:10px 16px;font-size:18px;line-height:1.3333333;border-radius:6px}.form-group-lg select.form-control{height:46px;line-height:46px}.form-group-lg select[multiple].form-control,.form-group-lg textarea.form-control{height:auto}.form-group-lg .form-control-static{height:46px;min-height:38px;padding:11px 16px;font-size:18px;line-height:1.3333333}.has-feedback{position:relative}.has-feedback .form-control{padding-right:42.5px}.form-control-feedback{position:absolute;top:0;right:0;z-index:2;display:block;width:34px;height:34px;line-height:34px;text-align:center;pointer-events:none}.form-group-lg .form-control+.form-control-feedback,.input-group-lg+.form-control-feedback,.input-lg+.form-control-feedback{width:46px;height:46px;line-height:46px}.form-group-sm .form-control+.form-control-feedback,.input-group-sm+.form-control-feedback,.input-sm+.form-control-feedback{width:30px;height:30px;line-height:30px}.has-success .checkbox,.has-success .checkbox-inline,.has-success.checkbox-inline label,.has-success.checkbox label,.has-success .control-label,.has-success .help-block,.has-success .radio,.has-success .radio-inline,.has-success.radio-inline label,.has-success.radio label{color:#3c763d}.has-success .form-control{border-color:#3c763d;box-shadow:inset 0 1px 1px rgba(0,0,0,.075)}.has-success .form-control:focus{border-color:#2b542c;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #67b168}.has-success .input-group-addon{color:#3c763d;background-color:#dff0d8;border-color:#3c763d}.has-success .form-control-feedback{color:#3c763d}.has-warning .checkbox,.has-warning .checkbox-inline,.has-warning.checkbox-inline label,.has-warning.checkbox label,.has-warning .control-label,.has-warning .help-block,.has-warning .radio,.has-warning .radio-inline,.has-warning.radio-inline label,.has-warning.radio label{color:#8a6d3b}.has-warning .form-control{border-color:#8a6d3b;box-shadow:inset 0 1px 1px rgba(0,0,0,.075)}.has-warning .form-control:focus{border-color:#66512c;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #c0a16b}.has-warning .input-group-addon{color:#8a6d3b;background-color:#fcf8e3;border-color:#8a6d3b}.has-warning .form-control-feedback{color:#8a6d3b}.has-error .checkbox,.has-error .checkbox-inline,.has-error.checkbox-inline label,.has-error.checkbox label,.has-error .control-label,.has-error .help-block,.has-error .radio,.has-error .radio-inline,.has-error.radio-inline label,.has-error.radio label{color:#a94442}.has-error .form-control{border-color:#a94442;box-shadow:inset 0 1px 1px rgba(0,0,0,.075)}.has-error .form-control:focus{border-color:#843534;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #ce8483}.has-error .input-group-addon{color:#a94442;background-color:#f2dede;border-color:#a94442}.has-error .form-control-feedback{color:#a94442}.has-feedback label~.form-control-feedback{top:25px}.has-feedback label.sr-only~.form-control-feedback{top:0}.help-block{display:block;margin-top:5px;margin-bottom:10px;color:#737373}@media (min-width:768px){.form-inline .form-group{display:inline-block;margin-bottom:0;vertical-align:middle}.form-inline .form-control{display:inline-block;width:auto;vertical-align:middle}.form-inline .form-control-static{display:inline-block}.form-inline .input-group{display:inline-table;vertical-align:middle}.form-inline .input-group .form-control,.form-inline .input-group .input-group-addon,.form-inline .input-group .input-group-btn{width:auto}.form-inline .input-group>.form-control{width:100%}.form-inline .control-label{margin-bottom:0;vertical-align:middle}.form-inline .checkbox,.form-inline .radio{display:inline-block;margin-top:0;margin-bottom:0;vertical-align:middle}.form-inline .checkbox label,.form-inline .radio label{padding-left:0}.form-inline .checkbox input[type=checkbox],.form-inline .radio input[type=radio]{position:relative;margin-left:0}.form-inline .has-feedback .form-control-feedback{top:0}}.form-horizontal .checkbox,.form-horizontal .checkbox-inline,.form-horizontal .radio,.form-horizontal .radio-inline{padding-top:7px;margin-top:0;margin-bottom:0}.form-horizontal .checkbox,.form-horizontal .radio{min-height:27px}.form-horizontal .form-group{margin-right:-15px;margin-left:-15px}@media (min-width:768px){.form-horizontal .control-label{padding-top:7px;margin-bottom:0;text-align:right}}.form-horizontal .has-feedback .form-control-feedback{right:15px}@media (min-width:768px){.form-horizontal .form-group-lg .control-label{padding-top:11px;font-size:18px}}@media (min-width:768px){.form-horizontal .form-group-sm .control-label{padding-top:6px;font-size:12px}}.btn{display:inline-block;padding:6px 12px;margin-bottom:0;font-size:14px;font-weight:400;line-height:1.42857143;text-align:center;white-space:nowrap;vertical-align:middle;-ms-touch-action:manipulation;touch-action:manipulation;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;background-image:none;border:1px solid transparent;border-radius:4px}.btn.active.focus,.btn.active:focus,.btn.focus,.btn:active.focus,.btn:active:focus,.btn:focus{outline:5px auto -webkit-focus-ring-color;outline-offset:-2px}.btn.focus,.btn:focus,.btn:hover{color:#333;text-decoration:none}.btn.active,.btn:active{background-image:none;outline:0;box-shadow:inset 0 3px 5px rgba(0,0,0,.125)}.btn.disabled,.btn[disabled],fieldset[disabled] .btn{cursor:not-allowed;filter:alpha(opacity=65);box-shadow:none;opacity:.65}a.btn.disabled,fieldset[disabled] a.btn{pointer-events:none}.btn-default{color:#333;background-color:#fff;border-color:#ccc}.btn-default.focus,.btn-default:focus{color:#333;background-color:#e6e6e6;border-color:#8c8c8c}.btn-default.active,.btn-default:active,.btn-default:hover,.open>.dropdown-toggle.btn-default{color:#333;background-color:#e6e6e6;border-color:#adadad}.btn-default.active.focus,.btn-default.active:focus,.btn-default.active:hover,.btn-default:active.focus,.btn-default:active:focus,.btn-default:active:hover,.open>.dropdown-toggle.btn-default.focus,.open>.dropdown-toggle.btn-default:focus,.open>.dropdown-toggle.btn-default:hover{color:#333;background-color:#d4d4d4;border-color:#8c8c8c}.btn-default.active,.btn-default:active,.open>.dropdown-toggle.btn-default{background-image:none}.btn-default.disabled.focus,.btn-default.disabled:focus,.btn-default.disabled:hover,.btn-default[disabled].focus,.btn-default[disabled]:focus,.btn-default[disabled]:hover,fieldset[disabled] .btn-default.focus,fieldset[disabled] .btn-default:focus,fieldset[disabled] .btn-default:hover{background-color:#fff;border-color:#ccc}.btn-default .badge{color:#fff;background-color:#333}.btn-primary{color:#fff;background-color:#337ab7;border-color:#2e6da4}.btn-primary.focus,.btn-primary:focus{color:#fff;background-color:#286090;border-color:#122b40}.btn-primary.active,.btn-primary:active,.btn-primary:hover,.open>.dropdown-toggle.btn-primary{color:#fff;background-color:#286090;border-color:#204d74}.btn-primary.active.focus,.btn-primary.active:focus,.btn-primary.active:hover,.btn-primary:active.focus,.btn-primary:active:focus,.btn-primary:active:hover,.open>.dropdown-toggle.btn-primary.focus,.open>.dropdown-toggle.btn-primary:focus,.open>.dropdown-toggle.btn-primary:hover{color:#fff;background-color:#204d74;border-color:#122b40}.btn-primary.active,.btn-primary:active,.open>.dropdown-toggle.btn-primary{background-image:none}.btn-primary.disabled.focus,.btn-primary.disabled:focus,.btn-primary.disabled:hover,.btn-primary[disabled].focus,.btn-primary[disabled]:focus,.btn-primary[disabled]:hover,fieldset[disabled] .btn-primary.focus,fieldset[disabled] .btn-primary:focus,fieldset[disabled] .btn-primary:hover{background-color:#337ab7;border-color:#2e6da4}.btn-primary .badge{color:#337ab7;background-color:#fff}.btn-success{color:#fff;background-color:#5cb85c;border-color:#4cae4c}.btn-success.focus,.btn-success:focus{color:#fff;background-color:#449d44;border-color:#255625}.btn-success.active,.btn-success:active,.btn-success:hover,.open>.dropdown-toggle.btn-success{color:#fff;background-color:#449d44;border-color:#398439}.btn-success.active.focus,.btn-success.active:focus,.btn-success.active:hover,.btn-success:active.focus,.btn-success:active:focus,.btn-success:active:hover,.open>.dropdown-toggle.btn-success.focus,.open>.dropdown-toggle.btn-success:focus,.open>.dropdown-toggle.btn-success:hover{color:#fff;background-color:#398439;border-color:#255625}.btn-success.active,.btn-success:active,.open>.dropdown-toggle.btn-success{background-image:none}.btn-success.disabled.focus,.btn-success.disabled:focus,.btn-success.disabled:hover,.btn-success[disabled].focus,.btn-success[disabled]:focus,.btn-success[disabled]:hover,fieldset[disabled] .btn-success.focus,fieldset[disabled] .btn-success:focus,fieldset[disabled] .btn-success:hover{background-color:#5cb85c;border-color:#4cae4c}.btn-success .badge{color:#5cb85c;background-color:#fff}.btn-info{color:#fff;background-color:#5bc0de;border-color:#46b8da}.btn-info.focus,.btn-info:focus{color:#fff;background-color:#31b0d5;border-color:#1b6d85}.btn-info.active,.btn-info:active,.btn-info:hover,.open>.dropdown-toggle.btn-info{color:#fff;background-color:#31b0d5;border-color:#269abc}.btn-info.active.focus,.btn-info.active:focus,.btn-info.active:hover,.btn-info:active.focus,.btn-info:active:focus,.btn-info:active:hover,.open>.dropdown-toggle.btn-info.focus,.open>.dropdown-toggle.btn-info:focus,.open>.dropdown-toggle.btn-info:hover{color:#fff;background-color:#269abc;border-color:#1b6d85}.btn-info.active,.btn-info:active,.open>.dropdown-toggle.btn-info{background-image:none}.btn-info.disabled.focus,.btn-info.disabled:focus,.btn-info.disabled:hover,.btn-info[disabled].focus,.btn-info[disabled]:focus,.btn-info[disabled]:hover,fieldset[disabled] .btn-info.focus,fieldset[disabled] .btn-info:focus,fieldset[disabled] .btn-info:hover{background-color:#5bc0de;border-color:#46b8da}.btn-info .badge{color:#5bc0de;background-color:#fff}.btn-warning{color:#fff;background-color:#f0ad4e;border-color:#eea236}.btn-warning.focus,.btn-warning:focus{color:#fff;background-color:#ec971f;border-color:#985f0d}.btn-warning.active,.btn-warning:active,.btn-warning:hover,.open>.dropdown-toggle.btn-warning{color:#fff;background-color:#ec971f;border-color:#d58512}.btn-warning.active.focus,.btn-warning.active:focus,.btn-warning.active:hover,.btn-warning:active.focus,.btn-warning:active:focus,.btn-warning:active:hover,.open>.dropdown-toggle.btn-warning.focus,.open>.dropdown-toggle.btn-warning:focus,.open>.dropdown-toggle.btn-warning:hover{color:#fff;background-color:#d58512;border-color:#985f0d}.btn-warning.active,.btn-warning:active,.open>.dropdown-toggle.btn-warning{background-image:none}.btn-warning.disabled.focus,.btn-warning.disabled:focus,.btn-warning.disabled:hover,.btn-warning[disabled].focus,.btn-warning[disabled]:focus,.btn-warning[disabled]:hover,fieldset[disabled] .btn-warning.focus,fieldset[disabled] .btn-warning:focus,fieldset[disabled] .btn-warning:hover{background-color:#f0ad4e;border-color:#eea236}.btn-warning .badge{color:#f0ad4e;background-color:#fff}.btn-danger{color:#fff;background-color:#d9534f;border-color:#d43f3a}.btn-danger.focus,.btn-danger:focus{color:#fff;background-color:#c9302c;border-color:#761c19}.btn-danger.active,.btn-danger:active,.btn-danger:hover,.open>.dropdown-toggle.btn-danger{color:#fff;background-color:#c9302c;border-color:#ac2925}.btn-danger.active.focus,.btn-danger.active:focus,.btn-danger.active:hover,.btn-danger:active.focus,.btn-danger:active:focus,.btn-danger:active:hover,.open>.dropdown-toggle.btn-danger.focus,.open>.dropdown-toggle.btn-danger:focus,.open>.dropdown-toggle.btn-danger:hover{color:#fff;background-color:#ac2925;border-color:#761c19}.btn-danger.active,.btn-danger:active,.open>.dropdown-toggle.btn-danger{background-image:none}.btn-danger.disabled.focus,.btn-danger.disabled:focus,.btn-danger.disabled:hover,.btn-danger[disabled].focus,.btn-danger[disabled]:focus,.btn-danger[disabled]:hover,fieldset[disabled] .btn-danger.focus,fieldset[disabled] .btn-danger:focus,fieldset[disabled] .btn-danger:hover{background-color:#d9534f;border-color:#d43f3a}.btn-danger .badge{color:#d9534f;background-color:#fff}.btn-link{font-weight:400;color:#337ab7;border-radius:0}.btn-link,.btn-link.active,.btn-link:active,.btn-link[disabled],fieldset[disabled] .btn-link{background-color:transparent;box-shadow:none}.btn-link,.btn-link:active,.btn-link:focus,.btn-link:hover{border-color:transparent}.btn-link:focus,.btn-link:hover{color:#23527c;text-decoration:underline;background-color:transparent}.btn-link[disabled]:focus,.btn-link[disabled]:hover,fieldset[disabled] .btn-link:focus,fieldset[disabled] .btn-link:hover{color:#777;text-decoration:none}.btn-group-lg>.btn,.btn-lg{padding:10px 16px;font-size:18px;line-height:1.3333333;border-radius:6px}.btn-group-sm>.btn,.btn-sm{padding:5px 10px;font-size:12px;line-height:1.5;border-radius:3px}.btn-group-xs>.btn,.btn-xs{padding:1px 5px;font-size:12px;line-height:1.5;border-radius:3px}.btn-block{display:block;width:100%}.btn-block+.btn-block{margin-top:5px}input[type=button].btn-block,input[type=reset].btn-block,input[type=submit].btn-block{width:100%}.fade{opacity:0;transition:opacity .15s linear}.fade.in{opacity:1}.collapse{display:none}.collapse.in{display:block}tr.collapse.in{display:table-row}tbody.collapse.in{display:table-row-group}.collapsing{position:relative;height:0;overflow:hidden;transition-timing-function:ease;transition-duration:.35s;transition-property:height,visibility}.caret{display:inline-block;width:0;height:0;margin-left:2px;vertical-align:middle;border-top:4px dashed;border-top:4px solid\\9;border-right:4px solid transparent;border-left:4px solid transparent}.dropdown,.dropup{position:relative}.dropdown-toggle:focus{outline:0}.dropdown-menu{position:absolute;top:100%;left:0;z-index:1000;display:none;float:left;min-width:160px;padding:5px 0;margin:2px 0 0;font-size:14px;text-align:left;list-style:none;background-color:#fff;background-clip:padding-box;border:1px solid #ccc;border:1px solid rgba(0,0,0,.15);border-radius:4px;box-shadow:0 6px 12px rgba(0,0,0,.175)}.dropdown-menu.pull-right{right:0;left:auto}.dropdown-menu .divider{height:1px;margin:9px 0;overflow:hidden;background-color:#e5e5e5}.dropdown-menu>li>a{display:block;padding:3px 20px;clear:both;font-weight:400;line-height:1.42857143;color:#333;white-space:nowrap}.dropdown-menu>li>a:focus,.dropdown-menu>li>a:hover{color:#262626;text-decoration:none;background-color:#f5f5f5}.dropdown-menu>.active>a,.dropdown-menu>.active>a:focus,.dropdown-menu>.active>a:hover{color:#fff;text-decoration:none;background-color:#337ab7;outline:0}.dropdown-menu>.disabled>a,.dropdown-menu>.disabled>a:focus,.dropdown-menu>.disabled>a:hover{color:#777}.dropdown-menu>.disabled>a:focus,.dropdown-menu>.disabled>a:hover{text-decoration:none;cursor:not-allowed;background-color:transparent;background-image:none;filter:progid:DXImageTransform.Microsoft.gradient(enabled=false)}.open>.dropdown-menu{display:block}.open>a{outline:0}.dropdown-menu-right{right:0;left:auto}.dropdown-menu-left{right:auto;left:0}.dropdown-header{display:block;padding:3px 20px;font-size:12px;line-height:1.42857143;color:#777;white-space:nowrap}.dropdown-backdrop{position:fixed;top:0;right:0;bottom:0;left:0;z-index:990}.pull-right>.dropdown-menu{right:0;left:auto}.dropup .caret,.navbar-fixed-bottom .dropdown .caret{content:\"\";border-top:0;border-bottom:4px dashed;border-bottom:4px solid\\9}.dropup .dropdown-menu,.navbar-fixed-bottom .dropdown .dropdown-menu{top:auto;bottom:100%;margin-bottom:2px}@media (min-width:768px){.navbar-right .dropdown-menu{right:0;left:auto}.navbar-right .dropdown-menu-left{right:auto;left:0}}.btn-group,.btn-group-vertical{position:relative;display:inline-block;vertical-align:middle}.btn-group-vertical>.btn,.btn-group>.btn{position:relative;float:left}.btn-group-vertical>.btn.active,.btn-group-vertical>.btn:active,.btn-group-vertical>.btn:focus,.btn-group-vertical>.btn:hover,.btn-group>.btn.active,.btn-group>.btn:active,.btn-group>.btn:focus,.btn-group>.btn:hover{z-index:2}.btn-group .btn+.btn,.btn-group .btn+.btn-group,.btn-group .btn-group+.btn,.btn-group .btn-group+.btn-group{margin-left:-1px}.btn-toolbar{margin-left:-5px}.btn-toolbar .btn,.btn-toolbar .btn-group,.btn-toolbar .input-group{float:left}.btn-toolbar>.btn,.btn-toolbar>.btn-group,.btn-toolbar>.input-group{margin-left:5px}.btn-group>.btn:not(:first-child):not(:last-child):not(.dropdown-toggle){border-radius:0}.btn-group>.btn:first-child{margin-left:0}.btn-group>.btn:first-child:not(:last-child):not(.dropdown-toggle){border-top-right-radius:0;border-bottom-right-radius:0}.btn-group>.btn:last-child:not(:first-child),.btn-group>.dropdown-toggle:not(:first-child){border-top-left-radius:0;border-bottom-left-radius:0}.btn-group>.btn-group{float:left}.btn-group>.btn-group:not(:first-child):not(:last-child)>.btn{border-radius:0}.btn-group>.btn-group:first-child:not(:last-child)>.btn:last-child,.btn-group>.btn-group:first-child:not(:last-child)>.dropdown-toggle{border-top-right-radius:0;border-bottom-right-radius:0}.btn-group>.btn-group:last-child:not(:first-child)>.btn:first-child{border-top-left-radius:0;border-bottom-left-radius:0}.btn-group .dropdown-toggle:active,.btn-group.open .dropdown-toggle{outline:0}.btn-group>.btn+.dropdown-toggle{padding-right:8px;padding-left:8px}.btn-group>.btn-lg+.dropdown-toggle{padding-right:12px;padding-left:12px}.btn-group.open .dropdown-toggle{box-shadow:inset 0 3px 5px rgba(0,0,0,.125)}.btn-group.open .dropdown-toggle.btn-link{box-shadow:none}.btn .caret{margin-left:0}.btn-lg .caret{border-width:5px 5px 0;border-bottom-width:0}.dropup .btn-lg .caret{border-width:0 5px 5px}.btn-group-vertical>.btn,.btn-group-vertical>.btn-group,.btn-group-vertical>.btn-group>.btn{display:block;float:none;width:100%;max-width:100%}.btn-group-vertical>.btn-group>.btn{float:none}.btn-group-vertical>.btn+.btn,.btn-group-vertical>.btn+.btn-group,.btn-group-vertical>.btn-group+.btn,.btn-group-vertical>.btn-group+.btn-group{margin-top:-1px;margin-left:0}.btn-group-vertical>.btn:not(:first-child):not(:last-child){border-radius:0}.btn-group-vertical>.btn:first-child:not(:last-child){border-top-left-radius:4px;border-top-right-radius:4px;border-bottom-right-radius:0;border-bottom-left-radius:0}.btn-group-vertical>.btn:last-child:not(:first-child){border-top-left-radius:0;border-top-right-radius:0;border-bottom-right-radius:4px;border-bottom-left-radius:4px}.btn-group-vertical>.btn-group:not(:first-child):not(:last-child)>.btn{border-radius:0}.btn-group-vertical>.btn-group:first-child:not(:last-child)>.btn:last-child,.btn-group-vertical>.btn-group:first-child:not(:last-child)>.dropdown-toggle{border-bottom-right-radius:0;border-bottom-left-radius:0}.btn-group-vertical>.btn-group:last-child:not(:first-child)>.btn:first-child{border-top-left-radius:0;border-top-right-radius:0}.btn-group-justified{display:table;width:100%;table-layout:fixed;border-collapse:separate}.btn-group-justified>.btn,.btn-group-justified>.btn-group{display:table-cell;float:none;width:1%}.btn-group-justified>.btn-group .btn{width:100%}.btn-group-justified>.btn-group .dropdown-menu{left:auto}[data-toggle=buttons]>.btn-group>.btn input[type=checkbox],[data-toggle=buttons]>.btn-group>.btn input[type=radio],[data-toggle=buttons]>.btn input[type=checkbox],[data-toggle=buttons]>.btn input[type=radio]{position:absolute;clip:rect(0,0,0,0);pointer-events:none}.input-group{position:relative;display:table;border-collapse:separate}.input-group[class*=col-]{float:none;padding-right:0;padding-left:0}.input-group .form-control{position:relative;z-index:2;float:left;width:100%;margin-bottom:0}.input-group .form-control:focus{z-index:3}.input-group-lg>.form-control,.input-group-lg>.input-group-addon,.input-group-lg>.input-group-btn>.btn{height:46px;padding:10px 16px;font-size:18px;line-height:1.3333333;border-radius:6px}select.input-group-lg>.form-control,select.input-group-lg>.input-group-addon,select.input-group-lg>.input-group-btn>.btn{height:46px;line-height:46px}select[multiple].input-group-lg>.form-control,select[multiple].input-group-lg>.input-group-addon,select[multiple].input-group-lg>.input-group-btn>.btn,textarea.input-group-lg>.form-control,textarea.input-group-lg>.input-group-addon,textarea.input-group-lg>.input-group-btn>.btn{height:auto}.input-group-sm>.form-control,.input-group-sm>.input-group-addon,.input-group-sm>.input-group-btn>.btn{height:30px;padding:5px 10px;font-size:12px;line-height:1.5;border-radius:3px}select.input-group-sm>.form-control,select.input-group-sm>.input-group-addon,select.input-group-sm>.input-group-btn>.btn{height:30px;line-height:30px}select[multiple].input-group-sm>.form-control,select[multiple].input-group-sm>.input-group-addon,select[multiple].input-group-sm>.input-group-btn>.btn,textarea.input-group-sm>.form-control,textarea.input-group-sm>.input-group-addon,textarea.input-group-sm>.input-group-btn>.btn{height:auto}.input-group-addon,.input-group-btn,.input-group .form-control{display:table-cell}.input-group-addon:not(:first-child):not(:last-child),.input-group-btn:not(:first-child):not(:last-child),.input-group .form-control:not(:first-child):not(:last-child){border-radius:0}.input-group-addon,.input-group-btn{width:1%;white-space:nowrap;vertical-align:middle}.input-group-addon{padding:6px 12px;font-size:14px;font-weight:400;line-height:1;color:#555;text-align:center;background-color:#eee;border:1px solid #ccc;border-radius:4px}.input-group-addon.input-sm{padding:5px 10px;font-size:12px;border-radius:3px}.input-group-addon.input-lg{padding:10px 16px;font-size:18px;border-radius:6px}.input-group-addon input[type=checkbox],.input-group-addon input[type=radio]{margin-top:0}.input-group-addon:first-child,.input-group-btn:first-child>.btn,.input-group-btn:first-child>.btn-group>.btn,.input-group-btn:first-child>.dropdown-toggle,.input-group-btn:last-child>.btn-group:not(:last-child)>.btn,.input-group-btn:last-child>.btn:not(:last-child):not(.dropdown-toggle),.input-group .form-control:first-child{border-top-right-radius:0;border-bottom-right-radius:0}.input-group-addon:first-child{border-right:0}.input-group-addon:last-child,.input-group-btn:first-child>.btn-group:not(:first-child)>.btn,.input-group-btn:first-child>.btn:not(:first-child),.input-group-btn:last-child>.btn,.input-group-btn:last-child>.btn-group>.btn,.input-group-btn:last-child>.dropdown-toggle,.input-group .form-control:last-child{border-top-left-radius:0;border-bottom-left-radius:0}.input-group-addon:last-child{border-left:0}.input-group-btn{font-size:0;white-space:nowrap}.input-group-btn,.input-group-btn>.btn{position:relative}.input-group-btn>.btn+.btn{margin-left:-1px}.input-group-btn>.btn:active,.input-group-btn>.btn:focus,.input-group-btn>.btn:hover{z-index:2}.input-group-btn:first-child>.btn,.input-group-btn:first-child>.btn-group{margin-right:-1px}.input-group-btn:last-child>.btn,.input-group-btn:last-child>.btn-group{z-index:2;margin-left:-1px}.nav{padding-left:0;margin-bottom:0;list-style:none}.nav>li,.nav>li>a{position:relative;display:block}.nav>li>a{padding:10px 15px}.nav>li>a:focus,.nav>li>a:hover{text-decoration:none;background-color:#eee}.nav>li.disabled>a{color:#777}.nav>li.disabled>a:focus,.nav>li.disabled>a:hover{color:#777;text-decoration:none;cursor:not-allowed;background-color:transparent}.nav .open>a,.nav .open>a:focus,.nav .open>a:hover{background-color:#eee;border-color:#337ab7}.nav .nav-divider{height:1px;margin:9px 0;overflow:hidden;background-color:#e5e5e5}.nav>li>a>img{max-width:none}.nav-tabs{border-bottom:1px solid #ddd}.nav-tabs>li{float:left;margin-bottom:-1px}.nav-tabs>li>a{margin-right:2px;line-height:1.42857143;border:1px solid transparent;border-radius:4px 4px 0 0}.nav-tabs>li>a:hover{border-color:#eee #eee #ddd}.nav-tabs>li.active>a,.nav-tabs>li.active>a:focus,.nav-tabs>li.active>a:hover{color:#555;cursor:default;background-color:#fff;border:1px solid #ddd;border-bottom-color:transparent}.nav-tabs.nav-justified{width:100%;border-bottom:0}.nav-tabs.nav-justified>li{float:none}.nav-tabs.nav-justified>li>a{margin-bottom:5px;text-align:center}.nav-tabs.nav-justified>.dropdown .dropdown-menu{top:auto;left:auto}@media (min-width:768px){.nav-tabs.nav-justified>li{display:table-cell;width:1%}.nav-tabs.nav-justified>li>a{margin-bottom:0}}.nav-tabs.nav-justified>li>a{margin-right:0;border-radius:4px}.nav-tabs.nav-justified>.active>a,.nav-tabs.nav-justified>.active>a:focus,.nav-tabs.nav-justified>.active>a:hover{border:1px solid #ddd}@media (min-width:768px){.nav-tabs.nav-justified>li>a{border-bottom:1px solid #ddd;border-radius:4px 4px 0 0}.nav-tabs.nav-justified>.active>a,.nav-tabs.nav-justified>.active>a:focus,.nav-tabs.nav-justified>.active>a:hover{border-bottom-color:#fff}}.nav-pills>li{float:left}.nav-pills>li>a{border-radius:4px}.nav-pills>li+li{margin-left:2px}.nav-pills>li.active>a,.nav-pills>li.active>a:focus,.nav-pills>li.active>a:hover{color:#fff;background-color:#337ab7}.nav-stacked>li{float:none}.nav-stacked>li+li{margin-top:2px;margin-left:0}.nav-justified{width:100%}.nav-justified>li{float:none}.nav-justified>li>a{margin-bottom:5px;text-align:center}.nav-justified>.dropdown .dropdown-menu{top:auto;left:auto}@media (min-width:768px){.nav-justified>li{display:table-cell;width:1%}.nav-justified>li>a{margin-bottom:0}}.nav-tabs-justified{border-bottom:0}.nav-tabs-justified>li>a{margin-right:0;border-radius:4px}.nav-tabs-justified>.active>a,.nav-tabs-justified>.active>a:focus,.nav-tabs-justified>.active>a:hover{border:1px solid #ddd}@media (min-width:768px){.nav-tabs-justified>li>a{border-bottom:1px solid #ddd;border-radius:4px 4px 0 0}.nav-tabs-justified>.active>a,.nav-tabs-justified>.active>a:focus,.nav-tabs-justified>.active>a:hover{border-bottom-color:#fff}}.tab-content>.tab-pane{display:none}.tab-content>.active{display:block}.nav-tabs .dropdown-menu{margin-top:-1px;border-top-left-radius:0;border-top-right-radius:0}.navbar{position:relative;min-height:50px;margin-bottom:20px;border:1px solid transparent}@media (min-width:768px){.navbar{border-radius:4px}}@media (min-width:768px){.navbar-header{float:left}}.navbar-collapse{padding-right:15px;padding-left:15px;overflow-x:visible;-webkit-overflow-scrolling:touch;border-top:1px solid transparent;box-shadow:inset 0 1px 0 hsla(0,0%,100%,.1)}.navbar-collapse.in{overflow-y:auto}@media (min-width:768px){.navbar-collapse{width:auto;border-top:0;box-shadow:none}.navbar-collapse.collapse{display:block!important;height:auto!important;padding-bottom:0;overflow:visible!important}.navbar-collapse.in{overflow-y:visible}.navbar-fixed-bottom .navbar-collapse,.navbar-fixed-top .navbar-collapse,.navbar-static-top .navbar-collapse{padding-right:0;padding-left:0}}.navbar-fixed-bottom .navbar-collapse,.navbar-fixed-top .navbar-collapse{max-height:340px}@media (max-device-width:480px) and (orientation:landscape){.navbar-fixed-bottom .navbar-collapse,.navbar-fixed-top .navbar-collapse{max-height:200px}}.container-fluid>.navbar-collapse,.container-fluid>.navbar-header,.container>.navbar-collapse,.container>.navbar-header{margin-right:-15px;margin-left:-15px}@media (min-width:768px){.container-fluid>.navbar-collapse,.container-fluid>.navbar-header,.container>.navbar-collapse,.container>.navbar-header{margin-right:0;margin-left:0}}.navbar-static-top{z-index:1000;border-width:0 0 1px}@media (min-width:768px){.navbar-static-top{border-radius:0}}.navbar-fixed-bottom,.navbar-fixed-top{position:fixed;right:0;left:0;z-index:1030}@media (min-width:768px){.navbar-fixed-bottom,.navbar-fixed-top{border-radius:0}}.navbar-fixed-top{top:0;border-width:0 0 1px}.navbar-fixed-bottom{bottom:0;margin-bottom:0;border-width:1px 0 0}.navbar-brand{float:left;height:50px;padding:15px;font-size:18px;line-height:20px}.navbar-brand:focus,.navbar-brand:hover{text-decoration:none}.navbar-brand>img{display:block}@media (min-width:768px){.navbar>.container-fluid .navbar-brand,.navbar>.container .navbar-brand{margin-left:-15px}}.navbar-toggle{position:relative;float:right;padding:9px 10px;margin-top:8px;margin-right:15px;margin-bottom:8px;background-color:transparent;background-image:none;border:1px solid transparent;border-radius:4px}.navbar-toggle:focus{outline:0}.navbar-toggle .icon-bar{display:block;width:22px;height:2px;border-radius:1px}.navbar-toggle .icon-bar+.icon-bar{margin-top:4px}@media (min-width:768px){.navbar-toggle{display:none}}.navbar-nav{margin:7.5px -15px}.navbar-nav>li>a{padding-top:10px;padding-bottom:10px;line-height:20px}@media (max-width:767px){.navbar-nav .open .dropdown-menu{position:static;float:none;width:auto;margin-top:0;background-color:transparent;border:0;box-shadow:none}.navbar-nav .open .dropdown-menu .dropdown-header,.navbar-nav .open .dropdown-menu>li>a{padding:5px 15px 5px 25px}.navbar-nav .open .dropdown-menu>li>a{line-height:20px}.navbar-nav .open .dropdown-menu>li>a:focus,.navbar-nav .open .dropdown-menu>li>a:hover{background-image:none}}@media (min-width:768px){.navbar-nav{float:left;margin:0}.navbar-nav>li{float:left}.navbar-nav>li>a{padding-top:15px;padding-bottom:15px}}.navbar-form{padding:10px 15px;margin:8px -15px;border-top:1px solid transparent;border-bottom:1px solid transparent;box-shadow:inset 0 1px 0 hsla(0,0%,100%,.1),0 1px 0 hsla(0,0%,100%,.1)}@media (min-width:768px){.navbar-form .form-group{display:inline-block;margin-bottom:0;vertical-align:middle}.navbar-form .form-control{display:inline-block;width:auto;vertical-align:middle}.navbar-form .form-control-static{display:inline-block}.navbar-form .input-group{display:inline-table;vertical-align:middle}.navbar-form .input-group .form-control,.navbar-form .input-group .input-group-addon,.navbar-form .input-group .input-group-btn{width:auto}.navbar-form .input-group>.form-control{width:100%}.navbar-form .control-label{margin-bottom:0;vertical-align:middle}.navbar-form .checkbox,.navbar-form .radio{display:inline-block;margin-top:0;margin-bottom:0;vertical-align:middle}.navbar-form .checkbox label,.navbar-form .radio label{padding-left:0}.navbar-form .checkbox input[type=checkbox],.navbar-form .radio input[type=radio]{position:relative;margin-left:0}.navbar-form .has-feedback .form-control-feedback{top:0}}@media (max-width:767px){.navbar-form .form-group{margin-bottom:5px}.navbar-form .form-group:last-child{margin-bottom:0}}@media (min-width:768px){.navbar-form{width:auto;padding-top:0;padding-bottom:0;margin-right:0;margin-left:0;border:0;box-shadow:none}}.navbar-nav>li>.dropdown-menu{margin-top:0;border-top-left-radius:0;border-top-right-radius:0}.navbar-fixed-bottom .navbar-nav>li>.dropdown-menu{margin-bottom:0;border-top-left-radius:4px;border-top-right-radius:4px;border-bottom-right-radius:0;border-bottom-left-radius:0}.navbar-btn{margin-top:8px;margin-bottom:8px}.navbar-btn.btn-sm{margin-top:10px;margin-bottom:10px}.navbar-btn.btn-xs{margin-top:14px;margin-bottom:14px}.navbar-text{margin-top:15px;margin-bottom:15px}@media (min-width:768px){.navbar-text{float:left;margin-right:15px;margin-left:15px}}@media (min-width:768px){.navbar-left{float:left!important}.navbar-right{float:right!important;margin-right:-15px}.navbar-right~.navbar-right{margin-right:0}}.navbar-default{background-color:#f8f8f8;border-color:#e7e7e7}.navbar-default .navbar-brand{color:#777}.navbar-default .navbar-brand:focus,.navbar-default .navbar-brand:hover{color:#5e5e5e;background-color:transparent}.navbar-default .navbar-nav>li>a,.navbar-default .navbar-text{color:#777}.navbar-default .navbar-nav>li>a:focus,.navbar-default .navbar-nav>li>a:hover{color:#333;background-color:transparent}.navbar-default .navbar-nav>.active>a,.navbar-default .navbar-nav>.active>a:focus,.navbar-default .navbar-nav>.active>a:hover{color:#555;background-color:#e7e7e7}.navbar-default .navbar-nav>.disabled>a,.navbar-default .navbar-nav>.disabled>a:focus,.navbar-default .navbar-nav>.disabled>a:hover{color:#ccc;background-color:transparent}.navbar-default .navbar-toggle{border-color:#ddd}.navbar-default .navbar-toggle:focus,.navbar-default .navbar-toggle:hover{background-color:#ddd}.navbar-default .navbar-toggle .icon-bar{background-color:#888}.navbar-default .navbar-collapse,.navbar-default .navbar-form{border-color:#e7e7e7}.navbar-default .navbar-nav>.open>a,.navbar-default .navbar-nav>.open>a:focus,.navbar-default .navbar-nav>.open>a:hover{color:#555;background-color:#e7e7e7}@media (max-width:767px){.navbar-default .navbar-nav .open .dropdown-menu>li>a{color:#777}.navbar-default .navbar-nav .open .dropdown-menu>li>a:focus,.navbar-default .navbar-nav .open .dropdown-menu>li>a:hover{color:#333;background-color:transparent}.navbar-default .navbar-nav .open .dropdown-menu>.active>a,.navbar-default .navbar-nav .open .dropdown-menu>.active>a:focus,.navbar-default .navbar-nav .open .dropdown-menu>.active>a:hover{color:#555;background-color:#e7e7e7}.navbar-default .navbar-nav .open .dropdown-menu>.disabled>a,.navbar-default .navbar-nav .open .dropdown-menu>.disabled>a:focus,.navbar-default .navbar-nav .open .dropdown-menu>.disabled>a:hover{color:#ccc;background-color:transparent}}.navbar-default .navbar-link{color:#777}.navbar-default .navbar-link:hover{color:#333}.navbar-default .btn-link{color:#777}.navbar-default .btn-link:focus,.navbar-default .btn-link:hover{color:#333}.navbar-default .btn-link[disabled]:focus,.navbar-default .btn-link[disabled]:hover,fieldset[disabled] .navbar-default .btn-link:focus,fieldset[disabled] .navbar-default .btn-link:hover{color:#ccc}.navbar-inverse{background-color:#222;border-color:#080808}.navbar-inverse .navbar-brand{color:#9d9d9d}.navbar-inverse .navbar-brand:focus,.navbar-inverse .navbar-brand:hover{color:#fff;background-color:transparent}.navbar-inverse .navbar-nav>li>a,.navbar-inverse .navbar-text{color:#9d9d9d}.navbar-inverse .navbar-nav>li>a:focus,.navbar-inverse .navbar-nav>li>a:hover{color:#fff;background-color:transparent}.navbar-inverse .navbar-nav>.active>a,.navbar-inverse .navbar-nav>.active>a:focus,.navbar-inverse .navbar-nav>.active>a:hover{color:#fff;background-color:#080808}.navbar-inverse .navbar-nav>.disabled>a,.navbar-inverse .navbar-nav>.disabled>a:focus,.navbar-inverse .navbar-nav>.disabled>a:hover{color:#444;background-color:transparent}.navbar-inverse .navbar-toggle{border-color:#333}.navbar-inverse .navbar-toggle:focus,.navbar-inverse .navbar-toggle:hover{background-color:#333}.navbar-inverse .navbar-toggle .icon-bar{background-color:#fff}.navbar-inverse .navbar-collapse,.navbar-inverse .navbar-form{border-color:#101010}.navbar-inverse .navbar-nav>.open>a,.navbar-inverse .navbar-nav>.open>a:focus,.navbar-inverse .navbar-nav>.open>a:hover{color:#fff;background-color:#080808}@media (max-width:767px){.navbar-inverse .navbar-nav .open .dropdown-menu>.dropdown-header{border-color:#080808}.navbar-inverse .navbar-nav .open .dropdown-menu .divider{background-color:#080808}.navbar-inverse .navbar-nav .open .dropdown-menu>li>a{color:#9d9d9d}.navbar-inverse .navbar-nav .open .dropdown-menu>li>a:focus,.navbar-inverse .navbar-nav .open .dropdown-menu>li>a:hover{color:#fff;background-color:transparent}.navbar-inverse .navbar-nav .open .dropdown-menu>.active>a,.navbar-inverse .navbar-nav .open .dropdown-menu>.active>a:focus,.navbar-inverse .navbar-nav .open .dropdown-menu>.active>a:hover{color:#fff;background-color:#080808}.navbar-inverse .navbar-nav .open .dropdown-menu>.disabled>a,.navbar-inverse .navbar-nav .open .dropdown-menu>.disabled>a:focus,.navbar-inverse .navbar-nav .open .dropdown-menu>.disabled>a:hover{color:#444;background-color:transparent}}.navbar-inverse .navbar-link{color:#9d9d9d}.navbar-inverse .navbar-link:hover{color:#fff}.navbar-inverse .btn-link{color:#9d9d9d}.navbar-inverse .btn-link:focus,.navbar-inverse .btn-link:hover{color:#fff}.navbar-inverse .btn-link[disabled]:focus,.navbar-inverse .btn-link[disabled]:hover,fieldset[disabled] .navbar-inverse .btn-link:focus,fieldset[disabled] .navbar-inverse .btn-link:hover{color:#444}.breadcrumb{padding:8px 15px;margin-bottom:20px;list-style:none;background-color:#f5f5f5;border-radius:4px}.breadcrumb>li{display:inline-block}.breadcrumb>li+li:before{padding:0 5px;color:#ccc;content:\"/\\A0\"}.breadcrumb>.active{color:#777}.pagination{display:inline-block;padding-left:0;margin:20px 0;border-radius:4px}.pagination>li{display:inline}.pagination>li>a,.pagination>li>span{position:relative;float:left;padding:6px 12px;margin-left:-1px;line-height:1.42857143;color:#337ab7;text-decoration:none;background-color:#fff;border:1px solid #ddd}.pagination>li:first-child>a,.pagination>li:first-child>span{margin-left:0;border-top-left-radius:4px;border-bottom-left-radius:4px}.pagination>li:last-child>a,.pagination>li:last-child>span{border-top-right-radius:4px;border-bottom-right-radius:4px}.pagination>li>a:focus,.pagination>li>a:hover,.pagination>li>span:focus,.pagination>li>span:hover{z-index:2;color:#23527c;background-color:#eee;border-color:#ddd}.pagination>.active>a,.pagination>.active>a:focus,.pagination>.active>a:hover,.pagination>.active>span,.pagination>.active>span:focus,.pagination>.active>span:hover{z-index:3;color:#fff;cursor:default;background-color:#337ab7;border-color:#337ab7}.pagination>.disabled>a,.pagination>.disabled>a:focus,.pagination>.disabled>a:hover,.pagination>.disabled>span,.pagination>.disabled>span:focus,.pagination>.disabled>span:hover{color:#777;cursor:not-allowed;background-color:#fff;border-color:#ddd}.pagination-lg>li>a,.pagination-lg>li>span{padding:10px 16px;font-size:18px;line-height:1.3333333}.pagination-lg>li:first-child>a,.pagination-lg>li:first-child>span{border-top-left-radius:6px;border-bottom-left-radius:6px}.pagination-lg>li:last-child>a,.pagination-lg>li:last-child>span{border-top-right-radius:6px;border-bottom-right-radius:6px}.pagination-sm>li>a,.pagination-sm>li>span{padding:5px 10px;font-size:12px;line-height:1.5}.pagination-sm>li:first-child>a,.pagination-sm>li:first-child>span{border-top-left-radius:3px;border-bottom-left-radius:3px}.pagination-sm>li:last-child>a,.pagination-sm>li:last-child>span{border-top-right-radius:3px;border-bottom-right-radius:3px}.pager{padding-left:0;margin:20px 0;text-align:center;list-style:none}.pager li{display:inline}.pager li>a,.pager li>span{display:inline-block;padding:5px 14px;background-color:#fff;border:1px solid #ddd;border-radius:15px}.pager li>a:focus,.pager li>a:hover{text-decoration:none;background-color:#eee}.pager .next>a,.pager .next>span{float:right}.pager .previous>a,.pager .previous>span{float:left}.pager .disabled>a,.pager .disabled>a:focus,.pager .disabled>a:hover,.pager .disabled>span{color:#777;cursor:not-allowed;background-color:#fff}.label{display:inline;padding:.2em .6em .3em;font-size:75%;font-weight:700;line-height:1;color:#fff;text-align:center;white-space:nowrap;vertical-align:baseline;border-radius:.25em}a.label:focus,a.label:hover{color:#fff;text-decoration:none;cursor:pointer}.label:empty{display:none}.btn .label{position:relative;top:-1px}.label-default{background-color:#777}.label-default[href]:focus,.label-default[href]:hover{background-color:#5e5e5e}.label-primary{background-color:#337ab7}.label-primary[href]:focus,.label-primary[href]:hover{background-color:#286090}.label-success{background-color:#5cb85c}.label-success[href]:focus,.label-success[href]:hover{background-color:#449d44}.label-info{background-color:#5bc0de}.label-info[href]:focus,.label-info[href]:hover{background-color:#31b0d5}.label-warning{background-color:#f0ad4e}.label-warning[href]:focus,.label-warning[href]:hover{background-color:#ec971f}.label-danger{background-color:#d9534f}.label-danger[href]:focus,.label-danger[href]:hover{background-color:#c9302c}.badge{display:inline-block;min-width:10px;padding:3px 7px;font-size:12px;font-weight:700;line-height:1;color:#fff;text-align:center;white-space:nowrap;vertical-align:middle;background-color:#777;border-radius:10px}.badge:empty{display:none}.btn .badge{position:relative;top:-1px}.btn-group-xs>.btn .badge,.btn-xs .badge{top:0;padding:1px 5px}a.badge:focus,a.badge:hover{color:#fff;text-decoration:none;cursor:pointer}.list-group-item.active>.badge,.nav-pills>.active>a>.badge{color:#337ab7;background-color:#fff}.list-group-item>.badge{float:right}.list-group-item>.badge+.badge{margin-right:5px}.nav-pills>li>a>.badge{margin-left:3px}.jumbotron{padding-top:30px;padding-bottom:30px;margin-bottom:30px;background-color:#eee}.jumbotron,.jumbotron .h1,.jumbotron h1{color:inherit}.jumbotron p{margin-bottom:15px;font-size:21px;font-weight:200}.jumbotron>hr{border-top-color:#d5d5d5}.container-fluid .jumbotron,.container .jumbotron{padding-right:15px;padding-left:15px;border-radius:6px}.jumbotron .container{max-width:100%}@media screen and (min-width:768px){.jumbotron{padding-top:48px;padding-bottom:48px}.container-fluid .jumbotron,.container .jumbotron{padding-right:60px;padding-left:60px}.jumbotron .h1,.jumbotron h1{font-size:63px}}.thumbnail{display:block;padding:4px;margin-bottom:20px;line-height:1.42857143;background-color:#fff;border:1px solid #ddd;border-radius:4px;transition:border .2s ease-in-out}.thumbnail>img,.thumbnail a>img{margin-right:auto;margin-left:auto}a.thumbnail.active,a.thumbnail:focus,a.thumbnail:hover{border-color:#337ab7}.thumbnail .caption{padding:9px;color:#333}.alert{padding:15px;margin-bottom:20px;border:1px solid transparent;border-radius:4px}.alert h4{margin-top:0;color:inherit}.alert .alert-link{font-weight:700}.alert>p,.alert>ul{margin-bottom:0}.alert>p+p{margin-top:5px}.alert-dismissable,.alert-dismissible{padding-right:35px}.alert-dismissable .close,.alert-dismissible .close{position:relative;top:-2px;right:-21px;color:inherit}.alert-success{color:#3c763d;background-color:#dff0d8;border-color:#d6e9c6}.alert-success hr{border-top-color:#c9e2b3}.alert-success .alert-link{color:#2b542c}.alert-info{color:#31708f;background-color:#d9edf7;border-color:#bce8f1}.alert-info hr{border-top-color:#a6e1ec}.alert-info .alert-link{color:#245269}.alert-warning{color:#8a6d3b;background-color:#fcf8e3;border-color:#faebcc}.alert-warning hr{border-top-color:#f7e1b5}.alert-warning .alert-link{color:#66512c}.alert-danger{color:#a94442;background-color:#f2dede;border-color:#ebccd1}.alert-danger hr{border-top-color:#e4b9c0}.alert-danger .alert-link{color:#843534}@keyframes progress-bar-stripes{0%{background-position:40px 0}to{background-position:0 0}}.progress{height:20px;margin-bottom:20px;overflow:hidden;background-color:#f5f5f5;border-radius:4px;box-shadow:inset 0 1px 2px rgba(0,0,0,.1)}.progress-bar{float:left;width:0;height:100%;font-size:12px;line-height:20px;color:#fff;text-align:center;background-color:#337ab7;box-shadow:inset 0 -1px 0 rgba(0,0,0,.15);transition:width .6s ease}.progress-bar-striped,.progress-striped .progress-bar{background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent);background-size:40px 40px}.progress-bar.active,.progress.active .progress-bar{animation:progress-bar-stripes 2s linear infinite}.progress-bar-success{background-color:#5cb85c}.progress-striped .progress-bar-success{background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.progress-bar-info{background-color:#5bc0de}.progress-striped .progress-bar-info{background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.progress-bar-warning{background-color:#f0ad4e}.progress-striped .progress-bar-warning{background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.progress-bar-danger{background-color:#d9534f}.progress-striped .progress-bar-danger{background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.media{margin-top:15px}.media:first-child{margin-top:0}.media,.media-body{overflow:hidden;zoom:1}.media-body{width:10000px}.media-object{display:block}.media-object.img-thumbnail{max-width:none}.media-right,.media>.pull-right{padding-left:10px}.media-left,.media>.pull-left{padding-right:10px}.media-body,.media-left,.media-right{display:table-cell;vertical-align:top}.media-middle{vertical-align:middle}.media-bottom{vertical-align:bottom}.media-heading{margin-top:0;margin-bottom:5px}.media-list{padding-left:0;list-style:none}.list-group{padding-left:0;margin-bottom:20px}.list-group-item{position:relative;display:block;padding:10px 15px;margin-bottom:-1px;background-color:#fff;border:1px solid #ddd}.list-group-item:first-child{border-top-left-radius:4px;border-top-right-radius:4px}.list-group-item:last-child{margin-bottom:0;border-bottom-right-radius:4px;border-bottom-left-radius:4px}a.list-group-item,button.list-group-item{color:#555}a.list-group-item .list-group-item-heading,button.list-group-item .list-group-item-heading{color:#333}a.list-group-item:focus,a.list-group-item:hover,button.list-group-item:focus,button.list-group-item:hover{color:#555;text-decoration:none;background-color:#f5f5f5}button.list-group-item{width:100%;text-align:left}.list-group-item.disabled,.list-group-item.disabled:focus,.list-group-item.disabled:hover{color:#777;cursor:not-allowed;background-color:#eee}.list-group-item.disabled .list-group-item-heading,.list-group-item.disabled:focus .list-group-item-heading,.list-group-item.disabled:hover .list-group-item-heading{color:inherit}.list-group-item.disabled .list-group-item-text,.list-group-item.disabled:focus .list-group-item-text,.list-group-item.disabled:hover .list-group-item-text{color:#777}.list-group-item.active,.list-group-item.active:focus,.list-group-item.active:hover{z-index:2;color:#fff;background-color:#337ab7;border-color:#337ab7}.list-group-item.active .list-group-item-heading,.list-group-item.active .list-group-item-heading>.small,.list-group-item.active .list-group-item-heading>small,.list-group-item.active:focus .list-group-item-heading,.list-group-item.active:focus .list-group-item-heading>.small,.list-group-item.active:focus .list-group-item-heading>small,.list-group-item.active:hover .list-group-item-heading,.list-group-item.active:hover .list-group-item-heading>.small,.list-group-item.active:hover .list-group-item-heading>small{color:inherit}.list-group-item.active .list-group-item-text,.list-group-item.active:focus .list-group-item-text,.list-group-item.active:hover .list-group-item-text{color:#c7ddef}.list-group-item-success{color:#3c763d;background-color:#dff0d8}a.list-group-item-success,button.list-group-item-success{color:#3c763d}a.list-group-item-success .list-group-item-heading,button.list-group-item-success .list-group-item-heading{color:inherit}a.list-group-item-success:focus,a.list-group-item-success:hover,button.list-group-item-success:focus,button.list-group-item-success:hover{color:#3c763d;background-color:#d0e9c6}a.list-group-item-success.active,a.list-group-item-success.active:focus,a.list-group-item-success.active:hover,button.list-group-item-success.active,button.list-group-item-success.active:focus,button.list-group-item-success.active:hover{color:#fff;background-color:#3c763d;border-color:#3c763d}.list-group-item-info{color:#31708f;background-color:#d9edf7}a.list-group-item-info,button.list-group-item-info{color:#31708f}a.list-group-item-info .list-group-item-heading,button.list-group-item-info .list-group-item-heading{color:inherit}a.list-group-item-info:focus,a.list-group-item-info:hover,button.list-group-item-info:focus,button.list-group-item-info:hover{color:#31708f;background-color:#c4e3f3}a.list-group-item-info.active,a.list-group-item-info.active:focus,a.list-group-item-info.active:hover,button.list-group-item-info.active,button.list-group-item-info.active:focus,button.list-group-item-info.active:hover{color:#fff;background-color:#31708f;border-color:#31708f}.list-group-item-warning{color:#8a6d3b;background-color:#fcf8e3}a.list-group-item-warning,button.list-group-item-warning{color:#8a6d3b}a.list-group-item-warning .list-group-item-heading,button.list-group-item-warning .list-group-item-heading{color:inherit}a.list-group-item-warning:focus,a.list-group-item-warning:hover,button.list-group-item-warning:focus,button.list-group-item-warning:hover{color:#8a6d3b;background-color:#faf2cc}a.list-group-item-warning.active,a.list-group-item-warning.active:focus,a.list-group-item-warning.active:hover,button.list-group-item-warning.active,button.list-group-item-warning.active:focus,button.list-group-item-warning.active:hover{color:#fff;background-color:#8a6d3b;border-color:#8a6d3b}.list-group-item-danger{color:#a94442;background-color:#f2dede}a.list-group-item-danger,button.list-group-item-danger{color:#a94442}a.list-group-item-danger .list-group-item-heading,button.list-group-item-danger .list-group-item-heading{color:inherit}a.list-group-item-danger:focus,a.list-group-item-danger:hover,button.list-group-item-danger:focus,button.list-group-item-danger:hover{color:#a94442;background-color:#ebcccc}a.list-group-item-danger.active,a.list-group-item-danger.active:focus,a.list-group-item-danger.active:hover,button.list-group-item-danger.active,button.list-group-item-danger.active:focus,button.list-group-item-danger.active:hover{color:#fff;background-color:#a94442;border-color:#a94442}.list-group-item-heading{margin-top:0;margin-bottom:5px}.list-group-item-text{margin-bottom:0;line-height:1.3}.panel{margin-bottom:20px;background-color:#fff;border:1px solid transparent;border-radius:4px;box-shadow:0 1px 1px rgba(0,0,0,.05)}.panel-body{padding:15px}.panel-heading{padding:10px 15px;border-bottom:1px solid transparent;border-top-left-radius:3px;border-top-right-radius:3px}.panel-heading>.dropdown .dropdown-toggle,.panel-title{color:inherit}.panel-title{margin-top:0;margin-bottom:0;font-size:16px}.panel-title>.small,.panel-title>.small>a,.panel-title>a,.panel-title>small,.panel-title>small>a{color:inherit}.panel-footer{padding:10px 15px;background-color:#f5f5f5;border-top:1px solid #ddd;border-bottom-right-radius:3px;border-bottom-left-radius:3px}.panel>.list-group,.panel>.panel-collapse>.list-group{margin-bottom:0}.panel>.list-group .list-group-item,.panel>.panel-collapse>.list-group .list-group-item{border-width:1px 0;border-radius:0}.panel>.list-group:first-child .list-group-item:first-child,.panel>.panel-collapse>.list-group:first-child .list-group-item:first-child{border-top:0;border-top-left-radius:3px;border-top-right-radius:3px}.panel>.list-group:last-child .list-group-item:last-child,.panel>.panel-collapse>.list-group:last-child .list-group-item:last-child{border-bottom:0;border-bottom-right-radius:3px;border-bottom-left-radius:3px}.panel>.panel-heading+.panel-collapse>.list-group .list-group-item:first-child{border-top-left-radius:0;border-top-right-radius:0}.list-group+.panel-footer,.panel-heading+.list-group .list-group-item:first-child{border-top-width:0}.panel>.panel-collapse>.table,.panel>.table,.panel>.table-responsive>.table{margin-bottom:0}.panel>.panel-collapse>.table caption,.panel>.table-responsive>.table caption,.panel>.table caption{padding-right:15px;padding-left:15px}.panel>.table-responsive:first-child>.table:first-child,.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child,.panel>.table:first-child,.panel>.table:first-child>tbody:first-child>tr:first-child,.panel>.table:first-child>thead:first-child>tr:first-child{border-top-left-radius:3px;border-top-right-radius:3px}.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child td:first-child,.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child th:first-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child td:first-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child th:first-child,.panel>.table:first-child>tbody:first-child>tr:first-child td:first-child,.panel>.table:first-child>tbody:first-child>tr:first-child th:first-child,.panel>.table:first-child>thead:first-child>tr:first-child td:first-child,.panel>.table:first-child>thead:first-child>tr:first-child th:first-child{border-top-left-radius:3px}.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child td:last-child,.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child th:last-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child td:last-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child th:last-child,.panel>.table:first-child>tbody:first-child>tr:first-child td:last-child,.panel>.table:first-child>tbody:first-child>tr:first-child th:last-child,.panel>.table:first-child>thead:first-child>tr:first-child td:last-child,.panel>.table:first-child>thead:first-child>tr:first-child th:last-child{border-top-right-radius:3px}.panel>.table-responsive:last-child>.table:last-child,.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child,.panel>.table:last-child,.panel>.table:last-child>tbody:last-child>tr:last-child,.panel>.table:last-child>tfoot:last-child>tr:last-child{border-bottom-right-radius:3px;border-bottom-left-radius:3px}.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child td:first-child,.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child th:first-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child td:first-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child th:first-child,.panel>.table:last-child>tbody:last-child>tr:last-child td:first-child,.panel>.table:last-child>tbody:last-child>tr:last-child th:first-child,.panel>.table:last-child>tfoot:last-child>tr:last-child td:first-child,.panel>.table:last-child>tfoot:last-child>tr:last-child th:first-child{border-bottom-left-radius:3px}.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child td:last-child,.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child th:last-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child td:last-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child th:last-child,.panel>.table:last-child>tbody:last-child>tr:last-child td:last-child,.panel>.table:last-child>tbody:last-child>tr:last-child th:last-child,.panel>.table:last-child>tfoot:last-child>tr:last-child td:last-child,.panel>.table:last-child>tfoot:last-child>tr:last-child th:last-child{border-bottom-right-radius:3px}.panel>.panel-body+.table,.panel>.panel-body+.table-responsive,.panel>.table+.panel-body,.panel>.table-responsive+.panel-body{border-top:1px solid #ddd}.panel>.table>tbody:first-child>tr:first-child td,.panel>.table>tbody:first-child>tr:first-child th{border-top:0}.panel>.table-bordered,.panel>.table-responsive>.table-bordered{border:0}.panel>.table-bordered>tbody>tr>td:first-child,.panel>.table-bordered>tbody>tr>th:first-child,.panel>.table-bordered>tfoot>tr>td:first-child,.panel>.table-bordered>tfoot>tr>th:first-child,.panel>.table-bordered>thead>tr>td:first-child,.panel>.table-bordered>thead>tr>th:first-child,.panel>.table-responsive>.table-bordered>tbody>tr>td:first-child,.panel>.table-responsive>.table-bordered>tbody>tr>th:first-child,.panel>.table-responsive>.table-bordered>tfoot>tr>td:first-child,.panel>.table-responsive>.table-bordered>tfoot>tr>th:first-child,.panel>.table-responsive>.table-bordered>thead>tr>td:first-child,.panel>.table-responsive>.table-bordered>thead>tr>th:first-child{border-left:0}.panel>.table-bordered>tbody>tr>td:last-child,.panel>.table-bordered>tbody>tr>th:last-child,.panel>.table-bordered>tfoot>tr>td:last-child,.panel>.table-bordered>tfoot>tr>th:last-child,.panel>.table-bordered>thead>tr>td:last-child,.panel>.table-bordered>thead>tr>th:last-child,.panel>.table-responsive>.table-bordered>tbody>tr>td:last-child,.panel>.table-responsive>.table-bordered>tbody>tr>th:last-child,.panel>.table-responsive>.table-bordered>tfoot>tr>td:last-child,.panel>.table-responsive>.table-bordered>tfoot>tr>th:last-child,.panel>.table-responsive>.table-bordered>thead>tr>td:last-child,.panel>.table-responsive>.table-bordered>thead>tr>th:last-child{border-right:0}.panel>.table-bordered>tbody>tr:first-child>td,.panel>.table-bordered>tbody>tr:first-child>th,.panel>.table-bordered>tbody>tr:last-child>td,.panel>.table-bordered>tbody>tr:last-child>th,.panel>.table-bordered>tfoot>tr:last-child>td,.panel>.table-bordered>tfoot>tr:last-child>th,.panel>.table-bordered>thead>tr:first-child>td,.panel>.table-bordered>thead>tr:first-child>th,.panel>.table-responsive>.table-bordered>tbody>tr:first-child>td,.panel>.table-responsive>.table-bordered>tbody>tr:first-child>th,.panel>.table-responsive>.table-bordered>tbody>tr:last-child>td,.panel>.table-responsive>.table-bordered>tbody>tr:last-child>th,.panel>.table-responsive>.table-bordered>tfoot>tr:last-child>td,.panel>.table-responsive>.table-bordered>tfoot>tr:last-child>th,.panel>.table-responsive>.table-bordered>thead>tr:first-child>td,.panel>.table-responsive>.table-bordered>thead>tr:first-child>th{border-bottom:0}.panel>.table-responsive{margin-bottom:0;border:0}.panel-group{margin-bottom:20px}.panel-group .panel{margin-bottom:0;border-radius:4px}.panel-group .panel+.panel{margin-top:5px}.panel-group .panel-heading{border-bottom:0}.panel-group .panel-heading+.panel-collapse>.list-group,.panel-group .panel-heading+.panel-collapse>.panel-body{border-top:1px solid #ddd}.panel-group .panel-footer{border-top:0}.panel-group .panel-footer+.panel-collapse .panel-body{border-bottom:1px solid #ddd}.panel-default{border-color:#ddd}.panel-default>.panel-heading{color:#333;background-color:#f5f5f5;border-color:#ddd}.panel-default>.panel-heading+.panel-collapse>.panel-body{border-top-color:#ddd}.panel-default>.panel-heading .badge{color:#f5f5f5;background-color:#333}.panel-default>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#ddd}.panel-primary{border-color:#337ab7}.panel-primary>.panel-heading{color:#fff;background-color:#337ab7;border-color:#337ab7}.panel-primary>.panel-heading+.panel-collapse>.panel-body{border-top-color:#337ab7}.panel-primary>.panel-heading .badge{color:#337ab7;background-color:#fff}.panel-primary>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#337ab7}.panel-success{border-color:#d6e9c6}.panel-success>.panel-heading{color:#3c763d;background-color:#dff0d8;border-color:#d6e9c6}.panel-success>.panel-heading+.panel-collapse>.panel-body{border-top-color:#d6e9c6}.panel-success>.panel-heading .badge{color:#dff0d8;background-color:#3c763d}.panel-success>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#d6e9c6}.panel-info{border-color:#bce8f1}.panel-info>.panel-heading{color:#31708f;background-color:#d9edf7;border-color:#bce8f1}.panel-info>.panel-heading+.panel-collapse>.panel-body{border-top-color:#bce8f1}.panel-info>.panel-heading .badge{color:#d9edf7;background-color:#31708f}.panel-info>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#bce8f1}.panel-warning{border-color:#faebcc}.panel-warning>.panel-heading{color:#8a6d3b;background-color:#fcf8e3;border-color:#faebcc}.panel-warning>.panel-heading+.panel-collapse>.panel-body{border-top-color:#faebcc}.panel-warning>.panel-heading .badge{color:#fcf8e3;background-color:#8a6d3b}.panel-warning>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#faebcc}.panel-danger{border-color:#ebccd1}.panel-danger>.panel-heading{color:#a94442;background-color:#f2dede;border-color:#ebccd1}.panel-danger>.panel-heading+.panel-collapse>.panel-body{border-top-color:#ebccd1}.panel-danger>.panel-heading .badge{color:#f2dede;background-color:#a94442}.panel-danger>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#ebccd1}.embed-responsive{position:relative;display:block;height:0;padding:0;overflow:hidden}.embed-responsive .embed-responsive-item,.embed-responsive embed,.embed-responsive iframe,.embed-responsive object,.embed-responsive video{position:absolute;top:0;bottom:0;left:0;width:100%;height:100%;border:0}.embed-responsive-16by9{padding-bottom:56.25%}.embed-responsive-4by3{padding-bottom:75%}.well{min-height:20px;padding:19px;margin-bottom:20px;background-color:#f5f5f5;border:1px solid #e3e3e3;border-radius:4px;box-shadow:inset 0 1px 1px rgba(0,0,0,.05)}.well blockquote{border-color:#ddd;border-color:rgba(0,0,0,.15)}.well-lg{padding:24px;border-radius:6px}.well-sm{padding:9px;border-radius:3px}.close{float:right;font-size:21px;font-weight:700;line-height:1;color:#000;text-shadow:0 1px 0 #fff;filter:alpha(opacity=20);opacity:.2}.close:focus,.close:hover{color:#000;text-decoration:none;cursor:pointer;filter:alpha(opacity=50);opacity:.5}button.close{-webkit-appearance:none;padding:0;cursor:pointer;background:0 0;border:0}.modal,.modal-open{overflow:hidden}.modal{position:fixed;top:0;right:0;bottom:0;left:0;z-index:1050;display:none;-webkit-overflow-scrolling:touch;outline:0}.modal.fade .modal-dialog{transition:transform .3s ease-out;transform:translateY(-25%)}.modal.in .modal-dialog{transform:translate(0)}.modal-open .modal{overflow-x:hidden;overflow-y:auto}.modal-dialog{position:relative;width:auto;margin:10px}.modal-content{position:relative;background-color:#fff;background-clip:padding-box;border:1px solid #999;border:1px solid rgba(0,0,0,.2);border-radius:6px;outline:0;box-shadow:0 3px 9px rgba(0,0,0,.5)}.modal-backdrop{position:fixed;top:0;right:0;bottom:0;left:0;z-index:1040;background-color:#000}.modal-backdrop.fade{filter:alpha(opacity=0);opacity:0}.modal-backdrop.in{filter:alpha(opacity=50);opacity:.5}.modal-header{padding:15px;border-bottom:1px solid #e5e5e5}.modal-header .close{margin-top:-2px}.modal-title{margin:0;line-height:1.42857143}.modal-body{position:relative;padding:15px}.modal-footer{padding:15px;text-align:right;border-top:1px solid #e5e5e5}.modal-footer .btn+.btn{margin-bottom:0;margin-left:5px}.modal-footer .btn-group .btn+.btn{margin-left:-1px}.modal-footer .btn-block+.btn-block{margin-left:0}.modal-scrollbar-measure{position:absolute;top:-9999px;width:50px;height:50px;overflow:scroll}@media (min-width:768px){.modal-dialog{width:600px;margin:30px auto}.modal-content{box-shadow:0 5px 15px rgba(0,0,0,.5)}.modal-sm{width:300px}}@media (min-width:992px){.modal-lg{width:900px}}.tooltip{position:absolute;z-index:1070;display:block;font-family:Helvetica Neue,Helvetica,Arial,sans-serif;font-size:12px;font-style:normal;font-weight:400;line-height:1.42857143;text-align:left;text-align:start;text-decoration:none;text-shadow:none;text-transform:none;letter-spacing:normal;word-break:normal;word-spacing:normal;word-wrap:normal;white-space:normal;filter:alpha(opacity=0);opacity:0;line-break:auto}.tooltip.in{filter:alpha(opacity=90);opacity:.9}.tooltip.top{padding:5px 0;margin-top:-3px}.tooltip.right{padding:0 5px;margin-left:3px}.tooltip.bottom{padding:5px 0;margin-top:3px}.tooltip.left{padding:0 5px;margin-left:-3px}.tooltip-inner{max-width:200px;padding:3px 8px;color:#fff;text-align:center;background-color:#000;border-radius:4px}.tooltip-arrow{position:absolute;width:0;height:0;border-color:transparent;border-style:solid}.tooltip.top .tooltip-arrow{bottom:0;left:50%;margin-left:-5px;border-width:5px 5px 0;border-top-color:#000}.tooltip.top-left .tooltip-arrow{right:5px}.tooltip.top-left .tooltip-arrow,.tooltip.top-right .tooltip-arrow{bottom:0;margin-bottom:-5px;border-width:5px 5px 0;border-top-color:#000}.tooltip.top-right .tooltip-arrow{left:5px}.tooltip.right .tooltip-arrow{top:50%;left:0;margin-top:-5px;border-width:5px 5px 5px 0;border-right-color:#000}.tooltip.left .tooltip-arrow{top:50%;right:0;margin-top:-5px;border-width:5px 0 5px 5px;border-left-color:#000}.tooltip.bottom .tooltip-arrow{top:0;left:50%;margin-left:-5px;border-width:0 5px 5px;border-bottom-color:#000}.tooltip.bottom-left .tooltip-arrow{top:0;right:5px;margin-top:-5px;border-width:0 5px 5px;border-bottom-color:#000}.tooltip.bottom-right .tooltip-arrow{top:0;left:5px;margin-top:-5px;border-width:0 5px 5px;border-bottom-color:#000}.popover{position:absolute;top:0;left:0;z-index:1060;display:none;max-width:276px;padding:1px;font-family:Helvetica Neue,Helvetica,Arial,sans-serif;font-size:14px;font-style:normal;font-weight:400;line-height:1.42857143;text-align:left;text-align:start;text-decoration:none;text-shadow:none;text-transform:none;letter-spacing:normal;word-break:normal;word-spacing:normal;word-wrap:normal;white-space:normal;background-color:#fff;background-clip:padding-box;border:1px solid #ccc;border:1px solid rgba(0,0,0,.2);border-radius:6px;box-shadow:0 5px 10px rgba(0,0,0,.2);line-break:auto}.popover.top{margin-top:-10px}.popover.right{margin-left:10px}.popover.bottom{margin-top:10px}.popover.left{margin-left:-10px}.popover-title{padding:8px 14px;margin:0;font-size:14px;background-color:#f7f7f7;border-bottom:1px solid #ebebeb;border-radius:5px 5px 0 0}.popover-content{padding:9px 14px}.popover>.arrow,.popover>.arrow:after{position:absolute;display:block;width:0;height:0;border-color:transparent;border-style:solid}.popover>.arrow{border-width:11px}.popover>.arrow:after{content:\"\";border-width:10px}.popover.top>.arrow{bottom:-11px;left:50%;margin-left:-11px;border-top-color:#999;border-top-color:rgba(0,0,0,.25);border-bottom-width:0}.popover.top>.arrow:after{bottom:1px;margin-left:-10px;content:\" \";border-top-color:#fff;border-bottom-width:0}.popover.right>.arrow{top:50%;left:-11px;margin-top:-11px;border-right-color:#999;border-right-color:rgba(0,0,0,.25);border-left-width:0}.popover.right>.arrow:after{bottom:-10px;left:1px;content:\" \";border-right-color:#fff;border-left-width:0}.popover.bottom>.arrow{top:-11px;left:50%;margin-left:-11px;border-top-width:0;border-bottom-color:#999;border-bottom-color:rgba(0,0,0,.25)}.popover.bottom>.arrow:after{top:1px;margin-left:-10px;content:\" \";border-top-width:0;border-bottom-color:#fff}.popover.left>.arrow{top:50%;right:-11px;margin-top:-11px;border-right-width:0;border-left-color:#999;border-left-color:rgba(0,0,0,.25)}.popover.left>.arrow:after{right:1px;bottom:-10px;content:\" \";border-right-width:0;border-left-color:#fff}.carousel,.carousel-inner{position:relative}.carousel-inner{width:100%;overflow:hidden}.carousel-inner>.item{position:relative;display:none;transition:left .6s ease-in-out}.carousel-inner>.item>a>img,.carousel-inner>.item>img{line-height:1}@media (-webkit-transform-3d),(transform-3d){.carousel-inner>.item{transition:transform .6s ease-in-out;-webkit-backface-visibility:hidden;backface-visibility:hidden;perspective:1000px}.carousel-inner>.item.active.right,.carousel-inner>.item.next{left:0;transform:translate3d(100%,0,0)}.carousel-inner>.item.active.left,.carousel-inner>.item.prev{left:0;transform:translate3d(-100%,0,0)}.carousel-inner>.item.active,.carousel-inner>.item.next.left,.carousel-inner>.item.prev.right{left:0;transform:translateZ(0)}}.carousel-inner>.active,.carousel-inner>.next,.carousel-inner>.prev{display:block}.carousel-inner>.active{left:0}.carousel-inner>.next,.carousel-inner>.prev{position:absolute;top:0;width:100%}.carousel-inner>.next{left:100%}.carousel-inner>.prev{left:-100%}.carousel-inner>.next.left,.carousel-inner>.prev.right{left:0}.carousel-inner>.active.left{left:-100%}.carousel-inner>.active.right{left:100%}.carousel-control{position:absolute;top:0;bottom:0;left:0;width:15%;font-size:20px;color:#fff;text-align:center;text-shadow:0 1px 2px rgba(0,0,0,.6);background-color:transparent;filter:alpha(opacity=50);opacity:.5}.carousel-control.left{background-image:linear-gradient(90deg,rgba(0,0,0,.5) 0,rgba(0,0,0,.0001));filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\"#80000000\",endColorstr=\"#00000000\",GradientType=1);background-repeat:repeat-x}.carousel-control.right{right:0;left:auto;background-image:linear-gradient(90deg,rgba(0,0,0,.0001) 0,rgba(0,0,0,.5));filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\"#00000000\",endColorstr=\"#80000000\",GradientType=1);background-repeat:repeat-x}.carousel-control:focus,.carousel-control:hover{color:#fff;text-decoration:none;filter:alpha(opacity=90);outline:0;opacity:.9}.carousel-control .glyphicon-chevron-left,.carousel-control .glyphicon-chevron-right,.carousel-control .icon-next,.carousel-control .icon-prev{position:absolute;top:50%;z-index:5;display:inline-block;margin-top:-10px}.carousel-control .glyphicon-chevron-left,.carousel-control .icon-prev{left:50%;margin-left:-10px}.carousel-control .glyphicon-chevron-right,.carousel-control .icon-next{right:50%;margin-right:-10px}.carousel-control .icon-next,.carousel-control .icon-prev{width:20px;height:20px;font-family:serif;line-height:1}.carousel-control .icon-prev:before{content:\"\\2039\"}.carousel-control .icon-next:before{content:\"\\203A\"}.carousel-indicators{position:absolute;bottom:10px;left:50%;z-index:15;width:60%;padding-left:0;margin-left:-30%;text-align:center;list-style:none}.carousel-indicators li{display:inline-block;width:10px;height:10px;margin:1px;text-indent:-999px;cursor:pointer;background-color:#000\\9;background-color:transparent;border:1px solid #fff;border-radius:10px}.carousel-indicators .active{width:12px;height:12px;margin:0;background-color:#fff}.carousel-caption{position:absolute;right:15%;bottom:20px;left:15%;z-index:10;padding-top:20px;padding-bottom:20px;color:#fff;text-align:center;text-shadow:0 1px 2px rgba(0,0,0,.6)}.carousel-caption .btn{text-shadow:none}@media screen and (min-width:768px){.carousel-control .glyphicon-chevron-left,.carousel-control .glyphicon-chevron-right,.carousel-control .icon-next,.carousel-control .icon-prev{width:30px;height:30px;margin-top:-10px;font-size:30px}.carousel-control .glyphicon-chevron-left,.carousel-control .icon-prev{margin-left:-10px}.carousel-control .glyphicon-chevron-right,.carousel-control .icon-next{margin-right:-10px}.carousel-caption{right:20%;left:20%;padding-bottom:30px}.carousel-indicators{bottom:20px}}.btn-group-vertical>.btn-group:after,.btn-group-vertical>.btn-group:before,.btn-toolbar:after,.btn-toolbar:before,.clearfix:after,.clearfix:before,.container-fluid:after,.container-fluid:before,.container:after,.container:before,.dl-horizontal dd:after,.dl-horizontal dd:before,.form-horizontal .form-group:after,.form-horizontal .form-group:before,.modal-footer:after,.modal-footer:before,.modal-header:after,.modal-header:before,.nav:after,.nav:before,.navbar-collapse:after,.navbar-collapse:before,.navbar-header:after,.navbar-header:before,.navbar:after,.navbar:before,.pager:after,.pager:before,.panel-body:after,.panel-body:before,.row:after,.row:before{display:table;content:\" \"}.btn-group-vertical>.btn-group:after,.btn-toolbar:after,.clearfix:after,.container-fluid:after,.container:after,.dl-horizontal dd:after,.form-horizontal .form-group:after,.modal-footer:after,.modal-header:after,.nav:after,.navbar-collapse:after,.navbar-header:after,.navbar:after,.pager:after,.panel-body:after,.row:after{clear:both}.center-block{display:block;margin-right:auto;margin-left:auto}.pull-right{float:right!important}.pull-left{float:left!important}.hide{display:none!important}.show{display:block!important}.invisible{visibility:hidden}.text-hide{font:0/0 a;color:transparent;text-shadow:none;background-color:transparent;border:0}.hidden{display:none!important}.affix{position:fixed}@-ms-viewport{width:device-width}.visible-lg,.visible-lg-block,.visible-lg-inline,.visible-lg-inline-block,.visible-md,.visible-md-block,.visible-md-inline,.visible-md-inline-block,.visible-sm,.visible-sm-block,.visible-sm-inline,.visible-sm-inline-block,.visible-xs,.visible-xs-block,.visible-xs-inline,.visible-xs-inline-block{display:none!important}@media (max-width:767px){.visible-xs{display:block!important}table.visible-xs{display:table!important}tr.visible-xs{display:table-row!important}td.visible-xs,th.visible-xs{display:table-cell!important}}@media (max-width:767px){.visible-xs-block{display:block!important}}@media (max-width:767px){.visible-xs-inline{display:inline!important}}@media (max-width:767px){.visible-xs-inline-block{display:inline-block!important}}@media (min-width:768px) and (max-width:991px){.visible-sm{display:block!important}table.visible-sm{display:table!important}tr.visible-sm{display:table-row!important}td.visible-sm,th.visible-sm{display:table-cell!important}}@media (min-width:768px) and (max-width:991px){.visible-sm-block{display:block!important}}@media (min-width:768px) and (max-width:991px){.visible-sm-inline{display:inline!important}}@media (min-width:768px) and (max-width:991px){.visible-sm-inline-block{display:inline-block!important}}@media (min-width:992px) and (max-width:1199px){.visible-md{display:block!important}table.visible-md{display:table!important}tr.visible-md{display:table-row!important}td.visible-md,th.visible-md{display:table-cell!important}}@media (min-width:992px) and (max-width:1199px){.visible-md-block{display:block!important}}@media (min-width:992px) and (max-width:1199px){.visible-md-inline{display:inline!important}}@media (min-width:992px) and (max-width:1199px){.visible-md-inline-block{display:inline-block!important}}@media (min-width:1200px){.visible-lg{display:block!important}table.visible-lg{display:table!important}tr.visible-lg{display:table-row!important}td.visible-lg,th.visible-lg{display:table-cell!important}}@media (min-width:1200px){.visible-lg-block{display:block!important}}@media (min-width:1200px){.visible-lg-inline{display:inline!important}}@media (min-width:1200px){.visible-lg-inline-block{display:inline-block!important}}@media (max-width:767px){.hidden-xs{display:none!important}}@media (min-width:768px) and (max-width:991px){.hidden-sm{display:none!important}}@media (min-width:992px) and (max-width:1199px){.hidden-md{display:none!important}}@media (min-width:1200px){.hidden-lg{display:none!important}}.visible-print{display:none!important}@media print{.visible-print{display:block!important}table.visible-print{display:table!important}tr.visible-print{display:table-row!important}td.visible-print,th.visible-print{display:table-cell!important}}.visible-print-block{display:none!important}@media print{.visible-print-block{display:block!important}}.visible-print-inline{display:none!important}@media print{.visible-print-inline{display:inline!important}}.visible-print-inline-block{display:none!important}@media print{.visible-print-inline-block{display:inline-block!important}}@media print{.hidden-print{display:none!important}}", ""]);
	
	// exports


/***/ }),
/* 96 */
/***/ (function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// Copyright (c) 2017 Adobe Systems Incorporated. All rights reserved.
	//
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//
	// http://www.apache.org/licenses/LICENSE-2.0
	//
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// See the License for the specific language governing permissions and
	// limitations under the License.
	// ┌────────────────────────────────────────────────────────────┐ \\
	// │ Eve 0.5.4 - JavaScript Events Library                      │ \\
	// ├────────────────────────────────────────────────────────────┤ \\
	// │ Author Dmitry Baranovskiy (http://dmitry.baranovskiy.com/) │ \\
	// └────────────────────────────────────────────────────────────┘ \\
	
	(function (glob) {
	    var version = "0.5.4",
	        has = "hasOwnProperty",
	        separator = /[\.\/]/,
	        comaseparator = /\s*,\s*/,
	        wildcard = "*",
	        numsort = function (a, b) {
	            return a - b;
	        },
	        current_event,
	        stop,
	        events = {n: {}},
	        firstDefined = function () {
	            for (var i = 0, ii = this.length; i < ii; i++) {
	                if (typeof this[i] != "undefined") {
	                    return this[i];
	                }
	            }
	        },
	        lastDefined = function () {
	            var i = this.length;
	            while (--i) {
	                if (typeof this[i] != "undefined") {
	                    return this[i];
	                }
	            }
	        },
	        objtos = Object.prototype.toString,
	        Str = String,
	        isArray = Array.isArray || function (ar) {
	            return ar instanceof Array || objtos.call(ar) == "[object Array]";
	        },
	    /*\
	     * eve
	     [ method ]
	
	     * Fires event with given `name`, given scope and other parameters.
	
	     - name (string) name of the *event*, dot (`.`) or slash (`/`) separated
	     - scope (object) context for the event handlers
	     - varargs (...) the rest of arguments will be sent to event handlers
	
	     = (object) array of returned values from the listeners. Array has two methods `.firstDefined()` and `.lastDefined()` to get first or last not `undefined` value.
	    \*/
	        eve = function (name, scope) {
	            var oldstop = stop,
	                args = Array.prototype.slice.call(arguments, 2),
	                listeners = eve.listeners(name),
	                z = 0,
	                l,
	                indexed = [],
	                queue = {},
	                out = [],
	                ce = current_event;
	            out.firstDefined = firstDefined;
	            out.lastDefined = lastDefined;
	            current_event = name;
	            stop = 0;
	            for (var i = 0, ii = listeners.length; i < ii; i++) if ("zIndex" in listeners[i]) {
	                indexed.push(listeners[i].zIndex);
	                if (listeners[i].zIndex < 0) {
	                    queue[listeners[i].zIndex] = listeners[i];
	                }
	            }
	            indexed.sort(numsort);
	            while (indexed[z] < 0) {
	                l = queue[indexed[z++]];
	                out.push(l.apply(scope, args));
	                if (stop) {
	                    stop = oldstop;
	                    return out;
	                }
	            }
	            for (i = 0; i < ii; i++) {
	                l = listeners[i];
	                if ("zIndex" in l) {
	                    if (l.zIndex == indexed[z]) {
	                        out.push(l.apply(scope, args));
	                        if (stop) {
	                            break;
	                        }
	                        do {
	                            z++;
	                            l = queue[indexed[z]];
	                            l && out.push(l.apply(scope, args));
	                            if (stop) {
	                                break;
	                            }
	                        } while (l)
	                    } else {
	                        queue[l.zIndex] = l;
	                    }
	                } else {
	                    out.push(l.apply(scope, args));
	                    if (stop) {
	                        break;
	                    }
	                }
	            }
	            stop = oldstop;
	            current_event = ce;
	            return out;
	        };
	    // Undocumented. Debug only.
	    eve._events = events;
	    /*\
	     * eve.listeners
	     [ method ]
	
	     * Internal method which gives you array of all event handlers that will be triggered by the given `name`.
	
	     - name (string) name of the event, dot (`.`) or slash (`/`) separated
	
	     = (array) array of event handlers
	    \*/
	    eve.listeners = function (name) {
	        var names = isArray(name) ? name : name.split(separator),
	            e = events,
	            item,
	            items,
	            k,
	            i,
	            ii,
	            j,
	            jj,
	            nes,
	            es = [e],
	            out = [];
	        for (i = 0, ii = names.length; i < ii; i++) {
	            nes = [];
	            for (j = 0, jj = es.length; j < jj; j++) {
	                e = es[j].n;
	                items = [e[names[i]], e[wildcard]];
	                k = 2;
	                while (k--) {
	                    item = items[k];
	                    if (item) {
	                        nes.push(item);
	                        out = out.concat(item.f || []);
	                    }
	                }
	            }
	            es = nes;
	        }
	        return out;
	    };
	    /*\
	     * eve.separator
	     [ method ]
	
	     * If for some reasons you don’t like default separators (`.` or `/`) you can specify yours
	     * here. Be aware that if you pass a string longer than one character it will be treated as
	     * a list of characters.
	
	     - separator (string) new separator. Empty string resets to default: `.` or `/`.
	    \*/
	    eve.separator = function (sep) {
	        if (sep) {
	            sep = Str(sep).replace(/(?=[\.\^\]\[\-])/g, "\\");
	            sep = "[" + sep + "]";
	            separator = new RegExp(sep);
	        } else {
	            separator = /[\.\/]/;
	        }
	    };
	    /*\
	     * eve.on
	     [ method ]
	     **
	     * Binds given event handler with a given name. You can use wildcards “`*`” for the names:
	     | eve.on("*.under.*", f);
	     | eve("mouse.under.floor"); // triggers f
	     * Use @eve to trigger the listener.
	     **
	     - name (string) name of the event, dot (`.`) or slash (`/`) separated, with optional wildcards
	     - f (function) event handler function
	     **
	     - name (array) if you don’t want to use separators, you can use array of strings
	     - f (function) event handler function
	     **
	     = (function) returned function accepts a single numeric parameter that represents z-index of the handler. It is an optional feature and only used when you need to ensure that some subset of handlers will be invoked in a given order, despite of the order of assignment.
	     > Example:
	     | eve.on("mouse", eatIt)(2);
	     | eve.on("mouse", scream);
	     | eve.on("mouse", catchIt)(1);
	     * This will ensure that `catchIt` function will be called before `eatIt`.
	     *
	     * If you want to put your handler before non-indexed handlers, specify a negative value.
	     * Note: I assume most of the time you don’t need to worry about z-index, but it’s nice to have this feature “just in case”.
	    \*/
	    eve.on = function (name, f) {
	        if (typeof f != "function") {
	            return function () {};
	        }
	        var names = isArray(name) ? isArray(name[0]) ? name : [name] : Str(name).split(comaseparator);
	        for (var i = 0, ii = names.length; i < ii; i++) {
	            (function (name) {
	                var names = isArray(name) ? name : Str(name).split(separator),
	                    e = events,
	                    exist;
	                for (var i = 0, ii = names.length; i < ii; i++) {
	                    e = e.n;
	                    e = e.hasOwnProperty(names[i]) && e[names[i]] || (e[names[i]] = {n: {}});
	                }
	                e.f = e.f || [];
	                for (i = 0, ii = e.f.length; i < ii; i++) if (e.f[i] == f) {
	                    exist = true;
	                    break;
	                }
	                !exist && e.f.push(f);
	            }(names[i]));
	        }
	        return function (zIndex) {
	            if (+zIndex == +zIndex) {
	                f.zIndex = +zIndex;
	            }
	        };
	    };
	    /*\
	     * eve.f
	     [ method ]
	     **
	     * Returns function that will fire given event with optional arguments.
	     * Arguments that will be passed to the result function will be also
	     * concated to the list of final arguments.
	     | el.onclick = eve.f("click", 1, 2);
	     | eve.on("click", function (a, b, c) {
	     |     console.log(a, b, c); // 1, 2, [event object]
	     | });
	     - event (string) event name
	     - varargs (…) and any other arguments
	     = (function) possible event handler function
	    \*/
	    eve.f = function (event) {
	        var attrs = [].slice.call(arguments, 1);
	        return function () {
	            eve.apply(null, [event, null].concat(attrs).concat([].slice.call(arguments, 0)));
	        };
	    };
	    /*\
	     * eve.stop
	     [ method ]
	     **
	     * Is used inside an event handler to stop the event, preventing any subsequent listeners from firing.
	    \*/
	    eve.stop = function () {
	        stop = 1;
	    };
	    /*\
	     * eve.nt
	     [ method ]
	     **
	     * Could be used inside event handler to figure out actual name of the event.
	     **
	     - subname (string) #optional subname of the event
	     **
	     = (string) name of the event, if `subname` is not specified
	     * or
	     = (boolean) `true`, if current event’s name contains `subname`
	    \*/
	    eve.nt = function (subname) {
	        var cur = isArray(current_event) ? current_event.join(".") : current_event;
	        if (subname) {
	            return new RegExp("(?:\\.|\\/|^)" + subname + "(?:\\.|\\/|$)").test(cur);
	        }
	        return cur;
	    };
	    /*\
	     * eve.nts
	     [ method ]
	     **
	     * Could be used inside event handler to figure out actual name of the event.
	     **
	     **
	     = (array) names of the event
	    \*/
	    eve.nts = function () {
	        return isArray(current_event) ? current_event : current_event.split(separator);
	    };
	    /*\
	     * eve.off
	     [ method ]
	     **
	     * Removes given function from the list of event listeners assigned to given name.
	     * If no arguments specified all the events will be cleared.
	     **
	     - name (string) name of the event, dot (`.`) or slash (`/`) separated, with optional wildcards
	     - f (function) event handler function
	    \*/
	    /*\
	     * eve.unbind
	     [ method ]
	     **
	     * See @eve.off
	    \*/
	    eve.off = eve.unbind = function (name, f) {
	        if (!name) {
	            eve._events = events = {n: {}};
	            return;
	        }
	        var names = isArray(name) ? isArray(name[0]) ? name : [name] : Str(name).split(comaseparator);
	        if (names.length > 1) {
	            for (var i = 0, ii = names.length; i < ii; i++) {
	                eve.off(names[i], f);
	            }
	            return;
	        }
	        names = isArray(name) ? name : Str(name).split(separator);
	        var e,
	            key,
	            splice,
	            i, ii, j, jj,
	            cur = [events],
	            inodes = [];
	        for (i = 0, ii = names.length; i < ii; i++) {
	            for (j = 0; j < cur.length; j += splice.length - 2) {
	                splice = [j, 1];
	                e = cur[j].n;
	                if (names[i] != wildcard) {
	                    if (e[names[i]]) {
	                        splice.push(e[names[i]]);
	                        inodes.unshift({
	                            n: e,
	                            name: names[i]
	                        });
	                    }
	                } else {
	                    for (key in e) if (e[has](key)) {
	                        splice.push(e[key]);
	                        inodes.unshift({
	                            n: e,
	                            name: key
	                        });
	                    }
	                }
	                cur.splice.apply(cur, splice);
	            }
	        }
	        for (i = 0, ii = cur.length; i < ii; i++) {
	            e = cur[i];
	            while (e.n) {
	                if (f) {
	                    if (e.f) {
	                        for (j = 0, jj = e.f.length; j < jj; j++) if (e.f[j] == f) {
	                            e.f.splice(j, 1);
	                            break;
	                        }
	                        !e.f.length && delete e.f;
	                    }
	                    for (key in e.n) if (e.n[has](key) && e.n[key].f) {
	                        var funcs = e.n[key].f;
	                        for (j = 0, jj = funcs.length; j < jj; j++) if (funcs[j] == f) {
	                            funcs.splice(j, 1);
	                            break;
	                        }
	                        !funcs.length && delete e.n[key].f;
	                    }
	                } else {
	                    delete e.f;
	                    for (key in e.n) if (e.n[has](key) && e.n[key].f) {
	                        delete e.n[key].f;
	                    }
	                }
	                e = e.n;
	            }
	        }
	        // prune inner nodes in path
	        prune: for (i = 0, ii = inodes.length; i < ii; i++) {
	            e = inodes[i];
	            for (key in e.n[e.name].f) {
	                // not empty (has listeners)
	                continue prune;
	            }
	            for (key in e.n[e.name].n) {
	                // not empty (has children)
	                continue prune;
	            }
	            // is empty
	            delete e.n[e.name];
	        }
	    };
	    /*\
	     * eve.once
	     [ method ]
	     **
	     * Binds given event handler with a given name to only run once then unbind itself.
	     | eve.once("login", f);
	     | eve("login"); // triggers f
	     | eve("login"); // no listeners
	     * Use @eve to trigger the listener.
	     **
	     - name (string) name of the event, dot (`.`) or slash (`/`) separated, with optional wildcards
	     - f (function) event handler function
	     **
	     = (function) same return function as @eve.on
	    \*/
	    eve.once = function (name, f) {
	        var f2 = function () {
	            eve.off(name, f2);
	            return f.apply(this, arguments);
	        };
	        return eve.on(name, f2);
	    };
	    /*\
	     * eve.version
	     [ property (string) ]
	     **
	     * Current version of the library.
	    \*/
	    eve.version = version;
	    eve.toString = function () {
	        return "You are running Eve " + version;
	    };
	    glob.eve = eve;
	    typeof module != "undefined" && module.exports ? module.exports = eve :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () { return eve; }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : glob.eve = eve;
	})(typeof window != "undefined" ? window : this);


/***/ }),
/* 98 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule camelize
	 * @typechecks
	 */
	
	"use strict";
	
	var _hyphenPattern = /-(.)/g;
	
	/**
	 * Camelcases a hyphenated string, for example:
	 *
	 *   > camelize('background-color')
	 *   < "backgroundColor"
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelize(string) {
	  return string.replace(_hyphenPattern, function (_, character) {
	    return character.toUpperCase();
	  });
	}
	
	module.exports = camelize;

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule camelizeStyleName
	 * @typechecks
	 */
	
	'use strict';
	
	var camelize = __webpack_require__(98);
	
	var msPattern = /^-ms-/;
	
	/**
	 * Camelcases a hyphenated CSS property name, for example:
	 *
	 *   > camelizeStyleName('background-color')
	 *   < "backgroundColor"
	 *   > camelizeStyleName('-moz-transition')
	 *   < "MozTransition"
	 *   > camelizeStyleName('-ms-transition')
	 *   < "msTransition"
	 *
	 * As Andi Smith suggests
	 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
	 * is converted to lowercase `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelizeStyleName(string) {
	  return camelize(string.replace(msPattern, 'ms-'));
	}
	
	module.exports = camelizeStyleName;

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule createArrayFromMixed
	 * @typechecks
	 */
	
	'use strict';
	
	var toArray = __webpack_require__(109);
	
	/**
	 * Perform a heuristic test to determine if an object is "array-like".
	 *
	 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
	 *   Joshu replied: "Mu."
	 *
	 * This function determines if its argument has "array nature": it returns
	 * true if the argument is an actual array, an `arguments' object, or an
	 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
	 *
	 * It will return false for other array-like objects like Filelist.
	 *
	 * @param {*} obj
	 * @return {boolean}
	 */
	function hasArrayNature(obj) {
	  return(
	    // not null/false
	    !!obj && (
	    // arrays are objects, NodeLists are functions in Safari
	    typeof obj == 'object' || typeof obj == 'function') &&
	    // quacks like an array
	    'length' in obj &&
	    // not window
	    !('setInterval' in obj) &&
	    // no DOM node should be considered an array-like
	    // a 'select' element has 'length' and 'item' properties on IE8
	    typeof obj.nodeType != 'number' && (
	    // a real array
	    Array.isArray(obj) ||
	    // arguments
	    'callee' in obj ||
	    // HTMLCollection/NodeList
	    'item' in obj)
	  );
	}
	
	/**
	 * Ensure that the argument is an array by wrapping it in an array if it is not.
	 * Creates a copy of the argument if it is already an array.
	 *
	 * This is mostly useful idiomatically:
	 *
	 *   var createArrayFromMixed = require('createArrayFromMixed');
	 *
	 *   function takesOneOrMoreThings(things) {
	 *     things = createArrayFromMixed(things);
	 *     ...
	 *   }
	 *
	 * This allows you to treat `things' as an array, but accept scalars in the API.
	 *
	 * If you need to convert an array-like object, like `arguments`, into an array
	 * use toArray instead.
	 *
	 * @param {*} obj
	 * @return {array}
	 */
	function createArrayFromMixed(obj) {
	  if (!hasArrayNature(obj)) {
	    return [obj];
	  } else if (Array.isArray(obj)) {
	    return obj.slice();
	  } else {
	    return toArray(obj);
	  }
	}
	
	module.exports = createArrayFromMixed;

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule createNodesFromMarkup
	 * @typechecks
	 */
	
	/*eslint-disable fb-www/unsafe-html*/
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(4);
	
	var createArrayFromMixed = __webpack_require__(100);
	var getMarkupWrap = __webpack_require__(58);
	var invariant = __webpack_require__(1);
	
	/**
	 * Dummy container used to render all markup.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Pattern used by `getNodeName`.
	 */
	var nodeNamePattern = /^\s*<(\w+)/;
	
	/**
	 * Extracts the `nodeName` of the first element in a string of markup.
	 *
	 * @param {string} markup String of markup.
	 * @return {?string} Node name of the supplied markup.
	 */
	function getNodeName(markup) {
	  var nodeNameMatch = markup.match(nodeNamePattern);
	  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
	}
	
	/**
	 * Creates an array containing the nodes rendered from the supplied markup. The
	 * optionally supplied `handleScript` function will be invoked once for each
	 * <script> element that is rendered. If no `handleScript` function is supplied,
	 * an exception is thrown if any <script> elements are rendered.
	 *
	 * @param {string} markup A string of valid HTML markup.
	 * @param {?function} handleScript Invoked once for each rendered <script>.
	 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
	 */
	function createNodesFromMarkup(markup, handleScript) {
	  var node = dummyNode;
	  !!!dummyNode ?  false ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : undefined;
	  var nodeName = getNodeName(markup);
	
	  var wrap = nodeName && getMarkupWrap(nodeName);
	  if (wrap) {
	    node.innerHTML = wrap[1] + markup + wrap[2];
	
	    var wrapDepth = wrap[0];
	    while (wrapDepth--) {
	      node = node.lastChild;
	    }
	  } else {
	    node.innerHTML = markup;
	  }
	
	  var scripts = node.getElementsByTagName('script');
	  if (scripts.length) {
	    !handleScript ?  false ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : undefined;
	    createArrayFromMixed(scripts).forEach(handleScript);
	  }
	
	  var nodes = createArrayFromMixed(node.childNodes);
	  while (node.lastChild) {
	    node.removeChild(node.lastChild);
	  }
	  return nodes;
	}
	
	module.exports = createNodesFromMarkup;

/***/ }),
/* 102 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getUnboundedScrollPosition
	 * @typechecks
	 */
	
	'use strict';
	
	/**
	 * Gets the scroll position of the supplied element or window.
	 *
	 * The return values are unbounded, unlike `getScrollPosition`. This means they
	 * may be negative or exceed the element boundaries (which is possible using
	 * inertial scrolling).
	 *
	 * @param {DOMWindow|DOMElement} scrollable
	 * @return {object} Map with `x` and `y` keys.
	 */
	function getUnboundedScrollPosition(scrollable) {
	  if (scrollable === window) {
	    return {
	      x: window.pageXOffset || document.documentElement.scrollLeft,
	      y: window.pageYOffset || document.documentElement.scrollTop
	    };
	  }
	  return {
	    x: scrollable.scrollLeft,
	    y: scrollable.scrollTop
	  };
	}
	
	module.exports = getUnboundedScrollPosition;

/***/ }),
/* 103 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule hyphenate
	 * @typechecks
	 */
	
	'use strict';
	
	var _uppercasePattern = /([A-Z])/g;
	
	/**
	 * Hyphenates a camelcased string, for example:
	 *
	 *   > hyphenate('backgroundColor')
	 *   < "background-color"
	 *
	 * For CSS style names, use `hyphenateStyleName` instead which works properly
	 * with all vendor prefixes, including `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenate(string) {
	  return string.replace(_uppercasePattern, '-$1').toLowerCase();
	}
	
	module.exports = hyphenate;

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule hyphenateStyleName
	 * @typechecks
	 */
	
	'use strict';
	
	var hyphenate = __webpack_require__(103);
	
	var msPattern = /^ms-/;
	
	/**
	 * Hyphenates a camelcased CSS property name, for example:
	 *
	 *   > hyphenateStyleName('backgroundColor')
	 *   < "background-color"
	 *   > hyphenateStyleName('MozTransition')
	 *   < "-moz-transition"
	 *   > hyphenateStyleName('msTransition')
	 *   < "-ms-transition"
	 *
	 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
	 * is converted to `-ms-`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenateStyleName(string) {
	  return hyphenate(string).replace(msPattern, '-ms-');
	}
	
	module.exports = hyphenateStyleName;

/***/ }),
/* 105 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule isNode
	 * @typechecks
	 */
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM node.
	 */
	'use strict';
	
	function isNode(object) {
	  return !!(object && (typeof Node === 'function' ? object instanceof Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
	}
	
	module.exports = isNode;

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule isTextNode
	 * @typechecks
	 */
	
	'use strict';
	
	var isNode = __webpack_require__(105);
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM text node.
	 */
	function isTextNode(object) {
	  return isNode(object) && object.nodeType == 3;
	}
	
	module.exports = isTextNode;

/***/ }),
/* 107 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule mapObject
	 */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * Executes the provided `callback` once for each enumerable own property in the
	 * object and constructs a new object from the results. The `callback` is
	 * invoked with three arguments:
	 *
	 *  - the property value
	 *  - the property name
	 *  - the object being traversed
	 *
	 * Properties that are added after the call to `mapObject` will not be visited
	 * by `callback`. If the values of existing properties are changed, the value
	 * passed to `callback` will be the value at the time `mapObject` visits them.
	 * Properties that are deleted before being visited are not visited.
	 *
	 * @grep function objectMap()
	 * @grep function objMap()
	 *
	 * @param {?object} object
	 * @param {function} callback
	 * @param {*} context
	 * @return {?object}
	 */
	function mapObject(object, callback, context) {
	  if (!object) {
	    return null;
	  }
	  var result = {};
	  for (var name in object) {
	    if (hasOwnProperty.call(object, name)) {
	      result[name] = callback.call(context, object[name], name, object);
	    }
	  }
	  return result;
	}
	
	module.exports = mapObject;

/***/ }),
/* 108 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule memoizeStringOnly
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Memoizes the return value of a function that accepts one string argument.
	 *
	 * @param {function} callback
	 * @return {function}
	 */
	function memoizeStringOnly(callback) {
	  var cache = {};
	  return function (string) {
	    if (!cache.hasOwnProperty(string)) {
	      cache[string] = callback.call(this, string);
	    }
	    return cache[string];
	  };
	}
	
	module.exports = memoizeStringOnly;

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule toArray
	 * @typechecks
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(1);
	
	/**
	 * Convert array-like objects to arrays.
	 *
	 * This API assumes the caller knows the contents of the data type. For less
	 * well defined inputs use createArrayFromMixed.
	 *
	 * @param {object|function|filelist} obj
	 * @return {array}
	 */
	function toArray(obj) {
	  var length = obj.length;
	
	  // Some browse builtin objects can report typeof 'function' (e.g. NodeList in
	  // old versions of Safari).
	  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : undefined;
	
	  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : undefined;
	
	  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : undefined;
	
	  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
	  // without method will throw during the slice call and skip straight to the
	  // fallback.
	  if (obj.hasOwnProperty) {
	    try {
	      return Array.prototype.slice.call(obj);
	    } catch (e) {
	      // IE < 9 does not support Array#slice on collections objects
	    }
	  }
	
	  // Fall back to copying key by key. This assumes all keys have a value,
	  // so will not preserve sparsely populated inputs.
	  var ret = Array(length);
	  for (var ii = 0; ii < length; ii++) {
	    ret[ii] = obj[ii];
	  }
	  return ret;
	}
	
	module.exports = toArray;

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//! openseadragon 2.4.0
	//! Built on 2018-07-20
	//! Git commit: v2.4.0-0-446af4d
	//! http://openseadragon.github.io
	//! License: http://openseadragon.github.io/license/
	
	/*
	 * OpenSeadragon
	 *
	 * Copyright (C) 2009 CodePlex Foundation
	 * Copyright (C) 2010-2013 OpenSeadragon contributors
	 *
	 * Redistribution and use in source and binary forms, with or without
	 * modification, are permitted provided that the following conditions are
	 * met:
	 *
	 * - Redistributions of source code must retain the above copyright notice,
	 *   this list of conditions and the following disclaimer.
	 *
	 * - Redistributions in binary form must reproduce the above copyright
	 *   notice, this list of conditions and the following disclaimer in the
	 *   documentation and/or other materials provided with the distribution.
	 *
	 * - Neither the name of CodePlex Foundation nor the names of its
	 *   contributors may be used to endorse or promote products derived from
	 *   this software without specific prior written permission.
	 *
	 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
	 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
	 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
	 * A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT
	 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
	 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
	 * TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 * PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
	 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
	 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
	 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	 */
	
	/*
	 * Portions of this source file taken from jQuery:
	 *
	 * Copyright 2011 John Resig
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining
	 * a copy of this software and associated documentation files (the
	 * "Software"), to deal in the Software without restriction, including
	 * without limitation the rights to use, copy, modify, merge, publish,
	 * distribute, sublicense, and/or sell copies of the Software, and to
	 * permit persons to whom the Software is furnished to do so, subject to
	 * the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be
	 * included in all copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
	 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
	 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
	 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
	 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
	 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	 */
	
	/*
	 * Portions of this source file taken from mattsnider.com:
	 *
	 * Copyright (c) 2006-2013 Matt Snider
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a
	 * copy of this software and associated documentation files (the "Software"),
	 * to deal in the Software without restriction, including without limitation
	 * the rights to use, copy, modify, merge, publish, distribute, sublicense,
	 * and/or sell copies of the Software, and to permit persons to whom the
	 * Software is furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included
	 * in all copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	 * OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
	 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
	 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT
	 * OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR
	 * THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	 */
	
	
	/**
	 * @namespace OpenSeadragon
	 * @version openseadragon 2.4.0
	 * @classdesc The root namespace for OpenSeadragon.  All utility methods
	 * and classes are defined on or below this namespace.
	 *
	 */
	
	
	// Typedefs
	
	 /**
	  * All required and optional settings for instantiating a new instance of an OpenSeadragon image viewer.
	  *
	  * @typedef {Object} Options
	  * @memberof OpenSeadragon
	  *
	  * @property {String} id
	  *     Id of the element to append the viewer's container element to. If not provided, the 'element' property must be provided.
	  *     If both the element and id properties are specified, the viewer is appended to the element provided in the element property.
	  *
	  * @property {Element} element
	  *     The element to append the viewer's container element to. If not provided, the 'id' property must be provided.
	  *     If both the element and id properties are specified, the viewer is appended to the element provided in the element property.
	  *
	  * @property {Array|String|Function|Object} [tileSources=null]
	  *     Tile source(s) to open initially. This is a complex parameter; see
	  *     {@link OpenSeadragon.Viewer#open} for details.
	  *
	  * @property {Number} [tabIndex=0]
	  *     Tabbing order index to assign to the viewer element. Positive values are selected in increasing order. When tabIndex is 0
	  *     source order is used. A negative value omits the viewer from the tabbing order.
	  *
	  * @property {Array} overlays Array of objects defining permanent overlays of
	  *     the viewer. The overlays added via this option and later removed with
	  *     {@link OpenSeadragon.Viewer#removeOverlay} will be added back when a new
	  *     image is opened.
	  *     To add overlays which can be definitively removed, one must use
	  *     {@link OpenSeadragon.Viewer#addOverlay}
	  *     If displaying a sequence of images, the overlays can be associated
	  *     with a specific page by passing the overlays array to the page's
	  *     tile source configuration.
	  *     Expected properties:
	  *     * x, y, (or px, py for pixel coordinates) to define the location.
	  *     * width, height in point if using x,y or in pixels if using px,py. If width
	  *       and height are specified, the overlay size is adjusted when zooming,
	  *       otherwise the size stays the size of the content (or the size defined by CSS).
	  *     * className to associate a class to the overlay
	  *     * id to set the overlay element. If an element with this id already exists,
	  *       it is reused, otherwise it is created. If not specified, a new element is
	  *       created.
	  *     * placement a string to define the relative position to the viewport.
	  *       Only used if no width and height are specified. Default: 'TOP_LEFT'.
	  *       See {@link OpenSeadragon.Placement} for possible values.
	  *
	  * @property {String} [xmlPath=null]
	  *     <strong>DEPRECATED</strong>. A relative path to load a DZI file from the server.
	  *     Prefer the newer Options.tileSources.
	  *
	  * @property {String} [prefixUrl='/images/']
	  *     Prepends the prefixUrl to navImages paths, which is very useful
	  *     since the default paths are rarely useful for production
	  *     environments.
	  *
	  * @property {OpenSeadragon.NavImages} [navImages]
	  *     An object with a property for each button or other built-in navigation
	  *     control, eg the current 'zoomIn', 'zoomOut', 'home', and 'fullpage'.
	  *     Each of those in turn provides an image path for each state of the button
	  *     or navigation control, eg 'REST', 'GROUP', 'HOVER', 'PRESS'. Finally the
	  *     image paths, by default assume there is a folder on the servers root path
	  *     called '/images', eg '/images/zoomin_rest.png'.  If you need to adjust
	  *     these paths, prefer setting the option.prefixUrl rather than overriding
	  *     every image path directly through this setting.
	  *
	  * @property {Boolean} [debugMode=false]
	  *     TODO: provide an in-screen panel providing event detail feedback.
	  *
	  * @property {String} [debugGridColor=['#437AB2', '#1B9E77', '#D95F02', '#7570B3', '#E7298A', '#66A61E', '#E6AB02', '#A6761D', '#666666']]
	  *     The colors of grids in debug mode. Each tiled image's grid uses a consecutive color.
	  *     If there are more tiled images than provided colors, the color vector is recycled.
	  *
	  * @property {Number} [blendTime=0]
	  *     Specifies the duration of animation as higher or lower level tiles are
	  *     replacing the existing tile.
	  *
	  * @property {Boolean} [alwaysBlend=false]
	  *     Forces the tile to always blend.  By default the tiles skip blending
	  *     when the blendTime is surpassed and the current animation frame would
	  *     not complete the blend.
	  *
	  * @property {Boolean} [autoHideControls=true]
	  *     If the user stops interacting with the viewport, fade the navigation
	  *     controls.  Useful for presentation since the controls are by default
	  *     floated on top of the image the user is viewing.
	  *
	  * @property {Boolean} [immediateRender=false]
	  *     Render the best closest level first, ignoring the lowering levels which
	  *     provide the effect of very blurry to sharp. It is recommended to change
	  *     setting to true for mobile devices.
	  *
	  * @property {Number} [defaultZoomLevel=0]
	  *     Zoom level to use when image is first opened or the home button is clicked.
	  *     If 0, adjusts to fit viewer.
	  *
	  * @property {Number} [opacity=1]
	  *     Default proportional opacity of the tiled images (1=opaque, 0=hidden)
	  *     Hidden images do not draw and only load when preloading is allowed.
	  *
	  * @property {Boolean} [preload=false]
	  *     Default switch for loading hidden images (true loads, false blocks)
	  *
	  * @property {String} [compositeOperation=null]
	  *     Valid values are 'source-over', 'source-atop', 'source-in', 'source-out',
	  *     'destination-over', 'destination-atop', 'destination-in',
	  *     'destination-out', 'lighter', 'copy' or 'xor'
	  *
	  * @property {String|CanvasGradient|CanvasPattern|Function} [placeholderFillStyle=null]
	  *     Draws a colored rectangle behind the tile if it is not loaded yet.
	  *     You can pass a CSS color value like "#FF8800".
	  *     When passing a function the tiledImage and canvas context are available as argument which is useful when you draw a gradient or pattern.
	  *
	  * @property {Number} [degrees=0]
	  *     Initial rotation.
	  *
	  * @property {Boolean} [flipped=false]
	  *     Initial flip state.
	  *
	  * @property {Number} [minZoomLevel=null]
	  *
	  * @property {Number} [maxZoomLevel=null]
	  *
	  * @property {Boolean} [homeFillsViewer=false]
	  *     Make the 'home' button fill the viewer and clip the image, instead
	  *     of fitting the image to the viewer and letterboxing.
	  *
	  * @property {Boolean} [panHorizontal=true]
	  *     Allow horizontal pan.
	  *
	  * @property {Boolean} [panVertical=true]
	  *     Allow vertical pan.
	  *
	  * @property {Boolean} [constrainDuringPan=false]
	  *
	  * @property {Boolean} [wrapHorizontal=false]
	  *     Set to true to force the image to wrap horizontally within the viewport.
	  *     Useful for maps or images representing the surface of a sphere or cylinder.
	  *
	  * @property {Boolean} [wrapVertical=false]
	  *     Set to true to force the image to wrap vertically within the viewport.
	  *     Useful for maps or images representing the surface of a sphere or cylinder.
	  *
	  * @property {Number} [minZoomImageRatio=0.9]
	  *     The minimum percentage ( expressed as a number between 0 and 1 ) of
	  *     the viewport height or width at which the zoom out will be constrained.
	  *     Setting it to 0, for example will allow you to zoom out infinity.
	  *
	  * @property {Number} [maxZoomPixelRatio=1.1]
	  *     The maximum ratio to allow a zoom-in to affect the highest level pixel
	  *     ratio. This can be set to Infinity to allow 'infinite' zooming into the
	  *     image though it is less effective visually if the HTML5 Canvas is not
	  *     availble on the viewing device.
	  *
	  * @property {Number} [smoothTileEdgesMinZoom=1.1]
	  *     A zoom percentage ( where 1 is 100% ) of the highest resolution level.
	  *     When zoomed in beyond this value alternative compositing will be used to
	  *     smooth out the edges between tiles. This will have a performance impact.
	  *     Can be set to Infinity to turn it off.
	  *     Note: This setting is ignored on iOS devices due to a known bug (See {@link https://github.com/openseadragon/openseadragon/issues/952})
	  *
	  * @property {Boolean} [iOSDevice=?]
	  *     True if running on an iOS device, false otherwise.
	  *     Used to disable certain features that behave differently on iOS devices.
	  *
	  * @property {Boolean} [autoResize=true]
	  *     Set to false to prevent polling for viewer size changes. Useful for providing custom resize behavior.
	  *
	  * @property {Boolean} [preserveImageSizeOnResize=false]
	  *     Set to true to have the image size preserved when the viewer is resized. This requires autoResize=true (default).
	  *
	  * @property {Number} [minScrollDeltaTime=50]
	  *     Number of milliseconds between canvas-scroll events. This value helps normalize the rate of canvas-scroll
	  *     events between different devices, causing the faster devices to slow down enough to make the zoom control
	  *     more manageable.
	  *
	  * @property {Number} [pixelsPerWheelLine=40]
	  *     For pixel-resolution scrolling devices, the number of pixels equal to one scroll line.
	  *
	  * @property {Number} [pixelsPerArrowPress=40]
	  *     The number of pixels viewport moves when an arrow key is pressed.
	  *
	  * @property {Number} [visibilityRatio=0.5]
	  *     The percentage ( as a number from 0 to 1 ) of the source image which
	  *     must be kept within the viewport.  If the image is dragged beyond that
	  *     limit, it will 'bounce' back until the minimum visibility ratio is
	  *     achieved.  Setting this to 0 and wrapHorizontal ( or wrapVertical ) to
	  *     true will provide the effect of an infinitely scrolling viewport.
	  *
	  * @property {Object} [viewportMargins={}]
	  *     Pushes the "home" region in from the sides by the specified amounts.
	  *     Possible subproperties (Numbers, in screen coordinates): left, top, right, bottom.
	  *
	  * @property {Number} [imageLoaderLimit=0]
	  *     The maximum number of image requests to make concurrently. By default
	  *     it is set to 0 allowing the browser to make the maximum number of
	  *     image requests in parallel as allowed by the browsers policy.
	  *
	  * @property {Number} [clickTimeThreshold=300]
	  *      The number of milliseconds within which a pointer down-up event combination
	  *      will be treated as a click gesture.
	  *
	  * @property {Number} [clickDistThreshold=5]
	  *      The maximum distance allowed between a pointer down event and a pointer up event
	  *      to be treated as a click gesture.
	  *
	  * @property {Number} [dblClickTimeThreshold=300]
	  *      The number of milliseconds within which two pointer down-up event combinations
	  *      will be treated as a double-click gesture.
	  *
	  * @property {Number} [dblClickDistThreshold=20]
	  *      The maximum distance allowed between two pointer click events
	  *      to be treated as a double-click gesture.
	  *
	  * @property {Number} [springStiffness=6.5]
	  *
	  * @property {Number} [animationTime=1.2]
	  *     Specifies the animation duration per each {@link OpenSeadragon.Spring}
	  *     which occur when the image is dragged or zoomed.
	  *
	  * @property {OpenSeadragon.GestureSettings} [gestureSettingsMouse]
	  *     Settings for gestures generated by a mouse pointer device. (See {@link OpenSeadragon.GestureSettings})
	  * @property {Boolean} [gestureSettingsMouse.scrollToZoom=true] - Zoom on scroll gesture
	  * @property {Boolean} [gestureSettingsMouse.clickToZoom=true] - Zoom on click gesture
	  * @property {Boolean} [gestureSettingsMouse.dblClickToZoom=false] - Zoom on double-click gesture. Note: If set to true
	  *     then clickToZoom should be set to false to prevent multiple zooms.
	  * @property {Boolean} [gestureSettingsMouse.pinchToZoom=false] - Zoom on pinch gesture
	  * @property {Boolean} [gestureSettingsMouse.zoomToRefPoint=true] - If zoomToRefPoint is true, the zoom is centered at the pointer position. Otherwise,
	  *     the zoom is centered at the canvas center.
	  * @property {Boolean} [gestureSettingsMouse.flickEnabled=false] - Enable flick gesture
	  * @property {Number} [gestureSettingsMouse.flickMinSpeed=120] - If flickEnabled is true, the minimum speed to initiate a flick gesture (pixels-per-second)
	  * @property {Number} [gestureSettingsMouse.flickMomentum=0.25] - If flickEnabled is true, the momentum factor for the flick gesture
	  * @property {Boolean} [gestureSettingsMouse.pinchRotate=false] - If pinchRotate is true, the user will have the ability to rotate the image using their fingers.
	  *
	  * @property {OpenSeadragon.GestureSettings} [gestureSettingsTouch]
	  *     Settings for gestures generated by a touch pointer device. (See {@link OpenSeadragon.GestureSettings})
	  * @property {Boolean} [gestureSettingsTouch.scrollToZoom=false] - Zoom on scroll gesture
	  * @property {Boolean} [gestureSettingsTouch.clickToZoom=false] - Zoom on click gesture
	  * @property {Boolean} [gestureSettingsTouch.dblClickToZoom=true] - Zoom on double-click gesture. Note: If set to true
	  *     then clickToZoom should be set to false to prevent multiple zooms.
	  * @property {Boolean} [gestureSettingsTouch.pinchToZoom=true] - Zoom on pinch gesture
	  * @property {Boolean} [gestureSettingsTouch.zoomToRefPoint=true] - If zoomToRefPoint is true, the zoom is centered at the pointer position. Otherwise,
	  *     the zoom is centered at the canvas center.
	  * @property {Boolean} [gestureSettingsTouch.flickEnabled=true] - Enable flick gesture
	  * @property {Number} [gestureSettingsTouch.flickMinSpeed=120] - If flickEnabled is true, the minimum speed to initiate a flick gesture (pixels-per-second)
	  * @property {Number} [gestureSettingsTouch.flickMomentum=0.25] - If flickEnabled is true, the momentum factor for the flick gesture
	  * @property {Boolean} [gestureSettingsTouch.pinchRotate=false] - If pinchRotate is true, the user will have the ability to rotate the image using their fingers.
	  *
	  * @property {OpenSeadragon.GestureSettings} [gestureSettingsPen]
	  *     Settings for gestures generated by a pen pointer device. (See {@link OpenSeadragon.GestureSettings})
	  * @property {Boolean} [gestureSettingsPen.scrollToZoom=false] - Zoom on scroll gesture
	  * @property {Boolean} [gestureSettingsPen.clickToZoom=true] - Zoom on click gesture
	  * @property {Boolean} [gestureSettingsPen.dblClickToZoom=false] - Zoom on double-click gesture. Note: If set to true
	  *     then clickToZoom should be set to false to prevent multiple zooms.
	  * @property {Boolean} [gestureSettingsPen.pinchToZoom=false] - Zoom on pinch gesture
	  * @property {Boolean} [gestureSettingsPan.zoomToRefPoint=true] - If zoomToRefPoint is true, the zoom is centered at the pointer position. Otherwise,
	  *     the zoom is centered at the canvas center.
	  * @property {Boolean} [gestureSettingsPen.flickEnabled=false] - Enable flick gesture
	  * @property {Number} [gestureSettingsPen.flickMinSpeed=120] - If flickEnabled is true, the minimum speed to initiate a flick gesture (pixels-per-second)
	  * @property {Number} [gestureSettingsPen.flickMomentum=0.25] - If flickEnabled is true, the momentum factor for the flick gesture
	  * @property {Boolean} [gestureSettingsPen.pinchRotate=false] - If pinchRotate is true, the user will have the ability to rotate the image using their fingers.
	  *
	  * @property {OpenSeadragon.GestureSettings} [gestureSettingsUnknown]
	  *     Settings for gestures generated by unknown pointer devices. (See {@link OpenSeadragon.GestureSettings})
	  * @property {Boolean} [gestureSettingsUnknown.scrollToZoom=true] - Zoom on scroll gesture
	  * @property {Boolean} [gestureSettingsUnknown.clickToZoom=false] - Zoom on click gesture
	  * @property {Boolean} [gestureSettingsUnknown.dblClickToZoom=true] - Zoom on double-click gesture. Note: If set to true
	  *     then clickToZoom should be set to false to prevent multiple zooms.
	  * @property {Boolean} [gestureSettingsUnknown.pinchToZoom=true] - Zoom on pinch gesture
	  * @property {Boolean} [gestureSettingsUnknown.zoomToRefPoint=true] - If zoomToRefPoint is true, the zoom is centered at the pointer position. Otherwise,
	  *     the zoom is centered at the canvas center.
	  * @property {Boolean} [gestureSettingsUnknown.flickEnabled=true] - Enable flick gesture
	  * @property {Number} [gestureSettingsUnknown.flickMinSpeed=120] - If flickEnabled is true, the minimum speed to initiate a flick gesture (pixels-per-second)
	  * @property {Number} [gestureSettingsUnknown.flickMomentum=0.25] - If flickEnabled is true, the momentum factor for the flick gesture
	  * @property {Boolean} [gestureSettingsUnknown.pinchRotate=false] - If pinchRotate is true, the user will have the ability to rotate the image using their fingers.
	  *
	  * @property {Number} [zoomPerClick=2.0]
	  *     The "zoom distance" per mouse click or touch tap. <em><strong>Note:</strong> Setting this to 1.0 effectively disables the click-to-zoom feature (also see gestureSettings[Mouse|Touch|Pen].clickToZoom/dblClickToZoom).</em>
	  *
	  * @property {Number} [zoomPerScroll=1.2]
	  *     The "zoom distance" per mouse scroll or touch pinch. <em><strong>Note:</strong> Setting this to 1.0 effectively disables the mouse-wheel zoom feature (also see gestureSettings[Mouse|Touch|Pen].scrollToZoom}).</em>
	  *
	  * @property {Number} [zoomPerSecond=1.0]
	  *     The number of seconds to animate a single zoom event over.
	  *
	  * @property {Boolean} [showNavigator=false]
	  *     Set to true to make the navigator minimap appear.
	  *
	  * @property {String} [navigatorId=navigator-GENERATED DATE]
	  *     The ID of a div to hold the navigator minimap.
	  *     If an ID is specified, the navigatorPosition, navigatorSizeRatio, navigatorMaintainSizeRatio, navigator[Top|Left|Height|Width] and navigatorAutoFade options will be ignored.
	  *     If an ID is not specified, a div element will be generated and placed on top of the main image.
	  *
	  * @property {String} [navigatorPosition='TOP_RIGHT']
	  *     Valid values are 'TOP_LEFT', 'TOP_RIGHT', 'BOTTOM_LEFT', 'BOTTOM_RIGHT', or 'ABSOLUTE'.<br>
	  *     If 'ABSOLUTE' is specified, then navigator[Top|Left|Height|Width] determines the size and position of the navigator minimap in the viewer, and navigatorSizeRatio and navigatorMaintainSizeRatio are ignored.<br>
	  *     For 'TOP_LEFT', 'TOP_RIGHT', 'BOTTOM_LEFT', and 'BOTTOM_RIGHT', the navigatorSizeRatio or navigator[Height|Width] values determine the size of the navigator minimap.
	  *
	  * @property {Number} [navigatorSizeRatio=0.2]
	  *     Ratio of navigator size to viewer size. Ignored if navigator[Height|Width] are specified.
	  *
	  * @property {Boolean} [navigatorMaintainSizeRatio=false]
	  *     If true, the navigator minimap is resized (using navigatorSizeRatio) when the viewer size changes.
	  *
	  * @property {Number|String} [navigatorTop=null]
	  *     Specifies the location of the navigator minimap (see navigatorPosition).
	  *
	  * @property {Number|String} [navigatorLeft=null]
	  *     Specifies the location of the navigator minimap (see navigatorPosition).
	  *
	  * @property {Number|String} [navigatorHeight=null]
	  *     Specifies the size of the navigator minimap (see navigatorPosition).
	  *     If specified, navigatorSizeRatio and navigatorMaintainSizeRatio are ignored.
	  *
	  * @property {Number|String} [navigatorWidth=null]
	  *     Specifies the size of the navigator minimap (see navigatorPosition).
	  *     If specified, navigatorSizeRatio and navigatorMaintainSizeRatio are ignored.
	  *
	  * @property {Boolean} [navigatorAutoResize=true]
	  *     Set to false to prevent polling for navigator size changes. Useful for providing custom resize behavior.
	  *     Setting to false can also improve performance when the navigator is configured to a fixed size.
	  *
	  * @property {Boolean} [navigatorAutoFade=true]
	  *     If the user stops interacting with the viewport, fade the navigator minimap.
	  *     Setting to false will make the navigator minimap always visible.
	  *
	  * @property {Boolean} [navigatorRotate=true]
	  *     If true, the navigator will be rotated together with the viewer.
	  *
	  * @property {String} [navigatorBackground='#000']
	  *     Specifies the background color of the navigator minimap
	  *
	  * @property {Number} [navigatorOpacity=0.8]
	  *     Specifies the opacity of the navigator minimap.
	  *
	  * @property {String} [navigatorBorderColor='#555']
	  *     Specifies the border color of the navigator minimap
	  *
	  * @property {String} [navigatorDisplayRegionColor='#900']
	  *     Specifies the border color of the display region rectangle of the navigator minimap
	  *
	  * @property {Number} [controlsFadeDelay=2000]
	  *     The number of milliseconds to wait once the user has stopped interacting
	  *     with the interface before begining to fade the controls. Assumes
	  *     showNavigationControl and autoHideControls are both true.
	  *
	  * @property {Number} [controlsFadeLength=1500]
	  *     The number of milliseconds to animate the controls fading out.
	  *
	  * @property {Number} [maxImageCacheCount=200]
	  *     The max number of images we should keep in memory (per drawer).
	  *
	  * @property {Number} [timeout=30000]
	  *     The max number of milliseconds that an image job may take to complete.
	  *
	  * @property {Boolean} [useCanvas=true]
	  *     Set to false to not use an HTML canvas element for image rendering even if canvas is supported.
	  *
	  * @property {Number} [minPixelRatio=0.5]
	  *     The higher the minPixelRatio, the lower the quality of the image that
	  *     is considered sufficient to stop rendering a given zoom level.  For
	  *     example, if you are targeting mobile devices with less bandwith you may
	  *     try setting this to 1.5 or higher.
	  *
	  * @property {Boolean} [mouseNavEnabled=true]
	  *     Is the user able to interact with the image via mouse or touch. Default
	  *     interactions include draging the image in a plane, and zooming in toward
	  *     and away from the image.
	  *
	  * @property {Boolean} [showNavigationControl=true]
	  *     Set to false to prevent the appearance of the default navigation controls.<br>
	  *     Note that if set to false, the customs buttons set by the options
	  *     zoomInButton, zoomOutButton etc, are rendered inactive.
	  *
	  * @property {OpenSeadragon.ControlAnchor} [navigationControlAnchor=TOP_LEFT]
	  *     Placement of the default navigation controls.
	  *     To set the placement of the sequence controls, see the
	  *     sequenceControlAnchor option.
	  *
	  * @property {Boolean} [showZoomControl=true]
	  *     If true then + and - buttons to zoom in and out are displayed.<br>
	  *     Note: {@link OpenSeadragon.Options.showNavigationControl} is overriding
	  *     this setting when set to false.
	  *
	  * @property {Boolean} [showHomeControl=true]
	  *     If true then the 'Go home' button is displayed to go back to the original
	  *     zoom and pan.<br>
	  *     Note: {@link OpenSeadragon.Options.showNavigationControl} is overriding
	  *     this setting when set to false.
	  *
	  * @property {Boolean} [showFullPageControl=true]
	  *     If true then the 'Toggle full page' button is displayed to switch
	  *     between full page and normal mode.<br>
	  *     Note: {@link OpenSeadragon.Options.showNavigationControl} is overriding
	  *     this setting when set to false.
	  *
	  * @property {Boolean} [showRotationControl=false]
	  *     If true then the rotate left/right controls will be displayed as part of the
	  *     standard controls. This is also subject to the browser support for rotate
	  *     (e.g. viewer.drawer.canRotate()).<br>
	  *     Note: {@link OpenSeadragon.Options.showNavigationControl} is overriding
	  *     this setting when set to false.
	  *
	  * @property {Boolean} [showFlipControl=false]
	  *     If true then the flip controls will be displayed as part of the
	  *     standard controls.
	  *
	  * @property {Boolean} [showSequenceControl=true]
	  *     If sequenceMode is true, then provide buttons for navigating forward and
	  *     backward through the images.
	  *
	  * @property {OpenSeadragon.ControlAnchor} [sequenceControlAnchor=TOP_LEFT]
	  *     Placement of the default sequence controls.
	  *
	  * @property {Boolean} [navPrevNextWrap=false]
	  *     If true then the 'previous' button will wrap to the last image when
	  *     viewing the first image and the 'next' button will wrap to the first
	  *     image when viewing the last image.
	  *
	  * @property {String} zoomInButton
	  *     Set the id of the custom 'Zoom in' button to use.
	  *     This is useful to have a custom button anywhere in the web page.<br>
	  *     To only change the button images, consider using
	  *     {@link OpenSeadragon.Options.navImages}
	  *
	  * @property {String} zoomOutButton
	  *     Set the id of the custom 'Zoom out' button to use.
	  *     This is useful to have a custom button anywhere in the web page.<br>
	  *     To only change the button images, consider using
	  *     {@link OpenSeadragon.Options.navImages}
	  *
	  * @property {String} homeButton
	  *     Set the id of the custom 'Go home' button to use.
	  *     This is useful to have a custom button anywhere in the web page.<br>
	  *     To only change the button images, consider using
	  *     {@link OpenSeadragon.Options.navImages}
	  *
	  * @property {String} fullPageButton
	  *     Set the id of the custom 'Toggle full page' button to use.
	  *     This is useful to have a custom button anywhere in the web page.<br>
	  *     To only change the button images, consider using
	  *     {@link OpenSeadragon.Options.navImages}
	  *
	  * @property {String} rotateLeftButton
	  *     Set the id of the custom 'Rotate left' button to use.
	  *     This is useful to have a custom button anywhere in the web page.<br>
	  *     To only change the button images, consider using
	  *     {@link OpenSeadragon.Options.navImages}
	  *
	  * @property {String} rotateRightButton
	  *     Set the id of the custom 'Rotate right' button to use.
	  *     This is useful to have a custom button anywhere in the web page.<br>
	  *     To only change the button images, consider using
	  *     {@link OpenSeadragon.Options.navImages}
	  *
	  * @property {String} previousButton
	  *     Set the id of the custom 'Previous page' button to use.
	  *     This is useful to have a custom button anywhere in the web page.<br>
	  *     To only change the button images, consider using
	  *     {@link OpenSeadragon.Options.navImages}
	  *
	  * @property {String} nextButton
	  *     Set the id of the custom 'Next page' button to use.
	  *     This is useful to have a custom button anywhere in the web page.<br>
	  *     To only change the button images, consider using
	  *     {@link OpenSeadragon.Options.navImages}
	  *
	  * @property {Boolean} [sequenceMode=false]
	  *     Set to true to have the viewer treat your tilesources as a sequence of images to
	  *     be opened one at a time rather than all at once.
	  *
	  * @property {Number} [initialPage=0]
	  *     If sequenceMode is true, display this page initially.
	  *
	  * @property {Boolean} [preserveViewport=false]
	  *     If sequenceMode is true, then normally navigating through each image resets the
	  *     viewport to 'home' position.  If preserveViewport is set to true, then the viewport
	  *     position is preserved when navigating between images in the sequence.
	  *
	  * @property {Boolean} [preserveOverlays=false]
	  *     If sequenceMode is true, then normally navigating through each image
	  *     resets the overlays.
	  *     If preserveOverlays is set to true, then the overlays added with {@link OpenSeadragon.Viewer#addOverlay}
	  *     are preserved when navigating between images in the sequence.
	  *     Note: setting preserveOverlays overrides any overlays specified in the global
	  *     "overlays" option for the Viewer. It's also not compatible with specifying
	  *     per-tileSource overlays via the options, as those overlays will persist
	  *     even after the tileSource is closed.
	  *
	  * @property {Boolean} [showReferenceStrip=false]
	  *     If sequenceMode is true, then display a scrolling strip of image thumbnails for
	  *     navigating through the images.
	  *
	  * @property {String} [referenceStripScroll='horizontal']
	  *
	  * @property {Element} [referenceStripElement=null]
	  *
	  * @property {Number} [referenceStripHeight=null]
	  *
	  * @property {Number} [referenceStripWidth=null]
	  *
	  * @property {String} [referenceStripPosition='BOTTOM_LEFT']
	  *
	  * @property {Number} [referenceStripSizeRatio=0.2]
	  *
	  * @property {Boolean} [collectionMode=false]
	  *     Set to true to have the viewer arrange your TiledImages in a grid or line.
	  *
	  * @property {Number} [collectionRows=3]
	  *     If collectionMode is true, specifies how many rows the grid should have. Use 1 to make a line.
	  *     If collectionLayout is 'vertical', specifies how many columns instead.
	  *
	  * @property {Number} [collectionColumns=0]
	  *     If collectionMode is true, specifies how many columns the grid should have. Use 1 to make a line.
	  *     If collectionLayout is 'vertical', specifies how many rows instead. Ignored if collectionRows is not set to a falsy value.
	  *
	  * @property {String} [collectionLayout='horizontal']
	  *     If collectionMode is true, specifies whether to arrange vertically or horizontally.
	  *
	  * @property {Number} [collectionTileSize=800]
	  *     If collectionMode is true, specifies the size, in viewport coordinates, for each TiledImage to fit into.
	  *     The TiledImage will be centered within a square of the specified size.
	  *
	  * @property {Number} [collectionTileMargin=80]
	  *     If collectionMode is true, specifies the margin, in viewport coordinates, between each TiledImage.
	  *
	  * @property {String|Boolean} [crossOriginPolicy=false]
	  *     Valid values are 'Anonymous', 'use-credentials', and false. If false, canvas requests will
	  *     not use CORS, and the canvas will be tainted.
	  *
	  * @property {Boolean} [ajaxWithCredentials=false]
	  *     Whether to set the withCredentials XHR flag for AJAX requests.
	  *     Note that this can be overridden at the {@link OpenSeadragon.TileSource} level.
	  *
	  * @property {Boolean} [loadTilesWithAjax=false]
	  *     Whether to load tile data using AJAX requests.
	  *     Note that this can be overridden at the {@link OpenSeadragon.TileSource} level.
	  *
	  * @property {Object} [ajaxHeaders={}]
	  *     A set of headers to include when making AJAX requests for tile sources or tiles.
	  *
	  */
	
	 /**
	  * Settings for gestures generated by a pointer device.
	  *
	  * @typedef {Object} GestureSettings
	  * @memberof OpenSeadragon
	  *
	  * @property {Boolean} scrollToZoom
	  *     Set to false to disable zooming on scroll gestures.
	  *
	  * @property {Boolean} clickToZoom
	  *     Set to false to disable zooming on click gestures.
	  *
	  * @property {Boolean} dblClickToZoom
	  *     Set to false to disable zooming on double-click gestures. Note: If set to true
	  *     then clickToZoom should be set to false to prevent multiple zooms.
	  *
	  * @property {Boolean} pinchToZoom
	  *     Set to false to disable zooming on pinch gestures.
	  *
	  * @property {Boolean} flickEnabled
	  *     Set to false to disable the kinetic panning effect (flick) at the end of a drag gesture.
	  *
	  * @property {Number} flickMinSpeed
	  *     If flickEnabled is true, the minimum speed (in pixels-per-second) required to cause the kinetic panning effect (flick) at the end of a drag gesture.
	  *
	  * @property {Number} flickMomentum
	  *     If flickEnabled is true, a constant multiplied by the velocity to determine the distance of the kinetic panning effect (flick) at the end of a drag gesture.
	  *     A larger value will make the flick feel "lighter", while a smaller value will make the flick feel "heavier".
	  *     Note: springStiffness and animationTime also affect the "spring" used to stop the flick animation.
	  *
	  */
	
	/**
	  * The names for the image resources used for the image navigation buttons.
	  *
	  * @typedef {Object} NavImages
	  * @memberof OpenSeadragon
	  *
	  * @property {Object} zoomIn - Images for the zoom-in button.
	  * @property {String} zoomIn.REST
	  * @property {String} zoomIn.GROUP
	  * @property {String} zoomIn.HOVER
	  * @property {String} zoomIn.DOWN
	  *
	  * @property {Object} zoomOut - Images for the zoom-out button.
	  * @property {String} zoomOut.REST
	  * @property {String} zoomOut.GROUP
	  * @property {String} zoomOut.HOVER
	  * @property {String} zoomOut.DOWN
	  *
	  * @property {Object} home - Images for the home button.
	  * @property {String} home.REST
	  * @property {String} home.GROUP
	  * @property {String} home.HOVER
	  * @property {String} home.DOWN
	  *
	  * @property {Object} fullpage - Images for the full-page button.
	  * @property {String} fullpage.REST
	  * @property {String} fullpage.GROUP
	  * @property {String} fullpage.HOVER
	  * @property {String} fullpage.DOWN
	  *
	  * @property {Object} rotateleft - Images for the rotate left button.
	  * @property {String} rotateleft.REST
	  * @property {String} rotateleft.GROUP
	  * @property {String} rotateleft.HOVER
	  * @property {String} rotateleft.DOWN
	  *
	  * @property {Object} rotateright - Images for the rotate right button.
	  * @property {String} rotateright.REST
	  * @property {String} rotateright.GROUP
	  * @property {String} rotateright.HOVER
	  * @property {String} rotateright.DOWN
	  *
	  * @property {Object} flip - Images for the flip button.
	  * @property {String} flip.REST
	  * @property {String} flip.GROUP
	  * @property {String} flip.HOVER
	  * @property {String} flip.DOWN
	  *
	  * @property {Object} previous - Images for the previous button.
	  * @property {String} previous.REST
	  * @property {String} previous.GROUP
	  * @property {String} previous.HOVER
	  * @property {String} previous.DOWN
	  *
	  * @property {Object} next - Images for the next button.
	  * @property {String} next.REST
	  * @property {String} next.GROUP
	  * @property {String} next.HOVER
	  * @property {String} next.DOWN
	  *
	  */
	
	
	function OpenSeadragon( options ){
	    return new OpenSeadragon.Viewer( options );
	}
	
	(function( $ ){
	
	
	    /**
	     * The OpenSeadragon version.
	     *
	     * @member {Object} OpenSeadragon.version
	     * @property {String} versionStr - The version number as a string ('major.minor.revision').
	     * @property {Number} major - The major version number.
	     * @property {Number} minor - The minor version number.
	     * @property {Number} revision - The revision number.
	     * @since 1.0.0
	     */
	    $.version = {
	        versionStr: '2.4.0',
	        major: parseInt('2', 10),
	        minor: parseInt('4', 10),
	        revision: parseInt('0', 10)
	    };
	
	
	    /**
	     * Taken from jquery 1.6.1
	     * [[Class]] -> type pairs
	     * @private
	     */
	    var class2type = {
	            '[object Boolean]':     'boolean',
	            '[object Number]':      'number',
	            '[object String]':      'string',
	            '[object Function]':    'function',
	            '[object Array]':       'array',
	            '[object Date]':        'date',
	            '[object RegExp]':      'regexp',
	            '[object Object]':      'object'
	        },
	        // Save a reference to some core methods
	        toString    = Object.prototype.toString,
	        hasOwn      = Object.prototype.hasOwnProperty;
	
	    /**
	     * Taken from jQuery 1.6.1
	     * @function isFunction
	     * @memberof OpenSeadragon
	     * @see {@link http://www.jquery.com/ jQuery}
	     */
	    $.isFunction = function( obj ) {
	        return $.type(obj) === "function";
	    };
	
	
	    /**
	     * Taken from jQuery 1.6.1
	     * @function isArray
	     * @memberof OpenSeadragon
	     * @see {@link http://www.jquery.com/ jQuery}
	     */
	    $.isArray = Array.isArray || function( obj ) {
	        return $.type(obj) === "array";
	    };
	
	
	    /**
	     * A crude way of determining if an object is a window.
	     * Taken from jQuery 1.6.1
	     * @function isWindow
	     * @memberof OpenSeadragon
	     * @see {@link http://www.jquery.com/ jQuery}
	     */
	    $.isWindow = function( obj ) {
	        return obj && typeof obj === "object" && "setInterval" in obj;
	    };
	
	
	    /**
	     * Taken from jQuery 1.6.1
	     * @function type
	     * @memberof OpenSeadragon
	     * @see {@link http://www.jquery.com/ jQuery}
	     */
	    $.type = function( obj ) {
	        return ( obj === null ) || ( obj === undefined ) ?
	            String( obj ) :
	            class2type[ toString.call(obj) ] || "object";
	    };
	
	
	    /**
	     * Taken from jQuery 1.6.1
	     * @function isPlainObject
	     * @memberof OpenSeadragon
	     * @see {@link http://www.jquery.com/ jQuery}
	     */
	    $.isPlainObject = function( obj ) {
	        // Must be an Object.
	        // Because of IE, we also have to check the presence of the constructor property.
	        // Make sure that DOM nodes and window objects don't pass through, as well
	        if ( !obj || OpenSeadragon.type(obj) !== "object" || obj.nodeType || $.isWindow( obj ) ) {
	            return false;
	        }
	
	        // Not own constructor property must be Object
	        if ( obj.constructor &&
	            !hasOwn.call(obj, "constructor") &&
	            !hasOwn.call(obj.constructor.prototype, "isPrototypeOf") ) {
	            return false;
	        }
	
	        // Own properties are enumerated firstly, so to speed up,
	        // if last one is own, then all properties are own.
	
	        var lastKey;
	        for (var key in obj ) {
	            lastKey = key;
	        }
	
	        return lastKey === undefined || hasOwn.call( obj, lastKey );
	    };
	
	
	    /**
	     * Taken from jQuery 1.6.1
	     * @function isEmptyObject
	     * @memberof OpenSeadragon
	     * @see {@link http://www.jquery.com/ jQuery}
	     */
	    $.isEmptyObject = function( obj ) {
	        for ( var name in obj ) {
	            return false;
	        }
	        return true;
	    };
	
	    /**
	     * Shim around Object.freeze. Does nothing if Object.freeze is not supported.
	     * @param {Object} obj The object to freeze.
	     * @return {Object} obj The frozen object.
	     */
	    $.freezeObject = function(obj) {
	        if (Object.freeze) {
	            $.freezeObject = Object.freeze;
	        } else {
	            $.freezeObject = function(obj) {
	                return obj;
	            };
	        }
	        return $.freezeObject(obj);
	    };
	
	    /**
	     * True if the browser supports the HTML5 canvas element
	     * @member {Boolean} supportsCanvas
	     * @memberof OpenSeadragon
	     */
	    $.supportsCanvas = (function () {
	        var canvasElement = document.createElement( 'canvas' );
	        return !!( $.isFunction( canvasElement.getContext ) &&
	                    canvasElement.getContext( '2d' ) );
	    }());
	
	    /**
	     * Test whether the submitted canvas is tainted or not.
	     * @argument {Canvas} canvas The canvas to test.
	     * @returns {Boolean} True if the canvas is tainted.
	     */
	    $.isCanvasTainted = function(canvas) {
	        var isTainted = false;
	        try {
	            // We test if the canvas is tainted by retrieving data from it.
	            // An exception will be raised if the canvas is tainted.
	            canvas.getContext('2d').getImageData(0, 0, 1, 1);
	        } catch (e) {
	            isTainted = true;
	        }
	        return isTainted;
	    };
	
	    /**
	     * A ratio comparing the device screen's pixel density to the canvas's backing store pixel density,
	     * clamped to a minimum of 1. Defaults to 1 if canvas isn't supported by the browser.
	     * @member {Number} pixelDensityRatio
	     * @memberof OpenSeadragon
	     */
	    $.pixelDensityRatio = (function () {
	        if ( $.supportsCanvas ) {
	            var context = document.createElement('canvas').getContext('2d');
	            var devicePixelRatio = window.devicePixelRatio || 1;
	            var backingStoreRatio = context.webkitBackingStorePixelRatio ||
	                                    context.mozBackingStorePixelRatio ||
	                                    context.msBackingStorePixelRatio ||
	                                    context.oBackingStorePixelRatio ||
	                                    context.backingStorePixelRatio || 1;
	            return Math.max(devicePixelRatio, 1) / backingStoreRatio;
	        } else {
	            return 1;
	        }
	    }());
	
	}( OpenSeadragon ));
	
	/**
	 *  This closure defines all static methods available to the OpenSeadragon
	 *  namespace.  Many, if not most, are taked directly from jQuery for use
	 *  to simplify and reduce common programming patterns.  More static methods
	 *  from jQuery may eventually make their way into this though we are
	 *  attempting to avoid an explicit dependency on jQuery only because
	 *  OpenSeadragon is a broadly useful code base and would be made less broad
	 *  by requiring jQuery fully.
	 *
	 *  Some static methods have also been refactored from the original OpenSeadragon
	 *  project.
	 */
	(function( $ ){
	
	    /**
	     * Taken from jQuery 1.6.1
	     * @function extend
	     * @memberof OpenSeadragon
	     * @see {@link http://www.jquery.com/ jQuery}
	     */
	    $.extend = function() {
	        var options,
	            name,
	            src,
	            copy,
	            copyIsArray,
	            clone,
	            target  = arguments[ 0 ] || {},
	            length  = arguments.length,
	            deep    = false,
	            i       = 1;
	
	        // Handle a deep copy situation
	        if ( typeof target === "boolean" ) {
	            deep    = target;
	            target  = arguments[ 1 ] || {};
	            // skip the boolean and the target
	            i = 2;
	        }
	
	        // Handle case when target is a string or something (possible in deep copy)
	        if ( typeof target !== "object" && !OpenSeadragon.isFunction( target ) ) {
	            target = {};
	        }
	
	        // extend jQuery itself if only one argument is passed
	        if ( length === i ) {
	            target = this;
	            --i;
	        }
	
	        for ( ; i < length; i++ ) {
	            // Only deal with non-null/undefined values
	            options = arguments[ i ];
	            if ( options !== null || options !== undefined ) {
	                // Extend the base object
	                for ( name in options ) {
	                    src = target[ name ];
	                    copy = options[ name ];
	
	                    // Prevent never-ending loop
	                    if ( target === copy ) {
	                        continue;
	                    }
	
	                    // Recurse if we're merging plain objects or arrays
	                    if ( deep && copy && ( OpenSeadragon.isPlainObject( copy ) || ( copyIsArray = OpenSeadragon.isArray( copy ) ) ) ) {
	                        if ( copyIsArray ) {
	                            copyIsArray = false;
	                            clone = src && OpenSeadragon.isArray( src ) ? src : [];
	
	                        } else {
	                            clone = src && OpenSeadragon.isPlainObject( src ) ? src : {};
	                        }
	
	                        // Never move original objects, clone them
	                        target[ name ] = OpenSeadragon.extend( deep, clone, copy );
	
	                    // Don't bring in undefined values
	                    } else if ( copy !== undefined ) {
	                        target[ name ] = copy;
	                    }
	                }
	            }
	        }
	
	        // Return the modified object
	        return target;
	    };
	
	    var isIOSDevice = function () {
	        if (typeof navigator !== 'object') {
	            return false;
	        }
	        var userAgent = navigator.userAgent;
	        if (typeof userAgent !== 'string') {
	            return false;
	        }
	        return userAgent.indexOf('iPhone') !== -1 ||
	               userAgent.indexOf('iPad') !== -1 ||
	               userAgent.indexOf('iPod') !== -1;
	    };
	
	    $.extend( $, /** @lends OpenSeadragon */{
	        /**
	         * The default values for the optional settings documented at {@link OpenSeadragon.Options}.
	         * @static
	         * @type {Object}
	         */
	        DEFAULT_SETTINGS: {
	            //DATA SOURCE DETAILS
	            xmlPath:                null,
	            tileSources:            null,
	            tileHost:               null,
	            initialPage:            0,
	            crossOriginPolicy:      false,
	            ajaxWithCredentials:    false,
	            loadTilesWithAjax:      false,
	            ajaxHeaders:            {},
	
	            //PAN AND ZOOM SETTINGS AND CONSTRAINTS
	            panHorizontal:          true,
	            panVertical:            true,
	            constrainDuringPan:     false,
	            wrapHorizontal:         false,
	            wrapVertical:           false,
	            visibilityRatio:        0.5, //-> how much of the viewer can be negative space
	            minPixelRatio:          0.5, //->closer to 0 draws tiles meant for a higher zoom at this zoom
	            defaultZoomLevel:       0,
	            minZoomLevel:           null,
	            maxZoomLevel:           null,
	            homeFillsViewer:        false,
	
	            //UI RESPONSIVENESS AND FEEL
	            clickTimeThreshold:     300,
	            clickDistThreshold:     5,
	            dblClickTimeThreshold:  300,
	            dblClickDistThreshold:  20,
	            springStiffness:        6.5,
	            animationTime:          1.2,
	            gestureSettingsMouse:   {
	                scrollToZoom: true,
	                clickToZoom: true,
	                dblClickToZoom: false,
	                pinchToZoom: false,
	                zoomToRefPoint: true,
	                flickEnabled: false,
	                flickMinSpeed: 120,
	                flickMomentum: 0.25,
	                pinchRotate: false
	            },
	            gestureSettingsTouch:   {
	                scrollToZoom: false,
	                clickToZoom: false,
	                dblClickToZoom: true,
	                pinchToZoom: true,
	                zoomToRefPoint: true,
	                flickEnabled: true,
	                flickMinSpeed: 120,
	                flickMomentum: 0.25,
	                pinchRotate: false
	            },
	            gestureSettingsPen:     {
	                scrollToZoom: false,
	                clickToZoom: true,
	                dblClickToZoom: false,
	                pinchToZoom: false,
	                zoomToRefPoint: true,
	                flickEnabled: false,
	                flickMinSpeed: 120,
	                flickMomentum: 0.25,
	                pinchRotate: false
	            },
	            gestureSettingsUnknown: {
	                scrollToZoom: false,
	                clickToZoom: false,
	                dblClickToZoom: true,
	                pinchToZoom: true,
	                zoomToRefPoint: true,
	                flickEnabled: true,
	                flickMinSpeed: 120,
	                flickMomentum: 0.25,
	                pinchRotate: false
	            },
	            zoomPerClick:           2,
	            zoomPerScroll:          1.2,
	            zoomPerSecond:          1.0,
	            blendTime:              0,
	            alwaysBlend:            false,
	            autoHideControls:       true,
	            immediateRender:        false,
	            minZoomImageRatio:      0.9, //-> closer to 0 allows zoom out to infinity
	            maxZoomPixelRatio:      1.1, //-> higher allows 'over zoom' into pixels
	            smoothTileEdgesMinZoom: 1.1, //-> higher than maxZoomPixelRatio disables it
	            iOSDevice:              isIOSDevice(),
	            pixelsPerWheelLine:     40,
	            pixelsPerArrowPress:    40,
	            autoResize:             true,
	            preserveImageSizeOnResize: false, // requires autoResize=true
	            minScrollDeltaTime:     50,
	
	            //DEFAULT CONTROL SETTINGS
	            showSequenceControl:     true,  //SEQUENCE
	            sequenceControlAnchor:   null,  //SEQUENCE
	            preserveViewport:        false, //SEQUENCE
	            preserveOverlays:        false, //SEQUENCE
	            navPrevNextWrap:         false, //SEQUENCE
	            showNavigationControl:   true,  //ZOOM/HOME/FULL/ROTATION
	            navigationControlAnchor: null,  //ZOOM/HOME/FULL/ROTATION
	            showZoomControl:         true,  //ZOOM
	            showHomeControl:         true,  //HOME
	            showFullPageControl:     true,  //FULL
	            showRotationControl:     false, //ROTATION
	            showFlipControl:         false,  //FLIP
	            controlsFadeDelay:       2000,  //ZOOM/HOME/FULL/SEQUENCE
	            controlsFadeLength:      1500,  //ZOOM/HOME/FULL/SEQUENCE
	            mouseNavEnabled:         true,  //GENERAL MOUSE INTERACTIVITY
	
	            //VIEWPORT NAVIGATOR SETTINGS
	            showNavigator:              false,
	            navigatorId:                null,
	            navigatorPosition:          null,
	            navigatorSizeRatio:         0.2,
	            navigatorMaintainSizeRatio: false,
	            navigatorTop:               null,
	            navigatorLeft:              null,
	            navigatorHeight:            null,
	            navigatorWidth:             null,
	            navigatorAutoResize:        true,
	            navigatorAutoFade:          true,
	            navigatorRotate:            true,
	            navigatorBackground:        '#000',
	            navigatorOpacity:           0.8,
	            navigatorBorderColor:       '#555',
	            navigatorDisplayRegionColor: '#900',
	
	            // INITIAL ROTATION
	            degrees:                    0,
	
	            // INITIAL FLIP STATE
	            flipped:                    false,
	
	            // APPEARANCE
	            opacity:                    1,
	            preload:                    false,
	            compositeOperation:         null,
	            placeholderFillStyle:       null,
	
	            //REFERENCE STRIP SETTINGS
	            showReferenceStrip:          false,
	            referenceStripScroll:       'horizontal',
	            referenceStripElement:       null,
	            referenceStripHeight:        null,
	            referenceStripWidth:         null,
	            referenceStripPosition:      'BOTTOM_LEFT',
	            referenceStripSizeRatio:     0.2,
	
	            //COLLECTION VISUALIZATION SETTINGS
	            collectionRows:         3, //or columns depending on layout
	            collectionColumns:      0, //columns in horizontal layout, rows in vertical layout
	            collectionLayout:       'horizontal', //vertical
	            collectionMode:         false,
	            collectionTileSize:     800,
	            collectionTileMargin:   80,
	
	            //PERFORMANCE SETTINGS
	            imageLoaderLimit:       0,
	            maxImageCacheCount:     200,
	            timeout:                30000,
	            useCanvas:              true,  // Use canvas element for drawing if available
	
	            //INTERFACE RESOURCE SETTINGS
	            prefixUrl:              "/images/",
	            navImages: {
	                zoomIn: {
	                    REST:   'zoomin_rest.png',
	                    GROUP:  'zoomin_grouphover.png',
	                    HOVER:  'zoomin_hover.png',
	                    DOWN:   'zoomin_pressed.png'
	                },
	                zoomOut: {
	                    REST:   'zoomout_rest.png',
	                    GROUP:  'zoomout_grouphover.png',
	                    HOVER:  'zoomout_hover.png',
	                    DOWN:   'zoomout_pressed.png'
	                },
	                home: {
	                    REST:   'home_rest.png',
	                    GROUP:  'home_grouphover.png',
	                    HOVER:  'home_hover.png',
	                    DOWN:   'home_pressed.png'
	                },
	                fullpage: {
	                    REST:   'fullpage_rest.png',
	                    GROUP:  'fullpage_grouphover.png',
	                    HOVER:  'fullpage_hover.png',
	                    DOWN:   'fullpage_pressed.png'
	                },
	                rotateleft: {
	                    REST:   'rotateleft_rest.png',
	                    GROUP:  'rotateleft_grouphover.png',
	                    HOVER:  'rotateleft_hover.png',
	                    DOWN:   'rotateleft_pressed.png'
	                },
	                rotateright: {
	                    REST:   'rotateright_rest.png',
	                    GROUP:  'rotateright_grouphover.png',
	                    HOVER:  'rotateright_hover.png',
	                    DOWN:   'rotateright_pressed.png'
	                },
	                flip: { // Flip icon designed by Yaroslav Samoylov from the Noun Project and modified by Nelson Campos ncampos@criteriamarathon.com, https://thenounproject.com/term/flip/136289/
	                    REST:   'flip_rest.png',
	                    GROUP:  'flip_grouphover.png',
	                    HOVER:  'flip_hover.png',
	                    DOWN:   'flip_pressed.png'
	                },
	                previous: {
	                    REST:   'previous_rest.png',
	                    GROUP:  'previous_grouphover.png',
	                    HOVER:  'previous_hover.png',
	                    DOWN:   'previous_pressed.png'
	                },
	                next: {
	                    REST:   'next_rest.png',
	                    GROUP:  'next_grouphover.png',
	                    HOVER:  'next_hover.png',
	                    DOWN:   'next_pressed.png'
	                }
	            },
	
	            //DEVELOPER SETTINGS
	            debugMode:              false,
	            debugGridColor:         ['#437AB2', '#1B9E77', '#D95F02', '#7570B3', '#E7298A', '#66A61E', '#E6AB02', '#A6761D', '#666666']
	        },
	
	
	        /**
	         * TODO: get rid of this.  I can't see how it's required at all.  Looks
	         *       like an early legacy code artifact.
	         * @static
	         * @ignore
	         */
	        SIGNAL: "----seadragon----",
	
	
	        /**
	         * Returns a function which invokes the method as if it were a method belonging to the object.
	         * @function
	         * @param {Object} object
	         * @param {Function} method
	         * @returns {Function}
	         */
	        delegate: function( object, method ) {
	            return function(){
	                var args = arguments;
	                if ( args === undefined ){
	                    args = [];
	                }
	                return method.apply( object, args );
	            };
	        },
	
	
	        /**
	         * An enumeration of Browser vendors.
	         * @static
	         * @type {Object}
	         * @property {Number} UNKNOWN
	         * @property {Number} IE
	         * @property {Number} FIREFOX
	         * @property {Number} SAFARI
	         * @property {Number} CHROME
	         * @property {Number} OPERA
	         */
	        BROWSERS: {
	            UNKNOWN:    0,
	            IE:         1,
	            FIREFOX:    2,
	            SAFARI:     3,
	            CHROME:     4,
	            OPERA:      5
	        },
	
	
	        /**
	         * Returns a DOM Element for the given id or element.
	         * @function
	         * @param {String|Element} element Accepts an id or element.
	         * @returns {Element} The element with the given id, null, or the element itself.
	         */
	        getElement: function( element ) {
	            if ( typeof ( element ) == "string" ) {
	                element = document.getElementById( element );
	            }
	            return element;
	        },
	
	
	        /**
	         * Determines the position of the upper-left corner of the element.
	         * @function
	         * @param {Element|String} element - the elemenet we want the position for.
	         * @returns {OpenSeadragon.Point} - the position of the upper left corner of the element.
	         */
	        getElementPosition: function( element ) {
	            var result = new $.Point(),
	                isFixed,
	                offsetParent;
	
	            element      = $.getElement( element );
	            isFixed      = $.getElementStyle( element ).position == "fixed";
	            offsetParent = getOffsetParent( element, isFixed );
	
	            while ( offsetParent ) {
	
	                result.x += element.offsetLeft;
	                result.y += element.offsetTop;
	
	                if ( isFixed ) {
	                    result = result.plus( $.getPageScroll() );
	                }
	
	                element = offsetParent;
	                isFixed = $.getElementStyle( element ).position == "fixed";
	                offsetParent = getOffsetParent( element, isFixed );
	            }
	
	            return result;
	        },
	
	
	        /**
	         * Determines the position of the upper-left corner of the element adjusted for current page and/or element scroll.
	         * @function
	         * @param {Element|String} element - the element we want the position for.
	         * @returns {OpenSeadragon.Point} - the position of the upper left corner of the element adjusted for current page and/or element scroll.
	         */
	        getElementOffset: function( element ) {
	            element = $.getElement( element );
	
	            var doc = element && element.ownerDocument,
	                docElement,
	                win,
	                boundingRect = { top: 0, left: 0 };
	
	            if ( !doc ) {
	                return new $.Point();
	            }
	
	            docElement = doc.documentElement;
	
	            if ( typeof element.getBoundingClientRect !== typeof undefined ) {
	                boundingRect = element.getBoundingClientRect();
	            }
	
	            win = ( doc == doc.window ) ?
	                doc :
	                ( doc.nodeType === 9 ) ?
	                    doc.defaultView || doc.parentWindow :
	                    false;
	
	            return new $.Point(
	                boundingRect.left + ( win.pageXOffset || docElement.scrollLeft ) - ( docElement.clientLeft || 0 ),
	                boundingRect.top + ( win.pageYOffset || docElement.scrollTop ) - ( docElement.clientTop || 0 )
	            );
	        },
	
	
	        /**
	         * Determines the height and width of the given element.
	         * @function
	         * @param {Element|String} element
	         * @returns {OpenSeadragon.Point}
	         */
	        getElementSize: function( element ) {
	            element = $.getElement( element );
	
	            return new $.Point(
	                element.clientWidth,
	                element.clientHeight
	            );
	        },
	
	
	        /**
	         * Returns the CSSStyle object for the given element.
	         * @function
	         * @param {Element|String} element
	         * @returns {CSSStyle}
	         */
	        getElementStyle:
	            document.documentElement.currentStyle ?
	            function( element ) {
	                element = $.getElement( element );
	                return element.currentStyle;
	            } :
	            function( element ) {
	                element = $.getElement( element );
	                return window.getComputedStyle( element, "" );
	            },
	
	        /**
	         * Returns the property with the correct vendor prefix appended.
	         * @param {String} property the property name
	         * @returns {String} the property with the correct prefix or null if not
	         * supported.
	         */
	        getCssPropertyWithVendorPrefix: function(property) {
	            var memo = {};
	
	            $.getCssPropertyWithVendorPrefix = function(property) {
	                if (memo[property] !== undefined) {
	                    return memo[property];
	                }
	                var style = document.createElement('div').style;
	                var result = null;
	                if (style[property] !== undefined) {
	                    result = property;
	                } else {
	                    var prefixes = ['Webkit', 'Moz', 'MS', 'O',
	                        'webkit', 'moz', 'ms', 'o'];
	                    var suffix = $.capitalizeFirstLetter(property);
	                    for (var i = 0; i < prefixes.length; i++) {
	                        var prop = prefixes[i] + suffix;
	                        if (style[prop] !== undefined) {
	                            result = prop;
	                            break;
	                        }
	                    }
	                }
	                memo[property] = result;
	                return result;
	            };
	            return $.getCssPropertyWithVendorPrefix(property);
	        },
	
	        /**
	         * Capitalizes the first letter of a string
	         * @param {String} string
	         * @returns {String} The string with the first letter capitalized
	         */
	        capitalizeFirstLetter: function(string) {
	            return string.charAt(0).toUpperCase() + string.slice(1);
	        },
	
	        /**
	         * Compute the modulo of a number but makes sure to always return
	         * a positive value.
	         * @param {Number} number the number to computes the modulo of
	         * @param {Number} modulo the modulo
	         * @returns {Number} the result of the modulo of number
	         */
	        positiveModulo: function(number, modulo) {
	            var result = number % modulo;
	            if (result < 0) {
	                result += modulo;
	            }
	            return result;
	        },
	
	        /**
	         * Determines if a point is within the bounding rectangle of the given element (hit-test).
	         * @function
	         * @param {Element|String} element
	         * @param {OpenSeadragon.Point} point
	         * @returns {Boolean}
	         */
	        pointInElement: function( element, point ) {
	            element = $.getElement( element );
	            var offset = $.getElementOffset( element ),
	                size = $.getElementSize( element );
	            return point.x >= offset.x && point.x < offset.x + size.x && point.y < offset.y + size.y && point.y >= offset.y;
	        },
	
	
	        /**
	         * Gets the latest event, really only useful internally since its
	         * specific to IE behavior.
	         * @function
	         * @param {Event} [event]
	         * @returns {Event}
	         * @deprecated For internal use only
	         * @private
	         */
	        getEvent: function( event ) {
	            if( event ){
	                $.getEvent = function( event ) {
	                    return event;
	                };
	            } else {
	                $.getEvent = function() {
	                    return window.event;
	                };
	            }
	            return $.getEvent( event );
	        },
	
	
	        /**
	         * Gets the position of the mouse on the screen for a given event.
	         * @function
	         * @param {Event} [event]
	         * @returns {OpenSeadragon.Point}
	         */
	        getMousePosition: function( event ) {
	
	            if ( typeof ( event.pageX ) == "number" ) {
	                $.getMousePosition = function( event ){
	                    var result = new $.Point();
	
	                    event = $.getEvent( event );
	                    result.x = event.pageX;
	                    result.y = event.pageY;
	
	                    return result;
	                };
	            } else if ( typeof ( event.clientX ) == "number" ) {
	                $.getMousePosition = function( event ){
	                    var result = new $.Point();
	
	                    event = $.getEvent( event );
	                    result.x =
	                        event.clientX +
	                        document.body.scrollLeft +
	                        document.documentElement.scrollLeft;
	                    result.y =
	                        event.clientY +
	                        document.body.scrollTop +
	                        document.documentElement.scrollTop;
	
	                    return result;
	                };
	            } else {
	                throw new Error(
	                    "Unknown event mouse position, no known technique."
	                );
	            }
	
	            return $.getMousePosition( event );
	        },
	
	
	        /**
	         * Determines the page's current scroll position.
	         * @function
	         * @returns {OpenSeadragon.Point}
	         */
	        getPageScroll: function() {
	            var docElement  = document.documentElement || {},
	                body        = document.body || {};
	
	            if ( typeof ( window.pageXOffset ) == "number" ) {
	                $.getPageScroll = function(){
	                    return new $.Point(
	                        window.pageXOffset,
	                        window.pageYOffset
	                    );
	                };
	            } else if ( body.scrollLeft || body.scrollTop ) {
	                $.getPageScroll = function(){
	                    return new $.Point(
	                        document.body.scrollLeft,
	                        document.body.scrollTop
	                    );
	                };
	            } else if ( docElement.scrollLeft || docElement.scrollTop ) {
	                $.getPageScroll = function(){
	                    return new $.Point(
	                        document.documentElement.scrollLeft,
	                        document.documentElement.scrollTop
	                    );
	                };
	            } else {
	                // We can't reassign the function yet, as there was no scroll.
	                return new $.Point(0, 0);
	            }
	
	            return $.getPageScroll();
	        },
	
	        /**
	         * Set the page scroll position.
	         * @function
	         * @returns {OpenSeadragon.Point}
	         */
	        setPageScroll: function( scroll ) {
	            if ( typeof ( window.scrollTo ) !== "undefined" ) {
	                $.setPageScroll = function( scroll ) {
	                    window.scrollTo( scroll.x, scroll.y );
	                };
	            } else {
	                var originalScroll = $.getPageScroll();
	                if ( originalScroll.x === scroll.x &&
	                    originalScroll.y === scroll.y ) {
	                    // We are already correctly positioned and there
	                    // is no way to detect the correct method.
	                    return;
	                }
	
	                document.body.scrollLeft = scroll.x;
	                document.body.scrollTop = scroll.y;
	                var currentScroll = $.getPageScroll();
	                if ( currentScroll.x !== originalScroll.x &&
	                    currentScroll.y !== originalScroll.y ) {
	                    $.setPageScroll = function( scroll ) {
	                        document.body.scrollLeft = scroll.x;
	                        document.body.scrollTop = scroll.y;
	                    };
	                    return;
	                }
	
	                document.documentElement.scrollLeft = scroll.x;
	                document.documentElement.scrollTop = scroll.y;
	                currentScroll = $.getPageScroll();
	                if ( currentScroll.x !== originalScroll.x &&
	                    currentScroll.y !== originalScroll.y ) {
	                    $.setPageScroll = function( scroll ) {
	                        document.documentElement.scrollLeft = scroll.x;
	                        document.documentElement.scrollTop = scroll.y;
	                    };
	                    return;
	                }
	
	                // We can't find anything working, so we do nothing.
	                $.setPageScroll = function( scroll ) {
	                };
	            }
	
	            return $.setPageScroll( scroll );
	        },
	
	        /**
	         * Determines the size of the browsers window.
	         * @function
	         * @returns {OpenSeadragon.Point}
	         */
	        getWindowSize: function() {
	            var docElement = document.documentElement || {},
	                body    = document.body || {};
	
	            if ( typeof ( window.innerWidth ) == 'number' ) {
	                $.getWindowSize = function(){
	                    return new $.Point(
	                        window.innerWidth,
	                        window.innerHeight
	                    );
	                };
	            } else if ( docElement.clientWidth || docElement.clientHeight ) {
	                $.getWindowSize = function(){
	                    return new $.Point(
	                        document.documentElement.clientWidth,
	                        document.documentElement.clientHeight
	                    );
	                };
	            } else if ( body.clientWidth || body.clientHeight ) {
	                $.getWindowSize = function(){
	                    return new $.Point(
	                        document.body.clientWidth,
	                        document.body.clientHeight
	                    );
	                };
	            } else {
	                throw new Error("Unknown window size, no known technique.");
	            }
	
	            return $.getWindowSize();
	        },
	
	
	        /**
	         * Wraps the given element in a nest of divs so that the element can
	         * be easily centered using CSS tables
	         * @function
	         * @param {Element|String} element
	         * @returns {Element} outermost wrapper element
	         */
	        makeCenteredNode: function( element ) {
	            // Convert a possible ID to an actual HTMLElement
	            element = $.getElement( element );
	
	            /*
	                CSS tables require you to have a display:table/row/cell hierarchy so we need to create
	                three nested wrapper divs:
	             */
	
	            var wrappers = [
	                $.makeNeutralElement( 'div' ),
	                $.makeNeutralElement( 'div' ),
	                $.makeNeutralElement( 'div' )
	            ];
	
	            // It feels like we should be able to pass style dicts to makeNeutralElement:
	            $.extend(wrappers[0].style, {
	                display: "table",
	                height: "100%",
	                width: "100%"
	            });
	
	            $.extend(wrappers[1].style, {
	                display: "table-row"
	            });
	
	            $.extend(wrappers[2].style, {
	                display: "table-cell",
	                verticalAlign: "middle",
	                textAlign: "center"
	            });
	
	            wrappers[0].appendChild(wrappers[1]);
	            wrappers[1].appendChild(wrappers[2]);
	            wrappers[2].appendChild(element);
	
	            return wrappers[0];
	        },
	
	
	        /**
	         * Creates an easily positionable element of the given type that therefor
	         * serves as an excellent container element.
	         * @function
	         * @param {String} tagName
	         * @returns {Element}
	         */
	        makeNeutralElement: function( tagName ) {
	            var element = document.createElement( tagName ),
	                style   = element.style;
	
	            style.background = "transparent none";
	            style.border     = "none";
	            style.margin     = "0px";
	            style.padding    = "0px";
	            style.position   = "static";
	
	            return element;
	        },
	
	
	        /**
	         * Returns the current milliseconds, using Date.now() if available
	         * @function
	         */
	        now: function( ) {
	            if (Date.now) {
	                $.now = Date.now;
	            } else {
	                $.now = function() {
	                    return new Date().getTime();
	                };
	            }
	
	            return $.now();
	        },
	
	
	        /**
	         * Ensures an image is loaded correctly to support alpha transparency.
	         * Generally only IE has issues doing this correctly for formats like
	         * png.
	         * @function
	         * @param {String} src
	         * @returns {Element}
	         */
	        makeTransparentImage: function( src ) {
	
	            $.makeTransparentImage = function( src ){
	                var img = $.makeNeutralElement( "img" );
	
	                img.src = src;
	
	                return img;
	            };
	
	            if ( $.Browser.vendor == $.BROWSERS.IE && $.Browser.version < 7 ) {
	
	                $.makeTransparentImage = function( src ){
	                    var img     = $.makeNeutralElement( "img" ),
	                        element = null;
	
	                    element = $.makeNeutralElement("span");
	                    element.style.display = "inline-block";
	
	                    img.onload = function() {
	                        element.style.width  = element.style.width || img.width + "px";
	                        element.style.height = element.style.height || img.height + "px";
	
	                        img.onload = null;
	                        img = null;     // to prevent memory leaks in IE
	                    };
	
	                    img.src = src;
	                    element.style.filter =
	                        "progid:DXImageTransform.Microsoft.AlphaImageLoader(src='" +
	                        src +
	                        "', sizingMethod='scale')";
	
	                    return element;
	                };
	
	            }
	
	            return $.makeTransparentImage( src );
	        },
	
	
	        /**
	         * Sets the opacity of the specified element.
	         * @function
	         * @param {Element|String} element
	         * @param {Number} opacity
	         * @param {Boolean} [usesAlpha]
	         */
	        setElementOpacity: function( element, opacity, usesAlpha ) {
	
	            var ieOpacity,
	                ieFilter;
	
	            element = $.getElement( element );
	
	            if ( usesAlpha && !$.Browser.alpha ) {
	                opacity = Math.round( opacity );
	            }
	
	            if ( $.Browser.opacity ) {
	                element.style.opacity = opacity < 1 ? opacity : "";
	            } else {
	                if ( opacity < 1 ) {
	                    ieOpacity = Math.round( 100 * opacity );
	                    ieFilter  = "alpha(opacity=" + ieOpacity + ")";
	                    element.style.filter = ieFilter;
	                } else {
	                    element.style.filter = "";
	                }
	            }
	        },
	
	
	        /**
	         * Sets the specified element's touch-action style attribute to 'none'.
	         * @function
	         * @param {Element|String} element
	         */
	        setElementTouchActionNone: function( element ) {
	            element = $.getElement( element );
	            if ( typeof element.style.touchAction !== 'undefined' ) {
	                element.style.touchAction = 'none';
	            } else if ( typeof element.style.msTouchAction !== 'undefined' ) {
	                element.style.msTouchAction = 'none';
	            }
	        },
	
	
	        /**
	         * Add the specified CSS class to the element if not present.
	         * @function
	         * @param {Element|String} element
	         * @param {String} className
	         */
	        addClass: function( element, className ) {
	            element = $.getElement( element );
	
	            if (!element.className) {
	                element.className = className;
	            } else if ( ( ' ' + element.className + ' ' ).
	                indexOf( ' ' + className + ' ' ) === -1 ) {
	                element.className += ' ' + className;
	            }
	        },
	
	        /**
	         * Find the first index at which an element is found in an array or -1
	         * if not present.
	         *
	         * Code taken and adapted from
	         * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/indexOf#Compatibility
	         *
	         * @function
	         * @param {Array} array The array from which to find the element
	         * @param {Object} searchElement The element to find
	         * @param {Number} [fromIndex=0] Index to start research.
	         * @returns {Number} The index of the element in the array.
	         */
	        indexOf: function( array, searchElement, fromIndex ) {
	            if ( Array.prototype.indexOf ) {
	                this.indexOf = function( array, searchElement, fromIndex ) {
	                    return array.indexOf( searchElement, fromIndex );
	                };
	            } else {
	                this.indexOf = function( array, searchElement, fromIndex ) {
	                    var i,
	                        pivot = ( fromIndex ) ? fromIndex : 0,
	                        length;
	                    if ( !array ) {
	                        throw new TypeError( );
	                    }
	
	                    length = array.length;
	                    if ( length === 0 || pivot >= length ) {
	                        return -1;
	                    }
	
	                    if ( pivot < 0 ) {
	                        pivot = length - Math.abs( pivot );
	                    }
	
	                    for ( i = pivot; i < length; i++ ) {
	                        if ( array[i] === searchElement ) {
	                            return i;
	                        }
	                    }
	                    return -1;
	                };
	            }
	            return this.indexOf( array, searchElement, fromIndex );
	        },
	
	        /**
	         * Remove the specified CSS class from the element.
	         * @function
	         * @param {Element|String} element
	         * @param {String} className
	         */
	        removeClass: function( element, className ) {
	            var oldClasses,
	                newClasses = [],
	                i;
	
	            element = $.getElement( element );
	            oldClasses = element.className.split( /\s+/ );
	            for ( i = 0; i < oldClasses.length; i++ ) {
	                if ( oldClasses[ i ] && oldClasses[ i ] !== className ) {
	                    newClasses.push( oldClasses[ i ] );
	                }
	            }
	            element.className = newClasses.join(' ');
	        },
	
	
	        /**
	         * Adds an event listener for the given element, eventName and handler.
	         * @function
	         * @param {Element|String} element
	         * @param {String} eventName
	         * @param {Function} handler
	         * @param {Boolean} [useCapture]
	         */
	        addEvent: (function () {
	            if ( window.addEventListener ) {
	                return function ( element, eventName, handler, useCapture ) {
	                    element = $.getElement( element );
	                    element.addEventListener( eventName, handler, useCapture );
	                };
	            } else if ( window.attachEvent ) {
	                return function ( element, eventName, handler, useCapture ) {
	                    element = $.getElement( element );
	                    element.attachEvent( 'on' + eventName, handler );
	                };
	            } else {
	                throw new Error( "No known event model." );
	            }
	        }()),
	
	
	        /**
	         * Remove a given event listener for the given element, event type and
	         * handler.
	         * @function
	         * @param {Element|String} element
	         * @param {String} eventName
	         * @param {Function} handler
	         * @param {Boolean} [useCapture]
	         */
	        removeEvent: (function () {
	            if ( window.removeEventListener ) {
	                return function ( element, eventName, handler, useCapture ) {
	                    element = $.getElement( element );
	                    element.removeEventListener( eventName, handler, useCapture );
	                };
	            } else if ( window.detachEvent ) {
	                return function( element, eventName, handler, useCapture ) {
	                    element = $.getElement( element );
	                    element.detachEvent( 'on' + eventName, handler );
	                };
	            } else {
	                throw new Error( "No known event model." );
	            }
	        }()),
	
	
	        /**
	         * Cancels the default browser behavior had the event propagated all
	         * the way up the DOM to the window object.
	         * @function
	         * @param {Event} [event]
	         */
	        cancelEvent: function( event ) {
	            event = $.getEvent( event );
	
	            if ( event.preventDefault ) {
	                $.cancelEvent = function( event ){
	                    // W3C for preventing default
	                    event.preventDefault();
	                };
	            } else {
	                $.cancelEvent = function( event ){
	                    event = $.getEvent( event );
	                    // legacy for preventing default
	                    event.cancel = true;
	                    // IE for preventing default
	                    event.returnValue = false;
	                };
	            }
	            $.cancelEvent( event );
	        },
	
	
	        /**
	         * Stops the propagation of the event up the DOM.
	         * @function
	         * @param {Event} [event]
	         */
	        stopEvent: function( event ) {
	            event = $.getEvent( event );
	
	            if ( event.stopPropagation ) {
	                // W3C for stopping propagation
	                $.stopEvent = function( event ){
	                    event.stopPropagation();
	                };
	            } else {
	                // IE for stopping propagation
	                $.stopEvent = function( event ){
	                    event = $.getEvent( event );
	                    event.cancelBubble = true;
	                };
	
	            }
	
	            $.stopEvent( event );
	        },
	
	
	        /**
	         * Similar to OpenSeadragon.delegate, but it does not immediately call
	         * the method on the object, returning a function which can be called
	         * repeatedly to delegate the method. It also allows additonal arguments
	         * to be passed during construction which will be added during each
	         * invocation, and each invocation can add additional arguments as well.
	         *
	         * @function
	         * @param {Object} object
	         * @param {Function} method
	         * @param [args] any additional arguments are passed as arguments to the
	         *  created callback
	         * @returns {Function}
	         */
	        createCallback: function( object, method ) {
	            //TODO: This pattern is painful to use and debug.  It's much cleaner
	            //      to use pinning plus anonymous functions.  Get rid of this
	            //      pattern!
	            var initialArgs = [],
	                i;
	            for ( i = 2; i < arguments.length; i++ ) {
	                initialArgs.push( arguments[ i ] );
	            }
	
	            return function() {
	                var args = initialArgs.concat( [] ),
	                    i;
	                for ( i = 0; i < arguments.length; i++ ) {
	                    args.push( arguments[ i ] );
	                }
	
	                return method.apply( object, args );
	            };
	        },
	
	
	        /**
	         * Retreives the value of a url parameter from the window.location string.
	         * @function
	         * @param {String} key
	         * @returns {String} The value of the url parameter or null if no param matches.
	         */
	        getUrlParameter: function( key ) {
	            // eslint-disable-next-line no-use-before-define
	            var value = URLPARAMS[ key ];
	            return value ? value : null;
	        },
	
	        /**
	         * Retrieves the protocol used by the url. The url can either be absolute
	         * or relative.
	         * @function
	         * @private
	         * @param {String} url The url to retrieve the protocol from.
	         * @return {String} The protocol (http:, https:, file:, ftp: ...)
	         */
	        getUrlProtocol: function( url ) {
	            var match = url.match(/^([a-z]+:)\/\//i);
	            if ( match === null ) {
	                // Relative URL, retrive the protocol from window.location
	                return window.location.protocol;
	            }
	            return match[1].toLowerCase();
	        },
	
	        /**
	         * Create an XHR object
	         * @private
	         * @param {type} [local] If set to true, the XHR will be file: protocol
	         * compatible if possible (but may raise a warning in the browser).
	         * @returns {XMLHttpRequest}
	         */
	        createAjaxRequest: function( local ) {
	            // IE11 does not support window.ActiveXObject so we just try to
	            // create one to see if it is supported.
	            // See: http://msdn.microsoft.com/en-us/library/ie/dn423948%28v=vs.85%29.aspx
	            var supportActiveX;
	            try {
	                /* global ActiveXObject:true */
	                supportActiveX = !!new ActiveXObject( "Microsoft.XMLHTTP" );
	            } catch( e ) {
	                supportActiveX = false;
	            }
	
	            if ( supportActiveX ) {
	                if ( window.XMLHttpRequest ) {
	                    $.createAjaxRequest = function( local ) {
	                        if ( local ) {
	                            return new ActiveXObject( "Microsoft.XMLHTTP" );
	                        }
	                        return new XMLHttpRequest();
	                    };
	                } else {
	                    $.createAjaxRequest = function() {
	                        return new ActiveXObject( "Microsoft.XMLHTTP" );
	                    };
	                }
	            } else if ( window.XMLHttpRequest ) {
	                $.createAjaxRequest = function() {
	                    return new XMLHttpRequest();
	                };
	            } else {
	                throw new Error( "Browser doesn't support XMLHttpRequest." );
	            }
	            return $.createAjaxRequest( local );
	        },
	
	        /**
	         * Makes an AJAX request.
	         * @param {Object} options
	         * @param {String} options.url - the url to request
	         * @param {Function} options.success - a function to call on a successful response
	         * @param {Function} options.error - a function to call on when an error occurs
	         * @param {Object} options.headers - headers to add to the AJAX request
	         * @param {String} options.responseType - the response type of the the AJAX request
	         * @param {Boolean} [options.withCredentials=false] - whether to set the XHR's withCredentials
	         * @throws {Error}
	         * @returns {XMLHttpRequest}
	         */
	        makeAjaxRequest: function( url, onSuccess, onError ) {
	            var withCredentials;
	            var headers;
	            var responseType;
	
	            // Note that our preferred API is that you pass in a single object; the named
	            // arguments are for legacy support.
	            if( $.isPlainObject( url ) ){
	                onSuccess = url.success;
	                onError = url.error;
	                withCredentials = url.withCredentials;
	                headers = url.headers;
	                responseType = url.responseType || null;
	                url = url.url;
	            }
	
	            var protocol = $.getUrlProtocol( url );
	            var request = $.createAjaxRequest( protocol === "file:" );
	
	            if ( !$.isFunction( onSuccess ) ) {
	                throw new Error( "makeAjaxRequest requires a success callback" );
	            }
	
	            request.onreadystatechange = function() {
	                // 4 = DONE (https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest#Properties)
	                if ( request.readyState == 4 ) {
	                    request.onreadystatechange = function(){};
	
	                    // With protocols other than http/https, a successful request status is in
	                    // the 200's on Firefox and 0 on other browsers
	                    if ( (request.status >= 200 && request.status < 300) ||
	                        ( request.status === 0 &&
	                          protocol !== "http:" &&
	                          protocol !== "https:" )) {
	                        onSuccess( request );
	                    } else {
	                        $.console.log( "AJAX request returned %d: %s", request.status, url );
	
	                        if ( $.isFunction( onError ) ) {
	                            onError( request );
	                        }
	                    }
	                }
	            };
	
	            try {
	                request.open( "GET", url, true );
	
	                if (responseType) {
	                    request.responseType = responseType;
	                }
	
	                if (headers) {
	                    for (var headerName in headers) {
	                        if (headers.hasOwnProperty(headerName) && headers[headerName]) {
	                            request.setRequestHeader(headerName, headers[headerName]);
	                        }
	                    }
	                }
	
	                if (withCredentials) {
	                    request.withCredentials = true;
	                }
	
	                request.send(null);
	            } catch (e) {
	                var msg = e.message;
	
	                /*
	                    IE < 10 does not support CORS and an XHR request to a different origin will fail as soon
	                    as send() is called. This is particularly easy to miss during development and appear in
	                    production if you use a CDN or domain sharding and the security policy is likely to break
	                    exception handlers since any attempt to access a property of the request object will
	                    raise an access denied TypeError inside the catch block.
	
	                    To be friendlier, we'll check for this specific error and add a documentation pointer
	                    to point developers in the right direction. We test the exception number because IE's
	                    error messages are localized.
	                */
	                var oldIE = $.Browser.vendor == $.BROWSERS.IE && $.Browser.version < 10;
	                if ( oldIE && typeof ( e.number ) != "undefined" && e.number == -2147024891 ) {
	                    msg += "\nSee http://msdn.microsoft.com/en-us/library/ms537505(v=vs.85).aspx#xdomain";
	                }
	
	                $.console.log( "%s while making AJAX request: %s", e.name, msg );
	
	                request.onreadystatechange = function(){};
	
	                if (window.XDomainRequest) { // IE9 or IE8 might as well try to use XDomainRequest
	                    var xdr = new XDomainRequest();
	                    if (xdr) {
	                        xdr.onload = function (e) {
	                            if ( $.isFunction( onSuccess ) ) {
	                                onSuccess({ // Faking an xhr object
	                                    responseText: xdr.responseText,
	                                    status: 200, // XDomainRequest doesn't support status codes, so we just fake one! :/
	                                    statusText: 'OK'
	                                });
	                            }
	                        };
	                        xdr.onerror = function (e) {
	                            if ($.isFunction(onError)) {
	                                onError({ // Faking an xhr object
	                                    responseText: xdr.responseText,
	                                    status: 444, // 444 No Response
	                                    statusText: 'An error happened. Due to an XDomainRequest deficiency we can not extract any information about this error. Upgrade your browser.'
	                                });
	                            }
	                        };
	                        try {
	                            xdr.open('GET', url);
	                            xdr.send();
	                        } catch (e2) {
	                            if ( $.isFunction( onError ) ) {
	                                onError( request, e );
	                            }
	                        }
	                    }
	                } else {
	                    if ( $.isFunction( onError ) ) {
	                        onError( request, e );
	                    }
	                }
	            }
	
	            return request;
	        },
	
	        /**
	         * Taken from jQuery 1.6.1
	         * @function
	         * @param {Object} options
	         * @param {String} options.url
	         * @param {Function} options.callback
	         * @param {String} [options.param='callback'] The name of the url parameter
	         *      to request the jsonp provider with.
	         * @param {String} [options.callbackName=] The name of the callback to
	         *      request the jsonp provider with.
	         */
	        jsonp: function( options ){
	            var script,
	                url     = options.url,
	                head    = document.head ||
	                    document.getElementsByTagName( "head" )[ 0 ] ||
	                    document.documentElement,
	                jsonpCallback = options.callbackName || 'openseadragon' + $.now(),
	                previous      = window[ jsonpCallback ],
	                replace       = "$1" + jsonpCallback + "$2",
	                callbackParam = options.param || 'callback',
	                callback      = options.callback;
	
	            url = url.replace( /(\=)\?(&|$)|\?\?/i, replace );
	            // Add callback manually
	            url += (/\?/.test( url ) ? "&" : "?") + callbackParam + "=" + jsonpCallback;
	
	            // Install callback
	            window[ jsonpCallback ] = function( response ) {
	                if ( !previous ){
	                    try{
	                        delete window[ jsonpCallback ];
	                    }catch(e){
	                        //swallow
	                    }
	                } else {
	                    window[ jsonpCallback ] = previous;
	                }
	                if( callback && $.isFunction( callback ) ){
	                    callback( response );
	                }
	            };
	
	            script = document.createElement( "script" );
	
	            //TODO: having an issue with async info requests
	            if( undefined !== options.async || false !== options.async ){
	                script.async = "async";
	            }
	
	            if ( options.scriptCharset ) {
	                script.charset = options.scriptCharset;
	            }
	
	            script.src = url;
	
	            // Attach handlers for all browsers
	            script.onload = script.onreadystatechange = function( _, isAbort ) {
	
	                if ( isAbort || !script.readyState || /loaded|complete/.test( script.readyState ) ) {
	
	                    // Handle memory leak in IE
	                    script.onload = script.onreadystatechange = null;
	
	                    // Remove the script
	                    if ( head && script.parentNode ) {
	                        head.removeChild( script );
	                    }
	
	                    // Dereference the script
	                    script = undefined;
	                }
	            };
	            // Use insertBefore instead of appendChild  to circumvent an IE6 bug.
	            // This arises when a base node is used (#2709 and #4378).
	            head.insertBefore( script, head.firstChild );
	
	        },
	
	
	        /**
	         * Fully deprecated. Will throw an error.
	         * @function
	         * @deprecated use {@link OpenSeadragon.Viewer#open}
	         */
	        createFromDZI: function() {
	            throw "OpenSeadragon.createFromDZI is deprecated, use Viewer.open.";
	        },
	
	        /**
	         * Parses an XML string into a DOM Document.
	         * @function
	         * @param {String} string
	         * @returns {Document}
	         */
	        parseXml: function( string ) {
	            if ( window.DOMParser ) {
	
	                $.parseXml = function( string ) {
	                    var xmlDoc = null,
	                        parser;
	
	                    parser = new DOMParser();
	                    xmlDoc = parser.parseFromString( string, "text/xml" );
	                    return xmlDoc;
	                };
	
	            } else if ( window.ActiveXObject ) {
	
	                $.parseXml = function( string ) {
	                    var xmlDoc = null;
	
	                    xmlDoc = new ActiveXObject( "Microsoft.XMLDOM" );
	                    xmlDoc.async = false;
	                    xmlDoc.loadXML( string );
	                    return xmlDoc;
	                };
	
	            } else {
	                throw new Error( "Browser doesn't support XML DOM." );
	            }
	
	            return $.parseXml( string );
	        },
	
	        /**
	         * Parses a JSON string into a Javascript object.
	         * @function
	         * @param {String} string
	         * @returns {Object}
	         */
	        parseJSON: function(string) {
	            if (window.JSON && window.JSON.parse) {
	                $.parseJSON = window.JSON.parse;
	            } else {
	                // Should only be used by IE8 in non standards mode
	                $.parseJSON = function(string) {
	                    /*jshint evil:true*/
	                    //eslint-disable-next-line no-eval
	                    return eval('(' + string + ')');
	                };
	            }
	            return $.parseJSON(string);
	        },
	
	        /**
	         * Reports whether the image format is supported for tiling in this
	         * version.
	         * @function
	         * @param {String} [extension]
	         * @returns {Boolean}
	         */
	        imageFormatSupported: function( extension ) {
	            extension = extension ? extension : "";
	            // eslint-disable-next-line no-use-before-define
	            return !!FILEFORMATS[ extension.toLowerCase() ];
	        }
	
	    });
	
	
	    /**
	     * The current browser vendor, version, and related information regarding detected features.
	     * @member {Object} Browser
	     * @memberof OpenSeadragon
	     * @static
	     * @type {Object}
	     * @property {OpenSeadragon.BROWSERS} vendor - One of the {@link OpenSeadragon.BROWSERS} enumeration values.
	     * @property {Number} version
	     * @property {Boolean} alpha - Does the browser support image alpha transparency.
	     */
	    $.Browser = {
	        vendor:     $.BROWSERS.UNKNOWN,
	        version:    0,
	        alpha:      true
	    };
	
	
	    var FILEFORMATS = {
	            "bmp":  false,
	            "jpeg": true,
	            "jpg":  true,
	            "png":  true,
	            "tif":  false,
	            "wdp":  false
	        },
	        URLPARAMS = {};
	
	    (function() {
	        //A small auto-executing routine to determine the browser vendor,
	        //version and supporting feature sets.
	        var ver = navigator.appVersion,
	            ua  = navigator.userAgent,
	            regex;
	
	        //console.error( 'appName: ' + navigator.appName );
	        //console.error( 'appVersion: ' + navigator.appVersion );
	        //console.error( 'userAgent: ' + navigator.userAgent );
	
	        switch( navigator.appName ){
	            case "Microsoft Internet Explorer":
	                if( !!window.attachEvent &&
	                    !!window.ActiveXObject ) {
	
	                    $.Browser.vendor = $.BROWSERS.IE;
	                    $.Browser.version = parseFloat(
	                        ua.substring(
	                            ua.indexOf( "MSIE" ) + 5,
	                            ua.indexOf( ";", ua.indexOf( "MSIE" ) ) )
	                        );
	                }
	                break;
	            case "Netscape":
	                if (window.addEventListener) {
	                    if ( ua.indexOf( "Firefox" ) >= 0 ) {
	                        $.Browser.vendor = $.BROWSERS.FIREFOX;
	                        $.Browser.version = parseFloat(
	                            ua.substring( ua.indexOf( "Firefox" ) + 8 )
	                        );
	                    } else if ( ua.indexOf( "Safari" ) >= 0 ) {
	                        $.Browser.vendor = ua.indexOf( "Chrome" ) >= 0 ?
	                            $.BROWSERS.CHROME :
	                            $.BROWSERS.SAFARI;
	                        $.Browser.version = parseFloat(
	                            ua.substring(
	                                ua.substring( 0, ua.indexOf( "Safari" ) ).lastIndexOf( "/" ) + 1,
	                                ua.indexOf( "Safari" )
	                            )
	                        );
	                    } else {
	                        regex = new RegExp( "Trident/.*rv:([0-9]{1,}[.0-9]{0,})");
	                        if ( regex.exec( ua ) !== null ) {
	                            $.Browser.vendor = $.BROWSERS.IE;
	                            $.Browser.version = parseFloat( RegExp.$1 );
	                        }
	                    }
	                }
	                break;
	            case "Opera":
	                $.Browser.vendor = $.BROWSERS.OPERA;
	                $.Browser.version = parseFloat( ver );
	                break;
	        }
	
	            // ignore '?' portion of query string
	        var query = window.location.search.substring( 1 ),
	            parts = query.split('&'),
	            part,
	            sep,
	            i;
	
	        for ( i = 0; i < parts.length; i++ ) {
	            part = parts[ i ];
	            sep  = part.indexOf( '=' );
	
	            if ( sep > 0 ) {
	                URLPARAMS[ part.substring( 0, sep ) ] =
	                    decodeURIComponent( part.substring( sep + 1 ) );
	            }
	        }
	
	        //determine if this browser supports image alpha transparency
	        $.Browser.alpha = !(
	            (
	                $.Browser.vendor == $.BROWSERS.IE &&
	                $.Browser.version < 9
	            ) || (
	                $.Browser.vendor == $.BROWSERS.CHROME &&
	                $.Browser.version < 2
	            )
	        );
	
	        //determine if this browser supports element.style.opacity
	        $.Browser.opacity = !(
	            $.Browser.vendor == $.BROWSERS.IE &&
	            $.Browser.version < 9
	        );
	
	    })();
	
	
	    //TODO: $.console is often used inside a try/catch block which generally
	    //      prevents allowings errors to occur with detection until a debugger
	    //      is attached.  Although I've been guilty of the same anti-pattern
	    //      I eventually was convinced that errors should naturally propogate in
	    //      all but the most special cases.
	    /**
	     * A convenient alias for console when available, and a simple null
	     * function when console is unavailable.
	     * @static
	     * @private
	     */
	    var nullfunction = function( msg ){
	            //document.location.hash = msg;
	        };
	
	    $.console = window.console || {
	        log:    nullfunction,
	        debug:  nullfunction,
	        info:   nullfunction,
	        warn:   nullfunction,
	        error:  nullfunction,
	        assert: nullfunction
	    };
	
	
	    // Adding support for HTML5's requestAnimationFrame as suggested by acdha.
	    // Implementation taken from matt synder's post here:
	    // http://mattsnider.com/cross-browser-and-legacy-supported-requestframeanimation/
	    (function( w ) {
	
	        // most browsers have an implementation
	        var requestAnimationFrame = w.requestAnimationFrame ||
	            w.mozRequestAnimationFrame ||
	            w.webkitRequestAnimationFrame ||
	            w.msRequestAnimationFrame;
	
	        var cancelAnimationFrame = w.cancelAnimationFrame ||
	            w.mozCancelAnimationFrame ||
	            w.webkitCancelAnimationFrame ||
	            w.msCancelAnimationFrame;
	
	        // polyfill, when necessary
	        if ( requestAnimationFrame && cancelAnimationFrame ) {
	            // We can't assign these window methods directly to $ because they
	            // expect their "this" to be "window", so we call them in wrappers.
	            $.requestAnimationFrame = function(){
	                return requestAnimationFrame.apply( w, arguments );
	            };
	            $.cancelAnimationFrame = function(){
	                return cancelAnimationFrame.apply( w, arguments );
	            };
	        } else {
	            var aAnimQueue = [],
	                processing = [],
	                iRequestId = 0,
	                iIntervalId;
	
	            // create a mock requestAnimationFrame function
	            $.requestAnimationFrame = function( callback ) {
	                aAnimQueue.push( [ ++iRequestId, callback ] );
	
	                if ( !iIntervalId ) {
	                    iIntervalId = setInterval( function() {
	                        if ( aAnimQueue.length ) {
	                            var time = $.now();
	                            // Process all of the currently outstanding frame
	                            // requests, but none that get added during the
	                            // processing.
	                            // Swap the arrays so we don't have to create a new
	                            // array every frame.
	                            var temp = processing;
	                            processing = aAnimQueue;
	                            aAnimQueue = temp;
	                            while ( processing.length ) {
	                                processing.shift()[ 1 ]( time );
	                            }
	                        } else {
	                            // don't continue the interval, if unnecessary
	                            clearInterval( iIntervalId );
	                            iIntervalId = undefined;
	                        }
	                    }, 1000 / 50);  // estimating support for 50 frames per second
	                }
	
	                return iRequestId;
	            };
	
	            // create a mock cancelAnimationFrame function
	            $.cancelAnimationFrame = function( requestId ) {
	                // find the request ID and remove it
	                var i, j;
	                for ( i = 0, j = aAnimQueue.length; i < j; i += 1 ) {
	                    if ( aAnimQueue[ i ][ 0 ] === requestId ) {
	                        aAnimQueue.splice( i, 1 );
	                        return;
	                    }
	                }
	
	                // If it's not in the queue, it may be in the set we're currently
	                // processing (if cancelAnimationFrame is called from within a
	                // requestAnimationFrame callback).
	                for ( i = 0, j = processing.length; i < j; i += 1 ) {
	                    if ( processing[ i ][ 0 ] === requestId ) {
	                        processing.splice( i, 1 );
	                        return;
	                    }
	                }
	            };
	        }
	    })( window );
	
	    /**
	     * @private
	     * @inner
	     * @function
	     * @param {Element} element
	     * @param {Boolean} [isFixed]
	     * @returns {Element}
	     */
	    function getOffsetParent( element, isFixed ) {
	        if ( isFixed && element != document.body ) {
	            return document.body;
	        } else {
	            return element.offsetParent;
	        }
	    }
	
	}(OpenSeadragon));
	
	
	// Universal Module Definition, supports CommonJS, AMD and simple script tag
	(function (root, factory) {
	    if (true) {
	        // expose as amd module
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof module === 'object' && module.exports) {
	        // expose as commonjs module
	        module.exports = factory();
	    } else {
	        // expose as window.OpenSeadragon
	        root.OpenSeadragon = factory();
	    }
	}(this, function () {
	    return OpenSeadragon;
	}));
	
	/*
	 * OpenSeadragon - full-screen support functions
	 *
	 * Copyright (C) 2009 CodePlex Foundation
	 * Copyright (C) 2010-2013 OpenSeadragon contributors
	 *
	 * Redistribution and use in source and binary forms, with or without
	 * modification, are permitted provided that the following conditions are
	 * met:
	 *
	 * - Redistributions of source code must retain the above copyright notice,
	 *   this list of conditions and the following disclaimer.
	 *
	 * - Redistributions in binary form must reproduce the above copyright
	 *   notice, this list of conditions and the following disclaimer in the
	 *   documentation and/or other materials provided with the distribution.
	 *
	 * - Neither the name of CodePlex Foundation nor the names of its
	 *   contributors may be used to endorse or promote products derived from
	 *   this software without specific prior written permission.
	 *
	 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
	 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
	 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
	 * A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT
	 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
	 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
	 * TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 * PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
	 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
	 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
	 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	 */
	
	(function( $ ) {
	    /**
	     * Determine native full screen support we can get from the browser.
	     * @member fullScreenApi
	     * @memberof OpenSeadragon
	     * @type {object}
	     * @property {Boolean} supportsFullScreen Return true if full screen API is supported.
	     * @property {Function} isFullScreen Return true if currently in full screen mode.
	     * @property {Function} getFullScreenElement Return the element currently in full screen mode.
	     * @property {Function} requestFullScreen Make a request to go in full screen mode.
	     * @property {Function} exitFullScreen Make a request to exit full screen mode.
	     * @property {Function} cancelFullScreen Deprecated, use exitFullScreen instead.
	     * @property {String} fullScreenEventName Event fired when the full screen mode change.
	     * @property {String} fullScreenErrorEventName Event fired when a request to go
	     * in full screen mode failed.
	     */
	    var fullScreenApi = {
	        supportsFullScreen: false,
	        isFullScreen: function() { return false; },
	        getFullScreenElement: function() { return null; },
	        requestFullScreen: function() {},
	        exitFullScreen: function() {},
	        cancelFullScreen: function() {},
	        fullScreenEventName: '',
	        fullScreenErrorEventName: ''
	    };
	
	    // check for native support
	    if ( document.exitFullscreen ) {
	        // W3C standard
	        fullScreenApi.supportsFullScreen = true;
	        fullScreenApi.getFullScreenElement = function() {
	            return document.fullscreenElement;
	        };
	        fullScreenApi.requestFullScreen = function( element ) {
	            return element.requestFullscreen();
	        };
	        fullScreenApi.exitFullScreen = function() {
	            document.exitFullscreen();
	        };
	        fullScreenApi.fullScreenEventName = "fullscreenchange";
	        fullScreenApi.fullScreenErrorEventName = "fullscreenerror";
	    } else if ( document.msExitFullscreen ) {
	        // IE 11
	        fullScreenApi.supportsFullScreen = true;
	        fullScreenApi.getFullScreenElement = function() {
	            return document.msFullscreenElement;
	        };
	        fullScreenApi.requestFullScreen = function( element ) {
	            return element.msRequestFullscreen();
	        };
	        fullScreenApi.exitFullScreen = function() {
	            document.msExitFullscreen();
	        };
	        fullScreenApi.fullScreenEventName = "MSFullscreenChange";
	        fullScreenApi.fullScreenErrorEventName = "MSFullscreenError";
	    } else if ( document.webkitExitFullscreen ) {
	        // Recent webkit
	        fullScreenApi.supportsFullScreen = true;
	        fullScreenApi.getFullScreenElement = function() {
	            return document.webkitFullscreenElement;
	        };
	        fullScreenApi.requestFullScreen = function( element ) {
	            return element.webkitRequestFullscreen();
	        };
	        fullScreenApi.exitFullScreen = function() {
	            document.webkitExitFullscreen();
	        };
	        fullScreenApi.fullScreenEventName = "webkitfullscreenchange";
	        fullScreenApi.fullScreenErrorEventName = "webkitfullscreenerror";
	    } else if ( document.webkitCancelFullScreen ) {
	        // Old webkit
	        fullScreenApi.supportsFullScreen = true;
	        fullScreenApi.getFullScreenElement = function() {
	            return document.webkitCurrentFullScreenElement;
	        };
	        fullScreenApi.requestFullScreen = function( element ) {
	            return element.webkitRequestFullScreen();
	        };
	        fullScreenApi.exitFullScreen = function() {
	            document.webkitCancelFullScreen();
	        };
	        fullScreenApi.fullScreenEventName = "webkitfullscreenchange";
	        fullScreenApi.fullScreenErrorEventName = "webkitfullscreenerror";
	    } else if ( document.mozCancelFullScreen ) {
	        // Firefox
	        fullScreenApi.supportsFullScreen = true;
	        fullScreenApi.getFullScreenElement = function() {
	            return document.mozFullScreenElement;
	        };
	        fullScreenApi.requestFullScreen = function( element ) {
	            return element.mozRequestFullScreen();
	        };
	        fullScreenApi.exitFullScreen = function() {
	            document.mozCancelFullScreen();
	        };
	        fullScreenApi.fullScreenEventName = "mozfullscreenchange";
	        fullScreenApi.fullScreenErrorEventName = "mozfullscreenerror";
	    }
	    fullScreenApi.isFullScreen = function() {
	        return fullScreenApi.getFullScreenElement() !== null;
	    };
	    fullScreenApi.cancelFullScreen = function() {
	        $.console.error("cancelFullScreen is deprecated. Use exitFullScreen instead.");
	        fullScreenApi.exitFullScreen();
	    };
	
	    // export api
	    $.extend( $, fullScreenApi );
	
	})( OpenSeadragon );
	
	/*
	 * OpenSeadragon - EventSource
	 *
	 * Copyright (C) 2009 CodePlex Foundation
	 * Copyright (C) 2010-2013 OpenSeadragon contributors
	 *
	 * Redistribution and use in source and binary forms, with or without
	 * modification, are permitted provided that the following conditions are
	 * met:
	 *
	 * - Redistributions of source code must retain the above copyright notice,
	 *   this list of conditions and the following disclaimer.
	 *
	 * - Redistributions in binary form must reproduce the above copyright
	 *   notice, this list of conditions and the following disclaimer in the
	 *   documentation and/or other materials provided with the distribution.
	 *
	 * - Neither the name of CodePlex Foundation nor the names of its
	 *   contributors may be used to endorse or promote products derived from
	 *   this software without specific prior written permission.
	 *
	 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
	 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
	 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
	 * A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT
	 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
	 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
	 * TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 * PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
	 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
	 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
	 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	 */
	
	(function($){
	
	/**
	 * Event handler method signature used by all OpenSeadragon events.
	 *
	 * @callback EventHandler
	 * @memberof OpenSeadragon
	 * @param {Object} event - See individual events for event-specific properties.
	 */
	
	
	/**
	 * @class EventSource
	 * @classdesc For use by classes which want to support custom, non-browser events.
	 *
	 * @memberof OpenSeadragon
	 */
	$.EventSource = function() {
	    this.events = {};
	};
	
	/** @lends OpenSeadragon.EventSource.prototype */
	$.EventSource.prototype = {
	
	    /**
	     * Add an event handler to be triggered only once (or a given number of times)
	     * for a given event.
	     * @function
	     * @param {String} eventName - Name of event to register.
	     * @param {OpenSeadragon.EventHandler} handler - Function to call when event
	     * is triggered.
	     * @param {Object} [userData=null] - Arbitrary object to be passed unchanged
	     * to the handler.
	     * @param {Number} [times=1] - The number of times to handle the event
	     * before removing it.
	     */
	    addOnceHandler: function(eventName, handler, userData, times) {
	        var self = this;
	        times = times || 1;
	        var count = 0;
	        var onceHandler = function(event) {
	            count++;
	            if (count === times) {
	                self.removeHandler(eventName, onceHandler);
	            }
	            handler(event);
	        };
	        this.addHandler(eventName, onceHandler, userData);
	    },
	
	    /**
	     * Add an event handler for a given event.
	     * @function
	     * @param {String} eventName - Name of event to register.
	     * @param {OpenSeadragon.EventHandler} handler - Function to call when event is triggered.
	     * @param {Object} [userData=null] - Arbitrary object to be passed unchanged to the handler.
	     */
	    addHandler: function ( eventName, handler, userData ) {
	        var events = this.events[ eventName ];
	        if ( !events ) {
	            this.events[ eventName ] = events = [];
	        }
	        if ( handler && $.isFunction( handler ) ) {
	            events[ events.length ] = { handler: handler, userData: userData || null };
	        }
	    },
	
	    /**
	     * Remove a specific event handler for a given event.
	     * @function
	     * @param {String} eventName - Name of event for which the handler is to be removed.
	     * @param {OpenSeadragon.EventHandler} handler - Function to be removed.
	     */
	    removeHandler: function ( eventName, handler ) {
	        var events = this.events[ eventName ],
	            handlers = [],
	            i;
	        if ( !events ) {
	            return;
	        }
	        if ( $.isArray( events ) ) {
	            for ( i = 0; i < events.length; i++ ) {
	                if ( events[i].handler !== handler ) {
	                    handlers.push( events[ i ] );
	                }
	            }
	            this.events[ eventName ] = handlers;
	        }
	    },
	
	
	    /**
	     * Remove all event handlers for a given event type. If no type is given all
	     * event handlers for every event type are removed.
	     * @function
	     * @param {String} eventName - Name of event for which all handlers are to be removed.
	     */
	    removeAllHandlers: function( eventName ) {
	        if ( eventName ){
	            this.events[ eventName ] = [];
	        } else{
	            for ( var eventType in this.events ) {
	                this.events[ eventType ] = [];
	            }
	        }
	    },
	
	    /**
	     * Get a function which iterates the list of all handlers registered for a given event, calling the handler for each.
	     * @function
	     * @param {String} eventName - Name of event to get handlers for.
	     */
	    getHandler: function ( eventName ) {
	        var events = this.events[ eventName ];
	        if ( !events || !events.length ) {
	            return null;
	        }
	        events = events.length === 1 ?
	            [ events[ 0 ] ] :
	            Array.apply( null, events );
	        return function ( source, args ) {
	            var i,
	                length = events.length;
	            for ( i = 0; i < length; i++ ) {
	                if ( events[ i ] ) {
	                    args.eventSource = source;
	                    args.userData = events[ i ].userData;
	                    events[ i ].handler( args );
	                }
	            }
	        };
	    },
	
	    /**
	     * Trigger an event, optionally passing additional information.
	     * @function
	     * @param {String} eventName - Name of event to register.
	     * @param {Object} eventArgs - Event-specific data.
	     */
	    raiseEvent: function( eventName, eventArgs ) {
	        //uncomment if you want to get a log of all events
	        //$.console.log( eventName );
	        var handler = this.getHandler( eventName );
	
	        if ( handler ) {
	            if ( !eventArgs ) {
	                eventArgs = {};
	            }
	
	            handler( this, eventArgs );
	        }
	    }
	};
	
	}( OpenSeadragon ));
	
	/*
	 * OpenSeadragon - MouseTracker
	 *
	 * Copyright (C) 2009 CodePlex Foundation
	 * Copyright (C) 2010-2013 OpenSeadragon contributors
	 *
	 * Redistribution and use in source and binary forms, with or without
	 * modification, are permitted provided that the following conditions are
	 * met:
	 *
	 * - Redistributions of source code must retain the above copyright notice,
	 *   this list of conditions and the following disclaimer.
	 *
	 * - Redistributions in binary form must reproduce the above copyright
	 *   notice, this list of conditions and the following disclaimer in the
	 *   documentation and/or other materials provided with the distribution.
	 *
	 * - Neither the name of CodePlex Foundation nor the names of its
	 *   contributors may be used to endorse or promote products derived from
	 *   this software without specific prior written permission.
	 *
	 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
	 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
	 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
	 * A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT
	 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
	 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
	 * TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 * PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
	 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
	 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
	 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	 */
	
	(function ( $ ) {
	
	    // All MouseTracker instances
	    var MOUSETRACKERS  = [];
	
	    // dictionary from hash to private properties
	    var THIS           = {};
	
	
	    /**
	     * @class MouseTracker
	     * @classdesc Provides simplified handling of common pointer device (mouse, touch, pen, etc.) gestures
	     *            and keyboard events on a specified element.
	     * @memberof OpenSeadragon
	     * @param {Object} options
	     *      Allows configurable properties to be entirely specified by passing
	     *      an options object to the constructor.  The constructor also supports
	     *      the original positional arguments 'element', 'clickTimeThreshold',
	     *      and 'clickDistThreshold' in that order.
	     * @param {Element|String} options.element
	     *      A reference to an element or an element id for which the pointer/key
	     *      events will be monitored.
	     * @param {Boolean} [options.startDisabled=false]
	     *      If true, event tracking on the element will not start until
	     *      {@link OpenSeadragon.MouseTracker.setTracking|setTracking} is called.
	     * @param {Number} options.clickTimeThreshold
	     *      The number of milliseconds within which a pointer down-up event combination
	     *      will be treated as a click gesture.
	     * @param {Number} options.clickDistThreshold
	     *      The maximum distance allowed between a pointer down event and a pointer up event
	     *      to be treated as a click gesture.
	     * @param {Number} options.dblClickTimeThreshold
	     *      The number of milliseconds within which two pointer down-up event combinations
	     *      will be treated as a double-click gesture.
	     * @param {Number} options.dblClickDistThreshold
	     *      The maximum distance allowed between two pointer click events
	     *      to be treated as a click gesture.
	     * @param {Number} [options.stopDelay=50]
	     *      The number of milliseconds without pointer move before the stop
	     *      event is fired.
	     * @param {OpenSeadragon.EventHandler} [options.enterHandler=null]
	     *      An optional handler for pointer enter.
	     * @param {OpenSeadragon.EventHandler} [options.exitHandler=null]
	     *      An optional handler for pointer exit.
	     * @param {OpenSeadragon.EventHandler} [options.pressHandler=null]
	     *      An optional handler for pointer press.
	     * @param {OpenSeadragon.EventHandler} [options.nonPrimaryPressHandler=null]
	     *      An optional handler for pointer non-primary button press.
	     * @param {OpenSeadragon.EventHandler} [options.releaseHandler=null]
	     *      An optional handler for pointer release.
	     * @param {OpenSeadragon.EventHandler} [options.nonPrimaryReleaseHandler=null]
	     *      An optional handler for pointer non-primary button release.
	     * @param {OpenSeadragon.EventHandler} [options.moveHandler=null]
	     *      An optional handler for pointer move.
	     * @param {OpenSeadragon.EventHandler} [options.scrollHandler=null]
	     *      An optional handler for mouse wheel scroll.
	     * @param {OpenSeadragon.EventHandler} [options.clickHandler=null]
	     *      An optional handler for pointer click.
	     * @param {OpenSeadragon.EventHandler} [options.dblClickHandler=null]
	     *      An optional handler for pointer double-click.
	     * @param {OpenSeadragon.EventHandler} [options.dragHandler=null]
	     *      An optional handler for the drag gesture.
	     * @param {OpenSeadragon.EventHandler} [options.dragEndHandler=null]
	     *      An optional handler for after a drag gesture.
	     * @param {OpenSeadragon.EventHandler} [options.pinchHandler=null]
	     *      An optional handler for the pinch gesture.
	     * @param {OpenSeadragon.EventHandler} [options.keyDownHandler=null]
	     *      An optional handler for keydown.
	     * @param {OpenSeadragon.EventHandler} [options.keyUpHandler=null]
	     *      An optional handler for keyup.
	     * @param {OpenSeadragon.EventHandler} [options.keyHandler=null]
	     *      An optional handler for keypress.
	     * @param {OpenSeadragon.EventHandler} [options.focusHandler=null]
	     *      An optional handler for focus.
	     * @param {OpenSeadragon.EventHandler} [options.blurHandler=null]
	     *      An optional handler for blur.
	     * @param {Object} [options.userData=null]
	     *      Arbitrary object to be passed unchanged to any attached handler methods.
	     */
	    $.MouseTracker = function ( options ) {
	
	        MOUSETRACKERS.push( this );
	
	        var args = arguments;
	
	        if ( !$.isPlainObject( options ) ) {
	            options = {
	                element:            args[ 0 ],
	                clickTimeThreshold: args[ 1 ],
	                clickDistThreshold: args[ 2 ]
	            };
	        }
	
	        this.hash               = Math.random(); // An unique hash for this tracker.
	        /**
	         * The element for which pointer events are being monitored.
	         * @member {Element} element
	         * @memberof OpenSeadragon.MouseTracker#
	         */
	        this.element            = $.getElement( options.element );
	        /**
	         * The number of milliseconds within which a pointer down-up event combination
	         * will be treated as a click gesture.
	         * @member {Number} clickTimeThreshold
	         * @memberof OpenSeadragon.MouseTracker#
	         */
	        this.clickTimeThreshold = options.clickTimeThreshold || $.DEFAULT_SETTINGS.clickTimeThreshold;
	        /**
	         * The maximum distance allowed between a pointer down event and a pointer up event
	         * to be treated as a click gesture.
	         * @member {Number} clickDistThreshold
	         * @memberof OpenSeadragon.MouseTracker#
	         */
	        this.clickDistThreshold = options.clickDistThreshold || $.DEFAULT_SETTINGS.clickDistThreshold;
	        /**
	         * The number of milliseconds within which two pointer down-up event combinations
	         * will be treated as a double-click gesture.
	         * @member {Number} dblClickTimeThreshold
	         * @memberof OpenSeadragon.MouseTracker#
	         */
	        this.dblClickTimeThreshold = options.dblClickTimeThreshold || $.DEFAULT_SETTINGS.dblClickTimeThreshold;
	        /**
	         * The maximum distance allowed between two pointer click events
	         * to be treated as a click gesture.
	         * @member {Number} clickDistThreshold
	         * @memberof OpenSeadragon.MouseTracker#
	         */
	        this.dblClickDistThreshold = options.dblClickDistThreshold || $.DEFAULT_SETTINGS.dblClickDistThreshold;
	        /*eslint-disable no-multi-spaces*/
	        this.userData              = options.userData          || null;
	        this.stopDelay             = options.stopDelay         || 50;
	
	        this.enterHandler             = options.enterHandler             || null;
	        this.exitHandler              = options.exitHandler              || null;
	        this.pressHandler             = options.pressHandler             || null;
	        this.nonPrimaryPressHandler   = options.nonPrimaryPressHandler   || null;
	        this.releaseHandler           = options.releaseHandler           || null;
	        this.nonPrimaryReleaseHandler = options.nonPrimaryReleaseHandler || null;
	        this.moveHandler              = options.moveHandler              || null;
	        this.scrollHandler            = options.scrollHandler            || null;
	        this.clickHandler             = options.clickHandler             || null;
	        this.dblClickHandler          = options.dblClickHandler          || null;
	        this.dragHandler              = options.dragHandler              || null;
	        this.dragEndHandler           = options.dragEndHandler           || null;
	        this.pinchHandler             = options.pinchHandler             || null;
	        this.stopHandler              = options.stopHandler              || null;
	        this.keyDownHandler           = options.keyDownHandler           || null;
	        this.keyUpHandler             = options.keyUpHandler             || null;
	        this.keyHandler               = options.keyHandler               || null;
	        this.focusHandler             = options.focusHandler             || null;
	        this.blurHandler              = options.blurHandler              || null;
	        /*eslint-enable no-multi-spaces*/
	
	        //Store private properties in a scope sealed hash map
	        var _this = this;
	
	        /**
	         * @private
	         * @property {Boolean} tracking
	         *      Are we currently tracking pointer events for this element.
	         */
	        THIS[ this.hash ] = {
	            click:                 function ( event ) { onClick( _this, event ); },
	            dblclick:              function ( event ) { onDblClick( _this, event ); },
	            keydown:               function ( event ) { onKeyDown( _this, event ); },
	            keyup:                 function ( event ) { onKeyUp( _this, event ); },
	            keypress:              function ( event ) { onKeyPress( _this, event ); },
	            focus:                 function ( event ) { onFocus( _this, event ); },
	            blur:                  function ( event ) { onBlur( _this, event ); },
	
	            wheel:                 function ( event ) { onWheel( _this, event ); },
	            mousewheel:            function ( event ) { onMouseWheel( _this, event ); },
	            DOMMouseScroll:        function ( event ) { onMouseWheel( _this, event ); },
	            MozMousePixelScroll:   function ( event ) { onMouseWheel( _this, event ); },
	
	            mouseenter:            function ( event ) { onMouseEnter( _this, event ); }, // Used on IE8 only
	            mouseleave:            function ( event ) { onMouseLeave( _this, event ); }, // Used on IE8 only
	            mouseover:             function ( event ) { onMouseOver( _this, event ); },
	            mouseout:              function ( event ) { onMouseOut( _this, event ); },
	            mousedown:             function ( event ) { onMouseDown( _this, event ); },
	            mouseup:               function ( event ) { onMouseUp( _this, event ); },
	            mouseupcaptured:       function ( event ) { onMouseUpCaptured( _this, event ); },
	            mousemove:             function ( event ) { onMouseMove( _this, event ); },
	            mousemovecaptured:     function ( event ) { onMouseMoveCaptured( _this, event ); },
	
	            touchstart:            function ( event ) { onTouchStart( _this, event ); },
	            touchend:              function ( event ) { onTouchEnd( _this, event ); },
	            touchendcaptured:      function ( event ) { onTouchEndCaptured( _this, event ); },
	            touchmove:             function ( event ) { onTouchMove( _this, event ); },
	            touchmovecaptured:     function ( event ) { onTouchMoveCaptured( _this, event ); },
	            touchcancel:           function ( event ) { onTouchCancel( _this, event ); },
	
	            gesturestart:          function ( event ) { onGestureStart( _this, event ); },
	            gesturechange:         function ( event ) { onGestureChange( _this, event ); },
	
	            pointerover:           function ( event ) { onPointerOver( _this, event ); },
	            MSPointerOver:         function ( event ) { onPointerOver( _this, event ); },
	            pointerout:            function ( event ) { onPointerOut( _this, event ); },
	            MSPointerOut:          function ( event ) { onPointerOut( _this, event ); },
	            pointerdown:           function ( event ) { onPointerDown( _this, event ); },
	            MSPointerDown:         function ( event ) { onPointerDown( _this, event ); },
	            pointerup:             function ( event ) { onPointerUp( _this, event ); },
	            MSPointerUp:           function ( event ) { onPointerUp( _this, event ); },
	            pointermove:           function ( event ) { onPointerMove( _this, event ); },
	            MSPointerMove:         function ( event ) { onPointerMove( _this, event ); },
	            pointercancel:         function ( event ) { onPointerCancel( _this, event ); },
	            MSPointerCancel:       function ( event ) { onPointerCancel( _this, event ); },
	            pointerupcaptured:     function ( event ) { onPointerUpCaptured( _this, event ); },
	            pointermovecaptured:   function ( event ) { onPointerMoveCaptured( _this, event ); },
	
	            tracking:              false,
	
	            // Active pointers lists. Array of GesturePointList objects, one for each pointer device type.
	            // GesturePointList objects are added each time a pointer is tracked by a new pointer device type (see getActivePointersListByType()).
	            // Active pointers are any pointer being tracked for this element which are in the hit-test area
	            //     of the element (for hover-capable devices) and/or have contact or a button press initiated in the element.
	            activePointersLists:   [],
	
	            // Tracking for double-click gesture
	            lastClickPos:          null,
	            dblClickTimeOut:       null,
	
	            // Tracking for pinch gesture
	            pinchGPoints:          [],
	            lastPinchDist:         0,
	            currentPinchDist:      0,
	            lastPinchCenter:       null,
	            currentPinchCenter:    null
	        };
	
	        if ( !options.startDisabled ) {
	            this.setTracking( true );
	        }
	    };
	
	    /** @lends OpenSeadragon.MouseTracker.prototype */
	    $.MouseTracker.prototype = {
	
	        /**
	         * Clean up any events or objects created by the tracker.
	         * @function
	         */
	        destroy: function () {
	            var i;
	
	            stopTracking( this );
	            this.element = null;
	
	            for ( i = 0; i < MOUSETRACKERS.length; i++ ) {
	                if ( MOUSETRACKERS[ i ] === this ) {
	                    MOUSETRACKERS.splice( i, 1 );
	                    break;
	                }
	            }
	
	            THIS[ this.hash ] = null;
	            delete THIS[ this.hash ];
	        },
	
	        /**
	         * Are we currently tracking events on this element.
	         * @deprecated Just use this.tracking
	         * @function
	         * @returns {Boolean} Are we currently tracking events on this element.
	         */
	        isTracking: function () {
	            return THIS[ this.hash ].tracking;
	        },
	
	        /**
	         * Enable or disable whether or not we are tracking events on this element.
	         * @function
	         * @param {Boolean} track True to start tracking, false to stop tracking.
	         * @returns {OpenSeadragon.MouseTracker} Chainable.
	         */
	        setTracking: function ( track ) {
	            if ( track ) {
	                startTracking( this );
	            } else {
	                stopTracking( this );
	            }
	            //chain
	            return this;
	        },
	
	        /**
	         * Returns the {@link OpenSeadragon.MouseTracker.GesturePointList|GesturePointList} for all but the given pointer device type.
	         * @function
	         * @param {String} type - The pointer device type: "mouse", "touch", "pen", etc.
	         * @returns {Array.<OpenSeadragon.MouseTracker.GesturePointList>}
	         */
	        getActivePointersListsExceptType: function ( type ) {
	            var delegate = THIS[ this.hash ];
	            var listArray = [];
	
	            for (var i = 0; i < delegate.activePointersLists.length; ++i) {
	                if (delegate.activePointersLists[i].type !== type) {
	                    listArray.push(delegate.activePointersLists[i]);
	                }
	            }
	
	            return listArray;
	        },
	
	        /**
	         * Returns the {@link OpenSeadragon.MouseTracker.GesturePointList|GesturePointList} for the given pointer device type,
	         * creating and caching a new {@link OpenSeadragon.MouseTracker.GesturePointList|GesturePointList} if one doesn't already exist for the type.
	         * @function
	         * @param {String} type - The pointer device type: "mouse", "touch", "pen", etc.
	         * @returns {OpenSeadragon.MouseTracker.GesturePointList}
	         */
	        getActivePointersListByType: function ( type ) {
	            var delegate = THIS[ this.hash ],
	                i,
	                len = delegate.activePointersLists.length,
	                list;
	
	            for ( i = 0; i < len; i++ ) {
	                if ( delegate.activePointersLists[ i ].type === type ) {
	                    return delegate.activePointersLists[ i ];
	                }
	            }
	
	            list = new $.MouseTracker.GesturePointList( type );
	            delegate.activePointersLists.push( list );
	            return list;
	        },
	
	        /**
	         * Returns the total number of pointers currently active on the tracked element.
	         * @function
	         * @returns {Number}
	         */
	        getActivePointerCount: function () {
	            var delegate = THIS[ this.hash ],
	                i,
	                len = delegate.activePointersLists.length,
	                count = 0;
	
	            for ( i = 0; i < len; i++ ) {
	                count += delegate.activePointersLists[ i ].getLength();
	            }
	
	            return count;
	        },
	
	        /**
	         * Implement or assign implementation to these handlers during or after
	         * calling the constructor.
	         * @function
	         * @param {Object} event
	         * @param {OpenSeadragon.MouseTracker} event.eventSource
	         *      A reference to the tracker instance.
	         * @param {String} event.pointerType
	         *     "mouse", "touch", "pen", etc.
	         * @param {OpenSeadragon.Point} event.position
	         *      The position of the event relative to the tracked element.
	         * @param {Number} event.buttons
	         *      Current buttons pressed.
	         *      Combination of bit flags 0: none, 1: primary (or touch contact), 2: secondary, 4: aux (often middle), 8: X1 (often back), 16: X2 (often forward), 32: pen eraser.
	         * @param {Number} event.pointers
	         *      Number of pointers (all types) active in the tracked element.
	         * @param {Boolean} event.insideElementPressed
	         *      True if the left mouse button is currently being pressed and was
	         *      initiated inside the tracked element, otherwise false.
	         * @param {Boolean} event.buttonDownAny
	         *      Was the button down anywhere in the screen during the event. <span style="color:red;">Deprecated. Use buttons instead.</span>
	         * @param {Boolean} event.isTouchEvent
	         *      True if the original event is a touch event, otherwise false. <span style="color:red;">Deprecated. Use pointerType and/or originalEvent instead.</span>
	         * @param {Object} event.originalEvent
	         *      The original event object.
	         * @param {Boolean} event.preventDefaultAction
	         *      Set to true to prevent the tracker subscriber from performing its default action (subscriber implementation dependent). Default: false.
	         * @param {Object} event.userData
	         *      Arbitrary user-defined object.
	         */
	        enterHandler: function () { },
	
	        /**
	         * Implement or assign implementation to these handlers during or after
	         * calling the constructor.
	         * @function
	         * @param {Object} event
	         * @param {OpenSeadragon.MouseTracker} event.eventSource
	         *      A reference to the tracker instance.
	         * @param {String} event.pointerType
	         *     "mouse", "touch", "pen", etc.
	         * @param {OpenSeadragon.Point} event.position
	         *      The position of the event relative to the tracked element.
	         * @param {Number} event.buttons
	         *      Current buttons pressed.
	         *      Combination of bit flags 0: none, 1: primary (or touch contact), 2: secondary, 4: aux (often middle), 8: X1 (often back), 16: X2 (often forward), 32: pen eraser.
	         * @param {Number} event.pointers
	         *      Number of pointers (all types) active in the tracked element.
	         * @param {Boolean} event.insideElementPressed
	         *      True if the left mouse button is currently being pressed and was
	         *      initiated inside the tracked element, otherwise false.
	         * @param {Boolean} event.buttonDownAny
	         *      Was the button down anywhere in the screen during the event. <span style="color:red;">Deprecated. Use buttons instead.</span>
	         * @param {Boolean} event.isTouchEvent
	         *      True if the original event is a touch event, otherwise false. <span style="color:red;">Deprecated. Use pointerType and/or originalEvent instead.</span>
	         * @param {Object} event.originalEvent
	         *      The original event object.
	         * @param {Boolean} event.preventDefaultAction
	         *      Set to true to prevent the tracker subscriber from performing its default action (subscriber implementation dependent). Default: false.
	         * @param {Object} event.userData
	         *      Arbitrary user-defined object.
	         */
	        exitHandler: function () { },
	
	        /**
	         * Implement or assign implementation to these handlers during or after
	         * calling the constructor.
	         * @function
	         * @param {Object} event
	         * @param {OpenSeadragon.MouseTracker} event.eventSource
	         *      A reference to the tracker instance.
	         * @param {String} event.pointerType
	         *     "mouse", "touch", "pen", etc.
	         * @param {OpenSeadragon.Point} event.position
	         *      The position of the event relative to the tracked element.
	         * @param {Number} event.buttons
	         *      Current buttons pressed.
	         *      Combination of bit flags 0: none, 1: primary (or touch contact), 2: secondary, 4: aux (often middle), 8: X1 (often back), 16: X2 (often forward), 32: pen eraser.
	         * @param {Boolean} event.isTouchEvent
	         *      True if the original event is a touch event, otherwise false. <span style="color:red;">Deprecated. Use pointerType and/or originalEvent instead.</span>
	         * @param {Object} event.originalEvent
	         *      The original event object.
	         * @param {Boolean} event.preventDefaultAction
	         *      Set to true to prevent the tracker subscriber from performing its default action (subscriber implementation dependent). Default: false.
	         * @param {Object} event.userData
	         *      Arbitrary user-defined object.
	         */
	        pressHandler: function () { },
	
	        /**
	         * Implement or assign implementation to these handlers during or after
	         * calling the constructor.
	         * @function
	         * @param {Object} event
	         * @param {OpenSeadragon.MouseTracker} event.eventSource
	         *      A reference to the tracker instance.
	         * @param {String} event.pointerType
	         *     "mouse", "touch", "pen", etc.
	         * @param {OpenSeadragon.Point} event.position
	         *      The position of the event relative to the tracked element.
	         * @param {Number} event.button
	         *      Button which caused the event.
	         *      -1: none, 0: primary/left, 1: aux/middle, 2: secondary/right, 3: X1/back, 4: X2/forward, 5: pen eraser.
	         * @param {Number} event.buttons
	         *      Current buttons pressed.
	         *      Combination of bit flags 0: none, 1: primary (or touch contact), 2: secondary, 4: aux (often middle), 8: X1 (often back), 16: X2 (often forward), 32: pen eraser.
	         * @param {Boolean} event.isTouchEvent
	         *      True if the original event is a touch event, otherwise false. <span style="color:red;">Deprecated. Use pointerType and/or originalEvent instead.</span>
	         * @param {Object} event.originalEvent
	         *      The original event object.
	         * @param {Boolean} event.preventDefaultAction
	         *      Set to true to prevent the tracker subscriber from performing its default action (subscriber implementation dependent). Default: false.
	         * @param {Object} event.userData
	         *      Arbitrary user-defined object.
	         */
	        nonPrimaryPressHandler: function () { },
	
	        /**
	         * Implement or assign implementation to these handlers during or after
	         * calling the constructor.
	         * @function
	         * @param {Object} event
	         * @param {OpenSeadragon.MouseTracker} event.eventSource
	         *      A reference to the tracker instance.
	         * @param {String} event.pointerType
	         *     "mouse", "touch", "pen", etc.
	         * @param {OpenSeadragon.Point} event.position
	         *      The position of the event relative to the tracked element.
	         * @param {Number} event.buttons
	         *      Current buttons pressed.
	         *      Combination of bit flags 0: none, 1: primary (or touch contact), 2: secondary, 4: aux (often middle), 8: X1 (often back), 16: X2 (often forward), 32: pen eraser.
	         * @param {Boolean} event.insideElementPressed
	         *      True if the left mouse button is currently being pressed and was
	         *      initiated inside the tracked element, otherwise false.
	         * @param {Boolean} event.insideElementReleased
	         *      True if the cursor inside the tracked element when the button was released.
	         * @param {Boolean} event.isTouchEvent
	         *      True if the original event is a touch event, otherwise false. <span style="color:red;">Deprecated. Use pointerType and/or originalEvent instead.</span>
	         * @param {Object} event.originalEvent
	         *      The original event object.
	         * @param {Boolean} event.preventDefaultAction
	         *      Set to true to prevent the tracker subscriber from performing its default action (subscriber implementation dependent). Default: false.
	         * @param {Object} event.userData
	         *      Arbitrary user-defined object.
	         */
	        releaseHandler: function () { },
	
	        /**
	         * Implement or assign implementation to these handlers during or after
	         * calling the constructor.
	         * @function
	         * @param {Object} event
	         * @param {OpenSeadragon.MouseTracker} event.eventSource
	         *      A reference to the tracker instance.
	         * @param {String} event.pointerType
	         *     "mouse", "touch", "pen", etc.
	         * @param {OpenSeadragon.Point} event.position
	         *      The position of the event relative to the tracked element.
	         * @param {Number} event.button
	         *      Button which caused the event.
	         *      -1: none, 0: primary/left, 1: aux/middle, 2: secondary/right, 3: X1/back, 4: X2/forward, 5: pen eraser.
	         * @param {Number} event.buttons
	         *      Current buttons pressed.
	         *      Combination of bit flags 0: none, 1: primary (or touch contact), 2: secondary, 4: aux (often middle), 8: X1 (often back), 16: X2 (often forward), 32: pen eraser.
	         * @param {Boolean} event.isTouchEvent
	         *      True if the original event is a touch event, otherwise false. <span style="color:red;">Deprecated. Use pointerType and/or originalEvent instead.</span>
	         * @param {Object} event.originalEvent
	         *      The original event object.
	         * @param {Boolean} event.preventDefaultAction
	         *      Set to true to prevent the tracker subscriber from performing its default action (subscriber implementation dependent). Default: false.
	         * @param {Object} event.userData
	         *      Arbitrary user-defined object.
	         */
	        nonPrimaryReleaseHandler: function () { },
	
	        /**
	         * Implement or assign implementation to these handlers during or after
	         * calling the constructor.
	         * @function
	         * @param {Object} event
	         * @param {OpenSeadragon.MouseTracker} event.eventSource
	         *      A reference to the tracker instance.
	         * @param {String} event.pointerType
	         *     "mouse", "touch", "pen", etc.
	         * @param {OpenSeadragon.Point} event.position
	         *      The position of the event relative to the tracked element.
	         * @param {Number} event.buttons
	         *      Current buttons pressed.
	         *      Combination of bit flags 0: none, 1: primary (or touch contact), 2: secondary, 4: aux (often middle), 8: X1 (often back), 16: X2 (often forward), 32: pen eraser.
	         * @param {Boolean} event.isTouchEvent
	         *      True if the original event is a touch event, otherwise false. <span style="color:red;">Deprecated. Use pointerType and/or originalEvent instead.</span>
	         * @param {Object} event.originalEvent
	         *      The original event object.
	         * @param {Boolean} event.preventDefaultAction
	         *      Set to true to prevent the tracker subscriber from performing its default action (subscriber implementation dependent). Default: false.
	         * @param {Object} event.userData
	         *      Arbitrary user-defined object.
	         */
	        moveHandler: function () { },
	
	        /**
	         * Implement or assign implementation to these handlers during or after
	         * calling the constructor.
	         * @function
	         * @param {Object} event
	         * @param {OpenSeadragon.MouseTracker} event.eventSource
	         *      A reference to the tracker instance.
	         * @param {String} event.pointerType
	         *     "mouse", "touch", "pen", etc.
	         * @param {OpenSeadragon.Point} event.position
	         *      The position of the event relative to the tracked element.
	         * @param {Number} event.scroll
	         *      The scroll delta for the event.
	         * @param {Boolean} event.shift
	         *      True if the shift key was pressed during this event.
	         * @param {Boolean} event.isTouchEvent
	         *      True if the original event is a touch event, otherwise false. <span style="color:red;">Deprecated. Use pointerType and/or originalEvent instead. Touch devices no longer generate scroll event.</span>
	         * @param {Object} event.originalEvent
	         *      The original event object.
	         * @param {Boolean} event.preventDefaultAction
	         *      Set to true to prevent the tracker subscriber from performing its default action (subscriber implementation dependent). Default: false.
	         * @param {Object} event.userData
	         *      Arbitrary user-defined object.
	         */
	        scrollHandler: function () { },
	
	        /**
	         * Implement or assign implementation to these handlers during or after
	         * calling the constructor.
	         * @function
	         * @param {Object} event
	         * @param {OpenSeadragon.MouseTracker} event.eventSource
	         *      A reference to the tracker instance.
	         * @param {String} event.pointerType
	         *     "mouse", "touch", "pen", etc.
	         * @param {OpenSeadragon.Point} event.position
	         *      The position of the event relative to the tracked element.
	         * @param {Boolean} event.quick
	         *      True only if the clickDistThreshold and clickTimeThreshold are both passed. Useful for ignoring drag events.
	         * @param {Boolean} event.shift
	         *      True if the shift key was pressed during this event.
	         * @param {Boolean} event.isTouchEvent
	         *      True if the original event is a touch event, otherwise false. <span style="color:red;">Deprecated. Use pointerType and/or originalEvent instead.</span>
	         * @param {Object} event.originalEvent
	         *      The original event object.
	         * @param {Boolean} event.preventDefaultAction
	         *      Set to true to prevent the tracker subscriber from performing its default action (subscriber implementation dependent). Default: false.
	         * @param {Object} event.userData
	         *      Arbitrary user-defined object.
	         */
	        clickHandler: function () { },
	
	        /**
	         * Implement or assign implementation to these handlers during or after
	         * calling the constructor.
	         * @function
	         * @param {Object} event
	         * @param {OpenSeadragon.MouseTracker} event.eventSource
	         *      A reference to the tracker instance.
	         * @param {String} event.pointerType
	         *     "mouse", "touch", "pen", etc.
	         * @param {OpenSeadragon.Point} event.position
	         *      The position of the event relative to the tracked element.
	         * @param {Boolean} event.shift
	         *      True if the shift key was pressed during this event.
	         * @param {Boolean} event.isTouchEvent
	         *      True if the original event is a touch event, otherwise false. <span style="color:red;">Deprecated. Use pointerType and/or originalEvent instead.</span>
	         * @param {Object} event.originalEvent
	         *      The original event object.
	         * @param {Boolean} event.preventDefaultAction
	         *      Set to true to prevent the tracker subscriber from performing its default action (subscriber implementation dependent). Default: false.
	         * @param {Object} event.userData
	         *      Arbitrary user-defined object.
	         */
	        dblClickHandler: function () { },
	
	        /**
	         * Implement or assign implementation to these handlers during or after
	         * calling the constructor.
	         * @function
	         * @param {Object} event
	         * @param {OpenSeadragon.MouseTracker} event.eventSource
	         *      A reference to the tracker instance.
	         * @param {String} event.pointerType
	         *     "mouse", "touch", "pen", etc.
	         * @param {OpenSeadragon.Point} event.position
	         *      The position of the event relative to the tracked element.
	         * @param {Number} event.buttons
	         *      Current buttons pressed.
	         *      Combination of bit flags 0: none, 1: primary (or touch contact), 2: secondary, 4: aux (often middle), 8: X1 (often back), 16: X2 (often forward), 32: pen eraser.
	         * @param {OpenSeadragon.Point} event.delta
	         *      The x,y components of the difference between the current position and the last drag event position.  Useful for ignoring or weighting the events.
	         * @param {Number} event.speed
	         *     Current computed speed, in pixels per second.
	         * @param {Number} event.direction
	         *     Current computed direction, expressed as an angle counterclockwise relative to the positive X axis (-pi to pi, in radians). Only valid if speed > 0.
	         * @param {Boolean} event.shift
	         *      True if the shift key was pressed during this event.
	         * @param {Boolean} event.isTouchEvent
	         *      True if the original event is a touch event, otherwise false. <span style="color:red;">Deprecated. Use pointerType and/or originalEvent instead.</span>
	         * @param {Object} event.originalEvent
	         *      The original event object.
	         * @param {Boolean} event.preventDefaultAction
	         *      Set to true to prevent the tracker subscriber from performing its default action (subscriber implementation dependent). Default: false.
	         * @param {Object} event.userData
	         *      Arbitrary user-defined object.
	         */
	        dragHandler: function () { },
	
	        /**
	         * Implement or assign implementation to these handlers during or after
	         * calling the constructor.
	         * @function
	         * @param {Object} event
	         * @param {OpenSeadragon.MouseTracker} event.eventSource
	         *      A reference to the tracker instance.
	         * @param {String} event.pointerType
	         *     "mouse", "touch", "pen", etc.
	         * @param {OpenSeadragon.Point} event.position
	         *      The position of the event relative to the tracked element.
	         * @param {Number} event.speed
	         *     Speed at the end of a drag gesture, in pixels per second.
	         * @param {Number} event.direction
	         *     Direction at the end of a drag gesture, expressed as an angle counterclockwise relative to the positive X axis (-pi to pi, in radians). Only valid if speed > 0.
	         * @param {Boolean} event.shift
	         *      True if the shift key was pressed during this event.
	         * @param {Boolean} event.isTouchEvent
	         *      True if the original event is a touch event, otherwise false. <span style="color:red;">Deprecated. Use pointerType and/or originalEvent instead.</span>
	         * @param {Object} event.originalEvent
	         *      The original event object.
	         * @param {Boolean} event.preventDefaultAction
	         *      Set to true to prevent the tracker subscriber from performing its default action (subscriber implementation dependent). Default: false.
	         * @param {Object} event.userData
	         *      Arbitrary user-defined object.
	         */
	        dragEndHandler: function () { },
	
	        /**
	         * Implement or assign implementation to these handlers during or after
	         * calling the constructor.
	         * @function
	         * @param {Object} event
	         * @param {OpenSeadragon.MouseTracker} event.eventSource
	         *      A reference to the tracker instance.
	         * @param {String} event.pointerType
	         *     "mouse", "touch", "pen", etc.
	         * @param {Array.<OpenSeadragon.MouseTracker.GesturePoint>} event.gesturePoints
	         *      Gesture points associated with the gesture. Velocity data can be found here.
	         * @param {OpenSeadragon.Point} event.lastCenter
	         *      The previous center point of the two pinch contact points relative to the tracked element.
	         * @param {OpenSeadragon.Point} event.center
	         *      The center point of the two pinch contact points relative to the tracked element.
	         * @param {Number} event.lastDistance
	         *      The previous distance between the two pinch contact points in CSS pixels.
	         * @param {Number} event.distance
	         *      The distance between the two pinch contact points in CSS pixels.
	         * @param {Boolean} event.shift
	         *      True if the shift key was pressed during this event.
	         * @param {Object} event.originalEvent
	         *      The original event object.
	         * @param {Boolean} event.preventDefaultAction
	         *      Set to true to prevent the tracker subscriber from performing its default action (subscriber implementation dependent). Default: false.
	         * @param {Object} event.userData
	         *      Arbitrary user-defined object.
	         */
	        pinchHandler: function () { },
	
	        /**
	         * Implement or assign implementation to these handlers during or after
	         * calling the constructor.
	         * @function
	         * @param {Object} event
	         * @param {OpenSeadragon.MouseTracker} event.eventSource
	         *      A reference to the tracker instance.
	         * @param {String} event.pointerType
	         *     "mouse", "touch", "pen", etc.
	         * @param {OpenSeadragon.Point} event.position
	         *      The position of the event relative to the tracked element.
	         * @param {Number} event.buttons
	         *      Current buttons pressed.
	         *      Combination of bit flags 0: none, 1: primary (or touch contact), 2: secondary, 4: aux (often middle), 8: X1 (often back), 16: X2 (often forward), 32: pen eraser.
	         * @param {Boolean} event.isTouchEvent
	         *      True if the original event is a touch event, otherwise false. <span style="color:red;">Deprecated. Use pointerType and/or originalEvent instead.</span>
	         * @param {Object} event.originalEvent
	         *      The original event object.
	         * @param {Boolean} event.preventDefaultAction
	         *      Set to true to prevent the tracker subscriber from performing its default action (subscriber implementation dependent). Default: false.
	         * @param {Object} event.userData
	         *      Arbitrary user-defined object.
	         */
	        stopHandler: function () { },
	
	        /**
	         * Implement or assign implementation to these handlers during or after
	         * calling the constructor.
	         * @function
	         * @param {Object} event
	         * @param {OpenSeadragon.MouseTracker} event.eventSource
	         *      A reference to the tracker instance.
	         * @param {Number} event.keyCode
	         *      The key code that was pressed.
	         * @param {Boolean} event.ctrl
	         *      True if the ctrl key was pressed during this event.
	         * @param {Boolean} event.shift
	         *      True if the shift key was pressed during this event.
	         * @param {Boolean} event.alt
	         *      True if the alt key was pressed during this event.
	         * @param {Boolean} event.meta
	         *      True if the meta key was pressed during this event.
	         * @param {Object} event.originalEvent
	         *      The original event object.
	         * @param {Boolean} event.preventDefaultAction
	         *      Set to true to prevent the tracker subscriber from performing its default action (subscriber implementation dependent). Default: false.
	         * @param {Object} event.userData
	         *      Arbitrary user-defined object.
	         */
	        keyDownHandler: function () { },
	
	        /**
	         * Implement or assign implementation to these handlers during or after
	         * calling the constructor.
	         * @function
	         * @param {Object} event
	         * @param {OpenSeadragon.MouseTracker} event.eventSource
	         *      A reference to the tracker instance.
	         * @param {Number} event.keyCode
	         *      The key code that was pressed.
	         * @param {Boolean} event.ctrl
	         *      True if the ctrl key was pressed during this event.
	         * @param {Boolean} event.shift
	         *      True if the shift key was pressed during this event.
	         * @param {Boolean} event.alt
	         *      True if the alt key was pressed during this event.
	         * @param {Boolean} event.meta
	         *      True if the meta key was pressed during this event.
	         * @param {Object} event.originalEvent
	         *      The original event object.
	         * @param {Boolean} event.preventDefaultAction
	         *      Set to true to prevent the tracker subscriber from performing its default action (subscriber implementation dependent). Default: false.
	         * @param {Object} event.userData
	         *      Arbitrary user-defined object.
	         */
	        keyUpHandler: function () { },
	
	        /**
	         * Implement or assign implementation to these handlers during or after
	         * calling the constructor.
	         * @function
	         * @param {Object} event
	         * @param {OpenSeadragon.MouseTracker} event.eventSource
	         *      A reference to the tracker instance.
	         * @param {Number} event.keyCode
	         *      The key code that was pressed.
	         * @param {Boolean} event.ctrl
	         *      True if the ctrl key was pressed during this event.
	         * @param {Boolean} event.shift
	         *      True if the shift key was pressed during this event.
	         * @param {Boolean} event.alt
	         *      True if the alt key was pressed during this event.
	         * @param {Boolean} event.meta
	         *      True if the meta key was pressed during this event.
	         * @param {Object} event.originalEvent
	         *      The original event object.
	         * @param {Boolean} event.preventDefaultAction
	         *      Set to true to prevent the tracker subscriber from performing its default action (subscriber implementation dependent). Default: false.
	         * @param {Object} event.userData
	         *      Arbitrary user-defined object.
	         */
	        keyHandler: function () { },
	
	        /**
	         * Implement or assign implementation to these handlers during or after
	         * calling the constructor.
	         * @function
	         * @param {Object} event
	         * @param {OpenSeadragon.MouseTracker} event.eventSource
	         *      A reference to the tracker instance.
	         * @param {Object} event.originalEvent
	         *      The original event object.
	         * @param {Boolean} event.preventDefaultAction
	         *      Set to true to prevent the tracker subscriber from performing its default action (subscriber implementation dependent). Default: false.
	         * @param {Object} event.userData
	         *      Arbitrary user-defined object.
	         */
	        focusHandler: function () { },
	
	        /**
	         * Implement or assign implementation to these handlers during or after
	         * calling the constructor.
	         * @function
	         * @param {Object} event
	         * @param {OpenSeadragon.MouseTracker} event.eventSource
	         *      A reference to the tracker instance.
	         * @param {Object} event.originalEvent
	         *      The original event object.
	         * @param {Boolean} event.preventDefaultAction
	         *      Set to true to prevent the tracker subscriber from performing its default action (subscriber implementation dependent). Default: false.
	         * @param {Object} event.userData
	         *      Arbitrary user-defined object.
	         */
	        blurHandler: function () { }
	    };
	
	    /**
	     * Resets all active mousetrakers. (Added to patch issue #697 "Mouse up outside map will cause "canvas-drag" event to stick")
	     *
	     * @private
	     * @member resetAllMouseTrackers
	     * @memberof OpenSeadragon.MouseTracker
	     */
	    $.MouseTracker.resetAllMouseTrackers = function(){
	        for(var i = 0; i < MOUSETRACKERS.length; i++){
	            if (MOUSETRACKERS[i].isTracking()){
	                MOUSETRACKERS[i].setTracking(false);
	                MOUSETRACKERS[i].setTracking(true);
	            }
	        }
	    };
	
	    /**
	     * Provides continuous computation of velocity (speed and direction) of active pointers.
	     * This is a singleton, used by all MouseTracker instances, as it is unlikely there will ever be more than
	     * two active gesture pointers at a time.
	     *
	     * @private
	     * @member gesturePointVelocityTracker
	     * @memberof OpenSeadragon.MouseTracker
	     */
	    $.MouseTracker.gesturePointVelocityTracker = (function () {
	        var trackerPoints = [],
	            intervalId = 0,
	            lastTime = 0;
	
	        // Generates a unique identifier for a tracked gesture point
	        var _generateGuid = function ( tracker, gPoint ) {
	            return tracker.hash.toString() + gPoint.type + gPoint.id.toString();
	        };
	
	        // Interval timer callback. Computes velocity for all tracked gesture points.
	        var _doTracking = function () {
	            var i,
	                len = trackerPoints.length,
	                trackPoint,
	                gPoint,
	                now = $.now(),
	                elapsedTime,
	                distance,
	                speed;
	
	            elapsedTime = now - lastTime;
	            lastTime = now;
	
	            for ( i = 0; i < len; i++ ) {
	                trackPoint = trackerPoints[ i ];
	                gPoint = trackPoint.gPoint;
	                // Math.atan2 gives us just what we need for a velocity vector, as we can simply
	                //   use cos()/sin() to extract the x/y velocity components.
	                gPoint.direction = Math.atan2( gPoint.currentPos.y - trackPoint.lastPos.y, gPoint.currentPos.x - trackPoint.lastPos.x );
	                // speed = distance / elapsed time
	                distance = trackPoint.lastPos.distanceTo( gPoint.currentPos );
	                trackPoint.lastPos = gPoint.currentPos;
	                speed = 1000 * distance / ( elapsedTime + 1 );
	                // Simple biased average, favors the most recent speed computation. Smooths out erratic gestures a bit.
	                gPoint.speed = 0.75 * speed + 0.25 * gPoint.speed;
	            }
	        };
	
	        // Public. Add a gesture point to be tracked
	        var addPoint = function ( tracker, gPoint ) {
	            var guid = _generateGuid( tracker, gPoint );
	
	            trackerPoints.push(
	                {
	                    guid: guid,
	                    gPoint: gPoint,
	                    lastPos: gPoint.currentPos
	                } );
	
	            // Only fire up the interval timer when there's gesture pointers to track
	            if ( trackerPoints.length === 1 ) {
	                lastTime = $.now();
	                intervalId = window.setInterval( _doTracking, 50 );
	            }
	        };
	
	        // Public. Stop tracking a gesture point
	        var removePoint = function ( tracker, gPoint ) {
	            var guid = _generateGuid( tracker, gPoint ),
	                i,
	                len = trackerPoints.length;
	            for ( i = 0; i < len; i++ ) {
	                if ( trackerPoints[ i ].guid === guid ) {
	                    trackerPoints.splice( i, 1 );
	                    // Only run the interval timer if theres gesture pointers to track
	                    len--;
	                    if ( len === 0 ) {
	                        window.clearInterval( intervalId );
	                    }
	                    break;
	                }
	            }
	        };
	
	        return {
	            addPoint:    addPoint,
	            removePoint: removePoint
	        };
	    } )();
	
	
	///////////////////////////////////////////////////////////////////////////////
	// Pointer event model and feature detection
	///////////////////////////////////////////////////////////////////////////////
	
	    $.MouseTracker.captureElement = document;
	
	    /**
	     * Detect available mouse wheel event name.
	     */
	    $.MouseTracker.wheelEventName = ( $.Browser.vendor == $.BROWSERS.IE && $.Browser.version > 8 ) ||
	                                                ( 'onwheel' in document.createElement( 'div' ) ) ? 'wheel' : // Modern browsers support 'wheel'
	                                    document.onmousewheel !== undefined ? 'mousewheel' :                     // Webkit and IE support at least 'mousewheel'
	                                    'DOMMouseScroll';                                                        // Assume old Firefox
	
	    /**
	     * Detect legacy mouse capture support.
	     */
	    $.MouseTracker.supportsMouseCapture = (function () {
	        var divElement = document.createElement( 'div' );
	        return $.isFunction( divElement.setCapture ) && $.isFunction( divElement.releaseCapture );
	    }());
	
	    /**
	     * Detect browser pointer device event model(s) and build appropriate list of events to subscribe to.
	     */
	    $.MouseTracker.subscribeEvents = [ "click", "dblclick", "keydown", "keyup", "keypress", "focus", "blur", $.MouseTracker.wheelEventName ];
	
	    if( $.MouseTracker.wheelEventName == "DOMMouseScroll" ) {
	        // Older Firefox
	        $.MouseTracker.subscribeEvents.push( "MozMousePixelScroll" );
	    }
	
	    // Note: window.navigator.pointerEnable is deprecated on IE 11 and not part of W3C spec.
	    if ( window.PointerEvent && ( window.navigator.pointerEnabled || $.Browser.vendor !== $.BROWSERS.IE ) ) {
	        // IE11 and other W3C Pointer Event implementations (see http://www.w3.org/TR/pointerevents)
	        $.MouseTracker.havePointerEvents = true;
	        $.MouseTracker.subscribeEvents.push( "pointerover", "pointerout", "pointerdown", "pointerup", "pointermove", "pointercancel" );
	        $.MouseTracker.unprefixedPointerEvents = true;
	        if( navigator.maxTouchPoints ) {
	            $.MouseTracker.maxTouchPoints = navigator.maxTouchPoints;
	        } else {
	            $.MouseTracker.maxTouchPoints = 0;
	        }
	        $.MouseTracker.haveMouseEnter = false;
	    } else if ( window.MSPointerEvent && window.navigator.msPointerEnabled ) {
	        // IE10
	        $.MouseTracker.havePointerEvents = true;
	        $.MouseTracker.subscribeEvents.push( "MSPointerOver", "MSPointerOut", "MSPointerDown", "MSPointerUp", "MSPointerMove", "MSPointerCancel" );
	        $.MouseTracker.unprefixedPointerEvents = false;
	        if( navigator.msMaxTouchPoints ) {
	            $.MouseTracker.maxTouchPoints = navigator.msMaxTouchPoints;
	        } else {
	            $.MouseTracker.maxTouchPoints = 0;
	        }
	        $.MouseTracker.haveMouseEnter = false;
	    } else {
	        // Legacy W3C mouse events
	        $.MouseTracker.havePointerEvents = false;
	        if ( $.Browser.vendor === $.BROWSERS.IE && $.Browser.version < 9 ) {
	            $.MouseTracker.subscribeEvents.push( "mouseenter", "mouseleave" );
	            $.MouseTracker.haveMouseEnter = true;
	        } else {
	            $.MouseTracker.subscribeEvents.push( "mouseover", "mouseout" );
	            $.MouseTracker.haveMouseEnter = false;
	        }
	        $.MouseTracker.subscribeEvents.push( "mousedown", "mouseup", "mousemove" );
	        if ( 'ontouchstart' in window ) {
	            // iOS, Android, and other W3c Touch Event implementations
	            //    (see http://www.w3.org/TR/touch-events/)
	            //    (see https://developer.apple.com/library/ios/documentation/AppleApplications/Reference/SafariWebContent/HandlingEvents/HandlingEvents.html)
	            //    (see https://developer.apple.com/library/safari/documentation/AppleApplications/Reference/SafariWebContent/HandlingEvents/HandlingEvents.html)
	            $.MouseTracker.subscribeEvents.push( "touchstart", "touchend", "touchmove", "touchcancel" );
	        }
	        if ( 'ongesturestart' in window ) {
	            // iOS (see https://developer.apple.com/library/ios/documentation/AppleApplications/Reference/SafariWebContent/HandlingEvents/HandlingEvents.html)
	            //   Subscribe to these to prevent default gesture handling
	            $.MouseTracker.subscribeEvents.push( "gesturestart", "gesturechange" );
	        }
	        $.MouseTracker.mousePointerId = "legacy-mouse";
	        $.MouseTracker.maxTouchPoints = 10;
	    }
	
	
	///////////////////////////////////////////////////////////////////////////////
	// Classes and typedefs
	///////////////////////////////////////////////////////////////////////////////
	
	    /**
	     * Represents a point of contact on the screen made by a mouse cursor, pen, touch, or other pointer device.
	     *
	     * @typedef {Object} GesturePoint
	     * @memberof OpenSeadragon.MouseTracker
	     *
	     * @property {Number} id
	     *     Identifier unique from all other active GesturePoints for a given pointer device.
	     * @property {String} type
	     *     The pointer device type: "mouse", "touch", "pen", etc.
	     * @property {Boolean} captured
	     *     True if events for the gesture point are captured to the tracked element.
	     * @property {Boolean} isPrimary
	     *     True if the gesture point is a master pointer amongst the set of active pointers for each pointer type. True for mouse and primary (first) touch/pen pointers.
	     * @property {Boolean} insideElementPressed
	     *     True if button pressed or contact point initiated inside the screen area of the tracked element.
	     * @property {Boolean} insideElement
	     *     True if pointer or contact point is currently inside the bounds of the tracked element.
	     * @property {Number} speed
	     *     Current computed speed, in pixels per second.
	     * @property {Number} direction
	     *     Current computed direction, expressed as an angle counterclockwise relative to the positive X axis (-pi to pi, in radians). Only valid if speed > 0.
	     * @property {OpenSeadragon.Point} contactPos
	     *     The initial pointer contact position, relative to the page including any scrolling. Only valid if the pointer has contact (pressed, touch contact, pen contact).
	     * @property {Number} contactTime
	     *     The initial pointer contact time, in milliseconds. Only valid if the pointer has contact (pressed, touch contact, pen contact).
	     * @property {OpenSeadragon.Point} lastPos
	     *     The last pointer position, relative to the page including any scrolling.
	     * @property {Number} lastTime
	     *     The last pointer contact time, in milliseconds.
	     * @property {OpenSeadragon.Point} currentPos
	     *     The current pointer position, relative to the page including any scrolling.
	     * @property {Number} currentTime
	     *     The current pointer contact time, in milliseconds.
	     */
	
	
	    /**
	     * @class GesturePointList
	     * @classdesc Provides an abstraction for a set of active {@link OpenSeadragon.MouseTracker.GesturePoint|GesturePoint} objects for a given pointer device type.
	     *            Active pointers are any pointer being tracked for this element which are in the hit-test area
	     *            of the element (for hover-capable devices) and/or have contact or a button press initiated in the element.
	     * @memberof OpenSeadragon.MouseTracker
	     * @param {String} type - The pointer device type: "mouse", "touch", "pen", etc.
	     */
	    $.MouseTracker.GesturePointList = function ( type ) {
	        this._gPoints = [];
	        /**
	         * The pointer device type: "mouse", "touch", "pen", etc.
	         * @member {String} type
	         * @memberof OpenSeadragon.MouseTracker.GesturePointList#
	         */
	        this.type = type;
	        /**
	         * Current buttons pressed for the device.
	         * Combination of bit flags 0: none, 1: primary (or touch contact), 2: secondary, 4: aux (often middle), 8: X1 (often back), 16: X2 (often forward), 32: pen eraser.
	         * @member {Number} buttons
	         * @memberof OpenSeadragon.MouseTracker.GesturePointList#
	         */
	        this.buttons = 0;
	        /**
	         * Current number of contact points (touch points, mouse down, etc.) for the device.
	         * @member {Number} contacts
	         * @memberof OpenSeadragon.MouseTracker.GesturePointList#
	         */
	        this.contacts = 0;
	        /**
	         * Current number of clicks for the device. Used for multiple click gesture tracking.
	         * @member {Number} clicks
	         * @memberof OpenSeadragon.MouseTracker.GesturePointList#
	         */
	        this.clicks = 0;
	        /**
	         * Current number of captured pointers for the device.
	         * @member {Number} captureCount
	         * @memberof OpenSeadragon.MouseTracker.GesturePointList#
	         */
	        this.captureCount = 0;
	    };
	
	    /** @lends OpenSeadragon.MouseTracker.GesturePointList.prototype */
	    $.MouseTracker.GesturePointList.prototype = {
	        /**
	         * @function
	         * @returns {Number} Number of gesture points in the list.
	         */
	        getLength: function () {
	            return this._gPoints.length;
	        },
	        /**
	         * @function
	         * @returns {Array.<OpenSeadragon.MouseTracker.GesturePoint>} The list of gesture points in the list as an array (read-only).
	         */
	        asArray: function () {
	            return this._gPoints;
	        },
	        /**
	         * @function
	         * @param {OpenSeadragon.MouseTracker.GesturePoint} gesturePoint - A gesture point to add to the list.
	         * @returns {Number} Number of gesture points in the list.
	         */
	        add: function ( gp ) {
	            return this._gPoints.push( gp );
	        },
	        /**
	         * @function
	         * @param {Number} id - The id of the gesture point to remove from the list.
	         * @returns {Number} Number of gesture points in the list.
	         */
	        removeById: function ( id ) {
	            var i,
	                len = this._gPoints.length;
	            for ( i = 0; i < len; i++ ) {
	                if ( this._gPoints[ i ].id === id ) {
	                    this._gPoints.splice( i, 1 );
	                    break;
	                }
	            }
	            return this._gPoints.length;
	        },
	        /**
	         * @function
	         * @param {Number} index - The index of the gesture point to retrieve from the list.
	         * @returns {OpenSeadragon.MouseTracker.GesturePoint|null} The gesture point at the given index, or null if not found.
	         */
	        getByIndex: function ( index ) {
	            if ( index < this._gPoints.length) {
	                return this._gPoints[ index ];
	            }
	
	            return null;
	        },
	        /**
	         * @function
	         * @param {Number} id - The id of the gesture point to retrieve from the list.
	         * @returns {OpenSeadragon.MouseTracker.GesturePoint|null} The gesture point with the given id, or null if not found.
	         */
	        getById: function ( id ) {
	            var i,
	                len = this._gPoints.length;
	            for ( i = 0; i < len; i++ ) {
	                if ( this._gPoints[ i ].id === id ) {
	                    return this._gPoints[ i ];
	                }
	            }
	            return null;
	        },
	        /**
	         * @function
	         * @returns {OpenSeadragon.MouseTracker.GesturePoint|null} The primary gesture point in the list, or null if not found.
	         */
	        getPrimary: function ( id ) {
	            var i,
	                len = this._gPoints.length;
	            for ( i = 0; i < len; i++ ) {
	                if ( this._gPoints[ i ].isPrimary ) {
	                    return this._gPoints[ i ];
	                }
	            }
	            return null;
	        },
	
	        /**
	         * Increment this pointer's contact count.
	         * It will evaluate whether this pointer type is allowed to have multiple contacts.
	         * @function
	         */
	        addContact: function() {
	            ++this.contacts;
	
	            if (this.contacts > 1 && (this.type === "mouse" || this.type === "pen")) {
	                this.contacts = 1;
	            }
	        },
	
	        /**
	         * Decrement this pointer's contact count.
	         * It will make sure the count does not go below 0.
	         * @function
	         */
	        removeContact: function() {
	            --this.contacts;
	
	            if (this.contacts < 0) {
	                this.contacts = 0;
	            }
	        }
	    };
	
	
	///////////////////////////////////////////////////////////////////////////////
	// Utility functions
	///////////////////////////////////////////////////////////////////////////////
	
	    /**
	     * Removes all tracked pointers.
	     * @private
	     * @inner
	     */
	    function clearTrackedPointers( tracker ) {
	        var delegate = THIS[ tracker.hash ],
	            i,
	            pointerListCount = delegate.activePointersLists.length;
	
	        for ( i = 0; i < pointerListCount; i++ ) {
	            if ( delegate.activePointersLists[ i ].captureCount > 0 ) {
	                $.removeEvent(
	                    $.MouseTracker.captureElement,
	                    'mousemove',
	                    delegate.mousemovecaptured,
	                    true
	                );
	                $.removeEvent(
	                    $.MouseTracker.captureElement,
	                    'mouseup',
	                    delegate.mouseupcaptured,
	                    true
	                );
	                $.removeEvent(
	                    $.MouseTracker.captureElement,
	                    $.MouseTracker.unprefixedPointerEvents ? 'pointermove' : 'MSPointerMove',
	                    delegate.pointermovecaptured,
	                    true
	                );
	                $.removeEvent(
	                    $.MouseTracker.captureElement,
	                    $.MouseTracker.unprefixedPointerEvents ? 'pointerup' : 'MSPointerUp',
	                    delegate.pointerupcaptured,
	                    true
	                );
	                $.removeEvent(
	                    $.MouseTracker.captureElement,
	                    'touchmove',
	                    delegate.touchmovecaptured,
	                    true
	                );
	                $.removeEvent(
	                    $.MouseTracker.captureElement,
	                    'touchend',
	                    delegate.touchendcaptured,
	                    true
	                );
	
	                delegate.activePointersLists[ i ].captureCount = 0;
	            }
	        }
	
	        for ( i = 0; i < pointerListCount; i++ ) {
	            delegate.activePointersLists.pop();
	        }
	    }
	
	    /**
	     * Starts tracking pointer events on the tracked element.
	     * @private
	     * @inner
	     */
	    function startTracking( tracker ) {
	        var delegate = THIS[ tracker.hash ],
	            event,
	            i;
	
	        if ( !delegate.tracking ) {
	            for ( i = 0; i < $.MouseTracker.subscribeEvents.length; i++ ) {
	                event = $.MouseTracker.subscribeEvents[ i ];
	                $.addEvent(
	                    tracker.element,
	                    event,
	                    delegate[ event ],
	                    false
	                );
	            }
	
	            clearTrackedPointers( tracker );
	
	            delegate.tracking = true;
	        }
	    }
	
	    /**
	     * Stops tracking pointer events on the tracked element.
	     * @private
	     * @inner
	     */
	    function stopTracking( tracker ) {
	        var delegate = THIS[ tracker.hash ],
	            event,
	            i;
	
	        if ( delegate.tracking ) {
	            for ( i = 0; i < $.MouseTracker.subscribeEvents.length; i++ ) {
	                event = $.MouseTracker.subscribeEvents[ i ];
	                $.removeEvent(
	                    tracker.element,
	                    event,
	                    delegate[ event ],
	                    false
	                );
	            }
	
	            clearTrackedPointers( tracker );
	
	            delegate.tracking = false;
	        }
	    }
	
	    /**
	     * @private
	     * @inner
	     */
	    function getCaptureEventParams( tracker, pointerType ) {
	        var delegate = THIS[ tracker.hash ];
	
	        if ( pointerType === 'pointerevent' ) {
	            return {
	                upName: $.MouseTracker.unprefixedPointerEvents ? 'pointerup' : 'MSPointerUp',
	                upHandler: delegate.pointerupcaptured,
	                moveName: $.MouseTracker.unprefixedPointerEvents ? 'pointermove' : 'MSPointerMove',
	                moveHandler: delegate.pointermovecaptured
	            };
	        } else if ( pointerType === 'mouse' ) {
	            return {
	                upName: 'mouseup',
	                upHandler: delegate.mouseupcaptured,
	                moveName: 'mousemove',
	                moveHandler: delegate.mousemovecaptured
	            };
	        } else if ( pointerType === 'touch' ) {
	            return {
	                upName: 'touchend',
	                upHandler: delegate.touchendcaptured,
	                moveName: 'touchmove',
	                moveHandler: delegate.touchmovecaptured
	            };
	        } else {
	            throw new Error( "MouseTracker.getCaptureEventParams: Unknown pointer type." );
	        }
	    }
	
	    /**
	     * Begin capturing pointer events to the tracked element.
	     * @private
	     * @inner
	     */
	    function capturePointer( tracker, pointerType, pointerCount ) {
	        var pointsList = tracker.getActivePointersListByType( pointerType ),
	            eventParams;
	
	        pointsList.captureCount += (pointerCount || 1);
	
	        if ( pointsList.captureCount === 1 ) {
	            if ( $.Browser.vendor === $.BROWSERS.IE && $.Browser.version < 9 ) {
	                tracker.element.setCapture( true );
	            } else {
	                eventParams = getCaptureEventParams( tracker, $.MouseTracker.havePointerEvents ? 'pointerevent' : pointerType );
	                // We emulate mouse capture by hanging listeners on the document object.
	                //    (Note we listen on the capture phase so the captured handlers will get called first)
	                // eslint-disable-next-line no-use-before-define
	                if (isInIframe && canAccessEvents(window.top)) {
	                    $.addEvent(
	                        window.top,
	                        eventParams.upName,
	                        eventParams.upHandler,
	                        true
	                    );
	                }
	                $.addEvent(
	                    $.MouseTracker.captureElement,
	                    eventParams.upName,
	                    eventParams.upHandler,
	                    true
	                );
	                $.addEvent(
	                    $.MouseTracker.captureElement,
	                    eventParams.moveName,
	                    eventParams.moveHandler,
	                    true
	                );
	            }
	        }
	    }
	
	
	    /**
	     * Stop capturing pointer events to the tracked element.
	     * @private
	     * @inner
	     */
	    function releasePointer( tracker, pointerType, pointerCount ) {
	        var pointsList = tracker.getActivePointersListByType( pointerType ),
	            eventParams;
	
	        pointsList.captureCount -= (pointerCount || 1);
	
	        if ( pointsList.captureCount === 0 ) {
	            if ( $.Browser.vendor === $.BROWSERS.IE && $.Browser.version < 9 ) {
	                tracker.element.releaseCapture();
	            } else {
	                eventParams = getCaptureEventParams( tracker, $.MouseTracker.havePointerEvents ? 'pointerevent' : pointerType );
	                // We emulate mouse capture by hanging listeners on the document object.
	                //    (Note we listen on the capture phase so the captured handlers will get called first)
	                // eslint-disable-next-line no-use-before-define
	                if (isInIframe && canAccessEvents(window.top)) {
	                    $.removeEvent(
	                        window.top,
	                        eventParams.upName,
	                        eventParams.upHandler,
	                        true
	                    );
	                }
	                $.removeEvent(
	                    $.MouseTracker.captureElement,
	                    eventParams.moveName,
	                    eventParams.moveHandler,
	                    true
	                );
	                $.removeEvent(
	                    $.MouseTracker.captureElement,
	                    eventParams.upName,
	                    eventParams.upHandler,
	                    true
	                );
	            }
	        }
	    }
	
	
	    /**
	     * Gets a W3C Pointer Events model compatible pointer type string from a DOM pointer event.
	     * IE10 used a long integer value, but the W3C specification (and IE11+) use a string "mouse", "touch", "pen", etc.
	     * @private
	     * @inner
	     */
	    function getPointerType( event ) {
	        var pointerTypeStr;
	        if ( $.MouseTracker.unprefixedPointerEvents ) {
	            pointerTypeStr = event.pointerType;
	        } else {
	            // IE10
	            //  MSPOINTER_TYPE_TOUCH: 0x00000002
	            //  MSPOINTER_TYPE_PEN:   0x00000003
	            //  MSPOINTER_TYPE_MOUSE: 0x00000004
	            switch( event.pointerType )
	            {
	                case 0x00000002:
	                    pointerTypeStr = 'touch';
	                    break;
	                case 0x00000003:
	                    pointerTypeStr = 'pen';
	                    break;
	                case 0x00000004:
	                    pointerTypeStr = 'mouse';
	                    break;
	                default:
	                    pointerTypeStr = '';
	            }
	        }
	        return pointerTypeStr;
	    }
	
	
	    /**
	     * @private
	     * @inner
	     */
	    function getMouseAbsolute( event ) {
	        return $.getMousePosition( event );
	    }
	
	    /**
	     * @private
	     * @inner
	     */
	    function getMouseRelative( event, element ) {
	        return getPointRelativeToAbsolute( getMouseAbsolute( event ), element );
	    }
	
	    /**
	     * @private
	     * @inner
	     */
	    function getPointRelativeToAbsolute( point, element ) {
	        var offset = $.getElementOffset( element );
	        return point.minus( offset );
	    }
	
	    /**
	     * @private
	     * @inner
	     */
	    function getCenterPoint( point1, point2 ) {
	        return new $.Point( ( point1.x + point2.x ) / 2, ( point1.y + point2.y ) / 2 );
	    }
	
	
	///////////////////////////////////////////////////////////////////////////////
	// Device-specific DOM event handlers
	///////////////////////////////////////////////////////////////////////////////
	
	    /**
	     * @private
	     * @inner
	     */
	    function onClick( tracker, event ) {
	        if ( tracker.clickHandler ) {
	            $.cancelEvent( event );
	        }
	    }
	
	
	    /**
	     * @private
	     * @inner
	     */
	    function onDblClick( tracker, event ) {
	        if ( tracker.dblClickHandler ) {
	            $.cancelEvent( event );
	        }
	    }
	
	
	    /**
	     * @private
	     * @inner
	     */
	    function onKeyDown( tracker, event ) {
	        //$.console.log( "keydown %s %s %s %s %s", event.keyCode, event.charCode, event.ctrlKey, event.shiftKey, event.altKey );
	        var propagate;
	        if ( tracker.keyDownHandler ) {
	            event = $.getEvent( event );
	            propagate = tracker.keyDownHandler(
	                {
	                    eventSource:          tracker,
	                    keyCode:              event.keyCode ? event.keyCode : event.charCode,
	                    ctrl:                 event.ctrlKey,
	                    shift:                event.shiftKey,
	                    alt:                  event.altKey,
	                    meta:                 event.metaKey,
	                    originalEvent:        event,
	                    preventDefaultAction: false,
	                    userData:             tracker.userData
	                }
	            );
	            if ( !propagate ) {
	                $.cancelEvent( event );
	            }
	        }
	    }
	
	
	    /**
	     * @private
	     * @inner
	     */
	    function onKeyUp( tracker, event ) {
	        //$.console.log( "keyup %s %s %s %s %s", event.keyCode, event.charCode, event.ctrlKey, event.shiftKey, event.altKey );
	        var propagate;
	        if ( tracker.keyUpHandler ) {
	            event = $.getEvent( event );
	            propagate = tracker.keyUpHandler(
	                {
	                    eventSource:          tracker,
	                    keyCode:              event.keyCode ? event.keyCode : event.charCode,
	                    ctrl:                 event.ctrlKey,
	                    shift:                event.shiftKey,
	                    alt:                  event.altKey,
	                    meta:                 event.metaKey,
	                    originalEvent:        event,
	                    preventDefaultAction: false,
	                    userData:             tracker.userData
	                }
	            );
	            if ( !propagate ) {
	                $.cancelEvent( event );
	            }
	        }
	    }
	
	
	    /**
	     * @private
	     * @inner
	     */
	    function onKeyPress( tracker, event ) {
	        //$.console.log( "keypress %s %s %s %s %s", event.keyCode, event.charCode, event.ctrlKey, event.shiftKey, event.altKey );
	        var propagate;
	        if ( tracker.keyHandler ) {
	            event = $.getEvent( event );
	            propagate = tracker.keyHandler(
	                {
	                    eventSource:          tracker,
	                    keyCode:              event.keyCode ? event.keyCode : event.charCode,
	                    ctrl:                 event.ctrlKey,
	                    shift:                event.shiftKey,
	                    alt:                  event.altKey,
	                    meta:                 event.metaKey,
	                    originalEvent:        event,
	                    preventDefaultAction: false,
	                    userData:             tracker.userData
	                }
	            );
	            if ( !propagate ) {
	                $.cancelEvent( event );
	            }
	        }
	    }
	
	
	    /**
	     * @private
	     * @inner
	     */
	    function onFocus( tracker, event ) {
	        //console.log( "focus %s", event );
	        var propagate;
	        if ( tracker.focusHandler ) {
	            event = $.getEvent( event );
	            propagate = tracker.focusHandler(
	                {
	                    eventSource:          tracker,
	                    originalEvent:        event,
	                    preventDefaultAction: false,
	                    userData:             tracker.userData
	                }
	            );
	            if ( propagate === false ) {
	                $.cancelEvent( event );
	            }
	        }
	    }
	
	
	    /**
	     * @private
	     * @inner
	     */
	    function onBlur( tracker, event ) {
	        //console.log( "blur %s", event );
	        var propagate;
	        if ( tracker.blurHandler ) {
	            event = $.getEvent( event );
	            propagate = tracker.blurHandler(
	                {
	                    eventSource:          tracker,
	                    originalEvent:        event,
	                    preventDefaultAction: false,
	                    userData:             tracker.userData
	                }
	            );
	            if ( propagate === false ) {
	                $.cancelEvent( event );
	            }
	        }
	    }
	
	
	    /**
	     * Handler for 'wheel' events
	     *
	     * @private
	     * @inner
	     */
	    function onWheel( tracker, event ) {
	        handleWheelEvent( tracker, event, event );
	    }
	
	
	    /**
	     * Handler for 'mousewheel', 'DOMMouseScroll', and 'MozMousePixelScroll' events
	     *
	     * @private
	     * @inner
	     */
	    function onMouseWheel( tracker, event ) {
	        event = $.getEvent( event );
	
	        // Simulate a 'wheel' event
	        var simulatedEvent = {
	            target:     event.target || event.srcElement,
	            type:       "wheel",
	            shiftKey:   event.shiftKey || false,
	            clientX:    event.clientX,
	            clientY:    event.clientY,
	            pageX:      event.pageX ? event.pageX : event.clientX,
	            pageY:      event.pageY ? event.pageY : event.clientY,
	            deltaMode:  event.type == "MozMousePixelScroll" ? 0 : 1, // 0=pixel, 1=line, 2=page
	            deltaX:     0,
	            deltaZ:     0
	        };
	
	        // Calculate deltaY
	        if ( $.MouseTracker.wheelEventName == "mousewheel" ) {
	            simulatedEvent.deltaY = -event.wheelDelta / $.DEFAULT_SETTINGS.pixelsPerWheelLine;
	        } else {
	            simulatedEvent.deltaY = event.detail;
	        }
	
	        handleWheelEvent( tracker, simulatedEvent, event );
	    }
	
	
	    /**
	     * Handles 'wheel' events.
	     * The event may be simulated by the legacy mouse wheel event handler (onMouseWheel()).
	     *
	     * @private
	     * @inner
	     */
	    function handleWheelEvent( tracker, event, originalEvent ) {
	        var nDelta = 0,
	            propagate;
	
	        // The nDelta variable is gated to provide smooth z-index scrolling
	        //   since the mouse wheel allows for substantial deltas meant for rapid
	        //   y-index scrolling.
	        // event.deltaMode: 0=pixel, 1=line, 2=page
	        // TODO: Deltas in pixel mode should be accumulated then a scroll value computed after $.DEFAULT_SETTINGS.pixelsPerWheelLine threshold reached
	        nDelta = event.deltaY < 0 ? 1 : -1;
	
	        if ( tracker.scrollHandler ) {
	            propagate = tracker.scrollHandler(
	                {
	                    eventSource:          tracker,
	                    pointerType:          'mouse',
	                    position:             getMouseRelative( event, tracker.element ),
	                    scroll:               nDelta,
	                    shift:                event.shiftKey,
	                    isTouchEvent:         false,
	                    originalEvent:        originalEvent,
	                    preventDefaultAction: false,
	                    userData:             tracker.userData
	                }
	            );
	            if ( propagate === false ) {
	                $.cancelEvent( originalEvent );
	            }
	        }
	    }
	
	
	    /**
	     * @private
	     * @inner
	     */
	    function isParentChild( parent, child )
	    {
	       if ( parent === child ) {
	           return false;
	       }
	       while ( child && child !== parent ) {
	           child = child.parentNode;
	       }
	       return child === parent;
	    }
	
	
	    /**
	     * Only used on IE 8
	     *
	     * @private
	     * @inner
	     */
	    function onMouseEnter( tracker, event ) {
	        event = $.getEvent( event );
	
	        handleMouseEnter( tracker, event );
	    }
	
	
	    /**
	     * @private
	     * @inner
	     */
	    function onMouseOver( tracker, event ) {
	        event = $.getEvent( event );
	
	        if ( event.currentTarget === event.relatedTarget || isParentChild( event.currentTarget, event.relatedTarget ) ) {
	            return;
	        }
	
	        handleMouseEnter( tracker, event );
	    }
	
	
	    /**
	     * @private
	     * @inner
	     */
	    function handleMouseEnter( tracker, event ) {
	        var gPoint = {
	            id: $.MouseTracker.mousePointerId,
	            type: 'mouse',
	            isPrimary: true,
	            currentPos: getMouseAbsolute( event ),
	            currentTime: $.now()
	        };
	
	        updatePointersEnter( tracker, event, [ gPoint ] );
	    }
	
	
	    /**
	     * Only used on IE 8
	     *
	     * @private
	     * @inner
	     */
	    function onMouseLeave( tracker, event ) {
	        event = $.getEvent( event );
	
	        handleMouseExit( tracker, event );
	    }
	
	
	    /**
	     * @private
	     * @inner
	     */
	    function onMouseOut( tracker, event ) {
	        event = $.getEvent( event );
	
	        if ( event.currentTarget === event.relatedTarget || isParentChild( event.currentTarget, event.relatedTarget ) ) {
	            return;
	        }
	
	        handleMouseExit( tracker, event );
	    }
	
	
	    /**
	     * @private
	     * @inner
	     */
	    function handleMouseExit( tracker, event ) {
	        var gPoint = {
	            id: $.MouseTracker.mousePointerId,
	            type: 'mouse',
	            isPrimary: true,
	            currentPos: getMouseAbsolute( event ),
	            currentTime: $.now()
	        };
	
	        updatePointersExit( tracker, event, [ gPoint ] );
	    }
	
	
	    /**
	     * Returns a W3C DOM level 3 standard button value given an event.button property:
	     *   -1 == none, 0 == primary/left, 1 == middle, 2 == secondary/right, 3 == X1/back, 4 == X2/forward, 5 == eraser (pen)
	     * @private
	     * @inner
	     */
	    function getStandardizedButton( button ) {
	        if ( $.Browser.vendor === $.BROWSERS.IE && $.Browser.version < 9 ) {
	            // On IE 8, 0 == none, 1 == left, 2 == right, 3 == left and right, 4 == middle, 5 == left and middle, 6 == right and middle, 7 == all three
	            // TODO: Support chorded (multiple) button presses on IE 8?
	            if ( button === 1 ) {
	                return 0;
	            } else if ( button === 2 ) {
	                return 2;
	            } else if ( button === 4 ) {
	                return 1;
	            } else {
	                return -1;
	            }
	        } else {
	            return button;
	        }
	    }
	
	
	    /**
	     * @private
	     * @inner
	     */
	    function onMouseDown( tracker, event ) {
	        var gPoint;
	
	        event = $.getEvent( event );
	
	        gPoint = {
	            id: $.MouseTracker.mousePointerId,
	            type: 'mouse',
	            isPrimary: true,
	            currentPos: getMouseAbsolute( event ),
	            currentTime: $.now()
	        };
	
	        if ( updatePointersDown( tracker, event, [ gPoint ], getStandardizedButton( event.button ) ) ) {
	            $.stopEvent( event );
	            capturePointer( tracker, 'mouse' );
	        }
	
	        if ( tracker.clickHandler || tracker.dblClickHandler || tracker.pressHandler || tracker.dragHandler || tracker.dragEndHandler ) {
	            $.cancelEvent( event );
	        }
	    }
	
	
	    /**
	     * @private
	     * @inner
	     */
	    function onMouseUp( tracker, event ) {
	        handleMouseUp( tracker, event );
	    }
	
	    /**
	     * This handler is attached to the window object (on the capture phase) to emulate mouse capture.
	     * onMouseUp is still attached to the tracked element, so stop propagation to avoid processing twice.
	     *
	     * @private
	     * @inner
	     */
	    function onMouseUpCaptured( tracker, event ) {
	        handleMouseUp( tracker, event );
	        $.stopEvent( event );
	    }
	
	
	    /**
	     * @private
	     * @inner
	     */
	    function handleMouseUp( tracker, event ) {
	        var gPoint;
	
	        event = $.getEvent( event );
	
	        gPoint = {
	            id: $.MouseTracker.mousePointerId,
	            type: 'mouse',
	            isPrimary: true,
	            currentPos: getMouseAbsolute( event ),
	            currentTime: $.now()
	        };
	
	        if ( updatePointersUp( tracker, event, [ gPoint ], getStandardizedButton( event.button ) ) ) {
	            releasePointer( tracker, 'mouse' );
	        }
	    }
	
	
	    /**
	     * @private
	     * @inner
	     */
	    function onMouseMove( tracker, event ) {
	        handleMouseMove( tracker, event );
	   }
	
	
	    /**
	     * This handler is attached to the window object (on the capture phase) to emulate mouse capture.
	     * onMouseMove is still attached to the tracked element, so stop propagation to avoid processing twice.
	     *
	     * @private
	     * @inner
	     */
	    function onMouseMoveCaptured( tracker, event ) {
	        handleMouseMove( tracker, event );
	        $.stopEvent( event );
	    }
	
	
	    /**
	     * @private
	     * @inner
	     */
	    function handleMouseMove( tracker, event ) {
	        var gPoint;
	
	        event = $.getEvent( event );
	
	        gPoint = {
	            id: $.MouseTracker.mousePointerId,
	            type: 'mouse',
	            isPrimary: true,
	            currentPos: getMouseAbsolute( event ),
	            currentTime: $.now()
	        };
	
	        updatePointersMove( tracker, event, [ gPoint ] );
	    }
	
	
	    /**
	     * @private
	     * @inner
	     */
	    function abortContacts( tracker, event, pointsList ) {
	        var i,
	            gPointCount = pointsList.getLength(),
	            abortGPoints = [];
	
	        // Check contact count for hoverable pointer types before aborting
	        if (pointsList.type === 'touch' || pointsList.contacts > 0) {
	            for ( i = 0; i < gPointCount; i++ ) {
	                abortGPoints.push( pointsList.getByIndex( i ) );
	            }
	
	            if ( abortGPoints.length > 0 ) {
	                // simulate touchend/mouseup
	                updatePointersUp( tracker, event, abortGPoints, 0 ); // 0 means primary button press/release or touch contact
	                // release pointer capture
	                pointsList.captureCount = 1;
	                releasePointer( tracker, pointsList.type );
	                // simulate touchleave/mouseout
	                updatePointersExit( tracker, event, abortGPoints );
	            }
	        }
	    }
	
	
	    /**
	     * @private
	     * @inner
	     */
	    function onTouchStart( tracker, event ) {
	        var time,
	            i,
	            j,
	            touchCount = event.changedTouches.length,
	            gPoints = [],
	            parentGPoints,
	            pointsList = tracker.getActivePointersListByType( 'touch' );
	
	        time = $.now();
	
	        if ( pointsList.getLength() > event.touches.length - touchCount ) {
	            $.console.warn('Tracked touch contact count doesn\'t match event.touches.length. Removing all tracked touch pointers.');
	            abortContacts( tracker, event, pointsList );
	        }
	
	        for ( i = 0; i < touchCount; i++ ) {
	            gPoints.push( {
	                id: event.changedTouches[ i ].identifier,
	                type: 'touch',
	                // isPrimary not set - let the updatePointers functions determine it
	                currentPos: getMouseAbsolute( event.changedTouches[ i ] ),
	                currentTime: time
	            } );
	        }
	
	        // simulate touchenter on our tracked element
	        updatePointersEnter( tracker, event, gPoints );
	
	        // simulate touchenter on our tracked element's tracked ancestor elements
	        for ( i = 0; i < MOUSETRACKERS.length; i++ ) {
	            if ( MOUSETRACKERS[ i ] !== tracker && MOUSETRACKERS[ i ].isTracking() && isParentChild( MOUSETRACKERS[ i ].element, tracker.element ) ) {
	                parentGPoints = [];
	                for ( j = 0; j < touchCount; j++ ) {
	                    parentGPoints.push( {
	                        id: event.changedTouches[ j ].identifier,
	                        type: 'touch',
	                        // isPrimary not set - let the updatePointers functions determine it
	                        currentPos: getMouseAbsolute( event.changedTouches[ j ] ),
	                        currentTime: time
	                    } );
	                }
	                updatePointersEnter( MOUSETRACKERS[ i ], event, parentGPoints );
	            }
	        }
	
	        if ( updatePointersDown( tracker, event, gPoints, 0 ) ) { // 0 means primary button press/release or touch contact
	            $.stopEvent( event );
	            capturePointer( tracker, 'touch', touchCount );
	        }
	
	        $.cancelEvent( event );
	    }
	
	
	    /**
	     * @private
	     * @inner
	     */
	    function onTouchEnd( tracker, event ) {
	        handleTouchEnd( tracker, event );
	    }
	
	
	    /**
	     * This handler is attached to the window object (on the capture phase) to emulate pointer capture.
	     * onTouchEnd is still attached to the tracked element, so stop propagation to avoid processing twice.
	     *
	     * @private
	     * @inner
	     */
	    function onTouchEndCaptured( tracker, event ) {
	        handleTouchEnd( tracker, event );
	        $.stopEvent( event );
	    }
	
	
	    /**
	     * @private
	     * @inner
	     */
	    function handleTouchEnd( tracker, event ) {
	        var time,
	            i,
	            j,
	            touchCount = event.changedTouches.length,
	            gPoints = [],
	            parentGPoints;
	
	        time = $.now();
	
	        for ( i = 0; i < touchCount; i++ ) {
	            gPoints.push( {
	                id: event.changedTouches[ i ].identifier,
	                type: 'touch',
	                // isPrimary not set - let the updatePointers functions determine it
	                currentPos: getMouseAbsolute( event.changedTouches[ i ] ),
	                currentTime: time
	            } );
	        }
	
	        if ( updatePointersUp( tracker, event, gPoints, 0 ) ) {
	            releasePointer( tracker, 'touch', touchCount );
	        }
	
	        // simulate touchleave on our tracked element
	        updatePointersExit( tracker, event, gPoints );
	
	        // simulate touchleave on our tracked element's tracked ancestor elements
	        for ( i = 0; i < MOUSETRACKERS.length; i++ ) {
	            if ( MOUSETRACKERS[ i ] !== tracker && MOUSETRACKERS[ i ].isTracking() && isParentChild( MOUSETRACKERS[ i ].element, tracker.element ) ) {
	                parentGPoints = [];
	                for ( j = 0; j < touchCount; j++ ) {
	                    parentGPoints.push( {
	                        id: event.changedTouches[ j ].identifier,
	                        type: 'touch',
	                        // isPrimary not set - let the updatePointers functions determine it
	                        currentPos: getMouseAbsolute( event.changedTouches[ j ] ),
	                        currentTime: time
	                    } );
	                }
	                updatePointersExit( MOUSETRACKERS[ i ], event, parentGPoints );
	            }
	        }
	
	        $.cancelEvent( event );
	    }
	
	
	    /**
	     * @private
	     * @inner
	     */
	    function onTouchMove( tracker, event ) {
	        handleTouchMove( tracker, event );
	    }
	
	
	    /**
	     * This handler is attached to the window object (on the capture phase) to emulate pointer capture.
	     * onTouchMove is still attached to the tracked element, so stop propagation to avoid processing twice.
	     *
	     * @private
	     * @inner
	     */
	    function onTouchMoveCaptured( tracker, event ) {
	        handleTouchMove( tracker, event );
	        $.stopEvent( event );
	    }
	
	
	    /**
	     * @private
	     * @inner
	     */
	    function handleTouchMove( tracker, event ) {
	        var i,
	            touchCount = event.changedTouches.length,
	            gPoints = [];
	
	        for ( i = 0; i < touchCount; i++ ) {
	            gPoints.push( {
	                id: event.changedTouches[ i ].identifier,
	                type: 'touch',
	                // isPrimary not set - let the updatePointers functions determine it
	                currentPos: getMouseAbsolute( event.changedTouches[ i ] ),
	                currentTime: $.now()
	            } );
	        }
	
	        updatePointersMove( tracker, event, gPoints );
	
	        $.cancelEvent( event );
	    }
	
	
	    /**
	     * @private
	     * @inner
	     */
	    function onTouchCancel( tracker, event ) {
	        var pointsList = tracker.getActivePointersListByType('touch');
	
	        abortContacts( tracker, event, pointsList );
	    }
	
	
	    /**
	     * @private
	     * @inner
	     */
	    function onGestureStart( tracker, event ) {
	        event.stopPropagation();
	        event.preventDefault();
	        return false;
	    }
	
	
	    /**
	     * @private
	     * @inner
	     */
	    function onGestureChange( tracker, event ) {
	        event.stopPropagation();
	        event.preventDefault();
	        return false;
	    }
	
	
	    /**
	     * @private
	     * @inner
	     */
	    function onPointerOver( tracker, event ) {
	        var gPoint;
	
	        if ( event.currentTarget === event.relatedTarget || isParentChild( event.currentTarget, event.relatedTarget ) ) {
	            return;
	        }
	
	        gPoint = {
	            id: event.pointerId,
	            type: getPointerType( event ),
	            isPrimary: event.isPrimary,
	            currentPos: getMouseAbsolute( event ),
	            currentTime: $.now()
	        };
	
	        updatePointersEnter( tracker, event, [ gPoint ] );
	    }
	
	
	    /**
	     * @private
	     * @inner
	     */
	    function onPointerOut( tracker, event ) {
	        var gPoint;
	
	        if ( event.currentTarget === event.relatedTarget || isParentChild( event.currentTarget, event.relatedTarget ) ) {
	            return;
	        }
	
	        gPoint = {
	            id: event.pointerId,
	            type: getPointerType( event ),
	            isPrimary: event.isPrimary,
	            currentPos: getMouseAbsolute( event ),
	            currentTime: $.now()
	        };
	
	        updatePointersExit( tracker, event, [ gPoint ] );
	    }
	
	
	    /**
	     * @private
	     * @inner
	     */
	    function onPointerDown( tracker, event ) {
	        var gPoint;
	
	        gPoint = {
	            id: event.pointerId,
	            type: getPointerType( event ),
	            isPrimary: event.isPrimary,
	            currentPos: getMouseAbsolute( event ),
	            currentTime: $.now()
	        };
	
	        if ( updatePointersDown( tracker, event, [ gPoint ], event.button ) ) {
	            $.stopEvent( event );
	            capturePointer( tracker, gPoint.type );
	        }
	
	        if ( tracker.clickHandler || tracker.dblClickHandler || tracker.pressHandler || tracker.dragHandler || tracker.dragEndHandler || tracker.pinchHandler ) {
	            $.cancelEvent( event );
	        }
	    }
	
	
	    /**
	     * @private
	     * @inner
	     */
	    function onPointerUp( tracker, event ) {
	        handlePointerUp( tracker, event );
	    }
	
	
	    /**
	     * This handler is attached to the window object (on the capture phase) to emulate mouse capture.
	     * onPointerUp is still attached to the tracked element, so stop propagation to avoid processing twice.
	     *
	     * @private
	     * @inner
	     */
	    function onPointerUpCaptured( tracker, event ) {
	        var pointsList = tracker.getActivePointersListByType( getPointerType( event ) );
	        if ( pointsList.getById( event.pointerId ) ) {
	            handlePointerUp( tracker, event );
	        }
	        $.stopEvent( event );
	    }
	
	
	    /**
	     * @private
	     * @inner
	     */
	    function handlePointerUp( tracker, event ) {
	        var gPoint;
	
	        gPoint = {
	            id: event.pointerId,
	            type: getPointerType( event ),
	            isPrimary: event.isPrimary,
	            currentPos: getMouseAbsolute( event ),
	            currentTime: $.now()
	        };
	
	        if ( updatePointersUp( tracker, event, [ gPoint ], event.button ) ) {
	            releasePointer( tracker, gPoint.type );
	        }
	    }
	
	
	    /**
	     * @private
	     * @inner
	     */
	    function onPointerMove( tracker, event ) {
	        handlePointerMove( tracker, event );
	    }
	
	
	    /**
	     * This handler is attached to the window object (on the capture phase) to emulate mouse capture.
	     * onPointerMove is still attached to the tracked element, so stop propagation to avoid processing twice.
	     *
	     * @private
	     * @inner
	     */
	    function onPointerMoveCaptured( tracker, event ) {
	        var pointsList = tracker.getActivePointersListByType( getPointerType( event ) );
	        if ( pointsList.getById( event.pointerId ) ) {
	            handlePointerMove( tracker, event );
	        }
	        $.stopEvent( event );
	    }
	
	
	    /**
	     * @private
	     * @inner
	     */
	    function handlePointerMove( tracker, event ) {
	        // Pointer changed coordinates, button state, pressure, tilt, or contact geometry (e.g. width and height)
	        var gPoint;
	
	        gPoint = {
	            id: event.pointerId,
	            type: getPointerType( event ),
	            isPrimary: event.isPrimary,
	            currentPos: getMouseAbsolute( event ),
	            currentTime: $.now()
	        };
	
	        updatePointersMove( tracker, event, [ gPoint ] );
	    }
	
	
	    /**
	     * @private
	     * @inner
	     */
	    function onPointerCancel( tracker, event ) {
	        var gPoint;
	
	        gPoint = {
	            id: event.pointerId,
	            type: getPointerType( event )
	        };
	
	        updatePointersCancel( tracker, event, [ gPoint ] );
	    }
	
	
	///////////////////////////////////////////////////////////////////////////////
	// Device-agnostic DOM event handlers
	///////////////////////////////////////////////////////////////////////////////
	
	    /**
	     * @function
	     * @private
	     * @inner
	     * @param {OpenSeadragon.MouseTracker.GesturePointList} pointsList
	     *     The GesturePointList to track the pointer in.
	     * @param {OpenSeadragon.MouseTracker.GesturePoint} gPoint
	     *      Gesture point to track.
	     * @returns {Number} Number of gesture points in pointsList.
	     */
	    function startTrackingPointer( pointsList, gPoint ) {
	
	        // If isPrimary is not known for the pointer then set it according to our rules:
	        //    true if the first pointer in the gesture, otherwise false
	        if ( !gPoint.hasOwnProperty( 'isPrimary' ) ) {
	            if ( pointsList.getLength() === 0 ) {
	                gPoint.isPrimary = true;
	            } else {
	                gPoint.isPrimary = false;
	            }
	        }
	        gPoint.speed = 0;
	        gPoint.direction = 0;
	        gPoint.contactPos = gPoint.currentPos;
	        gPoint.contactTime = gPoint.currentTime;
	        gPoint.lastPos = gPoint.currentPos;
	        gPoint.lastTime = gPoint.currentTime;
	
	        return pointsList.add( gPoint );
	    }
	
	
	    /**
	     * @function
	     * @private
	     * @inner
	     * @param {OpenSeadragon.MouseTracker.GesturePointList} pointsList
	     *     The GesturePointList to stop tracking the pointer on.
	     * @param {OpenSeadragon.MouseTracker.GesturePoint} gPoint
	     *      Gesture point to stop tracking.
	     * @returns {Number} Number of gesture points in pointsList.
	     */
	    function stopTrackingPointer( pointsList, gPoint ) {
	        var listLength,
	            primaryPoint;
	
	        if ( pointsList.getById( gPoint.id ) ) {
	            listLength = pointsList.removeById( gPoint.id );
	
	            // If isPrimary is not known for the pointer and we just removed the primary pointer from the list then we need to set another pointer as primary
	            if ( !gPoint.hasOwnProperty( 'isPrimary' ) ) {
	                primaryPoint = pointsList.getPrimary();
	                if ( !primaryPoint ) {
	                    primaryPoint = pointsList.getByIndex( 0 );
	                    if ( primaryPoint ) {
	                        primaryPoint.isPrimary = true;
	                    }
	                }
	            }
	        } else {
	            listLength = pointsList.getLength();
	        }
	
	        return listLength;
	    }
	
	
	    /**
	     * @function
	     * @private
	     * @inner
	     * @param {OpenSeadragon.MouseTracker} tracker
	     *     A reference to the MouseTracker instance.
	     * @param {Object} event
	     *     A reference to the originating DOM event.
	     * @param {Array.<OpenSeadragon.MouseTracker.GesturePoint>} gPoints
	     *      Gesture points associated with the event.
	     */
	    function updatePointersEnter( tracker, event, gPoints ) {
	        var pointsList = tracker.getActivePointersListByType( gPoints[ 0 ].type ),
	            i,
	            gPointCount = gPoints.length,
	            curGPoint,
	            updateGPoint,
	            propagate;
	
	        for ( i = 0; i < gPointCount; i++ ) {
	            curGPoint = gPoints[ i ];
	            updateGPoint = pointsList.getById( curGPoint.id );
	
	            if ( updateGPoint ) {
	                // Already tracking the pointer...update it
	                updateGPoint.insideElement = true;
	                updateGPoint.lastPos = updateGPoint.currentPos;
	                updateGPoint.lastTime = updateGPoint.currentTime;
	                updateGPoint.currentPos = curGPoint.currentPos;
	                updateGPoint.currentTime = curGPoint.currentTime;
	
	                curGPoint = updateGPoint;
	            } else {
	                // Initialize for tracking and add to the tracking list
	                curGPoint.captured = false;
	                curGPoint.insideElementPressed = false;
	                curGPoint.insideElement = true;
	                startTrackingPointer( pointsList, curGPoint );
	            }
	
	            // Enter
	            if ( tracker.enterHandler ) {
	                propagate = tracker.enterHandler(
	                    {
	                        eventSource:          tracker,
	                        pointerType:          curGPoint.type,
	                        position:             getPointRelativeToAbsolute( curGPoint.currentPos, tracker.element ),
	                        buttons:              pointsList.buttons,
	                        pointers:             tracker.getActivePointerCount(),
	                        insideElementPressed: curGPoint.insideElementPressed,
	                        buttonDownAny:        pointsList.buttons !== 0,
	                        isTouchEvent:         curGPoint.type === 'touch',
	                        originalEvent:        event,
	                        preventDefaultAction: false,
	                        userData:             tracker.userData
	                    }
	                );
	                if ( propagate === false ) {
	                    $.cancelEvent( event );
	                }
	            }
	        }
	    }
	
	
	    /**
	     * @function
	     * @private
	     * @inner
	     * @param {OpenSeadragon.MouseTracker} tracker
	     *     A reference to the MouseTracker instance.
	     * @param {Object} event
	     *     A reference to the originating DOM event.
	     * @param {Array.<OpenSeadragon.MouseTracker.GesturePoint>} gPoints
	     *      Gesture points associated with the event.
	     */
	    function updatePointersExit( tracker, event, gPoints ) {
	        var pointsList = tracker.getActivePointersListByType(gPoints[0].type),
	            i,
	            gPointCount = gPoints.length,
	            curGPoint,
	            updateGPoint,
	            propagate;
	
	        for ( i = 0; i < gPointCount; i++ ) {
	            curGPoint = gPoints[ i ];
	            updateGPoint = pointsList.getById( curGPoint.id );
	
	            if ( updateGPoint ) {
	                // Already tracking the pointer. If captured then update it, else stop tracking it
	                if ( updateGPoint.captured ) {
	                    updateGPoint.insideElement = false;
	                    updateGPoint.lastPos = updateGPoint.currentPos;
	                    updateGPoint.lastTime = updateGPoint.currentTime;
	                    updateGPoint.currentPos = curGPoint.currentPos;
	                    updateGPoint.currentTime = curGPoint.currentTime;
	                } else {
	                    stopTrackingPointer( pointsList, updateGPoint );
	                }
	
	                curGPoint = updateGPoint;
	            }
	
	            // Exit
	            if ( tracker.exitHandler ) {
	                propagate = tracker.exitHandler(
	                    {
	                        eventSource:          tracker,
	                        pointerType:          curGPoint.type,
	                        position:             getPointRelativeToAbsolute( curGPoint.currentPos, tracker.element ),
	                        buttons:              pointsList.buttons,
	                        pointers:             tracker.getActivePointerCount(),
	                        insideElementPressed: updateGPoint ? updateGPoint.insideElementPressed : false,
	                        buttonDownAny:        pointsList.buttons !== 0,
	                        isTouchEvent:         curGPoint.type === 'touch',
	                        originalEvent:        event,
	                        preventDefaultAction: false,
	                        userData:             tracker.userData
	                    }
	                );
	
	                if ( propagate === false ) {
	                    $.cancelEvent( event );
	                }
	            }
	        }
	    }
	
	
	    /**
	     * @function
	     * @private
	     * @inner
	     * @param {OpenSeadragon.MouseTracker} tracker
	     *     A reference to the MouseTracker instance.
	     * @param {Object} event
	     *     A reference to the originating DOM event.
	     * @param {Array.<OpenSeadragon.MouseTracker.GesturePoint>} gPoints
	     *      Gesture points associated with the event.
	     * @param {Number} buttonChanged
	     *      The button involved in the event: -1: none, 0: primary/left, 1: aux/middle, 2: secondary/right, 3: X1/back, 4: X2/forward, 5: pen eraser.
	     *      Note on chorded button presses (a button pressed when another button is already pressed): In the W3C Pointer Events model,
	     *      only one pointerdown/pointerup event combo is fired. Chorded button state changes instead fire pointermove events.
	     *
	     * @returns {Boolean} True if pointers should be captured to the tracked element, otherwise false.
	     */
	    function updatePointersDown( tracker, event, gPoints, buttonChanged ) {
	        var delegate = THIS[ tracker.hash ],
	            propagate,
	            pointsList = tracker.getActivePointersListByType( gPoints[ 0 ].type ),
	            i,
	            gPointCount = gPoints.length,
	            curGPoint,
	            updateGPoint;
	
	        if ( typeof event.buttons !== 'undefined' ) {
	            pointsList.buttons = event.buttons;
	        } else {
	            if ( $.Browser.vendor === $.BROWSERS.IE && $.Browser.version < 9 ) {
	                if ( buttonChanged === 0 ) {
	                    // Primary
	                    pointsList.buttons += 1;
	                } else if ( buttonChanged === 1 ) {
	                    // Aux
	                    pointsList.buttons += 4;
	                } else if ( buttonChanged === 2 ) {
	                    // Secondary
	                    pointsList.buttons += 2;
	                } else if ( buttonChanged === 3 ) {
	                    // X1 (Back)
	                    pointsList.buttons += 8;
	                } else if ( buttonChanged === 4 ) {
	                    // X2 (Forward)
	                    pointsList.buttons += 16;
	                } else if ( buttonChanged === 5 ) {
	                    // Pen Eraser
	                    pointsList.buttons += 32;
	                }
	            } else {
	                if ( buttonChanged === 0 ) {
	                    // Primary
	                    pointsList.buttons |= 1;
	                } else if ( buttonChanged === 1 ) {
	                    // Aux
	                    pointsList.buttons |= 4;
	                } else if ( buttonChanged === 2 ) {
	                    // Secondary
	                    pointsList.buttons |= 2;
	                } else if ( buttonChanged === 3 ) {
	                    // X1 (Back)
	                    pointsList.buttons |= 8;
	                } else if ( buttonChanged === 4 ) {
	                    // X2 (Forward)
	                    pointsList.buttons |= 16;
	                } else if ( buttonChanged === 5 ) {
	                    // Pen Eraser
	                    pointsList.buttons |= 32;
	                }
	            }
	        }
	
	        // Some pointers may steal control from another pointer without firing the appropriate release events
	        // e.g. Touching a screen while click-dragging with certain mice.
	        var otherPointsLists = tracker.getActivePointersListsExceptType(gPoints[ 0 ].type);
	        for (i = 0; i < otherPointsLists.length; i++) {
	            //If another pointer has contact, simulate the release
	            abortContacts(tracker, event, otherPointsLists[i]); // No-op if no active pointer
	        }
	
	        // Only capture and track primary button, pen, and touch contacts
	        if ( buttonChanged !== 0 ) {
	            // Aux Press
	            if ( tracker.nonPrimaryPressHandler ) {
	                propagate = tracker.nonPrimaryPressHandler(
	                    {
	                        eventSource:          tracker,
	                        pointerType:          gPoints[ 0 ].type,
	                        position:             getPointRelativeToAbsolute( gPoints[ 0 ].currentPos, tracker.element ),
	                        button:               buttonChanged,
	                        buttons:              pointsList.buttons,
	                        isTouchEvent:         gPoints[ 0 ].type === 'touch',
	                        originalEvent:        event,
	                        preventDefaultAction: false,
	                        userData:             tracker.userData
	                    }
	                );
	                if ( propagate === false ) {
	                    $.cancelEvent( event );
	                }
	            }
	
	            return false;
	        }
	
	        for ( i = 0; i < gPointCount; i++ ) {
	            curGPoint = gPoints[ i ];
	            updateGPoint = pointsList.getById( curGPoint.id );
	
	            if ( updateGPoint ) {
	                // Already tracking the pointer...update it
	                updateGPoint.captured = true;
	                updateGPoint.insideElementPressed = true;
	                updateGPoint.insideElement = true;
	                updateGPoint.contactPos = curGPoint.currentPos;
	                updateGPoint.contactTime = curGPoint.currentTime;
	                updateGPoint.lastPos = updateGPoint.currentPos;
	                updateGPoint.lastTime = updateGPoint.currentTime;
	                updateGPoint.currentPos = curGPoint.currentPos;
	                updateGPoint.currentTime = curGPoint.currentTime;
	
	                curGPoint = updateGPoint;
	            } else {
	                // Initialize for tracking and add to the tracking list (no pointerover or pointermove event occurred before this)
	                curGPoint.captured = true;
	                curGPoint.insideElementPressed = true;
	                curGPoint.insideElement = true;
	                startTrackingPointer( pointsList, curGPoint );
	            }
	
	            pointsList.addContact();
	            //$.console.log('contacts++ ', pointsList.contacts);
	
	            if ( tracker.dragHandler || tracker.dragEndHandler || tracker.pinchHandler ) {
	                $.MouseTracker.gesturePointVelocityTracker.addPoint( tracker, curGPoint );
	            }
	
	            if ( pointsList.contacts === 1 ) {
	                // Press
	                if ( tracker.pressHandler ) {
	                    propagate = tracker.pressHandler(
	                        {
	                            eventSource:          tracker,
	                            pointerType:          curGPoint.type,
	                            position:             getPointRelativeToAbsolute( curGPoint.contactPos, tracker.element ),
	                            buttons:              pointsList.buttons,
	                            isTouchEvent:         curGPoint.type === 'touch',
	                            originalEvent:        event,
	                            preventDefaultAction: false,
	                            userData:             tracker.userData
	                        }
	                    );
	                    if ( propagate === false ) {
	                        $.cancelEvent( event );
	                    }
	                }
	            } else if ( pointsList.contacts === 2 ) {
	                if ( tracker.pinchHandler && curGPoint.type === 'touch' ) {
	                    // Initialize for pinch
	                    delegate.pinchGPoints = pointsList.asArray();
	                    delegate.lastPinchDist = delegate.currentPinchDist = delegate.pinchGPoints[ 0 ].currentPos.distanceTo( delegate.pinchGPoints[ 1 ].currentPos );
	                    delegate.lastPinchCenter = delegate.currentPinchCenter = getCenterPoint( delegate.pinchGPoints[ 0 ].currentPos, delegate.pinchGPoints[ 1 ].currentPos );
	                }
	            }
	        }
	
	        return true;
	    }
	
	
	    /**
	     * @function
	     * @private
	     * @inner
	     * @param {OpenSeadragon.MouseTracker} tracker
	     *     A reference to the MouseTracker instance.
	     * @param {Object} event
	     *     A reference to the originating DOM event.
	     * @param {Array.<OpenSeadragon.MouseTracker.GesturePoint>} gPoints
	     *      Gesture points associated with the event.
	     * @param {Number} buttonChanged
	     *      The button involved in the event: -1: none, 0: primary/left, 1: aux/middle, 2: secondary/right, 3: X1/back, 4: X2/forward, 5: pen eraser.
	     *      Note on chorded button presses (a button pressed when another button is already pressed): In the W3C Pointer Events model,
	     *      only one pointerdown/pointerup event combo is fired. Chorded button state changes instead fire pointermove events.
	     *
	     * @returns {Boolean} True if pointer capture should be released from the tracked element, otherwise false.
	     */
	    function updatePointersUp( tracker, event, gPoints, buttonChanged ) {
	        var delegate = THIS[ tracker.hash ],
	            pointsList = tracker.getActivePointersListByType( gPoints[ 0 ].type ),
	            propagate,
	            releasePoint,
	            releaseTime,
	            i,
	            gPointCount = gPoints.length,
	            curGPoint,
	            updateGPoint,
	            releaseCapture = false,
	            wasCaptured = false,
	            quick;
	
	        if ( typeof event.buttons !== 'undefined' ) {
	            pointsList.buttons = event.buttons;
	        } else {
	            if ( $.Browser.vendor === $.BROWSERS.IE && $.Browser.version < 9 ) {
	                if ( buttonChanged === 0 ) {
	                    // Primary
	                    pointsList.buttons -= 1;
	                } else if ( buttonChanged === 1 ) {
	                    // Aux
	                    pointsList.buttons -= 4;
	                } else if ( buttonChanged === 2 ) {
	                    // Secondary
	                    pointsList.buttons -= 2;
	                } else if ( buttonChanged === 3 ) {
	                    // X1 (Back)
	                    pointsList.buttons -= 8;
	                } else if ( buttonChanged === 4 ) {
	                    // X2 (Forward)
	                    pointsList.buttons -= 16;
	                } else if ( buttonChanged === 5 ) {
	                    // Pen Eraser
	                    pointsList.buttons -= 32;
	                }
	            } else {
	                if ( buttonChanged === 0 ) {
	                    // Primary
	                    pointsList.buttons ^= ~1;
	                } else if ( buttonChanged === 1 ) {
	                    // Aux
	                    pointsList.buttons ^= ~4;
	                } else if ( buttonChanged === 2 ) {
	                    // Secondary
	                    pointsList.buttons ^= ~2;
	                } else if ( buttonChanged === 3 ) {
	                    // X1 (Back)
	                    pointsList.buttons ^= ~8;
	                } else if ( buttonChanged === 4 ) {
	                    // X2 (Forward)
	                    pointsList.buttons ^= ~16;
	                } else if ( buttonChanged === 5 ) {
	                    // Pen Eraser
	                    pointsList.buttons ^= ~32;
	                }
	            }
	        }
	
	        // Only capture and track primary button, pen, and touch contacts
	        if ( buttonChanged !== 0 ) {
	            // Aux Release
	            if ( tracker.nonPrimaryReleaseHandler ) {
	                propagate = tracker.nonPrimaryReleaseHandler(
	                    {
	                        eventSource:           tracker,
	                        pointerType:           gPoints[ 0 ].type,
	                        position:              getPointRelativeToAbsolute(gPoints[0].currentPos, tracker.element),
	                        button:                buttonChanged,
	                        buttons:               pointsList.buttons,
	                        isTouchEvent:          gPoints[ 0 ].type === 'touch',
	                        originalEvent:         event,
	                        preventDefaultAction:  false,
	                        userData:              tracker.userData
	                    }
	                );
	                if ( propagate === false ) {
	                    $.cancelEvent( event );
	                }
	            }
	
	            // A primary mouse button may have been released while the non-primary button was down
	            var otherPointsList = tracker.getActivePointersListByType("mouse");
	            // Stop tracking the mouse; see https://github.com/openseadragon/openseadragon/pull/1223
	            abortContacts(tracker, event, otherPointsList); // No-op if no active pointer
	
	            return false;
	        }
	
	        for ( i = 0; i < gPointCount; i++ ) {
	            curGPoint = gPoints[ i ];
	            updateGPoint = pointsList.getById( curGPoint.id );
	
	            if ( updateGPoint ) {
	                // Update the pointer, stop tracking it if not still in this element
	                if ( updateGPoint.captured ) {
	                    updateGPoint.captured = false;
	                    releaseCapture = true;
	                    wasCaptured = true;
	                }
	                updateGPoint.lastPos = updateGPoint.currentPos;
	                updateGPoint.lastTime = updateGPoint.currentTime;
	                updateGPoint.currentPos = curGPoint.currentPos;
	                updateGPoint.currentTime = curGPoint.currentTime;
	                if ( !updateGPoint.insideElement ) {
	                    stopTrackingPointer( pointsList, updateGPoint );
	                }
	
	                releasePoint = updateGPoint.currentPos;
	                releaseTime = updateGPoint.currentTime;
	
	                if ( wasCaptured ) {
	                    // Pointer was activated in our element but could have been removed in any element since events are captured to our element
	
	                    pointsList.removeContact();
	                    //$.console.log('contacts-- ', pointsList.contacts);
	
	                    if ( tracker.dragHandler || tracker.dragEndHandler || tracker.pinchHandler ) {
	                        $.MouseTracker.gesturePointVelocityTracker.removePoint( tracker, updateGPoint );
	                    }
	
	                    if ( pointsList.contacts === 0 ) {
	
	                        // Release (pressed in our element)
	                        if ( tracker.releaseHandler ) {
	                            propagate = tracker.releaseHandler(
	                                {
	                                    eventSource:           tracker,
	                                    pointerType:           updateGPoint.type,
	                                    position:              getPointRelativeToAbsolute( releasePoint, tracker.element ),
	                                    buttons:               pointsList.buttons,
	                                    insideElementPressed:  updateGPoint.insideElementPressed,
	                                    insideElementReleased: updateGPoint.insideElement,
	                                    isTouchEvent:          updateGPoint.type === 'touch',
	                                    originalEvent:         event,
	                                    preventDefaultAction:  false,
	                                    userData:              tracker.userData
	                                }
	                            );
	                            if ( propagate === false ) {
	                                $.cancelEvent( event );
	                            }
	                        }
	
	                        // Drag End
	                        if ( tracker.dragEndHandler && !updateGPoint.currentPos.equals( updateGPoint.contactPos ) ) {
	                            propagate = tracker.dragEndHandler(
	                                {
	                                    eventSource:          tracker,
	                                    pointerType:          updateGPoint.type,
	                                    position:             getPointRelativeToAbsolute( updateGPoint.currentPos, tracker.element ),
	                                    speed:                updateGPoint.speed,
	                                    direction:            updateGPoint.direction,
	                                    shift:                event.shiftKey,
	                                    isTouchEvent:         updateGPoint.type === 'touch',
	                                    originalEvent:        event,
	                                    preventDefaultAction: false,
	                                    userData:             tracker.userData
	                                }
	                            );
	                            if ( propagate === false ) {
	                                $.cancelEvent( event );
	                            }
	                        }
	
	                        // Click / Double-Click
	                        if ( ( tracker.clickHandler || tracker.dblClickHandler ) && updateGPoint.insideElement ) {
	                            quick = releaseTime - updateGPoint.contactTime <= tracker.clickTimeThreshold &&
	                                            updateGPoint.contactPos.distanceTo( releasePoint ) <= tracker.clickDistThreshold;
	
	                            // Click
	                            if ( tracker.clickHandler ) {
	                                propagate = tracker.clickHandler(
	                                    {
	                                        eventSource:          tracker,
	                                        pointerType:          updateGPoint.type,
	                                        position:             getPointRelativeToAbsolute( updateGPoint.currentPos, tracker.element ),
	                                        quick:                quick,
	                                        shift:                event.shiftKey,
	                                        isTouchEvent:         updateGPoint.type === 'touch',
	                                        originalEvent:        event,
	                                        preventDefaultAction: false,
	                                        userData:             tracker.userData
	                                    }
	                                );
	                                if ( propagate === false ) {
	                                    $.cancelEvent( event );
	                                }
	                            }
	
	                            // Double-Click
	                            if ( tracker.dblClickHandler && quick ) {
	                                pointsList.clicks++;
	                                if ( pointsList.clicks === 1 ) {
	                                    delegate.lastClickPos = releasePoint;
	                                    /*jshint loopfunc:true*/
	                                    delegate.dblClickTimeOut = setTimeout( function() {
	                                        pointsList.clicks = 0;
	                                    }, tracker.dblClickTimeThreshold );
	                                    /*jshint loopfunc:false*/
	                                } else if ( pointsList.clicks === 2 ) {
	                                    clearTimeout( delegate.dblClickTimeOut );
	                                    pointsList.clicks = 0;
	                                    if ( delegate.lastClickPos.distanceTo( releasePoint ) <= tracker.dblClickDistThreshold ) {
	                                        propagate = tracker.dblClickHandler(
	                                            {
	                                                eventSource:          tracker,
	                                                pointerType:          updateGPoint.type,
	                                                position:             getPointRelativeToAbsolute( updateGPoint.currentPos, tracker.element ),
	                                                shift:                event.shiftKey,
	                                                isTouchEvent:         updateGPoint.type === 'touch',
	                                                originalEvent:        event,
	                                                preventDefaultAction: false,
	                                                userData:             tracker.userData
	                                            }
	                                        );
	                                        if ( propagate === false ) {
	                                            $.cancelEvent( event );
	                                        }
	                                    }
	                                    delegate.lastClickPos = null;
	                                }
	                            }
	                        }
	                    } else if ( pointsList.contacts === 2 ) {
	                        if ( tracker.pinchHandler && updateGPoint.type === 'touch' ) {
	                            // Reset for pinch
	                            delegate.pinchGPoints = pointsList.asArray();
	                            delegate.lastPinchDist = delegate.currentPinchDist = delegate.pinchGPoints[ 0 ].currentPos.distanceTo( delegate.pinchGPoints[ 1 ].currentPos );
	                            delegate.lastPinchCenter = delegate.currentPinchCenter = getCenterPoint( delegate.pinchGPoints[ 0 ].currentPos, delegate.pinchGPoints[ 1 ].currentPos );
	                        }
	                    }
	                } else {
	                    // Pointer was activated in another element but removed in our element
	
	                    // Release (pressed in another element)
	                    if ( tracker.releaseHandler ) {
	                        propagate = tracker.releaseHandler(
	                            {
	                                eventSource:           tracker,
	                                pointerType:           updateGPoint.type,
	                                position:              getPointRelativeToAbsolute( releasePoint, tracker.element ),
	                                buttons:               pointsList.buttons,
	                                insideElementPressed:  updateGPoint.insideElementPressed,
	                                insideElementReleased: updateGPoint.insideElement,
	                                isTouchEvent:          updateGPoint.type === 'touch',
	                                originalEvent:         event,
	                                preventDefaultAction:  false,
	                                userData:              tracker.userData
	                            }
	                        );
	                        if ( propagate === false ) {
	                            $.cancelEvent( event );
	                        }
	                    }
	                }
	            }
	        }
	
	        return releaseCapture;
	    }
	
	
	    /**
	     * Call when pointer(s) change coordinates, button state, pressure, tilt, or contact geometry (e.g. width and height)
	     *
	     * @function
	     * @private
	     * @inner
	     * @param {OpenSeadragon.MouseTracker} tracker
	     *     A reference to the MouseTracker instance.
	     * @param {Object} event
	     *     A reference to the originating DOM event.
	     * @param {Array.<OpenSeadragon.MouseTracker.GesturePoint>} gPoints
	     *      Gesture points associated with the event.
	     */
	    function updatePointersMove( tracker, event, gPoints ) {
	        var delegate = THIS[ tracker.hash ],
	            pointsList = tracker.getActivePointersListByType( gPoints[ 0 ].type ),
	            i,
	            gPointCount = gPoints.length,
	            curGPoint,
	            updateGPoint,
	            gPointArray,
	            delta,
	            propagate;
	
	        if ( typeof event.buttons !== 'undefined' ) {
	            pointsList.buttons = event.buttons;
	        }
	
	        for ( i = 0; i < gPointCount; i++ ) {
	            curGPoint = gPoints[ i ];
	            updateGPoint = pointsList.getById( curGPoint.id );
	
	            if ( updateGPoint ) {
	                // Already tracking the pointer...update it
	                if ( curGPoint.hasOwnProperty( 'isPrimary' ) ) {
	                    updateGPoint.isPrimary = curGPoint.isPrimary;
	                }
	                updateGPoint.lastPos = updateGPoint.currentPos;
	                updateGPoint.lastTime = updateGPoint.currentTime;
	                updateGPoint.currentPos = curGPoint.currentPos;
	                updateGPoint.currentTime = curGPoint.currentTime;
	            } else {
	                // Initialize for tracking and add to the tracking list (no pointerover or pointerdown event occurred before this)
	                curGPoint.captured = false;
	                curGPoint.insideElementPressed = false;
	                curGPoint.insideElement = true;
	                startTrackingPointer( pointsList, curGPoint );
	            }
	        }
	
	        // Stop (mouse only)
	        if ( tracker.stopHandler && gPoints[ 0 ].type === 'mouse' ) {
	            clearTimeout( tracker.stopTimeOut );
	            tracker.stopTimeOut = setTimeout( function() {
	                handlePointerStop( tracker, event, gPoints[ 0 ].type );
	            }, tracker.stopDelay );
	        }
	
	        if ( pointsList.contacts === 0 ) {
	            // Move (no contacts: hovering mouse or other hover-capable device)
	            if ( tracker.moveHandler ) {
	                propagate = tracker.moveHandler(
	                    {
	                        eventSource:          tracker,
	                        pointerType:          gPoints[ 0 ].type,
	                        position:             getPointRelativeToAbsolute( gPoints[ 0 ].currentPos, tracker.element ),
	                        buttons:              pointsList.buttons,
	                        isTouchEvent:         gPoints[ 0 ].type === 'touch',
	                        originalEvent:        event,
	                        preventDefaultAction: false,
	                        userData:             tracker.userData
	                    }
	                );
	                if ( propagate === false ) {
	                    $.cancelEvent( event );
	                }
	            }
	        } else if ( pointsList.contacts === 1 ) {
	            // Move (1 contact)
	            if ( tracker.moveHandler ) {
	                updateGPoint = pointsList.asArray()[ 0 ];
	                propagate = tracker.moveHandler(
	                    {
	                        eventSource:          tracker,
	                        pointerType:          updateGPoint.type,
	                        position:             getPointRelativeToAbsolute( updateGPoint.currentPos, tracker.element ),
	                        buttons:              pointsList.buttons,
	                        isTouchEvent:         updateGPoint.type === 'touch',
	                        originalEvent:        event,
	                        preventDefaultAction: false,
	                        userData:             tracker.userData
	                    }
	                );
	                if ( propagate === false ) {
	                    $.cancelEvent( event );
	                }
	            }
	
	            // Drag
	            if ( tracker.dragHandler ) {
	                updateGPoint = pointsList.asArray()[ 0 ];
	                delta = updateGPoint.currentPos.minus( updateGPoint.lastPos );
	                propagate = tracker.dragHandler(
	                    {
	                        eventSource:          tracker,
	                        pointerType:          updateGPoint.type,
	                        position:             getPointRelativeToAbsolute( updateGPoint.currentPos, tracker.element ),
	                        buttons:              pointsList.buttons,
	                        delta:                delta,
	                        speed:                updateGPoint.speed,
	                        direction:            updateGPoint.direction,
	                        shift:                event.shiftKey,
	                        isTouchEvent:         updateGPoint.type === 'touch',
	                        originalEvent:        event,
	                        preventDefaultAction: false,
	                        userData:             tracker.userData
	                    }
	                );
	                if ( propagate === false ) {
	                    $.cancelEvent( event );
	                }
	            }
	        } else if ( pointsList.contacts === 2 ) {
	            // Move (2 contacts, use center)
	            if ( tracker.moveHandler ) {
	                gPointArray = pointsList.asArray();
	                propagate = tracker.moveHandler(
	                    {
	                        eventSource:          tracker,
	                        pointerType:          gPointArray[ 0 ].type,
	                        position:             getPointRelativeToAbsolute( getCenterPoint( gPointArray[ 0 ].currentPos, gPointArray[ 1 ].currentPos ), tracker.element ),
	                        buttons:              pointsList.buttons,
	                        isTouchEvent:         gPointArray[ 0 ].type === 'touch',
	                        originalEvent:        event,
	                        preventDefaultAction: false,
	                        userData:             tracker.userData
	                    }
	                );
	                if ( propagate === false ) {
	                    $.cancelEvent( event );
	                }
	            }
	
	            // Pinch
	            if ( tracker.pinchHandler && gPoints[ 0 ].type === 'touch' ) {
	                delta = delegate.pinchGPoints[ 0 ].currentPos.distanceTo( delegate.pinchGPoints[ 1 ].currentPos );
	                if ( delta != delegate.currentPinchDist ) {
	                    delegate.lastPinchDist = delegate.currentPinchDist;
	                    delegate.currentPinchDist = delta;
	                    delegate.lastPinchCenter = delegate.currentPinchCenter;
	                    delegate.currentPinchCenter = getCenterPoint( delegate.pinchGPoints[ 0 ].currentPos, delegate.pinchGPoints[ 1 ].currentPos );
	                    propagate = tracker.pinchHandler(
	                        {
	                            eventSource:          tracker,
	                            pointerType:          'touch',
	                            gesturePoints:        delegate.pinchGPoints,
	                            lastCenter:           getPointRelativeToAbsolute( delegate.lastPinchCenter, tracker.element ),
	                            center:               getPointRelativeToAbsolute( delegate.currentPinchCenter, tracker.element ),
	                            lastDistance:         delegate.lastPinchDist,
	                            distance:             delegate.currentPinchDist,
	                            shift:                event.shiftKey,
	                            originalEvent:        event,
	                            preventDefaultAction: false,
	                            userData:             tracker.userData
	                        }
	                    );
	                    if ( propagate === false ) {
	                        $.cancelEvent( event );
	                    }
	                }
	            }
	        }
	    }
	
	
	    /**
	     * @function
	     * @private
	     * @inner
	     * @param {OpenSeadragon.MouseTracker} tracker
	     *     A reference to the MouseTracker instance.
	     * @param {Object} event
	     *     A reference to the originating DOM event.
	     * @param {Array.<OpenSeadragon.MouseTracker.GesturePoint>} gPoints
	     *      Gesture points associated with the event.
	     */
	    function updatePointersCancel( tracker, event, gPoints ) {
	        updatePointersUp( tracker, event, gPoints, 0 );
	        updatePointersExit( tracker, event, gPoints );
	    }
	
	
	    /**
	     * @private
	     * @inner
	     */
	    function handlePointerStop( tracker, originalMoveEvent, pointerType ) {
	        if ( tracker.stopHandler ) {
	            tracker.stopHandler( {
	                eventSource:          tracker,
	                pointerType:          pointerType,
	                position:             getMouseRelative( originalMoveEvent, tracker.element ),
	                buttons:              tracker.getActivePointersListByType( pointerType ).buttons,
	                isTouchEvent:         pointerType === 'touch',
	                originalEvent:        originalMoveEvent,
	                preventDefaultAction: false,
	                userData:             tracker.userData
	            } );
	        }
	    }
	
	    /**
	     * True if inside an iframe, otherwise false.
	     * @member {Boolean} isInIframe
	     * @private
	     * @inner
	     */
	    var isInIframe = (function() {
	        try {
	            return window.self !== window.top;
	        } catch (e) {
	            return true;
	        }
	    })();
	
	    /**
	     * @function
	     * @private
	     * @inner
	     * @returns {Boolean} True if the target has access rights to events, otherwise false.
	     */
	    function canAccessEvents (target) {
	        try {
	            return target.addEventListener && target.removeEventListener;
	        } catch (e) {
	            return false;
	        }
	    }
	
	}(OpenSeadragon));
	
	/*
	 * OpenSeadragon - Control
	 *
	 * Copyright (C) 2009 CodePlex Foundation
	 * Copyright (C) 2010-2013 OpenSeadragon contributors
	 *
	 * Redistribution and use in source and binary forms, with or without
	 * modification, are permitted provided that the following conditions are
	 * met:
	 *
	 * - Redistributions of source code must retain the above copyright notice,
	 *   this list of conditions and the following disclaimer.
	 *
	 * - Redistributions in binary form must reproduce the above copyright
	 *   notice, this list of conditions and the following disclaimer in the
	 *   documentation and/or other materials provided with the distribution.
	 *
	 * - Neither the name of CodePlex Foundation nor the names of its
	 *   contributors may be used to endorse or promote products derived from
	 *   this software without specific prior written permission.
	 *
	 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
	 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
	 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
	 * A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT
	 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
	 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
	 * TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 * PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
	 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
	 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
	 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	 */
	
	(function( $ ){
	
	/**
	 * An enumeration of supported locations where controls can be anchored.
	 * The anchoring is always relative to the container.
	 * @member ControlAnchor
	 * @memberof OpenSeadragon
	 * @static
	 * @type {Object}
	 * @property {Number} NONE
	 * @property {Number} TOP_LEFT
	 * @property {Number} TOP_RIGHT
	 * @property {Number} BOTTOM_LEFT
	 * @property {Number} BOTTOM_RIGHT
	 * @property {Number} ABSOLUTE
	 */
	$.ControlAnchor = {
	    NONE: 0,
	    TOP_LEFT: 1,
	    TOP_RIGHT: 2,
	    BOTTOM_RIGHT: 3,
	    BOTTOM_LEFT: 4,
	    ABSOLUTE: 5
	};
	
	/**
	 * @class Control
	 * @classdesc A Control represents any interface element which is meant to allow the user
	 * to interact with the zoomable interface. Any control can be anchored to any
	 * element.
	 *
	 * @memberof OpenSeadragon
	 * @param {Element} element - the control element to be anchored in the container.
	 * @param {Object } options - All required and optional settings for configuring a control element.
	 * @param {OpenSeadragon.ControlAnchor} [options.anchor=OpenSeadragon.ControlAnchor.NONE] - the position of the control
	 *  relative to the container.
	 * @param {Boolean} [options.attachToViewer=true] - Whether the control should be added directly to the viewer, or
	 *  directly to the container
	 * @param {Boolean} [options.autoFade=true] - Whether the control should have the autofade behavior
	 * @param {Element} container - the element to control will be anchored too.
	 */
	$.Control = function ( element, options, container ) {
	    var parent = element.parentNode;
	    if (typeof options === 'number')
	    {
	        $.console.error("Passing an anchor directly into the OpenSeadragon.Control constructor is deprecated; " +
	                        "please use an options object instead.  " +
	                        "Support for this deprecated variant is scheduled for removal in December 2013");
	         options = {anchor: options};
	    }
	    options.attachToViewer = (typeof options.attachToViewer === 'undefined') ? true : options.attachToViewer;
	    /**
	     * True if the control should have autofade behavior.
	     * @member {Boolean} autoFade
	     * @memberof OpenSeadragon.Control#
	     */
	    this.autoFade = (typeof options.autoFade === 'undefined') ? true : options.autoFade;
	    /**
	     * The element providing the user interface with some type of control (e.g. a zoom-in button).
	     * @member {Element} element
	     * @memberof OpenSeadragon.Control#
	     */
	    this.element    = element;
	    /**
	     * The position of the Control relative to its container.
	     * @member {OpenSeadragon.ControlAnchor} anchor
	     * @memberof OpenSeadragon.Control#
	     */
	    this.anchor     = options.anchor;
	    /**
	     * The Control's containing element.
	     * @member {Element} container
	     * @memberof OpenSeadragon.Control#
	     */
	    this.container  = container;
	    /**
	     * A neutral element surrounding the control element.
	     * @member {Element} wrapper
	     * @memberof OpenSeadragon.Control#
	     */
	    if ( this.anchor == $.ControlAnchor.ABSOLUTE ) {
	        this.wrapper    = $.makeNeutralElement( "div" );
	        this.wrapper.style.position = "absolute";
	        this.wrapper.style.top = typeof (options.top) == "number" ? (options.top + 'px') : options.top;
	        this.wrapper.style.left  = typeof (options.left) == "number" ? (options.left + 'px') : options.left;
	        this.wrapper.style.height = typeof (options.height) == "number" ? (options.height + 'px') : options.height;
	        this.wrapper.style.width  = typeof (options.width) == "number" ? (options.width + 'px') : options.width;
	        this.wrapper.style.margin = "0px";
	        this.wrapper.style.padding = "0px";
	
	        this.element.style.position = "relative";
	        this.element.style.top = "0px";
	        this.element.style.left = "0px";
	        this.element.style.height = "100%";
	        this.element.style.width = "100%";
	    } else {
	        this.wrapper    = $.makeNeutralElement( "div" );
	        this.wrapper.style.display = "inline-block";
	        if ( this.anchor == $.ControlAnchor.NONE ) {
	            // IE6 fix
	            this.wrapper.style.width = this.wrapper.style.height = "100%";
	        }
	    }
	    this.wrapper.appendChild( this.element );
	
	    if (options.attachToViewer ) {
	        if ( this.anchor == $.ControlAnchor.TOP_RIGHT ||
	             this.anchor == $.ControlAnchor.BOTTOM_RIGHT ) {
	            this.container.insertBefore(
	                this.wrapper,
	                this.container.firstChild
	            );
	        } else {
	            this.container.appendChild( this.wrapper );
	        }
	    } else {
	        parent.appendChild( this.wrapper );
	    }
	};
	
	/** @lends OpenSeadragon.Control.prototype */
	$.Control.prototype = {
	
	    /**
	     * Removes the control from the container.
	     * @function
	     */
	    destroy: function() {
	        this.wrapper.removeChild( this.element );
	        this.container.removeChild( this.wrapper );
	    },
	
	    /**
	     * Determines if the control is currently visible.
	     * @function
	     * @return {Boolean} true if currenly visible, false otherwise.
	     */
	    isVisible: function() {
	        return this.wrapper.style.display != "none";
	    },
	
	    /**
	     * Toggles the visibility of the control.
	     * @function
	     * @param {Boolean} visible - true to make visible, false to hide.
	     */
	    setVisible: function( visible ) {
	        this.wrapper.style.display = visible ?
	            ( this.anchor == $.ControlAnchor.ABSOLUTE ? 'block' : 'inline-block' ) :
	            "none";
	    },
	
	    /**
	     * Sets the opacity level for the control.
	     * @function
	     * @param {Number} opactiy - a value between 1 and 0 inclusively.
	     */
	    setOpacity: function( opacity ) {
	        if ( this.element[ $.SIGNAL ] && $.Browser.vendor == $.BROWSERS.IE ) {
	            $.setElementOpacity( this.element, opacity, true );
	        } else {
	            $.setElementOpacity( this.wrapper, opacity, true );
	        }
	    }
	};
	
	}( OpenSeadragon ));
	
	/*
	 * OpenSeadragon - ControlDock
	 *
	 * Copyright (C) 2009 CodePlex Foundation
	 * Copyright (C) 2010-2013 OpenSeadragon contributors
	 *
	 * Redistribution and use in source and binary forms, with or without
	 * modification, are permitted provided that the following conditions are
	 * met:
	 *
	 * - Redistributions of source code must retain the above copyright notice,
	 *   this list of conditions and the following disclaimer.
	 *
	 * - Redistributions in binary form must reproduce the above copyright
	 *   notice, this list of conditions and the following disclaimer in the
	 *   documentation and/or other materials provided with the distribution.
	 *
	 * - Neither the name of CodePlex Foundation nor the names of its
	 *   contributors may be used to endorse or promote products derived from
	 *   this software without specific prior written permission.
	 *
	 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
	 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
	 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
	 * A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT
	 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
	 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
	 * TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 * PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
	 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
	 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
	 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	 */
	
	(function( $ ){
	    /**
	     * @class ControlDock
	     * @classdesc Provides a container element (a &lt;form&gt; element) with support for the layout of control elements.
	     *
	     * @memberof OpenSeadragon
	     */
	    $.ControlDock = function( options ){
	        var layouts = [ 'topleft', 'topright', 'bottomright', 'bottomleft'],
	            layout,
	            i;
	
	        $.extend( true, this, {
	            id: 'controldock-' + $.now() + '-' + Math.floor(Math.random() * 1000000),
	            container: $.makeNeutralElement( 'div' ),
	            controls: []
	        }, options );
	
	        // Disable the form's submit; otherwise button clicks and return keys
	        // can trigger it.
	        this.container.onsubmit = function() {
	            return false;
	        };
	
	        if( this.element ){
	            this.element = $.getElement( this.element );
	            this.element.appendChild( this.container );
	            this.element.style.position = 'relative';
	            this.container.style.width = '100%';
	            this.container.style.height = '100%';
	        }
	
	        for( i = 0; i < layouts.length; i++ ){
	            layout = layouts[ i ];
	            this.controls[ layout ] = $.makeNeutralElement( "div" );
	            this.controls[ layout ].style.position = 'absolute';
	            if ( layout.match( 'left' ) ){
	                this.controls[ layout ].style.left = '0px';
	            }
	            if ( layout.match( 'right' ) ){
	                this.controls[ layout ].style.right = '0px';
	            }
	            if ( layout.match( 'top' ) ){
	                this.controls[ layout ].style.top = '0px';
	            }
	            if ( layout.match( 'bottom' ) ){
	                this.controls[ layout ].style.bottom = '0px';
	            }
	        }
	
	        this.container.appendChild( this.controls.topleft );
	        this.container.appendChild( this.controls.topright );
	        this.container.appendChild( this.controls.bottomright );
	        this.container.appendChild( this.controls.bottomleft );
	    };
	
	    /** @lends OpenSeadragon.ControlDock.prototype */
	    $.ControlDock.prototype = {
	
	        /**
	         * @function
	         */
	        addControl: function ( element, controlOptions ) {
	            element = $.getElement( element );
	            var div = null;
	
	            if ( getControlIndex( this, element ) >= 0 ) {
	                return;     // they're trying to add a duplicate control
	            }
	
	            switch ( controlOptions.anchor ) {
	                case $.ControlAnchor.TOP_RIGHT:
	                    div = this.controls.topright;
	                    element.style.position = "relative";
	                    element.style.paddingRight = "0px";
	                    element.style.paddingTop = "0px";
	                    break;
	                case $.ControlAnchor.BOTTOM_RIGHT:
	                    div = this.controls.bottomright;
	                    element.style.position = "relative";
	                    element.style.paddingRight = "0px";
	                    element.style.paddingBottom = "0px";
	                    break;
	                case $.ControlAnchor.BOTTOM_LEFT:
	                    div = this.controls.bottomleft;
	                    element.style.position = "relative";
	                    element.style.paddingLeft = "0px";
	                    element.style.paddingBottom = "0px";
	                    break;
	                case $.ControlAnchor.TOP_LEFT:
	                    div = this.controls.topleft;
	                    element.style.position = "relative";
	                    element.style.paddingLeft = "0px";
	                    element.style.paddingTop = "0px";
	                    break;
	                case $.ControlAnchor.ABSOLUTE:
	                    div = this.container;
	                    element.style.margin = "0px";
	                    element.style.padding = "0px";
	                    break;
	                default:
	                case $.ControlAnchor.NONE:
	                    div = this.container;
	                    element.style.margin = "0px";
	                    element.style.padding = "0px";
	                    break;
	            }
	
	            this.controls.push(
	                new $.Control( element, controlOptions, div )
	            );
	            element.style.display = "inline-block";
	        },
	
	
	        /**
	         * @function
	         * @return {OpenSeadragon.ControlDock} Chainable.
	         */
	        removeControl: function ( element ) {
	            element = $.getElement( element );
	            var i = getControlIndex( this, element );
	
	            if ( i >= 0 ) {
	                this.controls[ i ].destroy();
	                this.controls.splice( i, 1 );
	            }
	
	            return this;
	        },
	
	        /**
	         * @function
	         * @return {OpenSeadragon.ControlDock} Chainable.
	         */
	        clearControls: function () {
	            while ( this.controls.length > 0 ) {
	                this.controls.pop().destroy();
	            }
	
	            return this;
	        },
	
	
	        /**
	         * @function
	         * @return {Boolean}
	         */
	        areControlsEnabled: function () {
	            var i;
	
	            for ( i = this.controls.length - 1; i >= 0; i-- ) {
	                if ( this.controls[ i ].isVisible() ) {
	                    return true;
	                }
	            }
	
	            return false;
	        },
	
	
	        /**
	         * @function
	         * @return {OpenSeadragon.ControlDock} Chainable.
	         */
	        setControlsEnabled: function( enabled ) {
	            var i;
	
	            for ( i = this.controls.length - 1; i >= 0; i-- ) {
	                this.controls[ i ].setVisible( enabled );
	            }
	
	            return this;
	        }
	
	    };
	
	
	    ///////////////////////////////////////////////////////////////////////////////
	    // Utility methods
	    ///////////////////////////////////////////////////////////////////////////////
	    function getControlIndex( dock, element ) {
	        var controls = dock.controls,
	            i;
	
	        for ( i = controls.length - 1; i >= 0; i-- ) {
	            if ( controls[ i ].element == element ) {
	                return i;
	            }
	        }
	
	        return -1;
	    }
	
	}( OpenSeadragon ));
	
	/*
	 * OpenSeadragon - Placement
	 *
	 * Copyright (C) 2010-2016 OpenSeadragon contributors
	 *
	 * Redistribution and use in source and binary forms, with or without
	 * modification, are permitted provided that the following conditions are
	 * met:
	 *
	 * - Redistributions of source code must retain the above copyright notice,
	 *   this list of conditions and the following disclaimer.
	 *
	 * - Redistributions in binary form must reproduce the above copyright
	 *   notice, this list of conditions and the following disclaimer in the
	 *   documentation and/or other materials provided with the distribution.
	 *
	 * - Neither the name of CodePlex Foundation nor the names of its
	 *   contributors may be used to endorse or promote products derived from
	 *   this software without specific prior written permission.
	 *
	 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
	 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
	 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
	 * A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT
	 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
	 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
	 * TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 * PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
	 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
	 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
	 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	 */
	
	(function($) {
	
	    /**
	     * An enumeration of positions to anchor an element.
	     * @member Placement
	     * @memberOf OpenSeadragon
	     * @static
	     * @readonly
	     * @property {OpenSeadragon.Placement} CENTER
	     * @property {OpenSeadragon.Placement} TOP_LEFT
	     * @property {OpenSeadragon.Placement} TOP
	     * @property {OpenSeadragon.Placement} TOP_RIGHT
	     * @property {OpenSeadragon.Placement} RIGHT
	     * @property {OpenSeadragon.Placement} BOTTOM_RIGHT
	     * @property {OpenSeadragon.Placement} BOTTOM
	     * @property {OpenSeadragon.Placement} BOTTOM_LEFT
	     * @property {OpenSeadragon.Placement} LEFT
	     */
	    $.Placement = $.freezeObject({
	        CENTER:       0,
	        TOP_LEFT:     1,
	        TOP:          2,
	        TOP_RIGHT:    3,
	        RIGHT:        4,
	        BOTTOM_RIGHT: 5,
	        BOTTOM:       6,
	        BOTTOM_LEFT:  7,
	        LEFT:         8,
	        properties: {
	            0: {
	                isLeft: false,
	                isHorizontallyCentered: true,
	                isRight: false,
	                isTop: false,
	                isVerticallyCentered: true,
	                isBottom: false
	            },
	            1: {
	                isLeft: true,
	                isHorizontallyCentered: false,
	                isRight: false,
	                isTop: true,
	                isVerticallyCentered: false,
	                isBottom: false
	            },
	            2: {
	                isLeft: false,
	                isHorizontallyCentered: true,
	                isRight: false,
	                isTop: true,
	                isVerticallyCentered: false,
	                isBottom: false
	            },
	            3: {
	                isLeft: false,
	                isHorizontallyCentered: false,
	                isRight: true,
	                isTop: true,
	                isVerticallyCentered: false,
	                isBottom: false
	            },
	            4: {
	                isLeft: false,
	                isHorizontallyCentered: false,
	                isRight: true,
	                isTop: false,
	                isVerticallyCentered: true,
	                isBottom: false
	            },
	            5: {
	                isLeft: false,
	                isHorizontallyCentered: false,
	                isRight: true,
	                isTop: false,
	                isVerticallyCentered: false,
	                isBottom: true
	            },
	            6: {
	                isLeft: false,
	                isHorizontallyCentered: true,
	                isRight: false,
	                isTop: false,
	                isVerticallyCentered: false,
	                isBottom: true
	            },
	            7: {
	                isLeft: true,
	                isHorizontallyCentered: false,
	                isRight: false,
	                isTop: false,
	                isVerticallyCentered: false,
	                isBottom: true
	            },
	            8: {
	                isLeft: true,
	                isHorizontallyCentered: false,
	                isRight: false,
	                isTop: false,
	                isVerticallyCentered: true,
	                isBottom: false
	            }
	        }
	    });
	
	}(OpenSeadragon));
	
	/*
	 * OpenSeadragon - Viewer
	 *
	 * Copyright (C) 2009 CodePlex Foundation
	 * Copyright (C) 2010-2013 OpenSeadragon contributors
	 *
	 * Redistribution and use in source and binary forms, with or without
	 * modification, are permitted provided that the following conditions are
	 * met:
	 *
	 * - Redistributions of source code must retain the above copyright notice,
	 *   this list of conditions and the following disclaimer.
	 *
	 * - Redistributions in binary form must reproduce the above copyright
	 *   notice, this list of conditions and the following disclaimer in the
	 *   documentation and/or other materials provided with the distribution.
	 *
	 * - Neither the name of CodePlex Foundation nor the names of its
	 *   contributors may be used to endorse or promote products derived from
	 *   this software without specific prior written permission.
	 *
	 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
	 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
	 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
	 * A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT
	 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
	 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
	 * TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 * PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
	 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
	 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
	 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	 */
	
	(function( $ ){
	
	// dictionary from hash to private properties
	var THIS = {};
	var nextHash = 1;
	
	/**
	 *
	 * The main point of entry into creating a zoomable image on the page.<br>
	 * <br>
	 * We have provided an idiomatic javascript constructor which takes
	 * a single object, but still support the legacy positional arguments.<br>
	 * <br>
	 * The options below are given in order that they appeared in the constructor
	 * as arguments and we translate a positional call into an idiomatic call.<br>
	 * <br>
	 * To create a viewer, you can use either of this methods:<br>
	 * <ul>
	 * <li><code>var viewer = new OpenSeadragon.Viewer(options);</code></li>
	 * <li><code>var viewer = OpenSeadragon(options);</code></li>
	 * </ul>
	 * @class Viewer
	 * @classdesc The main OpenSeadragon viewer class.
	 *
	 * @memberof OpenSeadragon
	 * @extends OpenSeadragon.EventSource
	 * @extends OpenSeadragon.ControlDock
	 * @param {OpenSeadragon.Options} options - Viewer options.
	 *
	 **/
	$.Viewer = function( options ) {
	
	    var args  = arguments,
	        _this = this,
	        i;
	
	
	    //backward compatibility for positional args while prefering more
	    //idiomatic javascript options object as the only argument
	    if( !$.isPlainObject( options ) ){
	        options = {
	            id:                 args[ 0 ],
	            xmlPath:            args.length > 1 ? args[ 1 ] : undefined,
	            prefixUrl:          args.length > 2 ? args[ 2 ] : undefined,
	            controls:           args.length > 3 ? args[ 3 ] : undefined,
	            overlays:           args.length > 4 ? args[ 4 ] : undefined
	        };
	    }
	
	    //options.config and the general config argument are deprecated
	    //in favor of the more direct specification of optional settings
	    //being pass directly on the options object
	    if ( options.config ){
	        $.extend( true, options, options.config );
	        delete options.config;
	    }
	
	    //Public properties
	    //Allow the options object to override global defaults
	    $.extend( true, this, {
	
	        //internal state and dom identifiers
	        id:             options.id,
	        hash:           options.hash || nextHash++,
	        /**
	         * Index for page to be shown first next time open() is called (only used in sequenceMode).
	         * @member {Number} initialPage
	         * @memberof OpenSeadragon.Viewer#
	         */
	        initialPage:    0,
	
	        //dom nodes
	        /**
	         * The parent element of this Viewer instance, passed in when the Viewer was created.
	         * @member {Element} element
	         * @memberof OpenSeadragon.Viewer#
	         */
	        element:        null,
	        /**
	         * A &lt;div&gt; element (provided by {@link OpenSeadragon.ControlDock}), the base element of this Viewer instance.<br><br>
	         * Child element of {@link OpenSeadragon.Viewer#element}.
	         * @member {Element} container
	         * @memberof OpenSeadragon.Viewer#
	         */
	        container:      null,
	        /**
	         * A &lt;div&gt; element, the element where user-input events are handled for panning and zooming.<br><br>
	         * Child element of {@link OpenSeadragon.Viewer#container},
	         * positioned on top of {@link OpenSeadragon.Viewer#keyboardCommandArea}.<br><br>
	         * The parent of {@link OpenSeadragon.Drawer#canvas} instances.
	         * @member {Element} canvas
	         * @memberof OpenSeadragon.Viewer#
	         */
	        canvas:         null,
	
	        // Overlays list. An overlay allows to add html on top of the viewer.
	        overlays:           [],
	        // Container inside the canvas where overlays are drawn.
	        overlaysContainer:  null,
	
	        //private state properties
	        previousBody:   [],
	
	        //This was originally initialized in the constructor and so could never
	        //have anything in it.  now it can because we allow it to be specified
	        //in the options and is only empty by default if not specified. Also
	        //this array was returned from get_controls which I find confusing
	        //since this object has a controls property which is treated in other
	        //functions like clearControls.  I'm removing the accessors.
	        customControls: [],
	
	        //These are originally not part options but declared as members
	        //in initialize.  It's still considered idiomatic to put them here
	        //source is here for backwards compatibility. It is not an official
	        //part of the API and should not be relied upon.
	        source:         null,
	        /**
	         * Handles rendering of tiles in the viewer. Created for each TileSource opened.
	         * @member {OpenSeadragon.Drawer} drawer
	         * @memberof OpenSeadragon.Viewer#
	         */
	        drawer:             null,
	        /**
	         * Keeps track of all of the tiled images in the scene.
	         * @member {OpenSeadragon.Drawer} world
	         * @memberof OpenSeadragon.Viewer#
	         */
	        world:              null,
	        /**
	         * Handles coordinate-related functionality - zoom, pan, rotation, etc. Created for each TileSource opened.
	         * @member {OpenSeadragon.Viewport} viewport
	         * @memberof OpenSeadragon.Viewer#
	         */
	        viewport:       null,
	        /**
	         * @member {OpenSeadragon.Navigator} navigator
	         * @memberof OpenSeadragon.Viewer#
	         */
	        navigator:      null,
	
	        //A collection viewport is a separate viewport used to provide
	        //simultaneous rendering of sets of tiles
	        collectionViewport:     null,
	        collectionDrawer:       null,
	
	        //UI image resources
	        //TODO: rename navImages to uiImages
	        navImages:      null,
	
	        //interface button controls
	        buttons:        null,
	
	        //TODO: this is defunct so safely remove it
	        profiler:       null
	
	    }, $.DEFAULT_SETTINGS, options );
	
	    if ( typeof ( this.hash) === "undefined" ) {
	        throw new Error("A hash must be defined, either by specifying options.id or options.hash.");
	    }
	    if ( typeof ( THIS[ this.hash ] ) !== "undefined" ) {
	        // We don't want to throw an error here, as the user might have discarded
	        // the previous viewer with the same hash and now want to recreate it.
	        $.console.warn("Hash " + this.hash + " has already been used.");
	    }
	
	    //Private state properties
	    THIS[ this.hash ] = {
	        "fsBoundsDelta":     new $.Point( 1, 1 ),
	        "prevContainerSize": null,
	        "animating":         false,
	        "forceRedraw":       false,
	        "mouseInside":       false,
	        "group":             null,
	        // whether we should be continuously zooming
	        "zooming":           false,
	        // how much we should be continuously zooming by
	        "zoomFactor":        null,
	        "lastZoomTime":      null,
	        "fullPage":          false,
	        "onfullscreenchange": null
	    };
	
	    this._sequenceIndex = 0;
	    this._firstOpen = true;
	    this._updateRequestId = null;
	    this._loadQueue = [];
	    this.currentOverlays = [];
	
	    this._lastScrollTime = $.now(); // variable used to help normalize the scroll event speed of different devices
	
	    //Inherit some behaviors and properties
	    $.EventSource.call( this );
	
	    this.addHandler( 'open-failed', function ( event ) {
	        var msg = $.getString( "Errors.OpenFailed", event.eventSource, event.message);
	        _this._showMessage( msg );
	    });
	
	    $.ControlDock.call( this, options );
	
	    //Deal with tile sources
	    if (this.xmlPath) {
	        //Deprecated option.  Now it is preferred to use the tileSources option
	        this.tileSources = [ this.xmlPath ];
	    }
	
	    this.element              = this.element || document.getElementById( this.id );
	    this.canvas               = $.makeNeutralElement( "div" );
	
	    this.canvas.className = "openseadragon-canvas";
	    (function( style ){
	        style.width    = "100%";
	        style.height   = "100%";
	        style.overflow = "hidden";
	        style.position = "absolute";
	        style.top      = "0px";
	        style.left     = "0px";
	    }(this.canvas.style));
	    $.setElementTouchActionNone( this.canvas );
	    if (options.tabIndex !== "") {
	        this.canvas.tabIndex = (options.tabIndex === undefined ? 0 : options.tabIndex);
	    }
	
	    //the container is created through applying the ControlDock constructor above
	    this.container.className = "openseadragon-container";
	    (function( style ){
	        style.width     = "100%";
	        style.height    = "100%";
	        style.position  = "relative";
	        style.overflow  = "hidden";
	        style.left      = "0px";
	        style.top       = "0px";
	        style.textAlign = "left";  // needed to protect against
	    }( this.container.style ));
	
	    this.container.insertBefore( this.canvas, this.container.firstChild );
	    this.element.appendChild( this.container );
	
	    //Used for toggling between fullscreen and default container size
	    //TODO: these can be closure private and shared across Viewer
	    //      instances.
	    this.bodyWidth      = document.body.style.width;
	    this.bodyHeight     = document.body.style.height;
	    this.bodyOverflow   = document.body.style.overflow;
	    this.docOverflow    = document.documentElement.style.overflow;
	
	    this.innerTracker = new $.MouseTracker({
	        element:                  this.canvas,
	        startDisabled:            !this.mouseNavEnabled,
	        clickTimeThreshold:       this.clickTimeThreshold,
	        clickDistThreshold:       this.clickDistThreshold,
	        dblClickTimeThreshold:    this.dblClickTimeThreshold,
	        dblClickDistThreshold:    this.dblClickDistThreshold,
	        keyDownHandler:           $.delegate( this, onCanvasKeyDown ),
	        keyHandler:               $.delegate( this, onCanvasKeyPress ),
	        clickHandler:             $.delegate( this, onCanvasClick ),
	        dblClickHandler:          $.delegate( this, onCanvasDblClick ),
	        dragHandler:              $.delegate( this, onCanvasDrag ),
	        dragEndHandler:           $.delegate( this, onCanvasDragEnd ),
	        enterHandler:             $.delegate( this, onCanvasEnter ),
	        exitHandler:              $.delegate( this, onCanvasExit ),
	        pressHandler:             $.delegate( this, onCanvasPress ),
	        releaseHandler:           $.delegate( this, onCanvasRelease ),
	        nonPrimaryPressHandler:   $.delegate( this, onCanvasNonPrimaryPress ),
	        nonPrimaryReleaseHandler: $.delegate( this, onCanvasNonPrimaryRelease ),
	        scrollHandler:            $.delegate( this, onCanvasScroll ),
	        pinchHandler:             $.delegate( this, onCanvasPinch )
	    });
	
	    this.outerTracker = new $.MouseTracker({
	        element:               this.container,
	        startDisabled:         !this.mouseNavEnabled,
	        clickTimeThreshold:    this.clickTimeThreshold,
	        clickDistThreshold:    this.clickDistThreshold,
	        dblClickTimeThreshold: this.dblClickTimeThreshold,
	        dblClickDistThreshold: this.dblClickDistThreshold,
	        enterHandler:          $.delegate( this, onContainerEnter ),
	        exitHandler:           $.delegate( this, onContainerExit )
	    });
	
	    if( this.toolbar ){
	        this.toolbar = new $.ControlDock({ element: this.toolbar });
	    }
	
	    this.bindStandardControls();
	
	    THIS[ this.hash ].prevContainerSize = _getSafeElemSize( this.container );
	
	    // Create the world
	    this.world = new $.World({
	        viewer: this
	    });
	
	    this.world.addHandler('add-item', function(event) {
	        // For backwards compatibility, we maintain the source property
	        _this.source = _this.world.getItemAt(0).source;
	
	        THIS[ _this.hash ].forceRedraw = true;
	
	        if (!_this._updateRequestId) {
	            _this._updateRequestId = scheduleUpdate( _this, updateMulti );
	        }
	    });
	
	    this.world.addHandler('remove-item', function(event) {
	        // For backwards compatibility, we maintain the source property
	        if (_this.world.getItemCount()) {
	            _this.source = _this.world.getItemAt(0).source;
	        } else {
	            _this.source = null;
	        }
	
	        THIS[ _this.hash ].forceRedraw = true;
	    });
	
	    this.world.addHandler('metrics-change', function(event) {
	        if (_this.viewport) {
	            _this.viewport._setContentBounds(_this.world.getHomeBounds(), _this.world.getContentFactor());
	        }
	    });
	
	    this.world.addHandler('item-index-change', function(event) {
	        // For backwards compatibility, we maintain the source property
	        _this.source = _this.world.getItemAt(0).source;
	    });
	
	    // Create the viewport
	    this.viewport = new $.Viewport({
	        containerSize:      THIS[ this.hash ].prevContainerSize,
	        springStiffness:    this.springStiffness,
	        animationTime:      this.animationTime,
	        minZoomImageRatio:  this.minZoomImageRatio,
	        maxZoomPixelRatio:  this.maxZoomPixelRatio,
	        visibilityRatio:    this.visibilityRatio,
	        wrapHorizontal:     this.wrapHorizontal,
	        wrapVertical:       this.wrapVertical,
	        defaultZoomLevel:   this.defaultZoomLevel,
	        minZoomLevel:       this.minZoomLevel,
	        maxZoomLevel:       this.maxZoomLevel,
	        viewer:             this,
	        degrees:            this.degrees,
	        flipped:            this.flipped,
	        navigatorRotate:    this.navigatorRotate,
	        homeFillsViewer:    this.homeFillsViewer,
	        margins:            this.viewportMargins
	    });
	
	    this.viewport._setContentBounds(this.world.getHomeBounds(), this.world.getContentFactor());
	
	    // Create the image loader
	    this.imageLoader = new $.ImageLoader({
	        jobLimit: this.imageLoaderLimit,
	        timeout: options.timeout
	    });
	
	    // Create the tile cache
	    this.tileCache = new $.TileCache({
	        maxImageCacheCount: this.maxImageCacheCount
	    });
	
	    // Create the drawer
	    this.drawer = new $.Drawer({
	        viewer:             this,
	        viewport:           this.viewport,
	        element:            this.canvas,
	        debugGridColor:     this.debugGridColor
	    });
	
	    // Overlay container
	    this.overlaysContainer    = $.makeNeutralElement( "div" );
	    this.canvas.appendChild( this.overlaysContainer );
	
	    // Now that we have a drawer, see if it supports rotate. If not we need to remove the rotate buttons
	    if (!this.drawer.canRotate()) {
	        // Disable/remove the rotate left/right buttons since they aren't supported
	        if (this.rotateLeft) {
	            i = this.buttons.buttons.indexOf(this.rotateLeft);
	            this.buttons.buttons.splice(i, 1);
	            this.buttons.element.removeChild(this.rotateLeft.element);
	        }
	        if (this.rotateRight) {
	            i = this.buttons.buttons.indexOf(this.rotateRight);
	            this.buttons.buttons.splice(i, 1);
	            this.buttons.element.removeChild(this.rotateRight.element);
	        }
	    }
	
	    //Instantiate a navigator if configured
	    if ( this.showNavigator){
	        this.navigator = new $.Navigator({
	            id:                this.navigatorId,
	            position:          this.navigatorPosition,
	            sizeRatio:         this.navigatorSizeRatio,
	            maintainSizeRatio: this.navigatorMaintainSizeRatio,
	            top:               this.navigatorTop,
	            left:              this.navigatorLeft,
	            width:             this.navigatorWidth,
	            height:            this.navigatorHeight,
	            autoResize:        this.navigatorAutoResize,
	            autoFade:          this.navigatorAutoFade,
	            prefixUrl:         this.prefixUrl,
	            viewer:            this,
	            navigatorRotate:   this.navigatorRotate,
	            background:        this.navigatorBackground,
	            opacity:           this.navigatorOpacity,
	            borderColor:       this.navigatorBorderColor,
	            displayRegionColor: this.navigatorDisplayRegionColor,
	            crossOriginPolicy: this.crossOriginPolicy
	        });
	    }
	
	    // Sequence mode
	    if (this.sequenceMode) {
	        this.bindSequenceControls();
	    }
	
	    // Open initial tilesources
	    if (this.tileSources) {
	        this.open( this.tileSources );
	    }
	
	    // Add custom controls
	    for ( i = 0; i < this.customControls.length; i++ ) {
	        this.addControl(
	            this.customControls[ i ].id,
	            {anchor: this.customControls[ i ].anchor}
	        );
	    }
	
	    // Initial fade out
	    $.requestAnimationFrame( function(){
	        beginControlsAutoHide( _this );
	    } );
	};
	
	$.extend( $.Viewer.prototype, $.EventSource.prototype, $.ControlDock.prototype, /** @lends OpenSeadragon.Viewer.prototype */{
	
	
	    /**
	     * @function
	     * @return {Boolean}
	     */
	    isOpen: function () {
	        return !!this.world.getItemCount();
	    },
	
	    // deprecated
	    openDzi: function ( dzi ) {
	        $.console.error( "[Viewer.openDzi] this function is deprecated; use Viewer.open() instead." );
	        return this.open( dzi );
	    },
	
	    // deprecated
	    openTileSource: function ( tileSource ) {
	        $.console.error( "[Viewer.openTileSource] this function is deprecated; use Viewer.open() instead." );
	        return this.open( tileSource );
	    },
	
	    /**
	     * Open tiled images into the viewer, closing any others.
	     * To get the TiledImage instance created by open, add an event listener for
	     * {@link OpenSeadragon.Viewer.html#.event:open}, which when fired can be used to get access
	     * to the instance, i.e., viewer.world.getItemAt(0).
	     * @function
	     * @param {Array|String|Object|Function} tileSources - This can be a TiledImage
	     * specifier, a TileSource specifier, or an array of either. A TiledImage specifier
	     * is the same as the options parameter for {@link OpenSeadragon.Viewer#addTiledImage},
	     * except for the index property; images are added in sequence.
	     * A TileSource specifier is anything you could pass as the tileSource property
	     * of the options parameter for {@link OpenSeadragon.Viewer#addTiledImage}.
	     * @param {Number} initialPage - If sequenceMode is true, display this page initially
	     * for the given tileSources. If specified, will overwrite the Viewer's existing initialPage property.
	     * @return {OpenSeadragon.Viewer} Chainable.
	     * @fires OpenSeadragon.Viewer.event:open
	     * @fires OpenSeadragon.Viewer.event:open-failed
	     */
	    open: function (tileSources, initialPage) {
	        var _this = this;
	
	        this.close();
	
	        if (!tileSources) {
	            return;
	        }
	
	        if (this.sequenceMode && $.isArray(tileSources)) {
	            if (this.referenceStrip) {
	                this.referenceStrip.destroy();
	                this.referenceStrip = null;
	            }
	
	            if (typeof initialPage != 'undefined' && !isNaN(initialPage)) {
	              this.initialPage = initialPage;
	            }
	
	            this.tileSources = tileSources;
	            this._sequenceIndex = Math.max(0, Math.min(this.tileSources.length - 1, this.initialPage));
	            if (this.tileSources.length) {
	                this.open(this.tileSources[this._sequenceIndex]);
	
	                if ( this.showReferenceStrip ){
	                    this.addReferenceStrip();
	                }
	            }
	
	            this._updateSequenceButtons( this._sequenceIndex );
	            return;
	        }
	
	        if (!$.isArray(tileSources)) {
	            tileSources = [tileSources];
	        }
	
	        if (!tileSources.length) {
	            return;
	        }
	
	        this._opening = true;
	
	        var expected = tileSources.length;
	        var successes = 0;
	        var failures = 0;
	        var failEvent;
	
	        var checkCompletion = function() {
	            if (successes + failures === expected) {
	                if (successes) {
	                    if (_this._firstOpen || !_this.preserveViewport) {
	                        _this.viewport.goHome( true );
	                        _this.viewport.update();
	                    }
	
	                    _this._firstOpen = false;
	
	                    var source = tileSources[0];
	                    if (source.tileSource) {
	                        source = source.tileSource;
	                    }
	
	                    // Global overlays
	                    if( _this.overlays && !_this.preserveOverlays ){
	                        for ( var i = 0; i < _this.overlays.length; i++ ) {
	                            _this.currentOverlays[ i ] = getOverlayObject( _this, _this.overlays[ i ] );
	                        }
	                    }
	
	                    _this._drawOverlays();
	                    _this._opening = false;
	
	                    /**
	                     * Raised when the viewer has opened and loaded one or more TileSources.
	                     *
	                     * @event open
	                     * @memberof OpenSeadragon.Viewer
	                     * @type {object}
	                     * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised the event.
	                     * @property {OpenSeadragon.TileSource} source - The tile source that was opened.
	                     * @property {?Object} userData - Arbitrary subscriber-defined object.
	                     */
	                    // TODO: what if there are multiple sources?
	                    _this.raiseEvent( 'open', { source: source } );
	                } else {
	                    _this._opening = false;
	
	                    /**
	                     * Raised when an error occurs loading a TileSource.
	                     *
	                     * @event open-failed
	                     * @memberof OpenSeadragon.Viewer
	                     * @type {object}
	                     * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised the event.
	                     * @property {String} message - Information about what failed.
	                     * @property {String} source - The tile source that failed.
	                     * @property {?Object} userData - Arbitrary subscriber-defined object.
	                     */
	                    _this.raiseEvent( 'open-failed', failEvent );
	                }
	            }
	        };
	
	        var doOne = function(options) {
	            if (!$.isPlainObject(options) || !options.tileSource) {
	                options = {
	                    tileSource: options
	                };
	            }
	
	            if (options.index !== undefined) {
	                $.console.error('[Viewer.open] setting indexes here is not supported; use addTiledImage instead');
	                delete options.index;
	            }
	
	            if (options.collectionImmediately === undefined) {
	                options.collectionImmediately = true;
	            }
	
	            var originalSuccess = options.success;
	            options.success = function(event) {
	                successes++;
	
	                // TODO: now that options has other things besides tileSource, the overlays
	                // should probably be at the options level, not the tileSource level.
	                if (options.tileSource.overlays) {
	                    for (var i = 0; i < options.tileSource.overlays.length; i++) {
	                        _this.addOverlay(options.tileSource.overlays[i]);
	                    }
	                }
	
	                if (originalSuccess) {
	                    originalSuccess(event);
	                }
	
	                checkCompletion();
	            };
	
	            var originalError = options.error;
	            options.error = function(event) {
	                failures++;
	
	                if (!failEvent) {
	                    failEvent = event;
	                }
	
	                if (originalError) {
	                    originalError(event);
	                }
	
	                checkCompletion();
	            };
	
	            _this.addTiledImage(options);
	        };
	
	        // TileSources
	        for (var i = 0; i < tileSources.length; i++) {
	            doOne(tileSources[i]);
	        }
	
	        return this;
	    },
	
	
	    /**
	     * @function
	     * @return {OpenSeadragon.Viewer} Chainable.
	     * @fires OpenSeadragon.Viewer.event:close
	     */
	    close: function ( ) {
	        if ( !THIS[ this.hash ] ) {
	            //this viewer has already been destroyed: returning immediately
	            return this;
	        }
	
	        this._opening = false;
	
	        if ( this.navigator ) {
	            this.navigator.close();
	        }
	
	        if (!this.preserveOverlays) {
	            this.clearOverlays();
	            this.overlaysContainer.innerHTML = "";
	        }
	
	        THIS[ this.hash ].animating = false;
	        this.world.removeAll();
	        this.imageLoader.clear();
	
	        /**
	         * Raised when the viewer is closed (see {@link OpenSeadragon.Viewer#close}).
	         *
	         * @event close
	         * @memberof OpenSeadragon.Viewer
	         * @type {object}
	         * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised the event.
	         * @property {?Object} userData - Arbitrary subscriber-defined object.
	         */
	        this.raiseEvent( 'close' );
	
	        return this;
	    },
	
	
	    /**
	     * Function to destroy the viewer and clean up everything created by OpenSeadragon.
	     *
	     * Example:
	     * var viewer = OpenSeadragon({
	     *   [...]
	     * });
	     *
	     * //when you are done with the viewer:
	     * viewer.destroy();
	     * viewer = null; //important
	     *
	     * @function
	     */
	    destroy: function( ) {
	        if ( !THIS[ this.hash ] ) {
	            //this viewer has already been destroyed: returning immediately
	            return;
	        }
	
	        this.close();
	
	        this.clearOverlays();
	        this.overlaysContainer.innerHTML = "";
	
	        //TODO: implement this...
	        //this.unbindSequenceControls()
	        //this.unbindStandardControls()
	
	        if (this.referenceStrip) {
	            this.referenceStrip.destroy();
	            this.referenceStrip = null;
	        }
	
	        if ( this._updateRequestId !== null ) {
	            $.cancelAnimationFrame( this._updateRequestId );
	            this._updateRequestId = null;
	        }
	
	        if ( this.drawer ) {
	            this.drawer.destroy();
	        }
	
	        this.removeAllHandlers();
	
	        // Go through top element (passed to us) and remove all children
	        // Use removeChild to make sure it handles SVG or any non-html
	        // also it performs better - http://jsperf.com/innerhtml-vs-removechild/15
	        if (this.element){
	            while (this.element.firstChild) {
	                this.element.removeChild(this.element.firstChild);
	            }
	        }
	
	        // destroy the mouse trackers
	        if (this.innerTracker){
	            this.innerTracker.destroy();
	        }
	        if (this.outerTracker){
	            this.outerTracker.destroy();
	        }
	
	        THIS[ this.hash ] = null;
	        delete THIS[ this.hash ];
	
	        // clear all our references to dom objects
	        this.canvas = null;
	        this.container = null;
	
	        // clear our reference to the main element - they will need to pass it in again, creating a new viewer
	        this.element = null;
	    },
	
	    /**
	     * @function
	     * @return {Boolean}
	     */
	    isMouseNavEnabled: function () {
	        return this.innerTracker.isTracking();
	    },
	
	    /**
	     * @function
	     * @param {Boolean} enabled - true to enable, false to disable
	     * @return {OpenSeadragon.Viewer} Chainable.
	     * @fires OpenSeadragon.Viewer.event:mouse-enabled
	     */
	    setMouseNavEnabled: function( enabled ){
	        this.innerTracker.setTracking( enabled );
	        this.outerTracker.setTracking( enabled );
	        /**
	         * Raised when mouse/touch navigation is enabled or disabled (see {@link OpenSeadragon.Viewer#setMouseNavEnabled}).
	         *
	         * @event mouse-enabled
	         * @memberof OpenSeadragon.Viewer
	         * @type {object}
	         * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised the event.
	         * @property {Boolean} enabled
	         * @property {?Object} userData - Arbitrary subscriber-defined object.
	         */
	        this.raiseEvent( 'mouse-enabled', { enabled: enabled } );
	        return this;
	    },
	
	
	    /**
	     * @function
	     * @return {Boolean}
	     */
	    areControlsEnabled: function () {
	        var enabled = this.controls.length,
	            i;
	        for( i = 0; i < this.controls.length; i++ ){
	            enabled = enabled && this.controls[ i ].isVisibile();
	        }
	        return enabled;
	    },
	
	
	    /**
	     * Shows or hides the controls (e.g. the default navigation buttons).
	     *
	     * @function
	     * @param {Boolean} true to show, false to hide.
	     * @return {OpenSeadragon.Viewer} Chainable.
	     * @fires OpenSeadragon.Viewer.event:controls-enabled
	     */
	    setControlsEnabled: function( enabled ) {
	        if( enabled ){
	            abortControlsAutoHide( this );
	        } else {
	            beginControlsAutoHide( this );
	        }
	        /**
	         * Raised when the navigation controls are shown or hidden (see {@link OpenSeadragon.Viewer#setControlsEnabled}).
	         *
	         * @event controls-enabled
	         * @memberof OpenSeadragon.Viewer
	         * @type {object}
	         * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised the event.
	         * @property {Boolean} enabled
	         * @property {?Object} userData - Arbitrary subscriber-defined object.
	         */
	        this.raiseEvent( 'controls-enabled', { enabled: enabled } );
	        return this;
	    },
	
	    /**
	     * Turns debugging mode on or off for this viewer.
	     *
	     * @function
	     * @param {Boolean} true to turn debug on, false to turn debug off.
	     */
	    setDebugMode: function(debugMode){
	
	        for (var i = 0; i < this.world.getItemCount(); i++) {
	            this.world.getItemAt(i).debugMode = debugMode;
	        }
	
	        this.debugMode = debugMode;
	        this.forceRedraw();
	    },
	
	    /**
	     * @function
	     * @return {Boolean}
	     */
	    isFullPage: function () {
	        return THIS[ this.hash ].fullPage;
	    },
	
	
	    /**
	     * Toggle full page mode.
	     * @function
	     * @param {Boolean} fullPage
	     *      If true, enter full page mode.  If false, exit full page mode.
	     * @return {OpenSeadragon.Viewer} Chainable.
	     * @fires OpenSeadragon.Viewer.event:pre-full-page
	     * @fires OpenSeadragon.Viewer.event:full-page
	     */
	    setFullPage: function( fullPage ) {
	
	        var body = document.body,
	            bodyStyle = body.style,
	            docStyle = document.documentElement.style,
	            _this = this,
	            nodes,
	            i;
	
	        //dont bother modifying the DOM if we are already in full page mode.
	        if ( fullPage == this.isFullPage() ) {
	            return this;
	        }
	
	        var fullPageEventArgs = {
	            fullPage: fullPage,
	            preventDefaultAction: false
	        };
	        /**
	         * Raised when the viewer is about to change to/from full-page mode (see {@link OpenSeadragon.Viewer#setFullPage}).
	         *
	         * @event pre-full-page
	         * @memberof OpenSeadragon.Viewer
	         * @type {object}
	         * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised the event.
	         * @property {Boolean} fullPage - True if entering full-page mode, false if exiting full-page mode.
	         * @property {Boolean} preventDefaultAction - Set to true to prevent full-page mode change. Default: false.
	         * @property {?Object} userData - Arbitrary subscriber-defined object.
	         */
	        this.raiseEvent( 'pre-full-page', fullPageEventArgs );
	        if ( fullPageEventArgs.preventDefaultAction ) {
	            return this;
	        }
	
	        if ( fullPage ) {
	
	            this.elementSize = $.getElementSize( this.element );
	            this.pageScroll = $.getPageScroll();
	
	            this.elementMargin = this.element.style.margin;
	            this.element.style.margin = "0";
	            this.elementPadding = this.element.style.padding;
	            this.element.style.padding = "0";
	
	            this.bodyMargin = bodyStyle.margin;
	            this.docMargin = docStyle.margin;
	            bodyStyle.margin = "0";
	            docStyle.margin = "0";
	
	            this.bodyPadding = bodyStyle.padding;
	            this.docPadding = docStyle.padding;
	            bodyStyle.padding = "0";
	            docStyle.padding = "0";
	
	            this.bodyWidth = bodyStyle.width;
	            this.docWidth = docStyle.width;
	            bodyStyle.width = "100%";
	            docStyle.width = "100%";
	
	            this.bodyHeight = bodyStyle.height;
	            this.docHeight = docStyle.height;
	            bodyStyle.height = "100%";
	            docStyle.height = "100%";
	
	            //when entering full screen on the ipad it wasnt sufficient to leave
	            //the body intact as only only the top half of the screen would
	            //respond to touch events on the canvas, while the bottom half treated
	            //them as touch events on the document body.  Thus we remove and store
	            //the bodies elements and replace them when we leave full screen.
	            this.previousBody = [];
	            THIS[ this.hash ].prevElementParent = this.element.parentNode;
	            THIS[ this.hash ].prevNextSibling = this.element.nextSibling;
	            THIS[ this.hash ].prevElementWidth = this.element.style.width;
	            THIS[ this.hash ].prevElementHeight = this.element.style.height;
	            nodes = body.childNodes.length;
	            for ( i = 0; i < nodes; i++ ) {
	                this.previousBody.push( body.childNodes[ 0 ] );
	                body.removeChild( body.childNodes[ 0 ] );
	            }
	
	            //If we've got a toolbar, we need to enable the user to use css to
	            //preserve it in fullpage mode
	            if ( this.toolbar && this.toolbar.element ) {
	                //save a reference to the parent so we can put it back
	                //in the long run we need a better strategy
	                this.toolbar.parentNode = this.toolbar.element.parentNode;
	                this.toolbar.nextSibling = this.toolbar.element.nextSibling;
	                body.appendChild( this.toolbar.element );
	
	                //Make sure the user has some ability to style the toolbar based
	                //on the mode
	                $.addClass( this.toolbar.element, 'fullpage' );
	            }
	
	            $.addClass( this.element, 'fullpage' );
	            body.appendChild( this.element );
	
	            this.element.style.height = $.getWindowSize().y + 'px';
	            this.element.style.width = $.getWindowSize().x + 'px';
	
	            if ( this.toolbar && this.toolbar.element ) {
	                this.element.style.height = (
	                    $.getElementSize( this.element ).y - $.getElementSize( this.toolbar.element ).y
	                ) + 'px';
	            }
	
	            THIS[ this.hash ].fullPage = true;
	
	            // mouse will be inside container now
	            $.delegate( this, onContainerEnter )( {} );
	
	        } else {
	
	            this.element.style.margin = this.elementMargin;
	            this.element.style.padding = this.elementPadding;
	
	            bodyStyle.margin = this.bodyMargin;
	            docStyle.margin = this.docMargin;
	
	            bodyStyle.padding = this.bodyPadding;
	            docStyle.padding = this.docPadding;
	
	            bodyStyle.width = this.bodyWidth;
	            docStyle.width = this.docWidth;
	
	            bodyStyle.height = this.bodyHeight;
	            docStyle.height = this.docHeight;
	
	            body.removeChild( this.element );
	            nodes = this.previousBody.length;
	            for ( i = 0; i < nodes; i++ ) {
	                body.appendChild( this.previousBody.shift() );
	            }
	
	            $.removeClass( this.element, 'fullpage' );
	            THIS[ this.hash ].prevElementParent.insertBefore(
	                this.element,
	                THIS[ this.hash ].prevNextSibling
	            );
	
	            //If we've got a toolbar, we need to enable the user to use css to
	            //reset it to its original state
	            if ( this.toolbar && this.toolbar.element ) {
	                body.removeChild( this.toolbar.element );
	
	                //Make sure the user has some ability to style the toolbar based
	                //on the mode
	                $.removeClass( this.toolbar.element, 'fullpage' );
	
	                this.toolbar.parentNode.insertBefore(
	                    this.toolbar.element,
	                    this.toolbar.nextSibling
	                );
	                delete this.toolbar.parentNode;
	                delete this.toolbar.nextSibling;
	            }
	
	            this.element.style.width = THIS[ this.hash ].prevElementWidth;
	            this.element.style.height = THIS[ this.hash ].prevElementHeight;
	
	            // After exiting fullPage or fullScreen, it can take some time
	            // before the browser can actually set the scroll.
	            var restoreScrollCounter = 0;
	            var restoreScroll = function() {
	                $.setPageScroll( _this.pageScroll );
	                var pageScroll = $.getPageScroll();
	                restoreScrollCounter++;
	                if (restoreScrollCounter < 10 &&
	                    (pageScroll.x !== _this.pageScroll.x ||
	                    pageScroll.y !== _this.pageScroll.y)) {
	                    $.requestAnimationFrame( restoreScroll );
	                }
	            };
	            $.requestAnimationFrame( restoreScroll );
	
	            THIS[ this.hash ].fullPage = false;
	
	            // mouse will likely be outside now
	            $.delegate( this, onContainerExit )( { } );
	
	        }
	
	        if ( this.navigator && this.viewport ) {
	            this.navigator.update( this.viewport );
	        }
	
	        /**
	         * Raised when the viewer has changed to/from full-page mode (see {@link OpenSeadragon.Viewer#setFullPage}).
	         *
	         * @event full-page
	         * @memberof OpenSeadragon.Viewer
	         * @type {object}
	         * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised the event.
	         * @property {Boolean} fullPage - True if changed to full-page mode, false if exited full-page mode.
	         * @property {?Object} userData - Arbitrary subscriber-defined object.
	         */
	        this.raiseEvent( 'full-page', { fullPage: fullPage } );
	
	        return this;
	    },
	
	    /**
	     * Toggle full screen mode if supported. Toggle full page mode otherwise.
	     * @function
	     * @param {Boolean} fullScreen
	     *      If true, enter full screen mode.  If false, exit full screen mode.
	     * @return {OpenSeadragon.Viewer} Chainable.
	     * @fires OpenSeadragon.Viewer.event:pre-full-screen
	     * @fires OpenSeadragon.Viewer.event:full-screen
	     */
	    setFullScreen: function( fullScreen ) {
	        var _this = this;
	
	        if ( !$.supportsFullScreen ) {
	            return this.setFullPage( fullScreen );
	        }
	
	        if ( $.isFullScreen() === fullScreen ) {
	            return this;
	        }
	
	        var fullScreeEventArgs = {
	            fullScreen: fullScreen,
	            preventDefaultAction: false
	        };
	        /**
	         * Raised when the viewer is about to change to/from full-screen mode (see {@link OpenSeadragon.Viewer#setFullScreen}).
	         * Note: the pre-full-screen event is not raised when the user is exiting
	         * full-screen mode by pressing the Esc key. In that case, consider using
	         * the full-screen, pre-full-page or full-page events.
	         *
	         * @event pre-full-screen
	         * @memberof OpenSeadragon.Viewer
	         * @type {object}
	         * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised the event.
	         * @property {Boolean} fullScreen - True if entering full-screen mode, false if exiting full-screen mode.
	         * @property {Boolean} preventDefaultAction - Set to true to prevent full-screen mode change. Default: false.
	         * @property {?Object} userData - Arbitrary subscriber-defined object.
	         */
	        this.raiseEvent( 'pre-full-screen', fullScreeEventArgs );
	        if ( fullScreeEventArgs.preventDefaultAction ) {
	            return this;
	        }
	
	        if ( fullScreen ) {
	
	            this.setFullPage( true );
	            // If the full page mode is not actually entered, we need to prevent
	            // the full screen mode.
	            if ( !this.isFullPage() ) {
	                return this;
	            }
	
	            this.fullPageStyleWidth = this.element.style.width;
	            this.fullPageStyleHeight = this.element.style.height;
	            this.element.style.width = '100%';
	            this.element.style.height = '100%';
	
	            var onFullScreenChange = function() {
	                var isFullScreen = $.isFullScreen();
	                if ( !isFullScreen ) {
	                    $.removeEvent( document, $.fullScreenEventName, onFullScreenChange );
	                    $.removeEvent( document, $.fullScreenErrorEventName, onFullScreenChange );
	
	                    _this.setFullPage( false );
	                    if ( _this.isFullPage() ) {
	                        _this.element.style.width = _this.fullPageStyleWidth;
	                        _this.element.style.height = _this.fullPageStyleHeight;
	                    }
	                }
	                if ( _this.navigator && _this.viewport ) {
	                    _this.navigator.update( _this.viewport );
	                }
	                /**
	                 * Raised when the viewer has changed to/from full-screen mode (see {@link OpenSeadragon.Viewer#setFullScreen}).
	                 *
	                 * @event full-screen
	                 * @memberof OpenSeadragon.Viewer
	                 * @type {object}
	                 * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised the event.
	                 * @property {Boolean} fullScreen - True if changed to full-screen mode, false if exited full-screen mode.
	                 * @property {?Object} userData - Arbitrary subscriber-defined object.
	                 */
	                _this.raiseEvent( 'full-screen', { fullScreen: isFullScreen } );
	            };
	            $.addEvent( document, $.fullScreenEventName, onFullScreenChange );
	            $.addEvent( document, $.fullScreenErrorEventName, onFullScreenChange );
	
	            $.requestFullScreen( document.body );
	
	        } else {
	            $.exitFullScreen();
	        }
	        return this;
	    },
	
	    /**
	     * @function
	     * @return {Boolean}
	     */
	    isVisible: function () {
	        return this.container.style.visibility != "hidden";
	    },
	
	
	    /**
	     * @function
	     * @param {Boolean} visible
	     * @return {OpenSeadragon.Viewer} Chainable.
	     * @fires OpenSeadragon.Viewer.event:visible
	     */
	    setVisible: function( visible ){
	        this.container.style.visibility = visible ? "" : "hidden";
	        /**
	         * Raised when the viewer is shown or hidden (see {@link OpenSeadragon.Viewer#setVisible}).
	         *
	         * @event visible
	         * @memberof OpenSeadragon.Viewer
	         * @type {object}
	         * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised the event.
	         * @property {Boolean} visible
	         * @property {?Object} userData - Arbitrary subscriber-defined object.
	         */
	        this.raiseEvent( 'visible', { visible: visible } );
	        return this;
	    },
	
	    /**
	     * Add a tiled image to the viewer.
	     * options.tileSource can be anything that {@link OpenSeadragon.Viewer#open}
	     *  supports except arrays of images.
	     * Note that you can specify options.width or options.height, but not both.
	     * The other dimension will be calculated according to the item's aspect ratio.
	     * If collectionMode is on (see {@link OpenSeadragon.Options}), the new image is
	     * automatically arranged with the others.
	     * @function
	     * @param {Object} options
	     * @param {String|Object|Function} options.tileSource - The TileSource specifier.
	     * A String implies a url used to determine the tileSource implementation
	     *      based on the file extension of url. JSONP is implied by *.js,
	     *      otherwise the url is retrieved as text and the resulting text is
	     *      introspected to determine if its json, xml, or text and parsed.
	     * An Object implies an inline configuration which has a single
	     *      property sufficient for being able to determine tileSource
	     *      implementation. If the object has a property which is a function
	     *      named 'getTileUrl', it is treated as a custom TileSource.
	     * @param {Number} [options.index] The index of the item. Added on top of
	     * all other items if not specified.
	     * @param {Boolean} [options.replace=false] If true, the item at options.index will be
	     * removed and the new item is added in its place. options.tileSource will be
	     * interpreted and fetched if necessary before the old item is removed to avoid leaving
	     * a gap in the world.
	     * @param {Number} [options.x=0] The X position for the image in viewport coordinates.
	     * @param {Number} [options.y=0] The Y position for the image in viewport coordinates.
	     * @param {Number} [options.width=1] The width for the image in viewport coordinates.
	     * @param {Number} [options.height] The height for the image in viewport coordinates.
	     * @param {OpenSeadragon.Rect} [options.fitBounds] The bounds in viewport coordinates
	     * to fit the image into. If specified, x, y, width and height get ignored.
	     * @param {OpenSeadragon.Placement} [options.fitBoundsPlacement=OpenSeadragon.Placement.CENTER]
	     * How to anchor the image in the bounds if options.fitBounds is set.
	     * @param {OpenSeadragon.Rect} [options.clip] - An area, in image pixels, to clip to
	     * (portions of the image outside of this area will not be visible). Only works on
	     * browsers that support the HTML5 canvas.
	     * @param {Number} [options.opacity=1] Proportional opacity of the tiled images (1=opaque, 0=hidden)
	     * @param {Boolean} [options.preload=false]  Default switch for loading hidden images (true loads, false blocks)
	     * @param {Number} [options.degrees=0] Initial rotation of the tiled image around
	     * its top left corner in degrees.
	     * @param {String} [options.compositeOperation] How the image is composited onto other images.
	     * @param {String} [options.crossOriginPolicy] The crossOriginPolicy for this specific image,
	     * overriding viewer.crossOriginPolicy.
	     * @param {Boolean} [options.ajaxWithCredentials] Whether to set withCredentials on tile AJAX
	     * @param {Boolean} [options.loadTilesWithAjax]
	     *      Whether to load tile data using AJAX requests.
	     *      Defaults to the setting in {@link OpenSeadragon.Options}.
	     * @param {Object} [options.ajaxHeaders]
	     *      A set of headers to include when making tile AJAX requests.
	     *      Note that these headers will be merged over any headers specified in {@link OpenSeadragon.Options}.
	     *      Specifying a falsy value for a header will clear its existing value set at the Viewer level (if any).
	     * requests.
	     * @param {Function} [options.success] A function that gets called when the image is
	     * successfully added. It's passed the event object which contains a single property:
	     * "item", which is the resulting instance of TiledImage.
	     * @param {Function} [options.error] A function that gets called if the image is
	     * unable to be added. It's passed the error event object, which contains "message"
	     * and "source" properties.
	     * @param {Boolean} [options.collectionImmediately=false] If collectionMode is on,
	     * specifies whether to snap to the new arrangement immediately or to animate to it.
	     * @param {String|CanvasGradient|CanvasPattern|Function} [options.placeholderFillStyle] - See {@link OpenSeadragon.Options}.
	     * @fires OpenSeadragon.World.event:add-item
	     * @fires OpenSeadragon.Viewer.event:add-item-failed
	     */
	    addTiledImage: function( options ) {
	        $.console.assert(options, "[Viewer.addTiledImage] options is required");
	        $.console.assert(options.tileSource, "[Viewer.addTiledImage] options.tileSource is required");
	        $.console.assert(!options.replace || (options.index > -1 && options.index < this.world.getItemCount()),
	            "[Viewer.addTiledImage] if options.replace is used, options.index must be a valid index in Viewer.world");
	
	        var _this = this;
	
	        if (options.replace) {
	            options.replaceItem = _this.world.getItemAt(options.index);
	        }
	
	        this._hideMessage();
	
	        if (options.placeholderFillStyle === undefined) {
	            options.placeholderFillStyle = this.placeholderFillStyle;
	        }
	        if (options.opacity === undefined) {
	            options.opacity = this.opacity;
	        }
	        if (options.preload === undefined) {
	            options.preload = this.preload;
	        }
	        if (options.compositeOperation === undefined) {
	            options.compositeOperation = this.compositeOperation;
	        }
	        if (options.crossOriginPolicy === undefined) {
	            options.crossOriginPolicy = options.tileSource.crossOriginPolicy !== undefined ? options.tileSource.crossOriginPolicy : this.crossOriginPolicy;
	        }
	        if (options.ajaxWithCredentials === undefined) {
	            options.ajaxWithCredentials = this.ajaxWithCredentials;
	        }
	        if (options.loadTilesWithAjax === undefined) {
	            options.loadTilesWithAjax = this.loadTilesWithAjax;
	        }
	        if (options.ajaxHeaders === undefined || options.ajaxHeaders === null) {
	            options.ajaxHeaders = this.ajaxHeaders;
	        } else if ($.isPlainObject(options.ajaxHeaders) && $.isPlainObject(this.ajaxHeaders)) {
	            options.ajaxHeaders = $.extend({}, this.ajaxHeaders, options.ajaxHeaders);
	        }
	
	        var myQueueItem = {
	            options: options
	        };
	
	        function raiseAddItemFailed( event ) {
	            for (var i = 0; i < _this._loadQueue.length; i++) {
	                if (_this._loadQueue[i] === myQueueItem) {
	                    _this._loadQueue.splice(i, 1);
	                    break;
	                }
	            }
	
	            if (_this._loadQueue.length === 0) {
	                refreshWorld(myQueueItem);
	            }
	
	             /**
	             * Raised when an error occurs while adding a item.
	             * @event add-item-failed
	             * @memberOf OpenSeadragon.Viewer
	             * @type {object}
	             * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised the event.
	             * @property {String} message
	             * @property {String} source
	             * @property {Object} options The options passed to the addTiledImage method.
	             * @property {?Object} userData - Arbitrary subscriber-defined object.
	             */
	            _this.raiseEvent( 'add-item-failed', event );
	
	            if (options.error) {
	                options.error(event);
	            }
	        }
	
	        function refreshWorld(theItem) {
	            if (_this.collectionMode) {
	                _this.world.arrange({
	                    immediately: theItem.options.collectionImmediately,
	                    rows: _this.collectionRows,
	                    columns: _this.collectionColumns,
	                    layout: _this.collectionLayout,
	                    tileSize: _this.collectionTileSize,
	                    tileMargin: _this.collectionTileMargin
	                });
	                _this.world.setAutoRefigureSizes(true);
	            }
	        }
	
	        if ($.isArray(options.tileSource)) {
	            setTimeout(function() {
	                raiseAddItemFailed({
	                    message: "[Viewer.addTiledImage] Sequences can not be added; add them one at a time instead.",
	                    source: options.tileSource,
	                    options: options
	                });
	            });
	            return;
	        }
	
	        this._loadQueue.push(myQueueItem);
	
	        function processReadyItems() {
	            var queueItem, tiledImage, optionsClone;
	            while (_this._loadQueue.length) {
	                queueItem = _this._loadQueue[0];
	                if (!queueItem.tileSource) {
	                    break;
	                }
	
	                _this._loadQueue.splice(0, 1);
	
	                if (queueItem.options.replace) {
	                    var newIndex = _this.world.getIndexOfItem(queueItem.options.replaceItem);
	                    if (newIndex != -1) {
	                        queueItem.options.index = newIndex;
	                    }
	                    _this.world.removeItem(queueItem.options.replaceItem);
	                }
	
	                tiledImage = new $.TiledImage({
	                    viewer: _this,
	                    source: queueItem.tileSource,
	                    viewport: _this.viewport,
	                    drawer: _this.drawer,
	                    tileCache: _this.tileCache,
	                    imageLoader: _this.imageLoader,
	                    x: queueItem.options.x,
	                    y: queueItem.options.y,
	                    width: queueItem.options.width,
	                    height: queueItem.options.height,
	                    fitBounds: queueItem.options.fitBounds,
	                    fitBoundsPlacement: queueItem.options.fitBoundsPlacement,
	                    clip: queueItem.options.clip,
	                    placeholderFillStyle: queueItem.options.placeholderFillStyle,
	                    opacity: queueItem.options.opacity,
	                    preload: queueItem.options.preload,
	                    degrees: queueItem.options.degrees,
	                    compositeOperation: queueItem.options.compositeOperation,
	                    springStiffness: _this.springStiffness,
	                    animationTime: _this.animationTime,
	                    minZoomImageRatio: _this.minZoomImageRatio,
	                    wrapHorizontal: _this.wrapHorizontal,
	                    wrapVertical: _this.wrapVertical,
	                    immediateRender: _this.immediateRender,
	                    blendTime: _this.blendTime,
	                    alwaysBlend: _this.alwaysBlend,
	                    minPixelRatio: _this.minPixelRatio,
	                    smoothTileEdgesMinZoom: _this.smoothTileEdgesMinZoom,
	                    iOSDevice: _this.iOSDevice,
	                    crossOriginPolicy: queueItem.options.crossOriginPolicy,
	                    ajaxWithCredentials: queueItem.options.ajaxWithCredentials,
	                    loadTilesWithAjax: queueItem.options.loadTilesWithAjax,
	                    ajaxHeaders: queueItem.options.ajaxHeaders,
	                    debugMode: _this.debugMode
	                });
	
	                if (_this.collectionMode) {
	                    _this.world.setAutoRefigureSizes(false);
	                }
	                _this.world.addItem( tiledImage, {
	                    index: queueItem.options.index
	                });
	
	                if (_this._loadQueue.length === 0) {
	                    //this restores the autoRefigureSizes flag to true.
	                    refreshWorld(queueItem);
	                }
	
	                if (_this.world.getItemCount() === 1 && !_this.preserveViewport) {
	                    _this.viewport.goHome(true);
	                }
	
	                if (_this.navigator) {
	                    optionsClone = $.extend({}, queueItem.options, {
	                        replace: false, // navigator already removed the layer, nothing to replace
	                        originalTiledImage: tiledImage,
	                        tileSource: queueItem.tileSource
	                    });
	
	                    _this.navigator.addTiledImage(optionsClone);
	                }
	
	                if (queueItem.options.success) {
	                    queueItem.options.success({
	                        item: tiledImage
	                    });
	                }
	            }
	        }
	
	        getTileSourceImplementation( this, options.tileSource, options, function( tileSource ) {
	
	            myQueueItem.tileSource = tileSource;
	
	            // add everybody at the front of the queue that's ready to go
	            processReadyItems();
	        }, function( event ) {
	            event.options = options;
	            raiseAddItemFailed(event);
	
	            // add everybody at the front of the queue that's ready to go
	            processReadyItems();
	        } );
	    },
	
	    /**
	     * Add a simple image to the viewer.
	     * The options are the same as the ones in {@link OpenSeadragon.Viewer#addTiledImage}
	     * except for options.tileSource which is replaced by options.url.
	     * @function
	     * @param {Object} options - See {@link OpenSeadragon.Viewer#addTiledImage}
	     * for all the options
	     * @param {String} options.url - The URL of the image to add.
	     * @fires OpenSeadragon.World.event:add-item
	     * @fires OpenSeadragon.Viewer.event:add-item-failed
	     */
	    addSimpleImage: function(options) {
	        $.console.assert(options, "[Viewer.addSimpleImage] options is required");
	        $.console.assert(options.url, "[Viewer.addSimpleImage] options.url is required");
	
	        var opts = $.extend({}, options, {
	            tileSource: {
	                type: 'image',
	                url:  options.url
	            }
	        });
	        delete opts.url;
	        this.addTiledImage(opts);
	    },
	
	    // deprecated
	    addLayer: function( options ) {
	        var _this = this;
	
	        $.console.error( "[Viewer.addLayer] this function is deprecated; use Viewer.addTiledImage() instead." );
	
	        var optionsClone = $.extend({}, options, {
	            success: function(event) {
	                _this.raiseEvent("add-layer", {
	                    options: options,
	                    drawer: event.item
	                });
	            },
	            error: function(event) {
	                _this.raiseEvent("add-layer-failed", event);
	            }
	        });
	
	        this.addTiledImage(optionsClone);
	        return this;
	    },
	
	    // deprecated
	    getLayerAtLevel: function( level ) {
	        $.console.error( "[Viewer.getLayerAtLevel] this function is deprecated; use World.getItemAt() instead." );
	        return this.world.getItemAt(level);
	    },
	
	    // deprecated
	    getLevelOfLayer: function( drawer ) {
	        $.console.error( "[Viewer.getLevelOfLayer] this function is deprecated; use World.getIndexOfItem() instead." );
	        return this.world.getIndexOfItem(drawer);
	    },
	
	    // deprecated
	    getLayersCount: function() {
	        $.console.error( "[Viewer.getLayersCount] this function is deprecated; use World.getItemCount() instead." );
	        return this.world.getItemCount();
	    },
	
	    // deprecated
	    setLayerLevel: function( drawer, level ) {
	        $.console.error( "[Viewer.setLayerLevel] this function is deprecated; use World.setItemIndex() instead." );
	        return this.world.setItemIndex(drawer, level);
	    },
	
	    // deprecated
	    removeLayer: function( drawer ) {
	        $.console.error( "[Viewer.removeLayer] this function is deprecated; use World.removeItem() instead." );
	        return this.world.removeItem(drawer);
	    },
	
	    /**
	     * Force the viewer to redraw its contents.
	     * @returns {OpenSeadragon.Viewer} Chainable.
	     */
	    forceRedraw: function() {
	        THIS[ this.hash ].forceRedraw = true;
	        return this;
	    },
	
	    /**
	     * @function
	     * @return {OpenSeadragon.Viewer} Chainable.
	     */
	    bindSequenceControls: function(){
	
	        //////////////////////////////////////////////////////////////////////////
	        // Image Sequence Controls
	        //////////////////////////////////////////////////////////////////////////
	        var onFocusHandler          = $.delegate( this, onFocus ),
	            onBlurHandler           = $.delegate( this, onBlur ),
	            onNextHandler           = $.delegate( this, onNext ),
	            onPreviousHandler       = $.delegate( this, onPrevious ),
	            navImages               = this.navImages,
	            useGroup                = true;
	
	        if( this.showSequenceControl ){
	
	            if( this.previousButton || this.nextButton ){
	                //if we are binding to custom buttons then layout and
	                //grouping is the responsibility of the page author
	                useGroup = false;
	            }
	
	            this.previousButton = new $.Button({
	                element:    this.previousButton ? $.getElement( this.previousButton ) : null,
	                clickTimeThreshold: this.clickTimeThreshold,
	                clickDistThreshold: this.clickDistThreshold,
	                tooltip:    $.getString( "Tooltips.PreviousPage" ),
	                srcRest:    resolveUrl( this.prefixUrl, navImages.previous.REST ),
	                srcGroup:   resolveUrl( this.prefixUrl, navImages.previous.GROUP ),
	                srcHover:   resolveUrl( this.prefixUrl, navImages.previous.HOVER ),
	                srcDown:    resolveUrl( this.prefixUrl, navImages.previous.DOWN ),
	                onRelease:  onPreviousHandler,
	                onFocus:    onFocusHandler,
	                onBlur:     onBlurHandler
	            });
	
	            this.nextButton = new $.Button({
	                element:    this.nextButton ? $.getElement( this.nextButton ) : null,
	                clickTimeThreshold: this.clickTimeThreshold,
	                clickDistThreshold: this.clickDistThreshold,
	                tooltip:    $.getString( "Tooltips.NextPage" ),
	                srcRest:    resolveUrl( this.prefixUrl, navImages.next.REST ),
	                srcGroup:   resolveUrl( this.prefixUrl, navImages.next.GROUP ),
	                srcHover:   resolveUrl( this.prefixUrl, navImages.next.HOVER ),
	                srcDown:    resolveUrl( this.prefixUrl, navImages.next.DOWN ),
	                onRelease:  onNextHandler,
	                onFocus:    onFocusHandler,
	                onBlur:     onBlurHandler
	            });
	
	            if( !this.navPrevNextWrap ){
	                this.previousButton.disable();
	            }
	
	            if (!this.tileSources || !this.tileSources.length) {
	                this.nextButton.disable();
	            }
	
	            if( useGroup ){
	                this.paging = new $.ButtonGroup({
	                    buttons: [
	                        this.previousButton,
	                        this.nextButton
	                    ],
	                    clickTimeThreshold: this.clickTimeThreshold,
	                    clickDistThreshold: this.clickDistThreshold
	                });
	
	                this.pagingControl = this.paging.element;
	
	                if( this.toolbar ){
	                    this.toolbar.addControl(
	                        this.pagingControl,
	                        {anchor: $.ControlAnchor.BOTTOM_RIGHT}
	                    );
	                }else{
	                    this.addControl(
	                        this.pagingControl,
	                        {anchor: this.sequenceControlAnchor || $.ControlAnchor.TOP_LEFT}
	                    );
	                }
	            }
	        }
	        return this;
	    },
	
	
	    /**
	     * @function
	     * @return {OpenSeadragon.Viewer} Chainable.
	     */
	    bindStandardControls: function(){
	        //////////////////////////////////////////////////////////////////////////
	        // Navigation Controls
	        //////////////////////////////////////////////////////////////////////////
	        var beginZoomingInHandler   = $.delegate( this, beginZoomingIn ),
	            endZoomingHandler       = $.delegate( this, endZooming ),
	            doSingleZoomInHandler   = $.delegate( this, doSingleZoomIn ),
	            beginZoomingOutHandler  = $.delegate( this, beginZoomingOut ),
	            doSingleZoomOutHandler  = $.delegate( this, doSingleZoomOut ),
	            onHomeHandler           = $.delegate( this, onHome ),
	            onFullScreenHandler     = $.delegate( this, onFullScreen ),
	            onRotateLeftHandler     = $.delegate( this, onRotateLeft ),
	            onRotateRightHandler    = $.delegate( this, onRotateRight ),
	            onFlipHandler           = $.delegate( this, onFlip),
	            onFocusHandler          = $.delegate( this, onFocus ),
	            onBlurHandler           = $.delegate( this, onBlur ),
	            navImages               = this.navImages,
	            buttons                 = [],
	            useGroup                = true;
	
	
	        if ( this.showNavigationControl ) {
	
	            if( this.zoomInButton || this.zoomOutButton ||
	                this.homeButton || this.fullPageButton ||
	                this.rotateLeftButton || this.rotateRightButton ||
	                this.flipButton ) {
	                //if we are binding to custom buttons then layout and
	                //grouping is the responsibility of the page author
	                useGroup = false;
	            }
	
	            if ( this.showZoomControl ) {
	                buttons.push( this.zoomInButton = new $.Button({
	                    element:    this.zoomInButton ? $.getElement( this.zoomInButton ) : null,
	                    clickTimeThreshold: this.clickTimeThreshold,
	                    clickDistThreshold: this.clickDistThreshold,
	                    tooltip:    $.getString( "Tooltips.ZoomIn" ),
	                    srcRest:    resolveUrl( this.prefixUrl, navImages.zoomIn.REST ),
	                    srcGroup:   resolveUrl( this.prefixUrl, navImages.zoomIn.GROUP ),
	                    srcHover:   resolveUrl( this.prefixUrl, navImages.zoomIn.HOVER ),
	                    srcDown:    resolveUrl( this.prefixUrl, navImages.zoomIn.DOWN ),
	                    onPress:    beginZoomingInHandler,
	                    onRelease:  endZoomingHandler,
	                    onClick:    doSingleZoomInHandler,
	                    onEnter:    beginZoomingInHandler,
	                    onExit:     endZoomingHandler,
	                    onFocus:    onFocusHandler,
	                    onBlur:     onBlurHandler
	                }));
	
	                buttons.push( this.zoomOutButton = new $.Button({
	                    element:    this.zoomOutButton ? $.getElement( this.zoomOutButton ) : null,
	                    clickTimeThreshold: this.clickTimeThreshold,
	                    clickDistThreshold: this.clickDistThreshold,
	                    tooltip:    $.getString( "Tooltips.ZoomOut" ),
	                    srcRest:    resolveUrl( this.prefixUrl, navImages.zoomOut.REST ),
	                    srcGroup:   resolveUrl( this.prefixUrl, navImages.zoomOut.GROUP ),
	                    srcHover:   resolveUrl( this.prefixUrl, navImages.zoomOut.HOVER ),
	                    srcDown:    resolveUrl( this.prefixUrl, navImages.zoomOut.DOWN ),
	                    onPress:    beginZoomingOutHandler,
	                    onRelease:  endZoomingHandler,
	                    onClick:    doSingleZoomOutHandler,
	                    onEnter:    beginZoomingOutHandler,
	                    onExit:     endZoomingHandler,
	                    onFocus:    onFocusHandler,
	                    onBlur:     onBlurHandler
	                }));
	            }
	
	            if ( this.showHomeControl ) {
	                buttons.push( this.homeButton = new $.Button({
	                    element:    this.homeButton ? $.getElement( this.homeButton ) : null,
	                    clickTimeThreshold: this.clickTimeThreshold,
	                    clickDistThreshold: this.clickDistThreshold,
	                    tooltip:    $.getString( "Tooltips.Home" ),
	                    srcRest:    resolveUrl( this.prefixUrl, navImages.home.REST ),
	                    srcGroup:   resolveUrl( this.prefixUrl, navImages.home.GROUP ),
	                    srcHover:   resolveUrl( this.prefixUrl, navImages.home.HOVER ),
	                    srcDown:    resolveUrl( this.prefixUrl, navImages.home.DOWN ),
	                    onRelease:  onHomeHandler,
	                    onFocus:    onFocusHandler,
	                    onBlur:     onBlurHandler
	                }));
	            }
	
	            if ( this.showFullPageControl ) {
	                buttons.push( this.fullPageButton = new $.Button({
	                    element:    this.fullPageButton ? $.getElement( this.fullPageButton ) : null,
	                    clickTimeThreshold: this.clickTimeThreshold,
	                    clickDistThreshold: this.clickDistThreshold,
	                    tooltip:    $.getString( "Tooltips.FullPage" ),
	                    srcRest:    resolveUrl( this.prefixUrl, navImages.fullpage.REST ),
	                    srcGroup:   resolveUrl( this.prefixUrl, navImages.fullpage.GROUP ),
	                    srcHover:   resolveUrl( this.prefixUrl, navImages.fullpage.HOVER ),
	                    srcDown:    resolveUrl( this.prefixUrl, navImages.fullpage.DOWN ),
	                    onRelease:  onFullScreenHandler,
	                    onFocus:    onFocusHandler,
	                    onBlur:     onBlurHandler
	                }));
	            }
	
	            if ( this.showRotationControl ) {
	                buttons.push( this.rotateLeftButton = new $.Button({
	                    element:    this.rotateLeftButton ? $.getElement( this.rotateLeftButton ) : null,
	                    clickTimeThreshold: this.clickTimeThreshold,
	                    clickDistThreshold: this.clickDistThreshold,
	                    tooltip:    $.getString( "Tooltips.RotateLeft" ),
	                    srcRest:    resolveUrl( this.prefixUrl, navImages.rotateleft.REST ),
	                    srcGroup:   resolveUrl( this.prefixUrl, navImages.rotateleft.GROUP ),
	                    srcHover:   resolveUrl( this.prefixUrl, navImages.rotateleft.HOVER ),
	                    srcDown:    resolveUrl( this.prefixUrl, navImages.rotateleft.DOWN ),
	                    onRelease:  onRotateLeftHandler,
	                    onFocus:    onFocusHandler,
	                    onBlur:     onBlurHandler
	                }));
	
	                buttons.push( this.rotateRightButton = new $.Button({
	                    element:    this.rotateRightButton ? $.getElement( this.rotateRightButton ) : null,
	                    clickTimeThreshold: this.clickTimeThreshold,
	                    clickDistThreshold: this.clickDistThreshold,
	                    tooltip:    $.getString( "Tooltips.RotateRight" ),
	                    srcRest:    resolveUrl( this.prefixUrl, navImages.rotateright.REST ),
	                    srcGroup:   resolveUrl( this.prefixUrl, navImages.rotateright.GROUP ),
	                    srcHover:   resolveUrl( this.prefixUrl, navImages.rotateright.HOVER ),
	                    srcDown:    resolveUrl( this.prefixUrl, navImages.rotateright.DOWN ),
	                    onRelease:  onRotateRightHandler,
	                    onFocus:    onFocusHandler,
	                    onBlur:     onBlurHandler
	                }));
	            }
	
	            if ( this.showFlipControl ) {
	                buttons.push( this.flipButton = new $.Button({
	                    element:    this.flipButton ? $.getElement( this.flipButton ) : null,
	                    clickTimeThreshold: this.clickTimeThreshold,
	                    clickDistThreshold: this.clickDistThreshold,
	                    tooltip:    $.getString( "Tooltips.Flip" ),
	                    srcRest:    resolveUrl( this.prefixUrl, navImages.flip.REST ),
	                    srcGroup:   resolveUrl( this.prefixUrl, navImages.flip.GROUP ),
	                    srcHover:   resolveUrl( this.prefixUrl, navImages.flip.HOVER ),
	                    srcDown:    resolveUrl( this.prefixUrl, navImages.flip.DOWN ),
	                    onRelease:  onFlipHandler,
	                    onFocus:    onFocusHandler,
	                    onBlur:     onBlurHandler
	                }));
	            }
	
	            if ( useGroup ) {
	                this.buttons = new $.ButtonGroup({
	                    buttons:            buttons,
	                    clickTimeThreshold: this.clickTimeThreshold,
	                    clickDistThreshold: this.clickDistThreshold
	                });
	
	                this.navControl  = this.buttons.element;
	                this.addHandler( 'open', $.delegate( this, lightUp ) );
	
	                if( this.toolbar ){
	                    this.toolbar.addControl(
	                        this.navControl,
	                        {anchor: this.navigationControlAnchor || $.ControlAnchor.TOP_LEFT}
	                    );
	                } else {
	                    this.addControl(
	                        this.navControl,
	                        {anchor: this.navigationControlAnchor || $.ControlAnchor.TOP_LEFT}
	                    );
	                }
	            }
	
	        }
	        return this;
	    },
	
	    /**
	     * Gets the active page of a sequence
	     * @function
	     * @return {Number}
	     */
	    currentPage: function() {
	        return this._sequenceIndex;
	    },
	
	    /**
	     * @function
	     * @return {OpenSeadragon.Viewer} Chainable.
	     * @fires OpenSeadragon.Viewer.event:page
	     */
	    goToPage: function( page ){
	        if( this.tileSources && page >= 0 && page < this.tileSources.length ){
	            this._sequenceIndex = page;
	
	            this._updateSequenceButtons( page );
	
	            this.open( this.tileSources[ page ] );
	
	            if( this.referenceStrip ){
	                this.referenceStrip.setFocus( page );
	            }
	
	            /**
	             * Raised when the page is changed on a viewer configured with multiple image sources (see {@link OpenSeadragon.Viewer#goToPage}).
	             *
	             * @event page
	             * @memberof OpenSeadragon.Viewer
	             * @type {Object}
	             * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised the event.
	             * @property {Number} page - The page index.
	             * @property {?Object} userData - Arbitrary subscriber-defined object.
	             */
	            this.raiseEvent( 'page', { page: page } );
	        }
	
	        return this;
	    },
	
	   /**
	     * Adds an html element as an overlay to the current viewport.  Useful for
	     * highlighting words or areas of interest on an image or other zoomable
	     * interface. The overlays added via this method are removed when the viewport
	     * is closed which include when changing page.
	     * @method
	     * @param {Element|String|Object} element - A reference to an element or an id for
	     *      the element which will be overlayed. Or an Object specifying the configuration for the overlay.
	     *      If using an object, see {@link OpenSeadragon.Overlay} for a list of
	     *      all available options.
	     * @param {OpenSeadragon.Point|OpenSeadragon.Rect} location - The point or
	     *      rectangle which will be overlayed. This is a viewport relative location.
	     * @param {OpenSeadragon.Placement} placement - The position of the
	     *      viewport which the location coordinates will be treated as relative
	     *      to.
	     * @param {function} onDraw - If supplied the callback is called when the overlay
	     *      needs to be drawn. It it the responsibility of the callback to do any drawing/positioning.
	     *      It is passed position, size and element.
	     * @return {OpenSeadragon.Viewer} Chainable.
	     * @fires OpenSeadragon.Viewer.event:add-overlay
	     */
	    addOverlay: function( element, location, placement, onDraw ) {
	        var options;
	        if( $.isPlainObject( element ) ){
	            options = element;
	        } else {
	            options = {
	                element: element,
	                location: location,
	                placement: placement,
	                onDraw: onDraw
	            };
	        }
	
	        element = $.getElement( options.element );
	
	        if ( getOverlayIndex( this.currentOverlays, element ) >= 0 ) {
	            // they're trying to add a duplicate overlay
	            return this;
	        }
	
	        var overlay = getOverlayObject( this, options);
	        this.currentOverlays.push(overlay);
	        overlay.drawHTML( this.overlaysContainer, this.viewport );
	
	        /**
	         * Raised when an overlay is added to the viewer (see {@link OpenSeadragon.Viewer#addOverlay}).
	         *
	         * @event add-overlay
	         * @memberof OpenSeadragon.Viewer
	         * @type {object}
	         * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised the event.
	         * @property {Element} element - The overlay element.
	         * @property {OpenSeadragon.Point|OpenSeadragon.Rect} location
	         * @property {OpenSeadragon.Placement} placement
	         * @property {?Object} userData - Arbitrary subscriber-defined object.
	         */
	        this.raiseEvent( 'add-overlay', {
	            element: element,
	            location: options.location,
	            placement: options.placement
	        });
	        return this;
	    },
	
	    /**
	     * Updates the overlay represented by the reference to the element or
	     * element id moving it to the new location, relative to the new placement.
	     * @method
	     * @param {Element|String} element - A reference to an element or an id for
	     *      the element which is overlayed.
	     * @param {OpenSeadragon.Point|OpenSeadragon.Rect} location - The point or
	     *      rectangle which will be overlayed. This is a viewport relative location.
	     * @param {OpenSeadragon.Placement} placement - The position of the
	     *      viewport which the location coordinates will be treated as relative
	     *      to.
	     * @return {OpenSeadragon.Viewer} Chainable.
	     * @fires OpenSeadragon.Viewer.event:update-overlay
	     */
	    updateOverlay: function( element, location, placement ) {
	        var i;
	
	        element = $.getElement( element );
	        i = getOverlayIndex( this.currentOverlays, element );
	
	        if ( i >= 0 ) {
	            this.currentOverlays[ i ].update( location, placement );
	            THIS[ this.hash ].forceRedraw = true;
	            /**
	             * Raised when an overlay's location or placement changes
	             * (see {@link OpenSeadragon.Viewer#updateOverlay}).
	             *
	             * @event update-overlay
	             * @memberof OpenSeadragon.Viewer
	             * @type {object}
	             * @property {OpenSeadragon.Viewer} eventSource - A reference to the
	             * Viewer which raised the event.
	             * @property {Element} element
	             * @property {OpenSeadragon.Point|OpenSeadragon.Rect} location
	             * @property {OpenSeadragon.Placement} placement
	             * @property {?Object} userData - Arbitrary subscriber-defined object.
	             */
	            this.raiseEvent( 'update-overlay', {
	                element: element,
	                location: location,
	                placement: placement
	            });
	        }
	        return this;
	    },
	
	    /**
	     * Removes an overlay identified by the reference element or element id
	     * and schedules an update.
	     * @method
	     * @param {Element|String} element - A reference to the element or an
	     *      element id which represent the ovelay content to be removed.
	     * @return {OpenSeadragon.Viewer} Chainable.
	     * @fires OpenSeadragon.Viewer.event:remove-overlay
	     */
	    removeOverlay: function( element ) {
	        var i;
	
	        element = $.getElement( element );
	        i = getOverlayIndex( this.currentOverlays, element );
	
	        if ( i >= 0 ) {
	            this.currentOverlays[ i ].destroy();
	            this.currentOverlays.splice( i, 1 );
	            THIS[ this.hash ].forceRedraw = true;
	            /**
	             * Raised when an overlay is removed from the viewer
	             * (see {@link OpenSeadragon.Viewer#removeOverlay}).
	             *
	             * @event remove-overlay
	             * @memberof OpenSeadragon.Viewer
	             * @type {object}
	             * @property {OpenSeadragon.Viewer} eventSource - A reference to the
	             * Viewer which raised the event.
	             * @property {Element} element - The overlay element.
	             * @property {?Object} userData - Arbitrary subscriber-defined object.
	             */
	            this.raiseEvent( 'remove-overlay', {
	                element: element
	            });
	        }
	        return this;
	    },
	
	    /**
	     * Removes all currently configured Overlays from this Viewer and schedules
	     * an update.
	     * @method
	     * @return {OpenSeadragon.Viewer} Chainable.
	     * @fires OpenSeadragon.Viewer.event:clear-overlay
	     */
	    clearOverlays: function() {
	        while ( this.currentOverlays.length > 0 ) {
	            this.currentOverlays.pop().destroy();
	        }
	        THIS[ this.hash ].forceRedraw = true;
	        /**
	         * Raised when all overlays are removed from the viewer (see {@link OpenSeadragon.Drawer#clearOverlays}).
	         *
	         * @event clear-overlay
	         * @memberof OpenSeadragon.Viewer
	         * @type {object}
	         * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised the event.
	         * @property {?Object} userData - Arbitrary subscriber-defined object.
	         */
	        this.raiseEvent( 'clear-overlay', {} );
	        return this;
	    },
	
	     /**
	     * Finds an overlay identified by the reference element or element id
	     * and returns it as an object, return null if not found.
	     * @method
	     * @param {Element|String} element - A reference to the element or an
	     *      element id which represents the overlay content.
	     * @return {OpenSeadragon.Overlay} the matching overlay or null if none found.
	     */
	    getOverlayById: function( element ) {
	        var i;
	
	        element = $.getElement( element );
	        i = getOverlayIndex( this.currentOverlays, element );
	
	        if (i >= 0) {
	            return this.currentOverlays[i];
	        } else {
	            return null;
	        }
	    },
	
	    /**
	     * Updates the sequence buttons.
	     * @function OpenSeadragon.Viewer.prototype._updateSequenceButtons
	     * @private
	     * @param {Number} Sequence Value
	     */
	    _updateSequenceButtons: function( page ) {
	
	            if ( this.nextButton ) {
	                if(!this.tileSources || this.tileSources.length - 1 === page) {
	                    //Disable next button
	                    if ( !this.navPrevNextWrap ) {
	                        this.nextButton.disable();
	                    }
	                } else {
	                    this.nextButton.enable();
	                }
	            }
	            if ( this.previousButton ) {
	                if ( page > 0 ) {
	                    //Enable previous button
	                    this.previousButton.enable();
	                } else {
	                    if ( !this.navPrevNextWrap ) {
	                        this.previousButton.disable();
	                    }
	                }
	            }
	      },
	
	    /**
	     * Display a message in the viewport
	     * @function OpenSeadragon.Viewer.prototype._showMessage
	     * @private
	     * @param {String} text message
	     */
	    _showMessage: function ( message ) {
	        this._hideMessage();
	
	        var div = $.makeNeutralElement( "div" );
	        div.appendChild( document.createTextNode( message ) );
	
	        this.messageDiv = $.makeCenteredNode( div );
	
	        $.addClass(this.messageDiv, "openseadragon-message");
	
	        this.container.appendChild( this.messageDiv );
	    },
	
	    /**
	     * Hide any currently displayed viewport message
	     * @function OpenSeadragon.Viewer.prototype._hideMessage
	     * @private
	     */
	    _hideMessage: function () {
	        var div = this.messageDiv;
	        if (div) {
	            div.parentNode.removeChild(div);
	            delete this.messageDiv;
	        }
	    },
	
	    /**
	     * Gets this viewer's gesture settings for the given pointer device type.
	     * @method
	     * @param {String} type - The pointer device type to get the gesture settings for ("mouse", "touch", "pen", etc.).
	     * @return {OpenSeadragon.GestureSettings}
	     */
	    gestureSettingsByDeviceType: function ( type ) {
	        switch ( type ) {
	            case 'mouse':
	                return this.gestureSettingsMouse;
	            case 'touch':
	                return this.gestureSettingsTouch;
	            case 'pen':
	                return this.gestureSettingsPen;
	            default:
	                return this.gestureSettingsUnknown;
	        }
	    },
	
	    // private
	    _drawOverlays: function() {
	        var i,
	            length = this.currentOverlays.length;
	        for ( i = 0; i < length; i++ ) {
	            this.currentOverlays[ i ].drawHTML( this.overlaysContainer, this.viewport );
	        }
	    },
	
	    /**
	     * Cancel the "in flight" images.
	     */
	    _cancelPendingImages: function() {
	        this._loadQueue = [];
	    },
	
	    /**
	     * Removes the reference strip and disables displaying it.
	     * @function
	     */
	    removeReferenceStrip: function() {
	        this.showReferenceStrip = false;
	
	        if (this.referenceStrip) {
	            this.referenceStrip.destroy();
	            this.referenceStrip = null;
	        }
	    },
	
	    /**
	     * Enables and displays the reference strip based on the currently set tileSources.
	     * Works only when the Viewer has sequenceMode set to true.
	     * @function
	     */
	    addReferenceStrip: function() {
	        this.showReferenceStrip = true;
	
	        if (this.sequenceMode) {
	            if (this.referenceStrip) {
	                return;
	            }
	
	            if (this.tileSources.length && this.tileSources.length > 1) {
	                this.referenceStrip = new $.ReferenceStrip({
	                    id:          this.referenceStripElement,
	                    position:    this.referenceStripPosition,
	                    sizeRatio:   this.referenceStripSizeRatio,
	                    scroll:      this.referenceStripScroll,
	                    height:      this.referenceStripHeight,
	                    width:       this.referenceStripWidth,
	                    tileSources: this.tileSources,
	                    prefixUrl:   this.prefixUrl,
	                    viewer:      this
	                });
	
	                this.referenceStrip.setFocus( this._sequenceIndex );
	            }
	        } else {
	            $.console.warn('Attempting to display a reference strip while "sequenceMode" is off.');
	        }
	    }
	});
	
	
	/**
	 * _getSafeElemSize is like getElementSize(), but refuses to return 0 for x or y,
	 * which was causing some calling operations to return NaN.
	 * @returns {Point}
	 * @private
	 */
	function _getSafeElemSize (oElement) {
	    oElement = $.getElement( oElement );
	
	    return new $.Point(
	        (oElement.clientWidth === 0 ? 1 : oElement.clientWidth),
	        (oElement.clientHeight === 0 ? 1 : oElement.clientHeight)
	    );
	}
	
	
	/**
	 * @function
	 * @private
	 */
	function getTileSourceImplementation( viewer, tileSource, imgOptions, successCallback,
	    failCallback ) {
	    var _this = viewer;
	
	    //allow plain xml strings or json strings to be parsed here
	    if ( $.type( tileSource ) == 'string' ) {
	        //xml should start with "<" and end with ">"
	        if ( tileSource.match( /^\s*<.*>\s*$/ ) ) {
	            tileSource = $.parseXml( tileSource );
	        //json should start with "{" or "[" and end with "}" or "]"
	        } else if ( tileSource.match(/^\s*[\{\[].*[\}\]]\s*$/ ) ) {
	            try {
	              var tileSourceJ = $.parseJSON(tileSource);
	              tileSource = tileSourceJ;
	            } catch (e) {
	              //tileSource = tileSource;
	            }
	        }
	    }
	
	    function waitUntilReady(tileSource, originalTileSource) {
	        if (tileSource.ready) {
	            successCallback(tileSource);
	        } else {
	            tileSource.addHandler('ready', function () {
	                successCallback(tileSource);
	            });
	            tileSource.addHandler('open-failed', function (event) {
	                failCallback({
	                    message: event.message,
	                    source: originalTileSource
	                });
	            });
	        }
	    }
	
	    setTimeout( function() {
	        if ( $.type( tileSource ) == 'string' ) {
	            //If its still a string it means it must be a url at this point
	            tileSource = new $.TileSource({
	                url: tileSource,
	                crossOriginPolicy: imgOptions.crossOriginPolicy !== undefined ?
	                    imgOptions.crossOriginPolicy : viewer.crossOriginPolicy,
	                ajaxWithCredentials: viewer.ajaxWithCredentials,
	                ajaxHeaders: viewer.ajaxHeaders,
	                useCanvas: viewer.useCanvas,
	                success: function( event ) {
	                    successCallback( event.tileSource );
	                }
	            });
	            tileSource.addHandler( 'open-failed', function( event ) {
	                failCallback( event );
	            } );
	
	        } else if ($.isPlainObject(tileSource) || tileSource.nodeType) {
	            if (tileSource.crossOriginPolicy === undefined &&
	                (imgOptions.crossOriginPolicy !== undefined || viewer.crossOriginPolicy !== undefined)) {
	                tileSource.crossOriginPolicy = imgOptions.crossOriginPolicy !== undefined ?
	                    imgOptions.crossOriginPolicy : viewer.crossOriginPolicy;
	            }
	            if (tileSource.ajaxWithCredentials === undefined) {
	                tileSource.ajaxWithCredentials = viewer.ajaxWithCredentials;
	            }
	            if (tileSource.useCanvas === undefined) {
	                tileSource.useCanvas = viewer.useCanvas;
	            }
	
	            if ( $.isFunction( tileSource.getTileUrl ) ) {
	                //Custom tile source
	                var customTileSource = new $.TileSource( tileSource );
	                customTileSource.getTileUrl = tileSource.getTileUrl;
	                successCallback( customTileSource );
	            } else {
	                //inline configuration
	                var $TileSource = $.TileSource.determineType( _this, tileSource );
	                if ( !$TileSource ) {
	                    failCallback( {
	                        message: "Unable to load TileSource",
	                        source: tileSource
	                    });
	                    return;
	                }
	                var options = $TileSource.prototype.configure.apply( _this, [ tileSource ] );
	                waitUntilReady(new $TileSource(options), tileSource);
	            }
	        } else {
	            //can assume it's already a tile source implementation
	            waitUntilReady(tileSource, tileSource);
	        }
	    });
	}
	
	function getOverlayObject( viewer, overlay ) {
	    if ( overlay instanceof $.Overlay ) {
	        return overlay;
	    }
	
	    var element = null;
	    if ( overlay.element ) {
	        element = $.getElement( overlay.element );
	    } else {
	        var id = overlay.id ?
	            overlay.id :
	            "openseadragon-overlay-" + Math.floor( Math.random() * 10000000 );
	
	        element = $.getElement( overlay.id );
	        if ( !element ) {
	            element         = document.createElement( "a" );
	            element.href    = "#/overlay/" + id;
	        }
	        element.id = id;
	        $.addClass( element, overlay.className ?
	            overlay.className :
	            "openseadragon-overlay"
	        );
	    }
	
	    var location = overlay.location;
	    var width = overlay.width;
	    var height = overlay.height;
	    if (!location) {
	        var x = overlay.x;
	        var y = overlay.y;
	        if (overlay.px !== undefined) {
	            var rect = viewer.viewport.imageToViewportRectangle(new $.Rect(
	                overlay.px,
	                overlay.py,
	                width || 0,
	                height || 0));
	            x = rect.x;
	            y = rect.y;
	            width = width !== undefined ? rect.width : undefined;
	            height = height !== undefined ? rect.height : undefined;
	        }
	        location = new $.Point(x, y);
	    }
	
	    var placement = overlay.placement;
	    if (placement && $.type(placement) === "string") {
	        placement = $.Placement[overlay.placement.toUpperCase()];
	    }
	
	    return new $.Overlay({
	        element: element,
	        location: location,
	        placement: placement,
	        onDraw: overlay.onDraw,
	        checkResize: overlay.checkResize,
	        width: width,
	        height: height,
	        rotationMode: overlay.rotationMode
	    });
	}
	
	/**
	 * @private
	 * @inner
	 * Determines the index of the given overlay in the given overlays array.
	 */
	function getOverlayIndex( overlays, element ) {
	    var i;
	    for ( i = overlays.length - 1; i >= 0; i-- ) {
	        if ( overlays[ i ].element === element ) {
	            return i;
	        }
	    }
	
	    return -1;
	}
	
	///////////////////////////////////////////////////////////////////////////////
	// Schedulers provide the general engine for animation
	///////////////////////////////////////////////////////////////////////////////
	function scheduleUpdate( viewer, updateFunc ){
	    return $.requestAnimationFrame( function(){
	        updateFunc( viewer );
	    } );
	}
	
	
	//provides a sequence in the fade animation
	function scheduleControlsFade( viewer ) {
	    $.requestAnimationFrame( function(){
	        updateControlsFade( viewer );
	    });
	}
	
	
	//initiates an animation to hide the controls
	function beginControlsAutoHide( viewer ) {
	    if ( !viewer.autoHideControls ) {
	        return;
	    }
	    viewer.controlsShouldFade = true;
	    viewer.controlsFadeBeginTime =
	        $.now() +
	        viewer.controlsFadeDelay;
	
	    window.setTimeout( function(){
	        scheduleControlsFade( viewer );
	    }, viewer.controlsFadeDelay );
	}
	
	
	//determines if fade animation is done or continues the animation
	function updateControlsFade( viewer ) {
	    var currentTime,
	        deltaTime,
	        opacity,
	        i;
	    if ( viewer.controlsShouldFade ) {
	        currentTime = $.now();
	        deltaTime = currentTime - viewer.controlsFadeBeginTime;
	        opacity = 1.0 - deltaTime / viewer.controlsFadeLength;
	
	        opacity = Math.min( 1.0, opacity );
	        opacity = Math.max( 0.0, opacity );
	
	        for ( i = viewer.controls.length - 1; i >= 0; i--) {
	            if (viewer.controls[ i ].autoFade) {
	                viewer.controls[ i ].setOpacity( opacity );
	            }
	        }
	
	        if ( opacity > 0 ) {
	            // fade again
	            scheduleControlsFade( viewer );
	        }
	    }
	}
	
	
	//stop the fade animation on the controls and show them
	function abortControlsAutoHide( viewer ) {
	    var i;
	    viewer.controlsShouldFade = false;
	    for ( i = viewer.controls.length - 1; i >= 0; i-- ) {
	        viewer.controls[ i ].setOpacity( 1.0 );
	    }
	}
	
	
	
	///////////////////////////////////////////////////////////////////////////////
	// Default view event handlers.
	///////////////////////////////////////////////////////////////////////////////
	function onFocus(){
	    abortControlsAutoHide( this );
	}
	
	function onBlur(){
	    beginControlsAutoHide( this );
	
	}
	
	function onCanvasKeyDown( event ) {
	    var canvasKeyDownEventArgs = {
	      originalEvent: event.originalEvent,
	      preventDefaultAction: event.preventDefaultAction,
	      preventVerticalPan: event.preventVerticalPan,
	      preventHorizontalPan: event.preventHorizontalPan
	    };
	
	    /**
	     * Raised when a keyboard key is pressed and the focus is on the {@link OpenSeadragon.Viewer#canvas} element.
	     *
	     * @event canvas-key
	     * @memberof OpenSeadragon.Viewer
	     * @type {object}
	     * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised this event.
	     * @property {Object} originalEvent - The original DOM event.
	     * @property {Boolean} preventDefaultAction - Set to true to prevent default keyboard behaviour. Default: false.
	     * @property {Boolean} preventVerticalPan - Set to true to prevent keyboard vertical panning. Default: false.
	     * @property {Boolean} preventHorizontalPan - Set to true to prevent keyboard horizontal panning. Default: false.
	     * @property {?Object} userData - Arbitrary subscriber-defined object.
	     */
	
	    this.raiseEvent('canvas-key', canvasKeyDownEventArgs);
	
	    if ( !canvasKeyDownEventArgs.preventDefaultAction && !event.ctrl && !event.alt && !event.meta ) {
	        switch( event.keyCode ){
	            case 38://up arrow
	                if (!canvasKeyDownEventArgs.preventVerticalPan) {
	                  if ( event.shift ) {
	                    this.viewport.zoomBy(1.1);
	                  } else {
	                    this.viewport.panBy(this.viewport.deltaPointsFromPixels(new $.Point(0, -this.pixelsPerArrowPress)));
	                  }
	                  this.viewport.applyConstraints();
	                }
	                return false;
	            case 40://down arrow
	                if (!canvasKeyDownEventArgs.preventVerticalPan) {
	                  if ( event.shift ) {
	                    this.viewport.zoomBy(0.9);
	                  } else {
	                    this.viewport.panBy(this.viewport.deltaPointsFromPixels(new $.Point(0, this.pixelsPerArrowPress)));
	                  }
	                  this.viewport.applyConstraints();
	                }
	                return false;
	            case 37://left arrow
	                if (!canvasKeyDownEventArgs.preventHorizontalPan) {
	                  this.viewport.panBy(this.viewport.deltaPointsFromPixels(new $.Point(-this.pixelsPerArrowPress, 0)));
	                  this.viewport.applyConstraints();
	                }
	                return false;
	            case 39://right arrow
	                if (!canvasKeyDownEventArgs.preventHorizontalPan) {
	                  this.viewport.panBy(this.viewport.deltaPointsFromPixels(new $.Point(this.pixelsPerArrowPress, 0)));
	                  this.viewport.applyConstraints();
	                }
	                return false;
	            default:
	                //console.log( 'navigator keycode %s', event.keyCode );
	                return true;
	        }
	    } else {
	        return true;
	    }
	}
	function onCanvasKeyPress( event ) {
	    var canvasKeyPressEventArgs = {
	      originalEvent: event.originalEvent,
	      preventDefaultAction: event.preventDefaultAction,
	      preventVerticalPan: event.preventVerticalPan,
	      preventHorizontalPan: event.preventHorizontalPan
	    };
	
	    // This event is documented in onCanvasKeyDown
	    this.raiseEvent('canvas-key', canvasKeyPressEventArgs);
	
	    if ( !canvasKeyPressEventArgs.preventDefaultAction && !event.ctrl && !event.alt && !event.meta ) {
	        switch( event.keyCode ){
	            case 43://=|+
	            case 61://=|+
	                this.viewport.zoomBy(1.1);
	                this.viewport.applyConstraints();
	                return false;
	            case 45://-|_
	                this.viewport.zoomBy(0.9);
	                this.viewport.applyConstraints();
	                return false;
	            case 48://0|)
	                this.viewport.goHome();
	                this.viewport.applyConstraints();
	                return false;
	            case 119://w
	            case 87://W
	                if (!canvasKeyPressEventArgs.preventVerticalPan) {
	                    if ( event.shift ) {
	                        this.viewport.zoomBy(1.1);
	                    } else {
	                        this.viewport.panBy(this.viewport.deltaPointsFromPixels(new $.Point(0, -40)));
	                    }
	                    this.viewport.applyConstraints();
	                  }
	                  return false;
	            case 115://s
	            case 83://S
	                if (!canvasKeyPressEventArgs.preventVerticalPan) {
	                  if ( event.shift ) {
	                    this.viewport.zoomBy(0.9);
	                  } else {
	                    this.viewport.panBy(this.viewport.deltaPointsFromPixels(new $.Point(0, 40)));
	                  }
	                  this.viewport.applyConstraints();
	                }
	                return false;
	            case 97://a
	                if (!canvasKeyPressEventArgs.preventHorizontalPan) {
	                  this.viewport.panBy(this.viewport.deltaPointsFromPixels(new $.Point(-40, 0)));
	                  this.viewport.applyConstraints();
	                }
	                return false;
	            case 100://d
	                if (!canvasKeyPressEventArgs.preventHorizontalPan) {
	                  this.viewport.panBy(this.viewport.deltaPointsFromPixels(new $.Point(40, 0)));
	                  this.viewport.applyConstraints();
	                }
	                return false;
	            case 114: //r - 90 degrees clockwise rotation
	              if(this.viewport.flipped){
	                this.viewport.setRotation(this.viewport.degrees - 90);
	              } else{
	                this.viewport.setRotation(this.viewport.degrees + 90);
	              }
	              this.viewport.applyConstraints();
	              return false;
	            case 82: //R - 90 degrees counterclockwise  rotation
	              if(this.viewport.flipped){
	                this.viewport.setRotation(this.viewport.degrees + 90);
	              } else{
	                this.viewport.setRotation(this.viewport.degrees - 90);
	              }
	              this.viewport.applyConstraints();
	              return false;
	            case 102: //f
	              this.viewport.toggleFlip();
	              return false;
	            default:
	                // console.log( 'navigator keycode %s', event.keyCode );
	                return true;
	        }
	    } else {
	        return true;
	    }
	}
	
	function onCanvasClick( event ) {
	    var gestureSettings;
	
	    var haveKeyboardFocus = document.activeElement == this.canvas;
	
	    // If we don't have keyboard focus, request it.
	    if ( !haveKeyboardFocus ) {
	        this.canvas.focus();
	    }
	    if(this.viewport.flipped){
	        event.position.x = this.viewport.getContainerSize().x - event.position.x;
	    }
	
	    var canvasClickEventArgs = {
	        tracker: event.eventSource,
	        position: event.position,
	        quick: event.quick,
	        shift: event.shift,
	        originalEvent: event.originalEvent,
	        preventDefaultAction: event.preventDefaultAction
	    };
	
	    /**
	     * Raised when a mouse press/release or touch/remove occurs on the {@link OpenSeadragon.Viewer#canvas} element.
	     *
	     * @event canvas-click
	     * @memberof OpenSeadragon.Viewer
	     * @type {object}
	     * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised this event.
	     * @property {OpenSeadragon.MouseTracker} tracker - A reference to the MouseTracker which originated this event.
	     * @property {OpenSeadragon.Point} position - The position of the event relative to the tracked element.
	     * @property {Boolean} quick - True only if the clickDistThreshold and clickTimeThreshold are both passed. Useful for differentiating between clicks and drags.
	     * @property {Boolean} shift - True if the shift key was pressed during this event.
	     * @property {Object} originalEvent - The original DOM event.
	     * @property {Boolean} preventDefaultAction - Set to true to prevent default click to zoom behaviour. Default: false.
	     * @property {?Object} userData - Arbitrary subscriber-defined object.
	     */
	    this.raiseEvent( 'canvas-click', canvasClickEventArgs);
	
	    if ( !canvasClickEventArgs.preventDefaultAction && this.viewport && event.quick ) {
	        gestureSettings = this.gestureSettingsByDeviceType( event.pointerType );
	        if ( gestureSettings.clickToZoom ) {
	            this.viewport.zoomBy(
	                event.shift ? 1.0 / this.zoomPerClick : this.zoomPerClick,
	                gestureSettings.zoomToRefPoint ? this.viewport.pointFromPixel( event.position, true ) : null
	            );
	            this.viewport.applyConstraints();
	        }
	    }
	}
	
	function onCanvasDblClick( event ) {
	    var gestureSettings;
	
	    var canvasDblClickEventArgs = {
	        tracker: event.eventSource,
	        position: event.position,
	        shift: event.shift,
	        originalEvent: event.originalEvent,
	        preventDefaultAction: event.preventDefaultAction
	    };
	
	    /**
	     * Raised when a double mouse press/release or touch/remove occurs on the {@link OpenSeadragon.Viewer#canvas} element.
	     *
	     * @event canvas-double-click
	     * @memberof OpenSeadragon.Viewer
	     * @type {object}
	     * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised this event.
	     * @property {OpenSeadragon.MouseTracker} tracker - A reference to the MouseTracker which originated this event.
	     * @property {OpenSeadragon.Point} position - The position of the event relative to the tracked element.
	     * @property {Boolean} shift - True if the shift key was pressed during this event.
	     * @property {Object} originalEvent - The original DOM event.
	     * @property {Boolean} preventDefaultAction - Set to true to prevent default double tap to zoom behaviour. Default: false.
	     * @property {?Object} userData - Arbitrary subscriber-defined object.
	     */
	    this.raiseEvent( 'canvas-double-click', canvasDblClickEventArgs);
	
	    if ( !canvasDblClickEventArgs.preventDefaultAction && this.viewport ) {
	        gestureSettings = this.gestureSettingsByDeviceType( event.pointerType );
	        if ( gestureSettings.dblClickToZoom ) {
	            this.viewport.zoomBy(
	                event.shift ? 1.0 / this.zoomPerClick : this.zoomPerClick,
	                gestureSettings.zoomToRefPoint ? this.viewport.pointFromPixel( event.position, true ) : null
	            );
	            this.viewport.applyConstraints();
	        }
	    }
	}
	
	function onCanvasDrag( event ) {
	    var gestureSettings;
	
	    var canvasDragEventArgs = {
	        tracker: event.eventSource,
	        position: event.position,
	        delta: event.delta,
	        speed: event.speed,
	        direction: event.direction,
	        shift: event.shift,
	        originalEvent: event.originalEvent,
	        preventDefaultAction: event.preventDefaultAction
	    };
	
	    /**
	     * Raised when a mouse or touch drag operation occurs on the {@link OpenSeadragon.Viewer#canvas} element.
	     *
	     * @event canvas-drag
	     * @memberof OpenSeadragon.Viewer
	     * @type {object}
	     * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised this event.
	     * @property {OpenSeadragon.MouseTracker} tracker - A reference to the MouseTracker which originated this event.
	     * @property {OpenSeadragon.Point} position - The position of the event relative to the tracked element.
	     * @property {OpenSeadragon.Point} delta - The x,y components of the difference between start drag and end drag.
	     * @property {Number} speed - Current computed speed, in pixels per second.
	     * @property {Number} direction - Current computed direction, expressed as an angle counterclockwise relative to the positive X axis (-pi to pi, in radians). Only valid if speed > 0.
	     * @property {Boolean} shift - True if the shift key was pressed during this event.
	     * @property {Object} originalEvent - The original DOM event.
	     * @property {Boolean} preventDefaultAction - Set to true to prevent default drag behaviour. Default: false.
	     * @property {?Object} userData - Arbitrary subscriber-defined object.
	     */
	    this.raiseEvent( 'canvas-drag', canvasDragEventArgs);
	
	    if ( !canvasDragEventArgs.preventDefaultAction && this.viewport ) {
	        gestureSettings = this.gestureSettingsByDeviceType( event.pointerType );
	        if( !this.panHorizontal ){
	            event.delta.x = 0;
	        }
	        if( !this.panVertical ){
	            event.delta.y = 0;
	        }
	        if(this.viewport.flipped){
	            event.delta.x = -event.delta.x;
	        }
	
	        if( this.constrainDuringPan ){
	            var delta = this.viewport.deltaPointsFromPixels( event.delta.negate() );
	
	            this.viewport.centerSpringX.target.value += delta.x;
	            this.viewport.centerSpringY.target.value += delta.y;
	
	            var bounds = this.viewport.getBounds();
	            var constrainedBounds = this.viewport.getConstrainedBounds();
	
	            this.viewport.centerSpringX.target.value -= delta.x;
	            this.viewport.centerSpringY.target.value -= delta.y;
	
	            if (bounds.x != constrainedBounds.x) {
	                event.delta.x = 0;
	            }
	
	            if (bounds.y != constrainedBounds.y) {
	                event.delta.y = 0;
	            }
	        }
	
	        this.viewport.panBy( this.viewport.deltaPointsFromPixels( event.delta.negate() ), gestureSettings.flickEnabled && !this.constrainDuringPan);
	    }
	}
	
	function onCanvasDragEnd( event ) {
	    if (!event.preventDefaultAction && this.viewport) {
	        var gestureSettings = this.gestureSettingsByDeviceType(event.pointerType);
	        if (gestureSettings.flickEnabled &&
	            event.speed >= gestureSettings.flickMinSpeed) {
	            var amplitudeX = 0;
	            if (this.panHorizontal) {
	                amplitudeX = gestureSettings.flickMomentum * event.speed *
	                    Math.cos(event.direction);
	            }
	            var amplitudeY = 0;
	            if (this.panVertical) {
	                amplitudeY = gestureSettings.flickMomentum * event.speed *
	                    Math.sin(event.direction);
	            }
	            var center = this.viewport.pixelFromPoint(
	                this.viewport.getCenter(true));
	            var target = this.viewport.pointFromPixel(
	                new $.Point(center.x - amplitudeX, center.y - amplitudeY));
	            this.viewport.panTo(target, false);
	        }
	        this.viewport.applyConstraints();
	    }
	    /**
	     * Raised when a mouse or touch drag operation ends on the {@link OpenSeadragon.Viewer#canvas} element.
	     *
	     * @event canvas-drag-end
	     * @memberof OpenSeadragon.Viewer
	     * @type {object}
	     * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised this event.
	     * @property {OpenSeadragon.MouseTracker} tracker - A reference to the MouseTracker which originated this event.
	     * @property {OpenSeadragon.Point} position - The position of the event relative to the tracked element.
	     * @property {Number} speed - Speed at the end of a drag gesture, in pixels per second.
	     * @property {Number} direction - Direction at the end of a drag gesture, expressed as an angle counterclockwise relative to the positive X axis (-pi to pi, in radians). Only valid if speed > 0.
	     * @property {Boolean} shift - True if the shift key was pressed during this event.
	     * @property {Object} originalEvent - The original DOM event.
	     * @property {?Object} userData - Arbitrary subscriber-defined object.
	     */
	    this.raiseEvent('canvas-drag-end', {
	        tracker: event.eventSource,
	        position: event.position,
	        speed: event.speed,
	        direction: event.direction,
	        shift: event.shift,
	        originalEvent: event.originalEvent
	    });
	}
	
	function onCanvasEnter( event ) {
	    /**
	     * Raised when a pointer enters the {@link OpenSeadragon.Viewer#canvas} element.
	     *
	     * @event canvas-enter
	     * @memberof OpenSeadragon.Viewer
	     * @type {object}
	     * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised this event.
	     * @property {OpenSeadragon.MouseTracker} tracker - A reference to the MouseTracker which originated this event.
	     * @property {String} pointerType - "mouse", "touch", "pen", etc.
	     * @property {OpenSeadragon.Point} position - The position of the event relative to the tracked element.
	     * @property {Number} buttons - Current buttons pressed. A combination of bit flags 0: none, 1: primary (or touch contact), 2: secondary, 4: aux (often middle), 8: X1 (often back), 16: X2 (often forward), 32: pen eraser.
	     * @property {Number} pointers - Number of pointers (all types) active in the tracked element.
	     * @property {Boolean} insideElementPressed - True if the left mouse button is currently being pressed and was initiated inside the tracked element, otherwise false.
	     * @property {Boolean} buttonDownAny - Was the button down anywhere in the screen during the event. <span style="color:red;">Deprecated. Use buttons instead.</span>
	     * @property {Object} originalEvent - The original DOM event.
	     * @property {?Object} userData - Arbitrary subscriber-defined object.
	     */
	    this.raiseEvent( 'canvas-enter', {
	        tracker: event.eventSource,
	        pointerType: event.pointerType,
	        position: event.position,
	        buttons: event.buttons,
	        pointers: event.pointers,
	        insideElementPressed: event.insideElementPressed,
	        buttonDownAny: event.buttonDownAny,
	        originalEvent: event.originalEvent
	    });
	}
	
	function onCanvasExit( event ) {
	
	    if (window.location != window.parent.location){
	        $.MouseTracker.resetAllMouseTrackers();
	    }
	
	    /**
	     * Raised when a pointer leaves the {@link OpenSeadragon.Viewer#canvas} element.
	     *
	     * @event canvas-exit
	     * @memberof OpenSeadragon.Viewer
	     * @type {object}
	     * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised this event.
	     * @property {OpenSeadragon.MouseTracker} tracker - A reference to the MouseTracker which originated this event.
	     * @property {String} pointerType - "mouse", "touch", "pen", etc.
	     * @property {OpenSeadragon.Point} position - The position of the event relative to the tracked element.
	     * @property {Number} buttons - Current buttons pressed. A combination of bit flags 0: none, 1: primary (or touch contact), 2: secondary, 4: aux (often middle), 8: X1 (often back), 16: X2 (often forward), 32: pen eraser.
	     * @property {Number} pointers - Number of pointers (all types) active in the tracked element.
	     * @property {Boolean} insideElementPressed - True if the left mouse button is currently being pressed and was initiated inside the tracked element, otherwise false.
	     * @property {Boolean} buttonDownAny - Was the button down anywhere in the screen during the event. <span style="color:red;">Deprecated. Use buttons instead.</span>
	     * @property {Object} originalEvent - The original DOM event.
	     * @property {?Object} userData - Arbitrary subscriber-defined object.
	     */
	    this.raiseEvent( 'canvas-exit', {
	        tracker: event.eventSource,
	        pointerType: event.pointerType,
	        position: event.position,
	        buttons: event.buttons,
	        pointers: event.pointers,
	        insideElementPressed: event.insideElementPressed,
	        buttonDownAny: event.buttonDownAny,
	        originalEvent: event.originalEvent
	    });
	}
	
	function onCanvasPress( event ) {
	    /**
	     * Raised when the primary mouse button is pressed or touch starts on the {@link OpenSeadragon.Viewer#canvas} element.
	     *
	     * @event canvas-press
	     * @memberof OpenSeadragon.Viewer
	     * @type {object}
	     * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised this event.
	     * @property {OpenSeadragon.MouseTracker} tracker - A reference to the MouseTracker which originated this event.
	     * @property {String} pointerType - "mouse", "touch", "pen", etc.
	     * @property {OpenSeadragon.Point} position - The position of the event relative to the tracked element.
	     * @property {Boolean} insideElementPressed - True if the left mouse button is currently being pressed and was initiated inside the tracked element, otherwise false.
	     * @property {Boolean} insideElementReleased - True if the cursor still inside the tracked element when the button was released.
	     * @property {Object} originalEvent - The original DOM event.
	     * @property {?Object} userData - Arbitrary subscriber-defined object.
	     */
	    this.raiseEvent( 'canvas-press', {
	        tracker: event.eventSource,
	        pointerType: event.pointerType,
	        position: event.position,
	        insideElementPressed: event.insideElementPressed,
	        insideElementReleased: event.insideElementReleased,
	        originalEvent: event.originalEvent
	    });
	}
	
	function onCanvasRelease( event ) {
	    /**
	     * Raised when the primary mouse button is released or touch ends on the {@link OpenSeadragon.Viewer#canvas} element.
	     *
	     * @event canvas-release
	     * @memberof OpenSeadragon.Viewer
	     * @type {object}
	     * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised this event.
	     * @property {OpenSeadragon.MouseTracker} tracker - A reference to the MouseTracker which originated this event.
	     * @property {String} pointerType - "mouse", "touch", "pen", etc.
	     * @property {OpenSeadragon.Point} position - The position of the event relative to the tracked element.
	     * @property {Boolean} insideElementPressed - True if the left mouse button is currently being pressed and was initiated inside the tracked element, otherwise false.
	     * @property {Boolean} insideElementReleased - True if the cursor still inside the tracked element when the button was released.
	     * @property {Object} originalEvent - The original DOM event.
	     * @property {?Object} userData - Arbitrary subscriber-defined object.
	     */
	    this.raiseEvent( 'canvas-release', {
	        tracker: event.eventSource,
	        pointerType: event.pointerType,
	        position: event.position,
	        insideElementPressed: event.insideElementPressed,
	        insideElementReleased: event.insideElementReleased,
	        originalEvent: event.originalEvent
	    });
	}
	
	function onCanvasNonPrimaryPress( event ) {
	    /**
	     * Raised when any non-primary pointer button is pressed on the {@link OpenSeadragon.Viewer#canvas} element.
	     *
	     * @event canvas-nonprimary-press
	     * @memberof OpenSeadragon.Viewer
	     * @type {object}
	     * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised this event.
	     * @property {OpenSeadragon.MouseTracker} tracker - A reference to the MouseTracker which originated this event.
	     * @property {OpenSeadragon.Point} position - The position of the event relative to the tracked element.
	     * @property {String} pointerType - "mouse", "touch", "pen", etc.
	     * @property {Number} button - Button which caused the event.
	     *      -1: none, 0: primary/left, 1: aux/middle, 2: secondary/right, 3: X1/back, 4: X2/forward, 5: pen eraser.
	     * @property {Number} buttons - Current buttons pressed.
	     *      Combination of bit flags 0: none, 1: primary (or touch contact), 2: secondary, 4: aux (often middle), 8: X1 (often back), 16: X2 (often forward), 32: pen eraser.
	     * @property {Object} originalEvent - The original DOM event.
	     * @property {?Object} userData - Arbitrary subscriber-defined object.
	     */
	    this.raiseEvent( 'canvas-nonprimary-press', {
	        tracker: event.eventSource,
	        position: event.position,
	        pointerType: event.pointerType,
	        button: event.button,
	        buttons: event.buttons,
	        originalEvent: event.originalEvent
	    });
	}
	
	function onCanvasNonPrimaryRelease( event ) {
	    /**
	     * Raised when any non-primary pointer button is released on the {@link OpenSeadragon.Viewer#canvas} element.
	     *
	     * @event canvas-nonprimary-release
	     * @memberof OpenSeadragon.Viewer
	     * @type {object}
	     * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised this event.
	     * @property {OpenSeadragon.MouseTracker} tracker - A reference to the MouseTracker which originated this event.
	     * @property {OpenSeadragon.Point} position - The position of the event relative to the tracked element.
	     * @property {String} pointerType - "mouse", "touch", "pen", etc.
	     * @property {Number} button - Button which caused the event.
	     *      -1: none, 0: primary/left, 1: aux/middle, 2: secondary/right, 3: X1/back, 4: X2/forward, 5: pen eraser.
	     * @property {Number} buttons - Current buttons pressed.
	     *      Combination of bit flags 0: none, 1: primary (or touch contact), 2: secondary, 4: aux (often middle), 8: X1 (often back), 16: X2 (often forward), 32: pen eraser.
	     * @property {Object} originalEvent - The original DOM event.
	     * @property {?Object} userData - Arbitrary subscriber-defined object.
	     */
	    this.raiseEvent( 'canvas-nonprimary-release', {
	        tracker: event.eventSource,
	        position: event.position,
	        pointerType: event.pointerType,
	        button: event.button,
	        buttons: event.buttons,
	        originalEvent: event.originalEvent
	    });
	}
	
	function onCanvasPinch( event ) {
	    var gestureSettings,
	        centerPt,
	        lastCenterPt,
	        panByPt;
	
	    if ( !event.preventDefaultAction && this.viewport ) {
	        gestureSettings = this.gestureSettingsByDeviceType( event.pointerType );
	        if ( gestureSettings.pinchToZoom ) {
	            centerPt = this.viewport.pointFromPixel( event.center, true );
	            lastCenterPt = this.viewport.pointFromPixel( event.lastCenter, true );
	            panByPt = lastCenterPt.minus( centerPt );
	            if( !this.panHorizontal ) {
	                panByPt.x = 0;
	            }
	            if( !this.panVertical ) {
	                panByPt.y = 0;
	            }
	            this.viewport.zoomBy( event.distance / event.lastDistance, centerPt, true );
	            if ( gestureSettings.zoomToRefPoint ) {
	                this.viewport.panBy(panByPt, true);
	            }
	            this.viewport.applyConstraints();
	        }
	        if ( gestureSettings.pinchRotate ) {
	            // Pinch rotate
	            var angle1 = Math.atan2(event.gesturePoints[0].currentPos.y - event.gesturePoints[1].currentPos.y,
	                event.gesturePoints[0].currentPos.x - event.gesturePoints[1].currentPos.x);
	            var angle2 = Math.atan2(event.gesturePoints[0].lastPos.y - event.gesturePoints[1].lastPos.y,
	                event.gesturePoints[0].lastPos.x - event.gesturePoints[1].lastPos.x);
	            this.viewport.setRotation(this.viewport.getRotation() + ((angle1 - angle2) * (180 / Math.PI)));
	        }
	    }
	    /**
	     * Raised when a pinch event occurs on the {@link OpenSeadragon.Viewer#canvas} element.
	     *
	     * @event canvas-pinch
	     * @memberof OpenSeadragon.Viewer
	     * @type {object}
	     * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised this event.
	     * @property {OpenSeadragon.MouseTracker} tracker - A reference to the MouseTracker which originated this event.
	     * @property {Array.<OpenSeadragon.MouseTracker.GesturePoint>} gesturePoints - Gesture points associated with the gesture. Velocity data can be found here.
	     * @property {OpenSeadragon.Point} lastCenter - The previous center point of the two pinch contact points relative to the tracked element.
	     * @property {OpenSeadragon.Point} center - The center point of the two pinch contact points relative to the tracked element.
	     * @property {Number} lastDistance - The previous distance between the two pinch contact points in CSS pixels.
	     * @property {Number} distance - The distance between the two pinch contact points in CSS pixels.
	     * @property {Boolean} shift - True if the shift key was pressed during this event.
	     * @property {Object} originalEvent - The original DOM event.
	     * @property {?Object} userData - Arbitrary subscriber-defined object.
	     */
	    this.raiseEvent('canvas-pinch', {
	        tracker: event.eventSource,
	        gesturePoints: event.gesturePoints,
	        lastCenter: event.lastCenter,
	        center: event.center,
	        lastDistance: event.lastDistance,
	        distance: event.distance,
	        shift: event.shift,
	        originalEvent: event.originalEvent
	    });
	    //cancels event
	    return false;
	}
	
	function onCanvasScroll( event ) {
	    var gestureSettings,
	        factor,
	        thisScrollTime,
	        deltaScrollTime;
	
	    /* Certain scroll devices fire the scroll event way too fast so we are injecting a simple adjustment to keep things
	     * partially normalized. If we have already fired an event within the last 'minScrollDelta' milliseconds we skip
	     * this one and wait for the next event. */
	    thisScrollTime = $.now();
	    deltaScrollTime = thisScrollTime - this._lastScrollTime;
	    if (deltaScrollTime > this.minScrollDeltaTime) {
	        this._lastScrollTime = thisScrollTime;
	
	        if(this.viewport.flipped){
	          event.position.x = this.viewport.getContainerSize().x - event.position.x;
	        }
	
	        if ( !event.preventDefaultAction && this.viewport ) {
	            gestureSettings = this.gestureSettingsByDeviceType( event.pointerType );
	            if ( gestureSettings.scrollToZoom ) {
	                factor = Math.pow( this.zoomPerScroll, event.scroll );
	                this.viewport.zoomBy(
	                    factor,
	                    gestureSettings.zoomToRefPoint ? this.viewport.pointFromPixel( event.position, true ) : null
	                );
	                this.viewport.applyConstraints();
	            }
	        }
	        /**
	         * Raised when a scroll event occurs on the {@link OpenSeadragon.Viewer#canvas} element (mouse wheel).
	         *
	         * @event canvas-scroll
	         * @memberof OpenSeadragon.Viewer
	         * @type {object}
	         * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised this event.
	         * @property {OpenSeadragon.MouseTracker} tracker - A reference to the MouseTracker which originated this event.
	         * @property {OpenSeadragon.Point} position - The position of the event relative to the tracked element.
	         * @property {Number} scroll - The scroll delta for the event.
	         * @property {Boolean} shift - True if the shift key was pressed during this event.
	         * @property {Object} originalEvent - The original DOM event.
	         * @property {?Object} userData - Arbitrary subscriber-defined object.
	         */
	        this.raiseEvent( 'canvas-scroll', {
	            tracker: event.eventSource,
	            position: event.position,
	            scroll: event.scroll,
	            shift: event.shift,
	            originalEvent: event.originalEvent
	        });
	        if (gestureSettings && gestureSettings.scrollToZoom) {
	            //cancels event
	            return false;
	        }
	    }
	    else {
	        gestureSettings = this.gestureSettingsByDeviceType( event.pointerType );
	        if (gestureSettings && gestureSettings.scrollToZoom) {
	            return false;   // We are swallowing this event
	        }
	    }
	}
	
	function onContainerEnter( event ) {
	    THIS[ this.hash ].mouseInside = true;
	    abortControlsAutoHide( this );
	    /**
	     * Raised when the cursor enters the {@link OpenSeadragon.Viewer#container} element.
	     *
	     * @event container-enter
	     * @memberof OpenSeadragon.Viewer
	     * @type {object}
	     * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised this event.
	     * @property {OpenSeadragon.MouseTracker} tracker - A reference to the MouseTracker which originated this event.
	     * @property {OpenSeadragon.Point} position - The position of the event relative to the tracked element.
	     * @property {Number} buttons - Current buttons pressed. A combination of bit flags 0: none, 1: primary (or touch contact), 2: secondary, 4: aux (often middle), 8: X1 (often back), 16: X2 (often forward), 32: pen eraser.
	     * @property {Number} pointers - Number of pointers (all types) active in the tracked element.
	     * @property {Boolean} insideElementPressed - True if the left mouse button is currently being pressed and was initiated inside the tracked element, otherwise false.
	     * @property {Boolean} buttonDownAny - Was the button down anywhere in the screen during the event. <span style="color:red;">Deprecated. Use buttons instead.</span>
	     * @property {Object} originalEvent - The original DOM event.
	     * @property {?Object} userData - Arbitrary subscriber-defined object.
	     */
	    this.raiseEvent( 'container-enter', {
	        tracker: event.eventSource,
	        position: event.position,
	        buttons: event.buttons,
	        pointers: event.pointers,
	        insideElementPressed: event.insideElementPressed,
	        buttonDownAny: event.buttonDownAny,
	        originalEvent: event.originalEvent
	    });
	}
	
	function onContainerExit( event ) {
	    if ( event.pointers < 1 ) {
	        THIS[ this.hash ].mouseInside = false;
	        if ( !THIS[ this.hash ].animating ) {
	            beginControlsAutoHide( this );
	        }
	    }
	    /**
	     * Raised when the cursor leaves the {@link OpenSeadragon.Viewer#container} element.
	     *
	     * @event container-exit
	     * @memberof OpenSeadragon.Viewer
	     * @type {object}
	     * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised this event.
	     * @property {OpenSeadragon.MouseTracker} tracker - A reference to the MouseTracker which originated this event.
	     * @property {OpenSeadragon.Point} position - The position of the event relative to the tracked element.
	     * @property {Number} buttons - Current buttons pressed. A combination of bit flags 0: none, 1: primary (or touch contact), 2: secondary, 4: aux (often middle), 8: X1 (often back), 16: X2 (often forward), 32: pen eraser.
	     * @property {Number} pointers - Number of pointers (all types) active in the tracked element.
	     * @property {Boolean} insideElementPressed - True if the left mouse button is currently being pressed and was initiated inside the tracked element, otherwise false.
	     * @property {Boolean} buttonDownAny - Was the button down anywhere in the screen during the event. <span style="color:red;">Deprecated. Use buttons instead.</span>
	     * @property {Object} originalEvent - The original DOM event.
	     * @property {?Object} userData - Arbitrary subscriber-defined object.
	     */
	    this.raiseEvent( 'container-exit', {
	        tracker: event.eventSource,
	        position: event.position,
	        buttons: event.buttons,
	        pointers: event.pointers,
	        insideElementPressed: event.insideElementPressed,
	        buttonDownAny: event.buttonDownAny,
	        originalEvent: event.originalEvent
	    });
	}
	
	
	///////////////////////////////////////////////////////////////////////////////
	// Page update routines ( aka Views - for future reference )
	///////////////////////////////////////////////////////////////////////////////
	
	function updateMulti( viewer ) {
	    updateOnce( viewer );
	
	    // Request the next frame, unless we've been closed
	    if ( viewer.isOpen() ) {
	        viewer._updateRequestId = scheduleUpdate( viewer, updateMulti );
	    } else {
	        viewer._updateRequestId = false;
	    }
	}
	
	function updateOnce( viewer ) {
	
	    //viewer.profiler.beginUpdate();
	
	    if (viewer._opening) {
	        return;
	    }
	
	    if (viewer.autoResize) {
	        var containerSize = _getSafeElemSize(viewer.container);
	        var prevContainerSize = THIS[viewer.hash].prevContainerSize;
	        if (!containerSize.equals(prevContainerSize)) {
	            var viewport = viewer.viewport;
	            if (viewer.preserveImageSizeOnResize) {
	                var resizeRatio = prevContainerSize.x / containerSize.x;
	                var zoom = viewport.getZoom() * resizeRatio;
	                var center = viewport.getCenter();
	                viewport.resize(containerSize, false);
	                viewport.zoomTo(zoom, null, true);
	                viewport.panTo(center, true);
	            } else {
	                // maintain image position
	                var oldBounds = viewport.getBounds();
	                viewport.resize(containerSize, true);
	                viewport.fitBoundsWithConstraints(oldBounds, true);
	            }
	            THIS[viewer.hash].prevContainerSize = containerSize;
	            THIS[viewer.hash].forceRedraw = true;
	        }
	    }
	
	    var viewportChange = viewer.viewport.update();
	    var animated = viewer.world.update() || viewportChange;
	
	    if (viewportChange) {
	        /**
	         * Raised when any spring animation update occurs (zoom, pan, etc.),
	         * before the viewer has drawn the new location.
	         *
	         * @event viewport-change
	         * @memberof OpenSeadragon.Viewer
	         * @type {object}
	         * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised this event.
	         * @property {?Object} userData - Arbitrary subscriber-defined object.
	         */
	        viewer.raiseEvent('viewport-change');
	    }
	
	    if( viewer.referenceStrip ){
	        animated = viewer.referenceStrip.update( viewer.viewport ) || animated;
	    }
	
	    if ( !THIS[ viewer.hash ].animating && animated ) {
	        /**
	         * Raised when any spring animation starts (zoom, pan, etc.).
	         *
	         * @event animation-start
	         * @memberof OpenSeadragon.Viewer
	         * @type {object}
	         * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised this event.
	         * @property {?Object} userData - Arbitrary subscriber-defined object.
	         */
	        viewer.raiseEvent( "animation-start" );
	        abortControlsAutoHide( viewer );
	    }
	
	    if ( animated || THIS[ viewer.hash ].forceRedraw || viewer.world.needsDraw() ) {
	        drawWorld( viewer );
	        viewer._drawOverlays();
	        if( viewer.navigator ){
	          viewer.navigator.update( viewer.viewport );
	        }
	
	        THIS[ viewer.hash ].forceRedraw = false;
	
	        if (animated) {
	            /**
	             * Raised when any spring animation update occurs (zoom, pan, etc.),
	             * after the viewer has drawn the new location.
	             *
	             * @event animation
	             * @memberof OpenSeadragon.Viewer
	             * @type {object}
	             * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised this event.
	             * @property {?Object} userData - Arbitrary subscriber-defined object.
	             */
	            viewer.raiseEvent( "animation" );
	        }
	    }
	
	    if ( THIS[ viewer.hash ].animating && !animated ) {
	        /**
	         * Raised when any spring animation ends (zoom, pan, etc.).
	         *
	         * @event animation-finish
	         * @memberof OpenSeadragon.Viewer
	         * @type {object}
	         * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised this event.
	         * @property {?Object} userData - Arbitrary subscriber-defined object.
	         */
	        viewer.raiseEvent( "animation-finish" );
	
	        if ( !THIS[ viewer.hash ].mouseInside ) {
	            beginControlsAutoHide( viewer );
	        }
	    }
	
	    THIS[ viewer.hash ].animating = animated;
	
	    //viewer.profiler.endUpdate();
	}
	
	function drawWorld( viewer ) {
	    viewer.imageLoader.clear();
	    viewer.drawer.clear();
	    viewer.world.draw();
	
	    /**
	     * <em>- Needs documentation -</em>
	     *
	     * @event update-viewport
	     * @memberof OpenSeadragon.Viewer
	     * @type {object}
	     * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised the event.
	     * @property {?Object} userData - Arbitrary subscriber-defined object.
	     */
	    viewer.raiseEvent( 'update-viewport', {} );
	}
	
	///////////////////////////////////////////////////////////////////////////////
	// Navigation Controls
	///////////////////////////////////////////////////////////////////////////////
	function resolveUrl( prefix, url ) {
	    return prefix ? prefix + url : url;
	}
	
	
	
	function beginZoomingIn() {
	    THIS[ this.hash ].lastZoomTime = $.now();
	    THIS[ this.hash ].zoomFactor = this.zoomPerSecond;
	    THIS[ this.hash ].zooming = true;
	    scheduleZoom( this );
	}
	
	
	function beginZoomingOut() {
	    THIS[ this.hash ].lastZoomTime = $.now();
	    THIS[ this.hash ].zoomFactor = 1.0 / this.zoomPerSecond;
	    THIS[ this.hash ].zooming = true;
	    scheduleZoom( this );
	}
	
	
	function endZooming() {
	    THIS[ this.hash ].zooming = false;
	}
	
	
	function scheduleZoom( viewer ) {
	    $.requestAnimationFrame( $.delegate( viewer, doZoom ) );
	}
	
	
	function doZoom() {
	    var currentTime,
	        deltaTime,
	        adjustedFactor;
	
	    if ( THIS[ this.hash ].zooming && this.viewport) {
	        currentTime     = $.now();
	        deltaTime       = currentTime - THIS[ this.hash ].lastZoomTime;
	        adjustedFactor  = Math.pow( THIS[ this.hash ].zoomFactor, deltaTime / 1000 );
	
	        this.viewport.zoomBy( adjustedFactor );
	        this.viewport.applyConstraints();
	        THIS[ this.hash ].lastZoomTime = currentTime;
	        scheduleZoom( this );
	    }
	}
	
	
	function doSingleZoomIn() {
	    if ( this.viewport ) {
	        THIS[ this.hash ].zooming = false;
	        this.viewport.zoomBy(
	            this.zoomPerClick / 1.0
	        );
	        this.viewport.applyConstraints();
	    }
	}
	
	
	function doSingleZoomOut() {
	    if ( this.viewport ) {
	        THIS[ this.hash ].zooming = false;
	        this.viewport.zoomBy(
	            1.0 / this.zoomPerClick
	        );
	        this.viewport.applyConstraints();
	    }
	}
	
	
	function lightUp() {
	    this.buttons.emulateEnter();
	    this.buttons.emulateExit();
	}
	
	
	function onHome() {
	    if ( this.viewport ) {
	        this.viewport.goHome();
	    }
	}
	
	
	function onFullScreen() {
	    if ( this.isFullPage() && !$.isFullScreen() ) {
	        // Is fullPage but not fullScreen
	        this.setFullPage( false );
	    } else {
	        this.setFullScreen( !this.isFullPage() );
	    }
	    // correct for no mouseout event on change
	    if ( this.buttons ) {
	        this.buttons.emulateExit();
	    }
	    this.fullPageButton.element.focus();
	    if ( this.viewport ) {
	        this.viewport.applyConstraints();
	    }
	}
	
	/**
	 * Note: The current rotation feature is limited to 90 degree turns.
	 */
	function onRotateLeft() {
	    if ( this.viewport ) {
	        var currRotation = this.viewport.getRotation();
	
	        if ( this.viewport.flipped ){
	          currRotation = $.positiveModulo(currRotation + 90, 360);
	        } else {
	          currRotation = $.positiveModulo(currRotation - 90, 360);
	        }
	        this.viewport.setRotation(currRotation);
	    }
	}
	
	/**
	 * Note: The current rotation feature is limited to 90 degree turns.
	 */
	function onRotateRight() {
	    if ( this.viewport ) {
	        var currRotation = this.viewport.getRotation();
	
	        if ( this.viewport.flipped ){
	          currRotation = $.positiveModulo(currRotation - 90, 360);
	        } else {
	          currRotation = $.positiveModulo(currRotation + 90, 360);
	        }
	        this.viewport.setRotation(currRotation);
	    }
	}
	
	/**
	 * Note: When pressed flip control button
	 */
	function onFlip() {
	   this.viewport.toggleFlip();
	}
	
	function onPrevious(){
	    var previous = this._sequenceIndex - 1;
	    if(this.navPrevNextWrap && previous < 0){
	        previous += this.tileSources.length;
	    }
	    this.goToPage( previous );
	}
	
	
	function onNext(){
	    var next = this._sequenceIndex + 1;
	    if(this.navPrevNextWrap && next >= this.tileSources.length){
	        next = 0;
	    }
	    this.goToPage( next );
	}
	
	
	}( OpenSeadragon ));
	
	/*
	 * OpenSeadragon - Navigator
	 *
	 * Copyright (C) 2009 CodePlex Foundation
	 * Copyright (C) 2010-2013 OpenSeadragon contributors
	 *
	 * Redistribution and use in source and binary forms, with or without
	 * modification, are permitted provided that the following conditions are
	 * met:
	 *
	 * - Redistributions of source code must retain the above copyright notice,
	 *   this list of conditions and the following disclaimer.
	 *
	 * - Redistributions in binary form must reproduce the above copyright
	 *   notice, this list of conditions and the following disclaimer in the
	 *   documentation and/or other materials provided with the distribution.
	 *
	 * - Neither the name of CodePlex Foundation nor the names of its
	 *   contributors may be used to endorse or promote products derived from
	 *   this software without specific prior written permission.
	 *
	 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
	 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
	 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
	 * A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT
	 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
	 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
	 * TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 * PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
	 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
	 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
	 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	 */
	
	(function( $ ){
	
	/**
	 * @class Navigator
	 * @classdesc The Navigator provides a small view of the current image as fixed
	 * while representing the viewport as a moving box serving as a frame
	 * of reference in the larger viewport as to which portion of the image
	 * is currently being examined.  The navigator's viewport can be interacted
	 * with using the keyboard or the mouse.
	 *
	 * @memberof OpenSeadragon
	 * @extends OpenSeadragon.Viewer
	 * @extends OpenSeadragon.EventSource
	 * @param {Object} options
	 */
	$.Navigator = function( options ){
	
	    var viewer      = options.viewer,
	        _this = this,
	        viewerSize,
	        navigatorSize;
	
	    //We may need to create a new element and id if they did not
	    //provide the id for the existing element
	    if( !options.id ){
	        options.id              = 'navigator-' + $.now();
	        this.element            = $.makeNeutralElement( "div" );
	        options.controlOptions  = {
	            anchor:           $.ControlAnchor.TOP_RIGHT,
	            attachToViewer:   true,
	            autoFade:         options.autoFade
	        };
	
	        if( options.position ){
	            if( 'BOTTOM_RIGHT' == options.position ){
	               options.controlOptions.anchor = $.ControlAnchor.BOTTOM_RIGHT;
	            } else if( 'BOTTOM_LEFT' == options.position ){
	               options.controlOptions.anchor = $.ControlAnchor.BOTTOM_LEFT;
	            } else if( 'TOP_RIGHT' == options.position ){
	               options.controlOptions.anchor = $.ControlAnchor.TOP_RIGHT;
	            } else if( 'TOP_LEFT' == options.position ){
	               options.controlOptions.anchor = $.ControlAnchor.TOP_LEFT;
	            } else if( 'ABSOLUTE' == options.position ){
	               options.controlOptions.anchor = $.ControlAnchor.ABSOLUTE;
	               options.controlOptions.top = options.top;
	               options.controlOptions.left = options.left;
	               options.controlOptions.height = options.height;
	               options.controlOptions.width = options.width;
	            }
	        }
	
	    } else {
	        this.element            = document.getElementById( options.id );
	        options.controlOptions  = {
	            anchor:           $.ControlAnchor.NONE,
	            attachToViewer:   false,
	            autoFade:         false
	        };
	    }
	    this.element.id         = options.id;
	    this.element.className  += ' navigator';
	
	    options = $.extend( true, {
	        sizeRatio:     $.DEFAULT_SETTINGS.navigatorSizeRatio
	    }, options, {
	        element:                this.element,
	        tabIndex:               -1, // No keyboard navigation, omit from tab order
	        //These need to be overridden to prevent recursion since
	        //the navigator is a viewer and a viewer has a navigator
	        showNavigator:          false,
	        mouseNavEnabled:        false,
	        showNavigationControl:  false,
	        showSequenceControl:    false,
	        immediateRender:        true,
	        blendTime:              0,
	        animationTime:          0,
	        autoResize:             options.autoResize,
	        // prevent resizing the navigator from adding unwanted space around the image
	        minZoomImageRatio:      1.0,
	        background:             options.background,
	        opacity:                options.opacity,
	        borderColor:            options.borderColor,
	        displayRegionColor:     options.displayRegionColor
	    });
	
	    options.minPixelRatio = this.minPixelRatio = viewer.minPixelRatio;
	
	    $.setElementTouchActionNone( this.element );
	
	    this.borderWidth = 2;
	    //At some browser magnification levels the display regions lines up correctly, but at some there appears to
	    //be a one pixel gap.
	    this.fudge = new $.Point(1, 1);
	    this.totalBorderWidths = new $.Point(this.borderWidth * 2, this.borderWidth * 2).minus(this.fudge);
	
	
	    if ( options.controlOptions.anchor != $.ControlAnchor.NONE ) {
	        (function( style, borderWidth ){
	            style.margin        = '0px';
	            style.border        = borderWidth + 'px solid ' + options.borderColor;
	            style.padding       = '0px';
	            style.background    = options.background;
	            style.opacity       = options.opacity;
	            style.overflow      = 'hidden';
	        }( this.element.style, this.borderWidth));
	    }
	
	    this.displayRegion           = $.makeNeutralElement( "div" );
	    this.displayRegion.id        = this.element.id + '-displayregion';
	    this.displayRegion.className = 'displayregion';
	
	    (function( style, borderWidth ){
	        style.position      = 'relative';
	        style.top           = '0px';
	        style.left          = '0px';
	        style.fontSize      = '0px';
	        style.overflow      = 'hidden';
	        style.border        = borderWidth + 'px solid ' + options.displayRegionColor;
	        style.margin        = '0px';
	        style.padding       = '0px';
	        //TODO: IE doesnt like this property being set
	        //try{ style.outline  = '2px auto #909'; }catch(e){/*ignore*/}
	
	        style.background    = 'transparent';
	
	        // We use square bracket notation on the statement below, because float is a keyword.
	        // This is important for the Google Closure compiler, if nothing else.
	        /*jshint sub:true */
	        style['float']      = 'left'; //Webkit
	
	        style.cssFloat      = 'left'; //Firefox
	        style.styleFloat    = 'left'; //IE
	        style.zIndex        = 999999999;
	        style.cursor        = 'default';
	    }( this.displayRegion.style, this.borderWidth ));
	
	    this.displayRegionContainer = $.makeNeutralElement("div");
	    this.displayRegionContainer.id = this.element.id + '-displayregioncontainer';
	    this.displayRegionContainer.className = "displayregioncontainer";
	    this.displayRegionContainer.style.width = "100%";
	    this.displayRegionContainer.style.height = "100%";
	
	    viewer.addControl(
	        this.element,
	        options.controlOptions
	    );
	
	    this._resizeWithViewer = options.controlOptions.anchor != $.ControlAnchor.ABSOLUTE &&
	        options.controlOptions.anchor != $.ControlAnchor.NONE;
	
	    if ( this._resizeWithViewer ) {
	        if ( options.width && options.height ) {
	            this.element.style.height = typeof (options.height) == "number" ? (options.height + 'px') : options.height;
	            this.element.style.width  = typeof (options.width) == "number" ? (options.width + 'px') : options.width;
	        } else {
	            viewerSize = $.getElementSize( viewer.element );
	            this.element.style.height = Math.round( viewerSize.y * options.sizeRatio ) + 'px';
	            this.element.style.width  = Math.round( viewerSize.x * options.sizeRatio ) + 'px';
	            this.oldViewerSize = viewerSize;
	        }
	        navigatorSize = $.getElementSize( this.element );
	        this.elementArea = navigatorSize.x * navigatorSize.y;
	    }
	
	    this.oldContainerSize = new $.Point( 0, 0 );
	
	    $.Viewer.apply( this, [ options ] );
	
	    this.displayRegionContainer.appendChild(this.displayRegion);
	    this.element.getElementsByTagName('div')[0].appendChild(this.displayRegionContainer);
	
	    function rotate(degrees) {
	        _setTransformRotate(_this.displayRegionContainer, degrees);
	        _setTransformRotate(_this.displayRegion, -degrees);
	        _this.viewport.setRotation(degrees);
	    }
	    if (options.navigatorRotate) {
	        var degrees = options.viewer.viewport ?
	            options.viewer.viewport.getRotation() :
	            options.viewer.degrees || 0;
	
	        rotate(degrees);
	        options.viewer.addHandler("rotate", function (args) {
	            rotate(args.degrees);
	        });
	    }
	
	
	    // Remove the base class' (Viewer's) innerTracker and replace it with our own
	    this.innerTracker.destroy();
	    this.innerTracker = new $.MouseTracker({
	        element:         this.element,
	        dragHandler:     $.delegate( this, onCanvasDrag ),
	        clickHandler:    $.delegate( this, onCanvasClick ),
	        releaseHandler:  $.delegate( this, onCanvasRelease ),
	        scrollHandler:   $.delegate( this, onCanvasScroll )
	    });
	
	    this.addHandler("reset-size", function() {
	        if (_this.viewport) {
	            _this.viewport.goHome(true);
	        }
	    });
	
	    viewer.world.addHandler("item-index-change", function(event) {
	        window.setTimeout(function(){
	            var item = _this.world.getItemAt(event.previousIndex);
	            _this.world.setItemIndex(item, event.newIndex);
	        }, 1);
	    });
	
	    viewer.world.addHandler("remove-item", function(event) {
	        var theirItem = event.item;
	        var myItem = _this._getMatchingItem(theirItem);
	        if (myItem) {
	            _this.world.removeItem(myItem);
	        }
	    });
	
	    this.update(viewer.viewport);
	};
	
	$.extend( $.Navigator.prototype, $.EventSource.prototype, $.Viewer.prototype, /** @lends OpenSeadragon.Navigator.prototype */{
	
	    /**
	     * Used to notify the navigator when its size has changed.
	     * Especially useful when {@link OpenSeadragon.Options}.navigatorAutoResize is set to false and the navigator is resizable.
	     * @function
	     */
	    updateSize: function () {
	        if ( this.viewport ) {
	            var containerSize = new $.Point(
	                    (this.container.clientWidth === 0 ? 1 : this.container.clientWidth),
	                    (this.container.clientHeight === 0 ? 1 : this.container.clientHeight)
	                );
	
	            if ( !containerSize.equals( this.oldContainerSize ) ) {
	                this.viewport.resize( containerSize, true );
	                this.viewport.goHome(true);
	                this.oldContainerSize = containerSize;
	                this.drawer.clear();
	                this.world.draw();
	            }
	        }
	    },
	    /**
	      /* Flip navigator element
	      * @param {Boolean} state - Flip state to set.
	      */
	    setFlip: function(state) {
	      this.viewport.setFlip(state);
	
	      this.setDisplayTransform(this.viewer.viewport.getFlip() ? "scale(-1,1)" : "scale(1,1)");
	      return this;
	    },
	
	    setDisplayTransform: function(rule) {
	      setElementTransform(this.displayRegion, rule);
	      setElementTransform(this.canvas, rule);
	      setElementTransform(this.element, rule);
	    },
	
	    /**
	     * Used to update the navigator minimap's viewport rectangle when a change in the viewer's viewport occurs.
	     * @function
	     * @param {OpenSeadragon.Viewport} The viewport this navigator is tracking.
	     */
	    update: function( viewport ) {
	
	        var viewerSize,
	            newWidth,
	            newHeight,
	            bounds,
	            topleft,
	            bottomright;
	
	        viewerSize = $.getElementSize( this.viewer.element );
	        if ( this._resizeWithViewer && viewerSize.x && viewerSize.y && !viewerSize.equals( this.oldViewerSize ) ) {
	            this.oldViewerSize = viewerSize;
	
	            if ( this.maintainSizeRatio || !this.elementArea) {
	                newWidth  = viewerSize.x * this.sizeRatio;
	                newHeight = viewerSize.y * this.sizeRatio;
	            } else {
	                newWidth = Math.sqrt(this.elementArea * (viewerSize.x / viewerSize.y));
	                newHeight = this.elementArea / newWidth;
	            }
	
	            this.element.style.width  = Math.round( newWidth ) + 'px';
	            this.element.style.height = Math.round( newHeight ) + 'px';
	
	            if (!this.elementArea) {
	                this.elementArea = newWidth * newHeight;
	            }
	
	            this.updateSize();
	        }
	
	        if (viewport && this.viewport) {
	            bounds      = viewport.getBoundsNoRotate(true);
	            topleft     = this.viewport.pixelFromPointNoRotate(bounds.getTopLeft(), false);
	            bottomright = this.viewport.pixelFromPointNoRotate(bounds.getBottomRight(), false)
	                .minus( this.totalBorderWidths );
	
	            //update style for navigator-box
	            var style = this.displayRegion.style;
	            style.display = this.world.getItemCount() ? 'block' : 'none';
	
	            style.top    = Math.round( topleft.y ) + 'px';
	            style.left   = Math.round( topleft.x ) + 'px';
	
	            var width = Math.abs( topleft.x - bottomright.x );
	            var height = Math.abs( topleft.y - bottomright.y );
	            // make sure width and height are non-negative so IE doesn't throw
	            style.width  = Math.round( Math.max( width, 0 ) ) + 'px';
	            style.height = Math.round( Math.max( height, 0 ) ) + 'px';
	        }
	
	    },
	
	    // overrides Viewer.addTiledImage
	    addTiledImage: function(options) {
	        var _this = this;
	
	        var original = options.originalTiledImage;
	        delete options.original;
	
	        var optionsClone = $.extend({}, options, {
	            success: function(event) {
	                var myItem = event.item;
	                myItem._originalForNavigator = original;
	                _this._matchBounds(myItem, original, true);
	
	                function matchBounds() {
	                    _this._matchBounds(myItem, original);
	                }
	
	                function matchOpacity() {
	                    _this._matchOpacity(myItem, original);
	                }
	
	                function matchCompositeOperation() {
	                    _this._matchCompositeOperation(myItem, original);
	                }
	
	                original.addHandler('bounds-change', matchBounds);
	                original.addHandler('clip-change', matchBounds);
	                original.addHandler('opacity-change', matchOpacity);
	                original.addHandler('composite-operation-change', matchCompositeOperation);
	            }
	        });
	
	        return $.Viewer.prototype.addTiledImage.apply(this, [optionsClone]);
	    },
	
	    // private
	    _getMatchingItem: function(theirItem) {
	        var count = this.world.getItemCount();
	        var item;
	        for (var i = 0; i < count; i++) {
	            item = this.world.getItemAt(i);
	            if (item._originalForNavigator === theirItem) {
	                return item;
	            }
	        }
	
	        return null;
	    },
	
	    // private
	    _matchBounds: function(myItem, theirItem, immediately) {
	        var bounds = theirItem.getBoundsNoRotate();
	        myItem.setPosition(bounds.getTopLeft(), immediately);
	        myItem.setWidth(bounds.width, immediately);
	        myItem.setRotation(theirItem.getRotation(), immediately);
	        myItem.setClip(theirItem.getClip());
	    },
	
	    // private
	    _matchOpacity: function(myItem, theirItem) {
	        myItem.setOpacity(theirItem.opacity);
	    },
	
	    // private
	    _matchCompositeOperation: function(myItem, theirItem) {
	        myItem.setCompositeOperation(theirItem.compositeOperation);
	    }
	});
	
	
	/**
	 * @private
	 * @inner
	 * @function
	 */
	function onCanvasClick( event ) {
	  var canvasClickEventArgs = {
	    tracker: event.eventSource,
	    position: event.position,
	    quick: event.quick,
	    shift: event.shift,
	    originalEvent: event.originalEvent,
	    preventDefaultAction: event.preventDefaultAction
	  };
	  /**
	   * Raised when a click event occurs on the {@link OpenSeadragon.Viewer#navigator} element.
	   *
	   * @event navigator-click
	   * @memberof OpenSeadragon.Viewer
	   * @type {object}
	   * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised this event.
	   * @property {OpenSeadragon.MouseTracker} tracker - A reference to the MouseTracker which originated this event.
	   * @property {OpenSeadragon.Point} position - The position of the event relative to the tracked element.
	   * @property {Boolean} quick - True only if the clickDistThreshold and clickTimeThreshold are both passed. Useful for differentiating between clicks and drags.
	   * @property {Boolean} shift - True if the shift key was pressed during this event.
	   * @property {Object} originalEvent - The original DOM event.
	   * @property {?Object} userData - Arbitrary subscriber-defined object.
	   * @property {Boolean} preventDefaultAction - Set to true to prevent default click to zoom behaviour. Default: false.
	   */
	
	   this.viewer.raiseEvent('navigator-click', canvasClickEventArgs);
	
	   if ( !canvasClickEventArgs.preventDefaultAction && event.quick && this.viewer.viewport && (this.panVertical || this.panHorizontal)) {
	    if(this.viewer.viewport.flipped) {
	      event.position.x = this.viewport.getContainerSize().x - event.position.x;
	    }
	    var target = this.viewport.pointFromPixel(event.position);
	    if (!this.panVertical) {
	      // perform only horizonal pan
	      target.y = this.viewer.viewport.getCenter(true).y;
	    } else if (!this.panHorizontal) {
	      // perform only vertical pan
	      target.x = this.viewer.viewport.getCenter(true).x;
	    }
	    this.viewer.viewport.panTo(target);
	    this.viewer.viewport.applyConstraints();
	  }
	
	}
	
	/**
	 * @private
	 * @inner
	 * @function
	 */
	function onCanvasDrag( event ) {
	    var canvasDragEventArgs = {
	      tracker: event.eventSource,
	      position: event.position,
	      delta: event.delta,
	      speed: event.speed,
	      direction: event.direction,
	      shift: event.shift,
	      originalEvent: event.originalEvent,
	      preventDefaultAction: event.preventDefaultAction
	    };
	    /**
	     * Raised when a drag event occurs on the {@link OpenSeadragon.Viewer#navigator} element.
	     *
	     * @event navigator-drag
	     * @memberof OpenSeadragon.Viewer
	     * @type {object}
	     * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised this event.
	     * @property {OpenSeadragon.MouseTracker} tracker - A reference to the MouseTracker which originated this event.
	     * @property {OpenSeadragon.Point} position - The position of the event relative to the tracked element.
	     * @property {OpenSeadragon.Point} delta - The x,y components of the difference between start drag and end drag.
	     * @property {Number} speed - Current computed speed, in pixels per second.
	     * @property {Number} direction - Current computed direction, expressed as an angle counterclockwise relative to the positive X axis (-pi to pi, in radians). Only valid if speed > 0.
	     * @property {Boolean} shift - True if the shift key was pressed during this event.
	     * @property {Object} originalEvent - The original DOM event.
	     * @property {?Object} userData - Arbitrary subscriber-defined object.
	     * @property {Boolean} preventDefaultAction - Set to true to prevent default click to zoom behaviour. Default: false.
	     */
	     this.viewer.raiseEvent('navigator-drag', canvasDragEventArgs);
	
	     if ( !canvasDragEventArgs.preventDefaultAction && this.viewer.viewport ) {
	       if( !this.panHorizontal ){
	            event.delta.x = 0;
	        }
	        if( !this.panVertical ){
	            event.delta.y = 0;
	        }
	
	        if(this.viewer.viewport.flipped){
	            event.delta.x = -event.delta.x;
	        }
	
	        this.viewer.viewport.panBy(
	            this.viewport.deltaPointsFromPixels(
	                event.delta
	            )
	        );
	        if( this.viewer.constrainDuringPan ){
	            this.viewer.viewport.applyConstraints();
	        }
	    }
	}
	
	
	/**
	 * @private
	 * @inner
	 * @function
	 */
	function onCanvasRelease( event ) {
	    if ( event.insideElementPressed && this.viewer.viewport ) {
	        this.viewer.viewport.applyConstraints();
	    }
	}
	
	
	/**
	 * @private
	 * @inner
	 * @function
	 */
	function onCanvasScroll( event ) {
	    /**
	     * Raised when a scroll event occurs on the {@link OpenSeadragon.Viewer#navigator} element (mouse wheel, touch pinch, etc.).
	     *
	     * @event navigator-scroll
	     * @memberof OpenSeadragon.Viewer
	     * @type {object}
	     * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised this event.
	     * @property {OpenSeadragon.MouseTracker} tracker - A reference to the MouseTracker which originated this event.
	     * @property {OpenSeadragon.Point} position - The position of the event relative to the tracked element.
	     * @property {Number} scroll - The scroll delta for the event.
	     * @property {Boolean} shift - True if the shift key was pressed during this event.
	     * @property {Object} originalEvent - The original DOM event.
	     * @property {?Object} userData - Arbitrary subscriber-defined object.
	     */
	    this.viewer.raiseEvent( 'navigator-scroll', {
	        tracker: event.eventSource,
	        position: event.position,
	        scroll: event.scroll,
	        shift: event.shift,
	        originalEvent: event.originalEvent
	    });
	
	    //dont scroll the page up and down if the user is scrolling
	    //in the navigator
	    return false;
	}
	
	/**
	    * @function
	    * @private
	    * @param {Object} element
	    * @param {Number} degrees
	    */
	function _setTransformRotate( element, degrees ) {
	  setElementTransform(element, "rotate(" + degrees + "deg)");
	}
	
	function setElementTransform( element, rule ) {
	  element.style.webkitTransform = rule;
	  element.style.mozTransform = rule;
	  element.style.msTransform = rule;
	  element.style.oTransform = rule;
	  element.style.transform = rule;
	}
	
	}( OpenSeadragon ));
	
	/*
	 * OpenSeadragon - getString/setString
	 *
	 * Copyright (C) 2009 CodePlex Foundation
	 * Copyright (C) 2010-2013 OpenSeadragon contributors
	 *
	 * Redistribution and use in source and binary forms, with or without
	 * modification, are permitted provided that the following conditions are
	 * met:
	 *
	 * - Redistributions of source code must retain the above copyright notice,
	 *   this list of conditions and the following disclaimer.
	 *
	 * - Redistributions in binary form must reproduce the above copyright
	 *   notice, this list of conditions and the following disclaimer in the
	 *   documentation and/or other materials provided with the distribution.
	 *
	 * - Neither the name of CodePlex Foundation nor the names of its
	 *   contributors may be used to endorse or promote products derived from
	 *   this software without specific prior written permission.
	 *
	 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
	 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
	 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
	 * A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT
	 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
	 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
	 * TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 * PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
	 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
	 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
	 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	 */
	
	(function( $ ){
	
	//TODO: I guess this is where the i18n needs to be reimplemented.  I'll look
	//      into existing patterns for i18n in javascript but i think that mimicking
	//      pythons gettext might be a reasonable approach.
	var I18N = {
	    Errors: {
	        Dzc:            "Sorry, we don't support Deep Zoom Collections!",
	        Dzi:            "Hmm, this doesn't appear to be a valid Deep Zoom Image.",
	        Xml:            "Hmm, this doesn't appear to be a valid Deep Zoom Image.",
	        ImageFormat:    "Sorry, we don't support {0}-based Deep Zoom Images.",
	        Security:       "It looks like a security restriction stopped us from " +
	                        "loading this Deep Zoom Image.",
	        Status:         "This space unintentionally left blank ({0} {1}).",
	        OpenFailed:     "Unable to open {0}: {1}"
	    },
	
	    Tooltips: {
	        FullPage:       "Toggle full page",
	        Home:           "Go home",
	        ZoomIn:         "Zoom in",
	        ZoomOut:        "Zoom out",
	        NextPage:       "Next page",
	        PreviousPage:   "Previous page",
	        RotateLeft:     "Rotate left",
	        RotateRight:    "Rotate right",
	        Flip:           "Flip Horizontally"
	    }
	};
	
	$.extend( $, /** @lends OpenSeadragon */{
	
	    /**
	     * @function
	     * @param {String} property
	     */
	    getString: function( prop ) {
	
	        var props   = prop.split('.'),
	            string  = null,
	            args    = arguments,
	            container = I18N,
	            i;
	
	        for (i = 0; i < props.length - 1; i++) {
	            // in case not a subproperty
	            container = container[ props[ i ] ] || {};
	        }
	        string = container[ props[ i ] ];
	
	        if ( typeof ( string ) != "string" ) {
	            $.console.log( "Untranslated source string:", prop );
	            string = ""; // FIXME: this breaks gettext()-style convention, which would return source
	        }
	
	        return string.replace(/\{\d+\}/g, function(capture) {
	            var i = parseInt( capture.match( /\d+/ ), 10 ) + 1;
	            return i < args.length ?
	                args[ i ] :
	                "";
	        });
	    },
	
	    /**
	     * @function
	     * @param {String} property
	     * @param {*} value
	     */
	    setString: function( prop, value ) {
	
	        var props     = prop.split('.'),
	            container = I18N,
	            i;
	
	        for ( i = 0; i < props.length - 1; i++ ) {
	            if ( !container[ props[ i ] ] ) {
	                container[ props[ i ] ] = {};
	            }
	            container = container[ props[ i ] ];
	        }
	
	        container[ props[ i ] ] = value;
	    }
	
	});
	
	}( OpenSeadragon ));
	
	/*
	 * OpenSeadragon - Point
	 *
	 * Copyright (C) 2009 CodePlex Foundation
	 * Copyright (C) 2010-2013 OpenSeadragon contributors
	 *
	 * Redistribution and use in source and binary forms, with or without
	 * modification, are permitted provided that the following conditions are
	 * met:
	 *
	 * - Redistributions of source code must retain the above copyright notice,
	 *   this list of conditions and the following disclaimer.
	 *
	 * - Redistributions in binary form must reproduce the above copyright
	 *   notice, this list of conditions and the following disclaimer in the
	 *   documentation and/or other materials provided with the distribution.
	 *
	 * - Neither the name of CodePlex Foundation nor the names of its
	 *   contributors may be used to endorse or promote products derived from
	 *   this software without specific prior written permission.
	 *
	 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
	 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
	 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
	 * A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT
	 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
	 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
	 * TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 * PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
	 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
	 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
	 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	 */
	
	(function( $ ){
	
	/**
	 * @class Point
	 * @classdesc A Point is really used as a 2-dimensional vector, equally useful for
	 * representing a point on a plane, or the height and width of a plane
	 * not requiring any other frame of reference.
	 *
	 * @memberof OpenSeadragon
	 * @param {Number} [x] The vector component 'x'. Defaults to the origin at 0.
	 * @param {Number} [y] The vector component 'y'. Defaults to the origin at 0.
	 */
	$.Point = function( x, y ) {
	    /**
	     * The vector component 'x'.
	     * @member {Number} x
	     * @memberof OpenSeadragon.Point#
	     */
	    this.x = typeof ( x ) == "number" ? x : 0;
	    /**
	     * The vector component 'y'.
	     * @member {Number} y
	     * @memberof OpenSeadragon.Point#
	     */
	    this.y = typeof ( y ) == "number" ? y : 0;
	};
	
	/** @lends OpenSeadragon.Point.prototype */
	$.Point.prototype = {
	    /**
	     * @function
	     * @returns {OpenSeadragon.Point} a duplicate of this Point
	     */
	    clone: function() {
	        return new $.Point(this.x, this.y);
	    },
	
	    /**
	     * Add another Point to this point and return a new Point.
	     * @function
	     * @param {OpenSeadragon.Point} point The point to add vector components.
	     * @returns {OpenSeadragon.Point} A new point representing the sum of the
	     *  vector components
	     */
	    plus: function( point ) {
	        return new $.Point(
	            this.x + point.x,
	            this.y + point.y
	        );
	    },
	
	    /**
	     * Substract another Point to this point and return a new Point.
	     * @function
	     * @param {OpenSeadragon.Point} point The point to substract vector components.
	     * @returns {OpenSeadragon.Point} A new point representing the substraction of the
	     *  vector components
	     */
	    minus: function( point ) {
	        return new $.Point(
	            this.x - point.x,
	            this.y - point.y
	        );
	    },
	
	    /**
	     * Multiply this point by a factor and return a new Point.
	     * @function
	     * @param {Number} factor The factor to multiply vector components.
	     * @returns {OpenSeadragon.Point} A new point representing the multiplication
	     *  of the vector components by the factor
	     */
	    times: function( factor ) {
	        return new $.Point(
	            this.x * factor,
	            this.y * factor
	        );
	    },
	
	    /**
	     * Divide this point by a factor and return a new Point.
	     * @function
	     * @param {Number} factor The factor to divide vector components.
	     * @returns {OpenSeadragon.Point} A new point representing the division of the
	     *  vector components by the factor
	     */
	    divide: function( factor ) {
	        return new $.Point(
	            this.x / factor,
	            this.y / factor
	        );
	    },
	
	    /**
	     * Compute the opposite of this point and return a new Point.
	     * @function
	     * @returns {OpenSeadragon.Point} A new point representing the opposite of the
	     *  vector components
	     */
	    negate: function() {
	        return new $.Point( -this.x, -this.y );
	    },
	
	    /**
	     * Compute the distance between this point and another point.
	     * @function
	     * @param {OpenSeadragon.Point} point The point to compute the distance with.
	     * @returns {Number} The distance between the 2 points
	     */
	    distanceTo: function( point ) {
	        return Math.sqrt(
	            Math.pow( this.x - point.x, 2 ) +
	            Math.pow( this.y - point.y, 2 )
	        );
	    },
	
	    /**
	     * Compute the squared distance between this point and another point.
	     * Useful for optimizing things like comparing distances.
	     * @function
	     * @param {OpenSeadragon.Point} point The point to compute the squared distance with.
	     * @returns {Number} The squared distance between the 2 points
	     */
	    squaredDistanceTo: function( point ) {
	        return Math.pow( this.x - point.x, 2 ) +
	            Math.pow( this.y - point.y, 2 );
	    },
	
	    /**
	     * Apply a function to each coordinate of this point and return a new point.
	     * @function
	     * @param {function} func The function to apply to each coordinate.
	     * @returns {OpenSeadragon.Point} A new point with the coordinates computed
	     * by the specified function
	     */
	    apply: function( func ) {
	        return new $.Point( func( this.x ), func( this.y ) );
	    },
	
	    /**
	     * Check if this point is equal to another one.
	     * @function
	     * @param {OpenSeadragon.Point} point The point to compare this point with.
	     * @returns {Boolean} true if they are equal, false otherwise.
	     */
	    equals: function( point ) {
	        return (
	            point instanceof $.Point
	        ) && (
	            this.x === point.x
	        ) && (
	            this.y === point.y
	        );
	    },
	
	    /**
	     * Rotates the point around the specified pivot
	     * From http://stackoverflow.com/questions/4465931/rotate-rectangle-around-a-point
	     * @function
	     * @param {Number} degress to rotate around the pivot.
	     * @param {OpenSeadragon.Point} [pivot=(0,0)] Point around which to rotate.
	     * Defaults to the origin.
	     * @returns {OpenSeadragon.Point}. A new point representing the point rotated around the specified pivot
	     */
	    rotate: function (degrees, pivot) {
	        pivot = pivot || new $.Point(0, 0);
	        var cos;
	        var sin;
	        // Avoid float computations when possible
	        if (degrees % 90 === 0) {
	            var d = $.positiveModulo(degrees, 360);
	            switch (d) {
	                case 0:
	                    cos = 1;
	                    sin = 0;
	                    break;
	                case 90:
	                    cos = 0;
	                    sin = 1;
	                    break;
	                case 180:
	                    cos = -1;
	                    sin = 0;
	                    break;
	                case 270:
	                    cos = 0;
	                    sin = -1;
	                    break;
	            }
	        } else {
	            var angle = degrees * Math.PI / 180.0;
	            cos = Math.cos(angle);
	            sin = Math.sin(angle);
	        }
	        var x = cos * (this.x - pivot.x) - sin * (this.y - pivot.y) + pivot.x;
	        var y = sin * (this.x - pivot.x) + cos * (this.y - pivot.y) + pivot.y;
	        return new $.Point(x, y);
	    },
	
	    /**
	     * Convert this point to a string in the format (x,y) where x and y are
	     * rounded to the nearest integer.
	     * @function
	     * @returns {String} A string representation of this point.
	     */
	    toString: function() {
	        return "(" + (Math.round(this.x * 100) / 100) + "," + (Math.round(this.y * 100) / 100) + ")";
	    }
	};
	
	}( OpenSeadragon ));
	
	/*
	 * OpenSeadragon - TileSource
	 *
	 * Copyright (C) 2009 CodePlex Foundation
	 * Copyright (C) 2010-2013 OpenSeadragon contributors
	 *
	 * Redistribution and use in source and binary forms, with or without
	 * modification, are permitted provided that the following conditions are
	 * met:
	 *
	 * - Redistributions of source code must retain the above copyright notice,
	 *   this list of conditions and the following disclaimer.
	 *
	 * - Redistributions in binary form must reproduce the above copyright
	 *   notice, this list of conditions and the following disclaimer in the
	 *   documentation and/or other materials provided with the distribution.
	 *
	 * - Neither the name of CodePlex Foundation nor the names of its
	 *   contributors may be used to endorse or promote products derived from
	 *   this software without specific prior written permission.
	 *
	 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
	 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
	 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
	 * A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT
	 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
	 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
	 * TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 * PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
	 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
	 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
	 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	 */
	
	(function( $ ){
	
	
	/**
	 * @class TileSource
	 * @classdesc The TileSource contains the most basic implementation required to create a
	 * smooth transition between layers in an image pyramid. It has only a single key
	 * interface that must be implemented to complete its key functionality:
	 * 'getTileUrl'.  It also has several optional interfaces that can be
	 * implemented if a new TileSource wishes to support configuration via a simple
	 * object or array ('configure') and if the tile source supports or requires
	 * configuration via retrieval of a document on the network ala AJAX or JSONP,
	 * ('getImageInfo').
	 * <br/>
	 * By default the image pyramid is split into N layers where the image's longest
	 * side in M (in pixels), where N is the smallest integer which satisfies
	 *      <strong>2^(N+1) >= M</strong>.
	 *
	 * @memberof OpenSeadragon
	 * @extends OpenSeadragon.EventSource
	 * @param {Object} options
	 *      You can either specify a URL, or literally define the TileSource (by specifying
	 *      width, height, tileSize, tileOverlap, minLevel, and maxLevel). For the former,
	 *      the extending class is expected to implement 'getImageInfo' and 'configure'.
	 *      For the latter, the construction is assumed to occur through
	 *      the extending classes implementation of 'configure'.
	 * @param {String} [options.url]
	 *      The URL for the data necessary for this TileSource.
	 * @param {String} [options.referenceStripThumbnailUrl]
	 *      The URL for a thumbnail image to be used by the reference strip
	 * @param {Function} [options.success]
	 *      A function to be called upon successful creation.
	 * @param {Boolean} [options.ajaxWithCredentials]
	 *      If this TileSource needs to make an AJAX call, this specifies whether to set
	 *      the XHR's withCredentials (for accessing secure data).
	 * @param {Object} [options.ajaxHeaders]
	 *      A set of headers to include in AJAX requests.
	 * @param {Number} [options.width]
	 *      Width of the source image at max resolution in pixels.
	 * @param {Number} [options.height]
	 *      Height of the source image at max resolution in pixels.
	 * @param {Number} [options.tileSize]
	 *      The size of the tiles to assumed to make up each pyramid layer in pixels.
	 *      Tile size determines the point at which the image pyramid must be
	 *      divided into a matrix of smaller images.
	 *      Use options.tileWidth and options.tileHeight to support non-square tiles.
	 * @param {Number} [options.tileWidth]
	 *      The width of the tiles to assumed to make up each pyramid layer in pixels.
	 * @param {Number} [options.tileHeight]
	 *      The height of the tiles to assumed to make up each pyramid layer in pixels.
	 * @param {Number} [options.tileOverlap]
	 *      The number of pixels each tile is expected to overlap touching tiles.
	 * @param {Number} [options.minLevel]
	 *      The minimum level to attempt to load.
	 * @param {Number} [options.maxLevel]
	 *      The maximum level to attempt to load.
	 */
	$.TileSource = function( width, height, tileSize, tileOverlap, minLevel, maxLevel ) {
	    var _this = this;
	
	    var args = arguments,
	        options,
	        i;
	
	    if( $.isPlainObject( width ) ){
	        options = width;
	    }else{
	        options = {
	            width: args[0],
	            height: args[1],
	            tileSize: args[2],
	            tileOverlap: args[3],
	            minLevel: args[4],
	            maxLevel: args[5]
	        };
	    }
	
	    //Tile sources supply some events, namely 'ready' when they must be configured
	    //by asynchronously fetching their configuration data.
	    $.EventSource.call( this );
	
	    //we allow options to override anything we dont treat as
	    //required via idiomatic options or which is functionally
	    //set depending on the state of the readiness of this tile
	    //source
	    $.extend( true, this, options );
	
	    if (!this.success) {
	        //Any functions that are passed as arguments are bound to the ready callback
	        for ( i = 0; i < arguments.length; i++ ) {
	            if ( $.isFunction( arguments[ i ] ) ) {
	                this.success = arguments[ i ];
	                //only one callback per constructor
	                break;
	            }
	        }
	    }
	
	    if (this.success) {
	        this.addHandler( 'ready', function ( event ) {
	            _this.success( event );
	        } );
	    }
	
	    /**
	     * Ratio of width to height
	     * @member {Number} aspectRatio
	     * @memberof OpenSeadragon.TileSource#
	     */
	    /**
	     * Vector storing x and y dimensions ( width and height respectively ).
	     * @member {OpenSeadragon.Point} dimensions
	     * @memberof OpenSeadragon.TileSource#
	     */
	    /**
	     * The overlap in pixels each tile shares with its adjacent neighbors.
	     * @member {Number} tileOverlap
	     * @memberof OpenSeadragon.TileSource#
	     */
	    /**
	     * The minimum pyramid level this tile source supports or should attempt to load.
	     * @member {Number} minLevel
	     * @memberof OpenSeadragon.TileSource#
	     */
	    /**
	     * The maximum pyramid level this tile source supports or should attempt to load.
	     * @member {Number} maxLevel
	     * @memberof OpenSeadragon.TileSource#
	     */
	    /**
	     *
	     * @member {Boolean} ready
	     * @memberof OpenSeadragon.TileSource#
	     */
	
	    if( 'string' == $.type( arguments[ 0 ] ) ){
	        this.url = arguments[0];
	    }
	
	    if (this.url) {
	        //in case the getImageInfo method is overriden and/or implies an
	        //async mechanism set some safe defaults first
	        this.aspectRatio = 1;
	        this.dimensions  = new $.Point( 10, 10 );
	        this._tileWidth  = 0;
	        this._tileHeight = 0;
	        this.tileOverlap = 0;
	        this.minLevel    = 0;
	        this.maxLevel    = 0;
	        this.ready       = false;
	        //configuration via url implies the extending class
	        //implements and 'configure'
	        this.getImageInfo( this.url );
	
	    } else {
	
	        //explicit configuration via positional args in constructor
	        //or the more idiomatic 'options' object
	        this.ready       = true;
	        this.aspectRatio = (options.width && options.height) ?
	            (options.width / options.height) : 1;
	        this.dimensions  = new $.Point( options.width, options.height );
	
	        if ( this.tileSize ){
	            this._tileWidth = this._tileHeight = this.tileSize;
	            delete this.tileSize;
	        } else {
	            if( this.tileWidth ){
	                // We were passed tileWidth in options, but we want to rename it
	                // with a leading underscore to make clear that it is not safe to directly modify it
	                this._tileWidth = this.tileWidth;
	                delete this.tileWidth;
	            } else {
	                this._tileWidth = 0;
	            }
	
	            if( this.tileHeight ){
	                // See note above about renaming this.tileWidth
	                this._tileHeight = this.tileHeight;
	                delete this.tileHeight;
	            } else {
	                this._tileHeight = 0;
	            }
	        }
	
	        this.tileOverlap = options.tileOverlap ? options.tileOverlap : 0;
	        this.minLevel    = options.minLevel ? options.minLevel : 0;
	        this.maxLevel    = ( undefined !== options.maxLevel && null !== options.maxLevel ) ?
	            options.maxLevel : (
	                ( options.width && options.height ) ? Math.ceil(
	                    Math.log( Math.max( options.width, options.height ) ) /
	                    Math.log( 2 )
	                ) : 0
	            );
	        if( this.success && $.isFunction( this.success ) ){
	            this.success( this );
	        }
	    }
	
	
	};
	
	/** @lends OpenSeadragon.TileSource.prototype */
	$.TileSource.prototype = {
	
	    getTileSize: function( level ) {
	        $.console.error(
	            "[TileSource.getTileSize] is deprecated." +
	            "Use TileSource.getTileWidth() and TileSource.getTileHeight() instead"
	        );
	        return this._tileWidth;
	    },
	
	    /**
	     * Return the tileWidth for a given level.
	     * Subclasses should override this if tileWidth can be different at different levels
	     *   such as in IIIFTileSource.  Code should use this function rather than reading
	     *   from ._tileWidth directly.
	     * @function
	     * @param {Number} level
	     */
	    getTileWidth: function( level ) {
	        if (!this._tileWidth) {
	            return this.getTileSize(level);
	        }
	        return this._tileWidth;
	    },
	
	    /**
	     * Return the tileHeight for a given level.
	     * Subclasses should override this if tileHeight can be different at different levels
	     *   such as in IIIFTileSource.  Code should use this function rather than reading
	     *   from ._tileHeight directly.
	     * @function
	     * @param {Number} level
	     */
	    getTileHeight: function( level ) {
	        if (!this._tileHeight) {
	            return this.getTileSize(level);
	        }
	        return this._tileHeight;
	    },
	
	    /**
	     * @function
	     * @param {Number} level
	     */
	    getLevelScale: function( level ) {
	
	        // see https://github.com/openseadragon/openseadragon/issues/22
	        // we use the tilesources implementation of getLevelScale to generate
	        // a memoized re-implementation
	        var levelScaleCache = {},
	            i;
	        for( i = 0; i <= this.maxLevel; i++ ){
	            levelScaleCache[ i ] = 1 / Math.pow(2, this.maxLevel - i);
	        }
	        this.getLevelScale = function( _level ){
	            return levelScaleCache[ _level ];
	        };
	        return this.getLevelScale( level );
	    },
	
	    /**
	     * @function
	     * @param {Number} level
	     */
	    getNumTiles: function( level ) {
	        var scale = this.getLevelScale( level ),
	            x = Math.ceil( scale * this.dimensions.x / this.getTileWidth(level) ),
	            y = Math.ceil( scale * this.dimensions.y / this.getTileHeight(level) );
	
	        return new $.Point( x, y );
	    },
	
	    /**
	     * @function
	     * @param {Number} level
	     */
	    getPixelRatio: function( level ) {
	        var imageSizeScaled = this.dimensions.times( this.getLevelScale( level ) ),
	            rx = 1.0 / imageSizeScaled.x,
	            ry = 1.0 / imageSizeScaled.y;
	
	        return new $.Point(rx, ry);
	    },
	
	
	    /**
	     * @function
	     * @returns {Number} The highest level in this tile source that can be contained in a single tile.
	     */
	    getClosestLevel: function() {
	        var i,
	            tiles;
	
	        for (i = this.minLevel + 1; i <= this.maxLevel; i++){
	            tiles = this.getNumTiles(i);
	            if (tiles.x > 1 || tiles.y > 1) {
	                break;
	            }
	        }
	
	        return i - 1;
	    },
	
	    /**
	     * @function
	     * @param {Number} level
	     * @param {OpenSeadragon.Point} point
	     */
	    getTileAtPoint: function(level, point) {
	        var validPoint = point.x >= 0 && point.x <= 1 &&
	            point.y >= 0 && point.y <= 1 / this.aspectRatio;
	        $.console.assert(validPoint, "[TileSource.getTileAtPoint] must be called with a valid point.");
	
	        var widthScaled = this.dimensions.x * this.getLevelScale(level);
	        var pixelX = point.x * widthScaled;
	        var pixelY = point.y * widthScaled;
	
	        var x = Math.floor(pixelX / this.getTileWidth(level));
	        var y = Math.floor(pixelY / this.getTileHeight(level));
	
	        // When point.x == 1 or point.y == 1 / this.aspectRatio we want to
	        // return the last tile of the row/column
	        if (point.x >= 1) {
	            x = this.getNumTiles(level).x - 1;
	        }
	        var EPSILON = 1e-15;
	        if (point.y >= 1 / this.aspectRatio - EPSILON) {
	            y = this.getNumTiles(level).y - 1;
	        }
	
	        return new $.Point(x, y);
	    },
	
	    /**
	     * @function
	     * @param {Number} level
	     * @param {Number} x
	     * @param {Number} y
	     * @param {Boolean} [isSource=false] Whether to return the source bounds of the tile.
	     * @returns {OpenSeadragon.Rect} Either where this tile fits (in normalized coordinates) or the
	     * portion of the tile to use as the source of the drawing operation (in pixels), depending on
	     * the isSource parameter.
	     */
	    getTileBounds: function( level, x, y, isSource ) {
	        var dimensionsScaled = this.dimensions.times( this.getLevelScale( level ) ),
	            tileWidth = this.getTileWidth(level),
	            tileHeight = this.getTileHeight(level),
	            px = ( x === 0 ) ? 0 : tileWidth * x - this.tileOverlap,
	            py = ( y === 0 ) ? 0 : tileHeight * y - this.tileOverlap,
	            sx = tileWidth + ( x === 0 ? 1 : 2 ) * this.tileOverlap,
	            sy = tileHeight + ( y === 0 ? 1 : 2 ) * this.tileOverlap,
	            scale = 1.0 / dimensionsScaled.x;
	
	        sx = Math.min( sx, dimensionsScaled.x - px );
	        sy = Math.min( sy, dimensionsScaled.y - py );
	
	        if (isSource) {
	            return new $.Rect(0, 0, sx, sy);
	        }
	
	        return new $.Rect( px * scale, py * scale, sx * scale, sy * scale );
	    },
	
	
	    /**
	     * Responsible for retrieving, and caching the
	     * image metadata pertinent to this TileSources implementation.
	     * @function
	     * @param {String} url
	     * @throws {Error}
	     */
	    getImageInfo: function( url ) {
	        var _this = this,
	            callbackName,
	            callback,
	            readySource,
	            options,
	            urlParts,
	            filename,
	            lastDot;
	
	
	        if( url ) {
	            urlParts = url.split( '/' );
	            filename = urlParts[ urlParts.length - 1 ];
	            lastDot  = filename.lastIndexOf( '.' );
	            if ( lastDot > -1 ) {
	                urlParts[ urlParts.length - 1 ] = filename.slice( 0, lastDot );
	            }
	        }
	
	        callback = function( data ){
	            if( typeof (data) === "string" ) {
	                data = $.parseXml( data );
	            }
	            var $TileSource = $.TileSource.determineType( _this, data, url );
	            if ( !$TileSource ) {
	                /**
	                 * Raised when an error occurs loading a TileSource.
	                 *
	                 * @event open-failed
	                 * @memberof OpenSeadragon.TileSource
	                 * @type {object}
	                 * @property {OpenSeadragon.TileSource} eventSource - A reference to the TileSource which raised the event.
	                 * @property {String} message
	                 * @property {String} source
	                 * @property {?Object} userData - Arbitrary subscriber-defined object.
	                 */
	                _this.raiseEvent( 'open-failed', { message: "Unable to load TileSource", source: url } );
	                return;
	            }
	
	            options = $TileSource.prototype.configure.apply( _this, [ data, url ]);
	            if (options.ajaxWithCredentials === undefined) {
	                options.ajaxWithCredentials = _this.ajaxWithCredentials;
	            }
	
	            readySource = new $TileSource( options );
	            _this.ready = true;
	            /**
	             * Raised when a TileSource is opened and initialized.
	             *
	             * @event ready
	             * @memberof OpenSeadragon.TileSource
	             * @type {object}
	             * @property {OpenSeadragon.TileSource} eventSource - A reference to the TileSource which raised the event.
	             * @property {Object} tileSource
	             * @property {?Object} userData - Arbitrary subscriber-defined object.
	             */
	            _this.raiseEvent( 'ready', { tileSource: readySource } );
	        };
	
	        if( url.match(/\.js$/) ){
	            //TODO: Its not very flexible to require tile sources to end jsonp
	            //      request for info  with a url that ends with '.js' but for
	            //      now it's the only way I see to distinguish uniformly.
	            callbackName = url.split('/').pop().replace('.js', '');
	            $.jsonp({
	                url: url,
	                async: false,
	                callbackName: callbackName,
	                callback: callback
	            });
	        } else {
	            // request info via xhr asynchronously.
	            $.makeAjaxRequest( {
	                url: url,
	                withCredentials: this.ajaxWithCredentials,
	                headers: this.ajaxHeaders,
	                success: function( xhr ) {
	                    var data = processResponse( xhr );
	                    callback( data );
	                },
	                error: function ( xhr, exc ) {
	                    var msg;
	
	                    /*
	                        IE < 10 will block XHR requests to different origins. Any property access on the request
	                        object will raise an exception which we'll attempt to handle by formatting the original
	                        exception rather than the second one raised when we try to access xhr.status
	                     */
	                    try {
	                        msg = "HTTP " + xhr.status + " attempting to load TileSource";
	                    } catch ( e ) {
	                        var formattedExc;
	                        if ( typeof ( exc ) == "undefined" || !exc.toString ) {
	                            formattedExc = "Unknown error";
	                        } else {
	                            formattedExc = exc.toString();
	                        }
	
	                        msg = formattedExc + " attempting to load TileSource";
	                    }
	
	                    /***
	                     * Raised when an error occurs loading a TileSource.
	                     *
	                     * @event open-failed
	                     * @memberof OpenSeadragon.TileSource
	                     * @type {object}
	                     * @property {OpenSeadragon.TileSource} eventSource - A reference to the TileSource which raised the event.
	                     * @property {String} message
	                     * @property {String} source
	                     * @property {?Object} userData - Arbitrary subscriber-defined object.
	                     */
	                    _this.raiseEvent( 'open-failed', {
	                        message: msg,
	                        source: url
	                    });
	                }
	            });
	        }
	
	    },
	
	    /**
	     * Responsible determining if a the particular TileSource supports the
	     * data format ( and allowed to apply logic against the url the data was
	     * loaded from, if any ). Overriding implementations are expected to do
	     * something smart with data and / or url to determine support.  Also
	     * understand that iteration order of TileSources is not guarunteed so
	     * please make sure your data or url is expressive enough to ensure a simple
	     * and sufficient mechanisim for clear determination.
	     * @function
	     * @param {String|Object|Array|Document} data
	     * @param {String} url - the url the data was loaded
	     *      from if any.
	     * @return {Boolean}
	     */
	    supports: function( data, url ) {
	        return false;
	    },
	
	    /**
	     * Responsible for parsing and configuring the
	     * image metadata pertinent to this TileSources implementation.
	     * This method is not implemented by this class other than to throw an Error
	     * announcing you have to implement it.  Because of the variety of tile
	     * server technologies, and various specifications for building image
	     * pyramids, this method is here to allow easy integration.
	     * @function
	     * @param {String|Object|Array|Document} data
	     * @param {String} url - the url the data was loaded
	     *      from if any.
	     * @return {Object} options - A dictionary of keyword arguments sufficient
	     *      to configure this tile sources constructor.
	     * @throws {Error}
	     */
	    configure: function( data, url ) {
	        throw new Error( "Method not implemented." );
	    },
	
	    /**
	     * Responsible for retrieving the url which will return an image for the
	     * region specified by the given x, y, and level components.
	     * This method is not implemented by this class other than to throw an Error
	     * announcing you have to implement it.  Because of the variety of tile
	     * server technologies, and various specifications for building image
	     * pyramids, this method is here to allow easy integration.
	     * @function
	     * @param {Number} level
	     * @param {Number} x
	     * @param {Number} y
	     * @throws {Error}
	     */
	    getTileUrl: function( level, x, y ) {
	        throw new Error( "Method not implemented." );
	    },
	
	    /**
	     * Responsible for retrieving the headers which will be attached to the image request for the
	     * region specified by the given x, y, and level components.
	     * This option is only relevant if {@link OpenSeadragon.Options}.loadTilesWithAjax is set to true.
	     * The headers returned here will override headers specified at the Viewer or TiledImage level.
	     * Specifying a falsy value for a header will clear its existing value set at the Viewer or
	     * TiledImage level (if any).
	     * @function
	     * @param {Number} level
	     * @param {Number} x
	     * @param {Number} y
	     * @returns {Object}
	     */
	    getTileAjaxHeaders: function( level, x, y ) {
	        return {};
	    },
	
	    /**
	     * @function
	     * @param {Number} level
	     * @param {Number} x
	     * @param {Number} y
	     */
	    tileExists: function( level, x, y ) {
	        var numTiles = this.getNumTiles( level );
	        return level >= this.minLevel &&
	               level <= this.maxLevel &&
	               x >= 0 &&
	               y >= 0 &&
	               x < numTiles.x &&
	               y < numTiles.y;
	    }
	};
	
	
	$.extend( true, $.TileSource.prototype, $.EventSource.prototype );
	
	
	/**
	 * Decides whether to try to process the response as xml, json, or hand back
	 * the text
	 * @private
	 * @inner
	 * @function
	 * @param {XMLHttpRequest} xhr - the completed network request
	 */
	function processResponse( xhr ){
	    var responseText = xhr.responseText,
	        status       = xhr.status,
	        statusText,
	        data;
	
	    if ( !xhr ) {
	        throw new Error( $.getString( "Errors.Security" ) );
	    } else if ( xhr.status !== 200 && xhr.status !== 0 ) {
	        status     = xhr.status;
	        statusText = ( status == 404 ) ?
	            "Not Found" :
	            xhr.statusText;
	        throw new Error( $.getString( "Errors.Status", status, statusText ) );
	    }
	
	    if( responseText.match(/\s*<.*/) ){
	        try{
	        data = ( xhr.responseXML && xhr.responseXML.documentElement ) ?
	            xhr.responseXML :
	            $.parseXml( responseText );
	        } catch (e){
	            data = xhr.responseText;
	        }
	    }else if( responseText.match(/\s*[\{\[].*/) ){
	        try{
	          data = $.parseJSON(responseText);
	        } catch(e){
	          data =  responseText;
	        }
	    }else{
	        data = responseText;
	    }
	    return data;
	}
	
	
	/**
	 * Determines the TileSource Implementation by introspection of OpenSeadragon
	 * namespace, calling each TileSource implementation of 'isType'
	 * @private
	 * @inner
	 * @function
	 * @param {Object|Array|Document} data - the tile source configuration object
	 * @param {String} url - the url where the tile source configuration object was
	 *      loaded from, if any.
	 */
	$.TileSource.determineType = function( tileSource, data, url ){
	    var property;
	    for( property in OpenSeadragon ){
	        if( property.match(/.+TileSource$/) &&
	            $.isFunction( OpenSeadragon[ property ] ) &&
	            $.isFunction( OpenSeadragon[ property ].prototype.supports ) &&
	            OpenSeadragon[ property ].prototype.supports.call( tileSource, data, url )
	        ){
	            return OpenSeadragon[ property ];
	        }
	    }
	
	    $.console.error( "No TileSource was able to open %s %s", url, data );
	};
	
	
	}( OpenSeadragon ));
	
	/*
	 * OpenSeadragon - DziTileSource
	 *
	 * Copyright (C) 2009 CodePlex Foundation
	 * Copyright (C) 2010-2013 OpenSeadragon contributors
	 *
	 * Redistribution and use in source and binary forms, with or without
	 * modification, are permitted provided that the following conditions are
	 * met:
	 *
	 * - Redistributions of source code must retain the above copyright notice,
	 *   this list of conditions and the following disclaimer.
	 *
	 * - Redistributions in binary form must reproduce the above copyright
	 *   notice, this list of conditions and the following disclaimer in the
	 *   documentation and/or other materials provided with the distribution.
	 *
	 * - Neither the name of CodePlex Foundation nor the names of its
	 *   contributors may be used to endorse or promote products derived from
	 *   this software without specific prior written permission.
	 *
	 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
	 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
	 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
	 * A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT
	 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
	 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
	 * TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 * PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
	 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
	 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
	 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	 */
	
	(function( $ ){
	
	/**
	 * @class DziTileSource
	 * @memberof OpenSeadragon
	 * @extends OpenSeadragon.TileSource
	 * @param {Number|Object} width - the pixel width of the image or the idiomatic
	 *      options object which is used instead of positional arguments.
	 * @param {Number} height
	 * @param {Number} tileSize
	 * @param {Number} tileOverlap
	 * @param {String} tilesUrl
	 * @param {String} fileFormat
	 * @param {OpenSeadragon.DisplayRect[]} displayRects
	 * @property {String} tilesUrl
	 * @property {String} fileFormat
	 * @property {OpenSeadragon.DisplayRect[]} displayRects
	 */
	$.DziTileSource = function( width, height, tileSize, tileOverlap, tilesUrl, fileFormat, displayRects, minLevel, maxLevel ) {
	    var i,
	        rect,
	        level,
	        options;
	
	    if( $.isPlainObject( width ) ){
	        options = width;
	    }else{
	        options = {
	            width: arguments[ 0 ],
	            height: arguments[ 1 ],
	            tileSize: arguments[ 2 ],
	            tileOverlap: arguments[ 3 ],
	            tilesUrl: arguments[ 4 ],
	            fileFormat: arguments[ 5 ],
	            displayRects: arguments[ 6 ],
	            minLevel: arguments[ 7 ],
	            maxLevel: arguments[ 8 ]
	        };
	    }
	
	    this._levelRects  = {};
	    this.tilesUrl     = options.tilesUrl;
	    this.fileFormat   = options.fileFormat;
	    this.displayRects = options.displayRects;
	
	    if ( this.displayRects ) {
	        for ( i = this.displayRects.length - 1; i >= 0; i-- ) {
	            rect = this.displayRects[ i ];
	            for ( level = rect.minLevel; level <= rect.maxLevel; level++ ) {
	                if ( !this._levelRects[ level ] ) {
	                    this._levelRects[ level ] = [];
	                }
	                this._levelRects[ level ].push( rect );
	            }
	        }
	    }
	
	    $.TileSource.apply( this, [ options ] );
	
	};
	
	$.extend( $.DziTileSource.prototype, $.TileSource.prototype, /** @lends OpenSeadragon.DziTileSource.prototype */{
	
	
	    /**
	     * Determine if the data and/or url imply the image service is supported by
	     * this tile source.
	     * @function
	     * @param {Object|Array} data
	     * @param {String} optional - url
	     */
	    supports: function( data, url ){
	        var ns;
	        if ( data.Image ) {
	            ns = data.Image.xmlns;
	        } else if ( data.documentElement) {
	            if ("Image" == data.documentElement.localName || "Image" == data.documentElement.tagName) {
	                ns = data.documentElement.namespaceURI;
	            }
	        }
	
	        ns = (ns || '').toLowerCase();
	
	        return (ns.indexOf('schemas.microsoft.com/deepzoom/2008') !== -1 ||
	            ns.indexOf('schemas.microsoft.com/deepzoom/2009') !== -1);
	    },
	
	    /**
	     *
	     * @function
	     * @param {Object|XMLDocument} data - the raw configuration
	     * @param {String} url - the url the data was retreived from if any.
	     * @return {Object} options - A dictionary of keyword arguments sufficient
	     *      to configure this tile sources constructor.
	     */
	    configure: function( data, url ){
	
	        var options;
	
	        if( !$.isPlainObject(data) ){
	
	            options = configureFromXML( this, data );
	
	        }else{
	
	            options = configureFromObject( this, data );
	        }
	
	        if (url && !options.tilesUrl) {
	            options.tilesUrl = url.replace(
	                    /([^\/]+?)(\.(dzi|xml|js)?(\?[^\/]*)?)?\/?$/, '$1_files/');
	
	            if (url.search(/\.(dzi|xml|js)\?/) != -1) {
	                options.queryParams = url.match(/\?.*/);
	            }else{
	                options.queryParams = '';
	            }
	        }
	
	        return options;
	    },
	
	
	    /**
	     * @function
	     * @param {Number} level
	     * @param {Number} x
	     * @param {Number} y
	     */
	    getTileUrl: function( level, x, y ) {
	        return [ this.tilesUrl, level, '/', x, '_', y, '.', this.fileFormat, this.queryParams ].join( '' );
	    },
	
	
	    /**
	     * @function
	     * @param {Number} level
	     * @param {Number} x
	     * @param {Number} y
	     */
	    tileExists: function( level, x, y ) {
	        var rects = this._levelRects[ level ],
	            rect,
	            scale,
	            xMin,
	            yMin,
	            xMax,
	            yMax,
	            i;
	
	        if ((this.minLevel && level < this.minLevel) || (this.maxLevel && level > this.maxLevel)) {
	            return false;
	        }
	
	        if ( !rects || !rects.length ) {
	            return true;
	        }
	
	        for ( i = rects.length - 1; i >= 0; i-- ) {
	            rect = rects[ i ];
	
	            if ( level < rect.minLevel || level > rect.maxLevel ) {
	                continue;
	            }
	
	            scale = this.getLevelScale( level );
	            xMin = rect.x * scale;
	            yMin = rect.y * scale;
	            xMax = xMin + rect.width * scale;
	            yMax = yMin + rect.height * scale;
	
	            xMin = Math.floor( xMin / this._tileWidth );
	            yMin = Math.floor( yMin / this._tileWidth ); // DZI tiles are square, so we just use _tileWidth
	            xMax = Math.ceil( xMax / this._tileWidth );
	            yMax = Math.ceil( yMax / this._tileWidth );
	
	            if ( xMin <= x && x < xMax && yMin <= y && y < yMax ) {
	                return true;
	            }
	        }
	
	        return false;
	    }
	});
	
	
	/**
	 * @private
	 * @inner
	 * @function
	 */
	function configureFromXML( tileSource, xmlDoc ){
	
	    if ( !xmlDoc || !xmlDoc.documentElement ) {
	        throw new Error( $.getString( "Errors.Xml" ) );
	    }
	
	    var root           = xmlDoc.documentElement,
	        rootName       = root.localName || root.tagName,
	        ns             = xmlDoc.documentElement.namespaceURI,
	        configuration  = null,
	        displayRects   = [],
	        dispRectNodes,
	        dispRectNode,
	        rectNode,
	        sizeNode,
	        i;
	
	    if ( rootName == "Image" ) {
	
	        try {
	            sizeNode = root.getElementsByTagName("Size" )[ 0 ];
	            if (sizeNode === undefined) {
	                sizeNode = root.getElementsByTagNameNS(ns, "Size" )[ 0 ];
	            }
	
	            configuration = {
	                Image: {
	                    xmlns:       "http://schemas.microsoft.com/deepzoom/2008",
	                    Url:         root.getAttribute( "Url" ),
	                    Format:      root.getAttribute( "Format" ),
	                    DisplayRect: null,
	                    Overlap:     parseInt( root.getAttribute( "Overlap" ), 10 ),
	                    TileSize:    parseInt( root.getAttribute( "TileSize" ), 10 ),
	                    Size: {
	                        Height: parseInt( sizeNode.getAttribute( "Height" ), 10 ),
	                        Width:  parseInt( sizeNode.getAttribute( "Width" ), 10 )
	                    }
	                }
	            };
	
	            if ( !$.imageFormatSupported( configuration.Image.Format ) ) {
	                throw new Error(
	                    $.getString( "Errors.ImageFormat", configuration.Image.Format.toUpperCase() )
	                );
	            }
	
	            dispRectNodes = root.getElementsByTagName("DisplayRect" );
	            if (dispRectNodes === undefined) {
	                dispRectNodes = root.getElementsByTagNameNS(ns, "DisplayRect" )[ 0 ];
	            }
	
	            for ( i = 0; i < dispRectNodes.length; i++ ) {
	                dispRectNode = dispRectNodes[ i ];
	                rectNode     = dispRectNode.getElementsByTagName("Rect" )[ 0 ];
	                if (rectNode === undefined) {
	                    rectNode = dispRectNode.getElementsByTagNameNS(ns, "Rect" )[ 0 ];
	                }
	
	                displayRects.push({
	                    Rect: {
	                        X: parseInt( rectNode.getAttribute( "X" ), 10 ),
	                        Y: parseInt( rectNode.getAttribute( "Y" ), 10 ),
	                        Width: parseInt( rectNode.getAttribute( "Width" ), 10 ),
	                        Height: parseInt( rectNode.getAttribute( "Height" ), 10 ),
	                        MinLevel: parseInt( dispRectNode.getAttribute( "MinLevel" ), 10 ),
	                        MaxLevel: parseInt( dispRectNode.getAttribute( "MaxLevel" ), 10 )
	                    }
	                });
	            }
	
	            if( displayRects.length ){
	                configuration.Image.DisplayRect = displayRects;
	            }
	
	            return configureFromObject( tileSource, configuration );
	
	        } catch ( e ) {
	            throw (e instanceof Error) ?
	                e :
	                new Error( $.getString("Errors.Dzi") );
	        }
	    } else if ( rootName == "Collection" ) {
	        throw new Error( $.getString( "Errors.Dzc" ) );
	    } else if ( rootName == "Error" ) {
	        var messageNode = root.getElementsByTagName("Message")[0];
	        var message = messageNode.firstChild.nodeValue;
	        throw new Error(message);
	    }
	
	    throw new Error( $.getString( "Errors.Dzi" ) );
	}
	
	/**
	 * @private
	 * @inner
	 * @function
	 */
	function configureFromObject( tileSource, configuration ){
	    var imageData     = configuration.Image,
	        tilesUrl      = imageData.Url,
	        fileFormat    = imageData.Format,
	        sizeData      = imageData.Size,
	        dispRectData  = imageData.DisplayRect || [],
	        width         = parseInt( sizeData.Width, 10 ),
	        height        = parseInt( sizeData.Height, 10 ),
	        tileSize      = parseInt( imageData.TileSize, 10 ),
	        tileOverlap   = parseInt( imageData.Overlap, 10 ),
	        displayRects  = [],
	        rectData,
	        i;
	
	    //TODO: need to figure out out to better handle image format compatibility
	    //      which actually includes additional file formats like xml and pdf
	    //      and plain text for various tilesource implementations to avoid low
	    //      level errors.
	    //
	    //      For now, just don't perform the check.
	    //
	    /*if ( !imageFormatSupported( fileFormat ) ) {
	        throw new Error(
	            $.getString( "Errors.ImageFormat", fileFormat.toUpperCase() )
	        );
	    }*/
	
	    for ( i = 0; i < dispRectData.length; i++ ) {
	        rectData = dispRectData[ i ].Rect;
	
	        displayRects.push( new $.DisplayRect(
	            parseInt( rectData.X, 10 ),
	            parseInt( rectData.Y, 10 ),
	            parseInt( rectData.Width, 10 ),
	            parseInt( rectData.Height, 10 ),
	            parseInt( rectData.MinLevel, 10 ),
	            parseInt( rectData.MaxLevel, 10 )
	        ));
	    }
	
	    return $.extend(true, {
	        width: width, /* width *required */
	        height: height, /* height *required */
	        tileSize: tileSize, /* tileSize *required */
	        tileOverlap: tileOverlap, /* tileOverlap *required */
	        minLevel: null, /* minLevel */
	        maxLevel: null, /* maxLevel */
	        tilesUrl: tilesUrl, /* tilesUrl */
	        fileFormat: fileFormat, /* fileFormat */
	        displayRects: displayRects /* displayRects */
	    }, configuration );
	
	}
	
	}( OpenSeadragon ));
	
	/*
	 * OpenSeadragon - IIIFTileSource
	 *
	 * Copyright (C) 2009 CodePlex Foundation
	 * Copyright (C) 2010-2013 OpenSeadragon contributors
	 *
	 * Redistribution and use in source and binary forms, with or without
	 * modification, are permitted provided that the following conditions are
	 * met:
	 *
	 * - Redistributions of source code must retain the above copyright notice,
	 *   this list of conditions and the following disclaimer.
	 *
	 * - Redistributions in binary form must reproduce the above copyright
	 *   notice, this list of conditions and the following disclaimer in the
	 *   documentation and/or other materials provided with the distribution.
	 *
	 * - Neither the name of CodePlex Foundation nor the names of its
	 *   contributors may be used to endorse or promote products derived from
	 *   this software without specific prior written permission.
	 *
	 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
	 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
	 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
	 * A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT
	 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
	 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
	 * TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 * PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
	 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
	 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
	 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	 */
	
	(function( $ ){
	
	/**
	 * @class IIIFTileSource
	 * @classdesc A client implementation of the International Image Interoperability Framework
	 * Format: Image API 1.0 - 2.1
	 *
	 * @memberof OpenSeadragon
	 * @extends OpenSeadragon.TileSource
	 * @see http://iiif.io/api/image/
	 */
	$.IIIFTileSource = function( options ){
	
	    /* eslint-disable camelcase */
	
	    $.extend( true, this, options );
	
	    if ( !( this.height && this.width && this['@id'] ) ) {
	        throw new Error( 'IIIF required parameters not provided.' );
	    }
	
	    options.tileSizePerScaleFactor = {};
	
	    // N.B. 2.0 renamed scale_factors to scaleFactors
	    if ( this.tile_width && this.tile_height ) {
	        options.tileWidth = this.tile_width;
	        options.tileHeight = this.tile_height;
	    } else if ( this.tile_width ) {
	        options.tileSize = this.tile_width;
	    } else if ( this.tile_height ) {
	        options.tileSize = this.tile_height;
	    } else if ( this.tiles ) {
	        // Version 2.0 forwards
	        if ( this.tiles.length == 1 ) {
	            options.tileWidth  = this.tiles[0].width;
	            // Use height if provided, otherwise assume square tiles and use width.
	            options.tileHeight = this.tiles[0].height || this.tiles[0].width;
	            this.scale_factors = this.tiles[0].scaleFactors;
	        } else {
	            // Multiple tile sizes at different levels
	            this.scale_factors = [];
	            for (var t = 0; t < this.tiles.length; t++ ) {
	                for (var sf = 0; sf < this.tiles[t].scaleFactors.length; sf++) {
	                    var scaleFactor = this.tiles[t].scaleFactors[sf];
	                    this.scale_factors.push(scaleFactor);
	                    options.tileSizePerScaleFactor[scaleFactor] = {
	                        width: this.tiles[t].width,
	                        height: this.tiles[t].height || this.tiles[t].width
	                    };
	                }
	            }
	        }
	    } else if ( canBeTiled(options.profile) ) {
	        // use the largest of tileOptions that is smaller than the short dimension
	        var shortDim = Math.min( this.height, this.width ),
	            tileOptions = [256, 512, 1024],
	            smallerTiles = [];
	
	        for ( var c = 0; c < tileOptions.length; c++ ) {
	            if ( tileOptions[c] <= shortDim ) {
	                smallerTiles.push( tileOptions[c] );
	            }
	        }
	
	        if ( smallerTiles.length > 0 ) {
	            options.tileSize = Math.max.apply( null, smallerTiles );
	        } else {
	            // If we're smaller than 256, just use the short side.
	            options.tileSize = shortDim;
	        }
	    } else if (this.sizes && this.sizes.length > 0) {
	        // This info.json can't be tiled, but we can still construct a legacy pyramid from the sizes array.
	        // In this mode, IIIFTileSource will call functions from the abstract baseTileSource or the
	        // LegacyTileSource instead of performing IIIF tiling.
	        this.emulateLegacyImagePyramid = true;
	
	        options.levels = constructLevels( this );
	        // use the largest available size to define tiles
	        $.extend( true, options, {
	            width: options.levels[ options.levels.length - 1 ].width,
	            height: options.levels[ options.levels.length - 1 ].height,
	            tileSize: Math.max( options.height, options.width ),
	            tileOverlap: 0,
	            minLevel: 0,
	            maxLevel: options.levels.length - 1
	        });
	        this.levels = options.levels;
	    } else {
	        $.console.error("Nothing in the info.json to construct image pyramids from");
	    }
	
	    if (!options.maxLevel && !this.emulateLegacyImagePyramid) {
	        if (!this.scale_factors) {
	            options.maxLevel = Number(Math.ceil(Math.log(Math.max(this.width, this.height), 2)));
	        } else {
	            var maxScaleFactor = Math.max.apply(null, this.scale_factors);
	            options.maxLevel = Math.round(Math.log(maxScaleFactor) * Math.LOG2E);
	        }
	    }
	
	    $.TileSource.apply( this, [ options ] );
	};
	
	$.extend( $.IIIFTileSource.prototype, $.TileSource.prototype, /** @lends OpenSeadragon.IIIFTileSource.prototype */{
	    /**
	     * Determine if the data and/or url imply the image service is supported by
	     * this tile source.
	     * @function
	     * @param {Object|Array} data
	     * @param {String} optional - url
	     */
	
	    supports: function( data, url ) {
	        // Version 2.0 and forwards
	        if (data.protocol && data.protocol == 'http://iiif.io/api/image') {
	            return true;
	        // Version 1.1
	        } else if ( data['@context'] && (
	            data['@context'] == "http://library.stanford.edu/iiif/image-api/1.1/context.json" ||
	            data['@context'] == "http://iiif.io/api/image/1/context.json") ) {
	            // N.B. the iiif.io context is wrong, but where the representation lives so likely to be used
	            return true;
	
	        // Version 1.0
	        } else if ( data.profile &&
	            data.profile.indexOf("http://library.stanford.edu/iiif/image-api/compliance.html") === 0) {
	            return true;
	        } else if ( data.identifier && data.width && data.height ) {
	            return true;
	        } else if ( data.documentElement &&
	            "info" == data.documentElement.tagName &&
	            "http://library.stanford.edu/iiif/image-api/ns/" ==
	                data.documentElement.namespaceURI) {
	            return true;
	
	        // Not IIIF
	        } else {
	            return false;
	        }
	    },
	
	    /**
	     *
	     * @function
	     * @param {Object} data - the raw configuration
	     * @example <caption>IIIF 1.1 Info Looks like this</caption>
	     * {
	     *   "@context" : "http://library.stanford.edu/iiif/image-api/1.1/context.json",
	     *   "@id" : "http://iiif.example.com/prefix/1E34750D-38DB-4825-A38A-B60A345E591C",
	     *   "width" : 6000,
	     *   "height" : 4000,
	     *   "scale_factors" : [ 1, 2, 4 ],
	     *   "tile_width" : 1024,
	     *   "tile_height" : 1024,
	     *   "formats" : [ "jpg", "png" ],
	     *   "qualities" : [ "native", "grey" ],
	     *   "profile" : "http://library.stanford.edu/iiif/image-api/1.1/compliance.html#level0"
	     * }
	     */
	    configure: function( data, url ){
	        // Try to deduce our version and fake it upwards if needed
	        if ( !$.isPlainObject(data) ) {
	            var options = configureFromXml10( data );
	            options['@context'] = "http://iiif.io/api/image/1.0/context.json";
	            options['@id'] = url.replace('/info.xml', '');
	            return options;
	        } else if ( !data['@context'] ) {
	            data['@context'] = 'http://iiif.io/api/image/1.0/context.json';
	            data['@id'] = url.replace('/info.json', '');
	            return data;
	        } else {
	            return data;
	        }
	    },
	
	    /**
	     * Return the tileWidth for the given level.
	     * @function
	     * @param {Number} level
	     */
	    getTileWidth: function( level ) {
	
	        if(this.emulateLegacyImagePyramid) {
	            return $.TileSource.prototype.getTileWidth.call(this, level);
	        }
	
	        var scaleFactor = Math.pow(2, this.maxLevel - level);
	
	        if (this.tileSizePerScaleFactor && this.tileSizePerScaleFactor[scaleFactor]) {
	            return this.tileSizePerScaleFactor[scaleFactor].width;
	        }
	        return this._tileWidth;
	    },
	
	    /**
	     * Return the tileHeight for the given level.
	     * @function
	     * @param {Number} level
	     */
	    getTileHeight: function( level ) {
	
	        if(this.emulateLegacyImagePyramid) {
	            return $.TileSource.prototype.getTileHeight.call(this, level);
	        }
	
	        var scaleFactor = Math.pow(2, this.maxLevel - level);
	
	        if (this.tileSizePerScaleFactor && this.tileSizePerScaleFactor[scaleFactor]) {
	            return this.tileSizePerScaleFactor[scaleFactor].height;
	        }
	        return this._tileHeight;
	    },
	
	    /**
	     * @function
	     * @param {Number} level
	     */
	    getLevelScale: function ( level ) {
	
	        if(this.emulateLegacyImagePyramid) {
	            var levelScale = NaN;
	            if (this.levels.length > 0 && level >= this.minLevel && level <= this.maxLevel) {
	                levelScale =
	                    this.levels[level].width /
	                    this.levels[this.maxLevel].width;
	            }
	            return levelScale;
	        }
	
	        return $.TileSource.prototype.getLevelScale.call(this, level);
	    },
	
	    /**
	     * @function
	     * @param {Number} level
	     */
	    getNumTiles: function( level ) {
	
	        if(this.emulateLegacyImagePyramid) {
	            var scale = this.getLevelScale(level);
	            if (scale) {
	                return new $.Point(1, 1);
	            } else {
	                return new $.Point(0, 0);
	            }
	        }
	
	        return $.TileSource.prototype.getNumTiles.call(this, level);
	    },
	
	
	    /**
	     * @function
	     * @param {Number} level
	     * @param {OpenSeadragon.Point} point
	     */
	    getTileAtPoint: function( level, point ) {
	
	        if(this.emulateLegacyImagePyramid) {
	            return new $.Point(0, 0);
	        }
	
	        return $.TileSource.prototype.getTileAtPoint.call(this, level, point);
	    },
	
	
	    /**
	     * Responsible for retrieving the url which will return an image for the
	     * region specified by the given x, y, and level components.
	     * @function
	     * @param {Number} level - z index
	     * @param {Number} x
	     * @param {Number} y
	     * @throws {Error}
	     */
	    getTileUrl: function( level, x, y ){
	
	        if(this.emulateLegacyImagePyramid) {
	            var url = null;
	            if ( this.levels.length > 0 && level >= this.minLevel && level <= this.maxLevel ) {
	                url = this.levels[ level ].url;
	            }
	            return url;
	        }
	
	        //# constants
	        var IIIF_ROTATION = '0',
	            //## get the scale (level as a decimal)
	            scale = Math.pow( 0.5, this.maxLevel - level ),
	
	            //# image dimensions at this level
	            levelWidth = Math.ceil( this.width * scale ),
	            levelHeight = Math.ceil( this.height * scale ),
	
	            //## iiif region
	            tileWidth,
	            tileHeight,
	            iiifTileSizeWidth,
	            iiifTileSizeHeight,
	            iiifRegion,
	            iiifTileX,
	            iiifTileY,
	            iiifTileW,
	            iiifTileH,
	            iiifSize,
	            iiifQuality,
	            uri;
	
	        tileWidth = this.getTileWidth(level);
	        tileHeight = this.getTileHeight(level);
	        iiifTileSizeWidth = Math.ceil( tileWidth / scale );
	        iiifTileSizeHeight = Math.ceil( tileHeight / scale );
	
	        if ( this['@context'].indexOf('/1.0/context.json') > -1 ||
	             this['@context'].indexOf('/1.1/context.json') > -1 ||
	             this['@context'].indexOf('/1/context.json') > -1 ) {
	            iiifQuality = "native.jpg";
	        } else {
	            iiifQuality = "default.jpg";
	        }
	
	        if ( levelWidth < tileWidth && levelHeight < tileHeight ){
	            iiifSize = levelWidth + ",";
	            iiifRegion = 'full';
	        } else {
	            iiifTileX = x * iiifTileSizeWidth;
	            iiifTileY = y * iiifTileSizeHeight;
	            iiifTileW = Math.min( iiifTileSizeWidth, this.width - iiifTileX );
	            iiifTileH = Math.min( iiifTileSizeHeight, this.height - iiifTileY );
	            iiifSize = Math.ceil( iiifTileW * scale ) + ",";
	            iiifRegion = [ iiifTileX, iiifTileY, iiifTileW, iiifTileH ].join( ',' );
	        }
	        uri = [ this['@id'], iiifRegion, iiifSize, IIIF_ROTATION, iiifQuality ].join( '/' );
	
	        return uri;
	    }
	
	  });
	
	    /**
	     * Determine whether arbitrary tile requests can be made against a service with the given profile
	     * @function
	     * @param {object} profile - IIIF profile object
	     * @throws {Error}
	     */
	    function canBeTiled (profile ) {
	        var level0Profiles = [
	            "http://library.stanford.edu/iiif/image-api/compliance.html#level0",
	            "http://library.stanford.edu/iiif/image-api/1.1/compliance.html#level0",
	            "http://iiif.io/api/image/2/level0.json"
	        ];
	        var isLevel0 = (level0Profiles.indexOf(profile[0]) != -1);
	        return !isLevel0 || (profile.indexOf("sizeByW") != -1);
	    }
	
	    /**
	     * Build the legacy pyramid URLs (one tile per level)
	     * @function
	     * @param {object} options - infoJson
	     * @throws {Error}
	     */
	    function constructLevels(options) {
	        var levels = [];
	        for(var i = 0; i < options.sizes.length; i++) {
	            levels.push({
	                url: options['@id'] + '/full/' + options.sizes[i].width + ',/0/default.jpg',
	                width: options.sizes[i].width,
	                height: options.sizes[i].height
	            });
	        }
	        return levels.sort(function(a, b) {
	            return a.width - b.width;
	        });
	    }
	
	
	    function configureFromXml10(xmlDoc) {
	        //parse the xml
	        if ( !xmlDoc || !xmlDoc.documentElement ) {
	            throw new Error( $.getString( "Errors.Xml" ) );
	        }
	
	        var root            = xmlDoc.documentElement,
	            rootName        = root.tagName,
	            configuration   = null;
	
	        if ( rootName == "info" ) {
	            try {
	                configuration = {};
	                parseXML10( root, configuration );
	                return configuration;
	
	            } catch ( e ) {
	                throw (e instanceof Error) ?
	                    e :
	                    new Error( $.getString("Errors.IIIF") );
	            }
	        }
	        throw new Error( $.getString( "Errors.IIIF" ) );
	    }
	
	    function parseXML10( node, configuration, property ) {
	        var i,
	            value;
	        if ( node.nodeType == 3 && property ) {//text node
	            value = node.nodeValue.trim();
	            if( value.match(/^\d*$/)){
	                value = Number( value );
	            }
	            if( !configuration[ property ] ){
	                configuration[ property ] = value;
	            }else{
	                if( !$.isArray( configuration[ property ] ) ){
	                    configuration[ property ] = [ configuration[ property ] ];
	                }
	                configuration[ property ].push( value );
	            }
	        } else if( node.nodeType == 1 ){
	            for( i = 0; i < node.childNodes.length; i++ ){
	                parseXML10( node.childNodes[ i ], configuration, node.nodeName );
	            }
	        }
	    }
	
	
	
	}( OpenSeadragon ));
	
	/*
	 * OpenSeadragon - OsmTileSource
	 *
	 * Copyright (C) 2009 CodePlex Foundation
	 * Copyright (C) 2010-2013 OpenSeadragon contributors
	 *
	 * Redistribution and use in source and binary forms, with or without
	 * modification, are permitted provided that the following conditions are
	 * met:
	 *
	 * - Redistributions of source code must retain the above copyright notice,
	 *   this list of conditions and the following disclaimer.
	 *
	 * - Redistributions in binary form must reproduce the above copyright
	 *   notice, this list of conditions and the following disclaimer in the
	 *   documentation and/or other materials provided with the distribution.
	 *
	 * - Neither the name of CodePlex Foundation nor the names of its
	 *   contributors may be used to endorse or promote products derived from
	 *   this software without specific prior written permission.
	 *
	 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
	 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
	 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
	 * A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT
	 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
	 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
	 * TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 * PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
	 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
	 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
	 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	 */
	
	/*
	 * Derived from the OSM tile source in Rainer Simon's seajax-utils project
	 * <http://github.com/rsimon/seajax-utils>.  Rainer Simon has contributed
	 * the included code to the OpenSeadragon project under the New BSD license;
	 * see <https://github.com/openseadragon/openseadragon/issues/58>.
	 */
	
	
	(function( $ ){
	
	/**
	 * @class OsmTileSource
	 * @classdesc A tilesource implementation for OpenStreetMap.<br><br>
	 *
	 * Note 1. Zoomlevels. Deep Zoom and OSM define zoom levels differently. In  Deep
	 * Zoom, level 0 equals an image of 1x1 pixels. In OSM, level 0 equals an image of
	 * 256x256 levels (see http://gasi.ch/blog/inside-deep-zoom-2). I.e. there is a
	 * difference of log2(256)=8 levels.<br><br>
	 *
	 * Note 2. Image dimension. According to the OSM Wiki
	 * (http://wiki.openstreetmap.org/wiki/Slippy_map_tilenames#Zoom_levels)
	 * the highest Mapnik zoom level has 256.144x256.144 tiles, with a 256x256
	 * pixel size. I.e. the Deep Zoom image dimension is 65.572.864x65.572.864
	 * pixels.
	 *
	 * @memberof OpenSeadragon
	 * @extends OpenSeadragon.TileSource
	 * @param {Number|Object} width - the pixel width of the image or the idiomatic
	 *      options object which is used instead of positional arguments.
	 * @param {Number} height
	 * @param {Number} tileSize
	 * @param {Number} tileOverlap
	 * @param {String} tilesUrl
	 */
	$.OsmTileSource = function( width, height, tileSize, tileOverlap, tilesUrl ) {
	    var options;
	
	    if( $.isPlainObject( width ) ){
	        options = width;
	    }else{
	        options = {
	            width: arguments[0],
	            height: arguments[1],
	            tileSize: arguments[2],
	            tileOverlap: arguments[3],
	            tilesUrl: arguments[4]
	        };
	    }
	    //apply default setting for standard public OpenStreatMaps service
	    //but allow them to be specified so fliks can host there own instance
	    //or apply against other services supportting the same standard
	    if( !options.width || !options.height ){
	        options.width = 65572864;
	        options.height = 65572864;
	    }
	    if( !options.tileSize ){
	        options.tileSize = 256;
	        options.tileOverlap = 0;
	    }
	    if( !options.tilesUrl ){
	        options.tilesUrl = "http://tile.openstreetmap.org/";
	    }
	    options.minLevel = 8;
	
	    $.TileSource.apply( this, [ options ] );
	
	};
	
	$.extend( $.OsmTileSource.prototype, $.TileSource.prototype, /** @lends OpenSeadragon.OsmTileSource.prototype */{
	
	
	    /**
	     * Determine if the data and/or url imply the image service is supported by
	     * this tile source.
	     * @function
	     * @param {Object|Array} data
	     * @param {String} optional - url
	     */
	    supports: function( data, url ){
	        return (
	            data.type &&
	            "openstreetmaps" == data.type
	        );
	    },
	
	    /**
	     *
	     * @function
	     * @param {Object} data - the raw configuration
	     * @param {String} url - the url the data was retreived from if any.
	     * @return {Object} options - A dictionary of keyword arguments sufficient
	     *      to configure this tile sources constructor.
	     */
	    configure: function( data, url ){
	        return data;
	    },
	
	
	    /**
	     * @function
	     * @param {Number} level
	     * @param {Number} x
	     * @param {Number} y
	     */
	    getTileUrl: function( level, x, y ) {
	        return this.tilesUrl + (level - 8) + "/" + x + "/" + y + ".png";
	    }
	});
	
	
	}( OpenSeadragon ));
	
	/*
	 * OpenSeadragon - TmsTileSource
	 *
	 * Copyright (C) 2009 CodePlex Foundation
	 * Copyright (C) 2010-2013 OpenSeadragon contributors
	 *
	 * Redistribution and use in source and binary forms, with or without
	 * modification, are permitted provided that the following conditions are
	 * met:
	 *
	 * - Redistributions of source code must retain the above copyright notice,
	 *   this list of conditions and the following disclaimer.
	 *
	 * - Redistributions in binary form must reproduce the above copyright
	 *   notice, this list of conditions and the following disclaimer in the
	 *   documentation and/or other materials provided with the distribution.
	 *
	 * - Neither the name of CodePlex Foundation nor the names of its
	 *   contributors may be used to endorse or promote products derived from
	 *   this software without specific prior written permission.
	 *
	 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
	 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
	 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
	 * A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT
	 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
	 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
	 * TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 * PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
	 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
	 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
	 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	 */
	
	/*
	 * Derived from the TMS tile source in Rainer Simon's seajax-utils project
	 * <http://github.com/rsimon/seajax-utils>.  Rainer Simon has contributed
	 * the included code to the OpenSeadragon project under the New BSD license;
	 * see <https://github.com/openseadragon/openseadragon/issues/58>.
	 */
	
	
	(function( $ ){
	
	/**
	 * @class TmsTileSource
	 * @classdesc A tilesource implementation for Tiled Map Services (TMS).
	 * TMS tile scheme ( [ as supported by OpenLayers ] is described here
	 * ( http://openlayers.org/dev/examples/tms.html ).
	 *
	 * @memberof OpenSeadragon
	 * @extends OpenSeadragon.TileSource
	 * @param {Number|Object} width - the pixel width of the image or the idiomatic
	 *      options object which is used instead of positional arguments.
	 * @param {Number} height
	 * @param {Number} tileSize
	 * @param {Number} tileOverlap
	 * @param {String} tilesUrl
	 */
	$.TmsTileSource = function( width, height, tileSize, tileOverlap, tilesUrl ) {
	    var options;
	
	    if( $.isPlainObject( width ) ){
	        options = width;
	    }else{
	        options = {
	            width: arguments[0],
	            height: arguments[1],
	            tileSize: arguments[2],
	            tileOverlap: arguments[3],
	            tilesUrl: arguments[4]
	        };
	    }
	    // TMS has integer multiples of 256 for width/height and adds buffer
	    // if necessary -> account for this!
	    var bufferedWidth = Math.ceil(options.width / 256) * 256,
	        bufferedHeight = Math.ceil(options.height / 256) * 256,
	        max;
	
	    // Compute number of zoomlevels in this tileset
	    if (bufferedWidth > bufferedHeight) {
	        max = bufferedWidth / 256;
	    } else {
	        max = bufferedHeight / 256;
	    }
	    options.maxLevel = Math.ceil(Math.log(max) / Math.log(2)) - 1;
	    options.tileSize = 256;
	    options.width = bufferedWidth;
	    options.height = bufferedHeight;
	
	    $.TileSource.apply( this, [ options ] );
	
	};
	
	$.extend( $.TmsTileSource.prototype, $.TileSource.prototype, /** @lends OpenSeadragon.TmsTileSource.prototype */{
	
	
	    /**
	     * Determine if the data and/or url imply the image service is supported by
	     * this tile source.
	     * @function
	     * @param {Object|Array} data
	     * @param {String} optional - url
	     */
	    supports: function( data, url ){
	        return ( data.type && "tiledmapservice" == data.type );
	    },
	
	    /**
	     *
	     * @function
	     * @param {Object} data - the raw configuration
	     * @param {String} url - the url the data was retreived from if any.
	     * @return {Object} options - A dictionary of keyword arguments sufficient
	     *      to configure this tile sources constructor.
	     */
	    configure: function( data, url ){
	        return data;
	    },
	
	
	    /**
	     * @function
	     * @param {Number} level
	     * @param {Number} x
	     * @param {Number} y
	     */
	    getTileUrl: function( level, x, y ) {
	        // Convert from Deep Zoom definition to TMS zoom definition
	        var yTiles = this.getNumTiles( level ).y - 1;
	
	        return this.tilesUrl + level + "/" + x + "/" + (yTiles - y) + ".png";
	    }
	});
	
	
	}( OpenSeadragon ));
	
	(function($) {
	
	    /**
	     * @class ZoomifyTileSource
	     * @classdesc A tilesource implementation for the zoomify format.
	     *
	     * A description of the format can be found here:
	     * https://ecommons.cornell.edu/bitstream/handle/1813/5410/Introducing_Zoomify_Image.pdf
	     *
	     * There are two ways of creating a zoomify tilesource for openseadragon
	     *
	     * 1) Supplying all necessary information in the tilesource object. A minimal example object for this method looks like this:
	     *
	     * {
	     *      type: "zoomifytileservice",
	     *      width: 1000,
	     *      height: 1000,
	     *      tilesUrl: "/test/data/zoomify/"
	     * }
	     *
	     * The tileSize is currently hardcoded to 256 (the usual Zoomify default). The tileUrl must the path to the image _directory_.
	     *
	     * 2) Loading image metadata from xml file: (CURRENTLY NOT SUPPORTED)
	     *
	     * When creating zoomify formatted images one "xml" like file with name ImageProperties.xml
	     * will be created as well. Here is an example of such a file:
	     *
	     * <IMAGE_PROPERTIES WIDTH="1000" HEIGHT="1000" NUMTILES="21" NUMIMAGES="1" VERSION="1.8" TILESIZE="256" />
	     *
	     * To use this xml file as metadata source you must supply the path to the ImageProperties.xml file and leave out all other parameters:
	     * As stated above, this method of loading a zoomify tilesource is currently not supported
	     *
	     * {
	     *      type: "zoomifytileservice",
	     *      tilesUrl: "/test/data/zoomify/ImageProperties.xml"
	     * }
	
	    *
	    * @memberof OpenSeadragon
	     * @extends OpenSeadragon.TileSource
	     * @param {Number} width - the pixel width of the image.
	     * @param {Number} height
	     * @param {Number} tileSize
	     * @param {String} tilesUrl
	     */
	    $.ZoomifyTileSource = function(options) {
	        options.tileSize = 256;
	
	        var currentImageSize = {
	            x: options.width,
	            y: options.height
	        };
	        options.imageSizes = [{
	            x: options.width,
	            y: options.height
	        }];
	        options.gridSize = [this._getGridSize(options.width, options.height, options.tileSize)];
	
	        while (parseInt(currentImageSize.x, 10) > options.tileSize || parseInt(currentImageSize.y, 10) > options.tileSize) {
	            currentImageSize.x = Math.floor(currentImageSize.x / 2);
	            currentImageSize.y = Math.floor(currentImageSize.y / 2);
	            options.imageSizes.push({
	                x: currentImageSize.x,
	                y: currentImageSize.y
	            });
	            options.gridSize.push(this._getGridSize(currentImageSize.x, currentImageSize.y, options.tileSize));
	        }
	        options.imageSizes.reverse();
	        options.gridSize.reverse();
	        options.minLevel = 0;
	        options.maxLevel = options.gridSize.length - 1;
	
	        OpenSeadragon.TileSource.apply(this, [options]);
	    };
	
	    $.extend($.ZoomifyTileSource.prototype, $.TileSource.prototype, /** @lends OpenSeadragon.ZoomifyTileSource.prototype */ {
	
	        //private
	        _getGridSize: function(width, height, tileSize) {
	            return {
	                x: Math.ceil(width / tileSize),
	                y: Math.ceil(height / tileSize)
	            };
	        },
	
	        //private
	        _calculateAbsoluteTileNumber: function(level, x, y) {
	            var num = 0;
	            var size = {};
	
	            //Sum up all tiles below the level we want the number of tiles
	            for (var z = 0; z < level; z++) {
	                size = this.gridSize[z];
	                num += size.x * size.y;
	            }
	            //Add the tiles of the level
	            size = this.gridSize[level];
	            num += size.x * y + x;
	            return num;
	        },
	
	        /**
	         * Determine if the data and/or url imply the image service is supported by
	         * this tile source.
	         * @function
	         * @param {Object|Array} data
	         * @param {String} optional - url
	         */
	        supports: function(data, url) {
	            return (data.type && "zoomifytileservice" == data.type);
	        },
	
	        /**
	         *
	         * @function
	         * @param {Object} data - the raw configuration
	         * @param {String} url - the url the data was retreived from if any.
	         * @return {Object} options - A dictionary of keyword arguments sufficient
	         *      to configure this tile sources constructor.
	         */
	        configure: function(data, url) {
	            return data;
	        },
	
	        /**
	         * @function
	         * @param {Number} level
	         * @param {Number} x
	         * @param {Number} y
	         */
	        getTileUrl: function(level, x, y) {
	            //console.log(level);
	            var result = 0;
	            var num = this._calculateAbsoluteTileNumber(level, x, y);
	            result = Math.floor(num / 256);
	            return this.tilesUrl + 'TileGroup' + result + '/' + level + '-' + x + '-' + y + '.jpg';
	
	        }
	    });
	
	}(OpenSeadragon));
	
	
	/*
	 * OpenSeadragon - LegacyTileSource
	 *
	 * Copyright (C) 2009 CodePlex Foundation
	 * Copyright (C) 2010-2013 OpenSeadragon contributors
	 *
	 * Redistribution and use in source and binary forms, with or without
	 * modification, are permitted provided that the following conditions are
	 * met:
	 *
	 * - Redistributions of source code must retain the above copyright notice,
	 *   this list of conditions and the following disclaimer.
	 *
	 * - Redistributions in binary form must reproduce the above copyright
	 *   notice, this list of conditions and the following disclaimer in the
	 *   documentation and/or other materials provided with the distribution.
	 *
	 * - Neither the name of CodePlex Foundation nor the names of its
	 *   contributors may be used to endorse or promote products derived from
	 *   this software without specific prior written permission.
	 *
	 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
	 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
	 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
	 * A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT
	 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
	 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
	 * TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 * PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
	 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
	 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
	 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	 */
	
	(function( $ ){
	
	/**
	 * @class LegacyTileSource
	 * @classdesc The LegacyTileSource allows simple, traditional image pyramids to be loaded
	 * into an OpenSeadragon Viewer.  Basically, this translates to the historically
	 * common practice of starting with a 'master' image, maybe a tiff for example,
	 * and generating a set of 'service' images like one or more thumbnails, a medium
	 * resolution image and a high resolution image in standard web formats like
	 * png or jpg.
	 *
	 * @memberof OpenSeadragon
	 * @extends OpenSeadragon.TileSource
	 * @param {Array} levels An array of file descriptions, each is an object with
	 *      a 'url', a 'width', and a 'height'.  Overriding classes can expect more
	 *      properties but these properties are sufficient for this implementation.
	 *      Additionally, the levels are required to be listed in order from
	 *      smallest to largest.
	 * @property {Number} aspectRatio
	 * @property {Number} dimensions
	 * @property {Number} tileSize
	 * @property {Number} tileOverlap
	 * @property {Number} minLevel
	 * @property {Number} maxLevel
	 * @property {Array}  levels
	 */
	$.LegacyTileSource = function( levels ) {
	
	    var options,
	        width,
	        height;
	
	    if( $.isArray( levels ) ){
	        options = {
	            type: 'legacy-image-pyramid',
	            levels: levels
	        };
	    }
	
	    //clean up the levels to make sure we support all formats
	    options.levels = filterFiles( options.levels );
	
	    if ( options.levels.length > 0 ) {
	        width = options.levels[ options.levels.length - 1 ].width;
	        height = options.levels[ options.levels.length - 1 ].height;
	    }
	    else {
	        width = 0;
	        height = 0;
	        $.console.error( "No supported image formats found" );
	    }
	
	    $.extend( true, options, {
	        width: width,
	        height: height,
	        tileSize: Math.max( height, width ),
	        tileOverlap: 0,
	        minLevel: 0,
	        maxLevel: options.levels.length > 0 ? options.levels.length - 1 : 0
	    } );
	
	    $.TileSource.apply( this, [ options ] );
	
	    this.levels = options.levels;
	};
	
	$.extend( $.LegacyTileSource.prototype, $.TileSource.prototype, /** @lends OpenSeadragon.LegacyTileSource.prototype */{
	    /**
	     * Determine if the data and/or url imply the image service is supported by
	     * this tile source.
	     * @function
	     * @param {Object|Array} data
	     * @param {String} optional - url
	     */
	    supports: function( data, url ){
	        return (
	            data.type &&
	            "legacy-image-pyramid" == data.type
	        ) || (
	            data.documentElement &&
	            "legacy-image-pyramid" == data.documentElement.getAttribute('type')
	        );
	    },
	
	
	    /**
	     *
	     * @function
	     * @param {Object|XMLDocument} configuration - the raw configuration
	     * @param {String} dataUrl - the url the data was retreived from if any.
	     * @return {Object} options - A dictionary of keyword arguments sufficient
	     *      to configure this tile sources constructor.
	     */
	    configure: function( configuration, dataUrl ){
	
	        var options;
	
	        if( !$.isPlainObject(configuration) ){
	
	            options = configureFromXML( this, configuration );
	
	        }else{
	
	            options = configureFromObject( this, configuration );
	        }
	
	        return options;
	
	    },
	
	    /**
	     * @function
	     * @param {Number} level
	     */
	    getLevelScale: function ( level ) {
	        var levelScale = NaN;
	        if ( this.levels.length > 0 && level >= this.minLevel && level <= this.maxLevel ) {
	            levelScale =
	                this.levels[ level ].width /
	                this.levels[ this.maxLevel ].width;
	        }
	        return levelScale;
	    },
	
	    /**
	     * @function
	     * @param {Number} level
	     */
	    getNumTiles: function( level ) {
	        var scale = this.getLevelScale( level );
	        if ( scale ){
	            return new $.Point( 1, 1 );
	        } else {
	            return new $.Point( 0, 0 );
	        }
	    },
	
	    /**
	     * This method is not implemented by this class other than to throw an Error
	     * announcing you have to implement it.  Because of the variety of tile
	     * server technologies, and various specifications for building image
	     * pyramids, this method is here to allow easy integration.
	     * @function
	     * @param {Number} level
	     * @param {Number} x
	     * @param {Number} y
	     * @throws {Error}
	     */
	    getTileUrl: function ( level, x, y ) {
	        var url = null;
	        if ( this.levels.length > 0 && level >= this.minLevel && level <= this.maxLevel ) {
	            url = this.levels[ level ].url;
	        }
	        return url;
	    }
	} );
	
	/**
	 * This method removes any files from the Array which dont conform to our
	 * basic requirements for a 'level' in the LegacyTileSource.
	 * @private
	 * @inner
	 * @function
	 */
	function filterFiles( files ){
	    var filtered = [],
	        file,
	        i;
	    for( i = 0; i < files.length; i++ ){
	        file = files[ i ];
	        if( file.height &&
	            file.width &&
	            file.url ){
	            //This is sufficient to serve as a level
	            filtered.push({
	                url: file.url,
	                width: Number( file.width ),
	                height: Number( file.height )
	            });
	        }
	        else {
	            $.console.error( 'Unsupported image format: %s', file.url ? file.url : '<no URL>' );
	        }
	    }
	
	    return filtered.sort(function(a, b) {
	        return a.height - b.height;
	    });
	
	}
	
	/**
	 * @private
	 * @inner
	 * @function
	 */
	function configureFromXML( tileSource, xmlDoc ){
	
	    if ( !xmlDoc || !xmlDoc.documentElement ) {
	        throw new Error( $.getString( "Errors.Xml" ) );
	    }
	
	    var root         = xmlDoc.documentElement,
	        rootName     = root.tagName,
	        conf         = null,
	        levels       = [],
	        level,
	        i;
	
	    if ( rootName == "image" ) {
	
	        try {
	            conf = {
	                type:        root.getAttribute( "type" ),
	                levels:      []
	            };
	
	            levels = root.getElementsByTagName( "level" );
	            for ( i = 0; i < levels.length; i++ ) {
	                level = levels[ i ];
	
	                conf.levels.push({
	                    url:    level.getAttribute( "url" ),
	                    width:  parseInt( level.getAttribute( "width" ), 10 ),
	                    height: parseInt( level.getAttribute( "height" ), 10 )
	                });
	            }
	
	            return configureFromObject( tileSource, conf );
	
	        } catch ( e ) {
	            throw (e instanceof Error) ?
	                e :
	                new Error( 'Unknown error parsing Legacy Image Pyramid XML.' );
	        }
	    } else if ( rootName == "collection" ) {
	        throw new Error( 'Legacy Image Pyramid Collections not yet supported.' );
	    } else if ( rootName == "error" ) {
	        throw new Error( 'Error: ' + xmlDoc );
	    }
	
	    throw new Error( 'Unknown element ' + rootName );
	}
	
	/**
	 * @private
	 * @inner
	 * @function
	 */
	function configureFromObject( tileSource, configuration ){
	
	    return configuration.levels;
	
	}
	
	}( OpenSeadragon ));
	
	/*
	 * OpenSeadragon - ImageTileSource
	 *
	 * Copyright (C) 2009 CodePlex Foundation
	 * Copyright (C) 2010-2013 OpenSeadragon contributors
	 *
	 * Redistribution and use in source and binary forms, with or without
	 * modification, are permitted provided that the following conditions are
	 * met:
	 *
	 * - Redistributions of source code must retain the above copyright notice,
	 *   this list of conditions and the following disclaimer.
	 *
	 * - Redistributions in binary form must reproduce the above copyright
	 *   notice, this list of conditions and the following disclaimer in the
	 *   documentation and/or other materials provided with the distribution.
	 *
	 * - Neither the name of CodePlex Foundation nor the names of its
	 *   contributors may be used to endorse or promote products derived from
	 *   this software without specific prior written permission.
	 *
	 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
	 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
	 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
	 * A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT
	 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
	 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
	 * TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 * PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
	 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
	 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
	 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	 */
	
	(function ($) {
	
	    /**
	     * @class ImageTileSource
	     * @classdesc The ImageTileSource allows a simple image to be loaded
	     * into an OpenSeadragon Viewer.
	     * There are 2 ways to open an ImageTileSource:
	     * 1. viewer.open({type: 'image', url: fooUrl});
	     * 2. viewer.open(new OpenSeadragon.ImageTileSource({url: fooUrl}));
	     *
	     * With the first syntax, the crossOriginPolicy, ajaxWithCredentials and
	     * useCanvas options are inherited from the viewer if they are not
	     * specified directly in the options object.
	     *
	     * @memberof OpenSeadragon
	     * @extends OpenSeadragon.TileSource
	     * @param {Object} options Options object.
	     * @param {String} options.url URL of the image
	     * @param {Boolean} [options.buildPyramid=true] If set to true (default), a
	     * pyramid will be built internally to provide a better downsampling.
	     * @param {String|Boolean} [options.crossOriginPolicy=false] Valid values are
	     * 'Anonymous', 'use-credentials', and false. If false, image requests will
	     * not use CORS preventing internal pyramid building for images from other
	     * domains.
	     * @param {String|Boolean} [options.ajaxWithCredentials=false] Whether to set
	     * the withCredentials XHR flag for AJAX requests (when loading tile sources).
	     * @param {Boolean} [options.useCanvas=true] Set to false to prevent any use
	     * of the canvas API.
	     */
	    $.ImageTileSource = function (options) {
	
	        options = $.extend({
	            buildPyramid: true,
	            crossOriginPolicy: false,
	            ajaxWithCredentials: false,
	            useCanvas: true
	        }, options);
	        $.TileSource.apply(this, [options]);
	
	    };
	
	    $.extend($.ImageTileSource.prototype, $.TileSource.prototype, /** @lends OpenSeadragon.ImageTileSource.prototype */{
	        /**
	         * Determine if the data and/or url imply the image service is supported by
	         * this tile source.
	         * @function
	         * @param {Object|Array} data
	         * @param {String} optional - url
	         */
	        supports: function (data, url) {
	            return data.type && data.type === "image";
	        },
	        /**
	         *
	         * @function
	         * @param {Object} options - the options
	         * @param {String} dataUrl - the url the image was retreived from, if any.
	         * @return {Object} options - A dictionary of keyword arguments sufficient
	         *      to configure this tile sources constructor.
	         */
	        configure: function (options, dataUrl) {
	            return options;
	        },
	        /**
	         * Responsible for retrieving, and caching the
	         * image metadata pertinent to this TileSources implementation.
	         * @function
	         * @param {String} url
	         * @throws {Error}
	         */
	        getImageInfo: function (url) {
	            var image = this._image = new Image();
	            var _this = this;
	
	            if (this.crossOriginPolicy) {
	                image.crossOrigin = this.crossOriginPolicy;
	            }
	            if (this.ajaxWithCredentials) {
	                image.useCredentials = this.ajaxWithCredentials;
	            }
	
	            $.addEvent(image, 'load', function () {
	                /* IE8 fix since it has no naturalWidth and naturalHeight */
	                _this.width = Object.prototype.hasOwnProperty.call(image, 'naturalWidth') ? image.naturalWidth : image.width;
	                _this.height = Object.prototype.hasOwnProperty.call(image, 'naturalHeight') ? image.naturalHeight : image.height;
	                _this.aspectRatio = _this.width / _this.height;
	                _this.dimensions = new $.Point(_this.width, _this.height);
	                _this._tileWidth = _this.width;
	                _this._tileHeight = _this.height;
	                _this.tileOverlap = 0;
	                _this.minLevel = 0;
	                _this.levels = _this._buildLevels();
	                _this.maxLevel = _this.levels.length - 1;
	
	                _this.ready = true;
	
	                // Note: this event is documented elsewhere, in TileSource
	                _this.raiseEvent('ready', {tileSource: _this});
	            });
	
	            $.addEvent(image, 'error', function () {
	                // Note: this event is documented elsewhere, in TileSource
	                _this.raiseEvent('open-failed', {
	                    message: "Error loading image at " + url,
	                    source: url
	                });
	            });
	
	            image.src = url;
	        },
	        /**
	         * @function
	         * @param {Number} level
	         */
	        getLevelScale: function (level) {
	            var levelScale = NaN;
	            if (level >= this.minLevel && level <= this.maxLevel) {
	                levelScale =
	                        this.levels[level].width /
	                        this.levels[this.maxLevel].width;
	            }
	            return levelScale;
	        },
	        /**
	         * @function
	         * @param {Number} level
	         */
	        getNumTiles: function (level) {
	            var scale = this.getLevelScale(level);
	            if (scale) {
	                return new $.Point(1, 1);
	            } else {
	                return new $.Point(0, 0);
	            }
	        },
	        /**
	         * Retrieves a tile url
	         * @function
	         * @param {Number} level Level of the tile
	         * @param {Number} x x coordinate of the tile
	         * @param {Number} y y coordinate of the tile
	         */
	        getTileUrl: function (level, x, y) {
	            var url = null;
	            if (level >= this.minLevel && level <= this.maxLevel) {
	                url = this.levels[level].url;
	            }
	            return url;
	        },
	        /**
	         * Retrieves a tile context 2D
	         * @function
	         * @param {Number} level Level of the tile
	         * @param {Number} x x coordinate of the tile
	         * @param {Number} y y coordinate of the tile
	         */
	        getContext2D: function (level, x, y) {
	            var context = null;
	            if (level >= this.minLevel && level <= this.maxLevel) {
	                context = this.levels[level].context2D;
	            }
	            return context;
	        },
	
	        // private
	        //
	        // Builds the differents levels of the pyramid if possible
	        // (i.e. if canvas API enabled and no canvas tainting issue).
	        _buildLevels: function () {
	            var levels = [{
	                    url: this._image.src,
	                    /* IE8 fix since it has no naturalWidth and naturalHeight */
	                    width: Object.prototype.hasOwnProperty.call(this._image, 'naturalWidth') ? this._image.naturalWidth : this._image.width,
	                    height:  Object.prototype.hasOwnProperty.call(this._image, 'naturalHeight') ? this._image.naturalHeight : this._image.height
	                }];
	
	            if (!this.buildPyramid || !$.supportsCanvas || !this.useCanvas) {
	                // We don't need the image anymore. Allows it to be GC.
	                delete this._image;
	                return levels;
	            }
	
	            /* IE8 fix since it has no naturalWidth and naturalHeight */
	            var currentWidth = Object.prototype.hasOwnProperty.call(this._image, 'naturalWidth') ? this._image.naturalWidth : this._image.width;
	            var currentHeight = Object.prototype.hasOwnProperty.call(this._image, 'naturalHeight') ? this._image.naturalHeight : this._image.height;
	
	
	            var bigCanvas = document.createElement("canvas");
	            var bigContext = bigCanvas.getContext("2d");
	
	            bigCanvas.width = currentWidth;
	            bigCanvas.height = currentHeight;
	            bigContext.drawImage(this._image, 0, 0, currentWidth, currentHeight);
	            // We cache the context of the highest level because the browser
	            // is a lot faster at downsampling something it already has
	            // downsampled before.
	            levels[0].context2D = bigContext;
	            // We don't need the image anymore. Allows it to be GC.
	            delete this._image;
	
	            if ($.isCanvasTainted(bigCanvas)) {
	                // If the canvas is tainted, we can't compute the pyramid.
	                return levels;
	            }
	
	            // We build smaller levels until either width or height becomes
	            // 1 pixel wide.
	            while (currentWidth >= 2 && currentHeight >= 2) {
	                currentWidth = Math.floor(currentWidth / 2);
	                currentHeight = Math.floor(currentHeight / 2);
	                var smallCanvas = document.createElement("canvas");
	                var smallContext = smallCanvas.getContext("2d");
	                smallCanvas.width = currentWidth;
	                smallCanvas.height = currentHeight;
	                smallContext.drawImage(bigCanvas, 0, 0, currentWidth, currentHeight);
	
	                levels.splice(0, 0, {
	                    context2D: smallContext,
	                    width: currentWidth,
	                    height: currentHeight
	                });
	
	                bigCanvas = smallCanvas;
	                bigContext = smallContext;
	            }
	            return levels;
	        }
	    });
	
	}(OpenSeadragon));
	
	/*
	 * OpenSeadragon - TileSourceCollection
	 *
	 * Copyright (C) 2009 CodePlex Foundation
	 * Copyright (C) 2010-2013 OpenSeadragon contributors
	 *
	 * Redistribution and use in source and binary forms, with or without
	 * modification, are permitted provided that the following conditions are
	 * met:
	 *
	 * - Redistributions of source code must retain the above copyright notice,
	 *   this list of conditions and the following disclaimer.
	 *
	 * - Redistributions in binary form must reproduce the above copyright
	 *   notice, this list of conditions and the following disclaimer in the
	 *   documentation and/or other materials provided with the distribution.
	 *
	 * - Neither the name of CodePlex Foundation nor the names of its
	 *   contributors may be used to endorse or promote products derived from
	 *   this software without specific prior written permission.
	 *
	 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
	 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
	 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
	 * A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT
	 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
	 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
	 * TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 * PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
	 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
	 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
	 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	 */
	
	(function($) {
	
	// deprecated
	$.TileSourceCollection = function(tileSize, tileSources, rows, layout) {
	    $.console.error('TileSourceCollection is deprecated; use World instead');
	};
	
	}(OpenSeadragon));
	
	/*
	 * OpenSeadragon - Button
	 *
	 * Copyright (C) 2009 CodePlex Foundation
	 * Copyright (C) 2010-2013 OpenSeadragon contributors
	 *
	 * Redistribution and use in source and binary forms, with or without
	 * modification, are permitted provided that the following conditions are
	 * met:
	 *
	 * - Redistributions of source code must retain the above copyright notice,
	 *   this list of conditions and the following disclaimer.
	 *
	 * - Redistributions in binary form must reproduce the above copyright
	 *   notice, this list of conditions and the following disclaimer in the
	 *   documentation and/or other materials provided with the distribution.
	 *
	 * - Neither the name of CodePlex Foundation nor the names of its
	 *   contributors may be used to endorse or promote products derived from
	 *   this software without specific prior written permission.
	 *
	 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
	 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
	 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
	 * A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT
	 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
	 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
	 * TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 * PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
	 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
	 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
	 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	 */
	
	(function( $ ){
	
	/**
	 * An enumeration of button states
	 * @member ButtonState
	 * @memberof OpenSeadragon
	 * @static
	 * @type {Object}
	 * @property {Number} REST
	 * @property {Number} GROUP
	 * @property {Number} HOVER
	 * @property {Number} DOWN
	 */
	$.ButtonState = {
	    REST:   0,
	    GROUP:  1,
	    HOVER:  2,
	    DOWN:   3
	};
	
	/**
	 * @class Button
	 * @classdesc Manages events, hover states for individual buttons, tool-tips, as well
	 * as fading the buttons out when the user has not interacted with them
	 * for a specified period.
	 *
	 * @memberof OpenSeadragon
	 * @extends OpenSeadragon.EventSource
	 * @param {Object} options
	 * @param {Element} [options.element=null] Element to use as the button. If not specified, an HTML &lt;div&gt; element is created.
	 * @param {String} [options.tooltip=null] Provides context help for the button when the
	 *  user hovers over it.
	 * @param {String} [options.srcRest=null] URL of image to use in 'rest' state.
	 * @param {String} [options.srcGroup=null] URL of image to use in 'up' state.
	 * @param {String} [options.srcHover=null] URL of image to use in 'hover' state.
	 * @param {String} [options.srcDown=null] URL of image to use in 'down' state.
	 * @param {Number} [options.fadeDelay=0] How long to wait before fading.
	 * @param {Number} [options.fadeLength=2000] How long should it take to fade the button.
	 * @param {OpenSeadragon.EventHandler} [options.onPress=null] Event handler callback for {@link OpenSeadragon.Button.event:press}.
	 * @param {OpenSeadragon.EventHandler} [options.onRelease=null] Event handler callback for {@link OpenSeadragon.Button.event:release}.
	 * @param {OpenSeadragon.EventHandler} [options.onClick=null] Event handler callback for {@link OpenSeadragon.Button.event:click}.
	 * @param {OpenSeadragon.EventHandler} [options.onEnter=null] Event handler callback for {@link OpenSeadragon.Button.event:enter}.
	 * @param {OpenSeadragon.EventHandler} [options.onExit=null] Event handler callback for {@link OpenSeadragon.Button.event:exit}.
	 * @param {OpenSeadragon.EventHandler} [options.onFocus=null] Event handler callback for {@link OpenSeadragon.Button.event:focus}.
	 * @param {OpenSeadragon.EventHandler} [options.onBlur=null] Event handler callback for {@link OpenSeadragon.Button.event:blur}.
	 */
	$.Button = function( options ) {
	
	    var _this = this;
	
	    $.EventSource.call( this );
	
	    $.extend( true, this, {
	
	        tooltip:            null,
	        srcRest:            null,
	        srcGroup:           null,
	        srcHover:           null,
	        srcDown:            null,
	        clickTimeThreshold: $.DEFAULT_SETTINGS.clickTimeThreshold,
	        clickDistThreshold: $.DEFAULT_SETTINGS.clickDistThreshold,
	        /**
	         * How long to wait before fading.
	         * @member {Number} fadeDelay
	         * @memberof OpenSeadragon.Button#
	         */
	        fadeDelay:          0,
	        /**
	         * How long should it take to fade the button.
	         * @member {Number} fadeLength
	         * @memberof OpenSeadragon.Button#
	         */
	        fadeLength:         2000,
	        onPress:            null,
	        onRelease:          null,
	        onClick:            null,
	        onEnter:            null,
	        onExit:             null,
	        onFocus:            null,
	        onBlur:             null
	
	    }, options );
	
	    /**
	     * The button element.
	     * @member {Element} element
	     * @memberof OpenSeadragon.Button#
	     */
	    this.element = options.element || $.makeNeutralElement("div");
	
	    //if the user has specified the element to bind the control to explicitly
	    //then do not add the default control images
	    if ( !options.element ) {
	        this.imgRest      = $.makeTransparentImage( this.srcRest );
	        this.imgGroup     = $.makeTransparentImage( this.srcGroup );
	        this.imgHover     = $.makeTransparentImage( this.srcHover );
	        this.imgDown      = $.makeTransparentImage( this.srcDown );
	
	        this.imgRest.alt  =
	        this.imgGroup.alt =
	        this.imgHover.alt =
	        this.imgDown.alt  =
	            this.tooltip;
	
	        this.element.style.position = "relative";
	        $.setElementTouchActionNone( this.element );
	
	        this.imgGroup.style.position =
	        this.imgHover.style.position =
	        this.imgDown.style.position  =
	            "absolute";
	
	        this.imgGroup.style.top =
	        this.imgHover.style.top =
	        this.imgDown.style.top  =
	            "0px";
	
	        this.imgGroup.style.left =
	        this.imgHover.style.left =
	        this.imgDown.style.left  =
	            "0px";
	
	        this.imgHover.style.visibility =
	        this.imgDown.style.visibility  =
	            "hidden";
	
	        if ($.Browser.vendor == $.BROWSERS.FIREFOX && $.Browser.version < 3) {
	            this.imgGroup.style.top =
	            this.imgHover.style.top =
	            this.imgDown.style.top  =
	                "";
	        }
	
	        this.element.appendChild( this.imgRest );
	        this.element.appendChild( this.imgGroup );
	        this.element.appendChild( this.imgHover );
	        this.element.appendChild( this.imgDown );
	    }
	
	
	    this.addHandler("press", this.onPress);
	    this.addHandler("release", this.onRelease);
	    this.addHandler("click", this.onClick);
	    this.addHandler("enter", this.onEnter);
	    this.addHandler("exit", this.onExit);
	    this.addHandler("focus", this.onFocus);
	    this.addHandler("blur", this.onBlur);
	
	    /**
	     * The button's current state.
	     * @member {OpenSeadragon.ButtonState} currentState
	     * @memberof OpenSeadragon.Button#
	     */
	    this.currentState = $.ButtonState.GROUP;
	
	    // When the button last began to fade.
	    this.fadeBeginTime  = null;
	    // Whether this button should fade after user stops interacting with the viewport.
	    this.shouldFade     = false;
	
	    this.element.style.display  = "inline-block";
	    this.element.style.position = "relative";
	    this.element.title          = this.tooltip;
	
	    /**
	     * Tracks mouse/touch/key events on the button.
	     * @member {OpenSeadragon.MouseTracker} tracker
	     * @memberof OpenSeadragon.Button#
	     */
	    this.tracker = new $.MouseTracker({
	
	        element:            this.element,
	        clickTimeThreshold: this.clickTimeThreshold,
	        clickDistThreshold: this.clickDistThreshold,
	
	        enterHandler: function( event ) {
	            if ( event.insideElementPressed ) {
	                inTo( _this, $.ButtonState.DOWN );
	                /**
	                 * Raised when the cursor enters the Button element.
	                 *
	                 * @event enter
	                 * @memberof OpenSeadragon.Button
	                 * @type {object}
	                 * @property {OpenSeadragon.Button} eventSource - A reference to the Button which raised the event.
	                 * @property {Object} originalEvent - The original DOM event.
	                 * @property {?Object} userData - Arbitrary subscriber-defined object.
	                 */
	                _this.raiseEvent( "enter", { originalEvent: event.originalEvent } );
	            } else if ( !event.buttonDownAny ) {
	                inTo( _this, $.ButtonState.HOVER );
	            }
	        },
	
	        focusHandler: function ( event ) {
	            this.enterHandler( event );
	            /**
	             * Raised when the Button element receives focus.
	             *
	             * @event focus
	             * @memberof OpenSeadragon.Button
	             * @type {object}
	             * @property {OpenSeadragon.Button} eventSource - A reference to the Button which raised the event.
	             * @property {Object} originalEvent - The original DOM event.
	             * @property {?Object} userData - Arbitrary subscriber-defined object.
	             */
	            _this.raiseEvent( "focus", { originalEvent: event.originalEvent } );
	        },
	
	        exitHandler: function( event ) {
	            outTo( _this, $.ButtonState.GROUP );
	            if ( event.insideElementPressed ) {
	                /**
	                 * Raised when the cursor leaves the Button element.
	                 *
	                 * @event exit
	                 * @memberof OpenSeadragon.Button
	                 * @type {object}
	                 * @property {OpenSeadragon.Button} eventSource - A reference to the Button which raised the event.
	                 * @property {Object} originalEvent - The original DOM event.
	                 * @property {?Object} userData - Arbitrary subscriber-defined object.
	                 */
	                _this.raiseEvent( "exit", { originalEvent: event.originalEvent } );
	            }
	        },
	
	        blurHandler: function ( event ) {
	            this.exitHandler( event );
	            /**
	             * Raised when the Button element loses focus.
	             *
	             * @event blur
	             * @memberof OpenSeadragon.Button
	             * @type {object}
	             * @property {OpenSeadragon.Button} eventSource - A reference to the Button which raised the event.
	             * @property {Object} originalEvent - The original DOM event.
	             * @property {?Object} userData - Arbitrary subscriber-defined object.
	             */
	            _this.raiseEvent( "blur", { originalEvent: event.originalEvent } );
	        },
	
	        pressHandler: function ( event ) {
	            inTo( _this, $.ButtonState.DOWN );
	            /**
	             * Raised when a mouse button is pressed or touch occurs in the Button element.
	             *
	             * @event press
	             * @memberof OpenSeadragon.Button
	             * @type {object}
	             * @property {OpenSeadragon.Button} eventSource - A reference to the Button which raised the event.
	             * @property {Object} originalEvent - The original DOM event.
	             * @property {?Object} userData - Arbitrary subscriber-defined object.
	             */
	            _this.raiseEvent( "press", { originalEvent: event.originalEvent } );
	        },
	
	        releaseHandler: function( event ) {
	            if ( event.insideElementPressed && event.insideElementReleased ) {
	                outTo( _this, $.ButtonState.HOVER );
	                /**
	                 * Raised when the mouse button is released or touch ends in the Button element.
	                 *
	                 * @event release
	                 * @memberof OpenSeadragon.Button
	                 * @type {object}
	                 * @property {OpenSeadragon.Button} eventSource - A reference to the Button which raised the event.
	                 * @property {Object} originalEvent - The original DOM event.
	                 * @property {?Object} userData - Arbitrary subscriber-defined object.
	                 */
	                _this.raiseEvent( "release", { originalEvent: event.originalEvent } );
	            } else if ( event.insideElementPressed ) {
	                outTo( _this, $.ButtonState.GROUP );
	            } else {
	                inTo( _this, $.ButtonState.HOVER );
	            }
	        },
	
	        clickHandler: function( event ) {
	            if ( event.quick ) {
	                /**
	                 * Raised when a mouse button is pressed and released or touch is initiated and ended in the Button element within the time and distance threshold.
	                 *
	                 * @event click
	                 * @memberof OpenSeadragon.Button
	                 * @type {object}
	                 * @property {OpenSeadragon.Button} eventSource - A reference to the Button which raised the event.
	                 * @property {Object} originalEvent - The original DOM event.
	                 * @property {?Object} userData - Arbitrary subscriber-defined object.
	                 */
	                _this.raiseEvent("click", { originalEvent: event.originalEvent });
	            }
	        },
	
	        keyHandler: function( event ){
	            //console.log( "%s : handling key %s!", _this.tooltip, event.keyCode);
	            if( 13 === event.keyCode ){
	                /***
	                 * Raised when a mouse button is pressed and released or touch is initiated and ended in the Button element within the time and distance threshold.
	                 *
	                 * @event click
	                 * @memberof OpenSeadragon.Button
	                 * @type {object}
	                 * @property {OpenSeadragon.Button} eventSource - A reference to the Button which raised the event.
	                 * @property {Object} originalEvent - The original DOM event.
	                 * @property {?Object} userData - Arbitrary subscriber-defined object.
	                 */
	                _this.raiseEvent( "click", { originalEvent: event.originalEvent } );
	                /***
	                 * Raised when the mouse button is released or touch ends in the Button element.
	                 *
	                 * @event release
	                 * @memberof OpenSeadragon.Button
	                 * @type {object}
	                 * @property {OpenSeadragon.Button} eventSource - A reference to the Button which raised the event.
	                 * @property {Object} originalEvent - The original DOM event.
	                 * @property {?Object} userData - Arbitrary subscriber-defined object.
	                 */
	                _this.raiseEvent( "release", { originalEvent: event.originalEvent } );
	                return false;
	            }
	            return true;
	        }
	
	    });
	
	    outTo( this, $.ButtonState.REST );
	};
	
	$.extend( $.Button.prototype, $.EventSource.prototype, /** @lends OpenSeadragon.Button.prototype */{
	
	    /**
	     * TODO: Determine what this function is intended to do and if it's actually
	     * useful as an API point.
	     * @function
	     */
	    notifyGroupEnter: function() {
	        inTo( this, $.ButtonState.GROUP );
	    },
	
	    /**
	     * TODO: Determine what this function is intended to do and if it's actually
	     * useful as an API point.
	     * @function
	     */
	    notifyGroupExit: function() {
	        outTo( this, $.ButtonState.REST );
	    },
	
	    /**
	     * @function
	     */
	    disable: function(){
	        this.notifyGroupExit();
	        this.element.disabled = true;
	        $.setElementOpacity( this.element, 0.2, true );
	    },
	
	    /**
	     * @function
	     */
	    enable: function(){
	        this.element.disabled = false;
	        $.setElementOpacity( this.element, 1.0, true );
	        this.notifyGroupEnter();
	    }
	
	});
	
	
	function scheduleFade( button ) {
	    $.requestAnimationFrame(function(){
	        updateFade( button );
	    });
	}
	
	function updateFade( button ) {
	    var currentTime,
	        deltaTime,
	        opacity;
	
	    if ( button.shouldFade ) {
	        currentTime = $.now();
	        deltaTime   = currentTime - button.fadeBeginTime;
	        opacity     = 1.0 - deltaTime / button.fadeLength;
	        opacity     = Math.min( 1.0, opacity );
	        opacity     = Math.max( 0.0, opacity );
	
	        if( button.imgGroup ){
	            $.setElementOpacity( button.imgGroup, opacity, true );
	        }
	        if ( opacity > 0 ) {
	            // fade again
	            scheduleFade( button );
	        }
	    }
	}
	
	function beginFading( button ) {
	    button.shouldFade = true;
	    button.fadeBeginTime = $.now() + button.fadeDelay;
	    window.setTimeout( function(){
	        scheduleFade( button );
	    }, button.fadeDelay );
	}
	
	function stopFading( button ) {
	    button.shouldFade = false;
	    if( button.imgGroup ){
	        $.setElementOpacity( button.imgGroup, 1.0, true );
	    }
	}
	
	function inTo( button, newState ) {
	
	    if( button.element.disabled ){
	        return;
	    }
	
	    if ( newState >= $.ButtonState.GROUP &&
	         button.currentState == $.ButtonState.REST ) {
	        stopFading( button );
	        button.currentState = $.ButtonState.GROUP;
	    }
	
	    if ( newState >= $.ButtonState.HOVER &&
	         button.currentState == $.ButtonState.GROUP ) {
	        if( button.imgHover ){
	            button.imgHover.style.visibility = "";
	        }
	        button.currentState = $.ButtonState.HOVER;
	    }
	
	    if ( newState >= $.ButtonState.DOWN &&
	         button.currentState == $.ButtonState.HOVER ) {
	        if( button.imgDown ){
	            button.imgDown.style.visibility = "";
	        }
	        button.currentState = $.ButtonState.DOWN;
	    }
	}
	
	
	function outTo( button, newState ) {
	
	    if( button.element.disabled ){
	        return;
	    }
	
	    if ( newState <= $.ButtonState.HOVER &&
	         button.currentState == $.ButtonState.DOWN ) {
	        if( button.imgDown ){
	            button.imgDown.style.visibility = "hidden";
	        }
	        button.currentState = $.ButtonState.HOVER;
	    }
	
	    if ( newState <= $.ButtonState.GROUP &&
	         button.currentState == $.ButtonState.HOVER ) {
	        if( button.imgHover ){
	            button.imgHover.style.visibility = "hidden";
	        }
	        button.currentState = $.ButtonState.GROUP;
	    }
	
	    if ( newState <= $.ButtonState.REST &&
	         button.currentState == $.ButtonState.GROUP ) {
	        beginFading( button );
	        button.currentState = $.ButtonState.REST;
	    }
	}
	
	
	
	}( OpenSeadragon ));
	
	/*
	 * OpenSeadragon - ButtonGroup
	 *
	 * Copyright (C) 2009 CodePlex Foundation
	 * Copyright (C) 2010-2013 OpenSeadragon contributors
	 *
	 * Redistribution and use in source and binary forms, with or without
	 * modification, are permitted provided that the following conditions are
	 * met:
	 *
	 * - Redistributions of source code must retain the above copyright notice,
	 *   this list of conditions and the following disclaimer.
	 *
	 * - Redistributions in binary form must reproduce the above copyright
	 *   notice, this list of conditions and the following disclaimer in the
	 *   documentation and/or other materials provided with the distribution.
	 *
	 * - Neither the name of CodePlex Foundation nor the names of its
	 *   contributors may be used to endorse or promote products derived from
	 *   this software without specific prior written permission.
	 *
	 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
	 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
	 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
	 * A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT
	 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
	 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
	 * TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 * PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
	 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
	 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
	 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	 */
	
	(function( $ ){
	/**
	 * @class ButtonGroup
	 * @classdesc Manages events on groups of buttons.
	 *
	 * @memberof OpenSeadragon
	 * @param {Object} options - A dictionary of settings applied against the entire group of buttons.
	 * @param {Array} options.buttons Array of buttons
	 * @param {Element} [options.element] Element to use as the container
	 **/
	$.ButtonGroup = function( options ) {
	
	    $.extend( true, this, {
	        /**
	         * An array containing the buttons themselves.
	         * @member {Array} buttons
	         * @memberof OpenSeadragon.ButtonGroup#
	         */
	        buttons:            [],
	        clickTimeThreshold: $.DEFAULT_SETTINGS.clickTimeThreshold,
	        clickDistThreshold: $.DEFAULT_SETTINGS.clickDistThreshold,
	        labelText:          ""
	    }, options );
	
	    // copy the button elements  TODO: Why?
	    var buttons = this.buttons.concat([]),
	        _this = this,
	        i;
	
	    /**
	     * The shared container for the buttons.
	     * @member {Element} element
	     * @memberof OpenSeadragon.ButtonGroup#
	     */
	    this.element = options.element || $.makeNeutralElement( "div" );
	
	    // TODO What if there IS an options.group specified?
	    if( !options.group ){
	        this.label   = $.makeNeutralElement( "label" );
	        //TODO: support labels for ButtonGroups
	        //this.label.innerHTML = this.labelText;
	        this.element.style.display = "inline-block";
	        this.element.appendChild( this.label );
	        for ( i = 0; i < buttons.length; i++ ) {
	            this.element.appendChild( buttons[ i ].element );
	        }
	    }
	
	    $.setElementTouchActionNone( this.element );
	
	    /**
	     * Tracks mouse/touch/key events accross the group of buttons.
	     * @member {OpenSeadragon.MouseTracker} tracker
	     * @memberof OpenSeadragon.ButtonGroup#
	     */
	    this.tracker = new $.MouseTracker({
	        element:            this.element,
	        clickTimeThreshold: this.clickTimeThreshold,
	        clickDistThreshold: this.clickDistThreshold,
	        enterHandler: function ( event ) {
	            var i;
	            for ( i = 0; i < _this.buttons.length; i++ ) {
	                _this.buttons[ i ].notifyGroupEnter();
	            }
	        },
	        exitHandler: function ( event ) {
	            var i;
	            if ( !event.insideElementPressed ) {
	                for ( i = 0; i < _this.buttons.length; i++ ) {
	                    _this.buttons[ i ].notifyGroupExit();
	                }
	            }
	        },
	    });
	};
	
	/** @lends OpenSeadragon.ButtonGroup.prototype */
	$.ButtonGroup.prototype = {
	
	    /**
	     * TODO: Figure out why this is used on the public API and if a more useful
	     * api can be created.
	     * @function
	     * @private
	     */
	    emulateEnter: function() {
	        this.tracker.enterHandler( { eventSource: this.tracker } );
	    },
	
	    /**
	     * TODO: Figure out why this is used on the public API and if a more useful
	     * api can be created.
	     * @function
	     * @private
	     */
	    emulateExit: function() {
	        this.tracker.exitHandler( { eventSource: this.tracker } );
	    }
	};
	
	
	}( OpenSeadragon ));
	
	/*
	 * OpenSeadragon - Rect
	 *
	 * Copyright (C) 2009 CodePlex Foundation
	 * Copyright (C) 2010-2013 OpenSeadragon contributors
	 *
	 * Redistribution and use in source and binary forms, with or without
	 * modification, are permitted provided that the following conditions are
	 * met:
	 *
	 * - Redistributions of source code must retain the above copyright notice,
	 *   this list of conditions and the following disclaimer.
	 *
	 * - Redistributions in binary form must reproduce the above copyright
	 *   notice, this list of conditions and the following disclaimer in the
	 *   documentation and/or other materials provided with the distribution.
	 *
	 * - Neither the name of CodePlex Foundation nor the names of its
	 *   contributors may be used to endorse or promote products derived from
	 *   this software without specific prior written permission.
	 *
	 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
	 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
	 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
	 * A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT
	 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
	 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
	 * TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 * PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
	 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
	 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
	 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	 */
	
	(function($) {
	
	/**
	 * @class Rect
	 * @classdesc A Rectangle is described by it top left coordinates (x, y), width,
	 * height and degrees of rotation around (x, y).
	 * Note that the coordinate system used is the one commonly used with images:
	 * x increases when going to the right
	 * y increases when going to the bottom
	 * degrees increases clockwise with 0 being the horizontal
	 *
	 * The constructor normalizes the rectangle to always have 0 <= degrees < 90
	 *
	 * @memberof OpenSeadragon
	 * @param {Number} [x=0] The vector component 'x'.
	 * @param {Number} [y=0] The vector component 'y'.
	 * @param {Number} [width=0] The vector component 'width'.
	 * @param {Number} [height=0] The vector component 'height'.
	 * @param {Number} [degrees=0] Rotation of the rectangle around (x,y) in degrees.
	 */
	$.Rect = function(x, y, width, height, degrees) {
	    /**
	     * The vector component 'x'.
	     * @member {Number} x
	     * @memberof OpenSeadragon.Rect#
	     */
	    this.x = typeof (x) === "number" ? x : 0;
	    /**
	     * The vector component 'y'.
	     * @member {Number} y
	     * @memberof OpenSeadragon.Rect#
	     */
	    this.y = typeof (y) === "number" ? y : 0;
	    /**
	     * The vector component 'width'.
	     * @member {Number} width
	     * @memberof OpenSeadragon.Rect#
	     */
	    this.width  = typeof (width) === "number" ? width : 0;
	    /**
	     * The vector component 'height'.
	     * @member {Number} height
	     * @memberof OpenSeadragon.Rect#
	     */
	    this.height = typeof (height) === "number" ? height : 0;
	
	    this.degrees = typeof (degrees) === "number" ? degrees : 0;
	
	    // Normalizes the rectangle.
	    this.degrees = $.positiveModulo(this.degrees, 360);
	    var newTopLeft, newWidth;
	    if (this.degrees >= 270) {
	        newTopLeft = this.getTopRight();
	        this.x = newTopLeft.x;
	        this.y = newTopLeft.y;
	        newWidth = this.height;
	        this.height = this.width;
	        this.width = newWidth;
	        this.degrees -= 270;
	    } else if (this.degrees >= 180) {
	        newTopLeft = this.getBottomRight();
	        this.x = newTopLeft.x;
	        this.y = newTopLeft.y;
	        this.degrees -= 180;
	    } else if (this.degrees >= 90) {
	        newTopLeft = this.getBottomLeft();
	        this.x = newTopLeft.x;
	        this.y = newTopLeft.y;
	        newWidth = this.height;
	        this.height = this.width;
	        this.width = newWidth;
	        this.degrees -= 90;
	    }
	};
	
	/**
	 * Builds a rectangle having the 3 specified points as summits.
	 * @static
	 * @memberof OpenSeadragon.Rect
	 * @param {OpenSeadragon.Point} topLeft
	 * @param {OpenSeadragon.Point} topRight
	 * @param {OpenSeadragon.Point} bottomLeft
	 * @returns {OpenSeadragon.Rect}
	 */
	$.Rect.fromSummits = function(topLeft, topRight, bottomLeft) {
	    var width = topLeft.distanceTo(topRight);
	    var height = topLeft.distanceTo(bottomLeft);
	    var diff = topRight.minus(topLeft);
	    var radians = Math.atan(diff.y / diff.x);
	    if (diff.x < 0) {
	        radians += Math.PI;
	    } else if (diff.y < 0) {
	        radians += 2 * Math.PI;
	    }
	    return new $.Rect(
	        topLeft.x,
	        topLeft.y,
	        width,
	        height,
	        radians / Math.PI * 180);
	};
	
	/** @lends OpenSeadragon.Rect.prototype */
	$.Rect.prototype = {
	    /**
	     * @function
	     * @returns {OpenSeadragon.Rect} a duplicate of this Rect
	     */
	    clone: function() {
	        return new $.Rect(
	            this.x,
	            this.y,
	            this.width,
	            this.height,
	            this.degrees);
	    },
	
	    /**
	     * The aspect ratio is simply the ratio of width to height.
	     * @function
	     * @returns {Number} The ratio of width to height.
	     */
	    getAspectRatio: function() {
	        return this.width / this.height;
	    },
	
	    /**
	     * Provides the coordinates of the upper-left corner of the rectangle as a
	     * point.
	     * @function
	     * @returns {OpenSeadragon.Point} The coordinate of the upper-left corner of
	     *  the rectangle.
	     */
	    getTopLeft: function() {
	        return new $.Point(
	            this.x,
	            this.y
	        );
	    },
	
	    /**
	     * Provides the coordinates of the bottom-right corner of the rectangle as a
	     * point.
	     * @function
	     * @returns {OpenSeadragon.Point} The coordinate of the bottom-right corner of
	     *  the rectangle.
	     */
	    getBottomRight: function() {
	        return new $.Point(this.x + this.width, this.y + this.height)
	            .rotate(this.degrees, this.getTopLeft());
	    },
	
	    /**
	     * Provides the coordinates of the top-right corner of the rectangle as a
	     * point.
	     * @function
	     * @returns {OpenSeadragon.Point} The coordinate of the top-right corner of
	     *  the rectangle.
	     */
	    getTopRight: function() {
	        return new $.Point(this.x + this.width, this.y)
	            .rotate(this.degrees, this.getTopLeft());
	    },
	
	    /**
	     * Provides the coordinates of the bottom-left corner of the rectangle as a
	     * point.
	     * @function
	     * @returns {OpenSeadragon.Point} The coordinate of the bottom-left corner of
	     *  the rectangle.
	     */
	    getBottomLeft: function() {
	        return new $.Point(this.x, this.y + this.height)
	            .rotate(this.degrees, this.getTopLeft());
	    },
	
	    /**
	     * Computes the center of the rectangle.
	     * @function
	     * @returns {OpenSeadragon.Point} The center of the rectangle as represented
	     *  as represented by a 2-dimensional vector (x,y)
	     */
	    getCenter: function() {
	        return new $.Point(
	            this.x + this.width / 2.0,
	            this.y + this.height / 2.0
	        ).rotate(this.degrees, this.getTopLeft());
	    },
	
	    /**
	     * Returns the width and height component as a vector OpenSeadragon.Point
	     * @function
	     * @returns {OpenSeadragon.Point} The 2 dimensional vector representing the
	     *  the width and height of the rectangle.
	     */
	    getSize: function() {
	        return new $.Point(this.width, this.height);
	    },
	
	    /**
	     * Determines if two Rectangles have equivalent components.
	     * @function
	     * @param {OpenSeadragon.Rect} rectangle The Rectangle to compare to.
	     * @return {Boolean} 'true' if all components are equal, otherwise 'false'.
	     */
	    equals: function(other) {
	        return (other instanceof $.Rect) &&
	            this.x === other.x &&
	            this.y === other.y &&
	            this.width === other.width &&
	            this.height === other.height &&
	            this.degrees === other.degrees;
	    },
	
	    /**
	    * Multiply all dimensions (except degrees) in this Rect by a factor and
	    * return a new Rect.
	    * @function
	    * @param {Number} factor The factor to multiply vector components.
	    * @returns {OpenSeadragon.Rect} A new rect representing the multiplication
	    *  of the vector components by the factor
	    */
	    times: function(factor) {
	        return new $.Rect(
	            this.x * factor,
	            this.y * factor,
	            this.width * factor,
	            this.height * factor,
	            this.degrees);
	    },
	
	    /**
	    * Translate/move this Rect by a vector and return new Rect.
	    * @function
	    * @param {OpenSeadragon.Point} delta The translation vector.
	    * @returns {OpenSeadragon.Rect} A new rect with altered position
	    */
	    translate: function(delta) {
	        return new $.Rect(
	            this.x + delta.x,
	            this.y + delta.y,
	            this.width,
	            this.height,
	            this.degrees);
	    },
	
	    /**
	     * Returns the smallest rectangle that will contain this and the given
	     * rectangle bounding boxes.
	     * @param {OpenSeadragon.Rect} rect
	     * @return {OpenSeadragon.Rect} The new rectangle.
	     */
	    union: function(rect) {
	        var thisBoundingBox = this.getBoundingBox();
	        var otherBoundingBox = rect.getBoundingBox();
	
	        var left = Math.min(thisBoundingBox.x, otherBoundingBox.x);
	        var top = Math.min(thisBoundingBox.y, otherBoundingBox.y);
	        var right = Math.max(
	            thisBoundingBox.x + thisBoundingBox.width,
	            otherBoundingBox.x + otherBoundingBox.width);
	        var bottom = Math.max(
	            thisBoundingBox.y + thisBoundingBox.height,
	            otherBoundingBox.y + otherBoundingBox.height);
	
	        return new $.Rect(
	            left,
	            top,
	            right - left,
	            bottom - top);
	    },
	
	    /**
	     * Returns the bounding box of the intersection of this rectangle with the
	     * given rectangle.
	     * @param {OpenSeadragon.Rect} rect
	     * @return {OpenSeadragon.Rect} the bounding box of the intersection
	     * or null if the rectangles don't intersect.
	     */
	    intersection: function(rect) {
	        // Simplified version of Weiler Atherton clipping algorithm
	        // https://en.wikipedia.org/wiki/Weiler%E2%80%93Atherton_clipping_algorithm
	        // Because we just want the bounding box of the intersection,
	        // we can just compute the bounding box of:
	        // 1. all the summits of this which are inside rect
	        // 2. all the summits of rect which are inside this
	        // 3. all the intersections of rect and this
	        var EPSILON = 0.0000000001;
	
	        var intersectionPoints = [];
	
	        var thisTopLeft = this.getTopLeft();
	        if (rect.containsPoint(thisTopLeft, EPSILON)) {
	            intersectionPoints.push(thisTopLeft);
	        }
	        var thisTopRight = this.getTopRight();
	        if (rect.containsPoint(thisTopRight, EPSILON)) {
	            intersectionPoints.push(thisTopRight);
	        }
	        var thisBottomLeft = this.getBottomLeft();
	        if (rect.containsPoint(thisBottomLeft, EPSILON)) {
	            intersectionPoints.push(thisBottomLeft);
	        }
	        var thisBottomRight = this.getBottomRight();
	        if (rect.containsPoint(thisBottomRight, EPSILON)) {
	            intersectionPoints.push(thisBottomRight);
	        }
	
	        var rectTopLeft = rect.getTopLeft();
	        if (this.containsPoint(rectTopLeft, EPSILON)) {
	            intersectionPoints.push(rectTopLeft);
	        }
	        var rectTopRight = rect.getTopRight();
	        if (this.containsPoint(rectTopRight, EPSILON)) {
	            intersectionPoints.push(rectTopRight);
	        }
	        var rectBottomLeft = rect.getBottomLeft();
	        if (this.containsPoint(rectBottomLeft, EPSILON)) {
	            intersectionPoints.push(rectBottomLeft);
	        }
	        var rectBottomRight = rect.getBottomRight();
	        if (this.containsPoint(rectBottomRight, EPSILON)) {
	            intersectionPoints.push(rectBottomRight);
	        }
	
	        var thisSegments = this._getSegments();
	        var rectSegments = rect._getSegments();
	        for (var i = 0; i < thisSegments.length; i++) {
	            var thisSegment = thisSegments[i];
	            for (var j = 0; j < rectSegments.length; j++) {
	                var rectSegment = rectSegments[j];
	                var intersect = getIntersection(thisSegment[0], thisSegment[1],
	                    rectSegment[0], rectSegment[1]);
	                if (intersect) {
	                    intersectionPoints.push(intersect);
	                }
	            }
	        }
	
	        // Get intersection point of segments [a,b] and [c,d]
	        function getIntersection(a, b, c, d) {
	            // http://stackoverflow.com/a/1968345/1440403
	            var abVector = b.minus(a);
	            var cdVector = d.minus(c);
	
	            var denom = -cdVector.x * abVector.y + abVector.x * cdVector.y;
	            if (denom === 0) {
	                return null;
	            }
	
	            var s = (abVector.x * (a.y - c.y) - abVector.y * (a.x - c.x)) / denom;
	            var t = (cdVector.x * (a.y - c.y) - cdVector.y * (a.x - c.x)) / denom;
	
	            if (-EPSILON <= s && s <= 1 - EPSILON &&
	                -EPSILON <= t && t <= 1 - EPSILON) {
	                return new $.Point(a.x + t * abVector.x, a.y + t * abVector.y);
	            }
	            return null;
	        }
	
	        if (intersectionPoints.length === 0) {
	            return null;
	        }
	
	        var minX = intersectionPoints[0].x;
	        var maxX = intersectionPoints[0].x;
	        var minY = intersectionPoints[0].y;
	        var maxY = intersectionPoints[0].y;
	        for (var k = 1; k < intersectionPoints.length; k++) {
	            var point = intersectionPoints[k];
	            if (point.x < minX) {
	                minX = point.x;
	            }
	            if (point.x > maxX) {
	                maxX = point.x;
	            }
	            if (point.y < minY) {
	                minY = point.y;
	            }
	            if (point.y > maxY) {
	                maxY = point.y;
	            }
	        }
	        return new $.Rect(minX, minY, maxX - minX, maxY - minY);
	    },
	
	    // private
	    _getSegments: function() {
	        var topLeft = this.getTopLeft();
	        var topRight = this.getTopRight();
	        var bottomLeft = this.getBottomLeft();
	        var bottomRight = this.getBottomRight();
	        return [[topLeft, topRight],
	            [topRight, bottomRight],
	            [bottomRight, bottomLeft],
	            [bottomLeft, topLeft]];
	    },
	
	    /**
	     * Rotates a rectangle around a point.
	     * @function
	     * @param {Number} degrees The angle in degrees to rotate.
	     * @param {OpenSeadragon.Point} [pivot] The point about which to rotate.
	     * Defaults to the center of the rectangle.
	     * @return {OpenSeadragon.Rect}
	     */
	    rotate: function(degrees, pivot) {
	        degrees = $.positiveModulo(degrees, 360);
	        if (degrees === 0) {
	            return this.clone();
	        }
	
	        pivot = pivot || this.getCenter();
	        var newTopLeft = this.getTopLeft().rotate(degrees, pivot);
	        var newTopRight = this.getTopRight().rotate(degrees, pivot);
	
	        var diff = newTopRight.minus(newTopLeft);
	        // Handle floating point error
	        diff = diff.apply(function(x) {
	            var EPSILON = 1e-15;
	            return Math.abs(x) < EPSILON ? 0 : x;
	        });
	        var radians = Math.atan(diff.y / diff.x);
	        if (diff.x < 0) {
	            radians += Math.PI;
	        } else if (diff.y < 0) {
	            radians += 2 * Math.PI;
	        }
	        return new $.Rect(
	            newTopLeft.x,
	            newTopLeft.y,
	            this.width,
	            this.height,
	            radians / Math.PI * 180);
	    },
	
	    /**
	     * Retrieves the smallest horizontal (degrees=0) rectangle which contains
	     * this rectangle.
	     * @returns {OpenSeadragon.Rect}
	     */
	    getBoundingBox: function() {
	        if (this.degrees === 0) {
	            return this.clone();
	        }
	        var topLeft = this.getTopLeft();
	        var topRight = this.getTopRight();
	        var bottomLeft = this.getBottomLeft();
	        var bottomRight = this.getBottomRight();
	        var minX = Math.min(topLeft.x, topRight.x, bottomLeft.x, bottomRight.x);
	        var maxX = Math.max(topLeft.x, topRight.x, bottomLeft.x, bottomRight.x);
	        var minY = Math.min(topLeft.y, topRight.y, bottomLeft.y, bottomRight.y);
	        var maxY = Math.max(topLeft.y, topRight.y, bottomLeft.y, bottomRight.y);
	        return new $.Rect(
	            minX,
	            minY,
	            maxX - minX,
	            maxY - minY);
	    },
	
	    /**
	     * Retrieves the smallest horizontal (degrees=0) rectangle which contains
	     * this rectangle and has integers x, y, width and height
	     * @returns {OpenSeadragon.Rect}
	     */
	    getIntegerBoundingBox: function() {
	        var boundingBox = this.getBoundingBox();
	        var x = Math.floor(boundingBox.x);
	        var y = Math.floor(boundingBox.y);
	        var width = Math.ceil(boundingBox.width + boundingBox.x - x);
	        var height = Math.ceil(boundingBox.height + boundingBox.y - y);
	        return new $.Rect(x, y, width, height);
	    },
	
	    /**
	     * Determines whether a point is inside this rectangle (edge included).
	     * @function
	     * @param {OpenSeadragon.Point} point
	     * @param {Number} [epsilon=0] the margin of error allowed
	     * @returns {Boolean} true if the point is inside this rectangle, false
	     * otherwise.
	     */
	    containsPoint: function(point, epsilon) {
	        epsilon = epsilon || 0;
	
	        // See http://stackoverflow.com/a/2752754/1440403 for explanation
	        var topLeft = this.getTopLeft();
	        var topRight = this.getTopRight();
	        var bottomLeft = this.getBottomLeft();
	        var topDiff = topRight.minus(topLeft);
	        var leftDiff = bottomLeft.minus(topLeft);
	
	        return ((point.x - topLeft.x) * topDiff.x +
	            (point.y - topLeft.y) * topDiff.y >= -epsilon) &&
	
	            ((point.x - topRight.x) * topDiff.x +
	            (point.y - topRight.y) * topDiff.y <= epsilon) &&
	
	            ((point.x - topLeft.x) * leftDiff.x +
	            (point.y - topLeft.y) * leftDiff.y >= -epsilon) &&
	
	            ((point.x - bottomLeft.x) * leftDiff.x +
	            (point.y - bottomLeft.y) * leftDiff.y <= epsilon);
	    },
	
	    /**
	     * Provides a string representation of the rectangle which is useful for
	     * debugging.
	     * @function
	     * @returns {String} A string representation of the rectangle.
	     */
	    toString: function() {
	        return "[" +
	            (Math.round(this.x * 100) / 100) + ", " +
	            (Math.round(this.y * 100) / 100) + ", " +
	            (Math.round(this.width * 100) / 100) + "x" +
	            (Math.round(this.height * 100) / 100) + ", " +
	            (Math.round(this.degrees * 100) / 100) + "deg" +
	            "]";
	    }
	};
	
	
	}(OpenSeadragon));
	
	/*
	 * OpenSeadragon - ReferenceStrip
	 *
	 * Copyright (C) 2009 CodePlex Foundation
	 * Copyright (C) 2010-2013 OpenSeadragon contributors
	 *
	 * Redistribution and use in source and binary forms, with or without
	 * modification, are permitted provided that the following conditions are
	 * met:
	 *
	 * - Redistributions of source code must retain the above copyright notice,
	 *   this list of conditions and the following disclaimer.
	 *
	 * - Redistributions in binary form must reproduce the above copyright
	 *   notice, this list of conditions and the following disclaimer in the
	 *   documentation and/or other materials provided with the distribution.
	 *
	 * - Neither the name of CodePlex Foundation nor the names of its
	 *   contributors may be used to endorse or promote products derived from
	 *   this software without specific prior written permission.
	 *
	 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
	 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
	 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
	 * A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT
	 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
	 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
	 * TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 * PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
	 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
	 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
	 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	 */
	
	(function ( $ ) {
	
	// dictionary from id to private properties
	var THIS = {};
	
	/**
	 *  The CollectionDrawer is a reimplementation if the Drawer API that
	 *  focuses on allowing a viewport to be redefined as a collection
	 *  of smaller viewports, defined by a clear number of rows and / or
	 *  columns of which each item in the matrix of viewports has its own
	 *  source.
	 *
	 *  This idea is a reexpression of the idea of dzi collections
	 *  which allows a clearer algorithm to reuse the tile sources already
	 *  supported by OpenSeadragon, in heterogenious or homogenious
	 *  sequences just like mixed groups already supported by the viewer
	 *  for the purpose of image sequnces.
	 *
	 *  TODO:   The difficult part of this feature is figuring out how to express
	 *          this functionality as a combination of the functionality already
	 *          provided by Drawer, Viewport, TileSource, and Navigator.  It may
	 *          require better abstraction at those points in order to effeciently
	 *          reuse those paradigms.
	 */
	/**
	 * @class ReferenceStrip
	 * @memberof OpenSeadragon
	 * @param {Object} options
	 */
	$.ReferenceStrip = function ( options ) {
	
	    var _this       = this,
	        viewer      = options.viewer,
	        viewerSize  = $.getElementSize( viewer.element ),
	        element,
	        style,
	        i;
	
	    //We may need to create a new element and id if they did not
	    //provide the id for the existing element
	    if ( !options.id ) {
	        options.id              = 'referencestrip-' + $.now();
	        this.element            = $.makeNeutralElement( "div" );
	        this.element.id         = options.id;
	        this.element.className  = 'referencestrip';
	    }
	
	    options = $.extend( true, {
	        sizeRatio:  $.DEFAULT_SETTINGS.referenceStripSizeRatio,
	        position:   $.DEFAULT_SETTINGS.referenceStripPosition,
	        scroll:     $.DEFAULT_SETTINGS.referenceStripScroll,
	        clickTimeThreshold:  $.DEFAULT_SETTINGS.clickTimeThreshold
	    }, options, {
	        //required overrides
	        element:                this.element,
	        //These need to be overridden to prevent recursion since
	        //the navigator is a viewer and a viewer has a navigator
	        showNavigator:          false,
	        mouseNavEnabled:        false,
	        showNavigationControl:  false,
	        showSequenceControl:    false
	    } );
	
	    $.extend( this, options );
	    //Private state properties
	    THIS[this.id] = {
	        "animating":           false
	    };
	
	    this.minPixelRatio = this.viewer.minPixelRatio;
	
	    style = this.element.style;
	    style.marginTop     = '0px';
	    style.marginRight   = '0px';
	    style.marginBottom  = '0px';
	    style.marginLeft    = '0px';
	    style.left          = '0px';
	    style.bottom        = '0px';
	    style.border        = '0px';
	    style.background    = '#000';
	    style.position      = 'relative';
	
	    $.setElementTouchActionNone( this.element );
	
	    $.setElementOpacity( this.element, 0.8 );
	
	    this.viewer = viewer;
	    this.innerTracker = new $.MouseTracker( {
	        element:        this.element,
	        dragHandler:    $.delegate( this, onStripDrag ),
	        scrollHandler:  $.delegate( this, onStripScroll ),
	        enterHandler:   $.delegate( this, onStripEnter ),
	        exitHandler:    $.delegate( this, onStripExit ),
	        keyDownHandler: $.delegate( this, onKeyDown ),
	        keyHandler:     $.delegate( this, onKeyPress )
	    } );
	
	    //Controls the position and orientation of the reference strip and sets the
	    //appropriate width and height
	    if ( options.width && options.height ) {
	        this.element.style.width  = options.width + 'px';
	        this.element.style.height = options.height + 'px';
	        viewer.addControl(
	            this.element,
	            { anchor: $.ControlAnchor.BOTTOM_LEFT }
	        );
	    } else {
	        if ( "horizontal" == options.scroll ) {
	            this.element.style.width = (
	                viewerSize.x *
	                options.sizeRatio *
	                viewer.tileSources.length
	            ) + ( 12 * viewer.tileSources.length ) + 'px';
	
	            this.element.style.height = (
	                viewerSize.y *
	                options.sizeRatio
	            ) + 'px';
	
	            viewer.addControl(
	                this.element,
	                { anchor: $.ControlAnchor.BOTTOM_LEFT }
	            );
	        } else {
	            this.element.style.height = (
	                viewerSize.y *
	                options.sizeRatio *
	                viewer.tileSources.length
	            ) + ( 12 * viewer.tileSources.length ) + 'px';
	
	            this.element.style.width = (
	                viewerSize.x *
	                options.sizeRatio
	            ) + 'px';
	
	            viewer.addControl(
	                this.element,
	                { anchor: $.ControlAnchor.TOP_LEFT }
	            );
	
	        }
	    }
	
	    this.panelWidth = ( viewerSize.x * this.sizeRatio ) + 8;
	    this.panelHeight = ( viewerSize.y * this.sizeRatio ) + 8;
	    this.panels = [];
	    this.miniViewers = {};
	
	    /*jshint loopfunc:true*/
	    for ( i = 0; i < viewer.tileSources.length; i++ ) {
	
	        element = $.makeNeutralElement( 'div' );
	        element.id = this.element.id + "-" + i;
	
	        element.style.width         = _this.panelWidth + 'px';
	        element.style.height        = _this.panelHeight + 'px';
	        element.style.display       = 'inline';
	        element.style.float         = 'left'; //Webkit
	        element.style.cssFloat      = 'left'; //Firefox
	        element.style.styleFloat    = 'left'; //IE
	        element.style.padding       = '2px';
	        $.setElementTouchActionNone( element );
	
	        element.innerTracker = new $.MouseTracker( {
	            element:            element,
	            clickTimeThreshold: this.clickTimeThreshold,
	            clickDistThreshold: this.clickDistThreshold,
	            pressHandler: function ( event ) {
	                event.eventSource.dragging = $.now();
	            },
	            releaseHandler: function ( event ) {
	                var tracker = event.eventSource,
	                    id      = tracker.element.id,
	                    page    = Number( id.split( '-' )[2] ),
	                    now     = $.now();
	
	                if ( event.insideElementPressed &&
	                     event.insideElementReleased &&
	                     tracker.dragging &&
	                     ( now - tracker.dragging ) < tracker.clickTimeThreshold ) {
	                    tracker.dragging = null;
	                    viewer.goToPage( page );
	                }
	            }
	        } );
	
	        this.element.appendChild( element );
	
	        element.activePanel = false;
	
	        this.panels.push( element );
	
	    }
	    loadPanels( this, this.scroll == 'vertical' ? viewerSize.y : viewerSize.x, 0 );
	    this.setFocus( 0 );
	
	};
	
	$.extend( $.ReferenceStrip.prototype, $.EventSource.prototype, $.Viewer.prototype, /** @lends OpenSeadragon.ReferenceStrip.prototype */{
	
	    /**
	     * @function
	     */
	    setFocus: function ( page ) {
	        var element      = $.getElement( this.element.id + '-' + page ),
	            viewerSize   = $.getElementSize( this.viewer.canvas ),
	            scrollWidth  = Number( this.element.style.width.replace( 'px', '' ) ),
	            scrollHeight = Number( this.element.style.height.replace( 'px', '' ) ),
	            offsetLeft   = -Number( this.element.style.marginLeft.replace( 'px', '' ) ),
	            offsetTop    = -Number( this.element.style.marginTop.replace( 'px', '' ) ),
	            offset;
	
	        if ( this.currentSelected !== element ) {
	            if ( this.currentSelected ) {
	                this.currentSelected.style.background = '#000';
	            }
	            this.currentSelected = element;
	            this.currentSelected.style.background = '#999';
	
	            if ( 'horizontal' == this.scroll ) {
	                //right left
	                offset = ( Number( page ) ) * ( this.panelWidth + 3 );
	                if ( offset > offsetLeft + viewerSize.x - this.panelWidth ) {
	                    offset = Math.min( offset, ( scrollWidth - viewerSize.x ) );
	                    this.element.style.marginLeft = -offset + 'px';
	                    loadPanels( this, viewerSize.x, -offset );
	                } else if ( offset < offsetLeft ) {
	                    offset = Math.max( 0, offset - viewerSize.x / 2 );
	                    this.element.style.marginLeft = -offset + 'px';
	                    loadPanels( this, viewerSize.x, -offset );
	                }
	            } else {
	                offset = ( Number( page ) ) * ( this.panelHeight + 3 );
	                if ( offset > offsetTop + viewerSize.y - this.panelHeight ) {
	                    offset = Math.min( offset, ( scrollHeight - viewerSize.y ) );
	                    this.element.style.marginTop = -offset + 'px';
	                    loadPanels( this, viewerSize.y, -offset );
	                } else if ( offset < offsetTop ) {
	                    offset = Math.max( 0, offset - viewerSize.y / 2 );
	                    this.element.style.marginTop = -offset + 'px';
	                    loadPanels( this, viewerSize.y, -offset );
	                }
	            }
	
	            this.currentPage = page;
	            onStripEnter.call( this, { eventSource: this.innerTracker } );
	        }
	    },
	
	    /**
	     * @function
	     */
	    update: function () {
	        if ( THIS[this.id].animating ) {
	            $.console.log( 'image reference strip update' );
	            return true;
	        }
	        return false;
	    },
	
	    // Overrides Viewer.destroy
	    destroy: function() {
	        if (this.miniViewers) {
	          for (var key in this.miniViewers) {
	            this.miniViewers[key].destroy();
	          }
	        }
	
	        if (this.element) {
	            this.element.parentNode.removeChild(this.element);
	        }
	    }
	
	} );
	
	
	
	
	/**
	 * @private
	 * @inner
	 * @function
	 */
	function onStripDrag( event ) {
	
	    var offsetLeft   = Number( this.element.style.marginLeft.replace( 'px', '' ) ),
	        offsetTop    = Number( this.element.style.marginTop.replace( 'px', '' ) ),
	        scrollWidth  = Number( this.element.style.width.replace( 'px', '' ) ),
	        scrollHeight = Number( this.element.style.height.replace( 'px', '' ) ),
	        viewerSize   = $.getElementSize( this.viewer.canvas );
	    this.dragging = true;
	    if ( this.element ) {
	        if ( 'horizontal' == this.scroll ) {
	            if ( -event.delta.x > 0 ) {
	                //forward
	                if ( offsetLeft > -( scrollWidth - viewerSize.x ) ) {
	                    this.element.style.marginLeft = ( offsetLeft + ( event.delta.x * 2 ) ) + 'px';
	                    loadPanels( this, viewerSize.x, offsetLeft + ( event.delta.x * 2 ) );
	                }
	            } else if ( -event.delta.x < 0 ) {
	                //reverse
	                if ( offsetLeft < 0 ) {
	                    this.element.style.marginLeft = ( offsetLeft + ( event.delta.x * 2 ) ) + 'px';
	                    loadPanels( this, viewerSize.x, offsetLeft + ( event.delta.x * 2 ) );
	                }
	            }
	        } else {
	            if ( -event.delta.y > 0 ) {
	                //forward
	                if ( offsetTop > -( scrollHeight - viewerSize.y ) ) {
	                    this.element.style.marginTop = ( offsetTop + ( event.delta.y * 2 ) ) + 'px';
	                    loadPanels( this, viewerSize.y, offsetTop + ( event.delta.y * 2 ) );
	                }
	            } else if ( -event.delta.y < 0 ) {
	                //reverse
	                if ( offsetTop < 0 ) {
	                    this.element.style.marginTop = ( offsetTop + ( event.delta.y * 2 ) ) + 'px';
	                    loadPanels( this, viewerSize.y, offsetTop + ( event.delta.y * 2 ) );
	                }
	            }
	        }
	    }
	    return false;
	
	}
	
	
	
	/**
	 * @private
	 * @inner
	 * @function
	 */
	function onStripScroll( event ) {
	    var offsetLeft   = Number( this.element.style.marginLeft.replace( 'px', '' ) ),
	        offsetTop    = Number( this.element.style.marginTop.replace( 'px', '' ) ),
	        scrollWidth  = Number( this.element.style.width.replace( 'px', '' ) ),
	        scrollHeight = Number( this.element.style.height.replace( 'px', '' ) ),
	        viewerSize   = $.getElementSize( this.viewer.canvas );
	    if ( this.element ) {
	        if ( 'horizontal' == this.scroll ) {
	            if ( event.scroll > 0 ) {
	                //forward
	                if ( offsetLeft > -( scrollWidth - viewerSize.x ) ) {
	                    this.element.style.marginLeft = ( offsetLeft - ( event.scroll * 60 ) ) + 'px';
	                    loadPanels( this, viewerSize.x, offsetLeft - ( event.scroll * 60 ) );
	                }
	            } else if ( event.scroll < 0 ) {
	                //reverse
	                if ( offsetLeft < 0 ) {
	                    this.element.style.marginLeft = ( offsetLeft - ( event.scroll * 60 ) ) + 'px';
	                    loadPanels( this, viewerSize.x, offsetLeft - ( event.scroll * 60 ) );
	                }
	            }
	        } else {
	            if ( event.scroll < 0 ) {
	                //scroll up
	                if ( offsetTop > viewerSize.y - scrollHeight ) {
	                    this.element.style.marginTop = ( offsetTop + ( event.scroll * 60 ) ) + 'px';
	                    loadPanels( this, viewerSize.y, offsetTop + ( event.scroll * 60 ) );
	                }
	            } else if ( event.scroll > 0 ) {
	                //scroll dowm
	                if ( offsetTop < 0 ) {
	                    this.element.style.marginTop = ( offsetTop + ( event.scroll * 60 ) ) + 'px';
	                    loadPanels( this, viewerSize.y, offsetTop + ( event.scroll * 60 ) );
	                }
	            }
	        }
	    }
	    //cancels event
	    return false;
	}
	
	
	function loadPanels( strip, viewerSize, scroll ) {
	    var panelSize,
	        activePanelsStart,
	        activePanelsEnd,
	        miniViewer,
	        style,
	        i,
	        element;
	    if ( 'horizontal' == strip.scroll ) {
	        panelSize = strip.panelWidth;
	    } else {
	        panelSize = strip.panelHeight;
	    }
	    activePanelsStart = Math.ceil( viewerSize / panelSize ) + 5;
	    activePanelsEnd = Math.ceil( ( Math.abs( scroll ) + viewerSize ) / panelSize ) + 1;
	    activePanelsStart = activePanelsEnd - activePanelsStart;
	    activePanelsStart = activePanelsStart < 0 ? 0 : activePanelsStart;
	
	    for ( i = activePanelsStart; i < activePanelsEnd && i < strip.panels.length; i++ ) {
	        element = strip.panels[i];
	        if ( !element.activePanel ) {
	            var miniTileSource;
	            var originalTileSource = strip.viewer.tileSources[i];
	            if (originalTileSource.referenceStripThumbnailUrl) {
	                miniTileSource = {
	                    type: 'image',
	                    url: originalTileSource.referenceStripThumbnailUrl
	                };
	            } else {
	                miniTileSource = originalTileSource;
	            }
	            miniViewer = new $.Viewer( {
	                id:                     element.id,
	                tileSources:            [miniTileSource],
	                element:                element,
	                navigatorSizeRatio:     strip.sizeRatio,
	                showNavigator:          false,
	                mouseNavEnabled:        false,
	                showNavigationControl:  false,
	                showSequenceControl:    false,
	                immediateRender:        true,
	                blendTime:              0,
	                animationTime:          0
	            } );
	
	            miniViewer.displayRegion           = $.makeNeutralElement( "div" );
	            miniViewer.displayRegion.id        = element.id + '-displayregion';
	            miniViewer.displayRegion.className = 'displayregion';
	
	            style               = miniViewer.displayRegion.style;
	            style.position      = 'relative';
	            style.top           = '0px';
	            style.left          = '0px';
	            style.fontSize      = '0px';
	            style.overflow      = 'hidden';
	            style.float         = 'left'; //Webkit
	            style.cssFloat      = 'left'; //Firefox
	            style.styleFloat    = 'left'; //IE
	            style.zIndex        = 999999999;
	            style.cursor        = 'default';
	            style.width         = ( strip.panelWidth - 4 ) + 'px';
	            style.height        = ( strip.panelHeight - 4 ) + 'px';
	
	            // TODO: What is this for? Future keyboard navigation support?
	            miniViewer.displayRegion.innerTracker = new $.MouseTracker( {
	                element: miniViewer.displayRegion,
	                startDisabled: true
	            } );
	
	            element.getElementsByTagName( 'div' )[0].appendChild(
	                miniViewer.displayRegion
	            );
	
	            strip.miniViewers[element.id] = miniViewer;
	
	            element.activePanel = true;
	        }
	    }
	}
	
	
	/**
	 * @private
	 * @inner
	 * @function
	 */
	function onStripEnter( event ) {
	    var element = event.eventSource.element;
	
	    //$.setElementOpacity(element, 0.8);
	
	    //element.style.border = '1px solid #555';
	    //element.style.background = '#000';
	
	    if ( 'horizontal' == this.scroll ) {
	
	        //element.style.paddingTop = "0px";
	        element.style.marginBottom = "0px";
	
	    } else {
	
	        //element.style.paddingRight = "0px";
	        element.style.marginLeft = "0px";
	
	    }
	    return false;
	}
	
	
	/**
	 * @private
	 * @inner
	 * @function
	 */
	function onStripExit( event ) {
	    var element = event.eventSource.element;
	
	    if ( 'horizontal' == this.scroll ) {
	
	        //element.style.paddingTop = "10px";
	        element.style.marginBottom = "-" + ( $.getElementSize( element ).y / 2 ) + "px";
	
	    } else {
	
	        //element.style.paddingRight = "10px";
	        element.style.marginLeft = "-" + ( $.getElementSize( element ).x / 2 ) + "px";
	
	    }
	    return false;
	}
	
	
	/**
	 * @private
	 * @inner
	 * @function
	 */
	function onKeyDown( event ) {
	    //console.log( event.keyCode );
	
	    if ( !event.preventDefaultAction && !event.ctrl && !event.alt && !event.meta ) {
	        switch ( event.keyCode ) {
	            case 38: //up arrow
	                onStripScroll.call( this, { eventSource: this.tracker, position: null, scroll: 1, shift: null } );
	                return false;
	            case 40: //down arrow
	                onStripScroll.call( this, { eventSource: this.tracker, position: null, scroll: -1, shift: null } );
	                return false;
	            case 37: //left arrow
	                onStripScroll.call( this, { eventSource: this.tracker, position: null, scroll: -1, shift: null } );
	                return false;
	            case 39: //right arrow
	                onStripScroll.call( this, { eventSource: this.tracker, position: null, scroll: 1, shift: null } );
	                return false;
	            default:
	                //console.log( 'navigator keycode %s', event.keyCode );
	                return true;
	        }
	    } else {
	        return true;
	    }
	}
	
	
	/**
	 * @private
	 * @inner
	 * @function
	 */
	function onKeyPress( event ) {
	    //console.log( event.keyCode );
	
	    if ( !event.preventDefaultAction && !event.ctrl && !event.alt && !event.meta ) {
	        switch ( event.keyCode ) {
	            case 61: //=|+
	                onStripScroll.call( this, { eventSource: this.tracker, position: null, scroll: 1, shift: null } );
	                return false;
	            case 45: //-|_
	                onStripScroll.call( this, { eventSource: this.tracker, position: null, scroll: -1, shift: null } );
	                return false;
	            case 48: //0|)
	            case 119: //w
	            case 87: //W
	                onStripScroll.call( this, { eventSource: this.tracker, position: null, scroll: 1, shift: null } );
	                return false;
	            case 115: //s
	            case 83: //S
	                onStripScroll.call( this, { eventSource: this.tracker, position: null, scroll: -1, shift: null } );
	                return false;
	            case 97: //a
	                onStripScroll.call( this, { eventSource: this.tracker, position: null, scroll: -1, shift: null } );
	                return false;
	            case 100: //d
	                onStripScroll.call( this, { eventSource: this.tracker, position: null, scroll: 1, shift: null } );
	                return false;
	            default:
	                //console.log( 'navigator keycode %s', event.keyCode );
	                return true;
	        }
	    } else {
	        return true;
	    }
	}
	
	}(OpenSeadragon));
	
	/*
	 * OpenSeadragon - DisplayRect
	 *
	 * Copyright (C) 2009 CodePlex Foundation
	 * Copyright (C) 2010-2013 OpenSeadragon contributors
	 *
	 * Redistribution and use in source and binary forms, with or without
	 * modification, are permitted provided that the following conditions are
	 * met:
	 *
	 * - Redistributions of source code must retain the above copyright notice,
	 *   this list of conditions and the following disclaimer.
	 *
	 * - Redistributions in binary form must reproduce the above copyright
	 *   notice, this list of conditions and the following disclaimer in the
	 *   documentation and/or other materials provided with the distribution.
	 *
	 * - Neither the name of CodePlex Foundation nor the names of its
	 *   contributors may be used to endorse or promote products derived from
	 *   this software without specific prior written permission.
	 *
	 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
	 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
	 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
	 * A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT
	 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
	 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
	 * TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 * PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
	 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
	 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
	 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	 */
	
	(function( $ ){
	
	/**
	 * @class DisplayRect
	 * @classdesc A display rectangle is very similar to {@link OpenSeadragon.Rect} but adds two
	 * fields, 'minLevel' and 'maxLevel' which denote the supported zoom levels
	 * for this rectangle.
	 *
	 * @memberof OpenSeadragon
	 * @extends OpenSeadragon.Rect
	 * @param {Number} x The vector component 'x'.
	 * @param {Number} y The vector component 'y'.
	 * @param {Number} width The vector component 'height'.
	 * @param {Number} height The vector component 'width'.
	 * @param {Number} minLevel The lowest zoom level supported.
	 * @param {Number} maxLevel The highest zoom level supported.
	 */
	$.DisplayRect = function( x, y, width, height, minLevel, maxLevel ) {
	    $.Rect.apply( this, [ x, y, width, height ] );
	
	    /**
	     * The lowest zoom level supported.
	     * @member {Number} minLevel
	     * @memberof OpenSeadragon.DisplayRect#
	     */
	    this.minLevel = minLevel;
	    /**
	     * The highest zoom level supported.
	     * @member {Number} maxLevel
	     * @memberof OpenSeadragon.DisplayRect#
	     */
	    this.maxLevel = maxLevel;
	};
	
	$.extend( $.DisplayRect.prototype, $.Rect.prototype );
	
	}( OpenSeadragon ));
	
	/*
	 * OpenSeadragon - Spring
	 *
	 * Copyright (C) 2009 CodePlex Foundation
	 * Copyright (C) 2010-2013 OpenSeadragon contributors
	 *
	 * Redistribution and use in source and binary forms, with or without
	 * modification, are permitted provided that the following conditions are
	 * met:
	 *
	 * - Redistributions of source code must retain the above copyright notice,
	 *   this list of conditions and the following disclaimer.
	 *
	 * - Redistributions in binary form must reproduce the above copyright
	 *   notice, this list of conditions and the following disclaimer in the
	 *   documentation and/or other materials provided with the distribution.
	 *
	 * - Neither the name of CodePlex Foundation nor the names of its
	 *   contributors may be used to endorse or promote products derived from
	 *   this software without specific prior written permission.
	 *
	 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
	 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
	 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
	 * A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT
	 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
	 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
	 * TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 * PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
	 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
	 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
	 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	 */
	
	(function( $ ){
	
	/**
	 * @class Spring
	 * @memberof OpenSeadragon
	 * @param {Object} options - Spring configuration settings.
	 * @param {Number} options.springStiffness - Spring stiffness. Must be greater than zero.
	 * The closer to zero, the closer to linear animation.
	 * @param {Number} options.animationTime - Animation duration per spring, in seconds.
	 * Must be zero or greater.
	 * @param {Number} [options.initial=0] - Initial value of spring.
	 * @param {Boolean} [options.exponential=false] - Whether this spring represents
	 * an exponential scale (such as zoom) and should be animated accordingly. Note that
	 * exponential springs must have non-zero values.
	 */
	$.Spring = function( options ) {
	    var args = arguments;
	
	    if( typeof ( options ) != 'object' ){
	        //allows backward compatible use of ( initialValue, config ) as
	        //constructor parameters
	        options = {
	            initial: args.length && typeof ( args[ 0 ] ) == "number" ?
	                args[ 0 ] :
	                undefined,
	            /**
	             * Spring stiffness.
	             * @member {Number} springStiffness
	             * @memberof OpenSeadragon.Spring#
	             */
	            springStiffness: args.length > 1 ?
	                args[ 1 ].springStiffness :
	                5.0,
	            /**
	             * Animation duration per spring.
	             * @member {Number} animationTime
	             * @memberof OpenSeadragon.Spring#
	             */
	            animationTime: args.length > 1 ?
	                args[ 1 ].animationTime :
	                1.5
	        };
	    }
	
	    $.console.assert(typeof options.springStiffness === "number" && options.springStiffness !== 0,
	        "[OpenSeadragon.Spring] options.springStiffness must be a non-zero number");
	
	    $.console.assert(typeof options.animationTime === "number" && options.animationTime >= 0,
	        "[OpenSeadragon.Spring] options.animationTime must be a number greater than or equal to 0");
	
	    if (options.exponential) {
	        this._exponential = true;
	        delete options.exponential;
	    }
	
	    $.extend( true, this, options);
	
	    /**
	     * @member {Object} current
	     * @memberof OpenSeadragon.Spring#
	     * @property {Number} value
	     * @property {Number} time
	     */
	    this.current = {
	        value: typeof ( this.initial ) == "number" ?
	            this.initial :
	            (this._exponential ? 0 : 1),
	        time:  $.now() // always work in milliseconds
	    };
	
	    $.console.assert(!this._exponential || this.current.value !== 0,
	        "[OpenSeadragon.Spring] value must be non-zero for exponential springs");
	
	    /**
	     * @member {Object} start
	     * @memberof OpenSeadragon.Spring#
	     * @property {Number} value
	     * @property {Number} time
	     */
	    this.start = {
	        value: this.current.value,
	        time:  this.current.time
	    };
	
	    /**
	     * @member {Object} target
	     * @memberof OpenSeadragon.Spring#
	     * @property {Number} value
	     * @property {Number} time
	     */
	    this.target = {
	        value: this.current.value,
	        time:  this.current.time
	    };
	
	    if (this._exponential) {
	        this.start._logValue = Math.log(this.start.value);
	        this.target._logValue = Math.log(this.target.value);
	        this.current._logValue = Math.log(this.current.value);
	    }
	};
	
	/** @lends OpenSeadragon.Spring.prototype */
	$.Spring.prototype = {
	
	    /**
	     * @function
	     * @param {Number} target
	     */
	    resetTo: function( target ) {
	        $.console.assert(!this._exponential || target !== 0,
	            "[OpenSeadragon.Spring.resetTo] target must be non-zero for exponential springs");
	
	        this.start.value = this.target.value = this.current.value = target;
	        this.start.time = this.target.time = this.current.time = $.now();
	
	        if (this._exponential) {
	            this.start._logValue = Math.log(this.start.value);
	            this.target._logValue = Math.log(this.target.value);
	            this.current._logValue = Math.log(this.current.value);
	        }
	    },
	
	    /**
	     * @function
	     * @param {Number} target
	     */
	    springTo: function( target ) {
	        $.console.assert(!this._exponential || target !== 0,
	            "[OpenSeadragon.Spring.springTo] target must be non-zero for exponential springs");
	
	        this.start.value  = this.current.value;
	        this.start.time   = this.current.time;
	        this.target.value = target;
	        this.target.time  = this.start.time + 1000 * this.animationTime;
	
	        if (this._exponential) {
	            this.start._logValue = Math.log(this.start.value);
	            this.target._logValue = Math.log(this.target.value);
	        }
	    },
	
	    /**
	     * @function
	     * @param {Number} delta
	     */
	    shiftBy: function( delta ) {
	        this.start.value  += delta;
	        this.target.value += delta;
	
	        if (this._exponential) {
	            $.console.assert(this.target.value !== 0 && this.start.value !== 0,
	                "[OpenSeadragon.Spring.shiftBy] spring value must be non-zero for exponential springs");
	
	            this.start._logValue = Math.log(this.start.value);
	            this.target._logValue = Math.log(this.target.value);
	        }
	    },
	
	    setExponential: function(value) {
	        this._exponential = value;
	
	        if (this._exponential) {
	            $.console.assert(this.current.value !== 0 && this.target.value !== 0 && this.start.value !== 0,
	                "[OpenSeadragon.Spring.setExponential] spring value must be non-zero for exponential springs");
	
	            this.start._logValue = Math.log(this.start.value);
	            this.target._logValue = Math.log(this.target.value);
	            this.current._logValue = Math.log(this.current.value);
	        }
	    },
	
	    /**
	     * @function
	     * @returns true if the value got updated, false otherwise
	     */
	    update: function() {
	        this.current.time  = $.now();
	
	        var startValue, targetValue;
	        if (this._exponential) {
	            startValue = this.start._logValue;
	            targetValue = this.target._logValue;
	        } else {
	            startValue = this.start.value;
	            targetValue = this.target.value;
	        }
	
	        var currentValue = (this.current.time >= this.target.time) ?
	            targetValue :
	            startValue +
	                ( targetValue - startValue ) *
	                transform(
	                    this.springStiffness,
	                    ( this.current.time - this.start.time ) /
	                    ( this.target.time - this.start.time )
	                );
	
	        var oldValue = this.current.value;
	        if (this._exponential) {
	            this.current.value = Math.exp(currentValue);
	        } else {
	            this.current.value = currentValue;
	        }
	
	        return oldValue != this.current.value;
	    },
	
	    /**
	     * Returns whether the spring is at the target value
	     * @function
	     * @returns {Boolean} True if at target value, false otherwise
	     */
	    isAtTargetValue: function() {
	        return this.current.value === this.target.value;
	    }
	};
	
	/**
	 * @private
	 */
	function transform( stiffness, x ) {
	    return ( 1.0 - Math.exp( stiffness * -x ) ) /
	        ( 1.0 - Math.exp( -stiffness ) );
	}
	
	}( OpenSeadragon ));
	
	/*
	 * OpenSeadragon - ImageLoader
	 *
	 * Copyright (C) 2009 CodePlex Foundation
	 * Copyright (C) 2010-2013 OpenSeadragon contributors
	
	 * Redistribution and use in source and binary forms, with or without
	 * modification, are permitted provided that the following conditions are
	 * met:
	 *
	 * - Redistributions of source code must retain the above copyright notice,
	 *   this list of conditions and the following disclaimer.
	 *
	 * - Redistributions in binary form must reproduce the above copyright
	 *   notice, this list of conditions and the following disclaimer in the
	 *   documentation and/or other materials provided with the distribution.
	 *
	 * - Neither the name of CodePlex Foundation nor the names of its
	 *   contributors may be used to endorse or promote products derived from
	 *   this software without specific prior written permission.
	 *
	 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
	 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
	 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
	 * A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT
	 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
	 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
	 * TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 * PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
	 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
	 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
	 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	 */
	
	(function($){
	
	/**
	 * @private
	 * @class ImageJob
	 * @classdesc Handles downloading of a single image.
	 * @param {Object} options - Options for this ImageJob.
	 * @param {String} [options.src] - URL of image to download.
	 * @param {String} [options.loadWithAjax] - Whether to load this image with AJAX.
	 * @param {String} [options.ajaxHeaders] - Headers to add to the image request if using AJAX.
	 * @param {String} [options.crossOriginPolicy] - CORS policy to use for downloads
	 * @param {Function} [options.callback] - Called once image has been downloaded.
	 * @param {Function} [options.abort] - Called when this image job is aborted.
	 * @param {Number} [options.timeout] - The max number of milliseconds that this image job may take to complete.
	 */
	function ImageJob (options) {
	
	    $.extend(true, this, {
	        timeout: $.DEFAULT_SETTINGS.timeout,
	        jobId: null
	    }, options);
	
	    /**
	     * Image object which will contain downloaded image.
	     * @member {Image} image
	     * @memberof OpenSeadragon.ImageJob#
	     */
	    this.image = null;
	}
	
	ImageJob.prototype = {
	    errorMsg: null,
	
	    /**
	     * Starts the image job.
	     * @method
	     */
	    start: function(){
	        var self = this;
	        var selfAbort = this.abort;
	
	        this.image = new Image();
	
	        this.image.onload = function(){
	            self.finish(true);
	        };
	        this.image.onabort = this.image.onerror = function() {
	            self.errorMsg = "Image load aborted";
	            self.finish(false);
	        };
	
	        this.jobId = window.setTimeout(function(){
	            self.errorMsg = "Image load exceeded timeout";
	            self.finish(false);
	        }, this.timeout);
	
	        // Load the tile with an AJAX request if the loadWithAjax option is
	        // set. Otherwise load the image by setting the source proprety of the image object.
	        if (this.loadWithAjax) {
	            this.request = $.makeAjaxRequest({
	                url: this.src,
	                withCredentials: this.ajaxWithCredentials,
	                headers: this.ajaxHeaders,
	                responseType: "arraybuffer",
	                success: function(request) {
	                    var blb;
	                    // Make the raw data into a blob.
	                    // BlobBuilder fallback adapted from
	                    // http://stackoverflow.com/questions/15293694/blob-constructor-browser-compatibility
	                    try {
	                        blb = new window.Blob([request.response]);
	                    } catch (e) {
	                        var BlobBuilder = (
	                            window.BlobBuilder ||
	                            window.WebKitBlobBuilder ||
	                            window.MozBlobBuilder ||
	                            window.MSBlobBuilder
	                        );
	                        if (e.name === 'TypeError' && BlobBuilder) {
	                            var bb = new BlobBuilder();
	                            bb.append(request.response);
	                            blb = bb.getBlob();
	                        }
	                    }
	                    // If the blob is empty for some reason consider the image load a failure.
	                    if (blb.size === 0) {
	                        self.errorMsg = "Empty image response.";
	                        self.finish(false);
	                    }
	                    // Create a URL for the blob data and make it the source of the image object.
	                    // This will still trigger Image.onload to indicate a successful tile load.
	                    var url = (window.URL || window.webkitURL).createObjectURL(blb);
	                    self.image.src = url;
	                },
	                error: function(request) {
	                    self.errorMsg = "Image load aborted - XHR error";
	                    self.finish(false);
	                }
	            });
	
	            // Provide a function to properly abort the request.
	            this.abort = function() {
	                self.request.abort();
	
	                // Call the existing abort function if available
	                if (typeof selfAbort === "function") {
	                    selfAbort();
	                }
	            };
	        } else {
	            if (this.crossOriginPolicy !== false) {
	                this.image.crossOrigin = this.crossOriginPolicy;
	            }
	
	            this.image.src = this.src;
	        }
	    },
	
	    finish: function(successful) {
	        this.image.onload = this.image.onerror = this.image.onabort = null;
	        if (!successful) {
	            this.image = null;
	        }
	
	        if (this.jobId) {
	            window.clearTimeout(this.jobId);
	        }
	
	        this.callback(this);
	    }
	
	};
	
	/**
	 * @class ImageLoader
	 * @memberof OpenSeadragon
	 * @classdesc Handles downloading of a set of images using asynchronous queue pattern.
	 * You generally won't have to interact with the ImageLoader directly.
	 * @param {Object} options - Options for this ImageLoader.
	 * @param {Number} [options.jobLimit] - The number of concurrent image requests. See imageLoaderLimit in {@link OpenSeadragon.Options} for details.
	 * @param {Number} [options.timeout] - The max number of milliseconds that an image job may take to complete.
	 */
	$.ImageLoader = function(options) {
	
	    $.extend(true, this, {
	        jobLimit:       $.DEFAULT_SETTINGS.imageLoaderLimit,
	        timeout:        $.DEFAULT_SETTINGS.timeout,
	        jobQueue:       [],
	        jobsInProgress: 0
	    }, options);
	
	};
	
	/** @lends OpenSeadragon.ImageLoader.prototype */
	$.ImageLoader.prototype = {
	
	    /**
	     * Add an unloaded image to the loader queue.
	     * @method
	     * @param {Object} options - Options for this job.
	     * @param {String} [options.src] - URL of image to download.
	     * @param {String} [options.loadWithAjax] - Whether to load this image with AJAX.
	     * @param {String} [options.ajaxHeaders] - Headers to add to the image request if using AJAX.
	     * @param {String|Boolean} [options.crossOriginPolicy] - CORS policy to use for downloads
	     * @param {Boolean} [options.ajaxWithCredentials] - Whether to set withCredentials on AJAX
	     * requests.
	     * @param {Function} [options.callback] - Called once image has been downloaded.
	     * @param {Function} [options.abort] - Called when this image job is aborted.
	     */
	    addJob: function(options) {
	        var _this = this,
	            complete = function(job) {
	                completeJob(_this, job, options.callback);
	            },
	            jobOptions = {
	                src: options.src,
	                loadWithAjax: options.loadWithAjax,
	                ajaxHeaders: options.loadWithAjax ? options.ajaxHeaders : null,
	                crossOriginPolicy: options.crossOriginPolicy,
	                ajaxWithCredentials: options.ajaxWithCredentials,
	                callback: complete,
	                abort: options.abort,
	                timeout: this.timeout
	            },
	            newJob = new ImageJob(jobOptions);
	
	        if ( !this.jobLimit || this.jobsInProgress < this.jobLimit ) {
	            newJob.start();
	            this.jobsInProgress++;
	        }
	        else {
	            this.jobQueue.push( newJob );
	        }
	    },
	
	    /**
	     * Clear any unstarted image loading jobs from the queue.
	     * @method
	     */
	    clear: function() {
	        for( var i = 0; i < this.jobQueue.length; i++ ) {
	            var job = this.jobQueue[i];
	            if ( typeof job.abort === "function" ) {
	                job.abort();
	            }
	        }
	
	        this.jobQueue = [];
	    }
	};
	
	/**
	 * Cleans up ImageJob once completed.
	 * @method
	 * @private
	 * @param loader - ImageLoader used to start job.
	 * @param job - The ImageJob that has completed.
	 * @param callback - Called once cleanup is finished.
	 */
	function completeJob(loader, job, callback) {
	    var nextJob;
	
	    loader.jobsInProgress--;
	
	    if ((!loader.jobLimit || loader.jobsInProgress < loader.jobLimit) && loader.jobQueue.length > 0) {
	        nextJob = loader.jobQueue.shift();
	        nextJob.start();
	        loader.jobsInProgress++;
	    }
	
	    callback(job.image, job.errorMsg, job.request);
	}
	
	}(OpenSeadragon));
	
	/*
	 * OpenSeadragon - Tile
	 *
	 * Copyright (C) 2009 CodePlex Foundation
	 * Copyright (C) 2010-2013 OpenSeadragon contributors
	 *
	 * Redistribution and use in source and binary forms, with or without
	 * modification, are permitted provided that the following conditions are
	 * met:
	 *
	 * - Redistributions of source code must retain the above copyright notice,
	 *   this list of conditions and the following disclaimer.
	 *
	 * - Redistributions in binary form must reproduce the above copyright
	 *   notice, this list of conditions and the following disclaimer in the
	 *   documentation and/or other materials provided with the distribution.
	 *
	 * - Neither the name of CodePlex Foundation nor the names of its
	 *   contributors may be used to endorse or promote products derived from
	 *   this software without specific prior written permission.
	 *
	 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
	 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
	 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
	 * A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT
	 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
	 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
	 * TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 * PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
	 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
	 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
	 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	 */
	
	(function( $ ){
	
	/**
	 * @class Tile
	 * @memberof OpenSeadragon
	 * @param {Number} level The zoom level this tile belongs to.
	 * @param {Number} x The vector component 'x'.
	 * @param {Number} y The vector component 'y'.
	 * @param {OpenSeadragon.Rect} bounds Where this tile fits, in normalized
	 *      coordinates.
	 * @param {Boolean} exists Is this tile a part of a sparse image? ( Also has
	 *      this tile failed to load? )
	 * @param {String} url The URL of this tile's image.
	 * @param {CanvasRenderingContext2D} context2D The context2D of this tile if it
	 * is provided directly by the tile source.
	 * @param {Boolean} loadWithAjax Whether this tile image should be loaded with an AJAX request .
	 * @param {Object} ajaxHeaders The headers to send with this tile's AJAX request (if applicable).
	 * @param {OpenSeadragon.Rect} sourceBounds The portion of the tile to use as the source of the
	 * drawing operation, in pixels. Note that this only works when drawing with canvas; when drawing
	 * with HTML the entire tile is always used.
	 */
	$.Tile = function(level, x, y, bounds, exists, url, context2D, loadWithAjax, ajaxHeaders, sourceBounds) {
	    /**
	     * The zoom level this tile belongs to.
	     * @member {Number} level
	     * @memberof OpenSeadragon.Tile#
	     */
	    this.level   = level;
	    /**
	     * The vector component 'x'.
	     * @member {Number} x
	     * @memberof OpenSeadragon.Tile#
	     */
	    this.x       = x;
	    /**
	     * The vector component 'y'.
	     * @member {Number} y
	     * @memberof OpenSeadragon.Tile#
	     */
	    this.y       = y;
	    /**
	     * Where this tile fits, in normalized coordinates
	     * @member {OpenSeadragon.Rect} bounds
	     * @memberof OpenSeadragon.Tile#
	     */
	    this.bounds  = bounds;
	    /**
	    * The portion of the tile to use as the source of the drawing operation, in pixels. Note that
	    * this only works when drawing with canvas; when drawing with HTML the entire tile is always used.
	    * @member {OpenSeadragon.Rect} sourceBounds
	    * @memberof OpenSeadragon.Tile#
	    */
	    this.sourceBounds = sourceBounds;
	    /**
	     * Is this tile a part of a sparse image? Also has this tile failed to load?
	     * @member {Boolean} exists
	     * @memberof OpenSeadragon.Tile#
	     */
	    this.exists  = exists;
	    /**
	     * The URL of this tile's image.
	     * @member {String} url
	     * @memberof OpenSeadragon.Tile#
	     */
	    this.url     = url;
	    /**
	     * The context2D of this tile if it is provided directly by the tile source.
	     * @member {CanvasRenderingContext2D} context2D
	     * @memberOf OpenSeadragon.Tile#
	     */
	    this.context2D = context2D;
	    /**
	     * Whether to load this tile's image with an AJAX request.
	     * @member {Boolean} loadWithAjax
	     * @memberof OpenSeadragon.Tile#
	     */
	    this.loadWithAjax = loadWithAjax;
	    /**
	     * The headers to be used in requesting this tile's image.
	     * Only used if loadWithAjax is set to true.
	     * @member {Object} ajaxHeaders
	     * @memberof OpenSeadragon.Tile#
	     */
	    this.ajaxHeaders = ajaxHeaders;
	    /**
	     * The unique cache key for this tile.
	     * @member {String} cacheKey
	     * @memberof OpenSeadragon.Tile#
	     */
	    if (this.ajaxHeaders) {
	        this.cacheKey = this.url + "+" + JSON.stringify(this.ajaxHeaders);
	    } else {
	        this.cacheKey = this.url;
	    }
	    /**
	     * Is this tile loaded?
	     * @member {Boolean} loaded
	     * @memberof OpenSeadragon.Tile#
	     */
	    this.loaded  = false;
	    /**
	     * Is this tile loading?
	     * @member {Boolean} loading
	     * @memberof OpenSeadragon.Tile#
	     */
	    this.loading = false;
	
	    /**
	     * The HTML div element for this tile
	     * @member {Element} element
	     * @memberof OpenSeadragon.Tile#
	     */
	    this.element    = null;
	    /**
	     * The HTML img element for this tile.
	     * @member {Element} imgElement
	     * @memberof OpenSeadragon.Tile#
	     */
	    this.imgElement = null;
	    /**
	     * The Image object for this tile.
	     * @member {Object} image
	     * @memberof OpenSeadragon.Tile#
	     */
	    this.image      = null;
	
	    /**
	     * The alias of this.element.style.
	     * @member {String} style
	     * @memberof OpenSeadragon.Tile#
	     */
	    this.style      = null;
	    /**
	     * This tile's position on screen, in pixels.
	     * @member {OpenSeadragon.Point} position
	     * @memberof OpenSeadragon.Tile#
	     */
	    this.position   = null;
	    /**
	     * This tile's size on screen, in pixels.
	     * @member {OpenSeadragon.Point} size
	     * @memberof OpenSeadragon.Tile#
	     */
	    this.size       = null;
	    /**
	     * The start time of this tile's blending.
	     * @member {Number} blendStart
	     * @memberof OpenSeadragon.Tile#
	     */
	    this.blendStart = null;
	    /**
	     * The current opacity this tile should be.
	     * @member {Number} opacity
	     * @memberof OpenSeadragon.Tile#
	     */
	    this.opacity    = null;
	    /**
	     * The squared distance of this tile to the viewport center.
	     * Use for comparing tiles.
	     * @private
	     * @member {Number} squaredDistance
	     * @memberof OpenSeadragon.Tile#
	     */
	    this.squaredDistance   = null;
	    /**
	     * The visibility score of this tile.
	     * @member {Number} visibility
	     * @memberof OpenSeadragon.Tile#
	     */
	    this.visibility = null;
	
	    /**
	     * Whether this tile is currently being drawn.
	     * @member {Boolean} beingDrawn
	     * @memberof OpenSeadragon.Tile#
	     */
	    this.beingDrawn     = false;
	
	    /**
	     * Timestamp the tile was last touched.
	     * @member {Number} lastTouchTime
	     * @memberof OpenSeadragon.Tile#
	     */
	    this.lastTouchTime  = 0;
	
	    /**
	     * Whether this tile is in the right-most column for its level.
	     * @member {Boolean} isRightMost
	     * @memberof OpenSeadragon.Tile#
	     */
	    this.isRightMost = false;
	
	    /**
	     * Whether this tile is in the bottom-most row for its level.
	     * @member {Boolean} isBottomMost
	     * @memberof OpenSeadragon.Tile#
	     */
	    this.isBottomMost = false;
	};
	
	/** @lends OpenSeadragon.Tile.prototype */
	$.Tile.prototype = {
	
	    /**
	     * Provides a string representation of this tiles level and (x,y)
	     * components.
	     * @function
	     * @returns {String}
	     */
	    toString: function() {
	        return this.level + "/" + this.x + "_" + this.y;
	    },
	
	    // private
	    _hasTransparencyChannel: function() {
	        return !!this.context2D || this.url.match('.png');
	    },
	
	    /**
	     * Renders the tile in an html container.
	     * @function
	     * @param {Element} container
	     */
	    drawHTML: function( container ) {
	        if (!this.cacheImageRecord) {
	            $.console.warn(
	                '[Tile.drawHTML] attempting to draw tile %s when it\'s not cached',
	                this.toString());
	            return;
	        }
	
	        if ( !this.loaded ) {
	            $.console.warn(
	                "Attempting to draw tile %s when it's not yet loaded.",
	                this.toString()
	            );
	            return;
	        }
	
	        //EXPERIMENTAL - trying to figure out how to scale the container
	        //               content during animation of the container size.
	
	        if ( !this.element ) {
	            this.element                              = $.makeNeutralElement( "div" );
	            this.imgElement                           = this.cacheImageRecord.getImage().cloneNode();
	            this.imgElement.style.msInterpolationMode = "nearest-neighbor";
	            this.imgElement.style.width               = "100%";
	            this.imgElement.style.height              = "100%";
	
	            this.style                     = this.element.style;
	            this.style.position            = "absolute";
	        }
	        if ( this.element.parentNode != container ) {
	            container.appendChild( this.element );
	        }
	        if ( this.imgElement.parentNode != this.element ) {
	            this.element.appendChild( this.imgElement );
	        }
	
	        this.style.top     = this.position.y + "px";
	        this.style.left    = this.position.x + "px";
	        this.style.height  = this.size.y + "px";
	        this.style.width   = this.size.x + "px";
	
	        $.setElementOpacity( this.element, this.opacity );
	    },
	
	    /**
	     * Renders the tile in a canvas-based context.
	     * @function
	     * @param {Canvas} context
	     * @param {Function} drawingHandler - Method for firing the drawing event.
	     * drawingHandler({context, tile, rendered})
	     * where <code>rendered</code> is the context with the pre-drawn image.
	     * @param {Number} [scale=1] - Apply a scale to position and size
	     * @param {OpenSeadragon.Point} [translate] - A translation vector
	     */
	    drawCanvas: function( context, drawingHandler, scale, translate ) {
	
	        var position = this.position.times($.pixelDensityRatio),
	            size     = this.size.times($.pixelDensityRatio),
	            rendered;
	
	        if (!this.context2D && !this.cacheImageRecord) {
	            $.console.warn(
	                '[Tile.drawCanvas] attempting to draw tile %s when it\'s not cached',
	                this.toString());
	            return;
	        }
	
	        rendered = this.context2D || this.cacheImageRecord.getRenderedContext();
	
	        if ( !this.loaded || !rendered ){
	            $.console.warn(
	                "Attempting to draw tile %s when it's not yet loaded.",
	                this.toString()
	            );
	
	            return;
	        }
	
	        context.save();
	
	        context.globalAlpha = this.opacity;
	
	        if (typeof scale === 'number' && scale !== 1) {
	            // draw tile at a different scale
	            position = position.times(scale);
	            size = size.times(scale);
	        }
	
	        if (translate instanceof $.Point) {
	            // shift tile position slightly
	            position = position.plus(translate);
	        }
	
	        //if we are supposed to be rendering fully opaque rectangle,
	        //ie its done fading or fading is turned off, and if we are drawing
	        //an image with an alpha channel, then the only way
	        //to avoid seeing the tile underneath is to clear the rectangle
	        if (context.globalAlpha === 1 && this._hasTransparencyChannel()) {
	            //clearing only the inside of the rectangle occupied
	            //by the png prevents edge flikering
	            context.clearRect(
	                position.x,
	                position.y,
	                size.x,
	                size.y
	            );
	        }
	
	        // This gives the application a chance to make image manipulation
	        // changes as we are rendering the image
	        drawingHandler({context: context, tile: this, rendered: rendered});
	
	        var sourceWidth, sourceHeight;
	        if (this.sourceBounds) {
	            sourceWidth = Math.min(this.sourceBounds.width, rendered.canvas.width);
	            sourceHeight = Math.min(this.sourceBounds.height, rendered.canvas.height);
	        } else {
	            sourceWidth = rendered.canvas.width;
	            sourceHeight = rendered.canvas.height;
	        }
	
	        context.drawImage(
	            rendered.canvas,
	            0,
	            0,
	            sourceWidth,
	            sourceHeight,
	            position.x,
	            position.y,
	            size.x,
	            size.y
	        );
	
	        context.restore();
	    },
	
	    /**
	     * Get the ratio between current and original size.
	     * @function
	     * @return {Float}
	     */
	    getScaleForEdgeSmoothing: function() {
	        var context;
	        if (this.cacheImageRecord) {
	            context = this.cacheImageRecord.getRenderedContext();
	        } else if (this.context2D) {
	            context = this.context2D;
	        } else {
	            $.console.warn(
	                '[Tile.drawCanvas] attempting to get tile scale %s when tile\'s not cached',
	                this.toString());
	            return 1;
	        }
	        return context.canvas.width / (this.size.x * $.pixelDensityRatio);
	    },
	
	    /**
	     * Get a translation vector that when applied to the tile position produces integer coordinates.
	     * Needed to avoid swimming and twitching.
	     * @function
	     * @param {Number} [scale=1] - Scale to be applied to position.
	     * @return {OpenSeadragon.Point}
	     */
	    getTranslationForEdgeSmoothing: function(scale, canvasSize, sketchCanvasSize) {
	        // The translation vector must have positive values, otherwise the image goes a bit off
	        // the sketch canvas to the top and left and we must use negative coordinates to repaint it
	        // to the main canvas. In that case, some browsers throw:
	        // INDEX_SIZE_ERR: DOM Exception 1: Index or size was negative, or greater than the allowed value.
	        var x = Math.max(1, Math.ceil((sketchCanvasSize.x - canvasSize.x) / 2));
	        var y = Math.max(1, Math.ceil((sketchCanvasSize.y - canvasSize.y) / 2));
	        return new $.Point(x, y).minus(
	            this.position
	                .times($.pixelDensityRatio)
	                .times(scale || 1)
	                .apply(function(x) {
	                    return x % 1;
	                })
	        );
	    },
	
	    /**
	     * Removes tile from its container.
	     * @function
	     */
	    unload: function() {
	        if ( this.imgElement && this.imgElement.parentNode ) {
	            this.imgElement.parentNode.removeChild( this.imgElement );
	        }
	        if ( this.element && this.element.parentNode ) {
	            this.element.parentNode.removeChild( this.element );
	        }
	
	        this.element    = null;
	        this.imgElement = null;
	        this.loaded     = false;
	        this.loading    = false;
	    }
	};
	
	}( OpenSeadragon ));
	
	/*
	 * OpenSeadragon - Overlay
	 *
	 * Copyright (C) 2009 CodePlex Foundation
	 * Copyright (C) 2010-2013 OpenSeadragon contributors
	 *
	 * Redistribution and use in source and binary forms, with or without
	 * modification, are permitted provided that the following conditions are
	 * met:
	 *
	 * - Redistributions of source code must retain the above copyright notice,
	 *   this list of conditions and the following disclaimer.
	 *
	 * - Redistributions in binary form must reproduce the above copyright
	 *   notice, this list of conditions and the following disclaimer in the
	 *   documentation and/or other materials provided with the distribution.
	 *
	 * - Neither the name of CodePlex Foundation nor the names of its
	 *   contributors may be used to endorse or promote products derived from
	 *   this software without specific prior written permission.
	 *
	 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
	 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
	 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
	 * A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT
	 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
	 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
	 * TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 * PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
	 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
	 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
	 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	 */
	
	(function($) {
	
	    /**
	     * An enumeration of positions that an overlay may be assigned relative to
	     * the viewport.
	     * It is identical to OpenSeadragon.Placement but is kept for backward
	     * compatibility.
	     * @member OverlayPlacement
	     * @memberof OpenSeadragon
	     * @see OpenSeadragon.Placement
	     * @static
	     * @readonly
	     * @type {Object}
	     * @property {Number} CENTER
	     * @property {Number} TOP_LEFT
	     * @property {Number} TOP
	     * @property {Number} TOP_RIGHT
	     * @property {Number} RIGHT
	     * @property {Number} BOTTOM_RIGHT
	     * @property {Number} BOTTOM
	     * @property {Number} BOTTOM_LEFT
	     * @property {Number} LEFT
	     */
	    $.OverlayPlacement = $.Placement;
	
	    /**
	     * An enumeration of possible ways to handle overlays rotation
	     * @member OverlayRotationMode
	     * @memberOf OpenSeadragon
	     * @static
	     * @readonly
	     * @property {Number} NO_ROTATION The overlay ignore the viewport rotation.
	     * @property {Number} EXACT The overlay use CSS 3 transforms to rotate with
	     * the viewport. If the overlay contains text, it will get rotated as well.
	     * @property {Number} BOUNDING_BOX The overlay adjusts for rotation by
	     * taking the size of the bounding box of the rotated bounds.
	     * Only valid for overlays with Rect location and scalable in both directions.
	     */
	    $.OverlayRotationMode = $.freezeObject({
	        NO_ROTATION: 1,
	        EXACT: 2,
	        BOUNDING_BOX: 3
	    });
	
	    /**
	     * @class Overlay
	     * @classdesc Provides a way to float an HTML element on top of the viewer element.
	     *
	     * @memberof OpenSeadragon
	     * @param {Object} options
	     * @param {Element} options.element
	     * @param {OpenSeadragon.Point|OpenSeadragon.Rect} options.location - The
	     * location of the overlay on the image. If a {@link OpenSeadragon.Point}
	     * is specified, the overlay will be located at this location with respect
	     * to the placement option. If a {@link OpenSeadragon.Rect} is specified,
	     * the overlay will be placed at this location with the corresponding width
	     * and height and placement TOP_LEFT.
	     * @param {OpenSeadragon.Placement} [options.placement=OpenSeadragon.Placement.TOP_LEFT]
	     * Defines what part of the overlay should be at the specified options.location
	     * @param {OpenSeadragon.Overlay.OnDrawCallback} [options.onDraw]
	     * @param {Boolean} [options.checkResize=true] Set to false to avoid to
	     * check the size of the overlay everytime it is drawn in the directions
	     * which are not scaled. It will improve performances but will cause a
	     * misalignment if the overlay size changes.
	     * @param {Number} [options.width] The width of the overlay in viewport
	     * coordinates. If specified, the width of the overlay will be adjusted when
	     * the zoom changes.
	     * @param {Number} [options.height] The height of the overlay in viewport
	     * coordinates. If specified, the height of the overlay will be adjusted when
	     * the zoom changes.
	     * @param {Boolean} [options.rotationMode=OpenSeadragon.OverlayRotationMode.EXACT]
	     * How to handle the rotation of the viewport.
	     */
	    $.Overlay = function(element, location, placement) {
	
	        /**
	         * onDraw callback signature used by {@link OpenSeadragon.Overlay}.
	         *
	         * @callback OnDrawCallback
	         * @memberof OpenSeadragon.Overlay
	         * @param {OpenSeadragon.Point} position
	         * @param {OpenSeadragon.Point} size
	         * @param {Element} element
	         */
	
	        var options;
	        if ($.isPlainObject(element)) {
	            options = element;
	        } else {
	            options = {
	                element: element,
	                location: location,
	                placement: placement
	            };
	        }
	
	        this.element = options.element;
	        this.style = options.element.style;
	        this._init(options);
	    };
	
	    /** @lends OpenSeadragon.Overlay.prototype */
	    $.Overlay.prototype = {
	
	        // private
	        _init: function(options) {
	            this.location = options.location;
	            this.placement = options.placement === undefined ?
	                $.Placement.TOP_LEFT : options.placement;
	            this.onDraw = options.onDraw;
	            this.checkResize = options.checkResize === undefined ?
	                true : options.checkResize;
	
	            // When this.width is not null, the overlay get scaled horizontally
	            this.width = options.width === undefined ? null : options.width;
	
	            // When this.height is not null, the overlay get scaled vertically
	            this.height = options.height === undefined ? null : options.height;
	
	            this.rotationMode = options.rotationMode || $.OverlayRotationMode.EXACT;
	
	            // Having a rect as location is a syntactic sugar
	            if (this.location instanceof $.Rect) {
	                this.width = this.location.width;
	                this.height = this.location.height;
	                this.location = this.location.getTopLeft();
	                this.placement = $.Placement.TOP_LEFT;
	            }
	
	            // Deprecated properties kept for backward compatibility.
	            this.scales = this.width !== null && this.height !== null;
	            this.bounds = new $.Rect(
	                this.location.x, this.location.y, this.width, this.height);
	            this.position = this.location;
	        },
	
	        /**
	         * Internal function to adjust the position of an overlay
	         * depending on it size and placement.
	         * @function
	         * @param {OpenSeadragon.Point} position
	         * @param {OpenSeadragon.Point} size
	         */
	        adjust: function(position, size) {
	            var properties = $.Placement.properties[this.placement];
	            if (!properties) {
	                return;
	            }
	            if (properties.isHorizontallyCentered) {
	                position.x -= size.x / 2;
	            } else if (properties.isRight) {
	                position.x -= size.x;
	            }
	            if (properties.isVerticallyCentered) {
	                position.y -= size.y / 2;
	            } else if (properties.isBottom) {
	                position.y -= size.y;
	            }
	        },
	
	        /**
	         * @function
	         */
	        destroy: function() {
	            var element = this.element;
	            var style = this.style;
	
	            if (element.parentNode) {
	                element.parentNode.removeChild(element);
	                //this should allow us to preserve overlays when required between
	                //pages
	                if (element.prevElementParent) {
	                    style.display = 'none';
	                    //element.prevElementParent.insertBefore(
	                    //    element,
	                    //    element.prevNextSibling
	                    //);
	                    document.body.appendChild(element);
	                }
	            }
	
	            // clear the onDraw callback
	            this.onDraw = null;
	
	            style.top = "";
	            style.left = "";
	            style.position = "";
	
	            if (this.width !== null) {
	                style.width = "";
	            }
	            if (this.height !== null) {
	                style.height = "";
	            }
	            var transformOriginProp = $.getCssPropertyWithVendorPrefix(
	                'transformOrigin');
	            var transformProp = $.getCssPropertyWithVendorPrefix(
	                'transform');
	            if (transformOriginProp && transformProp) {
	                style[transformOriginProp] = "";
	                style[transformProp] = "";
	            }
	        },
	
	        /**
	         * @function
	         * @param {Element} container
	         */
	        drawHTML: function(container, viewport) {
	            var element = this.element;
	            if (element.parentNode !== container) {
	                //save the source parent for later if we need it
	                element.prevElementParent = element.parentNode;
	                element.prevNextSibling = element.nextSibling;
	                container.appendChild(element);
	
	                // have to set position before calculating size, fix #1116
	                this.style.position = "absolute";
	                // this.size is used by overlays which don't get scaled in at
	                // least one direction when this.checkResize is set to false.
	                this.size = $.getElementSize(element);
	            }
	
	            var positionAndSize = this._getOverlayPositionAndSize(viewport);
	
	            var position = positionAndSize.position;
	            var size = this.size = positionAndSize.size;
	            var rotate = positionAndSize.rotate;
	
	            // call the onDraw callback if it exists to allow one to overwrite
	            // the drawing/positioning/sizing of the overlay
	            if (this.onDraw) {
	                this.onDraw(position, size, this.element);
	            } else {
	                var style = this.style;
	                style.left = position.x + "px";
	                style.top = position.y + "px";
	                if (this.width !== null) {
	                    style.width = size.x + "px";
	                }
	                if (this.height !== null) {
	                    style.height = size.y + "px";
	                }
	                var transformOriginProp = $.getCssPropertyWithVendorPrefix(
	                    'transformOrigin');
	                var transformProp = $.getCssPropertyWithVendorPrefix(
	                    'transform');
	                if (transformOriginProp && transformProp) {
	                    if (rotate) {
	                        style[transformOriginProp] = this._getTransformOrigin();
	                        style[transformProp] = "rotate(" + rotate + "deg)";
	                    } else {
	                        style[transformOriginProp] = "";
	                        style[transformProp] = "";
	                    }
	                }
	
	                if (style.display !== 'none') {
	                    style.display = 'block';
	                }
	            }
	        },
	
	        // private
	        _getOverlayPositionAndSize: function(viewport) {
	            var position = viewport.pixelFromPoint(this.location, true);
	            var size = this._getSizeInPixels(viewport);
	            this.adjust(position, size);
	
	            var rotate = 0;
	            if (viewport.degrees &&
	                this.rotationMode !== $.OverlayRotationMode.NO_ROTATION) {
	                // BOUNDING_BOX is only valid if both directions get scaled.
	                // Get replaced by EXACT otherwise.
	                if (this.rotationMode === $.OverlayRotationMode.BOUNDING_BOX &&
	                    this.width !== null && this.height !== null) {
	                    var rect = new $.Rect(position.x, position.y, size.x, size.y);
	                    var boundingBox = this._getBoundingBox(rect, viewport.degrees);
	                    position = boundingBox.getTopLeft();
	                    size = boundingBox.getSize();
	                } else {
	                    rotate = viewport.degrees;
	                }
	            }
	
	            return {
	                position: position,
	                size: size,
	                rotate: rotate
	            };
	        },
	
	        // private
	        _getSizeInPixels: function(viewport) {
	            var width = this.size.x;
	            var height = this.size.y;
	            if (this.width !== null || this.height !== null) {
	                var scaledSize = viewport.deltaPixelsFromPointsNoRotate(
	                    new $.Point(this.width || 0, this.height || 0), true);
	                if (this.width !== null) {
	                    width = scaledSize.x;
	                }
	                if (this.height !== null) {
	                    height = scaledSize.y;
	                }
	            }
	            if (this.checkResize &&
	                (this.width === null || this.height === null)) {
	                var eltSize = this.size = $.getElementSize(this.element);
	                if (this.width === null) {
	                    width = eltSize.x;
	                }
	                if (this.height === null) {
	                    height = eltSize.y;
	                }
	            }
	            return new $.Point(width, height);
	        },
	
	        // private
	        _getBoundingBox: function(rect, degrees) {
	            var refPoint = this._getPlacementPoint(rect);
	            return rect.rotate(degrees, refPoint).getBoundingBox();
	        },
	
	        // private
	        _getPlacementPoint: function(rect) {
	            var result = new $.Point(rect.x, rect.y);
	            var properties = $.Placement.properties[this.placement];
	            if (properties) {
	                if (properties.isHorizontallyCentered) {
	                    result.x += rect.width / 2;
	                } else if (properties.isRight) {
	                    result.x += rect.width;
	                }
	                if (properties.isVerticallyCentered) {
	                    result.y += rect.height / 2;
	                } else if (properties.isBottom) {
	                    result.y += rect.height;
	                }
	            }
	            return result;
	        },
	
	        // private
	        _getTransformOrigin: function() {
	            var result = "";
	            var properties = $.Placement.properties[this.placement];
	            if (!properties) {
	                return result;
	            }
	            if (properties.isLeft) {
	                result = "left";
	            } else if (properties.isRight) {
	                result = "right";
	            }
	            if (properties.isTop) {
	                result += " top";
	            } else if (properties.isBottom) {
	                result += " bottom";
	            }
	            return result;
	        },
	
	        /**
	         * Changes the overlay settings.
	         * @function
	         * @param {OpenSeadragon.Point|OpenSeadragon.Rect|Object} location
	         * If an object is specified, the options are the same than the constructor
	         * except for the element which can not be changed.
	         * @param {OpenSeadragon.Placement} placement
	         */
	        update: function(location, placement) {
	            var options = $.isPlainObject(location) ? location : {
	                location: location,
	                placement: placement
	            };
	            this._init({
	                location: options.location || this.location,
	                placement: options.placement !== undefined ?
	                    options.placement : this.placement,
	                onDraw: options.onDraw || this.onDraw,
	                checkResize: options.checkResize || this.checkResize,
	                width: options.width !== undefined ? options.width : this.width,
	                height: options.height !== undefined ? options.height : this.height,
	                rotationMode: options.rotationMode || this.rotationMode
	            });
	        },
	
	        /**
	         * Returns the current bounds of the overlay in viewport coordinates
	         * @function
	         * @param {OpenSeadragon.Viewport} viewport the viewport
	         * @returns {OpenSeadragon.Rect} overlay bounds
	         */
	        getBounds: function(viewport) {
	            $.console.assert(viewport,
	                'A viewport must now be passed to Overlay.getBounds.');
	            var width = this.width;
	            var height = this.height;
	            if (width === null || height === null) {
	                var size = viewport.deltaPointsFromPixelsNoRotate(this.size, true);
	                if (width === null) {
	                    width = size.x;
	                }
	                if (height === null) {
	                    height = size.y;
	                }
	            }
	            var location = this.location.clone();
	            this.adjust(location, new $.Point(width, height));
	            return this._adjustBoundsForRotation(
	                viewport, new $.Rect(location.x, location.y, width, height));
	        },
	
	        // private
	        _adjustBoundsForRotation: function(viewport, bounds) {
	            if (!viewport ||
	                viewport.degrees === 0 ||
	                this.rotationMode === $.OverlayRotationMode.EXACT) {
	                return bounds;
	            }
	            if (this.rotationMode === $.OverlayRotationMode.BOUNDING_BOX) {
	                // If overlay not fully scalable, BOUNDING_BOX falls back to EXACT
	                if (this.width === null || this.height === null) {
	                    return bounds;
	                }
	                // It is easier to just compute the position and size and
	                // convert to viewport coordinates.
	                var positionAndSize = this._getOverlayPositionAndSize(viewport);
	                return viewport.viewerElementToViewportRectangle(new $.Rect(
	                    positionAndSize.position.x,
	                    positionAndSize.position.y,
	                    positionAndSize.size.x,
	                    positionAndSize.size.y));
	            }
	
	            // NO_ROTATION case
	            return bounds.rotate(-viewport.degrees,
	                this._getPlacementPoint(bounds));
	        }
	    };
	
	}(OpenSeadragon));
	
	/*
	 * OpenSeadragon - Drawer
	 *
	 * Copyright (C) 2009 CodePlex Foundation
	 * Copyright (C) 2010-2013 OpenSeadragon contributors
	 *
	 * Redistribution and use in source and binary forms, with or without
	 * modification, are permitted provided that the following conditions are
	 * met:
	 *
	 * - Redistributions of source code must retain the above copyright notice,
	 *   this list of conditions and the following disclaimer.
	 *
	 * - Redistributions in binary form must reproduce the above copyright
	 *   notice, this list of conditions and the following disclaimer in the
	 *   documentation and/or other materials provided with the distribution.
	 *
	 * - Neither the name of CodePlex Foundation nor the names of its
	 *   contributors may be used to endorse or promote products derived from
	 *   this software without specific prior written permission.
	 *
	 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
	 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
	 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
	 * A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT
	 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
	 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
	 * TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 * PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
	 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
	 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
	 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	 */
	
	(function( $ ){
	
	/**
	 * @class Drawer
	 * @memberof OpenSeadragon
	 * @classdesc Handles rendering of tiles for an {@link OpenSeadragon.Viewer}.
	 * @param {Object} options - Options for this Drawer.
	 * @param {OpenSeadragon.Viewer} options.viewer - The Viewer that owns this Drawer.
	 * @param {OpenSeadragon.Viewport} options.viewport - Reference to Viewer viewport.
	 * @param {Element} options.element - Parent element.
	 * @param {Number} [options.debugGridColor] - See debugGridColor in {@link OpenSeadragon.Options} for details.
	 */
	$.Drawer = function( options ) {
	
	    $.console.assert( options.viewer, "[Drawer] options.viewer is required" );
	
	    //backward compatibility for positional args while prefering more
	    //idiomatic javascript options object as the only argument
	    var args  = arguments;
	
	    if( !$.isPlainObject( options ) ){
	        options = {
	            source:     args[ 0 ], // Reference to Viewer tile source.
	            viewport:   args[ 1 ], // Reference to Viewer viewport.
	            element:    args[ 2 ]  // Parent element.
	        };
	    }
	
	    $.console.assert( options.viewport, "[Drawer] options.viewport is required" );
	    $.console.assert( options.element, "[Drawer] options.element is required" );
	
	    if ( options.source ) {
	        $.console.error( "[Drawer] options.source is no longer accepted; use TiledImage instead" );
	    }
	
	    this.viewer = options.viewer;
	    this.viewport = options.viewport;
	    this.debugGridColor = typeof options.debugGridColor === 'string' ? [options.debugGridColor] : options.debugGridColor || $.DEFAULT_SETTINGS.debugGridColor;
	    if (options.opacity) {
	        $.console.error( "[Drawer] options.opacity is no longer accepted; set the opacity on the TiledImage instead" );
	    }
	
	    this.useCanvas  = $.supportsCanvas && ( this.viewer ? this.viewer.useCanvas : true );
	    /**
	     * The parent element of this Drawer instance, passed in when the Drawer was created.
	     * The parent of {@link OpenSeadragon.Drawer#canvas}.
	     * @member {Element} container
	     * @memberof OpenSeadragon.Drawer#
	     */
	    this.container  = $.getElement( options.element );
	    /**
	     * A &lt;canvas&gt; element if the browser supports them, otherwise a &lt;div&gt; element.
	     * Child element of {@link OpenSeadragon.Drawer#container}.
	     * @member {Element} canvas
	     * @memberof OpenSeadragon.Drawer#
	     */
	    this.canvas     = $.makeNeutralElement( this.useCanvas ? "canvas" : "div" );
	    /**
	     * 2d drawing context for {@link OpenSeadragon.Drawer#canvas} if it's a &lt;canvas&gt; element, otherwise null.
	     * @member {Object} context
	     * @memberof OpenSeadragon.Drawer#
	     */
	    this.context    = this.useCanvas ? this.canvas.getContext( "2d" ) : null;
	
	    /**
	     * Sketch canvas used to temporarily draw tiles which cannot be drawn directly
	     * to the main canvas due to opacity. Lazily initialized.
	     */
	    this.sketchCanvas = null;
	    this.sketchContext = null;
	
	    /**
	     * @member {Element} element
	     * @memberof OpenSeadragon.Drawer#
	     * @deprecated Alias for {@link OpenSeadragon.Drawer#container}.
	     */
	    this.element    = this.container;
	
	    // We force our container to ltr because our drawing math doesn't work in rtl.
	    // This issue only affects our canvas renderer, but we do it always for consistency.
	    // Note that this means overlays you want to be rtl need to be explicitly set to rtl.
	    this.container.dir = 'ltr';
	
	    // check canvas available width and height, set canvas width and height such that the canvas backing store is set to the proper pixel density
	    if (this.useCanvas) {
	        var viewportSize = this._calculateCanvasSize();
	        this.canvas.width = viewportSize.x;
	        this.canvas.height = viewportSize.y;
	    }
	
	    this.canvas.style.width     = "100%";
	    this.canvas.style.height    = "100%";
	    this.canvas.style.position  = "absolute";
	    $.setElementOpacity( this.canvas, this.opacity, true );
	
	    // explicit left-align
	    this.container.style.textAlign = "left";
	    this.container.appendChild( this.canvas );
	};
	
	/** @lends OpenSeadragon.Drawer.prototype */
	$.Drawer.prototype = {
	    // deprecated
	    addOverlay: function( element, location, placement, onDraw ) {
	        $.console.error("drawer.addOverlay is deprecated. Use viewer.addOverlay instead.");
	        this.viewer.addOverlay( element, location, placement, onDraw );
	        return this;
	    },
	
	    // deprecated
	    updateOverlay: function( element, location, placement ) {
	        $.console.error("drawer.updateOverlay is deprecated. Use viewer.updateOverlay instead.");
	        this.viewer.updateOverlay( element, location, placement );
	        return this;
	    },
	
	    // deprecated
	    removeOverlay: function( element ) {
	        $.console.error("drawer.removeOverlay is deprecated. Use viewer.removeOverlay instead.");
	        this.viewer.removeOverlay( element );
	        return this;
	    },
	
	    // deprecated
	    clearOverlays: function() {
	        $.console.error("drawer.clearOverlays is deprecated. Use viewer.clearOverlays instead.");
	        this.viewer.clearOverlays();
	        return this;
	    },
	
	    /**
	     * Set the opacity of the drawer.
	     * @param {Number} opacity
	     * @return {OpenSeadragon.Drawer} Chainable.
	     */
	    setOpacity: function( opacity ) {
	        $.console.error("drawer.setOpacity is deprecated. Use tiledImage.setOpacity instead.");
	        var world = this.viewer.world;
	        for (var i = 0; i < world.getItemCount(); i++) {
	            world.getItemAt( i ).setOpacity( opacity );
	        }
	        return this;
	    },
	
	    /**
	     * Get the opacity of the drawer.
	     * @returns {Number}
	     */
	    getOpacity: function() {
	        $.console.error("drawer.getOpacity is deprecated. Use tiledImage.getOpacity instead.");
	        var world = this.viewer.world;
	        var maxOpacity = 0;
	        for (var i = 0; i < world.getItemCount(); i++) {
	            var opacity = world.getItemAt( i ).getOpacity();
	            if ( opacity > maxOpacity ) {
	                maxOpacity = opacity;
	            }
	        }
	        return maxOpacity;
	    },
	
	    // deprecated
	    needsUpdate: function() {
	        $.console.error( "[Drawer.needsUpdate] this function is deprecated. Use World.needsDraw instead." );
	        return this.viewer.world.needsDraw();
	    },
	
	    // deprecated
	    numTilesLoaded: function() {
	        $.console.error( "[Drawer.numTilesLoaded] this function is deprecated. Use TileCache.numTilesLoaded instead." );
	        return this.viewer.tileCache.numTilesLoaded();
	    },
	
	    // deprecated
	    reset: function() {
	        $.console.error( "[Drawer.reset] this function is deprecated. Use World.resetItems instead." );
	        this.viewer.world.resetItems();
	        return this;
	    },
	
	    // deprecated
	    update: function() {
	        $.console.error( "[Drawer.update] this function is deprecated. Use Drawer.clear and World.draw instead." );
	        this.clear();
	        this.viewer.world.draw();
	        return this;
	    },
	
	    /**
	     * @return {Boolean} True if rotation is supported.
	     */
	    canRotate: function() {
	        return this.useCanvas;
	    },
	
	    /**
	     * Destroy the drawer (unload current loaded tiles)
	     */
	    destroy: function() {
	        //force unloading of current canvas (1x1 will be gc later, trick not necessarily needed)
	        this.canvas.width  = 1;
	        this.canvas.height = 1;
	        this.sketchCanvas = null;
	        this.sketchContext = null;
	    },
	
	    /**
	     * Clears the Drawer so it's ready to draw another frame.
	     */
	    clear: function() {
	        this.canvas.innerHTML = "";
	        if ( this.useCanvas ) {
	            var viewportSize = this._calculateCanvasSize();
	            if( this.canvas.width != viewportSize.x ||
	                this.canvas.height != viewportSize.y ) {
	                this.canvas.width = viewportSize.x;
	                this.canvas.height = viewportSize.y;
	                if ( this.sketchCanvas !== null ) {
	                    var sketchCanvasSize = this._calculateSketchCanvasSize();
	                    this.sketchCanvas.width = sketchCanvasSize.x;
	                    this.sketchCanvas.height = sketchCanvasSize.y;
	                }
	            }
	            this._clear();
	        }
	    },
	
	    _clear: function (useSketch, bounds) {
	        if (!this.useCanvas) {
	            return;
	        }
	        var context = this._getContext(useSketch);
	        if (bounds) {
	            context.clearRect(bounds.x, bounds.y, bounds.width, bounds.height);
	        } else {
	            var canvas = context.canvas;
	            context.clearRect(0, 0, canvas.width, canvas.height);
	        }
	    },
	
	    /**
	     * Scale from OpenSeadragon viewer rectangle to drawer rectangle
	     * (ignoring rotation)
	     * @param {OpenSeadragon.Rect} rectangle - The rectangle in viewport coordinate system.
	     * @return {OpenSeadragon.Rect} Rectangle in drawer coordinate system.
	     */
	    viewportToDrawerRectangle: function(rectangle) {
	        var topLeft = this.viewport.pixelFromPointNoRotate(rectangle.getTopLeft(), true);
	        var size = this.viewport.deltaPixelsFromPointsNoRotate(rectangle.getSize(), true);
	
	        return new $.Rect(
	            topLeft.x * $.pixelDensityRatio,
	            topLeft.y * $.pixelDensityRatio,
	            size.x * $.pixelDensityRatio,
	            size.y * $.pixelDensityRatio
	        );
	    },
	
	    /**
	     * Draws the given tile.
	     * @param {OpenSeadragon.Tile} tile - The tile to draw.
	     * @param {Function} drawingHandler - Method for firing the drawing event if using canvas.
	     * drawingHandler({context, tile, rendered})
	     * @param {Boolean} useSketch - Whether to use the sketch canvas or not.
	     * where <code>rendered</code> is the context with the pre-drawn image.
	     * @param {Float} [scale=1] - Apply a scale to tile position and size. Defaults to 1.
	     * @param {OpenSeadragon.Point} [translate] A translation vector to offset tile position
	     */
	    drawTile: function(tile, drawingHandler, useSketch, scale, translate) {
	        $.console.assert(tile, '[Drawer.drawTile] tile is required');
	        $.console.assert(drawingHandler, '[Drawer.drawTile] drawingHandler is required');
	
	        if (this.useCanvas) {
	            var context = this._getContext(useSketch);
	            scale = scale || 1;
	            tile.drawCanvas(context, drawingHandler, scale, translate);
	        } else {
	            tile.drawHTML( this.canvas );
	        }
	    },
	
	    _getContext: function( useSketch ) {
	        var context = this.context;
	        if ( useSketch ) {
	            if (this.sketchCanvas === null) {
	                this.sketchCanvas = document.createElement( "canvas" );
	                var sketchCanvasSize = this._calculateSketchCanvasSize();
	                this.sketchCanvas.width = sketchCanvasSize.x;
	                this.sketchCanvas.height = sketchCanvasSize.y;
	                this.sketchContext = this.sketchCanvas.getContext( "2d" );
	
	                // If the viewport is not currently rotated, the sketchCanvas
	                // will have the same size as the main canvas. However, if
	                // the viewport get rotated later on, we will need to resize it.
	                if (this.viewport.getRotation() === 0) {
	                    var self = this;
	                    this.viewer.addHandler('rotate', function resizeSketchCanvas() {
	                        if (self.viewport.getRotation() === 0) {
	                            return;
	                        }
	                        self.viewer.removeHandler('rotate', resizeSketchCanvas);
	                        var sketchCanvasSize = self._calculateSketchCanvasSize();
	                        self.sketchCanvas.width = sketchCanvasSize.x;
	                        self.sketchCanvas.height = sketchCanvasSize.y;
	                    });
	                }
	            }
	            context = this.sketchContext;
	        }
	        return context;
	    },
	
	    // private
	    saveContext: function( useSketch ) {
	        if (!this.useCanvas) {
	            return;
	        }
	
	        this._getContext( useSketch ).save();
	    },
	
	    // private
	    restoreContext: function( useSketch ) {
	        if (!this.useCanvas) {
	            return;
	        }
	
	        this._getContext( useSketch ).restore();
	    },
	
	    // private
	    setClip: function(rect, useSketch) {
	        if (!this.useCanvas) {
	            return;
	        }
	
	        var context = this._getContext( useSketch );
	        context.beginPath();
	        context.rect(rect.x, rect.y, rect.width, rect.height);
	        context.clip();
	    },
	
	    // private
	    drawRectangle: function(rect, fillStyle, useSketch) {
	        if (!this.useCanvas) {
	            return;
	        }
	
	        var context = this._getContext( useSketch );
	        context.save();
	        context.fillStyle = fillStyle;
	        context.fillRect(rect.x, rect.y, rect.width, rect.height);
	        context.restore();
	    },
	
	    /**
	     * Blends the sketch canvas in the main canvas.
	     * @param {Object} options The options
	     * @param {Float} options.opacity The opacity of the blending.
	     * @param {Float} [options.scale=1] The scale at which tiles were drawn on
	     * the sketch. Default is 1.
	     * Use scale to draw at a lower scale and then enlarge onto the main canvas.
	     * @param {OpenSeadragon.Point} [options.translate] A translation vector
	     * that was used to draw the tiles
	     * @param {String} [options.compositeOperation] - How the image is
	     * composited onto other images; see compositeOperation in
	     * {@link OpenSeadragon.Options} for possible values.
	     * @param {OpenSeadragon.Rect} [options.bounds] The part of the sketch
	     * canvas to blend in the main canvas. If specified, options.scale and
	     * options.translate get ignored.
	     */
	    blendSketch: function(opacity, scale, translate, compositeOperation) {
	        var options = opacity;
	        if (!$.isPlainObject(options)) {
	            options = {
	                opacity: opacity,
	                scale: scale,
	                translate: translate,
	                compositeOperation: compositeOperation
	            };
	        }
	        if (!this.useCanvas || !this.sketchCanvas) {
	            return;
	        }
	        opacity = options.opacity;
	        compositeOperation = options.compositeOperation;
	        var bounds = options.bounds;
	
	        this.context.save();
	        this.context.globalAlpha = opacity;
	        if (compositeOperation) {
	            this.context.globalCompositeOperation = compositeOperation;
	        }
	        if (bounds) {
	            // Internet Explorer, Microsoft Edge, and Safari have problems
	            // when you call context.drawImage with negative x or y
	            // or x + width or y + height greater than the canvas width or height respectively.
	            if (bounds.x < 0) {
	                bounds.width += bounds.x;
	                bounds.x = 0;
	            }
	            if (bounds.x + bounds.width > this.canvas.width) {
	                bounds.width = this.canvas.width - bounds.x;
	            }
	            if (bounds.y < 0) {
	                bounds.height += bounds.y;
	                bounds.y = 0;
	            }
	            if (bounds.y + bounds.height > this.canvas.height) {
	                bounds.height = this.canvas.height - bounds.y;
	            }
	
	            this.context.drawImage(
	                this.sketchCanvas,
	                bounds.x,
	                bounds.y,
	                bounds.width,
	                bounds.height,
	                bounds.x,
	                bounds.y,
	                bounds.width,
	                bounds.height
	            );
	        } else {
	            scale = options.scale || 1;
	            translate = options.translate;
	            var position = translate instanceof $.Point ?
	                translate : new $.Point(0, 0);
	
	            var widthExt = 0;
	            var heightExt = 0;
	            if (translate) {
	                var widthDiff = this.sketchCanvas.width - this.canvas.width;
	                var heightDiff = this.sketchCanvas.height - this.canvas.height;
	                widthExt = Math.round(widthDiff / 2);
	                heightExt = Math.round(heightDiff / 2);
	            }
	            this.context.drawImage(
	                this.sketchCanvas,
	                position.x - widthExt * scale,
	                position.y - heightExt * scale,
	                (this.canvas.width + 2 * widthExt) * scale,
	                (this.canvas.height + 2 * heightExt) * scale,
	                -widthExt,
	                -heightExt,
	                this.canvas.width + 2 * widthExt,
	                this.canvas.height + 2 * heightExt
	            );
	        }
	        this.context.restore();
	    },
	
	    // private
	    drawDebugInfo: function(tile, count, i, tiledImage) {
	        if ( !this.useCanvas ) {
	            return;
	        }
	
	        var colorIndex = this.viewer.world.getIndexOfItem(tiledImage) % this.debugGridColor.length;
	        var context = this.context;
	        context.save();
	        context.lineWidth = 2 * $.pixelDensityRatio;
	        context.font = 'small-caps bold ' + (13 * $.pixelDensityRatio) + 'px arial';
	        context.strokeStyle = this.debugGridColor[colorIndex];
	        context.fillStyle = this.debugGridColor[colorIndex];
	
	        if ( this.viewport.degrees !== 0 ) {
	            this._offsetForRotation({degrees: this.viewport.degrees});
	        } else{
	          if(this.viewer.viewport.flipped) {
	            this._flip();
	          }
	        }
	        if (tiledImage.getRotation(true) % 360 !== 0) {
	            this._offsetForRotation({
	                degrees: tiledImage.getRotation(true),
	                point: tiledImage.viewport.pixelFromPointNoRotate(
	                    tiledImage._getRotationPoint(true), true)
	            });
	        }
	
	        context.strokeRect(
	            tile.position.x * $.pixelDensityRatio,
	            tile.position.y * $.pixelDensityRatio,
	            tile.size.x * $.pixelDensityRatio,
	            tile.size.y * $.pixelDensityRatio
	        );
	
	        var tileCenterX = (tile.position.x + (tile.size.x / 2)) * $.pixelDensityRatio;
	        var tileCenterY = (tile.position.y + (tile.size.y / 2)) * $.pixelDensityRatio;
	
	        // Rotate the text the right way around.
	        context.translate( tileCenterX, tileCenterY );
	        context.rotate( Math.PI / 180 * -this.viewport.degrees );
	        context.translate( -tileCenterX, -tileCenterY );
	
	        if( tile.x === 0 && tile.y === 0 ){
	            context.fillText(
	                "Zoom: " + this.viewport.getZoom(),
	                tile.position.x * $.pixelDensityRatio,
	                (tile.position.y - 30) * $.pixelDensityRatio
	            );
	            context.fillText(
	                "Pan: " + this.viewport.getBounds().toString(),
	                tile.position.x * $.pixelDensityRatio,
	                (tile.position.y - 20) * $.pixelDensityRatio
	            );
	        }
	        context.fillText(
	            "Level: " + tile.level,
	            (tile.position.x + 10) * $.pixelDensityRatio,
	            (tile.position.y + 20) * $.pixelDensityRatio
	        );
	        context.fillText(
	            "Column: " + tile.x,
	            (tile.position.x + 10) * $.pixelDensityRatio,
	            (tile.position.y + 30) * $.pixelDensityRatio
	        );
	        context.fillText(
	            "Row: " + tile.y,
	            (tile.position.x + 10) * $.pixelDensityRatio,
	            (tile.position.y + 40) * $.pixelDensityRatio
	        );
	        context.fillText(
	            "Order: " + i + " of " + count,
	            (tile.position.x + 10) * $.pixelDensityRatio,
	            (tile.position.y + 50) * $.pixelDensityRatio
	        );
	        context.fillText(
	            "Size: " + tile.size.toString(),
	            (tile.position.x + 10) * $.pixelDensityRatio,
	            (tile.position.y + 60) * $.pixelDensityRatio
	        );
	        context.fillText(
	            "Position: " + tile.position.toString(),
	            (tile.position.x + 10) * $.pixelDensityRatio,
	            (tile.position.y + 70) * $.pixelDensityRatio
	        );
	
	        if ( this.viewport.degrees !== 0 ) {
	            this._restoreRotationChanges();
	        }
	        if (tiledImage.getRotation(true) % 360 !== 0) {
	            this._restoreRotationChanges();
	        }
	        context.restore();
	    },
	
	    // private
	    debugRect: function(rect) {
	        if ( this.useCanvas ) {
	            var context = this.context;
	            context.save();
	            context.lineWidth = 2 * $.pixelDensityRatio;
	            context.strokeStyle = this.debugGridColor[0];
	            context.fillStyle = this.debugGridColor[0];
	
	            context.strokeRect(
	                rect.x * $.pixelDensityRatio,
	                rect.y * $.pixelDensityRatio,
	                rect.width * $.pixelDensityRatio,
	                rect.height * $.pixelDensityRatio
	            );
	
	            context.restore();
	        }
	    },
	
	    /**
	     * Get the canvas size
	     * @param {Boolean} sketch If set to true return the size of the sketch canvas
	     * @returns {OpenSeadragon.Point} The size of the canvas
	     */
	    getCanvasSize: function(sketch) {
	        var canvas = this._getContext(sketch).canvas;
	        return new $.Point(canvas.width, canvas.height);
	    },
	
	    getCanvasCenter: function() {
	        return new $.Point(this.canvas.width / 2, this.canvas.height / 2);
	    },
	
	    // private
	    _offsetForRotation: function(options) {
	        var point = options.point ?
	            options.point.times($.pixelDensityRatio) :
	            this.getCanvasCenter();
	
	        var context = this._getContext(options.useSketch);
	        context.save();
	
	        context.translate(point.x, point.y);
	        if(this.viewer.viewport.flipped){
	          context.rotate(Math.PI / 180 * -options.degrees);
	          context.scale(-1, 1);
	        } else{
	          context.rotate(Math.PI / 180 * options.degrees);
	        }
	        context.translate(-point.x, -point.y);
	    },
	
	    // private
	    _flip: function(options) {
	      options = options || {};
	      var point = options.point ?
	        options.point.times($.pixelDensityRatio) :
	        this.getCanvasCenter();
	      var context = this._getContext(options.useSketch);
	
	      context.translate(point.x, 0);
	      context.scale(-1, 1);
	      context.translate(-point.x, 0);
	    },
	
	    // private
	    _restoreRotationChanges: function(useSketch) {
	        var context = this._getContext(useSketch);
	        context.restore();
	    },
	
	    // private
	    _calculateCanvasSize: function() {
	        var pixelDensityRatio = $.pixelDensityRatio;
	        var viewportSize = this.viewport.getContainerSize();
	        return {
	            x: viewportSize.x * pixelDensityRatio,
	            y: viewportSize.y * pixelDensityRatio
	        };
	    },
	
	    // private
	    _calculateSketchCanvasSize: function() {
	        var canvasSize = this._calculateCanvasSize();
	        if (this.viewport.getRotation() === 0) {
	            return canvasSize;
	        }
	        // If the viewport is rotated, we need a larger sketch canvas in order
	        // to support edge smoothing.
	        var sketchCanvasSize = Math.ceil(Math.sqrt(
	            canvasSize.x * canvasSize.x +
	            canvasSize.y * canvasSize.y));
	        return {
	            x: sketchCanvasSize,
	            y: sketchCanvasSize
	        };
	    }
	};
	
	}( OpenSeadragon ));
	
	/*
	 * OpenSeadragon - Viewport
	 *
	 * Copyright (C) 2009 CodePlex Foundation
	 * Copyright (C) 2010-2013 OpenSeadragon contributors
	 *
	 * Redistribution and use in source and binary forms, with or without
	 * modification, are permitted provided that the following conditions are
	 * met:
	 *
	 * - Redistributions of source code must retain the above copyright notice,
	 *   this list of conditions and the following disclaimer.
	 *
	 * - Redistributions in binary form must reproduce the above copyright
	 *   notice, this list of conditions and the following disclaimer in the
	 *   documentation and/or other materials provided with the distribution.
	 *
	 * - Neither the name of CodePlex Foundation nor the names of its
	 *   contributors may be used to endorse or promote products derived from
	 *   this software without specific prior written permission.
	 *
	 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
	 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
	 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
	 * A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT
	 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
	 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
	 * TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 * PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
	 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
	 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
	 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	 */
	
	(function( $ ){
	
	
	/**
	 * @class Viewport
	 * @memberof OpenSeadragon
	 * @classdesc Handles coordinate-related functionality (zoom, pan, rotation, etc.)
	 * for an {@link OpenSeadragon.Viewer}.
	 * @param {Object} options - Options for this Viewport.
	 * @param {Object} [options.margins] - See viewportMargins in {@link OpenSeadragon.Options}.
	 * @param {Number} [options.springStiffness] - See springStiffness in {@link OpenSeadragon.Options}.
	 * @param {Number} [options.animationTime] - See animationTime in {@link OpenSeadragon.Options}.
	 * @param {Number} [options.minZoomImageRatio] - See minZoomImageRatio in {@link OpenSeadragon.Options}.
	 * @param {Number} [options.maxZoomPixelRatio] - See maxZoomPixelRatio in {@link OpenSeadragon.Options}.
	 * @param {Number} [options.visibilityRatio] - See visibilityRatio in {@link OpenSeadragon.Options}.
	 * @param {Boolean} [options.wrapHorizontal] - See wrapHorizontal in {@link OpenSeadragon.Options}.
	 * @param {Boolean} [options.wrapVertical] - See wrapVertical in {@link OpenSeadragon.Options}.
	 * @param {Number} [options.defaultZoomLevel] - See defaultZoomLevel in {@link OpenSeadragon.Options}.
	 * @param {Number} [options.minZoomLevel] - See minZoomLevel in {@link OpenSeadragon.Options}.
	 * @param {Number} [options.maxZoomLevel] - See maxZoomLevel in {@link OpenSeadragon.Options}.
	 * @param {Number} [options.degrees] - See degrees in {@link OpenSeadragon.Options}.
	 * @param {Boolean} [options.homeFillsViewer] - See homeFillsViewer in {@link OpenSeadragon.Options}.
	 */
	$.Viewport = function( options ) {
	
	    //backward compatibility for positional args while prefering more
	    //idiomatic javascript options object as the only argument
	    var args = arguments;
	    if (args.length && args[0] instanceof $.Point) {
	        options = {
	            containerSize:  args[0],
	            contentSize:    args[1],
	            config:         args[2]
	        };
	    }
	
	    //options.config and the general config argument are deprecated
	    //in favor of the more direct specification of optional settings
	    //being passed directly on the options object
	    if ( options.config ){
	        $.extend( true, options, options.config );
	        delete options.config;
	    }
	
	    this._margins = $.extend({
	        left: 0,
	        top: 0,
	        right: 0,
	        bottom: 0
	    }, options.margins || {});
	
	    delete options.margins;
	
	    $.extend( true, this, {
	
	        //required settings
	        containerSize:      null,
	        contentSize:        null,
	
	        //internal state properties
	        zoomPoint:          null,
	        viewer:           null,
	
	        //configurable options
	        springStiffness:    $.DEFAULT_SETTINGS.springStiffness,
	        animationTime:      $.DEFAULT_SETTINGS.animationTime,
	        minZoomImageRatio:  $.DEFAULT_SETTINGS.minZoomImageRatio,
	        maxZoomPixelRatio:  $.DEFAULT_SETTINGS.maxZoomPixelRatio,
	        visibilityRatio:    $.DEFAULT_SETTINGS.visibilityRatio,
	        wrapHorizontal:     $.DEFAULT_SETTINGS.wrapHorizontal,
	        wrapVertical:       $.DEFAULT_SETTINGS.wrapVertical,
	        defaultZoomLevel:   $.DEFAULT_SETTINGS.defaultZoomLevel,
	        minZoomLevel:       $.DEFAULT_SETTINGS.minZoomLevel,
	        maxZoomLevel:       $.DEFAULT_SETTINGS.maxZoomLevel,
	        degrees:            $.DEFAULT_SETTINGS.degrees,
	        flipped:            $.DEFAULT_SETTINGS.flipped,
	        homeFillsViewer:    $.DEFAULT_SETTINGS.homeFillsViewer
	
	    }, options );
	
	    this._updateContainerInnerSize();
	
	    this.centerSpringX = new $.Spring({
	        initial: 0,
	        springStiffness: this.springStiffness,
	        animationTime:   this.animationTime
	    });
	    this.centerSpringY = new $.Spring({
	        initial: 0,
	        springStiffness: this.springStiffness,
	        animationTime:   this.animationTime
	    });
	    this.zoomSpring    = new $.Spring({
	        exponential: true,
	        initial: 1,
	        springStiffness: this.springStiffness,
	        animationTime:   this.animationTime
	    });
	
	    this._oldCenterX = this.centerSpringX.current.value;
	    this._oldCenterY = this.centerSpringY.current.value;
	    this._oldZoom    = this.zoomSpring.current.value;
	
	    this._setContentBounds(new $.Rect(0, 0, 1, 1), 1);
	
	    this.goHome(true);
	    this.update();
	};
	
	/** @lends OpenSeadragon.Viewport.prototype */
	$.Viewport.prototype = {
	    /**
	     * Updates the viewport's home bounds and constraints for the given content size.
	     * @function
	     * @param {OpenSeadragon.Point} contentSize - size of the content in content units
	     * @return {OpenSeadragon.Viewport} Chainable.
	     * @fires OpenSeadragon.Viewer.event:reset-size
	     */
	    resetContentSize: function(contentSize) {
	        $.console.assert(contentSize, "[Viewport.resetContentSize] contentSize is required");
	        $.console.assert(contentSize instanceof $.Point, "[Viewport.resetContentSize] contentSize must be an OpenSeadragon.Point");
	        $.console.assert(contentSize.x > 0, "[Viewport.resetContentSize] contentSize.x must be greater than 0");
	        $.console.assert(contentSize.y > 0, "[Viewport.resetContentSize] contentSize.y must be greater than 0");
	
	        this._setContentBounds(new $.Rect(0, 0, 1, contentSize.y / contentSize.x), contentSize.x);
	        return this;
	    },
	
	    // deprecated
	    setHomeBounds: function(bounds, contentFactor) {
	        $.console.error("[Viewport.setHomeBounds] this function is deprecated; The content bounds should not be set manually.");
	        this._setContentBounds(bounds, contentFactor);
	    },
	
	    // Set the viewport's content bounds
	    // @param {OpenSeadragon.Rect} bounds - the new bounds in viewport coordinates
	    // without rotation
	    // @param {Number} contentFactor - how many content units per viewport unit
	    // @fires OpenSeadragon.Viewer.event:reset-size
	    // @private
	    _setContentBounds: function(bounds, contentFactor) {
	        $.console.assert(bounds, "[Viewport._setContentBounds] bounds is required");
	        $.console.assert(bounds instanceof $.Rect, "[Viewport._setContentBounds] bounds must be an OpenSeadragon.Rect");
	        $.console.assert(bounds.width > 0, "[Viewport._setContentBounds] bounds.width must be greater than 0");
	        $.console.assert(bounds.height > 0, "[Viewport._setContentBounds] bounds.height must be greater than 0");
	
	        this._contentBoundsNoRotate = bounds.clone();
	        this._contentSizeNoRotate = this._contentBoundsNoRotate.getSize().times(
	            contentFactor);
	
	        this._contentBounds = bounds.rotate(this.degrees).getBoundingBox();
	        this._contentSize = this._contentBounds.getSize().times(contentFactor);
	        this._contentAspectRatio = this._contentSize.x / this._contentSize.y;
	
	        if (this.viewer) {
	            /**
	             * Raised when the viewer's content size or home bounds are reset
	             * (see {@link OpenSeadragon.Viewport#resetContentSize}).
	             *
	             * @event reset-size
	             * @memberof OpenSeadragon.Viewer
	             * @type {object}
	             * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised this event.
	             * @property {OpenSeadragon.Point} contentSize
	             * @property {OpenSeadragon.Rect} contentBounds - Content bounds.
	             * @property {OpenSeadragon.Rect} homeBounds - Content bounds.
	             * Deprecated use contentBounds instead.
	             * @property {Number} contentFactor
	             * @property {?Object} userData - Arbitrary subscriber-defined object.
	             */
	            this.viewer.raiseEvent('reset-size', {
	                contentSize: this._contentSizeNoRotate.clone(),
	                contentFactor: contentFactor,
	                homeBounds: this._contentBoundsNoRotate.clone(),
	                contentBounds: this._contentBounds.clone()
	            });
	        }
	    },
	
	    /**
	     * Returns the home zoom in "viewport zoom" value.
	     * @function
	     * @returns {Number} The home zoom in "viewport zoom".
	     */
	    getHomeZoom: function() {
	        if (this.defaultZoomLevel) {
	            return this.defaultZoomLevel;
	        }
	
	        var aspectFactor = this._contentAspectRatio / this.getAspectRatio();
	        var output;
	        if (this.homeFillsViewer) { // fill the viewer and clip the image
	            output = aspectFactor >= 1 ? aspectFactor : 1;
	        } else {
	            output = aspectFactor >= 1 ? 1 : aspectFactor;
	        }
	
	        return output / this._contentBounds.width;
	    },
	
	    /**
	     * Returns the home bounds in viewport coordinates.
	     * @function
	     * @returns {OpenSeadragon.Rect} The home bounds in vewport coordinates.
	     */
	    getHomeBounds: function() {
	        return this.getHomeBoundsNoRotate().rotate(-this.getRotation());
	    },
	
	    /**
	     * Returns the home bounds in viewport coordinates.
	     * This method ignores the viewport rotation. Use
	     * {@link OpenSeadragon.Viewport#getHomeBounds} to take it into account.
	     * @function
	     * @returns {OpenSeadragon.Rect} The home bounds in vewport coordinates.
	     */
	    getHomeBoundsNoRotate: function() {
	        var center = this._contentBounds.getCenter();
	        var width  = 1.0 / this.getHomeZoom();
	        var height = width / this.getAspectRatio();
	
	        return new $.Rect(
	            center.x - (width / 2.0),
	            center.y - (height / 2.0),
	            width,
	            height
	        );
	    },
	
	    /**
	     * @function
	     * @param {Boolean} immediately
	     * @fires OpenSeadragon.Viewer.event:home
	     */
	    goHome: function(immediately) {
	        if (this.viewer) {
	            /**
	             * Raised when the "home" operation occurs (see {@link OpenSeadragon.Viewport#goHome}).
	             *
	             * @event home
	             * @memberof OpenSeadragon.Viewer
	             * @type {object}
	             * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised this event.
	             * @property {Boolean} immediately
	             * @property {?Object} userData - Arbitrary subscriber-defined object.
	             */
	            this.viewer.raiseEvent('home', {
	                immediately: immediately
	            });
	        }
	        return this.fitBounds(this.getHomeBounds(), immediately);
	    },
	
	    /**
	     * @function
	     */
	    getMinZoom: function() {
	        var homeZoom = this.getHomeZoom(),
	            zoom = this.minZoomLevel ?
	            this.minZoomLevel :
	                this.minZoomImageRatio * homeZoom;
	
	        return zoom;
	    },
	
	    /**
	     * @function
	     */
	    getMaxZoom: function() {
	        var zoom = this.maxZoomLevel;
	        if (!zoom) {
	            zoom = this._contentSize.x * this.maxZoomPixelRatio / this._containerInnerSize.x;
	            zoom /= this._contentBounds.width;
	        }
	
	        return Math.max( zoom, this.getHomeZoom() );
	    },
	
	    /**
	     * @function
	     */
	    getAspectRatio: function() {
	        return this._containerInnerSize.x / this._containerInnerSize.y;
	    },
	
	    /**
	     * @function
	     * @returns {OpenSeadragon.Point} The size of the container, in screen coordinates.
	     */
	    getContainerSize: function() {
	        return new $.Point(
	            this.containerSize.x,
	            this.containerSize.y
	        );
	    },
	
	    /**
	     * The margins push the "home" region in from the sides by the specified amounts.
	     * @function
	     * @returns {Object} Properties (Numbers, in screen coordinates): left, top, right, bottom.
	     */
	    getMargins: function() {
	        return $.extend({}, this._margins); // Make a copy so we are not returning our original
	    },
	
	    /**
	     * The margins push the "home" region in from the sides by the specified amounts.
	     * @function
	     * @param {Object} margins - Properties (Numbers, in screen coordinates): left, top, right, bottom.
	     */
	    setMargins: function(margins) {
	        $.console.assert($.type(margins) === 'object', '[Viewport.setMargins] margins must be an object');
	
	        this._margins = $.extend({
	            left: 0,
	            top: 0,
	            right: 0,
	            bottom: 0
	        }, margins);
	
	        this._updateContainerInnerSize();
	        if (this.viewer) {
	            this.viewer.forceRedraw();
	        }
	    },
	
	    /**
	     * Returns the bounds of the visible area in viewport coordinates.
	     * @function
	     * @param {Boolean} current - Pass true for the current location; defaults to false (target location).
	     * @returns {OpenSeadragon.Rect} The location you are zoomed/panned to, in viewport coordinates.
	     */
	    getBounds: function(current) {
	        return this.getBoundsNoRotate(current).rotate(-this.getRotation());
	    },
	
	    /**
	     * Returns the bounds of the visible area in viewport coordinates.
	     * This method ignores the viewport rotation. Use
	     * {@link OpenSeadragon.Viewport#getBounds} to take it into account.
	     * @function
	     * @param {Boolean} current - Pass true for the current location; defaults to false (target location).
	     * @returns {OpenSeadragon.Rect} The location you are zoomed/panned to, in viewport coordinates.
	     */
	    getBoundsNoRotate: function(current) {
	        var center = this.getCenter(current);
	        var width  = 1.0 / this.getZoom(current);
	        var height = width / this.getAspectRatio();
	
	        return new $.Rect(
	            center.x - (width / 2.0),
	            center.y - (height / 2.0),
	            width,
	            height
	        );
	    },
	
	    /**
	     * @function
	     * @param {Boolean} current - Pass true for the current location; defaults to false (target location).
	     * @returns {OpenSeadragon.Rect} The location you are zoomed/panned to,
	     * including the space taken by margins, in viewport coordinates.
	     */
	    getBoundsWithMargins: function(current) {
	        return this.getBoundsNoRotateWithMargins(current).rotate(
	            -this.getRotation(), this.getCenter(current));
	    },
	
	    /**
	     * @function
	     * @param {Boolean} current - Pass true for the current location; defaults to false (target location).
	     * @returns {OpenSeadragon.Rect} The location you are zoomed/panned to,
	     * including the space taken by margins, in viewport coordinates.
	     */
	    getBoundsNoRotateWithMargins: function(current) {
	        var bounds = this.getBoundsNoRotate(current);
	        var factor = this._containerInnerSize.x * this.getZoom(current);
	        bounds.x -= this._margins.left / factor;
	        bounds.y -= this._margins.top / factor;
	        bounds.width += (this._margins.left + this._margins.right) / factor;
	        bounds.height += (this._margins.top + this._margins.bottom) / factor;
	        return bounds;
	    },
	
	    /**
	     * @function
	     * @param {Boolean} current - Pass true for the current location; defaults to false (target location).
	     */
	    getCenter: function( current ) {
	        var centerCurrent = new $.Point(
	                this.centerSpringX.current.value,
	                this.centerSpringY.current.value
	            ),
	            centerTarget = new $.Point(
	                this.centerSpringX.target.value,
	                this.centerSpringY.target.value
	            ),
	            oldZoomPixel,
	            zoom,
	            width,
	            height,
	            bounds,
	            newZoomPixel,
	            deltaZoomPixels,
	            deltaZoomPoints;
	
	        if ( current ) {
	            return centerCurrent;
	        } else if ( !this.zoomPoint ) {
	            return centerTarget;
	        }
	
	        oldZoomPixel = this.pixelFromPoint(this.zoomPoint, true);
	
	        zoom    = this.getZoom();
	        width   = 1.0 / zoom;
	        height  = width / this.getAspectRatio();
	        bounds  = new $.Rect(
	            centerCurrent.x - width / 2.0,
	            centerCurrent.y - height / 2.0,
	            width,
	            height
	        );
	
	        newZoomPixel = this._pixelFromPoint(this.zoomPoint, bounds);
	        deltaZoomPixels = newZoomPixel.minus( oldZoomPixel );
	        deltaZoomPoints = deltaZoomPixels.divide( this._containerInnerSize.x * zoom );
	
	        return centerTarget.plus( deltaZoomPoints );
	    },
	
	    /**
	     * @function
	     * @param {Boolean} current - Pass true for the current location; defaults to false (target location).
	     */
	    getZoom: function( current ) {
	        if ( current ) {
	            return this.zoomSpring.current.value;
	        } else {
	            return this.zoomSpring.target.value;
	        }
	    },
	
	    // private
	    _applyZoomConstraints: function(zoom) {
	        return Math.max(
	            Math.min(zoom, this.getMaxZoom()),
	            this.getMinZoom());
	    },
	
	    /**
	     * @function
	     * @private
	     * @param {OpenSeadragon.Rect} bounds
	     * @return {OpenSeadragon.Rect} constrained bounds.
	     */
	    _applyBoundaryConstraints: function(bounds) {
	        var newBounds = new $.Rect(
	                bounds.x,
	                bounds.y,
	                bounds.width,
	                bounds.height);
	
	        if (this.wrapHorizontal) {
	            //do nothing
	        } else {
	            var horizontalThreshold = this.visibilityRatio * newBounds.width;
	            var boundsRight = newBounds.x + newBounds.width;
	            var contentRight = this._contentBoundsNoRotate.x + this._contentBoundsNoRotate.width;
	            var leftDx = this._contentBoundsNoRotate.x - boundsRight + horizontalThreshold;
	            var rightDx = contentRight - newBounds.x - horizontalThreshold;
	
	            if (horizontalThreshold > this._contentBoundsNoRotate.width) {
	                newBounds.x += (leftDx + rightDx) / 2;
	            } else if (rightDx < 0) {
	                newBounds.x += rightDx;
	            } else if (leftDx > 0) {
	                newBounds.x += leftDx;
	            }
	        }
	
	        if (this.wrapVertical) {
	            //do nothing
	        } else {
	            var verticalThreshold   = this.visibilityRatio * newBounds.height;
	            var boundsBottom = newBounds.y + newBounds.height;
	            var contentBottom = this._contentBoundsNoRotate.y + this._contentBoundsNoRotate.height;
	            var topDy = this._contentBoundsNoRotate.y - boundsBottom + verticalThreshold;
	            var bottomDy = contentBottom - newBounds.y - verticalThreshold;
	
	            if (verticalThreshold > this._contentBoundsNoRotate.height) {
	                newBounds.y += (topDy + bottomDy) / 2;
	            } else if (bottomDy < 0) {
	                newBounds.y += bottomDy;
	            } else if (topDy > 0) {
	                newBounds.y += topDy;
	            }
	        }
	
	        return newBounds;
	    },
	
	    /**
	     * @function
	     * @private
	     * @param {Boolean} [immediately=false] - whether the function that triggered this event was
	     * called with the "immediately" flag
	     */
	    _raiseConstraintsEvent: function(immediately) {
	        if (this.viewer) {
	            /**
	             * Raised when the viewport constraints are applied (see {@link OpenSeadragon.Viewport#applyConstraints}).
	             *
	             * @event constrain
	             * @memberof OpenSeadragon.Viewer
	             * @type {object}
	             * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised this event.
	             * @property {Boolean} immediately - whether the function that triggered this event was
	             * called with the "immediately" flag
	             * @property {?Object} userData - Arbitrary subscriber-defined object.
	             */
	            this.viewer.raiseEvent( 'constrain', {
	                immediately: immediately
	            });
	        }
	    },
	
	    /**
	     * Enforces the minZoom, maxZoom and visibilityRatio constraints by
	     * zooming and panning to the closest acceptable zoom and location.
	     * @function
	     * @param {Boolean} [immediately=false]
	     * @return {OpenSeadragon.Viewport} Chainable.
	     * @fires OpenSeadragon.Viewer.event:constrain
	     */
	    applyConstraints: function(immediately) {
	        var actualZoom = this.getZoom();
	        var constrainedZoom = this._applyZoomConstraints(actualZoom);
	
	        if (actualZoom !== constrainedZoom) {
	            this.zoomTo(constrainedZoom, this.zoomPoint, immediately);
	        }
	
	        var bounds = this.getBoundsNoRotate();
	        var constrainedBounds = this._applyBoundaryConstraints(bounds);
	        this._raiseConstraintsEvent(immediately);
	
	        if (bounds.x !== constrainedBounds.x ||
	            bounds.y !== constrainedBounds.y ||
	            immediately) {
	            this.fitBounds(
	                constrainedBounds.rotate(-this.getRotation()),
	                immediately);
	        }
	        return this;
	    },
	
	    /**
	     * Equivalent to {@link OpenSeadragon.Viewport#applyConstraints}
	     * @function
	     * @param {Boolean} [immediately=false]
	     * @return {OpenSeadragon.Viewport} Chainable.
	     * @fires OpenSeadragon.Viewer.event:constrain
	     */
	    ensureVisible: function(immediately) {
	        return this.applyConstraints(immediately);
	    },
	
	    /**
	     * @function
	     * @private
	     * @param {OpenSeadragon.Rect} bounds
	     * @param {Object} options (immediately=false, constraints=false)
	     * @return {OpenSeadragon.Viewport} Chainable.
	     */
	    _fitBounds: function(bounds, options) {
	        options = options || {};
	        var immediately = options.immediately || false;
	        var constraints = options.constraints || false;
	
	        var aspect = this.getAspectRatio();
	        var center = bounds.getCenter();
	
	        // Compute width and height of bounding box.
	        var newBounds = new $.Rect(
	            bounds.x,
	            bounds.y,
	            bounds.width,
	            bounds.height,
	            bounds.degrees + this.getRotation())
	            .getBoundingBox();
	
	        if (newBounds.getAspectRatio() >= aspect) {
	            newBounds.height = newBounds.width / aspect;
	        } else {
	            newBounds.width = newBounds.height * aspect;
	        }
	
	        // Compute x and y from width, height and center position
	        newBounds.x = center.x - newBounds.width / 2;
	        newBounds.y = center.y - newBounds.height / 2;
	        var newZoom = 1.0 / newBounds.width;
	
	        if (constraints) {
	            var newBoundsAspectRatio = newBounds.getAspectRatio();
	            var newConstrainedZoom = this._applyZoomConstraints(newZoom);
	
	            if (newZoom !== newConstrainedZoom) {
	                newZoom = newConstrainedZoom;
	                newBounds.width = 1.0 / newZoom;
	                newBounds.x = center.x - newBounds.width / 2;
	                newBounds.height = newBounds.width / newBoundsAspectRatio;
	                newBounds.y = center.y - newBounds.height / 2;
	            }
	
	            newBounds = this._applyBoundaryConstraints(newBounds);
	            center = newBounds.getCenter();
	            this._raiseConstraintsEvent(immediately);
	        }
	
	        if (immediately) {
	            this.panTo(center, true);
	            return this.zoomTo(newZoom, null, true);
	        }
	
	        this.panTo(this.getCenter(true), true);
	        this.zoomTo(this.getZoom(true), null, true);
	
	        var oldBounds = this.getBounds();
	        var oldZoom   = this.getZoom();
	
	        if (oldZoom === 0 || Math.abs(newZoom / oldZoom - 1) < 0.00000001) {
	            this.zoomTo(newZoom, true);
	            return this.panTo(center, immediately);
	        }
	
	        newBounds = newBounds.rotate(-this.getRotation());
	        var referencePoint = newBounds.getTopLeft().times(newZoom)
	            .minus(oldBounds.getTopLeft().times(oldZoom))
	            .divide(newZoom - oldZoom);
	
	        return this.zoomTo(newZoom, referencePoint, immediately);
	    },
	
	    /**
	     * Makes the viewport zoom and pan so that the specified bounds take
	     * as much space as possible in the viewport.
	     * Note: this method ignores the constraints (minZoom, maxZoom and
	     * visibilityRatio).
	     * Use {@link OpenSeadragon.Viewport#fitBoundsWithConstraints} to enforce
	     * them.
	     * @function
	     * @param {OpenSeadragon.Rect} bounds
	     * @param {Boolean} [immediately=false]
	     * @return {OpenSeadragon.Viewport} Chainable.
	     */
	    fitBounds: function(bounds, immediately) {
	        return this._fitBounds(bounds, {
	            immediately: immediately,
	            constraints: false
	        });
	    },
	
	    /**
	     * Makes the viewport zoom and pan so that the specified bounds take
	     * as much space as possible in the viewport while enforcing the constraints
	     * (minZoom, maxZoom and visibilityRatio).
	     * Note: because this method enforces the constraints, part of the
	     * provided bounds may end up outside of the viewport.
	     * Use {@link OpenSeadragon.Viewport#fitBounds} to ignore them.
	     * @function
	     * @param {OpenSeadragon.Rect} bounds
	     * @param {Boolean} [immediately=false]
	     * @return {OpenSeadragon.Viewport} Chainable.
	     */
	    fitBoundsWithConstraints: function(bounds, immediately) {
	        return this._fitBounds(bounds, {
	            immediately: immediately,
	            constraints: true
	        });
	    },
	
	    /**
	     * Zooms so the image just fills the viewer vertically.
	     * @param {Boolean} immediately
	     * @return {OpenSeadragon.Viewport} Chainable.
	     */
	    fitVertically: function(immediately) {
	        var box = new $.Rect(
	            this._contentBounds.x + (this._contentBounds.width / 2),
	            this._contentBounds.y,
	            0,
	            this._contentBounds.height);
	        return this.fitBounds(box, immediately);
	    },
	
	    /**
	     * Zooms so the image just fills the viewer horizontally.
	     * @param {Boolean} immediately
	     * @return {OpenSeadragon.Viewport} Chainable.
	     */
	    fitHorizontally: function(immediately) {
	        var box = new $.Rect(
	            this._contentBounds.x,
	            this._contentBounds.y + (this._contentBounds.height / 2),
	            this._contentBounds.width,
	            0);
	        return this.fitBounds(box, immediately);
	    },
	
	
	    /**
	     * Returns bounds taking constraints into account
	     * Added to improve constrained panning
	     * @param {Boolean} current - Pass true for the current location; defaults to false (target location).
	     * @return {OpenSeadragon.Viewport} Chainable.
	     */
	    getConstrainedBounds: function(current) {
	        var bounds,
	            constrainedBounds;
	
	        bounds = this.getBounds(current);
	
	        constrainedBounds = this._applyBoundaryConstraints(bounds);
	
	        return constrainedBounds;
	    },
	
	    /**
	     * @function
	     * @param {OpenSeadragon.Point} delta
	     * @param {Boolean} immediately
	     * @return {OpenSeadragon.Viewport} Chainable.
	     * @fires OpenSeadragon.Viewer.event:pan
	     */
	    panBy: function( delta, immediately ) {
	        var center = new $.Point(
	            this.centerSpringX.target.value,
	            this.centerSpringY.target.value
	        );
	        return this.panTo( center.plus( delta ), immediately );
	    },
	
	    /**
	     * @function
	     * @param {OpenSeadragon.Point} center
	     * @param {Boolean} immediately
	     * @return {OpenSeadragon.Viewport} Chainable.
	     * @fires OpenSeadragon.Viewer.event:pan
	     */
	    panTo: function( center, immediately ) {
	        if ( immediately ) {
	            this.centerSpringX.resetTo( center.x );
	            this.centerSpringY.resetTo( center.y );
	        } else {
	            this.centerSpringX.springTo( center.x );
	            this.centerSpringY.springTo( center.y );
	        }
	
	        if( this.viewer ){
	            /**
	             * Raised when the viewport is panned (see {@link OpenSeadragon.Viewport#panBy} and {@link OpenSeadragon.Viewport#panTo}).
	             *
	             * @event pan
	             * @memberof OpenSeadragon.Viewer
	             * @type {object}
	             * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised this event.
	             * @property {OpenSeadragon.Point} center
	             * @property {Boolean} immediately
	             * @property {?Object} userData - Arbitrary subscriber-defined object.
	             */
	            this.viewer.raiseEvent( 'pan', {
	                center: center,
	                immediately: immediately
	            });
	        }
	
	        return this;
	    },
	
	    /**
	     * @function
	     * @return {OpenSeadragon.Viewport} Chainable.
	     * @fires OpenSeadragon.Viewer.event:zoom
	     */
	    zoomBy: function(factor, refPoint, immediately) {
	        return this.zoomTo(
	            this.zoomSpring.target.value * factor, refPoint, immediately);
	    },
	
	    /**
	     * Zooms to the specified zoom level
	     * @function
	     * @param {Number} zoom The zoom level to zoom to.
	     * @param {OpenSeadragon.Point} [refPoint] The point which will stay at
	     * the same screen location. Defaults to the viewport center.
	     * @param {Boolean} [immediately=false]
	     * @return {OpenSeadragon.Viewport} Chainable.
	     * @fires OpenSeadragon.Viewer.event:zoom
	     */
	    zoomTo: function(zoom, refPoint, immediately) {
	        var _this = this;
	
	        this.zoomPoint = refPoint instanceof $.Point &&
	            !isNaN(refPoint.x) &&
	            !isNaN(refPoint.y) ?
	            refPoint :
	            null;
	
	        if (immediately) {
	            this._adjustCenterSpringsForZoomPoint(function() {
	                _this.zoomSpring.resetTo(zoom);
	            });
	        } else {
	            this.zoomSpring.springTo(zoom);
	        }
	
	        if (this.viewer) {
	            /**
	             * Raised when the viewport zoom level changes (see {@link OpenSeadragon.Viewport#zoomBy} and {@link OpenSeadragon.Viewport#zoomTo}).
	             *
	             * @event zoom
	             * @memberof OpenSeadragon.Viewer
	             * @type {object}
	             * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised this event.
	             * @property {Number} zoom
	             * @property {OpenSeadragon.Point} refPoint
	             * @property {Boolean} immediately
	             * @property {?Object} userData - Arbitrary subscriber-defined object.
	             */
	            this.viewer.raiseEvent('zoom', {
	                zoom: zoom,
	                refPoint: refPoint,
	                immediately: immediately
	            });
	        }
	
	        return this;
	    },
	
	    /**
	     * Rotates this viewport to the angle specified.
	     * @function
	     * @return {OpenSeadragon.Viewport} Chainable.
	     */
	    setRotation: function(degrees) {
	        if (!this.viewer || !this.viewer.drawer.canRotate()) {
	            return this;
	        }
	        this.degrees = $.positiveModulo(degrees, 360);
	        this._setContentBounds(
	            this.viewer.world.getHomeBounds(),
	            this.viewer.world.getContentFactor());
	        this.viewer.forceRedraw();
	
	        /**
	         * Raised when rotation has been changed.
	         *
	         * @event rotate
	         * @memberof OpenSeadragon.Viewer
	         * @type {object}
	         * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised the event.
	         * @property {Number} degrees - The number of degrees the rotation was set to.
	         * @property {?Object} userData - Arbitrary subscriber-defined object.
	         */
	        this.viewer.raiseEvent('rotate', {"degrees": degrees});
	        return this;
	    },
	
	    /**
	     * Gets the current rotation in degrees.
	     * @function
	     * @return {Number} The current rotation in degrees.
	     */
	    getRotation: function() {
	        return this.degrees;
	    },
	
	    /**
	     * @function
	     * @return {OpenSeadragon.Viewport} Chainable.
	     * @fires OpenSeadragon.Viewer.event:resize
	     */
	    resize: function( newContainerSize, maintain ) {
	        var oldBounds = this.getBoundsNoRotate(),
	            newBounds = oldBounds,
	            widthDeltaFactor;
	
	        this.containerSize.x = newContainerSize.x;
	        this.containerSize.y = newContainerSize.y;
	
	        this._updateContainerInnerSize();
	
	        if ( maintain ) {
	            // TODO: widthDeltaFactor will always be 1; probably not what's intended
	            widthDeltaFactor = newContainerSize.x / this.containerSize.x;
	            newBounds.width  = oldBounds.width * widthDeltaFactor;
	            newBounds.height = newBounds.width / this.getAspectRatio();
	        }
	
	        if( this.viewer ){
	            /**
	             * Raised when the viewer is resized (see {@link OpenSeadragon.Viewport#resize}).
	             *
	             * @event resize
	             * @memberof OpenSeadragon.Viewer
	             * @type {object}
	             * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised this event.
	             * @property {OpenSeadragon.Point} newContainerSize
	             * @property {Boolean} maintain
	             * @property {?Object} userData - Arbitrary subscriber-defined object.
	             */
	            this.viewer.raiseEvent( 'resize', {
	                newContainerSize: newContainerSize,
	                maintain: maintain
	            });
	        }
	
	        return this.fitBounds( newBounds, true );
	    },
	
	    // private
	    _updateContainerInnerSize: function() {
	        this._containerInnerSize = new $.Point(
	            Math.max(1, this.containerSize.x - (this._margins.left + this._margins.right)),
	            Math.max(1, this.containerSize.y - (this._margins.top + this._margins.bottom))
	        );
	    },
	
	    /**
	     * Update the zoom and center (X and Y) springs.
	     * @function
	     * @returns {Boolean} True if any change has been made, false otherwise.
	     */
	    update: function() {
	        var _this = this;
	        this._adjustCenterSpringsForZoomPoint(function() {
	            _this.zoomSpring.update();
	        });
	
	        this.centerSpringX.update();
	        this.centerSpringY.update();
	
	        var changed = this.centerSpringX.current.value !== this._oldCenterX ||
	            this.centerSpringY.current.value !== this._oldCenterY ||
	            this.zoomSpring.current.value !== this._oldZoom;
	
	        this._oldCenterX = this.centerSpringX.current.value;
	        this._oldCenterY = this.centerSpringY.current.value;
	        this._oldZoom    = this.zoomSpring.current.value;
	
	        return changed;
	    },
	
	    _adjustCenterSpringsForZoomPoint: function(zoomSpringHandler) {
	        if (this.zoomPoint) {
	            var oldZoomPixel = this.pixelFromPoint(this.zoomPoint, true);
	            zoomSpringHandler();
	            var newZoomPixel = this.pixelFromPoint(this.zoomPoint, true);
	
	            var deltaZoomPixels = newZoomPixel.minus(oldZoomPixel);
	            var deltaZoomPoints = this.deltaPointsFromPixels(
	                deltaZoomPixels, true);
	
	            this.centerSpringX.shiftBy(deltaZoomPoints.x);
	            this.centerSpringY.shiftBy(deltaZoomPoints.y);
	
	            if (this.zoomSpring.isAtTargetValue()) {
	                this.zoomPoint = null;
	            }
	        } else {
	            zoomSpringHandler();
	        }
	    },
	
	    /**
	     * Convert a delta (translation vector) from viewport coordinates to pixels
	     * coordinates. This method does not take rotation into account.
	     * Consider using deltaPixelsFromPoints if you need to account for rotation.
	     * @param {OpenSeadragon.Point} deltaPoints - The translation vector to convert.
	     * @param {Boolean} [current=false] - Pass true for the current location;
	     * defaults to false (target location).
	     * @returns {OpenSeadragon.Point}
	     */
	    deltaPixelsFromPointsNoRotate: function(deltaPoints, current) {
	        return deltaPoints.times(
	            this._containerInnerSize.x * this.getZoom(current)
	        );
	    },
	
	    /**
	     * Convert a delta (translation vector) from viewport coordinates to pixels
	     * coordinates.
	     * @param {OpenSeadragon.Point} deltaPoints - The translation vector to convert.
	     * @param {Boolean} [current=false] - Pass true for the current location;
	     * defaults to false (target location).
	     * @returns {OpenSeadragon.Point}
	     */
	    deltaPixelsFromPoints: function(deltaPoints, current) {
	        return this.deltaPixelsFromPointsNoRotate(
	            deltaPoints.rotate(this.getRotation()),
	            current);
	    },
	
	    /**
	     * Convert a delta (translation vector) from pixels coordinates to viewport
	     * coordinates. This method does not take rotation into account.
	     * Consider using deltaPointsFromPixels if you need to account for rotation.
	     * @param {OpenSeadragon.Point} deltaPixels - The translation vector to convert.
	     * @param {Boolean} [current=false] - Pass true for the current location;
	     * defaults to false (target location).
	     * @returns {OpenSeadragon.Point}
	     */
	    deltaPointsFromPixelsNoRotate: function(deltaPixels, current) {
	        return deltaPixels.divide(
	            this._containerInnerSize.x * this.getZoom(current)
	        );
	    },
	
	    /**
	     * Convert a delta (translation vector) from pixels coordinates to viewport
	     * coordinates.
	     * @param {OpenSeadragon.Point} deltaPixels - The translation vector to convert.
	     * @param {Boolean} [current=false] - Pass true for the current location;
	     * defaults to false (target location).
	     * @returns {OpenSeadragon.Point}
	     */
	    deltaPointsFromPixels: function(deltaPixels, current) {
	        return this.deltaPointsFromPixelsNoRotate(deltaPixels, current)
	            .rotate(-this.getRotation());
	    },
	
	    /**
	     * Convert viewport coordinates to pixels coordinates.
	     * This method does not take rotation into account.
	     * Consider using pixelFromPoint if you need to account for rotation.
	     * @param {OpenSeadragon.Point} point the viewport coordinates
	     * @param {Boolean} [current=false] - Pass true for the current location;
	     * defaults to false (target location).
	     * @returns {OpenSeadragon.Point}
	     */
	    pixelFromPointNoRotate: function(point, current) {
	        return this._pixelFromPointNoRotate(
	            point, this.getBoundsNoRotate(current));
	    },
	
	    /**
	     * Convert viewport coordinates to pixel coordinates.
	     * @param {OpenSeadragon.Point} point the viewport coordinates
	     * @param {Boolean} [current=false] - Pass true for the current location;
	     * defaults to false (target location).
	     * @returns {OpenSeadragon.Point}
	     */
	    pixelFromPoint: function(point, current) {
	        return this._pixelFromPoint(point, this.getBoundsNoRotate(current));
	    },
	
	    // private
	    _pixelFromPointNoRotate: function(point, bounds) {
	        return point.minus(
	            bounds.getTopLeft()
	        ).times(
	            this._containerInnerSize.x / bounds.width
	        ).plus(
	            new $.Point(this._margins.left, this._margins.top)
	        );
	    },
	
	    // private
	    _pixelFromPoint: function(point, bounds) {
	        return this._pixelFromPointNoRotate(
	            point.rotate(this.getRotation(), this.getCenter(true)),
	            bounds);
	    },
	
	    /**
	     * Convert pixel coordinates to viewport coordinates.
	     * This method does not take rotation into account.
	     * Consider using pointFromPixel if you need to account for rotation.
	     * @param {OpenSeadragon.Point} pixel Pixel coordinates
	     * @param {Boolean} [current=false] - Pass true for the current location;
	     * defaults to false (target location).
	     * @returns {OpenSeadragon.Point}
	     */
	    pointFromPixelNoRotate: function(pixel, current) {
	        var bounds = this.getBoundsNoRotate(current);
	        return pixel.minus(
	            new $.Point(this._margins.left, this._margins.top)
	        ).divide(
	            this._containerInnerSize.x / bounds.width
	        ).plus(
	            bounds.getTopLeft()
	        );
	    },
	
	    /**
	     * Convert pixel coordinates to viewport coordinates.
	     * @param {OpenSeadragon.Point} pixel Pixel coordinates
	     * @param {Boolean} [current=false] - Pass true for the current location;
	     * defaults to false (target location).
	     * @returns {OpenSeadragon.Point}
	     */
	    pointFromPixel: function(pixel, current) {
	        return this.pointFromPixelNoRotate(pixel, current).rotate(
	            -this.getRotation(),
	            this.getCenter(true)
	        );
	    },
	
	    // private
	    _viewportToImageDelta: function( viewerX, viewerY ) {
	        var scale = this._contentBoundsNoRotate.width;
	        return new $.Point(
	            viewerX * this._contentSizeNoRotate.x / scale,
	            viewerY * this._contentSizeNoRotate.x / scale);
	    },
	
	    /**
	     * Translates from OpenSeadragon viewer coordinate system to image coordinate system.
	     * This method can be called either by passing X,Y coordinates or an
	     * OpenSeadragon.Point
	     * Note: not accurate with multi-image; use TiledImage.viewportToImageCoordinates instead.
	     * @function
	     * @param {(OpenSeadragon.Point|Number)} viewerX either a point or the X
	     * coordinate in viewport coordinate system.
	     * @param {Number} [viewerY] Y coordinate in viewport coordinate system.
	     * @return {OpenSeadragon.Point} a point representing the coordinates in the image.
	     */
	    viewportToImageCoordinates: function(viewerX, viewerY) {
	        if (viewerX instanceof $.Point) {
	            //they passed a point instead of individual components
	            return this.viewportToImageCoordinates(viewerX.x, viewerX.y);
	        }
	
	        if (this.viewer) {
	            var count = this.viewer.world.getItemCount();
	            if (count > 1) {
	                $.console.error('[Viewport.viewportToImageCoordinates] is not accurate ' +
	                    'with multi-image; use TiledImage.viewportToImageCoordinates instead.');
	            } else if (count === 1) {
	                // It is better to use TiledImage.viewportToImageCoordinates
	                // because this._contentBoundsNoRotate can not be relied on
	                // with clipping.
	                var item = this.viewer.world.getItemAt(0);
	                return item.viewportToImageCoordinates(viewerX, viewerY, true);
	            }
	        }
	
	        return this._viewportToImageDelta(
	            viewerX - this._contentBoundsNoRotate.x,
	            viewerY - this._contentBoundsNoRotate.y);
	    },
	
	    // private
	    _imageToViewportDelta: function( imageX, imageY ) {
	        var scale = this._contentBoundsNoRotate.width;
	        return new $.Point(
	            imageX / this._contentSizeNoRotate.x * scale,
	            imageY / this._contentSizeNoRotate.x * scale);
	    },
	
	    /**
	     * Translates from image coordinate system to OpenSeadragon viewer coordinate system
	     * This method can be called either by passing X,Y coordinates or an
	     * OpenSeadragon.Point
	     * Note: not accurate with multi-image; use TiledImage.imageToViewportCoordinates instead.
	     * @function
	     * @param {(OpenSeadragon.Point | Number)} imageX the point or the
	     * X coordinate in image coordinate system.
	     * @param {Number} [imageY] Y coordinate in image coordinate system.
	     * @return {OpenSeadragon.Point} a point representing the coordinates in the viewport.
	     */
	    imageToViewportCoordinates: function(imageX, imageY) {
	        if (imageX instanceof $.Point) {
	            //they passed a point instead of individual components
	            return this.imageToViewportCoordinates(imageX.x, imageX.y);
	        }
	
	        if (this.viewer) {
	            var count = this.viewer.world.getItemCount();
	            if (count > 1) {
	                $.console.error('[Viewport.imageToViewportCoordinates] is not accurate ' +
	                    'with multi-image; use TiledImage.imageToViewportCoordinates instead.');
	            } else if (count === 1) {
	                // It is better to use TiledImage.viewportToImageCoordinates
	                // because this._contentBoundsNoRotate can not be relied on
	                // with clipping.
	                var item = this.viewer.world.getItemAt(0);
	                return item.imageToViewportCoordinates(imageX, imageY, true);
	            }
	        }
	
	        var point = this._imageToViewportDelta(imageX, imageY);
	        point.x += this._contentBoundsNoRotate.x;
	        point.y += this._contentBoundsNoRotate.y;
	        return point;
	    },
	
	    /**
	     * Translates from a rectangle which describes a portion of the image in
	     * pixel coordinates to OpenSeadragon viewport rectangle coordinates.
	     * This method can be called either by passing X,Y,width,height or an
	     * OpenSeadragon.Rect
	     * Note: not accurate with multi-image; use TiledImage.imageToViewportRectangle instead.
	     * @function
	     * @param {(OpenSeadragon.Rect | Number)} imageX the rectangle or the X
	     * coordinate of the top left corner of the rectangle in image coordinate system.
	     * @param {Number} [imageY] the Y coordinate of the top left corner of the rectangle
	     * in image coordinate system.
	     * @param {Number} [pixelWidth] the width in pixel of the rectangle.
	     * @param {Number} [pixelHeight] the height in pixel of the rectangle.
	     * @returns {OpenSeadragon.Rect} This image's bounds in viewport coordinates
	     */
	    imageToViewportRectangle: function(imageX, imageY, pixelWidth, pixelHeight) {
	        var rect = imageX;
	        if (!(rect instanceof $.Rect)) {
	            //they passed individual components instead of a rectangle
	            rect = new $.Rect(imageX, imageY, pixelWidth, pixelHeight);
	        }
	
	        if (this.viewer) {
	            var count = this.viewer.world.getItemCount();
	            if (count > 1) {
	                $.console.error('[Viewport.imageToViewportRectangle] is not accurate ' +
	                    'with multi-image; use TiledImage.imageToViewportRectangle instead.');
	            } else if (count === 1) {
	                // It is better to use TiledImage.imageToViewportRectangle
	                // because this._contentBoundsNoRotate can not be relied on
	                // with clipping.
	                var item = this.viewer.world.getItemAt(0);
	                return item.imageToViewportRectangle(
	                    imageX, imageY, pixelWidth, pixelHeight, true);
	            }
	        }
	
	        var coordA = this.imageToViewportCoordinates(rect.x, rect.y);
	        var coordB = this._imageToViewportDelta(rect.width, rect.height);
	        return new $.Rect(
	            coordA.x,
	            coordA.y,
	            coordB.x,
	            coordB.y,
	            rect.degrees
	        );
	    },
	
	    /**
	     * Translates from a rectangle which describes a portion of
	     * the viewport in point coordinates to image rectangle coordinates.
	     * This method can be called either by passing X,Y,width,height or an
	     * OpenSeadragon.Rect
	     * Note: not accurate with multi-image; use TiledImage.viewportToImageRectangle instead.
	     * @function
	     * @param {(OpenSeadragon.Rect | Number)} viewerX either a rectangle or
	     * the X coordinate of the top left corner of the rectangle in viewport
	     * coordinate system.
	     * @param {Number} [viewerY] the Y coordinate of the top left corner of the rectangle
	     * in viewport coordinate system.
	     * @param {Number} [pointWidth] the width of the rectangle in viewport coordinate system.
	     * @param {Number} [pointHeight] the height of the rectangle in viewport coordinate system.
	     */
	    viewportToImageRectangle: function(viewerX, viewerY, pointWidth, pointHeight) {
	        var rect = viewerX;
	        if (!(rect instanceof $.Rect)) {
	            //they passed individual components instead of a rectangle
	            rect = new $.Rect(viewerX, viewerY, pointWidth, pointHeight);
	        }
	
	        if (this.viewer) {
	            var count = this.viewer.world.getItemCount();
	            if (count > 1) {
	                $.console.error('[Viewport.viewportToImageRectangle] is not accurate ' +
	                    'with multi-image; use TiledImage.viewportToImageRectangle instead.');
	            } else if (count === 1) {
	                // It is better to use TiledImage.viewportToImageCoordinates
	                // because this._contentBoundsNoRotate can not be relied on
	                // with clipping.
	                var item = this.viewer.world.getItemAt(0);
	                return item.viewportToImageRectangle(
	                    viewerX, viewerY, pointWidth, pointHeight, true);
	            }
	        }
	
	        var coordA = this.viewportToImageCoordinates(rect.x, rect.y);
	        var coordB = this._viewportToImageDelta(rect.width, rect.height);
	        return new $.Rect(
	            coordA.x,
	            coordA.y,
	            coordB.x,
	            coordB.y,
	            rect.degrees
	        );
	    },
	
	    /**
	     * Convert pixel coordinates relative to the viewer element to image
	     * coordinates.
	     * Note: not accurate with multi-image.
	     * @param {OpenSeadragon.Point} pixel
	     * @returns {OpenSeadragon.Point}
	     */
	    viewerElementToImageCoordinates: function( pixel ) {
	        var point = this.pointFromPixel( pixel, true );
	        return this.viewportToImageCoordinates( point );
	    },
	
	    /**
	     * Convert pixel coordinates relative to the image to
	     * viewer element coordinates.
	     * Note: not accurate with multi-image.
	     * @param {OpenSeadragon.Point} pixel
	     * @returns {OpenSeadragon.Point}
	     */
	    imageToViewerElementCoordinates: function( pixel ) {
	        var point = this.imageToViewportCoordinates( pixel );
	        return this.pixelFromPoint( point, true );
	    },
	
	    /**
	     * Convert pixel coordinates relative to the window to image coordinates.
	     * Note: not accurate with multi-image.
	     * @param {OpenSeadragon.Point} pixel
	     * @returns {OpenSeadragon.Point}
	     */
	    windowToImageCoordinates: function(pixel) {
	        $.console.assert(this.viewer,
	            "[Viewport.windowToImageCoordinates] the viewport must have a viewer.");
	        var viewerCoordinates = pixel.minus(
	                $.getElementPosition(this.viewer.element));
	        return this.viewerElementToImageCoordinates(viewerCoordinates);
	    },
	
	    /**
	     * Convert image coordinates to pixel coordinates relative to the window.
	     * Note: not accurate with multi-image.
	     * @param {OpenSeadragon.Point} pixel
	     * @returns {OpenSeadragon.Point}
	     */
	    imageToWindowCoordinates: function(pixel) {
	        $.console.assert(this.viewer,
	            "[Viewport.imageToWindowCoordinates] the viewport must have a viewer.");
	        var viewerCoordinates = this.imageToViewerElementCoordinates(pixel);
	        return viewerCoordinates.plus(
	                $.getElementPosition(this.viewer.element));
	    },
	
	    /**
	     * Convert pixel coordinates relative to the viewer element to viewport
	     * coordinates.
	     * @param {OpenSeadragon.Point} pixel
	     * @returns {OpenSeadragon.Point}
	     */
	    viewerElementToViewportCoordinates: function( pixel ) {
	        return this.pointFromPixel( pixel, true );
	    },
	
	    /**
	     * Convert viewport coordinates to pixel coordinates relative to the
	     * viewer element.
	     * @param {OpenSeadragon.Point} point
	     * @returns {OpenSeadragon.Point}
	     */
	    viewportToViewerElementCoordinates: function( point ) {
	        return this.pixelFromPoint( point, true );
	    },
	
	    /**
	     * Convert a rectangle in pixel coordinates relative to the viewer element
	     * to viewport coordinates.
	     * @param {OpenSeadragon.Rect} rectangle the rectangle to convert
	     * @returns {OpenSeadragon.Rect} the converted rectangle
	     */
	    viewerElementToViewportRectangle: function(rectangle) {
	        return $.Rect.fromSummits(
	            this.pointFromPixel(rectangle.getTopLeft(), true),
	            this.pointFromPixel(rectangle.getTopRight(), true),
	            this.pointFromPixel(rectangle.getBottomLeft(), true)
	        );
	    },
	
	    /**
	     * Convert a rectangle in viewport coordinates to pixel coordinates relative
	     * to the viewer element.
	     * @param {OpenSeadragon.Rect} rectangle the rectangle to convert
	     * @returns {OpenSeadragon.Rect} the converted rectangle
	     */
	    viewportToViewerElementRectangle: function(rectangle) {
	        return $.Rect.fromSummits(
	            this.pixelFromPoint(rectangle.getTopLeft(), true),
	            this.pixelFromPoint(rectangle.getTopRight(), true),
	            this.pixelFromPoint(rectangle.getBottomLeft(), true)
	        );
	    },
	
	    /**
	     * Convert pixel coordinates relative to the window to viewport coordinates.
	     * @param {OpenSeadragon.Point} pixel
	     * @returns {OpenSeadragon.Point}
	     */
	    windowToViewportCoordinates: function(pixel) {
	        $.console.assert(this.viewer,
	            "[Viewport.windowToViewportCoordinates] the viewport must have a viewer.");
	        var viewerCoordinates = pixel.minus(
	                $.getElementPosition(this.viewer.element));
	        return this.viewerElementToViewportCoordinates(viewerCoordinates);
	    },
	
	    /**
	     * Convert viewport coordinates to pixel coordinates relative to the window.
	     * @param {OpenSeadragon.Point} point
	     * @returns {OpenSeadragon.Point}
	     */
	    viewportToWindowCoordinates: function(point) {
	        $.console.assert(this.viewer,
	            "[Viewport.viewportToWindowCoordinates] the viewport must have a viewer.");
	        var viewerCoordinates = this.viewportToViewerElementCoordinates(point);
	        return viewerCoordinates.plus(
	                $.getElementPosition(this.viewer.element));
	    },
	
	    /**
	     * Convert a viewport zoom to an image zoom.
	     * Image zoom: ratio of the original image size to displayed image size.
	     * 1 means original image size, 0.5 half size...
	     * Viewport zoom: ratio of the displayed image's width to viewport's width.
	     * 1 means identical width, 2 means image's width is twice the viewport's width...
	     * Note: not accurate with multi-image.
	     * @function
	     * @param {Number} viewportZoom The viewport zoom
	     * target zoom.
	     * @returns {Number} imageZoom The image zoom
	     */
	    viewportToImageZoom: function(viewportZoom) {
	        if (this.viewer) {
	            var count = this.viewer.world.getItemCount();
	            if (count > 1) {
	                $.console.error('[Viewport.viewportToImageZoom] is not ' +
	                    'accurate with multi-image.');
	            } else if (count === 1) {
	                // It is better to use TiledImage.viewportToImageZoom
	                // because this._contentBoundsNoRotate can not be relied on
	                // with clipping.
	                var item = this.viewer.world.getItemAt(0);
	                return item.viewportToImageZoom(viewportZoom);
	            }
	        }
	
	        var imageWidth = this._contentSizeNoRotate.x;
	        var containerWidth = this._containerInnerSize.x;
	        var scale = this._contentBoundsNoRotate.width;
	        var viewportToImageZoomRatio = (containerWidth / imageWidth) * scale;
	        return viewportZoom * viewportToImageZoomRatio;
	    },
	
	    /**
	     * Convert an image zoom to a viewport zoom.
	     * Image zoom: ratio of the original image size to displayed image size.
	     * 1 means original image size, 0.5 half size...
	     * Viewport zoom: ratio of the displayed image's width to viewport's width.
	     * 1 means identical width, 2 means image's width is twice the viewport's width...
	     * Note: not accurate with multi-image.
	     * @function
	     * @param {Number} imageZoom The image zoom
	     * target zoom.
	     * @returns {Number} viewportZoom The viewport zoom
	     */
	    imageToViewportZoom: function(imageZoom) {
	        if (this.viewer) {
	            var count = this.viewer.world.getItemCount();
	            if (count > 1) {
	                $.console.error('[Viewport.imageToViewportZoom] is not accurate ' +
	                    'with multi-image.');
	            } else if (count === 1) {
	                // It is better to use TiledImage.imageToViewportZoom
	                // because this._contentBoundsNoRotate can not be relied on
	                // with clipping.
	                var item = this.viewer.world.getItemAt(0);
	                return item.imageToViewportZoom(imageZoom);
	            }
	        }
	
	        var imageWidth = this._contentSizeNoRotate.x;
	        var containerWidth = this._containerInnerSize.x;
	        var scale = this._contentBoundsNoRotate.width;
	        var viewportToImageZoomRatio = (imageWidth / containerWidth) / scale;
	        return imageZoom * viewportToImageZoomRatio;
	    },
	
	    /**
	     * Toggles flip state and demands a new drawing on navigator and viewer objects.
	     * @function
	     * @return {OpenSeadragon.Viewport} Chainable.
	     */
	    toggleFlip: function() {
	      this.setFlip(!this.getFlip());
	      return this;
	    },
	
	    /**
	     * Gets flip state stored on viewport.
	     * @function
	     * @return {Boolean} Flip state.
	     */
	    getFlip: function() {
	      return this.flipped;
	    },
	
	    /**
	     * Sets flip state according to the state input argument.
	     * @function
	     * @param {Boolean} state - Flip state to set.
	     * @return {OpenSeadragon.Viewport} Chainable.
	     */
	    setFlip: function( state ) {
	      if ( this.flipped === state ) {
	        return this;
	      }
	
	      this.flipped = state;
	      if(this.viewer.navigator){
	        this.viewer.navigator.setFlip(this.getFlip());
	      }
	      this.viewer.forceRedraw();
	
	      /**
	       * Raised when flip state has been changed.
	       *
	       * @event flip
	       * @memberof OpenSeadragon.Viewer
	       * @type {object}
	       * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised the event.
	       * @property {Number} flipped - The flip state after this change.
	       * @property {?Object} userData - Arbitrary subscriber-defined object.
	       */
	      this.viewer.raiseEvent('flip', {"flipped": state});
	      return this;
	    }
	
	};
	
	}( OpenSeadragon ));
	
	/*
	 * OpenSeadragon - TiledImage
	 *
	 * Copyright (C) 2009 CodePlex Foundation
	 * Copyright (C) 2010-2013 OpenSeadragon contributors
	 *
	 * Redistribution and use in source and binary forms, with or without
	 * modification, are permitted provided that the following conditions are
	 * met:
	 *
	 * - Redistributions of source code must retain the above copyright notice,
	 *   this list of conditions and the following disclaimer.
	 *
	 * - Redistributions in binary form must reproduce the above copyright
	 *   notice, this list of conditions and the following disclaimer in the
	 *   documentation and/or other materials provided with the distribution.
	 *
	 * - Neither the name of CodePlex Foundation nor the names of its
	 *   contributors may be used to endorse or promote products derived from
	 *   this software without specific prior written permission.
	 *
	 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
	 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
	 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
	 * A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT
	 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
	 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
	 * TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 * PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
	 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
	 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
	 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	 */
	
	(function( $ ){
	
	/**
	 * You shouldn't have to create a TiledImage instance directly; get it asynchronously by
	 * using {@link OpenSeadragon.Viewer#open} or {@link OpenSeadragon.Viewer#addTiledImage} instead.
	 * @class TiledImage
	 * @memberof OpenSeadragon
	 * @extends OpenSeadragon.EventSource
	 * @classdesc Handles rendering of tiles for an {@link OpenSeadragon.Viewer}.
	 * A new instance is created for each TileSource opened.
	 * @param {Object} options - Configuration for this TiledImage.
	 * @param {OpenSeadragon.TileSource} options.source - The TileSource that defines this TiledImage.
	 * @param {OpenSeadragon.Viewer} options.viewer - The Viewer that owns this TiledImage.
	 * @param {OpenSeadragon.TileCache} options.tileCache - The TileCache for this TiledImage to use.
	 * @param {OpenSeadragon.Drawer} options.drawer - The Drawer for this TiledImage to draw onto.
	 * @param {OpenSeadragon.ImageLoader} options.imageLoader - The ImageLoader for this TiledImage to use.
	 * @param {Number} [options.x=0] - Left position, in viewport coordinates.
	 * @param {Number} [options.y=0] - Top position, in viewport coordinates.
	 * @param {Number} [options.width=1] - Width, in viewport coordinates.
	 * @param {Number} [options.height] - Height, in viewport coordinates.
	 * @param {OpenSeadragon.Rect} [options.fitBounds] The bounds in viewport coordinates
	 * to fit the image into. If specified, x, y, width and height get ignored.
	 * @param {OpenSeadragon.Placement} [options.fitBoundsPlacement=OpenSeadragon.Placement.CENTER]
	 * How to anchor the image in the bounds if options.fitBounds is set.
	 * @param {OpenSeadragon.Rect} [options.clip] - An area, in image pixels, to clip to
	 * (portions of the image outside of this area will not be visible). Only works on
	 * browsers that support the HTML5 canvas.
	 * @param {Number} [options.springStiffness] - See {@link OpenSeadragon.Options}.
	 * @param {Boolean} [options.animationTime] - See {@link OpenSeadragon.Options}.
	 * @param {Number} [options.minZoomImageRatio] - See {@link OpenSeadragon.Options}.
	 * @param {Boolean} [options.wrapHorizontal] - See {@link OpenSeadragon.Options}.
	 * @param {Boolean} [options.wrapVertical] - See {@link OpenSeadragon.Options}.
	 * @param {Boolean} [options.immediateRender] - See {@link OpenSeadragon.Options}.
	 * @param {Number} [options.blendTime] - See {@link OpenSeadragon.Options}.
	 * @param {Boolean} [options.alwaysBlend] - See {@link OpenSeadragon.Options}.
	 * @param {Number} [options.minPixelRatio] - See {@link OpenSeadragon.Options}.
	 * @param {Number} [options.smoothTileEdgesMinZoom] - See {@link OpenSeadragon.Options}.
	 * @param {Boolean} [options.iOSDevice] - See {@link OpenSeadragon.Options}.
	 * @param {Number} [options.opacity=1] - Set to draw at proportional opacity. If zero, images will not draw.
	 * @param {Boolean} [options.preload=false] - Set true to load even when the image is hidden by zero opacity.
	 * @param {String} [options.compositeOperation] - How the image is composited onto other images; see compositeOperation in {@link OpenSeadragon.Options} for possible values.
	 * @param {Boolean} [options.debugMode] - See {@link OpenSeadragon.Options}.
	 * @param {String|CanvasGradient|CanvasPattern|Function} [options.placeholderFillStyle] - See {@link OpenSeadragon.Options}.
	 * @param {String|Boolean} [options.crossOriginPolicy] - See {@link OpenSeadragon.Options}.
	 * @param {Boolean} [options.ajaxWithCredentials] - See {@link OpenSeadragon.Options}.
	 * @param {Boolean} [options.loadTilesWithAjax]
	 *      Whether to load tile data using AJAX requests.
	 *      Defaults to the setting in {@link OpenSeadragon.Options}.
	 * @param {Object} [options.ajaxHeaders={}]
	 *      A set of headers to include when making tile AJAX requests.
	 */
	$.TiledImage = function( options ) {
	    var _this = this;
	    /**
	     * The {@link OpenSeadragon.TileSource} that defines this TiledImage.
	     * @member {OpenSeadragon.TileSource} source
	     * @memberof OpenSeadragon.TiledImage#
	     */
	    $.console.assert( options.tileCache, "[TiledImage] options.tileCache is required" );
	    $.console.assert( options.drawer, "[TiledImage] options.drawer is required" );
	    $.console.assert( options.viewer, "[TiledImage] options.viewer is required" );
	    $.console.assert( options.imageLoader, "[TiledImage] options.imageLoader is required" );
	    $.console.assert( options.source, "[TiledImage] options.source is required" );
	    $.console.assert(!options.clip || options.clip instanceof $.Rect,
	        "[TiledImage] options.clip must be an OpenSeadragon.Rect if present");
	
	    $.EventSource.call( this );
	
	    this._tileCache = options.tileCache;
	    delete options.tileCache;
	
	    this._drawer = options.drawer;
	    delete options.drawer;
	
	    this._imageLoader = options.imageLoader;
	    delete options.imageLoader;
	
	    if (options.clip instanceof $.Rect) {
	        this._clip = options.clip.clone();
	    }
	
	    delete options.clip;
	
	    var x = options.x || 0;
	    delete options.x;
	    var y = options.y || 0;
	    delete options.y;
	
	    // Ratio of zoomable image height to width.
	    this.normHeight = options.source.dimensions.y / options.source.dimensions.x;
	    this.contentAspectX = options.source.dimensions.x / options.source.dimensions.y;
	
	    var scale = 1;
	    if ( options.width ) {
	        scale = options.width;
	        delete options.width;
	
	        if ( options.height ) {
	            $.console.error( "specifying both width and height to a tiledImage is not supported" );
	            delete options.height;
	        }
	    } else if ( options.height ) {
	        scale = options.height / this.normHeight;
	        delete options.height;
	    }
	
	    var fitBounds = options.fitBounds;
	    delete options.fitBounds;
	    var fitBoundsPlacement = options.fitBoundsPlacement || OpenSeadragon.Placement.CENTER;
	    delete options.fitBoundsPlacement;
	
	    var degrees = options.degrees || 0;
	    delete options.degrees;
	
	    $.extend( true, this, {
	
	        //internal state properties
	        viewer:         null,
	        tilesMatrix:    {},    // A '3d' dictionary [level][x][y] --> Tile.
	        coverage:       {},    // A '3d' dictionary [level][x][y] --> Boolean; shows what areas have been drawn.
	        loadingCoverage: {},   // A '3d' dictionary [level][x][y] --> Boolean; shows what areas are loaded or are being loaded/blended.
	        lastDrawn:      [],    // An unordered list of Tiles drawn last frame.
	        lastResetTime:  0,     // Last time for which the tiledImage was reset.
	        _midDraw:       false, // Is the tiledImage currently updating the viewport?
	        _needsDraw:     true,  // Does the tiledImage need to update the viewport again?
	        _hasOpaqueTile: false,  // Do we have even one fully opaque tile?
	        _tilesLoading:  0,     // The number of pending tile requests.
	        //configurable settings
	        springStiffness:        $.DEFAULT_SETTINGS.springStiffness,
	        animationTime:          $.DEFAULT_SETTINGS.animationTime,
	        minZoomImageRatio:      $.DEFAULT_SETTINGS.minZoomImageRatio,
	        wrapHorizontal:         $.DEFAULT_SETTINGS.wrapHorizontal,
	        wrapVertical:           $.DEFAULT_SETTINGS.wrapVertical,
	        immediateRender:        $.DEFAULT_SETTINGS.immediateRender,
	        blendTime:              $.DEFAULT_SETTINGS.blendTime,
	        alwaysBlend:            $.DEFAULT_SETTINGS.alwaysBlend,
	        minPixelRatio:          $.DEFAULT_SETTINGS.minPixelRatio,
	        smoothTileEdgesMinZoom: $.DEFAULT_SETTINGS.smoothTileEdgesMinZoom,
	        iOSDevice:              $.DEFAULT_SETTINGS.iOSDevice,
	        debugMode:              $.DEFAULT_SETTINGS.debugMode,
	        crossOriginPolicy:      $.DEFAULT_SETTINGS.crossOriginPolicy,
	        ajaxWithCredentials:    $.DEFAULT_SETTINGS.ajaxWithCredentials,
	        placeholderFillStyle:   $.DEFAULT_SETTINGS.placeholderFillStyle,
	        opacity:                $.DEFAULT_SETTINGS.opacity,
	        preload:                $.DEFAULT_SETTINGS.preload,
	        compositeOperation:     $.DEFAULT_SETTINGS.compositeOperation
	    }, options );
	
	    this._preload = this.preload;
	    delete this.preload;
	
	    this._fullyLoaded = false;
	
	    this._xSpring = new $.Spring({
	        initial: x,
	        springStiffness: this.springStiffness,
	        animationTime: this.animationTime
	    });
	
	    this._ySpring = new $.Spring({
	        initial: y,
	        springStiffness: this.springStiffness,
	        animationTime: this.animationTime
	    });
	
	    this._scaleSpring = new $.Spring({
	        initial: scale,
	        springStiffness: this.springStiffness,
	        animationTime: this.animationTime
	    });
	
	    this._degreesSpring = new $.Spring({
	        initial: degrees,
	        springStiffness: this.springStiffness,
	        animationTime: this.animationTime
	    });
	
	    this._updateForScale();
	
	    if (fitBounds) {
	        this.fitBounds(fitBounds, fitBoundsPlacement, true);
	    }
	
	    // We need a callback to give image manipulation a chance to happen
	    this._drawingHandler = function(args) {
	      /**
	       * This event is fired just before the tile is drawn giving the application a chance to alter the image.
	       *
	       * NOTE: This event is only fired when the drawer is using a &lt;canvas&gt;.
	       *
	       * @event tile-drawing
	       * @memberof OpenSeadragon.Viewer
	       * @type {object}
	       * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised the event.
	       * @property {OpenSeadragon.Tile} tile - The Tile being drawn.
	       * @property {OpenSeadragon.TiledImage} tiledImage - Which TiledImage is being drawn.
	       * @property {OpenSeadragon.Tile} context - The HTML canvas context being drawn into.
	       * @property {OpenSeadragon.Tile} rendered - The HTML canvas context containing the tile imagery.
	       * @property {?Object} userData - Arbitrary subscriber-defined object.
	       */
	        _this.viewer.raiseEvent('tile-drawing', $.extend({
	            tiledImage: _this
	        }, args));
	    };
	};
	
	$.extend($.TiledImage.prototype, $.EventSource.prototype, /** @lends OpenSeadragon.TiledImage.prototype */{
	    /**
	     * @returns {Boolean} Whether the TiledImage needs to be drawn.
	     */
	    needsDraw: function() {
	        return this._needsDraw;
	    },
	
	    /**
	     * @returns {Boolean} Whether all tiles necessary for this TiledImage to draw at the current view have been loaded.
	     */
	    getFullyLoaded: function() {
	        return this._fullyLoaded;
	    },
	
	    // private
	    _setFullyLoaded: function(flag) {
	        if (flag === this._fullyLoaded) {
	            return;
	        }
	
	        this._fullyLoaded = flag;
	
	        /**
	         * Fired when the TiledImage's "fully loaded" flag (whether all tiles necessary for this TiledImage
	         * to draw at the current view have been loaded) changes.
	         *
	         * @event fully-loaded-change
	         * @memberof OpenSeadragon.TiledImage
	         * @type {object}
	         * @property {Boolean} fullyLoaded - The new "fully loaded" value.
	         * @property {OpenSeadragon.TiledImage} eventSource - A reference to the TiledImage which raised the event.
	         * @property {?Object} userData - Arbitrary subscriber-defined object.
	         */
	        this.raiseEvent('fully-loaded-change', {
	            fullyLoaded: this._fullyLoaded
	        });
	    },
	
	    /**
	     * Clears all tiles and triggers an update on the next call to
	     * {@link OpenSeadragon.TiledImage#update}.
	     */
	    reset: function() {
	        this._tileCache.clearTilesFor(this);
	        this.lastResetTime = $.now();
	        this._needsDraw = true;
	    },
	
	    /**
	     * Updates the TiledImage's bounds, animating if needed.
	     * @returns {Boolean} Whether the TiledImage animated.
	     */
	    update: function() {
	        var xUpdated = this._xSpring.update();
	        var yUpdated = this._ySpring.update();
	        var scaleUpdated = this._scaleSpring.update();
	        var degreesUpdated = this._degreesSpring.update();
	
	        if (xUpdated || yUpdated || scaleUpdated || degreesUpdated) {
	            this._updateForScale();
	            this._needsDraw = true;
	            return true;
	        }
	
	        return false;
	    },
	
	    /**
	     * Draws the TiledImage to its Drawer.
	     */
	    draw: function() {
	        if (this.opacity !== 0 || this._preload) {
	            this._midDraw = true;
	            this._updateViewport();
	            this._midDraw = false;
	        }
	        // Images with opacity 0 should not need to be drawn in future. this._needsDraw = false is set in this._updateViewport() for other images.
	        else {
	            this._needsDraw = false;
	        }
	    },
	
	    /**
	     * Destroy the TiledImage (unload current loaded tiles).
	     */
	    destroy: function() {
	        this.reset();
	    },
	
	    /**
	     * Get this TiledImage's bounds in viewport coordinates.
	     * @param {Boolean} [current=false] - Pass true for the current location;
	     * false for target location.
	     * @returns {OpenSeadragon.Rect} This TiledImage's bounds in viewport coordinates.
	     */
	    getBounds: function(current) {
	        return this.getBoundsNoRotate(current)
	            .rotate(this.getRotation(current), this._getRotationPoint(current));
	    },
	
	    /**
	     * Get this TiledImage's bounds in viewport coordinates without taking
	     * rotation into account.
	     * @param {Boolean} [current=false] - Pass true for the current location;
	     * false for target location.
	     * @returns {OpenSeadragon.Rect} This TiledImage's bounds in viewport coordinates.
	     */
	    getBoundsNoRotate: function(current) {
	        return current ?
	            new $.Rect(
	                this._xSpring.current.value,
	                this._ySpring.current.value,
	                this._worldWidthCurrent,
	                this._worldHeightCurrent) :
	            new $.Rect(
	                this._xSpring.target.value,
	                this._ySpring.target.value,
	                this._worldWidthTarget,
	                this._worldHeightTarget);
	    },
	
	    // deprecated
	    getWorldBounds: function() {
	        $.console.error('[TiledImage.getWorldBounds] is deprecated; use TiledImage.getBounds instead');
	        return this.getBounds();
	    },
	
	    /**
	     * Get the bounds of the displayed part of the tiled image.
	     * @param {Boolean} [current=false] Pass true for the current location,
	     * false for the target location.
	     * @returns {$.Rect} The clipped bounds in viewport coordinates.
	     */
	    getClippedBounds: function(current) {
	        var bounds = this.getBoundsNoRotate(current);
	        if (this._clip) {
	            var worldWidth = current ?
	                this._worldWidthCurrent : this._worldWidthTarget;
	            var ratio = worldWidth / this.source.dimensions.x;
	            var clip = this._clip.times(ratio);
	            bounds = new $.Rect(
	                bounds.x + clip.x,
	                bounds.y + clip.y,
	                clip.width,
	                clip.height);
	        }
	        return bounds.rotate(this.getRotation(current), this._getRotationPoint(current));
	    },
	
	    /**
	     * @returns {OpenSeadragon.Point} This TiledImage's content size, in original pixels.
	     */
	    getContentSize: function() {
	        return new $.Point(this.source.dimensions.x, this.source.dimensions.y);
	    },
	
	    // private
	    _viewportToImageDelta: function( viewerX, viewerY, current ) {
	        var scale = (current ? this._scaleSpring.current.value : this._scaleSpring.target.value);
	        return new $.Point(viewerX * (this.source.dimensions.x / scale),
	            viewerY * ((this.source.dimensions.y * this.contentAspectX) / scale));
	    },
	
	    /**
	     * Translates from OpenSeadragon viewer coordinate system to image coordinate system.
	     * This method can be called either by passing X,Y coordinates or an {@link OpenSeadragon.Point}.
	     * @param {Number|OpenSeadragon.Point} viewerX - The X coordinate or point in viewport coordinate system.
	     * @param {Number} [viewerY] - The Y coordinate in viewport coordinate system.
	     * @param {Boolean} [current=false] - Pass true to use the current location; false for target location.
	     * @return {OpenSeadragon.Point} A point representing the coordinates in the image.
	     */
	    viewportToImageCoordinates: function(viewerX, viewerY, current) {
	        var point;
	        if (viewerX instanceof $.Point) {
	            //they passed a point instead of individual components
	            current = viewerY;
	            point = viewerX;
	        } else {
	            point = new $.Point(viewerX, viewerY);
	        }
	
	        point = point.rotate(-this.getRotation(current), this._getRotationPoint(current));
	        return current ?
	            this._viewportToImageDelta(
	                point.x - this._xSpring.current.value,
	                point.y - this._ySpring.current.value) :
	            this._viewportToImageDelta(
	                point.x - this._xSpring.target.value,
	                point.y - this._ySpring.target.value);
	    },
	
	    // private
	    _imageToViewportDelta: function( imageX, imageY, current ) {
	        var scale = (current ? this._scaleSpring.current.value : this._scaleSpring.target.value);
	        return new $.Point((imageX / this.source.dimensions.x) * scale,
	            (imageY / this.source.dimensions.y / this.contentAspectX) * scale);
	    },
	
	    /**
	     * Translates from image coordinate system to OpenSeadragon viewer coordinate system
	     * This method can be called either by passing X,Y coordinates or an {@link OpenSeadragon.Point}.
	     * @param {Number|OpenSeadragon.Point} imageX - The X coordinate or point in image coordinate system.
	     * @param {Number} [imageY] - The Y coordinate in image coordinate system.
	     * @param {Boolean} [current=false] - Pass true to use the current location; false for target location.
	     * @return {OpenSeadragon.Point} A point representing the coordinates in the viewport.
	     */
	    imageToViewportCoordinates: function(imageX, imageY, current) {
	        if (imageX instanceof $.Point) {
	            //they passed a point instead of individual components
	            current = imageY;
	            imageY = imageX.y;
	            imageX = imageX.x;
	        }
	
	        var point = this._imageToViewportDelta(imageX, imageY);
	        if (current) {
	            point.x += this._xSpring.current.value;
	            point.y += this._ySpring.current.value;
	        } else {
	            point.x += this._xSpring.target.value;
	            point.y += this._ySpring.target.value;
	        }
	
	        return point.rotate(this.getRotation(current), this._getRotationPoint(current));
	    },
	
	    /**
	     * Translates from a rectangle which describes a portion of the image in
	     * pixel coordinates to OpenSeadragon viewport rectangle coordinates.
	     * This method can be called either by passing X,Y,width,height or an {@link OpenSeadragon.Rect}.
	     * @param {Number|OpenSeadragon.Rect} imageX - The left coordinate or rectangle in image coordinate system.
	     * @param {Number} [imageY] - The top coordinate in image coordinate system.
	     * @param {Number} [pixelWidth] - The width in pixel of the rectangle.
	     * @param {Number} [pixelHeight] - The height in pixel of the rectangle.
	     * @param {Boolean} [current=false] - Pass true to use the current location; false for target location.
	     * @return {OpenSeadragon.Rect} A rect representing the coordinates in the viewport.
	     */
	    imageToViewportRectangle: function(imageX, imageY, pixelWidth, pixelHeight, current) {
	        var rect = imageX;
	        if (rect instanceof $.Rect) {
	            //they passed a rect instead of individual components
	            current = imageY;
	        } else {
	            rect = new $.Rect(imageX, imageY, pixelWidth, pixelHeight);
	        }
	
	        var coordA = this.imageToViewportCoordinates(rect.getTopLeft(), current);
	        var coordB = this._imageToViewportDelta(rect.width, rect.height, current);
	
	        return new $.Rect(
	            coordA.x,
	            coordA.y,
	            coordB.x,
	            coordB.y,
	            rect.degrees + this.getRotation(current)
	        );
	    },
	
	    /**
	     * Translates from a rectangle which describes a portion of
	     * the viewport in point coordinates to image rectangle coordinates.
	     * This method can be called either by passing X,Y,width,height or an {@link OpenSeadragon.Rect}.
	     * @param {Number|OpenSeadragon.Rect} viewerX - The left coordinate or rectangle in viewport coordinate system.
	     * @param {Number} [viewerY] - The top coordinate in viewport coordinate system.
	     * @param {Number} [pointWidth] - The width in viewport coordinate system.
	     * @param {Number} [pointHeight] - The height in viewport coordinate system.
	     * @param {Boolean} [current=false] - Pass true to use the current location; false for target location.
	     * @return {OpenSeadragon.Rect} A rect representing the coordinates in the image.
	     */
	    viewportToImageRectangle: function( viewerX, viewerY, pointWidth, pointHeight, current ) {
	        var rect = viewerX;
	        if (viewerX instanceof $.Rect) {
	            //they passed a rect instead of individual components
	            current = viewerY;
	        } else {
	            rect = new $.Rect(viewerX, viewerY, pointWidth, pointHeight);
	        }
	
	        var coordA = this.viewportToImageCoordinates(rect.getTopLeft(), current);
	        var coordB = this._viewportToImageDelta(rect.width, rect.height, current);
	
	        return new $.Rect(
	            coordA.x,
	            coordA.y,
	            coordB.x,
	            coordB.y,
	            rect.degrees - this.getRotation(current)
	        );
	    },
	
	    /**
	     * Convert pixel coordinates relative to the viewer element to image
	     * coordinates.
	     * @param {OpenSeadragon.Point} pixel
	     * @returns {OpenSeadragon.Point}
	     */
	    viewerElementToImageCoordinates: function( pixel ) {
	        var point = this.viewport.pointFromPixel( pixel, true );
	        return this.viewportToImageCoordinates( point );
	    },
	
	    /**
	     * Convert pixel coordinates relative to the image to
	     * viewer element coordinates.
	     * @param {OpenSeadragon.Point} pixel
	     * @returns {OpenSeadragon.Point}
	     */
	    imageToViewerElementCoordinates: function( pixel ) {
	        var point = this.imageToViewportCoordinates( pixel );
	        return this.viewport.pixelFromPoint( point, true );
	    },
	
	    /**
	     * Convert pixel coordinates relative to the window to image coordinates.
	     * @param {OpenSeadragon.Point} pixel
	     * @returns {OpenSeadragon.Point}
	     */
	    windowToImageCoordinates: function( pixel ) {
	        var viewerCoordinates = pixel.minus(
	                OpenSeadragon.getElementPosition( this.viewer.element ));
	        return this.viewerElementToImageCoordinates( viewerCoordinates );
	    },
	
	    /**
	     * Convert image coordinates to pixel coordinates relative to the window.
	     * @param {OpenSeadragon.Point} pixel
	     * @returns {OpenSeadragon.Point}
	     */
	    imageToWindowCoordinates: function( pixel ) {
	        var viewerCoordinates = this.imageToViewerElementCoordinates( pixel );
	        return viewerCoordinates.plus(
	                OpenSeadragon.getElementPosition( this.viewer.element ));
	    },
	
	    // private
	    // Convert rectangle in viewport coordinates to this tiled image point
	    // coordinates (x in [0, 1] and y in [0, aspectRatio])
	    _viewportToTiledImageRectangle: function(rect) {
	        var scale = this._scaleSpring.current.value;
	        rect = rect.rotate(-this.getRotation(true), this._getRotationPoint(true));
	        return new $.Rect(
	            (rect.x - this._xSpring.current.value) / scale,
	            (rect.y - this._ySpring.current.value) / scale,
	            rect.width / scale,
	            rect.height / scale,
	            rect.degrees);
	    },
	
	    /**
	     * Convert a viewport zoom to an image zoom.
	     * Image zoom: ratio of the original image size to displayed image size.
	     * 1 means original image size, 0.5 half size...
	     * Viewport zoom: ratio of the displayed image's width to viewport's width.
	     * 1 means identical width, 2 means image's width is twice the viewport's width...
	     * @function
	     * @param {Number} viewportZoom The viewport zoom
	     * @returns {Number} imageZoom The image zoom
	     */
	    viewportToImageZoom: function( viewportZoom ) {
	        var ratio = this._scaleSpring.current.value *
	                this.viewport._containerInnerSize.x / this.source.dimensions.x;
	        return ratio * viewportZoom;
	    },
	
	    /**
	     * Convert an image zoom to a viewport zoom.
	     * Image zoom: ratio of the original image size to displayed image size.
	     * 1 means original image size, 0.5 half size...
	     * Viewport zoom: ratio of the displayed image's width to viewport's width.
	     * 1 means identical width, 2 means image's width is twice the viewport's width...
	     * Note: not accurate with multi-image.
	     * @function
	     * @param {Number} imageZoom The image zoom
	     * @returns {Number} viewportZoom The viewport zoom
	     */
	    imageToViewportZoom: function( imageZoom ) {
	        var ratio = this._scaleSpring.current.value *
	                this.viewport._containerInnerSize.x / this.source.dimensions.x;
	        return imageZoom / ratio;
	    },
	
	    /**
	     * Sets the TiledImage's position in the world.
	     * @param {OpenSeadragon.Point} position - The new position, in viewport coordinates.
	     * @param {Boolean} [immediately=false] - Whether to animate to the new position or snap immediately.
	     * @fires OpenSeadragon.TiledImage.event:bounds-change
	     */
	    setPosition: function(position, immediately) {
	        var sameTarget = (this._xSpring.target.value === position.x &&
	            this._ySpring.target.value === position.y);
	
	        if (immediately) {
	            if (sameTarget && this._xSpring.current.value === position.x &&
	                    this._ySpring.current.value === position.y) {
	                return;
	            }
	
	            this._xSpring.resetTo(position.x);
	            this._ySpring.resetTo(position.y);
	            this._needsDraw = true;
	        } else {
	            if (sameTarget) {
	                return;
	            }
	
	            this._xSpring.springTo(position.x);
	            this._ySpring.springTo(position.y);
	            this._needsDraw = true;
	        }
	
	        if (!sameTarget) {
	            this._raiseBoundsChange();
	        }
	    },
	
	    /**
	     * Sets the TiledImage's width in the world, adjusting the height to match based on aspect ratio.
	     * @param {Number} width - The new width, in viewport coordinates.
	     * @param {Boolean} [immediately=false] - Whether to animate to the new size or snap immediately.
	     * @fires OpenSeadragon.TiledImage.event:bounds-change
	     */
	    setWidth: function(width, immediately) {
	        this._setScale(width, immediately);
	    },
	
	    /**
	     * Sets the TiledImage's height in the world, adjusting the width to match based on aspect ratio.
	     * @param {Number} height - The new height, in viewport coordinates.
	     * @param {Boolean} [immediately=false] - Whether to animate to the new size or snap immediately.
	     * @fires OpenSeadragon.TiledImage.event:bounds-change
	     */
	    setHeight: function(height, immediately) {
	        this._setScale(height / this.normHeight, immediately);
	    },
	
	    /**
	     * Positions and scales the TiledImage to fit in the specified bounds.
	     * Note: this method fires OpenSeadragon.TiledImage.event:bounds-change
	     * twice
	     * @param {OpenSeadragon.Rect} bounds The bounds to fit the image into.
	     * @param {OpenSeadragon.Placement} [anchor=OpenSeadragon.Placement.CENTER]
	     * How to anchor the image in the bounds.
	     * @param {Boolean} [immediately=false] Whether to animate to the new size
	     * or snap immediately.
	     * @fires OpenSeadragon.TiledImage.event:bounds-change
	     */
	    fitBounds: function(bounds, anchor, immediately) {
	        anchor = anchor || $.Placement.CENTER;
	        var anchorProperties = $.Placement.properties[anchor];
	        var aspectRatio = this.contentAspectX;
	        var xOffset = 0;
	        var yOffset = 0;
	        var displayedWidthRatio = 1;
	        var displayedHeightRatio = 1;
	        if (this._clip) {
	            aspectRatio = this._clip.getAspectRatio();
	            displayedWidthRatio = this._clip.width / this.source.dimensions.x;
	            displayedHeightRatio = this._clip.height / this.source.dimensions.y;
	            if (bounds.getAspectRatio() > aspectRatio) {
	                xOffset = this._clip.x / this._clip.height * bounds.height;
	                yOffset = this._clip.y / this._clip.height * bounds.height;
	            } else {
	                xOffset = this._clip.x / this._clip.width * bounds.width;
	                yOffset = this._clip.y / this._clip.width * bounds.width;
	            }
	        }
	
	        if (bounds.getAspectRatio() > aspectRatio) {
	            // We will have margins on the X axis
	            var height = bounds.height / displayedHeightRatio;
	            var marginLeft = 0;
	            if (anchorProperties.isHorizontallyCentered) {
	                marginLeft = (bounds.width - bounds.height * aspectRatio) / 2;
	            } else if (anchorProperties.isRight) {
	                marginLeft = bounds.width - bounds.height * aspectRatio;
	            }
	            this.setPosition(
	                new $.Point(bounds.x - xOffset + marginLeft, bounds.y - yOffset),
	                immediately);
	            this.setHeight(height, immediately);
	        } else {
	            // We will have margins on the Y axis
	            var width = bounds.width / displayedWidthRatio;
	            var marginTop = 0;
	            if (anchorProperties.isVerticallyCentered) {
	                marginTop = (bounds.height - bounds.width / aspectRatio) / 2;
	            } else if (anchorProperties.isBottom) {
	                marginTop = bounds.height - bounds.width / aspectRatio;
	            }
	            this.setPosition(
	                new $.Point(bounds.x - xOffset, bounds.y - yOffset + marginTop),
	                immediately);
	            this.setWidth(width, immediately);
	        }
	    },
	
	    /**
	     * @returns {OpenSeadragon.Rect|null} The TiledImage's current clip rectangle,
	     * in image pixels, or null if none.
	     */
	    getClip: function() {
	        if (this._clip) {
	            return this._clip.clone();
	        }
	
	        return null;
	    },
	
	    /**
	     * @param {OpenSeadragon.Rect|null} newClip - An area, in image pixels, to clip to
	     * (portions of the image outside of this area will not be visible). Only works on
	     * browsers that support the HTML5 canvas.
	     * @fires OpenSeadragon.TiledImage.event:clip-change
	     */
	    setClip: function(newClip) {
	        $.console.assert(!newClip || newClip instanceof $.Rect,
	            "[TiledImage.setClip] newClip must be an OpenSeadragon.Rect or null");
	
	        if (newClip instanceof $.Rect) {
	            this._clip = newClip.clone();
	        } else {
	            this._clip = null;
	        }
	
	        this._needsDraw = true;
	        /**
	         * Raised when the TiledImage's clip is changed.
	         * @event clip-change
	         * @memberOf OpenSeadragon.TiledImage
	         * @type {object}
	         * @property {OpenSeadragon.TiledImage} eventSource - A reference to the
	         * TiledImage which raised the event.
	         * @property {?Object} userData - Arbitrary subscriber-defined object.
	         */
	        this.raiseEvent('clip-change');
	    },
	
	    /**
	     * @returns {Number} The TiledImage's current opacity.
	     */
	    getOpacity: function() {
	        return this.opacity;
	    },
	
	    /**
	     * @param {Number} opacity Opacity the tiled image should be drawn at.
	     * @fires OpenSeadragon.TiledImage.event:opacity-change
	     */
	    setOpacity: function(opacity) {
	        if (opacity === this.opacity) {
	            return;
	        }
	
	        this.opacity = opacity;
	        this._needsDraw = true;
	        /**
	         * Raised when the TiledImage's opacity is changed.
	         * @event opacity-change
	         * @memberOf OpenSeadragon.TiledImage
	         * @type {object}
	         * @property {Number} opacity - The new opacity value.
	         * @property {OpenSeadragon.TiledImage} eventSource - A reference to the
	         * TiledImage which raised the event.
	         * @property {?Object} userData - Arbitrary subscriber-defined object.
	         */
	        this.raiseEvent('opacity-change', {
	            opacity: this.opacity
	        });
	    },
	
	    /**
	     * @returns {Boolean} whether the tiledImage can load its tiles even when it has zero opacity.
	     */
	    getPreload: function() {
	        return this._preload;
	    },
	
	    /**
	     * Set true to load even when hidden. Set false to block loading when hidden.
	     */
	    setPreload: function(preload) {
	        this._preload = !!preload;
	        this._needsDraw = true;
	    },
	
	    /**
	     * Get the rotation of this tiled image in degrees.
	     * @param {Boolean} [current=false] True for current rotation, false for target.
	     * @returns {Number} the rotation of this tiled image in degrees.
	     */
	    getRotation: function(current) {
	        return current ?
	            this._degreesSpring.current.value :
	            this._degreesSpring.target.value;
	    },
	
	    /**
	     * Set the current rotation of this tiled image in degrees.
	     * @param {Number} degrees the rotation in degrees.
	     * @param {Boolean} [immediately=false] Whether to animate to the new angle
	     * or rotate immediately.
	     * @fires OpenSeadragon.TiledImage.event:bounds-change
	     */
	    setRotation: function(degrees, immediately) {
	        if (this._degreesSpring.target.value === degrees &&
	            this._degreesSpring.isAtTargetValue()) {
	            return;
	        }
	        if (immediately) {
	            this._degreesSpring.resetTo(degrees);
	        } else {
	            this._degreesSpring.springTo(degrees);
	        }
	        this._needsDraw = true;
	        this._raiseBoundsChange();
	    },
	
	    /**
	     * Get the point around which this tiled image is rotated
	     * @private
	     * @param {Boolean} current True for current rotation point, false for target.
	     * @returns {OpenSeadragon.Point}
	     */
	    _getRotationPoint: function(current) {
	        return this.getBoundsNoRotate(current).getCenter();
	    },
	
	    /**
	     * @returns {String} The TiledImage's current compositeOperation.
	     */
	    getCompositeOperation: function() {
	        return this.compositeOperation;
	    },
	
	    /**
	     * @param {String} compositeOperation the tiled image should be drawn with this globalCompositeOperation.
	     * @fires OpenSeadragon.TiledImage.event:composite-operation-change
	     */
	    setCompositeOperation: function(compositeOperation) {
	        if (compositeOperation === this.compositeOperation) {
	            return;
	        }
	
	        this.compositeOperation = compositeOperation;
	        this._needsDraw = true;
	        /**
	         * Raised when the TiledImage's opacity is changed.
	         * @event composite-operation-change
	         * @memberOf OpenSeadragon.TiledImage
	         * @type {object}
	         * @property {String} compositeOperation - The new compositeOperation value.
	         * @property {OpenSeadragon.TiledImage} eventSource - A reference to the
	         * TiledImage which raised the event.
	         * @property {?Object} userData - Arbitrary subscriber-defined object.
	         */
	        this.raiseEvent('composite-operation-change', {
	            compositeOperation: this.compositeOperation
	        });
	    },
	
	    // private
	    _setScale: function(scale, immediately) {
	        var sameTarget = (this._scaleSpring.target.value === scale);
	        if (immediately) {
	            if (sameTarget && this._scaleSpring.current.value === scale) {
	                return;
	            }
	
	            this._scaleSpring.resetTo(scale);
	            this._updateForScale();
	            this._needsDraw = true;
	        } else {
	            if (sameTarget) {
	                return;
	            }
	
	            this._scaleSpring.springTo(scale);
	            this._updateForScale();
	            this._needsDraw = true;
	        }
	
	        if (!sameTarget) {
	            this._raiseBoundsChange();
	        }
	    },
	
	    // private
	    _updateForScale: function() {
	        this._worldWidthTarget = this._scaleSpring.target.value;
	        this._worldHeightTarget = this.normHeight * this._scaleSpring.target.value;
	        this._worldWidthCurrent = this._scaleSpring.current.value;
	        this._worldHeightCurrent = this.normHeight * this._scaleSpring.current.value;
	    },
	
	    // private
	    _raiseBoundsChange: function() {
	        /**
	         * Raised when the TiledImage's bounds are changed.
	         * Note that this event is triggered only when the animation target is changed;
	         * not for every frame of animation.
	         * @event bounds-change
	         * @memberOf OpenSeadragon.TiledImage
	         * @type {object}
	         * @property {OpenSeadragon.TiledImage} eventSource - A reference to the
	         * TiledImage which raised the event.
	         * @property {?Object} userData - Arbitrary subscriber-defined object.
	         */
	        this.raiseEvent('bounds-change');
	    },
	
	    // private
	    _isBottomItem: function() {
	        return this.viewer.world.getItemAt(0) === this;
	    },
	
	    // private
	    _getLevelsInterval: function() {
	        var lowestLevel = Math.max(
	            this.source.minLevel,
	            Math.floor(Math.log(this.minZoomImageRatio) / Math.log(2))
	        );
	        var currentZeroRatio = this.viewport.deltaPixelsFromPointsNoRotate(
	            this.source.getPixelRatio(0), true).x *
	            this._scaleSpring.current.value;
	        var highestLevel = Math.min(
	            Math.abs(this.source.maxLevel),
	            Math.abs(Math.floor(
	                Math.log(currentZeroRatio / this.minPixelRatio) / Math.log(2)
	            ))
	        );
	
	        // Calculations for the interval of levels to draw
	        // can return invalid intervals; fix that here if necessary
	        highestLevel = Math.max(highestLevel, this.source.minLevel || 0);
	        lowestLevel = Math.min(lowestLevel, highestLevel);
	        return {
	            lowestLevel: lowestLevel,
	            highestLevel: highestLevel
	        };
	    },
	
	    /**
	     * @private
	     * @inner
	     * Pretty much every other line in this needs to be documented so it's clear
	     * how each piece of this routine contributes to the drawing process.  That's
	     * why there are so many TODO's inside this function.
	     */
	    _updateViewport: function() {
	        this._needsDraw = false;
	        this._tilesLoading = 0;
	        this.loadingCoverage = {};
	
	        // Reset tile's internal drawn state
	        while (this.lastDrawn.length > 0) {
	            var tile = this.lastDrawn.pop();
	            tile.beingDrawn = false;
	        }
	
	        var viewport = this.viewport;
	        var drawArea = this._viewportToTiledImageRectangle(
	            viewport.getBoundsWithMargins(true));
	
	        if (!this.wrapHorizontal && !this.wrapVertical) {
	            var tiledImageBounds = this._viewportToTiledImageRectangle(
	                this.getClippedBounds(true));
	            drawArea = drawArea.intersection(tiledImageBounds);
	            if (drawArea === null) {
	                return;
	            }
	        }
	
	        var levelsInterval = this._getLevelsInterval();
	        var lowestLevel = levelsInterval.lowestLevel;
	        var highestLevel = levelsInterval.highestLevel;
	        var bestTile = null;
	        var haveDrawn = false;
	        var currentTime = $.now();
	
	        // Update any level that will be drawn
	        for (var level = highestLevel; level >= lowestLevel; level--) {
	            var drawLevel = false;
	
	            //Avoid calculations for draw if we have already drawn this
	            var currentRenderPixelRatio = viewport.deltaPixelsFromPointsNoRotate(
	                this.source.getPixelRatio(level),
	                true
	            ).x * this._scaleSpring.current.value;
	
	            if (level === lowestLevel ||
	                (!haveDrawn && currentRenderPixelRatio >= this.minPixelRatio)) {
	                drawLevel = true;
	                haveDrawn = true;
	            } else if (!haveDrawn) {
	                continue;
	            }
	
	            //Perform calculations for draw if we haven't drawn this
	            var targetRenderPixelRatio = viewport.deltaPixelsFromPointsNoRotate(
	                this.source.getPixelRatio(level),
	                false
	            ).x * this._scaleSpring.current.value;
	
	            var targetZeroRatio = viewport.deltaPixelsFromPointsNoRotate(
	                this.source.getPixelRatio(
	                    Math.max(
	                        this.source.getClosestLevel(),
	                        0
	                    )
	                ),
	                false
	            ).x * this._scaleSpring.current.value;
	
	            var optimalRatio = this.immediateRender ? 1 : targetZeroRatio;
	            var levelOpacity = Math.min(1, (currentRenderPixelRatio - 0.5) / 0.5);
	            var levelVisibility = optimalRatio / Math.abs(
	                optimalRatio - targetRenderPixelRatio
	            );
	
	            // Update the level and keep track of 'best' tile to load
	            bestTile = updateLevel(
	                this,
	                haveDrawn,
	                drawLevel,
	                level,
	                levelOpacity,
	                levelVisibility,
	                drawArea,
	                currentTime,
	                bestTile
	            );
	
	            // Stop the loop if lower-res tiles would all be covered by
	            // already drawn tiles
	            if (providesCoverage(this.coverage, level)) {
	                break;
	            }
	        }
	
	        // Perform the actual drawing
	        drawTiles(this, this.lastDrawn);
	
	        // Load the new 'best' tile
	        if (bestTile && !bestTile.context2D) {
	            loadTile(this, bestTile, currentTime);
	            this._needsDraw = true;
	            this._setFullyLoaded(false);
	        } else {
	            this._setFullyLoaded(this._tilesLoading === 0);
	        }
	    },
	
	    // private
	    _getCornerTiles: function(level, topLeftBound, bottomRightBound) {
	        var leftX;
	        var rightX;
	        if (this.wrapHorizontal) {
	            leftX = $.positiveModulo(topLeftBound.x, 1);
	            rightX = $.positiveModulo(bottomRightBound.x, 1);
	        } else {
	            leftX = Math.max(0, topLeftBound.x);
	            rightX = Math.min(1, bottomRightBound.x);
	        }
	        var topY;
	        var bottomY;
	        var aspectRatio = 1 / this.source.aspectRatio;
	        if (this.wrapVertical) {
	            topY = $.positiveModulo(topLeftBound.y, aspectRatio);
	            bottomY = $.positiveModulo(bottomRightBound.y, aspectRatio);
	        } else {
	            topY = Math.max(0, topLeftBound.y);
	            bottomY = Math.min(aspectRatio, bottomRightBound.y);
	        }
	
	        var topLeftTile = this.source.getTileAtPoint(level, new $.Point(leftX, topY));
	        var bottomRightTile = this.source.getTileAtPoint(level, new $.Point(rightX, bottomY));
	        var numTiles  = this.source.getNumTiles(level);
	
	        if (this.wrapHorizontal) {
	            topLeftTile.x += numTiles.x * Math.floor(topLeftBound.x);
	            bottomRightTile.x += numTiles.x * Math.floor(bottomRightBound.x);
	        }
	        if (this.wrapVertical) {
	            topLeftTile.y += numTiles.y * Math.floor(topLeftBound.y / aspectRatio);
	            bottomRightTile.y += numTiles.y * Math.floor(bottomRightBound.y / aspectRatio);
	        }
	
	        return {
	            topLeft: topLeftTile,
	            bottomRight: bottomRightTile,
	        };
	    }
	});
	
	/**
	 * @private
	 * @inner
	 * Updates all tiles at a given resolution level.
	 * @param {OpenSeadragon.TiledImage} tiledImage - Which TiledImage is being drawn.
	 * @param {Boolean} haveDrawn
	 * @param {Boolean} drawLevel
	 * @param {Number} level
	 * @param {Number} levelOpacity
	 * @param {Number} levelVisibility
	 * @param {OpenSeadragon.Point} viewportTL - The index of the most top-left visible tile.
	 * @param {OpenSeadragon.Point} viewportBR - The index of the most bottom-right visible tile.
	 * @param {Number} currentTime
	 * @param {OpenSeadragon.Tile} best - The current "best" tile to draw.
	 */
	function updateLevel(tiledImage, haveDrawn, drawLevel, level, levelOpacity,
	    levelVisibility, drawArea, currentTime, best) {
	
	    var topLeftBound = drawArea.getBoundingBox().getTopLeft();
	    var bottomRightBound = drawArea.getBoundingBox().getBottomRight();
	
	    if (tiledImage.viewer) {
	        /**
	         * <em>- Needs documentation -</em>
	         *
	         * @event update-level
	         * @memberof OpenSeadragon.Viewer
	         * @type {object}
	         * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised the event.
	         * @property {OpenSeadragon.TiledImage} tiledImage - Which TiledImage is being drawn.
	         * @property {Object} havedrawn
	         * @property {Object} level
	         * @property {Object} opacity
	         * @property {Object} visibility
	         * @property {OpenSeadragon.Rect} drawArea
	         * @property {Object} topleft deprecated, use drawArea instead
	         * @property {Object} bottomright deprecated, use drawArea instead
	         * @property {Object} currenttime
	         * @property {Object} best
	         * @property {?Object} userData - Arbitrary subscriber-defined object.
	         */
	        tiledImage.viewer.raiseEvent('update-level', {
	            tiledImage: tiledImage,
	            havedrawn: haveDrawn,
	            level: level,
	            opacity: levelOpacity,
	            visibility: levelVisibility,
	            drawArea: drawArea,
	            topleft: topLeftBound,
	            bottomright: bottomRightBound,
	            currenttime: currentTime,
	            best: best
	        });
	    }
	
	    resetCoverage(tiledImage.coverage, level);
	    resetCoverage(tiledImage.loadingCoverage, level);
	
	    //OK, a new drawing so do your calculations
	    var cornerTiles = tiledImage._getCornerTiles(level, topLeftBound, bottomRightBound);
	    var topLeftTile = cornerTiles.topLeft;
	    var bottomRightTile = cornerTiles.bottomRight;
	    var numberOfTiles  = tiledImage.source.getNumTiles(level);
	
	    var viewportCenter = tiledImage.viewport.pixelFromPoint(
	        tiledImage.viewport.getCenter());
	    for (var x = topLeftTile.x; x <= bottomRightTile.x; x++) {
	        for (var y = topLeftTile.y; y <= bottomRightTile.y; y++) {
	
	            // Optimisation disabled with wrapping because getTileBounds does not
	            // work correctly with x and y outside of the number of tiles
	            if (!tiledImage.wrapHorizontal && !tiledImage.wrapVertical) {
	                var tileBounds = tiledImage.source.getTileBounds(level, x, y);
	                if (drawArea.intersection(tileBounds) === null) {
	                    // This tile is outside of the viewport, no need to draw it
	                    continue;
	                }
	            }
	
	            best = updateTile(
	                tiledImage,
	                drawLevel,
	                haveDrawn,
	                x, y,
	                level,
	                levelOpacity,
	                levelVisibility,
	                viewportCenter,
	                numberOfTiles,
	                currentTime,
	                best
	            );
	
	        }
	    }
	
	    return best;
	}
	
	/**
	 * @private
	 * @inner
	 * Update a single tile at a particular resolution level.
	 * @param {OpenSeadragon.TiledImage} tiledImage - Which TiledImage is being drawn.
	 * @param {Boolean} haveDrawn
	 * @param {Boolean} drawLevel
	 * @param {Number} x
	 * @param {Number} y
	 * @param {Number} level
	 * @param {Number} levelOpacity
	 * @param {Number} levelVisibility
	 * @param {OpenSeadragon.Point} viewportCenter
	 * @param {Number} numberOfTiles
	 * @param {Number} currentTime
	 * @param {OpenSeadragon.Tile} best - The current "best" tile to draw.
	 */
	function updateTile( tiledImage, haveDrawn, drawLevel, x, y, level, levelOpacity, levelVisibility, viewportCenter, numberOfTiles, currentTime, best){
	
	    var tile = getTile(
	            x, y,
	            level,
	            tiledImage,
	            tiledImage.source,
	            tiledImage.tilesMatrix,
	            currentTime,
	            numberOfTiles,
	            tiledImage._worldWidthCurrent,
	            tiledImage._worldHeightCurrent
	        ),
	        drawTile = drawLevel;
	
	    if( tiledImage.viewer ){
	        /**
	         * <em>- Needs documentation -</em>
	         *
	         * @event update-tile
	         * @memberof OpenSeadragon.Viewer
	         * @type {object}
	         * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised the event.
	         * @property {OpenSeadragon.TiledImage} tiledImage - Which TiledImage is being drawn.
	         * @property {OpenSeadragon.Tile} tile
	         * @property {?Object} userData - Arbitrary subscriber-defined object.
	         */
	        tiledImage.viewer.raiseEvent( 'update-tile', {
	            tiledImage: tiledImage,
	            tile: tile
	        });
	    }
	
	    setCoverage( tiledImage.coverage, level, x, y, false );
	
	    var loadingCoverage = tile.loaded || tile.loading || isCovered(tiledImage.loadingCoverage, level, x, y);
	    setCoverage(tiledImage.loadingCoverage, level, x, y, loadingCoverage);
	
	    if ( !tile.exists ) {
	        return best;
	    }
	
	    if ( haveDrawn && !drawTile ) {
	        if ( isCovered( tiledImage.coverage, level, x, y ) ) {
	            setCoverage( tiledImage.coverage, level, x, y, true );
	        } else {
	            drawTile = true;
	        }
	    }
	
	    if ( !drawTile ) {
	        return best;
	    }
	
	    positionTile(
	        tile,
	        tiledImage.source.tileOverlap,
	        tiledImage.viewport,
	        viewportCenter,
	        levelVisibility,
	        tiledImage
	    );
	
	    if (!tile.loaded) {
	        if (tile.context2D) {
	            setTileLoaded(tiledImage, tile);
	        } else {
	            var imageRecord = tiledImage._tileCache.getImageRecord(tile.cacheKey);
	            if (imageRecord) {
	                var image = imageRecord.getImage();
	                setTileLoaded(tiledImage, tile, image);
	            }
	        }
	    }
	
	    if ( tile.loaded ) {
	        var needsDraw = blendTile(
	            tiledImage,
	            tile,
	            x, y,
	            level,
	            levelOpacity,
	            currentTime
	        );
	
	        if ( needsDraw ) {
	            tiledImage._needsDraw = true;
	        }
	    } else if ( tile.loading ) {
	        // the tile is already in the download queue
	        tiledImage._tilesLoading++;
	    } else if (!loadingCoverage) {
	        best = compareTiles( best, tile );
	    }
	
	    return best;
	}
	
	/**
	 * @private
	 * @inner
	 * Obtains a tile at the given location.
	 * @param {Number} x
	 * @param {Number} y
	 * @param {Number} level
	 * @param {OpenSeadragon.TiledImage} tiledImage
	 * @param {OpenSeadragon.TileSource} tileSource
	 * @param {Object} tilesMatrix - A '3d' dictionary [level][x][y] --> Tile.
	 * @param {Number} time
	 * @param {Number} numTiles
	 * @param {Number} worldWidth
	 * @param {Number} worldHeight
	 * @returns {OpenSeadragon.Tile}
	 */
	function getTile(
	    x, y,
	    level,
	    tiledImage,
	    tileSource,
	    tilesMatrix,
	    time,
	    numTiles,
	    worldWidth,
	    worldHeight
	) {
	    var xMod,
	        yMod,
	        bounds,
	        sourceBounds,
	        exists,
	        url,
	        ajaxHeaders,
	        context2D,
	        tile;
	
	    if ( !tilesMatrix[ level ] ) {
	        tilesMatrix[ level ] = {};
	    }
	    if ( !tilesMatrix[ level ][ x ] ) {
	        tilesMatrix[ level ][ x ] = {};
	    }
	
	    if ( !tilesMatrix[ level ][ x ][ y ] ) {
	        xMod    = ( numTiles.x + ( x % numTiles.x ) ) % numTiles.x;
	        yMod    = ( numTiles.y + ( y % numTiles.y ) ) % numTiles.y;
	        bounds  = tileSource.getTileBounds( level, xMod, yMod );
	        sourceBounds = tileSource.getTileBounds( level, xMod, yMod, true );
	        exists  = tileSource.tileExists( level, xMod, yMod );
	        url     = tileSource.getTileUrl( level, xMod, yMod );
	
	        // Headers are only applicable if loadTilesWithAjax is set
	        if (tiledImage.loadTilesWithAjax) {
	            ajaxHeaders = tileSource.getTileAjaxHeaders( level, xMod, yMod );
	            // Combine tile AJAX headers with tiled image AJAX headers (if applicable)
	            if ($.isPlainObject(tiledImage.ajaxHeaders)) {
	                ajaxHeaders = $.extend({}, tiledImage.ajaxHeaders, ajaxHeaders);
	            }
	        } else {
	            ajaxHeaders = null;
	        }
	
	        context2D = tileSource.getContext2D ?
	            tileSource.getContext2D(level, xMod, yMod) : undefined;
	
	        bounds.x += ( x - xMod ) / numTiles.x;
	        bounds.y += (worldHeight / worldWidth) * (( y - yMod ) / numTiles.y);
	
	        tile = new $.Tile(
	            level,
	            x,
	            y,
	            bounds,
	            exists,
	            url,
	            context2D,
	            tiledImage.loadTilesWithAjax,
	            ajaxHeaders,
	            sourceBounds
	        );
	
	        if (xMod === numTiles.x - 1) {
	            tile.isRightMost = true;
	        }
	
	        if (yMod === numTiles.y - 1) {
	            tile.isBottomMost = true;
	        }
	
	        tilesMatrix[ level ][ x ][ y ] = tile;
	    }
	
	    tile = tilesMatrix[ level ][ x ][ y ];
	    tile.lastTouchTime = time;
	
	    return tile;
	}
	
	/**
	 * @private
	 * @inner
	 * Dispatch a job to the ImageLoader to load the Image for a Tile.
	 * @param {OpenSeadragon.TiledImage} tiledImage
	 * @param {OpenSeadragon.Tile} tile
	 * @param {Number} time
	 */
	function loadTile( tiledImage, tile, time ) {
	    tile.loading = true;
	    tiledImage._imageLoader.addJob({
	        src: tile.url,
	        loadWithAjax: tile.loadWithAjax,
	        ajaxHeaders: tile.ajaxHeaders,
	        crossOriginPolicy: tiledImage.crossOriginPolicy,
	        ajaxWithCredentials: tiledImage.ajaxWithCredentials,
	        callback: function( image, errorMsg, tileRequest ){
	            onTileLoad( tiledImage, tile, time, image, errorMsg, tileRequest );
	        },
	        abort: function() {
	            tile.loading = false;
	        }
	    });
	}
	
	/**
	 * @private
	 * @inner
	 * Callback fired when a Tile's Image finished downloading.
	 * @param {OpenSeadragon.TiledImage} tiledImage
	 * @param {OpenSeadragon.Tile} tile
	 * @param {Number} time
	 * @param {Image} image
	 * @param {String} errorMsg
	 * @param {XMLHttpRequest} tileRequest
	 */
	function onTileLoad( tiledImage, tile, time, image, errorMsg, tileRequest ) {
	    if ( !image ) {
	        $.console.log( "Tile %s failed to load: %s - error: %s", tile, tile.url, errorMsg );
	        /**
	         * Triggered when a tile fails to load.
	         *
	         * @event tile-load-failed
	         * @memberof OpenSeadragon.Viewer
	         * @type {object}
	         * @property {OpenSeadragon.Tile} tile - The tile that failed to load.
	         * @property {OpenSeadragon.TiledImage} tiledImage - The tiled image the tile belongs to.
	         * @property {number} time - The time in milliseconds when the tile load began.
	         * @property {string} message - The error message.
	         * @property {XMLHttpRequest} tileRequest - The XMLHttpRequest used to load the tile if available.
	         */
	        tiledImage.viewer.raiseEvent("tile-load-failed", {
	            tile: tile,
	            tiledImage: tiledImage,
	            time: time,
	            message: errorMsg,
	            tileRequest: tileRequest
	        });
	        tile.loading = false;
	        tile.exists = false;
	        return;
	    }
	
	    if ( time < tiledImage.lastResetTime ) {
	        $.console.log( "Ignoring tile %s loaded before reset: %s", tile, tile.url );
	        tile.loading = false;
	        return;
	    }
	
	    var finish = function() {
	        var cutoff = tiledImage.source.getClosestLevel();
	        setTileLoaded(tiledImage, tile, image, cutoff, tileRequest);
	    };
	
	    // Check if we're mid-update; this can happen on IE8 because image load events for
	    // cached images happen immediately there
	    if ( !tiledImage._midDraw ) {
	        finish();
	    } else {
	        // Wait until after the update, in case caching unloads any tiles
	        window.setTimeout( finish, 1);
	    }
	}
	
	/**
	 * @private
	 * @inner
	 * @param {OpenSeadragon.TiledImage} tiledImage
	 * @param {OpenSeadragon.Tile} tile
	 * @param {Image} image
	 * @param {Number} cutoff
	 */
	function setTileLoaded(tiledImage, tile, image, cutoff, tileRequest) {
	    var increment = 0;
	
	    function getCompletionCallback() {
	        increment++;
	        return completionCallback;
	    }
	
	    function completionCallback() {
	        increment--;
	        if (increment === 0) {
	            tile.loading = false;
	            tile.loaded = true;
	            if (!tile.context2D) {
	                tiledImage._tileCache.cacheTile({
	                    image: image,
	                    tile: tile,
	                    cutoff: cutoff,
	                    tiledImage: tiledImage
	                });
	            }
	            tiledImage._needsDraw = true;
	        }
	    }
	
	    /**
	     * Triggered when a tile has just been loaded in memory. That means that the
	     * image has been downloaded and can be modified before being drawn to the canvas.
	     *
	     * @event tile-loaded
	     * @memberof OpenSeadragon.Viewer
	     * @type {object}
	     * @property {Image} image - The image of the tile.
	     * @property {OpenSeadragon.TiledImage} tiledImage - The tiled image of the loaded tile.
	     * @property {OpenSeadragon.Tile} tile - The tile which has been loaded.
	     * @property {XMLHttpRequest} tiledImage - The AJAX request that loaded this tile (if applicable).
	     * @property {function} getCompletionCallback - A function giving a callback to call
	     * when the asynchronous processing of the image is done. The image will be
	     * marked as entirely loaded when the callback has been called once for each
	     * call to getCompletionCallback.
	     */
	    tiledImage.viewer.raiseEvent("tile-loaded", {
	        tile: tile,
	        tiledImage: tiledImage,
	        tileRequest: tileRequest,
	        image: image,
	        getCompletionCallback: getCompletionCallback
	    });
	    // In case the completion callback is never called, we at least force it once.
	    getCompletionCallback()();
	}
	
	/**
	 * @private
	 * @inner
	 * @param {OpenSeadragon.Tile} tile
	 * @param {Boolean} overlap
	 * @param {OpenSeadragon.Viewport} viewport
	 * @param {OpenSeadragon.Point} viewportCenter
	 * @param {Number} levelVisibility
	 * @param {OpenSeadragon.TiledImage} tiledImage
	 */
	function positionTile( tile, overlap, viewport, viewportCenter, levelVisibility, tiledImage ){
	    var boundsTL     = tile.bounds.getTopLeft();
	
	    boundsTL.x *= tiledImage._scaleSpring.current.value;
	    boundsTL.y *= tiledImage._scaleSpring.current.value;
	    boundsTL.x += tiledImage._xSpring.current.value;
	    boundsTL.y += tiledImage._ySpring.current.value;
	
	    var boundsSize   = tile.bounds.getSize();
	
	    boundsSize.x *= tiledImage._scaleSpring.current.value;
	    boundsSize.y *= tiledImage._scaleSpring.current.value;
	
	    var positionC = viewport.pixelFromPointNoRotate(boundsTL, true),
	        positionT = viewport.pixelFromPointNoRotate(boundsTL, false),
	        sizeC = viewport.deltaPixelsFromPointsNoRotate(boundsSize, true),
	        sizeT = viewport.deltaPixelsFromPointsNoRotate(boundsSize, false),
	        tileCenter = positionT.plus( sizeT.divide( 2 ) ),
	        tileSquaredDistance = viewportCenter.squaredDistanceTo( tileCenter );
	
	    if ( !overlap ) {
	        sizeC = sizeC.plus( new $.Point( 1, 1 ) );
	    }
	
	    if (tile.isRightMost && tiledImage.wrapHorizontal) {
	        sizeC.x += 0.75; // Otherwise Firefox and Safari show seams
	    }
	
	    if (tile.isBottomMost && tiledImage.wrapVertical) {
	        sizeC.y += 0.75; // Otherwise Firefox and Safari show seams
	    }
	
	    tile.position   = positionC;
	    tile.size       = sizeC;
	    tile.squaredDistance   = tileSquaredDistance;
	    tile.visibility = levelVisibility;
	}
	
	/**
	 * @private
	 * @inner
	 * Updates the opacity of a tile according to the time it has been on screen
	 * to perform a fade-in.
	 * Updates coverage once a tile is fully opaque.
	 * Returns whether the fade-in has completed.
	 *
	 * @param {OpenSeadragon.TiledImage} tiledImage
	 * @param {OpenSeadragon.Tile} tile
	 * @param {Number} x
	 * @param {Number} y
	 * @param {Number} level
	 * @param {Number} levelOpacity
	 * @param {Number} currentTime
	 * @returns {Boolean}
	 */
	function blendTile( tiledImage, tile, x, y, level, levelOpacity, currentTime ){
	    var blendTimeMillis = 1000 * tiledImage.blendTime,
	        deltaTime,
	        opacity;
	
	    if ( !tile.blendStart ) {
	        tile.blendStart = currentTime;
	    }
	
	    deltaTime   = currentTime - tile.blendStart;
	    opacity     = blendTimeMillis ? Math.min( 1, deltaTime / ( blendTimeMillis ) ) : 1;
	
	    if ( tiledImage.alwaysBlend ) {
	        opacity *= levelOpacity;
	    }
	
	    tile.opacity = opacity;
	
	    tiledImage.lastDrawn.push( tile );
	
	    if ( opacity == 1 ) {
	        setCoverage( tiledImage.coverage, level, x, y, true );
	        tiledImage._hasOpaqueTile = true;
	    } else if ( deltaTime < blendTimeMillis ) {
	        return true;
	    }
	
	    return false;
	}
	
	/**
	 * @private
	 * @inner
	 * Returns true if the given tile provides coverage to lower-level tiles of
	 * lower resolution representing the same content. If neither x nor y is
	 * given, returns true if the entire visible level provides coverage.
	 *
	 * Note that out-of-bounds tiles provide coverage in this sense, since
	 * there's no content that they would need to cover. Tiles at non-existent
	 * levels that are within the image bounds, however, do not.
	 *
	 * @param {Object} coverage - A '3d' dictionary [level][x][y] --> Boolean.
	 * @param {Number} level - The resolution level of the tile.
	 * @param {Number} x - The X position of the tile.
	 * @param {Number} y - The Y position of the tile.
	 * @returns {Boolean}
	 */
	function providesCoverage( coverage, level, x, y ) {
	    var rows,
	        cols,
	        i, j;
	
	    if ( !coverage[ level ] ) {
	        return false;
	    }
	
	    if ( x === undefined || y === undefined ) {
	        rows = coverage[ level ];
	        for ( i in rows ) {
	            if ( rows.hasOwnProperty( i ) ) {
	                cols = rows[ i ];
	                for ( j in cols ) {
	                    if ( cols.hasOwnProperty( j ) && !cols[ j ] ) {
	                        return false;
	                    }
	                }
	            }
	        }
	
	        return true;
	    }
	
	    return (
	        coverage[ level ][ x] === undefined ||
	        coverage[ level ][ x ][ y ] === undefined ||
	        coverage[ level ][ x ][ y ] === true
	    );
	}
	
	/**
	 * @private
	 * @inner
	 * Returns true if the given tile is completely covered by higher-level
	 * tiles of higher resolution representing the same content. If neither x
	 * nor y is given, returns true if the entire visible level is covered.
	 *
	 * @param {Object} coverage - A '3d' dictionary [level][x][y] --> Boolean.
	 * @param {Number} level - The resolution level of the tile.
	 * @param {Number} x - The X position of the tile.
	 * @param {Number} y - The Y position of the tile.
	 * @returns {Boolean}
	 */
	function isCovered( coverage, level, x, y ) {
	    if ( x === undefined || y === undefined ) {
	        return providesCoverage( coverage, level + 1 );
	    } else {
	        return (
	             providesCoverage( coverage, level + 1, 2 * x, 2 * y ) &&
	             providesCoverage( coverage, level + 1, 2 * x, 2 * y + 1 ) &&
	             providesCoverage( coverage, level + 1, 2 * x + 1, 2 * y ) &&
	             providesCoverage( coverage, level + 1, 2 * x + 1, 2 * y + 1 )
	        );
	    }
	}
	
	/**
	 * @private
	 * @inner
	 * Sets whether the given tile provides coverage or not.
	 *
	 * @param {Object} coverage - A '3d' dictionary [level][x][y] --> Boolean.
	 * @param {Number} level - The resolution level of the tile.
	 * @param {Number} x - The X position of the tile.
	 * @param {Number} y - The Y position of the tile.
	 * @param {Boolean} covers - Whether the tile provides coverage.
	 */
	function setCoverage( coverage, level, x, y, covers ) {
	    if ( !coverage[ level ] ) {
	        $.console.warn(
	            "Setting coverage for a tile before its level's coverage has been reset: %s",
	            level
	        );
	        return;
	    }
	
	    if ( !coverage[ level ][ x ] ) {
	        coverage[ level ][ x ] = {};
	    }
	
	    coverage[ level ][ x ][ y ] = covers;
	}
	
	/**
	 * @private
	 * @inner
	 * Resets coverage information for the given level. This should be called
	 * after every draw routine. Note that at the beginning of the next draw
	 * routine, coverage for every visible tile should be explicitly set.
	 *
	 * @param {Object} coverage - A '3d' dictionary [level][x][y] --> Boolean.
	 * @param {Number} level - The resolution level of tiles to completely reset.
	 */
	function resetCoverage( coverage, level ) {
	    coverage[ level ] = {};
	}
	
	/**
	 * @private
	 * @inner
	 * Determines whether the 'last best' tile for the area is better than the
	 * tile in question.
	 *
	 * @param {OpenSeadragon.Tile} previousBest
	 * @param {OpenSeadragon.Tile} tile
	 * @returns {OpenSeadragon.Tile} The new best tile.
	 */
	function compareTiles( previousBest, tile ) {
	    if ( !previousBest ) {
	        return tile;
	    }
	
	    if ( tile.visibility > previousBest.visibility ) {
	        return tile;
	    } else if ( tile.visibility == previousBest.visibility ) {
	        if ( tile.squaredDistance < previousBest.squaredDistance ) {
	            return tile;
	        }
	    }
	
	    return previousBest;
	}
	
	/**
	 * @private
	 * @inner
	 * Draws a TiledImage.
	 * @param {OpenSeadragon.TiledImage} tiledImage
	 * @param {OpenSeadragon.Tile[]} lastDrawn - An unordered list of Tiles drawn last frame.
	 */
	function drawTiles( tiledImage, lastDrawn ) {
	    if (tiledImage.opacity === 0 || (lastDrawn.length === 0 && !tiledImage.placeholderFillStyle)) {
	        return;
	    }
	
	    var tile = lastDrawn[0];
	    var useSketch;
	
	    if (tile) {
	        useSketch = tiledImage.opacity < 1 ||
	            (tiledImage.compositeOperation &&
	                tiledImage.compositeOperation !== 'source-over') ||
	            (!tiledImage._isBottomItem() && tile._hasTransparencyChannel());
	    }
	
	    var sketchScale;
	    var sketchTranslate;
	
	    var zoom = tiledImage.viewport.getZoom(true);
	    var imageZoom = tiledImage.viewportToImageZoom(zoom);
	
	    if (lastDrawn.length > 1 &&
	        imageZoom > tiledImage.smoothTileEdgesMinZoom &&
	        !tiledImage.iOSDevice &&
	        tiledImage.getRotation(true) % 360 === 0 && // TODO: support tile edge smoothing with tiled image rotation.
	        $.supportsCanvas) {
	        // When zoomed in a lot (>100%) the tile edges are visible.
	        // So we have to composite them at ~100% and scale them up together.
	        // Note: Disabled on iOS devices per default as it causes a native crash
	        useSketch = true;
	        sketchScale = tile.getScaleForEdgeSmoothing();
	        sketchTranslate = tile.getTranslationForEdgeSmoothing(sketchScale,
	            tiledImage._drawer.getCanvasSize(false),
	            tiledImage._drawer.getCanvasSize(true));
	    }
	
	    var bounds;
	    if (useSketch) {
	        if (!sketchScale) {
	            // Except when edge smoothing, we only clean the part of the
	            // sketch canvas we are going to use for performance reasons.
	            bounds = tiledImage.viewport.viewportToViewerElementRectangle(
	                tiledImage.getClippedBounds(true))
	                .getIntegerBoundingBox()
	                .times($.pixelDensityRatio);
	        }
	        tiledImage._drawer._clear(true, bounds);
	    }
	
	    // When scaling, we must rotate only when blending the sketch canvas to
	    // avoid interpolation
	    if (!sketchScale) {
	        if (tiledImage.viewport.degrees !== 0) {
	            tiledImage._drawer._offsetForRotation({
	                degrees: tiledImage.viewport.degrees,
	                useSketch: useSketch
	            });
	        } else {
	            if(tiledImage._drawer.viewer.viewport.flipped) {
	                tiledImage._drawer._flip({});
	            }
	        }
	        if (tiledImage.getRotation(true) % 360 !== 0) {
	            tiledImage._drawer._offsetForRotation({
	                degrees: tiledImage.getRotation(true),
	                point: tiledImage.viewport.pixelFromPointNoRotate(
	                    tiledImage._getRotationPoint(true), true),
	                useSketch: useSketch
	            });
	        }
	    }
	
	    var usedClip = false;
	    if ( tiledImage._clip ) {
	        tiledImage._drawer.saveContext(useSketch);
	
	        var box = tiledImage.imageToViewportRectangle(tiledImage._clip, true);
	        box = box.rotate(-tiledImage.getRotation(true), tiledImage._getRotationPoint(true));
	        var clipRect = tiledImage._drawer.viewportToDrawerRectangle(box);
	        if (sketchScale) {
	            clipRect = clipRect.times(sketchScale);
	        }
	        if (sketchTranslate) {
	            clipRect = clipRect.translate(sketchTranslate);
	        }
	        tiledImage._drawer.setClip(clipRect, useSketch);
	
	        usedClip = true;
	    }
	
	    if ( tiledImage.placeholderFillStyle && tiledImage._hasOpaqueTile === false ) {
	        var placeholderRect = tiledImage._drawer.viewportToDrawerRectangle(tiledImage.getBounds(true));
	        if (sketchScale) {
	            placeholderRect = placeholderRect.times(sketchScale);
	        }
	        if (sketchTranslate) {
	            placeholderRect = placeholderRect.translate(sketchTranslate);
	        }
	
	        var fillStyle = null;
	        if ( typeof tiledImage.placeholderFillStyle === "function" ) {
	            fillStyle = tiledImage.placeholderFillStyle(tiledImage, tiledImage._drawer.context);
	        }
	        else {
	            fillStyle = tiledImage.placeholderFillStyle;
	        }
	
	        tiledImage._drawer.drawRectangle(placeholderRect, fillStyle, useSketch);
	    }
	
	    for (var i = lastDrawn.length - 1; i >= 0; i--) {
	        tile = lastDrawn[ i ];
	        tiledImage._drawer.drawTile( tile, tiledImage._drawingHandler, useSketch, sketchScale, sketchTranslate );
	        tile.beingDrawn = true;
	
	        if( tiledImage.viewer ){
	            /**
	             * <em>- Needs documentation -</em>
	             *
	             * @event tile-drawn
	             * @memberof OpenSeadragon.Viewer
	             * @type {object}
	             * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised the event.
	             * @property {OpenSeadragon.TiledImage} tiledImage - Which TiledImage is being drawn.
	             * @property {OpenSeadragon.Tile} tile
	             * @property {?Object} userData - Arbitrary subscriber-defined object.
	             */
	            tiledImage.viewer.raiseEvent( 'tile-drawn', {
	                tiledImage: tiledImage,
	                tile: tile
	            });
	        }
	    }
	
	    if ( usedClip ) {
	        tiledImage._drawer.restoreContext( useSketch );
	    }
	
	    if (!sketchScale) {
	        if (tiledImage.getRotation(true) % 360 !== 0) {
	            tiledImage._drawer._restoreRotationChanges(useSketch);
	        }
	        if (tiledImage.viewport.degrees !== 0) {
	            tiledImage._drawer._restoreRotationChanges(useSketch);
	        } else{
	          if(tiledImage._drawer.viewer.viewport.flipped) {
	            tiledImage._drawer._flip({});
	          }
	        }
	    }
	
	    if (useSketch) {
	        if (sketchScale) {
	            if (tiledImage.viewport.degrees !== 0) {
	                tiledImage._drawer._offsetForRotation({
	                    degrees: tiledImage.viewport.degrees,
	                    useSketch: false
	                });
	            }
	            if (tiledImage.getRotation(true) % 360 !== 0) {
	                tiledImage._drawer._offsetForRotation({
	                    degrees: tiledImage.getRotation(true),
	                    point: tiledImage.viewport.pixelFromPointNoRotate(
	                        tiledImage._getRotationPoint(true), true),
	                    useSketch: false
	                });
	            }
	        }
	        tiledImage._drawer.blendSketch({
	            opacity: tiledImage.opacity,
	            scale: sketchScale,
	            translate: sketchTranslate,
	            compositeOperation: tiledImage.compositeOperation,
	            bounds: bounds
	        });
	        if (sketchScale) {
	            if (tiledImage.getRotation(true) % 360 !== 0) {
	                tiledImage._drawer._restoreRotationChanges(false);
	            }
	            if (tiledImage.viewport.degrees !== 0) {
	                tiledImage._drawer._restoreRotationChanges(false);
	            }
	        }
	    }
	    drawDebugInfo( tiledImage, lastDrawn );
	}
	
	/**
	 * @private
	 * @inner
	 * Draws special debug information for a TiledImage if in debug mode.
	 * @param {OpenSeadragon.TiledImage} tiledImage
	 * @param {OpenSeadragon.Tile[]} lastDrawn - An unordered list of Tiles drawn last frame.
	 */
	function drawDebugInfo( tiledImage, lastDrawn ) {
	    if( tiledImage.debugMode ) {
	        for ( var i = lastDrawn.length - 1; i >= 0; i-- ) {
	            var tile = lastDrawn[ i ];
	            try {
	                tiledImage._drawer.drawDebugInfo(
	                    tile, lastDrawn.length, i, tiledImage);
	            } catch(e) {
	                $.console.error(e);
	            }
	        }
	    }
	}
	
	}( OpenSeadragon ));
	
	/*
	 * OpenSeadragon - TileCache
	 *
	 * Copyright (C) 2009 CodePlex Foundation
	 * Copyright (C) 2010-2013 OpenSeadragon contributors
	 *
	 * Redistribution and use in source and binary forms, with or without
	 * modification, are permitted provided that the following conditions are
	 * met:
	 *
	 * - Redistributions of source code must retain the above copyright notice,
	 *   this list of conditions and the following disclaimer.
	 *
	 * - Redistributions in binary form must reproduce the above copyright
	 *   notice, this list of conditions and the following disclaimer in the
	 *   documentation and/or other materials provided with the distribution.
	 *
	 * - Neither the name of CodePlex Foundation nor the names of its
	 *   contributors may be used to endorse or promote products derived from
	 *   this software without specific prior written permission.
	 *
	 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
	 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
	 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
	 * A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT
	 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
	 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
	 * TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 * PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
	 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
	 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
	 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	 */
	
	(function( $ ){
	
	// private class
	var TileRecord = function( options ) {
	    $.console.assert( options, "[TileCache.cacheTile] options is required" );
	    $.console.assert( options.tile, "[TileCache.cacheTile] options.tile is required" );
	    $.console.assert( options.tiledImage, "[TileCache.cacheTile] options.tiledImage is required" );
	    this.tile = options.tile;
	    this.tiledImage = options.tiledImage;
	};
	
	// private class
	var ImageRecord = function(options) {
	    $.console.assert( options, "[ImageRecord] options is required" );
	    $.console.assert( options.image, "[ImageRecord] options.image is required" );
	    this._image = options.image;
	    this._tiles = [];
	};
	
	ImageRecord.prototype = {
	    destroy: function() {
	        this._image = null;
	        this._renderedContext = null;
	        this._tiles = null;
	    },
	
	    getImage: function() {
	        return this._image;
	    },
	
	    getRenderedContext: function() {
	        if (!this._renderedContext) {
	            var canvas = document.createElement( 'canvas' );
	            canvas.width = this._image.width;
	            canvas.height = this._image.height;
	            this._renderedContext = canvas.getContext('2d');
	            this._renderedContext.drawImage( this._image, 0, 0 );
	            //since we are caching the prerendered image on a canvas
	            //allow the image to not be held in memory
	            this._image = null;
	        }
	        return this._renderedContext;
	    },
	
	    setRenderedContext: function(renderedContext) {
	        $.console.error("ImageRecord.setRenderedContext is deprecated. " +
	                "The rendered context should be created by the ImageRecord " +
	                "itself when calling ImageRecord.getRenderedContext.");
	        this._renderedContext = renderedContext;
	    },
	
	    addTile: function(tile) {
	        $.console.assert(tile, '[ImageRecord.addTile] tile is required');
	        this._tiles.push(tile);
	    },
	
	    removeTile: function(tile) {
	        for (var i = 0; i < this._tiles.length; i++) {
	            if (this._tiles[i] === tile) {
	                this._tiles.splice(i, 1);
	                return;
	            }
	        }
	
	        $.console.warn('[ImageRecord.removeTile] trying to remove unknown tile', tile);
	    },
	
	    getTileCount: function() {
	        return this._tiles.length;
	    }
	};
	
	/**
	 * @class TileCache
	 * @memberof OpenSeadragon
	 * @classdesc Stores all the tiles displayed in a {@link OpenSeadragon.Viewer}.
	 * You generally won't have to interact with the TileCache directly.
	 * @param {Object} options - Configuration for this TileCache.
	 * @param {Number} [options.maxImageCacheCount] - See maxImageCacheCount in
	 * {@link OpenSeadragon.Options} for details.
	 */
	$.TileCache = function( options ) {
	    options = options || {};
	
	    this._maxImageCacheCount = options.maxImageCacheCount || $.DEFAULT_SETTINGS.maxImageCacheCount;
	    this._tilesLoaded = [];
	    this._imagesLoaded = [];
	    this._imagesLoadedCount = 0;
	};
	
	/** @lends OpenSeadragon.TileCache.prototype */
	$.TileCache.prototype = {
	    /**
	     * @returns {Number} The total number of tiles that have been loaded by
	     * this TileCache.
	     */
	    numTilesLoaded: function() {
	        return this._tilesLoaded.length;
	    },
	
	    /**
	     * Caches the specified tile, removing an old tile if necessary to stay under the
	     * maxImageCacheCount specified on construction. Note that if multiple tiles reference
	     * the same image, there may be more tiles than maxImageCacheCount; the goal is to keep
	     * the number of images below that number. Note, as well, that even the number of images
	     * may temporarily surpass that number, but should eventually come back down to the max specified.
	     * @param {Object} options - Tile info.
	     * @param {OpenSeadragon.Tile} options.tile - The tile to cache.
	     * @param {String} options.tile.cacheKey - The unique key used to identify this tile in the cache.
	     * @param {Image} options.image - The image of the tile to cache.
	     * @param {OpenSeadragon.TiledImage} options.tiledImage - The TiledImage that owns that tile.
	     * @param {Number} [options.cutoff=0] - If adding this tile goes over the cache max count, this
	     * function will release an old tile. The cutoff option specifies a tile level at or below which
	     * tiles will not be released.
	     */
	    cacheTile: function( options ) {
	        $.console.assert( options, "[TileCache.cacheTile] options is required" );
	        $.console.assert( options.tile, "[TileCache.cacheTile] options.tile is required" );
	        $.console.assert( options.tile.cacheKey, "[TileCache.cacheTile] options.tile.cacheKey is required" );
	        $.console.assert( options.tiledImage, "[TileCache.cacheTile] options.tiledImage is required" );
	
	        var cutoff = options.cutoff || 0;
	        var insertionIndex = this._tilesLoaded.length;
	
	        var imageRecord = this._imagesLoaded[options.tile.cacheKey];
	        if (!imageRecord) {
	            $.console.assert( options.image, "[TileCache.cacheTile] options.image is required to create an ImageRecord" );
	            imageRecord = this._imagesLoaded[options.tile.cacheKey] = new ImageRecord({
	                image: options.image
	            });
	
	            this._imagesLoadedCount++;
	        }
	
	        imageRecord.addTile(options.tile);
	        options.tile.cacheImageRecord = imageRecord;
	
	        // Note that just because we're unloading a tile doesn't necessarily mean
	        // we're unloading an image. With repeated calls it should sort itself out, though.
	        if ( this._imagesLoadedCount > this._maxImageCacheCount ) {
	            var worstTile       = null;
	            var worstTileIndex  = -1;
	            var worstTileRecord = null;
	            var prevTile, worstTime, worstLevel, prevTime, prevLevel, prevTileRecord;
	
	            for ( var i = this._tilesLoaded.length - 1; i >= 0; i-- ) {
	                prevTileRecord = this._tilesLoaded[ i ];
	                prevTile = prevTileRecord.tile;
	
	                if ( prevTile.level <= cutoff || prevTile.beingDrawn ) {
	                    continue;
	                } else if ( !worstTile ) {
	                    worstTile       = prevTile;
	                    worstTileIndex  = i;
	                    worstTileRecord = prevTileRecord;
	                    continue;
	                }
	
	                prevTime    = prevTile.lastTouchTime;
	                worstTime   = worstTile.lastTouchTime;
	                prevLevel   = prevTile.level;
	                worstLevel  = worstTile.level;
	
	                if ( prevTime < worstTime ||
	                   ( prevTime == worstTime && prevLevel > worstLevel ) ) {
	                    worstTile       = prevTile;
	                    worstTileIndex  = i;
	                    worstTileRecord = prevTileRecord;
	                }
	            }
	
	            if ( worstTile && worstTileIndex >= 0 ) {
	                this._unloadTile(worstTileRecord);
	                insertionIndex = worstTileIndex;
	            }
	        }
	
	        this._tilesLoaded[ insertionIndex ] = new TileRecord({
	            tile: options.tile,
	            tiledImage: options.tiledImage
	        });
	    },
	
	    /**
	     * Clears all tiles associated with the specified tiledImage.
	     * @param {OpenSeadragon.TiledImage} tiledImage
	     */
	    clearTilesFor: function( tiledImage ) {
	        $.console.assert(tiledImage, '[TileCache.clearTilesFor] tiledImage is required');
	        var tileRecord;
	        for ( var i = 0; i < this._tilesLoaded.length; ++i ) {
	            tileRecord = this._tilesLoaded[ i ];
	            if ( tileRecord.tiledImage === tiledImage ) {
	                this._unloadTile(tileRecord);
	                this._tilesLoaded.splice( i, 1 );
	                i--;
	            }
	        }
	    },
	
	    // private
	    getImageRecord: function(cacheKey) {
	        $.console.assert(cacheKey, '[TileCache.getImageRecord] cacheKey is required');
	        return this._imagesLoaded[cacheKey];
	    },
	
	    // private
	    _unloadTile: function(tileRecord) {
	        $.console.assert(tileRecord, '[TileCache._unloadTile] tileRecord is required');
	        var tile = tileRecord.tile;
	        var tiledImage = tileRecord.tiledImage;
	
	        tile.unload();
	        tile.cacheImageRecord = null;
	
	        var imageRecord = this._imagesLoaded[tile.cacheKey];
	        imageRecord.removeTile(tile);
	        if (!imageRecord.getTileCount()) {
	            imageRecord.destroy();
	            delete this._imagesLoaded[tile.cacheKey];
	            this._imagesLoadedCount--;
	        }
	
	        /**
	         * Triggered when a tile has just been unloaded from memory.
	         *
	         * @event tile-unloaded
	         * @memberof OpenSeadragon.Viewer
	         * @type {object}
	         * @property {OpenSeadragon.TiledImage} tiledImage - The tiled image of the unloaded tile.
	         * @property {OpenSeadragon.Tile} tile - The tile which has been unloaded.
	         */
	        tiledImage.viewer.raiseEvent("tile-unloaded", {
	            tile: tile,
	            tiledImage: tiledImage
	        });
	    }
	};
	
	}( OpenSeadragon ));
	
	/*
	 * OpenSeadragon - World
	 *
	 * Copyright (C) 2009 CodePlex Foundation
	 * Copyright (C) 2010-2013 OpenSeadragon contributors
	 *
	 * Redistribution and use in source and binary forms, with or without
	 * modification, are permitted provided that the following conditions are
	 * met:
	 *
	 * - Redistributions of source code must retain the above copyright notice,
	 *   this list of conditions and the following disclaimer.
	 *
	 * - Redistributions in binary form must reproduce the above copyright
	 *   notice, this list of conditions and the following disclaimer in the
	 *   documentation and/or other materials provided with the distribution.
	 *
	 * - Neither the name of CodePlex Foundation nor the names of its
	 *   contributors may be used to endorse or promote products derived from
	 *   this software without specific prior written permission.
	 *
	 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
	 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
	 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
	 * A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT
	 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
	 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
	 * TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 * PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
	 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
	 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
	 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	 */
	
	(function( $ ){
	
	/**
	 * @class World
	 * @memberof OpenSeadragon
	 * @extends OpenSeadragon.EventSource
	 * @classdesc Keeps track of all of the tiled images in the scene.
	 * @param {Object} options - World options.
	 * @param {OpenSeadragon.Viewer} options.viewer - The Viewer that owns this World.
	 **/
	$.World = function( options ) {
	    var _this = this;
	
	    $.console.assert( options.viewer, "[World] options.viewer is required" );
	
	    $.EventSource.call( this );
	
	    this.viewer = options.viewer;
	    this._items = [];
	    this._needsDraw = false;
	    this._autoRefigureSizes = true;
	    this._needsSizesFigured = false;
	    this._delegatedFigureSizes = function(event) {
	        if (_this._autoRefigureSizes) {
	            _this._figureSizes();
	        } else {
	            _this._needsSizesFigured = true;
	        }
	    };
	
	    this._figureSizes();
	};
	
	$.extend( $.World.prototype, $.EventSource.prototype, /** @lends OpenSeadragon.World.prototype */{
	    /**
	     * Add the specified item.
	     * @param {OpenSeadragon.TiledImage} item - The item to add.
	     * @param {Number} [options.index] - Index for the item. If not specified, goes at the top.
	     * @fires OpenSeadragon.World.event:add-item
	     * @fires OpenSeadragon.World.event:metrics-change
	     */
	    addItem: function( item, options ) {
	        $.console.assert(item, "[World.addItem] item is required");
	        $.console.assert(item instanceof $.TiledImage, "[World.addItem] only TiledImages supported at this time");
	
	        options = options || {};
	        if (options.index !== undefined) {
	            var index = Math.max(0, Math.min(this._items.length, options.index));
	            this._items.splice(index, 0, item);
	        } else {
	            this._items.push( item );
	        }
	
	        if (this._autoRefigureSizes) {
	            this._figureSizes();
	        } else {
	            this._needsSizesFigured = true;
	        }
	
	        this._needsDraw = true;
	
	        item.addHandler('bounds-change', this._delegatedFigureSizes);
	        item.addHandler('clip-change', this._delegatedFigureSizes);
	
	        /**
	         * Raised when an item is added to the World.
	         * @event add-item
	         * @memberOf OpenSeadragon.World
	         * @type {object}
	         * @property {OpenSeadragon.Viewer} eventSource - A reference to the World which raised the event.
	         * @property {OpenSeadragon.TiledImage} item - The item that has been added.
	         * @property {?Object} userData - Arbitrary subscriber-defined object.
	         */
	        this.raiseEvent( 'add-item', {
	            item: item
	        } );
	    },
	
	    /**
	     * Get the item at the specified index.
	     * @param {Number} index - The item's index.
	     * @returns {OpenSeadragon.TiledImage} The item at the specified index.
	     */
	    getItemAt: function( index ) {
	        $.console.assert(index !== undefined, "[World.getItemAt] index is required");
	        return this._items[ index ];
	    },
	
	    /**
	     * Get the index of the given item or -1 if not present.
	     * @param {OpenSeadragon.TiledImage} item - The item.
	     * @returns {Number} The index of the item or -1 if not present.
	     */
	    getIndexOfItem: function( item ) {
	        $.console.assert(item, "[World.getIndexOfItem] item is required");
	        return $.indexOf( this._items, item );
	    },
	
	    /**
	     * @returns {Number} The number of items used.
	     */
	    getItemCount: function() {
	        return this._items.length;
	    },
	
	    /**
	     * Change the index of a item so that it appears over or under others.
	     * @param {OpenSeadragon.TiledImage} item - The item to move.
	     * @param {Number} index - The new index.
	     * @fires OpenSeadragon.World.event:item-index-change
	     */
	    setItemIndex: function( item, index ) {
	        $.console.assert(item, "[World.setItemIndex] item is required");
	        $.console.assert(index !== undefined, "[World.setItemIndex] index is required");
	
	        var oldIndex = this.getIndexOfItem( item );
	
	        if ( index >= this._items.length ) {
	            throw new Error( "Index bigger than number of layers." );
	        }
	
	        if ( index === oldIndex || oldIndex === -1 ) {
	            return;
	        }
	
	        this._items.splice( oldIndex, 1 );
	        this._items.splice( index, 0, item );
	        this._needsDraw = true;
	
	        /**
	         * Raised when the order of the indexes has been changed.
	         * @event item-index-change
	         * @memberOf OpenSeadragon.World
	         * @type {object}
	         * @property {OpenSeadragon.World} eventSource - A reference to the World which raised the event.
	         * @property {OpenSeadragon.TiledImage} item - The item whose index has
	         * been changed
	         * @property {Number} previousIndex - The previous index of the item
	         * @property {Number} newIndex - The new index of the item
	         * @property {?Object} userData - Arbitrary subscriber-defined object.
	         */
	        this.raiseEvent( 'item-index-change', {
	            item: item,
	            previousIndex: oldIndex,
	            newIndex: index
	        } );
	    },
	
	    /**
	     * Remove an item.
	     * @param {OpenSeadragon.TiledImage} item - The item to remove.
	     * @fires OpenSeadragon.World.event:remove-item
	     * @fires OpenSeadragon.World.event:metrics-change
	     */
	    removeItem: function( item ) {
	        $.console.assert(item, "[World.removeItem] item is required");
	
	        var index = $.indexOf(this._items, item );
	        if ( index === -1 ) {
	            return;
	        }
	
	        item.removeHandler('bounds-change', this._delegatedFigureSizes);
	        item.removeHandler('clip-change', this._delegatedFigureSizes);
	        item.destroy();
	        this._items.splice( index, 1 );
	        this._figureSizes();
	        this._needsDraw = true;
	        this._raiseRemoveItem(item);
	    },
	
	    /**
	     * Remove all items.
	     * @fires OpenSeadragon.World.event:remove-item
	     * @fires OpenSeadragon.World.event:metrics-change
	     */
	    removeAll: function() {
	        // We need to make sure any pending images are canceled so the world items don't get messed up
	        this.viewer._cancelPendingImages();
	        var item;
	        var i;
	        for (i = 0; i < this._items.length; i++) {
	            item = this._items[i];
	            item.removeHandler('bounds-change', this._delegatedFigureSizes);
	            item.removeHandler('clip-change', this._delegatedFigureSizes);
	            item.destroy();
	        }
	
	        var removedItems = this._items;
	        this._items = [];
	        this._figureSizes();
	        this._needsDraw = true;
	
	        for (i = 0; i < removedItems.length; i++) {
	            item = removedItems[i];
	            this._raiseRemoveItem(item);
	        }
	    },
	
	    /**
	     * Clears all tiles and triggers updates for all items.
	     */
	    resetItems: function() {
	        for ( var i = 0; i < this._items.length; i++ ) {
	            this._items[i].reset();
	        }
	    },
	
	    /**
	     * Updates (i.e. animates bounds of) all items.
	     */
	    update: function() {
	        var animated = false;
	        for ( var i = 0; i < this._items.length; i++ ) {
	            animated = this._items[i].update() || animated;
	        }
	
	        return animated;
	    },
	
	    /**
	     * Draws all items.
	     */
	    draw: function() {
	        for ( var i = 0; i < this._items.length; i++ ) {
	            this._items[i].draw();
	        }
	
	        this._needsDraw = false;
	    },
	
	    /**
	     * @returns {Boolean} true if any items need updating.
	     */
	    needsDraw: function() {
	        for ( var i = 0; i < this._items.length; i++ ) {
	            if ( this._items[i].needsDraw() ) {
	                return true;
	            }
	        }
	        return this._needsDraw;
	    },
	
	    /**
	     * @returns {OpenSeadragon.Rect} The smallest rectangle that encloses all items, in viewport coordinates.
	     */
	    getHomeBounds: function() {
	        return this._homeBounds.clone();
	    },
	
	    /**
	     * To facilitate zoom constraints, we keep track of the pixel density of the
	     * densest item in the World (i.e. the item whose content size to viewport size
	     * ratio is the highest) and save it as this "content factor".
	     * @returns {Number} the number of content units per viewport unit.
	     */
	    getContentFactor: function() {
	        return this._contentFactor;
	    },
	
	    /**
	     * As a performance optimization, setting this flag to false allows the bounds-change event handler
	     * on tiledImages to skip calculations on the world bounds. If a lot of images are going to be positioned in
	     * rapid succession, this is a good idea. When finished, setAutoRefigureSizes should be called with true
	     * or the system may behave oddly.
	     * @param {Boolean} [value] The value to which to set the flag.
	     */
	    setAutoRefigureSizes: function(value) {
	        this._autoRefigureSizes = value;
	        if (value & this._needsSizesFigured) {
	            this._figureSizes();
	            this._needsSizesFigured = false;
	        }
	    },
	
	    /**
	     * Arranges all of the TiledImages with the specified settings.
	     * @param {Object} options - Specifies how to arrange.
	     * @param {Boolean} [options.immediately=false] - Whether to animate to the new arrangement.
	     * @param {String} [options.layout] - See collectionLayout in {@link OpenSeadragon.Options}.
	     * @param {Number} [options.rows] - See collectionRows in {@link OpenSeadragon.Options}.
	     * @param {Number} [options.columns] - See collectionColumns in {@link OpenSeadragon.Options}.
	     * @param {Number} [options.tileSize] - See collectionTileSize in {@link OpenSeadragon.Options}.
	     * @param {Number} [options.tileMargin] - See collectionTileMargin in {@link OpenSeadragon.Options}.
	     * @fires OpenSeadragon.World.event:metrics-change
	     */
	    arrange: function(options) {
	        options = options || {};
	        var immediately = options.immediately || false;
	        var layout = options.layout || $.DEFAULT_SETTINGS.collectionLayout;
	        var rows = options.rows || $.DEFAULT_SETTINGS.collectionRows;
	        var columns = options.columns || $.DEFAULT_SETTINGS.collectionColumns;
	        var tileSize = options.tileSize || $.DEFAULT_SETTINGS.collectionTileSize;
	        var tileMargin = options.tileMargin || $.DEFAULT_SETTINGS.collectionTileMargin;
	        var increment = tileSize + tileMargin;
	        var wrap;
	        if (!options.rows && columns) {
	            wrap = columns;
	        } else {
	            wrap = Math.ceil(this._items.length / rows);
	        }
	        var x = 0;
	        var y = 0;
	        var item, box, width, height, position;
	
	        this.setAutoRefigureSizes(false);
	        for (var i = 0; i < this._items.length; i++) {
	            if (i && (i % wrap) === 0) {
	                if (layout === 'horizontal') {
	                    y += increment;
	                    x = 0;
	                } else {
	                    x += increment;
	                    y = 0;
	                }
	            }
	
	            item = this._items[i];
	            box = item.getBounds();
	            if (box.width > box.height) {
	                width = tileSize;
	            } else {
	                width = tileSize * (box.width / box.height);
	            }
	
	            height = width * (box.height / box.width);
	            position = new $.Point(x + ((tileSize - width) / 2),
	                y + ((tileSize - height) / 2));
	
	            item.setPosition(position, immediately);
	            item.setWidth(width, immediately);
	
	            if (layout === 'horizontal') {
	                x += increment;
	            } else {
	                y += increment;
	            }
	        }
	        this.setAutoRefigureSizes(true);
	    },
	
	    // private
	    _figureSizes: function() {
	        var oldHomeBounds = this._homeBounds ? this._homeBounds.clone() : null;
	        var oldContentSize = this._contentSize ? this._contentSize.clone() : null;
	        var oldContentFactor = this._contentFactor || 0;
	
	        if (!this._items.length) {
	            this._homeBounds = new $.Rect(0, 0, 1, 1);
	            this._contentSize = new $.Point(1, 1);
	            this._contentFactor = 1;
	        } else {
	            var item = this._items[0];
	            var bounds = item.getBounds();
	            this._contentFactor = item.getContentSize().x / bounds.width;
	            var clippedBounds = item.getClippedBounds().getBoundingBox();
	            var left = clippedBounds.x;
	            var top = clippedBounds.y;
	            var right = clippedBounds.x + clippedBounds.width;
	            var bottom = clippedBounds.y + clippedBounds.height;
	            for (var i = 1; i < this._items.length; i++) {
	                item = this._items[i];
	                bounds = item.getBounds();
	                this._contentFactor = Math.max(this._contentFactor,
	                    item.getContentSize().x / bounds.width);
	                clippedBounds = item.getClippedBounds().getBoundingBox();
	                left = Math.min(left, clippedBounds.x);
	                top = Math.min(top, clippedBounds.y);
	                right = Math.max(right, clippedBounds.x + clippedBounds.width);
	                bottom = Math.max(bottom, clippedBounds.y + clippedBounds.height);
	            }
	
	            this._homeBounds = new $.Rect(left, top, right - left, bottom - top);
	            this._contentSize = new $.Point(
	                this._homeBounds.width * this._contentFactor,
	                this._homeBounds.height * this._contentFactor);
	        }
	
	        if (this._contentFactor !== oldContentFactor ||
	            !this._homeBounds.equals(oldHomeBounds) ||
	            !this._contentSize.equals(oldContentSize)) {
	            /**
	             * Raised when the home bounds or content factor change.
	             * @event metrics-change
	             * @memberOf OpenSeadragon.World
	             * @type {object}
	             * @property {OpenSeadragon.World} eventSource - A reference to the World which raised the event.
	             * @property {?Object} userData - Arbitrary subscriber-defined object.
	             */
	            this.raiseEvent('metrics-change', {});
	        }
	    },
	
	    // private
	    _raiseRemoveItem: function(item) {
	        /**
	         * Raised when an item is removed.
	         * @event remove-item
	         * @memberOf OpenSeadragon.World
	         * @type {object}
	         * @property {OpenSeadragon.World} eventSource - A reference to the World which raised the event.
	         * @property {OpenSeadragon.TiledImage} item - The item's underlying item.
	         * @property {?Object} userData - Arbitrary subscriber-defined object.
	         */
	        this.raiseEvent( 'remove-item', { item: item } );
	    }
	});
	
	}( OpenSeadragon ));
	
	//# sourceMappingURL=openseadragon.js.map

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = __webpack_require__(112);
	
	function emptyFunction() {}
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    var err = new Error(
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	    err.name = 'Invariant Violation';
	    throw err;
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim
	  };
	
	  ReactPropTypes.checkPropTypes = emptyFunction;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ }),
/* 112 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(17);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(34);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var BurgerIcon = (function (_Component) {
	  _inherits(BurgerIcon, _Component);
	
	  function BurgerIcon(props) {
	    _classCallCheck(this, BurgerIcon);
	
	    _get(Object.getPrototypeOf(BurgerIcon.prototype), 'constructor', this).call(this, props);
	    this.state = {
	      hover: false
	    };
	  }
	
	  _createClass(BurgerIcon, [{
	    key: 'getLineStyle',
	    value: function getLineStyle(index) {
	      return {
	        position: 'absolute',
	        height: '20%',
	        left: 0,
	        right: 0,
	        top: 20 * (index * 2) + '%',
	        opacity: this.state.hover ? 0.6 : 1
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this = this;
	
	      var icon = undefined;
	      var buttonStyle = {
	        position: 'absolute',
	        left: 0,
	        top: 0,
	        width: '100%',
	        height: '100%',
	        margin: 0,
	        padding: 0,
	        border: 'none',
	        opacity: 0,
	        fontSize: 8,
	        cursor: 'pointer'
	      };
	
	      if (this.props.customIcon) {
	        var extraProps = {
	          className: 'bm-icon',
	          style: _extends({ width: '100%', height: '100%' }, this.props.styles.bmIcon)
	        };
	        icon = _react2['default'].cloneElement(this.props.customIcon, extraProps);
	      } else {
	        icon = _react2['default'].createElement(
	          'span',
	          null,
	          [0, 1, 2].map(function (bar) {
	            return _react2['default'].createElement('span', {
	              key: bar,
	              className: ('bm-burger-bars ' + _this.props.barClassName).trim(),
	              style: _extends({}, _this.getLineStyle(bar), _this.props.styles.bmBurgerBars)
	            });
	          })
	        );
	      }
	
	      return _react2['default'].createElement(
	        'div',
	        {
	          className: ('bm-burger-button ' + this.props.className).trim(),
	          style: _extends({ zIndex: 1000 }, this.props.styles.bmBurgerButton)
	        },
	        icon,
	        _react2['default'].createElement(
	          'button',
	          {
	            onClick: this.props.onClick,
	            onMouseOver: function () {
	              return _this.setState({ hover: true });
	            },
	            onMouseOut: function () {
	              return _this.setState({ hover: false });
	            },
	            style: buttonStyle
	          },
	          'Open Menu'
	        )
	      );
	    }
	  }]);
	
	  return BurgerIcon;
	})(_react.Component);
	
	exports['default'] = BurgerIcon;
	
	BurgerIcon.propTypes = {
	  barClassName: _propTypes2['default'].string,
	  customIcon: _propTypes2['default'].element,
	  styles: _propTypes2['default'].object
	};
	
	BurgerIcon.defaultProps = {
	  barClassName: '',
	  className: '',
	  styles: {}
	};
	module.exports = exports['default'];

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = {
	  slide: __webpack_require__(125),
	  stack: __webpack_require__(126),
	  elastic: __webpack_require__(118),
	  bubble: __webpack_require__(117),
	  push: __webpack_require__(120),
	  pushRotate: __webpack_require__(121),
	  scaleDown: __webpack_require__(123),
	  scaleRotate: __webpack_require__(124),
	  fallDown: __webpack_require__(119),
	  reveal: __webpack_require__(122)
	};
	module.exports = exports['default'];

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(17);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(34);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var CrossIcon = (function (_Component) {
	  _inherits(CrossIcon, _Component);
	
	  function CrossIcon() {
	    _classCallCheck(this, CrossIcon);
	
	    _get(Object.getPrototypeOf(CrossIcon.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(CrossIcon, [{
	    key: 'getCrossStyle',
	    value: function getCrossStyle(type) {
	      return {
	        position: 'absolute',
	        width: 3,
	        height: 14,
	        transform: type === 'before' ? 'rotate(45deg)' : 'rotate(-45deg)'
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this = this;
	
	      var icon;
	      var buttonWrapperStyle = {
	        position: 'absolute',
	        width: 24,
	        height: 24,
	        right: 8,
	        top: 8
	      };
	      var buttonStyle = {
	        position: 'absolute',
	        left: 0,
	        top: 0,
	        width: '100%',
	        height: '100%',
	        margin: 0,
	        padding: 0,
	        border: 'none',
	        fontSize: 0,
	        background: 'transparent',
	        color: 'transparent',
	        outline: 'none',
	        cursor: 'pointer'
	      };
	
	      if (this.props.customIcon) {
	        var extraProps = {
	          className: 'bm-cross',
	          style: _extends({ width: '100%', height: '100%' }, this.props.styles.bmCross)
	        };
	        icon = _react2['default'].cloneElement(this.props.customIcon, extraProps);
	      } else {
	        icon = _react2['default'].createElement(
	          'span',
	          { style: { position: 'absolute', top: '6px', right: '14px' } },
	          ['before', 'after'].map(function (type, i) {
	            return _react2['default'].createElement('span', {
	              key: i,
	              className: ('bm-cross ' + _this.props.crossClassName).trim(),
	              style: _extends({}, _this.getCrossStyle(type), _this.props.styles.bmCross)
	            });
	          })
	        );
	      }
	
	      return _react2['default'].createElement(
	        'div',
	        {
	          className: ('bm-cross-button ' + this.props.className).trim(),
	          style: _extends({}, buttonWrapperStyle, this.props.styles.bmCrossButton)
	        },
	        icon,
	        _react2['default'].createElement(
	          'button',
	          { onClick: this.props.onClick, style: buttonStyle },
	          'Close Menu'
	        )
	      );
	    }
	  }]);
	
	  return CrossIcon;
	})(_react.Component);
	
	exports['default'] = CrossIcon;
	
	CrossIcon.propTypes = {
	  crossClassName: _propTypes2['default'].string,
	  customIcon: _propTypes2['default'].element,
	  styles: _propTypes2['default'].object
	};
	
	CrossIcon.defaultProps = {
	  crossClassName: '',
	  className: '',
	  styles: {}
	};
	module.exports = exports['default'];

/***/ }),
/* 116 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var styles = {
	  overlay: function overlay(isOpen) {
	    return {
	      position: 'fixed',
	      zIndex: 1000,
	      width: '100%',
	      height: '100%',
	      background: 'rgba(0, 0, 0, 0.3)',
	      opacity: isOpen ? 1 : 0,
	      MozTransform: isOpen ? '' : 'translate3d(100%, 0, 0)',
	      MsTransform: isOpen ? '' : 'translate3d(100%, 0, 0)',
	      OTransform: isOpen ? '' : 'translate3d(100%, 0, 0)',
	      WebkitTransform: isOpen ? '' : 'translate3d(100%, 0, 0)',
	      transform: isOpen ? '' : 'translate3d(100%, 0, 0)',
	      transition: isOpen ? 'opacity 0.3s' : 'opacity 0.3s, transform 0s 0.3s'
	    };
	  },
	
	  menuWrap: function menuWrap(isOpen, width, right) {
	    return {
	      position: 'fixed',
	      right: right ? 0 : 'inherit',
	      zIndex: 1100,
	      width: width,
	      height: '100%',
	      MozTransform: isOpen ? '' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
	      MsTransform: isOpen ? '' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
	      OTransform: isOpen ? '' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
	      WebkitTransform: isOpen ? '' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
	      transform: isOpen ? '' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
	      transition: 'all 0.5s'
	    };
	  },
	
	  menu: function menu() {
	    return {
	      height: '100%',
	      boxSizing: 'border-box',
	      overflow: 'auto'
	    };
	  },
	
	  itemList: function itemList() {
	    return {
	      height: '100%'
	    };
	  },
	
	  item: function item() {
	    return {
	      display: 'block',
	      outline: 'none'
	    };
	  }
	};
	
	exports['default'] = styles;
	module.exports = exports['default'];

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _snapsvgImporter = __webpack_require__(61);
	
	var _snapsvgImporter2 = _interopRequireDefault(_snapsvgImporter);
	
	var _menuFactory = __webpack_require__(10);
	
	var _menuFactory2 = _interopRequireDefault(_menuFactory);
	
	var styles = {
	  svg: {
	    lib: _snapsvgImporter2['default'],
	    pathInitial: 'M-7.312,0H0c0,0,0,113.839,0,400c0,264.506,0,400,0,400h-7.312V0z',
	    pathOpen: 'M-7.312,0H15c0,0,66,113.339,66,399.5C81,664.006,15,800,15,800H-7.312V0z;M-7.312,0H100c0,0,0,113.839,0,400c0,264.506,0,400,0,400H-7.312V0z',
	    animate: function animate(path) {
	      var pos = 0;
	      var steps = this.pathOpen.split(';');
	      var stepsTotal = steps.length;
	      var mina = window.mina;
	
	      var nextStep = function nextStep() {
	        if (pos > stepsTotal - 1) return;
	
	        path.animate({ path: steps[pos] }, pos === 0 ? 400 : 500, pos === 0 ? mina.easein : mina.elastic, function () {
	          nextStep();
	        });
	
	        pos++;
	      };
	
	      nextStep();
	    }
	  },
	
	  morphShape: function morphShape(isOpen, width, right) {
	    return {
	      position: 'absolute',
	      width: '100%',
	      height: '100%',
	      right: right ? 'inherit' : 0,
	      left: right ? 0 : 'inherit',
	      MozTransform: right ? 'rotateY(180deg)' : 'rotateY(0deg)',
	      MsTransform: right ? 'rotateY(180deg)' : 'rotateY(0deg)',
	      OTransform: right ? 'rotateY(180deg)' : 'rotateY(0deg)',
	      WebkitTransform: right ? 'rotateY(180deg)' : 'rotateY(0deg)',
	      transform: right ? 'rotateY(180deg)' : 'rotateY(0deg)'
	    };
	  },
	
	  menuWrap: function menuWrap(isOpen, width, right) {
	    return {
	      MozTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
	      MsTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
	      OTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
	      WebkitTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
	      transform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
	      transition: isOpen ? 'transform 0.4s 0s' : 'transform 0.4s'
	    };
	  },
	
	  menu: function menu(isOpen, width, right) {
	    width -= 140;
	    return {
	      position: 'fixed',
	      MozTransform: isOpen ? '' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
	      MsTransform: isOpen ? '' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
	      OTransform: isOpen ? '' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
	      WebkitTransform: isOpen ? '' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
	      transform: isOpen ? '' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
	      transition: isOpen ? 'opacity 0.1s 0.4s cubic-bezier(.17, .67, .1, 1.27), transform 0.1s 0.4s cubic-bezier(.17, .67, .1, 1.27)' : 'opacity 0s 0.3s cubic-bezier(.17, .67, .1, 1.27), transform 0s 0.3s cubic-bezier(.17, .67, .1, 1.27)',
	      opacity: isOpen ? 1 : 0
	    };
	  },
	
	  item: function item(isOpen, width, right, nthChild) {
	    width -= 140;
	    return {
	      MozTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
	      MsTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
	      OTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
	      WebkitTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
	      transform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
	      transition: isOpen ? 'opacity 0.3s 0.4s, transform 0.3s 0.4s' : 'opacity 0s 0.3s cubic-bezier(.17, .67, .1, 1.27), transform 0s 0.3s cubic-bezier(.17, .67, .1, 1.27)',
	      opacity: isOpen ? 1 : 0
	    };
	  },
	
	  closeButton: function closeButton(isOpen, width, right) {
	    width -= 140;
	    return {
	      MozTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
	      MsTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
	      OTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
	      WebkitTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
	      transform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
	      transition: isOpen ? 'opacity 0.3s 0.4s cubic-bezier(.17, .67, .1, 1.27), transform 0.3s 0.4s cubic-bezier(.17, .67, .1, 1.27)' : 'opacity 0s 0.3s cubic-bezier(.17, .67, .1, 1.27), transform 0s 0.3s cubic-bezier(.17, .67, .1, 1.27)',
	      opacity: isOpen ? 1 : 0
	    };
	  }
	};
	
	exports['default'] = (0, _menuFactory2['default'])(styles);
	module.exports = exports['default'];

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _snapsvgImporter = __webpack_require__(61);
	
	var _snapsvgImporter2 = _interopRequireDefault(_snapsvgImporter);
	
	var _menuFactory = __webpack_require__(10);
	
	var _menuFactory2 = _interopRequireDefault(_menuFactory);
	
	var styles = {
	  svg: {
	    lib: _snapsvgImporter2['default'],
	    pathInitial: 'M-1,0h101c0,0-97.833,153.603-97.833,396.167C2.167,627.579,100,800,100,800H-1V0z',
	    pathOpen: 'M-1,0h101c0,0,0-1,0,395c0,404,0,405,0,405H-1V0z',
	    animate: function animate(path) {
	      path.animate({ path: this.pathOpen }, 400, window.mina.easeinout);
	    }
	  },
	
	  morphShape: function morphShape(isOpen, width, right) {
	    return {
	      position: 'absolute',
	      width: 120,
	      height: '100%',
	      right: right ? 'inherit' : 0,
	      left: right ? 0 : 'inherit',
	      MozTransform: right ? 'rotateY(180deg)' : '',
	      MsTransform: right ? 'rotateY(180deg)' : '',
	      OTransform: right ? 'rotateY(180deg)' : '',
	      WebkitTransform: right ? 'rotateY(180deg)' : '',
	      transform: right ? 'rotateY(180deg)' : ''
	    };
	  },
	
	  menuWrap: function menuWrap(isOpen, width, right) {
	    return {
	      MozTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
	      MsTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
	      OTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
	      WebkitTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
	      transform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
	      transition: 'all 0.3s'
	    };
	  },
	
	  menu: function menu(isOpen, width, right) {
	    return {
	      position: 'fixed',
	      right: right ? 0 : 'inherit',
	      width: 180,
	      whiteSpace: 'nowrap',
	      boxSizing: 'border-box',
	      overflow: 'visible'
	    };
	  },
	
	  itemList: function itemList(isOpen, width, right) {
	    if (right) {
	      return {
	        position: 'relative',
	        left: '-110px',
	        width: '170%',
	        overflow: 'auto'
	      };
	    }
	  },
	
	  pageWrap: function pageWrap(isOpen, width, right) {
	    return {
	      MozTransform: isOpen ? '' : right ? 'translate3d(-100px, 0, 0)' : 'translate3d(100px, 0, 0)',
	      MsTransform: isOpen ? '' : right ? 'translate3d(-100px, 0, 0)' : 'translate3d(100px, 0, 0)',
	      OTransform: isOpen ? '' : right ? 'translate3d(-100px, 0, 0)' : 'translate3d(100px, 0, 0)',
	      WebkitTransform: isOpen ? '' : right ? 'translate3d(-100px, 0, 0)' : 'translate3d(100px, 0, 0)',
	      transform: isOpen ? '' : right ? 'translate3d(-100px, 0, 0)' : 'translate3d(100px, 0, 0)',
	      transition: isOpen ? 'all 0.3s' : 'all 0.3s 0.1s'
	    };
	  },
	
	  outerContainer: function outerContainer(isOpen) {
	    return {
	      overflow: isOpen ? '' : 'hidden'
	    };
	  }
	};
	
	exports['default'] = (0, _menuFactory2['default'])(styles);
	module.exports = exports['default'];

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _menuFactory = __webpack_require__(10);
	
	var _menuFactory2 = _interopRequireDefault(_menuFactory);
	
	var styles = {
	  menuWrap: function menuWrap(isOpen) {
	    return {
	      MozTransform: isOpen ? '' : 'translate3d(0, -100%, 0)',
	      MsTransform: isOpen ? '' : 'translate3d(0, -100%, 0)',
	      OTransform: isOpen ? '' : 'translate3d(0, -100%, 0)',
	      WebkitTransform: isOpen ? '' : 'translate3d(0, -100%, 0)',
	      transform: isOpen ? '' : 'translate3d(0, -100%, 0)',
	      transition: 'all 0.5s ease-in-out'
	    };
	  },
	
	  pageWrap: function pageWrap(isOpen, width, right) {
	    return {
	      MozTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
	      MsTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
	      OTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
	      WebkitTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
	      transform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
	      transition: 'all 0.5s'
	    };
	  },
	
	  outerContainer: function outerContainer(isOpen) {
	    return {
	      perspective: '1500px',
	      perspectiveOrigin: '0% 50%',
	      overflow: isOpen ? '' : 'hidden'
	    };
	  }
	};
	
	exports['default'] = (0, _menuFactory2['default'])(styles);
	module.exports = exports['default'];

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _menuFactory = __webpack_require__(10);
	
	var _menuFactory2 = _interopRequireDefault(_menuFactory);
	
	var styles = {
	  pageWrap: function pageWrap(isOpen, width, right) {
	    return {
	      MozTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
	      MsTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
	      OTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
	      WebkitTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
	      transform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
	      transition: 'all 0.5s'
	    };
	  },
	
	  outerContainer: function outerContainer(isOpen) {
	    return {
	      overflow: isOpen ? '' : 'hidden'
	    };
	  }
	};
	
	exports['default'] = (0, _menuFactory2['default'])(styles);
	module.exports = exports['default'];

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _menuFactory = __webpack_require__(10);
	
	var _menuFactory2 = _interopRequireDefault(_menuFactory);
	
	var styles = {
	  pageWrap: function pageWrap(isOpen, width, right) {
	    return {
	      MozTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0) rotateY(15deg)' : 'translate3d(' + width + ', 0, 0) rotateY(-15deg)',
	      MsTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0) rotateY(15deg)' : 'translate3d(' + width + ', 0, 0) rotateY(-15deg)',
	      OTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0) rotateY(15deg)' : 'translate3d(' + width + ', 0, 0) rotateY(-15deg)',
	      WebkitTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0) rotateY(15deg)' : 'translate3d(' + width + ', 0, 0) rotateY(-15deg)',
	      transform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0) rotateY(15deg)' : 'translate3d(' + width + ', 0, 0) rotateY(-15deg)',
	      transformOrigin: right ? '100% 50%' : '0% 50%',
	      transformStyle: 'preserve-3d',
	      transition: 'all 0.5s'
	    };
	  },
	
	  outerContainer: function outerContainer(isOpen) {
	    return {
	      perspective: '1500px',
	      overflow: isOpen ? '' : 'hidden'
	    };
	  }
	};
	
	exports['default'] = (0, _menuFactory2['default'])(styles);
	module.exports = exports['default'];

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _menuFactory = __webpack_require__(10);
	
	var _menuFactory2 = _interopRequireDefault(_menuFactory);
	
	var styles = {
	  menuWrap: function menuWrap(isOpen, width, right) {
	    return {
	      visibility: isOpen ? 'visible' : 'hidden',
	      MozTransform: 'translate3d(0, 0, 0)',
	      MsTransform: 'translate3d(0, 0, 0)',
	      OTransform: 'translate3d(0, 0, 0)',
	      WebkitTransform: 'translate3d(0, 0, 0)',
	      transform: 'translate3d(0, 0, 0)',
	      zIndex: 1000
	    };
	  },
	
	  overlay: function overlay(isOpen, width, right) {
	    return {
	      zIndex: 1400,
	      MozTransform: isOpen ? right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)' : 'translate3d(0, 0, 0)',
	      MsTransform: isOpen ? right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)' : 'translate3d(0, 0, 0)',
	      OTransform: isOpen ? right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)' : 'translate3d(0, 0, 0)',
	      WebkitTransform: isOpen ? right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)' : 'translate3d(0, 0, 0)',
	      transform: isOpen ? right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)' : 'translate3d(0, 0, 0)',
	      transition: 'all 0.5s',
	      visibility: isOpen ? 'visible' : 'hidden'
	    };
	  },
	
	  pageWrap: function pageWrap(isOpen, width, right) {
	    return {
	      MozTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
	      MsTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
	      OTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
	      WebkitTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
	      transform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
	      transition: 'all 0.5s',
	      zIndex: 1200,
	      position: 'relative'
	    };
	  },
	
	  burgerIcon: function burgerIcon(isOpen, width, right) {
	    return {
	      MozTransform: isOpen ? right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)' : 'translate3d(0, 0, 0)',
	      MsTransform: isOpen ? right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)' : 'translate3d(0, 0, 0)',
	      OTransform: isOpen ? right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)' : 'translate3d(0, 0, 0)',
	      WebkitTransform: isOpen ? right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)' : 'translate3d(0, 0, 0)',
	      transform: isOpen ? right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)' : 'translate3d(0, 0, 0)',
	      transition: 'all 0.1s',
	      position: 'relative',
	      zIndex: 1300
	    };
	  },
	
	  outerContainer: function outerContainer(isOpen) {
	    return {
	      overflow: isOpen ? '' : 'hidden'
	    };
	  }
	};
	
	exports['default'] = (0, _menuFactory2['default'])(styles);
	module.exports = exports['default'];

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _menuFactory = __webpack_require__(10);
	
	var _menuFactory2 = _interopRequireDefault(_menuFactory);
	
	var styles = {
	  pageWrap: function pageWrap(isOpen, width) {
	    return {
	      MozTransform: isOpen ? '' : 'translate3d(0, 0, -' + width + ')',
	      MsTransform: isOpen ? '' : 'translate3d(0, 0, -' + width + ')',
	      OTransform: isOpen ? '' : 'translate3d(0, 0, -' + width + ')',
	      WebkitTransform: isOpen ? '' : 'translate3d(0, 0, -' + width + ')',
	      transform: isOpen ? '' : 'translate3d(0, 0, -' + width + ')',
	      transformOrigin: '100%',
	      transformStyle: 'preserve-3d',
	      transition: 'all 0.5s'
	    };
	  },
	
	  outerContainer: function outerContainer() {
	    return {
	      perspective: '1500px'
	    };
	  }
	};
	
	exports['default'] = (0, _menuFactory2['default'])(styles);
	module.exports = exports['default'];

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _menuFactory = __webpack_require__(10);
	
	var _menuFactory2 = _interopRequireDefault(_menuFactory);
	
	var styles = {
	  pageWrap: function pageWrap(isOpen, width, right) {
	    return {
	      MozTransform: isOpen ? '' : right ? 'translate3d(-100px, 0, -600px) rotateY(20deg)' : 'translate3d(100px, 0, -600px) rotateY(-20deg)',
	      MsTransform: isOpen ? '' : right ? 'translate3d(-100px, 0, -600px) rotateY(20deg)' : 'translate3d(100px, 0, -600px) rotateY(-20deg)',
	      OTransform: isOpen ? '' : right ? 'translate3d(-100px, 0, -600px) rotateY(20deg)' : 'translate3d(100px, 0, -600px) rotateY(-20deg)',
	      WebkitTransform: isOpen ? '' : right ? 'translate3d(-100px, 0, -600px) rotateY(20deg)' : 'translate3d(100px, 0, -600px) rotateY(-20deg)',
	      transform: isOpen ? '' : right ? 'translate3d(-100px, 0, -600px) rotateY(20deg)' : 'translate3d(100px, 0, -600px) rotateY(-20deg)',
	      transformStyle: 'preserve-3d',
	      transition: 'all 0.5s',
	      overflow: isOpen ? '' : 'hidden'
	    };
	  },
	
	  outerContainer: function outerContainer(isOpen) {
	    return {
	      perspective: '1500px',
	      overflow: isOpen ? '' : 'hidden'
	    };
	  }
	};
	
	exports['default'] = (0, _menuFactory2['default'])(styles);
	module.exports = exports['default'];

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _menuFactory = __webpack_require__(10);
	
	var _menuFactory2 = _interopRequireDefault(_menuFactory);
	
	var styles = {};
	
	exports['default'] = (0, _menuFactory2['default'])(styles);
	module.exports = exports['default'];

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _menuFactory = __webpack_require__(10);
	
	var _menuFactory2 = _interopRequireDefault(_menuFactory);
	
	var styles = {
	  menuWrap: function menuWrap(isOpen, width, right) {
	    return {
	      MozTransform: isOpen ? '' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
	      MsTransform: isOpen ? '' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
	      OTransform: isOpen ? '' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
	      WebkitTransform: isOpen ? '' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
	      transform: isOpen ? '' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
	      transition: isOpen ? 'transform 0.8s cubic-bezier(0.7, 0, 0.3, 1)' : 'transform 0.4s cubic-bezier(0.7, 0, 0.3, 1)'
	    };
	  },
	
	  item: function item(isOpen, width, right, nthChild) {
	    return {
	      MozTransform: isOpen ? '' : 'translate3d(0, ' + nthChild * 500 + 'px, 0)',
	      MsTransform: isOpen ? '' : 'translate3d(0, ' + nthChild * 500 + 'px, 0)',
	      OTransform: isOpen ? '' : 'translate3d(0, ' + nthChild * 500 + 'px, 0)',
	      WebkitTransform: isOpen ? '' : 'translate3d(0, ' + nthChild * 500 + 'px, 0)',
	      transform: isOpen ? '' : 'translate3d(0, ' + nthChild * 500 + 'px, 0)',
	      transition: isOpen ? 'transform 0.8s cubic-bezier(0.7, 0, 0.3, 1)' : 'transform 0s 0.2s cubic-bezier(0.7, 0, 0.3, 1)'
	    };
	  }
	};
	
	exports['default'] = (0, _menuFactory2['default'])(styles);
	module.exports = exports['default'];

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule AutoFocusUtils
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var ReactMount = __webpack_require__(5);
	
	var findDOMNode = __webpack_require__(43);
	var focusNode = __webpack_require__(56);
	
	var Mixin = {
	  componentDidMount: function () {
	    if (this.props.autoFocus) {
	      focusNode(findDOMNode(this));
	    }
	  }
	};
	
	var AutoFocusUtils = {
	  Mixin: Mixin,
	
	  focusDOMComponent: function () {
	    focusNode(ReactMount.getNode(this._rootNodeID));
	  }
	};
	
	module.exports = AutoFocusUtils;

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015 Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule BeforeInputEventPlugin
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(11);
	var EventPropagators = __webpack_require__(22);
	var ExecutionEnvironment = __webpack_require__(4);
	var FallbackCompositionState = __webpack_require__(136);
	var SyntheticCompositionEvent = __webpack_require__(166);
	var SyntheticInputEvent = __webpack_require__(169);
	
	var keyOf = __webpack_require__(13);
	
	var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
	var START_KEYCODE = 229;
	
	var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;
	
	var documentMode = null;
	if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
	  documentMode = document.documentMode;
	}
	
	// Webkit offers a very useful `textInput` event that can be used to
	// directly represent `beforeInput`. The IE `textinput` event is not as
	// useful, so we don't use it.
	var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();
	
	// In IE9+, we have access to composition events, but the data supplied
	// by the native compositionend event may be incorrect. Japanese ideographic
	// spaces, for instance (\u3000) are not recorded correctly.
	var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);
	
	/**
	 * Opera <= 12 includes TextEvent in window, but does not fire
	 * text input events. Rely on keypress instead.
	 */
	function isPresto() {
	  var opera = window.opera;
	  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
	}
	
	var SPACEBAR_CODE = 32;
	var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	// Events and their corresponding property names.
	var eventTypes = {
	  beforeInput: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onBeforeInput: null }),
	      captured: keyOf({ onBeforeInputCapture: null })
	    },
	    dependencies: [topLevelTypes.topCompositionEnd, topLevelTypes.topKeyPress, topLevelTypes.topTextInput, topLevelTypes.topPaste]
	  },
	  compositionEnd: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCompositionEnd: null }),
	      captured: keyOf({ onCompositionEndCapture: null })
	    },
	    dependencies: [topLevelTypes.topBlur, topLevelTypes.topCompositionEnd, topLevelTypes.topKeyDown, topLevelTypes.topKeyPress, topLevelTypes.topKeyUp, topLevelTypes.topMouseDown]
	  },
	  compositionStart: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCompositionStart: null }),
	      captured: keyOf({ onCompositionStartCapture: null })
	    },
	    dependencies: [topLevelTypes.topBlur, topLevelTypes.topCompositionStart, topLevelTypes.topKeyDown, topLevelTypes.topKeyPress, topLevelTypes.topKeyUp, topLevelTypes.topMouseDown]
	  },
	  compositionUpdate: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCompositionUpdate: null }),
	      captured: keyOf({ onCompositionUpdateCapture: null })
	    },
	    dependencies: [topLevelTypes.topBlur, topLevelTypes.topCompositionUpdate, topLevelTypes.topKeyDown, topLevelTypes.topKeyPress, topLevelTypes.topKeyUp, topLevelTypes.topMouseDown]
	  }
	};
	
	// Track whether we've ever handled a keypress on the space key.
	var hasSpaceKeypress = false;
	
	/**
	 * Return whether a native keypress event is assumed to be a command.
	 * This is required because Firefox fires `keypress` events for key commands
	 * (cut, copy, select-all, etc.) even though no character is inserted.
	 */
	function isKeypressCommand(nativeEvent) {
	  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
	  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
	  !(nativeEvent.ctrlKey && nativeEvent.altKey);
	}
	
	/**
	 * Translate native top level events into event types.
	 *
	 * @param {string} topLevelType
	 * @return {object}
	 */
	function getCompositionEventType(topLevelType) {
	  switch (topLevelType) {
	    case topLevelTypes.topCompositionStart:
	      return eventTypes.compositionStart;
	    case topLevelTypes.topCompositionEnd:
	      return eventTypes.compositionEnd;
	    case topLevelTypes.topCompositionUpdate:
	      return eventTypes.compositionUpdate;
	  }
	}
	
	/**
	 * Does our fallback best-guess model think this event signifies that
	 * composition has begun?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionStart(topLevelType, nativeEvent) {
	  return topLevelType === topLevelTypes.topKeyDown && nativeEvent.keyCode === START_KEYCODE;
	}
	
	/**
	 * Does our fallback mode think that this event is the end of composition?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionEnd(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case topLevelTypes.topKeyUp:
	      // Command keys insert or clear IME input.
	      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
	    case topLevelTypes.topKeyDown:
	      // Expect IME keyCode on each keydown. If we get any other
	      // code we must have exited earlier.
	      return nativeEvent.keyCode !== START_KEYCODE;
	    case topLevelTypes.topKeyPress:
	    case topLevelTypes.topMouseDown:
	    case topLevelTypes.topBlur:
	      // Events are not possible without cancelling IME.
	      return true;
	    default:
	      return false;
	  }
	}
	
	/**
	 * Google Input Tools provides composition data via a CustomEvent,
	 * with the `data` property populated in the `detail` object. If this
	 * is available on the event object, use it. If not, this is a plain
	 * composition event and we have nothing special to extract.
	 *
	 * @param {object} nativeEvent
	 * @return {?string}
	 */
	function getDataFromCustomEvent(nativeEvent) {
	  var detail = nativeEvent.detail;
	  if (typeof detail === 'object' && 'data' in detail) {
	    return detail.data;
	  }
	  return null;
	}
	
	// Track the current IME composition fallback object, if any.
	var currentComposition = null;
	
	/**
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {DOMEventTarget} topLevelTarget The listening component root node.
	 * @param {string} topLevelTargetID ID of `topLevelTarget`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?object} A SyntheticCompositionEvent.
	 */
	function extractCompositionEvent(topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget) {
	  var eventType;
	  var fallbackData;
	
	  if (canUseCompositionEvent) {
	    eventType = getCompositionEventType(topLevelType);
	  } else if (!currentComposition) {
	    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
	      eventType = eventTypes.compositionStart;
	    }
	  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	    eventType = eventTypes.compositionEnd;
	  }
	
	  if (!eventType) {
	    return null;
	  }
	
	  if (useFallbackCompositionData) {
	    // The current composition is stored statically and must not be
	    // overwritten while composition continues.
	    if (!currentComposition && eventType === eventTypes.compositionStart) {
	      currentComposition = FallbackCompositionState.getPooled(topLevelTarget);
	    } else if (eventType === eventTypes.compositionEnd) {
	      if (currentComposition) {
	        fallbackData = currentComposition.getData();
	      }
	    }
	  }
	
	  var event = SyntheticCompositionEvent.getPooled(eventType, topLevelTargetID, nativeEvent, nativeEventTarget);
	
	  if (fallbackData) {
	    // Inject data generated from fallback path into the synthetic event.
	    // This matches the property of native CompositionEventInterface.
	    event.data = fallbackData;
	  } else {
	    var customData = getDataFromCustomEvent(nativeEvent);
	    if (customData !== null) {
	      event.data = customData;
	    }
	  }
	
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The string corresponding to this `beforeInput` event.
	 */
	function getNativeBeforeInputChars(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case topLevelTypes.topCompositionEnd:
	      return getDataFromCustomEvent(nativeEvent);
	    case topLevelTypes.topKeyPress:
	      /**
	       * If native `textInput` events are available, our goal is to make
	       * use of them. However, there is a special case: the spacebar key.
	       * In Webkit, preventing default on a spacebar `textInput` event
	       * cancels character insertion, but it *also* causes the browser
	       * to fall back to its default spacebar behavior of scrolling the
	       * page.
	       *
	       * Tracking at:
	       * https://code.google.com/p/chromium/issues/detail?id=355103
	       *
	       * To avoid this issue, use the keypress event as if no `textInput`
	       * event is available.
	       */
	      var which = nativeEvent.which;
	      if (which !== SPACEBAR_CODE) {
	        return null;
	      }
	
	      hasSpaceKeypress = true;
	      return SPACEBAR_CHAR;
	
	    case topLevelTypes.topTextInput:
	      // Record the characters to be added to the DOM.
	      var chars = nativeEvent.data;
	
	      // If it's a spacebar character, assume that we have already handled
	      // it at the keypress level and bail immediately. Android Chrome
	      // doesn't give us keycodes, so we need to blacklist it.
	      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
	        return null;
	      }
	
	      return chars;
	
	    default:
	      // For other native event types, do nothing.
	      return null;
	  }
	}
	
	/**
	 * For browsers that do not provide the `textInput` event, extract the
	 * appropriate string to use for SyntheticInputEvent.
	 *
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The fallback string for this `beforeInput` event.
	 */
	function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
	  // If we are currently composing (IME) and using a fallback to do so,
	  // try to extract the composed characters from the fallback object.
	  if (currentComposition) {
	    if (topLevelType === topLevelTypes.topCompositionEnd || isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	      var chars = currentComposition.getData();
	      FallbackCompositionState.release(currentComposition);
	      currentComposition = null;
	      return chars;
	    }
	    return null;
	  }
	
	  switch (topLevelType) {
	    case topLevelTypes.topPaste:
	      // If a paste event occurs after a keypress, throw out the input
	      // chars. Paste events should not lead to BeforeInput events.
	      return null;
	    case topLevelTypes.topKeyPress:
	      /**
	       * As of v27, Firefox may fire keypress events even when no character
	       * will be inserted. A few possibilities:
	       *
	       * - `which` is `0`. Arrow keys, Esc key, etc.
	       *
	       * - `which` is the pressed key code, but no char is available.
	       *   Ex: 'AltGr + d` in Polish. There is no modified character for
	       *   this key combination and no character is inserted into the
	       *   document, but FF fires the keypress for char code `100` anyway.
	       *   No `input` event will occur.
	       *
	       * - `which` is the pressed key code, but a command combination is
	       *   being used. Ex: `Cmd+C`. No character is inserted, and no
	       *   `input` event will occur.
	       */
	      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
	        return String.fromCharCode(nativeEvent.which);
	      }
	      return null;
	    case topLevelTypes.topCompositionEnd:
	      return useFallbackCompositionData ? null : nativeEvent.data;
	    default:
	      return null;
	  }
	}
	
	/**
	 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
	 * `textInput` or fallback behavior.
	 *
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {DOMEventTarget} topLevelTarget The listening component root node.
	 * @param {string} topLevelTargetID ID of `topLevelTarget`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?object} A SyntheticInputEvent.
	 */
	function extractBeforeInputEvent(topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget) {
	  var chars;
	
	  if (canUseTextInputEvent) {
	    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
	  } else {
	    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
	  }
	
	  // If no characters are being inserted, no BeforeInput event should
	  // be fired.
	  if (!chars) {
	    return null;
	  }
	
	  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, topLevelTargetID, nativeEvent, nativeEventTarget);
	
	  event.data = chars;
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * Create an `onBeforeInput` event to match
	 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
	 *
	 * This event plugin is based on the native `textInput` event
	 * available in Chrome, Safari, Opera, and IE. This event fires after
	 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
	 *
	 * `beforeInput` is spec'd but not implemented in any browsers, and
	 * the `input` event does not provide any useful information about what has
	 * actually been added, contrary to the spec. Thus, `textInput` is the best
	 * available event to identify the characters that have actually been inserted
	 * into the target node.
	 *
	 * This plugin is also responsible for emitting `composition` events, thus
	 * allowing us to share composition fallback code for both `beforeInput` and
	 * `composition` event types.
	 */
	var BeforeInputEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  /**
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {DOMEventTarget} topLevelTarget The listening component root node.
	   * @param {string} topLevelTargetID ID of `topLevelTarget`.
	   * @param {object} nativeEvent Native browser event.
	   * @return {*} An accumulation of synthetic events.
	   * @see {EventPluginHub.extractEvents}
	   */
	  extractEvents: function (topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget) {
	    return [extractCompositionEvent(topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget)];
	  }
	};
	
	module.exports = BeforeInputEventPlugin;

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule CSSPropertyOperations
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(63);
	var ExecutionEnvironment = __webpack_require__(4);
	var ReactPerf = __webpack_require__(7);
	
	var camelizeStyleName = __webpack_require__(99);
	var dangerousStyleValue = __webpack_require__(174);
	var hyphenateStyleName = __webpack_require__(104);
	var memoizeStringOnly = __webpack_require__(108);
	var warning = __webpack_require__(2);
	
	var processStyleName = memoizeStringOnly(function (styleName) {
	  return hyphenateStyleName(styleName);
	});
	
	var hasShorthandPropertyBug = false;
	var styleFloatAccessor = 'cssFloat';
	if (ExecutionEnvironment.canUseDOM) {
	  var tempStyle = document.createElement('div').style;
	  try {
	    // IE8 throws "Invalid argument." if resetting shorthand style properties.
	    tempStyle.font = '';
	  } catch (e) {
	    hasShorthandPropertyBug = true;
	  }
	  // IE8 only supports accessing cssFloat (standard) as styleFloat
	  if (document.documentElement.style.cssFloat === undefined) {
	    styleFloatAccessor = 'styleFloat';
	  }
	}
	
	if (false) {
	  // 'msTransform' is correct, but the other prefixes should be capitalized
	  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
	
	  // style values shouldn't contain a semicolon
	  var badStyleValueWithSemicolonPattern = /;\s*$/;
	
	  var warnedStyleNames = {};
	  var warnedStyleValues = {};
	
	  var warnHyphenatedStyleName = function (name) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?', name, camelizeStyleName(name)) : undefined;
	  };
	
	  var warnBadVendoredStyleName = function (name) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?', name, name.charAt(0).toUpperCase() + name.slice(1)) : undefined;
	  };
	
	  var warnStyleValueWithSemicolon = function (name, value) {
	    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
	      return;
	    }
	
	    warnedStyleValues[value] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Style property values shouldn\'t contain a semicolon. ' + 'Try "%s: %s" instead.', name, value.replace(badStyleValueWithSemicolonPattern, '')) : undefined;
	  };
	
	  /**
	   * @param {string} name
	   * @param {*} value
	   */
	  var warnValidStyle = function (name, value) {
	    if (name.indexOf('-') > -1) {
	      warnHyphenatedStyleName(name);
	    } else if (badVendoredStyleNamePattern.test(name)) {
	      warnBadVendoredStyleName(name);
	    } else if (badStyleValueWithSemicolonPattern.test(value)) {
	      warnStyleValueWithSemicolon(name, value);
	    }
	  };
	}
	
	/**
	 * Operations for dealing with CSS properties.
	 */
	var CSSPropertyOperations = {
	
	  /**
	   * Serializes a mapping of style properties for use as inline styles:
	   *
	   *   > createMarkupForStyles({width: '200px', height: 0})
	   *   "width:200px;height:0;"
	   *
	   * Undefined values are ignored so that declarative programming is easier.
	   * The result should be HTML-escaped before insertion into the DOM.
	   *
	   * @param {object} styles
	   * @return {?string}
	   */
	  createMarkupForStyles: function (styles) {
	    var serialized = '';
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var styleValue = styles[styleName];
	      if (false) {
	        warnValidStyle(styleName, styleValue);
	      }
	      if (styleValue != null) {
	        serialized += processStyleName(styleName) + ':';
	        serialized += dangerousStyleValue(styleName, styleValue) + ';';
	      }
	    }
	    return serialized || null;
	  },
	
	  /**
	   * Sets the value for multiple styles on a node.  If a value is specified as
	   * '' (empty string), the corresponding style property will be unset.
	   *
	   * @param {DOMElement} node
	   * @param {object} styles
	   */
	  setValueForStyles: function (node, styles) {
	    var style = node.style;
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      if (false) {
	        warnValidStyle(styleName, styles[styleName]);
	      }
	      var styleValue = dangerousStyleValue(styleName, styles[styleName]);
	      if (styleName === 'float') {
	        styleName = styleFloatAccessor;
	      }
	      if (styleValue) {
	        style[styleName] = styleValue;
	      } else {
	        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
	        if (expansion) {
	          // Shorthand property that IE8 won't like unsetting, so unset each
	          // component to placate it
	          for (var individualStyleName in expansion) {
	            style[individualStyleName] = '';
	          }
	        } else {
	          style[styleName] = '';
	        }
	      }
	    }
	  }
	
	};
	
	ReactPerf.measureMethods(CSSPropertyOperations, 'CSSPropertyOperations', {
	  setValueForStyles: 'setValueForStyles'
	});
	
	module.exports = CSSPropertyOperations;

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ChangeEventPlugin
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(11);
	var EventPluginHub = __webpack_require__(21);
	var EventPropagators = __webpack_require__(22);
	var ExecutionEnvironment = __webpack_require__(4);
	var ReactUpdates = __webpack_require__(8);
	var SyntheticEvent = __webpack_require__(16);
	
	var getEventTarget = __webpack_require__(46);
	var isEventSupported = __webpack_require__(49);
	var isTextInputElement = __webpack_require__(90);
	var keyOf = __webpack_require__(13);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	var eventTypes = {
	  change: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onChange: null }),
	      captured: keyOf({ onChangeCapture: null })
	    },
	    dependencies: [topLevelTypes.topBlur, topLevelTypes.topChange, topLevelTypes.topClick, topLevelTypes.topFocus, topLevelTypes.topInput, topLevelTypes.topKeyDown, topLevelTypes.topKeyUp, topLevelTypes.topSelectionChange]
	  }
	};
	
	/**
	 * For IE shims
	 */
	var activeElement = null;
	var activeElementID = null;
	var activeElementValue = null;
	var activeElementValueProp = null;
	
	/**
	 * SECTION: handle `change` event
	 */
	function shouldUseChangeEvent(elem) {
	  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
	  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
	}
	
	var doesChangeEventBubble = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // See `handleChange` comment below
	  doesChangeEventBubble = isEventSupported('change') && (!('documentMode' in document) || document.documentMode > 8);
	}
	
	function manualDispatchChangeEvent(nativeEvent) {
	  var event = SyntheticEvent.getPooled(eventTypes.change, activeElementID, nativeEvent, getEventTarget(nativeEvent));
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	
	  // If change and propertychange bubbled, we'd just bind to it like all the
	  // other events and have it go through ReactBrowserEventEmitter. Since it
	  // doesn't, we manually listen for the events and so we have to enqueue and
	  // process the abstract event manually.
	  //
	  // Batching is necessary here in order to ensure that all event handlers run
	  // before the next rerender (including event handlers attached to ancestor
	  // elements instead of directly on the input). Without this, controlled
	  // components don't work properly in conjunction with event bubbling because
	  // the component is rerendered and the value reverted before all the event
	  // handlers can run. See https://github.com/facebook/react/issues/708.
	  ReactUpdates.batchedUpdates(runEventInBatch, event);
	}
	
	function runEventInBatch(event) {
	  EventPluginHub.enqueueEvents(event);
	  EventPluginHub.processEventQueue(false);
	}
	
	function startWatchingForChangeEventIE8(target, targetID) {
	  activeElement = target;
	  activeElementID = targetID;
	  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
	}
	
	function stopWatchingForChangeEventIE8() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
	  activeElement = null;
	  activeElementID = null;
	}
	
	function getTargetIDForChangeEvent(topLevelType, topLevelTarget, topLevelTargetID) {
	  if (topLevelType === topLevelTypes.topChange) {
	    return topLevelTargetID;
	  }
	}
	function handleEventsForChangeEventIE8(topLevelType, topLevelTarget, topLevelTargetID) {
	  if (topLevelType === topLevelTypes.topFocus) {
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForChangeEventIE8();
	    startWatchingForChangeEventIE8(topLevelTarget, topLevelTargetID);
	  } else if (topLevelType === topLevelTypes.topBlur) {
	    stopWatchingForChangeEventIE8();
	  }
	}
	
	/**
	 * SECTION: handle `input` event
	 */
	var isInputEventSupported = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // IE9 claims to support the input event but fails to trigger it when
	  // deleting text, so we ignore its input events
	  isInputEventSupported = isEventSupported('input') && (!('documentMode' in document) || document.documentMode > 9);
	}
	
	/**
	 * (For old IE.) Replacement getter/setter for the `value` property that gets
	 * set on the active element.
	 */
	var newValueProp = {
	  get: function () {
	    return activeElementValueProp.get.call(this);
	  },
	  set: function (val) {
	    // Cast to a string so we can do equality checks.
	    activeElementValue = '' + val;
	    activeElementValueProp.set.call(this, val);
	  }
	};
	
	/**
	 * (For old IE.) Starts tracking propertychange events on the passed-in element
	 * and override the value property so that we can distinguish user events from
	 * value changes in JS.
	 */
	function startWatchingForValueChange(target, targetID) {
	  activeElement = target;
	  activeElementID = targetID;
	  activeElementValue = target.value;
	  activeElementValueProp = Object.getOwnPropertyDescriptor(target.constructor.prototype, 'value');
	
	  // Not guarded in a canDefineProperty check: IE8 supports defineProperty only
	  // on DOM elements
	  Object.defineProperty(activeElement, 'value', newValueProp);
	  activeElement.attachEvent('onpropertychange', handlePropertyChange);
	}
	
	/**
	 * (For old IE.) Removes the event listeners from the currently-tracked element,
	 * if any exists.
	 */
	function stopWatchingForValueChange() {
	  if (!activeElement) {
	    return;
	  }
	
	  // delete restores the original property definition
	  delete activeElement.value;
	  activeElement.detachEvent('onpropertychange', handlePropertyChange);
	
	  activeElement = null;
	  activeElementID = null;
	  activeElementValue = null;
	  activeElementValueProp = null;
	}
	
	/**
	 * (For old IE.) Handles a propertychange event, sending a `change` event if
	 * the value of the active element has changed.
	 */
	function handlePropertyChange(nativeEvent) {
	  if (nativeEvent.propertyName !== 'value') {
	    return;
	  }
	  var value = nativeEvent.srcElement.value;
	  if (value === activeElementValue) {
	    return;
	  }
	  activeElementValue = value;
	
	  manualDispatchChangeEvent(nativeEvent);
	}
	
	/**
	 * If a `change` event should be fired, returns the target's ID.
	 */
	function getTargetIDForInputEvent(topLevelType, topLevelTarget, topLevelTargetID) {
	  if (topLevelType === topLevelTypes.topInput) {
	    // In modern browsers (i.e., not IE8 or IE9), the input event is exactly
	    // what we want so fall through here and trigger an abstract event
	    return topLevelTargetID;
	  }
	}
	
	// For IE8 and IE9.
	function handleEventsForInputEventIE(topLevelType, topLevelTarget, topLevelTargetID) {
	  if (topLevelType === topLevelTypes.topFocus) {
	    // In IE8, we can capture almost all .value changes by adding a
	    // propertychange handler and looking for events with propertyName
	    // equal to 'value'
	    // In IE9, propertychange fires for most input events but is buggy and
	    // doesn't fire when text is deleted, but conveniently, selectionchange
	    // appears to fire in all of the remaining cases so we catch those and
	    // forward the event if the value has changed
	    // In either case, we don't want to call the event handler if the value
	    // is changed from JS so we redefine a setter for `.value` that updates
	    // our activeElementValue variable, allowing us to ignore those changes
	    //
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForValueChange();
	    startWatchingForValueChange(topLevelTarget, topLevelTargetID);
	  } else if (topLevelType === topLevelTypes.topBlur) {
	    stopWatchingForValueChange();
	  }
	}
	
	// For IE8 and IE9.
	function getTargetIDForInputEventIE(topLevelType, topLevelTarget, topLevelTargetID) {
	  if (topLevelType === topLevelTypes.topSelectionChange || topLevelType === topLevelTypes.topKeyUp || topLevelType === topLevelTypes.topKeyDown) {
	    // On the selectionchange event, the target is just document which isn't
	    // helpful for us so just check activeElement instead.
	    //
	    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
	    // propertychange on the first input event after setting `value` from a
	    // script and fires only keydown, keypress, keyup. Catching keyup usually
	    // gets it and catching keydown lets us fire an event for the first
	    // keystroke if user does a key repeat (it'll be a little delayed: right
	    // before the second keystroke). Other input methods (e.g., paste) seem to
	    // fire selectionchange normally.
	    if (activeElement && activeElement.value !== activeElementValue) {
	      activeElementValue = activeElement.value;
	      return activeElementID;
	    }
	  }
	}
	
	/**
	 * SECTION: handle `click` event
	 */
	function shouldUseClickEvent(elem) {
	  // Use the `click` event to detect changes to checkbox and radio inputs.
	  // This approach works across all browsers, whereas `change` does not fire
	  // until `blur` in IE8.
	  return elem.nodeName && elem.nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
	}
	
	function getTargetIDForClickEvent(topLevelType, topLevelTarget, topLevelTargetID) {
	  if (topLevelType === topLevelTypes.topClick) {
	    return topLevelTargetID;
	  }
	}
	
	/**
	 * This plugin creates an `onChange` event that normalizes change events
	 * across form elements. This event fires at a time when it's possible to
	 * change the element's value without seeing a flicker.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - select
	 */
	var ChangeEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  /**
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {DOMEventTarget} topLevelTarget The listening component root node.
	   * @param {string} topLevelTargetID ID of `topLevelTarget`.
	   * @param {object} nativeEvent Native browser event.
	   * @return {*} An accumulation of synthetic events.
	   * @see {EventPluginHub.extractEvents}
	   */
	  extractEvents: function (topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget) {
	
	    var getTargetIDFunc, handleEventFunc;
	    if (shouldUseChangeEvent(topLevelTarget)) {
	      if (doesChangeEventBubble) {
	        getTargetIDFunc = getTargetIDForChangeEvent;
	      } else {
	        handleEventFunc = handleEventsForChangeEventIE8;
	      }
	    } else if (isTextInputElement(topLevelTarget)) {
	      if (isInputEventSupported) {
	        getTargetIDFunc = getTargetIDForInputEvent;
	      } else {
	        getTargetIDFunc = getTargetIDForInputEventIE;
	        handleEventFunc = handleEventsForInputEventIE;
	      }
	    } else if (shouldUseClickEvent(topLevelTarget)) {
	      getTargetIDFunc = getTargetIDForClickEvent;
	    }
	
	    if (getTargetIDFunc) {
	      var targetID = getTargetIDFunc(topLevelType, topLevelTarget, topLevelTargetID);
	      if (targetID) {
	        var event = SyntheticEvent.getPooled(eventTypes.change, targetID, nativeEvent, nativeEventTarget);
	        event.type = 'change';
	        EventPropagators.accumulateTwoPhaseDispatches(event);
	        return event;
	      }
	    }
	
	    if (handleEventFunc) {
	      handleEventFunc(topLevelType, topLevelTarget, topLevelTargetID);
	    }
	  }
	
	};
	
	module.exports = ChangeEventPlugin;

/***/ }),
/* 131 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ClientReactRootIndex
	 * @typechecks
	 */
	
	'use strict';
	
	var nextReactRootIndex = 0;
	
	var ClientReactRootIndex = {
	  createReactRootIndex: function () {
	    return nextReactRootIndex++;
	  }
	};
	
	module.exports = ClientReactRootIndex;

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule Danger
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(4);
	
	var createNodesFromMarkup = __webpack_require__(101);
	var emptyFunction = __webpack_require__(9);
	var getMarkupWrap = __webpack_require__(58);
	var invariant = __webpack_require__(1);
	
	var OPEN_TAG_NAME_EXP = /^(<[^ \/>]+)/;
	var RESULT_INDEX_ATTR = 'data-danger-index';
	
	/**
	 * Extracts the `nodeName` from a string of markup.
	 *
	 * NOTE: Extracting the `nodeName` does not require a regular expression match
	 * because we make assumptions about React-generated markup (i.e. there are no
	 * spaces surrounding the opening tag and there is at least one attribute).
	 *
	 * @param {string} markup String of markup.
	 * @return {string} Node name of the supplied markup.
	 * @see http://jsperf.com/extract-nodename
	 */
	function getNodeName(markup) {
	  return markup.substring(1, markup.indexOf(' '));
	}
	
	var Danger = {
	
	  /**
	   * Renders markup into an array of nodes. The markup is expected to render
	   * into a list of root nodes. Also, the length of `resultList` and
	   * `markupList` should be the same.
	   *
	   * @param {array<string>} markupList List of markup strings to render.
	   * @return {array<DOMElement>} List of rendered nodes.
	   * @internal
	   */
	  dangerouslyRenderMarkup: function (markupList) {
	    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyRenderMarkup(...): Cannot render markup in a worker ' + 'thread. Make sure `window` and `document` are available globally ' + 'before requiring React when unit testing or use ' + 'ReactDOMServer.renderToString for server rendering.') : invariant(false) : undefined;
	    var nodeName;
	    var markupByNodeName = {};
	    // Group markup by `nodeName` if a wrap is necessary, else by '*'.
	    for (var i = 0; i < markupList.length; i++) {
	      !markupList[i] ?  false ? invariant(false, 'dangerouslyRenderMarkup(...): Missing markup.') : invariant(false) : undefined;
	      nodeName = getNodeName(markupList[i]);
	      nodeName = getMarkupWrap(nodeName) ? nodeName : '*';
	      markupByNodeName[nodeName] = markupByNodeName[nodeName] || [];
	      markupByNodeName[nodeName][i] = markupList[i];
	    }
	    var resultList = [];
	    var resultListAssignmentCount = 0;
	    for (nodeName in markupByNodeName) {
	      if (!markupByNodeName.hasOwnProperty(nodeName)) {
	        continue;
	      }
	      var markupListByNodeName = markupByNodeName[nodeName];
	
	      // This for-in loop skips the holes of the sparse array. The order of
	      // iteration should follow the order of assignment, which happens to match
	      // numerical index order, but we don't rely on that.
	      var resultIndex;
	      for (resultIndex in markupListByNodeName) {
	        if (markupListByNodeName.hasOwnProperty(resultIndex)) {
	          var markup = markupListByNodeName[resultIndex];
	
	          // Push the requested markup with an additional RESULT_INDEX_ATTR
	          // attribute.  If the markup does not start with a < character, it
	          // will be discarded below (with an appropriate console.error).
	          markupListByNodeName[resultIndex] = markup.replace(OPEN_TAG_NAME_EXP,
	          // This index will be parsed back out below.
	          '$1 ' + RESULT_INDEX_ATTR + '="' + resultIndex + '" ');
	        }
	      }
	
	      // Render each group of markup with similar wrapping `nodeName`.
	      var renderNodes = createNodesFromMarkup(markupListByNodeName.join(''), emptyFunction // Do nothing special with <script> tags.
	      );
	
	      for (var j = 0; j < renderNodes.length; ++j) {
	        var renderNode = renderNodes[j];
	        if (renderNode.hasAttribute && renderNode.hasAttribute(RESULT_INDEX_ATTR)) {
	
	          resultIndex = +renderNode.getAttribute(RESULT_INDEX_ATTR);
	          renderNode.removeAttribute(RESULT_INDEX_ATTR);
	
	          !!resultList.hasOwnProperty(resultIndex) ?  false ? invariant(false, 'Danger: Assigning to an already-occupied result index.') : invariant(false) : undefined;
	
	          resultList[resultIndex] = renderNode;
	
	          // This should match resultList.length and markupList.length when
	          // we're done.
	          resultListAssignmentCount += 1;
	        } else if (false) {
	          console.error('Danger: Discarding unexpected node:', renderNode);
	        }
	      }
	    }
	
	    // Although resultList was populated out of order, it should now be a dense
	    // array.
	    !(resultListAssignmentCount === resultList.length) ?  false ? invariant(false, 'Danger: Did not assign to every index of resultList.') : invariant(false) : undefined;
	
	    !(resultList.length === markupList.length) ?  false ? invariant(false, 'Danger: Expected markup to render %s nodes, but rendered %s.', markupList.length, resultList.length) : invariant(false) : undefined;
	
	    return resultList;
	  },
	
	  /**
	   * Replaces a node with a string of markup at its current position within its
	   * parent. The markup must render into a single root node.
	   *
	   * @param {DOMElement} oldChild Child node to replace.
	   * @param {string} markup Markup to render in place of the child node.
	   * @internal
	   */
	  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
	    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a ' + 'worker thread. Make sure `window` and `document` are available ' + 'globally before requiring React when unit testing or use ' + 'ReactDOMServer.renderToString() for server rendering.') : invariant(false) : undefined;
	    !markup ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : invariant(false) : undefined;
	    !(oldChild.tagName.toLowerCase() !== 'html') ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the ' + '<html> node. This is because browser quirks make this unreliable ' + 'and/or slow. If you want to render to the root you must use ' + 'server rendering. See ReactDOMServer.renderToString().') : invariant(false) : undefined;
	
	    var newChild;
	    if (typeof markup === 'string') {
	      newChild = createNodesFromMarkup(markup, emptyFunction)[0];
	    } else {
	      newChild = markup;
	    }
	    oldChild.parentNode.replaceChild(newChild, oldChild);
	  }
	
	};
	
	module.exports = Danger;

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DefaultEventPluginOrder
	 */
	
	'use strict';
	
	var keyOf = __webpack_require__(13);
	
	/**
	 * Module that is injectable into `EventPluginHub`, that specifies a
	 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
	 * plugins, without having to package every one of them. This is better than
	 * having plugins be ordered in the same order that they are injected because
	 * that ordering would be influenced by the packaging order.
	 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
	 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
	 */
	var DefaultEventPluginOrder = [keyOf({ ResponderEventPlugin: null }), keyOf({ SimpleEventPlugin: null }), keyOf({ TapEventPlugin: null }), keyOf({ EnterLeaveEventPlugin: null }), keyOf({ ChangeEventPlugin: null }), keyOf({ SelectEventPlugin: null }), keyOf({ BeforeInputEventPlugin: null })];
	
	module.exports = DefaultEventPluginOrder;

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EnterLeaveEventPlugin
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(11);
	var EventPropagators = __webpack_require__(22);
	var SyntheticMouseEvent = __webpack_require__(29);
	
	var ReactMount = __webpack_require__(5);
	var keyOf = __webpack_require__(13);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	var getFirstReactDOM = ReactMount.getFirstReactDOM;
	
	var eventTypes = {
	  mouseEnter: {
	    registrationName: keyOf({ onMouseEnter: null }),
	    dependencies: [topLevelTypes.topMouseOut, topLevelTypes.topMouseOver]
	  },
	  mouseLeave: {
	    registrationName: keyOf({ onMouseLeave: null }),
	    dependencies: [topLevelTypes.topMouseOut, topLevelTypes.topMouseOver]
	  }
	};
	
	var extractedEvents = [null, null];
	
	var EnterLeaveEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  /**
	   * For almost every interaction we care about, there will be both a top-level
	   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
	   * we do not extract duplicate events. However, moving the mouse into the
	   * browser from outside will not fire a `mouseout` event. In this case, we use
	   * the `mouseover` top-level event.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {DOMEventTarget} topLevelTarget The listening component root node.
	   * @param {string} topLevelTargetID ID of `topLevelTarget`.
	   * @param {object} nativeEvent Native browser event.
	   * @return {*} An accumulation of synthetic events.
	   * @see {EventPluginHub.extractEvents}
	   */
	  extractEvents: function (topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget) {
	    if (topLevelType === topLevelTypes.topMouseOver && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
	      return null;
	    }
	    if (topLevelType !== topLevelTypes.topMouseOut && topLevelType !== topLevelTypes.topMouseOver) {
	      // Must not be a mouse in or mouse out - ignoring.
	      return null;
	    }
	
	    var win;
	    if (topLevelTarget.window === topLevelTarget) {
	      // `topLevelTarget` is probably a window object.
	      win = topLevelTarget;
	    } else {
	      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	      var doc = topLevelTarget.ownerDocument;
	      if (doc) {
	        win = doc.defaultView || doc.parentWindow;
	      } else {
	        win = window;
	      }
	    }
	
	    var from;
	    var to;
	    var fromID = '';
	    var toID = '';
	    if (topLevelType === topLevelTypes.topMouseOut) {
	      from = topLevelTarget;
	      fromID = topLevelTargetID;
	      to = getFirstReactDOM(nativeEvent.relatedTarget || nativeEvent.toElement);
	      if (to) {
	        toID = ReactMount.getID(to);
	      } else {
	        to = win;
	      }
	      to = to || win;
	    } else {
	      from = win;
	      to = topLevelTarget;
	      toID = topLevelTargetID;
	    }
	
	    if (from === to) {
	      // Nothing pertains to our managed components.
	      return null;
	    }
	
	    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, fromID, nativeEvent, nativeEventTarget);
	    leave.type = 'mouseleave';
	    leave.target = from;
	    leave.relatedTarget = to;
	
	    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, toID, nativeEvent, nativeEventTarget);
	    enter.type = 'mouseenter';
	    enter.target = to;
	    enter.relatedTarget = from;
	
	    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, fromID, toID);
	
	    extractedEvents[0] = leave;
	    extractedEvents[1] = enter;
	
	    return extractedEvents;
	  }
	
	};
	
	module.exports = EnterLeaveEventPlugin;

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventPluginUtils
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(11);
	var ReactErrorUtils = __webpack_require__(78);
	
	var invariant = __webpack_require__(1);
	var warning = __webpack_require__(2);
	
	/**
	 * Injected dependencies:
	 */
	
	/**
	 * - `Mount`: [required] Module that can convert between React dom IDs and
	 *   actual node references.
	 */
	var injection = {
	  Mount: null,
	  injectMount: function (InjectedMount) {
	    injection.Mount = InjectedMount;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(InjectedMount && InjectedMount.getNode && InjectedMount.getID, 'EventPluginUtils.injection.injectMount(...): Injected Mount ' + 'module is missing getNode or getID.') : undefined;
	    }
	  }
	};
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	function isEndish(topLevelType) {
	  return topLevelType === topLevelTypes.topMouseUp || topLevelType === topLevelTypes.topTouchEnd || topLevelType === topLevelTypes.topTouchCancel;
	}
	
	function isMoveish(topLevelType) {
	  return topLevelType === topLevelTypes.topMouseMove || topLevelType === topLevelTypes.topTouchMove;
	}
	function isStartish(topLevelType) {
	  return topLevelType === topLevelTypes.topMouseDown || topLevelType === topLevelTypes.topTouchStart;
	}
	
	var validateEventDispatches;
	if (false) {
	  validateEventDispatches = function (event) {
	    var dispatchListeners = event._dispatchListeners;
	    var dispatchIDs = event._dispatchIDs;
	
	    var listenersIsArr = Array.isArray(dispatchListeners);
	    var idsIsArr = Array.isArray(dispatchIDs);
	    var IDsLen = idsIsArr ? dispatchIDs.length : dispatchIDs ? 1 : 0;
	    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;
	
	    process.env.NODE_ENV !== 'production' ? warning(idsIsArr === listenersIsArr && IDsLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : undefined;
	  };
	}
	
	/**
	 * Dispatch the event to the listener.
	 * @param {SyntheticEvent} event SyntheticEvent to handle
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @param {function} listener Application-level callback
	 * @param {string} domID DOM id to pass to the callback.
	 */
	function executeDispatch(event, simulated, listener, domID) {
	  var type = event.type || 'unknown-event';
	  event.currentTarget = injection.Mount.getNode(domID);
	  if (simulated) {
	    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event, domID);
	  } else {
	    ReactErrorUtils.invokeGuardedCallback(type, listener, event, domID);
	  }
	  event.currentTarget = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches.
	 */
	function executeDispatchesInOrder(event, simulated) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchIDs = event._dispatchIDs;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and IDs are two parallel arrays that are always in sync.
	      executeDispatch(event, simulated, dispatchListeners[i], dispatchIDs[i]);
	    }
	  } else if (dispatchListeners) {
	    executeDispatch(event, simulated, dispatchListeners, dispatchIDs);
	  }
	  event._dispatchListeners = null;
	  event._dispatchIDs = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches, but stops
	 * at the first dispatch execution returning true, and returns that id.
	 *
	 * @return {?string} id of the first dispatch execution who's listener returns
	 * true, or null if no listener returned true.
	 */
	function executeDispatchesInOrderStopAtTrueImpl(event) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchIDs = event._dispatchIDs;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and IDs are two parallel arrays that are always in sync.
	      if (dispatchListeners[i](event, dispatchIDs[i])) {
	        return dispatchIDs[i];
	      }
	    }
	  } else if (dispatchListeners) {
	    if (dispatchListeners(event, dispatchIDs)) {
	      return dispatchIDs;
	    }
	  }
	  return null;
	}
	
	/**
	 * @see executeDispatchesInOrderStopAtTrueImpl
	 */
	function executeDispatchesInOrderStopAtTrue(event) {
	  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
	  event._dispatchIDs = null;
	  event._dispatchListeners = null;
	  return ret;
	}
	
	/**
	 * Execution of a "direct" dispatch - there must be at most one dispatch
	 * accumulated on the event or it is considered an error. It doesn't really make
	 * sense for an event with multiple dispatches (bubbled) to keep track of the
	 * return values at each dispatch execution, but it does tend to make sense when
	 * dealing with "direct" dispatches.
	 *
	 * @return {*} The return value of executing the single dispatch.
	 */
	function executeDirectDispatch(event) {
	  if (false) {
	    validateEventDispatches(event);
	  }
	  var dispatchListener = event._dispatchListeners;
	  var dispatchID = event._dispatchIDs;
	  !!Array.isArray(dispatchListener) ?  false ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : invariant(false) : undefined;
	  var res = dispatchListener ? dispatchListener(event, dispatchID) : null;
	  event._dispatchListeners = null;
	  event._dispatchIDs = null;
	  return res;
	}
	
	/**
	 * @param {SyntheticEvent} event
	 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
	 */
	function hasDispatches(event) {
	  return !!event._dispatchListeners;
	}
	
	/**
	 * General utilities that are useful in creating custom Event Plugins.
	 */
	var EventPluginUtils = {
	  isEndish: isEndish,
	  isMoveish: isMoveish,
	  isStartish: isStartish,
	
	  executeDirectDispatch: executeDirectDispatch,
	  executeDispatchesInOrder: executeDispatchesInOrder,
	  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
	  hasDispatches: hasDispatches,
	
	  getNode: function (id) {
	    return injection.Mount.getNode(id);
	  },
	  getID: function (node) {
	    return injection.Mount.getID(node);
	  },
	
	  injection: injection
	};
	
	module.exports = EventPluginUtils;

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule FallbackCompositionState
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(14);
	
	var assign = __webpack_require__(3);
	var getTextContentAccessor = __webpack_require__(89);
	
	/**
	 * This helper class stores information about text content of a target node,
	 * allowing comparison of content before and after a given event.
	 *
	 * Identify the node where selection currently begins, then observe
	 * both its text content and its current position in the DOM. Since the
	 * browser may natively replace the target node during composition, we can
	 * use its position to find its replacement.
	 *
	 * @param {DOMEventTarget} root
	 */
	function FallbackCompositionState(root) {
	  this._root = root;
	  this._startText = this.getText();
	  this._fallbackText = null;
	}
	
	assign(FallbackCompositionState.prototype, {
	  destructor: function () {
	    this._root = null;
	    this._startText = null;
	    this._fallbackText = null;
	  },
	
	  /**
	   * Get current text of input.
	   *
	   * @return {string}
	   */
	  getText: function () {
	    if ('value' in this._root) {
	      return this._root.value;
	    }
	    return this._root[getTextContentAccessor()];
	  },
	
	  /**
	   * Determine the differing substring between the initially stored
	   * text content and the current content.
	   *
	   * @return {string}
	   */
	  getData: function () {
	    if (this._fallbackText) {
	      return this._fallbackText;
	    }
	
	    var start;
	    var startValue = this._startText;
	    var startLength = startValue.length;
	    var end;
	    var endValue = this.getText();
	    var endLength = endValue.length;
	
	    for (start = 0; start < startLength; start++) {
	      if (startValue[start] !== endValue[start]) {
	        break;
	      }
	    }
	
	    var minEnd = startLength - start;
	    for (end = 1; end <= minEnd; end++) {
	      if (startValue[startLength - end] !== endValue[endLength - end]) {
	        break;
	      }
	    }
	
	    var sliceTail = end > 1 ? 1 - end : undefined;
	    this._fallbackText = endValue.slice(start, sliceTail);
	    return this._fallbackText;
	  }
	});
	
	PooledClass.addPoolingTo(FallbackCompositionState);
	
	module.exports = FallbackCompositionState;

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule HTMLDOMPropertyConfig
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(18);
	var ExecutionEnvironment = __webpack_require__(4);
	
	var MUST_USE_ATTRIBUTE = DOMProperty.injection.MUST_USE_ATTRIBUTE;
	var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
	var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
	var HAS_SIDE_EFFECTS = DOMProperty.injection.HAS_SIDE_EFFECTS;
	var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
	var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
	var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;
	
	var hasSVG;
	if (ExecutionEnvironment.canUseDOM) {
	  var implementation = document.implementation;
	  hasSVG = implementation && implementation.hasFeature && implementation.hasFeature('http://www.w3.org/TR/SVG11/feature#BasicStructure', '1.1');
	}
	
	var HTMLDOMPropertyConfig = {
	  isCustomAttribute: RegExp.prototype.test.bind(/^(data|aria)-[a-z_][a-z\d_.\-]*$/),
	  Properties: {
	    /**
	     * Standard Properties
	     */
	    accept: null,
	    acceptCharset: null,
	    accessKey: null,
	    action: null,
	    allowFullScreen: MUST_USE_ATTRIBUTE | HAS_BOOLEAN_VALUE,
	    allowTransparency: MUST_USE_ATTRIBUTE,
	    alt: null,
	    async: HAS_BOOLEAN_VALUE,
	    autoComplete: null,
	    // autoFocus is polyfilled/normalized by AutoFocusUtils
	    // autoFocus: HAS_BOOLEAN_VALUE,
	    autoPlay: HAS_BOOLEAN_VALUE,
	    capture: MUST_USE_ATTRIBUTE | HAS_BOOLEAN_VALUE,
	    cellPadding: null,
	    cellSpacing: null,
	    charSet: MUST_USE_ATTRIBUTE,
	    challenge: MUST_USE_ATTRIBUTE,
	    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    classID: MUST_USE_ATTRIBUTE,
	    // To set className on SVG elements, it's necessary to use .setAttribute;
	    // this works on HTML elements too in all browsers except IE8. Conveniently,
	    // IE8 doesn't support SVG and so we can simply use the attribute in
	    // browsers that support SVG and the property in browsers that don't,
	    // regardless of whether the element is HTML or SVG.
	    className: hasSVG ? MUST_USE_ATTRIBUTE : MUST_USE_PROPERTY,
	    cols: MUST_USE_ATTRIBUTE | HAS_POSITIVE_NUMERIC_VALUE,
	    colSpan: null,
	    content: null,
	    contentEditable: null,
	    contextMenu: MUST_USE_ATTRIBUTE,
	    controls: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    coords: null,
	    crossOrigin: null,
	    data: null, // For `<object />` acts as `src`.
	    dateTime: MUST_USE_ATTRIBUTE,
	    'default': HAS_BOOLEAN_VALUE,
	    defer: HAS_BOOLEAN_VALUE,
	    dir: null,
	    disabled: MUST_USE_ATTRIBUTE | HAS_BOOLEAN_VALUE,
	    download: HAS_OVERLOADED_BOOLEAN_VALUE,
	    draggable: null,
	    encType: null,
	    form: MUST_USE_ATTRIBUTE,
	    formAction: MUST_USE_ATTRIBUTE,
	    formEncType: MUST_USE_ATTRIBUTE,
	    formMethod: MUST_USE_ATTRIBUTE,
	    formNoValidate: HAS_BOOLEAN_VALUE,
	    formTarget: MUST_USE_ATTRIBUTE,
	    frameBorder: MUST_USE_ATTRIBUTE,
	    headers: null,
	    height: MUST_USE_ATTRIBUTE,
	    hidden: MUST_USE_ATTRIBUTE | HAS_BOOLEAN_VALUE,
	    high: null,
	    href: null,
	    hrefLang: null,
	    htmlFor: null,
	    httpEquiv: null,
	    icon: null,
	    id: MUST_USE_PROPERTY,
	    inputMode: MUST_USE_ATTRIBUTE,
	    integrity: null,
	    is: MUST_USE_ATTRIBUTE,
	    keyParams: MUST_USE_ATTRIBUTE,
	    keyType: MUST_USE_ATTRIBUTE,
	    kind: null,
	    label: null,
	    lang: null,
	    list: MUST_USE_ATTRIBUTE,
	    loop: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    low: null,
	    manifest: MUST_USE_ATTRIBUTE,
	    marginHeight: null,
	    marginWidth: null,
	    max: null,
	    maxLength: MUST_USE_ATTRIBUTE,
	    media: MUST_USE_ATTRIBUTE,
	    mediaGroup: null,
	    method: null,
	    min: null,
	    minLength: MUST_USE_ATTRIBUTE,
	    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    name: null,
	    nonce: MUST_USE_ATTRIBUTE,
	    noValidate: HAS_BOOLEAN_VALUE,
	    open: HAS_BOOLEAN_VALUE,
	    optimum: null,
	    pattern: null,
	    placeholder: null,
	    poster: null,
	    preload: null,
	    radioGroup: null,
	    readOnly: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    rel: null,
	    required: HAS_BOOLEAN_VALUE,
	    reversed: HAS_BOOLEAN_VALUE,
	    role: MUST_USE_ATTRIBUTE,
	    rows: MUST_USE_ATTRIBUTE | HAS_POSITIVE_NUMERIC_VALUE,
	    rowSpan: null,
	    sandbox: null,
	    scope: null,
	    scoped: HAS_BOOLEAN_VALUE,
	    scrolling: null,
	    seamless: MUST_USE_ATTRIBUTE | HAS_BOOLEAN_VALUE,
	    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    shape: null,
	    size: MUST_USE_ATTRIBUTE | HAS_POSITIVE_NUMERIC_VALUE,
	    sizes: MUST_USE_ATTRIBUTE,
	    span: HAS_POSITIVE_NUMERIC_VALUE,
	    spellCheck: null,
	    src: null,
	    srcDoc: MUST_USE_PROPERTY,
	    srcLang: null,
	    srcSet: MUST_USE_ATTRIBUTE,
	    start: HAS_NUMERIC_VALUE,
	    step: null,
	    style: null,
	    summary: null,
	    tabIndex: null,
	    target: null,
	    title: null,
	    type: null,
	    useMap: null,
	    value: MUST_USE_PROPERTY | HAS_SIDE_EFFECTS,
	    width: MUST_USE_ATTRIBUTE,
	    wmode: MUST_USE_ATTRIBUTE,
	    wrap: null,
	
	    /**
	     * RDFa Properties
	     */
	    about: MUST_USE_ATTRIBUTE,
	    datatype: MUST_USE_ATTRIBUTE,
	    inlist: MUST_USE_ATTRIBUTE,
	    prefix: MUST_USE_ATTRIBUTE,
	    // property is also supported for OpenGraph in meta tags.
	    property: MUST_USE_ATTRIBUTE,
	    resource: MUST_USE_ATTRIBUTE,
	    'typeof': MUST_USE_ATTRIBUTE,
	    vocab: MUST_USE_ATTRIBUTE,
	
	    /**
	     * Non-standard Properties
	     */
	    // autoCapitalize and autoCorrect are supported in Mobile Safari for
	    // keyboard hints.
	    autoCapitalize: MUST_USE_ATTRIBUTE,
	    autoCorrect: MUST_USE_ATTRIBUTE,
	    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
	    autoSave: null,
	    // color is for Safari mask-icon link
	    color: null,
	    // itemProp, itemScope, itemType are for
	    // Microdata support. See http://schema.org/docs/gs.html
	    itemProp: MUST_USE_ATTRIBUTE,
	    itemScope: MUST_USE_ATTRIBUTE | HAS_BOOLEAN_VALUE,
	    itemType: MUST_USE_ATTRIBUTE,
	    // itemID and itemRef are for Microdata support as well but
	    // only specified in the the WHATWG spec document. See
	    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
	    itemID: MUST_USE_ATTRIBUTE,
	    itemRef: MUST_USE_ATTRIBUTE,
	    // results show looking glass icon and recent searches on input
	    // search fields in WebKit/Blink
	    results: null,
	    // IE-only attribute that specifies security restrictions on an iframe
	    // as an alternative to the sandbox attribute on IE<10
	    security: MUST_USE_ATTRIBUTE,
	    // IE-only attribute that controls focus behavior
	    unselectable: MUST_USE_ATTRIBUTE
	  },
	  DOMAttributeNames: {
	    acceptCharset: 'accept-charset',
	    className: 'class',
	    htmlFor: 'for',
	    httpEquiv: 'http-equiv'
	  },
	  DOMPropertyNames: {
	    autoComplete: 'autocomplete',
	    autoFocus: 'autofocus',
	    autoPlay: 'autoplay',
	    autoSave: 'autosave',
	    // `encoding` is equivalent to `enctype`, IE8 lacks an `enctype` setter.
	    // http://www.w3.org/TR/html5/forms.html#dom-fs-encoding
	    encType: 'encoding',
	    hrefLang: 'hreflang',
	    radioGroup: 'radiogroup',
	    spellCheck: 'spellcheck',
	    srcDoc: 'srcdoc',
	    srcSet: 'srcset'
	  }
	};
	
	module.exports = HTMLDOMPropertyConfig;

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule React
	 */
	
	'use strict';
	
	var ReactDOM = __webpack_require__(69);
	var ReactDOMServer = __webpack_require__(148);
	var ReactIsomorphic = __webpack_require__(153);
	
	var assign = __webpack_require__(3);
	var deprecated = __webpack_require__(175);
	
	// `version` will be added here by ReactIsomorphic.
	var React = {};
	
	assign(React, ReactIsomorphic);
	
	assign(React, {
	  // ReactDOM
	  findDOMNode: deprecated('findDOMNode', 'ReactDOM', 'react-dom', ReactDOM, ReactDOM.findDOMNode),
	  render: deprecated('render', 'ReactDOM', 'react-dom', ReactDOM, ReactDOM.render),
	  unmountComponentAtNode: deprecated('unmountComponentAtNode', 'ReactDOM', 'react-dom', ReactDOM, ReactDOM.unmountComponentAtNode),
	
	  // ReactDOMServer
	  renderToString: deprecated('renderToString', 'ReactDOMServer', 'react-dom/server', ReactDOMServer, ReactDOMServer.renderToString),
	  renderToStaticMarkup: deprecated('renderToStaticMarkup', 'ReactDOMServer', 'react-dom/server', ReactDOMServer, ReactDOMServer.renderToStaticMarkup)
	});
	
	React.__SECRET_DOM_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = ReactDOM;
	React.__SECRET_DOM_SERVER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = ReactDOMServer;
	
	module.exports = React;

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactBrowserComponentMixin
	 */
	
	'use strict';
	
	var ReactInstanceMap = __webpack_require__(23);
	
	var findDOMNode = __webpack_require__(43);
	var warning = __webpack_require__(2);
	
	var didWarnKey = '_getDOMNodeDidWarn';
	
	var ReactBrowserComponentMixin = {
	  /**
	   * Returns the DOM node rendered by this component.
	   *
	   * @return {DOMElement} The root node of this component.
	   * @final
	   * @protected
	   */
	  getDOMNode: function () {
	     false ? warning(this.constructor[didWarnKey], '%s.getDOMNode(...) is deprecated. Please use ' + 'ReactDOM.findDOMNode(instance) instead.', ReactInstanceMap.get(this).getName() || this.tagName || 'Unknown') : undefined;
	    this.constructor[didWarnKey] = true;
	    return findDOMNode(this);
	  }
	};
	
	module.exports = ReactBrowserComponentMixin;

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactChildReconciler
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var ReactReconciler = __webpack_require__(15);
	
	var instantiateReactComponent = __webpack_require__(48);
	var shouldUpdateReactComponent = __webpack_require__(51);
	var traverseAllChildren = __webpack_require__(52);
	var warning = __webpack_require__(2);
	
	function instantiateChild(childInstances, child, name) {
	  // We found a component instance.
	  var keyUnique = childInstances[name] === undefined;
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(keyUnique, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.', name) : undefined;
	  }
	  if (child != null && keyUnique) {
	    childInstances[name] = instantiateReactComponent(child, null);
	  }
	}
	
	/**
	 * ReactChildReconciler provides helpers for initializing or updating a set of
	 * children. Its output is suitable for passing it onto ReactMultiChild which
	 * does diffed reordering and insertion.
	 */
	var ReactChildReconciler = {
	  /**
	   * Generates a "mount image" for each of the supplied children. In the case
	   * of `ReactDOMComponent`, a mount image is a string of markup.
	   *
	   * @param {?object} nestedChildNodes Nested child maps.
	   * @return {?object} A set of child instances.
	   * @internal
	   */
	  instantiateChildren: function (nestedChildNodes, transaction, context) {
	    if (nestedChildNodes == null) {
	      return null;
	    }
	    var childInstances = {};
	    traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
	    return childInstances;
	  },
	
	  /**
	   * Updates the rendered children and returns a new set of children.
	   *
	   * @param {?object} prevChildren Previously initialized set of children.
	   * @param {?object} nextChildren Flat child element maps.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @return {?object} A new set of child instances.
	   * @internal
	   */
	  updateChildren: function (prevChildren, nextChildren, transaction, context) {
	    // We currently don't have a way to track moves here but if we use iterators
	    // instead of for..in we can zip the iterators and check if an item has
	    // moved.
	    // TODO: If nothing has changed, return the prevChildren object so that we
	    // can quickly bailout if nothing has changed.
	    if (!nextChildren && !prevChildren) {
	      return null;
	    }
	    var name;
	    for (name in nextChildren) {
	      if (!nextChildren.hasOwnProperty(name)) {
	        continue;
	      }
	      var prevChild = prevChildren && prevChildren[name];
	      var prevElement = prevChild && prevChild._currentElement;
	      var nextElement = nextChildren[name];
	      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
	        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
	        nextChildren[name] = prevChild;
	      } else {
	        if (prevChild) {
	          ReactReconciler.unmountComponent(prevChild, name);
	        }
	        // The child must be instantiated before it's mounted.
	        var nextChildInstance = instantiateReactComponent(nextElement, null);
	        nextChildren[name] = nextChildInstance;
	      }
	    }
	    // Unmount children that are no longer present.
	    for (name in prevChildren) {
	      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
	        ReactReconciler.unmountComponent(prevChildren[name]);
	      }
	    }
	    return nextChildren;
	  },
	
	  /**
	   * Unmounts all rendered children. This should be used to clean up children
	   * when this component is unmounted.
	   *
	   * @param {?object} renderedChildren Previously initialized set of children.
	   * @internal
	   */
	  unmountChildren: function (renderedChildren) {
	    for (var name in renderedChildren) {
	      if (renderedChildren.hasOwnProperty(name)) {
	        var renderedChild = renderedChildren[name];
	        ReactReconciler.unmountComponent(renderedChild);
	      }
	    }
	  }
	
	};
	
	module.exports = ReactChildReconciler;

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactCompositeComponent
	 */
	
	'use strict';
	
	var ReactComponentEnvironment = __webpack_require__(39);
	var ReactCurrentOwner = __webpack_require__(12);
	var ReactElement = __webpack_require__(6);
	var ReactInstanceMap = __webpack_require__(23);
	var ReactPerf = __webpack_require__(7);
	var ReactPropTypeLocations = __webpack_require__(28);
	var ReactPropTypeLocationNames = __webpack_require__(27);
	var ReactReconciler = __webpack_require__(15);
	var ReactUpdateQueue = __webpack_require__(41);
	
	var assign = __webpack_require__(3);
	var emptyObject = __webpack_require__(20);
	var invariant = __webpack_require__(1);
	var shouldUpdateReactComponent = __webpack_require__(51);
	var warning = __webpack_require__(2);
	
	function getDeclarationErrorAddendum(component) {
	  var owner = component._currentElement._owner || null;
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	function StatelessComponent(Component) {}
	StatelessComponent.prototype.render = function () {
	  var Component = ReactInstanceMap.get(this)._currentElement.type;
	  return Component(this.props, this.context, this.updater);
	};
	
	/**
	 * ------------------ The Life-Cycle of a Composite Component ------------------
	 *
	 * - constructor: Initialization of state. The instance is now retained.
	 *   - componentWillMount
	 *   - render
	 *   - [children's constructors]
	 *     - [children's componentWillMount and render]
	 *     - [children's componentDidMount]
	 *     - componentDidMount
	 *
	 *       Update Phases:
	 *       - componentWillReceiveProps (only called if parent updated)
	 *       - shouldComponentUpdate
	 *         - componentWillUpdate
	 *           - render
	 *           - [children's constructors or receive props phases]
	 *         - componentDidUpdate
	 *
	 *     - componentWillUnmount
	 *     - [children's componentWillUnmount]
	 *   - [children destroyed]
	 * - (destroyed): The instance is now blank, released by React and ready for GC.
	 *
	 * -----------------------------------------------------------------------------
	 */
	
	/**
	 * An incrementing ID assigned to each component when it is mounted. This is
	 * used to enforce the order in which `ReactUpdates` updates dirty components.
	 *
	 * @private
	 */
	var nextMountID = 1;
	
	/**
	 * @lends {ReactCompositeComponent.prototype}
	 */
	var ReactCompositeComponentMixin = {
	
	  /**
	   * Base constructor for all composite component.
	   *
	   * @param {ReactElement} element
	   * @final
	   * @internal
	   */
	  construct: function (element) {
	    this._currentElement = element;
	    this._rootNodeID = null;
	    this._instance = null;
	
	    // See ReactUpdateQueue
	    this._pendingElement = null;
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    this._renderedComponent = null;
	
	    this._context = null;
	    this._mountOrder = 0;
	    this._topLevelWrapper = null;
	
	    // See ReactUpdates and ReactUpdateQueue.
	    this._pendingCallbacks = null;
	  },
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {string} rootID DOM ID of the root node.
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (rootID, transaction, context) {
	    this._context = context;
	    this._mountOrder = nextMountID++;
	    this._rootNodeID = rootID;
	
	    var publicProps = this._processProps(this._currentElement.props);
	    var publicContext = this._processContext(context);
	
	    var Component = this._currentElement.type;
	
	    // Initialize the public class
	    var inst;
	    var renderedElement;
	
	    // This is a way to detect if Component is a stateless arrow function
	    // component, which is not newable. It might not be 100% reliable but is
	    // something we can do until we start detecting that Component extends
	    // React.Component. We already assume that typeof Component === 'function'.
	    var canInstantiate = ('prototype' in Component);
	
	    if (canInstantiate) {
	      if (false) {
	        ReactCurrentOwner.current = this;
	        try {
	          inst = new Component(publicProps, publicContext, ReactUpdateQueue);
	        } finally {
	          ReactCurrentOwner.current = null;
	        }
	      } else {
	        inst = new Component(publicProps, publicContext, ReactUpdateQueue);
	      }
	    }
	
	    if (!canInstantiate || inst === null || inst === false || ReactElement.isValidElement(inst)) {
	      renderedElement = inst;
	      inst = new StatelessComponent(Component);
	    }
	
	    if (false) {
	      // This will throw later in _renderValidatedComponent, but add an early
	      // warning now to help debugging
	      if (inst.render == null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`, returned ' + 'null/false from a stateless component, or tried to render an ' + 'element whose type is a function that isn\'t a React component.', Component.displayName || Component.name || 'Component') : undefined;
	      } else {
	        // We support ES6 inheriting from React.Component, the module pattern,
	        // and stateless components, but not ES6 classes that don't extend
	        process.env.NODE_ENV !== 'production' ? warning(Component.prototype && Component.prototype.isReactComponent || !canInstantiate || !(inst instanceof Component), '%s(...): React component classes must extend React.Component.', Component.displayName || Component.name || 'Component') : undefined;
	      }
	    }
	
	    // These should be set up in the constructor, but as a convenience for
	    // simpler class abstractions, we set them up after the fact.
	    inst.props = publicProps;
	    inst.context = publicContext;
	    inst.refs = emptyObject;
	    inst.updater = ReactUpdateQueue;
	
	    this._instance = inst;
	
	    // Store a reference from the instance back to the internal representation
	    ReactInstanceMap.set(inst, this);
	
	    if (false) {
	      // Since plain JS classes are defined without any special initialization
	      // logic, we can not catch common errors early. Therefore, we have to
	      // catch them here, at initialization time, instead.
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : undefined;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : undefined;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : undefined;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : undefined;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : undefined;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : undefined;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : undefined;
	    }
	
	    var initialState = inst.state;
	    if (initialState === undefined) {
	      inst.state = initialState = null;
	    }
	    !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : invariant(false) : undefined;
	
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    if (inst.componentWillMount) {
	      inst.componentWillMount();
	      // When mounting, calls to `setState` by `componentWillMount` will set
	      // `this._pendingStateQueue` without triggering a re-render.
	      if (this._pendingStateQueue) {
	        inst.state = this._processPendingState(inst.props, inst.context);
	      }
	    }
	
	    // If not a stateless component, we now render
	    if (renderedElement === undefined) {
	      renderedElement = this._renderValidatedComponent();
	    }
	
	    this._renderedComponent = this._instantiateReactComponent(renderedElement);
	
	    var markup = ReactReconciler.mountComponent(this._renderedComponent, rootID, transaction, this._processChildContext(context));
	    if (inst.componentDidMount) {
	      transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
	    }
	
	    return markup;
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function () {
	    var inst = this._instance;
	
	    if (inst.componentWillUnmount) {
	      inst.componentWillUnmount();
	    }
	
	    ReactReconciler.unmountComponent(this._renderedComponent);
	    this._renderedComponent = null;
	    this._instance = null;
	
	    // Reset pending fields
	    // Even if this component is scheduled for another update in ReactUpdates,
	    // it would still be ignored because these fields are reset.
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	    this._pendingCallbacks = null;
	    this._pendingElement = null;
	
	    // These fields do not really need to be reset since this object is no
	    // longer accessible.
	    this._context = null;
	    this._rootNodeID = null;
	    this._topLevelWrapper = null;
	
	    // Delete the reference from the instance to this internal representation
	    // which allow the internals to be properly cleaned up even if the user
	    // leaks a reference to the public instance.
	    ReactInstanceMap.remove(inst);
	
	    // Some existing components rely on inst.props even after they've been
	    // destroyed (in event handlers).
	    // TODO: inst.props = null;
	    // TODO: inst.state = null;
	    // TODO: inst.context = null;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _maskContext: function (context) {
	    var maskedContext = null;
	    var Component = this._currentElement.type;
	    var contextTypes = Component.contextTypes;
	    if (!contextTypes) {
	      return emptyObject;
	    }
	    maskedContext = {};
	    for (var contextName in contextTypes) {
	      maskedContext[contextName] = context[contextName];
	    }
	    return maskedContext;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`, and asserts that they are valid.
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _processContext: function (context) {
	    var maskedContext = this._maskContext(context);
	    if (false) {
	      var Component = this._currentElement.type;
	      if (Component.contextTypes) {
	        this._checkPropTypes(Component.contextTypes, maskedContext, ReactPropTypeLocations.context);
	      }
	    }
	    return maskedContext;
	  },
	
	  /**
	   * @param {object} currentContext
	   * @return {object}
	   * @private
	   */
	  _processChildContext: function (currentContext) {
	    var Component = this._currentElement.type;
	    var inst = this._instance;
	    var childContext = inst.getChildContext && inst.getChildContext();
	    if (childContext) {
	      !(typeof Component.childContextTypes === 'object') ?  false ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to ' + 'use getChildContext().', this.getName() || 'ReactCompositeComponent') : invariant(false) : undefined;
	      if (false) {
	        this._checkPropTypes(Component.childContextTypes, childContext, ReactPropTypeLocations.childContext);
	      }
	      for (var name in childContext) {
	        !(name in Component.childContextTypes) ?  false ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : invariant(false) : undefined;
	      }
	      return assign({}, currentContext, childContext);
	    }
	    return currentContext;
	  },
	
	  /**
	   * Processes props by setting default values for unspecified props and
	   * asserting that the props are valid. Does not mutate its argument; returns
	   * a new props object with defaults merged in.
	   *
	   * @param {object} newProps
	   * @return {object}
	   * @private
	   */
	  _processProps: function (newProps) {
	    if (false) {
	      var Component = this._currentElement.type;
	      if (Component.propTypes) {
	        this._checkPropTypes(Component.propTypes, newProps, ReactPropTypeLocations.prop);
	      }
	    }
	    return newProps;
	  },
	
	  /**
	   * Assert that the props are valid
	   *
	   * @param {object} propTypes Map of prop name to a ReactPropType
	   * @param {object} props
	   * @param {string} location e.g. "prop", "context", "child context"
	   * @private
	   */
	  _checkPropTypes: function (propTypes, props, location) {
	    // TODO: Stop validating prop types here and only use the element
	    // validation.
	    var componentName = this.getName();
	    for (var propName in propTypes) {
	      if (propTypes.hasOwnProperty(propName)) {
	        var error;
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          !(typeof propTypes[propName] === 'function') ?  false ? invariant(false, '%s: %s type `%s` is invalid; it must be a function, usually ' + 'from React.PropTypes.', componentName || 'React class', ReactPropTypeLocationNames[location], propName) : invariant(false) : undefined;
	          error = propTypes[propName](props, propName, componentName, location, null, 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED');
	        } catch (ex) {
	          error = ex;
	        }
	        if (error instanceof Error) {
	          // We may want to extend this logic for similar errors in
	          // top-level render calls, so I'm abstracting it away into
	          // a function to minimize refactoring in the future
	          var addendum = getDeclarationErrorAddendum(this);
	
	          if (location === ReactPropTypeLocations.prop) {
	            // Preface gives us something to blacklist in warning module
	             false ? warning(false, 'Failed Composite propType: %s%s', error.message, addendum) : undefined;
	          } else {
	             false ? warning(false, 'Failed Context Types: %s%s', error.message, addendum) : undefined;
	          }
	        }
	      }
	    }
	  },
	
	  receiveComponent: function (nextElement, transaction, nextContext) {
	    var prevElement = this._currentElement;
	    var prevContext = this._context;
	
	    this._pendingElement = null;
	
	    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
	  },
	
	  /**
	   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
	   * is set, update the component.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (transaction) {
	    if (this._pendingElement != null) {
	      ReactReconciler.receiveComponent(this, this._pendingElement || this._currentElement, transaction, this._context);
	    }
	
	    if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
	      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
	    }
	  },
	
	  /**
	   * Perform an update to a mounted component. The componentWillReceiveProps and
	   * shouldComponentUpdate methods are called, then (assuming the update isn't
	   * skipped) the remaining update lifecycle methods are called and the DOM
	   * representation is updated.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevParentElement
	   * @param {ReactElement} nextParentElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
	    var inst = this._instance;
	
	    var nextContext = this._context === nextUnmaskedContext ? inst.context : this._processContext(nextUnmaskedContext);
	    var nextProps;
	
	    // Distinguish between a props update versus a simple state update
	    if (prevParentElement === nextParentElement) {
	      // Skip checking prop types again -- we don't read inst.props to avoid
	      // warning for DOM component props in this upgrade
	      nextProps = nextParentElement.props;
	    } else {
	      nextProps = this._processProps(nextParentElement.props);
	      // An update here will schedule an update but immediately set
	      // _pendingStateQueue which will ensure that any state updates gets
	      // immediately reconciled instead of waiting for the next batch.
	
	      if (inst.componentWillReceiveProps) {
	        inst.componentWillReceiveProps(nextProps, nextContext);
	      }
	    }
	
	    var nextState = this._processPendingState(nextProps, nextContext);
	
	    var shouldUpdate = this._pendingForceUpdate || !inst.shouldComponentUpdate || inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(typeof shouldUpdate !== 'undefined', '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : undefined;
	    }
	
	    if (shouldUpdate) {
	      this._pendingForceUpdate = false;
	      // Will set `this.props`, `this.state` and `this.context`.
	      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
	    } else {
	      // If it's determined that a component should not update, we still want
	      // to set props and state but we shortcut the rest of the update.
	      this._currentElement = nextParentElement;
	      this._context = nextUnmaskedContext;
	      inst.props = nextProps;
	      inst.state = nextState;
	      inst.context = nextContext;
	    }
	  },
	
	  _processPendingState: function (props, context) {
	    var inst = this._instance;
	    var queue = this._pendingStateQueue;
	    var replace = this._pendingReplaceState;
	    this._pendingReplaceState = false;
	    this._pendingStateQueue = null;
	
	    if (!queue) {
	      return inst.state;
	    }
	
	    if (replace && queue.length === 1) {
	      return queue[0];
	    }
	
	    var nextState = assign({}, replace ? queue[0] : inst.state);
	    for (var i = replace ? 1 : 0; i < queue.length; i++) {
	      var partial = queue[i];
	      assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
	    }
	
	    return nextState;
	  },
	
	  /**
	   * Merges new props and state, notifies delegate methods of update and
	   * performs update.
	   *
	   * @param {ReactElement} nextElement Next element
	   * @param {object} nextProps Next public object to set as properties.
	   * @param {?object} nextState Next object to set as state.
	   * @param {?object} nextContext Next public object to set as context.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {?object} unmaskedContext
	   * @private
	   */
	  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
	    var inst = this._instance;
	
	    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
	    var prevProps;
	    var prevState;
	    var prevContext;
	    if (hasComponentDidUpdate) {
	      prevProps = inst.props;
	      prevState = inst.state;
	      prevContext = inst.context;
	    }
	
	    if (inst.componentWillUpdate) {
	      inst.componentWillUpdate(nextProps, nextState, nextContext);
	    }
	
	    this._currentElement = nextElement;
	    this._context = unmaskedContext;
	    inst.props = nextProps;
	    inst.state = nextState;
	    inst.context = nextContext;
	
	    this._updateRenderedComponent(transaction, unmaskedContext);
	
	    if (hasComponentDidUpdate) {
	      transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
	    }
	  },
	
	  /**
	   * Call the component's `render` method and update the DOM accordingly.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  _updateRenderedComponent: function (transaction, context) {
	    var prevComponentInstance = this._renderedComponent;
	    var prevRenderedElement = prevComponentInstance._currentElement;
	    var nextRenderedElement = this._renderValidatedComponent();
	    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
	      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
	    } else {
	      // These two IDs are actually the same! But nothing should rely on that.
	      var thisID = this._rootNodeID;
	      var prevComponentID = prevComponentInstance._rootNodeID;
	      ReactReconciler.unmountComponent(prevComponentInstance);
	
	      this._renderedComponent = this._instantiateReactComponent(nextRenderedElement);
	      var nextMarkup = ReactReconciler.mountComponent(this._renderedComponent, thisID, transaction, this._processChildContext(context));
	      this._replaceNodeWithMarkupByID(prevComponentID, nextMarkup);
	    }
	  },
	
	  /**
	   * @protected
	   */
	  _replaceNodeWithMarkupByID: function (prevComponentID, nextMarkup) {
	    ReactComponentEnvironment.replaceNodeWithMarkupByID(prevComponentID, nextMarkup);
	  },
	
	  /**
	   * @protected
	   */
	  _renderValidatedComponentWithoutOwnerOrContext: function () {
	    var inst = this._instance;
	    var renderedComponent = inst.render();
	    if (false) {
	      // We allow auto-mocks to proceed as if they're returning null.
	      if (typeof renderedComponent === 'undefined' && inst.render._isMockFunction) {
	        // This is probably bad practice. Consider warning here and
	        // deprecating this convenience.
	        renderedComponent = null;
	      }
	    }
	
	    return renderedComponent;
	  },
	
	  /**
	   * @private
	   */
	  _renderValidatedComponent: function () {
	    var renderedComponent;
	    ReactCurrentOwner.current = this;
	    try {
	      renderedComponent = this._renderValidatedComponentWithoutOwnerOrContext();
	    } finally {
	      ReactCurrentOwner.current = null;
	    }
	    !(
	    // TODO: An `isValidNode` function would probably be more appropriate
	    renderedComponent === null || renderedComponent === false || ReactElement.isValidElement(renderedComponent)) ?  false ? invariant(false, '%s.render(): A valid ReactComponent must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : invariant(false) : undefined;
	    return renderedComponent;
	  },
	
	  /**
	   * Lazily allocates the refs object and stores `component` as `ref`.
	   *
	   * @param {string} ref Reference name.
	   * @param {component} component Component to store as `ref`.
	   * @final
	   * @private
	   */
	  attachRef: function (ref, component) {
	    var inst = this.getPublicInstance();
	    !(inst != null) ?  false ? invariant(false, 'Stateless function components cannot have refs.') : invariant(false) : undefined;
	    var publicComponentInstance = component.getPublicInstance();
	    if (false) {
	      var componentName = component && component.getName ? component.getName() : 'a component';
	      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : undefined;
	    }
	    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
	    refs[ref] = publicComponentInstance;
	  },
	
	  /**
	   * Detaches a reference name.
	   *
	   * @param {string} ref Name to dereference.
	   * @final
	   * @private
	   */
	  detachRef: function (ref) {
	    var refs = this.getPublicInstance().refs;
	    delete refs[ref];
	  },
	
	  /**
	   * Get a text description of the component that can be used to identify it
	   * in error messages.
	   * @return {string} The name or null.
	   * @internal
	   */
	  getName: function () {
	    var type = this._currentElement.type;
	    var constructor = this._instance && this._instance.constructor;
	    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
	  },
	
	  /**
	   * Get the publicly accessible representation of this component - i.e. what
	   * is exposed by refs and returned by render. Can be null for stateless
	   * components.
	   *
	   * @return {ReactComponent} the public component instance.
	   * @internal
	   */
	  getPublicInstance: function () {
	    var inst = this._instance;
	    if (inst instanceof StatelessComponent) {
	      return null;
	    }
	    return inst;
	  },
	
	  // Stub
	  _instantiateReactComponent: null
	
	};
	
	ReactPerf.measureMethods(ReactCompositeComponentMixin, 'ReactCompositeComponent', {
	  mountComponent: 'mountComponent',
	  updateComponent: 'updateComponent',
	  _renderValidatedComponent: '_renderValidatedComponent'
	});
	
	var ReactCompositeComponent = {
	
	  Mixin: ReactCompositeComponentMixin
	
	};
	
	module.exports = ReactCompositeComponent;

/***/ }),
/* 142 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMButton
	 */
	
	'use strict';
	
	var mouseListenerNames = {
	  onClick: true,
	  onDoubleClick: true,
	  onMouseDown: true,
	  onMouseMove: true,
	  onMouseUp: true,
	
	  onClickCapture: true,
	  onDoubleClickCapture: true,
	  onMouseDownCapture: true,
	  onMouseMoveCapture: true,
	  onMouseUpCapture: true
	};
	
	/**
	 * Implements a <button> native component that does not receive mouse events
	 * when `disabled` is set.
	 */
	var ReactDOMButton = {
	  getNativeProps: function (inst, props, context) {
	    if (!props.disabled) {
	      return props;
	    }
	
	    // Copy the props, except the mouse listeners
	    var nativeProps = {};
	    for (var key in props) {
	      if (props.hasOwnProperty(key) && !mouseListenerNames[key]) {
	        nativeProps[key] = props[key];
	      }
	    }
	
	    return nativeProps;
	  }
	};
	
	module.exports = ReactDOMButton;

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMComponent
	 * @typechecks static-only
	 */
	
	/* global hasOwnProperty:true */
	
	'use strict';
	
	var AutoFocusUtils = __webpack_require__(127);
	var CSSPropertyOperations = __webpack_require__(129);
	var DOMProperty = __webpack_require__(18);
	var DOMPropertyOperations = __webpack_require__(36);
	var EventConstants = __webpack_require__(11);
	var ReactBrowserEventEmitter = __webpack_require__(26);
	var ReactComponentBrowserEnvironment = __webpack_require__(38);
	var ReactDOMButton = __webpack_require__(142);
	var ReactDOMInput = __webpack_require__(145);
	var ReactDOMOption = __webpack_require__(146);
	var ReactDOMSelect = __webpack_require__(71);
	var ReactDOMTextarea = __webpack_require__(149);
	var ReactMount = __webpack_require__(5);
	var ReactMultiChild = __webpack_require__(154);
	var ReactPerf = __webpack_require__(7);
	var ReactUpdateQueue = __webpack_require__(41);
	
	var assign = __webpack_require__(3);
	var canDefineProperty = __webpack_require__(31);
	var escapeTextContentForBrowser = __webpack_require__(32);
	var invariant = __webpack_require__(1);
	var isEventSupported = __webpack_require__(49);
	var keyOf = __webpack_require__(13);
	var setInnerHTML = __webpack_require__(33);
	var setTextContent = __webpack_require__(50);
	var shallowEqual = __webpack_require__(59);
	var validateDOMNesting = __webpack_require__(53);
	var warning = __webpack_require__(2);
	
	var deleteListener = ReactBrowserEventEmitter.deleteListener;
	var listenTo = ReactBrowserEventEmitter.listenTo;
	var registrationNameModules = ReactBrowserEventEmitter.registrationNameModules;
	
	// For quickly matching children type, to test if can be treated as content.
	var CONTENT_TYPES = { 'string': true, 'number': true };
	
	var CHILDREN = keyOf({ children: null });
	var STYLE = keyOf({ style: null });
	var HTML = keyOf({ __html: null });
	
	var ELEMENT_NODE_TYPE = 1;
	
	function getDeclarationErrorAddendum(internalInstance) {
	  if (internalInstance) {
	    var owner = internalInstance._currentElement._owner || null;
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' This DOM node was rendered by `' + name + '`.';
	      }
	    }
	  }
	  return '';
	}
	
	var legacyPropsDescriptor;
	if (false) {
	  legacyPropsDescriptor = {
	    props: {
	      enumerable: false,
	      get: function () {
	        var component = this._reactInternalComponent;
	        process.env.NODE_ENV !== 'production' ? warning(false, 'ReactDOMComponent: Do not access .props of a DOM node; instead, ' + 'recreate the props as `render` did originally or read the DOM ' + 'properties/attributes directly from this node (e.g., ' + 'this.refs.box.className).%s', getDeclarationErrorAddendum(component)) : undefined;
	        return component._currentElement.props;
	      }
	    }
	  };
	}
	
	function legacyGetDOMNode() {
	  if (false) {
	    var component = this._reactInternalComponent;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'ReactDOMComponent: Do not access .getDOMNode() of a DOM node; ' + 'instead, use the node directly.%s', getDeclarationErrorAddendum(component)) : undefined;
	  }
	  return this;
	}
	
	function legacyIsMounted() {
	  var component = this._reactInternalComponent;
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(false, 'ReactDOMComponent: Do not access .isMounted() of a DOM node.%s', getDeclarationErrorAddendum(component)) : undefined;
	  }
	  return !!component;
	}
	
	function legacySetStateEtc() {
	  if (false) {
	    var component = this._reactInternalComponent;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'ReactDOMComponent: Do not access .setState(), .replaceState(), or ' + '.forceUpdate() of a DOM node. This is a no-op.%s', getDeclarationErrorAddendum(component)) : undefined;
	  }
	}
	
	function legacySetProps(partialProps, callback) {
	  var component = this._reactInternalComponent;
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(false, 'ReactDOMComponent: Do not access .setProps() of a DOM node. ' + 'Instead, call ReactDOM.render again at the top level.%s', getDeclarationErrorAddendum(component)) : undefined;
	  }
	  if (!component) {
	    return;
	  }
	  ReactUpdateQueue.enqueueSetPropsInternal(component, partialProps);
	  if (callback) {
	    ReactUpdateQueue.enqueueCallbackInternal(component, callback);
	  }
	}
	
	function legacyReplaceProps(partialProps, callback) {
	  var component = this._reactInternalComponent;
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(false, 'ReactDOMComponent: Do not access .replaceProps() of a DOM node. ' + 'Instead, call ReactDOM.render again at the top level.%s', getDeclarationErrorAddendum(component)) : undefined;
	  }
	  if (!component) {
	    return;
	  }
	  ReactUpdateQueue.enqueueReplacePropsInternal(component, partialProps);
	  if (callback) {
	    ReactUpdateQueue.enqueueCallbackInternal(component, callback);
	  }
	}
	
	function friendlyStringify(obj) {
	  if (typeof obj === 'object') {
	    if (Array.isArray(obj)) {
	      return '[' + obj.map(friendlyStringify).join(', ') + ']';
	    } else {
	      var pairs = [];
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
	          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
	        }
	      }
	      return '{' + pairs.join(', ') + '}';
	    }
	  } else if (typeof obj === 'string') {
	    return JSON.stringify(obj);
	  } else if (typeof obj === 'function') {
	    return '[function object]';
	  }
	  // Differs from JSON.stringify in that undefined becauses undefined and that
	  // inf and nan don't become null
	  return String(obj);
	}
	
	var styleMutationWarning = {};
	
	function checkAndWarnForMutatedStyle(style1, style2, component) {
	  if (style1 == null || style2 == null) {
	    return;
	  }
	  if (shallowEqual(style1, style2)) {
	    return;
	  }
	
	  var componentName = component._tag;
	  var owner = component._currentElement._owner;
	  var ownerName;
	  if (owner) {
	    ownerName = owner.getName();
	  }
	
	  var hash = ownerName + '|' + componentName;
	
	  if (styleMutationWarning.hasOwnProperty(hash)) {
	    return;
	  }
	
	  styleMutationWarning[hash] = true;
	
	   false ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : undefined;
	}
	
	/**
	 * @param {object} component
	 * @param {?object} props
	 */
	function assertValidProps(component, props) {
	  if (!props) {
	    return;
	  }
	  // Note the use of `==` which checks for null or undefined.
	  if (false) {
	    if (voidElementTags[component._tag]) {
	      process.env.NODE_ENV !== 'production' ? warning(props.children == null && props.dangerouslySetInnerHTML == null, '%s is a void element tag and must not have `children` or ' + 'use `props.dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : undefined;
	    }
	  }
	  if (props.dangerouslySetInnerHTML != null) {
	    !(props.children == null) ?  false ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : invariant(false) : undefined;
	    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ?  false ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. ' + 'Please visit https://fb.me/react-invariant-dangerously-set-inner-html ' + 'for more information.') : invariant(false) : undefined;
	  }
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : undefined;
	    process.env.NODE_ENV !== 'production' ? warning(!props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : undefined;
	  }
	  !(props.style == null || typeof props.style === 'object') ?  false ? invariant(false, 'The `style` prop expects a mapping from style properties to values, ' + 'not a string. For example, style={{marginRight: spacing + \'em\'}} when ' + 'using JSX.%s', getDeclarationErrorAddendum(component)) : invariant(false) : undefined;
	}
	
	function enqueuePutListener(id, registrationName, listener, transaction) {
	  if (false) {
	    // IE8 has no API for event capturing and the `onScroll` event doesn't
	    // bubble.
	    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), 'This browser doesn\'t support the `onScroll` event') : undefined;
	  }
	  var container = ReactMount.findReactContainerForID(id);
	  if (container) {
	    var doc = container.nodeType === ELEMENT_NODE_TYPE ? container.ownerDocument : container;
	    listenTo(registrationName, doc);
	  }
	  transaction.getReactMountReady().enqueue(putListener, {
	    id: id,
	    registrationName: registrationName,
	    listener: listener
	  });
	}
	
	function putListener() {
	  var listenerToPut = this;
	  ReactBrowserEventEmitter.putListener(listenerToPut.id, listenerToPut.registrationName, listenerToPut.listener);
	}
	
	// There are so many media events, it makes sense to just
	// maintain a list rather than create a `trapBubbledEvent` for each
	var mediaEvents = {
	  topAbort: 'abort',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTimeUpdate: 'timeupdate',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting'
	};
	
	function trapBubbledEventsLocal() {
	  var inst = this;
	  // If a component renders to null or if another component fatals and causes
	  // the state of the tree to be corrupted, `node` here can be null.
	  !inst._rootNodeID ?  false ? invariant(false, 'Must be mounted to trap events') : invariant(false) : undefined;
	  var node = ReactMount.getNode(inst._rootNodeID);
	  !node ?  false ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : invariant(false) : undefined;
	
	  switch (inst._tag) {
	    case 'iframe':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topLoad, 'load', node)];
	      break;
	    case 'video':
	    case 'audio':
	
	      inst._wrapperState.listeners = [];
	      // create listener for each media event
	      for (var event in mediaEvents) {
	        if (mediaEvents.hasOwnProperty(event)) {
	          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes[event], mediaEvents[event], node));
	        }
	      }
	
	      break;
	    case 'img':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topError, 'error', node), ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topLoad, 'load', node)];
	      break;
	    case 'form':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topReset, 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topSubmit, 'submit', node)];
	      break;
	  }
	}
	
	function mountReadyInputWrapper() {
	  ReactDOMInput.mountReadyWrapper(this);
	}
	
	function postUpdateSelectWrapper() {
	  ReactDOMSelect.postUpdateWrapper(this);
	}
	
	// For HTML, certain tags should omit their close tag. We keep a whitelist for
	// those special cased tags.
	
	var omittedCloseTags = {
	  'area': true,
	  'base': true,
	  'br': true,
	  'col': true,
	  'embed': true,
	  'hr': true,
	  'img': true,
	  'input': true,
	  'keygen': true,
	  'link': true,
	  'meta': true,
	  'param': true,
	  'source': true,
	  'track': true,
	  'wbr': true
	};
	
	// NOTE: menuitem's close tag should be omitted, but that causes problems.
	var newlineEatingTags = {
	  'listing': true,
	  'pre': true,
	  'textarea': true
	};
	
	// For HTML, certain tags cannot have children. This has the same purpose as
	// `omittedCloseTags` except that `menuitem` should still have its closing tag.
	
	var voidElementTags = assign({
	  'menuitem': true
	}, omittedCloseTags);
	
	// We accept any tag to be rendered but since this gets injected into arbitrary
	// HTML, we want to make sure that it's a safe tag.
	// http://www.w3.org/TR/REC-xml/#NT-Name
	
	var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
	var validatedTagCache = {};
	var hasOwnProperty = ({}).hasOwnProperty;
	
	function validateDangerousTag(tag) {
	  if (!hasOwnProperty.call(validatedTagCache, tag)) {
	    !VALID_TAG_REGEX.test(tag) ?  false ? invariant(false, 'Invalid tag: %s', tag) : invariant(false) : undefined;
	    validatedTagCache[tag] = true;
	  }
	}
	
	function processChildContextDev(context, inst) {
	  // Pass down our tag name to child components for validation purposes
	  context = assign({}, context);
	  var info = context[validateDOMNesting.ancestorInfoContextKey];
	  context[validateDOMNesting.ancestorInfoContextKey] = validateDOMNesting.updatedAncestorInfo(info, inst._tag, inst);
	  return context;
	}
	
	function isCustomComponent(tagName, props) {
	  return tagName.indexOf('-') >= 0 || props.is != null;
	}
	
	/**
	 * Creates a new React class that is idempotent and capable of containing other
	 * React components. It accepts event listeners and DOM properties that are
	 * valid according to `DOMProperty`.
	 *
	 *  - Event listeners: `onClick`, `onMouseDown`, etc.
	 *  - DOM properties: `className`, `name`, `title`, etc.
	 *
	 * The `style` property functions differently from the DOM API. It accepts an
	 * object mapping of style properties to values.
	 *
	 * @constructor ReactDOMComponent
	 * @extends ReactMultiChild
	 */
	function ReactDOMComponent(tag) {
	  validateDangerousTag(tag);
	  this._tag = tag.toLowerCase();
	  this._renderedChildren = null;
	  this._previousStyle = null;
	  this._previousStyleCopy = null;
	  this._rootNodeID = null;
	  this._wrapperState = null;
	  this._topLevelWrapper = null;
	  this._nodeWithLegacyProperties = null;
	  if (false) {
	    this._unprocessedContextDev = null;
	    this._processedContextDev = null;
	  }
	}
	
	ReactDOMComponent.displayName = 'ReactDOMComponent';
	
	ReactDOMComponent.Mixin = {
	
	  construct: function (element) {
	    this._currentElement = element;
	  },
	
	  /**
	   * Generates root tag markup then recurses. This method has side effects and
	   * is not idempotent.
	   *
	   * @internal
	   * @param {string} rootID The root DOM ID for this node.
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} context
	   * @return {string} The computed markup.
	   */
	  mountComponent: function (rootID, transaction, context) {
	    this._rootNodeID = rootID;
	
	    var props = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'iframe':
	      case 'img':
	      case 'form':
	      case 'video':
	      case 'audio':
	        this._wrapperState = {
	          listeners: null
	        };
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'button':
	        props = ReactDOMButton.getNativeProps(this, props, context);
	        break;
	      case 'input':
	        ReactDOMInput.mountWrapper(this, props, context);
	        props = ReactDOMInput.getNativeProps(this, props, context);
	        break;
	      case 'option':
	        ReactDOMOption.mountWrapper(this, props, context);
	        props = ReactDOMOption.getNativeProps(this, props, context);
	        break;
	      case 'select':
	        ReactDOMSelect.mountWrapper(this, props, context);
	        props = ReactDOMSelect.getNativeProps(this, props, context);
	        context = ReactDOMSelect.processChildContext(this, props, context);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.mountWrapper(this, props, context);
	        props = ReactDOMTextarea.getNativeProps(this, props, context);
	        break;
	    }
	
	    assertValidProps(this, props);
	    if (false) {
	      if (context[validateDOMNesting.ancestorInfoContextKey]) {
	        validateDOMNesting(this._tag, this, context[validateDOMNesting.ancestorInfoContextKey]);
	      }
	    }
	
	    if (false) {
	      this._unprocessedContextDev = context;
	      this._processedContextDev = processChildContextDev(context, this);
	      context = this._processedContextDev;
	    }
	
	    var mountImage;
	    if (transaction.useCreateElement) {
	      var ownerDocument = context[ReactMount.ownerDocumentContextKey];
	      var el = ownerDocument.createElement(this._currentElement.type);
	      DOMPropertyOperations.setAttributeForID(el, this._rootNodeID);
	      // Populate node cache
	      ReactMount.getID(el);
	      this._updateDOMProperties({}, props, transaction, el);
	      this._createInitialChildren(transaction, props, context, el);
	      mountImage = el;
	    } else {
	      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
	      var tagContent = this._createContentMarkup(transaction, props, context);
	      if (!tagContent && omittedCloseTags[this._tag]) {
	        mountImage = tagOpen + '/>';
	      } else {
	        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
	      }
	    }
	
	    switch (this._tag) {
	      case 'input':
	        transaction.getReactMountReady().enqueue(mountReadyInputWrapper, this);
	      // falls through
	      case 'button':
	      case 'select':
	      case 'textarea':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	    }
	
	    return mountImage;
	  },
	
	  /**
	   * Creates markup for the open tag and all attributes.
	   *
	   * This method has side effects because events get registered.
	   *
	   * Iterating over object properties is faster than iterating over arrays.
	   * @see http://jsperf.com/obj-vs-arr-iteration
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @return {string} Markup of opening tag.
	   */
	  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
	    var ret = '<' + this._currentElement.type;
	
	    for (var propKey in props) {
	      if (!props.hasOwnProperty(propKey)) {
	        continue;
	      }
	      var propValue = props[propKey];
	      if (propValue == null) {
	        continue;
	      }
	      if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (propValue) {
	          enqueuePutListener(this._rootNodeID, propKey, propValue, transaction);
	        }
	      } else {
	        if (propKey === STYLE) {
	          if (propValue) {
	            if (false) {
	              // See `_updateDOMProperties`. style block
	              this._previousStyle = propValue;
	            }
	            propValue = this._previousStyleCopy = assign({}, props.style);
	          }
	          propValue = CSSPropertyOperations.createMarkupForStyles(propValue);
	        }
	        var markup = null;
	        if (this._tag != null && isCustomComponent(this._tag, props)) {
	          if (propKey !== CHILDREN) {
	            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
	          }
	        } else {
	          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
	        }
	        if (markup) {
	          ret += ' ' + markup;
	        }
	      }
	    }
	
	    // For static pages, no need to put React ID and checksum. Saves lots of
	    // bytes.
	    if (transaction.renderToStaticMarkup) {
	      return ret;
	    }
	
	    var markupForID = DOMPropertyOperations.createMarkupForID(this._rootNodeID);
	    return ret + ' ' + markupForID;
	  },
	
	  /**
	   * Creates markup for the content between the tags.
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @param {object} context
	   * @return {string} Content markup.
	   */
	  _createContentMarkup: function (transaction, props, context) {
	    var ret = '';
	
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        ret = innerHTML.__html;
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      if (contentToUse != null) {
	        // TODO: Validate that text is allowed as a child of this node
	        ret = escapeTextContentForBrowser(contentToUse);
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        ret = mountImages.join('');
	      }
	    }
	    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
	      // text/html ignores the first character in these tags if it's a newline
	      // Prefer to break application/xml over text/html (for now) by adding
	      // a newline specifically to get eaten by the parser. (Alternately for
	      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
	      // \r is normalized out by HTMLTextAreaElement#value.)
	      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
	      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
	      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
	      // See: Parsing of "textarea" "listing" and "pre" elements
	      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
	      return '\n' + ret;
	    } else {
	      return ret;
	    }
	  },
	
	  _createInitialChildren: function (transaction, props, context, el) {
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        setInnerHTML(el, innerHTML.__html);
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      if (contentToUse != null) {
	        // TODO: Validate that text is allowed as a child of this node
	        setTextContent(el, contentToUse);
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        for (var i = 0; i < mountImages.length; i++) {
	          el.appendChild(mountImages[i]);
	        }
	      }
	    }
	  },
	
	  /**
	   * Receives a next element and updates the component.
	   *
	   * @internal
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} context
	   */
	  receiveComponent: function (nextElement, transaction, context) {
	    var prevElement = this._currentElement;
	    this._currentElement = nextElement;
	    this.updateComponent(transaction, prevElement, nextElement, context);
	  },
	
	  /**
	   * Updates a native DOM component after it has already been allocated and
	   * attached to the DOM. Reconciles the root DOM node, then recurses.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevElement
	   * @param {ReactElement} nextElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevElement, nextElement, context) {
	    var lastProps = prevElement.props;
	    var nextProps = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'button':
	        lastProps = ReactDOMButton.getNativeProps(this, lastProps);
	        nextProps = ReactDOMButton.getNativeProps(this, nextProps);
	        break;
	      case 'input':
	        ReactDOMInput.updateWrapper(this);
	        lastProps = ReactDOMInput.getNativeProps(this, lastProps);
	        nextProps = ReactDOMInput.getNativeProps(this, nextProps);
	        break;
	      case 'option':
	        lastProps = ReactDOMOption.getNativeProps(this, lastProps);
	        nextProps = ReactDOMOption.getNativeProps(this, nextProps);
	        break;
	      case 'select':
	        lastProps = ReactDOMSelect.getNativeProps(this, lastProps);
	        nextProps = ReactDOMSelect.getNativeProps(this, nextProps);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.updateWrapper(this);
	        lastProps = ReactDOMTextarea.getNativeProps(this, lastProps);
	        nextProps = ReactDOMTextarea.getNativeProps(this, nextProps);
	        break;
	    }
	
	    if (false) {
	      // If the context is reference-equal to the old one, pass down the same
	      // processed object so the update bailout in ReactReconciler behaves
	      // correctly (and identically in dev and prod). See #5005.
	      if (this._unprocessedContextDev !== context) {
	        this._unprocessedContextDev = context;
	        this._processedContextDev = processChildContextDev(context, this);
	      }
	      context = this._processedContextDev;
	    }
	
	    assertValidProps(this, nextProps);
	    this._updateDOMProperties(lastProps, nextProps, transaction, null);
	    this._updateDOMChildren(lastProps, nextProps, transaction, context);
	
	    if (!canDefineProperty && this._nodeWithLegacyProperties) {
	      this._nodeWithLegacyProperties.props = nextProps;
	    }
	
	    if (this._tag === 'select') {
	      // <select> value update needs to occur after <option> children
	      // reconciliation
	      transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
	    }
	  },
	
	  /**
	   * Reconciles the properties by detecting differences in property values and
	   * updating the DOM as necessary. This function is probably the single most
	   * critical path for performance optimization.
	   *
	   * TODO: Benchmark whether checking for changed values in memory actually
	   *       improves performance (especially statically positioned elements).
	   * TODO: Benchmark the effects of putting this at the top since 99% of props
	   *       do not change for a given reconciliation.
	   * TODO: Benchmark areas that can be improved with caching.
	   *
	   * @private
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {ReactReconcileTransaction} transaction
	   * @param {?DOMElement} node
	   */
	  _updateDOMProperties: function (lastProps, nextProps, transaction, node) {
	    var propKey;
	    var styleName;
	    var styleUpdates;
	    for (propKey in lastProps) {
	      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey)) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        var lastStyle = this._previousStyleCopy;
	        for (styleName in lastStyle) {
	          if (lastStyle.hasOwnProperty(styleName)) {
	            styleUpdates = styleUpdates || {};
	            styleUpdates[styleName] = '';
	          }
	        }
	        this._previousStyleCopy = null;
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (lastProps[propKey]) {
	          // Only call deleteListener if there was a listener previously or
	          // else willDeleteListener gets called when there wasn't actually a
	          // listener (e.g., onClick={null})
	          deleteListener(this._rootNodeID, propKey);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        if (!node) {
	          node = ReactMount.getNode(this._rootNodeID);
	        }
	        DOMPropertyOperations.deleteValueForProperty(node, propKey);
	      }
	    }
	    for (propKey in nextProps) {
	      var nextProp = nextProps[propKey];
	      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps[propKey];
	      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        if (nextProp) {
	          if (false) {
	            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
	            this._previousStyle = nextProp;
	          }
	          nextProp = this._previousStyleCopy = assign({}, nextProp);
	        } else {
	          this._previousStyleCopy = null;
	        }
	        if (lastProp) {
	          // Unset styles on `lastProp` but not on `nextProp`.
	          for (styleName in lastProp) {
	            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = '';
	            }
	          }
	          // Update styles that changed since `lastProp`.
	          for (styleName in nextProp) {
	            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = nextProp[styleName];
	            }
	          }
	        } else {
	          // Relies on `updateStylesByID` not mutating `styleUpdates`.
	          styleUpdates = nextProp;
	        }
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (nextProp) {
	          enqueuePutListener(this._rootNodeID, propKey, nextProp, transaction);
	        } else if (lastProp) {
	          deleteListener(this._rootNodeID, propKey);
	        }
	      } else if (isCustomComponent(this._tag, nextProps)) {
	        if (!node) {
	          node = ReactMount.getNode(this._rootNodeID);
	        }
	        if (propKey === CHILDREN) {
	          nextProp = null;
	        }
	        DOMPropertyOperations.setValueForAttribute(node, propKey, nextProp);
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        if (!node) {
	          node = ReactMount.getNode(this._rootNodeID);
	        }
	        // If we're updating to null or undefined, we should remove the property
	        // from the DOM node instead of inadvertantly setting to a string. This
	        // brings us in line with the same behavior we have on initial render.
	        if (nextProp != null) {
	          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
	        } else {
	          DOMPropertyOperations.deleteValueForProperty(node, propKey);
	        }
	      }
	    }
	    if (styleUpdates) {
	      if (!node) {
	        node = ReactMount.getNode(this._rootNodeID);
	      }
	      CSSPropertyOperations.setValueForStyles(node, styleUpdates);
	    }
	  },
	
	  /**
	   * Reconciles the children with the various properties that affect the
	   * children content.
	   *
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   */
	  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
	    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
	    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;
	
	    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
	    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;
	
	    // Note the use of `!=` which checks for null or undefined.
	    var lastChildren = lastContent != null ? null : lastProps.children;
	    var nextChildren = nextContent != null ? null : nextProps.children;
	
	    // If we're switching from children to content/html or vice versa, remove
	    // the old content
	    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
	    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
	    if (lastChildren != null && nextChildren == null) {
	      this.updateChildren(null, transaction, context);
	    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
	      this.updateTextContent('');
	    }
	
	    if (nextContent != null) {
	      if (lastContent !== nextContent) {
	        this.updateTextContent('' + nextContent);
	      }
	    } else if (nextHtml != null) {
	      if (lastHtml !== nextHtml) {
	        this.updateMarkup('' + nextHtml);
	      }
	    } else if (nextChildren != null) {
	      this.updateChildren(nextChildren, transaction, context);
	    }
	  },
	
	  /**
	   * Destroys all event registrations for this instance. Does not remove from
	   * the DOM. That must be done by the parent.
	   *
	   * @internal
	   */
	  unmountComponent: function () {
	    switch (this._tag) {
	      case 'iframe':
	      case 'img':
	      case 'form':
	      case 'video':
	      case 'audio':
	        var listeners = this._wrapperState.listeners;
	        if (listeners) {
	          for (var i = 0; i < listeners.length; i++) {
	            listeners[i].remove();
	          }
	        }
	        break;
	      case 'input':
	        ReactDOMInput.unmountWrapper(this);
	        break;
	      case 'html':
	      case 'head':
	      case 'body':
	        /**
	         * Components like <html> <head> and <body> can't be removed or added
	         * easily in a cross-browser way, however it's valuable to be able to
	         * take advantage of React's reconciliation for styling and <title>
	         * management. So we just document it and throw in dangerous cases.
	         */
	         true ?  false ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is ' + 'impossible to unmount some top-level components (eg <html>, ' + '<head>, and <body>) reliably and efficiently. To fix this, have a ' + 'single top-level component that never unmounts render these ' + 'elements.', this._tag) : invariant(false) : undefined;
	        break;
	    }
	
	    this.unmountChildren();
	    ReactBrowserEventEmitter.deleteAllListeners(this._rootNodeID);
	    ReactComponentBrowserEnvironment.unmountIDFromEnvironment(this._rootNodeID);
	    this._rootNodeID = null;
	    this._wrapperState = null;
	    if (this._nodeWithLegacyProperties) {
	      var node = this._nodeWithLegacyProperties;
	      node._reactInternalComponent = null;
	      this._nodeWithLegacyProperties = null;
	    }
	  },
	
	  getPublicInstance: function () {
	    if (!this._nodeWithLegacyProperties) {
	      var node = ReactMount.getNode(this._rootNodeID);
	
	      node._reactInternalComponent = this;
	      node.getDOMNode = legacyGetDOMNode;
	      node.isMounted = legacyIsMounted;
	      node.setState = legacySetStateEtc;
	      node.replaceState = legacySetStateEtc;
	      node.forceUpdate = legacySetStateEtc;
	      node.setProps = legacySetProps;
	      node.replaceProps = legacyReplaceProps;
	
	      if (false) {
	        if (canDefineProperty) {
	          Object.defineProperties(node, legacyPropsDescriptor);
	        } else {
	          // updateComponent will update this property on subsequent renders
	          node.props = this._currentElement.props;
	        }
	      } else {
	        // updateComponent will update this property on subsequent renders
	        node.props = this._currentElement.props;
	      }
	
	      this._nodeWithLegacyProperties = node;
	    }
	    return this._nodeWithLegacyProperties;
	  }
	
	};
	
	ReactPerf.measureMethods(ReactDOMComponent, 'ReactDOMComponent', {
	  mountComponent: 'mountComponent',
	  updateComponent: 'updateComponent'
	});
	
	assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);
	
	module.exports = ReactDOMComponent;

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMFactories
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(6);
	var ReactElementValidator = __webpack_require__(75);
	
	var mapObject = __webpack_require__(107);
	
	/**
	 * Create a factory that creates HTML tag elements.
	 *
	 * @param {string} tag Tag name (e.g. `div`).
	 * @private
	 */
	function createDOMFactory(tag) {
	  if (false) {
	    return ReactElementValidator.createFactory(tag);
	  }
	  return ReactElement.createFactory(tag);
	}
	
	/**
	 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
	 * This is also accessible via `React.DOM`.
	 *
	 * @public
	 */
	var ReactDOMFactories = mapObject({
	  a: 'a',
	  abbr: 'abbr',
	  address: 'address',
	  area: 'area',
	  article: 'article',
	  aside: 'aside',
	  audio: 'audio',
	  b: 'b',
	  base: 'base',
	  bdi: 'bdi',
	  bdo: 'bdo',
	  big: 'big',
	  blockquote: 'blockquote',
	  body: 'body',
	  br: 'br',
	  button: 'button',
	  canvas: 'canvas',
	  caption: 'caption',
	  cite: 'cite',
	  code: 'code',
	  col: 'col',
	  colgroup: 'colgroup',
	  data: 'data',
	  datalist: 'datalist',
	  dd: 'dd',
	  del: 'del',
	  details: 'details',
	  dfn: 'dfn',
	  dialog: 'dialog',
	  div: 'div',
	  dl: 'dl',
	  dt: 'dt',
	  em: 'em',
	  embed: 'embed',
	  fieldset: 'fieldset',
	  figcaption: 'figcaption',
	  figure: 'figure',
	  footer: 'footer',
	  form: 'form',
	  h1: 'h1',
	  h2: 'h2',
	  h3: 'h3',
	  h4: 'h4',
	  h5: 'h5',
	  h6: 'h6',
	  head: 'head',
	  header: 'header',
	  hgroup: 'hgroup',
	  hr: 'hr',
	  html: 'html',
	  i: 'i',
	  iframe: 'iframe',
	  img: 'img',
	  input: 'input',
	  ins: 'ins',
	  kbd: 'kbd',
	  keygen: 'keygen',
	  label: 'label',
	  legend: 'legend',
	  li: 'li',
	  link: 'link',
	  main: 'main',
	  map: 'map',
	  mark: 'mark',
	  menu: 'menu',
	  menuitem: 'menuitem',
	  meta: 'meta',
	  meter: 'meter',
	  nav: 'nav',
	  noscript: 'noscript',
	  object: 'object',
	  ol: 'ol',
	  optgroup: 'optgroup',
	  option: 'option',
	  output: 'output',
	  p: 'p',
	  param: 'param',
	  picture: 'picture',
	  pre: 'pre',
	  progress: 'progress',
	  q: 'q',
	  rp: 'rp',
	  rt: 'rt',
	  ruby: 'ruby',
	  s: 's',
	  samp: 'samp',
	  script: 'script',
	  section: 'section',
	  select: 'select',
	  small: 'small',
	  source: 'source',
	  span: 'span',
	  strong: 'strong',
	  style: 'style',
	  sub: 'sub',
	  summary: 'summary',
	  sup: 'sup',
	  table: 'table',
	  tbody: 'tbody',
	  td: 'td',
	  textarea: 'textarea',
	  tfoot: 'tfoot',
	  th: 'th',
	  thead: 'thead',
	  time: 'time',
	  title: 'title',
	  tr: 'tr',
	  track: 'track',
	  u: 'u',
	  ul: 'ul',
	  'var': 'var',
	  video: 'video',
	  wbr: 'wbr',
	
	  // SVG
	  circle: 'circle',
	  clipPath: 'clipPath',
	  defs: 'defs',
	  ellipse: 'ellipse',
	  g: 'g',
	  image: 'image',
	  line: 'line',
	  linearGradient: 'linearGradient',
	  mask: 'mask',
	  path: 'path',
	  pattern: 'pattern',
	  polygon: 'polygon',
	  polyline: 'polyline',
	  radialGradient: 'radialGradient',
	  rect: 'rect',
	  stop: 'stop',
	  svg: 'svg',
	  text: 'text',
	  tspan: 'tspan'
	
	}, createDOMFactory);
	
	module.exports = ReactDOMFactories;

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMInput
	 */
	
	'use strict';
	
	var ReactDOMIDOperations = __webpack_require__(40);
	var LinkedValueUtils = __webpack_require__(37);
	var ReactMount = __webpack_require__(5);
	var ReactUpdates = __webpack_require__(8);
	
	var assign = __webpack_require__(3);
	var invariant = __webpack_require__(1);
	
	var instancesByReactID = {};
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMInput.updateWrapper(this);
	  }
	}
	
	/**
	 * Implements an <input> native component that allows setting these optional
	 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
	 *
	 * If `checked` or `value` are not supplied (or null/undefined), user actions
	 * that affect the checked state or value will trigger updates to the element.
	 *
	 * If they are supplied (and not null/undefined), the rendered element will not
	 * trigger updates to the element. Instead, the props must change in order for
	 * the rendered element to be updated.
	 *
	 * The rendered element will be initialized as unchecked (or `defaultChecked`)
	 * with an empty value (or `defaultValue`).
	 *
	 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
	 */
	var ReactDOMInput = {
	  getNativeProps: function (inst, props, context) {
	    var value = LinkedValueUtils.getValue(props);
	    var checked = LinkedValueUtils.getChecked(props);
	
	    var nativeProps = assign({}, props, {
	      defaultChecked: undefined,
	      defaultValue: undefined,
	      value: value != null ? value : inst._wrapperState.initialValue,
	      checked: checked != null ? checked : inst._wrapperState.initialChecked,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return nativeProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);
	    }
	
	    var defaultValue = props.defaultValue;
	    inst._wrapperState = {
	      initialChecked: props.defaultChecked || false,
	      initialValue: defaultValue != null ? defaultValue : null,
	      onChange: _handleChange.bind(inst)
	    };
	  },
	
	  mountReadyWrapper: function (inst) {
	    // Can't be in mountWrapper or else server rendering leaks.
	    instancesByReactID[inst._rootNodeID] = inst;
	  },
	
	  unmountWrapper: function (inst) {
	    delete instancesByReactID[inst._rootNodeID];
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // TODO: Shouldn't this be getChecked(props)?
	    var checked = props.checked;
	    if (checked != null) {
	      ReactDOMIDOperations.updatePropertyByID(inst._rootNodeID, 'checked', checked || false);
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      ReactDOMIDOperations.updatePropertyByID(inst._rootNodeID, 'value', '' + value);
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  // Here we use asap to wait until all updates have propagated, which
	  // is important when using controlled components within layers:
	  // https://github.com/facebook/react/issues/1698
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	
	  var name = props.name;
	  if (props.type === 'radio' && name != null) {
	    var rootNode = ReactMount.getNode(this._rootNodeID);
	    var queryRoot = rootNode;
	
	    while (queryRoot.parentNode) {
	      queryRoot = queryRoot.parentNode;
	    }
	
	    // If `rootNode.form` was non-null, then we could try `form.elements`,
	    // but that sometimes behaves strangely in IE8. We could also try using
	    // `form.getElementsByName`, but that will only return direct children
	    // and won't include inputs that use the HTML5 `form=` attribute. Since
	    // the input might not even be in a form, let's just use the global
	    // `querySelectorAll` to ensure we don't miss anything.
	    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');
	
	    for (var i = 0; i < group.length; i++) {
	      var otherNode = group[i];
	      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
	        continue;
	      }
	      // This will throw if radio buttons rendered by different copies of React
	      // and the same name are rendered into the same form (same as #1939).
	      // That's probably okay; we don't support it just as we don't support
	      // mixing React with non-React.
	      var otherID = ReactMount.getID(otherNode);
	      !otherID ?  false ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the ' + 'same `name` is not supported.') : invariant(false) : undefined;
	      var otherInstance = instancesByReactID[otherID];
	      !otherInstance ?  false ? invariant(false, 'ReactDOMInput: Unknown radio button ID %s.', otherID) : invariant(false) : undefined;
	      // If this is a controlled radio button group, forcing the input that
	      // was previously checked to update will cause it to be come re-checked
	      // as appropriate.
	      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
	    }
	  }
	
	  return returnValue;
	}
	
	module.exports = ReactDOMInput;

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMOption
	 */
	
	'use strict';
	
	var ReactChildren = __webpack_require__(66);
	var ReactDOMSelect = __webpack_require__(71);
	
	var assign = __webpack_require__(3);
	var warning = __webpack_require__(2);
	
	var valueContextKey = ReactDOMSelect.valueContextKey;
	
	/**
	 * Implements an <option> native component that warns when `selected` is set.
	 */
	var ReactDOMOption = {
	  mountWrapper: function (inst, props, context) {
	    // TODO (yungsters): Remove support for `selected` in <option>.
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : undefined;
	    }
	
	    // Look up whether this option is 'selected' via context
	    var selectValue = context[valueContextKey];
	
	    // If context key is null (e.g., no specified value or after initial mount)
	    // or missing (e.g., for <datalist>), we don't change props.selected
	    var selected = null;
	    if (selectValue != null) {
	      selected = false;
	      if (Array.isArray(selectValue)) {
	        // multiple
	        for (var i = 0; i < selectValue.length; i++) {
	          if ('' + selectValue[i] === '' + props.value) {
	            selected = true;
	            break;
	          }
	        }
	      } else {
	        selected = '' + selectValue === '' + props.value;
	      }
	    }
	
	    inst._wrapperState = { selected: selected };
	  },
	
	  getNativeProps: function (inst, props, context) {
	    var nativeProps = assign({ selected: undefined, children: undefined }, props);
	
	    // Read state only from initial mount because <select> updates value
	    // manually; we need the initial state only for server rendering
	    if (inst._wrapperState.selected != null) {
	      nativeProps.selected = inst._wrapperState.selected;
	    }
	
	    var content = '';
	
	    // Flatten children and warn if they aren't strings or numbers;
	    // invalid types are ignored.
	    ReactChildren.forEach(props.children, function (child) {
	      if (child == null) {
	        return;
	      }
	      if (typeof child === 'string' || typeof child === 'number') {
	        content += child;
	      } else {
	         false ? warning(false, 'Only strings and numbers are supported as <option> children.') : undefined;
	      }
	    });
	
	    if (content) {
	      nativeProps.children = content;
	    }
	
	    return nativeProps;
	  }
	
	};
	
	module.exports = ReactDOMOption;

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMSelection
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(4);
	
	var getNodeForCharacterOffset = __webpack_require__(178);
	var getTextContentAccessor = __webpack_require__(89);
	
	/**
	 * While `isCollapsed` is available on the Selection object and `collapsed`
	 * is available on the Range object, IE11 sometimes gets them wrong.
	 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
	 */
	function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
	  return anchorNode === focusNode && anchorOffset === focusOffset;
	}
	
	/**
	 * Get the appropriate anchor and focus node/offset pairs for IE.
	 *
	 * The catch here is that IE's selection API doesn't provide information
	 * about whether the selection is forward or backward, so we have to
	 * behave as though it's always forward.
	 *
	 * IE text differs from modern selection in that it behaves as though
	 * block elements end with a new line. This means character offsets will
	 * differ between the two APIs.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getIEOffsets(node) {
	  var selection = document.selection;
	  var selectedRange = selection.createRange();
	  var selectedLength = selectedRange.text.length;
	
	  // Duplicate selection so we can move range without breaking user selection.
	  var fromStart = selectedRange.duplicate();
	  fromStart.moveToElementText(node);
	  fromStart.setEndPoint('EndToStart', selectedRange);
	
	  var startOffset = fromStart.text.length;
	  var endOffset = startOffset + selectedLength;
	
	  return {
	    start: startOffset,
	    end: endOffset
	  };
	}
	
	/**
	 * @param {DOMElement} node
	 * @return {?object}
	 */
	function getModernOffsets(node) {
	  var selection = window.getSelection && window.getSelection();
	
	  if (!selection || selection.rangeCount === 0) {
	    return null;
	  }
	
	  var anchorNode = selection.anchorNode;
	  var anchorOffset = selection.anchorOffset;
	  var focusNode = selection.focusNode;
	  var focusOffset = selection.focusOffset;
	
	  var currentRange = selection.getRangeAt(0);
	
	  // In Firefox, range.startContainer and range.endContainer can be "anonymous
	  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
	  // divs do not seem to expose properties, triggering a "Permission denied
	  // error" if any of its properties are accessed. The only seemingly possible
	  // way to avoid erroring is to access a property that typically works for
	  // non-anonymous divs and catch any error that may otherwise arise. See
	  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
	  try {
	    /* eslint-disable no-unused-expressions */
	    currentRange.startContainer.nodeType;
	    currentRange.endContainer.nodeType;
	    /* eslint-enable no-unused-expressions */
	  } catch (e) {
	    return null;
	  }
	
	  // If the node and offset values are the same, the selection is collapsed.
	  // `Selection.isCollapsed` is available natively, but IE sometimes gets
	  // this value wrong.
	  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);
	
	  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;
	
	  var tempRange = currentRange.cloneRange();
	  tempRange.selectNodeContents(node);
	  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);
	
	  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);
	
	  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
	  var end = start + rangeLength;
	
	  // Detect whether the selection is backward.
	  var detectionRange = document.createRange();
	  detectionRange.setStart(anchorNode, anchorOffset);
	  detectionRange.setEnd(focusNode, focusOffset);
	  var isBackward = detectionRange.collapsed;
	
	  return {
	    start: isBackward ? end : start,
	    end: isBackward ? start : end
	  };
	}
	
	/**
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setIEOffsets(node, offsets) {
	  var range = document.selection.createRange().duplicate();
	  var start, end;
	
	  if (typeof offsets.end === 'undefined') {
	    start = offsets.start;
	    end = start;
	  } else if (offsets.start > offsets.end) {
	    start = offsets.end;
	    end = offsets.start;
	  } else {
	    start = offsets.start;
	    end = offsets.end;
	  }
	
	  range.moveToElementText(node);
	  range.moveStart('character', start);
	  range.setEndPoint('EndToStart', range);
	  range.moveEnd('character', end - start);
	  range.select();
	}
	
	/**
	 * In modern non-IE browsers, we can support both forward and backward
	 * selections.
	 *
	 * Note: IE10+ supports the Selection object, but it does not support
	 * the `extend` method, which means that even in modern IE, it's not possible
	 * to programatically create a backward selection. Thus, for all IE
	 * versions, we use the old IE API to create our selections.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setModernOffsets(node, offsets) {
	  if (!window.getSelection) {
	    return;
	  }
	
	  var selection = window.getSelection();
	  var length = node[getTextContentAccessor()].length;
	  var start = Math.min(offsets.start, length);
	  var end = typeof offsets.end === 'undefined' ? start : Math.min(offsets.end, length);
	
	  // IE 11 uses modern selection, but doesn't support the extend method.
	  // Flip backward selections, so we can set with a single range.
	  if (!selection.extend && start > end) {
	    var temp = end;
	    end = start;
	    start = temp;
	  }
	
	  var startMarker = getNodeForCharacterOffset(node, start);
	  var endMarker = getNodeForCharacterOffset(node, end);
	
	  if (startMarker && endMarker) {
	    var range = document.createRange();
	    range.setStart(startMarker.node, startMarker.offset);
	    selection.removeAllRanges();
	
	    if (start > end) {
	      selection.addRange(range);
	      selection.extend(endMarker.node, endMarker.offset);
	    } else {
	      range.setEnd(endMarker.node, endMarker.offset);
	      selection.addRange(range);
	    }
	  }
	}
	
	var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);
	
	var ReactDOMSelection = {
	  /**
	   * @param {DOMElement} node
	   */
	  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,
	
	  /**
	   * @param {DOMElement|DOMTextNode} node
	   * @param {object} offsets
	   */
	  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
	};
	
	module.exports = ReactDOMSelection;

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMServer
	 */
	
	'use strict';
	
	var ReactDefaultInjection = __webpack_require__(74);
	var ReactServerRendering = __webpack_require__(159);
	var ReactVersion = __webpack_require__(42);
	
	ReactDefaultInjection.inject();
	
	var ReactDOMServer = {
	  renderToString: ReactServerRendering.renderToString,
	  renderToStaticMarkup: ReactServerRendering.renderToStaticMarkup,
	  version: ReactVersion
	};
	
	module.exports = ReactDOMServer;

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMTextarea
	 */
	
	'use strict';
	
	var LinkedValueUtils = __webpack_require__(37);
	var ReactDOMIDOperations = __webpack_require__(40);
	var ReactUpdates = __webpack_require__(8);
	
	var assign = __webpack_require__(3);
	var invariant = __webpack_require__(1);
	var warning = __webpack_require__(2);
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMTextarea.updateWrapper(this);
	  }
	}
	
	/**
	 * Implements a <textarea> native component that allows setting `value`, and
	 * `defaultValue`. This differs from the traditional DOM API because value is
	 * usually set as PCDATA children.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that affect the
	 * value will trigger updates to the element.
	 *
	 * If `value` is supplied (and not null/undefined), the rendered element will
	 * not trigger updates to the element. Instead, the `value` prop must change in
	 * order for the rendered element to be updated.
	 *
	 * The rendered element will be initialized with an empty value, the prop
	 * `defaultValue` if specified, or the children content (deprecated).
	 */
	var ReactDOMTextarea = {
	  getNativeProps: function (inst, props, context) {
	    !(props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : invariant(false) : undefined;
	
	    // Always set children to the same thing. In IE9, the selection range will
	    // get reset if `textContent` is mutated.
	    var nativeProps = assign({}, props, {
	      defaultValue: undefined,
	      value: undefined,
	      children: inst._wrapperState.initialValue,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return nativeProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
	    }
	
	    var defaultValue = props.defaultValue;
	    // TODO (yungsters): Remove support for children content in <textarea>.
	    var children = props.children;
	    if (children != null) {
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : undefined;
	      }
	      !(defaultValue == null) ?  false ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : invariant(false) : undefined;
	      if (Array.isArray(children)) {
	        !(children.length <= 1) ?  false ? invariant(false, '<textarea> can only have at most one child.') : invariant(false) : undefined;
	        children = children[0];
	      }
	
	      defaultValue = '' + children;
	    }
	    if (defaultValue == null) {
	      defaultValue = '';
	    }
	    var value = LinkedValueUtils.getValue(props);
	
	    inst._wrapperState = {
	      // We save the initial value so that `ReactDOMComponent` doesn't update
	      // `textContent` (unnecessary since we update value).
	      // The initial value can be a boolean or object so that's why it's
	      // forced to be a string.
	      initialValue: '' + (value != null ? value : defaultValue),
	      onChange: _handleChange.bind(inst)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      ReactDOMIDOperations.updatePropertyByID(inst._rootNodeID, 'value', '' + value);
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMTextarea;

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactEventEmitterMixin
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(21);
	
	function runEventQueueInBatch(events) {
	  EventPluginHub.enqueueEvents(events);
	  EventPluginHub.processEventQueue(false);
	}
	
	var ReactEventEmitterMixin = {
	
	  /**
	   * Streams a fired top-level event to `EventPluginHub` where plugins have the
	   * opportunity to create `ReactEvent`s to be dispatched.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {object} topLevelTarget The listening component root node.
	   * @param {string} topLevelTargetID ID of `topLevelTarget`.
	   * @param {object} nativeEvent Native environment event.
	   */
	  handleTopLevel: function (topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget) {
	    var events = EventPluginHub.extractEvents(topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget);
	    runEventQueueInBatch(events);
	  }
	};
	
	module.exports = ReactEventEmitterMixin;

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactEventListener
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var EventListener = __webpack_require__(54);
	var ExecutionEnvironment = __webpack_require__(4);
	var PooledClass = __webpack_require__(14);
	var ReactInstanceHandles = __webpack_require__(19);
	var ReactMount = __webpack_require__(5);
	var ReactUpdates = __webpack_require__(8);
	
	var assign = __webpack_require__(3);
	var getEventTarget = __webpack_require__(46);
	var getUnboundedScrollPosition = __webpack_require__(102);
	
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	/**
	 * Finds the parent React component of `node`.
	 *
	 * @param {*} node
	 * @return {?DOMEventTarget} Parent container, or `null` if the specified node
	 *                           is not nested.
	 */
	function findParent(node) {
	  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
	  // traversal, but caching is difficult to do correctly without using a
	  // mutation observer to listen for all DOM changes.
	  var nodeID = ReactMount.getID(node);
	  var rootID = ReactInstanceHandles.getReactRootIDFromNodeID(nodeID);
	  var container = ReactMount.findReactContainerForID(rootID);
	  var parent = ReactMount.getFirstReactDOM(container);
	  return parent;
	}
	
	// Used to store ancestor hierarchy in top level callback
	function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
	  this.topLevelType = topLevelType;
	  this.nativeEvent = nativeEvent;
	  this.ancestors = [];
	}
	assign(TopLevelCallbackBookKeeping.prototype, {
	  destructor: function () {
	    this.topLevelType = null;
	    this.nativeEvent = null;
	    this.ancestors.length = 0;
	  }
	});
	PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);
	
	function handleTopLevelImpl(bookKeeping) {
	  // TODO: Re-enable event.path handling
	  //
	  // if (bookKeeping.nativeEvent.path && bookKeeping.nativeEvent.path.length > 1) {
	  //   // New browsers have a path attribute on native events
	  //   handleTopLevelWithPath(bookKeeping);
	  // } else {
	  //   // Legacy browsers don't have a path attribute on native events
	  //   handleTopLevelWithoutPath(bookKeeping);
	  // }
	
	  void handleTopLevelWithPath; // temporarily unused
	  handleTopLevelWithoutPath(bookKeeping);
	}
	
	// Legacy browsers don't have a path attribute on native events
	function handleTopLevelWithoutPath(bookKeeping) {
	  var topLevelTarget = ReactMount.getFirstReactDOM(getEventTarget(bookKeeping.nativeEvent)) || window;
	
	  // Loop through the hierarchy, in case there's any nested components.
	  // It's important that we build the array of ancestors before calling any
	  // event handlers, because event handlers can modify the DOM, leading to
	  // inconsistencies with ReactMount's node cache. See #1105.
	  var ancestor = topLevelTarget;
	  while (ancestor) {
	    bookKeeping.ancestors.push(ancestor);
	    ancestor = findParent(ancestor);
	  }
	
	  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
	    topLevelTarget = bookKeeping.ancestors[i];
	    var topLevelTargetID = ReactMount.getID(topLevelTarget) || '';
	    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, topLevelTarget, topLevelTargetID, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
	  }
	}
	
	// New browsers have a path attribute on native events
	function handleTopLevelWithPath(bookKeeping) {
	  var path = bookKeeping.nativeEvent.path;
	  var currentNativeTarget = path[0];
	  var eventsFired = 0;
	  for (var i = 0; i < path.length; i++) {
	    var currentPathElement = path[i];
	    if (currentPathElement.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE) {
	      currentNativeTarget = path[i + 1];
	    }
	    // TODO: slow
	    var reactParent = ReactMount.getFirstReactDOM(currentPathElement);
	    if (reactParent === currentPathElement) {
	      var currentPathElementID = ReactMount.getID(currentPathElement);
	      var newRootID = ReactInstanceHandles.getReactRootIDFromNodeID(currentPathElementID);
	      bookKeeping.ancestors.push(currentPathElement);
	
	      var topLevelTargetID = ReactMount.getID(currentPathElement) || '';
	      eventsFired++;
	      ReactEventListener._handleTopLevel(bookKeeping.topLevelType, currentPathElement, topLevelTargetID, bookKeeping.nativeEvent, currentNativeTarget);
	
	      // Jump to the root of this React render tree
	      while (currentPathElementID !== newRootID) {
	        i++;
	        currentPathElement = path[i];
	        currentPathElementID = ReactMount.getID(currentPathElement);
	      }
	    }
	  }
	  if (eventsFired === 0) {
	    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, window, '', bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
	  }
	}
	
	function scrollValueMonitor(cb) {
	  var scrollPosition = getUnboundedScrollPosition(window);
	  cb(scrollPosition);
	}
	
	var ReactEventListener = {
	  _enabled: true,
	  _handleTopLevel: null,
	
	  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,
	
	  setHandleTopLevel: function (handleTopLevel) {
	    ReactEventListener._handleTopLevel = handleTopLevel;
	  },
	
	  setEnabled: function (enabled) {
	    ReactEventListener._enabled = !!enabled;
	  },
	
	  isEnabled: function () {
	    return ReactEventListener._enabled;
	  },
	
	  /**
	   * Traps top-level events by using event bubbling.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} handle Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
	    var element = handle;
	    if (!element) {
	      return null;
	    }
	    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  /**
	   * Traps a top-level event by using event capturing.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} handle Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
	    var element = handle;
	    if (!element) {
	      return null;
	    }
	    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  monitorScrollValue: function (refresh) {
	    var callback = scrollValueMonitor.bind(null, refresh);
	    EventListener.listen(window, 'scroll', callback);
	  },
	
	  dispatchEvent: function (topLevelType, nativeEvent) {
	    if (!ReactEventListener._enabled) {
	      return;
	    }
	
	    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
	    try {
	      // Event queue being processed in the same cycle allows
	      // `preventDefault`.
	      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
	    } finally {
	      TopLevelCallbackBookKeeping.release(bookKeeping);
	    }
	  }
	};
	
	module.exports = ReactEventListener;

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactInjection
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(18);
	var EventPluginHub = __webpack_require__(21);
	var ReactComponentEnvironment = __webpack_require__(39);
	var ReactClass = __webpack_require__(67);
	var ReactEmptyComponent = __webpack_require__(76);
	var ReactBrowserEventEmitter = __webpack_require__(26);
	var ReactNativeComponent = __webpack_require__(82);
	var ReactPerf = __webpack_require__(7);
	var ReactRootIndex = __webpack_require__(85);
	var ReactUpdates = __webpack_require__(8);
	
	var ReactInjection = {
	  Component: ReactComponentEnvironment.injection,
	  Class: ReactClass.injection,
	  DOMProperty: DOMProperty.injection,
	  EmptyComponent: ReactEmptyComponent.injection,
	  EventPluginHub: EventPluginHub.injection,
	  EventEmitter: ReactBrowserEventEmitter.injection,
	  NativeComponent: ReactNativeComponent.injection,
	  Perf: ReactPerf.injection,
	  RootIndex: ReactRootIndex.injection,
	  Updates: ReactUpdates.injection
	};
	
	module.exports = ReactInjection;

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactIsomorphic
	 */
	
	'use strict';
	
	var ReactChildren = __webpack_require__(66);
	var ReactComponent = __webpack_require__(68);
	var ReactClass = __webpack_require__(67);
	var ReactDOMFactories = __webpack_require__(144);
	var ReactElement = __webpack_require__(6);
	var ReactElementValidator = __webpack_require__(75);
	var ReactPropTypes = __webpack_require__(84);
	var ReactVersion = __webpack_require__(42);
	
	var assign = __webpack_require__(3);
	var onlyChild = __webpack_require__(179);
	
	var createElement = ReactElement.createElement;
	var createFactory = ReactElement.createFactory;
	var cloneElement = ReactElement.cloneElement;
	
	if (false) {
	  createElement = ReactElementValidator.createElement;
	  createFactory = ReactElementValidator.createFactory;
	  cloneElement = ReactElementValidator.cloneElement;
	}
	
	var React = {
	
	  // Modern
	
	  Children: {
	    map: ReactChildren.map,
	    forEach: ReactChildren.forEach,
	    count: ReactChildren.count,
	    toArray: ReactChildren.toArray,
	    only: onlyChild
	  },
	
	  Component: ReactComponent,
	
	  createElement: createElement,
	  cloneElement: cloneElement,
	  isValidElement: ReactElement.isValidElement,
	
	  // Classic
	
	  PropTypes: ReactPropTypes,
	  createClass: ReactClass.createClass,
	  createFactory: createFactory,
	  createMixin: function (mixin) {
	    // Currently a noop. Will be used to validate and trace mixins.
	    return mixin;
	  },
	
	  // This looks DOM specific but these are actually isomorphic helpers
	  // since they are just generating DOM strings.
	  DOM: ReactDOMFactories,
	
	  version: ReactVersion,
	
	  // Hook for JSX spread, don't use this for anything else.
	  __spread: assign
	};
	
	module.exports = React;

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactMultiChild
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var ReactComponentEnvironment = __webpack_require__(39);
	var ReactMultiChildUpdateTypes = __webpack_require__(81);
	
	var ReactCurrentOwner = __webpack_require__(12);
	var ReactReconciler = __webpack_require__(15);
	var ReactChildReconciler = __webpack_require__(140);
	
	var flattenChildren = __webpack_require__(176);
	
	/**
	 * Updating children of a component may trigger recursive updates. The depth is
	 * used to batch recursive updates to render markup more efficiently.
	 *
	 * @type {number}
	 * @private
	 */
	var updateDepth = 0;
	
	/**
	 * Queue of update configuration objects.
	 *
	 * Each object has a `type` property that is in `ReactMultiChildUpdateTypes`.
	 *
	 * @type {array<object>}
	 * @private
	 */
	var updateQueue = [];
	
	/**
	 * Queue of markup to be rendered.
	 *
	 * @type {array<string>}
	 * @private
	 */
	var markupQueue = [];
	
	/**
	 * Enqueues markup to be rendered and inserted at a supplied index.
	 *
	 * @param {string} parentID ID of the parent component.
	 * @param {string} markup Markup that renders into an element.
	 * @param {number} toIndex Destination index.
	 * @private
	 */
	function enqueueInsertMarkup(parentID, markup, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  updateQueue.push({
	    parentID: parentID,
	    parentNode: null,
	    type: ReactMultiChildUpdateTypes.INSERT_MARKUP,
	    markupIndex: markupQueue.push(markup) - 1,
	    content: null,
	    fromIndex: null,
	    toIndex: toIndex
	  });
	}
	
	/**
	 * Enqueues moving an existing element to another index.
	 *
	 * @param {string} parentID ID of the parent component.
	 * @param {number} fromIndex Source index of the existing element.
	 * @param {number} toIndex Destination index of the element.
	 * @private
	 */
	function enqueueMove(parentID, fromIndex, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  updateQueue.push({
	    parentID: parentID,
	    parentNode: null,
	    type: ReactMultiChildUpdateTypes.MOVE_EXISTING,
	    markupIndex: null,
	    content: null,
	    fromIndex: fromIndex,
	    toIndex: toIndex
	  });
	}
	
	/**
	 * Enqueues removing an element at an index.
	 *
	 * @param {string} parentID ID of the parent component.
	 * @param {number} fromIndex Index of the element to remove.
	 * @private
	 */
	function enqueueRemove(parentID, fromIndex) {
	  // NOTE: Null values reduce hidden classes.
	  updateQueue.push({
	    parentID: parentID,
	    parentNode: null,
	    type: ReactMultiChildUpdateTypes.REMOVE_NODE,
	    markupIndex: null,
	    content: null,
	    fromIndex: fromIndex,
	    toIndex: null
	  });
	}
	
	/**
	 * Enqueues setting the markup of a node.
	 *
	 * @param {string} parentID ID of the parent component.
	 * @param {string} markup Markup that renders into an element.
	 * @private
	 */
	function enqueueSetMarkup(parentID, markup) {
	  // NOTE: Null values reduce hidden classes.
	  updateQueue.push({
	    parentID: parentID,
	    parentNode: null,
	    type: ReactMultiChildUpdateTypes.SET_MARKUP,
	    markupIndex: null,
	    content: markup,
	    fromIndex: null,
	    toIndex: null
	  });
	}
	
	/**
	 * Enqueues setting the text content.
	 *
	 * @param {string} parentID ID of the parent component.
	 * @param {string} textContent Text content to set.
	 * @private
	 */
	function enqueueTextContent(parentID, textContent) {
	  // NOTE: Null values reduce hidden classes.
	  updateQueue.push({
	    parentID: parentID,
	    parentNode: null,
	    type: ReactMultiChildUpdateTypes.TEXT_CONTENT,
	    markupIndex: null,
	    content: textContent,
	    fromIndex: null,
	    toIndex: null
	  });
	}
	
	/**
	 * Processes any enqueued updates.
	 *
	 * @private
	 */
	function processQueue() {
	  if (updateQueue.length) {
	    ReactComponentEnvironment.processChildrenUpdates(updateQueue, markupQueue);
	    clearQueue();
	  }
	}
	
	/**
	 * Clears any enqueued updates.
	 *
	 * @private
	 */
	function clearQueue() {
	  updateQueue.length = 0;
	  markupQueue.length = 0;
	}
	
	/**
	 * ReactMultiChild are capable of reconciling multiple children.
	 *
	 * @class ReactMultiChild
	 * @internal
	 */
	var ReactMultiChild = {
	
	  /**
	   * Provides common functionality for components that must reconcile multiple
	   * children. This is used by `ReactDOMComponent` to mount, update, and
	   * unmount child components.
	   *
	   * @lends {ReactMultiChild.prototype}
	   */
	  Mixin: {
	
	    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
	      if (false) {
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	        }
	      }
	      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
	    },
	
	    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, transaction, context) {
	      var nextChildren;
	      if (false) {
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            nextChildren = flattenChildren(nextNestedChildrenElements);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	          return ReactChildReconciler.updateChildren(prevChildren, nextChildren, transaction, context);
	        }
	      }
	      nextChildren = flattenChildren(nextNestedChildrenElements);
	      return ReactChildReconciler.updateChildren(prevChildren, nextChildren, transaction, context);
	    },
	
	    /**
	     * Generates a "mount image" for each of the supplied children. In the case
	     * of `ReactDOMComponent`, a mount image is a string of markup.
	     *
	     * @param {?object} nestedChildren Nested child maps.
	     * @return {array} An array of mounted representations.
	     * @internal
	     */
	    mountChildren: function (nestedChildren, transaction, context) {
	      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
	      this._renderedChildren = children;
	      var mountImages = [];
	      var index = 0;
	      for (var name in children) {
	        if (children.hasOwnProperty(name)) {
	          var child = children[name];
	          // Inlined for performance, see `ReactInstanceHandles.createReactID`.
	          var rootID = this._rootNodeID + name;
	          var mountImage = ReactReconciler.mountComponent(child, rootID, transaction, context);
	          child._mountIndex = index++;
	          mountImages.push(mountImage);
	        }
	      }
	      return mountImages;
	    },
	
	    /**
	     * Replaces any rendered children with a text content string.
	     *
	     * @param {string} nextContent String of content.
	     * @internal
	     */
	    updateTextContent: function (nextContent) {
	      updateDepth++;
	      var errorThrown = true;
	      try {
	        var prevChildren = this._renderedChildren;
	        // Remove any rendered children.
	        ReactChildReconciler.unmountChildren(prevChildren);
	        // TODO: The setTextContent operation should be enough
	        for (var name in prevChildren) {
	          if (prevChildren.hasOwnProperty(name)) {
	            this._unmountChild(prevChildren[name]);
	          }
	        }
	        // Set new text content.
	        this.setTextContent(nextContent);
	        errorThrown = false;
	      } finally {
	        updateDepth--;
	        if (!updateDepth) {
	          if (errorThrown) {
	            clearQueue();
	          } else {
	            processQueue();
	          }
	        }
	      }
	    },
	
	    /**
	     * Replaces any rendered children with a markup string.
	     *
	     * @param {string} nextMarkup String of markup.
	     * @internal
	     */
	    updateMarkup: function (nextMarkup) {
	      updateDepth++;
	      var errorThrown = true;
	      try {
	        var prevChildren = this._renderedChildren;
	        // Remove any rendered children.
	        ReactChildReconciler.unmountChildren(prevChildren);
	        for (var name in prevChildren) {
	          if (prevChildren.hasOwnProperty(name)) {
	            this._unmountChildByName(prevChildren[name], name);
	          }
	        }
	        this.setMarkup(nextMarkup);
	        errorThrown = false;
	      } finally {
	        updateDepth--;
	        if (!updateDepth) {
	          if (errorThrown) {
	            clearQueue();
	          } else {
	            processQueue();
	          }
	        }
	      }
	    },
	
	    /**
	     * Updates the rendered children with new children.
	     *
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     */
	    updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      updateDepth++;
	      var errorThrown = true;
	      try {
	        this._updateChildren(nextNestedChildrenElements, transaction, context);
	        errorThrown = false;
	      } finally {
	        updateDepth--;
	        if (!updateDepth) {
	          if (errorThrown) {
	            clearQueue();
	          } else {
	            processQueue();
	          }
	        }
	      }
	    },
	
	    /**
	     * Improve performance by isolating this hot code path from the try/catch
	     * block in `updateChildren`.
	     *
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @final
	     * @protected
	     */
	    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      var prevChildren = this._renderedChildren;
	      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, transaction, context);
	      this._renderedChildren = nextChildren;
	      if (!nextChildren && !prevChildren) {
	        return;
	      }
	      var name;
	      // `nextIndex` will increment for each child in `nextChildren`, but
	      // `lastIndex` will be the last index visited in `prevChildren`.
	      var lastIndex = 0;
	      var nextIndex = 0;
	      for (name in nextChildren) {
	        if (!nextChildren.hasOwnProperty(name)) {
	          continue;
	        }
	        var prevChild = prevChildren && prevChildren[name];
	        var nextChild = nextChildren[name];
	        if (prevChild === nextChild) {
	          this.moveChild(prevChild, nextIndex, lastIndex);
	          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	          prevChild._mountIndex = nextIndex;
	        } else {
	          if (prevChild) {
	            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
	            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	            this._unmountChild(prevChild);
	          }
	          // The child must be instantiated before it's mounted.
	          this._mountChildByNameAtIndex(nextChild, name, nextIndex, transaction, context);
	        }
	        nextIndex++;
	      }
	      // Remove children that are no longer present.
	      for (name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
	          this._unmountChild(prevChildren[name]);
	        }
	      }
	    },
	
	    /**
	     * Unmounts all rendered children. This should be used to clean up children
	     * when this component is unmounted.
	     *
	     * @internal
	     */
	    unmountChildren: function () {
	      var renderedChildren = this._renderedChildren;
	      ReactChildReconciler.unmountChildren(renderedChildren);
	      this._renderedChildren = null;
	    },
	
	    /**
	     * Moves a child component to the supplied index.
	     *
	     * @param {ReactComponent} child Component to move.
	     * @param {number} toIndex Destination index of the element.
	     * @param {number} lastIndex Last index visited of the siblings of `child`.
	     * @protected
	     */
	    moveChild: function (child, toIndex, lastIndex) {
	      // If the index of `child` is less than `lastIndex`, then it needs to
	      // be moved. Otherwise, we do not need to move it because a child will be
	      // inserted or moved before `child`.
	      if (child._mountIndex < lastIndex) {
	        enqueueMove(this._rootNodeID, child._mountIndex, toIndex);
	      }
	    },
	
	    /**
	     * Creates a child component.
	     *
	     * @param {ReactComponent} child Component to create.
	     * @param {string} mountImage Markup to insert.
	     * @protected
	     */
	    createChild: function (child, mountImage) {
	      enqueueInsertMarkup(this._rootNodeID, mountImage, child._mountIndex);
	    },
	
	    /**
	     * Removes a child component.
	     *
	     * @param {ReactComponent} child Child to remove.
	     * @protected
	     */
	    removeChild: function (child) {
	      enqueueRemove(this._rootNodeID, child._mountIndex);
	    },
	
	    /**
	     * Sets this text content string.
	     *
	     * @param {string} textContent Text content to set.
	     * @protected
	     */
	    setTextContent: function (textContent) {
	      enqueueTextContent(this._rootNodeID, textContent);
	    },
	
	    /**
	     * Sets this markup string.
	     *
	     * @param {string} markup Markup to set.
	     * @protected
	     */
	    setMarkup: function (markup) {
	      enqueueSetMarkup(this._rootNodeID, markup);
	    },
	
	    /**
	     * Mounts a child with the supplied name.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to mount.
	     * @param {string} name Name of the child.
	     * @param {number} index Index at which to insert the child.
	     * @param {ReactReconcileTransaction} transaction
	     * @private
	     */
	    _mountChildByNameAtIndex: function (child, name, index, transaction, context) {
	      // Inlined for performance, see `ReactInstanceHandles.createReactID`.
	      var rootID = this._rootNodeID + name;
	      var mountImage = ReactReconciler.mountComponent(child, rootID, transaction, context);
	      child._mountIndex = index;
	      this.createChild(child, mountImage);
	    },
	
	    /**
	     * Unmounts a rendered child.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to unmount.
	     * @private
	     */
	    _unmountChild: function (child) {
	      this.removeChild(child);
	      child._mountIndex = null;
	    }
	
	  }
	
	};
	
	module.exports = ReactMultiChild;

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactOwner
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(1);
	
	/**
	 * ReactOwners are capable of storing references to owned components.
	 *
	 * All components are capable of //being// referenced by owner components, but
	 * only ReactOwner components are capable of //referencing// owned components.
	 * The named reference is known as a "ref".
	 *
	 * Refs are available when mounted and updated during reconciliation.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return (
	 *         <div onClick={this.handleClick}>
	 *           <CustomComponent ref="custom" />
	 *         </div>
	 *       );
	 *     },
	 *     handleClick: function() {
	 *       this.refs.custom.handleClick();
	 *     },
	 *     componentDidMount: function() {
	 *       this.refs.custom.initialize();
	 *     }
	 *   });
	 *
	 * Refs should rarely be used. When refs are used, they should only be done to
	 * control data that is not handled by React's data flow.
	 *
	 * @class ReactOwner
	 */
	var ReactOwner = {
	
	  /**
	   * @param {?object} object
	   * @return {boolean} True if `object` is a valid owner.
	   * @final
	   */
	  isValidOwner: function (object) {
	    return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
	  },
	
	  /**
	   * Adds a component by ref to an owner component.
	   *
	   * @param {ReactComponent} component Component to reference.
	   * @param {string} ref Name by which to refer to the component.
	   * @param {ReactOwner} owner Component on which to record the ref.
	   * @final
	   * @internal
	   */
	  addComponentAsRefTo: function (component, ref, owner) {
	    !ReactOwner.isValidOwner(owner) ?  false ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might ' + 'be adding a ref to a component that was not created inside a component\'s ' + '`render` method, or you have multiple copies of React loaded ' + '(details: https://fb.me/react-refs-must-have-owner).') : invariant(false) : undefined;
	    owner.attachRef(ref, component);
	  },
	
	  /**
	   * Removes a component by ref from an owner component.
	   *
	   * @param {ReactComponent} component Component to dereference.
	   * @param {string} ref Name of the ref to remove.
	   * @param {ReactOwner} owner Component on which the ref is recorded.
	   * @final
	   * @internal
	   */
	  removeComponentAsRefFrom: function (component, ref, owner) {
	    !ReactOwner.isValidOwner(owner) ?  false ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might ' + 'be removing a ref to a component that was not created inside a component\'s ' + '`render` method, or you have multiple copies of React loaded ' + '(details: https://fb.me/react-refs-must-have-owner).') : invariant(false) : undefined;
	    // Check that `component` is still the current ref because we do not want to
	    // detach the ref if another component stole it.
	    if (owner.getPublicInstance().refs[ref] === component.getPublicInstance()) {
	      owner.detachRef(ref);
	    }
	  }
	
	};
	
	module.exports = ReactOwner;

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactReconcileTransaction
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var CallbackQueue = __webpack_require__(35);
	var PooledClass = __webpack_require__(14);
	var ReactBrowserEventEmitter = __webpack_require__(26);
	var ReactDOMFeatureFlags = __webpack_require__(70);
	var ReactInputSelection = __webpack_require__(79);
	var Transaction = __webpack_require__(30);
	
	var assign = __webpack_require__(3);
	
	/**
	 * Ensures that, when possible, the selection range (currently selected text
	 * input) is not disturbed by performing the transaction.
	 */
	var SELECTION_RESTORATION = {
	  /**
	   * @return {Selection} Selection information.
	   */
	  initialize: ReactInputSelection.getSelectionInformation,
	  /**
	   * @param {Selection} sel Selection information returned from `initialize`.
	   */
	  close: ReactInputSelection.restoreSelection
	};
	
	/**
	 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
	 * high level DOM manipulations (like temporarily removing a text input from the
	 * DOM).
	 */
	var EVENT_SUPPRESSION = {
	  /**
	   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
	   * the reconciliation.
	   */
	  initialize: function () {
	    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
	    ReactBrowserEventEmitter.setEnabled(false);
	    return currentlyEnabled;
	  },
	
	  /**
	   * @param {boolean} previouslyEnabled Enabled status of
	   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
	   *   restores the previous value.
	   */
	  close: function (previouslyEnabled) {
	    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
	  }
	};
	
	/**
	 * Provides a queue for collecting `componentDidMount` and
	 * `componentDidUpdate` callbacks during the the transaction.
	 */
	var ON_DOM_READY_QUEUEING = {
	  /**
	   * Initializes the internal `onDOMReady` queue.
	   */
	  initialize: function () {
	    this.reactMountReady.reset();
	  },
	
	  /**
	   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
	   */
	  close: function () {
	    this.reactMountReady.notifyAll();
	  }
	};
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];
	
	/**
	 * Currently:
	 * - The order that these are listed in the transaction is critical:
	 * - Suppresses events.
	 * - Restores selection range.
	 *
	 * Future:
	 * - Restore document/overflow scroll positions that were unintentionally
	 *   modified via DOM insertions above the top viewport boundary.
	 * - Implement/integrate with customized constraint based layout system and keep
	 *   track of which dimensions must be remeasured.
	 *
	 * @class ReactReconcileTransaction
	 */
	function ReactReconcileTransaction(forceHTML) {
	  this.reinitializeTransaction();
	  // Only server-side rendering really needs this option (see
	  // `ReactServerRendering`), but server-side uses
	  // `ReactServerRenderingTransaction` instead. This option is here so that it's
	  // accessible and defaults to false when `ReactDOMComponent` and
	  // `ReactTextComponent` checks it in `mountComponent`.`
	  this.renderToStaticMarkup = false;
	  this.reactMountReady = CallbackQueue.getPooled(null);
	  this.useCreateElement = !forceHTML && ReactDOMFeatureFlags.useCreateElement;
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array<object>} List of operation wrap procedures.
	   *   TODO: convert to array<TransactionWrapper>
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return this.reactMountReady;
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {
	    CallbackQueue.release(this.reactMountReady);
	    this.reactMountReady = null;
	  }
	};
	
	assign(ReactReconcileTransaction.prototype, Transaction.Mixin, Mixin);
	
	PooledClass.addPoolingTo(ReactReconcileTransaction);
	
	module.exports = ReactReconcileTransaction;

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactRef
	 */
	
	'use strict';
	
	var ReactOwner = __webpack_require__(155);
	
	var ReactRef = {};
	
	function attachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(component.getPublicInstance());
	  } else {
	    // Legacy ref
	    ReactOwner.addComponentAsRefTo(component, ref, owner);
	  }
	}
	
	function detachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(null);
	  } else {
	    // Legacy ref
	    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
	  }
	}
	
	ReactRef.attachRefs = function (instance, element) {
	  if (element === null || element === false) {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    attachRef(ref, instance, element._owner);
	  }
	};
	
	ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
	  // If either the owner or a `ref` has changed, make sure the newest owner
	  // has stored a reference to `this`, and the previous owner (if different)
	  // has forgotten the reference to `this`. We use the element instead
	  // of the public this.props because the post processing cannot determine
	  // a ref. The ref conceptually lives on the element.
	
	  // TODO: Should this even be possible? The owner cannot change because
	  // it's forbidden by shouldUpdateReactComponent. The ref can change
	  // if you swap the keys of but not the refs. Reconsider where this check
	  // is made. It probably belongs where the key checking and
	  // instantiateReactComponent is done.
	
	  var prevEmpty = prevElement === null || prevElement === false;
	  var nextEmpty = nextElement === null || nextElement === false;
	
	  return(
	    // This has a few false positives w/r/t empty components.
	    prevEmpty || nextEmpty || nextElement._owner !== prevElement._owner || nextElement.ref !== prevElement.ref
	  );
	};
	
	ReactRef.detachRefs = function (instance, element) {
	  if (element === null || element === false) {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    detachRef(ref, instance, element._owner);
	  }
	};
	
	module.exports = ReactRef;

/***/ }),
/* 158 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactServerBatchingStrategy
	 * @typechecks
	 */
	
	'use strict';
	
	var ReactServerBatchingStrategy = {
	  isBatchingUpdates: false,
	  batchedUpdates: function (callback) {
	    // Don't do anything here. During the server rendering we don't want to
	    // schedule any updates. We will simply ignore them.
	  }
	};
	
	module.exports = ReactServerBatchingStrategy;

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks static-only
	 * @providesModule ReactServerRendering
	 */
	'use strict';
	
	var ReactDefaultBatchingStrategy = __webpack_require__(73);
	var ReactElement = __webpack_require__(6);
	var ReactInstanceHandles = __webpack_require__(19);
	var ReactMarkupChecksum = __webpack_require__(80);
	var ReactServerBatchingStrategy = __webpack_require__(158);
	var ReactServerRenderingTransaction = __webpack_require__(160);
	var ReactUpdates = __webpack_require__(8);
	
	var emptyObject = __webpack_require__(20);
	var instantiateReactComponent = __webpack_require__(48);
	var invariant = __webpack_require__(1);
	
	/**
	 * @param {ReactElement} element
	 * @return {string} the HTML markup
	 */
	function renderToString(element) {
	  !ReactElement.isValidElement(element) ?  false ? invariant(false, 'renderToString(): You must pass a valid ReactElement.') : invariant(false) : undefined;
	
	  var transaction;
	  try {
	    ReactUpdates.injection.injectBatchingStrategy(ReactServerBatchingStrategy);
	
	    var id = ReactInstanceHandles.createReactRootID();
	    transaction = ReactServerRenderingTransaction.getPooled(false);
	
	    return transaction.perform(function () {
	      var componentInstance = instantiateReactComponent(element, null);
	      var markup = componentInstance.mountComponent(id, transaction, emptyObject);
	      return ReactMarkupChecksum.addChecksumToMarkup(markup);
	    }, null);
	  } finally {
	    ReactServerRenderingTransaction.release(transaction);
	    // Revert to the DOM batching strategy since these two renderers
	    // currently share these stateful modules.
	    ReactUpdates.injection.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	  }
	}
	
	/**
	 * @param {ReactElement} element
	 * @return {string} the HTML markup, without the extra React ID and checksum
	 * (for generating static pages)
	 */
	function renderToStaticMarkup(element) {
	  !ReactElement.isValidElement(element) ?  false ? invariant(false, 'renderToStaticMarkup(): You must pass a valid ReactElement.') : invariant(false) : undefined;
	
	  var transaction;
	  try {
	    ReactUpdates.injection.injectBatchingStrategy(ReactServerBatchingStrategy);
	
	    var id = ReactInstanceHandles.createReactRootID();
	    transaction = ReactServerRenderingTransaction.getPooled(true);
	
	    return transaction.perform(function () {
	      var componentInstance = instantiateReactComponent(element, null);
	      return componentInstance.mountComponent(id, transaction, emptyObject);
	    }, null);
	  } finally {
	    ReactServerRenderingTransaction.release(transaction);
	    // Revert to the DOM batching strategy since these two renderers
	    // currently share these stateful modules.
	    ReactUpdates.injection.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	  }
	}
	
	module.exports = {
	  renderToString: renderToString,
	  renderToStaticMarkup: renderToStaticMarkup
	};

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactServerRenderingTransaction
	 * @typechecks
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(14);
	var CallbackQueue = __webpack_require__(35);
	var Transaction = __webpack_require__(30);
	
	var assign = __webpack_require__(3);
	var emptyFunction = __webpack_require__(9);
	
	/**
	 * Provides a `CallbackQueue` queue for collecting `onDOMReady` callbacks
	 * during the performing of the transaction.
	 */
	var ON_DOM_READY_QUEUEING = {
	  /**
	   * Initializes the internal `onDOMReady` queue.
	   */
	  initialize: function () {
	    this.reactMountReady.reset();
	  },
	
	  close: emptyFunction
	};
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [ON_DOM_READY_QUEUEING];
	
	/**
	 * @class ReactServerRenderingTransaction
	 * @param {boolean} renderToStaticMarkup
	 */
	function ReactServerRenderingTransaction(renderToStaticMarkup) {
	  this.reinitializeTransaction();
	  this.renderToStaticMarkup = renderToStaticMarkup;
	  this.reactMountReady = CallbackQueue.getPooled(null);
	  this.useCreateElement = false;
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array} Empty list of operation wrap procedures.
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return this.reactMountReady;
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {
	    CallbackQueue.release(this.reactMountReady);
	    this.reactMountReady = null;
	  }
	};
	
	assign(ReactServerRenderingTransaction.prototype, Transaction.Mixin, Mixin);
	
	PooledClass.addPoolingTo(ReactServerRenderingTransaction);
	
	module.exports = ReactServerRenderingTransaction;

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SVGDOMPropertyConfig
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(18);
	
	var MUST_USE_ATTRIBUTE = DOMProperty.injection.MUST_USE_ATTRIBUTE;
	
	var NS = {
	  xlink: 'http://www.w3.org/1999/xlink',
	  xml: 'http://www.w3.org/XML/1998/namespace'
	};
	
	var SVGDOMPropertyConfig = {
	  Properties: {
	    clipPath: MUST_USE_ATTRIBUTE,
	    cx: MUST_USE_ATTRIBUTE,
	    cy: MUST_USE_ATTRIBUTE,
	    d: MUST_USE_ATTRIBUTE,
	    dx: MUST_USE_ATTRIBUTE,
	    dy: MUST_USE_ATTRIBUTE,
	    fill: MUST_USE_ATTRIBUTE,
	    fillOpacity: MUST_USE_ATTRIBUTE,
	    fontFamily: MUST_USE_ATTRIBUTE,
	    fontSize: MUST_USE_ATTRIBUTE,
	    fx: MUST_USE_ATTRIBUTE,
	    fy: MUST_USE_ATTRIBUTE,
	    gradientTransform: MUST_USE_ATTRIBUTE,
	    gradientUnits: MUST_USE_ATTRIBUTE,
	    markerEnd: MUST_USE_ATTRIBUTE,
	    markerMid: MUST_USE_ATTRIBUTE,
	    markerStart: MUST_USE_ATTRIBUTE,
	    offset: MUST_USE_ATTRIBUTE,
	    opacity: MUST_USE_ATTRIBUTE,
	    patternContentUnits: MUST_USE_ATTRIBUTE,
	    patternUnits: MUST_USE_ATTRIBUTE,
	    points: MUST_USE_ATTRIBUTE,
	    preserveAspectRatio: MUST_USE_ATTRIBUTE,
	    r: MUST_USE_ATTRIBUTE,
	    rx: MUST_USE_ATTRIBUTE,
	    ry: MUST_USE_ATTRIBUTE,
	    spreadMethod: MUST_USE_ATTRIBUTE,
	    stopColor: MUST_USE_ATTRIBUTE,
	    stopOpacity: MUST_USE_ATTRIBUTE,
	    stroke: MUST_USE_ATTRIBUTE,
	    strokeDasharray: MUST_USE_ATTRIBUTE,
	    strokeLinecap: MUST_USE_ATTRIBUTE,
	    strokeOpacity: MUST_USE_ATTRIBUTE,
	    strokeWidth: MUST_USE_ATTRIBUTE,
	    textAnchor: MUST_USE_ATTRIBUTE,
	    transform: MUST_USE_ATTRIBUTE,
	    version: MUST_USE_ATTRIBUTE,
	    viewBox: MUST_USE_ATTRIBUTE,
	    x1: MUST_USE_ATTRIBUTE,
	    x2: MUST_USE_ATTRIBUTE,
	    x: MUST_USE_ATTRIBUTE,
	    xlinkActuate: MUST_USE_ATTRIBUTE,
	    xlinkArcrole: MUST_USE_ATTRIBUTE,
	    xlinkHref: MUST_USE_ATTRIBUTE,
	    xlinkRole: MUST_USE_ATTRIBUTE,
	    xlinkShow: MUST_USE_ATTRIBUTE,
	    xlinkTitle: MUST_USE_ATTRIBUTE,
	    xlinkType: MUST_USE_ATTRIBUTE,
	    xmlBase: MUST_USE_ATTRIBUTE,
	    xmlLang: MUST_USE_ATTRIBUTE,
	    xmlSpace: MUST_USE_ATTRIBUTE,
	    y1: MUST_USE_ATTRIBUTE,
	    y2: MUST_USE_ATTRIBUTE,
	    y: MUST_USE_ATTRIBUTE
	  },
	  DOMAttributeNamespaces: {
	    xlinkActuate: NS.xlink,
	    xlinkArcrole: NS.xlink,
	    xlinkHref: NS.xlink,
	    xlinkRole: NS.xlink,
	    xlinkShow: NS.xlink,
	    xlinkTitle: NS.xlink,
	    xlinkType: NS.xlink,
	    xmlBase: NS.xml,
	    xmlLang: NS.xml,
	    xmlSpace: NS.xml
	  },
	  DOMAttributeNames: {
	    clipPath: 'clip-path',
	    fillOpacity: 'fill-opacity',
	    fontFamily: 'font-family',
	    fontSize: 'font-size',
	    gradientTransform: 'gradientTransform',
	    gradientUnits: 'gradientUnits',
	    markerEnd: 'marker-end',
	    markerMid: 'marker-mid',
	    markerStart: 'marker-start',
	    patternContentUnits: 'patternContentUnits',
	    patternUnits: 'patternUnits',
	    preserveAspectRatio: 'preserveAspectRatio',
	    spreadMethod: 'spreadMethod',
	    stopColor: 'stop-color',
	    stopOpacity: 'stop-opacity',
	    strokeDasharray: 'stroke-dasharray',
	    strokeLinecap: 'stroke-linecap',
	    strokeOpacity: 'stroke-opacity',
	    strokeWidth: 'stroke-width',
	    textAnchor: 'text-anchor',
	    viewBox: 'viewBox',
	    xlinkActuate: 'xlink:actuate',
	    xlinkArcrole: 'xlink:arcrole',
	    xlinkHref: 'xlink:href',
	    xlinkRole: 'xlink:role',
	    xlinkShow: 'xlink:show',
	    xlinkTitle: 'xlink:title',
	    xlinkType: 'xlink:type',
	    xmlBase: 'xml:base',
	    xmlLang: 'xml:lang',
	    xmlSpace: 'xml:space'
	  }
	};
	
	module.exports = SVGDOMPropertyConfig;

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SelectEventPlugin
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(11);
	var EventPropagators = __webpack_require__(22);
	var ExecutionEnvironment = __webpack_require__(4);
	var ReactInputSelection = __webpack_require__(79);
	var SyntheticEvent = __webpack_require__(16);
	
	var getActiveElement = __webpack_require__(57);
	var isTextInputElement = __webpack_require__(90);
	var keyOf = __webpack_require__(13);
	var shallowEqual = __webpack_require__(59);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;
	
	var eventTypes = {
	  select: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onSelect: null }),
	      captured: keyOf({ onSelectCapture: null })
	    },
	    dependencies: [topLevelTypes.topBlur, topLevelTypes.topContextMenu, topLevelTypes.topFocus, topLevelTypes.topKeyDown, topLevelTypes.topMouseDown, topLevelTypes.topMouseUp, topLevelTypes.topSelectionChange]
	  }
	};
	
	var activeElement = null;
	var activeElementID = null;
	var lastSelection = null;
	var mouseDown = false;
	
	// Track whether a listener exists for this plugin. If none exist, we do
	// not extract events.
	var hasListener = false;
	var ON_SELECT_KEY = keyOf({ onSelect: null });
	
	/**
	 * Get an object which is a unique representation of the current selection.
	 *
	 * The return value will not be consistent across nodes or browsers, but
	 * two identical selections on the same node will return identical objects.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getSelection(node) {
	  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
	    return {
	      start: node.selectionStart,
	      end: node.selectionEnd
	    };
	  } else if (window.getSelection) {
	    var selection = window.getSelection();
	    return {
	      anchorNode: selection.anchorNode,
	      anchorOffset: selection.anchorOffset,
	      focusNode: selection.focusNode,
	      focusOffset: selection.focusOffset
	    };
	  } else if (document.selection) {
	    var range = document.selection.createRange();
	    return {
	      parentElement: range.parentElement(),
	      text: range.text,
	      top: range.boundingTop,
	      left: range.boundingLeft
	    };
	  }
	}
	
	/**
	 * Poll selection to see whether it's changed.
	 *
	 * @param {object} nativeEvent
	 * @return {?SyntheticEvent}
	 */
	function constructSelectEvent(nativeEvent, nativeEventTarget) {
	  // Ensure we have the right element, and that the user is not dragging a
	  // selection (this matches native `select` event behavior). In HTML5, select
	  // fires only on input and textarea thus if there's no focused element we
	  // won't dispatch.
	  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
	    return null;
	  }
	
	  // Only fire when selection has actually changed.
	  var currentSelection = getSelection(activeElement);
	  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
	    lastSelection = currentSelection;
	
	    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementID, nativeEvent, nativeEventTarget);
	
	    syntheticEvent.type = 'select';
	    syntheticEvent.target = activeElement;
	
	    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);
	
	    return syntheticEvent;
	  }
	
	  return null;
	}
	
	/**
	 * This plugin creates an `onSelect` event that normalizes select events
	 * across form elements.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - contentEditable
	 *
	 * This differs from native browser implementations in the following ways:
	 * - Fires on contentEditable fields as well as inputs.
	 * - Fires for collapsed selection.
	 * - Fires after user input.
	 */
	var SelectEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  /**
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {DOMEventTarget} topLevelTarget The listening component root node.
	   * @param {string} topLevelTargetID ID of `topLevelTarget`.
	   * @param {object} nativeEvent Native browser event.
	   * @return {*} An accumulation of synthetic events.
	   * @see {EventPluginHub.extractEvents}
	   */
	  extractEvents: function (topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget) {
	    if (!hasListener) {
	      return null;
	    }
	
	    switch (topLevelType) {
	      // Track the input node that has focus.
	      case topLevelTypes.topFocus:
	        if (isTextInputElement(topLevelTarget) || topLevelTarget.contentEditable === 'true') {
	          activeElement = topLevelTarget;
	          activeElementID = topLevelTargetID;
	          lastSelection = null;
	        }
	        break;
	      case topLevelTypes.topBlur:
	        activeElement = null;
	        activeElementID = null;
	        lastSelection = null;
	        break;
	
	      // Don't fire the event while the user is dragging. This matches the
	      // semantics of the native select event.
	      case topLevelTypes.topMouseDown:
	        mouseDown = true;
	        break;
	      case topLevelTypes.topContextMenu:
	      case topLevelTypes.topMouseUp:
	        mouseDown = false;
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	
	      // Chrome and IE fire non-standard event when selection is changed (and
	      // sometimes when it hasn't). IE's event fires out of order with respect
	      // to key and input events on deletion, so we discard it.
	      //
	      // Firefox doesn't support selectionchange, so check selection status
	      // after each key entry. The selection changes after keydown and before
	      // keyup, but we check on keydown as well in the case of holding down a
	      // key, when multiple keydown events are fired but only one keyup is.
	      // This is also our approach for IE handling, for the reason above.
	      case topLevelTypes.topSelectionChange:
	        if (skipSelectionChangeEvent) {
	          break;
	        }
	      // falls through
	      case topLevelTypes.topKeyDown:
	      case topLevelTypes.topKeyUp:
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	    }
	
	    return null;
	  },
	
	  didPutListener: function (id, registrationName, listener) {
	    if (registrationName === ON_SELECT_KEY) {
	      hasListener = true;
	    }
	  }
	};
	
	module.exports = SelectEventPlugin;

/***/ }),
/* 163 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ServerReactRootIndex
	 * @typechecks
	 */
	
	'use strict';
	
	/**
	 * Size of the reactRoot ID space. We generate random numbers for React root
	 * IDs and if there's a collision the events and DOM update system will
	 * get confused. In the future we need a way to generate GUIDs but for
	 * now this will work on a smaller scale.
	 */
	var GLOBAL_MOUNT_POINT_MAX = Math.pow(2, 53);
	
	var ServerReactRootIndex = {
	  createReactRootIndex: function () {
	    return Math.ceil(Math.random() * GLOBAL_MOUNT_POINT_MAX);
	  }
	};
	
	module.exports = ServerReactRootIndex;

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SimpleEventPlugin
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(11);
	var EventListener = __webpack_require__(54);
	var EventPropagators = __webpack_require__(22);
	var ReactMount = __webpack_require__(5);
	var SyntheticClipboardEvent = __webpack_require__(165);
	var SyntheticEvent = __webpack_require__(16);
	var SyntheticFocusEvent = __webpack_require__(168);
	var SyntheticKeyboardEvent = __webpack_require__(170);
	var SyntheticMouseEvent = __webpack_require__(29);
	var SyntheticDragEvent = __webpack_require__(167);
	var SyntheticTouchEvent = __webpack_require__(171);
	var SyntheticUIEvent = __webpack_require__(24);
	var SyntheticWheelEvent = __webpack_require__(172);
	
	var emptyFunction = __webpack_require__(9);
	var getEventCharCode = __webpack_require__(44);
	var invariant = __webpack_require__(1);
	var keyOf = __webpack_require__(13);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	var eventTypes = {
	  abort: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onAbort: true }),
	      captured: keyOf({ onAbortCapture: true })
	    }
	  },
	  blur: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onBlur: true }),
	      captured: keyOf({ onBlurCapture: true })
	    }
	  },
	  canPlay: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCanPlay: true }),
	      captured: keyOf({ onCanPlayCapture: true })
	    }
	  },
	  canPlayThrough: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCanPlayThrough: true }),
	      captured: keyOf({ onCanPlayThroughCapture: true })
	    }
	  },
	  click: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onClick: true }),
	      captured: keyOf({ onClickCapture: true })
	    }
	  },
	  contextMenu: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onContextMenu: true }),
	      captured: keyOf({ onContextMenuCapture: true })
	    }
	  },
	  copy: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCopy: true }),
	      captured: keyOf({ onCopyCapture: true })
	    }
	  },
	  cut: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCut: true }),
	      captured: keyOf({ onCutCapture: true })
	    }
	  },
	  doubleClick: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDoubleClick: true }),
	      captured: keyOf({ onDoubleClickCapture: true })
	    }
	  },
	  drag: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDrag: true }),
	      captured: keyOf({ onDragCapture: true })
	    }
	  },
	  dragEnd: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragEnd: true }),
	      captured: keyOf({ onDragEndCapture: true })
	    }
	  },
	  dragEnter: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragEnter: true }),
	      captured: keyOf({ onDragEnterCapture: true })
	    }
	  },
	  dragExit: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragExit: true }),
	      captured: keyOf({ onDragExitCapture: true })
	    }
	  },
	  dragLeave: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragLeave: true }),
	      captured: keyOf({ onDragLeaveCapture: true })
	    }
	  },
	  dragOver: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragOver: true }),
	      captured: keyOf({ onDragOverCapture: true })
	    }
	  },
	  dragStart: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragStart: true }),
	      captured: keyOf({ onDragStartCapture: true })
	    }
	  },
	  drop: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDrop: true }),
	      captured: keyOf({ onDropCapture: true })
	    }
	  },
	  durationChange: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDurationChange: true }),
	      captured: keyOf({ onDurationChangeCapture: true })
	    }
	  },
	  emptied: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onEmptied: true }),
	      captured: keyOf({ onEmptiedCapture: true })
	    }
	  },
	  encrypted: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onEncrypted: true }),
	      captured: keyOf({ onEncryptedCapture: true })
	    }
	  },
	  ended: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onEnded: true }),
	      captured: keyOf({ onEndedCapture: true })
	    }
	  },
	  error: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onError: true }),
	      captured: keyOf({ onErrorCapture: true })
	    }
	  },
	  focus: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onFocus: true }),
	      captured: keyOf({ onFocusCapture: true })
	    }
	  },
	  input: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onInput: true }),
	      captured: keyOf({ onInputCapture: true })
	    }
	  },
	  keyDown: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onKeyDown: true }),
	      captured: keyOf({ onKeyDownCapture: true })
	    }
	  },
	  keyPress: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onKeyPress: true }),
	      captured: keyOf({ onKeyPressCapture: true })
	    }
	  },
	  keyUp: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onKeyUp: true }),
	      captured: keyOf({ onKeyUpCapture: true })
	    }
	  },
	  load: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onLoad: true }),
	      captured: keyOf({ onLoadCapture: true })
	    }
	  },
	  loadedData: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onLoadedData: true }),
	      captured: keyOf({ onLoadedDataCapture: true })
	    }
	  },
	  loadedMetadata: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onLoadedMetadata: true }),
	      captured: keyOf({ onLoadedMetadataCapture: true })
	    }
	  },
	  loadStart: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onLoadStart: true }),
	      captured: keyOf({ onLoadStartCapture: true })
	    }
	  },
	  // Note: We do not allow listening to mouseOver events. Instead, use the
	  // onMouseEnter/onMouseLeave created by `EnterLeaveEventPlugin`.
	  mouseDown: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onMouseDown: true }),
	      captured: keyOf({ onMouseDownCapture: true })
	    }
	  },
	  mouseMove: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onMouseMove: true }),
	      captured: keyOf({ onMouseMoveCapture: true })
	    }
	  },
	  mouseOut: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onMouseOut: true }),
	      captured: keyOf({ onMouseOutCapture: true })
	    }
	  },
	  mouseOver: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onMouseOver: true }),
	      captured: keyOf({ onMouseOverCapture: true })
	    }
	  },
	  mouseUp: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onMouseUp: true }),
	      captured: keyOf({ onMouseUpCapture: true })
	    }
	  },
	  paste: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onPaste: true }),
	      captured: keyOf({ onPasteCapture: true })
	    }
	  },
	  pause: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onPause: true }),
	      captured: keyOf({ onPauseCapture: true })
	    }
	  },
	  play: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onPlay: true }),
	      captured: keyOf({ onPlayCapture: true })
	    }
	  },
	  playing: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onPlaying: true }),
	      captured: keyOf({ onPlayingCapture: true })
	    }
	  },
	  progress: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onProgress: true }),
	      captured: keyOf({ onProgressCapture: true })
	    }
	  },
	  rateChange: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onRateChange: true }),
	      captured: keyOf({ onRateChangeCapture: true })
	    }
	  },
	  reset: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onReset: true }),
	      captured: keyOf({ onResetCapture: true })
	    }
	  },
	  scroll: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onScroll: true }),
	      captured: keyOf({ onScrollCapture: true })
	    }
	  },
	  seeked: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onSeeked: true }),
	      captured: keyOf({ onSeekedCapture: true })
	    }
	  },
	  seeking: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onSeeking: true }),
	      captured: keyOf({ onSeekingCapture: true })
	    }
	  },
	  stalled: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onStalled: true }),
	      captured: keyOf({ onStalledCapture: true })
	    }
	  },
	  submit: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onSubmit: true }),
	      captured: keyOf({ onSubmitCapture: true })
	    }
	  },
	  suspend: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onSuspend: true }),
	      captured: keyOf({ onSuspendCapture: true })
	    }
	  },
	  timeUpdate: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onTimeUpdate: true }),
	      captured: keyOf({ onTimeUpdateCapture: true })
	    }
	  },
	  touchCancel: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onTouchCancel: true }),
	      captured: keyOf({ onTouchCancelCapture: true })
	    }
	  },
	  touchEnd: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onTouchEnd: true }),
	      captured: keyOf({ onTouchEndCapture: true })
	    }
	  },
	  touchMove: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onTouchMove: true }),
	      captured: keyOf({ onTouchMoveCapture: true })
	    }
	  },
	  touchStart: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onTouchStart: true }),
	      captured: keyOf({ onTouchStartCapture: true })
	    }
	  },
	  volumeChange: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onVolumeChange: true }),
	      captured: keyOf({ onVolumeChangeCapture: true })
	    }
	  },
	  waiting: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onWaiting: true }),
	      captured: keyOf({ onWaitingCapture: true })
	    }
	  },
	  wheel: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onWheel: true }),
	      captured: keyOf({ onWheelCapture: true })
	    }
	  }
	};
	
	var topLevelEventsToDispatchConfig = {
	  topAbort: eventTypes.abort,
	  topBlur: eventTypes.blur,
	  topCanPlay: eventTypes.canPlay,
	  topCanPlayThrough: eventTypes.canPlayThrough,
	  topClick: eventTypes.click,
	  topContextMenu: eventTypes.contextMenu,
	  topCopy: eventTypes.copy,
	  topCut: eventTypes.cut,
	  topDoubleClick: eventTypes.doubleClick,
	  topDrag: eventTypes.drag,
	  topDragEnd: eventTypes.dragEnd,
	  topDragEnter: eventTypes.dragEnter,
	  topDragExit: eventTypes.dragExit,
	  topDragLeave: eventTypes.dragLeave,
	  topDragOver: eventTypes.dragOver,
	  topDragStart: eventTypes.dragStart,
	  topDrop: eventTypes.drop,
	  topDurationChange: eventTypes.durationChange,
	  topEmptied: eventTypes.emptied,
	  topEncrypted: eventTypes.encrypted,
	  topEnded: eventTypes.ended,
	  topError: eventTypes.error,
	  topFocus: eventTypes.focus,
	  topInput: eventTypes.input,
	  topKeyDown: eventTypes.keyDown,
	  topKeyPress: eventTypes.keyPress,
	  topKeyUp: eventTypes.keyUp,
	  topLoad: eventTypes.load,
	  topLoadedData: eventTypes.loadedData,
	  topLoadedMetadata: eventTypes.loadedMetadata,
	  topLoadStart: eventTypes.loadStart,
	  topMouseDown: eventTypes.mouseDown,
	  topMouseMove: eventTypes.mouseMove,
	  topMouseOut: eventTypes.mouseOut,
	  topMouseOver: eventTypes.mouseOver,
	  topMouseUp: eventTypes.mouseUp,
	  topPaste: eventTypes.paste,
	  topPause: eventTypes.pause,
	  topPlay: eventTypes.play,
	  topPlaying: eventTypes.playing,
	  topProgress: eventTypes.progress,
	  topRateChange: eventTypes.rateChange,
	  topReset: eventTypes.reset,
	  topScroll: eventTypes.scroll,
	  topSeeked: eventTypes.seeked,
	  topSeeking: eventTypes.seeking,
	  topStalled: eventTypes.stalled,
	  topSubmit: eventTypes.submit,
	  topSuspend: eventTypes.suspend,
	  topTimeUpdate: eventTypes.timeUpdate,
	  topTouchCancel: eventTypes.touchCancel,
	  topTouchEnd: eventTypes.touchEnd,
	  topTouchMove: eventTypes.touchMove,
	  topTouchStart: eventTypes.touchStart,
	  topVolumeChange: eventTypes.volumeChange,
	  topWaiting: eventTypes.waiting,
	  topWheel: eventTypes.wheel
	};
	
	for (var type in topLevelEventsToDispatchConfig) {
	  topLevelEventsToDispatchConfig[type].dependencies = [type];
	}
	
	var ON_CLICK_KEY = keyOf({ onClick: null });
	var onClickListeners = {};
	
	var SimpleEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  /**
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {DOMEventTarget} topLevelTarget The listening component root node.
	   * @param {string} topLevelTargetID ID of `topLevelTarget`.
	   * @param {object} nativeEvent Native browser event.
	   * @return {*} An accumulation of synthetic events.
	   * @see {EventPluginHub.extractEvents}
	   */
	  extractEvents: function (topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget) {
	    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
	    if (!dispatchConfig) {
	      return null;
	    }
	    var EventConstructor;
	    switch (topLevelType) {
	      case topLevelTypes.topAbort:
	      case topLevelTypes.topCanPlay:
	      case topLevelTypes.topCanPlayThrough:
	      case topLevelTypes.topDurationChange:
	      case topLevelTypes.topEmptied:
	      case topLevelTypes.topEncrypted:
	      case topLevelTypes.topEnded:
	      case topLevelTypes.topError:
	      case topLevelTypes.topInput:
	      case topLevelTypes.topLoad:
	      case topLevelTypes.topLoadedData:
	      case topLevelTypes.topLoadedMetadata:
	      case topLevelTypes.topLoadStart:
	      case topLevelTypes.topPause:
	      case topLevelTypes.topPlay:
	      case topLevelTypes.topPlaying:
	      case topLevelTypes.topProgress:
	      case topLevelTypes.topRateChange:
	      case topLevelTypes.topReset:
	      case topLevelTypes.topSeeked:
	      case topLevelTypes.topSeeking:
	      case topLevelTypes.topStalled:
	      case topLevelTypes.topSubmit:
	      case topLevelTypes.topSuspend:
	      case topLevelTypes.topTimeUpdate:
	      case topLevelTypes.topVolumeChange:
	      case topLevelTypes.topWaiting:
	        // HTML Events
	        // @see http://www.w3.org/TR/html5/index.html#events-0
	        EventConstructor = SyntheticEvent;
	        break;
	      case topLevelTypes.topKeyPress:
	        // FireFox creates a keypress event for function keys too. This removes
	        // the unwanted keypress events. Enter is however both printable and
	        // non-printable. One would expect Tab to be as well (but it isn't).
	        if (getEventCharCode(nativeEvent) === 0) {
	          return null;
	        }
	      /* falls through */
	      case topLevelTypes.topKeyDown:
	      case topLevelTypes.topKeyUp:
	        EventConstructor = SyntheticKeyboardEvent;
	        break;
	      case topLevelTypes.topBlur:
	      case topLevelTypes.topFocus:
	        EventConstructor = SyntheticFocusEvent;
	        break;
	      case topLevelTypes.topClick:
	        // Firefox creates a click event on right mouse clicks. This removes the
	        // unwanted click events.
	        if (nativeEvent.button === 2) {
	          return null;
	        }
	      /* falls through */
	      case topLevelTypes.topContextMenu:
	      case topLevelTypes.topDoubleClick:
	      case topLevelTypes.topMouseDown:
	      case topLevelTypes.topMouseMove:
	      case topLevelTypes.topMouseOut:
	      case topLevelTypes.topMouseOver:
	      case topLevelTypes.topMouseUp:
	        EventConstructor = SyntheticMouseEvent;
	        break;
	      case topLevelTypes.topDrag:
	      case topLevelTypes.topDragEnd:
	      case topLevelTypes.topDragEnter:
	      case topLevelTypes.topDragExit:
	      case topLevelTypes.topDragLeave:
	      case topLevelTypes.topDragOver:
	      case topLevelTypes.topDragStart:
	      case topLevelTypes.topDrop:
	        EventConstructor = SyntheticDragEvent;
	        break;
	      case topLevelTypes.topTouchCancel:
	      case topLevelTypes.topTouchEnd:
	      case topLevelTypes.topTouchMove:
	      case topLevelTypes.topTouchStart:
	        EventConstructor = SyntheticTouchEvent;
	        break;
	      case topLevelTypes.topScroll:
	        EventConstructor = SyntheticUIEvent;
	        break;
	      case topLevelTypes.topWheel:
	        EventConstructor = SyntheticWheelEvent;
	        break;
	      case topLevelTypes.topCopy:
	      case topLevelTypes.topCut:
	      case topLevelTypes.topPaste:
	        EventConstructor = SyntheticClipboardEvent;
	        break;
	    }
	    !EventConstructor ?  false ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : invariant(false) : undefined;
	    var event = EventConstructor.getPooled(dispatchConfig, topLevelTargetID, nativeEvent, nativeEventTarget);
	    EventPropagators.accumulateTwoPhaseDispatches(event);
	    return event;
	  },
	
	  didPutListener: function (id, registrationName, listener) {
	    // Mobile Safari does not fire properly bubble click events on
	    // non-interactive elements, which means delegated click listeners do not
	    // fire. The workaround for this bug involves attaching an empty click
	    // listener on the target node.
	    if (registrationName === ON_CLICK_KEY) {
	      var node = ReactMount.getNode(id);
	      if (!onClickListeners[id]) {
	        onClickListeners[id] = EventListener.listen(node, 'click', emptyFunction);
	      }
	    }
	  },
	
	  willDeleteListener: function (id, registrationName) {
	    if (registrationName === ON_CLICK_KEY) {
	      onClickListeners[id].remove();
	      delete onClickListeners[id];
	    }
	  }
	
	};
	
	module.exports = SimpleEventPlugin;

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticClipboardEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(16);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/clipboard-apis/
	 */
	var ClipboardEventInterface = {
	  clipboardData: function (event) {
	    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);
	
	module.exports = SyntheticClipboardEvent;

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticCompositionEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(16);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
	 */
	var CompositionEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);
	
	module.exports = SyntheticCompositionEvent;

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticDragEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(29);
	
	/**
	 * @interface DragEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var DragEventInterface = {
	  dataTransfer: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);
	
	module.exports = SyntheticDragEvent;

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticFocusEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(24);
	
	/**
	 * @interface FocusEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var FocusEventInterface = {
	  relatedTarget: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);
	
	module.exports = SyntheticFocusEvent;

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticInputEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(16);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
	 *      /#events-inputevents
	 */
	var InputEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);
	
	module.exports = SyntheticInputEvent;

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticKeyboardEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(24);
	
	var getEventCharCode = __webpack_require__(44);
	var getEventKey = __webpack_require__(177);
	var getEventModifierState = __webpack_require__(45);
	
	/**
	 * @interface KeyboardEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var KeyboardEventInterface = {
	  key: getEventKey,
	  location: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  repeat: null,
	  locale: null,
	  getModifierState: getEventModifierState,
	  // Legacy Interface
	  charCode: function (event) {
	    // `charCode` is the result of a KeyPress event and represents the value of
	    // the actual printable character.
	
	    // KeyPress is deprecated, but its replacement is not yet final and not
	    // implemented in any major browser. Only KeyPress has charCode.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    return 0;
	  },
	  keyCode: function (event) {
	    // `keyCode` is the result of a KeyDown/Up event and represents the value of
	    // physical keyboard key.
	
	    // The actual meaning of the value depends on the users' keyboard layout
	    // which cannot be detected. Assuming that it is a US keyboard layout
	    // provides a surprisingly accurate mapping for US and European users.
	    // Due to this, it is left to the user to implement at this time.
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  },
	  which: function (event) {
	    // `which` is an alias for either `keyCode` or `charCode` depending on the
	    // type of the event.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);
	
	module.exports = SyntheticKeyboardEvent;

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticTouchEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(24);
	
	var getEventModifierState = __webpack_require__(45);
	
	/**
	 * @interface TouchEvent
	 * @see http://www.w3.org/TR/touch-events/
	 */
	var TouchEventInterface = {
	  touches: null,
	  targetTouches: null,
	  changedTouches: null,
	  altKey: null,
	  metaKey: null,
	  ctrlKey: null,
	  shiftKey: null,
	  getModifierState: getEventModifierState
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);
	
	module.exports = SyntheticTouchEvent;

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticWheelEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(29);
	
	/**
	 * @interface WheelEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var WheelEventInterface = {
	  deltaX: function (event) {
	    return 'deltaX' in event ? event.deltaX :
	    // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
	    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
	  },
	  deltaY: function (event) {
	    return 'deltaY' in event ? event.deltaY :
	    // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
	    'wheelDeltaY' in event ? -event.wheelDeltaY :
	    // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
	    'wheelDelta' in event ? -event.wheelDelta : 0;
	  },
	  deltaZ: null,
	
	  // Browsers without "deltaMode" is reporting in raw wheel delta where one
	  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
	  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
	  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
	  deltaMode: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticMouseEvent}
	 */
	function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);
	
	module.exports = SyntheticWheelEvent;

/***/ }),
/* 173 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule adler32
	 */
	
	'use strict';
	
	var MOD = 65521;
	
	// adler32 is not cryptographically strong, and is only used to sanity check that
	// markup generated on the server matches the markup generated on the client.
	// This implementation (a modified version of the SheetJS version) has been optimized
	// for our use case, at the expense of conforming to the adler32 specification
	// for non-ascii inputs.
	function adler32(data) {
	  var a = 1;
	  var b = 0;
	  var i = 0;
	  var l = data.length;
	  var m = l & ~0x3;
	  while (i < m) {
	    for (; i < Math.min(i + 4096, m); i += 4) {
	      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
	    }
	    a %= MOD;
	    b %= MOD;
	  }
	  for (; i < l; i++) {
	    b += a += data.charCodeAt(i);
	  }
	  a %= MOD;
	  b %= MOD;
	  return a | b << 16;
	}
	
	module.exports = adler32;

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule dangerousStyleValue
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(63);
	
	var isUnitlessNumber = CSSProperty.isUnitlessNumber;
	
	/**
	 * Convert a value into the proper css writable value. The style name `name`
	 * should be logical (no hyphens), as specified
	 * in `CSSProperty.isUnitlessNumber`.
	 *
	 * @param {string} name CSS property name such as `topMargin`.
	 * @param {*} value CSS property value such as `10px`.
	 * @return {string} Normalized style value with dimensions applied.
	 */
	function dangerousStyleValue(name, value) {
	  // Note that we've removed escapeTextForBrowser() calls here since the
	  // whole string will be escaped when the attribute is injected into
	  // the markup. If you provide unsafe user data here they can inject
	  // arbitrary CSS which may be problematic (I couldn't repro this):
	  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
	  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
	  // This is not an XSS hole but instead a potential CSS injection issue
	  // which has lead to a greater discussion about how we're going to
	  // trust URLs moving forward. See #2115901
	
	  var isEmpty = value == null || typeof value === 'boolean' || value === '';
	  if (isEmpty) {
	    return '';
	  }
	
	  var isNonNumeric = isNaN(value);
	  if (isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
	    return '' + value; // cast to string
	  }
	
	  if (typeof value === 'string') {
	    value = value.trim();
	  }
	  return value + 'px';
	}
	
	module.exports = dangerousStyleValue;

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule deprecated
	 */
	
	'use strict';
	
	var assign = __webpack_require__(3);
	var warning = __webpack_require__(2);
	
	/**
	 * This will log a single deprecation notice per function and forward the call
	 * on to the new API.
	 *
	 * @param {string} fnName The name of the function
	 * @param {string} newModule The module that fn will exist in
	 * @param {string} newPackage The module that fn will exist in
	 * @param {*} ctx The context this forwarded call should run in
	 * @param {function} fn The function to forward on to
	 * @return {function} The function that will warn once and then call fn
	 */
	function deprecated(fnName, newModule, newPackage, ctx, fn) {
	  var warned = false;
	  if (false) {
	    var newFn = function () {
	      process.env.NODE_ENV !== 'production' ? warning(warned,
	      // Require examples in this string must be split to prevent React's
	      // build tools from mistaking them for real requires.
	      // Otherwise the build tools will attempt to build a '%s' module.
	      'React.%s is deprecated. Please use %s.%s from require' + '(\'%s\') ' + 'instead.', fnName, newModule, fnName, newPackage) : undefined;
	      warned = true;
	      return fn.apply(ctx, arguments);
	    };
	    // We need to make sure all properties of the original fn are copied over.
	    // In particular, this is needed to support PropTypes
	    return assign(newFn, fn);
	  }
	
	  return fn;
	}
	
	module.exports = deprecated;

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule flattenChildren
	 */
	
	'use strict';
	
	var traverseAllChildren = __webpack_require__(52);
	var warning = __webpack_require__(2);
	
	/**
	 * @param {function} traverseContext Context passed through traversal.
	 * @param {?ReactComponent} child React child component.
	 * @param {!string} name String name of key path to child.
	 */
	function flattenSingleChildIntoContext(traverseContext, child, name) {
	  // We found a component instance.
	  var result = traverseContext;
	  var keyUnique = result[name] === undefined;
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(keyUnique, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.', name) : undefined;
	  }
	  if (keyUnique && child != null) {
	    result[name] = child;
	  }
	}
	
	/**
	 * Flattens children that are typically specified as `props.children`. Any null
	 * children will not be included in the resulting object.
	 * @return {!object} flattened children keyed by name.
	 */
	function flattenChildren(children) {
	  if (children == null) {
	    return children;
	  }
	  var result = {};
	  traverseAllChildren(children, flattenSingleChildIntoContext, result);
	  return result;
	}
	
	module.exports = flattenChildren;

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getEventKey
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var getEventCharCode = __webpack_require__(44);
	
	/**
	 * Normalization of deprecated HTML5 `key` values
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var normalizeKey = {
	  'Esc': 'Escape',
	  'Spacebar': ' ',
	  'Left': 'ArrowLeft',
	  'Up': 'ArrowUp',
	  'Right': 'ArrowRight',
	  'Down': 'ArrowDown',
	  'Del': 'Delete',
	  'Win': 'OS',
	  'Menu': 'ContextMenu',
	  'Apps': 'ContextMenu',
	  'Scroll': 'ScrollLock',
	  'MozPrintableKey': 'Unidentified'
	};
	
	/**
	 * Translation from legacy `keyCode` to HTML5 `key`
	 * Only special keys supported, all others depend on keyboard layout or browser
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var translateToKey = {
	  8: 'Backspace',
	  9: 'Tab',
	  12: 'Clear',
	  13: 'Enter',
	  16: 'Shift',
	  17: 'Control',
	  18: 'Alt',
	  19: 'Pause',
	  20: 'CapsLock',
	  27: 'Escape',
	  32: ' ',
	  33: 'PageUp',
	  34: 'PageDown',
	  35: 'End',
	  36: 'Home',
	  37: 'ArrowLeft',
	  38: 'ArrowUp',
	  39: 'ArrowRight',
	  40: 'ArrowDown',
	  45: 'Insert',
	  46: 'Delete',
	  112: 'F1', 113: 'F2', 114: 'F3', 115: 'F4', 116: 'F5', 117: 'F6',
	  118: 'F7', 119: 'F8', 120: 'F9', 121: 'F10', 122: 'F11', 123: 'F12',
	  144: 'NumLock',
	  145: 'ScrollLock',
	  224: 'Meta'
	};
	
	/**
	 * @param {object} nativeEvent Native browser event.
	 * @return {string} Normalized `key` property.
	 */
	function getEventKey(nativeEvent) {
	  if (nativeEvent.key) {
	    // Normalize inconsistent values reported by browsers due to
	    // implementations of a working draft specification.
	
	    // FireFox implements `key` but returns `MozPrintableKey` for all
	    // printable characters (normalized to `Unidentified`), ignore it.
	    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
	    if (key !== 'Unidentified') {
	      return key;
	    }
	  }
	
	  // Browser does not implement `key`, polyfill as much of it as we can.
	  if (nativeEvent.type === 'keypress') {
	    var charCode = getEventCharCode(nativeEvent);
	
	    // The enter-key is technically both printable and non-printable and can
	    // thus be captured by `keypress`, no other non-printable key should.
	    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
	  }
	  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
	    // While user keyboard layout determines the actual meaning of each
	    // `keyCode` value, almost all function keys have a universal value.
	    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
	  }
	  return '';
	}
	
	module.exports = getEventKey;

/***/ }),
/* 178 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getNodeForCharacterOffset
	 */
	
	'use strict';
	
	/**
	 * Given any node return the first leaf node without children.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {DOMElement|DOMTextNode}
	 */
	function getLeafNode(node) {
	  while (node && node.firstChild) {
	    node = node.firstChild;
	  }
	  return node;
	}
	
	/**
	 * Get the next sibling within a container. This will walk up the
	 * DOM if a node's siblings have been exhausted.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {?DOMElement|DOMTextNode}
	 */
	function getSiblingNode(node) {
	  while (node) {
	    if (node.nextSibling) {
	      return node.nextSibling;
	    }
	    node = node.parentNode;
	  }
	}
	
	/**
	 * Get object describing the nodes which contain characters at offset.
	 *
	 * @param {DOMElement|DOMTextNode} root
	 * @param {number} offset
	 * @return {?object}
	 */
	function getNodeForCharacterOffset(root, offset) {
	  var node = getLeafNode(root);
	  var nodeStart = 0;
	  var nodeEnd = 0;
	
	  while (node) {
	    if (node.nodeType === 3) {
	      nodeEnd = nodeStart + node.textContent.length;
	
	      if (nodeStart <= offset && nodeEnd >= offset) {
	        return {
	          node: node,
	          offset: offset - nodeStart
	        };
	      }
	
	      nodeStart = nodeEnd;
	    }
	
	    node = getLeafNode(getSiblingNode(node));
	  }
	}
	
	module.exports = getNodeForCharacterOffset;

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule onlyChild
	 */
	'use strict';
	
	var ReactElement = __webpack_require__(6);
	
	var invariant = __webpack_require__(1);
	
	/**
	 * Returns the first child in a collection of children and verifies that there
	 * is only one child in the collection. The current implementation of this
	 * function assumes that a single child gets passed without a wrapper, but the
	 * purpose of this helper function is to abstract away the particular structure
	 * of children.
	 *
	 * @param {?object} children Child collection structure.
	 * @return {ReactComponent} The first and only `ReactComponent` contained in the
	 * structure.
	 */
	function onlyChild(children) {
	  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'onlyChild must be passed a children with exactly one child.') : invariant(false) : undefined;
	  return children;
	}
	
	module.exports = onlyChild;

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule quoteAttributeValueForBrowser
	 */
	
	'use strict';
	
	var escapeTextContentForBrowser = __webpack_require__(32);
	
	/**
	 * Escapes attribute value to prevent scripting attacks.
	 *
	 * @param {*} value Value to escape.
	 * @return {string} An escaped string.
	 */
	function quoteAttributeValueForBrowser(value) {
	  return '"' + escapeTextContentForBrowser(value) + '"';
	}
	
	module.exports = quoteAttributeValueForBrowser;

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	* @providesModule renderSubtreeIntoContainer
	*/
	
	'use strict';
	
	var ReactMount = __webpack_require__(5);
	
	module.exports = ReactMount.renderSubtreeIntoContainer;

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

	window.eve = __webpack_require__(97)
	
	// Copyright (c) 2017 Adobe Systems Incorporated. All rights reserved.
	//
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//
	// http://www.apache.org/licenses/LICENSE-2.0
	//
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// See the License for the specific language governing permissions and
	// limitations under the License.
	var mina = (function (eve) {
	    var animations = {},
	    requestAnimFrame = window.requestAnimationFrame       ||
	                       window.webkitRequestAnimationFrame ||
	                       window.mozRequestAnimationFrame    ||
	                       window.oRequestAnimationFrame      ||
	                       window.msRequestAnimationFrame     ||
	                       function (callback) {
	                           setTimeout(callback, 16, new Date().getTime());
	                           return true;
	                       },
	    requestID,
	    isArray = Array.isArray || function (a) {
	        return a instanceof Array ||
	            Object.prototype.toString.call(a) == "[object Array]";
	    },
	    idgen = 0,
	    idprefix = "M" + (+new Date).toString(36),
	    ID = function () {
	        return idprefix + (idgen++).toString(36);
	    },
	    diff = function (a, b, A, B) {
	        if (isArray(a)) {
	            res = [];
	            for (var i = 0, ii = a.length; i < ii; i++) {
	                res[i] = diff(a[i], b, A[i], B);
	            }
	            return res;
	        }
	        var dif = (A - a) / (B - b);
	        return function (bb) {
	            return a + dif * (bb - b);
	        };
	    },
	    timer = Date.now || function () {
	        return +new Date;
	    },
	    sta = function (val) {
	        var a = this;
	        if (val == null) {
	            return a.s;
	        }
	        var ds = a.s - val;
	        a.b += a.dur * ds;
	        a.B += a.dur * ds;
	        a.s = val;
	    },
	    speed = function (val) {
	        var a = this;
	        if (val == null) {
	            return a.spd;
	        }
	        a.spd = val;
	    },
	    duration = function (val) {
	        var a = this;
	        if (val == null) {
	            return a.dur;
	        }
	        a.s = a.s * val / a.dur;
	        a.dur = val;
	    },
	    stopit = function () {
	        var a = this;
	        delete animations[a.id];
	        a.update();
	        eve("mina.stop." + a.id, a);
	    },
	    pause = function () {
	        var a = this;
	        if (a.pdif) {
	            return;
	        }
	        delete animations[a.id];
	        a.update();
	        a.pdif = a.get() - a.b;
	    },
	    resume = function () {
	        var a = this;
	        if (!a.pdif) {
	            return;
	        }
	        a.b = a.get() - a.pdif;
	        delete a.pdif;
	        animations[a.id] = a;
	        frame();
	    },
	    update = function () {
	        var a = this,
	            res;
	        if (isArray(a.start)) {
	            res = [];
	            for (var j = 0, jj = a.start.length; j < jj; j++) {
	                res[j] = +a.start[j] +
	                    (a.end[j] - a.start[j]) * a.easing(a.s);
	            }
	        } else {
	            res = +a.start + (a.end - a.start) * a.easing(a.s);
	        }
	        a.set(res);
	    },
	    frame = function (timeStamp) {
	        // Manual invokation?
	        if (!timeStamp) {
	            // Frame loop stopped?
	            if (!requestID) {
	                // Start frame loop...
	                requestID = requestAnimFrame(frame);
	            }
	            return;
	        }
	        var len = 0;
	        for (var i in animations) if (animations.hasOwnProperty(i)) {
	            var a = animations[i],
	                b = a.get(),
	                res;
	            len++;
	            a.s = (b - a.b) / (a.dur / a.spd);
	            if (a.s >= 1) {
	                delete animations[i];
	                a.s = 1;
	                len--;
	                (function (a) {
	                    setTimeout(function () {
	                        eve("mina.finish." + a.id, a);
	                    });
	                }(a));
	            }
	            a.update();
	        }
	        requestID = len ? requestAnimFrame(frame) : false;
	    },
	    /*\
	     * mina
	     [ method ]
	     **
	     * Generic animation of numbers
	     **
	     - a (number) start _slave_ number
	     - A (number) end _slave_ number
	     - b (number) start _master_ number (start time in general case)
	     - B (number) end _master_ number (end time in general case)
	     - get (function) getter of _master_ number (see @mina.time)
	     - set (function) setter of _slave_ number
	     - easing (function) #optional easing function, default is @mina.linear
	     = (object) animation descriptor
	     o {
	     o         id (string) animation id,
	     o         start (number) start _slave_ number,
	     o         end (number) end _slave_ number,
	     o         b (number) start _master_ number,
	     o         s (number) animation status (0..1),
	     o         dur (number) animation duration,
	     o         spd (number) animation speed,
	     o         get (function) getter of _master_ number (see @mina.time),
	     o         set (function) setter of _slave_ number,
	     o         easing (function) easing function, default is @mina.linear,
	     o         status (function) status getter/setter,
	     o         speed (function) speed getter/setter,
	     o         duration (function) duration getter/setter,
	     o         stop (function) animation stopper
	     o         pause (function) pauses the animation
	     o         resume (function) resumes the animation
	     o         update (function) calles setter with the right value of the animation
	     o }
	    \*/
	    mina = function (a, A, b, B, get, set, easing) {
	        var anim = {
	            id: ID(),
	            start: a,
	            end: A,
	            b: b,
	            s: 0,
	            dur: B - b,
	            spd: 1,
	            get: get,
	            set: set,
	            easing: easing || mina.linear,
	            status: sta,
	            speed: speed,
	            duration: duration,
	            stop: stopit,
	            pause: pause,
	            resume: resume,
	            update: update
	        };
	        animations[anim.id] = anim;
	        var len = 0, i;
	        for (i in animations) if (animations.hasOwnProperty(i)) {
	            len++;
	            if (len == 2) {
	                break;
	            }
	        }
	        len == 1 && frame();
	        return anim;
	    };
	    /*\
	     * mina.time
	     [ method ]
	     **
	     * Returns the current time. Equivalent to:
	     | function () {
	     |     return (new Date).getTime();
	     | }
	    \*/
	    mina.time = timer;
	    /*\
	     * mina.getById
	     [ method ]
	     **
	     * Returns an animation by its id
	     - id (string) animation's id
	     = (object) See @mina
	    \*/
	    mina.getById = function (id) {
	        return animations[id] || null;
	    };
	
	    /*\
	     * mina.linear
	     [ method ]
	     **
	     * Default linear easing
	     - n (number) input 0..1
	     = (number) output 0..1
	    \*/
	    mina.linear = function (n) {
	        return n;
	    };
	    /*\
	     * mina.easeout
	     [ method ]
	     **
	     * Easeout easing
	     - n (number) input 0..1
	     = (number) output 0..1
	    \*/
	    mina.easeout = function (n) {
	        return Math.pow(n, 1.7);
	    };
	    /*\
	     * mina.easein
	     [ method ]
	     **
	     * Easein easing
	     - n (number) input 0..1
	     = (number) output 0..1
	    \*/
	    mina.easein = function (n) {
	        return Math.pow(n, .48);
	    };
	    /*\
	     * mina.easeinout
	     [ method ]
	     **
	     * Easeinout easing
	     - n (number) input 0..1
	     = (number) output 0..1
	    \*/
	    mina.easeinout = function (n) {
	        if (n == 1) {
	            return 1;
	        }
	        if (n == 0) {
	            return 0;
	        }
	        var q = .48 - n / 1.04,
	            Q = Math.sqrt(.1734 + q * q),
	            x = Q - q,
	            X = Math.pow(Math.abs(x), 1 / 3) * (x < 0 ? -1 : 1),
	            y = -Q - q,
	            Y = Math.pow(Math.abs(y), 1 / 3) * (y < 0 ? -1 : 1),
	            t = X + Y + .5;
	        return (1 - t) * 3 * t * t + t * t * t;
	    };
	    /*\
	     * mina.backin
	     [ method ]
	     **
	     * Backin easing
	     - n (number) input 0..1
	     = (number) output 0..1
	    \*/
	    mina.backin = function (n) {
	        if (n == 1) {
	            return 1;
	        }
	        var s = 1.70158;
	        return n * n * ((s + 1) * n - s);
	    };
	    /*\
	     * mina.backout
	     [ method ]
	     **
	     * Backout easing
	     - n (number) input 0..1
	     = (number) output 0..1
	    \*/
	    mina.backout = function (n) {
	        if (n == 0) {
	            return 0;
	        }
	        n = n - 1;
	        var s = 1.70158;
	        return n * n * ((s + 1) * n + s) + 1;
	    };
	    /*\
	     * mina.elastic
	     [ method ]
	     **
	     * Elastic easing
	     - n (number) input 0..1
	     = (number) output 0..1
	    \*/
	    mina.elastic = function (n) {
	        if (n == !!n) {
	            return n;
	        }
	        return Math.pow(2, -10 * n) * Math.sin((n - .075) *
	            (2 * Math.PI) / .3) + 1;
	    };
	    /*\
	     * mina.bounce
	     [ method ]
	     **
	     * Bounce easing
	     - n (number) input 0..1
	     = (number) output 0..1
	    \*/
	    mina.bounce = function (n) {
	        var s = 7.5625,
	            p = 2.75,
	            l;
	        if (n < 1 / p) {
	            l = s * n * n;
	        } else {
	            if (n < 2 / p) {
	                n -= 1.5 / p;
	                l = s * n * n + .75;
	            } else {
	                if (n < 2.5 / p) {
	                    n -= 2.25 / p;
	                    l = s * n * n + .9375;
	                } else {
	                    n -= 2.625 / p;
	                    l = s * n * n + .984375;
	                }
	            }
	        }
	        return l;
	    };
	    window.mina = mina;
	    return mina;
	})(typeof eve == "undefined" ? function () {} : eve);
	
	// Copyright (c) 2013 - 2017 Adobe Systems Incorporated. All rights reserved.
	//
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//
	// http://www.apache.org/licenses/LICENSE-2.0
	//
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// See the License for the specific language governing permissions and
	// limitations under the License.
	
	var Snap = (function(root) {
	Snap.version = "0.5.1";
	/*\
	 * Snap
	 [ method ]
	 **
	 * Creates a drawing surface or wraps existing SVG element.
	 **
	 - width (number|string) width of surface
	 - height (number|string) height of surface
	 * or
	 - DOM (SVGElement) element to be wrapped into Snap structure
	 * or
	 - array (array) array of elements (will return set of elements)
	 * or
	 - query (string) CSS query selector
	 = (object) @Element
	\*/
	function Snap(w, h) {
	    if (w) {
	        if (w.nodeType) {
	            return wrap(w);
	        }
	        if (is(w, "array") && Snap.set) {
	            return Snap.set.apply(Snap, w);
	        }
	        if (w instanceof Element) {
	            return w;
	        }
	        if (h == null) {
	            try {
	                w = glob.doc.querySelector(String(w));
	                return wrap(w);
	            } catch (e) {
	                return null;
	            }
	        }
	    }
	    w = w == null ? "100%" : w;
	    h = h == null ? "100%" : h;
	    return new Paper(w, h);
	}
	Snap.toString = function () {
	    return "Snap v" + this.version;
	};
	Snap._ = {};
	var glob = {
	    win: root.window,
	    doc: root.window.document
	};
	Snap._.glob = glob;
	var has = "hasOwnProperty",
	    Str = String,
	    toFloat = parseFloat,
	    toInt = parseInt,
	    math = Math,
	    mmax = math.max,
	    mmin = math.min,
	    abs = math.abs,
	    pow = math.pow,
	    PI = math.PI,
	    round = math.round,
	    E = "",
	    S = " ",
	    objectToString = Object.prototype.toString,
	    ISURL = /^url\(['"]?([^\)]+?)['"]?\)$/i,
	    colourRegExp = /^\s*((#[a-f\d]{6})|(#[a-f\d]{3})|rgba?\(\s*([\d\.]+%?\s*,\s*[\d\.]+%?\s*,\s*[\d\.]+%?(?:\s*,\s*[\d\.]+%?)?)\s*\)|hsba?\(\s*([\d\.]+(?:deg|\xb0|%)?\s*,\s*[\d\.]+%?\s*,\s*[\d\.]+(?:%?\s*,\s*[\d\.]+)?%?)\s*\)|hsla?\(\s*([\d\.]+(?:deg|\xb0|%)?\s*,\s*[\d\.]+%?\s*,\s*[\d\.]+(?:%?\s*,\s*[\d\.]+)?%?)\s*\))\s*$/i,
	    bezierrg = /^(?:cubic-)?bezier\(([^,]+),([^,]+),([^,]+),([^\)]+)\)/,
	    separator = Snap._.separator = /[,\s]+/,
	    whitespace = /[\s]/g,
	    commaSpaces = /[\s]*,[\s]*/,
	    hsrg = {hs: 1, rg: 1},
	    pathCommand = /([a-z])[\s,]*((-?\d*\.?\d*(?:e[\-+]?\d+)?[\s]*,?[\s]*)+)/ig,
	    tCommand = /([rstm])[\s,]*((-?\d*\.?\d*(?:e[\-+]?\d+)?[\s]*,?[\s]*)+)/ig,
	    pathValues = /(-?\d*\.?\d*(?:e[\-+]?\d+)?)[\s]*,?[\s]*/ig,
	    idgen = 0,
	    idprefix = "S" + (+new Date).toString(36),
	    ID = function (el) {
	        return (el && el.type ? el.type : E) + idprefix + (idgen++).toString(36);
	    },
	    xlink = "http://www.w3.org/1999/xlink",
	    xmlns = "http://www.w3.org/2000/svg",
	    hub = {},
	    /*\
	     * Snap.url
	     [ method ]
	     **
	     * Wraps path into `"url('<path>')"`.
	     - value (string) path
	     = (string) wrapped path
	    \*/
	    URL = Snap.url = function (url) {
	        return "url('#" + url + "')";
	    };
	
	function $(el, attr) {
	    if (attr) {
	        if (el == "#text") {
	            el = glob.doc.createTextNode(attr.text || attr["#text"] || "");
	        }
	        if (el == "#comment") {
	            el = glob.doc.createComment(attr.text || attr["#text"] || "");
	        }
	        if (typeof el == "string") {
	            el = $(el);
	        }
	        if (typeof attr == "string") {
	            if (el.nodeType == 1) {
	                if (attr.substring(0, 6) == "xlink:") {
	                    return el.getAttributeNS(xlink, attr.substring(6));
	                }
	                if (attr.substring(0, 4) == "xml:") {
	                    return el.getAttributeNS(xmlns, attr.substring(4));
	                }
	                return el.getAttribute(attr);
	            } else if (attr == "text") {
	                return el.nodeValue;
	            } else {
	                return null;
	            }
	        }
	        if (el.nodeType == 1) {
	            for (var key in attr) if (attr[has](key)) {
	                var val = Str(attr[key]);
	                if (val) {
	                    if (key.substring(0, 6) == "xlink:") {
	                        el.setAttributeNS(xlink, key.substring(6), val);
	                    } else if (key.substring(0, 4) == "xml:") {
	                        el.setAttributeNS(xmlns, key.substring(4), val);
	                    } else {
	                        el.setAttribute(key, val);
	                    }
	                } else {
	                    el.removeAttribute(key);
	                }
	            }
	        } else if ("text" in attr) {
	            el.nodeValue = attr.text;
	        }
	    } else {
	        el = glob.doc.createElementNS(xmlns, el);
	    }
	    return el;
	}
	Snap._.$ = $;
	Snap._.id = ID;
	function getAttrs(el) {
	    var attrs = el.attributes,
	        name,
	        out = {};
	    for (var i = 0; i < attrs.length; i++) {
	        if (attrs[i].namespaceURI == xlink) {
	            name = "xlink:";
	        } else {
	            name = "";
	        }
	        name += attrs[i].name;
	        out[name] = attrs[i].textContent;
	    }
	    return out;
	}
	function is(o, type) {
	    type = Str.prototype.toLowerCase.call(type);
	    if (type == "finite") {
	        return isFinite(o);
	    }
	    if (type == "array" &&
	        (o instanceof Array || Array.isArray && Array.isArray(o))) {
	        return true;
	    }
	    return  type == "null" && o === null ||
	            type == typeof o && o !== null ||
	            type == "object" && o === Object(o) ||
	            objectToString.call(o).slice(8, -1).toLowerCase() == type;
	}
	/*\
	 * Snap.format
	 [ method ]
	 **
	 * Replaces construction of type `{<name>}` to the corresponding argument
	 **
	 - token (string) string to format
	 - json (object) object which properties are used as a replacement
	 = (string) formatted string
	 > Usage
	 | // this draws a rectangular shape equivalent to "M10,20h40v50h-40z"
	 | paper.path(Snap.format("M{x},{y}h{dim.width}v{dim.height}h{dim['negative width']}z", {
	 |     x: 10,
	 |     y: 20,
	 |     dim: {
	 |         width: 40,
	 |         height: 50,
	 |         "negative width": -40
	 |     }
	 | }));
	\*/
	Snap.format = (function () {
	    var tokenRegex = /\{([^\}]+)\}/g,
	        objNotationRegex = /(?:(?:^|\.)(.+?)(?=\[|\.|$|\()|\[('|")(.+?)\2\])(\(\))?/g, // matches .xxxxx or ["xxxxx"] to run over object properties
	        replacer = function (all, key, obj) {
	            var res = obj;
	            key.replace(objNotationRegex, function (all, name, quote, quotedName, isFunc) {
	                name = name || quotedName;
	                if (res) {
	                    if (name in res) {
	                        res = res[name];
	                    }
	                    typeof res == "function" && isFunc && (res = res());
	                }
	            });
	            res = (res == null || res == obj ? all : res) + "";
	            return res;
	        };
	    return function (str, obj) {
	        return Str(str).replace(tokenRegex, function (all, key) {
	            return replacer(all, key, obj);
	        });
	    };
	})();
	function clone(obj) {
	    if (typeof obj == "function" || Object(obj) !== obj) {
	        return obj;
	    }
	    var res = new obj.constructor;
	    for (var key in obj) if (obj[has](key)) {
	        res[key] = clone(obj[key]);
	    }
	    return res;
	}
	Snap._.clone = clone;
	function repush(array, item) {
	    for (var i = 0, ii = array.length; i < ii; i++) if (array[i] === item) {
	        return array.push(array.splice(i, 1)[0]);
	    }
	}
	function cacher(f, scope, postprocessor) {
	    function newf() {
	        var arg = Array.prototype.slice.call(arguments, 0),
	            args = arg.join("\u2400"),
	            cache = newf.cache = newf.cache || {},
	            count = newf.count = newf.count || [];
	        if (cache[has](args)) {
	            repush(count, args);
	            return postprocessor ? postprocessor(cache[args]) : cache[args];
	        }
	        count.length >= 1e3 && delete cache[count.shift()];
	        count.push(args);
	        cache[args] = f.apply(scope, arg);
	        return postprocessor ? postprocessor(cache[args]) : cache[args];
	    }
	    return newf;
	}
	Snap._.cacher = cacher;
	function angle(x1, y1, x2, y2, x3, y3) {
	    if (x3 == null) {
	        var x = x1 - x2,
	            y = y1 - y2;
	        if (!x && !y) {
	            return 0;
	        }
	        return (180 + math.atan2(-y, -x) * 180 / PI + 360) % 360;
	    } else {
	        return angle(x1, y1, x3, y3) - angle(x2, y2, x3, y3);
	    }
	}
	function rad(deg) {
	    return deg % 360 * PI / 180;
	}
	function deg(rad) {
	    return rad * 180 / PI % 360;
	}
	function x_y() {
	    return this.x + S + this.y;
	}
	function x_y_w_h() {
	    return this.x + S + this.y + S + this.width + " \xd7 " + this.height;
	}
	
	/*\
	 * Snap.rad
	 [ method ]
	 **
	 * Transform angle to radians
	 - deg (number) angle in degrees
	 = (number) angle in radians
	\*/
	Snap.rad = rad;
	/*\
	 * Snap.deg
	 [ method ]
	 **
	 * Transform angle to degrees
	 - rad (number) angle in radians
	 = (number) angle in degrees
	\*/
	Snap.deg = deg;
	/*\
	 * Snap.sin
	 [ method ]
	 **
	 * Equivalent to `Math.sin()` only works with degrees, not radians.
	 - angle (number) angle in degrees
	 = (number) sin
	\*/
	Snap.sin = function (angle) {
	    return math.sin(Snap.rad(angle));
	};
	/*\
	 * Snap.tan
	 [ method ]
	 **
	 * Equivalent to `Math.tan()` only works with degrees, not radians.
	 - angle (number) angle in degrees
	 = (number) tan
	\*/
	Snap.tan = function (angle) {
	    return math.tan(Snap.rad(angle));
	};
	/*\
	 * Snap.cos
	 [ method ]
	 **
	 * Equivalent to `Math.cos()` only works with degrees, not radians.
	 - angle (number) angle in degrees
	 = (number) cos
	\*/
	Snap.cos = function (angle) {
	    return math.cos(Snap.rad(angle));
	};
	/*\
	 * Snap.asin
	 [ method ]
	 **
	 * Equivalent to `Math.asin()` only works with degrees, not radians.
	 - num (number) value
	 = (number) asin in degrees
	\*/
	Snap.asin = function (num) {
	    return Snap.deg(math.asin(num));
	};
	/*\
	 * Snap.acos
	 [ method ]
	 **
	 * Equivalent to `Math.acos()` only works with degrees, not radians.
	 - num (number) value
	 = (number) acos in degrees
	\*/
	Snap.acos = function (num) {
	    return Snap.deg(math.acos(num));
	};
	/*\
	 * Snap.atan
	 [ method ]
	 **
	 * Equivalent to `Math.atan()` only works with degrees, not radians.
	 - num (number) value
	 = (number) atan in degrees
	\*/
	Snap.atan = function (num) {
	    return Snap.deg(math.atan(num));
	};
	/*\
	 * Snap.atan2
	 [ method ]
	 **
	 * Equivalent to `Math.atan2()` only works with degrees, not radians.
	 - num (number) value
	 = (number) atan2 in degrees
	\*/
	Snap.atan2 = function (num) {
	    return Snap.deg(math.atan2(num));
	};
	/*\
	 * Snap.angle
	 [ method ]
	 **
	 * Returns an angle between two or three points
	 - x1 (number) x coord of first point
	 - y1 (number) y coord of first point
	 - x2 (number) x coord of second point
	 - y2 (number) y coord of second point
	 - x3 (number) #optional x coord of third point
	 - y3 (number) #optional y coord of third point
	 = (number) angle in degrees
	\*/
	Snap.angle = angle;
	/*\
	 * Snap.len
	 [ method ]
	 **
	 * Returns distance between two points
	 - x1 (number) x coord of first point
	 - y1 (number) y coord of first point
	 - x2 (number) x coord of second point
	 - y2 (number) y coord of second point
	 = (number) distance
	\*/
	Snap.len = function (x1, y1, x2, y2) {
	    return Math.sqrt(Snap.len2(x1, y1, x2, y2));
	};
	/*\
	 * Snap.len2
	 [ method ]
	 **
	 * Returns squared distance between two points
	 - x1 (number) x coord of first point
	 - y1 (number) y coord of first point
	 - x2 (number) x coord of second point
	 - y2 (number) y coord of second point
	 = (number) distance
	\*/
	Snap.len2 = function (x1, y1, x2, y2) {
	    return (x1 - x2) * (x1 - x2) + (y1 - y2) * (y1 - y2);
	};
	/*\
	 * Snap.closestPoint
	 [ method ]
	 **
	 * Returns closest point to a given one on a given path.
	 - path (Element) path element
	 - x (number) x coord of a point
	 - y (number) y coord of a point
	 = (object) in format
	 {
	    x (number) x coord of the point on the path
	    y (number) y coord of the point on the path
	    length (number) length of the path to the point
	    distance (number) distance from the given point to the path
	 }
	\*/
	// Copied from http://bl.ocks.org/mbostock/8027637
	Snap.closestPoint = function (path, x, y) {
	    function distance2(p) {
	        var dx = p.x - x,
	            dy = p.y - y;
	        return dx * dx + dy * dy;
	    }
	    var pathNode = path.node,
	        pathLength = pathNode.getTotalLength(),
	        precision = pathLength / pathNode.pathSegList.numberOfItems * .125,
	        best,
	        bestLength,
	        bestDistance = Infinity;
	
	    // linear scan for coarse approximation
	    for (var scan, scanLength = 0, scanDistance; scanLength <= pathLength; scanLength += precision) {
	        if ((scanDistance = distance2(scan = pathNode.getPointAtLength(scanLength))) < bestDistance) {
	            best = scan;
	            bestLength = scanLength;
	            bestDistance = scanDistance;
	        }
	    }
	
	    // binary search for precise estimate
	    precision *= .5;
	    while (precision > .5) {
	        var before,
	            after,
	            beforeLength,
	            afterLength,
	            beforeDistance,
	            afterDistance;
	        if ((beforeLength = bestLength - precision) >= 0 && (beforeDistance = distance2(before = pathNode.getPointAtLength(beforeLength))) < bestDistance) {
	            best = before;
	            bestLength = beforeLength;
	            bestDistance = beforeDistance;
	        } else if ((afterLength = bestLength + precision) <= pathLength && (afterDistance = distance2(after = pathNode.getPointAtLength(afterLength))) < bestDistance) {
	            best = after;
	            bestLength = afterLength;
	            bestDistance = afterDistance;
	        } else {
	            precision *= .5;
	        }
	    }
	
	    best = {
	        x: best.x,
	        y: best.y,
	        length: bestLength,
	        distance: Math.sqrt(bestDistance)
	    };
	    return best;
	}
	/*\
	 * Snap.is
	 [ method ]
	 **
	 * Handy replacement for the `typeof` operator
	 - o (…) any object or primitive
	 - type (string) name of the type, e.g., `string`, `function`, `number`, etc.
	 = (boolean) `true` if given value is of given type
	\*/
	Snap.is = is;
	/*\
	 * Snap.snapTo
	 [ method ]
	 **
	 * Snaps given value to given grid
	 - values (array|number) given array of values or step of the grid
	 - value (number) value to adjust
	 - tolerance (number) #optional maximum distance to the target value that would trigger the snap. Default is `10`.
	 = (number) adjusted value
	\*/
	Snap.snapTo = function (values, value, tolerance) {
	    tolerance = is(tolerance, "finite") ? tolerance : 10;
	    if (is(values, "array")) {
	        var i = values.length;
	        while (i--) if (abs(values[i] - value) <= tolerance) {
	            return values[i];
	        }
	    } else {
	        values = +values;
	        var rem = value % values;
	        if (rem < tolerance) {
	            return value - rem;
	        }
	        if (rem > values - tolerance) {
	            return value - rem + values;
	        }
	    }
	    return value;
	};
	// Colour
	/*\
	 * Snap.getRGB
	 [ method ]
	 **
	 * Parses color string as RGB object
	 - color (string) color string in one of the following formats:
	 # <ul>
	 #     <li>Color name (<code>red</code>, <code>green</code>, <code>cornflowerblue</code>, etc)</li>
	 #     <li>#••• — shortened HTML color: (<code>#000</code>, <code>#fc0</code>, etc.)</li>
	 #     <li>#•••••• — full length HTML color: (<code>#000000</code>, <code>#bd2300</code>)</li>
	 #     <li>rgb(•••, •••, •••) — red, green and blue channels values: (<code>rgb(200,&nbsp;100,&nbsp;0)</code>)</li>
	 #     <li>rgba(•••, •••, •••, •••) — also with opacity</li>
	 #     <li>rgb(•••%, •••%, •••%) — same as above, but in %: (<code>rgb(100%,&nbsp;175%,&nbsp;0%)</code>)</li>
	 #     <li>rgba(•••%, •••%, •••%, •••%) — also with opacity</li>
	 #     <li>hsb(•••, •••, •••) — hue, saturation and brightness values: (<code>hsb(0.5,&nbsp;0.25,&nbsp;1)</code>)</li>
	 #     <li>hsba(•••, •••, •••, •••) — also with opacity</li>
	 #     <li>hsb(•••%, •••%, •••%) — same as above, but in %</li>
	 #     <li>hsba(•••%, •••%, •••%, •••%) — also with opacity</li>
	 #     <li>hsl(•••, •••, •••) — hue, saturation and luminosity values: (<code>hsb(0.5,&nbsp;0.25,&nbsp;0.5)</code>)</li>
	 #     <li>hsla(•••, •••, •••, •••) — also with opacity</li>
	 #     <li>hsl(•••%, •••%, •••%) — same as above, but in %</li>
	 #     <li>hsla(•••%, •••%, •••%, •••%) — also with opacity</li>
	 # </ul>
	 * Note that `%` can be used any time: `rgb(20%, 255, 50%)`.
	 = (object) RGB object in the following format:
	 o {
	 o     r (number) red,
	 o     g (number) green,
	 o     b (number) blue,
	 o     hex (string) color in HTML/CSS format: #••••••,
	 o     error (boolean) true if string can't be parsed
	 o }
	\*/
	Snap.getRGB = cacher(function (colour) {
	    if (!colour || !!((colour = Str(colour)).indexOf("-") + 1)) {
	        return {r: -1, g: -1, b: -1, hex: "none", error: 1, toString: rgbtoString};
	    }
	    if (colour == "none") {
	        return {r: -1, g: -1, b: -1, hex: "none", toString: rgbtoString};
	    }
	    !(hsrg[has](colour.toLowerCase().substring(0, 2)) || colour.charAt() == "#") && (colour = toHex(colour));
	    if (!colour) {
	        return {r: -1, g: -1, b: -1, hex: "none", error: 1, toString: rgbtoString};
	    }
	    var res,
	        red,
	        green,
	        blue,
	        opacity,
	        t,
	        values,
	        rgb = colour.match(colourRegExp);
	    if (rgb) {
	        if (rgb[2]) {
	            blue = toInt(rgb[2].substring(5), 16);
	            green = toInt(rgb[2].substring(3, 5), 16);
	            red = toInt(rgb[2].substring(1, 3), 16);
	        }
	        if (rgb[3]) {
	            blue = toInt((t = rgb[3].charAt(3)) + t, 16);
	            green = toInt((t = rgb[3].charAt(2)) + t, 16);
	            red = toInt((t = rgb[3].charAt(1)) + t, 16);
	        }
	        if (rgb[4]) {
	            values = rgb[4].split(commaSpaces);
	            red = toFloat(values[0]);
	            values[0].slice(-1) == "%" && (red *= 2.55);
	            green = toFloat(values[1]);
	            values[1].slice(-1) == "%" && (green *= 2.55);
	            blue = toFloat(values[2]);
	            values[2].slice(-1) == "%" && (blue *= 2.55);
	            rgb[1].toLowerCase().slice(0, 4) == "rgba" && (opacity = toFloat(values[3]));
	            values[3] && values[3].slice(-1) == "%" && (opacity /= 100);
	        }
	        if (rgb[5]) {
	            values = rgb[5].split(commaSpaces);
	            red = toFloat(values[0]);
	            values[0].slice(-1) == "%" && (red /= 100);
	            green = toFloat(values[1]);
	            values[1].slice(-1) == "%" && (green /= 100);
	            blue = toFloat(values[2]);
	            values[2].slice(-1) == "%" && (blue /= 100);
	            (values[0].slice(-3) == "deg" || values[0].slice(-1) == "\xb0") && (red /= 360);
	            rgb[1].toLowerCase().slice(0, 4) == "hsba" && (opacity = toFloat(values[3]));
	            values[3] && values[3].slice(-1) == "%" && (opacity /= 100);
	            return Snap.hsb2rgb(red, green, blue, opacity);
	        }
	        if (rgb[6]) {
	            values = rgb[6].split(commaSpaces);
	            red = toFloat(values[0]);
	            values[0].slice(-1) == "%" && (red /= 100);
	            green = toFloat(values[1]);
	            values[1].slice(-1) == "%" && (green /= 100);
	            blue = toFloat(values[2]);
	            values[2].slice(-1) == "%" && (blue /= 100);
	            (values[0].slice(-3) == "deg" || values[0].slice(-1) == "\xb0") && (red /= 360);
	            rgb[1].toLowerCase().slice(0, 4) == "hsla" && (opacity = toFloat(values[3]));
	            values[3] && values[3].slice(-1) == "%" && (opacity /= 100);
	            return Snap.hsl2rgb(red, green, blue, opacity);
	        }
	        red = mmin(math.round(red), 255);
	        green = mmin(math.round(green), 255);
	        blue = mmin(math.round(blue), 255);
	        opacity = mmin(mmax(opacity, 0), 1);
	        rgb = {r: red, g: green, b: blue, toString: rgbtoString};
	        rgb.hex = "#" + (16777216 | blue | green << 8 | red << 16).toString(16).slice(1);
	        rgb.opacity = is(opacity, "finite") ? opacity : 1;
	        return rgb;
	    }
	    return {r: -1, g: -1, b: -1, hex: "none", error: 1, toString: rgbtoString};
	}, Snap);
	/*\
	 * Snap.hsb
	 [ method ]
	 **
	 * Converts HSB values to a hex representation of the color
	 - h (number) hue
	 - s (number) saturation
	 - b (number) value or brightness
	 = (string) hex representation of the color
	\*/
	Snap.hsb = cacher(function (h, s, b) {
	    return Snap.hsb2rgb(h, s, b).hex;
	});
	/*\
	 * Snap.hsl
	 [ method ]
	 **
	 * Converts HSL values to a hex representation of the color
	 - h (number) hue
	 - s (number) saturation
	 - l (number) luminosity
	 = (string) hex representation of the color
	\*/
	Snap.hsl = cacher(function (h, s, l) {
	    return Snap.hsl2rgb(h, s, l).hex;
	});
	/*\
	 * Snap.rgb
	 [ method ]
	 **
	 * Converts RGB values to a hex representation of the color
	 - r (number) red
	 - g (number) green
	 - b (number) blue
	 = (string) hex representation of the color
	\*/
	Snap.rgb = cacher(function (r, g, b, o) {
	    if (is(o, "finite")) {
	        var round = math.round;
	        return "rgba(" + [round(r), round(g), round(b), +o.toFixed(2)] + ")";
	    }
	    return "#" + (16777216 | b | g << 8 | r << 16).toString(16).slice(1);
	});
	var toHex = function (color) {
	    var i = glob.doc.getElementsByTagName("head")[0] || glob.doc.getElementsByTagName("svg")[0],
	        red = "rgb(255, 0, 0)";
	    toHex = cacher(function (color) {
	        if (color.toLowerCase() == "red") {
	            return red;
	        }
	        i.style.color = red;
	        i.style.color = color;
	        var out = glob.doc.defaultView.getComputedStyle(i, E).getPropertyValue("color");
	        return out == red ? null : out;
	    });
	    return toHex(color);
	},
	hsbtoString = function () {
	    return "hsb(" + [this.h, this.s, this.b] + ")";
	},
	hsltoString = function () {
	    return "hsl(" + [this.h, this.s, this.l] + ")";
	},
	rgbtoString = function () {
	    return this.opacity == 1 || this.opacity == null ?
	            this.hex :
	            "rgba(" + [this.r, this.g, this.b, this.opacity] + ")";
	},
	prepareRGB = function (r, g, b) {
	    if (g == null && is(r, "object") && "r" in r && "g" in r && "b" in r) {
	        b = r.b;
	        g = r.g;
	        r = r.r;
	    }
	    if (g == null && is(r, string)) {
	        var clr = Snap.getRGB(r);
	        r = clr.r;
	        g = clr.g;
	        b = clr.b;
	    }
	    if (r > 1 || g > 1 || b > 1) {
	        r /= 255;
	        g /= 255;
	        b /= 255;
	    }
	
	    return [r, g, b];
	},
	packageRGB = function (r, g, b, o) {
	    r = math.round(r * 255);
	    g = math.round(g * 255);
	    b = math.round(b * 255);
	    var rgb = {
	        r: r,
	        g: g,
	        b: b,
	        opacity: is(o, "finite") ? o : 1,
	        hex: Snap.rgb(r, g, b),
	        toString: rgbtoString
	    };
	    is(o, "finite") && (rgb.opacity = o);
	    return rgb;
	};
	/*\
	 * Snap.color
	 [ method ]
	 **
	 * Parses the color string and returns an object featuring the color's component values
	 - clr (string) color string in one of the supported formats (see @Snap.getRGB)
	 = (object) Combined RGB/HSB object in the following format:
	 o {
	 o     r (number) red,
	 o     g (number) green,
	 o     b (number) blue,
	 o     hex (string) color in HTML/CSS format: #••••••,
	 o     error (boolean) `true` if string can't be parsed,
	 o     h (number) hue,
	 o     s (number) saturation,
	 o     v (number) value (brightness),
	 o     l (number) lightness
	 o }
	\*/
	Snap.color = function (clr) {
	    var rgb;
	    if (is(clr, "object") && "h" in clr && "s" in clr && "b" in clr) {
	        rgb = Snap.hsb2rgb(clr);
	        clr.r = rgb.r;
	        clr.g = rgb.g;
	        clr.b = rgb.b;
	        clr.opacity = 1;
	        clr.hex = rgb.hex;
	    } else if (is(clr, "object") && "h" in clr && "s" in clr && "l" in clr) {
	        rgb = Snap.hsl2rgb(clr);
	        clr.r = rgb.r;
	        clr.g = rgb.g;
	        clr.b = rgb.b;
	        clr.opacity = 1;
	        clr.hex = rgb.hex;
	    } else {
	        if (is(clr, "string")) {
	            clr = Snap.getRGB(clr);
	        }
	        if (is(clr, "object") && "r" in clr && "g" in clr && "b" in clr && !("error" in clr)) {
	            rgb = Snap.rgb2hsl(clr);
	            clr.h = rgb.h;
	            clr.s = rgb.s;
	            clr.l = rgb.l;
	            rgb = Snap.rgb2hsb(clr);
	            clr.v = rgb.b;
	        } else {
	            clr = {hex: "none"};
	            clr.r = clr.g = clr.b = clr.h = clr.s = clr.v = clr.l = -1;
	            clr.error = 1;
	        }
	    }
	    clr.toString = rgbtoString;
	    return clr;
	};
	/*\
	 * Snap.hsb2rgb
	 [ method ]
	 **
	 * Converts HSB values to an RGB object
	 - h (number) hue
	 - s (number) saturation
	 - v (number) value or brightness
	 = (object) RGB object in the following format:
	 o {
	 o     r (number) red,
	 o     g (number) green,
	 o     b (number) blue,
	 o     hex (string) color in HTML/CSS format: #••••••
	 o }
	\*/
	Snap.hsb2rgb = function (h, s, v, o) {
	    if (is(h, "object") && "h" in h && "s" in h && "b" in h) {
	        v = h.b;
	        s = h.s;
	        o = h.o;
	        h = h.h;
	    }
	    h *= 360;
	    var R, G, B, X, C;
	    h = h % 360 / 60;
	    C = v * s;
	    X = C * (1 - abs(h % 2 - 1));
	    R = G = B = v - C;
	
	    h = ~~h;
	    R += [C, X, 0, 0, X, C][h];
	    G += [X, C, C, X, 0, 0][h];
	    B += [0, 0, X, C, C, X][h];
	    return packageRGB(R, G, B, o);
	};
	/*\
	 * Snap.hsl2rgb
	 [ method ]
	 **
	 * Converts HSL values to an RGB object
	 - h (number) hue
	 - s (number) saturation
	 - l (number) luminosity
	 = (object) RGB object in the following format:
	 o {
	 o     r (number) red,
	 o     g (number) green,
	 o     b (number) blue,
	 o     hex (string) color in HTML/CSS format: #••••••
	 o }
	\*/
	Snap.hsl2rgb = function (h, s, l, o) {
	    if (is(h, "object") && "h" in h && "s" in h && "l" in h) {
	        l = h.l;
	        s = h.s;
	        h = h.h;
	    }
	    if (h > 1 || s > 1 || l > 1) {
	        h /= 360;
	        s /= 100;
	        l /= 100;
	    }
	    h *= 360;
	    var R, G, B, X, C;
	    h = h % 360 / 60;
	    C = 2 * s * (l < .5 ? l : 1 - l);
	    X = C * (1 - abs(h % 2 - 1));
	    R = G = B = l - C / 2;
	
	    h = ~~h;
	    R += [C, X, 0, 0, X, C][h];
	    G += [X, C, C, X, 0, 0][h];
	    B += [0, 0, X, C, C, X][h];
	    return packageRGB(R, G, B, o);
	};
	/*\
	 * Snap.rgb2hsb
	 [ method ]
	 **
	 * Converts RGB values to an HSB object
	 - r (number) red
	 - g (number) green
	 - b (number) blue
	 = (object) HSB object in the following format:
	 o {
	 o     h (number) hue,
	 o     s (number) saturation,
	 o     b (number) brightness
	 o }
	\*/
	Snap.rgb2hsb = function (r, g, b) {
	    b = prepareRGB(r, g, b);
	    r = b[0];
	    g = b[1];
	    b = b[2];
	
	    var H, S, V, C;
	    V = mmax(r, g, b);
	    C = V - mmin(r, g, b);
	    H = C == 0 ? null :
	        V == r ? (g - b) / C :
	        V == g ? (b - r) / C + 2 :
	                 (r - g) / C + 4;
	    H = (H + 360) % 6 * 60 / 360;
	    S = C == 0 ? 0 : C / V;
	    return {h: H, s: S, b: V, toString: hsbtoString};
	};
	/*\
	 * Snap.rgb2hsl
	 [ method ]
	 **
	 * Converts RGB values to an HSL object
	 - r (number) red
	 - g (number) green
	 - b (number) blue
	 = (object) HSL object in the following format:
	 o {
	 o     h (number) hue,
	 o     s (number) saturation,
	 o     l (number) luminosity
	 o }
	\*/
	Snap.rgb2hsl = function (r, g, b) {
	    b = prepareRGB(r, g, b);
	    r = b[0];
	    g = b[1];
	    b = b[2];
	
	    var H, S, L, M, m, C;
	    M = mmax(r, g, b);
	    m = mmin(r, g, b);
	    C = M - m;
	    H = C == 0 ? null :
	        M == r ? (g - b) / C :
	        M == g ? (b - r) / C + 2 :
	                 (r - g) / C + 4;
	    H = (H + 360) % 6 * 60 / 360;
	    L = (M + m) / 2;
	    S = C == 0 ? 0 :
	         L < .5 ? C / (2 * L) :
	                  C / (2 - 2 * L);
	    return {h: H, s: S, l: L, toString: hsltoString};
	};
	
	// Transformations
	/*\
	 * Snap.parsePathString
	 [ method ]
	 **
	 * Utility method
	 **
	 * Parses given path string into an array of arrays of path segments
	 - pathString (string|array) path string or array of segments (in the last case it is returned straight away)
	 = (array) array of segments
	\*/
	Snap.parsePathString = function (pathString) {
	    if (!pathString) {
	        return null;
	    }
	    var pth = Snap.path(pathString);
	    if (pth.arr) {
	        return Snap.path.clone(pth.arr);
	    }
	
	    var paramCounts = {a: 7, c: 6, o: 2, h: 1, l: 2, m: 2, r: 4, q: 4, s: 4, t: 2, v: 1, u: 3, z: 0},
	        data = [];
	    if (is(pathString, "array") && is(pathString[0], "array")) { // rough assumption
	        data = Snap.path.clone(pathString);
	    }
	    if (!data.length) {
	        Str(pathString).replace(pathCommand, function (a, b, c) {
	            var params = [],
	                name = b.toLowerCase();
	            c.replace(pathValues, function (a, b) {
	                b && params.push(+b);
	            });
	            if (name == "m" && params.length > 2) {
	                data.push([b].concat(params.splice(0, 2)));
	                name = "l";
	                b = b == "m" ? "l" : "L";
	            }
	            if (name == "o" && params.length == 1) {
	                data.push([b, params[0]]);
	            }
	            if (name == "r") {
	                data.push([b].concat(params));
	            } else while (params.length >= paramCounts[name]) {
	                data.push([b].concat(params.splice(0, paramCounts[name])));
	                if (!paramCounts[name]) {
	                    break;
	                }
	            }
	        });
	    }
	    data.toString = Snap.path.toString;
	    pth.arr = Snap.path.clone(data);
	    return data;
	};
	/*\
	 * Snap.parseTransformString
	 [ method ]
	 **
	 * Utility method
	 **
	 * Parses given transform string into an array of transformations
	 - TString (string|array) transform string or array of transformations (in the last case it is returned straight away)
	 = (array) array of transformations
	\*/
	var parseTransformString = Snap.parseTransformString = function (TString) {
	    if (!TString) {
	        return null;
	    }
	    var paramCounts = {r: 3, s: 4, t: 2, m: 6},
	        data = [];
	    if (is(TString, "array") && is(TString[0], "array")) { // rough assumption
	        data = Snap.path.clone(TString);
	    }
	    if (!data.length) {
	        Str(TString).replace(tCommand, function (a, b, c) {
	            var params = [],
	                name = b.toLowerCase();
	            c.replace(pathValues, function (a, b) {
	                b && params.push(+b);
	            });
	            data.push([b].concat(params));
	        });
	    }
	    data.toString = Snap.path.toString;
	    return data;
	};
	function svgTransform2string(tstr) {
	    var res = [];
	    tstr = tstr.replace(/(?:^|\s)(\w+)\(([^)]+)\)/g, function (all, name, params) {
	        params = params.split(/\s*,\s*|\s+/);
	        if (name == "rotate" && params.length == 1) {
	            params.push(0, 0);
	        }
	        if (name == "scale") {
	            if (params.length > 2) {
	                params = params.slice(0, 2);
	            } else if (params.length == 2) {
	                params.push(0, 0);
	            }
	            if (params.length == 1) {
	                params.push(params[0], 0, 0);
	            }
	        }
	        if (name == "skewX") {
	            res.push(["m", 1, 0, math.tan(rad(params[0])), 1, 0, 0]);
	        } else if (name == "skewY") {
	            res.push(["m", 1, math.tan(rad(params[0])), 0, 1, 0, 0]);
	        } else {
	            res.push([name.charAt(0)].concat(params));
	        }
	        return all;
	    });
	    return res;
	}
	Snap._.svgTransform2string = svgTransform2string;
	Snap._.rgTransform = /^[a-z][\s]*-?\.?\d/i;
	function transform2matrix(tstr, bbox) {
	    var tdata = parseTransformString(tstr),
	        m = new Snap.Matrix;
	    if (tdata) {
	        for (var i = 0, ii = tdata.length; i < ii; i++) {
	            var t = tdata[i],
	                tlen = t.length,
	                command = Str(t[0]).toLowerCase(),
	                absolute = t[0] != command,
	                inver = absolute ? m.invert() : 0,
	                x1,
	                y1,
	                x2,
	                y2,
	                bb;
	            if (command == "t" && tlen == 2){
	                m.translate(t[1], 0);
	            } else if (command == "t" && tlen == 3) {
	                if (absolute) {
	                    x1 = inver.x(0, 0);
	                    y1 = inver.y(0, 0);
	                    x2 = inver.x(t[1], t[2]);
	                    y2 = inver.y(t[1], t[2]);
	                    m.translate(x2 - x1, y2 - y1);
	                } else {
	                    m.translate(t[1], t[2]);
	                }
	            } else if (command == "r") {
	                if (tlen == 2) {
	                    bb = bb || bbox;
	                    m.rotate(t[1], bb.x + bb.width / 2, bb.y + bb.height / 2);
	                } else if (tlen == 4) {
	                    if (absolute) {
	                        x2 = inver.x(t[2], t[3]);
	                        y2 = inver.y(t[2], t[3]);
	                        m.rotate(t[1], x2, y2);
	                    } else {
	                        m.rotate(t[1], t[2], t[3]);
	                    }
	                }
	            } else if (command == "s") {
	                if (tlen == 2 || tlen == 3) {
	                    bb = bb || bbox;
	                    m.scale(t[1], t[tlen - 1], bb.x + bb.width / 2, bb.y + bb.height / 2);
	                } else if (tlen == 4) {
	                    if (absolute) {
	                        x2 = inver.x(t[2], t[3]);
	                        y2 = inver.y(t[2], t[3]);
	                        m.scale(t[1], t[1], x2, y2);
	                    } else {
	                        m.scale(t[1], t[1], t[2], t[3]);
	                    }
	                } else if (tlen == 5) {
	                    if (absolute) {
	                        x2 = inver.x(t[3], t[4]);
	                        y2 = inver.y(t[3], t[4]);
	                        m.scale(t[1], t[2], x2, y2);
	                    } else {
	                        m.scale(t[1], t[2], t[3], t[4]);
	                    }
	                }
	            } else if (command == "m" && tlen == 7) {
	                m.add(t[1], t[2], t[3], t[4], t[5], t[6]);
	            }
	        }
	    }
	    return m;
	}
	Snap._.transform2matrix = transform2matrix;
	Snap._unit2px = unit2px;
	var contains = glob.doc.contains || glob.doc.compareDocumentPosition ?
	    function (a, b) {
	        var adown = a.nodeType == 9 ? a.documentElement : a,
	            bup = b && b.parentNode;
	            return a == bup || !!(bup && bup.nodeType == 1 && (
	                adown.contains ?
	                    adown.contains(bup) :
	                    a.compareDocumentPosition && a.compareDocumentPosition(bup) & 16
	            ));
	    } :
	    function (a, b) {
	        if (b) {
	            while (b) {
	                b = b.parentNode;
	                if (b == a) {
	                    return true;
	                }
	            }
	        }
	        return false;
	    };
	function getSomeDefs(el) {
	    var p = el.node.ownerSVGElement && wrap(el.node.ownerSVGElement) ||
	            el.node.parentNode && wrap(el.node.parentNode) ||
	            Snap.select("svg") ||
	            Snap(0, 0),
	        pdefs = p.select("defs"),
	        defs  = pdefs == null ? false : pdefs.node;
	    if (!defs) {
	        defs = make("defs", p.node).node;
	    }
	    return defs;
	}
	function getSomeSVG(el) {
	    return el.node.ownerSVGElement && wrap(el.node.ownerSVGElement) || Snap.select("svg");
	}
	Snap._.getSomeDefs = getSomeDefs;
	Snap._.getSomeSVG = getSomeSVG;
	function unit2px(el, name, value) {
	    var svg = getSomeSVG(el).node,
	        out = {},
	        mgr = svg.querySelector(".svg---mgr");
	    if (!mgr) {
	        mgr = $("rect");
	        $(mgr, {x: -9e9, y: -9e9, width: 10, height: 10, "class": "svg---mgr", fill: "none"});
	        svg.appendChild(mgr);
	    }
	    function getW(val) {
	        if (val == null) {
	            return E;
	        }
	        if (val == +val) {
	            return val;
	        }
	        $(mgr, {width: val});
	        try {
	            return mgr.getBBox().width;
	        } catch (e) {
	            return 0;
	        }
	    }
	    function getH(val) {
	        if (val == null) {
	            return E;
	        }
	        if (val == +val) {
	            return val;
	        }
	        $(mgr, {height: val});
	        try {
	            return mgr.getBBox().height;
	        } catch (e) {
	            return 0;
	        }
	    }
	    function set(nam, f) {
	        if (name == null) {
	            out[nam] = f(el.attr(nam) || 0);
	        } else if (nam == name) {
	            out = f(value == null ? el.attr(nam) || 0 : value);
	        }
	    }
	    switch (el.type) {
	        case "rect":
	            set("rx", getW);
	            set("ry", getH);
	        case "image":
	            set("width", getW);
	            set("height", getH);
	        case "text":
	            set("x", getW);
	            set("y", getH);
	        break;
	        case "circle":
	            set("cx", getW);
	            set("cy", getH);
	            set("r", getW);
	        break;
	        case "ellipse":
	            set("cx", getW);
	            set("cy", getH);
	            set("rx", getW);
	            set("ry", getH);
	        break;
	        case "line":
	            set("x1", getW);
	            set("x2", getW);
	            set("y1", getH);
	            set("y2", getH);
	        break;
	        case "marker":
	            set("refX", getW);
	            set("markerWidth", getW);
	            set("refY", getH);
	            set("markerHeight", getH);
	        break;
	        case "radialGradient":
	            set("fx", getW);
	            set("fy", getH);
	        break;
	        case "tspan":
	            set("dx", getW);
	            set("dy", getH);
	        break;
	        default:
	            set(name, getW);
	    }
	    svg.removeChild(mgr);
	    return out;
	}
	/*\
	 * Snap.select
	 [ method ]
	 **
	 * Wraps a DOM element specified by CSS selector as @Element
	 - query (string) CSS selector of the element
	 = (Element) the current element
	\*/
	Snap.select = function (query) {
	    query = Str(query).replace(/([^\\]):/g, "$1\\:");
	    return wrap(glob.doc.querySelector(query));
	};
	/*\
	 * Snap.selectAll
	 [ method ]
	 **
	 * Wraps DOM elements specified by CSS selector as set or array of @Element
	 - query (string) CSS selector of the element
	 = (Element) the current element
	\*/
	Snap.selectAll = function (query) {
	    var nodelist = glob.doc.querySelectorAll(query),
	        set = (Snap.set || Array)();
	    for (var i = 0; i < nodelist.length; i++) {
	        set.push(wrap(nodelist[i]));
	    }
	    return set;
	};
	
	function add2group(list) {
	    if (!is(list, "array")) {
	        list = Array.prototype.slice.call(arguments, 0);
	    }
	    var i = 0,
	        j = 0,
	        node = this.node;
	    while (this[i]) delete this[i++];
	    for (i = 0; i < list.length; i++) {
	        if (list[i].type == "set") {
	            list[i].forEach(function (el) {
	                node.appendChild(el.node);
	            });
	        } else {
	            node.appendChild(list[i].node);
	        }
	    }
	    var children = node.childNodes;
	    for (i = 0; i < children.length; i++) {
	        this[j++] = wrap(children[i]);
	    }
	    return this;
	}
	// Hub garbage collector every 10s
	setInterval(function () {
	    for (var key in hub) if (hub[has](key)) {
	        var el = hub[key],
	            node = el.node;
	        if (el.type != "svg" && !node.ownerSVGElement || el.type == "svg" && (!node.parentNode || "ownerSVGElement" in node.parentNode && !node.ownerSVGElement)) {
	            delete hub[key];
	        }
	    }
	}, 1e4);
	function Element(el) {
	    if (el.snap in hub) {
	        return hub[el.snap];
	    }
	    var svg;
	    try {
	        svg = el.ownerSVGElement;
	    } catch(e) {}
	    /*\
	     * Element.node
	     [ property (object) ]
	     **
	     * Gives you a reference to the DOM object, so you can assign event handlers or just mess around.
	     > Usage
	     | // draw a circle at coordinate 10,10 with radius of 10
	     | var c = paper.circle(10, 10, 10);
	     | c.node.onclick = function () {
	     |     c.attr("fill", "red");
	     | };
	    \*/
	    this.node = el;
	    if (svg) {
	        this.paper = new Paper(svg);
	    }
	    /*\
	     * Element.type
	     [ property (string) ]
	     **
	     * SVG tag name of the given element.
	    \*/
	    this.type = el.tagName || el.nodeName;
	    var id = this.id = ID(this);
	    this.anims = {};
	    this._ = {
	        transform: []
	    };
	    el.snap = id;
	    hub[id] = this;
	    if (this.type == "g") {
	        this.add = add2group;
	    }
	    if (this.type in {g: 1, mask: 1, pattern: 1, symbol: 1}) {
	        for (var method in Paper.prototype) if (Paper.prototype[has](method)) {
	            this[method] = Paper.prototype[method];
	        }
	    }
	}
	   /*\
	     * Element.attr
	     [ method ]
	     **
	     * Gets or sets given attributes of the element.
	     **
	     - params (object) contains key-value pairs of attributes you want to set
	     * or
	     - param (string) name of the attribute
	     = (Element) the current element
	     * or
	     = (string) value of attribute
	     > Usage
	     | el.attr({
	     |     fill: "#fc0",
	     |     stroke: "#000",
	     |     strokeWidth: 2, // CamelCase...
	     |     "fill-opacity": 0.5, // or dash-separated names
	     |     width: "*=2" // prefixed values
	     | });
	     | console.log(el.attr("fill")); // #fc0
	     * Prefixed values in format `"+=10"` supported. All four operations
	     * (`+`, `-`, `*` and `/`) could be used. Optionally you can use units for `+`
	     * and `-`: `"+=2em"`.
	    \*/
	    Element.prototype.attr = function (params, value) {
	        var el = this,
	            node = el.node;
	        if (!params) {
	            if (node.nodeType != 1) {
	                return {
	                    text: node.nodeValue
	                };
	            }
	            var attr = node.attributes,
	                out = {};
	            for (var i = 0, ii = attr.length; i < ii; i++) {
	                out[attr[i].nodeName] = attr[i].nodeValue;
	            }
	            return out;
	        }
	        if (is(params, "string")) {
	            if (arguments.length > 1) {
	                var json = {};
	                json[params] = value;
	                params = json;
	            } else {
	                return eve("snap.util.getattr." + params, el).firstDefined();
	            }
	        }
	        for (var att in params) {
	            if (params[has](att)) {
	                eve("snap.util.attr." + att, el, params[att]);
	            }
	        }
	        return el;
	    };
	/*\
	 * Snap.parse
	 [ method ]
	 **
	 * Parses SVG fragment and converts it into a @Fragment
	 **
	 - svg (string) SVG string
	 = (Fragment) the @Fragment
	\*/
	Snap.parse = function (svg) {
	    var f = glob.doc.createDocumentFragment(),
	        full = true,
	        div = glob.doc.createElement("div");
	    svg = Str(svg);
	    if (!svg.match(/^\s*<\s*svg(?:\s|>)/)) {
	        svg = "<svg>" + svg + "</svg>";
	        full = false;
	    }
	    div.innerHTML = svg;
	    svg = div.getElementsByTagName("svg")[0];
	    if (svg) {
	        if (full) {
	            f = svg;
	        } else {
	            while (svg.firstChild) {
	                f.appendChild(svg.firstChild);
	            }
	        }
	    }
	    return new Fragment(f);
	};
	function Fragment(frag) {
	    this.node = frag;
	}
	/*\
	 * Snap.fragment
	 [ method ]
	 **
	 * Creates a DOM fragment from a given list of elements or strings
	 **
	 - varargs (…) SVG string
	 = (Fragment) the @Fragment
	\*/
	Snap.fragment = function () {
	    var args = Array.prototype.slice.call(arguments, 0),
	        f = glob.doc.createDocumentFragment();
	    for (var i = 0, ii = args.length; i < ii; i++) {
	        var item = args[i];
	        if (item.node && item.node.nodeType) {
	            f.appendChild(item.node);
	        }
	        if (item.nodeType) {
	            f.appendChild(item);
	        }
	        if (typeof item == "string") {
	            f.appendChild(Snap.parse(item).node);
	        }
	    }
	    return new Fragment(f);
	};
	
	function make(name, parent) {
	    var res = $(name);
	    parent.appendChild(res);
	    var el = wrap(res);
	    return el;
	}
	function Paper(w, h) {
	    var res,
	        desc,
	        defs,
	        proto = Paper.prototype;
	    if (w && w.tagName && w.tagName.toLowerCase() == "svg") {
	        if (w.snap in hub) {
	            return hub[w.snap];
	        }
	        var doc = w.ownerDocument;
	        res = new Element(w);
	        desc = w.getElementsByTagName("desc")[0];
	        defs = w.getElementsByTagName("defs")[0];
	        if (!desc) {
	            desc = $("desc");
	            desc.appendChild(doc.createTextNode("Created with Snap"));
	            res.node.appendChild(desc);
	        }
	        if (!defs) {
	            defs = $("defs");
	            res.node.appendChild(defs);
	        }
	        res.defs = defs;
	        for (var key in proto) if (proto[has](key)) {
	            res[key] = proto[key];
	        }
	        res.paper = res.root = res;
	    } else {
	        res = make("svg", glob.doc.body);
	        $(res.node, {
	            height: h,
	            version: 1.1,
	            width: w,
	            xmlns: xmlns
	        });
	    }
	    return res;
	}
	function wrap(dom) {
	    if (!dom) {
	        return dom;
	    }
	    if (dom instanceof Element || dom instanceof Fragment) {
	        return dom;
	    }
	    if (dom.tagName && dom.tagName.toLowerCase() == "svg") {
	        return new Paper(dom);
	    }
	    if (dom.tagName && dom.tagName.toLowerCase() == "object" && dom.type == "image/svg+xml") {
	        return new Paper(dom.contentDocument.getElementsByTagName("svg")[0]);
	    }
	    return new Element(dom);
	}
	
	Snap._.make = make;
	Snap._.wrap = wrap;
	/*\
	 * Paper.el
	 [ method ]
	 **
	 * Creates an element on paper with a given name and no attributes
	 **
	 - name (string) tag name
	 - attr (object) attributes
	 = (Element) the current element
	 > Usage
	 | var c = paper.circle(10, 10, 10); // is the same as...
	 | var c = paper.el("circle").attr({
	 |     cx: 10,
	 |     cy: 10,
	 |     r: 10
	 | });
	 | // and the same as
	 | var c = paper.el("circle", {
	 |     cx: 10,
	 |     cy: 10,
	 |     r: 10
	 | });
	\*/
	Paper.prototype.el = function (name, attr) {
	    var el = make(name, this.node);
	    attr && el.attr(attr);
	    return el;
	};
	/*\
	 * Element.children
	 [ method ]
	 **
	 * Returns array of all the children of the element.
	 = (array) array of Elements
	\*/
	Element.prototype.children = function () {
	    var out = [],
	        ch = this.node.childNodes;
	    for (var i = 0, ii = ch.length; i < ii; i++) {
	        out[i] = Snap(ch[i]);
	    }
	    return out;
	};
	function jsonFiller(root, o) {
	    for (var i = 0, ii = root.length; i < ii; i++) {
	        var item = {
	                type: root[i].type,
	                attr: root[i].attr()
	            },
	            children = root[i].children();
	        o.push(item);
	        if (children.length) {
	            jsonFiller(children, item.childNodes = []);
	        }
	    }
	}
	/*\
	 * Element.toJSON
	 [ method ]
	 **
	 * Returns object representation of the given element and all its children.
	 = (object) in format
	 o {
	 o     type (string) this.type,
	 o     attr (object) attributes map,
	 o     childNodes (array) optional array of children in the same format
	 o }
	\*/
	Element.prototype.toJSON = function () {
	    var out = [];
	    jsonFiller([this], out);
	    return out[0];
	};
	// default
	eve.on("snap.util.getattr", function () {
	    var att = eve.nt();
	    att = att.substring(att.lastIndexOf(".") + 1);
	    var css = att.replace(/[A-Z]/g, function (letter) {
	        return "-" + letter.toLowerCase();
	    });
	    if (cssAttr[has](css)) {
	        return this.node.ownerDocument.defaultView.getComputedStyle(this.node, null).getPropertyValue(css);
	    } else {
	        return $(this.node, att);
	    }
	});
	var cssAttr = {
	    "alignment-baseline": 0,
	    "baseline-shift": 0,
	    "clip": 0,
	    "clip-path": 0,
	    "clip-rule": 0,
	    "color": 0,
	    "color-interpolation": 0,
	    "color-interpolation-filters": 0,
	    "color-profile": 0,
	    "color-rendering": 0,
	    "cursor": 0,
	    "direction": 0,
	    "display": 0,
	    "dominant-baseline": 0,
	    "enable-background": 0,
	    "fill": 0,
	    "fill-opacity": 0,
	    "fill-rule": 0,
	    "filter": 0,
	    "flood-color": 0,
	    "flood-opacity": 0,
	    "font": 0,
	    "font-family": 0,
	    "font-size": 0,
	    "font-size-adjust": 0,
	    "font-stretch": 0,
	    "font-style": 0,
	    "font-variant": 0,
	    "font-weight": 0,
	    "glyph-orientation-horizontal": 0,
	    "glyph-orientation-vertical": 0,
	    "image-rendering": 0,
	    "kerning": 0,
	    "letter-spacing": 0,
	    "lighting-color": 0,
	    "marker": 0,
	    "marker-end": 0,
	    "marker-mid": 0,
	    "marker-start": 0,
	    "mask": 0,
	    "opacity": 0,
	    "overflow": 0,
	    "pointer-events": 0,
	    "shape-rendering": 0,
	    "stop-color": 0,
	    "stop-opacity": 0,
	    "stroke": 0,
	    "stroke-dasharray": 0,
	    "stroke-dashoffset": 0,
	    "stroke-linecap": 0,
	    "stroke-linejoin": 0,
	    "stroke-miterlimit": 0,
	    "stroke-opacity": 0,
	    "stroke-width": 0,
	    "text-anchor": 0,
	    "text-decoration": 0,
	    "text-rendering": 0,
	    "unicode-bidi": 0,
	    "visibility": 0,
	    "word-spacing": 0,
	    "writing-mode": 0
	};
	
	eve.on("snap.util.attr", function (value) {
	    var att = eve.nt(),
	        attr = {};
	    att = att.substring(att.lastIndexOf(".") + 1);
	    attr[att] = value;
	    var style = att.replace(/-(\w)/gi, function (all, letter) {
	            return letter.toUpperCase();
	        }),
	        css = att.replace(/[A-Z]/g, function (letter) {
	            return "-" + letter.toLowerCase();
	        });
	    if (cssAttr[has](css)) {
	        this.node.style[style] = value == null ? E : value;
	    } else {
	        $(this.node, attr);
	    }
	});
	(function (proto) {}(Paper.prototype));
	
	// simple ajax
	/*\
	 * Snap.ajax
	 [ method ]
	 **
	 * Simple implementation of Ajax
	 **
	 - url (string) URL
	 - postData (object|string) data for post request
	 - callback (function) callback
	 - scope (object) #optional scope of callback
	 * or
	 - url (string) URL
	 - callback (function) callback
	 - scope (object) #optional scope of callback
	 = (XMLHttpRequest) the XMLHttpRequest object, just in case
	\*/
	Snap.ajax = function (url, postData, callback, scope){
	    var req = new XMLHttpRequest,
	        id = ID();
	    if (req) {
	        if (is(postData, "function")) {
	            scope = callback;
	            callback = postData;
	            postData = null;
	        } else if (is(postData, "object")) {
	            var pd = [];
	            for (var key in postData) if (postData.hasOwnProperty(key)) {
	                pd.push(encodeURIComponent(key) + "=" + encodeURIComponent(postData[key]));
	            }
	            postData = pd.join("&");
	        }
	        req.open(postData ? "POST" : "GET", url, true);
	        if (postData) {
	            req.setRequestHeader("X-Requested-With", "XMLHttpRequest");
	            req.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
	        }
	        if (callback) {
	            eve.once("snap.ajax." + id + ".0", callback);
	            eve.once("snap.ajax." + id + ".200", callback);
	            eve.once("snap.ajax." + id + ".304", callback);
	        }
	        req.onreadystatechange = function() {
	            if (req.readyState != 4) return;
	            eve("snap.ajax." + id + "." + req.status, scope, req);
	        };
	        if (req.readyState == 4) {
	            return req;
	        }
	        req.send(postData);
	        return req;
	    }
	};
	/*\
	 * Snap.load
	 [ method ]
	 **
	 * Loads external SVG file as a @Fragment (see @Snap.ajax for more advanced AJAX)
	 **
	 - url (string) URL
	 - callback (function) callback
	 - scope (object) #optional scope of callback
	\*/
	Snap.load = function (url, callback, scope) {
	    Snap.ajax(url, function (req) {
	        var f = Snap.parse(req.responseText);
	        scope ? callback.call(scope, f) : callback(f);
	    });
	};
	var getOffset = function (elem) {
	    var box = elem.getBoundingClientRect(),
	        doc = elem.ownerDocument,
	        body = doc.body,
	        docElem = doc.documentElement,
	        clientTop = docElem.clientTop || body.clientTop || 0, clientLeft = docElem.clientLeft || body.clientLeft || 0,
	        top  = box.top  + (g.win.pageYOffset || docElem.scrollTop || body.scrollTop ) - clientTop,
	        left = box.left + (g.win.pageXOffset || docElem.scrollLeft || body.scrollLeft) - clientLeft;
	    return {
	        y: top,
	        x: left
	    };
	};
	/*\
	 * Snap.getElementByPoint
	 [ method ]
	 **
	 * Returns you topmost element under given point.
	 **
	 = (object) Snap element object
	 - x (number) x coordinate from the top left corner of the window
	 - y (number) y coordinate from the top left corner of the window
	 > Usage
	 | Snap.getElementByPoint(mouseX, mouseY).attr({stroke: "#f00"});
	\*/
	Snap.getElementByPoint = function (x, y) {
	    var paper = this,
	        svg = paper.canvas,
	        target = glob.doc.elementFromPoint(x, y);
	    if (glob.win.opera && target.tagName == "svg") {
	        var so = getOffset(target),
	            sr = target.createSVGRect();
	        sr.x = x - so.x;
	        sr.y = y - so.y;
	        sr.width = sr.height = 1;
	        var hits = target.getIntersectionList(sr, null);
	        if (hits.length) {
	            target = hits[hits.length - 1];
	        }
	    }
	    if (!target) {
	        return null;
	    }
	    return wrap(target);
	};
	/*\
	 * Snap.plugin
	 [ method ]
	 **
	 * Let you write plugins. You pass in a function with five arguments, like this:
	 | Snap.plugin(function (Snap, Element, Paper, global, Fragment) {
	 |     Snap.newmethod = function () {};
	 |     Element.prototype.newmethod = function () {};
	 |     Paper.prototype.newmethod = function () {};
	 | });
	 * Inside the function you have access to all main objects (and their
	 * prototypes). This allow you to extend anything you want.
	 **
	 - f (function) your plugin body
	\*/
	Snap.plugin = function (f) {
	    f(Snap, Element, Paper, glob, Fragment);
	};
	glob.win.Snap = Snap;
	return Snap;
	}(window || this));
	
	// Copyright (c) 2013 Adobe Systems Incorporated. All rights reserved.
	//
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//
	// http://www.apache.org/licenses/LICENSE-2.0
	//
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// See the License for the specific language governing permissions and
	// limitations under the License.
	Snap.plugin(function (Snap, Element, Paper, glob, Fragment) {
	    var elproto = Element.prototype,
	        is = Snap.is,
	        Str = String,
	        unit2px = Snap._unit2px,
	        $ = Snap._.$,
	        make = Snap._.make,
	        getSomeDefs = Snap._.getSomeDefs,
	        has = "hasOwnProperty",
	        wrap = Snap._.wrap;
	    /*\
	     * Element.getBBox
	     [ method ]
	     **
	     * Returns the bounding box descriptor for the given element
	     **
	     = (object) bounding box descriptor:
	     o {
	     o     cx: (number) x of the center,
	     o     cy: (number) x of the center,
	     o     h: (number) height,
	     o     height: (number) height,
	     o     path: (string) path command for the box,
	     o     r0: (number) radius of a circle that fully encloses the box,
	     o     r1: (number) radius of the smallest circle that can be enclosed,
	     o     r2: (number) radius of the largest circle that can be enclosed,
	     o     vb: (string) box as a viewbox command,
	     o     w: (number) width,
	     o     width: (number) width,
	     o     x2: (number) x of the right side,
	     o     x: (number) x of the left side,
	     o     y2: (number) y of the bottom edge,
	     o     y: (number) y of the top edge
	     o }
	    \*/
	    elproto.getBBox = function (isWithoutTransform) {
	        if (this.type == "tspan") {
	            return Snap._.box(this.node.getClientRects().item(0));
	        }
	        if (!Snap.Matrix || !Snap.path) {
	            return this.node.getBBox();
	        }
	        var el = this,
	            m = new Snap.Matrix;
	        if (el.removed) {
	            return Snap._.box();
	        }
	        while (el.type == "use") {
	            if (!isWithoutTransform) {
	                m = m.add(el.transform().localMatrix.translate(el.attr("x") || 0, el.attr("y") || 0));
	            }
	            if (el.original) {
	                el = el.original;
	            } else {
	                var href = el.attr("xlink:href");
	                el = el.original = el.node.ownerDocument.getElementById(href.substring(href.indexOf("#") + 1));
	            }
	        }
	        var _ = el._,
	            pathfinder = Snap.path.get[el.type] || Snap.path.get.deflt;
	        try {
	            if (isWithoutTransform) {
	                _.bboxwt = pathfinder ? Snap.path.getBBox(el.realPath = pathfinder(el)) : Snap._.box(el.node.getBBox());
	                return Snap._.box(_.bboxwt);
	            } else {
	                el.realPath = pathfinder(el);
	                el.matrix = el.transform().localMatrix;
	                _.bbox = Snap.path.getBBox(Snap.path.map(el.realPath, m.add(el.matrix)));
	                return Snap._.box(_.bbox);
	            }
	        } catch (e) {
	            // Firefox doesn’t give you bbox of hidden element
	            return Snap._.box();
	        }
	    };
	    var propString = function () {
	        return this.string;
	    };
	    function extractTransform(el, tstr) {
	        if (tstr == null) {
	            var doReturn = true;
	            if (el.type == "linearGradient" || el.type == "radialGradient") {
	                tstr = el.node.getAttribute("gradientTransform");
	            } else if (el.type == "pattern") {
	                tstr = el.node.getAttribute("patternTransform");
	            } else {
	                tstr = el.node.getAttribute("transform");
	            }
	            if (!tstr) {
	                return new Snap.Matrix;
	            }
	            tstr = Snap._.svgTransform2string(tstr);
	        } else {
	            if (!Snap._.rgTransform.test(tstr)) {
	                tstr = Snap._.svgTransform2string(tstr);
	            } else {
	                tstr = Str(tstr).replace(/\.{3}|\u2026/g, el._.transform || "");
	            }
	            if (is(tstr, "array")) {
	                tstr = Snap.path ? Snap.path.toString.call(tstr) : Str(tstr);
	            }
	            el._.transform = tstr;
	        }
	        var m = Snap._.transform2matrix(tstr, el.getBBox(1));
	        if (doReturn) {
	            return m;
	        } else {
	            el.matrix = m;
	        }
	    }
	    /*\
	     * Element.transform
	     [ method ]
	     **
	     * Gets or sets transformation of the element
	     **
	     - tstr (string) transform string in Snap or SVG format
	     = (Element) the current element
	     * or
	     = (object) transformation descriptor:
	     o {
	     o     string (string) transform string,
	     o     globalMatrix (Matrix) matrix of all transformations applied to element or its parents,
	     o     localMatrix (Matrix) matrix of transformations applied only to the element,
	     o     diffMatrix (Matrix) matrix of difference between global and local transformations,
	     o     global (string) global transformation as string,
	     o     local (string) local transformation as string,
	     o     toString (function) returns `string` property
	     o }
	    \*/
	    elproto.transform = function (tstr) {
	        var _ = this._;
	        if (tstr == null) {
	            var papa = this,
	                global = new Snap.Matrix(this.node.getCTM()),
	                local = extractTransform(this),
	                ms = [local],
	                m = new Snap.Matrix,
	                i,
	                localString = local.toTransformString(),
	                string = Str(local) == Str(this.matrix) ?
	                            Str(_.transform) : localString;
	            while (papa.type != "svg" && (papa = papa.parent())) {
	                ms.push(extractTransform(papa));
	            }
	            i = ms.length;
	            while (i--) {
	                m.add(ms[i]);
	            }
	            return {
	                string: string,
	                globalMatrix: global,
	                totalMatrix: m,
	                localMatrix: local,
	                diffMatrix: global.clone().add(local.invert()),
	                global: global.toTransformString(),
	                total: m.toTransformString(),
	                local: localString,
	                toString: propString
	            };
	        }
	        if (tstr instanceof Snap.Matrix) {
	            this.matrix = tstr;
	            this._.transform = tstr.toTransformString();
	        } else {
	            extractTransform(this, tstr);
	        }
	
	        if (this.node) {
	            if (this.type == "linearGradient" || this.type == "radialGradient") {
	                $(this.node, {gradientTransform: this.matrix});
	            } else if (this.type == "pattern") {
	                $(this.node, {patternTransform: this.matrix});
	            } else {
	                $(this.node, {transform: this.matrix});
	            }
	        }
	
	        return this;
	    };
	    /*\
	     * Element.parent
	     [ method ]
	     **
	     * Returns the element's parent
	     **
	     = (Element) the parent element
	    \*/
	    elproto.parent = function () {
	        return wrap(this.node.parentNode);
	    };
	    /*\
	     * Element.append
	     [ method ]
	     **
	     * Appends the given element to current one
	     **
	     - el (Element|Set) element to append
	     = (Element) the parent element
	    \*/
	    /*\
	     * Element.add
	     [ method ]
	     **
	     * See @Element.append
	    \*/
	    elproto.append = elproto.add = function (el) {
	        if (el) {
	            if (el.type == "set") {
	                var it = this;
	                el.forEach(function (el) {
	                    it.add(el);
	                });
	                return this;
	            }
	            el = wrap(el);
	            this.node.appendChild(el.node);
	            el.paper = this.paper;
	        }
	        return this;
	    };
	    /*\
	     * Element.appendTo
	     [ method ]
	     **
	     * Appends the current element to the given one
	     **
	     - el (Element) parent element to append to
	     = (Element) the child element
	    \*/
	    elproto.appendTo = function (el) {
	        if (el) {
	            el = wrap(el);
	            el.append(this);
	        }
	        return this;
	    };
	    /*\
	     * Element.prepend
	     [ method ]
	     **
	     * Prepends the given element to the current one
	     **
	     - el (Element) element to prepend
	     = (Element) the parent element
	    \*/
	    elproto.prepend = function (el) {
	        if (el) {
	            if (el.type == "set") {
	                var it = this,
	                    first;
	                el.forEach(function (el) {
	                    if (first) {
	                        first.after(el);
	                    } else {
	                        it.prepend(el);
	                    }
	                    first = el;
	                });
	                return this;
	            }
	            el = wrap(el);
	            var parent = el.parent();
	            this.node.insertBefore(el.node, this.node.firstChild);
	            this.add && this.add();
	            el.paper = this.paper;
	            this.parent() && this.parent().add();
	            parent && parent.add();
	        }
	        return this;
	    };
	    /*\
	     * Element.prependTo
	     [ method ]
	     **
	     * Prepends the current element to the given one
	     **
	     - el (Element) parent element to prepend to
	     = (Element) the child element
	    \*/
	    elproto.prependTo = function (el) {
	        el = wrap(el);
	        el.prepend(this);
	        return this;
	    };
	    /*\
	     * Element.before
	     [ method ]
	     **
	     * Inserts given element before the current one
	     **
	     - el (Element) element to insert
	     = (Element) the parent element
	    \*/
	    elproto.before = function (el) {
	        if (el.type == "set") {
	            var it = this;
	            el.forEach(function (el) {
	                var parent = el.parent();
	                it.node.parentNode.insertBefore(el.node, it.node);
	                parent && parent.add();
	            });
	            this.parent().add();
	            return this;
	        }
	        el = wrap(el);
	        var parent = el.parent();
	        this.node.parentNode.insertBefore(el.node, this.node);
	        this.parent() && this.parent().add();
	        parent && parent.add();
	        el.paper = this.paper;
	        return this;
	    };
	    /*\
	     * Element.after
	     [ method ]
	     **
	     * Inserts given element after the current one
	     **
	     - el (Element) element to insert
	     = (Element) the parent element
	    \*/
	    elproto.after = function (el) {
	        el = wrap(el);
	        var parent = el.parent();
	        if (this.node.nextSibling) {
	            this.node.parentNode.insertBefore(el.node, this.node.nextSibling);
	        } else {
	            this.node.parentNode.appendChild(el.node);
	        }
	        this.parent() && this.parent().add();
	        parent && parent.add();
	        el.paper = this.paper;
	        return this;
	    };
	    /*\
	     * Element.insertBefore
	     [ method ]
	     **
	     * Inserts the element after the given one
	     **
	     - el (Element) element next to whom insert to
	     = (Element) the parent element
	    \*/
	    elproto.insertBefore = function (el) {
	        el = wrap(el);
	        var parent = this.parent();
	        el.node.parentNode.insertBefore(this.node, el.node);
	        this.paper = el.paper;
	        parent && parent.add();
	        el.parent() && el.parent().add();
	        return this;
	    };
	    /*\
	     * Element.insertAfter
	     [ method ]
	     **
	     * Inserts the element after the given one
	     **
	     - el (Element) element next to whom insert to
	     = (Element) the parent element
	    \*/
	    elproto.insertAfter = function (el) {
	        el = wrap(el);
	        var parent = this.parent();
	        el.node.parentNode.insertBefore(this.node, el.node.nextSibling);
	        this.paper = el.paper;
	        parent && parent.add();
	        el.parent() && el.parent().add();
	        return this;
	    };
	    /*\
	     * Element.remove
	     [ method ]
	     **
	     * Removes element from the DOM
	     = (Element) the detached element
	    \*/
	    elproto.remove = function () {
	        var parent = this.parent();
	        this.node.parentNode && this.node.parentNode.removeChild(this.node);
	        delete this.paper;
	        this.removed = true;
	        parent && parent.add();
	        return this;
	    };
	    /*\
	     * Element.select
	     [ method ]
	     **
	     * Gathers the nested @Element matching the given set of CSS selectors
	     **
	     - query (string) CSS selector
	     = (Element) result of query selection
	    \*/
	    elproto.select = function (query) {
	        return wrap(this.node.querySelector(query));
	    };
	    /*\
	     * Element.selectAll
	     [ method ]
	     **
	     * Gathers nested @Element objects matching the given set of CSS selectors
	     **
	     - query (string) CSS selector
	     = (Set|array) result of query selection
	    \*/
	    elproto.selectAll = function (query) {
	        var nodelist = this.node.querySelectorAll(query),
	            set = (Snap.set || Array)();
	        for (var i = 0; i < nodelist.length; i++) {
	            set.push(wrap(nodelist[i]));
	        }
	        return set;
	    };
	    /*\
	     * Element.asPX
	     [ method ]
	     **
	     * Returns given attribute of the element as a `px` value (not %, em, etc.)
	     **
	     - attr (string) attribute name
	     - value (string) #optional attribute value
	     = (Element) result of query selection
	    \*/
	    elproto.asPX = function (attr, value) {
	        if (value == null) {
	            value = this.attr(attr);
	        }
	        return +unit2px(this, attr, value);
	    };
	    // SIERRA Element.use(): I suggest adding a note about how to access the original element the returned <use> instantiates. It's a part of SVG with which ordinary web developers may be least familiar.
	    /*\
	     * Element.use
	     [ method ]
	     **
	     * Creates a `<use>` element linked to the current element
	     **
	     = (Element) the `<use>` element
	    \*/
	    elproto.use = function () {
	        var use,
	            id = this.node.id;
	        if (!id) {
	            id = this.id;
	            $(this.node, {
	                id: id
	            });
	        }
	        if (this.type == "linearGradient" || this.type == "radialGradient" ||
	            this.type == "pattern") {
	            use = make(this.type, this.node.parentNode);
	        } else {
	            use = make("use", this.node.parentNode);
	        }
	        $(use.node, {
	            "xlink:href": "#" + id
	        });
	        use.original = this;
	        return use;
	    };
	    function fixids(el) {
	        var els = el.selectAll("*"),
	            it,
	            url = /^\s*url\(("|'|)(.*)\1\)\s*$/,
	            ids = [],
	            uses = {};
	        function urltest(it, name) {
	            var val = $(it.node, name);
	            val = val && val.match(url);
	            val = val && val[2];
	            if (val && val.charAt() == "#") {
	                val = val.substring(1);
	            } else {
	                return;
	            }
	            if (val) {
	                uses[val] = (uses[val] || []).concat(function (id) {
	                    var attr = {};
	                    attr[name] = Snap.url(id);
	                    $(it.node, attr);
	                });
	            }
	        }
	        function linktest(it) {
	            var val = $(it.node, "xlink:href");
	            if (val && val.charAt() == "#") {
	                val = val.substring(1);
	            } else {
	                return;
	            }
	            if (val) {
	                uses[val] = (uses[val] || []).concat(function (id) {
	                    it.attr("xlink:href", "#" + id);
	                });
	            }
	        }
	        for (var i = 0, ii = els.length; i < ii; i++) {
	            it = els[i];
	            urltest(it, "fill");
	            urltest(it, "stroke");
	            urltest(it, "filter");
	            urltest(it, "mask");
	            urltest(it, "clip-path");
	            linktest(it);
	            var oldid = $(it.node, "id");
	            if (oldid) {
	                $(it.node, {id: it.id});
	                ids.push({
	                    old: oldid,
	                    id: it.id
	                });
	            }
	        }
	        for (i = 0, ii = ids.length; i < ii; i++) {
	            var fs = uses[ids[i].old];
	            if (fs) {
	                for (var j = 0, jj = fs.length; j < jj; j++) {
	                    fs[j](ids[i].id);
	                }
	            }
	        }
	    }
	    /*\
	     * Element.clone
	     [ method ]
	     **
	     * Creates a clone of the element and inserts it after the element
	     **
	     = (Element) the clone
	    \*/
	    elproto.clone = function () {
	        var clone = wrap(this.node.cloneNode(true));
	        if ($(clone.node, "id")) {
	            $(clone.node, {id: clone.id});
	        }
	        fixids(clone);
	        clone.insertAfter(this);
	        return clone;
	    };
	    /*\
	     * Element.toDefs
	     [ method ]
	     **
	     * Moves element to the shared `<defs>` area
	     **
	     = (Element) the element
	    \*/
	    elproto.toDefs = function () {
	        var defs = getSomeDefs(this);
	        defs.appendChild(this.node);
	        return this;
	    };
	    /*\
	     * Element.toPattern
	     [ method ]
	     **
	     * Creates a `<pattern>` element from the current element
	     **
	     * To create a pattern you have to specify the pattern rect:
	     - x (string|number)
	     - y (string|number)
	     - width (string|number)
	     - height (string|number)
	     = (Element) the `<pattern>` element
	     * You can use pattern later on as an argument for `fill` attribute:
	     | var p = paper.path("M10-5-10,15M15,0,0,15M0-5-20,15").attr({
	     |         fill: "none",
	     |         stroke: "#bada55",
	     |         strokeWidth: 5
	     |     }).pattern(0, 0, 10, 10),
	     |     c = paper.circle(200, 200, 100);
	     | c.attr({
	     |     fill: p
	     | });
	    \*/
	    elproto.pattern = elproto.toPattern = function (x, y, width, height) {
	        var p = make("pattern", getSomeDefs(this));
	        if (x == null) {
	            x = this.getBBox();
	        }
	        if (is(x, "object") && "x" in x) {
	            y = x.y;
	            width = x.width;
	            height = x.height;
	            x = x.x;
	        }
	        $(p.node, {
	            x: x,
	            y: y,
	            width: width,
	            height: height,
	            patternUnits: "userSpaceOnUse",
	            id: p.id,
	            viewBox: [x, y, width, height].join(" ")
	        });
	        p.node.appendChild(this.node);
	        return p;
	    };
	// SIERRA Element.marker(): clarify what a reference point is. E.g., helps you offset the object from its edge such as when centering it over a path.
	// SIERRA Element.marker(): I suggest the method should accept default reference point values.  Perhaps centered with (refX = width/2) and (refY = height/2)? Also, couldn't it assume the element's current _width_ and _height_? And please specify what _x_ and _y_ mean: offsets? If so, from where?  Couldn't they also be assigned default values?
	    /*\
	     * Element.marker
	     [ method ]
	     **
	     * Creates a `<marker>` element from the current element
	     **
	     * To create a marker you have to specify the bounding rect and reference point:
	     - x (number)
	     - y (number)
	     - width (number)
	     - height (number)
	     - refX (number)
	     - refY (number)
	     = (Element) the `<marker>` element
	     * You can specify the marker later as an argument for `marker-start`, `marker-end`, `marker-mid`, and `marker` attributes. The `marker` attribute places the marker at every point along the path, and `marker-mid` places them at every point except the start and end.
	    \*/
	    // TODO add usage for markers
	    elproto.marker = function (x, y, width, height, refX, refY) {
	        var p = make("marker", getSomeDefs(this));
	        if (x == null) {
	            x = this.getBBox();
	        }
	        if (is(x, "object") && "x" in x) {
	            y = x.y;
	            width = x.width;
	            height = x.height;
	            refX = x.refX || x.cx;
	            refY = x.refY || x.cy;
	            x = x.x;
	        }
	        $(p.node, {
	            viewBox: [x, y, width, height].join(" "),
	            markerWidth: width,
	            markerHeight: height,
	            orient: "auto",
	            refX: refX || 0,
	            refY: refY || 0,
	            id: p.id
	        });
	        p.node.appendChild(this.node);
	        return p;
	    };
	    var eldata = {};
	    /*\
	     * Element.data
	     [ method ]
	     **
	     * Adds or retrieves given value associated with given key. (Don’t confuse
	     * with `data-` attributes)
	     *
	     * See also @Element.removeData
	     - key (string) key to store data
	     - value (any) #optional value to store
	     = (object) @Element
	     * or, if value is not specified:
	     = (any) value
	     > Usage
	     | for (var i = 0, i < 5, i++) {
	     |     paper.circle(10 + 15 * i, 10, 10)
	     |          .attr({fill: "#000"})
	     |          .data("i", i)
	     |          .click(function () {
	     |             alert(this.data("i"));
	     |          });
	     | }
	    \*/
	    elproto.data = function (key, value) {
	        var data = eldata[this.id] = eldata[this.id] || {};
	        if (arguments.length == 0){
	            eve("snap.data.get." + this.id, this, data, null);
	            return data;
	        }
	        if (arguments.length == 1) {
	            if (Snap.is(key, "object")) {
	                for (var i in key) if (key[has](i)) {
	                    this.data(i, key[i]);
	                }
	                return this;
	            }
	            eve("snap.data.get." + this.id, this, data[key], key);
	            return data[key];
	        }
	        data[key] = value;
	        eve("snap.data.set." + this.id, this, value, key);
	        return this;
	    };
	    /*\
	     * Element.removeData
	     [ method ]
	     **
	     * Removes value associated with an element by given key.
	     * If key is not provided, removes all the data of the element.
	     - key (string) #optional key
	     = (object) @Element
	    \*/
	    elproto.removeData = function (key) {
	        if (key == null) {
	            eldata[this.id] = {};
	        } else {
	            eldata[this.id] && delete eldata[this.id][key];
	        }
	        return this;
	    };
	    /*\
	     * Element.outerSVG
	     [ method ]
	     **
	     * Returns SVG code for the element, equivalent to HTML's `outerHTML`.
	     *
	     * See also @Element.innerSVG
	     = (string) SVG code for the element
	    \*/
	    /*\
	     * Element.toString
	     [ method ]
	     **
	     * See @Element.outerSVG
	    \*/
	    elproto.outerSVG = elproto.toString = toString(1);
	    /*\
	     * Element.innerSVG
	     [ method ]
	     **
	     * Returns SVG code for the element's contents, equivalent to HTML's `innerHTML`
	     = (string) SVG code for the element
	    \*/
	    elproto.innerSVG = toString();
	    function toString(type) {
	        return function () {
	            var res = type ? "<" + this.type : "",
	                attr = this.node.attributes,
	                chld = this.node.childNodes;
	            if (type) {
	                for (var i = 0, ii = attr.length; i < ii; i++) {
	                    res += " " + attr[i].name + '="' +
	                            attr[i].value.replace(/"/g, '\\"') + '"';
	                }
	            }
	            if (chld.length) {
	                type && (res += ">");
	                for (i = 0, ii = chld.length; i < ii; i++) {
	                    if (chld[i].nodeType == 3) {
	                        res += chld[i].nodeValue;
	                    } else if (chld[i].nodeType == 1) {
	                        res += wrap(chld[i]).toString();
	                    }
	                }
	                type && (res += "</" + this.type + ">");
	            } else {
	                type && (res += "/>");
	            }
	            return res;
	        };
	    }
	    elproto.toDataURL = function () {
	        if (window && window.btoa) {
	            var bb = this.getBBox(),
	                svg = Snap.format('<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="{width}" height="{height}" viewBox="{x} {y} {width} {height}">{contents}</svg>', {
	                x: +bb.x.toFixed(3),
	                y: +bb.y.toFixed(3),
	                width: +bb.width.toFixed(3),
	                height: +bb.height.toFixed(3),
	                contents: this.outerSVG()
	            });
	            return "data:image/svg+xml;base64," + btoa(unescape(encodeURIComponent(svg)));
	        }
	    };
	    /*\
	     * Fragment.select
	     [ method ]
	     **
	     * See @Element.select
	    \*/
	    Fragment.prototype.select = elproto.select;
	    /*\
	     * Fragment.selectAll
	     [ method ]
	     **
	     * See @Element.selectAll
	    \*/
	    Fragment.prototype.selectAll = elproto.selectAll;
	});
	
	// Copyright (c) 2013 Adobe Systems Incorporated. All rights reserved.
	//
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//
	// http://www.apache.org/licenses/LICENSE-2.0
	//
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// See the License for the specific language governing permissions and
	// limitations under the License.
	Snap.plugin(function (Snap, Element, Paper, glob, Fragment) {
	    var objectToString = Object.prototype.toString,
	        Str = String,
	        math = Math,
	        E = "";
	    function Matrix(a, b, c, d, e, f) {
	        if (b == null && objectToString.call(a) == "[object SVGMatrix]") {
	            this.a = a.a;
	            this.b = a.b;
	            this.c = a.c;
	            this.d = a.d;
	            this.e = a.e;
	            this.f = a.f;
	            return;
	        }
	        if (a != null) {
	            this.a = +a;
	            this.b = +b;
	            this.c = +c;
	            this.d = +d;
	            this.e = +e;
	            this.f = +f;
	        } else {
	            this.a = 1;
	            this.b = 0;
	            this.c = 0;
	            this.d = 1;
	            this.e = 0;
	            this.f = 0;
	        }
	    }
	    (function (matrixproto) {
	        /*\
	         * Matrix.add
	         [ method ]
	         **
	         * Adds the given matrix to existing one
	         - a (number)
	         - b (number)
	         - c (number)
	         - d (number)
	         - e (number)
	         - f (number)
	         * or
	         - matrix (object) @Matrix
	        \*/
	        matrixproto.add = function (a, b, c, d, e, f) {
	            if (a && a instanceof Matrix) {
	                return this.add(a.a, a.b, a.c, a.d, a.e, a.f);
	            }
	            var aNew = a * this.a + b * this.c,
	                bNew = a * this.b + b * this.d;
	            this.e += e * this.a + f * this.c;
	            this.f += e * this.b + f * this.d;
	            this.c = c * this.a + d * this.c;
	            this.d = c * this.b + d * this.d;
	
	            this.a = aNew;
	            this.b = bNew;
	            return this;
	        };
	        /*\
	         * Matrix.multLeft
	         [ method ]
	         **
	         * Multiplies a passed affine transform to the left: M * this.
	         - a (number)
	         - b (number)
	         - c (number)
	         - d (number)
	         - e (number)
	         - f (number)
	         * or
	         - matrix (object) @Matrix
	        \*/
	        Matrix.prototype.multLeft = function (a, b, c, d, e, f) {
	            if (a && a instanceof Matrix) {
	                return this.multLeft(a.a, a.b, a.c, a.d, a.e, a.f);
	            }
	            var aNew = a * this.a + c * this.b,
	                cNew = a * this.c + c * this.d,
	                eNew = a * this.e + c * this.f + e;
	            this.b = b * this.a + d * this.b;
	            this.d = b * this.c + d * this.d;
	            this.f = b * this.e + d * this.f + f;
	
	            this.a = aNew;
	            this.c = cNew;
	            this.e = eNew;
	            return this;
	        };
	        /*\
	         * Matrix.invert
	         [ method ]
	         **
	         * Returns an inverted version of the matrix
	         = (object) @Matrix
	        \*/
	        matrixproto.invert = function () {
	            var me = this,
	                x = me.a * me.d - me.b * me.c;
	            return new Matrix(me.d / x, -me.b / x, -me.c / x, me.a / x, (me.c * me.f - me.d * me.e) / x, (me.b * me.e - me.a * me.f) / x);
	        };
	        /*\
	         * Matrix.clone
	         [ method ]
	         **
	         * Returns a copy of the matrix
	         = (object) @Matrix
	        \*/
	        matrixproto.clone = function () {
	            return new Matrix(this.a, this.b, this.c, this.d, this.e, this.f);
	        };
	        /*\
	         * Matrix.translate
	         [ method ]
	         **
	         * Translate the matrix
	         - x (number) horizontal offset distance
	         - y (number) vertical offset distance
	        \*/
	        matrixproto.translate = function (x, y) {
	            this.e += x * this.a + y * this.c;
	            this.f += x * this.b + y * this.d;
	            return this;
	        };
	        /*\
	         * Matrix.scale
	         [ method ]
	         **
	         * Scales the matrix
	         - x (number) amount to be scaled, with `1` resulting in no change
	         - y (number) #optional amount to scale along the vertical axis. (Otherwise `x` applies to both axes.)
	         - cx (number) #optional horizontal origin point from which to scale
	         - cy (number) #optional vertical origin point from which to scale
	         * Default cx, cy is the middle point of the element.
	        \*/
	        matrixproto.scale = function (x, y, cx, cy) {
	            y == null && (y = x);
	            (cx || cy) && this.translate(cx, cy);
	            this.a *= x;
	            this.b *= x;
	            this.c *= y;
	            this.d *= y;
	            (cx || cy) && this.translate(-cx, -cy);
	            return this;
	        };
	        /*\
	         * Matrix.rotate
	         [ method ]
	         **
	         * Rotates the matrix
	         - a (number) angle of rotation, in degrees
	         - x (number) horizontal origin point from which to rotate
	         - y (number) vertical origin point from which to rotate
	        \*/
	        matrixproto.rotate = function (a, x, y) {
	            a = Snap.rad(a);
	            x = x || 0;
	            y = y || 0;
	            var cos = +math.cos(a).toFixed(9),
	                sin = +math.sin(a).toFixed(9);
	            this.add(cos, sin, -sin, cos, x, y);
	            return this.add(1, 0, 0, 1, -x, -y);
	        };
	        /*\
	         * Matrix.skewX
	         [ method ]
	         **
	         * Skews the matrix along the x-axis
	         - x (number) Angle to skew along the x-axis (in degrees).
	        \*/
	        matrixproto.skewX = function (x) {
	            return this.skew(x, 0);
	        };
	        /*\
	         * Matrix.skewY
	         [ method ]
	         **
	         * Skews the matrix along the y-axis
	         - y (number) Angle to skew along the y-axis (in degrees).
	        \*/
	        matrixproto.skewY = function (y) {
	            return this.skew(0, y);
	        };
	        /*\
	         * Matrix.skew
	         [ method ]
	         **
	         * Skews the matrix
	         - y (number) Angle to skew along the y-axis (in degrees).
	         - x (number) Angle to skew along the x-axis (in degrees).
	        \*/
	        matrixproto.skew = function (x, y) {
	            x = x || 0;
	            y = y || 0;
	            x = Snap.rad(x);
	            y = Snap.rad(y);
	            var c = math.tan(x).toFixed(9);
	            var b = math.tan(y).toFixed(9);
	            return this.add(1, b, c, 1, 0, 0);
	        };
	        /*\
	         * Matrix.x
	         [ method ]
	         **
	         * Returns x coordinate for given point after transformation described by the matrix. See also @Matrix.y
	         - x (number)
	         - y (number)
	         = (number) x
	        \*/
	        matrixproto.x = function (x, y) {
	            return x * this.a + y * this.c + this.e;
	        };
	        /*\
	         * Matrix.y
	         [ method ]
	         **
	         * Returns y coordinate for given point after transformation described by the matrix. See also @Matrix.x
	         - x (number)
	         - y (number)
	         = (number) y
	        \*/
	        matrixproto.y = function (x, y) {
	            return x * this.b + y * this.d + this.f;
	        };
	        matrixproto.get = function (i) {
	            return +this[Str.fromCharCode(97 + i)].toFixed(4);
	        };
	        matrixproto.toString = function () {
	            return "matrix(" + [this.get(0), this.get(1), this.get(2), this.get(3), this.get(4), this.get(5)].join() + ")";
	        };
	        matrixproto.offset = function () {
	            return [this.e.toFixed(4), this.f.toFixed(4)];
	        };
	        function norm(a) {
	            return a[0] * a[0] + a[1] * a[1];
	        }
	        function normalize(a) {
	            var mag = math.sqrt(norm(a));
	            a[0] && (a[0] /= mag);
	            a[1] && (a[1] /= mag);
	        }
	        /*\
	         * Matrix.determinant
	         [ method ]
	         **
	         * Finds determinant of the given matrix.
	         = (number) determinant
	        \*/
	        matrixproto.determinant = function () {
	            return this.a * this.d - this.b * this.c;
	        };
	        /*\
	         * Matrix.split
	         [ method ]
	         **
	         * Splits matrix into primitive transformations
	         = (object) in format:
	         o dx (number) translation by x
	         o dy (number) translation by y
	         o scalex (number) scale by x
	         o scaley (number) scale by y
	         o shear (number) shear
	         o rotate (number) rotation in deg
	         o isSimple (boolean) could it be represented via simple transformations
	        \*/
	        matrixproto.split = function () {
	            var out = {};
	            // translation
	            out.dx = this.e;
	            out.dy = this.f;
	
	            // scale and shear
	            var row = [[this.a, this.b], [this.c, this.d]];
	            out.scalex = math.sqrt(norm(row[0]));
	            normalize(row[0]);
	
	            out.shear = row[0][0] * row[1][0] + row[0][1] * row[1][1];
	            row[1] = [row[1][0] - row[0][0] * out.shear, row[1][1] - row[0][1] * out.shear];
	
	            out.scaley = math.sqrt(norm(row[1]));
	            normalize(row[1]);
	            out.shear /= out.scaley;
	
	            if (this.determinant() < 0) {
	                out.scalex = -out.scalex;
	            }
	
	            // rotation
	            var sin = row[0][1],
	                cos = row[1][1];
	            if (cos < 0) {
	                out.rotate = Snap.deg(math.acos(cos));
	                if (sin < 0) {
	                    out.rotate = 360 - out.rotate;
	                }
	            } else {
	                out.rotate = Snap.deg(math.asin(sin));
	            }
	
	            out.isSimple = !+out.shear.toFixed(9) && (out.scalex.toFixed(9) == out.scaley.toFixed(9) || !out.rotate);
	            out.isSuperSimple = !+out.shear.toFixed(9) && out.scalex.toFixed(9) == out.scaley.toFixed(9) && !out.rotate;
	            out.noRotation = !+out.shear.toFixed(9) && !out.rotate;
	            return out;
	        };
	        /*\
	         * Matrix.toTransformString
	         [ method ]
	         **
	         * Returns transform string that represents given matrix
	         = (string) transform string
	        \*/
	        matrixproto.toTransformString = function (shorter) {
	            var s = shorter || this.split();
	            if (!+s.shear.toFixed(9)) {
	                s.scalex = +s.scalex.toFixed(4);
	                s.scaley = +s.scaley.toFixed(4);
	                s.rotate = +s.rotate.toFixed(4);
	                return  (s.dx || s.dy ? "t" + [+s.dx.toFixed(4), +s.dy.toFixed(4)] : E) +
	                        (s.rotate ? "r" + [+s.rotate.toFixed(4), 0, 0] : E) +
	                        (s.scalex != 1 || s.scaley != 1 ? "s" + [s.scalex, s.scaley, 0, 0] : E);
	            } else {
	                return "m" + [this.get(0), this.get(1), this.get(2), this.get(3), this.get(4), this.get(5)];
	            }
	        };
	    })(Matrix.prototype);
	    /*\
	     * Snap.Matrix
	     [ method ]
	     **
	     * Matrix constructor, extend on your own risk.
	     * To create matrices use @Snap.matrix.
	    \*/
	    Snap.Matrix = Matrix;
	    /*\
	     * Snap.matrix
	     [ method ]
	     **
	     * Utility method
	     **
	     * Returns a matrix based on the given parameters
	     - a (number)
	     - b (number)
	     - c (number)
	     - d (number)
	     - e (number)
	     - f (number)
	     * or
	     - svgMatrix (SVGMatrix)
	     = (object) @Matrix
	    \*/
	    Snap.matrix = function (a, b, c, d, e, f) {
	        return new Matrix(a, b, c, d, e, f);
	    };
	});
	
	// Copyright (c) 2013 Adobe Systems Incorporated. All rights reserved.
	//
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//
	// http://www.apache.org/licenses/LICENSE-2.0
	//
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// See the License for the specific language governing permissions and
	// limitations under the License.
	Snap.plugin(function (Snap, Element, Paper, glob, Fragment) {
	    var has = "hasOwnProperty",
	        make = Snap._.make,
	        wrap = Snap._.wrap,
	        is = Snap.is,
	        getSomeDefs = Snap._.getSomeDefs,
	        reURLValue = /^url\((['"]?)([^)]+)\1\)$/,
	        $ = Snap._.$,
	        URL = Snap.url,
	        Str = String,
	        separator = Snap._.separator,
	        E = "";
	    /*\
	     * Snap.deurl
	     [ method ]
	     **
	     * Unwraps path from `"url(<path>)"`.
	     - value (string) url path
	     = (string) unwrapped path
	    \*/
	    Snap.deurl = function (value) {
	        var res = String(value).match(reURLValue);
	        return res ? res[2] : value;
	    }
	    // Attributes event handlers
	    eve.on("snap.util.attr.mask", function (value) {
	        if (value instanceof Element || value instanceof Fragment) {
	            eve.stop();
	            if (value instanceof Fragment && value.node.childNodes.length == 1) {
	                value = value.node.firstChild;
	                getSomeDefs(this).appendChild(value);
	                value = wrap(value);
	            }
	            if (value.type == "mask") {
	                var mask = value;
	            } else {
	                mask = make("mask", getSomeDefs(this));
	                mask.node.appendChild(value.node);
	            }
	            !mask.node.id && $(mask.node, {
	                id: mask.id
	            });
	            $(this.node, {
	                mask: URL(mask.id)
	            });
	        }
	    });
	    (function (clipIt) {
	        eve.on("snap.util.attr.clip", clipIt);
	        eve.on("snap.util.attr.clip-path", clipIt);
	        eve.on("snap.util.attr.clipPath", clipIt);
	    }(function (value) {
	        if (value instanceof Element || value instanceof Fragment) {
	            eve.stop();
	            var clip,
	                node = value.node;
	            while (node) {
	                if (node.nodeName === "clipPath") {
	                    clip = new Element(node);
	                    break;
	                }
	                if (node.nodeName === "svg") {
	                    clip = undefined;
	                    break;
	                }
	                node = node.parentNode;
	            }
	            if (!clip) {
	                clip = make("clipPath", getSomeDefs(this));
	                clip.node.appendChild(value.node);
	                !clip.node.id && $(clip.node, {
	                    id: clip.id
	                });
	            }
	            $(this.node, {
	                "clip-path": URL(clip.node.id || clip.id)
	            });
	        }
	    }));
	    function fillStroke(name) {
	        return function (value) {
	            eve.stop();
	            if (value instanceof Fragment && value.node.childNodes.length == 1 &&
	                (value.node.firstChild.tagName == "radialGradient" ||
	                value.node.firstChild.tagName == "linearGradient" ||
	                value.node.firstChild.tagName == "pattern")) {
	                value = value.node.firstChild;
	                getSomeDefs(this).appendChild(value);
	                value = wrap(value);
	            }
	            if (value instanceof Element) {
	                if (value.type == "radialGradient" || value.type == "linearGradient"
	                   || value.type == "pattern") {
	                    if (!value.node.id) {
	                        $(value.node, {
	                            id: value.id
	                        });
	                    }
	                    var fill = URL(value.node.id);
	                } else {
	                    fill = value.attr(name);
	                }
	            } else {
	                fill = Snap.color(value);
	                if (fill.error) {
	                    var grad = Snap(getSomeDefs(this).ownerSVGElement).gradient(value);
	                    if (grad) {
	                        if (!grad.node.id) {
	                            $(grad.node, {
	                                id: grad.id
	                            });
	                        }
	                        fill = URL(grad.node.id);
	                    } else {
	                        fill = value;
	                    }
	                } else {
	                    fill = Str(fill);
	                }
	            }
	            var attrs = {};
	            attrs[name] = fill;
	            $(this.node, attrs);
	            this.node.style[name] = E;
	        };
	    }
	    eve.on("snap.util.attr.fill", fillStroke("fill"));
	    eve.on("snap.util.attr.stroke", fillStroke("stroke"));
	    var gradrg = /^([lr])(?:\(([^)]*)\))?(.*)$/i;
	    eve.on("snap.util.grad.parse", function parseGrad(string) {
	        string = Str(string);
	        var tokens = string.match(gradrg);
	        if (!tokens) {
	            return null;
	        }
	        var type = tokens[1],
	            params = tokens[2],
	            stops = tokens[3];
	        params = params.split(/\s*,\s*/).map(function (el) {
	            return +el == el ? +el : el;
	        });
	        if (params.length == 1 && params[0] == 0) {
	            params = [];
	        }
	        stops = stops.split("-");
	        stops = stops.map(function (el) {
	            el = el.split(":");
	            var out = {
	                color: el[0]
	            };
	            if (el[1]) {
	                out.offset = parseFloat(el[1]);
	            }
	            return out;
	        });
	        var len = stops.length,
	            start = 0,
	            j = 0;
	        function seed(i, end) {
	            var step = (end - start) / (i - j);
	            for (var k = j; k < i; k++) {
	                stops[k].offset = +(+start + step * (k - j)).toFixed(2);
	            }
	            j = i;
	            start = end;
	        }
	        len--;
	        for (var i = 0; i < len; i++) if ("offset" in stops[i]) {
	            seed(i, stops[i].offset);
	        }
	        stops[len].offset = stops[len].offset || 100;
	        seed(len, stops[len].offset);
	        return {
	            type: type,
	            params: params,
	            stops: stops
	        };
	    });
	
	    eve.on("snap.util.attr.d", function (value) {
	        eve.stop();
	        if (is(value, "array") && is(value[0], "array")) {
	            value = Snap.path.toString.call(value);
	        }
	        value = Str(value);
	        if (value.match(/[ruo]/i)) {
	            value = Snap.path.toAbsolute(value);
	        }
	        $(this.node, {d: value});
	    })(-1);
	    eve.on("snap.util.attr.#text", function (value) {
	        eve.stop();
	        value = Str(value);
	        var txt = glob.doc.createTextNode(value);
	        while (this.node.firstChild) {
	            this.node.removeChild(this.node.firstChild);
	        }
	        this.node.appendChild(txt);
	    })(-1);
	    eve.on("snap.util.attr.path", function (value) {
	        eve.stop();
	        this.attr({d: value});
	    })(-1);
	    eve.on("snap.util.attr.class", function (value) {
	        eve.stop();
	        this.node.className.baseVal = value;
	    })(-1);
	    eve.on("snap.util.attr.viewBox", function (value) {
	        var vb;
	        if (is(value, "object") && "x" in value) {
	            vb = [value.x, value.y, value.width, value.height].join(" ");
	        } else if (is(value, "array")) {
	            vb = value.join(" ");
	        } else {
	            vb = value;
	        }
	        $(this.node, {
	            viewBox: vb
	        });
	        eve.stop();
	    })(-1);
	    eve.on("snap.util.attr.transform", function (value) {
	        this.transform(value);
	        eve.stop();
	    })(-1);
	    eve.on("snap.util.attr.r", function (value) {
	        if (this.type == "rect") {
	            eve.stop();
	            $(this.node, {
	                rx: value,
	                ry: value
	            });
	        }
	    })(-1);
	    eve.on("snap.util.attr.textpath", function (value) {
	        eve.stop();
	        if (this.type == "text") {
	            var id, tp, node;
	            if (!value && this.textPath) {
	                tp = this.textPath;
	                while (tp.node.firstChild) {
	                    this.node.appendChild(tp.node.firstChild);
	                }
	                tp.remove();
	                delete this.textPath;
	                return;
	            }
	            if (is(value, "string")) {
	                var defs = getSomeDefs(this),
	                    path = wrap(defs.parentNode).path(value);
	                defs.appendChild(path.node);
	                id = path.id;
	                path.attr({id: id});
	            } else {
	                value = wrap(value);
	                if (value instanceof Element) {
	                    id = value.attr("id");
	                    if (!id) {
	                        id = value.id;
	                        value.attr({id: id});
	                    }
	                }
	            }
	            if (id) {
	                tp = this.textPath;
	                node = this.node;
	                if (tp) {
	                    tp.attr({"xlink:href": "#" + id});
	                } else {
	                    tp = $("textPath", {
	                        "xlink:href": "#" + id
	                    });
	                    while (node.firstChild) {
	                        tp.appendChild(node.firstChild);
	                    }
	                    node.appendChild(tp);
	                    this.textPath = wrap(tp);
	                }
	            }
	        }
	    })(-1);
	    eve.on("snap.util.attr.text", function (value) {
	        if (this.type == "text") {
	            var i = 0,
	                node = this.node,
	                tuner = function (chunk) {
	                    var out = $("tspan");
	                    if (is(chunk, "array")) {
	                        for (var i = 0; i < chunk.length; i++) {
	                            out.appendChild(tuner(chunk[i]));
	                        }
	                    } else {
	                        out.appendChild(glob.doc.createTextNode(chunk));
	                    }
	                    out.normalize && out.normalize();
	                    return out;
	                };
	            while (node.firstChild) {
	                node.removeChild(node.firstChild);
	            }
	            var tuned = tuner(value);
	            while (tuned.firstChild) {
	                node.appendChild(tuned.firstChild);
	            }
	        }
	        eve.stop();
	    })(-1);
	    function setFontSize(value) {
	        eve.stop();
	        if (value == +value) {
	            value += "px";
	        }
	        this.node.style.fontSize = value;
	    }
	    eve.on("snap.util.attr.fontSize", setFontSize)(-1);
	    eve.on("snap.util.attr.font-size", setFontSize)(-1);
	
	
	    eve.on("snap.util.getattr.transform", function () {
	        eve.stop();
	        return this.transform();
	    })(-1);
	    eve.on("snap.util.getattr.textpath", function () {
	        eve.stop();
	        return this.textPath;
	    })(-1);
	    // Markers
	    (function () {
	        function getter(end) {
	            return function () {
	                eve.stop();
	                var style = glob.doc.defaultView.getComputedStyle(this.node, null).getPropertyValue("marker-" + end);
	                if (style == "none") {
	                    return style;
	                } else {
	                    return Snap(glob.doc.getElementById(style.match(reURLValue)[1]));
	                }
	            };
	        }
	        function setter(end) {
	            return function (value) {
	                eve.stop();
	                var name = "marker" + end.charAt(0).toUpperCase() + end.substring(1);
	                if (value == "" || !value) {
	                    this.node.style[name] = "none";
	                    return;
	                }
	                if (value.type == "marker") {
	                    var id = value.node.id;
	                    if (!id) {
	                        $(value.node, {id: value.id});
	                    }
	                    this.node.style[name] = URL(id);
	                    return;
	                }
	            };
	        }
	        eve.on("snap.util.getattr.marker-end", getter("end"))(-1);
	        eve.on("snap.util.getattr.markerEnd", getter("end"))(-1);
	        eve.on("snap.util.getattr.marker-start", getter("start"))(-1);
	        eve.on("snap.util.getattr.markerStart", getter("start"))(-1);
	        eve.on("snap.util.getattr.marker-mid", getter("mid"))(-1);
	        eve.on("snap.util.getattr.markerMid", getter("mid"))(-1);
	        eve.on("snap.util.attr.marker-end", setter("end"))(-1);
	        eve.on("snap.util.attr.markerEnd", setter("end"))(-1);
	        eve.on("snap.util.attr.marker-start", setter("start"))(-1);
	        eve.on("snap.util.attr.markerStart", setter("start"))(-1);
	        eve.on("snap.util.attr.marker-mid", setter("mid"))(-1);
	        eve.on("snap.util.attr.markerMid", setter("mid"))(-1);
	    }());
	    eve.on("snap.util.getattr.r", function () {
	        if (this.type == "rect" && $(this.node, "rx") == $(this.node, "ry")) {
	            eve.stop();
	            return $(this.node, "rx");
	        }
	    })(-1);
	    function textExtract(node) {
	        var out = [];
	        var children = node.childNodes;
	        for (var i = 0, ii = children.length; i < ii; i++) {
	            var chi = children[i];
	            if (chi.nodeType == 3) {
	                out.push(chi.nodeValue);
	            }
	            if (chi.tagName == "tspan") {
	                if (chi.childNodes.length == 1 && chi.firstChild.nodeType == 3) {
	                    out.push(chi.firstChild.nodeValue);
	                } else {
	                    out.push(textExtract(chi));
	                }
	            }
	        }
	        return out;
	    }
	    eve.on("snap.util.getattr.text", function () {
	        if (this.type == "text" || this.type == "tspan") {
	            eve.stop();
	            var out = textExtract(this.node);
	            return out.length == 1 ? out[0] : out;
	        }
	    })(-1);
	    eve.on("snap.util.getattr.#text", function () {
	        return this.node.textContent;
	    })(-1);
	    eve.on("snap.util.getattr.fill", function (internal) {
	        if (internal) {
	            return;
	        }
	        eve.stop();
	        var value = eve("snap.util.getattr.fill", this, true).firstDefined();
	        return Snap(Snap.deurl(value)) || value;
	    })(-1);
	    eve.on("snap.util.getattr.stroke", function (internal) {
	        if (internal) {
	            return;
	        }
	        eve.stop();
	        var value = eve("snap.util.getattr.stroke", this, true).firstDefined();
	        return Snap(Snap.deurl(value)) || value;
	    })(-1);
	    eve.on("snap.util.getattr.viewBox", function () {
	        eve.stop();
	        var vb = $(this.node, "viewBox");
	        if (vb) {
	            vb = vb.split(separator);
	            return Snap._.box(+vb[0], +vb[1], +vb[2], +vb[3]);
	        } else {
	            return;
	        }
	    })(-1);
	    eve.on("snap.util.getattr.points", function () {
	        var p = $(this.node, "points");
	        eve.stop();
	        if (p) {
	            return p.split(separator);
	        } else {
	            return;
	        }
	    })(-1);
	    eve.on("snap.util.getattr.path", function () {
	        var p = $(this.node, "d");
	        eve.stop();
	        return p;
	    })(-1);
	    eve.on("snap.util.getattr.class", function () {
	        return this.node.className.baseVal;
	    })(-1);
	    function getFontSize() {
	        eve.stop();
	        return this.node.style.fontSize;
	    }
	    eve.on("snap.util.getattr.fontSize", getFontSize)(-1);
	    eve.on("snap.util.getattr.font-size", getFontSize)(-1);
	});
	
	// Copyright (c) 2014 Adobe Systems Incorporated. All rights reserved.
	//
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//
	// http://www.apache.org/licenses/LICENSE-2.0
	//
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// See the License for the specific language governing permissions and
	// limitations under the License.
	Snap.plugin(function (Snap, Element, Paper, glob, Fragment) {
	    var rgNotSpace = /\S+/g,
	        rgBadSpace = /[\t\r\n\f]/g,
	        rgTrim = /(^\s+|\s+$)/g,
	        Str = String,
	        elproto = Element.prototype;
	    /*\
	     * Element.addClass
	     [ method ]
	     **
	     * Adds given class name or list of class names to the element.
	     - value (string) class name or space separated list of class names
	     **
	     = (Element) original element.
	    \*/
	    elproto.addClass = function (value) {
	        var classes = Str(value || "").match(rgNotSpace) || [],
	            elem = this.node,
	            className = elem.className.baseVal,
	            curClasses = className.match(rgNotSpace) || [],
	            j,
	            pos,
	            clazz,
	            finalValue;
	
	        if (classes.length) {
	            j = 0;
	            while (clazz = classes[j++]) {
	                pos = curClasses.indexOf(clazz);
	                if (!~pos) {
	                    curClasses.push(clazz);
	                }
	            }
	
	            finalValue = curClasses.join(" ");
	            if (className != finalValue) {
	                elem.className.baseVal = finalValue;
	            }
	        }
	        return this;
	    };
	    /*\
	     * Element.removeClass
	     [ method ]
	     **
	     * Removes given class name or list of class names from the element.
	     - value (string) class name or space separated list of class names
	     **
	     = (Element) original element.
	    \*/
	    elproto.removeClass = function (value) {
	        var classes = Str(value || "").match(rgNotSpace) || [],
	            elem = this.node,
	            className = elem.className.baseVal,
	            curClasses = className.match(rgNotSpace) || [],
	            j,
	            pos,
	            clazz,
	            finalValue;
	        if (curClasses.length) {
	            j = 0;
	            while (clazz = classes[j++]) {
	                pos = curClasses.indexOf(clazz);
	                if (~pos) {
	                    curClasses.splice(pos, 1);
	                }
	            }
	
	            finalValue = curClasses.join(" ");
	            if (className != finalValue) {
	                elem.className.baseVal = finalValue;
	            }
	        }
	        return this;
	    };
	    /*\
	     * Element.hasClass
	     [ method ]
	     **
	     * Checks if the element has a given class name in the list of class names applied to it.
	     - value (string) class name
	     **
	     = (boolean) `true` if the element has given class
	    \*/
	    elproto.hasClass = function (value) {
	        var elem = this.node,
	            className = elem.className.baseVal,
	            curClasses = className.match(rgNotSpace) || [];
	        return !!~curClasses.indexOf(value);
	    };
	    /*\
	     * Element.toggleClass
	     [ method ]
	     **
	     * Add or remove one or more classes from the element, depending on either
	     * the class’s presence or the value of the `flag` argument.
	     - value (string) class name or space separated list of class names
	     - flag (boolean) value to determine whether the class should be added or removed
	     **
	     = (Element) original element.
	    \*/
	    elproto.toggleClass = function (value, flag) {
	        if (flag != null) {
	            if (flag) {
	                return this.addClass(value);
	            } else {
	                return this.removeClass(value);
	            }
	        }
	        var classes = (value || "").match(rgNotSpace) || [],
	            elem = this.node,
	            className = elem.className.baseVal,
	            curClasses = className.match(rgNotSpace) || [],
	            j,
	            pos,
	            clazz,
	            finalValue;
	        j = 0;
	        while (clazz = classes[j++]) {
	            pos = curClasses.indexOf(clazz);
	            if (~pos) {
	                curClasses.splice(pos, 1);
	            } else {
	                curClasses.push(clazz);
	            }
	        }
	
	        finalValue = curClasses.join(" ");
	        if (className != finalValue) {
	            elem.className.baseVal = finalValue;
	        }
	        return this;
	    };
	});
	
	// Copyright (c) 2013 Adobe Systems Incorporated. All rights reserved.
	//
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//
	// http://www.apache.org/licenses/LICENSE-2.0
	//
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// See the License for the specific language governing permissions and
	// limitations under the License.
	Snap.plugin(function (Snap, Element, Paper, glob, Fragment) {
	    var operators = {
	            "+": function (x, y) {
	                    return x + y;
	                },
	            "-": function (x, y) {
	                    return x - y;
	                },
	            "/": function (x, y) {
	                    return x / y;
	                },
	            "*": function (x, y) {
	                    return x * y;
	                }
	        },
	        Str = String,
	        reUnit = /[a-z]+$/i,
	        reAddon = /^\s*([+\-\/*])\s*=\s*([\d.eE+\-]+)\s*([^\d\s]+)?\s*$/;
	    function getNumber(val) {
	        return val;
	    }
	    function getUnit(unit) {
	        return function (val) {
	            return +val.toFixed(3) + unit;
	        };
	    }
	    eve.on("snap.util.attr", function (val) {
	        var plus = Str(val).match(reAddon);
	        if (plus) {
	            var evnt = eve.nt(),
	                name = evnt.substring(evnt.lastIndexOf(".") + 1),
	                a = this.attr(name),
	                atr = {};
	            eve.stop();
	            var unit = plus[3] || "",
	                aUnit = a.match(reUnit),
	                op = operators[plus[1]];
	            if (aUnit && aUnit == unit) {
	                val = op(parseFloat(a), +plus[2]);
	            } else {
	                a = this.asPX(name);
	                val = op(this.asPX(name), this.asPX(name, plus[2] + unit));
	            }
	            if (isNaN(a) || isNaN(val)) {
	                return;
	            }
	            atr[name] = val;
	            this.attr(atr);
	        }
	    })(-10);
	    eve.on("snap.util.equal", function (name, b) {
	        var A, B, a = Str(this.attr(name) || ""),
	            el = this,
	            bplus = Str(b).match(reAddon);
	        if (bplus) {
	            eve.stop();
	            var unit = bplus[3] || "",
	                aUnit = a.match(reUnit),
	                op = operators[bplus[1]];
	            if (aUnit && aUnit == unit) {
	                return {
	                    from: parseFloat(a),
	                    to: op(parseFloat(a), +bplus[2]),
	                    f: getUnit(aUnit)
	                };
	            } else {
	                a = this.asPX(name);
	                return {
	                    from: a,
	                    to: op(a, this.asPX(name, bplus[2] + unit)),
	                    f: getNumber
	                };
	            }
	        }
	    })(-10);
	});
	
	// Copyright (c) 2013 Adobe Systems Incorporated. All rights reserved.
	//
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//
	// http://www.apache.org/licenses/LICENSE-2.0
	//
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// See the License for the specific language governing permissions and
	// limitations under the License.
	Snap.plugin(function (Snap, Element, Paper, glob, Fragment) {
	    var proto = Paper.prototype,
	        is = Snap.is;
	    /*\
	     * Paper.rect
	     [ method ]
	     *
	     * Draws a rectangle
	     **
	     - x (number) x coordinate of the top left corner
	     - y (number) y coordinate of the top left corner
	     - width (number) width
	     - height (number) height
	     - rx (number) #optional horizontal radius for rounded corners, default is 0
	     - ry (number) #optional vertical radius for rounded corners, default is rx or 0
	     = (object) the `rect` element
	     **
	     > Usage
	     | // regular rectangle
	     | var c = paper.rect(10, 10, 50, 50);
	     | // rectangle with rounded corners
	     | var c = paper.rect(40, 40, 50, 50, 10);
	    \*/
	    proto.rect = function (x, y, w, h, rx, ry) {
	        var attr;
	        if (ry == null) {
	            ry = rx;
	        }
	        if (is(x, "object") && x == "[object Object]") {
	            attr = x;
	        } else if (x != null) {
	            attr = {
	                x: x,
	                y: y,
	                width: w,
	                height: h
	            };
	            if (rx != null) {
	                attr.rx = rx;
	                attr.ry = ry;
	            }
	        }
	        return this.el("rect", attr);
	    };
	    /*\
	     * Paper.circle
	     [ method ]
	     **
	     * Draws a circle
	     **
	     - x (number) x coordinate of the centre
	     - y (number) y coordinate of the centre
	     - r (number) radius
	     = (object) the `circle` element
	     **
	     > Usage
	     | var c = paper.circle(50, 50, 40);
	    \*/
	    proto.circle = function (cx, cy, r) {
	        var attr;
	        if (is(cx, "object") && cx == "[object Object]") {
	            attr = cx;
	        } else if (cx != null) {
	            attr = {
	                cx: cx,
	                cy: cy,
	                r: r
	            };
	        }
	        return this.el("circle", attr);
	    };
	
	    var preload = (function () {
	        function onerror() {
	            this.parentNode.removeChild(this);
	        }
	        return function (src, f) {
	            var img = glob.doc.createElement("img"),
	                body = glob.doc.body;
	            img.style.cssText = "position:absolute;left:-9999em;top:-9999em";
	            img.onload = function () {
	                f.call(img);
	                img.onload = img.onerror = null;
	                body.removeChild(img);
	            };
	            img.onerror = onerror;
	            body.appendChild(img);
	            img.src = src;
	        };
	    }());
	
	    /*\
	     * Paper.image
	     [ method ]
	     **
	     * Places an image on the surface
	     **
	     - src (string) URI of the source image
	     - x (number) x offset position
	     - y (number) y offset position
	     - width (number) width of the image
	     - height (number) height of the image
	     = (object) the `image` element
	     * or
	     = (object) Snap element object with type `image`
	     **
	     > Usage
	     | var c = paper.image("apple.png", 10, 10, 80, 80);
	    \*/
	    proto.image = function (src, x, y, width, height) {
	        var el = this.el("image");
	        if (is(src, "object") && "src" in src) {
	            el.attr(src);
	        } else if (src != null) {
	            var set = {
	                "xlink:href": src,
	                preserveAspectRatio: "none"
	            };
	            if (x != null && y != null) {
	                set.x = x;
	                set.y = y;
	            }
	            if (width != null && height != null) {
	                set.width = width;
	                set.height = height;
	            } else {
	                preload(src, function () {
	                    Snap._.$(el.node, {
	                        width: this.offsetWidth,
	                        height: this.offsetHeight
	                    });
	                });
	            }
	            Snap._.$(el.node, set);
	        }
	        return el;
	    };
	    /*\
	     * Paper.ellipse
	     [ method ]
	     **
	     * Draws an ellipse
	     **
	     - x (number) x coordinate of the centre
	     - y (number) y coordinate of the centre
	     - rx (number) horizontal radius
	     - ry (number) vertical radius
	     = (object) the `ellipse` element
	     **
	     > Usage
	     | var c = paper.ellipse(50, 50, 40, 20);
	    \*/
	    proto.ellipse = function (cx, cy, rx, ry) {
	        var attr;
	        if (is(cx, "object") && cx == "[object Object]") {
	            attr = cx;
	        } else if (cx != null) {
	            attr ={
	                cx: cx,
	                cy: cy,
	                rx: rx,
	                ry: ry
	            };
	        }
	        return this.el("ellipse", attr);
	    };
	    // SIERRA Paper.path(): Unclear from the link what a Catmull-Rom curveto is, and why it would make life any easier.
	    /*\
	     * Paper.path
	     [ method ]
	     **
	     * Creates a `<path>` element using the given string as the path's definition
	     - pathString (string) #optional path string in SVG format
	     * Path string consists of one-letter commands, followed by comma seprarated arguments in numerical form. Example:
	     | "M10,20L30,40"
	     * This example features two commands: `M`, with arguments `(10, 20)` and `L` with arguments `(30, 40)`. Uppercase letter commands express coordinates in absolute terms, while lowercase commands express them in relative terms from the most recently declared coordinates.
	     *
	     # <p>Here is short list of commands available, for more details see <a href="http://www.w3.org/TR/SVG/paths.html#PathData" title="Details of a path's data attribute's format are described in the SVG specification.">SVG path string format</a> or <a href="https://developer.mozilla.org/en/SVG/Tutorial/Paths">article about path strings at MDN</a>.</p>
	     # <table><thead><tr><th>Command</th><th>Name</th><th>Parameters</th></tr></thead><tbody>
	     # <tr><td>M</td><td>moveto</td><td>(x y)+</td></tr>
	     # <tr><td>Z</td><td>closepath</td><td>(none)</td></tr>
	     # <tr><td>L</td><td>lineto</td><td>(x y)+</td></tr>
	     # <tr><td>H</td><td>horizontal lineto</td><td>x+</td></tr>
	     # <tr><td>V</td><td>vertical lineto</td><td>y+</td></tr>
	     # <tr><td>C</td><td>curveto</td><td>(x1 y1 x2 y2 x y)+</td></tr>
	     # <tr><td>S</td><td>smooth curveto</td><td>(x2 y2 x y)+</td></tr>
	     # <tr><td>Q</td><td>quadratic Bézier curveto</td><td>(x1 y1 x y)+</td></tr>
	     # <tr><td>T</td><td>smooth quadratic Bézier curveto</td><td>(x y)+</td></tr>
	     # <tr><td>A</td><td>elliptical arc</td><td>(rx ry x-axis-rotation large-arc-flag sweep-flag x y)+</td></tr>
	     # <tr><td>R</td><td><a href="http://en.wikipedia.org/wiki/Catmull–Rom_spline#Catmull.E2.80.93Rom_spline">Catmull-Rom curveto</a>*</td><td>x1 y1 (x y)+</td></tr></tbody></table>
	     * * _Catmull-Rom curveto_ is a not standard SVG command and added to make life easier.
	     * Note: there is a special case when a path consists of only three commands: `M10,10R…z`. In this case the path connects back to its starting point.
	     > Usage
	     | var c = paper.path("M10 10L90 90");
	     | // draw a diagonal line:
	     | // move to 10,10, line to 90,90
	    \*/
	    proto.path = function (d) {
	        var attr;
	        if (is(d, "object") && !is(d, "array")) {
	            attr = d;
	        } else if (d) {
	            attr = {d: d};
	        }
	        return this.el("path", attr);
	    };
	    /*\
	     * Paper.g
	     [ method ]
	     **
	     * Creates a group element
	     **
	     - varargs (…) #optional elements to nest within the group
	     = (object) the `g` element
	     **
	     > Usage
	     | var c1 = paper.circle(),
	     |     c2 = paper.rect(),
	     |     g = paper.g(c2, c1); // note that the order of elements is different
	     * or
	     | var c1 = paper.circle(),
	     |     c2 = paper.rect(),
	     |     g = paper.g();
	     | g.add(c2, c1);
	    \*/
	    /*\
	     * Paper.group
	     [ method ]
	     **
	     * See @Paper.g
	    \*/
	    proto.group = proto.g = function (first) {
	        var attr,
	            el = this.el("g");
	        if (arguments.length == 1 && first && !first.type) {
	            el.attr(first);
	        } else if (arguments.length) {
	            el.add(Array.prototype.slice.call(arguments, 0));
	        }
	        return el;
	    };
	    /*\
	     * Paper.svg
	     [ method ]
	     **
	     * Creates a nested SVG element.
	     - x (number) @optional X of the element
	     - y (number) @optional Y of the element
	     - width (number) @optional width of the element
	     - height (number) @optional height of the element
	     - vbx (number) @optional viewbox X
	     - vby (number) @optional viewbox Y
	     - vbw (number) @optional viewbox width
	     - vbh (number) @optional viewbox height
	     **
	     = (object) the `svg` element
	     **
	    \*/
	    proto.svg = function (x, y, width, height, vbx, vby, vbw, vbh) {
	        var attrs = {};
	        if (is(x, "object") && y == null) {
	            attrs = x;
	        } else {
	            if (x != null) {
	                attrs.x = x;
	            }
	            if (y != null) {
	                attrs.y = y;
	            }
	            if (width != null) {
	                attrs.width = width;
	            }
	            if (height != null) {
	                attrs.height = height;
	            }
	            if (vbx != null && vby != null && vbw != null && vbh != null) {
	                attrs.viewBox = [vbx, vby, vbw, vbh];
	            }
	        }
	        return this.el("svg", attrs);
	    };
	    /*\
	     * Paper.mask
	     [ method ]
	     **
	     * Equivalent in behaviour to @Paper.g, except it’s a mask.
	     **
	     = (object) the `mask` element
	     **
	    \*/
	    proto.mask = function (first) {
	        var attr,
	            el = this.el("mask");
	        if (arguments.length == 1 && first && !first.type) {
	            el.attr(first);
	        } else if (arguments.length) {
	            el.add(Array.prototype.slice.call(arguments, 0));
	        }
	        return el;
	    };
	    /*\
	     * Paper.ptrn
	     [ method ]
	     **
	     * Equivalent in behaviour to @Paper.g, except it’s a pattern.
	     - x (number) @optional X of the element
	     - y (number) @optional Y of the element
	     - width (number) @optional width of the element
	     - height (number) @optional height of the element
	     - vbx (number) @optional viewbox X
	     - vby (number) @optional viewbox Y
	     - vbw (number) @optional viewbox width
	     - vbh (number) @optional viewbox height
	     **
	     = (object) the `pattern` element
	     **
	    \*/
	    proto.ptrn = function (x, y, width, height, vx, vy, vw, vh) {
	        if (is(x, "object")) {
	            var attr = x;
	        } else {
	            attr = {patternUnits: "userSpaceOnUse"};
	            if (x) {
	                attr.x = x;
	            }
	            if (y) {
	                attr.y = y;
	            }
	            if (width != null) {
	                attr.width = width;
	            }
	            if (height != null) {
	                attr.height = height;
	            }
	            if (vx != null && vy != null && vw != null && vh != null) {
	                attr.viewBox = [vx, vy, vw, vh];
	            } else {
	                attr.viewBox = [x || 0, y || 0, width || 0, height || 0];
	            }
	        }
	        return this.el("pattern", attr);
	    };
	    /*\
	     * Paper.use
	     [ method ]
	     **
	     * Creates a <use> element.
	     - id (string) @optional id of element to link
	     * or
	     - id (Element) @optional element to link
	     **
	     = (object) the `use` element
	     **
	    \*/
	    proto.use = function (id) {
	        if (id != null) {
	            if (id instanceof Element) {
	                if (!id.attr("id")) {
	                    id.attr({id: Snap._.id(id)});
	                }
	                id = id.attr("id");
	            }
	            if (String(id).charAt() == "#") {
	                id = id.substring(1);
	            }
	            return this.el("use", {"xlink:href": "#" + id});
	        } else {
	            return Element.prototype.use.call(this);
	        }
	    };
	    /*\
	     * Paper.symbol
	     [ method ]
	     **
	     * Creates a <symbol> element.
	     - vbx (number) @optional viewbox X
	     - vby (number) @optional viewbox Y
	     - vbw (number) @optional viewbox width
	     - vbh (number) @optional viewbox height
	     = (object) the `symbol` element
	     **
	    \*/
	    proto.symbol = function (vx, vy, vw, vh) {
	        var attr = {};
	        if (vx != null && vy != null && vw != null && vh != null) {
	            attr.viewBox = [vx, vy, vw, vh];
	        }
	
	        return this.el("symbol", attr);
	    };
	    /*\
	     * Paper.text
	     [ method ]
	     **
	     * Draws a text string
	     **
	     - x (number) x coordinate position
	     - y (number) y coordinate position
	     - text (string|array) The text string to draw or array of strings to nest within separate `<tspan>` elements
	     = (object) the `text` element
	     **
	     > Usage
	     | var t1 = paper.text(50, 50, "Snap");
	     | var t2 = paper.text(50, 50, ["S","n","a","p"]);
	     | // Text path usage
	     | t1.attr({textpath: "M10,10L100,100"});
	     | // or
	     | var pth = paper.path("M10,10L100,100");
	     | t1.attr({textpath: pth});
	    \*/
	    proto.text = function (x, y, text) {
	        var attr = {};
	        if (is(x, "object")) {
	            attr = x;
	        } else if (x != null) {
	            attr = {
	                x: x,
	                y: y,
	                text: text || ""
	            };
	        }
	        return this.el("text", attr);
	    };
	    /*\
	     * Paper.line
	     [ method ]
	     **
	     * Draws a line
	     **
	     - x1 (number) x coordinate position of the start
	     - y1 (number) y coordinate position of the start
	     - x2 (number) x coordinate position of the end
	     - y2 (number) y coordinate position of the end
	     = (object) the `line` element
	     **
	     > Usage
	     | var t1 = paper.line(50, 50, 100, 100);
	    \*/
	    proto.line = function (x1, y1, x2, y2) {
	        var attr = {};
	        if (is(x1, "object")) {
	            attr = x1;
	        } else if (x1 != null) {
	            attr = {
	                x1: x1,
	                x2: x2,
	                y1: y1,
	                y2: y2
	            };
	        }
	        return this.el("line", attr);
	    };
	    /*\
	     * Paper.polyline
	     [ method ]
	     **
	     * Draws a polyline
	     **
	     - points (array) array of points
	     * or
	     - varargs (…) points
	     = (object) the `polyline` element
	     **
	     > Usage
	     | var p1 = paper.polyline([10, 10, 100, 100]);
	     | var p2 = paper.polyline(10, 10, 100, 100);
	    \*/
	    proto.polyline = function (points) {
	        if (arguments.length > 1) {
	            points = Array.prototype.slice.call(arguments, 0);
	        }
	        var attr = {};
	        if (is(points, "object") && !is(points, "array")) {
	            attr = points;
	        } else if (points != null) {
	            attr = {points: points};
	        }
	        return this.el("polyline", attr);
	    };
	    /*\
	     * Paper.polygon
	     [ method ]
	     **
	     * Draws a polygon. See @Paper.polyline
	    \*/
	    proto.polygon = function (points) {
	        if (arguments.length > 1) {
	            points = Array.prototype.slice.call(arguments, 0);
	        }
	        var attr = {};
	        if (is(points, "object") && !is(points, "array")) {
	            attr = points;
	        } else if (points != null) {
	            attr = {points: points};
	        }
	        return this.el("polygon", attr);
	    };
	    // gradients
	    (function () {
	        var $ = Snap._.$;
	        // gradients' helpers
	        /*\
	         * Element.stops
	         [ method ]
	         **
	         * Only for gradients!
	         * Returns array of gradient stops elements.
	         = (array) the stops array.
	        \*/
	        function Gstops() {
	            return this.selectAll("stop");
	        }
	        /*\
	         * Element.addStop
	         [ method ]
	         **
	         * Only for gradients!
	         * Adds another stop to the gradient.
	         - color (string) stops color
	         - offset (number) stops offset 0..100
	         = (object) gradient element
	        \*/
	        function GaddStop(color, offset) {
	            var stop = $("stop"),
	                attr = {
	                    offset: +offset + "%"
	                };
	            color = Snap.color(color);
	            attr["stop-color"] = color.hex;
	            if (color.opacity < 1) {
	                attr["stop-opacity"] = color.opacity;
	            }
	            $(stop, attr);
	            var stops = this.stops(),
	                inserted;
	            for (var i = 0; i < stops.length; i++) {
	                var stopOffset = parseFloat(stops[i].attr("offset"));
	                if (stopOffset > offset) {
	                    this.node.insertBefore(stop, stops[i].node);
	                    inserted = true;
	                    break;
	                }
	            }
	            if (!inserted) {
	                this.node.appendChild(stop);
	            }
	            return this;
	        }
	        function GgetBBox() {
	            if (this.type == "linearGradient") {
	                var x1 = $(this.node, "x1") || 0,
	                    x2 = $(this.node, "x2") || 1,
	                    y1 = $(this.node, "y1") || 0,
	                    y2 = $(this.node, "y2") || 0;
	                return Snap._.box(x1, y1, math.abs(x2 - x1), math.abs(y2 - y1));
	            } else {
	                var cx = this.node.cx || .5,
	                    cy = this.node.cy || .5,
	                    r = this.node.r || 0;
	                return Snap._.box(cx - r, cy - r, r * 2, r * 2);
	            }
	        }
	        /*\
	         * Element.setStops
	         [ method ]
	         **
	         * Only for gradients!
	         * Updates stops of the gradient based on passed gradient descriptor. See @Ppaer.gradient
	         - str (string) gradient descriptor part after `()`.
	         = (object) gradient element
	         | var g = paper.gradient("l(0, 0, 1, 1)#000-#f00-#fff");
	         | g.setStops("#fff-#000-#f00-#fc0");
	        \*/
	        function GsetStops(str) {
	            var grad = str,
	                stops = this.stops();
	            if (typeof str == "string") {
	                grad = eve("snap.util.grad.parse", null, "l(0,0,0,1)" + str).firstDefined().stops;
	            }
	            if (!Snap.is(grad, "array")) {
	                return;
	            }
	            for (var i = 0; i < stops.length; i++) {
	                if (grad[i]) {
	                    var color = Snap.color(grad[i].color),
	                        attr = {"offset": grad[i].offset + "%"};
	                    attr["stop-color"] = color.hex;
	                    if (color.opacity < 1) {
	                        attr["stop-opacity"] = color.opacity;
	                    }
	                    stops[i].attr(attr);
	                } else {
	                    stops[i].remove();
	                }
	            }
	            for (i = stops.length; i < grad.length; i++) {
	                this.addStop(grad[i].color, grad[i].offset);
	            }
	            return this;
	        }
	        function gradient(defs, str) {
	            var grad = eve("snap.util.grad.parse", null, str).firstDefined(),
	                el;
	            if (!grad) {
	                return null;
	            }
	            grad.params.unshift(defs);
	            if (grad.type.toLowerCase() == "l") {
	                el = gradientLinear.apply(0, grad.params);
	            } else {
	                el = gradientRadial.apply(0, grad.params);
	            }
	            if (grad.type != grad.type.toLowerCase()) {
	                $(el.node, {
	                    gradientUnits: "userSpaceOnUse"
	                });
	            }
	            var stops = grad.stops,
	                len = stops.length;
	            for (var i = 0; i < len; i++) {
	                var stop = stops[i];
	                el.addStop(stop.color, stop.offset);
	            }
	            return el;
	        }
	        function gradientLinear(defs, x1, y1, x2, y2) {
	            var el = Snap._.make("linearGradient", defs);
	            el.stops = Gstops;
	            el.addStop = GaddStop;
	            el.getBBox = GgetBBox;
	            el.setStops = GsetStops;
	            if (x1 != null) {
	                $(el.node, {
	                    x1: x1,
	                    y1: y1,
	                    x2: x2,
	                    y2: y2
	                });
	            }
	            return el;
	        }
	        function gradientRadial(defs, cx, cy, r, fx, fy) {
	            var el = Snap._.make("radialGradient", defs);
	            el.stops = Gstops;
	            el.addStop = GaddStop;
	            el.getBBox = GgetBBox;
	            if (cx != null) {
	                $(el.node, {
	                    cx: cx,
	                    cy: cy,
	                    r: r
	                });
	            }
	            if (fx != null && fy != null) {
	                $(el.node, {
	                    fx: fx,
	                    fy: fy
	                });
	            }
	            return el;
	        }
	        /*\
	         * Paper.gradient
	         [ method ]
	         **
	         * Creates a gradient element
	         **
	         - gradient (string) gradient descriptor
	         > Gradient Descriptor
	         * The gradient descriptor is an expression formatted as
	         * follows: `<type>(<coords>)<colors>`.  The `<type>` can be
	         * either linear or radial.  The uppercase `L` or `R` letters
	         * indicate absolute coordinates offset from the SVG surface.
	         * Lowercase `l` or `r` letters indicate coordinates
	         * calculated relative to the element to which the gradient is
	         * applied.  Coordinates specify a linear gradient vector as
	         * `x1`, `y1`, `x2`, `y2`, or a radial gradient as `cx`, `cy`,
	         * `r` and optional `fx`, `fy` specifying a focal point away
	         * from the center of the circle. Specify `<colors>` as a list
	         * of dash-separated CSS color values.  Each color may be
	         * followed by a custom offset value, separated with a colon
	         * character.
	         > Examples
	         * Linear gradient, relative from top-left corner to bottom-right
	         * corner, from black through red to white:
	         | var g = paper.gradient("l(0, 0, 1, 1)#000-#f00-#fff");
	         * Linear gradient, absolute from (0, 0) to (100, 100), from black
	         * through red at 25% to white:
	         | var g = paper.gradient("L(0, 0, 100, 100)#000-#f00:25-#fff");
	         * Radial gradient, relative from the center of the element with radius
	         * half the width, from black to white:
	         | var g = paper.gradient("r(0.5, 0.5, 0.5)#000-#fff");
	         * To apply the gradient:
	         | paper.circle(50, 50, 40).attr({
	         |     fill: g
	         | });
	         = (object) the `gradient` element
	        \*/
	        proto.gradient = function (str) {
	            return gradient(this.defs, str);
	        };
	        proto.gradientLinear = function (x1, y1, x2, y2) {
	            return gradientLinear(this.defs, x1, y1, x2, y2);
	        };
	        proto.gradientRadial = function (cx, cy, r, fx, fy) {
	            return gradientRadial(this.defs, cx, cy, r, fx, fy);
	        };
	        /*\
	         * Paper.toString
	         [ method ]
	         **
	         * Returns SVG code for the @Paper
	         = (string) SVG code for the @Paper
	        \*/
	        proto.toString = function () {
	            var doc = this.node.ownerDocument,
	                f = doc.createDocumentFragment(),
	                d = doc.createElement("div"),
	                svg = this.node.cloneNode(true),
	                res;
	            f.appendChild(d);
	            d.appendChild(svg);
	            Snap._.$(svg, {xmlns: "http://www.w3.org/2000/svg"});
	            res = d.innerHTML;
	            f.removeChild(f.firstChild);
	            return res;
	        };
	        /*\
	         * Paper.toDataURL
	         [ method ]
	         **
	         * Returns SVG code for the @Paper as Data URI string.
	         = (string) Data URI string
	        \*/
	        proto.toDataURL = function () {
	            if (window && window.btoa) {
	                return "data:image/svg+xml;base64," + btoa(unescape(encodeURIComponent(this)));
	            }
	        };
	        /*\
	         * Paper.clear
	         [ method ]
	         **
	         * Removes all child nodes of the paper, except <defs>.
	        \*/
	        proto.clear = function () {
	            var node = this.node.firstChild,
	                next;
	            while (node) {
	                next = node.nextSibling;
	                if (node.tagName != "defs") {
	                    node.parentNode.removeChild(node);
	                } else {
	                    proto.clear.call({node: node});
	                }
	                node = next;
	            }
	        };
	    }());
	});
	
	// Copyright (c) 2013 Adobe Systems Incorporated. All rights reserved.
	//
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//
	// http://www.apache.org/licenses/LICENSE-2.0
	//
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// See the License for the specific language governing permissions and
	// limitations under the License.
	Snap.plugin(function (Snap, Element, Paper, glob) {
	    var elproto = Element.prototype,
	        is = Snap.is,
	        clone = Snap._.clone,
	        has = "hasOwnProperty",
	        p2s = /,?([a-z]),?/gi,
	        toFloat = parseFloat,
	        math = Math,
	        PI = math.PI,
	        mmin = math.min,
	        mmax = math.max,
	        pow = math.pow,
	        abs = math.abs;
	    function paths(ps) {
	        var p = paths.ps = paths.ps || {};
	        if (p[ps]) {
	            p[ps].sleep = 100;
	        } else {
	            p[ps] = {
	                sleep: 100
	            };
	        }
	        setTimeout(function () {
	            for (var key in p) if (p[has](key) && key != ps) {
	                p[key].sleep--;
	                !p[key].sleep && delete p[key];
	            }
	        });
	        return p[ps];
	    }
	    function box(x, y, width, height) {
	        if (x == null) {
	            x = y = width = height = 0;
	        }
	        if (y == null) {
	            y = x.y;
	            width = x.width;
	            height = x.height;
	            x = x.x;
	        }
	        return {
	            x: x,
	            y: y,
	            width: width,
	            w: width,
	            height: height,
	            h: height,
	            x2: x + width,
	            y2: y + height,
	            cx: x + width / 2,
	            cy: y + height / 2,
	            r1: math.min(width, height) / 2,
	            r2: math.max(width, height) / 2,
	            r0: math.sqrt(width * width + height * height) / 2,
	            path: rectPath(x, y, width, height),
	            vb: [x, y, width, height].join(" ")
	        };
	    }
	    function toString() {
	        return this.join(",").replace(p2s, "$1");
	    }
	    function pathClone(pathArray) {
	        var res = clone(pathArray);
	        res.toString = toString;
	        return res;
	    }
	    function getPointAtSegmentLength(p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y, length) {
	        if (length == null) {
	            return bezlen(p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y);
	        } else {
	            return findDotsAtSegment(p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y,
	                getTotLen(p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y, length));
	        }
	    }
	    function getLengthFactory(istotal, subpath) {
	        function O(val) {
	            return +(+val).toFixed(3);
	        }
	        return Snap._.cacher(function (path, length, onlystart) {
	            if (path instanceof Element) {
	                path = path.attr("d");
	            }
	            path = path2curve(path);
	            var x, y, p, l, sp = "", subpaths = {}, point,
	                len = 0;
	            for (var i = 0, ii = path.length; i < ii; i++) {
	                p = path[i];
	                if (p[0] == "M") {
	                    x = +p[1];
	                    y = +p[2];
	                } else {
	                    l = getPointAtSegmentLength(x, y, p[1], p[2], p[3], p[4], p[5], p[6]);
	                    if (len + l > length) {
	                        if (subpath && !subpaths.start) {
	                            point = getPointAtSegmentLength(x, y, p[1], p[2], p[3], p[4], p[5], p[6], length - len);
	                            sp += [
	                                "C" + O(point.start.x),
	                                O(point.start.y),
	                                O(point.m.x),
	                                O(point.m.y),
	                                O(point.x),
	                                O(point.y)
	                            ];
	                            if (onlystart) {return sp;}
	                            subpaths.start = sp;
	                            sp = [
	                                "M" + O(point.x),
	                                O(point.y) + "C" + O(point.n.x),
	                                O(point.n.y),
	                                O(point.end.x),
	                                O(point.end.y),
	                                O(p[5]),
	                                O(p[6])
	                            ].join();
	                            len += l;
	                            x = +p[5];
	                            y = +p[6];
	                            continue;
	                        }
	                        if (!istotal && !subpath) {
	                            point = getPointAtSegmentLength(x, y, p[1], p[2], p[3], p[4], p[5], p[6], length - len);
	                            return point;
	                        }
	                    }
	                    len += l;
	                    x = +p[5];
	                    y = +p[6];
	                }
	                sp += p.shift() + p;
	            }
	            subpaths.end = sp;
	            point = istotal ? len : subpath ? subpaths : findDotsAtSegment(x, y, p[0], p[1], p[2], p[3], p[4], p[5], 1);
	            return point;
	        }, null, Snap._.clone);
	    }
	    var getTotalLength = getLengthFactory(1),
	        getPointAtLength = getLengthFactory(),
	        getSubpathsAtLength = getLengthFactory(0, 1);
	    function findDotsAtSegment(p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y, t) {
	        var t1 = 1 - t,
	            t13 = pow(t1, 3),
	            t12 = pow(t1, 2),
	            t2 = t * t,
	            t3 = t2 * t,
	            x = t13 * p1x + t12 * 3 * t * c1x + t1 * 3 * t * t * c2x + t3 * p2x,
	            y = t13 * p1y + t12 * 3 * t * c1y + t1 * 3 * t * t * c2y + t3 * p2y,
	            mx = p1x + 2 * t * (c1x - p1x) + t2 * (c2x - 2 * c1x + p1x),
	            my = p1y + 2 * t * (c1y - p1y) + t2 * (c2y - 2 * c1y + p1y),
	            nx = c1x + 2 * t * (c2x - c1x) + t2 * (p2x - 2 * c2x + c1x),
	            ny = c1y + 2 * t * (c2y - c1y) + t2 * (p2y - 2 * c2y + c1y),
	            ax = t1 * p1x + t * c1x,
	            ay = t1 * p1y + t * c1y,
	            cx = t1 * c2x + t * p2x,
	            cy = t1 * c2y + t * p2y,
	            alpha = 90 - math.atan2(mx - nx, my - ny) * 180 / PI;
	        // (mx > nx || my < ny) && (alpha += 180);
	        return {
	            x: x,
	            y: y,
	            m: {x: mx, y: my},
	            n: {x: nx, y: ny},
	            start: {x: ax, y: ay},
	            end: {x: cx, y: cy},
	            alpha: alpha
	        };
	    }
	    function bezierBBox(p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y) {
	        if (!Snap.is(p1x, "array")) {
	            p1x = [p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y];
	        }
	        var bbox = curveDim.apply(null, p1x);
	        return box(
	            bbox.min.x,
	            bbox.min.y,
	            bbox.max.x - bbox.min.x,
	            bbox.max.y - bbox.min.y
	        );
	    }
	    function isPointInsideBBox(bbox, x, y) {
	        return  x >= bbox.x &&
	                x <= bbox.x + bbox.width &&
	                y >= bbox.y &&
	                y <= bbox.y + bbox.height;
	    }
	    function isBBoxIntersect(bbox1, bbox2) {
	        bbox1 = box(bbox1);
	        bbox2 = box(bbox2);
	        return isPointInsideBBox(bbox2, bbox1.x, bbox1.y)
	            || isPointInsideBBox(bbox2, bbox1.x2, bbox1.y)
	            || isPointInsideBBox(bbox2, bbox1.x, bbox1.y2)
	            || isPointInsideBBox(bbox2, bbox1.x2, bbox1.y2)
	            || isPointInsideBBox(bbox1, bbox2.x, bbox2.y)
	            || isPointInsideBBox(bbox1, bbox2.x2, bbox2.y)
	            || isPointInsideBBox(bbox1, bbox2.x, bbox2.y2)
	            || isPointInsideBBox(bbox1, bbox2.x2, bbox2.y2)
	            || (bbox1.x < bbox2.x2 && bbox1.x > bbox2.x
	                || bbox2.x < bbox1.x2 && bbox2.x > bbox1.x)
	            && (bbox1.y < bbox2.y2 && bbox1.y > bbox2.y
	                || bbox2.y < bbox1.y2 && bbox2.y > bbox1.y);
	    }
	    function base3(t, p1, p2, p3, p4) {
	        var t1 = -3 * p1 + 9 * p2 - 9 * p3 + 3 * p4,
	            t2 = t * t1 + 6 * p1 - 12 * p2 + 6 * p3;
	        return t * t2 - 3 * p1 + 3 * p2;
	    }
	    function bezlen(x1, y1, x2, y2, x3, y3, x4, y4, z) {
	        if (z == null) {
	            z = 1;
	        }
	        z = z > 1 ? 1 : z < 0 ? 0 : z;
	        var z2 = z / 2,
	            n = 12,
	            Tvalues = [-.1252,.1252,-.3678,.3678,-.5873,.5873,-.7699,.7699,-.9041,.9041,-.9816,.9816],
	            Cvalues = [0.2491,0.2491,0.2335,0.2335,0.2032,0.2032,0.1601,0.1601,0.1069,0.1069,0.0472,0.0472],
	            sum = 0;
	        for (var i = 0; i < n; i++) {
	            var ct = z2 * Tvalues[i] + z2,
	                xbase = base3(ct, x1, x2, x3, x4),
	                ybase = base3(ct, y1, y2, y3, y4),
	                comb = xbase * xbase + ybase * ybase;
	            sum += Cvalues[i] * math.sqrt(comb);
	        }
	        return z2 * sum;
	    }
	    function getTotLen(x1, y1, x2, y2, x3, y3, x4, y4, ll) {
	        if (ll < 0 || bezlen(x1, y1, x2, y2, x3, y3, x4, y4) < ll) {
	            return;
	        }
	        var t = 1,
	            step = t / 2,
	            t2 = t - step,
	            l,
	            e = .01;
	        l = bezlen(x1, y1, x2, y2, x3, y3, x4, y4, t2);
	        while (abs(l - ll) > e) {
	            step /= 2;
	            t2 += (l < ll ? 1 : -1) * step;
	            l = bezlen(x1, y1, x2, y2, x3, y3, x4, y4, t2);
	        }
	        return t2;
	    }
	    function intersect(x1, y1, x2, y2, x3, y3, x4, y4) {
	        if (
	            mmax(x1, x2) < mmin(x3, x4) ||
	            mmin(x1, x2) > mmax(x3, x4) ||
	            mmax(y1, y2) < mmin(y3, y4) ||
	            mmin(y1, y2) > mmax(y3, y4)
	        ) {
	            return;
	        }
	        var nx = (x1 * y2 - y1 * x2) * (x3 - x4) - (x1 - x2) * (x3 * y4 - y3 * x4),
	            ny = (x1 * y2 - y1 * x2) * (y3 - y4) - (y1 - y2) * (x3 * y4 - y3 * x4),
	            denominator = (x1 - x2) * (y3 - y4) - (y1 - y2) * (x3 - x4);
	
	        if (!denominator) {
	            return;
	        }
	        var px = nx / denominator,
	            py = ny / denominator,
	            px2 = +px.toFixed(2),
	            py2 = +py.toFixed(2);
	        if (
	            px2 < +mmin(x1, x2).toFixed(2) ||
	            px2 > +mmax(x1, x2).toFixed(2) ||
	            px2 < +mmin(x3, x4).toFixed(2) ||
	            px2 > +mmax(x3, x4).toFixed(2) ||
	            py2 < +mmin(y1, y2).toFixed(2) ||
	            py2 > +mmax(y1, y2).toFixed(2) ||
	            py2 < +mmin(y3, y4).toFixed(2) ||
	            py2 > +mmax(y3, y4).toFixed(2)
	        ) {
	            return;
	        }
	        return {x: px, y: py};
	    }
	    function inter(bez1, bez2) {
	        return interHelper(bez1, bez2);
	    }
	    function interCount(bez1, bez2) {
	        return interHelper(bez1, bez2, 1);
	    }
	    function interHelper(bez1, bez2, justCount) {
	        var bbox1 = bezierBBox(bez1),
	            bbox2 = bezierBBox(bez2);
	        if (!isBBoxIntersect(bbox1, bbox2)) {
	            return justCount ? 0 : [];
	        }
	        var l1 = bezlen.apply(0, bez1),
	            l2 = bezlen.apply(0, bez2),
	            n1 = ~~(l1 / 8),
	            n2 = ~~(l2 / 8),
	            dots1 = [],
	            dots2 = [],
	            xy = {},
	            res = justCount ? 0 : [];
	        for (var i = 0; i < n1 + 1; i++) {
	            var p = findDotsAtSegment.apply(0, bez1.concat(i / n1));
	            dots1.push({x: p.x, y: p.y, t: i / n1});
	        }
	        for (i = 0; i < n2 + 1; i++) {
	            p = findDotsAtSegment.apply(0, bez2.concat(i / n2));
	            dots2.push({x: p.x, y: p.y, t: i / n2});
	        }
	        for (i = 0; i < n1; i++) {
	            for (var j = 0; j < n2; j++) {
	                var di = dots1[i],
	                    di1 = dots1[i + 1],
	                    dj = dots2[j],
	                    dj1 = dots2[j + 1],
	                    ci = abs(di1.x - di.x) < .001 ? "y" : "x",
	                    cj = abs(dj1.x - dj.x) < .001 ? "y" : "x",
	                    is = intersect(di.x, di.y, di1.x, di1.y, dj.x, dj.y, dj1.x, dj1.y);
	                if (is) {
	                    if (xy[is.x.toFixed(4)] == is.y.toFixed(4)) {
	                        continue;
	                    }
	                    xy[is.x.toFixed(4)] = is.y.toFixed(4);
	                    var t1 = di.t + abs((is[ci] - di[ci]) / (di1[ci] - di[ci])) * (di1.t - di.t),
	                        t2 = dj.t + abs((is[cj] - dj[cj]) / (dj1[cj] - dj[cj])) * (dj1.t - dj.t);
	                    if (t1 >= 0 && t1 <= 1 && t2 >= 0 && t2 <= 1) {
	                        if (justCount) {
	                            res++;
	                        } else {
	                            res.push({
	                                x: is.x,
	                                y: is.y,
	                                t1: t1,
	                                t2: t2
	                            });
	                        }
	                    }
	                }
	            }
	        }
	        return res;
	    }
	    function pathIntersection(path1, path2) {
	        return interPathHelper(path1, path2);
	    }
	    function pathIntersectionNumber(path1, path2) {
	        return interPathHelper(path1, path2, 1);
	    }
	    function interPathHelper(path1, path2, justCount) {
	        path1 = path2curve(path1);
	        path2 = path2curve(path2);
	        var x1, y1, x2, y2, x1m, y1m, x2m, y2m, bez1, bez2,
	            res = justCount ? 0 : [];
	        for (var i = 0, ii = path1.length; i < ii; i++) {
	            var pi = path1[i];
	            if (pi[0] == "M") {
	                x1 = x1m = pi[1];
	                y1 = y1m = pi[2];
	            } else {
	                if (pi[0] == "C") {
	                    bez1 = [x1, y1].concat(pi.slice(1));
	                    x1 = bez1[6];
	                    y1 = bez1[7];
	                } else {
	                    bez1 = [x1, y1, x1, y1, x1m, y1m, x1m, y1m];
	                    x1 = x1m;
	                    y1 = y1m;
	                }
	                for (var j = 0, jj = path2.length; j < jj; j++) {
	                    var pj = path2[j];
	                    if (pj[0] == "M") {
	                        x2 = x2m = pj[1];
	                        y2 = y2m = pj[2];
	                    } else {
	                        if (pj[0] == "C") {
	                            bez2 = [x2, y2].concat(pj.slice(1));
	                            x2 = bez2[6];
	                            y2 = bez2[7];
	                        } else {
	                            bez2 = [x2, y2, x2, y2, x2m, y2m, x2m, y2m];
	                            x2 = x2m;
	                            y2 = y2m;
	                        }
	                        var intr = interHelper(bez1, bez2, justCount);
	                        if (justCount) {
	                            res += intr;
	                        } else {
	                            for (var k = 0, kk = intr.length; k < kk; k++) {
	                                intr[k].segment1 = i;
	                                intr[k].segment2 = j;
	                                intr[k].bez1 = bez1;
	                                intr[k].bez2 = bez2;
	                            }
	                            res = res.concat(intr);
	                        }
	                    }
	                }
	            }
	        }
	        return res;
	    }
	    function isPointInsidePath(path, x, y) {
	        var bbox = pathBBox(path);
	        return isPointInsideBBox(bbox, x, y) &&
	               interPathHelper(path, [["M", x, y], ["H", bbox.x2 + 10]], 1) % 2 == 1;
	    }
	    function pathBBox(path) {
	        var pth = paths(path);
	        if (pth.bbox) {
	            return clone(pth.bbox);
	        }
	        if (!path) {
	            return box();
	        }
	        path = path2curve(path);
	        var x = 0,
	            y = 0,
	            X = [],
	            Y = [],
	            p;
	        for (var i = 0, ii = path.length; i < ii; i++) {
	            p = path[i];
	            if (p[0] == "M") {
	                x = p[1];
	                y = p[2];
	                X.push(x);
	                Y.push(y);
	            } else {
	                var dim = curveDim(x, y, p[1], p[2], p[3], p[4], p[5], p[6]);
	                X = X.concat(dim.min.x, dim.max.x);
	                Y = Y.concat(dim.min.y, dim.max.y);
	                x = p[5];
	                y = p[6];
	            }
	        }
	        var xmin = mmin.apply(0, X),
	            ymin = mmin.apply(0, Y),
	            xmax = mmax.apply(0, X),
	            ymax = mmax.apply(0, Y),
	            bb = box(xmin, ymin, xmax - xmin, ymax - ymin);
	        pth.bbox = clone(bb);
	        return bb;
	    }
	    function rectPath(x, y, w, h, r) {
	        if (r) {
	            return [
	                ["M", +x + +r, y],
	                ["l", w - r * 2, 0],
	                ["a", r, r, 0, 0, 1, r, r],
	                ["l", 0, h - r * 2],
	                ["a", r, r, 0, 0, 1, -r, r],
	                ["l", r * 2 - w, 0],
	                ["a", r, r, 0, 0, 1, -r, -r],
	                ["l", 0, r * 2 - h],
	                ["a", r, r, 0, 0, 1, r, -r],
	                ["z"]
	            ];
	        }
	        var res = [["M", x, y], ["l", w, 0], ["l", 0, h], ["l", -w, 0], ["z"]];
	        res.toString = toString;
	        return res;
	    }
	    function ellipsePath(x, y, rx, ry, a) {
	        if (a == null && ry == null) {
	            ry = rx;
	        }
	        x = +x;
	        y = +y;
	        rx = +rx;
	        ry = +ry;
	        if (a != null) {
	            var rad = Math.PI / 180,
	                x1 = x + rx * Math.cos(-ry * rad),
	                x2 = x + rx * Math.cos(-a * rad),
	                y1 = y + rx * Math.sin(-ry * rad),
	                y2 = y + rx * Math.sin(-a * rad),
	                res = [["M", x1, y1], ["A", rx, rx, 0, +(a - ry > 180), 0, x2, y2]];
	        } else {
	            res = [
	                ["M", x, y],
	                ["m", 0, -ry],
	                ["a", rx, ry, 0, 1, 1, 0, 2 * ry],
	                ["a", rx, ry, 0, 1, 1, 0, -2 * ry],
	                ["z"]
	            ];
	        }
	        res.toString = toString;
	        return res;
	    }
	    var unit2px = Snap._unit2px,
	        getPath = {
	        path: function (el) {
	            return el.attr("path");
	        },
	        circle: function (el) {
	            var attr = unit2px(el);
	            return ellipsePath(attr.cx, attr.cy, attr.r);
	        },
	        ellipse: function (el) {
	            var attr = unit2px(el);
	            return ellipsePath(attr.cx || 0, attr.cy || 0, attr.rx, attr.ry);
	        },
	        rect: function (el) {
	            var attr = unit2px(el);
	            return rectPath(attr.x || 0, attr.y || 0, attr.width, attr.height, attr.rx, attr.ry);
	        },
	        image: function (el) {
	            var attr = unit2px(el);
	            return rectPath(attr.x || 0, attr.y || 0, attr.width, attr.height);
	        },
	        line: function (el) {
	            return "M" + [el.attr("x1") || 0, el.attr("y1") || 0, el.attr("x2"), el.attr("y2")];
	        },
	        polyline: function (el) {
	            return "M" + el.attr("points");
	        },
	        polygon: function (el) {
	            return "M" + el.attr("points") + "z";
	        },
	        deflt: function (el) {
	            var bbox = el.node.getBBox();
	            return rectPath(bbox.x, bbox.y, bbox.width, bbox.height);
	        }
	    };
	    function pathToRelative(pathArray) {
	        var pth = paths(pathArray),
	            lowerCase = String.prototype.toLowerCase;
	        if (pth.rel) {
	            return pathClone(pth.rel);
	        }
	        if (!Snap.is(pathArray, "array") || !Snap.is(pathArray && pathArray[0], "array")) {
	            pathArray = Snap.parsePathString(pathArray);
	        }
	        var res = [],
	            x = 0,
	            y = 0,
	            mx = 0,
	            my = 0,
	            start = 0;
	        if (pathArray[0][0] == "M") {
	            x = pathArray[0][1];
	            y = pathArray[0][2];
	            mx = x;
	            my = y;
	            start++;
	            res.push(["M", x, y]);
	        }
	        for (var i = start, ii = pathArray.length; i < ii; i++) {
	            var r = res[i] = [],
	                pa = pathArray[i];
	            if (pa[0] != lowerCase.call(pa[0])) {
	                r[0] = lowerCase.call(pa[0]);
	                switch (r[0]) {
	                    case "a":
	                        r[1] = pa[1];
	                        r[2] = pa[2];
	                        r[3] = pa[3];
	                        r[4] = pa[4];
	                        r[5] = pa[5];
	                        r[6] = +(pa[6] - x).toFixed(3);
	                        r[7] = +(pa[7] - y).toFixed(3);
	                        break;
	                    case "v":
	                        r[1] = +(pa[1] - y).toFixed(3);
	                        break;
	                    case "m":
	                        mx = pa[1];
	                        my = pa[2];
	                    default:
	                        for (var j = 1, jj = pa.length; j < jj; j++) {
	                            r[j] = +(pa[j] - (j % 2 ? x : y)).toFixed(3);
	                        }
	                }
	            } else {
	                r = res[i] = [];
	                if (pa[0] == "m") {
	                    mx = pa[1] + x;
	                    my = pa[2] + y;
	                }
	                for (var k = 0, kk = pa.length; k < kk; k++) {
	                    res[i][k] = pa[k];
	                }
	            }
	            var len = res[i].length;
	            switch (res[i][0]) {
	                case "z":
	                    x = mx;
	                    y = my;
	                    break;
	                case "h":
	                    x += +res[i][len - 1];
	                    break;
	                case "v":
	                    y += +res[i][len - 1];
	                    break;
	                default:
	                    x += +res[i][len - 2];
	                    y += +res[i][len - 1];
	            }
	        }
	        res.toString = toString;
	        pth.rel = pathClone(res);
	        return res;
	    }
	    function pathToAbsolute(pathArray) {
	        var pth = paths(pathArray);
	        if (pth.abs) {
	            return pathClone(pth.abs);
	        }
	        if (!is(pathArray, "array") || !is(pathArray && pathArray[0], "array")) { // rough assumption
	            pathArray = Snap.parsePathString(pathArray);
	        }
	        if (!pathArray || !pathArray.length) {
	            return [["M", 0, 0]];
	        }
	        var res = [],
	            x = 0,
	            y = 0,
	            mx = 0,
	            my = 0,
	            start = 0,
	            pa0;
	        if (pathArray[0][0] == "M") {
	            x = +pathArray[0][1];
	            y = +pathArray[0][2];
	            mx = x;
	            my = y;
	            start++;
	            res[0] = ["M", x, y];
	        }
	        var crz = pathArray.length == 3 &&
	            pathArray[0][0] == "M" &&
	            pathArray[1][0].toUpperCase() == "R" &&
	            pathArray[2][0].toUpperCase() == "Z";
	        for (var r, pa, i = start, ii = pathArray.length; i < ii; i++) {
	            res.push(r = []);
	            pa = pathArray[i];
	            pa0 = pa[0];
	            if (pa0 != pa0.toUpperCase()) {
	                r[0] = pa0.toUpperCase();
	                switch (r[0]) {
	                    case "A":
	                        r[1] = pa[1];
	                        r[2] = pa[2];
	                        r[3] = pa[3];
	                        r[4] = pa[4];
	                        r[5] = pa[5];
	                        r[6] = +pa[6] + x;
	                        r[7] = +pa[7] + y;
	                        break;
	                    case "V":
	                        r[1] = +pa[1] + y;
	                        break;
	                    case "H":
	                        r[1] = +pa[1] + x;
	                        break;
	                    case "R":
	                        var dots = [x, y].concat(pa.slice(1));
	                        for (var j = 2, jj = dots.length; j < jj; j++) {
	                            dots[j] = +dots[j] + x;
	                            dots[++j] = +dots[j] + y;
	                        }
	                        res.pop();
	                        res = res.concat(catmullRom2bezier(dots, crz));
	                        break;
	                    case "O":
	                        res.pop();
	                        dots = ellipsePath(x, y, pa[1], pa[2]);
	                        dots.push(dots[0]);
	                        res = res.concat(dots);
	                        break;
	                    case "U":
	                        res.pop();
	                        res = res.concat(ellipsePath(x, y, pa[1], pa[2], pa[3]));
	                        r = ["U"].concat(res[res.length - 1].slice(-2));
	                        break;
	                    case "M":
	                        mx = +pa[1] + x;
	                        my = +pa[2] + y;
	                    default:
	                        for (j = 1, jj = pa.length; j < jj; j++) {
	                            r[j] = +pa[j] + (j % 2 ? x : y);
	                        }
	                }
	            } else if (pa0 == "R") {
	                dots = [x, y].concat(pa.slice(1));
	                res.pop();
	                res = res.concat(catmullRom2bezier(dots, crz));
	                r = ["R"].concat(pa.slice(-2));
	            } else if (pa0 == "O") {
	                res.pop();
	                dots = ellipsePath(x, y, pa[1], pa[2]);
	                dots.push(dots[0]);
	                res = res.concat(dots);
	            } else if (pa0 == "U") {
	                res.pop();
	                res = res.concat(ellipsePath(x, y, pa[1], pa[2], pa[3]));
	                r = ["U"].concat(res[res.length - 1].slice(-2));
	            } else {
	                for (var k = 0, kk = pa.length; k < kk; k++) {
	                    r[k] = pa[k];
	                }
	            }
	            pa0 = pa0.toUpperCase();
	            if (pa0 != "O") {
	                switch (r[0]) {
	                    case "Z":
	                        x = +mx;
	                        y = +my;
	                        break;
	                    case "H":
	                        x = r[1];
	                        break;
	                    case "V":
	                        y = r[1];
	                        break;
	                    case "M":
	                        mx = r[r.length - 2];
	                        my = r[r.length - 1];
	                    default:
	                        x = r[r.length - 2];
	                        y = r[r.length - 1];
	                }
	            }
	        }
	        res.toString = toString;
	        pth.abs = pathClone(res);
	        return res;
	    }
	    function l2c(x1, y1, x2, y2) {
	        return [x1, y1, x2, y2, x2, y2];
	    }
	    function q2c(x1, y1, ax, ay, x2, y2) {
	        var _13 = 1 / 3,
	            _23 = 2 / 3;
	        return [
	                _13 * x1 + _23 * ax,
	                _13 * y1 + _23 * ay,
	                _13 * x2 + _23 * ax,
	                _13 * y2 + _23 * ay,
	                x2,
	                y2
	            ];
	    }
	    function a2c(x1, y1, rx, ry, angle, large_arc_flag, sweep_flag, x2, y2, recursive) {
	        // for more information of where this math came from visit:
	        // http://www.w3.org/TR/SVG11/implnote.html#ArcImplementationNotes
	        var _120 = PI * 120 / 180,
	            rad = PI / 180 * (+angle || 0),
	            res = [],
	            xy,
	            rotate = Snap._.cacher(function (x, y, rad) {
	                var X = x * math.cos(rad) - y * math.sin(rad),
	                    Y = x * math.sin(rad) + y * math.cos(rad);
	                return {x: X, y: Y};
	            });
	        if (!rx || !ry) {
	            return [x1, y1, x2, y2, x2, y2];
	        }
	        if (!recursive) {
	            xy = rotate(x1, y1, -rad);
	            x1 = xy.x;
	            y1 = xy.y;
	            xy = rotate(x2, y2, -rad);
	            x2 = xy.x;
	            y2 = xy.y;
	            var cos = math.cos(PI / 180 * angle),
	                sin = math.sin(PI / 180 * angle),
	                x = (x1 - x2) / 2,
	                y = (y1 - y2) / 2;
	            var h = x * x / (rx * rx) + y * y / (ry * ry);
	            if (h > 1) {
	                h = math.sqrt(h);
	                rx = h * rx;
	                ry = h * ry;
	            }
	            var rx2 = rx * rx,
	                ry2 = ry * ry,
	                k = (large_arc_flag == sweep_flag ? -1 : 1) *
	                    math.sqrt(abs((rx2 * ry2 - rx2 * y * y - ry2 * x * x) / (rx2 * y * y + ry2 * x * x))),
	                cx = k * rx * y / ry + (x1 + x2) / 2,
	                cy = k * -ry * x / rx + (y1 + y2) / 2,
	                f1 = math.asin(((y1 - cy) / ry).toFixed(9)),
	                f2 = math.asin(((y2 - cy) / ry).toFixed(9));
	
	            f1 = x1 < cx ? PI - f1 : f1;
	            f2 = x2 < cx ? PI - f2 : f2;
	            f1 < 0 && (f1 = PI * 2 + f1);
	            f2 < 0 && (f2 = PI * 2 + f2);
	            if (sweep_flag && f1 > f2) {
	                f1 = f1 - PI * 2;
	            }
	            if (!sweep_flag && f2 > f1) {
	                f2 = f2 - PI * 2;
	            }
	        } else {
	            f1 = recursive[0];
	            f2 = recursive[1];
	            cx = recursive[2];
	            cy = recursive[3];
	        }
	        var df = f2 - f1;
	        if (abs(df) > _120) {
	            var f2old = f2,
	                x2old = x2,
	                y2old = y2;
	            f2 = f1 + _120 * (sweep_flag && f2 > f1 ? 1 : -1);
	            x2 = cx + rx * math.cos(f2);
	            y2 = cy + ry * math.sin(f2);
	            res = a2c(x2, y2, rx, ry, angle, 0, sweep_flag, x2old, y2old, [f2, f2old, cx, cy]);
	        }
	        df = f2 - f1;
	        var c1 = math.cos(f1),
	            s1 = math.sin(f1),
	            c2 = math.cos(f2),
	            s2 = math.sin(f2),
	            t = math.tan(df / 4),
	            hx = 4 / 3 * rx * t,
	            hy = 4 / 3 * ry * t,
	            m1 = [x1, y1],
	            m2 = [x1 + hx * s1, y1 - hy * c1],
	            m3 = [x2 + hx * s2, y2 - hy * c2],
	            m4 = [x2, y2];
	        m2[0] = 2 * m1[0] - m2[0];
	        m2[1] = 2 * m1[1] - m2[1];
	        if (recursive) {
	            return [m2, m3, m4].concat(res);
	        } else {
	            res = [m2, m3, m4].concat(res).join().split(",");
	            var newres = [];
	            for (var i = 0, ii = res.length; i < ii; i++) {
	                newres[i] = i % 2 ? rotate(res[i - 1], res[i], rad).y : rotate(res[i], res[i + 1], rad).x;
	            }
	            return newres;
	        }
	    }
	    function findDotAtSegment(p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y, t) {
	        var t1 = 1 - t;
	        return {
	            x: pow(t1, 3) * p1x + pow(t1, 2) * 3 * t * c1x + t1 * 3 * t * t * c2x + pow(t, 3) * p2x,
	            y: pow(t1, 3) * p1y + pow(t1, 2) * 3 * t * c1y + t1 * 3 * t * t * c2y + pow(t, 3) * p2y
	        };
	    }
	
	    // Returns bounding box of cubic bezier curve.
	    // Source: http://blog.hackers-cafe.net/2009/06/how-to-calculate-bezier-curves-bounding.html
	    // Original version: NISHIO Hirokazu
	    // Modifications: https://github.com/timo22345
	    function curveDim(x0, y0, x1, y1, x2, y2, x3, y3) {
	        var tvalues = [],
	            bounds = [[], []],
	            a, b, c, t, t1, t2, b2ac, sqrtb2ac;
	        for (var i = 0; i < 2; ++i) {
	            if (i == 0) {
	                b = 6 * x0 - 12 * x1 + 6 * x2;
	                a = -3 * x0 + 9 * x1 - 9 * x2 + 3 * x3;
	                c = 3 * x1 - 3 * x0;
	            } else {
	                b = 6 * y0 - 12 * y1 + 6 * y2;
	                a = -3 * y0 + 9 * y1 - 9 * y2 + 3 * y3;
	                c = 3 * y1 - 3 * y0;
	            }
	            if (abs(a) < 1e-12) {
	                if (abs(b) < 1e-12) {
	                    continue;
	                }
	                t = -c / b;
	                if (0 < t && t < 1) {
	                    tvalues.push(t);
	                }
	                continue;
	            }
	            b2ac = b * b - 4 * c * a;
	            sqrtb2ac = math.sqrt(b2ac);
	            if (b2ac < 0) {
	                continue;
	            }
	            t1 = (-b + sqrtb2ac) / (2 * a);
	            if (0 < t1 && t1 < 1) {
	                tvalues.push(t1);
	            }
	            t2 = (-b - sqrtb2ac) / (2 * a);
	            if (0 < t2 && t2 < 1) {
	                tvalues.push(t2);
	            }
	        }
	
	        var x, y, j = tvalues.length,
	            jlen = j,
	            mt;
	        while (j--) {
	            t = tvalues[j];
	            mt = 1 - t;
	            bounds[0][j] = mt * mt * mt * x0 + 3 * mt * mt * t * x1 + 3 * mt * t * t * x2 + t * t * t * x3;
	            bounds[1][j] = mt * mt * mt * y0 + 3 * mt * mt * t * y1 + 3 * mt * t * t * y2 + t * t * t * y3;
	        }
	
	        bounds[0][jlen] = x0;
	        bounds[1][jlen] = y0;
	        bounds[0][jlen + 1] = x3;
	        bounds[1][jlen + 1] = y3;
	        bounds[0].length = bounds[1].length = jlen + 2;
	
	
	        return {
	          min: {x: mmin.apply(0, bounds[0]), y: mmin.apply(0, bounds[1])},
	          max: {x: mmax.apply(0, bounds[0]), y: mmax.apply(0, bounds[1])}
	        };
	    }
	
	    function path2curve(path, path2) {
	        var pth = !path2 && paths(path);
	        if (!path2 && pth.curve) {
	            return pathClone(pth.curve);
	        }
	        var p = pathToAbsolute(path),
	            p2 = path2 && pathToAbsolute(path2),
	            attrs = {x: 0, y: 0, bx: 0, by: 0, X: 0, Y: 0, qx: null, qy: null},
	            attrs2 = {x: 0, y: 0, bx: 0, by: 0, X: 0, Y: 0, qx: null, qy: null},
	            processPath = function (path, d, pcom) {
	                var nx, ny;
	                if (!path) {
	                    return ["C", d.x, d.y, d.x, d.y, d.x, d.y];
	                }
	                !(path[0] in {T: 1, Q: 1}) && (d.qx = d.qy = null);
	                switch (path[0]) {
	                    case "M":
	                        d.X = path[1];
	                        d.Y = path[2];
	                        break;
	                    case "A":
	                        path = ["C"].concat(a2c.apply(0, [d.x, d.y].concat(path.slice(1))));
	                        break;
	                    case "S":
	                        if (pcom == "C" || pcom == "S") { // In "S" case we have to take into account, if the previous command is C/S.
	                            nx = d.x * 2 - d.bx;          // And reflect the previous
	                            ny = d.y * 2 - d.by;          // command's control point relative to the current point.
	                        }
	                        else {                            // or some else or nothing
	                            nx = d.x;
	                            ny = d.y;
	                        }
	                        path = ["C", nx, ny].concat(path.slice(1));
	                        break;
	                    case "T":
	                        if (pcom == "Q" || pcom == "T") { // In "T" case we have to take into account, if the previous command is Q/T.
	                            d.qx = d.x * 2 - d.qx;        // And make a reflection similar
	                            d.qy = d.y * 2 - d.qy;        // to case "S".
	                        }
	                        else {                            // or something else or nothing
	                            d.qx = d.x;
	                            d.qy = d.y;
	                        }
	                        path = ["C"].concat(q2c(d.x, d.y, d.qx, d.qy, path[1], path[2]));
	                        break;
	                    case "Q":
	                        d.qx = path[1];
	                        d.qy = path[2];
	                        path = ["C"].concat(q2c(d.x, d.y, path[1], path[2], path[3], path[4]));
	                        break;
	                    case "L":
	                        path = ["C"].concat(l2c(d.x, d.y, path[1], path[2]));
	                        break;
	                    case "H":
	                        path = ["C"].concat(l2c(d.x, d.y, path[1], d.y));
	                        break;
	                    case "V":
	                        path = ["C"].concat(l2c(d.x, d.y, d.x, path[1]));
	                        break;
	                    case "Z":
	                        path = ["C"].concat(l2c(d.x, d.y, d.X, d.Y));
	                        break;
	                }
	                return path;
	            },
	            fixArc = function (pp, i) {
	                if (pp[i].length > 7) {
	                    pp[i].shift();
	                    var pi = pp[i];
	                    while (pi.length) {
	                        pcoms1[i] = "A"; // if created multiple C:s, their original seg is saved
	                        p2 && (pcoms2[i] = "A"); // the same as above
	                        pp.splice(i++, 0, ["C"].concat(pi.splice(0, 6)));
	                    }
	                    pp.splice(i, 1);
	                    ii = mmax(p.length, p2 && p2.length || 0);
	                }
	            },
	            fixM = function (path1, path2, a1, a2, i) {
	                if (path1 && path2 && path1[i][0] == "M" && path2[i][0] != "M") {
	                    path2.splice(i, 0, ["M", a2.x, a2.y]);
	                    a1.bx = 0;
	                    a1.by = 0;
	                    a1.x = path1[i][1];
	                    a1.y = path1[i][2];
	                    ii = mmax(p.length, p2 && p2.length || 0);
	                }
	            },
	            pcoms1 = [], // path commands of original path p
	            pcoms2 = [], // path commands of original path p2
	            pfirst = "", // temporary holder for original path command
	            pcom = ""; // holder for previous path command of original path
	        for (var i = 0, ii = mmax(p.length, p2 && p2.length || 0); i < ii; i++) {
	            p[i] && (pfirst = p[i][0]); // save current path command
	
	            if (pfirst != "C") // C is not saved yet, because it may be result of conversion
	            {
	                pcoms1[i] = pfirst; // Save current path command
	                i && ( pcom = pcoms1[i - 1]); // Get previous path command pcom
	            }
	            p[i] = processPath(p[i], attrs, pcom); // Previous path command is inputted to processPath
	
	            if (pcoms1[i] != "A" && pfirst == "C") pcoms1[i] = "C"; // A is the only command
	            // which may produce multiple C:s
	            // so we have to make sure that C is also C in original path
	
	            fixArc(p, i); // fixArc adds also the right amount of A:s to pcoms1
	
	            if (p2) { // the same procedures is done to p2
	                p2[i] && (pfirst = p2[i][0]);
	                if (pfirst != "C") {
	                    pcoms2[i] = pfirst;
	                    i && (pcom = pcoms2[i - 1]);
	                }
	                p2[i] = processPath(p2[i], attrs2, pcom);
	
	                if (pcoms2[i] != "A" && pfirst == "C") {
	                    pcoms2[i] = "C";
	                }
	
	                fixArc(p2, i);
	            }
	            fixM(p, p2, attrs, attrs2, i);
	            fixM(p2, p, attrs2, attrs, i);
	            var seg = p[i],
	                seg2 = p2 && p2[i],
	                seglen = seg.length,
	                seg2len = p2 && seg2.length;
	            attrs.x = seg[seglen - 2];
	            attrs.y = seg[seglen - 1];
	            attrs.bx = toFloat(seg[seglen - 4]) || attrs.x;
	            attrs.by = toFloat(seg[seglen - 3]) || attrs.y;
	            attrs2.bx = p2 && (toFloat(seg2[seg2len - 4]) || attrs2.x);
	            attrs2.by = p2 && (toFloat(seg2[seg2len - 3]) || attrs2.y);
	            attrs2.x = p2 && seg2[seg2len - 2];
	            attrs2.y = p2 && seg2[seg2len - 1];
	        }
	        if (!p2) {
	            pth.curve = pathClone(p);
	        }
	        return p2 ? [p, p2] : p;
	    }
	    function mapPath(path, matrix) {
	        if (!matrix) {
	            return path;
	        }
	        var x, y, i, j, ii, jj, pathi;
	        path = path2curve(path);
	        for (i = 0, ii = path.length; i < ii; i++) {
	            pathi = path[i];
	            for (j = 1, jj = pathi.length; j < jj; j += 2) {
	                x = matrix.x(pathi[j], pathi[j + 1]);
	                y = matrix.y(pathi[j], pathi[j + 1]);
	                pathi[j] = x;
	                pathi[j + 1] = y;
	            }
	        }
	        return path;
	    }
	
	    // http://schepers.cc/getting-to-the-point
	    function catmullRom2bezier(crp, z) {
	        var d = [];
	        for (var i = 0, iLen = crp.length; iLen - 2 * !z > i; i += 2) {
	            var p = [
	                        {x: +crp[i - 2], y: +crp[i - 1]},
	                        {x: +crp[i],     y: +crp[i + 1]},
	                        {x: +crp[i + 2], y: +crp[i + 3]},
	                        {x: +crp[i + 4], y: +crp[i + 5]}
	                    ];
	            if (z) {
	                if (!i) {
	                    p[0] = {x: +crp[iLen - 2], y: +crp[iLen - 1]};
	                } else if (iLen - 4 == i) {
	                    p[3] = {x: +crp[0], y: +crp[1]};
	                } else if (iLen - 2 == i) {
	                    p[2] = {x: +crp[0], y: +crp[1]};
	                    p[3] = {x: +crp[2], y: +crp[3]};
	                }
	            } else {
	                if (iLen - 4 == i) {
	                    p[3] = p[2];
	                } else if (!i) {
	                    p[0] = {x: +crp[i], y: +crp[i + 1]};
	                }
	            }
	            d.push(["C",
	                  (-p[0].x + 6 * p[1].x + p[2].x) / 6,
	                  (-p[0].y + 6 * p[1].y + p[2].y) / 6,
	                  (p[1].x + 6 * p[2].x - p[3].x) / 6,
	                  (p[1].y + 6*p[2].y - p[3].y) / 6,
	                  p[2].x,
	                  p[2].y
	            ]);
	        }
	
	        return d;
	    }
	
	    // export
	    Snap.path = paths;
	
	    /*\
	     * Snap.path.getTotalLength
	     [ method ]
	     **
	     * Returns the length of the given path in pixels
	     **
	     - path (string) SVG path string
	     **
	     = (number) length
	    \*/
	    Snap.path.getTotalLength = getTotalLength;
	    /*\
	     * Snap.path.getPointAtLength
	     [ method ]
	     **
	     * Returns the coordinates of the point located at the given length along the given path
	     **
	     - path (string) SVG path string
	     - length (number) length, in pixels, from the start of the path, excluding non-rendering jumps
	     **
	     = (object) representation of the point:
	     o {
	     o     x: (number) x coordinate,
	     o     y: (number) y coordinate,
	     o     alpha: (number) angle of derivative
	     o }
	    \*/
	    Snap.path.getPointAtLength = getPointAtLength;
	    /*\
	     * Snap.path.getSubpath
	     [ method ]
	     **
	     * Returns the subpath of a given path between given start and end lengths
	     **
	     - path (string) SVG path string
	     - from (number) length, in pixels, from the start of the path to the start of the segment
	     - to (number) length, in pixels, from the start of the path to the end of the segment
	     **
	     = (string) path string definition for the segment
	    \*/
	    Snap.path.getSubpath = function (path, from, to) {
	        if (this.getTotalLength(path) - to < 1e-6) {
	            return getSubpathsAtLength(path, from).end;
	        }
	        var a = getSubpathsAtLength(path, to, 1);
	        return from ? getSubpathsAtLength(a, from).end : a;
	    };
	    /*\
	     * Element.getTotalLength
	     [ method ]
	     **
	     * Returns the length of the path in pixels (only works for `path` elements)
	     = (number) length
	    \*/
	    elproto.getTotalLength = function () {
	        if (this.node.getTotalLength) {
	            return this.node.getTotalLength();
	        }
	    };
	    // SIERRA Element.getPointAtLength()/Element.getTotalLength(): If a <path> is broken into different segments, is the jump distance to the new coordinates set by the _M_ or _m_ commands calculated as part of the path's total length?
	    /*\
	     * Element.getPointAtLength
	     [ method ]
	     **
	     * Returns coordinates of the point located at the given length on the given path (only works for `path` elements)
	     **
	     - length (number) length, in pixels, from the start of the path, excluding non-rendering jumps
	     **
	     = (object) representation of the point:
	     o {
	     o     x: (number) x coordinate,
	     o     y: (number) y coordinate,
	     o     alpha: (number) angle of derivative
	     o }
	    \*/
	    elproto.getPointAtLength = function (length) {
	        return getPointAtLength(this.attr("d"), length);
	    };
	    // SIERRA Element.getSubpath(): Similar to the problem for Element.getPointAtLength(). Unclear how this would work for a segmented path. Overall, the concept of _subpath_ and what I'm calling a _segment_ (series of non-_M_ or _Z_ commands) is unclear.
	    /*\
	     * Element.getSubpath
	     [ method ]
	     **
	     * Returns subpath of a given element from given start and end lengths (only works for `path` elements)
	     **
	     - from (number) length, in pixels, from the start of the path to the start of the segment
	     - to (number) length, in pixels, from the start of the path to the end of the segment
	     **
	     = (string) path string definition for the segment
	    \*/
	    elproto.getSubpath = function (from, to) {
	        return Snap.path.getSubpath(this.attr("d"), from, to);
	    };
	    Snap._.box = box;
	    /*\
	     * Snap.path.findDotsAtSegment
	     [ method ]
	     **
	     * Utility method
	     **
	     * Finds dot coordinates on the given cubic beziér curve at the given t
	     - p1x (number) x of the first point of the curve
	     - p1y (number) y of the first point of the curve
	     - c1x (number) x of the first anchor of the curve
	     - c1y (number) y of the first anchor of the curve
	     - c2x (number) x of the second anchor of the curve
	     - c2y (number) y of the second anchor of the curve
	     - p2x (number) x of the second point of the curve
	     - p2y (number) y of the second point of the curve
	     - t (number) position on the curve (0..1)
	     = (object) point information in format:
	     o {
	     o     x: (number) x coordinate of the point,
	     o     y: (number) y coordinate of the point,
	     o     m: {
	     o         x: (number) x coordinate of the left anchor,
	     o         y: (number) y coordinate of the left anchor
	     o     },
	     o     n: {
	     o         x: (number) x coordinate of the right anchor,
	     o         y: (number) y coordinate of the right anchor
	     o     },
	     o     start: {
	     o         x: (number) x coordinate of the start of the curve,
	     o         y: (number) y coordinate of the start of the curve
	     o     },
	     o     end: {
	     o         x: (number) x coordinate of the end of the curve,
	     o         y: (number) y coordinate of the end of the curve
	     o     },
	     o     alpha: (number) angle of the curve derivative at the point
	     o }
	    \*/
	    Snap.path.findDotsAtSegment = findDotsAtSegment;
	    /*\
	     * Snap.path.bezierBBox
	     [ method ]
	     **
	     * Utility method
	     **
	     * Returns the bounding box of a given cubic beziér curve
	     - p1x (number) x of the first point of the curve
	     - p1y (number) y of the first point of the curve
	     - c1x (number) x of the first anchor of the curve
	     - c1y (number) y of the first anchor of the curve
	     - c2x (number) x of the second anchor of the curve
	     - c2y (number) y of the second anchor of the curve
	     - p2x (number) x of the second point of the curve
	     - p2y (number) y of the second point of the curve
	     * or
	     - bez (array) array of six points for beziér curve
	     = (object) bounding box
	     o {
	     o     x: (number) x coordinate of the left top point of the box,
	     o     y: (number) y coordinate of the left top point of the box,
	     o     x2: (number) x coordinate of the right bottom point of the box,
	     o     y2: (number) y coordinate of the right bottom point of the box,
	     o     width: (number) width of the box,
	     o     height: (number) height of the box
	     o }
	    \*/
	    Snap.path.bezierBBox = bezierBBox;
	    /*\
	     * Snap.path.isPointInsideBBox
	     [ method ]
	     **
	     * Utility method
	     **
	     * Returns `true` if given point is inside bounding box
	     - bbox (string) bounding box
	     - x (string) x coordinate of the point
	     - y (string) y coordinate of the point
	     = (boolean) `true` if point is inside
	    \*/
	    Snap.path.isPointInsideBBox = isPointInsideBBox;
	    Snap.closest = function (x, y, X, Y) {
	        var r = 100,
	            b = box(x - r / 2, y - r / 2, r, r),
	            inside = [],
	            getter = X[0].hasOwnProperty("x") ? function (i) {
	                return {
	                    x: X[i].x,
	                    y: X[i].y
	                };
	            } : function (i) {
	                return {
	                    x: X[i],
	                    y: Y[i]
	                };
	            },
	            found = 0;
	        while (r <= 1e6 && !found) {
	            for (var i = 0, ii = X.length; i < ii; i++) {
	                var xy = getter(i);
	                if (isPointInsideBBox(b, xy.x, xy.y)) {
	                    found++;
	                    inside.push(xy);
	                    break;
	                }
	            }
	            if (!found) {
	                r *= 2;
	                b = box(x - r / 2, y - r / 2, r, r)
	            }
	        }
	        if (r == 1e6) {
	            return;
	        }
	        var len = Infinity,
	            res;
	        for (i = 0, ii = inside.length; i < ii; i++) {
	            var l = Snap.len(x, y, inside[i].x, inside[i].y);
	            if (len > l) {
	                len = l;
	                inside[i].len = l;
	                res = inside[i];
	            }
	        }
	        return res;
	    };
	    /*\
	     * Snap.path.isBBoxIntersect
	     [ method ]
	     **
	     * Utility method
	     **
	     * Returns `true` if two bounding boxes intersect
	     - bbox1 (string) first bounding box
	     - bbox2 (string) second bounding box
	     = (boolean) `true` if bounding boxes intersect
	    \*/
	    Snap.path.isBBoxIntersect = isBBoxIntersect;
	    /*\
	     * Snap.path.intersection
	     [ method ]
	     **
	     * Utility method
	     **
	     * Finds intersections of two paths
	     - path1 (string) path string
	     - path2 (string) path string
	     = (array) dots of intersection
	     o [
	     o     {
	     o         x: (number) x coordinate of the point,
	     o         y: (number) y coordinate of the point,
	     o         t1: (number) t value for segment of path1,
	     o         t2: (number) t value for segment of path2,
	     o         segment1: (number) order number for segment of path1,
	     o         segment2: (number) order number for segment of path2,
	     o         bez1: (array) eight coordinates representing beziér curve for the segment of path1,
	     o         bez2: (array) eight coordinates representing beziér curve for the segment of path2
	     o     }
	     o ]
	    \*/
	    Snap.path.intersection = pathIntersection;
	    Snap.path.intersectionNumber = pathIntersectionNumber;
	    /*\
	     * Snap.path.isPointInside
	     [ method ]
	     **
	     * Utility method
	     **
	     * Returns `true` if given point is inside a given closed path.
	     *
	     * Note: fill mode doesn’t affect the result of this method.
	     - path (string) path string
	     - x (number) x of the point
	     - y (number) y of the point
	     = (boolean) `true` if point is inside the path
	    \*/
	    Snap.path.isPointInside = isPointInsidePath;
	    /*\
	     * Snap.path.getBBox
	     [ method ]
	     **
	     * Utility method
	     **
	     * Returns the bounding box of a given path
	     - path (string) path string
	     = (object) bounding box
	     o {
	     o     x: (number) x coordinate of the left top point of the box,
	     o     y: (number) y coordinate of the left top point of the box,
	     o     x2: (number) x coordinate of the right bottom point of the box,
	     o     y2: (number) y coordinate of the right bottom point of the box,
	     o     width: (number) width of the box,
	     o     height: (number) height of the box
	     o }
	    \*/
	    Snap.path.getBBox = pathBBox;
	    Snap.path.get = getPath;
	    /*\
	     * Snap.path.toRelative
	     [ method ]
	     **
	     * Utility method
	     **
	     * Converts path coordinates into relative values
	     - path (string) path string
	     = (array) path string
	    \*/
	    Snap.path.toRelative = pathToRelative;
	    /*\
	     * Snap.path.toAbsolute
	     [ method ]
	     **
	     * Utility method
	     **
	     * Converts path coordinates into absolute values
	     - path (string) path string
	     = (array) path string
	    \*/
	    Snap.path.toAbsolute = pathToAbsolute;
	    /*\
	     * Snap.path.toCubic
	     [ method ]
	     **
	     * Utility method
	     **
	     * Converts path to a new path where all segments are cubic beziér curves
	     - pathString (string|array) path string or array of segments
	     = (array) array of segments
	    \*/
	    Snap.path.toCubic = path2curve;
	    /*\
	     * Snap.path.map
	     [ method ]
	     **
	     * Transform the path string with the given matrix
	     - path (string) path string
	     - matrix (object) see @Matrix
	     = (string) transformed path string
	    \*/
	    Snap.path.map = mapPath;
	    Snap.path.toString = toString;
	    Snap.path.clone = pathClone;
	});
	
	// Copyright (c) 2013 Adobe Systems Incorporated. All rights reserved.
	//
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//
	// http://www.apache.org/licenses/LICENSE-2.0
	//
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// See the License for the specific language governing permissions and
	// limitations under the License.
	Snap.plugin(function (Snap, Element, Paper, glob) {
	    var mmax = Math.max,
	        mmin = Math.min;
	
	    // Set
	    var Set = function (items) {
	        this.items = [];
		this.bindings = {};
	        this.length = 0;
	        this.type = "set";
	        if (items) {
	            for (var i = 0, ii = items.length; i < ii; i++) {
	                if (items[i]) {
	                    this[this.items.length] = this.items[this.items.length] = items[i];
	                    this.length++;
	                }
	            }
	        }
	    },
	    setproto = Set.prototype;
	    /*\
	     * Set.push
	     [ method ]
	     **
	     * Adds each argument to the current set
	     = (object) original element
	    \*/
	    setproto.push = function () {
	        var item,
	            len;
	        for (var i = 0, ii = arguments.length; i < ii; i++) {
	            item = arguments[i];
	            if (item) {
	                len = this.items.length;
	                this[len] = this.items[len] = item;
	                this.length++;
	            }
	        }
	        return this;
	    };
	    /*\
	     * Set.pop
	     [ method ]
	     **
	     * Removes last element and returns it
	     = (object) element
	    \*/
	    setproto.pop = function () {
	        this.length && delete this[this.length--];
	        return this.items.pop();
	    };
	    /*\
	     * Set.forEach
	     [ method ]
	     **
	     * Executes given function for each element in the set
	     *
	     * If the function returns `false`, the loop stops running.
	     **
	     - callback (function) function to run
	     - thisArg (object) context object for the callback
	     = (object) Set object
	    \*/
	    setproto.forEach = function (callback, thisArg) {
	        for (var i = 0, ii = this.items.length; i < ii; i++) {
	            if (callback.call(thisArg, this.items[i], i) === false) {
	                return this;
	            }
	        }
	        return this;
	    };
	    /*\
	     * Set.animate
	     [ method ]
	     **
	     * Animates each element in set in sync.
	     *
	     **
	     - attrs (object) key-value pairs of destination attributes
	     - duration (number) duration of the animation in milliseconds
	     - easing (function) #optional easing function from @mina or custom
	     - callback (function) #optional callback function that executes when the animation ends
	     * or
	     - animation (array) array of animation parameter for each element in set in format `[attrs, duration, easing, callback]`
	     > Usage
	     | // animate all elements in set to radius 10
	     | set.animate({r: 10}, 500, mina.easein);
	     | // or
	     | // animate first element to radius 10, but second to radius 20 and in different time
	     | set.animate([{r: 10}, 500, mina.easein], [{r: 20}, 1500, mina.easein]);
	     = (Element) the current element
	    \*/
	    setproto.animate = function (attrs, ms, easing, callback) {
	        if (typeof easing == "function" && !easing.length) {
	            callback = easing;
	            easing = mina.linear;
	        }
	        if (attrs instanceof Snap._.Animation) {
	            callback = attrs.callback;
	            easing = attrs.easing;
	            ms = easing.dur;
	            attrs = attrs.attr;
	        }
	        var args = arguments;
	        if (Snap.is(attrs, "array") && Snap.is(args[args.length - 1], "array")) {
	            var each = true;
	        }
	        var begin,
	            handler = function () {
	                if (begin) {
	                    this.b = begin;
	                } else {
	                    begin = this.b;
	                }
	            },
	            cb = 0,
	            set = this,
	            callbacker = callback && function () {
	                if (++cb == set.length) {
	                    callback.call(this);
	                }
	            };
	        return this.forEach(function (el, i) {
	            eve.once("snap.animcreated." + el.id, handler);
	            if (each) {
	                args[i] && el.animate.apply(el, args[i]);
	            } else {
	                el.animate(attrs, ms, easing, callbacker);
	            }
	        });
	    };
	    /*\
	     * Set.remove
	     [ method ]
	     **
	     * Removes all children of the set.
	     *
	     = (object) Set object
	    \*/
	    setproto.remove = function () {
	        while (this.length) {
	            this.pop().remove();
	        }
	        return this;
	    };
	    /*\
	     * Set.bind
	     [ method ]
	     **
	     * Specifies how to handle a specific attribute when applied
	     * to a set.
	     *
	     **
	     - attr (string) attribute name
	     - callback (function) function to run
	     * or
	     - attr (string) attribute name
	     - element (Element) specific element in the set to apply the attribute to
	     * or
	     - attr (string) attribute name
	     - element (Element) specific element in the set to apply the attribute to
	     - eattr (string) attribute on the element to bind the attribute to
	     = (object) Set object
	    \*/
	    setproto.bind = function (attr, a, b) {
	        var data = {};
	        if (typeof a == "function") {
	            this.bindings[attr] = a;
	        } else {
	            var aname = b || attr;
	            this.bindings[attr] = function (v) {
	                data[aname] = v;
	                a.attr(data);
	            };
	        }
	        return this;
	    };
	    /*\
	     * Set.attr
	     [ method ]
	     **
	     * Equivalent of @Element.attr.
	     = (object) Set object
	    \*/
	    setproto.attr = function (value) {
	        var unbound = {};
	        for (var k in value) {
	            if (this.bindings[k]) {
	                this.bindings[k](value[k]);
	            } else {
	                unbound[k] = value[k];
	            }
	        }
	        for (var i = 0, ii = this.items.length; i < ii; i++) {
	            this.items[i].attr(unbound);
	        }
	        return this;
	    };
	    /*\
	     * Set.clear
	     [ method ]
	     **
	     * Removes all elements from the set
	    \*/
	    setproto.clear = function () {
	        while (this.length) {
	            this.pop();
	        }
	    };
	    /*\
	     * Set.splice
	     [ method ]
	     **
	     * Removes range of elements from the set
	     **
	     - index (number) position of the deletion
	     - count (number) number of element to remove
	     - insertion… (object) #optional elements to insert
	     = (object) set elements that were deleted
	    \*/
	    setproto.splice = function (index, count, insertion) {
	        index = index < 0 ? mmax(this.length + index, 0) : index;
	        count = mmax(0, mmin(this.length - index, count));
	        var tail = [],
	            todel = [],
	            args = [],
	            i;
	        for (i = 2; i < arguments.length; i++) {
	            args.push(arguments[i]);
	        }
	        for (i = 0; i < count; i++) {
	            todel.push(this[index + i]);
	        }
	        for (; i < this.length - index; i++) {
	            tail.push(this[index + i]);
	        }
	        var arglen = args.length;
	        for (i = 0; i < arglen + tail.length; i++) {
	            this.items[index + i] = this[index + i] = i < arglen ? args[i] : tail[i - arglen];
	        }
	        i = this.items.length = this.length -= count - arglen;
	        while (this[i]) {
	            delete this[i++];
	        }
	        return new Set(todel);
	    };
	    /*\
	     * Set.exclude
	     [ method ]
	     **
	     * Removes given element from the set
	     **
	     - element (object) element to remove
	     = (boolean) `true` if object was found and removed from the set
	    \*/
	    setproto.exclude = function (el) {
	        for (var i = 0, ii = this.length; i < ii; i++) if (this[i] == el) {
	            this.splice(i, 1);
	            return true;
	        }
	        return false;
	    };
	    /*\
	     * Set.insertAfter
	     [ method ]
	     **
	     * Inserts set elements after given element.
	     **
	     - element (object) set will be inserted after this element
	     = (object) Set object
	    \*/
	    setproto.insertAfter = function (el) {
	        var i = this.items.length;
	        while (i--) {
	            this.items[i].insertAfter(el);
	        }
	        return this;
	    };
	    /*\
	     * Set.getBBox
	     [ method ]
	     **
	     * Union of all bboxes of the set. See @Element.getBBox.
	     = (object) bounding box descriptor. See @Element.getBBox.
	    \*/
	    setproto.getBBox = function () {
	        var x = [],
	            y = [],
	            x2 = [],
	            y2 = [];
	        for (var i = this.items.length; i--;) if (!this.items[i].removed) {
	            var box = this.items[i].getBBox();
	            x.push(box.x);
	            y.push(box.y);
	            x2.push(box.x + box.width);
	            y2.push(box.y + box.height);
	        }
	        x = mmin.apply(0, x);
	        y = mmin.apply(0, y);
	        x2 = mmax.apply(0, x2);
	        y2 = mmax.apply(0, y2);
	        return {
	            x: x,
	            y: y,
	            x2: x2,
	            y2: y2,
	            width: x2 - x,
	            height: y2 - y,
	            cx: x + (x2 - x) / 2,
	            cy: y + (y2 - y) / 2
	        };
	    };
	    /*\
	     * Set.insertAfter
	     [ method ]
	     **
	     * Creates a clone of the set.
	     **
	     = (object) New Set object
	    \*/
	    setproto.clone = function (s) {
	        s = new Set;
	        for (var i = 0, ii = this.items.length; i < ii; i++) {
	            s.push(this.items[i].clone());
	        }
	        return s;
	    };
	    setproto.toString = function () {
	        return "Snap\u2018s set";
	    };
	    setproto.type = "set";
	    // export
	    /*\
	     * Snap.Set
	     [ property ]
	     **
	     * Set constructor.
	    \*/
	    Snap.Set = Set;
	    /*\
	     * Snap.set
	     [ method ]
	     **
	     * Creates a set and fills it with list of arguments.
	     **
	     = (object) New Set object
	     | var r = paper.rect(0, 0, 10, 10),
	     |     s1 = Snap.set(), // empty set
	     |     s2 = Snap.set(r, paper.circle(100, 100, 20)); // prefilled set
	    \*/
	    Snap.set = function () {
	        var set = new Set;
	        if (arguments.length) {
	            set.push.apply(set, Array.prototype.slice.call(arguments, 0));
	        }
	        return set;
	    };
	});
	
	// Copyright (c) 2013 Adobe Systems Incorporated. All rights reserved.
	//
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//
	// http://www.apache.org/licenses/LICENSE-2.0
	//
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// See the License for the specific language governing permissions and
	// limitations under the License.
	Snap.plugin(function (Snap, Element, Paper, glob) {
	    var names = {},
	        reUnit = /[%a-z]+$/i,
	        Str = String;
	    names.stroke = names.fill = "colour";
	    function getEmpty(item) {
	        var l = item[0];
	        switch (l.toLowerCase()) {
	            case "t": return [l, 0, 0];
	            case "m": return [l, 1, 0, 0, 1, 0, 0];
	            case "r": if (item.length == 4) {
	                return [l, 0, item[2], item[3]];
	            } else {
	                return [l, 0];
	            }
	            case "s": if (item.length == 5) {
	                return [l, 1, 1, item[3], item[4]];
	            } else if (item.length == 3) {
	                return [l, 1, 1];
	            } else {
	                return [l, 1];
	            }
	        }
	    }
	    function equaliseTransform(t1, t2, getBBox) {
	        t1 = t1 || new Snap.Matrix;
	        t2 = t2 || new Snap.Matrix;
	        t1 = Snap.parseTransformString(t1.toTransformString()) || [];
	        t2 = Snap.parseTransformString(t2.toTransformString()) || [];
	        var maxlength = Math.max(t1.length, t2.length),
	            from = [],
	            to = [],
	            i = 0, j, jj,
	            tt1, tt2;
	        for (; i < maxlength; i++) {
	            tt1 = t1[i] || getEmpty(t2[i]);
	            tt2 = t2[i] || getEmpty(tt1);
	            if (tt1[0] != tt2[0] ||
	                tt1[0].toLowerCase() == "r" && (tt1[2] != tt2[2] || tt1[3] != tt2[3]) ||
	                tt1[0].toLowerCase() == "s" && (tt1[3] != tt2[3] || tt1[4] != tt2[4])
	                ) {
	                    t1 = Snap._.transform2matrix(t1, getBBox());
	                    t2 = Snap._.transform2matrix(t2, getBBox());
	                    from = [["m", t1.a, t1.b, t1.c, t1.d, t1.e, t1.f]];
	                    to = [["m", t2.a, t2.b, t2.c, t2.d, t2.e, t2.f]];
	                    break;
	            }
	            from[i] = [];
	            to[i] = [];
	            for (j = 0, jj = Math.max(tt1.length, tt2.length); j < jj; j++) {
	                j in tt1 && (from[i][j] = tt1[j]);
	                j in tt2 && (to[i][j] = tt2[j]);
	            }
	        }
	        return {
	            from: path2array(from),
	            to: path2array(to),
	            f: getPath(from)
	        };
	    }
	    function getNumber(val) {
	        return val;
	    }
	    function getUnit(unit) {
	        return function (val) {
	            return +val.toFixed(3) + unit;
	        };
	    }
	    function getViewBox(val) {
	        return val.join(" ");
	    }
	    function getColour(clr) {
	        return Snap.rgb(clr[0], clr[1], clr[2], clr[3]);
	    }
	    function getPath(path) {
	        var k = 0, i, ii, j, jj, out, a, b = [];
	        for (i = 0, ii = path.length; i < ii; i++) {
	            out = "[";
	            a = ['"' + path[i][0] + '"'];
	            for (j = 1, jj = path[i].length; j < jj; j++) {
	                a[j] = "val[" + k++ + "]";
	            }
	            out += a + "]";
	            b[i] = out;
	        }
	        return Function("val", "return Snap.path.toString.call([" + b + "])");
	    }
	    function path2array(path) {
	        var out = [];
	        for (var i = 0, ii = path.length; i < ii; i++) {
	            for (var j = 1, jj = path[i].length; j < jj; j++) {
	                out.push(path[i][j]);
	            }
	        }
	        return out;
	    }
	    function isNumeric(obj) {
	        return isFinite(obj);
	    }
	    function arrayEqual(arr1, arr2) {
	        if (!Snap.is(arr1, "array") || !Snap.is(arr2, "array")) {
	            return false;
	        }
	        return arr1.toString() == arr2.toString();
	    }
	    Element.prototype.equal = function (name, b) {
	        return eve("snap.util.equal", this, name, b).firstDefined();
	    };
	    eve.on("snap.util.equal", function (name, b) {
	        var A, B, a = Str(this.attr(name) || ""),
	            el = this;
	        if (names[name] == "colour") {
	            A = Snap.color(a);
	            B = Snap.color(b);
	            return {
	                from: [A.r, A.g, A.b, A.opacity],
	                to: [B.r, B.g, B.b, B.opacity],
	                f: getColour
	            };
	        }
	        if (name == "viewBox") {
	            A = this.attr(name).vb.split(" ").map(Number);
	            B = b.split(" ").map(Number);
	            return {
	                from: A,
	                to: B,
	                f: getViewBox
	            };
	        }
	        if (name == "transform" || name == "gradientTransform" || name == "patternTransform") {
	            if (typeof b == "string") {
	                b = Str(b).replace(/\.{3}|\u2026/g, a);
	            }
	            a = this.matrix;
	            if (!Snap._.rgTransform.test(b)) {
	                b = Snap._.transform2matrix(Snap._.svgTransform2string(b), this.getBBox());
	            } else {
	                b = Snap._.transform2matrix(b, this.getBBox());
	            }
	            return equaliseTransform(a, b, function () {
	                return el.getBBox(1);
	            });
	        }
	        if (name == "d" || name == "path") {
	            A = Snap.path.toCubic(a, b);
	            return {
	                from: path2array(A[0]),
	                to: path2array(A[1]),
	                f: getPath(A[0])
	            };
	        }
	        if (name == "points") {
	            A = Str(a).split(Snap._.separator);
	            B = Str(b).split(Snap._.separator);
	            return {
	                from: A,
	                to: B,
	                f: function (val) { return val; }
	            };
	        }
	        if (isNumeric(a) && isNumeric(b)) {
	            return {
	                from: parseFloat(a),
	                to: parseFloat(b),
	                f: getNumber
	            };
	        }
	        var aUnit = a.match(reUnit),
	            bUnit = Str(b).match(reUnit);
	        if (aUnit && arrayEqual(aUnit, bUnit)) {
	            return {
	                from: parseFloat(a),
	                to: parseFloat(b),
	                f: getUnit(aUnit)
	            };
	        } else {
	            return {
	                from: this.asPX(name),
	                to: this.asPX(name, b),
	                f: getNumber
	            };
	        }
	    });
	});
	
	// Copyright (c) 2013 Adobe Systems Incorporated. All rights reserved.
	// 
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	// 
	// http://www.apache.org/licenses/LICENSE-2.0
	// 
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// See the License for the specific language governing permissions and
	// limitations under the License.
	Snap.plugin(function (Snap, Element, Paper, glob) {
	    var elproto = Element.prototype,
	    has = "hasOwnProperty",
	    supportsTouch = "createTouch" in glob.doc,
	    events = [
	        "click", "dblclick", "mousedown", "mousemove", "mouseout",
	        "mouseover", "mouseup", "touchstart", "touchmove", "touchend",
	        "touchcancel"
	    ],
	    touchMap = {
	        mousedown: "touchstart",
	        mousemove: "touchmove",
	        mouseup: "touchend"
	    },
	    getScroll = function (xy, el) {
	        var name = xy == "y" ? "scrollTop" : "scrollLeft",
	            doc = el && el.node ? el.node.ownerDocument : glob.doc;
	        return doc[name in doc.documentElement ? "documentElement" : "body"][name];
	    },
	    preventDefault = function () {
	        this.returnValue = false;
	    },
	    preventTouch = function () {
	        return this.originalEvent.preventDefault();
	    },
	    stopPropagation = function () {
	        this.cancelBubble = true;
	    },
	    stopTouch = function () {
	        return this.originalEvent.stopPropagation();
	    },
	    addEvent = function (obj, type, fn, element) {
	        var realName = supportsTouch && touchMap[type] ? touchMap[type] : type,
	            f = function (e) {
	                var scrollY = getScroll("y", element),
	                    scrollX = getScroll("x", element);
	                if (supportsTouch && touchMap[has](type)) {
	                    for (var i = 0, ii = e.targetTouches && e.targetTouches.length; i < ii; i++) {
	                        if (e.targetTouches[i].target == obj || obj.contains(e.targetTouches[i].target)) {
	                            var olde = e;
	                            e = e.targetTouches[i];
	                            e.originalEvent = olde;
	                            e.preventDefault = preventTouch;
	                            e.stopPropagation = stopTouch;
	                            break;
	                        }
	                    }
	                }
	                var x = e.clientX + scrollX,
	                    y = e.clientY + scrollY;
	                return fn.call(element, e, x, y);
	            };
	
	        if (type !== realName) {
	            obj.addEventListener(type, f, false);
	        }
	
	        obj.addEventListener(realName, f, false);
	
	        return function () {
	            if (type !== realName) {
	                obj.removeEventListener(type, f, false);
	            }
	
	            obj.removeEventListener(realName, f, false);
	            return true;
	        };
	    },
	    drag = [],
	    dragMove = function (e) {
	        var x = e.clientX,
	            y = e.clientY,
	            scrollY = getScroll("y"),
	            scrollX = getScroll("x"),
	            dragi,
	            j = drag.length;
	        while (j--) {
	            dragi = drag[j];
	            if (supportsTouch) {
	                var i = e.touches && e.touches.length,
	                    touch;
	                while (i--) {
	                    touch = e.touches[i];
	                    if (touch.identifier == dragi.el._drag.id || dragi.el.node.contains(touch.target)) {
	                        x = touch.clientX;
	                        y = touch.clientY;
	                        (e.originalEvent ? e.originalEvent : e).preventDefault();
	                        break;
	                    }
	                }
	            } else {
	                e.preventDefault();
	            }
	            var node = dragi.el.node,
	                o,
	                next = node.nextSibling,
	                parent = node.parentNode,
	                display = node.style.display;
	            // glob.win.opera && parent.removeChild(node);
	            // node.style.display = "none";
	            // o = dragi.el.paper.getElementByPoint(x, y);
	            // node.style.display = display;
	            // glob.win.opera && (next ? parent.insertBefore(node, next) : parent.appendChild(node));
	            // o && eve("snap.drag.over." + dragi.el.id, dragi.el, o);
	            x += scrollX;
	            y += scrollY;
	            eve("snap.drag.move." + dragi.el.id, dragi.move_scope || dragi.el, x - dragi.el._drag.x, y - dragi.el._drag.y, x, y, e);
	        }
	    },
	    dragUp = function (e) {
	        Snap.unmousemove(dragMove).unmouseup(dragUp);
	        var i = drag.length,
	            dragi;
	        while (i--) {
	            dragi = drag[i];
	            dragi.el._drag = {};
	            eve("snap.drag.end." + dragi.el.id, dragi.end_scope || dragi.start_scope || dragi.move_scope || dragi.el, e);
	            eve.off("snap.drag.*." + dragi.el.id);
	        }
	        drag = [];
	    };
	    /*\
	     * Element.click
	     [ method ]
	     **
	     * Adds a click event handler to the element
	     - handler (function) handler for the event
	     = (object) @Element
	    \*/
	    /*\
	     * Element.unclick
	     [ method ]
	     **
	     * Removes a click event handler from the element
	     - handler (function) handler for the event
	     = (object) @Element
	    \*/
	    
	    /*\
	     * Element.dblclick
	     [ method ]
	     **
	     * Adds a double click event handler to the element
	     - handler (function) handler for the event
	     = (object) @Element
	    \*/
	    /*\
	     * Element.undblclick
	     [ method ]
	     **
	     * Removes a double click event handler from the element
	     - handler (function) handler for the event
	     = (object) @Element
	    \*/
	    
	    /*\
	     * Element.mousedown
	     [ method ]
	     **
	     * Adds a mousedown event handler to the element
	     - handler (function) handler for the event
	     = (object) @Element
	    \*/
	    /*\
	     * Element.unmousedown
	     [ method ]
	     **
	     * Removes a mousedown event handler from the element
	     - handler (function) handler for the event
	     = (object) @Element
	    \*/
	    
	    /*\
	     * Element.mousemove
	     [ method ]
	     **
	     * Adds a mousemove event handler to the element
	     - handler (function) handler for the event
	     = (object) @Element
	    \*/
	    /*\
	     * Element.unmousemove
	     [ method ]
	     **
	     * Removes a mousemove event handler from the element
	     - handler (function) handler for the event
	     = (object) @Element
	    \*/
	    
	    /*\
	     * Element.mouseout
	     [ method ]
	     **
	     * Adds a mouseout event handler to the element
	     - handler (function) handler for the event
	     = (object) @Element
	    \*/
	    /*\
	     * Element.unmouseout
	     [ method ]
	     **
	     * Removes a mouseout event handler from the element
	     - handler (function) handler for the event
	     = (object) @Element
	    \*/
	    
	    /*\
	     * Element.mouseover
	     [ method ]
	     **
	     * Adds a mouseover event handler to the element
	     - handler (function) handler for the event
	     = (object) @Element
	    \*/
	    /*\
	     * Element.unmouseover
	     [ method ]
	     **
	     * Removes a mouseover event handler from the element
	     - handler (function) handler for the event
	     = (object) @Element
	    \*/
	    
	    /*\
	     * Element.mouseup
	     [ method ]
	     **
	     * Adds a mouseup event handler to the element
	     - handler (function) handler for the event
	     = (object) @Element
	    \*/
	    /*\
	     * Element.unmouseup
	     [ method ]
	     **
	     * Removes a mouseup event handler from the element
	     - handler (function) handler for the event
	     = (object) @Element
	    \*/
	    
	    /*\
	     * Element.touchstart
	     [ method ]
	     **
	     * Adds a touchstart event handler to the element
	     - handler (function) handler for the event
	     = (object) @Element
	    \*/
	    /*\
	     * Element.untouchstart
	     [ method ]
	     **
	     * Removes a touchstart event handler from the element
	     - handler (function) handler for the event
	     = (object) @Element
	    \*/
	    
	    /*\
	     * Element.touchmove
	     [ method ]
	     **
	     * Adds a touchmove event handler to the element
	     - handler (function) handler for the event
	     = (object) @Element
	    \*/
	    /*\
	     * Element.untouchmove
	     [ method ]
	     **
	     * Removes a touchmove event handler from the element
	     - handler (function) handler for the event
	     = (object) @Element
	    \*/
	    
	    /*\
	     * Element.touchend
	     [ method ]
	     **
	     * Adds a touchend event handler to the element
	     - handler (function) handler for the event
	     = (object) @Element
	    \*/
	    /*\
	     * Element.untouchend
	     [ method ]
	     **
	     * Removes a touchend event handler from the element
	     - handler (function) handler for the event
	     = (object) @Element
	    \*/
	    
	    /*\
	     * Element.touchcancel
	     [ method ]
	     **
	     * Adds a touchcancel event handler to the element
	     - handler (function) handler for the event
	     = (object) @Element
	    \*/
	    /*\
	     * Element.untouchcancel
	     [ method ]
	     **
	     * Removes a touchcancel event handler from the element
	     - handler (function) handler for the event
	     = (object) @Element
	    \*/
	    for (var i = events.length; i--;) {
	        (function (eventName) {
	            Snap[eventName] = elproto[eventName] = function (fn, scope) {
	                if (Snap.is(fn, "function")) {
	                    this.events = this.events || [];
	                    this.events.push({
	                        name: eventName,
	                        f: fn,
	                        unbind: addEvent(this.node || document, eventName, fn, scope || this)
	                    });
	                } else {
	                    for (var i = 0, ii = this.events.length; i < ii; i++) if (this.events[i].name == eventName) {
	                        try {
	                            this.events[i].f.call(this);
	                        } catch (e) {}
	                    }
	                }
	                return this;
	            };
	            Snap["un" + eventName] =
	            elproto["un" + eventName] = function (fn) {
	                var events = this.events || [],
	                    l = events.length;
	                while (l--) if (events[l].name == eventName &&
	                               (events[l].f == fn || !fn)) {
	                    events[l].unbind();
	                    events.splice(l, 1);
	                    !events.length && delete this.events;
	                    return this;
	                }
	                return this;
	            };
	        })(events[i]);
	    }
	    /*\
	     * Element.hover
	     [ method ]
	     **
	     * Adds hover event handlers to the element
	     - f_in (function) handler for hover in
	     - f_out (function) handler for hover out
	     - icontext (object) #optional context for hover in handler
	     - ocontext (object) #optional context for hover out handler
	     = (object) @Element
	    \*/
	    elproto.hover = function (f_in, f_out, scope_in, scope_out) {
	        return this.mouseover(f_in, scope_in).mouseout(f_out, scope_out || scope_in);
	    };
	    /*\
	     * Element.unhover
	     [ method ]
	     **
	     * Removes hover event handlers from the element
	     - f_in (function) handler for hover in
	     - f_out (function) handler for hover out
	     = (object) @Element
	    \*/
	    elproto.unhover = function (f_in, f_out) {
	        return this.unmouseover(f_in).unmouseout(f_out);
	    };
	    var draggable = [];
	    // SIERRA unclear what _context_ refers to for starting, ending, moving the drag gesture.
	    // SIERRA Element.drag(): _x position of the mouse_: Where are the x/y values offset from?
	    // SIERRA Element.drag(): much of this member's doc appears to be duplicated for some reason.
	    // SIERRA Unclear about this sentence: _Additionally following drag events will be triggered: drag.start.<id> on start, drag.end.<id> on end and drag.move.<id> on every move._ Is there a global _drag_ object to which you can assign handlers keyed by an element's ID?
	    /*\
	     * Element.drag
	     [ method ]
	     **
	     * Adds event handlers for an element's drag gesture
	     **
	     - onmove (function) handler for moving
	     - onstart (function) handler for drag start
	     - onend (function) handler for drag end
	     - mcontext (object) #optional context for moving handler
	     - scontext (object) #optional context for drag start handler
	     - econtext (object) #optional context for drag end handler
	     * Additionaly following `drag` events are triggered: `drag.start.<id>` on start, 
	     * `drag.end.<id>` on end and `drag.move.<id>` on every move. When element is dragged over another element 
	     * `drag.over.<id>` fires as well.
	     *
	     * Start event and start handler are called in specified context or in context of the element with following parameters:
	     o x (number) x position of the mouse
	     o y (number) y position of the mouse
	     o event (object) DOM event object
	     * Move event and move handler are called in specified context or in context of the element with following parameters:
	     o dx (number) shift by x from the start point
	     o dy (number) shift by y from the start point
	     o x (number) x position of the mouse
	     o y (number) y position of the mouse
	     o event (object) DOM event object
	     * End event and end handler are called in specified context or in context of the element with following parameters:
	     o event (object) DOM event object
	     = (object) @Element
	    \*/
	    elproto.drag = function (onmove, onstart, onend, move_scope, start_scope, end_scope) {
	        var el = this;
	        if (!arguments.length) {
	            var origTransform;
	            return el.drag(function (dx, dy) {
	                this.attr({
	                    transform: origTransform + (origTransform ? "T" : "t") + [dx, dy]
	                });
	            }, function () {
	                origTransform = this.transform().local;
	            });
	        }
	        function start(e, x, y) {
	            (e.originalEvent || e).preventDefault();
	            el._drag.x = x;
	            el._drag.y = y;
	            el._drag.id = e.identifier;
	            !drag.length && Snap.mousemove(dragMove).mouseup(dragUp);
	            drag.push({el: el, move_scope: move_scope, start_scope: start_scope, end_scope: end_scope});
	            onstart && eve.on("snap.drag.start." + el.id, onstart);
	            onmove && eve.on("snap.drag.move." + el.id, onmove);
	            onend && eve.on("snap.drag.end." + el.id, onend);
	            eve("snap.drag.start." + el.id, start_scope || move_scope || el, x, y, e);
	        }
	        function init(e, x, y) {
	            eve("snap.draginit." + el.id, el, e, x, y);
	        }
	        eve.on("snap.draginit." + el.id, start);
	        el._drag = {};
	        draggable.push({el: el, start: start, init: init});
	        el.mousedown(init);
	        return el;
	    };
	    /*
	     * Element.onDragOver
	     [ method ]
	     **
	     * Shortcut to assign event handler for `drag.over.<id>` event, where `id` is the element's `id` (see @Element.id)
	     - f (function) handler for event, first argument would be the element you are dragging over
	    \*/
	    // elproto.onDragOver = function (f) {
	    //     f ? eve.on("snap.drag.over." + this.id, f) : eve.unbind("snap.drag.over." + this.id);
	    // };
	    /*\
	     * Element.undrag
	     [ method ]
	     **
	     * Removes all drag event handlers from the given element
	    \*/
	    elproto.undrag = function () {
	        var i = draggable.length;
	        while (i--) if (draggable[i].el == this) {
	            this.unmousedown(draggable[i].init);
	            draggable.splice(i, 1);
	            eve.unbind("snap.drag.*." + this.id);
	            eve.unbind("snap.draginit." + this.id);
	        }
	        !draggable.length && Snap.unmousemove(dragMove).unmouseup(dragUp);
	        return this;
	    };
	});
	
	// Copyright (c) 2013 Adobe Systems Incorporated. All rights reserved.
	//
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//
	// http://www.apache.org/licenses/LICENSE-2.0
	//
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// See the License for the specific language governing permissions and
	// limitations under the License.
	Snap.plugin(function (Snap, Element, Paper, glob) {
	    var elproto = Element.prototype,
	        pproto = Paper.prototype,
	        rgurl = /^\s*url\((.+)\)/,
	        Str = String,
	        $ = Snap._.$;
	    Snap.filter = {};
	    /*\
	     * Paper.filter
	     [ method ]
	     **
	     * Creates a `<filter>` element
	     **
	     - filstr (string) SVG fragment of filter provided as a string
	     = (object) @Element
	     * Note: It is recommended to use filters embedded into the page inside an empty SVG element.
	     > Usage
	     | var f = paper.filter('<feGaussianBlur stdDeviation="2"/>'),
	     |     c = paper.circle(10, 10, 10).attr({
	     |         filter: f
	     |     });
	    \*/
	    pproto.filter = function (filstr) {
	        var paper = this;
	        if (paper.type != "svg") {
	            paper = paper.paper;
	        }
	        var f = Snap.parse(Str(filstr)),
	            id = Snap._.id(),
	            width = paper.node.offsetWidth,
	            height = paper.node.offsetHeight,
	            filter = $("filter");
	        $(filter, {
	            id: id,
	            filterUnits: "userSpaceOnUse"
	        });
	        filter.appendChild(f.node);
	        paper.defs.appendChild(filter);
	        return new Element(filter);
	    };
	
	    eve.on("snap.util.getattr.filter", function () {
	        eve.stop();
	        var p = $(this.node, "filter");
	        if (p) {
	            var match = Str(p).match(rgurl);
	            return match && Snap.select(match[1]);
	        }
	    });
	    eve.on("snap.util.attr.filter", function (value) {
	        if (value instanceof Element && value.type == "filter") {
	            eve.stop();
	            var id = value.node.id;
	            if (!id) {
	                $(value.node, {id: value.id});
	                id = value.id;
	            }
	            $(this.node, {
	                filter: Snap.url(id)
	            });
	        }
	        if (!value || value == "none") {
	            eve.stop();
	            this.node.removeAttribute("filter");
	        }
	    });
	    /*\
	     * Snap.filter.blur
	     [ method ]
	     **
	     * Returns an SVG markup string for the blur filter
	     **
	     - x (number) amount of horizontal blur, in pixels
	     - y (number) #optional amount of vertical blur, in pixels
	     = (string) filter representation
	     > Usage
	     | var f = paper.filter(Snap.filter.blur(5, 10)),
	     |     c = paper.circle(10, 10, 10).attr({
	     |         filter: f
	     |     });
	    \*/
	    Snap.filter.blur = function (x, y) {
	        if (x == null) {
	            x = 2;
	        }
	        var def = y == null ? x : [x, y];
	        return Snap.format('\<feGaussianBlur stdDeviation="{def}"/>', {
	            def: def
	        });
	    };
	    Snap.filter.blur.toString = function () {
	        return this();
	    };
	    /*\
	     * Snap.filter.shadow
	     [ method ]
	     **
	     * Returns an SVG markup string for the shadow filter
	     **
	     - dx (number) #optional horizontal shift of the shadow, in pixels
	     - dy (number) #optional vertical shift of the shadow, in pixels
	     - blur (number) #optional amount of blur
	     - color (string) #optional color of the shadow
	     - opacity (number) #optional `0..1` opacity of the shadow
	     * or
	     - dx (number) #optional horizontal shift of the shadow, in pixels
	     - dy (number) #optional vertical shift of the shadow, in pixels
	     - color (string) #optional color of the shadow
	     - opacity (number) #optional `0..1` opacity of the shadow
	     * which makes blur default to `4`. Or
	     - dx (number) #optional horizontal shift of the shadow, in pixels
	     - dy (number) #optional vertical shift of the shadow, in pixels
	     - opacity (number) #optional `0..1` opacity of the shadow
	     = (string) filter representation
	     > Usage
	     | var f = paper.filter(Snap.filter.shadow(0, 2, .3)),
	     |     c = paper.circle(10, 10, 10).attr({
	     |         filter: f
	     |     });
	    \*/
	    Snap.filter.shadow = function (dx, dy, blur, color, opacity) {
	        if (opacity == null) {
	            if (color == null) {
	                opacity = blur;
	                blur = 4;
	                color = "#000";
	            } else {
	                opacity = color;
	                color = blur;
	                blur = 4;
	            }
	        }
	        if (blur == null) {
	            blur = 4;
	        }
	        if (opacity == null) {
	            opacity = 1;
	        }
	        if (dx == null) {
	            dx = 0;
	            dy = 2;
	        }
	        if (dy == null) {
	            dy = dx;
	        }
	        color = Snap.color(color);
	        return Snap.format('<feGaussianBlur in="SourceAlpha" stdDeviation="{blur}"/><feOffset dx="{dx}" dy="{dy}" result="offsetblur"/><feFlood flood-color="{color}"/><feComposite in2="offsetblur" operator="in"/><feComponentTransfer><feFuncA type="linear" slope="{opacity}"/></feComponentTransfer><feMerge><feMergeNode/><feMergeNode in="SourceGraphic"/></feMerge>', {
	            color: color,
	            dx: dx,
	            dy: dy,
	            blur: blur,
	            opacity: opacity
	        });
	    };
	    Snap.filter.shadow.toString = function () {
	        return this();
	    };
	    /*\
	     * Snap.filter.grayscale
	     [ method ]
	     **
	     * Returns an SVG markup string for the grayscale filter
	     **
	     - amount (number) amount of filter (`0..1`)
	     = (string) filter representation
	    \*/
	    Snap.filter.grayscale = function (amount) {
	        if (amount == null) {
	            amount = 1;
	        }
	        return Snap.format('<feColorMatrix type="matrix" values="{a} {b} {c} 0 0 {d} {e} {f} 0 0 {g} {b} {h} 0 0 0 0 0 1 0"/>', {
	            a: 0.2126 + 0.7874 * (1 - amount),
	            b: 0.7152 - 0.7152 * (1 - amount),
	            c: 0.0722 - 0.0722 * (1 - amount),
	            d: 0.2126 - 0.2126 * (1 - amount),
	            e: 0.7152 + 0.2848 * (1 - amount),
	            f: 0.0722 - 0.0722 * (1 - amount),
	            g: 0.2126 - 0.2126 * (1 - amount),
	            h: 0.0722 + 0.9278 * (1 - amount)
	        });
	    };
	    Snap.filter.grayscale.toString = function () {
	        return this();
	    };
	    /*\
	     * Snap.filter.sepia
	     [ method ]
	     **
	     * Returns an SVG markup string for the sepia filter
	     **
	     - amount (number) amount of filter (`0..1`)
	     = (string) filter representation
	    \*/
	    Snap.filter.sepia = function (amount) {
	        if (amount == null) {
	            amount = 1;
	        }
	        return Snap.format('<feColorMatrix type="matrix" values="{a} {b} {c} 0 0 {d} {e} {f} 0 0 {g} {h} {i} 0 0 0 0 0 1 0"/>', {
	            a: 0.393 + 0.607 * (1 - amount),
	            b: 0.769 - 0.769 * (1 - amount),
	            c: 0.189 - 0.189 * (1 - amount),
	            d: 0.349 - 0.349 * (1 - amount),
	            e: 0.686 + 0.314 * (1 - amount),
	            f: 0.168 - 0.168 * (1 - amount),
	            g: 0.272 - 0.272 * (1 - amount),
	            h: 0.534 - 0.534 * (1 - amount),
	            i: 0.131 + 0.869 * (1 - amount)
	        });
	    };
	    Snap.filter.sepia.toString = function () {
	        return this();
	    };
	    /*\
	     * Snap.filter.saturate
	     [ method ]
	     **
	     * Returns an SVG markup string for the saturate filter
	     **
	     - amount (number) amount of filter (`0..1`)
	     = (string) filter representation
	    \*/
	    Snap.filter.saturate = function (amount) {
	        if (amount == null) {
	            amount = 1;
	        }
	        return Snap.format('<feColorMatrix type="saturate" values="{amount}"/>', {
	            amount: 1 - amount
	        });
	    };
	    Snap.filter.saturate.toString = function () {
	        return this();
	    };
	    /*\
	     * Snap.filter.hueRotate
	     [ method ]
	     **
	     * Returns an SVG markup string for the hue-rotate filter
	     **
	     - angle (number) angle of rotation
	     = (string) filter representation
	    \*/
	    Snap.filter.hueRotate = function (angle) {
	        angle = angle || 0;
	        return Snap.format('<feColorMatrix type="hueRotate" values="{angle}"/>', {
	            angle: angle
	        });
	    };
	    Snap.filter.hueRotate.toString = function () {
	        return this();
	    };
	    /*\
	     * Snap.filter.invert
	     [ method ]
	     **
	     * Returns an SVG markup string for the invert filter
	     **
	     - amount (number) amount of filter (`0..1`)
	     = (string) filter representation
	    \*/
	    Snap.filter.invert = function (amount) {
	        if (amount == null) {
	            amount = 1;
	        }
	//        <feColorMatrix type="matrix" values="-1 0 0 0 1  0 -1 0 0 1  0 0 -1 0 1  0 0 0 1 0" color-interpolation-filters="sRGB"/>
	        return Snap.format('<feComponentTransfer><feFuncR type="table" tableValues="{amount} {amount2}"/><feFuncG type="table" tableValues="{amount} {amount2}"/><feFuncB type="table" tableValues="{amount} {amount2}"/></feComponentTransfer>', {
	            amount: amount,
	            amount2: 1 - amount
	        });
	    };
	    Snap.filter.invert.toString = function () {
	        return this();
	    };
	    /*\
	     * Snap.filter.brightness
	     [ method ]
	     **
	     * Returns an SVG markup string for the brightness filter
	     **
	     - amount (number) amount of filter (`0..1`)
	     = (string) filter representation
	    \*/
	    Snap.filter.brightness = function (amount) {
	        if (amount == null) {
	            amount = 1;
	        }
	        return Snap.format('<feComponentTransfer><feFuncR type="linear" slope="{amount}"/><feFuncG type="linear" slope="{amount}"/><feFuncB type="linear" slope="{amount}"/></feComponentTransfer>', {
	            amount: amount
	        });
	    };
	    Snap.filter.brightness.toString = function () {
	        return this();
	    };
	    /*\
	     * Snap.filter.contrast
	     [ method ]
	     **
	     * Returns an SVG markup string for the contrast filter
	     **
	     - amount (number) amount of filter (`0..1`)
	     = (string) filter representation
	    \*/
	    Snap.filter.contrast = function (amount) {
	        if (amount == null) {
	            amount = 1;
	        }
	        return Snap.format('<feComponentTransfer><feFuncR type="linear" slope="{amount}" intercept="{amount2}"/><feFuncG type="linear" slope="{amount}" intercept="{amount2}"/><feFuncB type="linear" slope="{amount}" intercept="{amount2}"/></feComponentTransfer>', {
	            amount: amount,
	            amount2: .5 - amount / 2
	        });
	    };
	    Snap.filter.contrast.toString = function () {
	        return this();
	    };
	});
	
	// Copyright (c) 2014 Adobe Systems Incorporated. All rights reserved.
	//
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//
	// http://www.apache.org/licenses/LICENSE-2.0
	//
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// See the License for the specific language governing permissions and
	// limitations under the License.
	Snap.plugin(function (Snap, Element, Paper, glob, Fragment) {
	    var box = Snap._.box,
	        is = Snap.is,
	        firstLetter = /^[^a-z]*([tbmlrc])/i,
	        toString = function () {
	            return "T" + this.dx + "," + this.dy;
	        };
	    /*\
	     * Element.getAlign
	     [ method ]
	     **
	     * Returns shift needed to align the element relatively to given element.
	     * If no elements specified, parent `<svg>` container will be used.
	     - el (object) @optional alignment element
	     - way (string) one of six values: `"top"`, `"middle"`, `"bottom"`, `"left"`, `"center"`, `"right"`
	     = (object|string) Object in format `{dx: , dy: }` also has a string representation as a transformation string
	     > Usage
	     | el.transform(el.getAlign(el2, "top"));
	     * or
	     | var dy = el.getAlign(el2, "top").dy;
	    \*/
	    Element.prototype.getAlign = function (el, way) {
	        if (way == null && is(el, "string")) {
	            way = el;
	            el = null;
	        }
	        el = el || this.paper;
	        var bx = el.getBBox ? el.getBBox() : box(el),
	            bb = this.getBBox(),
	            out = {};
	        way = way && way.match(firstLetter);
	        way = way ? way[1].toLowerCase() : "c";
	        switch (way) {
	            case "t":
	                out.dx = 0;
	                out.dy = bx.y - bb.y;
	            break;
	            case "b":
	                out.dx = 0;
	                out.dy = bx.y2 - bb.y2;
	            break;
	            case "m":
	                out.dx = 0;
	                out.dy = bx.cy - bb.cy;
	            break;
	            case "l":
	                out.dx = bx.x - bb.x;
	                out.dy = 0;
	            break;
	            case "r":
	                out.dx = bx.x2 - bb.x2;
	                out.dy = 0;
	            break;
	            default:
	                out.dx = bx.cx - bb.cx;
	                out.dy = 0;
	            break;
	        }
	        out.toString = toString;
	        return out;
	    };
	    /*\
	     * Element.align
	     [ method ]
	     **
	     * Aligns the element relatively to given one via transformation.
	     * If no elements specified, parent `<svg>` container will be used.
	     - el (object) @optional alignment element
	     - way (string) one of six values: `"top"`, `"middle"`, `"bottom"`, `"left"`, `"center"`, `"right"`
	     = (object) this element
	     > Usage
	     | el.align(el2, "top");
	     * or
	     | el.align("middle");
	    \*/
	    Element.prototype.align = function (el, way) {
	        return this.transform("..." + this.getAlign(el, way));
	    };
	});
	
	// Copyright (c) 2016 Adobe Systems Incorporated. All rights reserved.
	//
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//
	// http://www.apache.org/licenses/LICENSE-2.0
	//
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// See the License for the specific language governing permissions and
	// limitations under the License.
	Snap.plugin(function (Snap, Element, Paper, glob, Fragment) {
	    var elproto = Element.prototype,
	        is = Snap.is,
	        Str = String,
	        has = "hasOwnProperty";
	    function slice(from, to, f) {
	        return function (arr) {
	            var res = arr.slice(from, to);
	            if (res.length == 1) {
	                res = res[0];
	            }
	            return f ? f(res) : res;
	        };
	    }
	    var Animation = function (attr, ms, easing, callback) {
	        if (typeof easing == "function" && !easing.length) {
	            callback = easing;
	            easing = mina.linear;
	        }
	        this.attr = attr;
	        this.dur = ms;
	        easing && (this.easing = easing);
	        callback && (this.callback = callback);
	    };
	    Snap._.Animation = Animation;
	    /*\
	     * Snap.animation
	     [ method ]
	     **
	     * Creates an animation object
	     **
	     - attr (object) attributes of final destination
	     - duration (number) duration of the animation, in milliseconds
	     - easing (function) #optional one of easing functions of @mina or custom one
	     - callback (function) #optional callback function that fires when animation ends
	     = (object) animation object
	    \*/
	    Snap.animation = function (attr, ms, easing, callback) {
	        return new Animation(attr, ms, easing, callback);
	    };
	    /*\
	     * Element.inAnim
	     [ method ]
	     **
	     * Returns a set of animations that may be able to manipulate the current element
	     **
	     = (object) in format:
	     o {
	     o     anim (object) animation object,
	     o     mina (object) @mina object,
	     o     curStatus (number) 0..1 — status of the animation: 0 — just started, 1 — just finished,
	     o     status (function) gets or sets the status of the animation,
	     o     stop (function) stops the animation
	     o }
	    \*/
	    elproto.inAnim = function () {
	        var el = this,
	            res = [];
	        for (var id in el.anims) if (el.anims[has](id)) {
	            (function (a) {
	                res.push({
	                    anim: new Animation(a._attrs, a.dur, a.easing, a._callback),
	                    mina: a,
	                    curStatus: a.status(),
	                    status: function (val) {
	                        return a.status(val);
	                    },
	                    stop: function () {
	                        a.stop();
	                    }
	                });
	            }(el.anims[id]));
	        }
	        return res;
	    };
	    /*\
	     * Snap.animate
	     [ method ]
	     **
	     * Runs generic animation of one number into another with a caring function
	     **
	     - from (number|array) number or array of numbers
	     - to (number|array) number or array of numbers
	     - setter (function) caring function that accepts one number argument
	     - duration (number) duration, in milliseconds
	     - easing (function) #optional easing function from @mina or custom
	     - callback (function) #optional callback function to execute when animation ends
	     = (object) animation object in @mina format
	     o {
	     o     id (string) animation id, consider it read-only,
	     o     duration (function) gets or sets the duration of the animation,
	     o     easing (function) easing,
	     o     speed (function) gets or sets the speed of the animation,
	     o     status (function) gets or sets the status of the animation,
	     o     stop (function) stops the animation
	     o }
	     | var rect = Snap().rect(0, 0, 10, 10);
	     | Snap.animate(0, 10, function (val) {
	     |     rect.attr({
	     |         x: val
	     |     });
	     | }, 1000);
	     | // in given context is equivalent to
	     | rect.animate({x: 10}, 1000);
	    \*/
	    Snap.animate = function (from, to, setter, ms, easing, callback) {
	        if (typeof easing == "function" && !easing.length) {
	            callback = easing;
	            easing = mina.linear;
	        }
	        var now = mina.time(),
	            anim = mina(from, to, now, now + ms, mina.time, setter, easing);
	        callback && eve.once("mina.finish." + anim.id, callback);
	        return anim;
	    };
	    /*\
	     * Element.stop
	     [ method ]
	     **
	     * Stops all the animations for the current element
	     **
	     = (Element) the current element
	    \*/
	    elproto.stop = function () {
	        var anims = this.inAnim();
	        for (var i = 0, ii = anims.length; i < ii; i++) {
	            anims[i].stop();
	        }
	        return this;
	    };
	    /*\
	     * Element.animate
	     [ method ]
	     **
	     * Animates the given attributes of the element
	     **
	     - attrs (object) key-value pairs of destination attributes
	     - duration (number) duration of the animation in milliseconds
	     - easing (function) #optional easing function from @mina or custom
	     - callback (function) #optional callback function that executes when the animation ends
	     = (Element) the current element
	    \*/
	    elproto.animate = function (attrs, ms, easing, callback) {
	        if (typeof easing == "function" && !easing.length) {
	            callback = easing;
	            easing = mina.linear;
	        }
	        if (attrs instanceof Animation) {
	            callback = attrs.callback;
	            easing = attrs.easing;
	            ms = attrs.dur;
	            attrs = attrs.attr;
	        }
	        var fkeys = [], tkeys = [], keys = {}, from, to, f, eq,
	            el = this;
	        for (var key in attrs) if (attrs[has](key)) {
	            if (el.equal) {
	                eq = el.equal(key, Str(attrs[key]));
	                from = eq.from;
	                to = eq.to;
	                f = eq.f;
	            } else {
	                from = +el.attr(key);
	                to = +attrs[key];
	            }
	            var len = is(from, "array") ? from.length : 1;
	            keys[key] = slice(fkeys.length, fkeys.length + len, f);
	            fkeys = fkeys.concat(from);
	            tkeys = tkeys.concat(to);
	        }
	        var now = mina.time(),
	            anim = mina(fkeys, tkeys, now, now + ms, mina.time, function (val) {
	                var attr = {};
	                for (var key in keys) if (keys[has](key)) {
	                    attr[key] = keys[key](val);
	                }
	                el.attr(attr);
	            }, easing);
	        el.anims[anim.id] = anim;
	        anim._attrs = attrs;
	        anim._callback = callback;
	        eve("snap.animcreated." + el.id, anim);
	        eve.once("mina.finish." + anim.id, function () {
	            eve.off("mina.*." + anim.id);
	            delete el.anims[anim.id];
	            callback && callback.call(el);
	        });
	        eve.once("mina.stop." + anim.id, function () {
	            eve.off("mina.*." + anim.id);
	            delete el.anims[anim.id];
	        });
	        return el;
	    };
	});
	
	// Copyright (c) 2017 Adobe Systems Incorporated. All rights reserved.
	//
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//
	// http://www.apache.org/licenses/LICENSE-2.0
	//
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// See the License for the specific language governing permissions and
	// limitations under the License.
	Snap.plugin(function (Snap, Element, Paper, glob) {
	    // Colours are from https://www.materialui.co
	    var red         = "#ffebee#ffcdd2#ef9a9a#e57373#ef5350#f44336#e53935#d32f2f#c62828#b71c1c#ff8a80#ff5252#ff1744#d50000",
	        pink        = "#FCE4EC#F8BBD0#F48FB1#F06292#EC407A#E91E63#D81B60#C2185B#AD1457#880E4F#FF80AB#FF4081#F50057#C51162",
	        purple      = "#F3E5F5#E1BEE7#CE93D8#BA68C8#AB47BC#9C27B0#8E24AA#7B1FA2#6A1B9A#4A148C#EA80FC#E040FB#D500F9#AA00FF",
	        deeppurple  = "#EDE7F6#D1C4E9#B39DDB#9575CD#7E57C2#673AB7#5E35B1#512DA8#4527A0#311B92#B388FF#7C4DFF#651FFF#6200EA",
	        indigo      = "#E8EAF6#C5CAE9#9FA8DA#7986CB#5C6BC0#3F51B5#3949AB#303F9F#283593#1A237E#8C9EFF#536DFE#3D5AFE#304FFE",
	        blue        = "#E3F2FD#BBDEFB#90CAF9#64B5F6#64B5F6#2196F3#1E88E5#1976D2#1565C0#0D47A1#82B1FF#448AFF#2979FF#2962FF",
	        lightblue   = "#E1F5FE#B3E5FC#81D4FA#4FC3F7#29B6F6#03A9F4#039BE5#0288D1#0277BD#01579B#80D8FF#40C4FF#00B0FF#0091EA",
	        cyan        = "#E0F7FA#B2EBF2#80DEEA#4DD0E1#26C6DA#00BCD4#00ACC1#0097A7#00838F#006064#84FFFF#18FFFF#00E5FF#00B8D4",
	        teal        = "#E0F2F1#B2DFDB#80CBC4#4DB6AC#26A69A#009688#00897B#00796B#00695C#004D40#A7FFEB#64FFDA#1DE9B6#00BFA5",
	        green       = "#E8F5E9#C8E6C9#A5D6A7#81C784#66BB6A#4CAF50#43A047#388E3C#2E7D32#1B5E20#B9F6CA#69F0AE#00E676#00C853",
	        lightgreen  = "#F1F8E9#DCEDC8#C5E1A5#AED581#9CCC65#8BC34A#7CB342#689F38#558B2F#33691E#CCFF90#B2FF59#76FF03#64DD17",
	        lime        = "#F9FBE7#F0F4C3#E6EE9C#DCE775#D4E157#CDDC39#C0CA33#AFB42B#9E9D24#827717#F4FF81#EEFF41#C6FF00#AEEA00",
	        yellow      = "#FFFDE7#FFF9C4#FFF59D#FFF176#FFEE58#FFEB3B#FDD835#FBC02D#F9A825#F57F17#FFFF8D#FFFF00#FFEA00#FFD600",
	        amber       = "#FFF8E1#FFECB3#FFE082#FFD54F#FFCA28#FFC107#FFB300#FFA000#FF8F00#FF6F00#FFE57F#FFD740#FFC400#FFAB00",
	        orange      = "#FFF3E0#FFE0B2#FFCC80#FFB74D#FFA726#FF9800#FB8C00#F57C00#EF6C00#E65100#FFD180#FFAB40#FF9100#FF6D00",
	        deeporange  = "#FBE9E7#FFCCBC#FFAB91#FF8A65#FF7043#FF5722#F4511E#E64A19#D84315#BF360C#FF9E80#FF6E40#FF3D00#DD2C00",
	        brown       = "#EFEBE9#D7CCC8#BCAAA4#A1887F#8D6E63#795548#6D4C41#5D4037#4E342E#3E2723",
	        grey        = "#FAFAFA#F5F5F5#EEEEEE#E0E0E0#BDBDBD#9E9E9E#757575#616161#424242#212121",
	        bluegrey    = "#ECEFF1#CFD8DC#B0BEC5#90A4AE#78909C#607D8B#546E7A#455A64#37474F#263238";
	    /*\
	     * Snap.mui
	     [ property ]
	     **
	     * Contain Material UI colours.
	     | Snap().rect(0, 0, 10, 10).attr({fill: Snap.mui.deeppurple, stroke: Snap.mui.amber[600]});
	     # For colour reference: <a href="https://www.materialui.co">https://www.materialui.co</a>.
	    \*/
	    Snap.mui = {};
	    /*\
	     * Snap.flat
	     [ property ]
	     **
	     * Contain Flat UI colours.
	     | Snap().rect(0, 0, 10, 10).attr({fill: Snap.flat.carrot, stroke: Snap.flat.wetasphalt});
	     # For colour reference: <a href="https://www.materialui.co">https://www.materialui.co</a>.
	    \*/
	    Snap.flat = {};
	    function saveColor(colors) {
	        colors = colors.split(/(?=#)/);
	        var color = new String(colors[5]);
	        color[50] = colors[0];
	        color[100] = colors[1];
	        color[200] = colors[2];
	        color[300] = colors[3];
	        color[400] = colors[4];
	        color[500] = colors[5];
	        color[600] = colors[6];
	        color[700] = colors[7];
	        color[800] = colors[8];
	        color[900] = colors[9];
	        if (colors[10]) {
	            color.A100 = colors[10];
	            color.A200 = colors[11];
	            color.A400 = colors[12];
	            color.A700 = colors[13];
	        }
	        return color;
	    }
	    Snap.mui.red = saveColor(red);
	    Snap.mui.pink = saveColor(pink);
	    Snap.mui.purple = saveColor(purple);
	    Snap.mui.deeppurple = saveColor(deeppurple);
	    Snap.mui.indigo = saveColor(indigo);
	    Snap.mui.blue = saveColor(blue);
	    Snap.mui.lightblue = saveColor(lightblue);
	    Snap.mui.cyan = saveColor(cyan);
	    Snap.mui.teal = saveColor(teal);
	    Snap.mui.green = saveColor(green);
	    Snap.mui.lightgreen = saveColor(lightgreen);
	    Snap.mui.lime = saveColor(lime);
	    Snap.mui.yellow = saveColor(yellow);
	    Snap.mui.amber = saveColor(amber);
	    Snap.mui.orange = saveColor(orange);
	    Snap.mui.deeporange = saveColor(deeporange);
	    Snap.mui.brown = saveColor(brown);
	    Snap.mui.grey = saveColor(grey);
	    Snap.mui.bluegrey = saveColor(bluegrey);
	    Snap.flat.turquoise = "#1abc9c";
	    Snap.flat.greensea = "#16a085";
	    Snap.flat.sunflower = "#f1c40f";
	    Snap.flat.orange = "#f39c12";
	    Snap.flat.emerland = "#2ecc71";
	    Snap.flat.nephritis = "#27ae60";
	    Snap.flat.carrot = "#e67e22";
	    Snap.flat.pumpkin = "#d35400";
	    Snap.flat.peterriver = "#3498db";
	    Snap.flat.belizehole = "#2980b9";
	    Snap.flat.alizarin = "#e74c3c";
	    Snap.flat.pomegranate = "#c0392b";
	    Snap.flat.amethyst = "#9b59b6";
	    Snap.flat.wisteria = "#8e44ad";
	    Snap.flat.clouds = "#ecf0f1";
	    Snap.flat.silver = "#bdc3c7";
	    Snap.flat.wetasphalt = "#34495e";
	    Snap.flat.midnightblue = "#2c3e50";
	    Snap.flat.concrete = "#95a5a6";
	    Snap.flat.asbestos = "#7f8c8d";
	    /*\
	     * Snap.importMUIColors
	     [ method ]
	     **
	     * Imports Material UI colours into global object.
	     | Snap.importMUIColors();
	     | Snap().rect(0, 0, 10, 10).attr({fill: deeppurple, stroke: amber[600]});
	     # For colour reference: <a href="https://www.materialui.co">https://www.materialui.co</a>.
	    \*/
	    Snap.importMUIColors = function () {
	        for (var color in Snap.mui) {
	            if (Snap.mui.hasOwnProperty(color)) {
	                window[color] = Snap.mui[color];
	            }
	        }
	    };
	});
	
	module.exports = Snap


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(self.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0,
		styleElementsInsertedAtTop = [];
	
	module.exports = function(list, options) {
		if(false) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
		// By default, add <style> tags to the bottom of <head>.
		if (typeof options.insertAt === "undefined") options.insertAt = "bottom";
	
		var styles = listToStyles(list);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function insertStyleElement(options, styleElement) {
		var head = getHeadElement();
		var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
		if (options.insertAt === "top") {
			if(!lastStyleElementInsertedAtTop) {
				head.insertBefore(styleElement, head.firstChild);
			} else if(lastStyleElementInsertedAtTop.nextSibling) {
				head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
			} else {
				head.appendChild(styleElement);
			}
			styleElementsInsertedAtTop.push(styleElement);
		} else if (options.insertAt === "bottom") {
			head.appendChild(styleElement);
		} else {
			throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
		}
	}
	
	function removeStyleElement(styleElement) {
		styleElement.parentNode.removeChild(styleElement);
		var idx = styleElementsInsertedAtTop.indexOf(styleElement);
		if(idx >= 0) {
			styleElementsInsertedAtTop.splice(idx, 1);
		}
	}
	
	function createStyleElement(options) {
		var styleElement = document.createElement("style");
		styleElement.type = "text/css";
		insertStyleElement(options, styleElement);
		return styleElement;
	}
	
	function createLinkElement(options) {
		var linkElement = document.createElement("link");
		linkElement.rel = "stylesheet";
		insertStyleElement(options, linkElement);
		return linkElement;
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove;
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement(options));
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else if(obj.sourceMap &&
			typeof URL === "function" &&
			typeof URL.createObjectURL === "function" &&
			typeof URL.revokeObjectURL === "function" &&
			typeof Blob === "function" &&
			typeof btoa === "function") {
			styleElement = createLinkElement(options);
			update = updateLink.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
				if(styleElement.href)
					URL.revokeObjectURL(styleElement.href);
			};
		} else {
			styleElement = createStyleElement(options);
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
	
		if(media) {
			styleElement.setAttribute("media", media)
		}
	
		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}
	
	function updateLink(linkElement, obj) {
		var css = obj.css;
		var sourceMap = obj.sourceMap;
	
		if(sourceMap) {
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		var blob = new Blob([css], { type: "text/css" });
	
		var oldSrc = linkElement.href;
	
		linkElement.href = URL.createObjectURL(blob);
	
		if(oldSrc)
			URL.revokeObjectURL(oldSrc);
	}


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(95);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(183)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../css-loader/index.js!./bootstrap.min.css", function() {
				var newContent = require("!!../../../css-loader/index.js!./bootstrap.min.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global, module) {//     Underscore.js 1.9.1
	//     http://underscorejs.org
	//     (c) 2009-2018 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	//     Underscore may be freely distributed under the MIT license.
	
	(function() {
	
	  // Baseline setup
	  // --------------
	
	  // Establish the root object, `window` (`self`) in the browser, `global`
	  // on the server, or `this` in some virtual machines. We use `self`
	  // instead of `window` for `WebWorker` support.
	  var root = typeof self == 'object' && self.self === self && self ||
	            typeof global == 'object' && global.global === global && global ||
	            this ||
	            {};
	
	  // Save the previous value of the `_` variable.
	  var previousUnderscore = root._;
	
	  // Save bytes in the minified (but not gzipped) version:
	  var ArrayProto = Array.prototype, ObjProto = Object.prototype;
	  var SymbolProto = typeof Symbol !== 'undefined' ? Symbol.prototype : null;
	
	  // Create quick reference variables for speed access to core prototypes.
	  var push = ArrayProto.push,
	      slice = ArrayProto.slice,
	      toString = ObjProto.toString,
	      hasOwnProperty = ObjProto.hasOwnProperty;
	
	  // All **ECMAScript 5** native function implementations that we hope to use
	  // are declared here.
	  var nativeIsArray = Array.isArray,
	      nativeKeys = Object.keys,
	      nativeCreate = Object.create;
	
	  // Naked function reference for surrogate-prototype-swapping.
	  var Ctor = function(){};
	
	  // Create a safe reference to the Underscore object for use below.
	  var _ = function(obj) {
	    if (obj instanceof _) return obj;
	    if (!(this instanceof _)) return new _(obj);
	    this._wrapped = obj;
	  };
	
	  // Export the Underscore object for **Node.js**, with
	  // backwards-compatibility for their old module API. If we're in
	  // the browser, add `_` as a global object.
	  // (`nodeType` is checked to ensure that `module`
	  // and `exports` are not HTML elements.)
	  if (typeof exports != 'undefined' && !exports.nodeType) {
	    if (typeof module != 'undefined' && !module.nodeType && module.exports) {
	      exports = module.exports = _;
	    }
	    exports._ = _;
	  } else {
	    root._ = _;
	  }
	
	  // Current version.
	  _.VERSION = '1.9.1';
	
	  // Internal function that returns an efficient (for current engines) version
	  // of the passed-in callback, to be repeatedly applied in other Underscore
	  // functions.
	  var optimizeCb = function(func, context, argCount) {
	    if (context === void 0) return func;
	    switch (argCount == null ? 3 : argCount) {
	      case 1: return function(value) {
	        return func.call(context, value);
	      };
	      // The 2-argument case is omitted because we’re not using it.
	      case 3: return function(value, index, collection) {
	        return func.call(context, value, index, collection);
	      };
	      case 4: return function(accumulator, value, index, collection) {
	        return func.call(context, accumulator, value, index, collection);
	      };
	    }
	    return function() {
	      return func.apply(context, arguments);
	    };
	  };
	
	  var builtinIteratee;
	
	  // An internal function to generate callbacks that can be applied to each
	  // element in a collection, returning the desired result — either `identity`,
	  // an arbitrary callback, a property matcher, or a property accessor.
	  var cb = function(value, context, argCount) {
	    if (_.iteratee !== builtinIteratee) return _.iteratee(value, context);
	    if (value == null) return _.identity;
	    if (_.isFunction(value)) return optimizeCb(value, context, argCount);
	    if (_.isObject(value) && !_.isArray(value)) return _.matcher(value);
	    return _.property(value);
	  };
	
	  // External wrapper for our callback generator. Users may customize
	  // `_.iteratee` if they want additional predicate/iteratee shorthand styles.
	  // This abstraction hides the internal-only argCount argument.
	  _.iteratee = builtinIteratee = function(value, context) {
	    return cb(value, context, Infinity);
	  };
	
	  // Some functions take a variable number of arguments, or a few expected
	  // arguments at the beginning and then a variable number of values to operate
	  // on. This helper accumulates all remaining arguments past the function’s
	  // argument length (or an explicit `startIndex`), into an array that becomes
	  // the last argument. Similar to ES6’s "rest parameter".
	  var restArguments = function(func, startIndex) {
	    startIndex = startIndex == null ? func.length - 1 : +startIndex;
	    return function() {
	      var length = Math.max(arguments.length - startIndex, 0),
	          rest = Array(length),
	          index = 0;
	      for (; index < length; index++) {
	        rest[index] = arguments[index + startIndex];
	      }
	      switch (startIndex) {
	        case 0: return func.call(this, rest);
	        case 1: return func.call(this, arguments[0], rest);
	        case 2: return func.call(this, arguments[0], arguments[1], rest);
	      }
	      var args = Array(startIndex + 1);
	      for (index = 0; index < startIndex; index++) {
	        args[index] = arguments[index];
	      }
	      args[startIndex] = rest;
	      return func.apply(this, args);
	    };
	  };
	
	  // An internal function for creating a new object that inherits from another.
	  var baseCreate = function(prototype) {
	    if (!_.isObject(prototype)) return {};
	    if (nativeCreate) return nativeCreate(prototype);
	    Ctor.prototype = prototype;
	    var result = new Ctor;
	    Ctor.prototype = null;
	    return result;
	  };
	
	  var shallowProperty = function(key) {
	    return function(obj) {
	      return obj == null ? void 0 : obj[key];
	    };
	  };
	
	  var has = function(obj, path) {
	    return obj != null && hasOwnProperty.call(obj, path);
	  }
	
	  var deepGet = function(obj, path) {
	    var length = path.length;
	    for (var i = 0; i < length; i++) {
	      if (obj == null) return void 0;
	      obj = obj[path[i]];
	    }
	    return length ? obj : void 0;
	  };
	
	  // Helper for collection methods to determine whether a collection
	  // should be iterated as an array or as an object.
	  // Related: http://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
	  // Avoids a very nasty iOS 8 JIT bug on ARM-64. #2094
	  var MAX_ARRAY_INDEX = Math.pow(2, 53) - 1;
	  var getLength = shallowProperty('length');
	  var isArrayLike = function(collection) {
	    var length = getLength(collection);
	    return typeof length == 'number' && length >= 0 && length <= MAX_ARRAY_INDEX;
	  };
	
	  // Collection Functions
	  // --------------------
	
	  // The cornerstone, an `each` implementation, aka `forEach`.
	  // Handles raw objects in addition to array-likes. Treats all
	  // sparse array-likes as if they were dense.
	  _.each = _.forEach = function(obj, iteratee, context) {
	    iteratee = optimizeCb(iteratee, context);
	    var i, length;
	    if (isArrayLike(obj)) {
	      for (i = 0, length = obj.length; i < length; i++) {
	        iteratee(obj[i], i, obj);
	      }
	    } else {
	      var keys = _.keys(obj);
	      for (i = 0, length = keys.length; i < length; i++) {
	        iteratee(obj[keys[i]], keys[i], obj);
	      }
	    }
	    return obj;
	  };
	
	  // Return the results of applying the iteratee to each element.
	  _.map = _.collect = function(obj, iteratee, context) {
	    iteratee = cb(iteratee, context);
	    var keys = !isArrayLike(obj) && _.keys(obj),
	        length = (keys || obj).length,
	        results = Array(length);
	    for (var index = 0; index < length; index++) {
	      var currentKey = keys ? keys[index] : index;
	      results[index] = iteratee(obj[currentKey], currentKey, obj);
	    }
	    return results;
	  };
	
	  // Create a reducing function iterating left or right.
	  var createReduce = function(dir) {
	    // Wrap code that reassigns argument variables in a separate function than
	    // the one that accesses `arguments.length` to avoid a perf hit. (#1991)
	    var reducer = function(obj, iteratee, memo, initial) {
	      var keys = !isArrayLike(obj) && _.keys(obj),
	          length = (keys || obj).length,
	          index = dir > 0 ? 0 : length - 1;
	      if (!initial) {
	        memo = obj[keys ? keys[index] : index];
	        index += dir;
	      }
	      for (; index >= 0 && index < length; index += dir) {
	        var currentKey = keys ? keys[index] : index;
	        memo = iteratee(memo, obj[currentKey], currentKey, obj);
	      }
	      return memo;
	    };
	
	    return function(obj, iteratee, memo, context) {
	      var initial = arguments.length >= 3;
	      return reducer(obj, optimizeCb(iteratee, context, 4), memo, initial);
	    };
	  };
	
	  // **Reduce** builds up a single result from a list of values, aka `inject`,
	  // or `foldl`.
	  _.reduce = _.foldl = _.inject = createReduce(1);
	
	  // The right-associative version of reduce, also known as `foldr`.
	  _.reduceRight = _.foldr = createReduce(-1);
	
	  // Return the first value which passes a truth test. Aliased as `detect`.
	  _.find = _.detect = function(obj, predicate, context) {
	    var keyFinder = isArrayLike(obj) ? _.findIndex : _.findKey;
	    var key = keyFinder(obj, predicate, context);
	    if (key !== void 0 && key !== -1) return obj[key];
	  };
	
	  // Return all the elements that pass a truth test.
	  // Aliased as `select`.
	  _.filter = _.select = function(obj, predicate, context) {
	    var results = [];
	    predicate = cb(predicate, context);
	    _.each(obj, function(value, index, list) {
	      if (predicate(value, index, list)) results.push(value);
	    });
	    return results;
	  };
	
	  // Return all the elements for which a truth test fails.
	  _.reject = function(obj, predicate, context) {
	    return _.filter(obj, _.negate(cb(predicate)), context);
	  };
	
	  // Determine whether all of the elements match a truth test.
	  // Aliased as `all`.
	  _.every = _.all = function(obj, predicate, context) {
	    predicate = cb(predicate, context);
	    var keys = !isArrayLike(obj) && _.keys(obj),
	        length = (keys || obj).length;
	    for (var index = 0; index < length; index++) {
	      var currentKey = keys ? keys[index] : index;
	      if (!predicate(obj[currentKey], currentKey, obj)) return false;
	    }
	    return true;
	  };
	
	  // Determine if at least one element in the object matches a truth test.
	  // Aliased as `any`.
	  _.some = _.any = function(obj, predicate, context) {
	    predicate = cb(predicate, context);
	    var keys = !isArrayLike(obj) && _.keys(obj),
	        length = (keys || obj).length;
	    for (var index = 0; index < length; index++) {
	      var currentKey = keys ? keys[index] : index;
	      if (predicate(obj[currentKey], currentKey, obj)) return true;
	    }
	    return false;
	  };
	
	  // Determine if the array or object contains a given item (using `===`).
	  // Aliased as `includes` and `include`.
	  _.contains = _.includes = _.include = function(obj, item, fromIndex, guard) {
	    if (!isArrayLike(obj)) obj = _.values(obj);
	    if (typeof fromIndex != 'number' || guard) fromIndex = 0;
	    return _.indexOf(obj, item, fromIndex) >= 0;
	  };
	
	  // Invoke a method (with arguments) on every item in a collection.
	  _.invoke = restArguments(function(obj, path, args) {
	    var contextPath, func;
	    if (_.isFunction(path)) {
	      func = path;
	    } else if (_.isArray(path)) {
	      contextPath = path.slice(0, -1);
	      path = path[path.length - 1];
	    }
	    return _.map(obj, function(context) {
	      var method = func;
	      if (!method) {
	        if (contextPath && contextPath.length) {
	          context = deepGet(context, contextPath);
	        }
	        if (context == null) return void 0;
	        method = context[path];
	      }
	      return method == null ? method : method.apply(context, args);
	    });
	  });
	
	  // Convenience version of a common use case of `map`: fetching a property.
	  _.pluck = function(obj, key) {
	    return _.map(obj, _.property(key));
	  };
	
	  // Convenience version of a common use case of `filter`: selecting only objects
	  // containing specific `key:value` pairs.
	  _.where = function(obj, attrs) {
	    return _.filter(obj, _.matcher(attrs));
	  };
	
	  // Convenience version of a common use case of `find`: getting the first object
	  // containing specific `key:value` pairs.
	  _.findWhere = function(obj, attrs) {
	    return _.find(obj, _.matcher(attrs));
	  };
	
	  // Return the maximum element (or element-based computation).
	  _.max = function(obj, iteratee, context) {
	    var result = -Infinity, lastComputed = -Infinity,
	        value, computed;
	    if (iteratee == null || typeof iteratee == 'number' && typeof obj[0] != 'object' && obj != null) {
	      obj = isArrayLike(obj) ? obj : _.values(obj);
	      for (var i = 0, length = obj.length; i < length; i++) {
	        value = obj[i];
	        if (value != null && value > result) {
	          result = value;
	        }
	      }
	    } else {
	      iteratee = cb(iteratee, context);
	      _.each(obj, function(v, index, list) {
	        computed = iteratee(v, index, list);
	        if (computed > lastComputed || computed === -Infinity && result === -Infinity) {
	          result = v;
	          lastComputed = computed;
	        }
	      });
	    }
	    return result;
	  };
	
	  // Return the minimum element (or element-based computation).
	  _.min = function(obj, iteratee, context) {
	    var result = Infinity, lastComputed = Infinity,
	        value, computed;
	    if (iteratee == null || typeof iteratee == 'number' && typeof obj[0] != 'object' && obj != null) {
	      obj = isArrayLike(obj) ? obj : _.values(obj);
	      for (var i = 0, length = obj.length; i < length; i++) {
	        value = obj[i];
	        if (value != null && value < result) {
	          result = value;
	        }
	      }
	    } else {
	      iteratee = cb(iteratee, context);
	      _.each(obj, function(v, index, list) {
	        computed = iteratee(v, index, list);
	        if (computed < lastComputed || computed === Infinity && result === Infinity) {
	          result = v;
	          lastComputed = computed;
	        }
	      });
	    }
	    return result;
	  };
	
	  // Shuffle a collection.
	  _.shuffle = function(obj) {
	    return _.sample(obj, Infinity);
	  };
	
	  // Sample **n** random values from a collection using the modern version of the
	  // [Fisher-Yates shuffle](http://en.wikipedia.org/wiki/Fisher–Yates_shuffle).
	  // If **n** is not specified, returns a single random element.
	  // The internal `guard` argument allows it to work with `map`.
	  _.sample = function(obj, n, guard) {
	    if (n == null || guard) {
	      if (!isArrayLike(obj)) obj = _.values(obj);
	      return obj[_.random(obj.length - 1)];
	    }
	    var sample = isArrayLike(obj) ? _.clone(obj) : _.values(obj);
	    var length = getLength(sample);
	    n = Math.max(Math.min(n, length), 0);
	    var last = length - 1;
	    for (var index = 0; index < n; index++) {
	      var rand = _.random(index, last);
	      var temp = sample[index];
	      sample[index] = sample[rand];
	      sample[rand] = temp;
	    }
	    return sample.slice(0, n);
	  };
	
	  // Sort the object's values by a criterion produced by an iteratee.
	  _.sortBy = function(obj, iteratee, context) {
	    var index = 0;
	    iteratee = cb(iteratee, context);
	    return _.pluck(_.map(obj, function(value, key, list) {
	      return {
	        value: value,
	        index: index++,
	        criteria: iteratee(value, key, list)
	      };
	    }).sort(function(left, right) {
	      var a = left.criteria;
	      var b = right.criteria;
	      if (a !== b) {
	        if (a > b || a === void 0) return 1;
	        if (a < b || b === void 0) return -1;
	      }
	      return left.index - right.index;
	    }), 'value');
	  };
	
	  // An internal function used for aggregate "group by" operations.
	  var group = function(behavior, partition) {
	    return function(obj, iteratee, context) {
	      var result = partition ? [[], []] : {};
	      iteratee = cb(iteratee, context);
	      _.each(obj, function(value, index) {
	        var key = iteratee(value, index, obj);
	        behavior(result, value, key);
	      });
	      return result;
	    };
	  };
	
	  // Groups the object's values by a criterion. Pass either a string attribute
	  // to group by, or a function that returns the criterion.
	  _.groupBy = group(function(result, value, key) {
	    if (has(result, key)) result[key].push(value); else result[key] = [value];
	  });
	
	  // Indexes the object's values by a criterion, similar to `groupBy`, but for
	  // when you know that your index values will be unique.
	  _.indexBy = group(function(result, value, key) {
	    result[key] = value;
	  });
	
	  // Counts instances of an object that group by a certain criterion. Pass
	  // either a string attribute to count by, or a function that returns the
	  // criterion.
	  _.countBy = group(function(result, value, key) {
	    if (has(result, key)) result[key]++; else result[key] = 1;
	  });
	
	  var reStrSymbol = /[^\ud800-\udfff]|[\ud800-\udbff][\udc00-\udfff]|[\ud800-\udfff]/g;
	  // Safely create a real, live array from anything iterable.
	  _.toArray = function(obj) {
	    if (!obj) return [];
	    if (_.isArray(obj)) return slice.call(obj);
	    if (_.isString(obj)) {
	      // Keep surrogate pair characters together
	      return obj.match(reStrSymbol);
	    }
	    if (isArrayLike(obj)) return _.map(obj, _.identity);
	    return _.values(obj);
	  };
	
	  // Return the number of elements in an object.
	  _.size = function(obj) {
	    if (obj == null) return 0;
	    return isArrayLike(obj) ? obj.length : _.keys(obj).length;
	  };
	
	  // Split a collection into two arrays: one whose elements all satisfy the given
	  // predicate, and one whose elements all do not satisfy the predicate.
	  _.partition = group(function(result, value, pass) {
	    result[pass ? 0 : 1].push(value);
	  }, true);
	
	  // Array Functions
	  // ---------------
	
	  // Get the first element of an array. Passing **n** will return the first N
	  // values in the array. Aliased as `head` and `take`. The **guard** check
	  // allows it to work with `_.map`.
	  _.first = _.head = _.take = function(array, n, guard) {
	    if (array == null || array.length < 1) return n == null ? void 0 : [];
	    if (n == null || guard) return array[0];
	    return _.initial(array, array.length - n);
	  };
	
	  // Returns everything but the last entry of the array. Especially useful on
	  // the arguments object. Passing **n** will return all the values in
	  // the array, excluding the last N.
	  _.initial = function(array, n, guard) {
	    return slice.call(array, 0, Math.max(0, array.length - (n == null || guard ? 1 : n)));
	  };
	
	  // Get the last element of an array. Passing **n** will return the last N
	  // values in the array.
	  _.last = function(array, n, guard) {
	    if (array == null || array.length < 1) return n == null ? void 0 : [];
	    if (n == null || guard) return array[array.length - 1];
	    return _.rest(array, Math.max(0, array.length - n));
	  };
	
	  // Returns everything but the first entry of the array. Aliased as `tail` and `drop`.
	  // Especially useful on the arguments object. Passing an **n** will return
	  // the rest N values in the array.
	  _.rest = _.tail = _.drop = function(array, n, guard) {
	    return slice.call(array, n == null || guard ? 1 : n);
	  };
	
	  // Trim out all falsy values from an array.
	  _.compact = function(array) {
	    return _.filter(array, Boolean);
	  };
	
	  // Internal implementation of a recursive `flatten` function.
	  var flatten = function(input, shallow, strict, output) {
	    output = output || [];
	    var idx = output.length;
	    for (var i = 0, length = getLength(input); i < length; i++) {
	      var value = input[i];
	      if (isArrayLike(value) && (_.isArray(value) || _.isArguments(value))) {
	        // Flatten current level of array or arguments object.
	        if (shallow) {
	          var j = 0, len = value.length;
	          while (j < len) output[idx++] = value[j++];
	        } else {
	          flatten(value, shallow, strict, output);
	          idx = output.length;
	        }
	      } else if (!strict) {
	        output[idx++] = value;
	      }
	    }
	    return output;
	  };
	
	  // Flatten out an array, either recursively (by default), or just one level.
	  _.flatten = function(array, shallow) {
	    return flatten(array, shallow, false);
	  };
	
	  // Return a version of the array that does not contain the specified value(s).
	  _.without = restArguments(function(array, otherArrays) {
	    return _.difference(array, otherArrays);
	  });
	
	  // Produce a duplicate-free version of the array. If the array has already
	  // been sorted, you have the option of using a faster algorithm.
	  // The faster algorithm will not work with an iteratee if the iteratee
	  // is not a one-to-one function, so providing an iteratee will disable
	  // the faster algorithm.
	  // Aliased as `unique`.
	  _.uniq = _.unique = function(array, isSorted, iteratee, context) {
	    if (!_.isBoolean(isSorted)) {
	      context = iteratee;
	      iteratee = isSorted;
	      isSorted = false;
	    }
	    if (iteratee != null) iteratee = cb(iteratee, context);
	    var result = [];
	    var seen = [];
	    for (var i = 0, length = getLength(array); i < length; i++) {
	      var value = array[i],
	          computed = iteratee ? iteratee(value, i, array) : value;
	      if (isSorted && !iteratee) {
	        if (!i || seen !== computed) result.push(value);
	        seen = computed;
	      } else if (iteratee) {
	        if (!_.contains(seen, computed)) {
	          seen.push(computed);
	          result.push(value);
	        }
	      } else if (!_.contains(result, value)) {
	        result.push(value);
	      }
	    }
	    return result;
	  };
	
	  // Produce an array that contains the union: each distinct element from all of
	  // the passed-in arrays.
	  _.union = restArguments(function(arrays) {
	    return _.uniq(flatten(arrays, true, true));
	  });
	
	  // Produce an array that contains every item shared between all the
	  // passed-in arrays.
	  _.intersection = function(array) {
	    var result = [];
	    var argsLength = arguments.length;
	    for (var i = 0, length = getLength(array); i < length; i++) {
	      var item = array[i];
	      if (_.contains(result, item)) continue;
	      var j;
	      for (j = 1; j < argsLength; j++) {
	        if (!_.contains(arguments[j], item)) break;
	      }
	      if (j === argsLength) result.push(item);
	    }
	    return result;
	  };
	
	  // Take the difference between one array and a number of other arrays.
	  // Only the elements present in just the first array will remain.
	  _.difference = restArguments(function(array, rest) {
	    rest = flatten(rest, true, true);
	    return _.filter(array, function(value){
	      return !_.contains(rest, value);
	    });
	  });
	
	  // Complement of _.zip. Unzip accepts an array of arrays and groups
	  // each array's elements on shared indices.
	  _.unzip = function(array) {
	    var length = array && _.max(array, getLength).length || 0;
	    var result = Array(length);
	
	    for (var index = 0; index < length; index++) {
	      result[index] = _.pluck(array, index);
	    }
	    return result;
	  };
	
	  // Zip together multiple lists into a single array -- elements that share
	  // an index go together.
	  _.zip = restArguments(_.unzip);
	
	  // Converts lists into objects. Pass either a single array of `[key, value]`
	  // pairs, or two parallel arrays of the same length -- one of keys, and one of
	  // the corresponding values. Passing by pairs is the reverse of _.pairs.
	  _.object = function(list, values) {
	    var result = {};
	    for (var i = 0, length = getLength(list); i < length; i++) {
	      if (values) {
	        result[list[i]] = values[i];
	      } else {
	        result[list[i][0]] = list[i][1];
	      }
	    }
	    return result;
	  };
	
	  // Generator function to create the findIndex and findLastIndex functions.
	  var createPredicateIndexFinder = function(dir) {
	    return function(array, predicate, context) {
	      predicate = cb(predicate, context);
	      var length = getLength(array);
	      var index = dir > 0 ? 0 : length - 1;
	      for (; index >= 0 && index < length; index += dir) {
	        if (predicate(array[index], index, array)) return index;
	      }
	      return -1;
	    };
	  };
	
	  // Returns the first index on an array-like that passes a predicate test.
	  _.findIndex = createPredicateIndexFinder(1);
	  _.findLastIndex = createPredicateIndexFinder(-1);
	
	  // Use a comparator function to figure out the smallest index at which
	  // an object should be inserted so as to maintain order. Uses binary search.
	  _.sortedIndex = function(array, obj, iteratee, context) {
	    iteratee = cb(iteratee, context, 1);
	    var value = iteratee(obj);
	    var low = 0, high = getLength(array);
	    while (low < high) {
	      var mid = Math.floor((low + high) / 2);
	      if (iteratee(array[mid]) < value) low = mid + 1; else high = mid;
	    }
	    return low;
	  };
	
	  // Generator function to create the indexOf and lastIndexOf functions.
	  var createIndexFinder = function(dir, predicateFind, sortedIndex) {
	    return function(array, item, idx) {
	      var i = 0, length = getLength(array);
	      if (typeof idx == 'number') {
	        if (dir > 0) {
	          i = idx >= 0 ? idx : Math.max(idx + length, i);
	        } else {
	          length = idx >= 0 ? Math.min(idx + 1, length) : idx + length + 1;
	        }
	      } else if (sortedIndex && idx && length) {
	        idx = sortedIndex(array, item);
	        return array[idx] === item ? idx : -1;
	      }
	      if (item !== item) {
	        idx = predicateFind(slice.call(array, i, length), _.isNaN);
	        return idx >= 0 ? idx + i : -1;
	      }
	      for (idx = dir > 0 ? i : length - 1; idx >= 0 && idx < length; idx += dir) {
	        if (array[idx] === item) return idx;
	      }
	      return -1;
	    };
	  };
	
	  // Return the position of the first occurrence of an item in an array,
	  // or -1 if the item is not included in the array.
	  // If the array is large and already in sort order, pass `true`
	  // for **isSorted** to use binary search.
	  _.indexOf = createIndexFinder(1, _.findIndex, _.sortedIndex);
	  _.lastIndexOf = createIndexFinder(-1, _.findLastIndex);
	
	  // Generate an integer Array containing an arithmetic progression. A port of
	  // the native Python `range()` function. See
	  // [the Python documentation](http://docs.python.org/library/functions.html#range).
	  _.range = function(start, stop, step) {
	    if (stop == null) {
	      stop = start || 0;
	      start = 0;
	    }
	    if (!step) {
	      step = stop < start ? -1 : 1;
	    }
	
	    var length = Math.max(Math.ceil((stop - start) / step), 0);
	    var range = Array(length);
	
	    for (var idx = 0; idx < length; idx++, start += step) {
	      range[idx] = start;
	    }
	
	    return range;
	  };
	
	  // Chunk a single array into multiple arrays, each containing `count` or fewer
	  // items.
	  _.chunk = function(array, count) {
	    if (count == null || count < 1) return [];
	    var result = [];
	    var i = 0, length = array.length;
	    while (i < length) {
	      result.push(slice.call(array, i, i += count));
	    }
	    return result;
	  };
	
	  // Function (ahem) Functions
	  // ------------------
	
	  // Determines whether to execute a function as a constructor
	  // or a normal function with the provided arguments.
	  var executeBound = function(sourceFunc, boundFunc, context, callingContext, args) {
	    if (!(callingContext instanceof boundFunc)) return sourceFunc.apply(context, args);
	    var self = baseCreate(sourceFunc.prototype);
	    var result = sourceFunc.apply(self, args);
	    if (_.isObject(result)) return result;
	    return self;
	  };
	
	  // Create a function bound to a given object (assigning `this`, and arguments,
	  // optionally). Delegates to **ECMAScript 5**'s native `Function.bind` if
	  // available.
	  _.bind = restArguments(function(func, context, args) {
	    if (!_.isFunction(func)) throw new TypeError('Bind must be called on a function');
	    var bound = restArguments(function(callArgs) {
	      return executeBound(func, bound, context, this, args.concat(callArgs));
	    });
	    return bound;
	  });
	
	  // Partially apply a function by creating a version that has had some of its
	  // arguments pre-filled, without changing its dynamic `this` context. _ acts
	  // as a placeholder by default, allowing any combination of arguments to be
	  // pre-filled. Set `_.partial.placeholder` for a custom placeholder argument.
	  _.partial = restArguments(function(func, boundArgs) {
	    var placeholder = _.partial.placeholder;
	    var bound = function() {
	      var position = 0, length = boundArgs.length;
	      var args = Array(length);
	      for (var i = 0; i < length; i++) {
	        args[i] = boundArgs[i] === placeholder ? arguments[position++] : boundArgs[i];
	      }
	      while (position < arguments.length) args.push(arguments[position++]);
	      return executeBound(func, bound, this, this, args);
	    };
	    return bound;
	  });
	
	  _.partial.placeholder = _;
	
	  // Bind a number of an object's methods to that object. Remaining arguments
	  // are the method names to be bound. Useful for ensuring that all callbacks
	  // defined on an object belong to it.
	  _.bindAll = restArguments(function(obj, keys) {
	    keys = flatten(keys, false, false);
	    var index = keys.length;
	    if (index < 1) throw new Error('bindAll must be passed function names');
	    while (index--) {
	      var key = keys[index];
	      obj[key] = _.bind(obj[key], obj);
	    }
	  });
	
	  // Memoize an expensive function by storing its results.
	  _.memoize = function(func, hasher) {
	    var memoize = function(key) {
	      var cache = memoize.cache;
	      var address = '' + (hasher ? hasher.apply(this, arguments) : key);
	      if (!has(cache, address)) cache[address] = func.apply(this, arguments);
	      return cache[address];
	    };
	    memoize.cache = {};
	    return memoize;
	  };
	
	  // Delays a function for the given number of milliseconds, and then calls
	  // it with the arguments supplied.
	  _.delay = restArguments(function(func, wait, args) {
	    return setTimeout(function() {
	      return func.apply(null, args);
	    }, wait);
	  });
	
	  // Defers a function, scheduling it to run after the current call stack has
	  // cleared.
	  _.defer = _.partial(_.delay, _, 1);
	
	  // Returns a function, that, when invoked, will only be triggered at most once
	  // during a given window of time. Normally, the throttled function will run
	  // as much as it can, without ever going more than once per `wait` duration;
	  // but if you'd like to disable the execution on the leading edge, pass
	  // `{leading: false}`. To disable execution on the trailing edge, ditto.
	  _.throttle = function(func, wait, options) {
	    var timeout, context, args, result;
	    var previous = 0;
	    if (!options) options = {};
	
	    var later = function() {
	      previous = options.leading === false ? 0 : _.now();
	      timeout = null;
	      result = func.apply(context, args);
	      if (!timeout) context = args = null;
	    };
	
	    var throttled = function() {
	      var now = _.now();
	      if (!previous && options.leading === false) previous = now;
	      var remaining = wait - (now - previous);
	      context = this;
	      args = arguments;
	      if (remaining <= 0 || remaining > wait) {
	        if (timeout) {
	          clearTimeout(timeout);
	          timeout = null;
	        }
	        previous = now;
	        result = func.apply(context, args);
	        if (!timeout) context = args = null;
	      } else if (!timeout && options.trailing !== false) {
	        timeout = setTimeout(later, remaining);
	      }
	      return result;
	    };
	
	    throttled.cancel = function() {
	      clearTimeout(timeout);
	      previous = 0;
	      timeout = context = args = null;
	    };
	
	    return throttled;
	  };
	
	  // Returns a function, that, as long as it continues to be invoked, will not
	  // be triggered. The function will be called after it stops being called for
	  // N milliseconds. If `immediate` is passed, trigger the function on the
	  // leading edge, instead of the trailing.
	  _.debounce = function(func, wait, immediate) {
	    var timeout, result;
	
	    var later = function(context, args) {
	      timeout = null;
	      if (args) result = func.apply(context, args);
	    };
	
	    var debounced = restArguments(function(args) {
	      if (timeout) clearTimeout(timeout);
	      if (immediate) {
	        var callNow = !timeout;
	        timeout = setTimeout(later, wait);
	        if (callNow) result = func.apply(this, args);
	      } else {
	        timeout = _.delay(later, wait, this, args);
	      }
	
	      return result;
	    });
	
	    debounced.cancel = function() {
	      clearTimeout(timeout);
	      timeout = null;
	    };
	
	    return debounced;
	  };
	
	  // Returns the first function passed as an argument to the second,
	  // allowing you to adjust arguments, run code before and after, and
	  // conditionally execute the original function.
	  _.wrap = function(func, wrapper) {
	    return _.partial(wrapper, func);
	  };
	
	  // Returns a negated version of the passed-in predicate.
	  _.negate = function(predicate) {
	    return function() {
	      return !predicate.apply(this, arguments);
	    };
	  };
	
	  // Returns a function that is the composition of a list of functions, each
	  // consuming the return value of the function that follows.
	  _.compose = function() {
	    var args = arguments;
	    var start = args.length - 1;
	    return function() {
	      var i = start;
	      var result = args[start].apply(this, arguments);
	      while (i--) result = args[i].call(this, result);
	      return result;
	    };
	  };
	
	  // Returns a function that will only be executed on and after the Nth call.
	  _.after = function(times, func) {
	    return function() {
	      if (--times < 1) {
	        return func.apply(this, arguments);
	      }
	    };
	  };
	
	  // Returns a function that will only be executed up to (but not including) the Nth call.
	  _.before = function(times, func) {
	    var memo;
	    return function() {
	      if (--times > 0) {
	        memo = func.apply(this, arguments);
	      }
	      if (times <= 1) func = null;
	      return memo;
	    };
	  };
	
	  // Returns a function that will be executed at most one time, no matter how
	  // often you call it. Useful for lazy initialization.
	  _.once = _.partial(_.before, 2);
	
	  _.restArguments = restArguments;
	
	  // Object Functions
	  // ----------------
	
	  // Keys in IE < 9 that won't be iterated by `for key in ...` and thus missed.
	  var hasEnumBug = !{toString: null}.propertyIsEnumerable('toString');
	  var nonEnumerableProps = ['valueOf', 'isPrototypeOf', 'toString',
	    'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];
	
	  var collectNonEnumProps = function(obj, keys) {
	    var nonEnumIdx = nonEnumerableProps.length;
	    var constructor = obj.constructor;
	    var proto = _.isFunction(constructor) && constructor.prototype || ObjProto;
	
	    // Constructor is a special case.
	    var prop = 'constructor';
	    if (has(obj, prop) && !_.contains(keys, prop)) keys.push(prop);
	
	    while (nonEnumIdx--) {
	      prop = nonEnumerableProps[nonEnumIdx];
	      if (prop in obj && obj[prop] !== proto[prop] && !_.contains(keys, prop)) {
	        keys.push(prop);
	      }
	    }
	  };
	
	  // Retrieve the names of an object's own properties.
	  // Delegates to **ECMAScript 5**'s native `Object.keys`.
	  _.keys = function(obj) {
	    if (!_.isObject(obj)) return [];
	    if (nativeKeys) return nativeKeys(obj);
	    var keys = [];
	    for (var key in obj) if (has(obj, key)) keys.push(key);
	    // Ahem, IE < 9.
	    if (hasEnumBug) collectNonEnumProps(obj, keys);
	    return keys;
	  };
	
	  // Retrieve all the property names of an object.
	  _.allKeys = function(obj) {
	    if (!_.isObject(obj)) return [];
	    var keys = [];
	    for (var key in obj) keys.push(key);
	    // Ahem, IE < 9.
	    if (hasEnumBug) collectNonEnumProps(obj, keys);
	    return keys;
	  };
	
	  // Retrieve the values of an object's properties.
	  _.values = function(obj) {
	    var keys = _.keys(obj);
	    var length = keys.length;
	    var values = Array(length);
	    for (var i = 0; i < length; i++) {
	      values[i] = obj[keys[i]];
	    }
	    return values;
	  };
	
	  // Returns the results of applying the iteratee to each element of the object.
	  // In contrast to _.map it returns an object.
	  _.mapObject = function(obj, iteratee, context) {
	    iteratee = cb(iteratee, context);
	    var keys = _.keys(obj),
	        length = keys.length,
	        results = {};
	    for (var index = 0; index < length; index++) {
	      var currentKey = keys[index];
	      results[currentKey] = iteratee(obj[currentKey], currentKey, obj);
	    }
	    return results;
	  };
	
	  // Convert an object into a list of `[key, value]` pairs.
	  // The opposite of _.object.
	  _.pairs = function(obj) {
	    var keys = _.keys(obj);
	    var length = keys.length;
	    var pairs = Array(length);
	    for (var i = 0; i < length; i++) {
	      pairs[i] = [keys[i], obj[keys[i]]];
	    }
	    return pairs;
	  };
	
	  // Invert the keys and values of an object. The values must be serializable.
	  _.invert = function(obj) {
	    var result = {};
	    var keys = _.keys(obj);
	    for (var i = 0, length = keys.length; i < length; i++) {
	      result[obj[keys[i]]] = keys[i];
	    }
	    return result;
	  };
	
	  // Return a sorted list of the function names available on the object.
	  // Aliased as `methods`.
	  _.functions = _.methods = function(obj) {
	    var names = [];
	    for (var key in obj) {
	      if (_.isFunction(obj[key])) names.push(key);
	    }
	    return names.sort();
	  };
	
	  // An internal function for creating assigner functions.
	  var createAssigner = function(keysFunc, defaults) {
	    return function(obj) {
	      var length = arguments.length;
	      if (defaults) obj = Object(obj);
	      if (length < 2 || obj == null) return obj;
	      for (var index = 1; index < length; index++) {
	        var source = arguments[index],
	            keys = keysFunc(source),
	            l = keys.length;
	        for (var i = 0; i < l; i++) {
	          var key = keys[i];
	          if (!defaults || obj[key] === void 0) obj[key] = source[key];
	        }
	      }
	      return obj;
	    };
	  };
	
	  // Extend a given object with all the properties in passed-in object(s).
	  _.extend = createAssigner(_.allKeys);
	
	  // Assigns a given object with all the own properties in the passed-in object(s).
	  // (https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/assign)
	  _.extendOwn = _.assign = createAssigner(_.keys);
	
	  // Returns the first key on an object that passes a predicate test.
	  _.findKey = function(obj, predicate, context) {
	    predicate = cb(predicate, context);
	    var keys = _.keys(obj), key;
	    for (var i = 0, length = keys.length; i < length; i++) {
	      key = keys[i];
	      if (predicate(obj[key], key, obj)) return key;
	    }
	  };
	
	  // Internal pick helper function to determine if `obj` has key `key`.
	  var keyInObj = function(value, key, obj) {
	    return key in obj;
	  };
	
	  // Return a copy of the object only containing the whitelisted properties.
	  _.pick = restArguments(function(obj, keys) {
	    var result = {}, iteratee = keys[0];
	    if (obj == null) return result;
	    if (_.isFunction(iteratee)) {
	      if (keys.length > 1) iteratee = optimizeCb(iteratee, keys[1]);
	      keys = _.allKeys(obj);
	    } else {
	      iteratee = keyInObj;
	      keys = flatten(keys, false, false);
	      obj = Object(obj);
	    }
	    for (var i = 0, length = keys.length; i < length; i++) {
	      var key = keys[i];
	      var value = obj[key];
	      if (iteratee(value, key, obj)) result[key] = value;
	    }
	    return result;
	  });
	
	  // Return a copy of the object without the blacklisted properties.
	  _.omit = restArguments(function(obj, keys) {
	    var iteratee = keys[0], context;
	    if (_.isFunction(iteratee)) {
	      iteratee = _.negate(iteratee);
	      if (keys.length > 1) context = keys[1];
	    } else {
	      keys = _.map(flatten(keys, false, false), String);
	      iteratee = function(value, key) {
	        return !_.contains(keys, key);
	      };
	    }
	    return _.pick(obj, iteratee, context);
	  });
	
	  // Fill in a given object with default properties.
	  _.defaults = createAssigner(_.allKeys, true);
	
	  // Creates an object that inherits from the given prototype object.
	  // If additional properties are provided then they will be added to the
	  // created object.
	  _.create = function(prototype, props) {
	    var result = baseCreate(prototype);
	    if (props) _.extendOwn(result, props);
	    return result;
	  };
	
	  // Create a (shallow-cloned) duplicate of an object.
	  _.clone = function(obj) {
	    if (!_.isObject(obj)) return obj;
	    return _.isArray(obj) ? obj.slice() : _.extend({}, obj);
	  };
	
	  // Invokes interceptor with the obj, and then returns obj.
	  // The primary purpose of this method is to "tap into" a method chain, in
	  // order to perform operations on intermediate results within the chain.
	  _.tap = function(obj, interceptor) {
	    interceptor(obj);
	    return obj;
	  };
	
	  // Returns whether an object has a given set of `key:value` pairs.
	  _.isMatch = function(object, attrs) {
	    var keys = _.keys(attrs), length = keys.length;
	    if (object == null) return !length;
	    var obj = Object(object);
	    for (var i = 0; i < length; i++) {
	      var key = keys[i];
	      if (attrs[key] !== obj[key] || !(key in obj)) return false;
	    }
	    return true;
	  };
	
	
	  // Internal recursive comparison function for `isEqual`.
	  var eq, deepEq;
	  eq = function(a, b, aStack, bStack) {
	    // Identical objects are equal. `0 === -0`, but they aren't identical.
	    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
	    if (a === b) return a !== 0 || 1 / a === 1 / b;
	    // `null` or `undefined` only equal to itself (strict comparison).
	    if (a == null || b == null) return false;
	    // `NaN`s are equivalent, but non-reflexive.
	    if (a !== a) return b !== b;
	    // Exhaust primitive checks
	    var type = typeof a;
	    if (type !== 'function' && type !== 'object' && typeof b != 'object') return false;
	    return deepEq(a, b, aStack, bStack);
	  };
	
	  // Internal recursive comparison function for `isEqual`.
	  deepEq = function(a, b, aStack, bStack) {
	    // Unwrap any wrapped objects.
	    if (a instanceof _) a = a._wrapped;
	    if (b instanceof _) b = b._wrapped;
	    // Compare `[[Class]]` names.
	    var className = toString.call(a);
	    if (className !== toString.call(b)) return false;
	    switch (className) {
	      // Strings, numbers, regular expressions, dates, and booleans are compared by value.
	      case '[object RegExp]':
	      // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
	      case '[object String]':
	        // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
	        // equivalent to `new String("5")`.
	        return '' + a === '' + b;
	      case '[object Number]':
	        // `NaN`s are equivalent, but non-reflexive.
	        // Object(NaN) is equivalent to NaN.
	        if (+a !== +a) return +b !== +b;
	        // An `egal` comparison is performed for other numeric values.
	        return +a === 0 ? 1 / +a === 1 / b : +a === +b;
	      case '[object Date]':
	      case '[object Boolean]':
	        // Coerce dates and booleans to numeric primitive values. Dates are compared by their
	        // millisecond representations. Note that invalid dates with millisecond representations
	        // of `NaN` are not equivalent.
	        return +a === +b;
	      case '[object Symbol]':
	        return SymbolProto.valueOf.call(a) === SymbolProto.valueOf.call(b);
	    }
	
	    var areArrays = className === '[object Array]';
	    if (!areArrays) {
	      if (typeof a != 'object' || typeof b != 'object') return false;
	
	      // Objects with different constructors are not equivalent, but `Object`s or `Array`s
	      // from different frames are.
	      var aCtor = a.constructor, bCtor = b.constructor;
	      if (aCtor !== bCtor && !(_.isFunction(aCtor) && aCtor instanceof aCtor &&
	                               _.isFunction(bCtor) && bCtor instanceof bCtor)
	                          && ('constructor' in a && 'constructor' in b)) {
	        return false;
	      }
	    }
	    // Assume equality for cyclic structures. The algorithm for detecting cyclic
	    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
	
	    // Initializing stack of traversed objects.
	    // It's done here since we only need them for objects and arrays comparison.
	    aStack = aStack || [];
	    bStack = bStack || [];
	    var length = aStack.length;
	    while (length--) {
	      // Linear search. Performance is inversely proportional to the number of
	      // unique nested structures.
	      if (aStack[length] === a) return bStack[length] === b;
	    }
	
	    // Add the first object to the stack of traversed objects.
	    aStack.push(a);
	    bStack.push(b);
	
	    // Recursively compare objects and arrays.
	    if (areArrays) {
	      // Compare array lengths to determine if a deep comparison is necessary.
	      length = a.length;
	      if (length !== b.length) return false;
	      // Deep compare the contents, ignoring non-numeric properties.
	      while (length--) {
	        if (!eq(a[length], b[length], aStack, bStack)) return false;
	      }
	    } else {
	      // Deep compare objects.
	      var keys = _.keys(a), key;
	      length = keys.length;
	      // Ensure that both objects contain the same number of properties before comparing deep equality.
	      if (_.keys(b).length !== length) return false;
	      while (length--) {
	        // Deep compare each member
	        key = keys[length];
	        if (!(has(b, key) && eq(a[key], b[key], aStack, bStack))) return false;
	      }
	    }
	    // Remove the first object from the stack of traversed objects.
	    aStack.pop();
	    bStack.pop();
	    return true;
	  };
	
	  // Perform a deep comparison to check if two objects are equal.
	  _.isEqual = function(a, b) {
	    return eq(a, b);
	  };
	
	  // Is a given array, string, or object empty?
	  // An "empty" object has no enumerable own-properties.
	  _.isEmpty = function(obj) {
	    if (obj == null) return true;
	    if (isArrayLike(obj) && (_.isArray(obj) || _.isString(obj) || _.isArguments(obj))) return obj.length === 0;
	    return _.keys(obj).length === 0;
	  };
	
	  // Is a given value a DOM element?
	  _.isElement = function(obj) {
	    return !!(obj && obj.nodeType === 1);
	  };
	
	  // Is a given value an array?
	  // Delegates to ECMA5's native Array.isArray
	  _.isArray = nativeIsArray || function(obj) {
	    return toString.call(obj) === '[object Array]';
	  };
	
	  // Is a given variable an object?
	  _.isObject = function(obj) {
	    var type = typeof obj;
	    return type === 'function' || type === 'object' && !!obj;
	  };
	
	  // Add some isType methods: isArguments, isFunction, isString, isNumber, isDate, isRegExp, isError, isMap, isWeakMap, isSet, isWeakSet.
	  _.each(['Arguments', 'Function', 'String', 'Number', 'Date', 'RegExp', 'Error', 'Symbol', 'Map', 'WeakMap', 'Set', 'WeakSet'], function(name) {
	    _['is' + name] = function(obj) {
	      return toString.call(obj) === '[object ' + name + ']';
	    };
	  });
	
	  // Define a fallback version of the method in browsers (ahem, IE < 9), where
	  // there isn't any inspectable "Arguments" type.
	  if (!_.isArguments(arguments)) {
	    _.isArguments = function(obj) {
	      return has(obj, 'callee');
	    };
	  }
	
	  // Optimize `isFunction` if appropriate. Work around some typeof bugs in old v8,
	  // IE 11 (#1621), Safari 8 (#1929), and PhantomJS (#2236).
	  var nodelist = root.document && root.document.childNodes;
	  if (typeof /./ != 'function' && typeof Int8Array != 'object' && typeof nodelist != 'function') {
	    _.isFunction = function(obj) {
	      return typeof obj == 'function' || false;
	    };
	  }
	
	  // Is a given object a finite number?
	  _.isFinite = function(obj) {
	    return !_.isSymbol(obj) && isFinite(obj) && !isNaN(parseFloat(obj));
	  };
	
	  // Is the given value `NaN`?
	  _.isNaN = function(obj) {
	    return _.isNumber(obj) && isNaN(obj);
	  };
	
	  // Is a given value a boolean?
	  _.isBoolean = function(obj) {
	    return obj === true || obj === false || toString.call(obj) === '[object Boolean]';
	  };
	
	  // Is a given value equal to null?
	  _.isNull = function(obj) {
	    return obj === null;
	  };
	
	  // Is a given variable undefined?
	  _.isUndefined = function(obj) {
	    return obj === void 0;
	  };
	
	  // Shortcut function for checking if an object has a given property directly
	  // on itself (in other words, not on a prototype).
	  _.has = function(obj, path) {
	    if (!_.isArray(path)) {
	      return has(obj, path);
	    }
	    var length = path.length;
	    for (var i = 0; i < length; i++) {
	      var key = path[i];
	      if (obj == null || !hasOwnProperty.call(obj, key)) {
	        return false;
	      }
	      obj = obj[key];
	    }
	    return !!length;
	  };
	
	  // Utility Functions
	  // -----------------
	
	  // Run Underscore.js in *noConflict* mode, returning the `_` variable to its
	  // previous owner. Returns a reference to the Underscore object.
	  _.noConflict = function() {
	    root._ = previousUnderscore;
	    return this;
	  };
	
	  // Keep the identity function around for default iteratees.
	  _.identity = function(value) {
	    return value;
	  };
	
	  // Predicate-generating functions. Often useful outside of Underscore.
	  _.constant = function(value) {
	    return function() {
	      return value;
	    };
	  };
	
	  _.noop = function(){};
	
	  // Creates a function that, when passed an object, will traverse that object’s
	  // properties down the given `path`, specified as an array of keys or indexes.
	  _.property = function(path) {
	    if (!_.isArray(path)) {
	      return shallowProperty(path);
	    }
	    return function(obj) {
	      return deepGet(obj, path);
	    };
	  };
	
	  // Generates a function for a given object that returns a given property.
	  _.propertyOf = function(obj) {
	    if (obj == null) {
	      return function(){};
	    }
	    return function(path) {
	      return !_.isArray(path) ? obj[path] : deepGet(obj, path);
	    };
	  };
	
	  // Returns a predicate for checking whether an object has a given set of
	  // `key:value` pairs.
	  _.matcher = _.matches = function(attrs) {
	    attrs = _.extendOwn({}, attrs);
	    return function(obj) {
	      return _.isMatch(obj, attrs);
	    };
	  };
	
	  // Run a function **n** times.
	  _.times = function(n, iteratee, context) {
	    var accum = Array(Math.max(0, n));
	    iteratee = optimizeCb(iteratee, context, 1);
	    for (var i = 0; i < n; i++) accum[i] = iteratee(i);
	    return accum;
	  };
	
	  // Return a random integer between min and max (inclusive).
	  _.random = function(min, max) {
	    if (max == null) {
	      max = min;
	      min = 0;
	    }
	    return min + Math.floor(Math.random() * (max - min + 1));
	  };
	
	  // A (possibly faster) way to get the current timestamp as an integer.
	  _.now = Date.now || function() {
	    return new Date().getTime();
	  };
	
	  // List of HTML entities for escaping.
	  var escapeMap = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#x27;',
	    '`': '&#x60;'
	  };
	  var unescapeMap = _.invert(escapeMap);
	
	  // Functions for escaping and unescaping strings to/from HTML interpolation.
	  var createEscaper = function(map) {
	    var escaper = function(match) {
	      return map[match];
	    };
	    // Regexes for identifying a key that needs to be escaped.
	    var source = '(?:' + _.keys(map).join('|') + ')';
	    var testRegexp = RegExp(source);
	    var replaceRegexp = RegExp(source, 'g');
	    return function(string) {
	      string = string == null ? '' : '' + string;
	      return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
	    };
	  };
	  _.escape = createEscaper(escapeMap);
	  _.unescape = createEscaper(unescapeMap);
	
	  // Traverses the children of `obj` along `path`. If a child is a function, it
	  // is invoked with its parent as context. Returns the value of the final
	  // child, or `fallback` if any child is undefined.
	  _.result = function(obj, path, fallback) {
	    if (!_.isArray(path)) path = [path];
	    var length = path.length;
	    if (!length) {
	      return _.isFunction(fallback) ? fallback.call(obj) : fallback;
	    }
	    for (var i = 0; i < length; i++) {
	      var prop = obj == null ? void 0 : obj[path[i]];
	      if (prop === void 0) {
	        prop = fallback;
	        i = length; // Ensure we don't continue iterating.
	      }
	      obj = _.isFunction(prop) ? prop.call(obj) : prop;
	    }
	    return obj;
	  };
	
	  // Generate a unique integer id (unique within the entire client session).
	  // Useful for temporary DOM ids.
	  var idCounter = 0;
	  _.uniqueId = function(prefix) {
	    var id = ++idCounter + '';
	    return prefix ? prefix + id : id;
	  };
	
	  // By default, Underscore uses ERB-style template delimiters, change the
	  // following template settings to use alternative delimiters.
	  _.templateSettings = {
	    evaluate: /<%([\s\S]+?)%>/g,
	    interpolate: /<%=([\s\S]+?)%>/g,
	    escape: /<%-([\s\S]+?)%>/g
	  };
	
	  // When customizing `templateSettings`, if you don't want to define an
	  // interpolation, evaluation or escaping regex, we need one that is
	  // guaranteed not to match.
	  var noMatch = /(.)^/;
	
	  // Certain characters need to be escaped so that they can be put into a
	  // string literal.
	  var escapes = {
	    "'": "'",
	    '\\': '\\',
	    '\r': 'r',
	    '\n': 'n',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  var escapeRegExp = /\\|'|\r|\n|\u2028|\u2029/g;
	
	  var escapeChar = function(match) {
	    return '\\' + escapes[match];
	  };
	
	  // JavaScript micro-templating, similar to John Resig's implementation.
	  // Underscore templating handles arbitrary delimiters, preserves whitespace,
	  // and correctly escapes quotes within interpolated code.
	  // NB: `oldSettings` only exists for backwards compatibility.
	  _.template = function(text, settings, oldSettings) {
	    if (!settings && oldSettings) settings = oldSettings;
	    settings = _.defaults({}, settings, _.templateSettings);
	
	    // Combine delimiters into one regular expression via alternation.
	    var matcher = RegExp([
	      (settings.escape || noMatch).source,
	      (settings.interpolate || noMatch).source,
	      (settings.evaluate || noMatch).source
	    ].join('|') + '|$', 'g');
	
	    // Compile the template source, escaping string literals appropriately.
	    var index = 0;
	    var source = "__p+='";
	    text.replace(matcher, function(match, escape, interpolate, evaluate, offset) {
	      source += text.slice(index, offset).replace(escapeRegExp, escapeChar);
	      index = offset + match.length;
	
	      if (escape) {
	        source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
	      } else if (interpolate) {
	        source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
	      } else if (evaluate) {
	        source += "';\n" + evaluate + "\n__p+='";
	      }
	
	      // Adobe VMs need the match returned to produce the correct offset.
	      return match;
	    });
	    source += "';\n";
	
	    // If a variable is not specified, place data values in local scope.
	    if (!settings.variable) source = 'with(obj||{}){\n' + source + '}\n';
	
	    source = "var __t,__p='',__j=Array.prototype.join," +
	      "print=function(){__p+=__j.call(arguments,'');};\n" +
	      source + 'return __p;\n';
	
	    var render;
	    try {
	      render = new Function(settings.variable || 'obj', '_', source);
	    } catch (e) {
	      e.source = source;
	      throw e;
	    }
	
	    var template = function(data) {
	      return render.call(this, data, _);
	    };
	
	    // Provide the compiled source as a convenience for precompilation.
	    var argument = settings.variable || 'obj';
	    template.source = 'function(' + argument + '){\n' + source + '}';
	
	    return template;
	  };
	
	  // Add a "chain" function. Start chaining a wrapped Underscore object.
	  _.chain = function(obj) {
	    var instance = _(obj);
	    instance._chain = true;
	    return instance;
	  };
	
	  // OOP
	  // ---------------
	  // If Underscore is called as a function, it returns a wrapped object that
	  // can be used OO-style. This wrapper holds altered versions of all the
	  // underscore functions. Wrapped objects may be chained.
	
	  // Helper function to continue chaining intermediate results.
	  var chainResult = function(instance, obj) {
	    return instance._chain ? _(obj).chain() : obj;
	  };
	
	  // Add your own custom functions to the Underscore object.
	  _.mixin = function(obj) {
	    _.each(_.functions(obj), function(name) {
	      var func = _[name] = obj[name];
	      _.prototype[name] = function() {
	        var args = [this._wrapped];
	        push.apply(args, arguments);
	        return chainResult(this, func.apply(_, args));
	      };
	    });
	    return _;
	  };
	
	  // Add all of the Underscore functions to the wrapper object.
	  _.mixin(_);
	
	  // Add all mutator Array functions to the wrapper.
	  _.each(['pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift'], function(name) {
	    var method = ArrayProto[name];
	    _.prototype[name] = function() {
	      var obj = this._wrapped;
	      method.apply(obj, arguments);
	      if ((name === 'shift' || name === 'splice') && obj.length === 0) delete obj[0];
	      return chainResult(this, obj);
	    };
	  });
	
	  // Add all accessor Array functions to the wrapper.
	  _.each(['concat', 'join', 'slice'], function(name) {
	    var method = ArrayProto[name];
	    _.prototype[name] = function() {
	      return chainResult(this, method.apply(this._wrapped, arguments));
	    };
	  });
	
	  // Extracts the result from a wrapped and chained object.
	  _.prototype.value = function() {
	    return this._wrapped;
	  };
	
	  // Provide unwrapping proxy for some methods used in engine operations
	  // such as arithmetic and JSON stringification.
	  _.prototype.valueOf = _.prototype.toJSON = _.prototype.value;
	
	  _.prototype.toString = function() {
	    return String(this._wrapped);
	  };
	
	  // AMD registration happens at the end for compatibility with AMD loaders
	  // that may not enforce next-turn semantics on modules. Even though general
	  // practice for AMD registration is to be anonymous, underscore registers
	  // as a named module because, like jQuery, it is a base library that is
	  // popular enough to be bundled in a third party lib, but not be part of
	  // an AMD load request. Those cases could generate an error when an
	  // anonymous define() is called outside of a loader request.
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return _;
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	}());
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(190)(module)))

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "fa2772327f55d8198301fdb8bcfc8158.woff";

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "448c34a56d699c29117adc64c43affeb.woff2";

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "e18bbf611f2a2e43afc071aa2f4e1512.ttf";

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "89889688147bd7575d6327160d64e760.svg";

/***/ }),
/* 190 */
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// bundle.js